angular.module('image.text', [])

    .service('text', ['$rootScope', 'canvas', 'IES', 'fonts', 'simpleShapes', function ($rootScope, canvas, IES, fonts, simpleShapes) {

        var text = {

            removeTextFromCanvas: function(textObject) {
                  if ( ! textObject) {
                      textObject = canvas.fabric.getActiveObject();
                  }

                  //bail if we don't have a text object
                  if ( ! textObject.setFontSize) return;

                  canvas.fabric.remove(textObject);
            },

            getTextObject: function() {
                var active = canvas.fabric.getActiveObject();

                if( IES.get().activeTab == 'text'){                    
                    if (active && active.fontFamily && !active.niceName.indexOf("button") == 0 ) {
                        return active;
                    }
                }else{
                    if (active && active.fontFamily && active.niceName.indexOf("button") == 0) {
                        return active;
                    }
                }

                return null;
            },

            generateText: function(name) {    
                var font = 'Open Sans';
                var active = canvas.fabric.getActiveObject();
                if(!name) name = "GENERATED TEXT";
                var newText = new fabric.Textbox(name+'\n 00/00/0000 \n 00:00 PM ', {
                    fontWeight: 400,
                    fontSize: 38,
                    fill: '#fff',
                    breakwords: true,
                    removeOnCancel: true,
                    name: 'text',
                    niceName: 'generated text',
                    editable: false,
                    textAlign: 'center',
                    fontFamily: 'Open Sans',
                    senderNameChecked : false

                });

                canvas.fabric.add(newText);
                canvas.fabric.setActiveObject(newText);
                newText._controlsVisibility.tl= false;
                newText._controlsVisibility.tr= false;
                newText._controlsVisibility.br= false;
                newText._controlsVisibility.bl= false;
                newText._controlsVisibility.ml= false;
                newText._controlsVisibility.mt= false;
                newText._controlsVisibility.mr= false;
                newText._controlsVisibility.mb= false;
                newText._controlsVisibility.mtr= false;
                canvas.fabric.renderAll();

                fonts.createLinkToFont(newText.fontFamily);
                return newText;
            },      

            toggleTextDecoration: function(value) {
                var text = this.getTextObject(),
                    current = text.textDecoration.trim();

                //font style
                if (value == 'italic') {
                    if (text.fontStyle.indexOf('italic') > -1) {
                        text.setFontStyle('normal');
                    } else {
                        text.setFontStyle('italic');
                    }
                }

                //text decoration
                else {
                    if (current.indexOf(value) > -1) {
                        current = current.replace(value, '').trim();
                    } else {
                        current += ' '+value;
                    }

                    if (text.setTextDecoration) {
                        text.setTextDecoration(current);
                    }
                }

                canvas.fabric.renderAll();

                var decorations = text.fontStyle+' '+text.textDecoration.trim();

                return decorations.split(' ');
            },

            setProperty: function(property, value) {
                var text   = this.getTextObject(),
                    setter = this.makeSetterName(property);

                if( !text ) return;

                if (text[setter]) {
                    text[setter](value);
                }

                if( text.niceName.indexOf("button") == 0){
                    simpleShapes.setButtonShape(text);
                }

                canvas.fabric.renderAll();
            },

            /**
             * Toggle given property on/off on text object.
             *
             * @param {string}  property
             * @param {boolean} enabled
             */
            toggleProperty: function(property, enabled) {
                var text   = this.getTextObject(),
                    setter = this.makeSetterName(property);

                if (text[setter]) {
                    text[setter](enabled);
                }


                canvas.fabric.renderAll();
            },

            /**
             * Compile a fabric setter function name from give property.
             *
             * @param name (backgroundColor)
             * @returns string (setBackgroundColor)
             */
            makeSetterName: function(name) {
                  return 'set'+name.charAt(0).toUpperCase()+name.slice(1);
            },

            makeGoogleMap: function () {
                textObject = canvas.fabric.getActiveObject();
                if(textObject && textObject.useGoogleMap) {
                    return textObject.useGoogleMap;
                }
            },

            makeSelectedMapType: function () {
                textObject = canvas.fabric.getActiveObject();
                if(textObject && textObject.selectedMapType) {
                    return textObject.selectedMapType;
                }
            },
            makeuseUserGP: function () {
                textObject = canvas.fabric.getActiveObject();
                if(textObject && textObject.useUserGPS) {
                    return textObject.useUserGPS;
                }
            }
        };

        return text;

    }]);
'use strict';

angular.module('image.text')

.directive('edTextDecorationButtons', ['text', function (text) {
    return {
        compile: function (el) {
            el.on('click', '.toolbar-btn', function(e) {
                var name = e.currentTarget.dataset.decoration;

                var decorations = text.toggleTextDecoration(name);

                el.find('.toolbar-btn').removeClass('active');

                for (var i = 0; i < decorations.length; i++) {
                    el.find('[data-decoration="'+decorations[i].trim()+'"]').addClass('active');
                }
            });
        }
    };
}])

angular.module('image.text')

	.controller('TextController', ['$scope', '$rootScope', '$timeout', 'canvas', 'text', 'fonts', 'IES', '$log', function ($scope, $rootScope, $timeout, canvas, text, fonts, IES, $log) {


		$scope.text = text;
		$scope.fonts = fonts;
		$scope.opacity = 1;
		$scope.fontSize = 25;
		$scope.enableOutline = true;
		$scope.toggleEdit = false;
		$scope.senderNameChecked = false;
		$scope.useGoogleMap = false;
		$scope.selectedMapType = 'transit';
		$scope.filters = {
			category: 'handwriting',
			family: ''
		};
		$scope.mycolor = '#fff';
		$scope.useUserGPS = false;

		$scope.init = function (id) {
			$scope.id = id;
		};

		$scope.isPanelEnabled = function () {
			var obj = canvas.fabric.getActiveObject();
			if ($scope.id == 'text')
				return obj && obj.name === 'text' && !(obj.niceName.indexOf("button") == 0);
			else
				return obj && obj.name === 'text' && obj.niceName.indexOf("button") == 0;
		};

		$scope.toggleEditable = function () {
			var obj = $scope.text.getTextObject();
			obj.scaleY = 1;
			obj.scaleX = 1;
			obj.setAngle(0);
			obj.setCoords();
			obj._controlsVisibility.mtr = !$scope.toggleEdit;
			obj.niceName = ($scope.toggleEdit) ? 'editable text' : 'text';
			canvas.fabric.renderAll();
		};

		$scope.isGenerated = function () {
			var obj = canvas.fabric.getActiveObject();
			if (!obj) return false;
			return obj.niceName == 'generated text';
		};

		$scope.changeSenderNameChecked = function (event) {
			var obj = canvas.fabric.getActiveObject();
			if (!obj) return false;
			obj.senderNameChecked = event;
			canvas.fabric.setActiveObject(obj);
			canvas.fabric.renderAll();
		};

		$scope.changeUseGoogleMap = function () { 
			
			var obj = canvas.fabric.getActiveObject();
			if (!obj) return false;
			obj.useGoogleMap = $scope.useGoogleMap?false:true;
			canvas.fabric.setActiveObject(obj);
			canvas.fabric.renderAll();
		};

		$scope.setGoogleMap = function () {
			$scope.useGoogleMap = $scope.text.makeGoogleMap()?true:false;
			// $scope.selectedMapType = $scope.text.makeSelectedMapType()?$scope.text.makeSelectedMapType():null;
			$scope.useUserGPS = $scope.text.makeuseUserGP()?true:false;
			return $scope.useGoogleMap;
		}

		// $scope.changeSelectedMapType = function (selectedMapType) { 
			
		// 	var obj = canvas.fabric.getActiveObject();
		// 	if (!obj) return false;
		// 	obj.selectedMapType = selectedMapType?selectedMapType:null;
		// 	canvas.fabric.setActiveObject(obj);
		// 	canvas.fabric.renderAll();
		// };

		$scope.changeUseUserGPS = function () { 
			
			var obj = canvas.fabric.getActiveObject();
			if (!obj) return false;
			obj.useUserGPS = $scope.useUserGPS?false:true;
			canvas.fabric.setActiveObject(obj);
			canvas.fabric.renderAll();
		};

		// $scope.setSelectedMapType = function () {
		// 	$scope.selectedMapType = $scope.text.makeSelectedMapType()?true:false;
		// 	return $scope.selectedMapType;
		// }

		$scope.getTextTitle = function () {
			var obj = canvas.fabric.getActiveObject();
			if (obj && obj.name == 'text') {
				$scope.senderNameChecked = obj.senderNameChecked;
				return obj.niceName;
			} else if (obj && obj.textObject) {
				return obj.textObject.niceName;
			} else {
				return '';
			}
		};

		$scope.changeFont = function (font, e) {
			var active = text.getTextObject();

			if (e) {

				IES.get().openPanel('text', e);
			}

			if (!active || active.name !== 'text') {
				var newText = new fabric.Textbox('Double click me to edit my contents.', {
					fontWeight: 400,
					fontSize: 38,
					breakWords: true,
					fill: '#000',
					width: 650,
					removeOnCancel: true,
					name: 'text',
					niceName: 'text',
					textAlign: 'center',
					senderNameChecked: false
				});

				canvas.fabric.add(newText);
				newText.setTop(25);
				newText.setLeft(25);
				canvas.fabric.setActiveObject(newText);
				newText._controlsVisibility.tl = false;
				newText._controlsVisibility.tr = false;
				newText._controlsVisibility.br = false;
				newText._controlsVisibility.bl = false;
				newText._controlsVisibility.ml = false;
				newText._controlsVisibility.mt = false;
				newText._controlsVisibility.mr = false;
				newText._controlsVisibility.mb = false;
				newText._controlsVisibility.mtr = true;
				canvas.fabric.renderAll();

			}

			this.text.setProperty('fontFamily', font);
		};

		$scope.cancelAddingTextToCanvas = function () {
			var textObject = text.getTextObject();

			if (textObject.removeOnCancel) {
				text.removeTextFromCanvas(textObject);
			}

			IES.get().activePanel = false;
			IES.get().activeTab = false;
		};

		$scope.finishAddingTextToCanvas = function () {
			var textObject = text.getTextObject();

			IES.get().activePanel = false;
			IES.get().activeTab = false;
			$rootScope.$emit('text.added', textObject);
			//canvas.fabric.setActiveObject(canvas.mainImage);
			fonts.createLinkToFont(textObject.fontFamily);
		};

		$scope.tabChanged = $rootScope.$on('tab.changed', function (e, name) {
			if (name == 'text') {
				var textObject = $scope.text.getTextObject();

				//if we can find an existing text object set it as active
				if (textObject) {
					textObject.removeOnCancel = false;
					canvas.fabric.setActiveObject(textObject);
				}
			}
		});

		$scope.panelGetObject = $rootScope.$on('panel.getobject', function (event, obj) {
			if (!$scope.isPanelEnabled()) return;
			var yep = $scope;
			yep.toggleEdit = obj.niceName == 'editable text';
			yep.fontSize = obj.fontSize;
			$scope.$broadcast('panel.setcolor', { type: "text", color: obj.fill.toString() });
		});

		$scope.$on('$destroy', function () {
			$scope.panelGetObject();
			$scope.tabChanged();
		});


		fonts.getAll($scope.filters);
	}]);
'use strict';

angular.module('image.text')

.directive('edTextAlignButtons', ['text', '$rootScope', function (text,$rootScope) {
    return {
        compile: function (el) {

            el.on('$destroy', function() {
                el.panelShow();
            }); 
                
            el.panelShow = $rootScope.$on('panel.show', function(event) {
                var  obj = text.getTextObject();
                el.find('i').removeClass('active');
                if( obj ){
                    $( ".mdi-format-align-"+obj.textAlign ).addClass('active');
                }
            });           


            el.on('click', 'i', function(e) {
                var align = e.currentTarget.dataset.align;

                text.setProperty('textAlign', align);
                el.find('i').removeClass('active');
                $(e.currentTarget).addClass('active');

            });
        }
    };
}])

'use strict';

angular.module('image.text')

.directive('edFontsPagination', ['$rootScope', 'fonts', function($rootScope, fonts) {

    return {
        restrict: 'A',
        link: function($scope, el) {

            //initiate pagination plugin
            el.pagination({
                items: 0,
                itemsOnPage: fonts.paginator.perPage,
                onPageClick: function(num) {
                    $scope.$apply(function() {
                        fonts.paginator.selectPage(num);
                    })
                }
            });

            //redraw pagination bar on total items change
            $scope.$watch('fonts.paginator.totalItems', function(value) {
                if (value) { el.pagination('updateItems', value) }
            });
        }
    }
}])

.factory('fonts', ['$log','$rootScope', '$http', '$timeout', '$filter', 'localStorage', 'IES', function($log, $rootScope, $http, $timeout, $filter, localStorage, IES) {
    var fontList = ['Open Sans','Lato','Oswald','Arvo','Vollkorn','Droid Sans','Droid Serif','Permanent Marker','Vibur','Abril Fatface','Amiri','Rubik One','Bevan','Bungee Shade','Molle','Russo One','Space Mono','Indie Flower'];
    var fonts = {

        loading: false,

        paginator: {

            /**
             * All available fonts.
             *
             * @type array
             */
            sourceItems: [],

            /**
             * All available fonts with filtrs applied.
             */
            filteredItems: [],

            /**
             * Fonts currently being shown.
             *
             * @type array
             */
            currentItems: [],

            /**
             * Fonts to show per page.
             *
             * @type int
             */
            perPage: 17,

            /**
             * Total number of fonts.
             *
             * @type int
             */
            totalItems: 0,

            /**
             * Slice items for the given page.
             *
             * @param  {int} page
             * @return void
             */
            selectPage: function(page) {
                this.currentItems = this.filteredItems.slice(
                    (page-1)*this.perPage, (page-1)*this.perPage+this.perPage
                );

                fonts.load(fontList);//['open sans', 'roboto', 'roboto slab', 'monteserrat', 'bangers']);
            },

            filter: function(filters) {
                this.start($filter('filter')(fonts.paginator.sourceItems, filters));
            },

            /**
             * Start the paginator with given items.
             *
             * @param  {array} items
             * @return void
             */
            start: function(items) {
                this.filteredItems  = items;
                this.totalItems   = items.length;
                this.currentItems = items.slice(0, this.perPage);

                fonts.load(fontList);//['open sans', 'roboto', 'roboto slab', 'monteserrat', 'bangers']);
            }
        },

        /**
         * Fetch all available fonts from GoogleFonts API.
         *
         * @return void
         */
        getAll: function(filters) {
           /* var self   = this,
                cached = localStorage.get('googleFonts'),
                key    = IES.get().keys['google_fonts'];
            var names = ['open sans', 'roboto', 'roboto slab', 'monteserrat', 'bangers'];
            if (cached) {
                self.paginator.sourceItems = cached;
                return filters ? self.paginator.filter(filters) : self.paginator.start(cached);
            }*/

            this.paginator.currentItems = fontList;//['open sans', 'roboto', 'roboto slab', 'monteserrat', 'bangers'];

          /*  var dir = names.join('|').replace(/ /g, '+');

            $http.get('https://www.googleapis.com/webfonts/v1/webfonts?family='+ dir +'&key='+key'&sort=popularity' )
                .success(function(data) {
                    localStorage.set('googleFonts', data.items);
                    self.paginator.sourceItems = data.items;
                    filters ? self.paginator.filter(filters) : self.paginator.start(data.items);
                })
                .error(function(error){
                    $log.debug("error");
                });*/
        },

        /**
         * Load given google fonts into the DOM.
         *
         * @param  {mixed} names
         * @return void
         */
        load: function(names) {

            this.paginator.currentItems = fontList;//['open sans', 'roboto', 'roboto slab', 'monteserrat', 'bangers'];

/*
            var head = $('head');
            IES.get().loading = true;

            //make an array of font names from current fonts
            //in the paginator if none passed
            if ( ! names) {
                names = $.map(fonts.paginator.currentItems, function(font) {
                    return font.family;
                });

                //normalize names to array if string passed
            } else if ( ! angular.isArray(names)) {
                names = [names];
            }

            //remove previous page fonts
            $(head).find('#dynamic-fonts').remove();

            //load the given fonts
            head.append(
                '<link rel="stylesheet" id="dynamic-fonts" href="http://fonts.googleapis.com/css?family='+
                names.join('|').replace(/ /g, '+')+'">'
            );

            IES.get().loading = false;*/
        },

        createLinkToFont: function(font) {
            /*var name = font.replace(/ /g, '+'),
                link = $('#'+name);
                
            if (link[0]) {
                link.attr('href', 'http://fonts.googleapis.com/css?family='+name);
            } else {
                $('head').append('<link rel="stylesheet" id="'+name+'" href="http://fonts.googleapis.com/css?family='+name+'">');
            }*/
        }
    };

    return fonts;
}]);
angular.module('image.shapes', [])

    .controller('SimpleShapesController', ['$scope', '$rootScope', '$timeout', 'canvas', 'simpleShapes', 'IES', '$log', 'MsgService', function ($scope, $rootScope, $timeout, canvas, simpleShapes, IES, $log, MsgService) {
        $scope.shapes = simpleShapes;
        $scope.templateid = '';
        $scope.alertTemplateList = [];

        //if this is an advertisement or an announcement, don't show editable text as an option
        $rootScope.$on('templateLoaded', function (event, template) {
            $scope.templateid = template.id;
            $scope.shapes.available = _.each($scope.shapes.available, function (shape) {
                //this is a singleton object, so we have to be very careful about its' state. Changes to this array
                //will be reflected in all editors, so we have to reset it to what we want every time a new template is
                //loaded in
                if ((template.type == 'announcement' || template.type == 'advertisement') && (shape.name == 'editable' || shape.name == 'orgbanner')) {
                    shape.hidden = true;
                }
                else {
                    shape.hidden = false;
                }
            });
            MsgService.getAllParentTemplates('alert', template.id, function (error, data) {
                $scope.alertTemplateList = data;
            });
    

        });

        $scope.available = ['rect', 'triangle', 'circle', 'ellipse', 'polygon'];
        $scope.shapes.actionType = "";
        $scope.activeHeader = false;


        

        $scope.init = function (id) {
            $scope.id = id;
        }

        $scope.canAddButton = function () {
            return (IES.get().buttonCount < IES.get().buttonMax);
        };

        $scope.isPanelEnabled = function () {
            var obj = canvas.fabric.getActiveObject();
            return obj && obj.niceName && obj.niceName.indexOf("button") == 0 && simpleShapes.selected.options;
        };

        $scope.isShapePanelEnabled = function () {
            var obj = canvas.fabric.getActiveObject();
            return obj && obj.niceName && obj.niceName == 'shape';
        };

        $scope.movingObject = false;

        $scope.showAction = function () {

            var object = $scope.shapes.currentObj;
            var data = null;
            var actionType = null;

            if (object && object.action) {
                var data = object.action.split(/:(.+)?/);
                actionType = (data[0] || '');
                //action = ( data[1] || '' );
            }

            if (actionType == 'link' || actionType == 'phone')
                return true;

            return false;
        }

        $scope.showTemplateForReply = function () {
            var object = $scope.shapes.currentObj;
            var data = null;
            var actionType = null;

            if (object && object.action) {
                var data = object.action.split(/:(.+)?/);
                actionType = (data[0] || '');
                //action = ( data[1] || '' );
            }

            if (actionType == 'sendtemplateonreply' || actionType == 'sendtemplateon911')
                return true;

            return false;
        }

        $scope.isAppt = function () {
            var data = IES.get();
            if (data) return data.type == 'appointment';
            return false;
        }

        canvas.fabric.on("text:changed", function (event) {
            var obj = event.target;
            if (obj && obj.niceName && obj.niceName.indexOf("button") == 0) {
                simpleShapes.setButtonShape(obj);
            }
        })

        canvas.fabric.on('object:modified', function (event) {
            var obj = event.target;
            if (obj && obj.niceName && obj.niceName.indexOf("button") == 0) {
                simpleShapes.setButtonShape(obj);
            }
        });

        canvas.fabric.on('mouse:down', function (event) {
            //if (IES.get().activeTab !== 'simple-shapes' && IES.get().activeTab !== 'text' ) return;
            $scope.movingObject = event.target;
        });

        canvas.fabric.on('mouse:up', function (event) {
            //if (IES.get().activeTab !== 'simple-shapes' && IES.get().activeTab !== 'text' ) return;
            $scope.movingObject = false;
        });

        canvas.fabric.on('mouse:move', function (event) {
            //if (IES.get().activeTab !== 'simple-shapes' && IES.get().activeTab !== 'text' ) return;
            if ($scope.movingObject && $scope.movingObject.niceName && $scope.movingObject.niceName.indexOf("button") == 0) {
                if ($scope.movingObject) {
                    simpleShapes.setButtonPos($scope.movingObject);
                }
            }
        });

        canvas.fabric.on('object:moving', function (event) {
            var obj = event.target;
            if (obj && obj.name == 'editable') {
                if (obj.top < 10)
                    obj.top = 10;
                if (obj.top + 235 + 10 > 1000)
                    obj.top = 1000 - 235 - 10;
                obj.setCoords();
            }
            if (obj && obj.name == 'orgbanner') {
                obj.top = 0;
                obj.left = 0;
                obj.setCoords();
            }

            if (obj && obj.name == 'entryfield') {
                obj.left = 15;
                obj.setCoords();
            }
        });

        $scope.setupButton = function (obj) {
            var search = obj;
            var button = undefined;
            var text = undefined;
            var icon = undefined;
            while (search) {
                if (search.name == 'text') {
                    text = search;
                } else if (search.name == 'icon') {
                    icon = search;
                } else {
                    button = search;
                }
                search = search.textObj;
                if (search == obj) search = null;
            }

            // a button
            if (text) {

                if (button) simpleShapes.selectShape(button);

                if (button)
                    $scope.$broadcast('panel.setcolor', { type: "shapes", color: button.fill.toString() });
                else
                    $scope.$broadcast('panel.setcolor', { type: "shapes", color: "#FFF" });


                if (icon)
                    $scope.$broadcast('panel.setcolor', { type: "icon", color: icon.fill.toString() });
                else
                    $scope.$broadcast('panel.setcolor', { type: "icon", color: "#FFF" });
            }
        }

        $scope.setupShape = function (obj) {
            simpleShapes.selectShape(obj);
            $scope.$broadcast('panel.setcolor', { type: "shapes", color: obj.fill.toString() });

        }

        $scope.panelGetObject = $rootScope.$on('panel.getobject', function (event, obj, id) {
            if (!$scope.isPanelEnabled() && !$scope.isShapePanelEnabled()) return;
            if ($scope.id != id) return;

            if (id == 'button') {
                $scope.setupButton(obj);
            } else if (id == 'shape') {
                $scope.setupShape(obj);
            }

        });

        $scope.$on('$destroy', function () {
            $scope.panelGetObject();

        });

        $scope.clickHeader = function (name) {
            if ($scope.activeHeader == name)
                $scope.activeHeader = false;
            else
                $scope.activeHeader = name;
        }

    }]);
angular.module('image.shapes')

.controller('StickersController', ['$scope', '$rootScope', 'canvas', 'simpleShapes', 'history', 'settings', 'IES', function($scope, $rootScope, canvas, simpleShapes, history, settings, IES) {
	$scope.shapes = simpleShapes;
    $scope.opacity = 0.9;

    var stickers = 
    [
                {"name":"bubbles","items":104,"type":"png"},
                {"name":"stars","items":6,"type":"png","darkbg":true},
                {"name":"transportation","items":22,"type":"svg"},
                {"name":"doodles","items":100,"type":"svg"},
                {"name":"landmarks","items":100,"type":"svg"},
                {"name":"beach","items":22,"type":"svg"},
                {"name":"animals","items":10,"type":"png"},
                {"name":"clouds","items":15,"type":"png","darkbg":true}
            ];


    for (var i = stickers.length - 1; i >= 0; i--) {
        stickers[i].items = new Array(stickers[i].items);
    };

    $scope.categories = stickers;
    $scope.activeCategory = false;

    $scope.iconCategories = simpleShapes.iconCategories;

    $scope.init = function(id)
    {
        $scope.id = id;
    };

    $scope.isPanelEnabled = function() {
        var obj = canvas.fabric.getActiveObject();
        if( $scope.id == 'sticker' )
            return obj && obj.name == 'sticker';
        
        return false;
    };

    $scope.activeStickerIsSvg = function() {
        var obj = canvas.fabric.getActiveObject();

        return obj && obj.imagetype == 'svg';
    };

    $scope.setActiveCategory = function(name) {
        if ($scope.activeCategory === name) {
            $scope.activeCategory = false;
        } else {
            $scope.activeCategory = name;
        }
    };

    $scope.setOpacity = function(opacity) {
        simpleShapes.getShape('sticker').setOpacity(opacity);
        canvas.fabric.renderAll();
    };

    $scope.setColor = function(color) {
        var obj = simpleShapes.getShape('sticker');

        if (obj.isSameColor && obj.isSameColor() || ! obj.paths) {
            obj.setFill(color);
        }
        else if (obj.paths) {
            for (var i = 0; i < obj.paths.length; i++) {
                if( obj.paths[i].fill != undefined && obj.paths[i].fill == '') continue;
                obj.paths[i].setFill(color);
            }
        }

        canvas.fabric.renderAll();
    };

    $scope.addButtonIcon = function(index) {   
        simpleShapes.addButtonIcon(index);
    };

    $scope.addToCanvas = function(category, index, e) {
       // if ($scope.loading) return;
        //$scope.loading = true;
        IES.get().openPanel('stickers', e);

        if (category.type === 'svg') {
            fabric.loadSVGFromURL('assets/images/stickers/'+category.name+'/'+index+'.'+category.type, function (objects, options) {
                var image = fabric.util.groupSVGElements(objects, options);
                //var image = new fabric.Image(img);
                image.name = 'sticker';
                image.niceName = 'sticker';
                image.fill = "#000";
                image.imagetype = category.type;
                canvas.fabric.add(image);
                image.scaleToHeight((40 / 100) * canvas.fabric.getHeight());
                image.center();
                image.setCoords();
                canvas.fabric.setActiveObject(image);
                canvas.fabric.renderAll();

               /* $scope.$apply(function() {
                    $scope.loading = false;
                });*/

               // history.add('Added: Sticker', 'favorite');
            });
        } else {
            fabric.util.loadImage('assets/images/stickers/'+category.name+'/'+index+'.'+category.type, function(img) {
                var image = new fabric.Image(img);
                image.name = 'sticker';
                image.niceName = 'sticker';
                image.imagetype = category.type;
                canvas.fabric.add(image);
                image.center();
                image.setCoords();
                image.scaleToHeight((40 / 100) * canvas.original.height);

                canvas.fabric.setActiveObject(image);
                canvas.fabric.renderAll();

               /* $scope.$apply(function() {
                    $scope.loading = false;
                });*/

               // history.add('Added: Sticker', 'favorite');
            });
        }
    }

    $scope.panelGetObject = $rootScope.$on('panel.getobject', function(event, obj) {
        if( !$scope.isPanelEnabled() ) return;
        $scope.opacity = obj.getOpacity();
        $scope.$broadcast('panel.setcolor', {type:"sticker",color:obj.fill.toString()});        
    });

    $scope.$on('$destroy', function() {
        $scope.panelGetObject();        
    });

}]);
angular.module('image.shapes')

.directive('edStickersCategories', function() {
    return {
        restrict: 'A',
        link: function($scope, el) {

            //load sticker images into open category when stickers tab is opened
            var unbind = $scope.$watch('activeTab', function(newTab) {
                //if (newTab !== 'stickers') return;

                var cat = $('.category-stickers.open');

                cat.find('img').each(function() {
                    this.src = this.dataset.src;
                });

                cat.parent().addClass('loaded');

                unbind();
            });

            //load sticker images for the category that just been opened
            el.on('click', '.category-header', function(e) {
                $scope.$apply(function() {
                    $scope.setActiveCategory(e.target.dataset.name);
                });

                var category = $(e.currentTarget).parent();

                if ( ! category.hasClass('loaded')) {
                    category.addClass('loaded').find('img').each(function() {
                        this.src = this.dataset.src;
                    });
                }
            });
        }
   	}
});
angular.module('image.shapes')

    .filter('orderOptions', function () {
        return function (items, field, reverse) {
            var filtered = [];
            angular.forEach(items, function (item, key) {
                item.name = key;
                filtered.push(item);
            });
            filtered.sort(function (a, b) {
                return (a[field] > b[field] ? 1 : -1);
            });
            if (reverse) filtered.reverse();

            return filtered;
        };
    })

    .service('simpleShapes', ['$rootScope', '$log', 'canvas', 'polygon', 'history', 'IES', 'fonts', 'OrganizationService', function ($rootScope, $log, canvas, polygon, history, IES, fonts, OrganizationService) {

        var shapes = {

            gradients: edGradients,

            textures: new Array(28),

            baseOptions: {
                main: {
                    enabled: true,
                    //opacity: { type: 'slider', current: 1, min: 0.1, max: 1, step: 0.1 },
                    fill: { type: 'colorpicker', current: '#263238', hidden: true }
                },
                /*border: {
                    enabled: false,
                    onToggle: 'toggleBorder',
                    stroke: { type: 'colorpicker', current: '#2196F3', displayName: 'Color' },
                    strokeWidth: { type: 'slider', current: 5, max: 40, displayName: 'Width' }
                },
                shadow: {
                    enabled: false,
                    onToggle: 'toggleShadow',
                    color: { type: 'colorpicker', current: 'rgba(0,0,0,0.5)'},
                    blur: { type: 'slider', current: 5, max: 80 },
                    offsetX: { type: 'slider', current: 8, max: 30 },
                    offsetY: { type: 'slider', current: 5, max: 30 }
                }*/
            },

            available: [],
            actionType: '',
            action: 'type action text here',
            currentObj: false,
            selected: false,
            horizontal: 0,
            vertical: 0,

            fillWithGradient: function (index, type) {
                var shape = canvas.fabric.getActiveObject();

                shape.setGradient(type || 'fill', this.gradients[index]);

                canvas.fabric.renderAll();
            },

            fillWithImage: function (url) {
                var shape = canvas.fabric.getActiveObject();

                fabric.util.loadImage(url, function (img) {
                    shape.setPatternFill({ source: img });
                    canvas.fabric.renderAll();
                });
            },

            // shape
            addShapeToCanvas: function (shape) {
                if (!this.shapeExists(shape)) return;
                this.selected = shape;

                //we might need to enable a drawing mode instead
                //of added a shape to canvas if we get passed polygon
                if (shape.service && shape.service.enable) {
                    return shape.service.enable();
                }

                var fabricShape = this.createNewShape(shape);

                /*var shape = new fabric.Rect({width:100,height:100,fill:'#000'});
                canvas.fabric.add( shape );
                canvas.center(shape);
                canvas.fabric.renderAll();*/

                if (fabricShape.niceName != 'editable' || fabricShape.niceName != 'orgbanner' || fabricShape.niceName != 'entryfield') fabricShape.niceName = 'shape';
                canvas.fabric.add(fabricShape);
                if (shape.name != 'editable' && shape.name != 'orgbanner' && shape.name != 'entryfield') canvas.center(fabricShape);
                canvas.fabric.setActiveObject(fabricShape);
                canvas.fabric.renderAll();

                history.add('Added: ' + shape.name, 'panorama-vertical');
            },

            // button
            addToCanvas: function (shape, options) {

                if (options) {
                    for (var i = 0; i < shapes.available.length; i++) {
                        if (options.shape == shapes.available[i].name) {
                            shape = shapes.available[i];
                            break;
                        }
                    }
                }
                if (!this.shapeExists(shape)) return;

                if (IES.get().buttonCount >= IES.get().buttonMax) return;

                this.selected = shape;
                var fabricShape = this.createNewShape(shape);

                canvas.fabric.add(fabricShape);
                canvas.fabric.setActiveObject(fabricShape);
                fabricShape._controlsVisibility.tl = false;
                fabricShape._controlsVisibility.tr = false;
                fabricShape._controlsVisibility.br = false;
                fabricShape._controlsVisibility.bl = false;
                fabricShape._controlsVisibility.ml = false;
                fabricShape._controlsVisibility.mt = false;
                fabricShape._controlsVisibility.mr = false;
                fabricShape._controlsVisibility.mb = false;
                fabricShape._controlsVisibility.mtr = false;

                fabricShape.niceName += ' ' + IES.get().buttonCount;
                var text = null;
                if (options && options.name) text = options.name;
                var fontObj = this.addButtonFont(fabricShape, text);
                fabricShape.textObj = fontObj;
                fontObj.niceName += ' ' + IES.get().buttonCount;

                this.setButtonShape(fontObj);

                //this.addButtonIcon(fabricShape,1);

                // set button, user can't touch
                if (options) {
                    fabricShape.editable = false;
                    fontObj.editable = false;
                    fontObj.selectable = false;
                    fabricShape.selectable = false;
                    fabricShape.action = options.action;
                    fontObj.top = options.top;
                    fontObj.left = options.left;
                    this.setButtonPos(fontObj);
                    if (options.icon) {
                        this.addButtonIcon(options.icon)
                    }
                    fabricShape.horizontal = options.horizontal;
                    fabricShape.vertical = options.vertical;
                    fabricShape.corners = options.corners;
                    fabricShape.rx = options.corners;
                    fabricShape.ry = options.corners;
                    fabricShape.fill = options.color;

                    this.setButtonShape(fontObj);
                }

                /*fabricShape.left = fontObj.left-20;
                fabricShape.top = fontObj.top-20;
                fabricShape.width = fontObj.width+40;
                fabricShape.height = fontObj.height+40;
                fabricShape.radius = fontObj.width;
                fabricShape.scaleX = 1;
                fabricShape.scaleY = 1;
                fabricShape.setCoords();*/

                canvas.fabric.renderAll();
                IES.get().countButtons();

                history.add('Added: ' + shape.name, 'panorama-vertical');
            },

            addButtonFont: function (button, text) {
                var font = 'Open Sans';
                var active = canvas.fabric.getActiveObject();
                if (!text) text = 'Button';
                if (!active || active.name !== 'text') {
                    var newText = new fabric.IText(text, {
                        fontWeight: 400,
                        fontSize: 38,
                        fill: '#fff',
                        removeOnCancel: true,
                        name: 'text',
                        niceName: 'button text',
                        textAlign: 'center',
                        fontFamily: 'Open Sans'
                    });

                    canvas.fabric.add(newText);
                    ///newText.setTop(button.top);
                    ///newText.setLeft(button.left);
                    newText.textObj = button;
                    canvas.fabric.setActiveObject(newText);
                    //newText.text.setProperty('textAlign', 'center');
                    newText._controlsVisibility.tl = false;
                    newText._controlsVisibility.tr = false;
                    newText._controlsVisibility.br = false;
                    newText._controlsVisibility.bl = false;
                    newText._controlsVisibility.ml = false;
                    newText._controlsVisibility.mt = false;
                    newText._controlsVisibility.mr = false;
                    newText._controlsVisibility.mb = false;
                    newText._controlsVisibility.mtr = false;

                    canvas.fabric.renderAll();
                }

                fonts.createLinkToFont(newText.fontFamily);

                return newText;
            },

            addButtonIcon: function (index) {
                var buttonText = canvas.fabric.getActiveObject();

                var search = buttonText;
                var button = undefined;
                var text = undefined;
                var icon = undefined;
                while (search) {
                    if (search.name == 'text') {
                        text = search;
                    } else if (search.name == 'icon') {
                        icon = search;
                    } else {
                        button = search;
                    }
                    search = search.textObj;
                    if (search == buttonText) search = null;
                }

                var category = this.iconCategories[0];
                var local = this;
                if (index == 0) {
                    if (icon) {
                        canvas.fabric.remove(icon);
                        text.textObj = button;
                    }
                    this.setButtonShape(text);
                    canvas.fabric.renderAll();
                    return;
                }
                if (category.type === 'svg') {

                    fabric.loadSVGFromURL('assets/images/stickers/' + category.name + '/' + index + '.' + category.type, function (objects, options) {
                        var image = fabric.util.groupSVGElements(objects, options);
                        local.setupIcon(button, text, image);
                    });
                } else {
                    fabric.util.loadImage('assets/images/stickers/' + category.name + '/' + index + '.' + category.type, function (img) {
                        var image = new fabric.Image(img);
                        local.setupIcon(button, text, image);

                    });
                }
            },

            setupIcon: function (button, text, image) {
                image.name = 'icon';
                image.niceName = 'icon';
                canvas.fabric.add(image);
                image.center();
                image.setCoords();
                canvas.fabric.setActiveObject(image);
                var color = button.iconfill || "#fff";
                if (image.isSameColor && image.isSameColor() || !image.paths) {
                    image.setFill(color);
                }
                else if (image.paths) {
                    for (var i = 0; i < image.paths.length; i++) {
                        if (image.paths[i].fill != undefined && image.paths[i].fill == '') continue;
                        image.paths[i].setFill(color);
                    }
                }

                image._controlsVisibility.tl = false;
                image._controlsVisibility.tr = false;
                image._controlsVisibility.br = false;
                image._controlsVisibility.bl = false;
                image._controlsVisibility.ml = false;
                image._controlsVisibility.mt = false;
                image._controlsVisibility.mr = false;
                image._controlsVisibility.mb = false;
                image._controlsVisibility.mtr = false;

                if (button.editable == false)
                    image.editable = false;
                if (button.selectable == false)
                    image.selectable = false;

                if (text.textObj && text.textObj.name == 'icon') {
                    canvas.fabric.remove(text.textObj);
                }

                var id = text.niceName.replace('button text ', '');
                id = parseInt(id);

                image.niceName = 'button icon ' + id;
                text.textObj = image;
                image.textObj = button;

                this.setButtonShape(button);
                canvas.fabric.setActiveObject(text);
                canvas.fabric.renderAll();
            },

            applyAction: function () {
                this.currentObj.action = this.actionType + ":" + this.action;
                canvas.fabric.renderAll();
            },

            applyValue: function (group, name, option, value) {
                var setter = 'set' + fabric.util.string.capitalize(option, true),
                    shape = this.getShape(name);

                if (group === 'shadow') {
                    return this.applyShadowValue(shape, option, value);
                }

                if (option == 'corners') {
                    shape.rx = value;
                    shape.ry = value;
                    shape.setCoords();
                    canvas.fabric.renderAll();
                } else if (option == 'horizontal') {
                    shape.horizontal = value;
                    this.setButtonShape(this.currentObj.textObj);
                    canvas.fabric.renderAll();
                } else if (option == 'vertical') {
                    shape.vertical = value;
                    this.setButtonShape(this.currentObj.textObj);
                    canvas.fabric.renderAll();
                } else if (option == 'iconfill') {
                    if (shape.textObj && shape.textObj.textObj && shape.textObj.textObj.name == 'icon') {
                        shape.textObj.textObj.setFill(value);
                        shape.textObj.textObj.fill = value;
                        shape.iconfill = value;
                        canvas.fabric.renderAll();
                    }

                } else if (this.selected && this.selected.name === name) {

                    //use setter if available, other simply assign the value
                    shape[setter] ? shape[setter](value) : shape[option] = value;
                    shape.setCoords();
                    //  canvas.fabric.setActiveObject(shape);
                    canvas.fabric.renderAll();
                }
            },

            applyShadowValue: function (shape, option, value) {
                if (!shape) return;

                var options = {
                    color: this.selected.options.shadow.color.current,
                    blur: this.selected.options.shadow.blur.current,
                    offsetX: this.selected.options.shadow.offsetX.current,
                    offsetY: this.selected.options.shadow.offsetY.current
                };

                if (option && value) {
                    options[option] = value;
                }

                shape.setShadow(options);
                canvas.fabric.renderAll();
            },

            toggleShadow: function (name, on) {
                if (on) {
                    this.applyShadowValue(this.getShape(name));
                } else {
                    this.getShape(name).setShadow(false);
                    canvas.fabric.renderAll();
                }
            },

            /**
             * Toggle border on/off on active object in the canvas.
             *
             * @param name
             * @param on
             */
            toggleBorder: function (name, on) {
                if (on) {
                    this.getShape(name).setStroke(this.selected.options.border.stroke);
                } else {
                    this.getShape(name).setStroke(false);
                }

                canvas.fabric.renderAll();
            },

            shapeExists: function (shape) {
                for (var i = 0; i < this.available.length; i++) {
                    if (this.available[i].name === shape.name) {
                        return true;
                    }
                }
            },

            setButtonShape: function (obj) {
                if (!obj) return;
                var search = obj;
                var button = undefined;
                var text = undefined;
                var icon = undefined;
                while (search) {
                    if (search.name == 'text') {
                        text = search;
                    } else if (search.name == 'icon') {
                        icon = search;
                    } else {
                        button = search;
                    }
                    search = search.textObj;
                    if (search == obj) search = null;
                }

                var horizontal = button.horizontal | 0;
                var vertical = button.vertical | 0;
                var iconOffset = 0;

                if (icon) {
                    icon.scaleX = text.height / icon.height;
                    icon.scaleY = icon.scaleX;
                    icon.left = text.left - icon.width * icon.scaleX - 20;
                    icon.top = text.top;
                    icon.setCoords();
                    iconOffset = icon.width * icon.scaleX + 20;
                }

                if (button && text) {
                    if (button.name == 'circle') {
                        button.radius = (text.width + iconOffset) / 2 + 20;
                        button.height = button.radius * 2;
                        button.width = button.radius * 2;
                        button.left = text.left - 20 - iconOffset;
                        button.top = text.top - (button.radius - (text.height / 2));
                    } else if (button.name == 'rect') {
                        button.left = text.left - 20 - horizontal - iconOffset;
                        button.top = text.top - 20 - vertical;
                        button.width = text.width + 40 + horizontal * 2 + iconOffset;
                        button.height = text.height + 40 + vertical * 2;
                    } else if (button.name == 'ellipse') {
                        button.rx = text.width;
                        button.ry = text.height;
                        button.left = text.left - 20;
                        button.top = text.top - 20;
                        button.width = text.width + 40;
                        button.height = text.height + 40;
                    }

                    button.scaleX = 1;
                    button.scaleY = 1;
                    text.scaleY = 1;
                    text.scaleX = 1;
                    button.setCoords();
                }
            },

            setButtonPos: function (moving) {
                var search = moving;
                var button = undefined;
                var text = undefined;
                var icon = undefined;

                while (search) {
                    if (search.name == 'text') {
                        text = search;
                    } else if (search.name == 'icon') {
                        icon = search;
                    } else {
                        button = search;
                    }
                    search = search.textObj;
                    if (search == moving) search = null;
                }

                var horizontal = button.horizontal | 0;
                var vertical = button.vertical | 0;
                var iconOffset = 0;

                if (icon) {
                    iconOffset = icon.width * icon.scaleX + 20;
                }

                if (moving.name == 'text') {
                    // don't need to do anything
                } else if (moving.name == 'icon') {
                    text.left = moving.left + moving.width * moving.scaleX + 20;
                    text.top = moving.top;
                    //$log.debug(text.left);
                } else { // shape
                    if (button.name == 'circle') {
                        text.left = button.left + 20 + iconOffset;
                        text.top = button.top + (button.radius - (text.height / 2));
                    } else if (button.name == 'rect') {
                        text.left = button.left + 20 + horizontal + iconOffset;
                        text.top = button.top + 20 + vertical;
                    } else if (button.name == 'ellipse') {
                        text.left = button.left + 20;
                        text.top = button.top + 20;
                    }
                }

                this.setButtonShape(moving);
            },

            /**
             * Return a first available fabric object that matches given name.
             *
             * @param name
             * @returns {fabric.Object|*}
             */
            getShape: function (name) {
                var active = canvas.fabric.getActiveObject();

                if (active && active.name === name) {
                    return active;
                }

                active = this.currentObj;

                return active;
            },

            /**
             * Create new fabric shape from given config object.
             *
             * @param shape
             */
            createNewShape: function (shape) {
                var shapeName = fabric.util.string.capitalize(shape.name, true);
                if (IES.get().buttonCount >= IES.get().buttonMax) return;
                var name = shapeName;
                if (shapeName == 'Editable' || shapeName == 'Orgbanner' || shapeName == 'Entryfield') {
                    name = 'Rect';
                }
                if (fabric[name]) {

                    var sw = 0;
                    if (shape.options.boarder) sw = shape.options.border.strokeWidth.current;

                    var options = {
                        strokeWidth: sw
                    };

                    angular.forEach(shape.options.main, function (val, key) {
                        if (typeof val !== 'boolean') {
                            options[key] = val.current;
                        }
                    });

                    if (shape.creation) {
                        if (shape.name == "editable") {
                            var newShape = new fabric[name](shape.creation);
                            var text = new fabric.Text("Text Message",
                                {
                                    fill: "#000",
                                    fontWeight: "bold",
                                    left: newShape.left + 15,
                                    top: newShape.top + 15,
                                    fontFamily: 'Roboto',
                                    width: newShape.width,
                                    height: newShape.height,
                                    textAlign: 'left'
                                });
                            var group = new fabric.Group([newShape, text]);
                            group.hasControls = false;
                            //canvas.fabric.add(group);
                            group.name = shape.name;
                            group.niceName = shape.niceName;
                            group.displayName = shape.displayName;

                            newShape = group;
                        } else if (shape.name == 'orgbanner') {
                            var newShape = new fabric[name](shape.creation);
                            var org = OrganizationService.get();
                            var titleText = new fabric.Text(org.name,
                                {
                                    fill: "#FFF",
                                    left: newShape.left + 25,
                                    top: newShape.top + 25,
                                    fontFamily: 'Roboto',
                                    fontSize: 40,
                                    width: newShape.width,
                                    height: newShape.height,
                                    textAlign: 'left'
                                });
                            var address = '';
                            if (org.street) {
                                address += org.street;
                            }
                            if (org.street2) {
                                address += ' ' + org.street2;
                            }
                            if (org.city) {
                                address += ' - ' + org.city;
                            }

                            address += ', ' + org.state + ' - ' + org.zip;

                            var addressText = new fabric.Text(address,
                                {
                                    fill: "#FFF",
                                    left: newShape.left + 25,
                                    top: newShape.top + 75,
                                    fontFamily: 'Roboto',
                                    fontSize: 24,
                                    width: newShape.width,
                                    height: newShape.height,
                                    textAlign: 'left'
                                });

                            var group = new fabric.Group([newShape, titleText, addressText]);
                            group.hasControls = false;
                            //canvas.fabric.add(group);
                            group.name = shape.name;
                            group.niceName = shape.niceName;
                            group.displayName = shape.displayName;

                            newShape = group;

                        } else if (shape.name == 'entryfield') {
                            var newShape = new fabric[name](shape.creation);
                            var left = newShape.left + 10;
                            var editTop = newShape.top + 10;
                            var uTop = newShape.top + 60;
                            var editText = new fabric.Text('Entries will go here...', {
                                fill: "#CCC",
                                left: left,
                                top: editTop,
                                fontFamily: 'Roboto',
                                width: newShape.width,
                                height: newShape.height,
                                textAlign: 'left'
                            });
                            var underline = new fabric.Rect({
                                width: 660,
                                height: 3,
                                fill: '#000000',
                                left: left,
                                top: uTop,
                            });
                            var group = new fabric.Group([newShape, editText, underline]);
                            group.hasControls = false;
                            //canvas.fabric.add(group);
                            group.name = shape.name;
                            group.niceName = shape.niceName;
                            group.displayName = shape.displayName;
                            newShape = group;

                        }



                    } else if (shape.options.points) {
                        var newShape = new fabric[name](shape.options.points.current, options);
                    } else {
                        var newShape = new fabric[name](options);
                    }

                    newShape.name = shape.name;
                    newShape.niceName = shape.niceName;
                    newShape.action = 'type action here';

                    return newShape;
                }
            },

            selectShape: function (object) {
                var name = object.name;

                for (var i = 0; i < this.available.length; i++) {
                    if (this.available[i].name === name) {
                        this.selected = this.available[i];
                        break;
                    }
                }

                this.currentObj = object;

                if (object && object.action) {
                    var data = object.action.split(/:(.+)?/);
                    this.actionType = (data[0] || '');
                    this.action = (data[1] || '');
                }

                this.horizontal = 0;
                this.vertical = 0;

                for (var attrname in this.selected.options.main) {
                    var prop = this.selected.options.main[attrname];
                    if (object[attrname] != undefined && prop.current)
                        prop.current = object[attrname];
                }

                // custom rect properties
                if (this.selected.name == 'rect') {
                    if (object && object.rx != undefined) {
                        this.selected.options.main.corners.current = object.rx;
                    }
                    if (object && object.horizontal != undefined) {
                        this.horizontal = object.horizontal;
                    }
                    if (object && object.vertical != undefined) {
                        this.vertical = object.vertical;
                    }
                }
            }
        };

        shapes.iconCategories = [{ "name": "icons", "items": 256, "type": "svg" }];
        for (var i = shapes.iconCategories.length - 1; i >= 0; i--) {
            shapes.iconCategories[i].items = new Array(shapes.iconCategories[i].items);
        };

        var circleOptions = angular.copy(shapes.baseOptions);
        circleOptions.main.radius = { type: 'slider', current: 240, min: 20 };

        shapes.available.push({
            name: 'circle',
            niceName: 'button circle',
            options: circleOptions,
            button: true
        });

        var rectOptions = angular.copy(shapes.baseOptions);
        rectOptions.main.width = { type: 'slider', current: 250 };
        rectOptions.main.height = { type: 'slider', current: 150 };
        rectOptions.main.corners = { type: 'slider', current: 0, min: 0, max: 25 };

        shapes.available.push({
            name: 'rect',
            niceName: 'button rect',
            displayName: 'rectangle',
            options: rectOptions,
            button: true
        });

        var triangleOptions = angular.copy(shapes.baseOptions);
        triangleOptions.main.width = { type: 'slider', current: 140, min: 25 };
        triangleOptions.main.height = { type: 'slider', current: 140, min: 25 };

        shapes.available.push({
            name: 'triangle',
            options: triangleOptions,
            button: false
        });

        /*var rectOptions = angular.copy(shapes.baseOptions);
        rectOptions.main.width = { type: 'slider', current: 600, min: 200, max: 700 };
        rectOptions.main.height = { type: 'slider', current: 300, min: 300, max: 300 };*/

        shapes.available.push({
            name: 'editable',
            niceName: 'editable',
            displayName: 'editable text',
            options: {},
            creation: { width: 685, height: 235, top: 10, left: 15, fill: '#FFFFFF', rx: 10, ry: 10, lockMovementX: true, lockScalingX: true, lockScalingY: true, lockRotation: true, hasControls: false },
            button: false
        });

        shapes.available.push({
            name: 'entryfield',
            niceName: 'entryfield',
            displayName: 'Entry Field',
            options: {},
            creation: { width: 685, height: 70, top: 10, left: 15, fill: '#FFFFFF', lockMovementX: true, lockScalingX: true, lockScalingY: true, lockRotation: true, hasControls: false },
            button: false
        });

        shapes.available.push({
            name: 'orgbanner',
            niceName: 'orgbanner',
            displayName: 'Org Banner',
            options: {},
            creation: { width: 720, height: 125, top: 0, left: 0, fill: 'rgba(10,79,120,1)', lockMovementX: true, lockScalingX: true, lockScalingY: true, lockRotation: true, hasControls: false },
            button: false
        });

        /*var ellipse = angular.copy(shapes.baseOptions);
        ellipse.main.rx = { type: 'slider', current: 80, displayName: 'horizontal radius' };
        ellipse.main.ry = { type: 'slider', current: 30, displayName: 'vertical radius' };
    
        shapes.available.push({
            name: 'ellipse',
            niceName: 'button ellipse',
            options: ellipse,
            button: false
        });*/

        /*shapes.available.push({
            name: 'polygon',  options: angular.copy(shapes.baseOptions), service: polygon,
            button: false
        });*/

        return shapes;
    }]);
angular.module('image.shapes')

.service('polygon', ['$rootScope', '$mdDialog', 'canvas', function ($rootScope, $mdDialog, canvas) {

    var self = {

        mode: 'add',
        currentShape: false,

        onMouseMove: function(event) {
            var pos = canvas.fabric.getPointer(event.e);
            if (self.mode === "edit" && self.currentShape) {
                var points = self.currentShape.get("points");
                points[points.length - 1].x = pos.x - self.currentShape.get("left");
                points[points.length - 1].y = pos.y - self.currentShape.get("top");
                self.currentShape.set({
                    points: points
                });
                canvas.fabric.renderAll();
            }
        },

        onMouseDown: function(event) {
            var pos = canvas.fabric.getPointer(event.e);

            if (self.mode === "add") {
                var poly = new fabric.Polygon([{
                    x: pos.x,
                    y: pos.y
                }, {
                    x: pos.x + 0.5,
                    y: pos.y + 0.5
                }], {
                    fill: 'black',
                    opacity: 1,
                    selectable: false
                });
                self.currentShape = poly;
                self.currentShape.name = 'polygon';
                canvas.fabric.add(self.currentShape);
                self.mode = "edit";
            } else if (self.mode === "edit" && self.currentShape && self.currentShape.type === "polygon") {
                var points = self.currentShape.get("points");
                points.push({
                    x: pos.x - self.currentShape.get("left"),
                    y: pos.y - self.currentShape.get("top")
                });
                self.currentShape.set({
                    points: points
                });
                canvas.fabric.renderAll();
            }
        },

        onEscape: function(e) {
            if ((!e && self.currentShape) || e && e.keyCode === 27) {
                if (self.mode === 'edit' || self.mode === 'add') {
                    self.mode = 'normal';
                    self.currentShape.set({
                        selectable: true
                    });

                    self.currentShape._calcDimensions();
                    self.currentShape.setCoords();

                    canvas.fabric.setActiveObject(self.currentShape);
                    canvas.fabric.renderAll();
                } else {
                    self.mode = 'add';
                }

                self.currentShape = null;
            }
        },

        onClick: function(e) {
            var clickedInModal = $(e.target).closest('.md-dialog-container')[0];

            if (e.target.nodeName !== 'CANVAS' && $(e.target).closest('.shape').data('name') !== 'polygon' && !clickedInModal) {
                self.disable();
            }
        },

        enable: function() {
            if (this.enabled) return;

            this.enabled = true;
            canvas.fabric.on('mouse:move', self.onMouseMove);
            canvas.fabric.on('mouse:down', self.onMouseDown);
            fabric.util.addListener(window, 'keyup', self.onEscape);

            setTimeout(function() {
                fabric.util.addListener(window, 'click', self.onClick);
            }, 20);

            $mdDialog.show({
                templateUrl: 'modals/polygon.html',
                clickOutsideToClose: true,
                controller: ['$scope', '$mdDialog', function($scope, $mdDialog) {
                    $scope.closeModal = $mdDialog.hide;
                }]
            });
        },

        disable: function() {
            this.enabled = false;
            canvas.fabric.off('mouse:move', self.onMouseMove);
            canvas.fabric.off('mouse:down', self.onMouseDown);
            fabric.util.removeListener(window, 'keyup', self.onEscape);
            fabric.util.removeListener(window, 'click', self.onClick);
            self.onEscape();
        }
    };

    return self;

}]);
var edGradients = {
    1: {
        type: 'linear',
        x1: -80,
        y1: 0,
        x2: 80,
        y2: 0,
        colorStops: {
            0: '#ffe47b',
            1: 'rgb(111,154,211)'
        }
    },

    2:  {
        type: 'linear',
        x1: 0,
        y1: -120,
        x2: 0,
        y2: 120,
        colorStops: {
            0: '#ff4040',
            1: '#e6399b'
        }
    },

    3: {
        type: 'linear',
        x1: -90,
        y1: -90,
        x2: 90,
        y2: 90,
        colorStops: {
            0: 'rgb(166,111,213)',
            0.5: 'rgba(106, 72, 215, 0.5)',
            1: '#200772'
        }
    },

    4: {
        type: 'radial',
        r1: 100,
        r2: 10,
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        colorStops: {
            0: '#FF4F4F',
            1: 'rgb(255, 239, 64)'
        }
    },

    5: {
        type: 'radial',
        r1: 100,
        r2: 10,
        x1: 0,
        y1: 0,
        x2: 20,
        y2: 20,
        colorStops: {
            0: '#ffe47b',
            0.5: 'rgb(111,154,211)',
            1: 'rgb(166,111,213)'
        }
    },

    6: {
        type: 'radial',
        r1: 50,
        r2: 80,
        x1: 45,
        y1: 45,
        x2: 52,
        y2: 50,
        colorStops: {
            0: 'rgb(155, 237, 0)',
            1: 'rgba(0, 164, 128,0.4)'
        }
    },

    7: {
        type: 'linear',
        x1: -90,
        y1: -90,
        x2: 90,
        y2: 90,
        colorStops: {
            0: '#9ecb2d',
            0.5: '#72aa00',
            1: '#bfd255'
        }
    },

    8: {
        type: 'radial',
        r1: 100,
        r2: 50,
        x1: 30,
        y1: 0,
        x2: 0,
        y2: 0,
        colorStops: {
            0: '#aebcbf',
            1: '#0a0809'
        }
    },

    9: {
        type: 'linear',
        x1: -80,
        y1: 0,
        x2: 80,
        y2: 0,
        colorStops: {
            0: '#ffffff',
            1: '#f6f6f6'
        }
    },
    10:  {
        type: 'linear',
        x1: 0,
        y1: -120,
        x2: 0,
        y2: 120,
        colorStops: {
            0: '#fefcea',
            1: '#f1da36'
        }
    },
    11: {
        type: 'linear',
        x1: -90,
        y1: -90,
        x2: 90,
        y2: 90,
        colorStops: {
            0: 'rgb(166,111,213)',
            0.5: 'rgba(106, 72, 215, 0.5)',
            1: '#ff1a00'
        }
    },
    12:  {
        type: 'linear',
        x1: 0,
        y1: -120,
        x2: 0,
        y2: 120,
        colorStops: {
            0: '#b7deed',
            1: '#21b4e2'
        }
    },
    13: {
        type: 'linear',
        x1: -80,
        y1: 100,
        x2: 80,
        y2: -100,
        colorStops: {
            0: '#ffe47b',
            1: 'rgb(111,154,211)'
        }
    },
};
var colorsForPicker = ['#D24D57', '#F22613', '#D91E18', '#96281B', '#EF4836', '#D64541', '#C0392B', '#CF000F', '#E74C3C', '#DB0A5B', '#F64747', '#F1A9A0', '#D2527F', '#E08283', '#F62459', '#E26A6A', '#DCC6E0', '#663399', '#674172', '#AEA8D3', '#913D88', '#9A12B3', '#BF55EC', '#BE90D4', '#8E44AD', '#9B59B6', '#446CB3', '#E4F1FE', '#4183D7', '#59ABE3', '#81CFE0', '#52B3D9', '#C5EFF7', '#22A7F0', '#3498DB', '#2C3E50', '#19B5FE', '#336E7B', '#22313F', '#6BB9F0', '#1E8BC3', '#3A539B', '#34495E', '#67809F', '#2574A9', '#1F3A93', '#89C4F4', '#4B77BE', '#5C97BF', '#4ECDC4', '#A2DED0', '#87D37C', '#90C695', '#26A65B', '#03C9A9', '#68C3A3', '#65C6BB', '#1BBC9B', '#1BA39C', '#66CC99', '#36D7B7', '#C8F7C5', '#86E2D5', '#2ECC71', '#16a085', '#3FC380', '#019875', '#03A678', '#4DAF7C', '#2ABB9B', '#00B16A', '#1E824C', '#049372', '#26C281', '#FDE3A7', '#F89406', '#EB9532', '#E87E04', '#F4B350', '#F2784B', '#EB974E', '#F5AB35', '#D35400', '#F39C12', '#F9690E', '#F9BF3B', '#F27935', '#E67E22', '#ececec', '#6C7A89', '#D2D7D3', '#EEEEEE', '#BDC3C7', '#ECF0F1', '#95A5A6', '#DADFE1', '#ABB7B7', '#F2F1EF', '#BFBFBF', '#E6E2AF', '#A7A37E', '#EFECCA', '#046380', '#002F2F', '#468966', '#FFF0A5', '#FFB03B', '#B64926', '#8E2800', '#1E1E20'];
'use strict';

angular.module('ImageEditor', ['ngMaterial', 'ngAnimate', 'ui.sortable', 'image.crop', 'image.text', 'image.drawing', 'image.filters', 'image.shapes', 'image.directives', 'image.basics'])
/*
.config(['$mdThemingProvider', function($mdThemingProvider) {
    $mdThemingProvider.theme('default')
        .primaryPalette('deep-orange')
        .accentPalette('brown'); 
}])*/

.controller('BottomSheetController', ['$scope', '$mdBottomSheet', '$mdDialog', 'simpleShapes', function($scope, $mdBottomSheet, $mdDialog, simpleShapes) {
    $scope.shapes = simpleShapes;

    $scope.showDialog = function($event) {
        $mdDialog.show({
            template: $('#texture-upload-dialog-template').html(),
            targetEvent: $event,
            controller: 'BottomSheetController'
        });
    }
}]);
angular.module('ImageEditor')

.directive('edObjectsPanelSortable', ['$rootScope', 'canvas', function ($rootScope, canvas) {
    return {
        link: function ($scope, el) {
            var oldIndex, newIndex, obj;

            el.sortable({
                items: '.object:visible',
                scroll: false,
                containment: 'parent',
                start: function(e, ui) {
                    //oldIndex = $(ui.item).index();
                    ui.item.data('start', ui.item.index());
                },
                update: function(e, ui) {
                    //newIndex = $(ui.item).index();
                    var list = [];
                    
                    var start = ui.item.data('start'),
                        end   = ui.item.index();

                    canvas.fabric.forEachObject(function(obj) {
                        if( obj.editable == false ){
                            list.push(obj);
                        }
                    });

                    canvas.fabric._objects.splice(end, 0,canvas.fabric._objects.splice(start, 1)[0]);
                    $scope.objects = canvas.fabric._objects;

                    $scope.$apply();

                    //console.log($scope.objects);

                    obj = canvas.fabric.getObjects()[start];

                    if ( ! obj) return;

                    if (end > start) {
                        //send object forwards by the amount of objects it passed
                        for (var i = 0; i < (end - start); i++) {
                            canvas.fabric.bringForward(obj);
                        }
                    } else {
                        //send object backwards by the amount of objects it passed
                        for (var i = 0; i < (start - end); i++) {
                            canvas.fabric.sendBackwards(obj);
                        }
                    }

                    for(var i = 0; i < list.length; i++){
                        canvas.fabric.bringToFront(list[i]);
                    }

                    $scope.objects = canvas.fabric._objects;

                    $rootScope.$apply(function() {
                        canvas.fabric.renderAll();
                        start = false;
                    });
                }
            })
        }
    };
}]);

angular.module('ImageEditor')

.controller('ObjectsPanelController', ['$scope', '$rootScope', '$timeout', 'canvas', 'IES', function($scope, $rootScope, $timeout, canvas, IES) {
	$scope.objects = canvas.fabric._objects || [];

    $scope.sortableOptions = {
        items: '.object:visible',
        scroll: false,
        containment: 'parent',
        startedIndex: 0,
        start: function(e, ui) {
            ui.item.data('start', ui.item.index());
            //this.startedIndex = ui.item.data('start'),

        },
        update: function(e, ui) {

            //if( obj && (obj.editable == false || obj.selectable == false ) ) return;

            var start = ui.item.data('start'),
            end   = ui.item.index();

            obj = canvas.fabric.getObjects()[start];

            if (end > start) {
                //send object forwards by the amount of objects it passed
                for (var i = 0; i < (end - start); i++) {
                    canvas.fabric.bringForward(obj);
                }
            } else {
                //send object backwards by the amount of objects it passed
                for (var i = 0; i < (start - end); i++) {
                    canvas.fabric.sendBackwards(obj);
                }
            }

            $timeout(function() {
                //$scope.sortPriority();
                canvas.fabric.renderAll();
                start = false; end = false;
            });
        },
    }

    $scope.setAsActive = function(object) {
        if (object ) {
            canvas.fabric.setActiveObject(object);
        }
    };

    $scope.toggleVisibility = function(object) {
        if ( ! object ) return;

        if (object.visible) {
            object.set({ visible: false, evented: false, selectable: false, hasBorders: false, hasCorners: false });
        } else {
            object.set({ visible: true, evented: true, selectable: true, hasBorders: true, hasCorners: true });
            canvas.fabric.setActiveObject(object);
        }

        canvas.fabric.renderAll();
    };

    $scope.deleteObject = function(activeObject) {
        if( activeObject && activeObject.niceName && activeObject.niceName == 'generated text') return;
        if( activeObject && activeObject.editable == false ) return;
        
        if (activeObject) {
            var obj = activeObject.textObj;
            while( obj && obj != activeObject ){
                canvas.fabric.remove(obj);
                obj = obj.textObj;
            }
            

            canvas.fabric.remove(activeObject);            
            canvas.fabric.renderAll();
            IES.get().countButtons();
        }
    };

    $scope.toggleLock = function(object) {
        if ( ! object ) return;

        if (object.locked) {
            object.set({
                locked: false,
                selectable: true,
                evented: true,
                lockMovementX: false,
                lockMovementY: false,
                lockRotation: false,
                lockScalingX: false,
                lockScalingY: false,
                lockUniScaling: false,
                hasControls: true,
                hasBorders: true
            });

            canvas.fabric.setActiveObject(object);
        } else {
            object.set({
                locked: true,
                selectable: false,
                evented: false,
                lockMovementX: true,
                lockMovementY: true,
                lockRotation: true,
                lockScalingX: true,
                lockScalingY: true,
                lockUniScaling: true,
                hasControls: false,
                hasBorders: false
            });
        }

        canvas.fabric.renderAll();
    }

    $scope.$on('$destroy', function() {
        $scope.pageReady();
    });

    $scope.pageReady = $rootScope.$on('editor.loaded', function(event, data) {
        var fontSize = fabric.util.parseUnit(38+'px');
    });
}]);
angular.module('image.filters', [])

.controller('FiltersController', ['$scope', '$rootScope', 'canvas', 'filters', function($scope, $rootScope, canvas, filters) {

    $scope.filters = filters;

    $rootScope.$on('history.loaded', function () {
        if ( ! canvas.mainImage) return;

        var appliedFilters = [];

        for (var i = 0; i < canvas.mainImage.filters.length; i++) {
            appliedFilters.push(canvas.mainImage.filters[i].name);
        }

        $scope.$apply(function() {
            filters.appliedFilters = appliedFilters;
        });
    });
}]);

'use strict';

angular.module('image.filters')

.service('filters', ['$rootScope', 'canvas', 'history', 'IES', function ($rootScope, canvas, history, IES) {

    var filters = {

        all: [
            { name: 'grayscale' },
            { name: 'invert' },
            { name: 'sepia' },
            { name: 'sepia2' },
            {
                name: 'removeWhite',
                options: {
                    distance: { current: 10 },
                    threshold: { current: 50 }
                }
            },
            {
                name: 'brightness',
                options: {
                    brightness: { current: 50 }
                }
            },
            {
                name: 'noise',
                options: {
                    noise: { current: 40, max: 600 }
                }
            },
            {
                name: 'GradientTransparency',
                displayName: 'Gradient',
                options: {
                    threshold: { current: 40 }
                }
            },
            {
                name: 'pixelate',
                options: {
                    blocksize: { max: 40, current: 2 }
                }
            },
            {
                name: 'sharpen',
                uses: 'Convolute',
                matrix: [ 0, -1,  0, -1,  5, -1, 0, -1,  0 ]
            },
            {
                name: 'blur',
                uses: 'Convolute',
                matrix: [ 1/9, 1/9, 1/9, 1/9, 1/9, 1/9, 1/9, 1/9, 1/9 ]
            },
            {
                name: 'emboss',
                uses: 'Convolute',
                matrix: [ 1,   1,  1, 1, 0.7, -1, -1,  -1, -1 ]
            },
            {
                name: 'tint',
                options: {
                    opacity: { current: 0.5, min: 0.1, max: 1, step: 0.1 },
                    color: { colorpicker: true, current: '#FF4081' }
                }
            },
            {
                name: 'multiply',
                options: {
                    color: { colorpicker: true, current: '#FF4081' }
                }
            },
            {
                name: 'blend',
                options: {
                    mode: { current: 'add', select: true, available: ['add', 'multiply', 'subtract', 'diff', 'screen', 'lighten', 'darken'] },
                    alpha: { current: 0.5, min: 0.1, max: 1, step: 0.1 },
                    color: { colorpicker: true, current: '#FF4081' }

                }
            }

        ],

        appliedFilters: [],

        applyFilter: function(filter) {
            if ( ! this.filterExists(filter)) return;

            if (this.filterAlreadyApplied(filter.name)) {
                return this.removeFilter(filter);
            }

            IES.get().isLoading();
            filters.markAsApplied(filter.name);

            //need to use timeout to display loading spinner properly
            setTimeout(function() {
                canvas.fabric.forEachObject(function(obj) {
                    if (obj.applyFilters) {
                        obj.filters.push(filters.getFilter(filter));
                        obj.applyFilters(canvas.fabric.renderAll.bind(canvas.fabric));
                    }
                });

                history.add('filter: '+(filter.displayName || filter.name), 'brightness-6');
                filters.lastAppliedFilter = filter;
                IES.get().isNotLoading();
            }, 30);
        },

        removeFilter: function(filter) {
            if ( ! this.filterExists(filter)) return;

            IES.get().isLoading();
            filters.unmarkAsApplied(filter.name);

            setTimeout(function() {
                canvas.fabric.forEachObject(function(obj) {
                    if (obj.applyFilters) {
                        for (var i = 0; i < obj.filters.length; i++) {
                            if (obj.filters[i].name.toLowerCase() === filter.name.toLowerCase()) {
                                obj.filters.splice(i, 1);
                                obj.applyFilters(canvas.fabric.renderAll.bind(canvas.fabric));
                            }
                        }
                    }
                });

                filters.lastAppliedFilter = false;
                IES.get().isNotLoading();
            }, 30);
        },

        applyValue: function(filterName, optionName, optionValue) {
            IES.get().isLoading();

            setTimeout(function() {
                canvas.fabric.forEachObject(function(obj) {
                    if (obj.applyFilters) {
                        for (var i = 0; i < obj.filters.length; i++) {
                            var filter = obj.filters[i];

                            if (filter.type.toLowerCase() === filterName.toLowerCase()) {
                                filter[optionName] = optionValue;
                                obj.applyFilters(canvas.fabric.renderAll.bind(canvas.fabric));
                            }
                        }
                    }
                });

                IES.get().isNotLoading();
            }, 30);
        },

        filterAlreadyApplied: function(name) {
            return this.appliedFilters.indexOf(name) !== -1
        },

        markAsApplied: function(name) {
            if (this.appliedFilters.indexOf(name) === -1) {
                this.appliedFilters.push(name);
            }
        },

        unmarkAsApplied: function(name) {
            for (var i = 0; i < this.appliedFilters.length; i++) {
                if (this.appliedFilters[i] === name) {
                    this.appliedFilters.splice(i, 1);
                }
            }
        },

        filterExists: function(filter) {
            return fabric.Image.filters[fabric.util.string.capitalize(filter.uses || filter.name, true)] !== undefined;
        },

        getFilter: function(filter) {
            var newFilter;

            if (filter.uses) {
                newFilter = new fabric.Image.filters[fabric.util.string.capitalize(filter.uses, true)]({ matrix: filter.matrix });
            }

            else {
                var options = {};

                for (var key in filter.options) {
                    options[key] = filter.options[key].current;
                }

                newFilter = new fabric.Image.filters[fabric.util.string.capitalize(filter.name, true)](options);
            }

            newFilter.name = filter.name;

            return newFilter;
        },
    };

    return filters;

}]);
'use strict';

angular.module('image.directives', [])

.directive('edTabs', ['$rootScope', 'IES', function ($rootScope, IES) {
    return {
        link: function ($scope, el, attrs) {
            var blockClicks = false;

            $('#'+attrs.edTabs).addClass('open');
            $('[data-activates="'+attrs.edTabs+'"]').addClass('active');

            el.find('#navigation-bar').on('click', '.nav-item', function (e) {
                if (blockClicks === true) return;
                if( IES.get().activeTab != e.currentTarget.dataset.activates){
                    $scope.$apply(function() {
                        blockClicks = true;
                        IES.get().activeTab = e.currentTarget.dataset.activates;
                    });
                }
            });

            IES.get().scope.$watch('vme.activeTab', function(newTab, oldTab) {
                if (newTab && newTab !== oldTab) {
                    var oldTabNode = oldTab ? el.find('#'+oldTab) : el.find('.tab.open');
                    changeTab(newTab, oldTabNode, el.find('#'+newTab), $('[data-activates="'+newTab+'"]'));
                }
            });

            var changeTab = function(name, oldTab, newTab, tabButton) {
                var inAnimation  = 'fadeInLeft',
                    outAnimation = 'fadeOutRight';

                if (tabButton.hasClass('active')) return;

                //tab navigation
                $('.nav-item.active').removeClass('active');
                tabButton.addClass('active');

                //tabs
                if (parseInt(newTab.data('index')) < parseInt(oldTab.data('index'))) {
                    outAnimation = 'fadeOutLeft';
                    inAnimation  = 'fadeInRight';
                }

                oldTab.addClass('animated '+outAnimation).one(IES.get().animationEndEvent, function() {
                    if (newTab[0].id === $scope.activeTab) {
                        $(this).removeClass('open '+outAnimation);
                    }
                });
                newTab.addClass('open animated '+inAnimation).one(IES.get().animationEndEvent, function() {
                    $(this).removeClass(inAnimation);
                });

                $rootScope.$emit('tab.changed', name, oldTab[0].id);
                IES.get().activePanel = false;

                setTimeout(function() {
                    newTab.removeClass('fadeOutRight fadeOutLeft');
                    blockClicks = false;
                }, 270)
            }
        }
    };
}]);

'use strict';

angular.module('image.directives')

.directive('edRenderBrushes', ['$rootScope', '$compile', function ($rootScope, $compile) {
    return {
        link: function ($scope, el) {
            var template = '<div ng-repeat="brush in drawing.availableBrushes" ng-class="{ active: drawing.activeBrushName == brush }" class="brush animated-in-sequence" ng-click="changeBrush(brush)">'+
                '<img class="img-responsive" ng-src="assets/images/brushes/{{brush}}.png"/>'+
                '<div class="brush-name">{{ brush }}</div>'+
            '</div>';

            var unbind = $rootScope.$on('tab.changed', function(e, name) {
                if (name === 'drawing') {
                    $scope.$apply(function() {
                        el.append($compile(template)($scope));
                    });
                    unbind();
                }
            });
        }
    };
}]);

angular.module('image.drawing', [])

.service('drawing', ['$rootScope', 'canvas', function ($rootScope, canvas) {

    var drawing = {

        availableBrushes: ['pencil', 'vLine', 'diamond', 'hLine', 'circle', 'square', 'spray'],

        defaultBrushName: 'pencil',

        activeBrushName: false,

        isEnabled: false,

        params: {
            shadowColor: '#1E89E6',
            brushWidth: 9,
            brushColor: '#000',
            shadowBlur: 30,
            shadowOffsetX: 10,
            shadowOffsetY: 10,
            enableShadow: false
        },

        enable: function() {
            canvas.fabric.isDrawingMode = true;
            this.changeBrush(this.defaultBrushName);

            if ( ! this.shadow) {
                this.shadow = new fabric.Shadow({
                    color: this.params.shadowColor,
                    blur: this.params.shadowBlur,
                    offsetX: this.params.shadowOffsetX,
                    offsetY: this.params.shadowOffsetY
                });
            }

            this.isEnabled = true;
        },

        disable: function() {
            canvas.fabric.isDrawingMode = false;
            this.isEnabled = false;
        },

        setShadowProperty: function(name, value) {
            if (canvas.fabric.freeDrawingBrush.shadow[name]) {
                canvas.fabric.freeDrawingBrush.shadow[name] = value;
            }
        },

        setProperty: function(name, value) {
            if (canvas.fabric.freeDrawingBrush[name]) {
                canvas.fabric.freeDrawingBrush[name] = value;
            }
        },

        toggleShadow: function(on) {
            if (on) {
                canvas.fabric.freeDrawingBrush.shadow = this.shadow;
            } else {
                this.shadow = canvas.fabric.freeDrawingBrush.shadow;
                canvas.fabric.freeDrawingBrush.shadow = undefined;
            }
        },
        
        changeBrush: function(name) {
            this.activeBrushName = name;
            name = this.makeBrushName(name);

            //check if it's a base fabric brush
            if (fabric[name]) {
                canvas.fabric.freeDrawingBrush = new fabric[name](canvas.fabric);

            //check if it's a custom brush that we have already made
            } else if (this[name]) {
                canvas.fabric.freeDrawingBrush = this[name];

            //check if we can make a request brush
            } else if (this['make'+name]) {
                canvas.fabric.freeDrawingBrush = this['make'+name]();
            }

            canvas.fabric.freeDrawingBrush.width  = this.params.brushWidth;
            canvas.fabric.freeDrawingBrush.color  = this.params.brushColor;

            if (this.params.enableShadow) {
                canvas.fabric.freeDrawingBrush.shadow = this.shadow;
            }
        },

        /**
         * Compile a fabric brush function name from given name.
         *
         * @param name (pencil)
         * @returns string (PencilBrush)
         */
        makeBrushName: function(name) {
            return name.charAt(0).toUpperCase()+name.slice(1) + 'Brush';
        },

        makeVLineBrush: function() {
            this.VLineBrush = new fabric.PatternBrush(canvas.fabric);

            this.VLineBrush.getPatternSrc = function() {

                var patternCanvas = fabric.document.createElement('canvas');
                patternCanvas.width = patternCanvas.height = 10;
                var ctx = patternCanvas.getContext('2d');

                ctx.strokeStyle = this.color;
                ctx.lineWidth = 5;
                ctx.beginPath();
                ctx.moveTo(0, 5);
                ctx.lineTo(10, 5);
                ctx.closePath();
                ctx.stroke();

                return patternCanvas;
            };

            return this.VLineBrush;
        },

        makeDiamondBrush: function () {
            this.DiamondBrush = new fabric.PatternBrush(canvas.fabric);

            this.DiamondBrush.getPatternSrc = function() {

                var squareWidth = 10, squareDistance = 5;
                var patternCanvas = fabric.document.createElement('canvas');
                var rect = new fabric.Rect({
                    width: squareWidth,
                    height: squareWidth,
                    angle: 45,
                    fill: this.color
                });

                var canvasWidth = rect.getBoundingRectWidth();

                patternCanvas.width = patternCanvas.height = canvasWidth + squareDistance;
                rect.set({ left: canvasWidth / 2, top: canvasWidth / 2 });

                var ctx = patternCanvas.getContext('2d');
                rect.render(ctx);

                return patternCanvas;
            };

            return this.DiamondBrush;
        },

        makeHLineBrush: function () {
            this.HLineBrush = new fabric.PatternBrush(canvas.fabric);

            this.HLineBrush.getPatternSrc = function() {

                var patternCanvas = fabric.document.createElement('canvas');
                patternCanvas.width = patternCanvas.height = 10;
                var ctx = patternCanvas.getContext('2d');

                ctx.strokeStyle = this.color;
                ctx.lineWidth = 5;
                ctx.beginPath();
                ctx.moveTo(5, 0);
                ctx.lineTo(5, 10);
                ctx.closePath();
                ctx.stroke();

                return patternCanvas;
            };

            return this.HLineBrush;
        },

        makeSquareBrush: function () {
            this.SquareBrush = new fabric.PatternBrush(canvas.fabric);

            this.SquareBrush.getPatternSrc = function() {

                var squareWidth = 10, squareDistance = 2;

                var patternCanvas = fabric.document.createElement('canvas');
                patternCanvas.width = patternCanvas.height = squareWidth + squareDistance;
                var ctx = patternCanvas.getContext('2d');

                ctx.fillStyle = this.color;
                ctx.fillRect(0, 0, squareWidth, squareWidth);

                return patternCanvas;
            };

            return this.SquareBrush;
        }

    };

    return drawing;

}]);
angular.module('image.drawing')

.controller('DrawingController', ['$scope', '$rootScope', 'canvas', 'drawing', 'history', 'IES', function($scope, $rootScope, canvas, drawing, history, IES) {
	$scope.drawing = drawing;
    window.fb = canvas.fabric;

	$scope.changeBrush = function(brush, $event) {
		$scope.openPanel('drawing', $event);

		if ( ! drawing.isEnabled) {
			drawing.enable();
		}

		drawing.changeBrush(brush);
	};

	$scope.finishAddingDrawingsToCanvas = function() {
		IES.get().activePanel = false;

        if (canvas.mainImage) {
            canvas.fabric.setActiveObject(canvas.mainImage);
        }

		canvas.fabric.forEachObject(function(obj) {
			if (obj.name === 'freeDrawing') {
				obj.removeOnCancel = false;
			}
		});

        drawing.disable();
		history.add('added drawing', 'brush');
	};

	$scope.cancelAddingDrawingsToCanvas = function() {
        canvas.fabric.forEachObject(function (obj) {
			if (obj.name === 'freeDrawing' && obj.removeOnCancel) {
				canvas.fabric.remove(obj);
			}
		});

		drawing.disable();
        canvas.fabric.renderAll();
		IES.get().activePanel = false;
	};

	$rootScope.$on('tab.changed', function(e, name) {
		if (name !== 'drawing') {
			drawing.disable();
			$scope.cancelAddingDrawingsToCanvas();
		}
	});

	canvas.fabric.on('path:created', function(e) {
		if (drawing.isEnabled) {
			e.path.setOptions(canvas.imageStatic);
			e.path.name = 'freeDrawing';
			e.path.removeOnCancel = true;
		}
	});
}]);
angular.module('image.directives')

.directive('edToggleSidebar', function() {
    return {
        restrict: 'A',
        compile: function(el, attrs) {
            var sidebar = $('#left-sidebar');
            

            el.on('click', function() {
                sidebar.toggleClass('open');
            
            });
        }
   	}
});
angular.module('image.directives')

.directive('edTogglePanelVisibility', function() {
    return {
        restrict: 'A',
        compile: function(el, attrs) {
            el.on('click', function() {
                el.find('.icon').toggleClass('toggled');

                $('#'+attrs.edTogglePanelVisibility).find('ul').mCustomScrollbar('disable').slideToggle(150, function() {
                    $(this).mCustomScrollbar('update');
                });
            });
        }
   	}
});
angular.module('image.directives')

.directive('edSlider', function() {
    return {
        restrict: 'E',
        template: '<div class="ed-range-slider"><div class="ed-slider-inner"><div class="slider-extender"></div><div class="focus-handle"></div></div></div>',
        replace: true,
        require: 'ngModel',
        link: function($scope, el, attrs, ctrl) {
            var elem = el.find('.ed-slider-inner');

            $scope.$watch(attrs.ngModel, function(n, o) {
                if (!n || n < min || n > max) return;
                elem.slider('value', n);
            });

            if (angular.isDefined(attrs.ngDisabled)) {
                attrs.$observe('disabled', function(isDisabled) {
                    if (isDisabled) {
                        elem.slider('disable');
                    } else {
                        elem.slider('enable');
                    }
                })
            }

            function bindAttributes() {
                attrs.min ? attrs.$observe('min', updateMin) : '';
                attrs.max ? attrs.$observe('max', updateMax) : '';
                attrs.step ? attrs.$observe('step', updateStep) : '';

                function updateMin(val) {
                    elem.slider('option', 'min', parseFloat(val)); min = val;
                }

                function updateMax(val) {
                    elem.slider('option', 'max', parseFloat(val)); max = val;
                }

                function updateStep(val) {
                    elem.slider('option', 'step', parseFloat(val));
                }
            }

            function updateModel(e, ui) {
                ctrl.$setViewValue(ui.value);
            }

            var isDiscrete = angular.isDefined(attrs.edDiscrete),
                options    = { create: bindAttributes, range: 'min'}, min, max;

            isDiscrete ? options.stop = updateModel : options.slide = updateModel;
            elem.slider(options);
        }
    }
});
angular.module('image.directives')

.directive('edPrettyScrollbar', function() {
    return {
        restrict: 'A',
        compile: function(el, attrs) {
            setTimeout(function() {
                el.mCustomScrollbar({
                    theme: attrs.edScrollTheme || 'inset',
                    scrollInertia: 300,
                    autoExpandScrollbar: false,
                    axis: attrs.edScrollAxis || 'x',
                    advanced: { autoExpandHorizontalScroll:true },
                });
            }, 1)
        }
   	}
})

//fix some bug between custom scrollbar and material slider
.directive('edIeSliderFix', function() {
    return {
        restrict: 'A',
        template: '<div class="slider-fix-outter" style="height: 2px; position: absolute"><div class="slider-fix-inner" style="height: 1px; overflow: auto;">IE FIX</div></div>',
        compile: function(el) {
            el.find('.slider-fix-inner').mCustomScrollbar();
        }
    }
});
'use strict';

angular.module('image.directives').directive('edLazyShow', ['$animate', function ($animate) {

    return {
        multiElement: true,
        transclude: 'element',
        replace: true,
        priority: 600,
        terminal: true,
        restrict: 'A',
        link: function ($scope, $element, $attr, $ctrl, $transclude) {
            var loaded,
            stopWatching = $scope.$watch($attr.edLazyShow, function(value) {
                if(value && ! loaded) {
                    loaded = true;
                    $transclude(function(clone) {
                        clone[clone.length++] = document.createComment(' end ngLazyShow: ' + $attr.ngLazyShow + ' ');
                        $animate.enter(clone, $element.parent(), $element);
                        $element = clone;
                    });
                    stopWatching();
                }
            });
        }
    };

}]);
angular.module('image.directives')

.directive('edFileUploader', ['$parse', '$mdDialog', '$mdBottomSheet', function($parse, $mdDialog, $mdBottomSheet) {
    var validTypes = ['png', 'jpg', 'jpeg', 'gif'];

    return {
        restrict: 'A',
        link: function($scope, el, attrs) {
            var setter = $parse(attrs.edFileUploader)($scope);

            $(el[0]).on('change', function(e) {
                var reader = new FileReader();

                reader.onload = function(event) {
                    var mime = event.target.result.split(",")[0].split(":")[1].split(";")[0].split('/')[1];

                    if (validTypes.indexOf(mime) < 0) {
                        //
                    }

                    if (setter) {
                        setter(event.target.result,e.target.files[0]);

                        if (typeof attrs.edCloseAfter !== 'undefined') {
                            $mdDialog.hide();
                            $mdBottomSheet.hide();
                        }
                    }
                };

                reader.readAsDataURL(e.target.files[0]);
            });
        }
   	}
}]);
'use strict';

angular.module('image.directives')

.directive('edColorPicker', ['$rootScope', '$parse', '$log', function ($rootScope, $parse, $log) {
    return {
        link: function ($scope, el, attrs) {
            var flat = 'edFlat' in attrs;

            var type = attrs['edType'];

            $scope.$watch(attrs.ngDisabled, function(newVal) {
                if (newVal) {
                    el.spectrum('disable');
                } else {
                    el.spectrum('enable');
                }
            });

            var params = {
                color: attrs.startColor,
                clickoutFiresChange: true,
                showPalette: !flat,
                palette: colorsForPicker,
                preferredFormat: 'hex',
                showAlpha: true,
                showInput: true,
                flat: flat,
                showButtons: !flat
            },
            setter = function(selectedColor) {
                $parse(attrs.edColorPicker)($scope, {color: selectedColor.toString()});
                el.val(selectedColor.toString());
            };

            el.off('dragstop.spectrum');
            if (attrs.edDiscrete !== undefined) {
                el.on('dragstop.spectrum', function(e, selectedColor) {
                    setter(selectedColor);
                });

                params.change = function(selectedColor) {
                    setter(selectedColor);
                }
            } else {
                params.move = function(selectedColor) {
                    setter(selectedColor);
                }
            }
            
            el.spectrum(params);            

            $scope.$on('$destroy', function() {
                $scope.panelSetColor();
            }); 
                
            $scope.panelSetColor = $scope.$on('panel.setcolor', function(event, data) {
                if( type != data.type) return;
                var color = data.color;
                if( color == '' ) color = "#000"

                //el.spectrum({color:color});
                //el.val(color);
                var NewParams = {
                    color: color,
                    clickoutFiresChange: true,
                    showPalette: !flat,
                    palette: colorsForPicker,
                    preferredFormat: 'hex',
                    showAlpha: true,
                    showInput: true,
                    flat: flat,
                    showButtons: !flat
                };
                el.off('dragstop.spectrum');
                if (attrs.edDiscrete !== undefined) {
                    el.on('dragstop.spectrum', function(e, selectedColor) {
                        setter(selectedColor);
                    });

                    NewParams.change = function(selectedColor) {
                        setter(selectedColor);
                    }
                } else {
                    NewParams.move = function(selectedColor) {
                        setter(selectedColor);
                    }
                }
                el.spectrum(NewParams);
            });
        }
    };
}]);

angular.module('image.crop', [])

.service('cropper', ['$rootScope', 'cropzone', 'canvas', 'history', 'IES', function($rootScope, cropzone, canvas, history, IES) {
	
	var cropper = {

		start: function(e) {
			if (cropzone.initiated) return;
			history.add('crop', false, true);
			cropzone.add();
			IES.get().openPanel('crop', e);
		},

		stop: function(e) {
			cropzone.remove();
			history.load('crop');
			IES.get().activePanel = false;
		},

		crop: function() {
			if ( ! cropzone.initiated) return false;

			cropzone.hide();
		    var image = new Image();
		   	image.onload = function() {
		        var fabricImage = new fabric.Image(this, canvas.imageStatic);
                fabricImage.name = 'mainImage';
                fabricImage.crossOrigin = '';

		        canvas.mainImage && canvas.mainImage.remove();
                canvas.fabric.clear();
		        canvas.fabric.setWidth(Math.ceil(cropzone.rect.getWidth()));
		        canvas.fabric.setHeight(Math.ceil(cropzone.rect.getHeight()));
		        canvas.original.width = Math.ceil(cropzone.rect.getWidth());
            	canvas.original.height = Math.ceil(cropzone.rect.getHeight());

        		canvas.fabric.add(fabricImage);
                fabricImage.moveTo(0);
                fabricImage.center();
        		canvas.mainImage = fabricImage;
        		cropzone.remove();

               history.save('crop');

				$rootScope.$apply(function() {
					IES.get().activePanel = false;
				});
		    };

            canvas.zoom(1);

            IES.get().editorCustomActions.crop = {
                left: cropzone.rect.getLeft(),
                top: cropzone.rect.getTop(),
                width: Math.ceil(cropzone.rect.getWidth()),
                height: Math.ceil(cropzone.rect.getHeight())
            };


		    image.crossOrigin = 'anonymous';
		    image.src = canvas.fabric.toDataURL({
		        left: cropzone.rect.getLeft(),
		        top: cropzone.rect.getTop(),
		        width: Math.ceil(cropzone.rect.getWidth()),
		        height: Math.ceil(cropzone.rect.getHeight())
		    });           
		}

	};

	return cropper;

}]);
angular.module('image.crop')

.service('cropzone', ['$rootScope', 'canvas', function($rootScope, canvas) {

	var cropzone = {

		rect: {},

		dragging: false,

		initiated: false,

		minHeight: 25,

		minWidth: 25,

		setWidth: function(width) {
            if ( ! width) return;

            width = parseInt(width);

			if (width < this.minWidth) {
				width = this.minWidth;
			}

			if (width > canvas.original.width) {
				width = canvas.original.width - 25;
			}

            this.rect.width = width;
			this.rect.setTop((canvas.original.height - this.rect.getHeight()) / 2);
			this.rect.setLeft((canvas.original.width - this.rect.getWidth()) / 2);
			this.rect.setCoords();
			this.drawGrid();
			this.drawOverlay();
			canvas.fabric.renderAll();
		},

		setHeight: function(height) {
            if ( ! height) return;

            height = parseInt(height);

			if (height < this.minHeight) {
				height = this.minHeight;
			}

            if (height > canvas.original.height) {
                height = canvas.original.height - 25;
            }

            this.rect.height = height;
			this.rect.setTop((canvas.original.height - this.rect.getHeight()) / 2);
			this.rect.setLeft((canvas.original.width - this.rect.getWidth()) / 2);
			this.rect.setCoords();
			this.drawGrid();
			this.drawOverlay();
			canvas.fabric.renderAll();
		},

		add: function() {
			this.drawMainZone();
			this.drawOverlay();
			this.drawGrid();
			this.attachEvents();

			canvas.fabric.renderAll();

			this.initiated = true;

			$rootScope.$emit('cropzone.added');
		},

		constrainWithinCanvas: function(object) {
		    var x = object.getLeft(), y = object.getTop();
		    var w = object.getWidth(), h = object.getHeight();
		    var maxX = canvas.original.width - w;
		    var maxY = canvas.original.height - h;

		    if (x < 0) {
		    	object.set('left', 0);
		    }
		    if (y < 0) {
		        object.set('top', 0);
			}
		    if (x > maxX) {
		        object.set('left', maxX);
		    }
		    if (y > maxY) {
		    	object.set('top', maxY);
		    }
		},

		constrainWithinCanvasOnScaling: function(object) {

		    var minX = object.getLeft();
		    var minY = object.getTop();
		    var maxX = object.getLeft() + object.getWidth();
		    var maxY = object.getTop() + object.getHeight();

		    if (minX < 0 || maxX > canvas.original.width) {
		        var lastScaleX = this.lastScaleX || 1;
		        object.setScaleX(lastScaleX);
		    }

		    if (minX < 0) {
		        object.setLeft(0);
		    }

		    if (minY < 0 || maxY > canvas.original.height) {
		        var lastScaleY = this.lastScaleY || 1;
		        object.setScaleY(lastScaleY);
		    }

		    if (minY < 0) {
		        object.setTop(0);
		    }

		    if (object.getWidth() < this.minWidth) {
		        object.width = this.minWidth;
		        object.setScaleX(1);
		    }

		    if (object.getHeight() < this.minHeight) {
		       object.height = this.minHeight;
		       object.setScaleY(1);
		    }

		    this.lastScaleX = object.getScaleX();
		    this.lastScaleY = object.getScaleY();
		},

		onMouseDown: function(event) {
			if (event.target && (event.target.name === 'cropzone' || event.target.name === 'crop.grid')) return;

			cropzone.dragging = true;

			//hide cropzone on single click on overlay
			cropzone.overlay.visible = false;
			cropzone.grid.visible = false;
			cropzone.rect.visible = false;

			//start position for drawing a cropzone
		    cropzone.rect.left = event.e.pageX - canvas.fabric._offset.left;
		    cropzone.rect.top = event.e.pageY - canvas.fabric._offset.top;

		    //make sure cropzone scale is 1 for accurate coordinates
		    cropzone.rect.scale(1);
            cropzone.overlay.scale(1);
            cropzone.grid.scale(1);
		    cropzone.mousex = event.e.pageX;
		    cropzone.mousey = event.e.pageY;

		    //prevent selection of objects while dragging
		    canvas.fabric.selection = false;

		    cropzone.drawOverlay();
		},

		onMouseMove: function(event) {
			if ( ! cropzone.dragging) return;

			var width  = event.e.pageX - cropzone.mousex,
				height = event.e.pageY - cropzone.mousey;

			//prevent cropzone going over the right edge
			if (canvas.offset.left + canvas.original.width < event.e.pageX) {
				width = (canvas.offset.left + canvas.original.width) - cropzone.mousex;
			}

			//left edge
			if (canvas.offset.left > event.e.pageX) {
				width = canvas.offset.left - cropzone.mousex;
			}

			//bottom edge
			if (canvas.offset.top + canvas.original.height < event.e.pageY) {
				height = (canvas.offset.top + canvas.original.height) - cropzone.mousey;
			}

			//top edge
			if (canvas.offset.top > event.e.pageY) {
				height = canvas.offset.top - cropzone.mousey;
			}

			cropzone.rect.width = width;
        	cropzone.rect.height = height;
        	cropzone.rect.moveTo(3);
            cropzone.rect.setCoords();
        	cropzone.drawOverlay();
	        cropzone.drawGrid();

			if ( ! cropzone.rect.visible) {
				cropzone.rect.visible = true;
				cropzone.overlay.visible = true;
				cropzone.grid.visible = true;
			}
		},

		onMouseUp: function() {
		   	cropzone.dragging = false;
		    canvas.fabric.selection = true;
		    cropzone.rect.setCoords();
            cropzone.grid.setCoords();
            cropzone.overlay.setCoords();

		    if (cropzone.rect.visible) {
		    	canvas.fabric.setActiveObject(cropzone.rect);
			}
		},

		attachEvents: function() {

			//redraw cropzone grid and overlay when cropzone is resized
			this.rect.on('moving', function() {
				cropzone.constrainWithinCanvas(cropzone.rect);
				cropzone.drawOverlay();
				cropzone.drawGrid();
			});

			this.rect.on('scaling', function(e) {
				cropzone.constrainWithinCanvasOnScaling(cropzone.rect, e);
				cropzone.drawOverlay();
				cropzone.drawGrid();
			});

			canvas.fabric.on("mouse:down", cropzone.onMouseDown);
			canvas.fabric.on("mouse:move", cropzone.onMouseMove);
			canvas.fabric.on("mouse:up", cropzone.onMouseUp);
		},

		remove: function() {
			canvas.fabric.off("mouse:down", cropzone.onMouseDown);
			canvas.fabric.off("mouse:move", cropzone.onMouseMove);
			canvas.fabric.off("mouse:up", cropzone.onMouseUp);

			canvas.fabric.remove(this.rect);
			canvas.fabric.remove(this.grid);
			canvas.fabric.remove(this.overlay);
            canvas.fabric.renderAll();
			this.initiated = false;
		},

		hide: function() {
			this.rect.visible = false;
			this.rect.hasControls = false;
			this.grid.visible = false;
			this.overlay.visible = false;
		},

		getOptimalDimensions: function () {
            var width = canvas.original.width / 2,
                height = canvas.original.height / 2,
                left = canvas.original.width / 4,
                top = canvas.original.height / 4;

			if (canvas.viewport.offsetWidth < canvas.original.width) {
				width = canvas.viewport.offsetWidth / 2;
				left = canvas.viewport.offsetWidth / 4;

			}

            if (canvas.viewport.offsetHeight < canvas.original.height) {
                height = canvas.viewport.offsetHeight / 2;
                top = canvas.viewport.offsetHeight / 4;
            }

			return {width: width, height: height, left: left, top: top};
		},

		drawMainZone: function() {
			var dimensions = this.getOptimalDimensions();

			this.rect = new fabric.Rect({
			    fill: 'transparent',
			    stroke: 'rgba(255, 255, 255, 0.6)',
			    hasBorders: false,
			    width: dimensions.width,
			    height: dimensions.height,
			    left: dimensions.left,
			    top: dimensions.top,
			    hasRotatingPoint: false,
			    name: 'cropzone',
			    cornerColor: 'rgba(255, 255, 255, 0.6)',
			    transparentCorners: false,
                ignore: true
			});

			canvas.fabric.add(this.rect);
			this.rect.moveTo(3);
			canvas.fabric.setActiveObject(cropzone.rect);
		},

		drawGrid: function() {

			if ( ! this.initiated) {
				this.line1 = new fabric.Line([], { stroke: 'rgba(255, 255, 255, 0.6)', strokeWidth: 1, selectable: false, evented: false });
				this.line2 = new fabric.Line([], { stroke: 'rgba(255, 255, 255, 0.6)', strokeWidth: 1, selectable: false, evented: false });
				this.line3 = new fabric.Line([], { stroke: 'rgba(255, 255, 255, 0.6)', strokeWidth: 1, selectable: false, evented: false });
				this.line4 = new fabric.Line([], { stroke: 'rgba(255, 255, 255, 0.6)', strokeWidth: 1, selectable: false, evented: false });
				this.grid = new fabric.Group([this.line1, this.line2, this.line3, this.line4]);
				this.grid.originY = 'left';
				this.grid.originX = 'top';
                this.grid.ignore = true;
                this.grid.selectable = false;
				canvas.fabric.add(this.grid);
		    	this.grid.moveTo(10);
			}

			this.grid.width = this.rect.getWidth();
			this.grid.height = this.rect.getHeight();
			this.grid.left = this.rect.getLeft();
			this.grid.top = this.rect.getTop();

			var width  = cropzone.rect.getWidth() / 3,
				height = cropzone.rect.getHeight() / 3;

			this.line1.set({
				x1: width,
				y1: 0,
				x2: width,
				y2: cropzone.grid.getHeight(),
			});

			this.line2.set({
				x1: width * 2,
				y1: 0,
				x2: width * 2,
				y2: cropzone.grid.getHeight()
			});

			this.line3.set({
				x1: 0,
				y1: height,
				x2: cropzone.grid.getWidth(),
				y2: height
			});

			this.line4.set({
				x1: 0,
				y1: height * 2,
				x2: cropzone.grid.getWidth(),
				y2: height * 2
			});

			this.constrainWithinCanvas(this.grid);
		},

		drawOverlay: function() {

	    	if ( ! this.initiated) {
	    		this.topRect = new fabric.Rect({fill: 'rgba(0,0,0,0.7)', selectable: true, evented: false});
	    		this.rightRect = new fabric.Rect({fill: 'rgba(0,0,0,0.7)', selectable: true, evented: false});
	    		this.bottomRect = new fabric.Rect({fill: 'rgba(0,0,0,0.7)', selectable: true, evented: false});
	    		this.leftRect = new fabric.Rect({fill: 'rgba(0,0,0,0.7)', selectable: true, evented: false});
	    		this.overlay = new fabric.Group([this.topRect, this.rightRect, this.bottomRect, this.leftRect]);
                this.overlay.ignore = true;
                this.overlay.name = 'grid.overlay';
				canvas.fabric.add(this.overlay);
				this.overlay.moveTo(1);
	    	}

    		this.topRect.set({
	    		left: 0,
				top: 0,
				width: canvas.original.width,
				height: this.rect.getHeight() < 0 ? this.rect.getTop() - Math.abs(this.rect.getHeight()) : this.rect.getTop(),
	    	});

	    	this.rightRect.set({
	    		left: this.rect.getWidth() < 0 ? this.rect.getLeft() : this.rect.getLeft() + this.rect.getWidth(),
				top: this.rect.getTop(),
				width: this.rect.getWidth() < 0 ? canvas.original.width - (this.rect.getLeft() + this.rect.getWidth()) - Math.abs(this.rect.getWidth()) : canvas.original.width - (this.rect.getLeft() + this.rect.getWidth()),
				height: this.rect.getHeight(),
	    	});

	    	this.bottomRect.set({
	    		left: 0,
				top: this.rect.getHeight() < 0 ? this.rect.getTop() : this.rect.getTop() + this.rect.getHeight(),
				width: canvas.original.width,
				height: this.rect.getHeight() < 0 ? canvas.original.height - (this.rect.getTop()) : canvas.original.height - (this.rect.getTop() + this.rect.getHeight()),
	    	});

	    	this.leftRect.set({
	    		left: 0,
				top: this.rect.getTop(),
				width: this.rect.getWidth() > 0 ? this.rect.getLeft() : this.rect.getLeft() - Math.abs(this.rect.getWidth()),
				height: this.rect.getHeight(),
	    	});


	    }
	};

	return cropzone;

}]);
angular.module('image.crop')

.controller('CropController', ['$scope', '$rootScope', 'cropper', 'cropzone', function($scope, $rootScope, cropper, cropzone) {

	$scope.cropper = cropper;
	$scope.cropzone = cropzone;

    $rootScope.$on('tab.changed', function(e, newTab, oldTab) {
       if (oldTab === 'basics' && newTab !== 'basics') {
           cropper.stop();
       }
    });

    $rootScope.$watch('activePanel', function(newPanel, oldPanel) {
        if (newPanel !== 'crop' && oldPanel === 'crop') {
            cropzone.remove();
        }
    });

	$rootScope.$on('cropzone.added', function() {
		$scope.width = Math.round(cropzone.rect.width);
		$scope.height = Math.round(cropzone.rect.height);
	});
}]);
angular.module('image.basics', [])

.controller('RotateController', ['$scope', '$rootScope', 'canvas', 'history', 'IES', function($scope, $rootScope, canvas, history, IES) {

        $scope.angle = 0;

        $scope.startRotator = function($event) {
            history.add('rotate-original-state', 'backup', true);
            IES.get().openPanel('rotate', $event);
        };

        $scope.applyRotation = function() {
            IES.get().activePanel = false;
            history.save('rotate-original-state');
        };

        $scope.cancel = function() {
            history.load('rotate-original-state');
            IES.get().activePanel = false;
            $scope.angle = 0;
        };

        //rotate properly by scaling canvas to new height after rotating main image by 90 degrees
        $scope.rotateProper = function(originalAngle) {
            canvas.zoom(1);
            var angle = (canvas.mainImage.getAngle() + originalAngle) % 360;

            var height = Math.abs(canvas.mainImage.getWidth()*(Math.sin(angle*Math.PI/180)))+Math.abs(canvas.mainImage.getHeight()*(Math.cos(angle*Math.PI/180))),
                width = Math.abs(canvas.mainImage.getHeight()*(Math.sin(angle*Math.PI/180)))+Math.abs(canvas.mainImage.getWidth()*(Math.cos(angle*Math.PI/180)));

            canvas.fabric.setWidth(width * canvas.currentZoom);
            canvas.fabric.setHeight(height * canvas.currentZoom);
            canvas.original.height = height;
            canvas.original.width  = width;
            canvas.mainImage.center();

            canvas.fabric.forEachObject(function(obj) {
                obj.rotate((obj.getAngle() + originalAngle) % 360);
                obj.setCoords();
            });

            IES.get().editorCustomActions.rotate = originalAngle;
            canvas.fabric.renderAll();
            canvas.fitToScreen();
        };

        //only rotate the objects of canvas while leaving canvas width/height intact
        $scope.rotate = function(angle, direction) {
            if ( ! angle || angle > 360 || angle < 0) return;
            var resetOrigin = false;

            canvas.fabric.forEachObject(function(obj) {

                if (direction && direction === 'left') {
                    angle = obj.getAngle() - 90;
                } else if (direction && direction === 'right') {
                    angle = obj.getAngle() + 90;
                }

                if ((obj.originX !== 'center' || obj.originY !== 'center') && obj.centeredRotation) {
                    $scope.setOriginToCenter && $scope.setOriginToCenter(obj);
                    resetOrigin = true;
                }

                angle = angle > 360 ? 90 : angle < 0 ? 270 : angle;

                obj.setAngle(angle).setCoords();

                if (resetOrigin) {
                    $scope.setCenterToOrigin && $scope.setCenterToOrigin(obj);
                }
            });

            canvas.fitToScreen();
            canvas.fabric.renderAll();
        };

        $scope.setOriginToCenter = function (obj) {
            obj._originalOriginX = obj.originX;
            obj._originalOriginY = obj.originY;

            var center = obj.getCenterPoint();

            obj.set({
                originX: 'center',
                originY: 'center',
                left: center.x,
                top: center.y
            });
        };

        $scope.setCenterToOrigin = function (obj) {
            var originPoint = obj.translateToOriginPoint(
                obj.getCenterPoint(),
                obj._originalOriginX,
                obj._originalOriginY);

            obj.set({
                originX: obj._originalOriginX,
                originY: obj._originalOriginY,
                left: originPoint.x,
                top: originPoint.y
            });
        };
}]);
angular.module('image.basics')

.controller('RoundedCornersController', ['$scope', '$rootScope', 'canvas', 'history', 'IES', function($scope, $rootScope, canvas, history, IES) {

    $scope.radius = 50;

    $scope.startRoundedCorners = function(e) {
        if (IES.get().activePanel === 'round') return;

        history.add('Round Corners',false,true);

        IES.get().openPanel('round', e);

        $scope.rect = new fabric.Rect({
            width: canvas.original.width,
            height: canvas.original.height,
            rx: $scope.radius,
            ry: $scope.radius,
            opacity: 1,
            fill: 'transparent',
            name: 'rounding-rect',
            stroke: '#fff',
            strokeDashArray: [5, 5],
            selectable: false,
            evented: false,
            ignore: true
        });

        canvas.fabric.add($scope.rect);
        canvas.fabric.renderAll();
    };

    $scope.adjustPreview = function() {
        if ( ! $scope.rect) return;

        $scope.rect.set({
            rx: $scope.radius, ry: $scope.radius
        });
        canvas.fabric.renderAll();
    };

    $scope.cancel = function(leavePanel) {
        //history.load('Round Corners');
        canvas.fabric.remove($scope.rect);
        $scope.rect  = false;
        $scope.radius = 50;
        canvas.fabric.renderAll();

        if ( !leavePanel) {
            IES.get().activePanel = false;
        }
    };

    $scope.apply = function() {
        IES.get().editorCustomActions.roundCorners = angular.copy($scope.radius);

        canvas.fabric.remove($scope.rect);
        canvas.zoom(1);

        canvas.fabric.clipTo = function(ctx) {
            $scope.rect.render(ctx);
            canvas.fabric.clipTo = false;
        };
        var data = canvas.fabric.toDataURL(); //canvas.getDataURL();
        canvas.fabric.clear();
        $scope.cancel();

        canvas.loadMainImage(data, false, false, false, function() {
            $rootScope.$apply(function() {
                history.save('Round Corners');
            });
        });
    };

    $rootScope.$on('tab.changed', function(e, newTab, oldTab) {
        if (oldTab === 'basics' && $scope.rect && newTab !== 'basics') {
            $scope.cancel();
        }
    });

    $rootScope.$watch('activePanel', function(newPanel, oldPanel) {
        if (newPanel !== 'round' && oldPanel === 'round') {
            $scope.cancel(true);
        }
    });
}]);
angular.module('image.basics')

.controller('ResizeController', ['$scope', 'canvas', 'history', 'IES', function($scope, canvas, history, IES) {

    $scope.constrainProportions = true;

    $scope.percent = 100;

    $scope.startResizer = function($event) {
        $scope.width  = $scope.usePercentages ? 100 : Math.ceil(canvas.original.width);
        $scope.height = $scope.usePercentages ? 100 : Math.ceil(canvas.original.height);
        history.add('beforeResize', false, true);
        canvas.zoom(1);
        IES.get().openPanel('resize', $event);
    };

    /**
     * Toggle resizing mode between percentages and pixles.
     *
     * @param {boolean} usePercentages
     */
    $scope.togglePercentages = function(usePercentages) {
        if (usePercentages) {
            $scope.width = ($scope.width / canvas.original.width) * 100;
            $scope.height = ($scope.height / canvas.original.height) * 100;
        } else {
            $scope.width = ($scope.width * canvas.original.width) / 100;
            $scope.height = ($scope.height * canvas.original.height) / 100;
        }
    };

    $scope.apply = function() {
        var currentWidth  = Math.ceil(canvas.original.width),
            currentHeight = Math.ceil(canvas.original.height),
            newWidth      = Math.ceil($scope.width),
            newHeight     = Math.ceil($scope.height);

        if ($scope.usePercentages) {
            var widthScale    = $scope.width / 100;
            var heightScale   = $scope.height / 100;
        } else {
            var widthScale    = $scope.width / canvas.original.width;
            var heightScale   = $scope.height / canvas.original.height;
        }

        if (currentWidth === newWidth && currentHeight === newHeight) return;

        resize(widthScale, heightScale);

        IES.get().activePanel = false;
        history.save('beforeResize');
        canvas.fitToScreen();
    };

    $scope.close = function() {
        IES.get().activePanel = false;
        history.load('beforeResize');        
    };

    $scope.aspectToHeight = function(newWidth) {
        if ( ! $scope.constrainProportions) return;

        if ($scope.usePercentages) {
            $scope.height = newWidth;
        } else {
            var wRatio = parseFloat((canvas.original.width / newWidth).toPrecision(3));
            $scope.height = Math.ceil(canvas.original.height / wRatio);
        }
    };

    $scope.aspectToWidth = function(newHeight) {
        if ( ! $scope.constrainProportions) return;

        if ($scope.usePercentages) {
            $scope.width = newHeight;
        } else {
            var hRatio = parseFloat((canvas.original.height / newHeight).toPrecision(3));
            $scope.width = Math.floor(canvas.original.width / hRatio);
        }
    };

    function resize(widthScale, heightScale) {
        var newHeight = Math.round(canvas.original.height * heightScale),
            newWidth  = Math.round(canvas.original.width * widthScale);

        canvas.fabric.setHeight(newHeight);
        canvas.fabric.setWidth(newWidth);
        canvas.original.width = newWidth;
        canvas.original.height = newHeight;

        var objects = canvas.fabric.getObjects();
        for (var i in objects) {
            var scaleX = objects[i].scaleX;
            var scaleY = objects[i].scaleY;
            var left = objects[i].left;
            var top = objects[i].top;

            var tempScaleX = scaleX * widthScale;
            var tempScaleY = scaleY * heightScale;
            var tempLeft = left * widthScale;
            var tempTop = top * heightScale;

            objects[i].scaleX = tempScaleX;
            objects[i].scaleY = tempScaleY;
            objects[i].left = tempLeft;
            objects[i].top = tempTop;

            objects[i].setCoords();
        }

        canvas.fabric.renderAll();
    }
}]);
angular.module('image.basics')

.controller('CanvasBackgroundController', ['$scope', 'canvas', 'history', 'IES', function($scope, canvas, history, IES) {

    $scope.setBackground = function(color) {
       //history.add('Canvas Color',false,true);
        canvas.fabric.setBackgroundColor(color);
        canvas.fabric.renderAll();        
    };

    $scope.apply = function() {
        IES.get().activePanel = false;
        //history.save('Canvas Color');        
    };

    $scope.cancel = function() {
        IES.get().activePanel = false;
        canvas.fabric.setBackgroundColor('');
        //history.load('Canvas Color');
        canvas.fabric.renderAll();
    };
}]);
// Spectrum Colorpicker v1.6.0
// https://github.com/bgrins/spectrum
// Author: Brian Grinstead
// License: MIT

(function (factory) {
    "use strict";

    if (typeof define === 'function' && define.amd) { // AMD
        define(['jquery'], factory);
    }
    else if (typeof exports == "object" && typeof module == "object") { // CommonJS
        module.exports = factory;
    }
    else { // Browser
        factory(jQuery);
    }
})(function($, undefined) {
    "use strict";

    var defaultOpts = {

        // Callbacks
        beforeShow: noop,
        move: noop,
        change: noop,
        show: noop,
        hide: noop,

        // Options
        color: false,
        flat: false,
        showInput: false,
        allowEmpty: false,
        showButtons: true,
        clickoutFiresChange: false,
        showInitial: false,
        showPalette: false,
        showPaletteOnly: false,
        hideAfterPaletteSelect: false,
        togglePaletteOnly: false,
        showSelectionPalette: true,
        localStorageKey: false,
        appendTo: "body",
        maxSelectionSize: 7,
        cancelText: "cancel",
        chooseText: "choose",
        togglePaletteMoreText: "more",
        togglePaletteLessText: "less",
        clearText: "Clear Color Selection",
        noColorSelectedText: "No Color Selected",
        preferredFormat: false,
        className: "", // Deprecated - use containerClassName and replacerClassName instead.
        containerClassName: "",
        replacerClassName: "",
        showAlpha: false,
        theme: "sp-light",
        palette: [["#ffffff", "#000000", "#ff0000", "#ff8000", "#ffff00", "#008000", "#0000ff", "#4b0082", "#9400d3"]],
        selectionPalette: [],
        disabled: false,
        offset: null
    },
    spectrums = [],
    IE = !!/msie/i.exec( window.navigator.userAgent ),
    rgbaSupport = (function() {
        function contains( str, substr ) {
            return !!~('' + str).indexOf(substr);
        }

        var elem = document.createElement('div');
        var style = elem.style;
        style.cssText = 'background-color:rgba(0,0,0,.5)';
        return contains(style.backgroundColor, 'rgba') || contains(style.backgroundColor, 'hsla');
    })(),
    inputTypeColorSupport = (function() {
        var colorInput = $("<input type='color' value='!' />")[0];
        return colorInput.type === "color" && colorInput.value !== "!";
    })(),
    replaceInput = [
        "<div class='sp-replacer'>",
            "<div class='sp-preview'><div class='sp-preview-inner'></div></div>",
            "<div class='sp-dd'>&#9660;</div>",
        "</div>"
    ].join(''),
    markup = (function () {

        // IE does not support gradients with multiple stops, so we need to simulate
        //  that for the rainbow slider with 8 divs that each have a single gradient
        var gradientFix = "";
        if (IE) {
            for (var i = 1; i <= 6; i++) {
                gradientFix += "<div class='sp-" + i + "'></div>";
            }
        }

        return [
            "<div class='sp-container sp-hidden'>",
                "<div class='sp-palette-container'>",
                    "<div class='sp-palette sp-thumb sp-cf'></div>",
                    "<div class='sp-palette-button-container sp-cf'>",
                        "<button type='button' class='sp-palette-toggle'></button>",
                    "</div>",
                "</div>",
                "<div class='sp-picker-container'>",
                    "<div class='sp-top sp-cf'>",
                        "<div class='sp-fill'></div>",
                        "<div class='sp-top-inner'>",
                            "<div class='sp-color'>",
                                "<div class='sp-sat'>",
                                    "<div class='sp-val'>",
                                        "<div class='sp-dragger'></div>",
                                    "</div>",
                                "</div>",
                            "</div>",
                            "<div class='sp-clear sp-clear-display'>",
                            "</div>",
                            "<div class='sp-hue'>",
                                "<div class='sp-slider'></div>",
                                gradientFix,
                            "</div>",
                        "</div>",
                        "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>",
                    "</div>",
                    "<div class='sp-input-container sp-cf'>",
                        "<input class='sp-input' type='text' spellcheck='false'  />",
                    "</div>",
                    "<div class='sp-initial sp-thumb sp-cf'></div>",
                    "<div class='sp-button-container sp-cf'>",
                        "<a class='sp-cancel' href='#'></a>",
                        "<button type='button' class='sp-choose'></button>",
                    "</div>",
                "</div>",
            "</div>"
        ].join("");
    })();

    function paletteTemplate (p, color, className, opts) {
        var html = [];
        for (var i = 0; i < p.length; i++) {
            var current = p[i];
            if(current) {
                var tiny = tinycolor(current);
                var c = tiny.toHsl().l < 0.5 ? "sp-thumb-el sp-thumb-dark" : "sp-thumb-el sp-thumb-light";
                c += (tinycolor.equals(color, current)) ? " sp-thumb-active" : "";
                var formattedString = tiny.toString(opts.preferredFormat || "rgb");
                var swatchStyle = rgbaSupport ? ("background-color:" + tiny.toRgbString()) : "filter:" + tiny.toFilter();
                html.push('<span title="' + formattedString + '" data-color="' + tiny.toRgbString() + '" class="' + c + '"><span class="sp-thumb-inner" style="' + swatchStyle + ';" /></span>');
            } else {
                var cls = 'sp-clear-display';
                html.push($('<div />')
                    .append($('<span data-color="" style="background-color:transparent;" class="' + cls + '"></span>')
                        .attr('title', opts.noColorSelectedText)
                    )
                    .html()
                );
            }
        }
        return "<div class='sp-cf " + className + "'>" + html.join('') + "</div>";
    }

    function hideAll() {
        for (var i = 0; i < spectrums.length; i++) {
            if (spectrums[i]) {
                spectrums[i].hide();
            }
        }
    }

    function instanceOptions(o, callbackContext) {
        var opts = $.extend({}, defaultOpts, o);
        opts.callbacks = {
            'move': bind(opts.move, callbackContext),
            'change': bind(opts.change, callbackContext),
            'show': bind(opts.show, callbackContext),
            'hide': bind(opts.hide, callbackContext),
            'beforeShow': bind(opts.beforeShow, callbackContext)
        };

        return opts;
    }

    function spectrum(element, o) {

        var opts = instanceOptions(o, element),
            flat = opts.flat,
            showSelectionPalette = opts.showSelectionPalette,
            localStorageKey = opts.localStorageKey,
            theme = opts.theme,
            callbacks = opts.callbacks,
            resize = throttle(reflow, 10),
            visible = false,
            dragWidth = 0,
            dragHeight = 0,
            dragHelperHeight = 0,
            slideHeight = 0,
            slideWidth = 0,
            alphaWidth = 0,
            alphaSlideHelperWidth = 0,
            slideHelperHeight = 0,
            currentHue = 0,
            currentSaturation = 0,
            currentValue = 0,
            currentAlpha = 1,
            palette = [],
            paletteArray = [],
            paletteLookup = {},
            selectionPalette = opts.selectionPalette.slice(0),
            maxSelectionSize = opts.maxSelectionSize,
            draggingClass = "sp-dragging",
            shiftMovementDirection = null;

        var doc = element.ownerDocument,
            body = doc.body,
            boundElement = $(element),
            disabled = false,
            container = $(markup, doc).addClass(theme),
            pickerContainer = container.find(".sp-picker-container"),
            dragger = container.find(".sp-color"),
            dragHelper = container.find(".sp-dragger"),
            slider = container.find(".sp-hue"),
            slideHelper = container.find(".sp-slider"),
            alphaSliderInner = container.find(".sp-alpha-inner"),
            alphaSlider = container.find(".sp-alpha"),
            alphaSlideHelper = container.find(".sp-alpha-handle"),
            textInput = container.find(".sp-input"),
            paletteContainer = container.find(".sp-palette"),
            initialColorContainer = container.find(".sp-initial"),
           // cancelButton = container.find(".sp-cancel"),
            clearButton = container.find(".sp-clear"),
            chooseButton = container.find(".sp-choose"),
            toggleButton = container.find(".sp-palette-toggle"),
            isInput = boundElement.is("input"),
            isInputTypeColor = isInput && inputTypeColorSupport && boundElement.attr("type") === "color",
            shouldReplace = isInput && !flat,
            replacer = (shouldReplace) ? $(replaceInput).addClass(theme).addClass(opts.className).addClass(opts.replacerClassName) : $([]),
            offsetElement = (shouldReplace) ? replacer : boundElement,
            previewElement = replacer.find(".sp-preview-inner"),
            initialColor = opts.color || (isInput && boundElement.val()),
            colorOnShow = false,
            preferredFormat = opts.preferredFormat,
            currentPreferredFormat = preferredFormat,
            clickoutFiresChange = !opts.showButtons || opts.clickoutFiresChange,
            isEmpty = !initialColor,
            allowEmpty = opts.allowEmpty && !isInputTypeColor;

        function applyOptions() {

            if (opts.showPaletteOnly) {
                opts.showPalette = true;
            }

            toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);

            if (opts.palette) {
                palette = opts.palette.slice(0);
                paletteArray = $.isArray(palette[0]) ? palette : [palette];
                paletteLookup = {};
                for (var i = 0; i < paletteArray.length; i++) {
                    for (var j = 0; j < paletteArray[i].length; j++) {
                        var rgb = tinycolor(paletteArray[i][j]).toRgbString();
                        paletteLookup[rgb] = true;
                    }
                }
            }

            container.toggleClass("sp-flat", flat);
            container.toggleClass("sp-input-disabled", !opts.showInput);
            container.toggleClass("sp-alpha-enabled", opts.showAlpha);
            container.toggleClass("sp-clear-enabled", allowEmpty);
            container.toggleClass("sp-buttons-disabled", !opts.showButtons);
            container.toggleClass("sp-palette-buttons-disabled", !opts.togglePaletteOnly);
            container.toggleClass("sp-palette-disabled", !opts.showPalette);
            container.toggleClass("sp-palette-only", opts.showPaletteOnly);
            container.toggleClass("sp-initial-disabled", !opts.showInitial);
            container.addClass(opts.className).addClass(opts.containerClassName);

            reflow();
        }

        function initialize() {

            if (IE) {
                container.find("*:not(input)").attr("unselectable", "on");
            }

            applyOptions();

            if (shouldReplace) {
                boundElement.after(replacer).hide();
            }

            if (!allowEmpty) {
                clearButton.hide();
            }

            if (flat) {
                boundElement.after(container).hide();
            }
            else {

                var appendTo = opts.appendTo === "parent" ? boundElement.parent() : $(opts.appendTo);
                if (appendTo.length !== 1) {
                    appendTo = $("body");
                }

                appendTo.append(container);
            }

            updateSelectionPaletteFromStorage();

            offsetElement.bind("click.spectrum touchstart.spectrum", function (e) {
                if (!disabled) {
                    toggle();
                }

                e.stopPropagation();

                if (!$(e.target).is("input")) {
                    e.preventDefault();
                }
            });

            if(boundElement.is(":disabled") || (opts.disabled === true)) {
                disable();
            }

            // Prevent clicks from bubbling up to document.  This would cause it to be hidden.
            container.click(stopPropagation);

            // Handle user typed input
            textInput.change(setFromTextInput);
            textInput.bind("paste", function () {
                setTimeout(setFromTextInput, 1);
            });
            textInput.keydown(function (e) { if (e.keyCode == 13) { setFromTextInput(); } });

            /*cancelButton.text(opts.cancelText);
            cancelButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();
                revert();
                hide();
            });*/

            clearButton.attr("title", opts.clearText);
            clearButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();
                isEmpty = true;
                move();

                if(flat) {
                    //for the flat style, this is a change event
                    updateOriginalInput(true);
                }
            });

            chooseButton.text(opts.chooseText);
            chooseButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();

                if (isValid()) {
                    updateOriginalInput(true);
                    hide();
                }
            });

            toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);
            toggleButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();

                opts.showPaletteOnly = !opts.showPaletteOnly;

                // To make sure the Picker area is drawn on the right, next to the
                // Palette area (and not below the palette), first move the Palette
                // to the left to make space for the picker, plus 5px extra.
                // The 'applyOptions' function puts the whole container back into place
                // and takes care of the button-text and the sp-palette-only CSS class.
                if (!opts.showPaletteOnly && !flat) {
                    container.css('left', '-=' + (pickerContainer.outerWidth(true) + 5));
                }
                applyOptions();
            });

            draggable(alphaSlider, function (dragX, dragY, e) {
                currentAlpha = (dragX / alphaWidth);
                isEmpty = false;
                if (e.shiftKey) {
                    currentAlpha = Math.round(currentAlpha * 10) / 10;
                }

                move();
            }, dragStart, dragStop);

            draggable(slider, function (dragX, dragY) {
                currentHue = parseFloat(dragY / slideHeight);
                isEmpty = false;
                if (!opts.showAlpha) {
                    currentAlpha = 1;
                }
                move();
            }, dragStart, dragStop);

            draggable(dragger, function (dragX, dragY, e) {

                // shift+drag should snap the movement to either the x or y axis.
                if (!e.shiftKey) {
                    shiftMovementDirection = null;
                }
                else if (!shiftMovementDirection) {
                    var oldDragX = currentSaturation * dragWidth;
                    var oldDragY = dragHeight - (currentValue * dragHeight);
                    var furtherFromX = Math.abs(dragX - oldDragX) > Math.abs(dragY - oldDragY);

                    shiftMovementDirection = furtherFromX ? "x" : "y";
                }

                var setSaturation = !shiftMovementDirection || shiftMovementDirection === "x";
                var setValue = !shiftMovementDirection || shiftMovementDirection === "y";

                if (setSaturation) {
                    currentSaturation = parseFloat(dragX / dragWidth);
                }
                if (setValue) {
                    currentValue = parseFloat((dragHeight - dragY) / dragHeight);
                }

                isEmpty = false;
                if (!opts.showAlpha) {
                    currentAlpha = 1;
                }

                move();

            }, dragStart, dragStop);

            if (!!initialColor) {
                set(initialColor);

                // In case color was black - update the preview UI and set the format
                // since the set function will not run (default color is black).
                updateUI();
                currentPreferredFormat = preferredFormat || tinycolor(initialColor).format;

                addColorToSelectionPalette(initialColor);
            }
            else {
                updateUI();
            }

            if (flat) {
                show();
            }

            function paletteElementClick(e) {
                if (e.data && e.data.ignore) {
                    set($(e.target).closest(".sp-thumb-el").data("color"));
                    move();
                }
                else {
                    set($(e.target).closest(".sp-thumb-el").data("color"));
                    move();
                    updateOriginalInput(true);
                    if (opts.hideAfterPaletteSelect) {
                      hide();
                    }
                }

                return false;
            }

            var paletteEvent = IE ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum";
            paletteContainer.delegate(".sp-thumb-el", paletteEvent, paletteElementClick);
            initialColorContainer.delegate(".sp-thumb-el:nth-child(1)", paletteEvent, { ignore: true }, paletteElementClick);
        }

        function updateSelectionPaletteFromStorage() {

            if (localStorageKey && window.localStorage) {

                // Migrate old palettes over to new format.  May want to remove this eventually.
                try {
                    var oldPalette = window.localStorage[localStorageKey].split(",#");
                    if (oldPalette.length > 1) {
                        delete window.localStorage[localStorageKey];
                        $.each(oldPalette, function(i, c) {
                             addColorToSelectionPalette(c);
                        });
                    }
                }
                catch(e) { }

                try {
                    selectionPalette = window.localStorage[localStorageKey].split(";");
                }
                catch (e) { }
            }
        }

        function addColorToSelectionPalette(color) {
            if (showSelectionPalette) {
                var rgb = tinycolor(color).toRgbString();
                if (!paletteLookup[rgb] && $.inArray(rgb, selectionPalette) === -1) {
                    selectionPalette.push(rgb);
                    while(selectionPalette.length > maxSelectionSize) {
                        selectionPalette.shift();
                    }
                }

                if (localStorageKey && window.localStorage) {
                    try {
                        window.localStorage[localStorageKey] = selectionPalette.join(";");
                    }
                    catch(e) { }
                }
            }
        }

        function getUniqueSelectionPalette() {
            var unique = [];
            if (opts.showPalette) {
                for (var i = 0; i < selectionPalette.length; i++) {
                    var rgb = tinycolor(selectionPalette[i]).toRgbString();

                    if (!paletteLookup[rgb]) {
                        unique.push(selectionPalette[i]);
                    }
                }
            }

            return unique.reverse().slice(0, opts.maxSelectionSize);
        }

        function drawPalette() {

            var currentColor = get();

            var html = $.map(paletteArray, function (palette, i) {
                return paletteTemplate(palette, currentColor, "sp-palette-row sp-palette-row-" + i, opts);
            });

            updateSelectionPaletteFromStorage();

            if (selectionPalette) {
                html.push(paletteTemplate(getUniqueSelectionPalette(), currentColor, "sp-palette-row sp-palette-row-selection", opts));
            }

            paletteContainer.html(html.join(""));
        }

        function drawInitial() {
            if (opts.showInitial) {
                var initial = colorOnShow;
                var current = get();
                initialColorContainer.html(paletteTemplate([initial, current], current, "sp-palette-row-initial", opts));
            }
        }

        function dragStart() {
            if (dragHeight <= 0 || dragWidth <= 0 || slideHeight <= 0) {
                reflow();
            }
            container.addClass(draggingClass);
            shiftMovementDirection = null;
            boundElement.trigger('dragstart.spectrum', [ get() ]);
        }

        function dragStop() {
            container.removeClass(draggingClass);
            boundElement.trigger('dragstop.spectrum', [ get() ]);
        }

        function setFromTextInput() {

            var value = textInput.val();

            if ((value === null || value === "") && allowEmpty) {
                set(null);
                updateOriginalInput(true);
            }
            else {
                var tiny = tinycolor(value);
                if (tiny.isValid()) {
                    set(tiny);
                    updateOriginalInput(true);
                }
                else {
                    textInput.addClass("sp-validation-error");
                }
            }
        }

        function toggle() {
            if (visible) {
                hide();
            }
            else {
                show();
            }
        }

        function show() {
            var event = $.Event('beforeShow.spectrum');

            if (visible) {
                reflow();
                return;
            }

            boundElement.trigger(event, [ get() ]);

            if (callbacks.beforeShow(get()) === false || event.isDefaultPrevented()) {
                return;
            }

            hideAll();
            visible = true;

            $(doc).bind("click.spectrum", clickout);
            $(window).bind("resize.spectrum", resize);
            replacer.addClass("sp-active");
            container.removeClass("sp-hidden");

            reflow();
            updateUI();

            colorOnShow = get();

            drawInitial();
            callbacks.show(colorOnShow);
            boundElement.trigger('show.spectrum', [ colorOnShow ]);
        }

        function clickout(e) {
            // Return on right click.
            if (e.button == 2) { return; }

            if (clickoutFiresChange) {
                updateOriginalInput(true);
            }
            else {
                revert();
            }
            hide();
        }

        function hide() {
            // Return if hiding is unnecessary
            if (!visible || flat) { return; }
            visible = false;

            $(doc).unbind("click.spectrum", clickout);
            $(window).unbind("resize.spectrum", resize);

            replacer.removeClass("sp-active");
            container.addClass("sp-hidden");

            callbacks.hide(get());
            boundElement.trigger('hide.spectrum', [ get() ]);
        }

        function revert() {
            set(colorOnShow, true);
        }

        function set(color, ignoreFormatChange) {
            if (tinycolor.equals(color, get())) {
                // Update UI just in case a validation error needs
                // to be cleared.
                updateUI();
                return;
            }

            var newColor, newHsv;
            if (!color && allowEmpty) {
                isEmpty = true;
            } else {
                isEmpty = false;
                newColor = tinycolor(color);
                newHsv = newColor.toHsv();

                currentHue = (newHsv.h % 360) / 360;
                currentSaturation = newHsv.s;
                currentValue = newHsv.v;
                currentAlpha = newHsv.a;
            }
            updateUI();

            if (newColor && newColor.isValid() && !ignoreFormatChange) {
                currentPreferredFormat = preferredFormat || newColor.getFormat();
            }
        }

        function get(opts) {
            opts = opts || { };

            if (allowEmpty && isEmpty) {
                return null;
            }

            return tinycolor.fromRatio({
                h: currentHue,
                s: currentSaturation,
                v: currentValue,
                a: Math.round(currentAlpha * 100) / 100
            }, { format: opts.format || currentPreferredFormat });
        }

        function isValid() {
            return !textInput.hasClass("sp-validation-error");
        }

        function move() {
            updateUI();

            callbacks.move(get());
            boundElement.trigger('move.spectrum', [ get() ]);
        }

        function updateUI() {

            textInput.removeClass("sp-validation-error");

            updateHelperLocations();

            // Update dragger background color (gradients take care of saturation and value).
            var flatColor = tinycolor.fromRatio({ h: currentHue, s: 1, v: 1 });
            dragger.css("background-color", flatColor.toHexString());

            // Get a format that alpha will be included in (hex and names ignore alpha)
            var format = currentPreferredFormat;
            if (currentAlpha < 1 && !(currentAlpha === 0 && format === "name")) {
                if (format === "hex" || format === "hex3" || format === "hex6" || format === "name") {
                    format = "rgb";
                }
            }

            var realColor = get({ format: format }),
                displayColor = '';

             //reset background info for preview element
            previewElement.removeClass("sp-clear-display");
            previewElement.css('background-color', 'transparent');

            if (!realColor && allowEmpty) {
                // Update the replaced elements background with icon indicating no color selection
                previewElement.addClass("sp-clear-display");
            }
            else {
                var realHex = realColor.toHexString(),
                    realRgb = realColor.toRgbString();

                // Update the replaced elements background color (with actual selected color)
                if (rgbaSupport || realColor.alpha === 1) {
                    previewElement.css("background-color", realRgb);
                }
                else {
                    previewElement.css("background-color", "transparent");
                    previewElement.css("filter", realColor.toFilter());
                }

                if (opts.showAlpha) {
                    var rgb = realColor.toRgb();
                    rgb.a = 0;
                    var realAlpha = tinycolor(rgb).toRgbString();
                    var gradient = "linear-gradient(left, " + realAlpha + ", " + realHex + ")";

                    if (IE) {
                        alphaSliderInner.css("filter", tinycolor(realAlpha).toFilter({ gradientType: 1 }, realHex));
                    }
                    else {
                        alphaSliderInner.css("background", "-webkit-" + gradient);
                        alphaSliderInner.css("background", "-moz-" + gradient);
                        alphaSliderInner.css("background", "-ms-" + gradient);
                        // Use current syntax gradient on unprefixed property.
                        alphaSliderInner.css("background",
                            "linear-gradient(to right, " + realAlpha + ", " + realHex + ")");
                    }
                }

                displayColor = realColor.toString(format);
            }

            // Update the text entry input as it changes happen
            if (opts.showInput) {
                textInput.val(displayColor);
            }

            if (opts.showPalette) {
                drawPalette();
            }

            drawInitial();
        }

        function updateHelperLocations() {
            var s = currentSaturation;
            var v = currentValue;

            if(allowEmpty && isEmpty) {
                //if selected color is empty, hide the helpers
                alphaSlideHelper.hide();
                slideHelper.hide();
                dragHelper.hide();
            }
            else {
                //make sure helpers are visible
                alphaSlideHelper.show();
                slideHelper.show();
                dragHelper.show();

                // Where to show the little circle in that displays your current selected color
                var dragX = s * dragWidth;
                var dragY = dragHeight - (v * dragHeight);
                dragX = Math.max(
                    -dragHelperHeight,
                    Math.min(dragWidth - dragHelperHeight, dragX - dragHelperHeight)
                );
                dragY = Math.max(
                    -dragHelperHeight,
                    Math.min(dragHeight - dragHelperHeight, dragY - dragHelperHeight)
                );
                dragHelper.css({
                    "top": dragY + "px",
                    "left": dragX + "px"
                });

                var alphaX = currentAlpha * alphaWidth;
                alphaSlideHelper.css({
                    "left": (alphaX - (alphaSlideHelperWidth / 2)) + "px"
                });

                // Where to show the bar that displays your current selected hue
                var slideY = (currentHue) * slideHeight;
                slideHelper.css({
                    "top": (slideY - slideHelperHeight) + "px"
                });
            }
        }

        function updateOriginalInput(fireCallback) {
            var color = get(),
                displayColor = '',
                hasChanged = !tinycolor.equals(color, colorOnShow);

            if (color) {
                displayColor = color.toString(currentPreferredFormat);
                // Update the selection palette with the current color
                addColorToSelectionPalette(color);
            }

            if (isInput) {
                boundElement.val(displayColor);
            }

            if (fireCallback && hasChanged) {
                callbacks.change(color);
                boundElement.trigger('change', [ color ]);
            }
        }

        function reflow() {
            dragWidth = dragger.width();
            dragHeight = dragger.height();
            dragHelperHeight = dragHelper.height();
            slideWidth = slider.width();
            slideHeight = slider.height();
            slideHelperHeight = slideHelper.height();
            alphaWidth = alphaSlider.width();
            alphaSlideHelperWidth = alphaSlideHelper.width();

            if (!flat) {
                container.css("position", "absolute");
                if (opts.offset) {
                    container.offset(opts.offset);
                } else {
                    container.offset(getOffset(container, offsetElement));
                }
            }

            updateHelperLocations();

            if (opts.showPalette) {
                drawPalette();
            }

            boundElement.trigger('reflow.spectrum');
        }

        function destroy() {
            boundElement.show();
            offsetElement.unbind("click.spectrum touchstart.spectrum");
            container.remove();
            replacer.remove();
            spectrums[spect.id] = null;
        }

        function option(optionName, optionValue) {
            if (optionName === undefined) {
                return $.extend({}, opts);
            }
            if (optionValue === undefined) {
                return opts[optionName];
            }

            opts[optionName] = optionValue;
            applyOptions();
        }

        function enable() {
            disabled = false;
            boundElement.attr("disabled", false);
            offsetElement.removeClass("sp-disabled");
        }

        function disable() {
            hide();
            disabled = true;
            boundElement.attr("disabled", true);
            offsetElement.addClass("sp-disabled");
        }

        function setOffset(coord) {
            opts.offset = coord;
            reflow();
        }

        initialize();

        var spect = {
            show: show,
            hide: hide,
            toggle: toggle,
            reflow: reflow,
            option: option,
            enable: enable,
            disable: disable,
            offset: setOffset,
            set: function (c) {
                set(c);
                updateOriginalInput();
            },
            get: get,
            destroy: destroy,
            container: container
        };

        spect.id = spectrums.push(spect) - 1;

        return spect;
    }

    /**
    * checkOffset - get the offset below/above and left/right element depending on screen position
    * Thanks https://github.com/jquery/jquery-ui/blob/master/ui/jquery.ui.datepicker.js
    */
    function getOffset(picker, input) {
        var extraY = 0;
        var dpWidth = picker.outerWidth();
        var dpHeight = picker.outerHeight();
        var inputHeight = input.outerHeight();
        var doc = picker[0].ownerDocument;
        var docElem = doc.documentElement;
        var viewWidth = docElem.clientWidth + $(doc).scrollLeft();
        var viewHeight = docElem.clientHeight + $(doc).scrollTop();
        var offset = input.offset();
        offset.top += inputHeight;

        offset.left -=
            Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
            Math.abs(offset.left + dpWidth - viewWidth) : 0);

        offset.top -=
            Math.min(offset.top, ((offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
            Math.abs(dpHeight + inputHeight - extraY) : extraY));

        return offset;
    }

    /**
    * noop - do nothing
    */
    function noop() {

    }

    /**
    * stopPropagation - makes the code only doing this a little easier to read in line
    */
    function stopPropagation(e) {
        e.stopPropagation();
    }

    /**
    * Create a function bound to a given object
    * Thanks to underscore.js
    */
    function bind(func, obj) {
        var slice = Array.prototype.slice;
        var args = slice.call(arguments, 2);
        return function () {
            return func.apply(obj, args.concat(slice.call(arguments)));
        };
    }

    /**
    * Lightweight drag helper.  Handles containment within the element, so that
    * when dragging, the x is within [0,element.width] and y is within [0,element.height]
    */
    function draggable(element, onmove, onstart, onstop) {
        onmove = onmove || function () { };
        onstart = onstart || function () { };
        onstop = onstop || function () { };
        var doc = document;
        var dragging = false;
        var offset = {};
        var maxHeight = 0;
        var maxWidth = 0;
        var hasTouch = ('ontouchstart' in window);

        var duringDragEvents = {};
        duringDragEvents["selectstart"] = prevent;
        duringDragEvents["dragstart"] = prevent;
        duringDragEvents["touchmove mousemove"] = move;
        duringDragEvents["touchend mouseup"] = stop;

        function prevent(e) {
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            if (e.preventDefault) {
                e.preventDefault();
            }
            e.returnValue = false;
        }

        function move(e) {
            if (dragging) {
                // Mouseup happened outside of window
                if (IE && doc.documentMode < 9 && !e.button) {
                    return stop();
                }

                var touches = e.originalEvent && e.originalEvent.touches;
                var pageX = touches ? touches[0].pageX : e.pageX;
                var pageY = touches ? touches[0].pageY : e.pageY;

                var dragX = Math.max(0, Math.min(pageX - offset.left, maxWidth));
                var dragY = Math.max(0, Math.min(pageY - offset.top, maxHeight));

                if (hasTouch) {
                    // Stop scrolling in iOS
                    prevent(e);
                }

                onmove.apply(element, [dragX, dragY, e]);
            }
        }

        function start(e) {
            var rightclick = (e.which) ? (e.which == 3) : (e.button == 2);

            if (!rightclick && !dragging) {
                if (onstart.apply(element, arguments) !== false) {
                    dragging = true;
                    maxHeight = $(element).height();
                    maxWidth = $(element).width();
                    offset = $(element).offset();

                    $(doc).bind(duringDragEvents);
                    $(doc.body).addClass("sp-dragging");

                    if (!hasTouch) {
                        move(e);
                    }

                    prevent(e);
                }
            }
        }

        function stop() {
            if (dragging) {
                $(doc).unbind(duringDragEvents);
                $(doc.body).removeClass("sp-dragging");
                onstop.apply(element, arguments);
            }
            dragging = false;
        }

        $(element).bind("touchstart mousedown", start);
    }

    function throttle(func, wait, debounce) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var throttler = function () {
                timeout = null;
                func.apply(context, args);
            };
            if (debounce) clearTimeout(timeout);
            if (debounce || !timeout) timeout = setTimeout(throttler, wait);
        };
    }

    /**
    * Define a jQuery plugin
    */
    var dataID = "spectrum.id";
    $.fn.spectrum = function (opts, extra) {

        if (typeof opts == "string") {

            var returnValue = this;
            var args = Array.prototype.slice.call( arguments, 1 );

            this.each(function () {
                var spect = spectrums[$(this).data(dataID)];
                if (spect) {
                    var method = spect[opts];
                    if (!method) {
                        throw new Error( "Spectrum: no such method: '" + opts + "'" );
                    }

                    if (opts == "get") {
                        returnValue = spect.get();
                    }
                    else if (opts == "container") {
                        returnValue = spect.container;
                    }
                    else if (opts == "option") {
                        returnValue = spect.option.apply(spect, args);
                    }
                    else if (opts == "destroy") {
                        spect.destroy();
                        $(this).removeData(dataID);
                    }
                    else {
                        method.apply(spect, args);
                    }
                }
            });

            return returnValue;
        }

        // Initializing a new instance of spectrum
        return this.spectrum("destroy").each(function () {
            var options = $.extend({}, opts, $(this).data());
            var spect = spectrum(this, options);
            $(this).data(dataID, spect.id);
        });
    };

    $.fn.spectrum.load = true;
    $.fn.spectrum.loadOpts = {};
    $.fn.spectrum.draggable = draggable;
    $.fn.spectrum.defaults = defaultOpts;

    $.spectrum = { };
    $.spectrum.localization = { };
    $.spectrum.palettes = { };

    $.fn.spectrum.processNativeColorInputs = function () {
        if (!inputTypeColorSupport) {
            $("input[type=color]").spectrum({
                preferredFormat: "hex6"
            });
        }
    };

    // TinyColor v1.1.1
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License

    (function() {

    var trimLeft = /^[\s,#]+/,
        trimRight = /\s+$/,
        tinyCounter = 0,
        math = Math,
        mathRound = math.round,
        mathMin = math.min,
        mathMax = math.max,
        mathRandom = math.random;

    var tinycolor = function tinycolor (color, opts) {

        color = (color) ? color : '';
        opts = opts || { };

        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) {
           return color;
        }
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) {
            return new tinycolor(color, opts);
        }

        var rgb = inputToRGB(color);
        this._originalInput = color,
        this._r = rgb.r,
        this._g = rgb.g,
        this._b = rgb.b,
        this._a = rgb.a,
        this._roundA = mathRound(100*this._a) / 100,
        this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;

        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) { this._r = mathRound(this._r); }
        if (this._g < 1) { this._g = mathRound(this._g); }
        if (this._b < 1) { this._b = mathRound(this._b); }

        this._ok = rgb.ok;
        this._tc_id = tinyCounter++;
    };

    tinycolor.prototype = {
        isDark: function() {
            return this.getBrightness() < 128;
        },
        isLight: function() {
            return !this.isDark();
        },
        isValid: function() {
            return this._ok;
        },
        getOriginalInput: function() {
          return this._originalInput;
        },
        getFormat: function() {
            return this._format;
        },
        getAlpha: function() {
            return this._a;
        },
        getBrightness: function() {
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        setAlpha: function(value) {
            this._a = boundAlpha(value);
            this._roundA = mathRound(100*this._a) / 100;
            return this;
        },
        toHsv: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
        },
        toHsvString: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
            return (this._a == 1) ?
              "hsv("  + h + ", " + s + "%, " + v + "%)" :
              "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
        },
        toHsl: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
        },
        toHslString: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
            return (this._a == 1) ?
              "hsl("  + h + ", " + s + "%, " + l + "%)" :
              "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
        },
        toHex: function(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function(allow3Char) {
            return '#' + this.toHex(allow3Char);
        },
        toHex8: function() {
            return rgbaToHex(this._r, this._g, this._b, this._a);
        },
        toHex8String: function() {
            return '#' + this.toHex8();
        },
        toRgb: function() {
            return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
        },
        toRgbString: function() {
            return (this._a == 1) ?
              "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
              "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function() {
            return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
        },
        toPercentageRgbString: function() {
            return (this._a == 1) ?
              "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
              "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function() {
            if (this._a === 0) {
                return "transparent";
            }

            if (this._a < 1) {
                return false;
            }

            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function(secondColor) {
            var hex8String = '#' + rgbaToHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";

            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = s.toHex8String();
            }

            return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
        },
        toString: function(format) {
            var formatSet = !!format;
            format = format || this._format;

            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "name");

            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) {
                    return this.toName();
                }
                return this.toRgbString();
            }
            if (format === "rgb") {
                formattedString = this.toRgbString();
            }
            if (format === "prgb") {
                formattedString = this.toPercentageRgbString();
            }
            if (format === "hex" || format === "hex6") {
                formattedString = this.toHexString();
            }
            if (format === "hex3") {
                formattedString = this.toHexString(true);
            }
            if (format === "hex8") {
                formattedString = this.toHex8String();
            }
            if (format === "name") {
                formattedString = this.toName();
            }
            if (format === "hsl") {
                formattedString = this.toHslString();
            }
            if (format === "hsv") {
                formattedString = this.toHsvString();
            }

            return formattedString || this.toHexString();
        },

        _applyModification: function(fn, args) {
            var color = fn.apply(null, [this].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function() {
            return this._applyModification(lighten, arguments);
        },
        brighten: function() {
            return this._applyModification(brighten, arguments);
        },
        darken: function() {
            return this._applyModification(darken, arguments);
        },
        desaturate: function() {
            return this._applyModification(desaturate, arguments);
        },
        saturate: function() {
            return this._applyModification(saturate, arguments);
        },
        greyscale: function() {
            return this._applyModification(greyscale, arguments);
        },
        spin: function() {
            return this._applyModification(spin, arguments);
        },

        _applyCombination: function(fn, args) {
            return fn.apply(null, [this].concat([].slice.call(args)));
        },
        analogous: function() {
            return this._applyCombination(analogous, arguments);
        },
        complement: function() {
            return this._applyCombination(complement, arguments);
        },
        monochromatic: function() {
            return this._applyCombination(monochromatic, arguments);
        },
        splitcomplement: function() {
            return this._applyCombination(splitcomplement, arguments);
        },
        triad: function() {
            return this._applyCombination(triad, arguments);
        },
        tetrad: function() {
            return this._applyCombination(tetrad, arguments);
        }
    };

    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (typeof color == "object") {
            var newColor = {};
            for (var i in color) {
                if (color.hasOwnProperty(i)) {
                    if (i === "a") {
                        newColor[i] = color[i];
                    }
                    else {
                        newColor[i] = convertToPercentage(color[i]);
                    }
                }
            }
            color = newColor;
        }

        return tinycolor(color, opts);
    };

    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {

        var rgb = { r: 0, g: 0, b: 0 };
        var a = 1;
        var ok = false;
        var format = false;

        if (typeof color == "string") {
            color = stringInputToObject(color);
        }

        if (typeof color == "object") {
            if (color.hasOwnProperty("r") && color.hasOwnProperty("g") && color.hasOwnProperty("b")) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            }
            else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("v")) {
                color.s = convertToPercentage(color.s);
                color.v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, color.s, color.v);
                ok = true;
                format = "hsv";
            }
            else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("l")) {
                color.s = convertToPercentage(color.s);
                color.l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, color.s, color.l);
                ok = true;
                format = "hsl";
            }

            if (color.hasOwnProperty("a")) {
                a = color.a;
            }
        }

        a = boundAlpha(a);

        return {
            ok: ok,
            format: color.format || format,
            r: mathMin(255, mathMax(rgb.r, 0)),
            g: mathMin(255, mathMax(rgb.g, 0)),
            b: mathMin(255, mathMax(rgb.b, 0)),
            a: a
        };
    }


    // Conversion Functions
    // --------------------

    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b){
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }

    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {

        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);

        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, l = (max + min) / 2;

        if(max == min) {
            h = s = 0; // achromatic
        }
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }

            h /= 6;
        }

        return { h: h, s: s, l: l };
    }

    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;

        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);

        function hue2rgb(p, q, t) {
            if(t < 0) t += 1;
            if(t > 1) t -= 1;
            if(t < 1/6) return p + (q - p) * 6 * t;
            if(t < 1/2) return q;
            if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
            return p;
        }

        if(s === 0) {
            r = g = b = l; // achromatic
        }
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1/3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1/3);
        }

        return { r: r * 255, g: g * 255, b: b * 255 };
    }

    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {

        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);

        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, v = max;

        var d = max - min;
        s = max === 0 ? 0 : d / max;

        if(max == min) {
            h = 0; // achromatic
        }
        else {
            switch(max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }
        return { h: h, s: s, v: v };
    }

    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
     function hsvToRgb(h, s, v) {

        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);

        var i = math.floor(h),
            f = h - i,
            p = v * (1 - s),
            q = v * (1 - f * s),
            t = v * (1 - (1 - f) * s),
            mod = i % 6,
            r = [v, q, p, p, t, v][mod],
            g = [t, v, v, q, p, p][mod],
            b = [p, p, t, v, v, q][mod];

        return { r: r * 255, g: g * 255, b: b * 255 };
    }

    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {

        var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
        ];

        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
            return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        }

        return hex.join("");
    }
        // `rgbaToHex`
        // Converts an RGBA color plus alpha transparency to hex
        // Assumes r, g, b and a are contained in the set [0, 255]
        // Returns an 8 character hex
        function rgbaToHex(r, g, b, a) {

            var hex = [
                pad2(convertDecimalToHex(a)),
                pad2(mathRound(r).toString(16)),
                pad2(mathRound(g).toString(16)),
                pad2(mathRound(b).toString(16))
            ];

            return hex.join("");
        }

    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function (color1, color2) {
        if (!color1 || !color2) { return false; }
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: mathRandom(),
            g: mathRandom(),
            b: mathRandom()
        });
    };


    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

    function desaturate(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }

    function saturate(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }

    function greyscale(color) {
        return tinycolor(color).desaturate(100);
    }

    function lighten (color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }

    function brighten(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var rgb = tinycolor(color).toRgb();
        rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
        rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
        rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
        return tinycolor(rgb);
    }

    function darken (color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }

    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (mathRound(hsl.h) + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }

    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

    function complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }

    function triad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
        ];
    }

    function tetrad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
        ];
    }

    function splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
            tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
        ];
    }

    function analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;

        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [tinycolor(color)];

        for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }

    function monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;

        while (results--) {
            ret.push(tinycolor({ h: h, s: s, v: v}));
            v = (v + modification) % 1;
        }

        return ret;
    }

    // Utility Functions
    // ---------------------

    tinycolor.mix = function(color1, color2, amount) {
        amount = (amount === 0) ? 0 : (amount || 50);

        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();

        var p = amount / 100;
        var w = p * 2 - 1;
        var a = rgb2.a - rgb1.a;

        var w1;

        if (w * a == -1) {
            w1 = w;
        } else {
            w1 = (w + a) / (1 + w * a);
        }

        w1 = (w1 + 1) / 2;

        var w2 = 1 - w1;

        var rgba = {
            r: rgb2.r * w1 + rgb1.r * w2,
            g: rgb2.g * w1 + rgb1.g * w2,
            b: rgb2.b * w1 + rgb1.b * w2,
            a: rgb2.a * p  + rgb1.a * (1 - p)
        };

        return tinycolor(rgba);
    };


    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/AERT#color-contrast>

    // `readability`
    // Analyze the 2 colors and returns an object with the following properties:
    //    `brightness`: difference in brightness between the two colors
    //    `color`: difference in color/hue between the two colors
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        var rgb1 = c1.toRgb();
        var rgb2 = c2.toRgb();
        var brightnessA = c1.getBrightness();
        var brightnessB = c2.getBrightness();
        var colorDiff = (
            Math.max(rgb1.r, rgb2.r) - Math.min(rgb1.r, rgb2.r) +
            Math.max(rgb1.g, rgb2.g) - Math.min(rgb1.g, rgb2.g) +
            Math.max(rgb1.b, rgb2.b) - Math.min(rgb1.b, rgb2.b)
        );

        return {
            brightness: Math.abs(brightnessA - brightnessB),
            color: colorDiff
        };
    };

    // `readable`
    // http://www.w3.org/TR/AERT#color-contrast
    // Ensure that foreground and background color combinations provide sufficient contrast.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    tinycolor.isReadable = function(color1, color2) {
        var readability = tinycolor.readability(color1, color2);
        return readability.brightness > 125 && readability.color > 500;
    };

    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // *Example*
    //    tinycolor.mostReadable("#123", ["#fff", "#000"]) => "#000"
    tinycolor.mostReadable = function(baseColor, colorList) {
        var bestColor = null;
        var bestScore = 0;
        var bestIsReadable = false;
        for (var i=0; i < colorList.length; i++) {

            // We normalize both around the "acceptable" breaking point,
            // but rank brightness constrast higher than hue.

            var readability = tinycolor.readability(baseColor, colorList[i]);
            var readable = readability.brightness > 125 && readability.color > 500;
            var score = 3 * (readability.brightness / 125) + (readability.color / 500);

            if ((readable && ! bestIsReadable) ||
                (readable && bestIsReadable && score > bestScore) ||
                ((! readable) && (! bestIsReadable) && score > bestScore)) {
                bestIsReadable = readable;
                bestScore = score;
                bestColor = tinycolor(colorList[i]);
            }
        }
        return bestColor;
    };


    // Big List of Colors
    // ------------------
    // <http://www.w3.org/TR/css3-color/#svg-color>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };

    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);


    // Utilities
    // ---------

    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = { };
        for (var i in o) {
            if (o.hasOwnProperty(i)) {
                flipped[o[i]] = i;
            }
        }
        return flipped;
    }

    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);

        if (isNaN(a) || a < 0 || a > 1) {
            a = 1;
        }

        return a;
    }

    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) { n = "100%"; }

        var processPercent = isPercentage(n);
        n = mathMin(max, mathMax(0, parseFloat(n)));

        // Automatically convert percentage into number
        if (processPercent) {
            n = parseInt(n * max, 10) / 100;
        }

        // Handle floating point rounding errors
        if ((math.abs(n - max) < 0.000001)) {
            return 1;
        }

        // Convert into [0, 1] range if it isn't already
        return (n % max) / parseFloat(max);
    }

    // Force a number between 0 and 1
    function clamp01(val) {
        return mathMin(1, mathMax(0, val));
    }

    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }

    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
    }

    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf('%') != -1;
    }

    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? '0' + c : '' + c;
    }

    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) {
            n = (n * 100) + "%";
        }

        return n;
    }

    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return (parseIntFromHex(h) / 255);
    }

    var matchers = (function() {

        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";

        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

        return {
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    })();

    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {

        color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        }
        else if (color == 'transparent') {
            return { r: 0, g: 0, b: 0, a: 0, format: "name" };
        }

        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if ((match = matchers.rgb.exec(color))) {
            return { r: match[1], g: match[2], b: match[3] };
        }
        if ((match = matchers.rgba.exec(color))) {
            return { r: match[1], g: match[2], b: match[3], a: match[4] };
        }
        if ((match = matchers.hsl.exec(color))) {
            return { h: match[1], s: match[2], l: match[3] };
        }
        if ((match = matchers.hsla.exec(color))) {
            return { h: match[1], s: match[2], l: match[3], a: match[4] };
        }
        if ((match = matchers.hsv.exec(color))) {
            return { h: match[1], s: match[2], v: match[3] };
        }
        if ((match = matchers.hsva.exec(color))) {
            return { h: match[1], s: match[2], v: match[3], a: match[4] };
        }
        if ((match = matchers.hex8.exec(color))) {
            return {
                a: convertHexToDecimal(match[1]),
                r: parseIntFromHex(match[2]),
                g: parseIntFromHex(match[3]),
                b: parseIntFromHex(match[4]),
                format: named ? "name" : "hex8"
            };
        }
        if ((match = matchers.hex6.exec(color))) {
            return {
                r: parseIntFromHex(match[1]),
                g: parseIntFromHex(match[2]),
                b: parseIntFromHex(match[3]),
                format: named ? "name" : "hex"
            };
        }
        if ((match = matchers.hex3.exec(color))) {
            return {
                r: parseIntFromHex(match[1] + '' + match[1]),
                g: parseIntFromHex(match[2] + '' + match[2]),
                b: parseIntFromHex(match[3] + '' + match[3]),
                format: named ? "name" : "hex"
            };
        }

        return false;
    }

    window.tinycolor = tinycolor;
    })();


    $(function () {
        if ($.fn.spectrum.load) {
            $.fn.spectrum.processNativeColorInputs();
        }
    });

});

/* == jquery mousewheel plugin == Version: 3.1.12, License: MIT License (MIT) */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?module.exports=a:a(jQuery)}(function(a){function b(b){var g=b||window.event,h=i.call(arguments,1),j=0,l=0,m=0,n=0,o=0,p=0;if(b=a.event.fix(g),b.type="mousewheel","detail"in g&&(m=-1*g.detail),"wheelDelta"in g&&(m=g.wheelDelta),"wheelDeltaY"in g&&(m=g.wheelDeltaY),"wheelDeltaX"in g&&(l=-1*g.wheelDeltaX),"axis"in g&&g.axis===g.HORIZONTAL_AXIS&&(l=-1*m,m=0),j=0===m?l:m,"deltaY"in g&&(m=-1*g.deltaY,j=m),"deltaX"in g&&(l=g.deltaX,0===m&&(j=-1*l)),0!==m||0!==l){if(1===g.deltaMode){var q=a.data(this,"mousewheel-line-height");j*=q,m*=q,l*=q}else if(2===g.deltaMode){var r=a.data(this,"mousewheel-page-height");j*=r,m*=r,l*=r}if(n=Math.max(Math.abs(m),Math.abs(l)),(!f||f>n)&&(f=n,d(g,n)&&(f/=40)),d(g,n)&&(j/=40,l/=40,m/=40),j=Math[j>=1?"floor":"ceil"](j/f),l=Math[l>=1?"floor":"ceil"](l/f),m=Math[m>=1?"floor":"ceil"](m/f),k.settings.normalizeOffset&&this.getBoundingClientRect){var s=this.getBoundingClientRect();o=b.clientX-s.left,p=b.clientY-s.top}return b.deltaX=l,b.deltaY=m,b.deltaFactor=f,b.offsetX=o,b.offsetY=p,b.deltaMode=0,h.unshift(b,j,l,m),e&&clearTimeout(e),e=setTimeout(c,200),(a.event.dispatch||a.event.handle).apply(this,h)}}function c(){f=null}function d(a,b){return k.settings.adjustOldDeltas&&"mousewheel"===a.type&&b%120===0}var e,f,g=["wheel","mousewheel","DOMMouseScroll","MozMousePixelScroll"],h="onwheel"in document||document.documentMode>=9?["wheel"]:["mousewheel","DomMouseScroll","MozMousePixelScroll"],i=Array.prototype.slice;if(a.event.fixHooks)for(var j=g.length;j;)a.event.fixHooks[g[--j]]=a.event.mouseHooks;var k=a.event.special.mousewheel={version:"3.1.12",setup:function(){if(this.addEventListener)for(var c=h.length;c;)this.addEventListener(h[--c],b,!1);else this.onmousewheel=b;a.data(this,"mousewheel-line-height",k.getLineHeight(this)),a.data(this,"mousewheel-page-height",k.getPageHeight(this))},teardown:function(){if(this.removeEventListener)for(var c=h.length;c;)this.removeEventListener(h[--c],b,!1);else this.onmousewheel=null;a.removeData(this,"mousewheel-line-height"),a.removeData(this,"mousewheel-page-height")},getLineHeight:function(b){var c=a(b),d=c["offsetParent"in a.fn?"offsetParent":"parent"]();return d.length||(d=a("body")),parseInt(d.css("fontSize"),10)||parseInt(c.css("fontSize"),10)||16},getPageHeight:function(b){return a(b).height()},settings:{adjustOldDeltas:!0,normalizeOffset:!0}};a.fn.extend({mousewheel:function(a){return a?this.bind("mousewheel",a):this.trigger("mousewheel")},unmousewheel:function(a){return this.unbind("mousewheel",a)}})});
/* == malihu jquery custom scrollbar plugin == Version: 3.0.7, License: MIT License (MIT) */
!function(e,t,a){!function(t){var o="function"==typeof define&&define.amd,n="https:"==a.location.protocol?"https:":"http:",i="cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.12/jquery.mousewheel.min.js";o||e.event.special.mousewheel||e("head").append(decodeURI("%3Cscript src="+n+"//"+i+"%3E%3C/script%3E")),t()}(function(){var o,n="mCustomScrollbar",i="mCS",r=".mCustomScrollbar",l={setTop:0,setLeft:0,axis:"y",scrollbarPosition:"inside",scrollInertia:950,autoDraggerLength:!0,alwaysShowScrollbar:0,snapOffset:0,mouseWheel:{enable:!0,scrollAmount:"auto",axis:"y",deltaFactor:"auto",disableOver:["select","option","keygen","datalist","textarea"]},scrollButtons:{scrollType:"stepless",scrollAmount:"auto"},keyboard:{enable:!0,scrollType:"stepless",scrollAmount:"auto"},contentTouchScroll:25,advanced:{autoScrollOnFocus:"input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']",updateOnContentResize:!0,updateOnImageLoad:!0},theme:"light",callbacks:{onTotalScrollOffset:0,onTotalScrollBackOffset:0,alwaysTriggerOffsets:!0}},s=0,c={},d=t.attachEvent&&!t.addEventListener?1:0,u=!1,f=["mCSB_dragger_onDrag","mCSB_scrollTools_onDrag","mCS_img_loaded","mCS_disabled","mCS_destroyed","mCS_no_scrollbar","mCS-autoHide","mCS-dir-rtl","mCS_no_scrollbar_y","mCS_no_scrollbar_x","mCS_y_hidden","mCS_x_hidden","mCSB_draggerContainer","mCSB_buttonUp","mCSB_buttonDown","mCSB_buttonLeft","mCSB_buttonRight"],h={init:function(t){var t=e.extend(!0,{},l,t),a=m.call(this);if(t.live){var o=t.liveSelector||this.selector||r,n=e(o);if("off"===t.live)return void g(o);c[o]=setTimeout(function(){n.mCustomScrollbar(t),"once"===t.live&&n.length&&g(o)},500)}else g(o);return t.setWidth=t.set_width?t.set_width:t.setWidth,t.setHeight=t.set_height?t.set_height:t.setHeight,t.axis=t.horizontalScroll?"x":v(t.axis),t.scrollInertia=t.scrollInertia>0&&t.scrollInertia<17?17:t.scrollInertia,"object"!=typeof t.mouseWheel&&1==t.mouseWheel&&(t.mouseWheel={enable:!0,scrollAmount:"auto",axis:"y",preventDefault:!1,deltaFactor:"auto",normalizeDelta:!1,invert:!1}),t.mouseWheel.scrollAmount=t.mouseWheelPixels?t.mouseWheelPixels:t.mouseWheel.scrollAmount,t.mouseWheel.normalizeDelta=t.advanced.normalizeMouseWheelDelta?t.advanced.normalizeMouseWheelDelta:t.mouseWheel.normalizeDelta,t.scrollButtons.scrollType=x(t.scrollButtons.scrollType),p(t),e(a).each(function(){var a=e(this);if(!a.data(i)){a.data(i,{idx:++s,opt:t,scrollRatio:{y:null,x:null},overflowed:null,contentReset:{y:null,x:null},bindEvents:!1,tweenRunning:!1,sequential:{},langDir:a.css("direction"),cbOffsets:null,trigger:null});var o=a.data(i),n=o.opt,r=a.data("mcs-axis"),l=a.data("mcs-scrollbar-position"),c=a.data("mcs-theme");r&&(n.axis=r),l&&(n.scrollbarPosition=l),c&&(n.theme=c,p(n)),_.call(this),e("#mCSB_"+o.idx+"_container img:not(."+f[2]+")").addClass(f[2]),h.update.call(null,a)}})},update:function(t,a){var o=t||m.call(this);return e(o).each(function(){var t=e(this);if(t.data(i)){var o=t.data(i),n=o.opt,r=e("#mCSB_"+o.idx+"_container"),l=[e("#mCSB_"+o.idx+"_dragger_vertical"),e("#mCSB_"+o.idx+"_dragger_horizontal")];if(!r.length)return;o.tweenRunning&&Q(t),t.hasClass(f[3])&&t.removeClass(f[3]),t.hasClass(f[4])&&t.removeClass(f[4]),C.call(this),w.call(this),"y"===n.axis||n.advanced.autoExpandHorizontalScroll||r.css("width",S(r.children())),o.overflowed=k.call(this),R.call(this),n.autoDraggerLength&&y.call(this),B.call(this),O.call(this);var s=[Math.abs(r[0].offsetTop),Math.abs(r[0].offsetLeft)];"x"!==n.axis&&(o.overflowed[0]?l[0].height()>l[0].parent().height()?M.call(this):(G(t,s[0].toString(),{dir:"y",dur:0,overwrite:"none"}),o.contentReset.y=null):(M.call(this),"y"===n.axis?I.call(this):"yx"===n.axis&&o.overflowed[1]&&G(t,s[1].toString(),{dir:"x",dur:0,overwrite:"none"}))),"y"!==n.axis&&(o.overflowed[1]?l[1].width()>l[1].parent().width()?M.call(this):(G(t,s[1].toString(),{dir:"x",dur:0,overwrite:"none"}),o.contentReset.x=null):(M.call(this),"x"===n.axis?I.call(this):"yx"===n.axis&&o.overflowed[0]&&G(t,s[0].toString(),{dir:"y",dur:0,overwrite:"none"}))),a&&o&&(2===a&&n.callbacks.onImageLoad&&"function"==typeof n.callbacks.onImageLoad?n.callbacks.onImageLoad.call(this):3===a&&n.callbacks.onSelectorChange&&"function"==typeof n.callbacks.onSelectorChange?n.callbacks.onSelectorChange.call(this):n.callbacks.onUpdate&&"function"==typeof n.callbacks.onUpdate&&n.callbacks.onUpdate.call(this)),N.call(this)}})},scrollTo:function(t,a){if("undefined"!=typeof t&&null!=t){var o=m.call(this);return e(o).each(function(){var o=e(this);if(o.data(i)){var n=o.data(i),r=n.opt,l={trigger:"external",scrollInertia:r.scrollInertia,scrollEasing:"mcsEaseInOut",moveDragger:!1,timeout:60,callbacks:!0,onStart:!0,onUpdate:!0,onComplete:!0},s=e.extend(!0,{},l,a),c=Y.call(this,t),d=s.scrollInertia>0&&s.scrollInertia<17?17:s.scrollInertia;c[0]=X.call(this,c[0],"y"),c[1]=X.call(this,c[1],"x"),s.moveDragger&&(c[0]*=n.scrollRatio.y,c[1]*=n.scrollRatio.x),s.dur=d,setTimeout(function(){null!==c[0]&&"undefined"!=typeof c[0]&&"x"!==r.axis&&n.overflowed[0]&&(s.dir="y",s.overwrite="all",G(o,c[0].toString(),s)),null!==c[1]&&"undefined"!=typeof c[1]&&"y"!==r.axis&&n.overflowed[1]&&(s.dir="x",s.overwrite="none",G(o,c[1].toString(),s))},s.timeout)}})}},stop:function(){var t=m.call(this);return e(t).each(function(){var t=e(this);t.data(i)&&Q(t)})},disable:function(t){var a=m.call(this);return e(a).each(function(){var a=e(this);if(a.data(i)){{a.data(i)}N.call(this,"remove"),I.call(this),t&&M.call(this),R.call(this,!0),a.addClass(f[3])}})},destroy:function(){var t=m.call(this);return e(t).each(function(){var a=e(this);if(a.data(i)){var o=a.data(i),r=o.opt,l=e("#mCSB_"+o.idx),s=e("#mCSB_"+o.idx+"_container"),c=e(".mCSB_"+o.idx+"_scrollbar");r.live&&g(r.liveSelector||e(t).selector),N.call(this,"remove"),I.call(this),M.call(this),a.removeData(i),$(this,"mcs"),c.remove(),s.find("img."+f[2]).removeClass(f[2]),l.replaceWith(s.contents()),a.removeClass(n+" _"+i+"_"+o.idx+" "+f[6]+" "+f[7]+" "+f[5]+" "+f[3]).addClass(f[4])}})}},m=function(){return"object"!=typeof e(this)||e(this).length<1?r:this},p=function(t){var a=["rounded","rounded-dark","rounded-dots","rounded-dots-dark"],o=["rounded-dots","rounded-dots-dark","3d","3d-dark","3d-thick","3d-thick-dark","inset","inset-dark","inset-2","inset-2-dark","inset-3","inset-3-dark"],n=["minimal","minimal-dark"],i=["minimal","minimal-dark"],r=["minimal","minimal-dark"];t.autoDraggerLength=e.inArray(t.theme,a)>-1?!1:t.autoDraggerLength,t.autoExpandScrollbar=e.inArray(t.theme,o)>-1?!1:t.autoExpandScrollbar,t.scrollButtons.enable=e.inArray(t.theme,n)>-1?!1:t.scrollButtons.enable,t.autoHideScrollbar=e.inArray(t.theme,i)>-1?!0:t.autoHideScrollbar,t.scrollbarPosition=e.inArray(t.theme,r)>-1?"outside":t.scrollbarPosition},g=function(e){c[e]&&(clearTimeout(c[e]),$(c,e))},v=function(e){return"yx"===e||"xy"===e||"auto"===e?"yx":"x"===e||"horizontal"===e?"x":"y"},x=function(e){return"stepped"===e||"pixels"===e||"step"===e||"click"===e?"stepped":"stepless"},_=function(){var t=e(this),a=t.data(i),o=a.opt,r=o.autoExpandScrollbar?" "+f[1]+"_expand":"",l=["<div id='mCSB_"+a.idx+"_scrollbar_vertical' class='mCSB_scrollTools mCSB_"+a.idx+"_scrollbar mCS-"+o.theme+" mCSB_scrollTools_vertical"+r+"'><div class='"+f[12]+"'><div id='mCSB_"+a.idx+"_dragger_vertical' class='mCSB_dragger' style='position:absolute;' oncontextmenu='return false;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>","<div id='mCSB_"+a.idx+"_scrollbar_horizontal' class='mCSB_scrollTools mCSB_"+a.idx+"_scrollbar mCS-"+o.theme+" mCSB_scrollTools_horizontal"+r+"'><div class='"+f[12]+"'><div id='mCSB_"+a.idx+"_dragger_horizontal' class='mCSB_dragger' style='position:absolute;' oncontextmenu='return false;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>"],s="yx"===o.axis?"mCSB_vertical_horizontal":"x"===o.axis?"mCSB_horizontal":"mCSB_vertical",c="yx"===o.axis?l[0]+l[1]:"x"===o.axis?l[1]:l[0],d="yx"===o.axis?"<div id='mCSB_"+a.idx+"_container_wrapper' class='mCSB_container_wrapper' />":"",u=o.autoHideScrollbar?" "+f[6]:"",h="x"!==o.axis&&"rtl"===a.langDir?" "+f[7]:"";o.setWidth&&t.css("width",o.setWidth),o.setHeight&&t.css("height",o.setHeight),o.setLeft="y"!==o.axis&&"rtl"===a.langDir?"989999px":o.setLeft,t.addClass(n+" _"+i+"_"+a.idx+u+h).wrapInner("<div id='mCSB_"+a.idx+"' class='mCustomScrollBox mCS-"+o.theme+" "+s+"'><div id='mCSB_"+a.idx+"_container' class='mCSB_container' style='position:relative; top:"+o.setTop+"; left:"+o.setLeft+";' dir="+a.langDir+" /></div>");var m=e("#mCSB_"+a.idx),p=e("#mCSB_"+a.idx+"_container");"y"===o.axis||o.advanced.autoExpandHorizontalScroll||p.css("width",S(p.children())),"outside"===o.scrollbarPosition?("static"===t.css("position")&&t.css("position","relative"),t.css("overflow","visible"),m.addClass("mCSB_outside").after(c)):(m.addClass("mCSB_inside").append(c),p.wrap(d)),b.call(this);var g=[e("#mCSB_"+a.idx+"_dragger_vertical"),e("#mCSB_"+a.idx+"_dragger_horizontal")];g[0].css("min-height",g[0].height()),g[1].css("min-width",g[1].width())},S=function(t){return Math.max.apply(Math,t.map(function(){return e(this).outerWidth(!0)}).get())},w=function(){var t=e(this),a=t.data(i),o=a.opt,n=e("#mCSB_"+a.idx+"_container");o.advanced.autoExpandHorizontalScroll&&"y"!==o.axis&&n.css({position:"absolute",width:"auto"}).wrap("<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />").css({width:Math.ceil(n[0].getBoundingClientRect().right+.4)-Math.floor(n[0].getBoundingClientRect().left),position:"relative"}).unwrap()},b=function(){var t=e(this),a=t.data(i),o=a.opt,n=e(".mCSB_"+a.idx+"_scrollbar:first"),r=at(o.scrollButtons.tabindex)?"tabindex='"+o.scrollButtons.tabindex+"'":"",l=["<a href='#' class='"+f[13]+"' oncontextmenu='return false;' "+r+" />","<a href='#' class='"+f[14]+"' oncontextmenu='return false;' "+r+" />","<a href='#' class='"+f[15]+"' oncontextmenu='return false;' "+r+" />","<a href='#' class='"+f[16]+"' oncontextmenu='return false;' "+r+" />"],s=["x"===o.axis?l[2]:l[0],"x"===o.axis?l[3]:l[1],l[2],l[3]];o.scrollButtons.enable&&n.prepend(s[0]).append(s[1]).next(".mCSB_scrollTools").prepend(s[2]).append(s[3])},C=function(){var t=e(this),a=t.data(i),o=e("#mCSB_"+a.idx),n=t.css("max-height")||"none",r=-1!==n.indexOf("%"),l=t.css("box-sizing");if("none"!==n){var s=r?t.parent().height()*parseInt(n)/100:parseInt(n);"border-box"===l&&(s-=t.innerHeight()-t.height()+(t.outerHeight()-t.innerHeight())),o.css("max-height",Math.round(s))}},y=function(){var t=e(this),a=t.data(i),o=e("#mCSB_"+a.idx),n=e("#mCSB_"+a.idx+"_container"),r=[e("#mCSB_"+a.idx+"_dragger_vertical"),e("#mCSB_"+a.idx+"_dragger_horizontal")],l=[o.height()/n.outerHeight(!1),o.width()/n.outerWidth(!1)],s=[parseInt(r[0].css("min-height")),Math.round(l[0]*r[0].parent().height()),parseInt(r[1].css("min-width")),Math.round(l[1]*r[1].parent().width())],c=d&&s[1]<s[0]?s[0]:s[1],u=d&&s[3]<s[2]?s[2]:s[3];r[0].css({height:c,"max-height":r[0].parent().height()-10}).find(".mCSB_dragger_bar").css({"line-height":s[0]+"px"}),r[1].css({width:u,"max-width":r[1].parent().width()-10})},B=function(){var t=e(this),a=t.data(i),o=e("#mCSB_"+a.idx),n=e("#mCSB_"+a.idx+"_container"),r=[e("#mCSB_"+a.idx+"_dragger_vertical"),e("#mCSB_"+a.idx+"_dragger_horizontal")],l=[n.outerHeight(!1)-o.height(),n.outerWidth(!1)-o.width()],s=[l[0]/(r[0].parent().height()-r[0].height()),l[1]/(r[1].parent().width()-r[1].width())];a.scrollRatio={y:s[0],x:s[1]}},T=function(e,t,a){var o=a?f[0]+"_expanded":"",n=e.closest(".mCSB_scrollTools");"active"===t?(e.toggleClass(f[0]+" "+o),n.toggleClass(f[1]),e[0]._draggable=e[0]._draggable?0:1):e[0]._draggable||("hide"===t?(e.removeClass(f[0]),n.removeClass(f[1])):(e.addClass(f[0]),n.addClass(f[1])))},k=function(){var t=e(this),a=t.data(i),o=e("#mCSB_"+a.idx),n=e("#mCSB_"+a.idx+"_container"),r=null==a.overflowed?n.height():n.outerHeight(!1),l=null==a.overflowed?n.width():n.outerWidth(!1);return[r>o.height(),l>o.width()]},M=function(){var t=e(this),a=t.data(i),o=a.opt,n=e("#mCSB_"+a.idx),r=e("#mCSB_"+a.idx+"_container"),l=[e("#mCSB_"+a.idx+"_dragger_vertical"),e("#mCSB_"+a.idx+"_dragger_horizontal")];if(Q(t),("x"!==o.axis&&!a.overflowed[0]||"y"===o.axis&&a.overflowed[0])&&(l[0].add(r).css("top",0),G(t,"_resetY")),"y"!==o.axis&&!a.overflowed[1]||"x"===o.axis&&a.overflowed[1]){var s=dx=0;"rtl"===a.langDir&&(s=n.width()-r.outerWidth(!1),dx=Math.abs(s/a.scrollRatio.x)),r.css("left",s),l[1].css("left",dx),G(t,"_resetX")}},O=function(){function t(){r=setTimeout(function(){e.event.special.mousewheel?(clearTimeout(r),A.call(a[0])):t()},100)}var a=e(this),o=a.data(i),n=o.opt;if(!o.bindEvents){if(D.call(this),n.contentTouchScroll&&L.call(this),W.call(this),n.mouseWheel.enable){var r;t()}z.call(this),U.call(this),n.advanced.autoScrollOnFocus&&H.call(this),n.scrollButtons.enable&&F.call(this),n.keyboard.enable&&q.call(this),o.bindEvents=!0}},I=function(){var t=e(this),o=t.data(i),n=o.opt,r=i+"_"+o.idx,l=".mCSB_"+o.idx+"_scrollbar",s=e("#mCSB_"+o.idx+",#mCSB_"+o.idx+"_container,#mCSB_"+o.idx+"_container_wrapper,"+l+" ."+f[12]+",#mCSB_"+o.idx+"_dragger_vertical,#mCSB_"+o.idx+"_dragger_horizontal,"+l+">a"),c=e("#mCSB_"+o.idx+"_container");n.advanced.releaseDraggableSelectors&&s.add(e(n.advanced.releaseDraggableSelectors)),o.bindEvents&&(e(a).unbind("."+r),s.each(function(){e(this).unbind("."+r)}),clearTimeout(t[0]._focusTimeout),$(t[0],"_focusTimeout"),clearTimeout(o.sequential.step),$(o.sequential,"step"),clearTimeout(c[0].onCompleteTimeout),$(c[0],"onCompleteTimeout"),o.bindEvents=!1)},R=function(t){var a=e(this),o=a.data(i),n=o.opt,r=e("#mCSB_"+o.idx+"_container_wrapper"),l=r.length?r:e("#mCSB_"+o.idx+"_container"),s=[e("#mCSB_"+o.idx+"_scrollbar_vertical"),e("#mCSB_"+o.idx+"_scrollbar_horizontal")],c=[s[0].find(".mCSB_dragger"),s[1].find(".mCSB_dragger")];"x"!==n.axis&&(o.overflowed[0]&&!t?(s[0].add(c[0]).add(s[0].children("a")).css("display","block"),l.removeClass(f[8]+" "+f[10])):(n.alwaysShowScrollbar?(2!==n.alwaysShowScrollbar&&c[0].css("display","none"),l.removeClass(f[10])):(s[0].css("display","none"),l.addClass(f[10])),l.addClass(f[8]))),"y"!==n.axis&&(o.overflowed[1]&&!t?(s[1].add(c[1]).add(s[1].children("a")).css("display","block"),l.removeClass(f[9]+" "+f[11])):(n.alwaysShowScrollbar?(2!==n.alwaysShowScrollbar&&c[1].css("display","none"),l.removeClass(f[11])):(s[1].css("display","none"),l.addClass(f[11])),l.addClass(f[9]))),o.overflowed[0]||o.overflowed[1]?a.removeClass(f[5]):a.addClass(f[5])},E=function(e){var t=e.type;switch(t){case"pointerdown":case"MSPointerDown":case"pointermove":case"MSPointerMove":case"pointerup":case"MSPointerUp":return[e.originalEvent.pageY,e.originalEvent.pageX,!1];case"touchstart":case"touchmove":case"touchend":var a=e.originalEvent.touches[0]||e.originalEvent.changedTouches[0],o=e.originalEvent.touches.length||e.originalEvent.changedTouches.length;return[a.pageY,a.pageX,o>1];default:return[e.pageY,e.pageX,!1]}},D=function(){function t(e){var t=p.find("iframe");if(t.length){var a=e?"auto":"none";t.css("pointer-events",a)}}function o(e,t,a,o){if(p[0].idleTimer=f.scrollInertia<233?250:0,n.attr("id")===m[1])var i="x",r=(n[0].offsetLeft-t+o)*c.scrollRatio.x;else var i="y",r=(n[0].offsetTop-e+a)*c.scrollRatio.y;G(s,r.toString(),{dir:i,drag:!0})}var n,r,l,s=e(this),c=s.data(i),f=c.opt,h=i+"_"+c.idx,m=["mCSB_"+c.idx+"_dragger_vertical","mCSB_"+c.idx+"_dragger_horizontal"],p=e("#mCSB_"+c.idx+"_container"),g=e("#"+m[0]+",#"+m[1]),v=f.advanced.releaseDraggableSelectors?g.add(e(f.advanced.releaseDraggableSelectors)):g;g.bind("mousedown."+h+" touchstart."+h+" pointerdown."+h+" MSPointerDown."+h,function(o){if(o.stopImmediatePropagation(),o.preventDefault(),et(o)){u=!0,d&&(a.onselectstart=function(){return!1}),t(!1),Q(s),n=e(this);var i=n.offset(),c=E(o)[0]-i.top,h=E(o)[1]-i.left,m=n.height()+i.top,p=n.width()+i.left;m>c&&c>0&&p>h&&h>0&&(r=c,l=h),T(n,"active",f.autoExpandScrollbar)}}).bind("touchmove."+h,function(e){e.stopImmediatePropagation(),e.preventDefault();var t=n.offset(),a=E(e)[0]-t.top,i=E(e)[1]-t.left;o(r,l,a,i)}),e(a).bind("mousemove."+h+" pointermove."+h+" MSPointerMove."+h,function(e){if(n){var t=n.offset(),a=E(e)[0]-t.top,i=E(e)[1]-t.left;if(r===a)return;o(r,l,a,i)}}).add(v).bind("mouseup."+h+" touchend."+h+" pointerup."+h+" MSPointerUp."+h,function(){n&&(T(n,"active",f.autoExpandScrollbar),n=null),u=!1,d&&(a.onselectstart=null),t(!0)})},L=function(){function t(e,t){var a=[1.5*t,2*t,t/1.5,t/2];return e>90?t>4?a[0]:a[3]:e>60?t>3?a[3]:a[2]:e>30?t>8?a[1]:t>6?a[0]:t>4?t:a[2]:t>8?t:a[3]}function a(e,t,a,o,n,i){e&&G(_,e.toString(),{dur:t,scrollEasing:a,dir:o,overwrite:n,drag:i})}var n,r,l,s,c,d,f,h,m,p,g,v,x,_=e(this),S=_.data(i),w=S.opt,b=i+"_"+S.idx,C=e("#mCSB_"+S.idx),y=e("#mCSB_"+S.idx+"_container"),B=[e("#mCSB_"+S.idx+"_dragger_vertical"),e("#mCSB_"+S.idx+"_dragger_horizontal")],T=[],k=[],M=0,O="yx"===w.axis?"none":"all",I=[];y.bind("touchstart."+b+" pointerdown."+b+" MSPointerDown."+b,function(e){if(!tt(e)||u||E(e)[2])return void(o=0);o=1,v=0,x=0;var t=y.offset();n=E(e)[0]-t.top,r=E(e)[1]-t.left,I=[E(e)[0],E(e)[1]]}).bind("touchmove."+b+" pointermove."+b+" MSPointerMove."+b,function(e){if(tt(e)&&!u&&!E(e)[2]&&(e.stopImmediatePropagation(),!x||v)){d=K();var t=C.offset(),o=E(e)[0]-t.top,i=E(e)[1]-t.left,l="mcsLinearOut";if(T.push(o),k.push(i),I[2]=Math.abs(E(e)[0]-I[0]),I[3]=Math.abs(E(e)[1]-I[1]),S.overflowed[0])var s=B[0].parent().height()-B[0].height(),c=n-o>0&&o-n>-(s*S.scrollRatio.y)&&(2*I[3]<I[2]||"yx"===w.axis);if(S.overflowed[1])var f=B[1].parent().width()-B[1].width(),h=r-i>0&&i-r>-(f*S.scrollRatio.x)&&(2*I[2]<I[3]||"yx"===w.axis);c||h?(e.preventDefault(),v=1):x=1,p="yx"===w.axis?[n-o,r-i]:"x"===w.axis?[null,r-i]:[n-o,null],y[0].idleTimer=250,S.overflowed[0]&&a(p[0],M,l,"y","all",!0),S.overflowed[1]&&a(p[1],M,l,"x",O,!0)}}),C.bind("touchstart."+b+" pointerdown."+b+" MSPointerDown."+b,function(e){if(!tt(e)||u||E(e)[2])return void(o=0);o=1,e.stopImmediatePropagation(),Q(_),c=K();var t=C.offset();l=E(e)[0]-t.top,s=E(e)[1]-t.left,T=[],k=[]}).bind("touchend."+b+" pointerup."+b+" MSPointerUp."+b,function(e){if(tt(e)&&!u&&!E(e)[2]){e.stopImmediatePropagation(),v=0,x=0,f=K();var o=C.offset(),n=E(e)[0]-o.top,i=E(e)[1]-o.left;if(!(f-d>30)){m=1e3/(f-c);var r="mcsEaseOut",_=2.5>m,b=_?[T[T.length-2],k[k.length-2]]:[0,0];h=_?[n-b[0],i-b[1]]:[n-l,i-s];var B=[Math.abs(h[0]),Math.abs(h[1])];m=_?[Math.abs(h[0]/4),Math.abs(h[1]/4)]:[m,m];var M=[Math.abs(y[0].offsetTop)-h[0]*t(B[0]/m[0],m[0]),Math.abs(y[0].offsetLeft)-h[1]*t(B[1]/m[1],m[1])];p="yx"===w.axis?[M[0],M[1]]:"x"===w.axis?[null,M[1]]:[M[0],null],g=[4*B[0]+w.scrollInertia,4*B[1]+w.scrollInertia];var I=parseInt(w.contentTouchScroll)||0;p[0]=B[0]>I?p[0]:0,p[1]=B[1]>I?p[1]:0,S.overflowed[0]&&a(p[0],g[0],r,"y",O,!1),S.overflowed[1]&&a(p[1],g[1],r,"x",O,!1)}}})},W=function(){function n(){return t.getSelection?t.getSelection().toString():a.selection&&"Control"!=a.selection.type?a.selection.createRange().text:0}function r(e,t,a){f.type=a&&l?"stepped":"stepless",f.scrollAmount=10,j(s,e,t,"mcsLinearOut",a?60:null)}var l,s=e(this),c=s.data(i),d=c.opt,f=c.sequential,h=i+"_"+c.idx,m=e("#mCSB_"+c.idx+"_container"),p=m.parent();m.bind("mousedown."+h,function(){o||l||(l=1,u=!0)}).add(a).bind("mousemove."+h,function(e){if(!o&&l&&n()){var t=m.offset(),a=E(e)[0]-t.top+m[0].offsetTop,i=E(e)[1]-t.left+m[0].offsetLeft;a>0&&a<p.height()&&i>0&&i<p.width()?f.step&&r("off",null,"stepped"):("x"!==d.axis&&c.overflowed[0]&&(0>a?r("on",38):a>p.height()&&r("on",40)),"y"!==d.axis&&c.overflowed[1]&&(0>i?r("on",37):i>p.width()&&r("on",39)))}}).bind("mouseup."+h,function(){o||(l&&(l=0,r("off",null)),u=!1)})},A=function(){function t(e){var t=null;try{var a=e.contentDocument||e.contentWindow.document;t=a.body.innerHTML}catch(o){}return null!==t}var a=e(this),o=a.data(i);if(o){var n=o.opt,r=i+"_"+o.idx,l=e("#mCSB_"+o.idx),s=[e("#mCSB_"+o.idx+"_dragger_vertical"),e("#mCSB_"+o.idx+"_dragger_horizontal")],c=e("#mCSB_"+o.idx+"_container").find("iframe"),u=l;c.length&&c.each(function(){var a=this;t(a)&&(u=u.add(e(a).contents().find("body")))}),u.bind("mousewheel."+r,function(t,i){if(Q(a),!P(a,t.target)){var r="auto"!==n.mouseWheel.deltaFactor?parseInt(n.mouseWheel.deltaFactor):d&&t.deltaFactor<100?100:t.deltaFactor||100;if("x"===n.axis||"x"===n.mouseWheel.axis)var c="x",u=[Math.round(r*o.scrollRatio.x),parseInt(n.mouseWheel.scrollAmount)],f="auto"!==n.mouseWheel.scrollAmount?u[1]:u[0]>=l.width()?.9*l.width():u[0],h=Math.abs(e("#mCSB_"+o.idx+"_container")[0].offsetLeft),m=s[1][0].offsetLeft,p=s[1].parent().width()-s[1].width(),g=t.deltaX||t.deltaY||i;else var c="y",u=[Math.round(r*o.scrollRatio.y),parseInt(n.mouseWheel.scrollAmount)],f="auto"!==n.mouseWheel.scrollAmount?u[1]:u[0]>=l.height()?.9*l.height():u[0],h=Math.abs(e("#mCSB_"+o.idx+"_container")[0].offsetTop),m=s[0][0].offsetTop,p=s[0].parent().height()-s[0].height(),g=t.deltaY||i;"y"===c&&!o.overflowed[0]||"x"===c&&!o.overflowed[1]||(n.mouseWheel.invert&&(g=-g),n.mouseWheel.normalizeDelta&&(g=0>g?-1:1),(g>0&&0!==m||0>g&&m!==p||n.mouseWheel.preventDefault)&&(t.stopImmediatePropagation(),t.preventDefault()),G(a,(h-g*f).toString(),{dir:c}))}})}},P=function(t,a){var o=a.nodeName.toLowerCase(),n=t.data(i).opt.mouseWheel.disableOver,r=["select","textarea"];return e.inArray(o,n)>-1&&!(e.inArray(o,r)>-1&&!e(a).is(":focus"))},z=function(){var t=e(this),a=t.data(i),o=i+"_"+a.idx,n=e("#mCSB_"+a.idx+"_container"),r=n.parent(),l=e(".mCSB_"+a.idx+"_scrollbar ."+f[12]);l.bind("touchstart."+o+" pointerdown."+o+" MSPointerDown."+o,function(){u=!0}).bind("touchend."+o+" pointerup."+o+" MSPointerUp."+o,function(){u=!1}).bind("click."+o,function(o){if(e(o.target).hasClass(f[12])||e(o.target).hasClass("mCSB_draggerRail")){Q(t);var i=e(this),l=i.find(".mCSB_dragger");if(i.parent(".mCSB_scrollTools_horizontal").length>0){if(!a.overflowed[1])return;var s="x",c=o.pageX>l.offset().left?-1:1,d=Math.abs(n[0].offsetLeft)-.9*c*r.width()}else{if(!a.overflowed[0])return;var s="y",c=o.pageY>l.offset().top?-1:1,d=Math.abs(n[0].offsetTop)-.9*c*r.height()}G(t,d.toString(),{dir:s,scrollEasing:"mcsEaseInOut"})}})},H=function(){var t=e(this),o=t.data(i),n=o.opt,r=i+"_"+o.idx,l=e("#mCSB_"+o.idx+"_container"),s=l.parent();l.bind("focusin."+r,function(){var o=e(a.activeElement),i=l.find(".mCustomScrollBox").length,r=0;o.is(n.advanced.autoScrollOnFocus)&&(Q(t),clearTimeout(t[0]._focusTimeout),t[0]._focusTimer=i?(r+17)*i:0,t[0]._focusTimeout=setTimeout(function(){var e=[ot(o)[0],ot(o)[1]],a=[l[0].offsetTop,l[0].offsetLeft],i=[a[0]+e[0]>=0&&a[0]+e[0]<s.height()-o.outerHeight(!1),a[1]+e[1]>=0&&a[0]+e[1]<s.width()-o.outerWidth(!1)],c="yx"!==n.axis||i[0]||i[1]?"all":"none";"x"===n.axis||i[0]||G(t,e[0].toString(),{dir:"y",scrollEasing:"mcsEaseInOut",overwrite:c,dur:r}),"y"===n.axis||i[1]||G(t,e[1].toString(),{dir:"x",scrollEasing:"mcsEaseInOut",overwrite:c,dur:r})},t[0]._focusTimer))})},U=function(){var t=e(this),a=t.data(i),o=i+"_"+a.idx,n=e("#mCSB_"+a.idx+"_container").parent();n.bind("scroll."+o,function(){(0!==n.scrollTop()||0!==n.scrollLeft())&&e(".mCSB_"+a.idx+"_scrollbar").css("visibility","hidden")})},F=function(){var t=e(this),a=t.data(i),o=a.opt,n=a.sequential,r=i+"_"+a.idx,l=".mCSB_"+a.idx+"_scrollbar",s=e(l+">a");s.bind("mousedown."+r+" touchstart."+r+" pointerdown."+r+" MSPointerDown."+r+" mouseup."+r+" touchend."+r+" pointerup."+r+" MSPointerUp."+r+" mouseout."+r+" pointerout."+r+" MSPointerOut."+r+" click."+r,function(i){function r(e,a){n.scrollAmount=o.snapAmount||o.scrollButtons.scrollAmount,j(t,e,a)}if(i.preventDefault(),et(i)){var l=e(this).attr("class");switch(n.type=o.scrollButtons.scrollType,i.type){case"mousedown":case"touchstart":case"pointerdown":case"MSPointerDown":if("stepped"===n.type)return;u=!0,a.tweenRunning=!1,r("on",l);break;case"mouseup":case"touchend":case"pointerup":case"MSPointerUp":case"mouseout":case"pointerout":case"MSPointerOut":if("stepped"===n.type)return;u=!1,n.dir&&r("off",l);break;case"click":if("stepped"!==n.type||a.tweenRunning)return;r("on",l)}}})},q=function(){var t=e(this),o=t.data(i),n=o.opt,r=o.sequential,l=i+"_"+o.idx,s=e("#mCSB_"+o.idx),c=e("#mCSB_"+o.idx+"_container"),d=c.parent(),u="input,textarea,select,datalist,keygen,[contenteditable='true']";s.attr("tabindex","0").bind("blur."+l+" keydown."+l+" keyup."+l,function(i){function l(e,a){r.type=n.keyboard.scrollType,r.scrollAmount=n.snapAmount||n.keyboard.scrollAmount,"stepped"===r.type&&o.tweenRunning||j(t,e,a)}switch(i.type){case"blur":o.tweenRunning&&r.dir&&l("off",null);break;case"keydown":case"keyup":var s=i.keyCode?i.keyCode:i.which,f="on";if("x"!==n.axis&&(38===s||40===s)||"y"!==n.axis&&(37===s||39===s)){if((38===s||40===s)&&!o.overflowed[0]||(37===s||39===s)&&!o.overflowed[1])return;"keyup"===i.type&&(f="off"),e(a.activeElement).is(u)||(i.preventDefault(),i.stopImmediatePropagation(),l(f,s))}else if(33===s||34===s){if((o.overflowed[0]||o.overflowed[1])&&(i.preventDefault(),i.stopImmediatePropagation()),"keyup"===i.type){Q(t);var h=34===s?-1:1;if("x"===n.axis||"yx"===n.axis&&o.overflowed[1]&&!o.overflowed[0])var m="x",p=Math.abs(c[0].offsetLeft)-.9*h*d.width();else var m="y",p=Math.abs(c[0].offsetTop)-.9*h*d.height();G(t,p.toString(),{dir:m,scrollEasing:"mcsEaseInOut"})}}else if((35===s||36===s)&&!e(a.activeElement).is(u)&&((o.overflowed[0]||o.overflowed[1])&&(i.preventDefault(),i.stopImmediatePropagation()),"keyup"===i.type)){if("x"===n.axis||"yx"===n.axis&&o.overflowed[1]&&!o.overflowed[0])var m="x",p=35===s?Math.abs(d.width()-c.outerWidth(!1)):0;else var m="y",p=35===s?Math.abs(d.height()-c.outerHeight(!1)):0;G(t,p.toString(),{dir:m,scrollEasing:"mcsEaseInOut"})}}})},j=function(t,a,o,n,r){function l(e){var a="stepped"!==u.type,o=r?r:e?a?p/1.5:g:1e3/60,i=e?a?7.5:40:2.5,s=[Math.abs(h[0].offsetTop),Math.abs(h[0].offsetLeft)],d=[c.scrollRatio.y>10?10:c.scrollRatio.y,c.scrollRatio.x>10?10:c.scrollRatio.x],f="x"===u.dir[0]?s[1]+u.dir[1]*d[1]*i:s[0]+u.dir[1]*d[0]*i,m="x"===u.dir[0]?s[1]+u.dir[1]*parseInt(u.scrollAmount):s[0]+u.dir[1]*parseInt(u.scrollAmount),v="auto"!==u.scrollAmount?m:f,x=n?n:e?a?"mcsLinearOut":"mcsEaseInOut":"mcsLinear",_=e?!0:!1;return e&&17>o&&(v="x"===u.dir[0]?s[1]:s[0]),G(t,v.toString(),{dir:u.dir[0],scrollEasing:x,dur:o,onComplete:_}),e?void(u.dir=!1):(clearTimeout(u.step),void(u.step=setTimeout(function(){l()},o)))}function s(){clearTimeout(u.step),$(u,"step"),Q(t)}var c=t.data(i),d=c.opt,u=c.sequential,h=e("#mCSB_"+c.idx+"_container"),m="stepped"===u.type?!0:!1,p=d.scrollInertia<26?26:d.scrollInertia,g=d.scrollInertia<1?17:d.scrollInertia;switch(a){case"on":if(u.dir=[o===f[16]||o===f[15]||39===o||37===o?"x":"y",o===f[13]||o===f[15]||38===o||37===o?-1:1],Q(t),at(o)&&"stepped"===u.type)return;l(m);break;case"off":s(),(m||c.tweenRunning&&u.dir)&&l(!0)}},Y=function(t){var a=e(this).data(i).opt,o=[];return"function"==typeof t&&(t=t()),t instanceof Array?o=t.length>1?[t[0],t[1]]:"x"===a.axis?[null,t[0]]:[t[0],null]:(o[0]=t.y?t.y:t.x||"x"===a.axis?null:t,o[1]=t.x?t.x:t.y||"y"===a.axis?null:t),"function"==typeof o[0]&&(o[0]=o[0]()),"function"==typeof o[1]&&(o[1]=o[1]()),o},X=function(t,a){if(null!=t&&"undefined"!=typeof t){var o=e(this),n=o.data(i),r=n.opt,l=e("#mCSB_"+n.idx+"_container"),s=l.parent(),c=typeof t;a||(a="x"===r.axis?"x":"y");var d="x"===a?l.outerWidth(!1):l.outerHeight(!1),u="x"===a?l[0].offsetLeft:l[0].offsetTop,f="x"===a?"left":"top";switch(c){case"function":return t();case"object":var m=t.jquery?t:e(t);if(!m.length)return;return"x"===a?ot(m)[1]:ot(m)[0];case"string":case"number":if(at(t))return Math.abs(t);if(-1!==t.indexOf("%"))return Math.abs(d*parseInt(t)/100);if(-1!==t.indexOf("-="))return Math.abs(u-parseInt(t.split("-=")[1]));if(-1!==t.indexOf("+=")){var p=u+parseInt(t.split("+=")[1]);return p>=0?0:Math.abs(p)}if(-1!==t.indexOf("px")&&at(t.split("px")[0]))return Math.abs(t.split("px")[0]);if("top"===t||"left"===t)return 0;if("bottom"===t)return Math.abs(s.height()-l.outerHeight(!1));if("right"===t)return Math.abs(s.width()-l.outerWidth(!1));if("first"===t||"last"===t){var m=l.find(":"+t);return"x"===a?ot(m)[1]:ot(m)[0]}return e(t).length?"x"===a?ot(e(t))[1]:ot(e(t))[0]:(l.css(f,t),void h.update.call(null,o[0]))}}},N=function(t){function a(){clearTimeout(u[0].autoUpdate),u[0].autoUpdate=setTimeout(function(){return d.advanced.updateOnSelectorChange&&(m=r(),m!==S)?(l(3),void(S=m)):(d.advanced.updateOnContentResize&&(p=[u.outerHeight(!1),u.outerWidth(!1),v.height(),v.width(),_()[0],_()[1]],(p[0]!==w[0]||p[1]!==w[1]||p[2]!==w[2]||p[3]!==w[3]||p[4]!==w[4]||p[5]!==w[5])&&(l(p[0]!==w[0]||p[1]!==w[1]),w=p)),d.advanced.updateOnImageLoad&&(g=o(),g!==b&&(u.find("img").each(function(){n(this)}),b=g)),void((d.advanced.updateOnSelectorChange||d.advanced.updateOnContentResize||d.advanced.updateOnImageLoad)&&a()))},60)}function o(){var e=0;return d.advanced.updateOnImageLoad&&(e=u.find("img").length),e}function n(t){function a(e,t){return function(){return t.apply(e,arguments)}}function o(){this.onload=null,e(t).addClass(f[2]),l(2)}if(e(t).hasClass(f[2]))return void l();var n=new Image;n.onload=a(n,o),n.src=t.src}function r(){d.advanced.updateOnSelectorChange===!0&&(d.advanced.updateOnSelectorChange="*");var t=0,a=u.find(d.advanced.updateOnSelectorChange);return d.advanced.updateOnSelectorChange&&a.length>0&&a.each(function(){t+=e(this).height()+e(this).width()}),t}function l(e){clearTimeout(u[0].autoUpdate),h.update.call(null,s[0],e)}var s=e(this),c=s.data(i),d=c.opt,u=e("#mCSB_"+c.idx+"_container");if(t)return clearTimeout(u[0].autoUpdate),void $(u[0],"autoUpdate");var m,p,g,v=u.parent(),x=[e("#mCSB_"+c.idx+"_scrollbar_vertical"),e("#mCSB_"+c.idx+"_scrollbar_horizontal")],_=function(){return[x[0].is(":visible")?x[0].outerHeight(!0):0,x[1].is(":visible")?x[1].outerWidth(!0):0]},S=r(),w=[u.outerHeight(!1),u.outerWidth(!1),v.height(),v.width(),_()[0],_()[1]],b=o();a()},V=function(e,t,a){return Math.round(e/t)*t-a},Q=function(t){var a=t.data(i),o=e("#mCSB_"+a.idx+"_container,#mCSB_"+a.idx+"_container_wrapper,#mCSB_"+a.idx+"_dragger_vertical,#mCSB_"+a.idx+"_dragger_horizontal");o.each(function(){Z.call(this)})},G=function(t,a,o){function n(e){return s&&c.callbacks[e]&&"function"==typeof c.callbacks[e]}function r(){return[c.callbacks.alwaysTriggerOffsets||_>=S[0]+b,c.callbacks.alwaysTriggerOffsets||-C>=_]}function l(){var e=[h[0].offsetTop,h[0].offsetLeft],a=[v[0].offsetTop,v[0].offsetLeft],n=[h.outerHeight(!1),h.outerWidth(!1)],i=[f.height(),f.width()];t[0].mcs={content:h,top:e[0],left:e[1],draggerTop:a[0],draggerLeft:a[1],topPct:Math.round(100*Math.abs(e[0])/(Math.abs(n[0])-i[0])),leftPct:Math.round(100*Math.abs(e[1])/(Math.abs(n[1])-i[1])),direction:o.dir}}var s=t.data(i),c=s.opt,d={trigger:"internal",dir:"y",scrollEasing:"mcsEaseOut",drag:!1,dur:c.scrollInertia,overwrite:"all",callbacks:!0,onStart:!0,onUpdate:!0,onComplete:!0},o=e.extend(d,o),u=[o.dur,o.drag?0:o.dur],f=e("#mCSB_"+s.idx),h=e("#mCSB_"+s.idx+"_container"),m=h.parent(),p=c.callbacks.onTotalScrollOffset?Y.call(t,c.callbacks.onTotalScrollOffset):[0,0],g=c.callbacks.onTotalScrollBackOffset?Y.call(t,c.callbacks.onTotalScrollBackOffset):[0,0];if(s.trigger=o.trigger,(0!==m.scrollTop()||0!==m.scrollLeft())&&(e(".mCSB_"+s.idx+"_scrollbar").css("visibility","visible"),m.scrollTop(0).scrollLeft(0)),"_resetY"!==a||s.contentReset.y||(n("onOverflowYNone")&&c.callbacks.onOverflowYNone.call(t[0]),s.contentReset.y=1),"_resetX"!==a||s.contentReset.x||(n("onOverflowXNone")&&c.callbacks.onOverflowXNone.call(t[0]),s.contentReset.x=1),"_resetY"!==a&&"_resetX"!==a){switch(!s.contentReset.y&&t[0].mcs||!s.overflowed[0]||(n("onOverflowY")&&c.callbacks.onOverflowY.call(t[0]),s.contentReset.x=null),!s.contentReset.x&&t[0].mcs||!s.overflowed[1]||(n("onOverflowX")&&c.callbacks.onOverflowX.call(t[0]),s.contentReset.x=null),c.snapAmount&&(a=V(a,c.snapAmount,c.snapOffset)),o.dir){case"x":var v=e("#mCSB_"+s.idx+"_dragger_horizontal"),x="left",_=h[0].offsetLeft,S=[f.width()-h.outerWidth(!1),v.parent().width()-v.width()],w=[a,0===a?0:a/s.scrollRatio.x],b=p[1],C=g[1],y=b>0?b/s.scrollRatio.x:0,B=C>0?C/s.scrollRatio.x:0;
break;case"y":var v=e("#mCSB_"+s.idx+"_dragger_vertical"),x="top",_=h[0].offsetTop,S=[f.height()-h.outerHeight(!1),v.parent().height()-v.height()],w=[a,0===a?0:a/s.scrollRatio.y],b=p[0],C=g[0],y=b>0?b/s.scrollRatio.y:0,B=C>0?C/s.scrollRatio.y:0}w[1]<0||0===w[0]&&0===w[1]?w=[0,0]:w[1]>=S[1]?w=[S[0],S[1]]:w[0]=-w[0],t[0].mcs||(l(),n("onInit")&&c.callbacks.onInit.call(t[0])),clearTimeout(h[0].onCompleteTimeout),(s.tweenRunning||!(0===_&&w[0]>=0||_===S[0]&&w[0]<=S[0]))&&(J(v[0],x,Math.round(w[1]),u[1],o.scrollEasing),J(h[0],x,Math.round(w[0]),u[0],o.scrollEasing,o.overwrite,{onStart:function(){o.callbacks&&o.onStart&&!s.tweenRunning&&(n("onScrollStart")&&(l(),c.callbacks.onScrollStart.call(t[0])),s.tweenRunning=!0,T(v),s.cbOffsets=r())},onUpdate:function(){o.callbacks&&o.onUpdate&&n("whileScrolling")&&(l(),c.callbacks.whileScrolling.call(t[0]))},onComplete:function(){if(o.callbacks&&o.onComplete){"yx"===c.axis&&clearTimeout(h[0].onCompleteTimeout);var e=h[0].idleTimer||0;h[0].onCompleteTimeout=setTimeout(function(){n("onScroll")&&(l(),c.callbacks.onScroll.call(t[0])),n("onTotalScroll")&&w[1]>=S[1]-y&&s.cbOffsets[0]&&(l(),c.callbacks.onTotalScroll.call(t[0])),n("onTotalScrollBack")&&w[1]<=B&&s.cbOffsets[1]&&(l(),c.callbacks.onTotalScrollBack.call(t[0])),s.tweenRunning=!1,h[0].idleTimer=0,T(v,"hide")},e)}}}))}},J=function(e,a,o,n,i,r,l){function s(){b.stop||(_||p.call(),_=K()-x,c(),_>=b.time&&(b.time=_>b.time?_+h-(_-b.time):_+h-1,b.time<_+1&&(b.time=_+1)),b.time<n?b.id=m(s):v.call())}function c(){n>0?(b.currVal=f(b.time,S,C,n,i),w[a]=Math.round(b.currVal)+"px"):w[a]=o+"px",g.call()}function d(){h=1e3/60,b.time=_+h,m=t.requestAnimationFrame?t.requestAnimationFrame:function(e){return c(),setTimeout(e,.01)},b.id=m(s)}function u(){null!=b.id&&(t.requestAnimationFrame?t.cancelAnimationFrame(b.id):clearTimeout(b.id),b.id=null)}function f(e,t,a,o,n){switch(n){case"linear":case"mcsLinear":return a*e/o+t;case"mcsLinearOut":return e/=o,e--,a*Math.sqrt(1-e*e)+t;case"easeInOutSmooth":return e/=o/2,1>e?a/2*e*e+t:(e--,-a/2*(e*(e-2)-1)+t);case"easeInOutStrong":return e/=o/2,1>e?a/2*Math.pow(2,10*(e-1))+t:(e--,a/2*(-Math.pow(2,-10*e)+2)+t);case"easeInOut":case"mcsEaseInOut":return e/=o/2,1>e?a/2*e*e*e+t:(e-=2,a/2*(e*e*e+2)+t);case"easeOutSmooth":return e/=o,e--,-a*(e*e*e*e-1)+t;case"easeOutStrong":return a*(-Math.pow(2,-10*e/o)+1)+t;case"easeOut":case"mcsEaseOut":default:var i=(e/=o)*e,r=i*e;return t+a*(.499999999999997*r*i+-2.5*i*i+5.5*r+-6.5*i+4*e)}}e._mTween||(e._mTween={top:{},left:{}});var h,m,l=l||{},p=l.onStart||function(){},g=l.onUpdate||function(){},v=l.onComplete||function(){},x=K(),_=0,S=e.offsetTop,w=e.style,b=e._mTween[a];"left"===a&&(S=e.offsetLeft);var C=o-S;b.stop=0,"none"!==r&&u(),d()},K=function(){return t.performance&&t.performance.now?t.performance.now():t.performance&&t.performance.webkitNow?t.performance.webkitNow():Date.now?Date.now():(new Date).getTime()},Z=function(){var e=this;e._mTween||(e._mTween={top:{},left:{}});for(var a=["top","left"],o=0;o<a.length;o++){var n=a[o];e._mTween[n].id&&(t.requestAnimationFrame?t.cancelAnimationFrame(e._mTween[n].id):clearTimeout(e._mTween[n].id),e._mTween[n].id=null,e._mTween[n].stop=1)}},$=function(e,t){try{delete e[t]}catch(a){e[t]=null}},et=function(e){return!(e.which&&1!==e.which)},tt=function(e){var t=e.originalEvent.pointerType;return!(t&&"touch"!==t&&2!==t)},at=function(e){return!isNaN(parseFloat(e))&&isFinite(e)},ot=function(e){var t=e.parents(".mCSB_container");return[e.offset().top-t.offset().top,e.offset().left-t.offset().left]};e.fn[n]=function(t){return h[t]?h[t].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof t&&t?void e.error("Method "+t+" does not exist"):h.init.apply(this,arguments)},e[n]=function(t){return h[t]?h[t].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof t&&t?void e.error("Method "+t+" does not exist"):h.init.apply(this,arguments)},e[n].defaults=l,t[n]=!0,e(t).load(function(){e(r)[n](),e.extend(e.expr[":"],{mcsInView:e.expr[":"].mcsInView||function(t){var a,o,n=e(t),i=n.parents(".mCSB_container");if(i.length)return a=i.parent(),o=[i[0].offsetTop,i[0].offsetLeft],o[0]+ot(n)[0]>=0&&o[0]+ot(n)[0]<a.height()-n.outerHeight(!1)&&o[1]+ot(n)[1]>=0&&o[1]+ot(n)[1]<a.width()-n.outerWidth(!1)},mcsOverflow:e.expr[":"].mcsOverflow||function(t){var a=e(t).data(i);if(a)return a.overflowed[0]||a.overflowed[1]}})})})}(jQuery,window,document);
/**
* simplePagination.js v1.6
* A simple jQuery pagination plugin.
* http://flaviusmatis.github.com/simplePagination.js/
*
* Copyright 2012, Flavius Matis
* Released under the MIT license.
* http://flaviusmatis.github.com/license.html
*/

(function($){

	var methods = {
		init: function(options) {
			var o = $.extend({
				items: 1,
				itemsOnPage: 1,
				pages: 0,
				displayedPages: 5,
				edges: 2,
				currentPage: 0,
				hrefTextPrefix: '#page-',
				hrefTextSuffix: '',
				prevText: 'Prev',
				nextText: 'Next',
				ellipseText: '&hellip;',
				cssStyle: 'light-theme',
				labelMap: [],
				selectOnClick: true,
				nextAtFront: false,
				invertPageOrder: false,
				onPageClick: function(pageNumber, event) {
					// Callback triggered when a page is clicked
					// Page number is given as an optional parameter
				},
				onInit: function() {
					// Callback triggered immediately after initialization
				}
			}, options || {});

			var self = this;

			o.pages = o.pages ? o.pages : Math.ceil(o.items / o.itemsOnPage) ? Math.ceil(o.items / o.itemsOnPage) : 1;
			if (o.currentPage)
				o.currentPage = o.currentPage - 1;
			else
				o.currentPage = !o.invertPageOrder ? 0 : o.pages - 1;
			o.halfDisplayed = o.displayedPages / 2;

			this.each(function() {
				self.addClass(o.cssStyle + ' simple-pagination').data('pagination', o);
				methods._draw.call(self);
			});

			o.onInit();

			return this;
		},

		selectPage: function(page) {
			methods._selectPage.call(this, page - 1);
			return this;
		},

		prevPage: function() {
			var o = this.data('pagination');
			if (!o.invertPageOrder) {
				if (o.currentPage > 0) {
					methods._selectPage.call(this, o.currentPage - 1);
				}
			} else {
				if (o.currentPage < o.pages - 1) {
					methods._selectPage.call(this, o.currentPage + 1);
				}
			}
			return this;
		},

		nextPage: function() {
			var o = this.data('pagination');
			if (!o.invertPageOrder) {
				if (o.currentPage < o.pages - 1) {
					methods._selectPage.call(this, o.currentPage + 1);
				}
			} else {
				if (o.currentPage > 0) {
					methods._selectPage.call(this, o.currentPage - 1);
				}
			}
			return this;
		},

		getPagesCount: function() {
			return this.data('pagination').pages;
		},

		getCurrentPage: function () {
			return this.data('pagination').currentPage + 1;
		},

		destroy: function(){
			this.empty();
			return this;
		},

		drawPage: function (page) {
			var o = this.data('pagination');
			o.currentPage = page - 1;
			this.data('pagination', o);
			methods._draw.call(this);
			return this;
		},

		redraw: function(){
			methods._draw.call(this);
			return this;
		},

		disable: function(){
			var o = this.data('pagination');
			o.disabled = true;
			this.data('pagination', o);
			methods._draw.call(this);
			return this;
		},

		enable: function(){
			var o = this.data('pagination');
			o.disabled = false;
			this.data('pagination', o);
			methods._draw.call(this);
			return this;
		},

		updateItems: function (newItems) {
			var o = this.data('pagination');
			o.items = newItems;
			o.pages = methods._getPages(o);
			this.data('pagination', o);
			methods._draw.call(this);
		},

		updateItemsOnPage: function (itemsOnPage) {
			var o = this.data('pagination');
			o.itemsOnPage = itemsOnPage;
			o.pages = methods._getPages(o);
			this.data('pagination', o);
			methods._selectPage.call(this, 0);
			return this;
		},

		_draw: function() {
			var	o = this.data('pagination'),
				interval = methods._getInterval(o),
				i,
				tagName;

			methods.destroy.call(this);
			
			tagName = (typeof this.prop === 'function') ? this.prop('tagName') : this.attr('tagName');

			var $panel = tagName === 'UL' ? this : $('<ul></ul>').appendTo(this);

			// Generate Prev link
			if (o.prevText) {
				methods._appendItem.call(this, !o.invertPageOrder ? o.currentPage - 1 : o.currentPage + 1, {text: o.prevText, classes: 'prev'});
			}

			// Generate Next link (if option set for at front)
			if (o.nextText && o.nextAtFront) {
				methods._appendItem.call(this, !o.invertPageOrder ? o.currentPage + 1 : o.currentPage - 1, {text: o.nextText, classes: 'next'});
			}

			// Generate start edges
			if (!o.invertPageOrder) {
				if (interval.start > 0 && o.edges > 0) {
					var end = Math.min(o.edges, interval.start);
					for (i = 0; i < end; i++) {
						methods._appendItem.call(this, i);
					}
					if (o.edges < interval.start && (interval.start - o.edges != 1)) {
						$panel.append('<li class="disabled"><span class="ellipse">' + o.ellipseText + '</span></li>');
					} else if (interval.start - o.edges == 1) {
						methods._appendItem.call(this, o.edges);
					}
				}
			} else {
				if (interval.end < o.pages && o.edges > 0) {
					var begin = Math.max(o.pages - o.edges, interval.end);
					for (i = o.pages - 1; i >= begin; i--) {
						methods._appendItem.call(this, i);
					}
					if (o.pages - o.edges > interval.end && (o.pages - o.edges - interval.end != 1)) {
						$panel.append('<li class="disabled"><span class="ellipse">' + o.ellipseText + '</span></li>');
					} else if (o.pages - o.edges - interval.end == 1) {
						methods._appendItem.call(this, interval.end);
					}
				}
			}

			// Generate interval links
			if (!o.invertPageOrder) {
				for (i = interval.start; i < interval.end; i++) {
					methods._appendItem.call(this, i);
				}
			} else {
				for (i = interval.end - 1; i >= interval.start; i--) {
					methods._appendItem.call(this, i);
				}
			}

			// Generate end edges
			if (!o.invertPageOrder) {
				if (interval.end < o.pages && o.edges > 0) {
					if (o.pages - o.edges > interval.end && (o.pages - o.edges - interval.end != 1)) {
						$panel.append('<li class="disabled"><span class="ellipse">' + o.ellipseText + '</span></li>');
					} else if (o.pages - o.edges - interval.end == 1) {
						methods._appendItem.call(this, interval.end);
					}
					var begin = Math.max(o.pages - o.edges, interval.end);
					for (i = begin; i < o.pages; i++) {
						methods._appendItem.call(this, i);
					}
				}
			} else {
				if (interval.start > 0 && o.edges > 0) {
					if (o.edges < interval.start && (interval.start - o.edges != 1)) {
						$panel.append('<li class="disabled"><span class="ellipse">' + o.ellipseText + '</span></li>');
					} else if (interval.start - o.edges == 1) {
						methods._appendItem.call(this, o.edges);
					}
					var end = Math.min(o.edges, interval.start);
					for (i = end - 1; i >= 0; i--) {
						methods._appendItem.call(this, i);
					}
				}
			}

			// Generate Next link (unless option is set for at front)
			if (o.nextText && !o.nextAtFront) {
				methods._appendItem.call(this, !o.invertPageOrder ? o.currentPage + 1 : o.currentPage - 1, {text: o.nextText, classes: 'next'});
			}
		},

		_getPages: function(o) {
			var pages = Math.ceil(o.items / o.itemsOnPage);
			return pages || 1;
		},

		_getInterval: function(o) {
			return {
				start: Math.ceil(o.currentPage > o.halfDisplayed ? Math.max(Math.min(o.currentPage - o.halfDisplayed, (o.pages - o.displayedPages)), 0) : 0),
				end: Math.ceil(o.currentPage > o.halfDisplayed ? Math.min(o.currentPage + o.halfDisplayed, o.pages) : Math.min(o.displayedPages, o.pages))
			};
		},

		_appendItem: function(pageIndex, opts) {
			var self = this, options, $link, o = self.data('pagination'), $linkWrapper = $('<li></li>'), $ul = self.find('ul');

			pageIndex = pageIndex < 0 ? 0 : (pageIndex < o.pages ? pageIndex : o.pages - 1);

			options = {
				text: pageIndex + 1,
				classes: ''
			};

			if (o.labelMap.length && o.labelMap[pageIndex]) {
				options.text = o.labelMap[pageIndex];
			}

			options = $.extend(options, opts || {});

			if (pageIndex == o.currentPage || o.disabled) {
				if (o.disabled) {
					$linkWrapper.addClass('disabled');
				} else {
					$linkWrapper.addClass('active');
				}
				$link = $('<span class="current">' + (options.text) + '</span>');
			} else {
				$link = $('<a href="' + o.hrefTextPrefix + (pageIndex + 1) + o.hrefTextSuffix + '" class="page-link">' + (options.text) + '</a>');
				$link.click(function(event){
					return methods._selectPage.call(self, pageIndex, event);
				});
			}

			if (options.classes) {
				$link.addClass(options.classes);
			}

			$linkWrapper.append($link);

			if ($ul.length) {
				$ul.append($linkWrapper);
			} else {
				self.append($linkWrapper);
			}
		},

		_selectPage: function(pageIndex, event) {
			var o = this.data('pagination');
			o.currentPage = pageIndex;
			if (o.selectOnClick) {
				methods._draw.call(this);
			}
			return o.onPageClick(pageIndex + 1, event);
		}

	};

	$.fn.pagination = function(method) {

		// Method calling logic
		if (methods[method] && method.charAt(0) != '_') {
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof method === 'object' || !method) {
			return methods.init.apply(this, arguments);
		} else {
			$.error('Method ' +  method + ' does not exist on jQuery.pagination');
		}

	};

})(jQuery);

/*! Hammer.JS - v2.0.4 - 2014-09-28
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2014 Jorik Tangelder;
 * Licensed under the MIT license */
!function(a,b,c,d){"use strict";function e(a,b,c){return setTimeout(k(a,c),b)}function f(a,b,c){return Array.isArray(a)?(g(a,c[b],c),!0):!1}function g(a,b,c){var e;if(a)if(a.forEach)a.forEach(b,c);else if(a.length!==d)for(e=0;e<a.length;)b.call(c,a[e],e,a),e++;else for(e in a)a.hasOwnProperty(e)&&b.call(c,a[e],e,a)}function h(a,b,c){for(var e=Object.keys(b),f=0;f<e.length;)(!c||c&&a[e[f]]===d)&&(a[e[f]]=b[e[f]]),f++;return a}function i(a,b){return h(a,b,!0)}function j(a,b,c){var d,e=b.prototype;d=a.prototype=Object.create(e),d.constructor=a,d._super=e,c&&h(d,c)}function k(a,b){return function(){return a.apply(b,arguments)}}function l(a,b){return typeof a==kb?a.apply(b?b[0]||d:d,b):a}function m(a,b){return a===d?b:a}function n(a,b,c){g(r(b),function(b){a.addEventListener(b,c,!1)})}function o(a,b,c){g(r(b),function(b){a.removeEventListener(b,c,!1)})}function p(a,b){for(;a;){if(a==b)return!0;a=a.parentNode}return!1}function q(a,b){return a.indexOf(b)>-1}function r(a){return a.trim().split(/\s+/g)}function s(a,b,c){if(a.indexOf&&!c)return a.indexOf(b);for(var d=0;d<a.length;){if(c&&a[d][c]==b||!c&&a[d]===b)return d;d++}return-1}function t(a){return Array.prototype.slice.call(a,0)}function u(a,b,c){for(var d=[],e=[],f=0;f<a.length;){var g=b?a[f][b]:a[f];s(e,g)<0&&d.push(a[f]),e[f]=g,f++}return c&&(d=b?d.sort(function(a,c){return a[b]>c[b]}):d.sort()),d}function v(a,b){for(var c,e,f=b[0].toUpperCase()+b.slice(1),g=0;g<ib.length;){if(c=ib[g],e=c?c+f:b,e in a)return e;g++}return d}function w(){return ob++}function x(a){var b=a.ownerDocument;return b.defaultView||b.parentWindow}function y(a,b){var c=this;this.manager=a,this.callback=b,this.element=a.element,this.target=a.options.inputTarget,this.domHandler=function(b){l(a.options.enable,[a])&&c.handler(b)},this.init()}function z(a){var b,c=a.options.inputClass;return new(b=c?c:rb?N:sb?Q:qb?S:M)(a,A)}function A(a,b,c){var d=c.pointers.length,e=c.changedPointers.length,f=b&yb&&d-e===0,g=b&(Ab|Bb)&&d-e===0;c.isFirst=!!f,c.isFinal=!!g,f&&(a.session={}),c.eventType=b,B(a,c),a.emit("hammer.input",c),a.recognize(c),a.session.prevInput=c}function B(a,b){var c=a.session,d=b.pointers,e=d.length;c.firstInput||(c.firstInput=E(b)),e>1&&!c.firstMultiple?c.firstMultiple=E(b):1===e&&(c.firstMultiple=!1);var f=c.firstInput,g=c.firstMultiple,h=g?g.center:f.center,i=b.center=F(d);b.timeStamp=nb(),b.deltaTime=b.timeStamp-f.timeStamp,b.angle=J(h,i),b.distance=I(h,i),C(c,b),b.offsetDirection=H(b.deltaX,b.deltaY),b.scale=g?L(g.pointers,d):1,b.rotation=g?K(g.pointers,d):0,D(c,b);var j=a.element;p(b.srcEvent.target,j)&&(j=b.srcEvent.target),b.target=j}function C(a,b){var c=b.center,d=a.offsetDelta||{},e=a.prevDelta||{},f=a.prevInput||{};(b.eventType===yb||f.eventType===Ab)&&(e=a.prevDelta={x:f.deltaX||0,y:f.deltaY||0},d=a.offsetDelta={x:c.x,y:c.y}),b.deltaX=e.x+(c.x-d.x),b.deltaY=e.y+(c.y-d.y)}function D(a,b){var c,e,f,g,h=a.lastInterval||b,i=b.timeStamp-h.timeStamp;if(b.eventType!=Bb&&(i>xb||h.velocity===d)){var j=h.deltaX-b.deltaX,k=h.deltaY-b.deltaY,l=G(i,j,k);e=l.x,f=l.y,c=mb(l.x)>mb(l.y)?l.x:l.y,g=H(j,k),a.lastInterval=b}else c=h.velocity,e=h.velocityX,f=h.velocityY,g=h.direction;b.velocity=c,b.velocityX=e,b.velocityY=f,b.direction=g}function E(a){for(var b=[],c=0;c<a.pointers.length;)b[c]={clientX:lb(a.pointers[c].clientX),clientY:lb(a.pointers[c].clientY)},c++;return{timeStamp:nb(),pointers:b,center:F(b),deltaX:a.deltaX,deltaY:a.deltaY}}function F(a){var b=a.length;if(1===b)return{x:lb(a[0].clientX),y:lb(a[0].clientY)};for(var c=0,d=0,e=0;b>e;)c+=a[e].clientX,d+=a[e].clientY,e++;return{x:lb(c/b),y:lb(d/b)}}function G(a,b,c){return{x:b/a||0,y:c/a||0}}function H(a,b){return a===b?Cb:mb(a)>=mb(b)?a>0?Db:Eb:b>0?Fb:Gb}function I(a,b,c){c||(c=Kb);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return Math.sqrt(d*d+e*e)}function J(a,b,c){c||(c=Kb);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return 180*Math.atan2(e,d)/Math.PI}function K(a,b){return J(b[1],b[0],Lb)-J(a[1],a[0],Lb)}function L(a,b){return I(b[0],b[1],Lb)/I(a[0],a[1],Lb)}function M(){this.evEl=Nb,this.evWin=Ob,this.allow=!0,this.pressed=!1,y.apply(this,arguments)}function N(){this.evEl=Rb,this.evWin=Sb,y.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function O(){this.evTarget=Ub,this.evWin=Vb,this.started=!1,y.apply(this,arguments)}function P(a,b){var c=t(a.touches),d=t(a.changedTouches);return b&(Ab|Bb)&&(c=u(c.concat(d),"identifier",!0)),[c,d]}function Q(){this.evTarget=Xb,this.targetIds={},y.apply(this,arguments)}function R(a,b){var c=t(a.touches),d=this.targetIds;if(b&(yb|zb)&&1===c.length)return d[c[0].identifier]=!0,[c,c];var e,f,g=t(a.changedTouches),h=[],i=this.target;if(f=c.filter(function(a){return p(a.target,i)}),b===yb)for(e=0;e<f.length;)d[f[e].identifier]=!0,e++;for(e=0;e<g.length;)d[g[e].identifier]&&h.push(g[e]),b&(Ab|Bb)&&delete d[g[e].identifier],e++;return h.length?[u(f.concat(h),"identifier",!0),h]:void 0}function S(){y.apply(this,arguments);var a=k(this.handler,this);this.touch=new Q(this.manager,a),this.mouse=new M(this.manager,a)}function T(a,b){this.manager=a,this.set(b)}function U(a){if(q(a,bc))return bc;var b=q(a,cc),c=q(a,dc);return b&&c?cc+" "+dc:b||c?b?cc:dc:q(a,ac)?ac:_b}function V(a){this.id=w(),this.manager=null,this.options=i(a||{},this.defaults),this.options.enable=m(this.options.enable,!0),this.state=ec,this.simultaneous={},this.requireFail=[]}function W(a){return a&jc?"cancel":a&hc?"end":a&gc?"move":a&fc?"start":""}function X(a){return a==Gb?"down":a==Fb?"up":a==Db?"left":a==Eb?"right":""}function Y(a,b){var c=b.manager;return c?c.get(a):a}function Z(){V.apply(this,arguments)}function $(){Z.apply(this,arguments),this.pX=null,this.pY=null}function _(){Z.apply(this,arguments)}function ab(){V.apply(this,arguments),this._timer=null,this._input=null}function bb(){Z.apply(this,arguments)}function cb(){Z.apply(this,arguments)}function db(){V.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function eb(a,b){return b=b||{},b.recognizers=m(b.recognizers,eb.defaults.preset),new fb(a,b)}function fb(a,b){b=b||{},this.options=i(b,eb.defaults),this.options.inputTarget=this.options.inputTarget||a,this.handlers={},this.session={},this.recognizers=[],this.element=a,this.input=z(this),this.touchAction=new T(this,this.options.touchAction),gb(this,!0),g(b.recognizers,function(a){var b=this.add(new a[0](a[1]));a[2]&&b.recognizeWith(a[2]),a[3]&&b.requireFailure(a[3])},this)}function gb(a,b){var c=a.element;g(a.options.cssProps,function(a,d){c.style[v(c.style,d)]=b?a:""})}function hb(a,c){var d=b.createEvent("Event");d.initEvent(a,!0,!0),d.gesture=c,c.target.dispatchEvent(d)}var ib=["","webkit","moz","MS","ms","o"],jb=b.createElement("div"),kb="function",lb=Math.round,mb=Math.abs,nb=Date.now,ob=1,pb=/mobile|tablet|ip(ad|hone|od)|android/i,qb="ontouchstart"in a,rb=v(a,"PointerEvent")!==d,sb=qb&&pb.test(navigator.userAgent),tb="touch",ub="pen",vb="mouse",wb="kinect",xb=25,yb=1,zb=2,Ab=4,Bb=8,Cb=1,Db=2,Eb=4,Fb=8,Gb=16,Hb=Db|Eb,Ib=Fb|Gb,Jb=Hb|Ib,Kb=["x","y"],Lb=["clientX","clientY"];y.prototype={handler:function(){},init:function(){this.evEl&&n(this.element,this.evEl,this.domHandler),this.evTarget&&n(this.target,this.evTarget,this.domHandler),this.evWin&&n(x(this.element),this.evWin,this.domHandler)},destroy:function(){this.evEl&&o(this.element,this.evEl,this.domHandler),this.evTarget&&o(this.target,this.evTarget,this.domHandler),this.evWin&&o(x(this.element),this.evWin,this.domHandler)}};var Mb={mousedown:yb,mousemove:zb,mouseup:Ab},Nb="mousedown",Ob="mousemove mouseup";j(M,y,{handler:function(a){var b=Mb[a.type];b&yb&&0===a.button&&(this.pressed=!0),b&zb&&1!==a.which&&(b=Ab),this.pressed&&this.allow&&(b&Ab&&(this.pressed=!1),this.callback(this.manager,b,{pointers:[a],changedPointers:[a],pointerType:vb,srcEvent:a}))}});var Pb={pointerdown:yb,pointermove:zb,pointerup:Ab,pointercancel:Bb,pointerout:Bb},Qb={2:tb,3:ub,4:vb,5:wb},Rb="pointerdown",Sb="pointermove pointerup pointercancel";a.MSPointerEvent&&(Rb="MSPointerDown",Sb="MSPointerMove MSPointerUp MSPointerCancel"),j(N,y,{handler:function(a){var b=this.store,c=!1,d=a.type.toLowerCase().replace("ms",""),e=Pb[d],f=Qb[a.pointerType]||a.pointerType,g=f==tb,h=s(b,a.pointerId,"pointerId");e&yb&&(0===a.button||g)?0>h&&(b.push(a),h=b.length-1):e&(Ab|Bb)&&(c=!0),0>h||(b[h]=a,this.callback(this.manager,e,{pointers:b,changedPointers:[a],pointerType:f,srcEvent:a}),c&&b.splice(h,1))}});var Tb={touchstart:yb,touchmove:zb,touchend:Ab,touchcancel:Bb},Ub="touchstart",Vb="touchstart touchmove touchend touchcancel";j(O,y,{handler:function(a){var b=Tb[a.type];if(b===yb&&(this.started=!0),this.started){var c=P.call(this,a,b);b&(Ab|Bb)&&c[0].length-c[1].length===0&&(this.started=!1),this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:tb,srcEvent:a})}}});var Wb={touchstart:yb,touchmove:zb,touchend:Ab,touchcancel:Bb},Xb="touchstart touchmove touchend touchcancel";j(Q,y,{handler:function(a){var b=Wb[a.type],c=R.call(this,a,b);c&&this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:tb,srcEvent:a})}}),j(S,y,{handler:function(a,b,c){var d=c.pointerType==tb,e=c.pointerType==vb;if(d)this.mouse.allow=!1;else if(e&&!this.mouse.allow)return;b&(Ab|Bb)&&(this.mouse.allow=!0),this.callback(a,b,c)},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var Yb=v(jb.style,"touchAction"),Zb=Yb!==d,$b="compute",_b="auto",ac="manipulation",bc="none",cc="pan-x",dc="pan-y";T.prototype={set:function(a){a==$b&&(a=this.compute()),Zb&&(this.manager.element.style[Yb]=a),this.actions=a.toLowerCase().trim()},update:function(){this.set(this.manager.options.touchAction)},compute:function(){var a=[];return g(this.manager.recognizers,function(b){l(b.options.enable,[b])&&(a=a.concat(b.getTouchAction()))}),U(a.join(" "))},preventDefaults:function(a){if(!Zb){var b=a.srcEvent,c=a.offsetDirection;if(this.manager.session.prevented)return void b.preventDefault();var d=this.actions,e=q(d,bc),f=q(d,dc),g=q(d,cc);return e||f&&c&Hb||g&&c&Ib?this.preventSrc(b):void 0}},preventSrc:function(a){this.manager.session.prevented=!0,a.preventDefault()}};var ec=1,fc=2,gc=4,hc=8,ic=hc,jc=16,kc=32;V.prototype={defaults:{},set:function(a){return h(this.options,a),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function(a){if(f(a,"recognizeWith",this))return this;var b=this.simultaneous;return a=Y(a,this),b[a.id]||(b[a.id]=a,a.recognizeWith(this)),this},dropRecognizeWith:function(a){return f(a,"dropRecognizeWith",this)?this:(a=Y(a,this),delete this.simultaneous[a.id],this)},requireFailure:function(a){if(f(a,"requireFailure",this))return this;var b=this.requireFail;return a=Y(a,this),-1===s(b,a)&&(b.push(a),a.requireFailure(this)),this},dropRequireFailure:function(a){if(f(a,"dropRequireFailure",this))return this;a=Y(a,this);var b=s(this.requireFail,a);return b>-1&&this.requireFail.splice(b,1),this},hasRequireFailures:function(){return this.requireFail.length>0},canRecognizeWith:function(a){return!!this.simultaneous[a.id]},emit:function(a){function b(b){c.manager.emit(c.options.event+(b?W(d):""),a)}var c=this,d=this.state;hc>d&&b(!0),b(),d>=hc&&b(!0)},tryEmit:function(a){return this.canEmit()?this.emit(a):void(this.state=kc)},canEmit:function(){for(var a=0;a<this.requireFail.length;){if(!(this.requireFail[a].state&(kc|ec)))return!1;a++}return!0},recognize:function(a){var b=h({},a);return l(this.options.enable,[this,b])?(this.state&(ic|jc|kc)&&(this.state=ec),this.state=this.process(b),void(this.state&(fc|gc|hc|jc)&&this.tryEmit(b))):(this.reset(),void(this.state=kc))},process:function(){},getTouchAction:function(){},reset:function(){}},j(Z,V,{defaults:{pointers:1},attrTest:function(a){var b=this.options.pointers;return 0===b||a.pointers.length===b},process:function(a){var b=this.state,c=a.eventType,d=b&(fc|gc),e=this.attrTest(a);return d&&(c&Bb||!e)?b|jc:d||e?c&Ab?b|hc:b&fc?b|gc:fc:kc}}),j($,Z,{defaults:{event:"pan",threshold:10,pointers:1,direction:Jb},getTouchAction:function(){var a=this.options.direction,b=[];return a&Hb&&b.push(dc),a&Ib&&b.push(cc),b},directionTest:function(a){var b=this.options,c=!0,d=a.distance,e=a.direction,f=a.deltaX,g=a.deltaY;return e&b.direction||(b.direction&Hb?(e=0===f?Cb:0>f?Db:Eb,c=f!=this.pX,d=Math.abs(a.deltaX)):(e=0===g?Cb:0>g?Fb:Gb,c=g!=this.pY,d=Math.abs(a.deltaY))),a.direction=e,c&&d>b.threshold&&e&b.direction},attrTest:function(a){return Z.prototype.attrTest.call(this,a)&&(this.state&fc||!(this.state&fc)&&this.directionTest(a))},emit:function(a){this.pX=a.deltaX,this.pY=a.deltaY;var b=X(a.direction);b&&this.manager.emit(this.options.event+b,a),this._super.emit.call(this,a)}}),j(_,Z,{defaults:{event:"pinch",threshold:0,pointers:2},getTouchAction:function(){return[bc]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.scale-1)>this.options.threshold||this.state&fc)},emit:function(a){if(this._super.emit.call(this,a),1!==a.scale){var b=a.scale<1?"in":"out";this.manager.emit(this.options.event+b,a)}}}),j(ab,V,{defaults:{event:"press",pointers:1,time:500,threshold:5},getTouchAction:function(){return[_b]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime>b.time;if(this._input=a,!d||!c||a.eventType&(Ab|Bb)&&!f)this.reset();else if(a.eventType&yb)this.reset(),this._timer=e(function(){this.state=ic,this.tryEmit()},b.time,this);else if(a.eventType&Ab)return ic;return kc},reset:function(){clearTimeout(this._timer)},emit:function(a){this.state===ic&&(a&&a.eventType&Ab?this.manager.emit(this.options.event+"up",a):(this._input.timeStamp=nb(),this.manager.emit(this.options.event,this._input)))}}),j(bb,Z,{defaults:{event:"rotate",threshold:0,pointers:2},getTouchAction:function(){return[bc]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.rotation)>this.options.threshold||this.state&fc)}}),j(cb,Z,{defaults:{event:"swipe",threshold:10,velocity:.65,direction:Hb|Ib,pointers:1},getTouchAction:function(){return $.prototype.getTouchAction.call(this)},attrTest:function(a){var b,c=this.options.direction;return c&(Hb|Ib)?b=a.velocity:c&Hb?b=a.velocityX:c&Ib&&(b=a.velocityY),this._super.attrTest.call(this,a)&&c&a.direction&&a.distance>this.options.threshold&&mb(b)>this.options.velocity&&a.eventType&Ab},emit:function(a){var b=X(a.direction);b&&this.manager.emit(this.options.event+b,a),this.manager.emit(this.options.event,a)}}),j(db,V,{defaults:{event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:2,posThreshold:10},getTouchAction:function(){return[ac]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime<b.time;if(this.reset(),a.eventType&yb&&0===this.count)return this.failTimeout();if(d&&f&&c){if(a.eventType!=Ab)return this.failTimeout();var g=this.pTime?a.timeStamp-this.pTime<b.interval:!0,h=!this.pCenter||I(this.pCenter,a.center)<b.posThreshold;this.pTime=a.timeStamp,this.pCenter=a.center,h&&g?this.count+=1:this.count=1,this._input=a;var i=this.count%b.taps;if(0===i)return this.hasRequireFailures()?(this._timer=e(function(){this.state=ic,this.tryEmit()},b.interval,this),fc):ic}return kc},failTimeout:function(){return this._timer=e(function(){this.state=kc},this.options.interval,this),kc},reset:function(){clearTimeout(this._timer)},emit:function(){this.state==ic&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),eb.VERSION="2.0.4",eb.defaults={domEvents:!1,touchAction:$b,enable:!0,inputTarget:null,inputClass:null,preset:[[bb,{enable:!1}],[_,{enable:!1},["rotate"]],[cb,{direction:Hb}],[$,{direction:Hb},["swipe"]],[db],[db,{event:"doubletap",taps:2},["tap"]],[ab]],cssProps:{userSelect:"none",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}};var lc=1,mc=2;fb.prototype={set:function(a){return h(this.options,a),a.touchAction&&this.touchAction.update(),a.inputTarget&&(this.input.destroy(),this.input.target=a.inputTarget,this.input.init()),this},stop:function(a){this.session.stopped=a?mc:lc},recognize:function(a){var b=this.session;if(!b.stopped){this.touchAction.preventDefaults(a);var c,d=this.recognizers,e=b.curRecognizer;(!e||e&&e.state&ic)&&(e=b.curRecognizer=null);for(var f=0;f<d.length;)c=d[f],b.stopped===mc||e&&c!=e&&!c.canRecognizeWith(e)?c.reset():c.recognize(a),!e&&c.state&(fc|gc|hc)&&(e=b.curRecognizer=c),f++}},get:function(a){if(a instanceof V)return a;for(var b=this.recognizers,c=0;c<b.length;c++)if(b[c].options.event==a)return b[c];return null},add:function(a){if(f(a,"add",this))return this;var b=this.get(a.options.event);return b&&this.remove(b),this.recognizers.push(a),a.manager=this,this.touchAction.update(),a},remove:function(a){if(f(a,"remove",this))return this;var b=this.recognizers;return a=this.get(a),b.splice(s(b,a),1),this.touchAction.update(),this},on:function(a,b){var c=this.handlers;return g(r(a),function(a){c[a]=c[a]||[],c[a].push(b)}),this},off:function(a,b){var c=this.handlers;return g(r(a),function(a){b?c[a].splice(s(c[a],b),1):delete c[a]}),this},emit:function(a,b){this.options.domEvents&&hb(a,b);var c=this.handlers[a]&&this.handlers[a].slice();if(c&&c.length){b.type=a,b.preventDefault=function(){b.srcEvent.preventDefault()};for(var d=0;d<c.length;)c[d](b),d++}},destroy:function(){this.element&&gb(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},h(eb,{INPUT_START:yb,INPUT_MOVE:zb,INPUT_END:Ab,INPUT_CANCEL:Bb,STATE_POSSIBLE:ec,STATE_BEGAN:fc,STATE_CHANGED:gc,STATE_ENDED:hc,STATE_RECOGNIZED:ic,STATE_CANCELLED:jc,STATE_FAILED:kc,DIRECTION_NONE:Cb,DIRECTION_LEFT:Db,DIRECTION_RIGHT:Eb,DIRECTION_UP:Fb,DIRECTION_DOWN:Gb,DIRECTION_HORIZONTAL:Hb,DIRECTION_VERTICAL:Ib,DIRECTION_ALL:Jb,Manager:fb,Input:y,TouchAction:T,TouchInput:Q,MouseInput:M,PointerEventInput:N,TouchMouseInput:S,SingleTouchInput:O,Recognizer:V,AttrRecognizer:Z,Tap:db,Pan:$,Swipe:cb,Pinch:_,Rotate:bb,Press:ab,on:n,off:o,each:g,merge:i,extend:h,inherit:j,bindFn:k,prefixed:v}),typeof define==kb&&define.amd?define(function(){return eb}):"undefined"!=typeof module&&module.exports?module.exports=eb:a[c]=eb}(window,document,"Hammer");
//# sourceMappingURL=hammer.min.map
/* canvas-toBlob.js
 * A canvas.toBlob() implementation.
 * 2013-12-27
 * 
 * By Eli Grey, http://eligrey.com and Devin Samarin, https://github.com/eboyjr
 * License: X11/MIT
 *   See https://github.com/eligrey/canvas-toBlob.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
  plusplus: true */

/*! @source http://purl.eligrey.com/github/canvas-toBlob.js/blob/master/canvas-toBlob.js */

(function(view) {
"use strict";
var
	  Uint8Array = view.Uint8Array
	, HTMLCanvasElement = view.HTMLCanvasElement
	, canvas_proto = HTMLCanvasElement && HTMLCanvasElement.prototype
	, is_base64_regex = /\s*;\s*base64\s*(?:;|$)/i
	, to_data_url = "toDataURL"
	, base64_ranks
	, decode_base64 = function(base64) {
		var
			  len = base64.length
			, buffer = new Uint8Array(len / 4 * 3 | 0)
			, i = 0
			, outptr = 0
			, last = [0, 0]
			, state = 0
			, save = 0
			, rank
			, code
			, undef
		;
		while (len--) {
			code = base64.charCodeAt(i++);
			rank = base64_ranks[code-43];
			if (rank !== 255 && rank !== undef) {
				last[1] = last[0];
				last[0] = code;
				save = (save << 6) | rank;
				state++;
				if (state === 4) {
					buffer[outptr++] = save >>> 16;
					if (last[1] !== 61 /* padding character */) {
						buffer[outptr++] = save >>> 8;
					}
					if (last[0] !== 61 /* padding character */) {
						buffer[outptr++] = save;
					}
					state = 0;
				}
			}
		}
		// 2/3 chance there's going to be some null bytes at the end, but that
		// doesn't really matter with most image formats.
		// If it somehow matters for you, truncate the buffer up outptr.
		return buffer;
	}
;
if (Uint8Array) {
	base64_ranks = new Uint8Array([
		  62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1
		, -1, -1,  0, -1, -1, -1,  0,  1,  2,  3,  4,  5,  6,  7,  8,  9
		, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25
		, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35
		, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51
	]);
}
if (HTMLCanvasElement && !canvas_proto.toBlob) {
	canvas_proto.toBlob = function(callback, type /*, ...args*/) {
		  if (!type) {
			type = "image/png";
		} if (this.mozGetAsFile) {
			callback(this.mozGetAsFile("canvas", type));
			return;
		} if (this.msToBlob && /^\s*image\/png\s*(?:$|;)/i.test(type)) {
			callback(this.msToBlob());
			return;
		}

		var
			  args = Array.prototype.slice.call(arguments, 1)
			, dataURI = this[to_data_url].apply(this, args)
			, header_end = dataURI.indexOf(",")
			, data = dataURI.substring(header_end + 1)
			, is_base64 = is_base64_regex.test(dataURI.substring(0, header_end))
			, blob
		;
		if (Blob.fake) {
			// no reason to decode a data: URI that's just going to become a data URI again
			blob = new Blob
			if (is_base64) {
				blob.encoding = "base64";
			} else {
				blob.encoding = "URI";
			}
			blob.data = data;
			blob.size = data.length;
		} else if (Uint8Array) {
			if (is_base64) {
				blob = new Blob([decode_base64(data)], {type: type});
			} else {
				blob = new Blob([decodeURIComponent(data)], {type: type});
			}
		}
		callback(blob);
	};

	if (canvas_proto.toDataURLHD) {
		canvas_proto.toBlobHD = function() {
			to_data_url = "toDataURLHD";
			var blob = this.toBlob();
			to_data_url = "toDataURL";
			return blob;
		}
	} else {
		canvas_proto.toBlobHD = canvas_proto.toBlob;
	}
}
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || this.content || this));

/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 2015-03-04
 *
 * By Eli Grey, http://eligrey.com
 * License: X11/MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs
  // IE 10+ (native saveAs)
  || (typeof navigator !== "undefined" &&
      navigator.msSaveOrOpenBlob && navigator.msSaveOrOpenBlob.bind(navigator))
  // Everyone else
  || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof navigator !== "undefined" &&
	    /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = doc.createEvent("MouseEvents");
			event.initMouseEvent(
				"click", true, false, view, 0, 0, 0, 0, 0
				, false, false, false, false, 0, null
			);
			node.dispatchEvent(event);
		}
		, webkit_req_fs = view.webkitRequestFileSystem
		, req_fs = view.requestFileSystem || webkit_req_fs || view.mozRequestFileSystem
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		, fs_min_size = 0
		// See https://code.google.com/p/chromium/issues/detail?id=375297#c7 and
		// https://github.com/eligrey/FileSaver.js/commit/485930a#commitcomment-8768047
		// for the reasoning behind the timeout and revocation flow
		, arbitrary_revoke_timeout = 500 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			if (view.chrome) {
				revoker();
			} else {
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, FileSaver = function(blob, name) {
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, blob_changed = false
				, object_url
				, target_view
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					// don't create more object URLs than needed
					if (blob_changed || !object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (target_view) {
						target_view.location.href = object_url;
					} else {
						var new_tab = view.open(object_url, "_blank");
						if (new_tab == undefined && typeof safari !== "undefined") {
							//Apple do not allow window.open, see http://bit.ly/1kZffRI
							view.location.href = object_url
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
				, abortable = function(func) {
					return function() {
						if (filesaver.readyState !== filesaver.DONE) {
							return func.apply(this, arguments);
						}
					};
				}
				, create_if_not_found = {create: true, exclusive: false}
				, slice
			;
			filesaver.readyState = filesaver.INIT;
			if (!name) {
				name = "download";
			}
			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				save_link.href = object_url;
				save_link.download = name;
				click(save_link);
				filesaver.readyState = filesaver.DONE;
				dispatch_all();
				revoke(object_url);
				return;
			}
			// prepend BOM for UTF-8 XML and text/plain types
			if (/^\s*(?:text\/(?:plain|xml)|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				blob = new Blob(["\ufeff", blob], {type: blob.type});
			}
			// Object and web filesystem URLs have a problem saving in Google Chrome when
			// viewed in a tab, so I force save with application/octet-stream
			// http://code.google.com/p/chromium/issues/detail?id=91158
			// Update: Google errantly closed 91158, I submitted it again:
			// https://code.google.com/p/chromium/issues/detail?id=389642
			if (view.chrome && type && type !== force_saveable_type) {
				slice = blob.slice || blob.webkitSlice;
				blob = slice.call(blob, 0, blob.size, force_saveable_type);
				blob_changed = true;
			}
			// Since I can't be sure that the guessed media type will trigger a download
			// in WebKit, I append .download to the filename.
			// https://bugs.webkit.org/show_bug.cgi?id=65440
			if (webkit_req_fs && name !== "download") {
				name += ".download";
			}
			if (type === force_saveable_type || webkit_req_fs) {
				target_view = view;
			}
			if (!req_fs) {
				fs_error();
				return;
			}
			fs_min_size += blob.size;
			req_fs(view.TEMPORARY, fs_min_size, abortable(function(fs) {
				fs.root.getDirectory("saved", create_if_not_found, abortable(function(dir) {
					var save = function() {
						dir.getFile(name, create_if_not_found, abortable(function(file) {
							file.createWriter(abortable(function(writer) {
								writer.onwriteend = function(event) {
									target_view.location.href = file.toURL();
									filesaver.readyState = filesaver.DONE;
									dispatch(filesaver, "writeend", event);
									revoke(file);
								};
								writer.onerror = function() {
									var error = writer.error;
									if (error.code !== error.ABORT_ERR) {
										fs_error();
									}
								};
								"writestart progress write abort".split(" ").forEach(function(event) {
									writer["on" + event] = filesaver["on" + event];
								});
								writer.write(blob);
								filesaver.abort = function() {
									writer.abort();
									filesaver.readyState = filesaver.DONE;
								};
								filesaver.readyState = filesaver.WRITING;
							}), fs_error);
						}), fs_error);
					};
					dir.getFile(name, {create: false}, abortable(function(file) {
						// delete file if it already exists
						file.remove();
						save();
					}), abortable(function(ex) {
						if (ex.code === ex.NOT_FOUND_ERR) {
							save();
						} else {
							fs_error();
						}
					}));
				}), fs_error);
			}), fs_error);
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name) {
			return new FileSaver(blob, name);
		}
	;
	FS_proto.abort = function() {
		var filesaver = this;
		filesaver.readyState = filesaver.DONE;
		dispatch(filesaver, "abort");
	};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if ((typeof define !== "undefined" && define !== null) && (define.amd != null)) {
  define([], function() {
    return saveAs;
  });
}

'use strict';

angular.module('ImageEditor')

.controller('ZoomController', ['$rootScope', '$scope', 'canvas', function($rootScope, $scope, canvas) {

    $scope.canvas = canvas;
    $scope.zoom = 1;
    $scope.maxScale = 200;
    $scope.minScale = 30;

    $rootScope.$on('editor.mainImage.loaded', function() { $scope.fitToScreen() });
    $rootScope.$on('canvas.openedNew', function() { $scope.fitToScreen() });

    $scope.$watch('canvas.currentZoom', function(newValue) {
        var canvasZoom = newValue * 100;

        if (canvasZoom !== $scope.zoom) {
            $scope.zoom = canvasZoom;
        }
    });

    $scope.fitToScreen = function () {
        $scope.zoom = canvas.currentZoom * 100;
            
        if (canvas.mainImage) {
            var oWidth = canvas.mainImage.originalState.width,
                oHeight = canvas.mainImage.originalState.height;
        } else {
            var oWidth = canvas.original.width,
                oHeight = canvas.original.height;
        }

        var maxScale = Math.min(3582 / oHeight, 5731 / oWidth) * 100,
            minScale = Math.min(141 / oHeight, 211 / oWidth) * 100;

        $scope.maxScale = Math.ceil(maxScale);
        $scope.minScale = Math.ceil(minScale);

        canvas.zoom(canvas.currentZoom);
    };

    //make sure we adjust zoom slider properly on history change
    $rootScope.$on('history.loaded', function() {
        //$scope.zoom = canvas.currentScale * 100;
    });

    $scope.doZoom = function () {
        canvas.zoom($scope.zoom / 100);
    };

    $scope.getCurrentZoom = function() {
        return Math.round(canvas.currentZoom * 100);
    };
}]);




'use strict';

angular.module('ImageEditor')

    .controller('TopPanelController', ['$rootScope', '$scope', '$log', '$mdDialog', '$document', '$mdToast', '$$rAF', 'canvas', 'history', 'saver', 'UploadFileService', 'loadingScreen', 'IES', function ($rootScope, $scope, $log, $mdDialog, $document, $mdToast, $$rAF, canvas, history, saver, UploadFileService, loadingScreen, IES) {

        $scope.history = history;

        $scope.isDemo = IES.get().isDemo;
        $scope.canOpenImage = false;
        $scope.canvas = canvas;
        $scope.openImageMode = 'open';

        $scope.canvasWidth = 800;
        $scope.canvasHeight = 600;

        $scope.imageName = 'image';
        $scope.imageType = 'png';
        $scope.imageFile = undefined;
        $scope.imageQuality = 8;

        $scope.objectsPanelOpen = true;
        $scope.historyPanelOpen = false;

        $scope.imageList = []; // images pulled down from the server used to build your message
        $scope.imageListEditedData = []; // edited images pushed back up to the server

        UploadFileService.load(function (list, error) {
            $scope.imageList = list;
        });

        $scope.openUploadDialog = function ($event) {
            $mdDialog.show({
                template: $('#main-image-upload-dialog-template').html(),
                targetEvent: $event,
                controller: 'TopPanelController',
                clickOutsideToClose: true,
            });
        };

        $scope.toggleRightPanel = function (name, e) {
            var panelIsOpen = $scope[name + 'PanelOpen'];

            if (panelIsOpen) {
                $scope[name + 'PanelOpen'] = false;
                $('#' + name).hide();
            } else {
                $scope[name + 'PanelOpen'] = true;
                $('#' + name).show();
            }
        };

        $scope.transformOpen = function (name, e) {
            var panel = $('#' + name);

            panel.removeClass('transition-out transition-in').show();
            $scope.transformToClickElement(panel, e);

            $$rAF(function () {
                panel.addClass('transition-in').css('transform', '');
                e.currentTarget.blur();
            });
        };

        $scope.transformClose = function (name, e) {
            var panel = $('#' + name);

            panel.addClass('transition-out').removeClass('transition-in');
            $scope.transformToClickElement(panel, e);

            panel.one(IES.get().transitionEndEvent, function () {
                panel.hide().css('transform', '').removeClass('transition-out');
                e.currentTarget.blur();
            });
        };

        $scope.transformToClickElement = function (panel, e) {
            var clickRect = e.target.getBoundingClientRect();
            var panelRect = panel[0].getBoundingClientRect();

            var scaleX = Math.min(0.5, clickRect.width / panelRect.width);
            var scaleY = Math.min(0.5, clickRect.height / panelRect.height);

            panel.css('transform', 'translate3d(' +
                (-panelRect.left + clickRect.left + clickRect.width / 2 - panelRect.width / 2) + 'px,' +
                (-panelRect.top + clickRect.top + clickRect.height / 2 - panelRect.height / 2) + 'px,' +
                '0) scale(' + scaleX + ',' + scaleY + ')'
            );
        };

        $scope.buildLayout = function (backgroundColor, previewImagePath, imageData) {

            var layout = {};
            layout.backgroundColor = $scope.color2rgba(backgroundColor);
            layout.previewImage = previewImagePath;
            layout.buttonLayout = $scope.getButtonData();
            layout.textLayout = $scope.getTextData();
            layout.imageLayout = $scope.getImageData(imageData);
            layout.editableLayout = $scope.getEditableData();

            return layout;//JSON.stringify( layout );

        };

        $scope.getEditableData = function () {
            var list = [];
            canvas.fabric.forEachObject(function (obj) {
                if (obj && obj.name && (obj.name == 'editable' || obj.name == 'entryfield')) {
                    list.push({
                        zorder: obj.zorder,
                        top: obj.top / canvas.original.height,
                        left: obj.left / canvas.original.width,
                        height: obj.height / canvas.original.height,
                        width: obj.width / canvas.original.width,
                        type: obj.name
                    });
                }
            });

            return list;
        };

        $scope.getButtonData = function () {
            var list = [];
            canvas.fabric.forEachObject(function (button) {
                if (button && button.niceName &&
                    (button.niceName.indexOf('button rect') == 0 ||
                        button.niceName.indexOf('button circle') == 0 ||
                        button.niceName.indexOf('button ellipse') == 0)) {

                    var data = button.action.split(/:(.+)?/);
                    var actionType = (data[0] || '');
                    var action = (data[1] || '');

                    var text = button.textObj;
                    var icon = null;
                    if (text.textObj)
                        icon = text.textObj.url;

                    list.push({
                        //url: image.url,
                        top: button.top / canvas.original.height,
                        left: button.left / canvas.original.width,
                        height: button.height * button.scaleY / canvas.original.height,
                        width: button.width * button.scaleX / canvas.original.width,
                        corner: button.rx,
                        icon: icon,
                        zorder: button.zorder,
                        //scaleX: obj.scaleX,
                        //scaleY: obj.scaleY,
                        //angle: obj.angle,
                        style: button.name,
                        text: button.textObj.text,
                        textColor: $scope.color2rgba(button.textObj.fill),
                        fontfamily: button.textObj.fontFamily,
                        fontsize: /*button.textObj.fontSize * 72 / fabric.DPI*/button.textObj.fontSize,
                        color: $scope.color2rgba(button.fill),
                        actionType: actionType,
                        action: action
                    });
                }
            });
            return list;
            //return JSON.stringify( list );
        }

        $scope.getTextData = function () {
            var list = [];
            canvas.fabric.forEachObject(function (obj) {
                if (obj.name == 'text' && obj.niceName && !(obj.niceName.indexOf("button") == 0) && obj.visible == true) {
                    var angle = obj.angle;
                    obj.setAngle(0).setCoords();
                    console.log(obj, 'getTextDatagetTextData')
                    list.push({
                        editable: obj.niceName == 'editable text',
                        generated: obj.niceName == 'generated text',
                        zorder: obj.zorder,
                        top: obj.top / canvas.original.height,
                        left: obj.left / canvas.original.width,
                        height: obj.height / canvas.original.height,
                        width: obj.width / canvas.original.width,
                        text: obj.text,
                        fontfamily: obj.fontFamily,
                        fontsize: /*obj.fontSize * 72 / fabric.DPI*/obj.fontSize,
                        color: $scope.color2rgba(obj.fill),
                        angle: angle,
                        senderNameChecked: obj.senderNameChecked ? obj.senderNameChecked : false,

                    });
                    obj.setAngle(angle).setCoords();
                }
            });
            //return JSON.stringify( list );
            return list;
        };

        $scope.getImageData = function (imageData) {
            var list = [];
            imageData.forEach(function (image) {
                var obj = image.obj;
                if (obj && obj.niceName && (obj.niceName == 'image' || obj.name == 'sticker' || obj.niceName == 'shape') && (obj.name != 'editable') && (obj.name != 'entryfield')) {
                    var angle = obj.angle;
                    obj.setAngle(0).setCoords();
                    list.push({
                        url: image.url,
                        zorder: obj.zorder,
                        top: obj.top / canvas.original.height,
                        left: obj.left / canvas.original.width,
                        height: obj.height * obj.scaleY / canvas.original.height,
                        width: obj.width * obj.scaleX / canvas.original.width,
                        //scaleX: obj.scaleX,
                        //scaleY: obj.scaleY,
                        angle: angle,
                        useGoogleMap: obj.useGoogleMap ? obj.useGoogleMap : false,
                        selectedMapType: obj.selectedMapType ? obj.selectedMapType : null,
                        useUserGPS: obj.useUserGPS ? obj.useUserGPS : false,
                    });
                    obj.setAngle(angle).setCoords();
                }
            });
            //return JSON.stringify( list );
            return list;
        };

        $scope.color2rgba = function (color) {
            var result = [];
            if (color.indexOf("#") == 0) {
                var h = color.replace('#', '');
                if (h.length == 3) {
                    for (var i = 0; i < h.length; i++) {
                        result[i] = parseInt((h[i] + h[i]), 16);
                    }
                } else {
                    for (var i = 0; i < 3; i++) {
                        result[i] = parseInt((h[i * 2] + h[i * 2 + 1]), 16);
                    }
                }
                return result.join() + ",1";
            } else if (color.indexOf("rgba") == 0) {
                color = color.replace("rgba(", '').replace(")", '');
                color = color.split(" ").join('');
                return color;
            }

            return "0,0,0,1";
        }

        $scope.openSaveDialog = function ($event, cb) {
            console.log('event 1', $event)



            /*var result = hex2rgb("#00A");
            return;*/
            $log.debug("start");
            if (!IES.get().data) return;
            loadingScreen.turnOn(true);


            $scope.saveEditedImages(function (imageData, error) {
                /*
                // debug
                if( cb ) cb();
                */
                if (error == null) {
                    saver.saveImage($scope.imageType, $scope.imageQuality, $scope.imageName, $event, function (image, previewImage) {
                        canvas.zoom(saver.lastZoom);
                        //UploadFileService.upload( image, function(path,error){
                        //if( path && error == null ) {                            
                        //var payload = canvas.getDesignPayload();
                        //payload.imageurl = path;
                        UploadFileService.upload(previewImage, function (path, error) {

                            if (path && error == null) {
                                var payload = canvas.getDesignPayload();
                                var data = JSON.parse(payload.layout);
                                //payload.buttonlayout = $scope.getButtonData( imageData );
                                //payload.edittextdata = $scope.getEditableTextData();
                                //payload.generatedlayout = $scope.getGeneratedTextData();
                                payload.imageurl = path;
                                payload.previewurl = path;
                                payload.applayout = $scope.buildLayout(data.background, path, imageData);
                                IES.get().updateData(payload);
                                $rootScope.$emit('save.template', path);
                                loadingScreen.turnOn(false);
                                $log.debug("false");
                                if (cb) cb();
                            }
                        });
                        //}
                        //});
                    });
                }
            });
        };

        $scope.updatePreview = function () {
            console.log(121)
            saver.saveImage($scope.imageType, $scope.imageQuality, $scope.imageName, null, function (image, previewImage) {
                canvas.zoom(saver.lastZoom);
                console.log(previewImage, 'previewImagepreviewImagepreviewImage')
                $rootScope.$emit('save.template', previewImage);
            });
        }

        $scope.createNewCanvas = function () {
            canvas.openNew(IES.get().defaultWidth, IES.get().defaultHeight);
            $scope.closeUploadDialog();
            IES.get().started = true;
            IES.get().resetUI();
        };

        $scope.saveEditedImage = function (list, index, cb) {

            if (index >= list.length) {
                if (cb) cb($scope.imageListEditedData, null)
                return;
            }

            var image = list[index];
            // here we create an OFFSCREEN canvas
            var offscreenCanvas = document.createElement('canvas');
            var shadowWidth = 0;
            var shadowHeight = 0;
            if (image.shadow) {
                shadowWidth = image.shadow.offsetX;
                shadowHeight = image.shadow.offsetY;
            }
            var offset = 0;
            if (image.name == 'triangle') {
                offset = Math.acos(Math.tan(image.width / 2 / image.height)) * image.strokeWidth;
            }

            offscreenCanvas.width = (image.width + image.strokeWidth + shadowWidth + offset) * image.scaleX;
            offscreenCanvas.height = (image.height + image.strokeWidth + shadowHeight + offset) * image.scaleY;
            var context = offscreenCanvas.getContext('2d');


            // normalize button position
            var top = image.top;
            var left = image.left;
            var angle = image.angle;
            image.angle = 0;
            image.top = offset;
            image.left = offset / 2;
            image.setCoords();
            image.render(context);
            image.top = top;
            image.left = left;
            image.angle = angle;
            image.setCoords();

            var data = offscreenCanvas.toDataURL($scope.imageType, 0.8);


            var imageObj = {};
            UploadFileService.upload(data, function (path, error) {
                imageObj.obj = image;
                imageObj.url = path;
                image.url = path;
                //imageObj.top = image.top/canvas.original.height;
                //imageObj.left = image.left/canvas.original.width;
                if (image.action) {
                    var splitList = image.action.split(/:(.+)?/);
                    imageObj.actionType = splitList[0];
                    imageObj.action = splitList[1];
                }
                $scope.imageListEditedData.push(imageObj);

                if (error && cb) {
                    cb(null, error);
                } else {
                    // next button
                    $scope.saveEditedImage(list, index + 1, cb);
                }
            });

            /*
            // debug
            var test = $document[0].getElementById("preview1");
            test.height = offscreenCanvas.height;
            test.width = offscreenCanvas.width;
            test.src = data;
            $scope.saveEditedImage( list, index+1,cb );*/

        };

        $scope.saveEditedImages = function (cb) {


            var imageList = [];
            var zOrder = 0;
            $scope.imageListData = [];
            canvas.fabric.forEachObject(function (obj) {
                obj.zorder = zOrder++;
                if (obj.niceName &&
                    obj.niceName != 'entryfield' &&
                    obj.niceName != 'editable' && (
                        obj.niceName == 'shape' ||
                        obj.niceName == 'image' ||
                        obj.name == 'icon' ||
                        obj.niceName == 'sticker')
                    && obj.visible == true) {
                    imageList.push(obj);
                }
            });
            $scope.saveEditedImage(imageList, 0, cb);
        };

        /* $scope.getGeneratedTextData = function() {
             var list = [];
             canvas.fabric.forEachObject(function(obj) {
                 if( obj.niceName && obj.niceName == "generated text" && obj.visible == true ){
                     list.push({
                         top: obj.top/canvas.original.height,
                         left: obj.left/canvas.original.width,
                         height: obj.height/canvas.original.height,
                         width: obj.width/canvas.original.width,
                         text: obj.text,
                         fontfamily: obj.fontFamily,
                         fontsize: obj.fontSize,
                         color: obj.fill
                     });
                 }
             });
     
             return JSON.stringify( list );
         };
     
         $scope.getEditableTextData = function() {
             var list = [];
             canvas.fabric.forEachObject(function(obj) {
                 if( obj.niceName && obj.niceName == "editable text" && obj.visible == true ){
                     list.push({
                         top: obj.top/canvas.original.height,
                         left: obj.left/canvas.original.width,
                         height: obj.height/canvas.original.height,
                         width: obj.width/canvas.original.width,
                         text: obj.text,
                         fontfamily: obj.fontFamily,
                         fontsize: obj.fontSize,
                         color: obj.fill
                     });
                 }
             });
     
             return JSON.stringify( list );
         };*/

        /* $scope.saveImage = function($event) {
     
             
         };*/

        $scope.showImagePreview = function (url, file) {
            $scope.imageFile = undefined;
            fabric.util.loadImage(url, function (image) {
                if (image) {
                    $scope.$apply(function () {
                        $scope.imageFile = file;
                        $('.img-preview').html('').append(image);
                        $scope.canOpenImage = true;
                    });
                } else {
                    $scope.$apply(function () {
                        $scope.canOpenImage = false;
                    });
                }
            });
        };

        $scope.loadImage = function (url, cb) {
            fabric.util.loadImage(url, function (image) {
                if (!image) return;
                if (cb) cb(image);
            });
        };

        $scope.openImage = function () {
            var element = $('.img-preview img');
            var url = element.attr('src');

            if (!url || !$scope.canOpenImage) return;

            if ($scope.imageFile) { // only upload if its not already up
                UploadFileService.upload($scope.imageFile, function (path, error) {
                    if (path && error == null) {
                        $scope.loadImageUrl(path);
                    }
                });
            } else {
                $scope.loadImageUrl(url);
            }

        };
        $scope.loadImageUrl = function (url) {
            if ((!canvas.fabric._objects.length) && !IES.get().userPreset) {
                canvas.fabric.clear();
                this.createNewCanvas();
                canvas.openImage(url);
            } else {
                canvas.openImage(url);
            }

            $scope.closeUploadDialog();
            IES.get().started = true;
        }

        $scope.closeUploadDialog = function () {
            $scope.canUploadImage = false;
            $scope.openImageMode = 'open';
            $('.img-preview').html();
            $mdDialog.hide();
        };

        //cleanup. remove color picker containers on scope destroy.
        $scope.$on('$destroy', function () {
            $scope.saveData();
            $scope.updateData();
        });

        $scope.updateData = $rootScope.$on('editor.update', function (event, data) {
            $scope.updatePreview();
        });

        $scope.saveData = $rootScope.$on('editor.save', function (event, data) {
            //$log.debug("save message rec");
            $scope.imageListEditedData = [];
            $scope.openSaveDialog(null, data.cb);
        });
    }]);




'use strict';

angular.module('ImageEditor').factory('settings', ['$rootScope', '$http', function($rootScope, $http) {

	var settings = {
        all: {},

        get: function(name) {
            return this.all[name];
        }
	}

    $http.get('app/pages/pixie/config.json').success(function(data) {
        settings.all = data;

        $rootScope.$emit('settings.ready');
    });

	return settings;
}]);
'use strict';

angular.module('ImageEditor')

.factory('saver', ['$rootScope', '$mdDialog', '$http', '$timeout', 'canvas', 'cropper', 'IES', function($rootScope, $mdDialog, $http, $timeout, canvas, cropper, IES) {

	var saver = {
        lastZoom: 0,

        saveImage: function(format, quality, name, e, cb) {
            canvas.fabric.deactivateAll();
            cropper.stop();
            /*
            if (IES.get().isDemo) {
                return this.handleDemoSiteSave(e);
            }

            if (IES.get().isIntegrationMode) {
                return this.handleIntegrationModeSave(format, quality, name);
            }*/

            this.saveToComputer(format, quality, name, cb);
        },

        handleIntegrationModeSave: function(format, quality, name) {
            //canvas.zoom(1);
            var data = this.getDataUrl(format, quality);

            this.handleCallbacks(data, name);

            //firefox integration mode fix
            $('.md-dialog-container').remove();
            
            $mdDialog.hide();
            IES.get().pixie.close();
        },

        saveToComputer: function(format, quality, name, cb) {
            this.lastZoom = canvas.currentZoom;
            canvas.zoom(1);


            var previewData = this.getDataUrl(format, quality);

            //this.handleCallbacks(data, name);

            if(cb) cb( previewData, previewData );

            $mdDialog.hide();
        },

        handleCallbacks: function(data, name) {
            //replace image src with new data url in original window
            if (IES.get().getParam('replaceOriginal') && IES.get().getParam('image')) {
                IES.get().getParam('image').src = data;
            }

            //send image data to user specified url
            if (IES.get().getParam('saveUrl')) {
                $http.post(IES.get().getParam('saveUrl'), { data: data, name: name });
            }

            if (IES.get().getParam('onSave')) {
                var img = IES.get().getParam('image') || new Image(data);
                IES.get().getParam('onSave')(data, img, name);
            }
        },

        handleDemoSiteSave: function(e) {
            $('.demo-alert').one(IES.get().animationEndEvent, function() {
                $(this).removeClass('animated shake');  e.target.blur();
            }).addClass('animated shake');
        },

        getDataUrl: function(format, quality) {
            return canvas.fabric.toDataURL({
                format: format || 'png',
                quality: (quality || 8) / 10
            });
        }
	};

	return saver;
}]);
angular.module('ImageEditor')

.factory('localStorage', function() {
	var storage = {

		/**
		 * How long (days) data will be cached in local storage.
		 * 
		 * @type {Number}
		 */
		expireAfter: 2,

		/**
		 * Retrieve value under given key from local storage.
		 * 
		 * @param  string key
		 * @return mixed
		 */
		get: function(key) {
			var value = JSON.parse(localStorage.getItem(key));
			
			if ( ! value || ! storage.isValid(value.time)) {
				return false;
			}

			return value.value;
		},

		/**
		 * Store value into browser local storage.
		 * 
		 * @param string key
		 * @param mixed value
		 */
		set: function(key, value) {
			var data = { value: value, time: new Date().getTime() };

			return localStorage.setItem(key, JSON.stringify(data));
		},

		/**
		 * Whether or not cache with given time is considered expired.
		 * 
		 * @param  string  time
		 * @return {Boolean}
		 */
		isValid: function(time) {
			var days = (new Date().getTime() - new Date(time).getTime())/(1000*60*60*24);

			return days < storage.expireAfter;
		}
	};

	return storage;
});
'use strict';

angular.module('ImageEditor')

.factory('keybinds', ['$rootScope', 'IES', function($rootScope,IES) {

    var keybinds = {

        fabric: false,

        init: function(fabric) {
            this.fabric = fabric;
            init();
        },

        destroy: function() {
            $('.canvas-container').off("keydown", processKeys, false);
        }
    };

    function init() {
        $(document).on('keydown', handleKeyDown);
    }

    function handleKeyDown(e) {
        e = e || window.event;

        if ([37, 38, 39, 40].indexOf(e.keyCode) > -1) moveObject(e);
        if (e.keyCode === 46) deleteObject();

    }

    function deleteObject() {
        var activeObject = keybinds.fabric.getActiveObject();
        if( activeObject && activeObject.niceName && activeObject.niceName == 'generated text') return;
        if( activeObject && ( activeObject.editable == false ) ) return;
        
        if (activeObject) {
            var obj = activeObject.textObj;
            while( obj && obj != activeObject ){
                keybinds.fabric.remove(obj);
                obj = obj.textObj;
            }
            

            keybinds.fabric.remove(activeObject);
            keybinds.fabric.renderAll();
            IES.get().countButtons();
        }
    }

    function moveObject(e) {
        var movementDelta = 2;

        var activeObject = keybinds.fabric.getActiveObject();
        var activeGroup = keybinds.fabric.getActiveGroup();

        if (e.keyCode === 37) {
            e.preventDefault();
            if (activeObject) {
                var a = activeObject.get('left') - movementDelta;
                activeObject.set('left', a);
            }
            else if (activeGroup) {
                var a = activeGroup.get('left') - movementDelta;
                activeGroup.set('left', a);
            }

        } else if (e.keyCode === 39) {
            e.preventDefault();
            if (activeObject) {
                var a = activeObject.get('left') + movementDelta;
                activeObject.set('left', a);
            }
            else if (activeGroup) {
                var a = activeGroup.get('left') + movementDelta;
                activeGroup.set('left', a);
            }

        } else if (e.keyCode === 38) {
            e.preventDefault();
            if (activeObject) {
                var a = activeObject.get('top') - movementDelta;
                activeObject.set('top', a);
            }
            else if (activeGroup) {
                var a = activeGroup.get('top') - movementDelta;
                activeGroup.set('top', a);
            }

        } else if (e.keyCode === 40) {
            e.preventDefault();
            if (activeObject) {
                var a = activeObject.get('top') + movementDelta;
                activeObject.set('top', a);
            }
            else if (activeGroup) {
                var a = activeGroup.get('top') + movementDelta;
                activeGroup.set('top', a);
            }
        }

        if (activeObject) {
            activeObject.setCoords();
            keybinds.fabric.renderAll();
        } else if (activeGroup) {
            activeGroup.setCoords();
            keybinds.fabric.renderAll();
        }
    }

    return keybinds;
}]);
'use strict';

angular.module('ImageEditor')

.factory('history', ['$rootScope', '$timeout', 'canvas','IES', function($rootScope, $timeout, canvas, IES) {

	var history = {

		all: [],

        //used for backing up canvas and other serializations
        //that are not visible to the user
        ignored: [], 

		add: function(name, icon, ignore) {
            var prop = ignore ? 'ignored' : 'all';

            //make sure don't have duplicates in ignored array
            if (prop === 'ignored') { 
                for (var i = 0; i < this.ignored.length; i++) {
                    if (history.ignored[i].name === name) {
                        history.ignored.splice(i, 1)
                    }
                }
            }

			this[prop].push({
				name: name,
				state: canvas.getDesignPayload(),//canvas.fabric.toJSON(['selectable', 'name']),
				index: history.all.length+1,
				icon: icon,
                zoom: canvas.zoom,
				canvasWidth: canvas.original.width || canvas.fabric.getWidth(),
				canvasHeight: canvas.original.height || canvas.fabric.getHeight()
			});
		},

        save: function(name, prop){
            
            var item = history.get(name,prop);            
            history.all.push( item );
        },

        get: function(name, prop) {
            if ( !prop) prop = 'ignored';

            for (var i = 0; i < history[prop].length; i++) {
                if (history[prop][i].name === name) {
                    return history[prop][i];
                }
            }
        },

		load: function(item) {
			IES.get().isLoading();

            //if we get passed a name, fetch a matching history item
            if (angular.isString(item)) {
                item = history.get(item);
            }

            if ( ! item) {
                return IES.get().isNotLoading();
            }

			setTimeout(function() {
				canvas.setDesignPayload(item.state, null );
                var i = history.all.indexOf(item);
                if( i >= 0 ){
                    var length = history.all.length-i;
                    history.all.splice(i, length);
                }
			}, 30);
		}
	};

	return history;
}]);
angular.module('ImageEditor').controller('EditorUploadsController',
 ['$scope', '$rootScope', '$http', '$state', 'photos', 'canvas', 'folders', 'utils', function($scope, $rootScope, $http, $state, photos, canvas, folders, utils) {

    //uploaded photos user has access to
    $scope.photos = [];

    $scope.openImage = function(photo) {
        canvas.openImage(photo.absoluteUrl);
    };

    //on photo uploaded event open that image in editor
    $rootScope.$on('photos.uploaded', function(e, data) {
        if (data.uploaded && data.uploaded.length) {
            $scope.photos.unshift(data.uploaded[0]);
            $scope.openImage(data.uploaded[0]);
        }
    });

    photos.getAll().success(function(data) {
        $scope.photos = data;
    })
}]);
angular.module('ImageEditor').controller('EditorController', ['$scope', '$rootScope', '$http', '$state', 'folders', 'canvas', 'saver', 'photos', 'utils', 'selectedItem', 'IES', function($scope, $rootScope, $http, $state, folders, canvas, saver, photos, utils, selectedItem, IES) {

    //reference to image currently open in editor (if any)
    $scope.active = {};

    //update image in database
   /* saver.saveImage = function() {
        $scope.ajaxInProgress = true;

        var payload = getDesignPayload($scope.active);

        if (payload.id) {
            var promise = selectedItem.update(payload);
        } else {
            var promise = photos.save(payload);
        }

        promise.success(function(data) {
            utils.showToast('savedPhotoSuccessfully', true);
            $scope.active = data;
        }).finally(function() {
            $scope.ajaxInProgress = false;
        });

        $rootScope.$emit('activity.happened', 'edited', 'photo', [payload]);
    };*/

    //get payload to send to backend for updating image
    /*function getDesignPayload(photo) {
        canvas.fabric.deactivateAll().renderAll();

        var fabricData  = canvas.fabric.toDatalessJSON(['selectable', 'name']);
        fabricData.customActions = angular.copy(IES.get().editorCustomActions);

        //if photo corners were rounded we'll need to encode image as png for transparency
        var extension = fabricData.customActions && fabricData.customActions.roundCorners ? 'png' : photo.extension,
            imageData   = canvas.fabric.toDataURL({ format: extension || 'png', quality: 1 }),
            dimensions  = canvas.original;

        for (var i = 0; i < fabricData.objects.length; i++) {
            var obj = fabricData.objects[i];

            if (obj.name === 'mainImage') {
                obj.src = $scope.active.originalUrl;
                break;
            }
        }
        console.log(fabricData);
        if ( ! angular.isString(fabricData)) {
            fabricData = JSON.stringify(fabricData);
        }

        return {
            id: photo.id,
            name: photo.name || IES.get().userPreset.name,
            folder_id: photo.folder_id || folders.selected.id,
            serialized_editor_state: fabricData,
            imageData:  imageData,
            width: dimensions.width,
            height: dimensions.height,
            extension: extension
        };
    }*/

    var unbind = $rootScope.$on('canvas.init', function() {
        //load image into editor if we have an id in url
        if ($state.params.id) {
            $http.get($rootScope.baseUrl+'photos/'+$state.params.id).success(function(photo) {
                $scope.active = photo;
                selectedItem.set(photo);

                //if we have a serialized state, load that
                if (photo.serialized_editor_state) {
                    canvas.loadFromJSON(photo, loadCustomActions);

                    //otherwise just load image from absolute url
                } else {
                    canvas.loadMainImage(photo.originalUrl);
                }

                $rootScope.started = true;
            });

            //otherwise open a preset if we have one set on $rootScope
        } else {
            canvas.openNew($rootScope.userPreset.width, $rootScope.userPreset.height, $rootScope.userPreset.name);
            $rootScope.started = true;
        }
    });

    $scope.$on('$destroy', function() {
        canvas.destroy();
        IES.get().started = false;
        unbind();
    });

    //prevent fonts pagination links from changing the state
    $('.pagination').click('a', function(e) { e.preventDefault() });

    function loadCustomActions(photo) {
        var state = JSON.parse(photo.serialized_editor_state);

        if (state.customActions && ! $.isEmptyObject(state.customActions)) {
            canvas.fabric.clear();
            canvas.zoom(1);
            canvas.loadMainImage(photo.absoluteUrl);
        }
    }
}]);
angular.module('ImageEditor')

.service('canvas', ['$mdDialog', '$rootScope', '$timeout', 'keybinds', 'IES', function($mdDialog, $rootScope, $timeout, keybinds, IES) {

	var canvas = {       

        original: {},        

        //store window width and height so we don't execute
        //functions unnecessarily on resize event if they didn't change
        oldWindowDimensions: {
            width: window.innerWidth,
            height: window.innerHeight
        },

		mainImage: false,
		fabric: false,
		ctx: false,
		container: false,
		viewport: false,
		offset: false,
		element: false,

        minWidth: 50,
        minHeight: 50,

		imageStatic: {
            locked: true,
			selectable: false,
	      	evented: false,
	      	lockMovementX: true,
	      	lockMovementY: true,
	      	lockRotation: true,
	      	lockScalingX: true,
	      	lockScalingY: true,
	      	lockUniScaling: true,
	      	hasControls: false,
	      	hasBorders: false
		},

        destroy: function() {
            this.fabric.dispose();
            this.mainImage = false;
            this.fabric = false;
            this.ctx = false;
            this.container = false;
            this.viewport = false;
            this.offset = false;
            this.element = false;
            this.original = {};
            this.currentZoom = 1;
            IES.get().editorCustomActions = {};
            $(window).off('resize');
            keybinds.destroy();
        },

		start: function(url) {
            this.element = document.getElementById('canvas');

            this.fabric = new fabric.Canvas('canvas');

            this.fabric.setBackgroundColor('#FFFFFF');
            this.ctx = this.fabric.getContext('2d');
            this.container = $('.canvas-container');
            this.viewport = document.getElementById('viewport');
            IES.get().editorCustomActions = {};

            this.fabric.selection = false; 
            this.fabric.renderOnAddRemove = false;

            fabric.Object.prototype.borderColor = '#2196F3';
            fabric.Object.prototype.cornerColor = '#2196F3';
            fabric.Object.prototype.transparentCorners = false;

            if ( ! url) url = IES.get().getParam('url');

            if (url) {
                this.loadMainImage(url);
                IES.get().started = true;
            } else if (IES.get().getParam('blankCanvasSize')) {
                var size = IES.get().getParam('blankCanvasSize');
                this.openNew(size.width, size.height, 'newCanvas');
                IES.get().started = true;
            }
            /*
            if ( ! IES.get().started && ! IES.get().isIntegrationMode && ! IES.get().delayEditorStart) {
                $mdDialog.show({
                    template: $('#main-image-upload-dialog-template').html(),
                    controller: 'TopPanelController',
                    clickOutsideToClose: false
                });
            }*//*

            $(window).off('resize').on('resize', function(e) {
                if (canvas.oldWindowDimensions.height !== e.target.innerHeight ||
                    canvas.oldWindowDimensions.width !== e.target.innerWidth) {
                    canvas.fitToScreen();
                }

                canvas.oldWindowDimensions.width = e.target.innerWidth;
                canvas.oldWindowDimensions.height = e.target.innerHeight;
            });*/

            $rootScope.$emit('canvas.init');

            keybinds.init(this.fabric);

            if (IES.get().getParam('onLoad')) {
                IES.get().getParam('onLoad')(this.viewport, IES.get(), window); 
            }

            // Add click event listener
            this.fabric.on('mouse:down', function(e) {
                if (e.target && e.target.type === 'image') {
                    IES.get().activeTab = "googleMap";
                }
            });
        },

        hideModals: function() {
            $mdDialog.hide();
        },

        mergeObjects: function() {
            canvas.zoom(1);
            this.fabric.deactivateAll();
            var data = this.fabric.toDataURL();
            this.fabric.clear();
            this.loadMainImage(data);
        },

        setDesignPayload: function(data,cb) {
            IES.get().isLoading();
            var fabricData = data.layout;
            var customActions = data.actions;
            var dimensions = data.dimensions;
            var canvasSize = angular.fromJson(dimensions);
            if( canvasSize.width == 0 || canvasSize.height == 0 ){
                canvasSize.width = IES.get().defaultWidth;
                canvasSize.height = IES.get().defaultHeight;
            }
            canvas.fabric.clear();
            this.openNew( canvasSize.width, canvasSize.height);
            IES.get().editorCustomActions = angular.fromJson(customActions);
            IES.get().generatedText = undefined;
            var buttonCount = 0;
            canvas.fabric.loadFromDatalessJSON( fabricData , function(){
                canvas.fabric.forEachObject(function(obj) {
                    //reapply any filters object used to have
                    if (obj.applyFilters && obj.filters.length) {
                        obj.applyFilters(canvas.fabric.renderAll.bind(canvas.fabric));
                    }

                    if( obj.name == 'text'){
                        canvas.fabric.setActiveObject(obj);
                        obj._controlsVisibility.tl= false;
                        obj._controlsVisibility.tr= false;
                        obj._controlsVisibility.br= false;
                        obj._controlsVisibility.bl= false;
                        obj._controlsVisibility.ml= false;
                        obj._controlsVisibility.mt= false;
                        obj._controlsVisibility.mr= false;
                        obj._controlsVisibility.mb= false;
                        obj._controlsVisibility.mtr= (obj.niceName == 'text');                        
                    }

                    /*if( obj.niceName == 'generated text'){
                        IES.get().generatedText = obj;
                        obj.editable = false;
                    }*/

                    if( obj.name == 'editable'){
                        obj.lockMovementX = true;
                        obj.hasControls = false;
                    }

                    if( obj.niceName && (
                        obj.niceName.indexOf('button rect') == 0 ||
                        obj.niceName.indexOf('button circle') == 0 ||
                        obj.niceName.indexOf('button ellipse') == 0)
                        ){
                        buttonCount++;
                        canvas.fabric.setActiveObject(obj);
                        obj._controlsVisibility.tl= false;
                        obj._controlsVisibility.tr= false;
                        obj._controlsVisibility.br= false;
                        obj._controlsVisibility.bl= false;
                        obj._controlsVisibility.ml= false;
                        obj._controlsVisibility.mt= false;
                        obj._controlsVisibility.mr= false;
                        obj._controlsVisibility.mb= false;
                        obj._controlsVisibility.mtr= false;
                        
                        var number = obj.niceName.replace('button rect ', '').replace('button circle ', '').replace('button ellipse ', '');
                        number = parseInt(number);
                        
                        canvas.fabric.forEachObject(function(text) {
                            if(text.niceName && text.niceName == 'button text '+number ){
                                obj.textObj = text;
                                text.textObj = obj;
                                canvas.fabric.setActiveObject(text);
                                text._controlsVisibility.mtr= false;
                            }
                        });
                        if( obj.textObj ){
                            canvas.fabric.forEachObject(function(icon) {
                                if(icon.niceName && icon.niceName == 'button icon '+number ){
                                    obj.textObj.textObj = icon;
                                    icon.textObj = obj;
                                    canvas.fabric.setActiveObject(icon);
                                    icon._controlsVisibility.mtr= false;
                                }
                            });
                        }
                    }

                });

                IES.get().buttonCount = buttonCount;
                IES.get().started = true;
                
                canvas.fabric.renderAll();
                canvas.fabric.calcOffset();
                canvas.fitToScreen();
                IES.get().activeTab = "basics";
                //IES.get().resetUI();
                //IES.get().openPanel("simple-shapes");
                $rootScope.$emit('history.loaded'); 
               

               $timeout(function(){
                    canvas.zoom(1);
                    canvas.fabric.setWidth(canvasSize.width * canvas.currentZoom);
                    canvas.fabric.setHeight(canvasSize.height * canvas.currentZoom);
                    canvas.original.height = canvasSize.height;
                    canvas.original.width  = canvasSize.width;

                    canvas.fabric.deactivateAllWithDispatch();
                    canvas.fabric.renderAll();
                    canvas.fitToScreen();
                    canvas.fabric.calcOffset();
                    canvas.fitToScreen();                
                    IES.get().isNotLoading();
                    if(cb)cb();
                    $rootScope.$emit('editor.loaded');      
                }, 500);
            });
        },

        createApptText: function() {

        },

        //get payload to send to backend
        getDesignPayload: function() {
            canvas.fabric.deactivateAll().renderAll();
            var fabricData  = canvas.fabric.toDatalessJSON(['selectable', 'name','senderNameChecked','useGoogleMap','selectedMapType','useUserGPS', 'corners','vertical','horizontal','niceName','action','iconfill','imagetype']);
            var dimensions = { width: canvas.original.width, height: canvas.original.height };
            var customActions = angular.copy(IES.get().editorCustomActions);
            var data = {};
            data.layout = JSON.stringify(fabricData);
            data.actions = JSON.stringify(customActions);
            data.dimensions = JSON.stringify(dimensions);

            return data;
        },

        /**
         * Create a new image with given dimensions.
         *
         * @param {int|string} width
         * @param {int|string} height
         * @param {string|undefined} name
         */
        openNew: function(width, height, name) {
            width = width < this.minWidth ? this.minWidth : width;
            height = height < this.minHeight ? this.minHeight : height;

            this.fabric.clear();
            this.fabric.setWidth(width);
            this.fabric.setHeight(height);
            this.fabric.renderAll();
            canvas.fitToScreen();

            //save the dimensions so we can scale images opened later to them
            IES.get().userPreset = {
                width: width,
                height: height,
                name: name
            };

            canvas.original.height = height;
            canvas.original.width = width;

            $rootScope.$emit('canvas.openedNew');
        },

        center: function(obj) {
            obj.center();

            if (canvas.zoom > 100) {
                obj.setLeft(10);
                obj.setTop(35);
            }

            obj.setCoords();
        },

        serialize: function() {
            return this.fabric.toJSON(['selectable', 'name']);
        },

        /**
         * Open image at given url in canvas.
         *
         * @param {string} url
         */
        openImage: function(url) {
            canvas.zoom(1);
            fabric.util.loadImage(url, function(image) {
                if ( ! image) return;

                var object = new fabric.Image(image);
                object.name = 'image';
                object.niceName = 'image';

                //use either main image or canvas dimensions as outter boundaries for scaling new image
                var maxWidth  = canvas.mainImage ? canvas.mainImage.getWidth() : canvas.fabric.getWidth(),
                    maxHeight = canvas.mainImage ? canvas.mainImage.getHeight() : canvas.fabric.getHeight();

                //center and render newly uploaded image on the canvas
                canvas.fabric.add(object);
                object.left = (canvas.fabric.getWidth() - object.getWidth()) / 2;
                object.top = (canvas.fabric.getHeight() - object.getHeight()) / 2;
                object.setCoords();
                canvas.fabric.setActiveObject(object);
                canvas.fitToScreen();
                canvas.fabric.renderAll();
            });
        },

        getDataURL: function(options) {
            if ( ! options) options = {};

            //ignore zoom when getting data url
            options.multiplier = 1 / canvas.currentZoom;

            return this.fabric.toDataURL(options);
        },

        currentZoom: 1,

        zoom: function(scaleFactor) {
            this.fabric.setZoom(scaleFactor);
            this.fabric.setHeight(this.original.height * scaleFactor);
            this.fabric.setWidth(this.original.width * scaleFactor);

            this.currentZoom = scaleFactor;
        },

        fitToScreen: function () {
            var maxWidth  = canvas.viewport.offsetWidth - 40,
                maxHeight = canvas.viewport.offsetHeight - 120,
                outter    = canvas.mainImage || canvas.fabric,
            	scale     = Math.min(maxHeight / outter.getHeight(), maxWidth / outter.getWidth());

            if (outter.getHeight() > maxHeight || outter.getWidth() > maxWidth) {
                canvas.zoom(scale); 
            }
        }
	};

    return canvas;

}]);
(function() {
  'use strict';

  angular
  .module('youApp', ['ImageEditor', 'ngAnimate', 'ngCookies', 'ngMessages', 'ngRoute', 'ui.bootstrap', 'ngMaterial','toastr','mdPickers','uiGmapgoogle-maps', 'bw.paging', 'color.picker']);

})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Terms.Controller', Terms);

  /** @ngInject */
  function Terms($scope, $log, $modalInstance) {
    var vm = this;

    vm.onDone = function() {
      $modalInstance.close();
    }
  }
})();
(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('TemplateConfirm.Controller', TemplateConfirm);

  /** @ngInject */
  function TemplateConfirm($scope, $log) {
    var vm = this;
    vm.parentVM = $scope.$parent.vm;
    vm.data = $scope.$parent.vm.data;
    $log.debug(vm.data);

    vm.onDone = function() {
      if (vm.parentVM.onDone) vm.parentVM.onDone();
    }

    vm.onCancel = function() {
      if (vm.parentVM.onCancel) vm.parentVM.onCancel();
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('SendEmailCampaign.Controller', SendEmailCampaignController);

  /** @ngInject */
  function SendEmailCampaignController(
    $scope,
    $uibModalInstance,
    $rootScope,
    $timeout,
    MessageBoxService,
    UploadFileService,
    EmailTemplateService,
    $window,
    $httpParamSerializer,
    apiUrl,
    $sce
  ) {
    var vm = this;
    var emailTemplate = $scope.$parent.vm.emailTemplates[$scope.$parent.vm.templateid];
    emailTemplate.buttons = emailTemplate.buttons || [];
    vm.emailTemplate = emailTemplate;
    vm.imageRequiredHeight = 600;
    vm.imageRequiredWidth = 600;

    vm.newButton = {};
    vm.newButtonAlt = {};

    // var originalValue = angular.copy(vm.emailTemplate);

    vm.iframeUrl = '';

    vm.colorPickerOptions = {
      format: 'hexString',
      alpha: false,
      case: 'upper',
      inputClass: 'color-picker-input',
      restrictToFormat: true,
      allowEmpty: true
    };

    vm.onSave = function(close) {
      EmailTemplateService.update(vm.emailTemplate, function() {
        $timeout(function() {
          vm.updatePreview();
        }, 100);
        if (close) {
          MessageBoxService.open('Success', 'Successfully updated email template', 'Okay', function() {
            $scope.$parent.vm.loadData();
            $uibModalInstance.close();
          });
        }
      })
    };

    vm.onDone = function() {
      $uibModalInstance.close();
    };

    vm.removeImage = function(field) {
      vm.emailTemplate[field] = null;
      EmailTemplateService.update(vm.emailTemplate, function() {
        $timeout(function() {
          vm.updatePreview();
        }, 100);
      });
    };

    vm.addButton = function(useAlt) {
      if (useAlt) {
        vm.emailTemplate.buttonsalt = vm.emailTemplate.buttonsalt || [];
        vm.emailTemplate.buttonsalt.push(vm.newButtonAlt);
        vm.newButtonAlt = {};
      } else {
        vm.emailTemplate.buttons = vm.emailTemplate.buttons || [];
        vm.emailTemplate.buttons.push(vm.newButton);
        vm.newButton = {};
      }
    }

    vm.deleteButtonAtIndex = function(index, useAlt) {
      if (useAlt) {
        vm.emailTemplate.buttonsalt.splice(index, 1);
      } else {
        vm.emailTemplate.buttons.splice(index, 1);
      }
    }

    vm.updatePreview = function() {
      vm.iframeUrl = $sce.trustAsResourceUrl(apiUrl + '/YAEmailTemplates/' + vm.emailTemplate.id + '/render?t=' + Date.now());
    }

    vm.LoadImage = function(src, file, field) {
      if (file) {
        var tempImage = new Image();

        tempImage.onload = function() {
          var img = tempImage;
          vm.naturalWidth = img.naturalWidth;
          vm.naturalHeight = img.naturalHeight;
          $scope.$apply();
          vm.Upload(src, field);
        };

        tempImage.src = $window.URL.createObjectURL(file);
      }
    };

    vm.UpdateImage = function(element, field) {
      vm[element.id] = element.files[0];
      vm.LoadImage(element.id, element.files[0], field);
    };

    vm.Upload = function(id, field) {
      if (
        vm.imageRequiredHeight >= vm.naturalHeight &&
        vm.imageRequiredWidth >= vm.naturalWidth
      ) {
        UploadFileService.upload(vm[id], function(path, error) {
          if (error === null) {
            vm.emailTemplate[field] = path;
            EmailTemplateService.update(vm.emailTemplate, function() {
              $timeout(function() {
                vm.updatePreview();
              }, 100);
            });
          }
        });
      } else {
        MessageBoxService.open('Image Error', 'The select image must be no larger than ' + vm.imageRequiredWidth + 'x' + vm.imageRequiredHeight, 'Continue', function() { });
      }
    };

    vm.updatePreview();
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('PurchaseReport.Controller', PurchaseReport);

  /** @ngInject */
  function PurchaseReport($scope, report, $modalInstance, OrgReportService, MessageBoxService, CalculateApproval) {
    var vm = this;
    vm.report = report;
    vm.approval = false;

    vm.PurchaseReport = function() {
      if (vm.approval === false) {
        MessageBoxService.open('Please Accept Terms', 'You need to accept the terms by checking the checkbox to bill your account', 'Continue', function() {})
      } else {
        OrgReportService.purchaseReport(vm.report.id, function() {
          MessageBoxService.open('Success!', 'You can now view the report', 'Continue', function() {
            $scope.$parent.vm.loadData();
            $modalInstance.close();
          })
        });
      }
    };

    vm.onDone = function() {
      $modalInstance.close();
    };

    vm.updateApproval = function() {
      CalculateApproval.setApproval(vm.approval);
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('NewSalesPerson.Controller', NewSalesPerson);

  /** @ngInject */
  function NewSalesPerson($scope, $modalInstance, SalesPersonService, SalesOrgService, FormValidationService) {
    var vm = this;
    vm.addedSalesPerson = SalesPersonService.getTempSalesPerson();
    vm.salesOrgId = $scope.$parent.vm.editingOrgID;
    vm.formattedReferralCode = '';
    vm.ePattern = FormValidationService.GetEmailPattern();
    vm.phPattern = FormValidationService.GetPhonePattern();
    vm.refCodeValid = false;
    vm.showCode = false;



    vm.onAdd = function(valid) {
      vm.addedSalesPerson.salespersongroupid = vm.salesOrgId;
      if (valid === true) {
        SalesOrgService.getOrgReferralCodeById(vm.salesOrgId, function(error, data) {
          //format code
          vm.formattedReferralCode = data + '-' + vm.addedSalesPerson.referralcode;
          vm.addedSalesPerson.referralcode = vm.formattedReferralCode;
          SalesPersonService.update(vm.addedSalesPerson, function(error) {
            if (error === null) {
              $scope.$parent.vm.Update();
              $modalInstance.close();
            }
          })
        })
      }
    };

    vm.updateReferralCode = function() {
      vm.addedSalesPerson.referralcode = FormValidationService.UpdateReferralCode(vm.addedSalesPerson.referralcode);
      vm.refCodeValid = vm.addedSalesPerson.referralcode.length === 3;
      vm.showCode = true;
    };

    vm.createValid = function() {
      return vm.phvalid;
    };

    vm.onDone = function() {
      $modalInstance.close();
    };

    vm.phvalid = false;

    vm.updatePhoneNumber = function( ) {
      vm.addedSalesPerson.phone = FormValidationService.UpdatePhoneNumber( vm.addedSalesPerson.phone );
      vm.phvalid = vm.phPattern.test( vm.addedSalesPerson.phone );
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('NewSalesOrg.Controller', NewSalesOrg);

  /** @ngInject */
  function NewSalesOrg($scope, $modalInstance, SalesOrgService, IndTypeService, FormValidationService) {
    var vm = this;
    vm.types = IndTypeService.getTypes();
    vm.industryType = '';
    vm.addedSalesOrg = SalesOrgService.getTempSalesOrg();
    vm.refCodeValid = false;
    vm.showCode = false;


    vm.onAdd = function(valid) {
      if (valid === true) {
        IndTypeService.load(null, function() {
          IndTypeService.setCurrent(vm.industryType);

          vm.addedSalesOrg.industrytypeid = IndTypeService.getCurrent().id;

          SalesOrgService.update(vm.addedSalesOrg, function(error) {
            if ( error === null ) {
              $scope.$parent.vm.Update();
              $modalInstance.close();
            }
          });
        });
      }
    };

    vm.updateReferralCode = function() {
      vm.addedSalesOrg.referralcode = FormValidationService.UpdateReferralCode(vm.addedSalesOrg.referralcode);
      vm.refCodeValid = vm.addedSalesOrg.referralcode.length === 3;
      vm.showCode = true;
    };

    vm.onDone = function() {
      $modalInstance.close();
    };

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('NewGroupUser.Controller', NewGroupUser);

  /** @ngInject */
  function NewGroupUser($scope, $modalInstance, UploadFileService, OrgUserService, FormValidationService) {
    var vm = this;
    vm.addedUser = OrgUserService.grpGetTempUser();
    vm.groupID = $scope.$parent.vm.groupID;
    vm.addedUser.imageFile = null;
    vm.reader = new FileReader( );
    vm.ePattern = FormValidationService.GetEmailPattern();

    vm.onAdd = function(isValid) {
      if (isValid) {
        OrgUserService.grpUpdateUser(vm.addedUser, vm.groupID, function(error) {
          if ( error == null ) {
            $scope.$parent.vm.Update();
            $modalInstance.close();
          }
        });

      }
    }

    vm.onDone = function() {
      $modalInstance.close();
    }

    vm.LoadImage = function(file) {
      //var image = $document[0].getElementById("upload-image");
      vm.reader.onload = function(event) {
        //image.src = event.target.result;
        vm.addedUser.imageFile = event.target.result;
        $scope.$apply();
      };
      vm.reader.readAsDataURL(file);
    }

    vm.UpdateImage = function(element) {
      vm.addedUser.imageFile = element.files[0];
      vm.LoadImage(element.files[0]);
    }

    vm.updatePhoneNumber = function( ) {
      vm.addedUser.phonenumber = FormValidationService.UpdatePhoneNumber( vm.addedUser.phonenumber );
    }

    vm.Upload = function() {
      UploadFileService.upload( vm.addedUser.imageFile, function(path, error) {
        if ( error == null ) {
          vm.addedUser.imageFile = null;
          vm.addedUser.profileimage = path;
        }
      })
    }

    $scope.$on('$destroy', function UnLoaded() {
      vm.reader = null; // garbage collect
    });


  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('NewEmailUser.Controller', NewEmailUserController);

  /** @ngInject */
  function NewEmailUserController($scope, $modalInstance, OrgUserService, FormValidationService) {
    var vm = this;
    vm.addedUser = OrgUserService.grpGetTempUser();
    vm.groupID = $scope.$parent.vm.groupID;
    vm.ePattern = FormValidationService.GetEmailPattern();

    vm.onAdd = function(isValid) {
      if (isValid) {
        OrgUserService.grpUpdateUser(vm.addedUser, vm.groupID, function(error) {
          if ( error === null ) {
            $scope.$parent.vm.Update();
            $modalInstance.close();
          }
        });

      }
    };

    vm.onDone = function() {
      $modalInstance.close();
    };


    vm.updatePhoneNumber = function( ) {
      vm.addedUser.phonenumber = FormValidationService.UpdatePhoneNumber( vm.addedUser.phonenumber );
    };

    $scope.$on('$destroy', function UnLoaded() {
      vm.reader = null; // garbage collect
    });


  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('NewDashboardUser.Controller', NewDashboardUser);

  /** @ngInject */
  function NewDashboardUser(
    $scope,
    $modalInstance,
    UploadFileService,
    OrgUserService,
    FormValidationService,
    loadingScreen,
    addUser
  ) {
    var vm = this;
    vm.addedUser = OrgUserService.getNewUser();
    vm.addedUser.imageFile = null;
    vm.reader = new FileReader( );
    vm.ePattern = FormValidationService.GetEmailPattern();

    vm.onAdd = function(isValid) {
      if (isValid) {
        addUser(vm.addedUser)
        .then(function() {
          $modalInstance.close();
        });
        // OrgUserService.dbUpdate(vm.addedUser, function(error) {
        //   if ( error === null ) {
        //     $scope.$parent.vm.Update();
        //     $modalInstance.close();
        //   }
        // });
      }
    };

    vm.onDone = function() {
      $modalInstance.close();
    };

    vm.LoadImage = function(file) {
      //var image = $document[0].getElementById("upload-image");
      vm.reader.onload = function(event) {
        //image.src = event.target.result;
        vm.addedUser.imageFile = event.target.result;
        $scope.$apply();
      };
      vm.reader.readAsDataURL(file);
    };

    vm.UpdateImage = function(element) {
      vm.addedUser.imageFile = element.files[0];
      vm.LoadImage(element.files[0]);
    };

    vm.updatePhoneNumber = function() {
      vm.addedUser.phonenumber = FormValidationService.UpdatePhoneNumber( vm.addedUser.phonenumber );
    };

    vm.lookupUserByEmail = function() {
      vm.addedUser.id = null;
      OrgUserService.lookupByEmail(vm.addedUser.email)
      .then(function(users) {
        if (users && users.length === 1) {
          vm.addedUser.id = users[0].id;
          vm.addedUser.firstname = users[0].firstname;
          vm.addedUser.lastname = users[0].lastname;
          vm.addedUser.title = users[0].title;
          vm.addedUser.phonenumber = users[0].phonenumber;
        } else {
          vm.addedUser.id = null;
        }
      });
    };

    vm.Upload = function() {
      UploadFileService.upload( vm.addedUser.imageFile, function(path, error) {
        if ( error === null ) {
          vm.addedUser.imageFile = null;
          vm.addedUser.profileimage = path;
        }
      })
    };

    $scope.$on('$destroy', function UnLoaded() {
      vm.reader = null; // garbage collect
    });


  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Message.Controller', MessageController);

  /** @ngInject */
  function MessageController(MessageBoxService) {
    var vm = this;
    vm.data = MessageBoxService.getData();

    vm.Done = function() {
      if ( vm.data.cb ) vm.data.cb();
      vm.data.close();
    }
  }
})();
(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('DeleteUserConfirm.Controller', DeleteUserConfirm);

  /** @ngInject */
  function DeleteUserConfirm($modalInstance, user, groupID, OrgUserService, $rootScope) {
    var vm = this;
    vm.user = user;
    vm.groupID = groupID;
    vm.Remove = function() {
      if (vm.groupID) {
        OrgUserService.grpDeleteUser(user, vm.groupID, function(error) {
          if ( error == null ) {
            $rootScope.$emit('userDeleted');
          }
        });
      } else {
        OrgUserService.dbRemove(vm.user, function(error) {
          if ( error == null ) {
            $rootScope.$emit('userDeleted');
          }
        });
      }

      $modalInstance.close();
    };

    vm.onDone = function() {
      $modalInstance.close();
    };

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('DeleteSalesPerson.Controller', DeleteSalesPerson);

  /** @ngInject */
  function DeleteSalesPerson($modalInstance, user, $scope, SalesPersonService, MessageBoxService) {
    var vm = this;
    vm.userID = user.id;
    vm.Remove = function() {
      SalesPersonService.deleteSalesPerson(vm.userID, function(error) {
        if (error) {
          MessageBoxService.open('Error', 'Try again', 'Okay', function() {})
          $modalInstance.close();
        }
        $scope.$parent.vm.Update();
        $modalInstance.close();
      } );
    };

    vm.onDone = function() {
      $modalInstance.close();
    };

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('DeleteRespondentConfirm.Controller', DeleteRespondentConfirm);

  /** @ngInject */
  function DeleteRespondentConfirm($modalInstance, confirmFun) {
    var vm = this;
    vm.confirmFun = confirmFun;
    vm.Remove = function() {

      vm.confirmFun();
      $modalInstance.close();
    };

    vm.onDone = function() {
      $modalInstance.close();
    };

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('DeleteOrgConfirm.Controller', DeleteOrgConfirm);

  /** @ngInject */
  function DeleteOrgConfirm($modalInstance, $scope) {
    var vm = this;
    vm.org = $scope.$parent.vm.org;

    vm.Remove = function() {
      $scope.$parent.vm.DeleteOrg();
      $modalInstance.close();
    };

    vm.onDone = function() {
      $modalInstance.close();
    };

  }
})();
(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('DeleteGroupConfirm.Controller', DeleteGroupConfirm);

  /** @ngInject */
  function DeleteGroupConfirm($modalInstance, confirmFun) {
    var vm = this;
    vm.confirmFun = confirmFun;
    vm.Remove = function() {

      vm.confirmFun();
      $modalInstance.close();
    };

    vm.onDone = function() {
      $modalInstance.close();
    };

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('DeleteDashboardUserConfirm.Controller', DeleteDashboardUserConfirm);

  /** @ngInject */
  function DeleteDashboardUserConfirm($modalInstance, user, groupID, OrgUserService, $rootScope, remove) {
    var vm = this;
    vm.user = user;
    vm.groupID = groupID;
    vm.Remove = function() {
      remove()
      .then(function() {
        $rootScope.$emit('userDeleted');
        $modalInstance.close();
      });
    };

    vm.onDone = function() {
      $modalInstance.close();
    };

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('DeleteDashboardGroupConfirm.Controller', DeleteDashboardGroupConfirm);

  /** @ngInject */
  function DeleteDashboardGroupConfirm($modalInstance, confirmFun) {
    var vm = this;
    vm.confirmFun = confirmFun;
    vm.Remove = function() {

      vm.confirmFun();
      $modalInstance.close();
    };

    vm.onDone = function() {
      $modalInstance.close();
    };

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('DeleteBillingInfo.Controller', DeleteBillingInfo);

  /** @ngInject */
  function DeleteBillingInfo($scope, $modalInstance) {
    var vm = this;

    vm.Remove = function() {
      $scope.$parent.vm.Remove();
      $modalInstance.close();
    };

    vm.onDone = function() {
      $modalInstance.close();
    };

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('ConfirmSend.Controller', ConfirmSend);

  /** @ngInject */
  function ConfirmSend($scope, $modalInstance) {
    var vm = this;

    vm.Confirm = function() {
      $scope.$parent.vmp.finish();
      $modalInstance.close();
    };

    vm.onDone = function() {
      $modalInstance.close();
    };

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AddMaxCat.Controller', AddMaxCat);

  /** @ngInject */
  function AddMaxCat($scope, $modalInstance, CalculateApproval, OrganizationService, MessageBoxService) {
    var vm = this;
    vm.approval = false;
    vm.orgID = $scope.$parent.vm.orgID;

    vm.AddMaxCat = function() {
      if (vm.approval === false) {
        MessageBoxService.open('Please Accept Terms', 'You need to accept the terms by checking the checkbox to bill your account', 'Continue', function() {})
      } else {
        OrganizationService.addMaxCategory(vm.orgID, function(result) {
          MessageBoxService.open('Success!', 'You now have a total combination of ' + result + ' categories and recipient groups that you can use. A payment receipt will be sent to your billing email.', 'Continue', function() {
            $scope.$parent.vm.Update();
            $scope.$parent.vm.AddCatFromModal();
            $modalInstance.close();
          })
        });
      }
    };

    vm.onDone = function() {
      $modalInstance.close();
    };

    vm.updateApproval = function() {
      CalculateApproval.setApproval(vm.approval);
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('UserSetup.Controller', UserSetupController);

  /** @ngInject */
  function UserSetupController($scope, $routeParams, $log, $timeout, $document, OrgUserService, UploadFileService, OrganizationService, StateService) {
    var vm = this;
    vm.name = 'Users';
    vm.orgID = $routeParams.orgID;
    vm.reader = new FileReader( );
    vm.permissions = OrgUserService.getPermissions();

    vm.loadData = function() {
      OrgUserService.dbUserLoad( function() {
        vm.Update();
      });
    }

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.Update = function() {
      vm.users = OrgUserService.dbGet();
      $timeout( function() {
        for ( var i = 0; i < vm.users.length; i++) {
          if ( vm.users[i].profileurl != null && vm.users[i].profileurl != '') {
            var image = $document[0].getElementById('display' + i);
            image.src = vm.users[i].profileurl;
          }
        }
      }, 0.1);
    }

    vm.Remove = function(/*index*/) {
      /*OrgUserService.dbRemove(index, function(){
          vm.Update();
      });*/
    }

    vm.OpenEdit = function(index) {
      vm.users[index].edit = true;
    }

    vm.CloseEdit = function(index) {
      vm.users[index].edit = false;
      OrgUserService.dbUpdate(index, function() {
        vm.Update();
      });
    }

    vm.AddNew = function() {
      //OrgUserService.add();
      vm.Update();
    }

    vm.LoadImage = function(index, file) {
      var image = $document[0].getElementById('display' + index);
      vm.reader.onload = function(event) {
        image.src = event.target.result;
        $scope.$apply();
      };
      vm.reader.readAsDataURL(file);
    }

    vm.UpdateImage = function(index, element) {
      vm.users[index].imageFile = element.files[0];
      vm.LoadImage(index, element.files[0]);
    }

    vm.CSVFile = function(element) {
      vm.reader.onload = function(event) {
        $log.debug(event.target.result);
        OrgUserService.dbLoadCSVFile(event.target.result, false, function() {
          vm.Update();
        });
      };
      vm.reader.readAsText(element.files[0]);
    }

    vm.Upload = function(id) {
      UploadFileService.upload( vm.users[id].imageFile, function(path, error) {
        if ( error == null ) {
          vm.users[id].imageFile = null;
          vm.users[id].profileurl = path;
        }
      })
    }

    vm.Back = function() {
      StateService.go('catsetup');
    }

    vm.Continue = function() {
      OrganizationService.setState('usersetup', function() {
        StateService.go('payment');
      });
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {

    });

    $scope.$on('$destroy', function UnLoaded() {
      vm.reader = null; // garbage collect
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('UserRequest.Controller', UserRequestController);

  /** @ngInject */
  function UserRequestController($log, $scope, $routeParams, $rootScope, $document, $timeout, OrgUserService, OrganizationService, UserService, UploadFileService, StateService) {
    var vm = this;
    vm.name = 'User Page';
    vm.orgID = $routeParams.orgID;
    vm.reader = new FileReader( );
    vm.permissionList = OrgUserService.getPermissionList();

    vm.loadData = function() {
      UserService.load(function() {
        OrgUserService.dbUserLoad( function() {
          OrgUserService.dbLoadMyUser( ['orgadmin'], function() {
            vm.mypermission = OrgUserService.dbGetMyPermissions('orgadmin');
            vm.Update();
            $timeout(function() {
              $rootScope.$emit('page.ready');
            }, 100);
          });
        });
      });
    };

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.Update = function() {

    };

    vm.CanApprove = function(user) {
      return OrgUserService.isRequestingUser(user) && vm.mypermission;
    };

    vm.DenyUser = function(/*user*/) {

    }

    vm.ApproveUser = function(/*user*/) {

    }

    vm.Done = function() {
      StateService.go('user');
    }

    vm.Remove = function(/*index*/) {
      if ( vm.mypermission ) {
        /*OrgUserService.dbRemove(index, function(error){
          if( error == null ){
            vm.Update();
          }
        });*/
      }
    }

    vm.OpenEdit = function(index) {
      if ( vm.mypermission ) {
        vm.users[index].edit = true;
      }
    }

    vm.CloseEdit = function(index) {
      vm.users[index].edit = false;
      // assign workflowadmin id
      var name = vm.users[index].workflowadminName;
      for (var i = 0; i < vm.workFlowAdmins.length; i++) {
        if ( name == vm.workFlowAdmins[i].name) {
          vm.users[index].workflowadminid = vm.workFlowAdmins[i].id;
          break;
        }
      }
      OrgUserService.dbUpdate(index, function(error) {
        if ( error == null ) {
          vm.Update();
        }
      });
    }

    vm.AddNew = function() {
      if ( vm.mypermission ) {
        // OrgUserService.add();
        vm.Update();
      }
    }

    vm.LoadImage = function(index, file) {
      var image = $document[0].getElementById('display' + index);
      vm.reader.onload = function(event) {
        image.src = event.target.result;
        $scope.$apply();
      };
      vm.reader.readAsDataURL(file);
    }

    vm.UpdateImage = function(index, element) {
      vm.users[index].imageFile = element.files[0];
      vm.LoadImage(index, element.files[0]);
    }

    vm.CSVFile = function(element) {
      if ( vm.mypermission ) {
        vm.reader.onload = function(event) {
          $log.debug(event.target.result);
          OrgUserService.dbLoadCSVFile(event.target.result, false, function() {
            vm.Update();
          });
        };
        vm.reader.readAsText(element.files[0]);
      }
    }

    vm.Upload = function(id) {
      UploadFileService.upload( vm.users[id].imageFile, function(path, error) {
        if ( error == null ) {
          vm.users[id].imageFile = null;
          vm.users[id].profileurl = path;
        }
      })
    }

    vm.Back = function() {
      StateService.go('catsetup');
    }

    vm.Continue = function() {
      OrganizationService.setState('usersetup', function() {
        StateService.go('payment');
      });
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {

    });

    $scope.$on('$destroy', function UnLoaded() {
      vm.reader = null; // garbage collect
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('UserJoin.Controller', UserJoinController)
  .directive('yaJoiningAccount', yaJoiningAccount);

  /** @ngInject */
  function UserJoinController($scope, $routeParams) {
    var vm = this;
    vm.token = $routeParams.token;
    vm.orgName = $routeParams.organizationName;

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

function yaJoiningAccount() {

  var directive = {
    restrict: 'E',
    templateUrl: 'app/pages/userjoin/onjoining-createaccount.html',
    scope: { },
    controller: yaJoiningAccountCtrl,
    controllerAs: 'vm',
    bindToController: true
  };
  return directive;

}

/** @ngInject */
function yaJoiningAccountCtrl(
  $location,
  $window,
  $document,
  $log,
  $scope,
  UserService,
  OrganizationService,
  OrgUserService,
  FormValidationService,
  MessageBoxService,
  StateService,
  $routeParams,
  ClasslinkService
) {
  var vm = this;
  vm.email = $routeParams.email;
  vm.params = $location.search();
  vm.password = '';
  vm.phoneNumber = '';
  vm.birthday = '';
  vm.ePattern = FormValidationService.GetEmailPattern();
  vm.phPattern = FormValidationService.GetPhonePattern();
  vm.bdPattern = FormValidationService.GetDatePattern();
  vm.isUserExist = true;
  vm.isOrgDetected = false;

  vm.getCtrl = function(ctrl) {
    vm.stepperCtrl = ctrl;
    vm.loaded();
  };

  vm.loaded = function() {
    if (vm.params.code) {
      ClasslinkService.exchangeCodeForAccessToken(vm.params.code, function(error, response) {
        if (response && response.data && response.data.access_token) {
          UserService.loginWithClasslink(response.data.access_token, function(error, result) {
            if (error) {
              UserService.logout();
              MessageBoxService.open(
                'Oh no!',
                'Something went wrong!',
                'ok',
                function() {
                }
              );
              return;
            }
            if (result) {
              UserService.dbAcceptInvite($routeParams.token, function(error, result) {
                if (error === null) {
                  OrganizationService.loadByID(result.organizationid, function() {

                    var width = $window.innerWidth
                      || $document.documentElement.clientWidth
                      || $document.body.clientWidth;

                    if (width < 768) {
                      StateService.go('mobilelanding');
                    } else {
                      StateService.go('dashboard');
                    }
                  });
                } else {
                  MessageBoxService.open(
                    'Error',
                    'We were unable to complete your request. Please try again or contact support.',
                    'ok',
                    function() {
                    }
                  );
                }
              });
            }
          });
        } else {
          $log.log(error)
        }
      });
    }
  };

  vm.resetPassword = function() {
    UserService.exists( vm.email, function(error, doesExist) {
      if ( doesExist ) {
        UserService.sendResetPassword({
          'email': vm.email
        }, function(error) {
          if (error) {
            MessageBoxService.open(
              'ERROR',
              error,
              'ok',
              function() { }
            );
          } else {
            MessageBoxService.open(
              'Success',
              'Check your email for password reset request.',
              'ok',
              function() {
              }
            );
          }
        });
      } else {
        MessageBoxService.open(
          'ERROR',
          'No matching email found.',
          'ok',
          function() {
          }
        );
      }
    });
  };

  vm.bdvalid = false;
  vm.phvalid = false;

  vm.updatePhoneNumber = function( ) {
    vm.phoneNumber = FormValidationService.UpdatePhoneNumber( vm.phoneNumber );
    vm.phvalid = vm.phPattern.test( vm.phoneNumber );
  };

  vm.updateBirthdate = function( ) {
    vm.birthday = FormValidationService.UpdateBirthDate( vm.birthday );
    vm.bdvalid = vm.bdPattern.test( vm.birthday );
    vm.bdvalid = FormValidationService.isValidBirthday(vm.birthday);
  };

  vm.createValid = function() {
    return vm.bdvalid && vm.phvalid && vm.signupForm.$valid;
  };

  vm.isEmailDone = function() {
    return !vm.checkingEmail;
  };

  vm.isEmailExist = function( ) {
    return vm.isUserExist && !vm.checkingEmail && vm.email !== '';
  };

  vm.isLoggedIn = function( ) {
    return UserService.isLoggedIn();
  };

  vm.logout = function( ) {
    UserService.logout();
    vm.email = '';
    vm.password = '';
    vm.reset();
    vm.stepperCtrl.setCurrent(0);
  };

  vm.finished = function() {
    OrgUserService.dbAcceptInvite($routeParams.token, function(error, result) {
      if (error === null) {
        OrganizationService.loadByID(result.organizationid, function() {

          var width = $window.innerWidth
            || $document.documentElement.clientWidth
            || $document.body.clientWidth;

          if (width < 768) {
            StateService.go('mobilelanding');
          } else {
            StateService.go('dashboard');
          }
        });
      } else {
        MessageBoxService.open(
          'Error',
          'We were unable to complete your request. Please try again or contact support.',
          'ok',
          function() {
          }
        );
      }
    });
  };

  vm.orgsDetected = function() {
    // turn on organizations
    vm.stepperCtrl.elementList[2].setup(true, true, false);
    vm.stepperCtrl.setNumbers();
  };

  vm.reset = function() {
    // turn off
    vm.stepperCtrl.elementList[1].setup(true, false, false);
    vm.stepperCtrl.elementList[2].setup(false, false, false);
    vm.password = '';
  };

  vm.newUser = function( ) {
    vm.stepperCtrl.elementList[1].setup(false, false, false);
    vm.stepperCtrl.elementList[2].setup(true, false, false);
    vm.stepperCtrl.setNumbers();
  };

  vm.checkEmail = function() {

    if ( UserService.isLoggedIn() ) {
      UserService.logout();
      vm.password = '';
    }

    vm.checkingEmail = true;
    UserService.exists( vm.email, function(error, doesExist) {
      vm.checkingEmail = false;
      vm.isUserExist = doesExist;
      if ( !vm.isUserExist ) {
        vm.newUser( );
      } else {
        vm.reset();
      }

    });

  };

  vm.signInWithClasslink = function() {
    var here = $location.absUrl();
    location.href = ClasslinkService.getProfileAccessUrl(here);
  };

  vm.checkEmail();

  vm.onBack = function() {
    if ( vm.stepperCtrl.moveBack() ) {
      location.assign('/#/');
    }
  };

  vm.onEmail = function(isValid) {
    if ( isValid && !vm.checkingEmail ) {
      vm.stepperCtrl.moveToNext();
    }
  };

  vm.onPassword = function(isValid) {
    if ( isValid ) {

      if ( UserService.isLoggedIn() && UserService.getEmail() === vm.email ) {
        vm.finished();
      } else {
        UserService.login({
          'email': vm.email,
          'password': vm.password
        }, function(error) {
          if (error === null) {
            vm.finished();
          }
        });
      }
    }
  };

  vm.onSignup = function(isValid) {
    if (isValid && vm.createValid() ) {

      UserService.register({
        'password': vm.password,
        'email': vm.email
      }, function(error) {
        if (error === null) {
          vm.finished();
        }
      });
    }
  };

  vm.onConfirm = function(/*isValid*/) {
    vm.finished();
  };

  $scope.$on('$destroy', function UnLoaded() {

  });

}

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('User.Controller', UserController);

  /** @ngInject */
  function UserController($log, $scope, $routeParams, $rootScope, $document, $uibModal, $timeout, OrgUserService, OrganizationService, UploadFileService, MessageBoxService, UserService, StateService, FormValidationService,$location) {
    var vm = this;
    vm.name = 'User Page';
    vm.user = OrgUserService.getNewUser();
    vm.orgID = $routeParams.orgID;
    vm.exportLink = OrgUserService.getCsvExportLink(vm.orgID, null);
    vm.reader = new FileReader();
    vm.workFlowAdmins = [];
    vm.totalPages = 0;
    vm.currentPage = 0;
    vm.workFlowAdminNames = [];
    vm.permissionList = OrgUserService.getPermissionList();
    vm.helpTipList = ['You may add an individual user manually, or you may upload a CSV of multiple users.'];
    vm.showInviteAll = true;
    vm.filter = $location.search().email ? $location.search().email : '';
    vm.loadData = function() {
      UserService.load(function() {
        OrgUserService.dbLoadMyUser([], function() {
          vm.mypermission = OrgUserService.dbGetMyPermissions('orgadmin');
          vm.Update();

          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
        });
      });
    };

    // check to see if data should reload
    if (vm.orgID !== OrganizationService.getID()) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.Update = function() {
      OrgUserService.userMaxPage(vm.orgID, function(result) {
        vm.totalPages = result;

        OrgUserService.userLoadByPage(vm.orgID, vm.currentPage, (vm.filter || ''), function() {
          vm.users = OrgUserService.dbGet();

          vm.workFlowAdmins = [];
          vm.workFlowAdminNames = [];
          vm.workFlowAdmins = OrgUserService.dbGetWorkFlowAdmins();
          vm.workFlowAdmins.forEach(function(admin) {
            var name = admin.firstname + ' ' + admin.lastname;
            if (vm.workFlowAdminNames.indexOf(name) === -1) {
              vm.workFlowAdminNames.push(name);
            }
          });

          $timeout(function() {
            for (var i = 0; i < vm.users.length; i++) {
              if (vm.users[i].profileimage !== null && vm.users[i].profileimage !== '') {
                var image = $document[0].getElementById('display' + i);
                image.src = vm.users[i].profileimage;
              }
              vm.users[i].canInvite = vm.isUninvitedUser(vm.users[i]);
              vm.users[i].canReinvite = vm.isInvitedUser(vm.users[i]);
            }

          }, 0.1);
          $timeout(function() {
            $rootScope.$emit('page.ready');
            $scope.$apply();
          }, 100);
        });
      });

      vm.canInvite = function(user) {
        if (!user.userid) {
          return vm.isUninvitedUser(user);
        } else if (user.loggedin && !user.optout) {
          return false;
          // return !user.loggedin && !user.optout;
        } else {
          return false;
        }
      };

      vm.canRemind = function(user) {
        if (!user.userid) {
          return false;
        } else if (user.loggedin && !user.optout) {
          return false;
        } else {
          return !user.optout;
        }
      };

      vm.canReinvite = function(user) {
        if (!user.userid) {
          return vm.isInvitedUser(user);
        } else if (user.loggedin && !user.optout) {
          return false;
        } else {
          return false;
        }
      };

      vm.onPage = function() {
        vm.Update();
      };

      vm.isUninvitedUser = function(user) {
        return OrgUserService.isUninvitedUser(user) && vm.mypermission;
      };

      vm.isInvitedUser = function(user) {
        return OrgUserService.isInvitedUser(user) && vm.mypermission;
      };

      vm.Requesting = function() {
        StateService.go('userrequest');
      };

      vm.SendInvite = function(user) {
        OrgUserService.dbSendInvite(user, function(error) {
          if (error === null) {
            MessageBoxService.open('Invite Sent ', 'Email sent to ' + user.email, 'OK', function() {
              //this user has been sent an invite, so switch the toggle to reinvite
              user.canInvite = false;
              user.canReinvite = true;
            });
          } else {
            MessageBoxService.open('Error', 'Could not send invite to ' + user.email + ' try again later', 'OK', function() {
              vm.Update()
            });
          }
        });
      };

      vm.InviteAll = function() {
        OrgUserService.dbSendRemindAll({
          organizationid: Number(vm.orgID),
          dashboard: true
        }, function(err) {
          if (err === null) {
            MessageBoxService.open('Invites Sent', 'An email has been sent to all eligible users', 'OK', function() {
              vm.Update()
            });
          } else {
            MessageBoxService.open('Error', 'Could not send invites, try again later', 'OK', function() {
              vm.Update()
            });
          }
        });


        // OrgUserService.dbSendInviteAll( function (error) {
        //   if (error === null) {
        //     MessageBoxService.open("Invites Sent", "An email has been sent to all eligible users", "OK", function () {
        //       vm.Update()
        //     });
        //   } else {
        //     MessageBoxService.open("Error", "Could not send invites, try again later", "OK", function () {
        //       vm.Update()
        //     });
        //   }
        // });
      };

      vm.deleted = $rootScope.$on('userDeleted', function() {
        vm.Update();
      });

      vm.ConfirmRemove = function(user) {
        if (!vm.mypermission) {
          MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {
          });
          return;
        }

        if (vm.mypermission) {
          vm.popup = $uibModal.open({
            templateUrl: 'app/popups/deleteuserconfirm/deleteuserconfirm.html',
            controller: 'DeleteUserConfirm.Controller as vm',
            windowClass: 'template-box',
            scope: $scope,
            resolve: {
              user: function() {
                vm.user = user;
                return vm.user;
              },
              groupID: function() {
                return null;
              }
            }
          });
        }
      };

      vm.Remove = function(user) {
        if (!vm.mypermission) {
          MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {
          });
          return;
        }

        if (vm.mypermission) {
          OrgUserService.dbRemove(user, function(error) {
            if (error === null) {
              vm.Update();
            }
          });
        }
      };

      vm.updatePhoneNumber = function(user) {
        user.phonenumber = FormValidationService.UpdatePhoneNumber(user.phonenumber);
      };

      vm.getStatus = function(user) {
        var invite = OrgUserService.getInvite(user);

        if (user.userid) {
          if (user.optout) {
            return 'Opted Out';
          } else if (user.loggedin) {
            return 'Opted In';
          // } else if (invite) {
          //   var d = moment(Date.parse(invite.modifieddate));
          //   return 'Logged Out (' + d.format('MM/DD/YYYY') + ')';
          } else {
            return 'Logged Out';
          }
        } else if (invite) {
          var d = moment(Date.parse(invite.modifieddate));
          return 'Invited (' + d.format('MM/DD/YYYY') + ')';
        } else {
          return 'New';
        }
      };

      vm.OpenEdit = function(user) {
        vm.showInviteAll = false;
        vm.workFlowAdminNames.forEach(function(admin, index) {
          if (admin === (user.firstname + ' ' + user.lastname)) {
            vm.workFlowAdminNames.splice(index, 1);
          }
        });

        if (vm.mypermission) {
          OrgUserService.dbGetAdmin(user, function(error, myAdmin) {
            if (error === null) {
              if (!myAdmin.firstname) user.workflowadminName = 'None';
              else user.workflowadminName = (myAdmin.firstname + ' ' + myAdmin.lastname);
              user.edit = true;
            }
          });
        } else {
          MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {
          });
        }
      };

      vm.CloseEdit = function(user) {
        vm.showInviteAll = true;
        user.edit = false;

        if (user.permissions.length > 0) {
          user.workflowaccess = user.permissions[0];
          user.templateaccess = user.permissions[1];
          user.reportaccess = user.permissions[2];
          user.alertaccess = user.permissions[3];
          user.advertisementaccess = user.permissions[4];
          user.announcementaccess = user.permissions[5];
          user.appointmentaccess = user.permissions[6];
          user.orgadmin = user.permissions[7];
        }

        var name = user.workflowadminName;
        if (name && name.toLowerCase().trim() === 'none') {
          OrgUserService.dbRemoveWorkflowAdmin(user, function() {
            vm.Update();
          })
        }
        var admin = {};
        // assign workflowadmin id
        for (var i = 0; i < vm.workFlowAdmins.length; i++) {
          if (name === vm.workFlowAdmins[i].firstname + ' ' + vm.workFlowAdmins[i].lastname) {
            admin = vm.workFlowAdmins[i];
            user.workflowadminid = vm.workFlowAdmins[i].id;
            break;
          }
        }
        OrgUserService.dbSetAdmin(user, admin, function() {
          OrgUserService.dbUpdate(user, function(error) {
            if (error === null) {
              vm.Update();
            }
          });
        });
      };

      vm.AddNew = function() {

        if (!vm.mypermission) {
          MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {
          });
          return;
        }

        if (vm.mypermission) {
          vm.popup = $uibModal.open({
            templateUrl: 'app/popups/newdashboarduser/newdashboarduser.html',
            controller: 'NewDashboardUser.Controller as vm',
            windowClass: 'template-box',
            scope: $scope,
            resolve: {
              addUser: function() {
                return function(addedUser) {
                  return new Promise(function(resolve, reject) {
                    OrgUserService.dbUpdate(addedUser, function(error) {
                      if ( error === null ) {
                        vm.Update();
                        resolve();
                      } else {
                        reject(error);
                      }
                    });

                  });
                };
              }
            }
          });
        }
        /*
         if( vm.mypermission ){
         OrgUserService.dbAdd();
         vm.users = OrgUserService.dbGet();
         vm.users[0].edit = true;
         //this is only needed by this view, so we don't want to
         //add these fields to the model
         vm.users[0].canInvite = true;
         vm.users[0].canReinvite = false;
         } */
      };

      vm.UploadUsers = function(index) {
        var element = $document[0].getElementById(index);
        element.value = '';
      };

      vm.CSVFile = function(element) {

        if (!vm.mypermission) {
          MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {
          });
          return;
        }

        if (vm.mypermission) {
          vm.reader.onload = function(event) {
            $log.debug(event.target.result);

            OrgUserService.dbLoadCSVFile(event.target.result, true, function(error) {
              if (error === null) {
                vm.Update();
              }
            });
          };
          vm.reader.readAsText(element.files[0]);

        }
      };

      vm.LoadImage = function(index, file) {
        var image = $document[0].getElementById('display' + index);
        vm.reader.onload = function(event) {
          image.src = event.target.result;
          $scope.$apply();
        };
        vm.reader.readAsDataURL(file);
      };

      vm.UpdateImage = function(index, element) {
        vm.users[index].imageFile = element.files[0];
        vm.LoadImage(index, element.files[0]);
      };

      vm.Upload = function(id) {
        UploadFileService.upload(vm.users[id].imageFile, function(path, error) {
          if (error === null) {
            vm.users[id].imageFile = null;
            vm.users[id].profileimage = path;
          }
        })
      };

      vm.Back = function() {
        StateService.go('catsetup');
      };

      vm.Continue = function() {
        OrganizationService.setState('usersetup', function() {
          StateService.go('payment');
        });
      };

      $scope.$on('$viewContentLoaded', function ContentLoaded() {

      });

      $scope.$on('$destroy', function UnLoaded() {
        vm.reader = null; // garbage collect
        vm.deleted = null;
      });

    }
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Unsubscribe.Controller', UnsubscribeController);

  /** @ngInject */
  function UnsubscribeController(UserService, $scope, $routeParams) {
    var vm = this;
    vm.status = 'Unsubscribing...';
    var code = $routeParams.code;
    UserService.unsubscribe(code, function(err, isUnsubscribed) {
      if (err || !isUnsubscribed) {
        vm.status = 'We weren\'t able to complete your request. Please contact support.';
      } else {
        vm.status = 'You have successfully unsubscribed from Alert Reminder Emails.';
      }
    });
  }

})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Support.Controller', SupportController);

  function SupportController() {
    var vm = this;
    vm.helpTipList = ['Tip: here you can navigate the help tips to find a solution'];
    var d = document,
      accordionToggles = d.querySelectorAll('.js-accordionTrigger'),
      switchAccordion;

    //function
    switchAccordion = function(e) {
      e.preventDefault();
      var thisAnswer = e.target.parentNode.nextElementSibling;
      var thisQuestion = e.target;

      thisQuestion.classList.toggle('is-expanded');
      thisAnswer.classList.toggle('is-collapsed');

      thisAnswer.classList.toggle('animateIn');
    };

    for (var i = 0, len = accordionToggles.length; i < len; i++) {
      accordionToggles[i].addEventListener('click', switchAccordion, false);
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('SignUpOrg.Controller', SignUpOrgController);

  /** @ngInject */
  function SignUpOrgController($scope, $uibModal, IndTypeService, BusCatService, OrganizationService, OrgSaleService) {
    var vm = this;

    vm.currentType = '';
    vm.types = [];
    vm.currentCat = '';
    vm.categories = [];
    vm.code = '';

    vm.loadData = function() {
      OrganizationService.loadList( false, function() {
        IndTypeService.load(null, function() {
          vm.list = OrganizationService.getList();

          vm.types = IndTypeService.getTypes();
          IndTypeService.setCurrentByID( OrganizationService.get().industrytypeid );
          vm.currentType = IndTypeService.getCurrent().name;

          BusCatService.load( function(error) {
            if ( error == null ) {
              vm.currentCat = '';
              vm.categories = [];
            }
          });

          IndTypeService.setUserCount(0);

        });
      });
    }

    vm.loadData();

    vm.getCurrentIndustryType = function( ) {
      if (vm.currentType === '') {
        return 'INDUSTRY TYPE';
      }
      else {
        return vm.currentType;
      }
    }

    vm.getCurrentCategories = function( ) {
      if (vm.currentCat === '') {
        return 'CATEGORY';
      }
      else {
        return vm.currentCat;
      }
    }

    vm.Back = function() {
      if ( vm.list && vm.list.length > 0)
        location.assign('/#/continue');
      else
        location.assign('/#/');
    }

    vm.Continue = function() {
      if ( vm.code != '' ) {
        OrgSaleService.setCode(vm.code);
        OrgSaleService.verify(function() {
          OrgSaleService.setSalesPerson(function() {
            location.assign('/#/setup');
          })
        })
      } else {
        location.assign('/#/setup');
      }
    }

    vm.Update = function( ) {
      vm.ready = ( vm.currentCat != '' && vm.currentType != '' );
      IndTypeService.setCurrent(vm.currentType);
      vm.categories = BusCatService.getCategories(IndTypeService.getID());
      vm.currentCat = '';
      BusCatService.setCurrent(vm.currentCat);

    }

    vm.UpdateCat = function( ) {
      vm.ready = ( vm.currentCat != '' && vm.currentType != '' );
      BusCatService.setCurrent(vm.currentCat);
      OrgSaleService.setCode(vm.code);
    }

    $scope.$on('$destroy', function UnLoaded() {
    });
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('SetUp.Controller', SetUpController);

  /** @ngInject */
  function SetUpController($scope, $routeParams, BusCatService, IndTypeService, OrganizationService, OrgSaleService, FormValidationService, StateService) {
    var vm = this;
    vm.name = 'Setup Organization Page';
    vm.orgID = $routeParams.orgID;
    //regex patterns for validation
    vm.ePattern = FormValidationService.GetEmailPattern();
    vm.phPattern = FormValidationService.GetPhonePattern();
    vm.zPattern = FormValidationService.GetZipPattern();

    vm.loadData = function() {
      OrgSaleService.loadSalesPerson(function(data, error) {
        if ( data && error == null ) {
          vm.profile.salesRep = data.firstname + ' ' + data.lastname;
        }
      });
      vm.states = FormValidationService.GetStates();
      vm.profile = {};
      vm.orgID = $routeParams.orgID;
      vm.profile = OrganizationService.get();
      vm.profile.busCat = BusCatService.getCurrent().name;
      vm.profile.indType = IndTypeService.getCurrent().name;
    }

    if ( vm.orgID && vm.orgID != -1 ) {
      BusCatService.load( function() {
        IndTypeService.load(null, function() {
          OrganizationService.loadByID(vm.orgID, function() {
            BusCatService.getOrgBusCat(function() {
              IndTypeService.setCurrentByID(OrganizationService.get().industrytypeid);
              vm.loadData();
            });
          });
        });
      });
    }
    else if ( IndTypeService.getCurrent( ).name == '' ) {
      location.assign('/#/signuporg');
    }
    else {
      vm.loadData();
    }

    vm.SetUp = function(isValid) {
      if (isValid) {
        OrganizationService.register(function() {
          BusCatService.setOrganization(function() {
            OrganizationService.setState('setup', function() {
              StateService.go('billing');
            });
          });
        });
      }
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {

    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Select.Controller', SelectController);

  /** @ngInject */
  function SelectController(
    $scope,
    $log,
    OrganizationService,
    OrgCatService,
    StateService,
    $sce,
    TokenService,
    $window,
    loadingScreen
  ) {
    var vm = this; // vm in js and home in html
    vm.name = 'Select Organization';
    vm.list = [];
    vm.count;
    vm.plural;
    // OrganizationService.loadList( true, function(error,list){
    //   if( error == null){
    //     vm.list = list;
    //     vm.count = vm.list.length;
    //     vm.plural = vm.list.length > 1 ? 's' : '';
    //   }
    //   /*else{

    //   }*/
    // });

    vm.Continue = function(index) {
      OrganizationService.load(index);
      OrgCatService.load(function(error) {
        if (error == null ) {
          StateService.go('approval');
        }
      });
    }


    vm.getFrameSrc = function() {
      return $sce.trustAsResourceUrl($window.APPLICATION_SETTINGS.V2_URL + '/select?iframe=true&token=' + TokenService.get());
    }

    $window.addEventListener('message', function(e) {
      if (e.data && e.data.type === 'url') {
        if (e.data.url === '/class-link') {
          vm.signInWithClasslink();
        } else {
          location.assign(e.data.url);
        }
      }
      if (e.data && e.data.type === 'loading') {
        $scope.$apply(function() {
          loadingScreen.turnOn(e.data.loading);
        });
      }
    }, false);
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('SalesOrganizations.Controller', SalesOrganizationsController);

  /** @ngInject */
  function SalesOrganizationsController($scope, $rootScope, $timeout, $uibModal, MessageBoxService, SalesOrgService, IndTypeService) {
    var vm = this;
    vm.name = 'Group Page';
    vm.reader = new FileReader( );
    vm.indName = '';
    vm.helpTipList = ['Relevant tip info can go here'];
    vm.salesOrgs = [];

    vm.Update = function() {

      SalesOrgService.loadList(true, function(error, list) {
        if (error === null) {
          vm.salesOrgs = list;
          vm.industryTypes = [];

          vm.salesTotals = [];
          vm.totalSalesPeople = [];

          if (vm.salesOrgs.length === 0) {
            IndTypeService.load(null, function() {
              vm.industryTypes = IndTypeService.getTypes();
            })
          } else {
            vm.salesOrgs.forEach(function(org) {

              IndTypeService.load(null, function() {
                SalesOrgService.getTotalPeople(org.id, function(error, data) {
                  vm.totalSalesPeople.push(data);
                } );

                if (org.industrytypeid !== -1) {
                  IndTypeService.setCurrentByID(org.industrytypeid);
                }
                vm.industryTypes.push(IndTypeService.getCurrent().name);
              });
            });
          }


          SalesOrgService.getTotalSales(function(error, data) {
            vm.salesTotals = data;
          } );
        } else {
          MessageBoxService.open('Error', error, 'OK', function() {});
        }
      })
    };

    vm.updateSalesOrg = function(data) {
      location.assign('/#/editsalesorg/' + data.id);
    };

    vm.getTypes = function() {
      vm.types = IndTypeService.getTypes();
    };

    vm.loadData = function() {
      vm.Update();
    };

    vm.loadData();

    vm.deleteSalesOrg = function(index) {
      SalesOrgService.delete(index, function(error) {
        if (error === null) {
          vm.Update();
        } else {
          MessageBoxService.open('Error', 'Something went wrong! Please try again!', 'Okay', function() {})
        }
      });
    };

    vm.Disable = function(org) {
      org.disable = false;
      SalesOrgService.update(org, function() { });
    };

    vm.OpenEdit = function(index) {
      vm.salesOrgs[index].edit = true;
    };

    vm.CloseEdit = function(index) {

      IndTypeService.load(null, function() {
        IndTypeService.setCurrent(vm.indName);

        vm.salesOrgs[index].industrytypeid = IndTypeService.getCurrent().id;

        SalesOrgService.update(vm.salesOrgs[index], function(error) {
          if (error === null) {
            vm.loadData();
            vm.salesOrgs[index].edit = false;
          }
        });
      });
    };


    vm.AddSalesOrg = function() {
      vm.popup = $uibModal.open({
        templateUrl: 'app/popups/newsalesorg/newsalesorg.html',
        controller: 'NewSalesOrg.Controller as vm',
        windowClass: 'template-box',
        scope: $scope
      });
    };

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      //vm.reader = null; // garbage collect
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Sales.Controller', SalesController);

  /** @ngInject */
  function SalesController(
    $scope,
    $rootScope,
    $routeParams,
    $timeout,
    $sce,
    TokenService,
    $window,
    loadingScreen
  ) {
    var vm = this;
    vm.salesOrderCode = $routeParams.salesOrderCode;
    vm.selectedTab = $routeParams.selectedTab;

    vm.getFrameSrc = function() {
      if (vm.salesOrderCode.replace(/[^0-9]/gi, '').length === 10 && !vm.selectedTab) {
        return $sce.trustAsResourceUrl($window.APPLICATION_SETTINGS.V2_URL + '/sales-order/' + vm.salesOrderCode + '/general?iframe=true&token=' + TokenService.get());
      } else if (vm.selectedTab) {
        return $sce.trustAsResourceUrl($window.APPLICATION_SETTINGS.V2_URL + '/sales-order/' + vm.salesOrderCode + '/' + vm.selectedTab + '?iframe=true&token=' + TokenService.get());
      } else {
        return $sce.trustAsResourceUrl($window.APPLICATION_SETTINGS.V2_URL + '/sales-order/' + vm.salesOrderCode + '?iframe=true&token=' + TokenService.get());
      }
    }

    $window.addEventListener('message', function(e) {
      if (e.data && e.data.type === 'url') {
        location.assign(e.data.url);
      }
      if (e.data && e.data.type === 'loading') {
        $scope.$apply(function() {
          loadingScreen.turnOn(e.data.loading);
        });
      }
    }, false);



    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      //vm.reader = null; // garbage collect
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('ResponseGroup.Controller', ResponseGroupController);

  /** @ngInject */
  function ResponseGroupController(
    $scope,
    $routeParams,
    $uibModal,
    $rootScope,
    $timeout,
    $document,
    $log,
    MessageBoxService,
    OrganizationService,
    OrgUserService,
    UserService,
    OrgCatService,
    StateService,
    DashboardGroupService,
    loadingScreen
  ) {
    var vm = this;

    vm.name = 'Response Group Page';
    //vm.reader = new FileReader( );
    vm.orgID = $routeParams.orgID;

    vm.totalPages = 0;
    vm.currentPage = 0;
    vm.grpList = [];
    vm.helpTipList = [
      'You may \'Edit\' them, or choose to \'Add New Response Group\'.',
      'Make sure to add recipients by hovering over the group to \'Add / Update Recipient Info\''
    ];


    vm.loadData = function() {
      return UserService.load()
      .then(function() {
        return OrgUserService.dbUserLoad();
      })
      .then(function() {
        return OrgUserService.dbLoadMyUser([]);
      })
      .then(function() {
        vm.mypermission = OrgUserService.dbGetMyPermissions('orgadmin');
        return vm.Update();
      })
      .then(function() {
        $timeout(function() {
          $rootScope.$emit('page.ready');
        }, 100);
      });
    };

    vm.Update = function() {
      if (!vm.orgID) {
        vm.grpList = [];
      }
      return OrgUserService.getFormRespondentGroups(vm.orgID)
      .then(function(formResponseGroups) {
        vm.grpList = formResponseGroups;
      });
    };

    vm.OpenEdit = function(index) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {});
        return;
      }

      vm.grpList[index].edit = true;
    };

    vm.CloseEdit = function(index) {
      loadingScreen.turnOn(true);
      var responseGroup = vm.grpList[index];
      return OrgUserService.updateResponseGroup(responseGroup)
      .then(function() {
        return vm.Update();
      })
      .then(function() {
        responseGroup.edit = false;
        loadingScreen.turnOn(false);
      });
    };

    vm.onPage = function() {
      vm.Update();
    };

    vm.AddResponseGroup = function() {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {});
        return;
      }

      return OrgUserService.addFormRespondentGroups(vm.orgID)
      .then(vm.loadData());
    };

    vm.RemoveResponseGroup = function(index) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {});
        return;
      }

      var responseGroup = vm.grpList[index];

      $uibModal.open({
        templateUrl: 'app/popups/deletedashboardgroupconfirm/deletedashboardgroupconfirm.html',
        controller: 'DeleteDashboardGroupConfirm.Controller as vm',
        windowClass: 'template-box',
        scope: $scope,
        resolve: {
          confirmFun: function() {
            return function() {
              return OrgUserService.deleteFormRespondentGroup(responseGroup.id)
              .then(function() {
                vm.loadData();
              });
            };
          }
        }
      });
    };

    vm.AddEditMembers = function(responseGroup) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {});
        return;
      }
      StateService.go('responseforms', responseGroup.id)
    };

    // check to see if data should reload
    if (vm.orgID !== OrganizationService.getID()) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }



    // ============================================================================================================================================

    // vm.UploadUsers = function(index) {
    //   var id = 'input' + index;
    //   var element = $document[0].getElementById(id);
    //   element.value = '';
    //   element.click();
    // };

    // vm.CSVFile = function(/*element*/) {
    //   if ( vm.mypermission ) {

    //     //  var data = vm.grpList[parseInt(element.name)];

    //     // vm.reader.onload = function(event) {
    //     //   var users = OrgUserService.getCSVFileUsers(event.target.result);
    //     //   var list = [];
    //     //   users.forEach(function(user){
    //     //     list.push(user.id);
    //     //   });
    //     //   OrgUserService.assignToGroup(data.id, list,function(){

    //     //   });
    //     // };

    //     // vm.reader.readAsText(element.files[0]);
    //   }
    // };

    // vm.AddCatFromModal = function () {
    //   OrgCatService.getMaxCategories(vm.orgID, function(result) {
    //     vm.max = result;
    //     OrgCatService.add(true, vm.max, function () {
    //       vm.Update();
    //     })
    //   });
    // };

    // $scope.$on('$viewContentLoaded', function ContentLoaded() {
    // });

    // $scope.$on('$destroy', function UnLoaded() {
    //   //vm.reader = null; // garbage collect
    // });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Responseforms.Controller', ResponseformsController);

  /** @ngInject */
  function ResponseformsController(
    $scope,
    $routeParams,
    $rootScope,
    $document,
    $uibModal,
    $timeout,
    OrganizationService,
    UploadFileService,
    MessageBoxService,
    UserService,
    StateService,
    FormValidationService,
    DashboardGroupService,
    RecipientGroupService,
    OrgUserService,
    $log,
    loadingScreen
  ) {
    var vm = this;
    vm.name = 'User Page';
    vm.user = OrgUserService.getNewUser();
    vm.orgID = $routeParams.orgID;
    vm.groupID = $routeParams.groupID;
    vm.dashboardGroupId = Number($routeParams.groupID);
    vm.dashboardGroup = null;
    vm.dashboardGroups = null;
    vm.recipientGroups = null;

    vm.showInviteAll = true;
    vm.filter = '';

    vm.workFlowAdmins = [];
    vm.workFlowAdminNames = [];
    vm.permissionList = OrgUserService.getPermissionList();
    vm.respondents = [];

    vm.reader = new FileReader();

    vm.loadData = function() {
      return UserService.load()
      .then(function() {
        return OrgUserService.dbUserLoad();
      })
      .then(function() {
        return OrgUserService.dbLoadMyUser([]);
      })
      .then(function() {
        vm.mypermission = OrgUserService.dbGetMyPermissions('orgadmin');

        vm.workFlowAdmins = [];
        vm.workFlowAdminNames = [];
        vm.workFlowAdmins = OrgUserService.dbGetWorkFlowAdmins();

        vm.workFlowAdmins.forEach(function(admin) {
          var name = admin.firstname + ' ' + admin.lastname;
          if (vm.workFlowAdminNames.indexOf(name) === -1) {
            vm.workFlowAdminNames.push(name);
          }
        });

        return vm.Update();
      })
      .then(function() {
        $timeout(function() {
          $rootScope.$emit('page.ready');
        }, 100);
      });
    };

    vm.Update = function() {
      return Promise.all([
        DashboardGroupService.getById(vm.dashboardGroupId, vm.filter || ''),
        DashboardGroupService.load(),
        RecipientGroupService.load(),
        OrgUserService.getFormRespondents(vm.orgID, vm.groupID),
      ])
      .then(function(results) {
        vm.dashboardGroup = results[0];
        vm.dashboardGroups = results[1];
        vm.recipientGroups = results[2];
        vm.respondents = results[3];
      });
    };

    // check to see if data should reload
    if (vm.orgID !== OrganizationService.getID()) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.onPage = function() {
      vm.Update();
    };

    vm.getStatus = function(user) {
      var invite = OrgUserService.getInvite(user);

      if (user.userid) {
        if (user.optout) {
          return 'Opted Out';
        } else if (user.loggedin) {
          return 'Opted In';
        // } else if (invite) {
        //   var d = moment(Date.parse(invite.modifieddate));
        //   return 'Invited (' + d.format('MM/DD/YYYY') + ')';
        } else {
          return 'Logged Out';
        }
      } else if (invite) {
        var d = moment(Date.parse(invite.modifieddate));
        return 'Invited (' + d.format('MM/DD/YYYY') + ')';
      } else {
        return 'New';
      }
    };

    vm.onBack = function() {
      StateService.go('responsegroups');
    };

    vm.OpenEdit = function(user) {
      vm.showInviteAll = false;
      vm.workFlowAdminNames.forEach(function(admin, index) {
        if (admin === (user.firstname + ' ' + user.lastname)) {
          vm.workFlowAdminNames.splice(index, 1);
        }
      });

      if (vm.mypermission) {
        OrgUserService.dbGetAdmin(user, function(error, myAdmin) {
          if (error === null) {
            if (!myAdmin.firstname) user.workflowadminName = 'None';
            else user.workflowadminName = (myAdmin.firstname + ' ' + myAdmin.lastname);
            user.edit = true;
          }
        });
      } else {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {
        });
      }
    };

    vm.CloseEdit = function(user) {
      vm.showInviteAll = true;
      user.edit = false;

      if (user.permissions.length > 0) {
        user.workflowaccess = user.permissions[0];
        user.templateaccess = user.permissions[1];
        user.reportaccess = user.permissions[2];
        user.alertaccess = user.permissions[3];
        user.advertisementaccess = user.permissions[4];
        user.announcementaccess = user.permissions[5];
        user.appointmentaccess = user.permissions[6];
        user.orgadmin = user.permissions[7];
        user.emailmarketing = user.permissions[8];
      }

      user.dashboardGroupIds = Object.keys(user.dashboardGroups).reduce(function(groupIds, groupId) {
        if (user.dashboardGroups[groupId]) {
          groupIds.push(Number(groupId));
        }

        return groupIds;
      }, []);

      user.recipientGroupIds = Object.keys(user.recipientGroups).reduce(function(groupIds, groupId) {
        if (user.recipientGroups[groupId]) {
          groupIds.push(Number(groupId));
        }

        return groupIds;
      }, []);

      loadingScreen.turnOn(true);
      return OrgUserService.update(user)
      .then(function() {
        return vm.Update();
      })
      .then(function() {
        var name = user.workflowadminName;
        if (name && name.toLowerCase().trim() === 'none') {
          OrgUserService.dbRemoveWorkflowAdmin(user, function() {
            vm.Update();
          })
        }
        var admin = {};
        // assign workflowadmin id
        for (var i = 0; i < vm.workFlowAdmins.length; i++) {
          if (name === vm.workFlowAdmins[i].firstname + ' ' + vm.workFlowAdmins[i].lastname) {
            admin = vm.workFlowAdmins[i];
            user.workflowadminid = vm.workFlowAdmins[i].id;
            break;
          }
        }
        OrgUserService.dbSetAdmin(user, admin, function() {
          OrgUserService.dbUpdate(user, function(error) {
            if (error === null) {
              vm.Update();
            }
          });
        });
      })
      .then(function() {
        loadingScreen.turnOn(false);
      });
    };

    vm.onPage = function() {
      vm.Update();
    };

    vm.isUninvitedUser = function(user) {
      return OrgUserService.isUninvitedUser(user) && vm.mypermission;
    };

    vm.isInvitedUser = function(user) {
      return OrgUserService.isInvitedUser(user) && vm.mypermission;
    };

    vm.updatePhoneNumber = function(user) {
      user.phonenumber = FormValidationService.UpdatePhoneNumber(user.phonenumber);
    };

    vm.AddNew = function() {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {});
        return;
      }

      if (vm.mypermission) {
        vm.popup = $uibModal.open({
          templateUrl: 'app/popups/newdashboarduser/newdashboarduser.html',
          controller: 'NewDashboardUser.Controller as vm',
          windowClass: 'template-box',
          scope: $scope,
          resolve: {
            addUser: function() {
              return function(addedUser) {
                return Promise.resolve()
                .then(function() {
                  // user already exists, update the existing record
                  if (addedUser.id) {
                    return OrgUserService.getById(addedUser.id)
                    .then(function(existingUser) {
                      existingUser.dashboardGroupIds = existingUser.dashboardGroupIds || [];
                      existingUser.dashboardGroupIds.push(vm.dashboardGroup.id);
                      existingUser.firstname = addedUser.firstname || existingUser.firstname;
                      existingUser.lastname = addedUser.lastname || existingUser.lastname;
                      existingUser.email = (addedUser.email || existingUser.email).toLowerCase();
                      existingUser.title = addedUser.title || existingUser.title;
                      existingUser.phonenumber = addedUser.phonenumber || existingUser.phonenumber;
                      existingUser.isdashboarduser = true;

                      return OrgUserService.update(existingUser);
                    });
                  } else {
                    addedUser.dashboardGroupIds = [vm.dashboardGroup.id];
                    addedUser.isdashboarduser = true;
                    return OrgUserService.insert(addedUser);
                  }
                })
                .then(function() {
                  return vm.Update();
                });

              };
            }
          }
        });
      }
    };

    vm.ConfirmRemove = function(user) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {
        });
        return;
      }

      if (vm.mypermission) {
        vm.popup = $uibModal.open({
          templateUrl: 'app/popups/deletedashboarduserconfirm/deletedashboarduserconfirm.html',
          controller: 'DeleteDashboardUserConfirm.Controller as vm',
          windowClass: 'template-box',
          scope: $scope,
          resolve: {
            user: function() {
              vm.user = user;
              return vm.user;
            },
            groupID: function() {
              return null;
            },
            remove: function() {
              return function() {
                user.workflowaccess = false;
                user.templateaccess = false;
                user.reportaccess = false;
                user.alertaccess = false;
                user.advertisementaccess = false;
                user.announcementaccess = false;
                user.appointmentaccess = false;
                user.orgadmin = false;
                user.isdashboarduser = false;
                user.dashboardGroupIds = [];
                return OrgUserService.update(user)
                .then(function() {
                  return vm.Update();
                });
              };
            }
          }
        });
      }
    };

    vm.RemoveRespondent = function(respondent) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {});
        return;
      }

      $uibModal.open({
        templateUrl: 'app/popups/deleterespondentconfirm/deleterespondentconfirm.html',
        controller: 'DeleteRespondentConfirm.Controller as vm',
        windowClass: 'template-box',
        scope: $scope,
        resolve: {
          confirmFun: function() {
            return function() {
              loadingScreen.turnOn(true);
              OrgUserService.deleteRespondent(respondent.sourcekey)
              .then(function() {
                vm.Update();
                loadingScreen.turnOn(false);
              });
            };
          }
        }
      });
    };

    vm.UploadUsers = function(index) {
      var element = $document[0].getElementById(index);
      element.value = '';
    };

    vm.CSVFile = function(element) {
      var reader = new FileReader();

      if (!vm.mypermission) {
        MessageBoxService.open(
          'Permissions',
          'You don\'t have permissions to edit this.',
          'Continue',
          function() {}
        );
        return;
      }

      if (vm.mypermission) {
        reader.onload = function() {
          loadingScreen.turnOn(true);
          OrgUserService.loadFormRespondents(reader.result, vm.orgID, vm.groupID)
          .then(function() {
            vm.Update();
          })

          .then(function() {
            loadingScreen.turnOn(false);
          });
        };
        reader.readAsText(element.files[0]);

      }
    };

    vm.ExportCSV = function() {
      const csvUrl = OrgUserService.getFormRespondents(vm.orgID, vm.groupID, true);
      $log.log(csvUrl);
      window.open(csvUrl, '_blank');
    };

    $scope.$on('$destroy', function UnLoaded() {
      vm.reader = null; // garbage collect
      vm.deleted = null;
    });
  }
})();


(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Request.Controller', RequestController);

  /** @ngInject */
  function RequestController($log, UserService, FormValidationService, MessageBoxService) {
    var vm = this;

    vm.state = 'Question';

    vm.login = {};

    //error states
    vm.showErrorLgn = false;
    vm.showErrorReg = false;
    vm.showErrorSnd = false;

    vm.id = 0;
    vm.user = {};
    vm.user.email = '';
    vm.user.username = '';
    vm.user.password = '';
    vm.user.confirm = '';

    vm.ePattern = FormValidationService.GetEmailPattern();

    vm.Send = function(isValid) {
      if (isValid) {
        /* OrgUserService.requestJoin(vm.id,function(error){
          if( error == null ){
            MessageBoxService.open("Request sent to "+vm.id,"OK", function(){location.assign("/#/");});
          }else{
            MessageBoxService.open( "Error",error, "OK", function(){ });
          }
        });*/
      }
    }

    vm.Existing = function() {
      vm.state = 'Login';
      if ( UserService.isLoggedIn() ) {
        vm.state = 'Request';
      }
    }

    vm.NewUser = function() {
      vm.state = 'Register';
    }

    vm.Cancel = function() {
      vm.state = 'Question';
    }

    vm.Login = function(isValid) {
      if (isValid) {
        UserService.login({
          'email': vm.login.username,
          'password': vm.login.password
        }, function(error) {
          if (error == null) {
            vm.state = 'Request';
          }
        });
      }
    }

    vm.Register = function(isValid) {
      if (isValid && vm.user.password == vm.user.confirm) {
        UserService.register({
          'username': vm.user.username,
          'password': vm.user.password,
          'email': vm.user.email
        }, function(error) {
          if (error == null) {
            vm.state = 'Login';
          }
        });
      }
    }

    vm.Resend = function() {
      UserService.resendEmailVerification({
        'email': vm.user.email
      }, function(error) {
        if (error) {
          MessageBoxService.open(
            'Resend failed',
            MessageBoxService.invalidEmailMsg(
              vm.user.email,
              'could not resend email to ' + vm.user.email,
              'Please enter a valid email address'),
            'ok',
            function() { $log.debug('close'); }
          );
        } else {
          vm.state = 'Login';
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Reporting.Controller', ReportingController);

  /** @ngInject */
  function ReportingController($scope, $routeParams, $log, $timeout, $rootScope, OrganizationService, UserService, OrgUserService, OrgReportService, MessageBoxService) {
    var vm = this;
    vm.name = 'Reporting Page';
    vm.orgID = $routeParams.orgID;
    vm.report = {};

    vm.loadData = function() {
      UserService.load(function() {
        OrgUserService.dbLoadMyUser( ['reportaccess'], function(error) {
          if (error) {
            MessageBoxService.open('Permission Error', 'You do not have permission to view this page.', 'Continue', function() { });
          }

          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);

        });
      });
    };

    vm.onTabSelected = function(name) {
      if ( OrgUserService.dbGetMyPermissions('reportaccess') ) {

        if (name == 'organization') {
          OrgReportService.loadOrgReport(function() {
            vm.report = OrgReportService.getOrgReport();
          });
        } else if (name == 'followers') {
          OrgReportService.loadFollowersReport(function(err, report) {
            if (!err) {
              vm.report = report;
            } else {
              MessageBoxService.open('Error', 'Couldn\'t retrieve followers information. Try again later', 'Continue', function() { });
            }
          });
        } else {
          OrgReportService.loadMsgTypeReport(name, function() {
            vm.report = OrgReportService.getMsgTypeReport();
          });
        }
      }
    };

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();


(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('RateFee.Controller', RateFeeController);

  /** @ngInject */
  function RateFeeController($scope, $document, $routeParams, IndTypeService, OrganizationService, StateService) {
    var vm = this;
    vm.orgID = $routeParams.orgID;

    vm.loadData = function() {
      IndTypeService.load(null, function() {

        IndTypeService.setCurrentByID(OrganizationService.get().industrytypeid);

        // reset
        vm.industry = IndTypeService.getCurrent( );
        vm.numberOfUsers = IndTypeService.getUserCount( );
        vm.totalCost = 0;
        vm.ready = false;
        vm.termsAgree = false;

        if ( IndTypeService.getCurrent( ).name == '' ) {
          location.assign('/#/signuporg');
        }

        vm.Update( );
      });
    }

    if ( vm.orgID && vm.orgID != -1 ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    // select only one plan
    vm.ClickPlan = function(info) {

      for ( var i = 0; i < vm.industry.plans.length; i++ ) {
        var plan = vm.industry.plans[i];
        if ( plan === info ) info.selected = !info.selected;
        else plan.selected = false;
      }
      vm.Update( );
    }

    // toggle options
    vm.ClickOption = function(info) {
      info.selected = !info.selected;
      vm.Update( );
    }

    vm.Back = function() {
      StateService.go('billing');
    }

    vm.PlanSelected = function() {

      if ( !vm.indsutry || !vm.industry.plans || vm.industry.plans.length == 0 )
        return false;

      for ( var i = 0; i < vm.industry.plans.length; i++ ) {
        var plan = vm.industry.plans[i];
        if ( plan.selected )
          return false;
      }
      return true;
    }

    vm.Update = function( ) {
      vm.numberOfUsers = Math.max(vm.numberOfUsers, 0);
      IndTypeService.setUserCount( vm.numberOfUsers );
      IndTypeService.setPlan(vm.orgID, function() {
        var costs = IndTypeService.getCosts();
        vm.totalCost = costs.cost;//.toFixed(2);
        vm.ready = costs.ready && vm.termsAgree;
      });

    }

    vm.Continue = function(isValid) {
      if (isValid && vm.ready) {
        OrganizationService.setState('ratefee', function() {
          StateService.go('payment');
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Profile.Controller', ProfileController);

  /** @ngInject */
  function ProfileController($uibModal, $scope, $routeParams, $timeout, $rootScope, $document, BusCatService, IndTypeService, OrgBillingService, MessageBoxService, OrganizationService, OrgSaleService, UserService, OrgUserService, FormValidationService, UploadFileService, $window, loadingScreen, IdenticardService) {
    var vm = this;
    vm.name = 'Profile Page';
    vm.orgID = $routeParams.orgID;
    vm.states = FormValidationService.GetStates();
    //regex patterns for validation
    vm.ePattern = FormValidationService.GetEmailPattern();
    vm.phPattern = FormValidationService.GetPhonePattern();
    vm.zPattern = FormValidationService.GetZipPattern();
    vm.rPattern = FormValidationService.GetRoutingPattern();
    vm.aPattern = FormValidationService.GetAccountNoPattern();
    vm.cPattern = FormValidationService.GetCardNoPattern();
    vm.cvcPattern = FormValidationService.GetCvcPattern();
    vm.monthList = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    // vm.currentOrgPic = 'assets/images/60x60.png';
    vm.yearList = [];
    vm.year = '';
    vm.month = '';

    vm.IdenticardBuildings = null;

    var date = new Date();
    for ( var i = 0; i < 20; i++) {
      vm.yearList.push( (date.getFullYear() + i).toString() );
    }
    vm.imageRequiredHeight = 512;
    vm.imageRequiredWidth = 512;

    vm.billingTypes = ['Bank Account', 'Credit Card'];
    vm.bankAccountTypes = ['CHECKING', 'SAVINGS', 'BUSINESS'];

    vm.accessControlTypes = ['', 'Identicard'];
    vm.remoteMonitoringTypes = ['', 'CMS'];

    vm.loadData = function() {
      UserService.load(function() {

        OrgBillingService.load(function() {
          vm.billing = OrgBillingService.get();
          //accountNumber and cardNumber are formatted a little differently
          //by auth.net, so fix that here
          vm.billing.cardNumber = vm.billing.cardNumber ? '************' + vm.billing.cardNumber.substr(vm.billing.cardNumber.length - 4) : '';
          vm.billing.accountNumber = vm.billing.accountNumber ? '************' + vm.billing.accountNumber.substr(vm.billing.accountNumber.length - 4) : '';

          vm.billing.expDate = undefined;

          BusCatService.load( function() {
            BusCatService.getOrgBusCat( function() {
              IndTypeService.load(null, function() {
                if ( OrganizationService.get().industrytypeid !== -1) {
                  IndTypeService.setCurrentByID( OrganizationService.get().industrytypeid );
                }
                vm.currentType = IndTypeService.getCurrent().name;
                vm.categories = BusCatService.getCategories(IndTypeService.getID());
                vm.profile = {};
                vm.reader = new FileReader( );
                vm.profileimage = null;
                vm.profileimage1 = null;
                vm.profileimage2 = null;
                vm.profileimage3 = null;
                vm.profileimage4 = null;
                //vm.profiletagline = null;
                vm.orgID = $routeParams.orgID;
                vm.profile = OrganizationService.get();

                if (vm.profile.enableaccesscontrol && vm.profile.identicardserverurl && vm.profile.identicardserversecret) {
                  vm.IdenticardGetBuildings();
                }
                if ( vm.profile.profileimage !== null ) {
                  $document[0].getElementById('imageone').src = vm.profile.profileimage
                } else {
                  $document[0].getElementById('imageone').src = '/assets/images/profileDefualt.png';
                }

                if ( vm.profile.profileimage1 !== null ) {
                  $document[0].getElementById('image1').src = vm.profile.profileimage1
                } else {
                  $document[0].getElementById('image1').src = '/assets/images/profileImageOne.png';
                }
                // if (vm.profile.profileimage !== null) {
                //   vm.currentOrgPic = vm.profile.profileimage;
                // }
                if ( vm.profile.profileimage2 !== null ) {
                  $document[0].getElementById('image2').src = vm.profile.profileimage2
                } else {
                  $document[0].getElementById('image2').src = '/assets/images/profileImageTwo.png';
                }
                if ( vm.profile.profileimage3 !== null ) {
                  $document[0].getElementById('image3').src = vm.profile.profileimage3
                } else {
                  $document[0].getElementById('image3').src = '/assets/images/profileImageThree.png';
                }
                if ( vm.profile.profileimage4 !== null ) {
                  $document[0].getElementById('image4').src = vm.profile.profileimage4
                } else {
                  $document[0].getElementById('image4').src = '/assets/images/profileImageFour.png';
                }
                /* if( vm.profile.profiletagline != null ){
                  $document[0].getElementById('image2').src = vm.profile.profiletagline;
                }*/

                IndTypeService.setCurrentByID(OrganizationService.get().industrytypeid);

                vm.profile.busCat = BusCatService.getCurrent().id;
                vm.profile.indType = IndTypeService.getCurrent().name;

                OrgUserService.dbLoadMyUser( [], function() {
                  vm.mypermission = OrgUserService.dbGetMyPermissions('orgadmin');
                  OrgSaleService.loadSalesPerson(function(data, error) {
                    if ( data && error === null ) {
                      vm.profile.salesRep = data.firstname + ' ' + data.lastname;
                    }
                    $timeout(function() {
                      $rootScope.$emit('page.ready');
                    }, 100);
                  });
                });
              });
            });
          });

        });
      });
    };

    vm.Update = function(setupForm) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }
      if (setupForm.$valid) {
        OrganizationService.register(function() {
          OrganizationService.updateBusCategory(vm.profile.busCat, function() {} );
          vm.loadData();
        });
      }
    };

    vm.ConfirmRemove = function() {
      if (vm.mypermission) {
        vm.popup = $uibModal.open({
          templateUrl: 'app/popups/deletebillinginfo/deletebillinginfo.html',
          controller: 'DeleteBillingInfo.Controller as vm',
          windowClass: 'template-box',
          scope: $scope
        });
      }
    };

    vm.Remove = function( ) {
      OrgBillingService.delete(function() {
        vm.loadData();
      });
    };

    vm.SetUpBilling = function(form) {

      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      if (form.$valid) {

        vm.billing.expDate = vm.year + '-' + vm.month;

        OrgBillingService.register(function(error) {
          if ( error ) {
            MessageBoxService.open('Billing Error', error, 'Continue', function() { });
          } else {
            OrgBillingService.load(function() {
              vm.billing = OrgBillingService.get();
            });
          }
        });
      }
    }

    vm.IdenticardGetBuildings = function() {
      return IdenticardService.GetBuildings(vm.orgID)
      .then(function(rslt) {
        vm.IdenticardBuildings = rslt;
        return rslt;
      })
    };

    vm.IdenticardSetBuilding = function(buildingid, status) {
      loadingScreen.turnOn(true);
      return IdenticardService.SetBuilding(vm.orgID, buildingid, status)
      .then(function(rslt) {
        loadingScreen.turnOn(false);
        if (rslt.buildings) {
          vm.IdenticardBuildings = rslt.buildings;
        }
      });
    };

    vm.IdenticardStatus = function(statusCode) {
      return IdenticardService.Status(statusCode);
    };

    vm.LoadImage = function(dest, file,id) {

      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      if ( file && vm.mypermission) {

        var tempImage = new Image();

        tempImage.onload = function() {
          var img = tempImage;
          vm.naturalWidth = img.naturalWidth;
          vm.naturalHeight = img.naturalHeight;
          $scope.$apply();
          vm.Upload(id,dest);
        };

        tempImage.src = $window.URL.createObjectURL(file);
      }
    };

    vm.UpdateImage = function(dest, element) {
      vm[element.id] = element.files[0];
      vm.LoadImage(dest, element.files[0],element.id);
    };

    vm.Upload = function(id,dest, cb) {
      if ( vm.imageRequiredHeight >= vm.naturalHeight &&
          vm.imageRequiredWidth >= vm.naturalWidth ) {
        // alert(dest)
        UploadFileService.upload( vm[id], function(path, error) {
          if ( error === null ) {
            vm[id] = null;
            vm.profile[id] = path;
            var image = $document[0].getElementById(dest);
            image.src = vm.profile[id];
            // vm.currentOrgPic = path;
            $rootScope.$emit('organizationUpdated');
            OrganizationService.register(function() {
              if (cb) {
                return cb(true);
              }
            });
          }
        });
      } else {
        var image = $document[0].getElementById(dest);
        image.src = vm.profile[id] || 'assets/images/60x60.png';
        MessageBoxService.open('Image Error', 'The select image must be no larger than ' + vm.imageRequiredWidth + 'x' + vm.imageRequiredHeight, 'Continue', function() { });
        if (cb) {
          return cb(false);
        }
      }
    };

    if ( vm.orgID && vm.orgID !== -1 ) {
      OrganizationService.loadByID(vm.orgID, function() {

        vm.loadData();
      });
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      vm.reader = null; // some how causes GC to clear stupid memory for filereader
    });

  }
})();


(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('PricingTemplates.Controller', PricingTemplatesController);

  /** @ngInject */
  function PricingTemplatesController(
    $scope,
    $rootScope,
    $routeParams,
    $timeout,
    $sce,
    TokenService,
    $window,
    loadingScreen
  ) {
    var vm = this;

    vm.getFrameSrc = function() {
      return $sce.trustAsResourceUrl($window.APPLICATION_SETTINGS.V2_URL + '/pricing-templates?iframe=true&token=' + TokenService.get());
    }

    $window.addEventListener('message', function(e) {

      if (e.data && e.data.type === 'url') {
        location.assign(e.data.url);
      }
      if (e.data && e.data.type === 'loading') {
        $scope.$apply(function() {
          loadingScreen.turnOn(e.data.loading);
        });
      }
    }, false);



    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      //vm.reader = null; // garbage collect
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('PricingTemplate.Controller', PricingTemplateController);

  /** @ngInject */
  function PricingTemplateController(
    $scope,
    $rootScope,
    $routeParams,
    $timeout,
    $sce,
    TokenService,
    $window,
    loadingScreen
  ) {
    var vm = this;
    vm.pricingTemplateID = $routeParams.pricingTemplateID;

    vm.getFrameSrc = function() {
      return $sce.trustAsResourceUrl($window.APPLICATION_SETTINGS.V2_URL + '/pricing-templates/' + vm.pricingTemplateID + '?iframe=true&token=' + TokenService.get());
    }

    $window.addEventListener('message', function(e) {

      if (e.data && e.data.type === 'url') {
        location.assign(e.data.url);
      }
      if (e.data && e.data.type === 'loading') {
        $scope.$apply(function() {
          loadingScreen.turnOn(e.data.loading);
        });
      }
    }, false);



    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      //vm.reader = null; // garbage collect
    });

  }
})();

(function (window, undefined) {
    'use strict';

    var document = window.document, Pixie, _pixie, instance;

    Pixie = function() {

        _pixie.start();

        instance = {
            save: function(format, quality) { _pixie.save(format, quality); return this },
            getService: function(name) { return _pixie.getService(name); },
            //start: function(options) { _pixie.start(options); return this },
            close: function() { _pixie.close(); return this },
            open: function(options) { _pixie.open(options); return this },
            enableInteractiveMode: function(options) { _pixie.enableInteractiveMode(options); return this },
            getParams: function() { return _pixie.params },
            setOptions: function(options) { _pixie.setOptions(options); return this }
        };

        return instance;
    };

    _pixie = {

        params: {
            url: false,
            blankCanvasSize: false,
            enableCORS: false,
            path: 'pixie',
            saveUrl: false,
            hideOpenButton: false,
            replaceOriginal: false,
            forceLaundering: false,
            appendTo: 'body',
            noManualClose: false,
            openDelay: 400,
            closeDelay: 400,
            onError: function(err) { console.log(err) },
            onLoad: function() {},
            onSave: function() {},
            onClose: function() {},
            onSaveButtonClick: null
        },

        errors: {
            invalidImg: "Image you passed in doesn't exist or can't be loaded"
        },

        loaded: false,

        cache: {},

        setOptions: function(options) {
            this.extend(_pixie.params, options);
        },

        save: function(format, quality) {
            if (_pixie.loaded) {
                _pixie.getService('saver').saveImage(format, quality);
            }
        },

        getService: function(name) {
            if ( ! _pixie.injector) {
                _pixie.injector = _pixie.frameWindow.angular.element(_pixie.frameWindow.document.body).injector();
            }

            return _pixie.injector.get(name);
        },

        start: function() {

            var currentScript = document.currentScript || (function() {
                 var scripts = document.getElementsByTagName('script');
                      return scripts[scripts.length - 1];
            })();/*

           var script = document.currentScript;

            if ( ! script) {
                var scripts = document.getElementsByTagName('script');

                for (var i = scripts.length - 1; i >= 0; i--) {
                    if (scripts[i].src.indexOf('pixie-integrate.js') > -1) {
                        var script = scripts[i]; break;
                    }
                };
            }*/

            var data = currentScript.dataset;

            if (typeof data.path !== 'undefined') {
                _pixie.params.path = data.path;
            }

            if (data.preload && ! _pixie.loaded) {
                window.onload = function() {
                    _pixie.create();
                    window.onload = null;
                };
            }
        },

        /**
         * Automatically open images in editor on click within passed in container or whole page.
         *
         * @param params
         */
        enableInteractiveMode: function(params) {
            params = params || {};

            var selector  = params.selector || 'img',
                container = document,
                preventDefault = params.preventDefault || true;

            if (params.container) {
            	container = document.querySelectorAll(params.container)[0];
            }

            (container || document).addEventListener('click', function(e) {
                if (e.target.nodeName !== selector && e.target.className.indexOf(selector.replace('.', '')) === -1) return;

                if (preventDefault) {
                    e.preventDefault();
                }

                var node = e.target;

                if (node.nodeName !== 'IMG') {
                    node = e.target.querySelector('img');
                }

                if (node && node.nodeName === 'IMG') {
                    _pixie.params.image = node;
                    _pixie.open({ url: _pixie.params.image.src });
                }
            });
        },

        /**
         * Launder image using php to avoid problems with
         * tainted canvas when loading images through cross domain.
         *
         * @param url
         * @returns Promise|String
         */
        launderImage: function(url) {

            //if CORS is enabled or image is at the same domain
            // no need to fetch image through domains so we can just return the original url
            if (_pixie.params.enableCORS || ( ! _pixie.params.forceLaundering && _pixie.urlInSameDomain(url))) {
                return url;
            }

            //check cache to see if we have already laundered this image
            if (_pixie.cache[url]) {
                return _pixie.cache[url];
            }

            //if CORS is not enabled we will need to use php to fetch
            //the image at given url and then return its data in base64
            var request = _pixie.ajax(_pixie.getPath()+'launderer.php', 'url='+_pixie.absoluteUrl(url));

            request.onload = function(e) {
                if (e.target.status >= 200 && e.target.status < 400) {
                    _pixie.cache[url] = e.target.responseText;
                }
            };

            return request;
        },

        close: function() {
            _pixie.fadeOut(_pixie.container, {
                duration: _pixie.params.closeDelay,
                complete: function() {
                    _pixie.container.style.display = 'none';
                }
            });

            document.body.classList.remove('noscroll');

            this.params.onClose();
            _pixie.rootScope.resetUI();
        },

        open: function(options) {
            if (this.loading) return;

            this.extend(_pixie.params, options);

            document.body.classList.add('noscroll');

            if ( ! this.loaded) {
                _pixie.create(_pixie.loadImage);
            } else {
                _pixie.loadImage()
            }

            _pixie.container.style.display = 'block';

            if (_pixie.loaded) {
                _pixie.fadeIn(_pixie.container, {
                    duration: _pixie.params.openDelay
                });

            }
        },

        loadImage: function() {
            if (_pixie.params.url) {
                _pixie.imageExists(_pixie.params.url, function(exists) {
                    if (exists) {
                        var resp = _pixie.launderImage(_pixie.params.url);

                        //load the image after ajax request is done
                        if (typeof resp === 'object') {
                            resp.onload = function(e) {
                                if (e.target.status >= 200 && e.target.status < 400 && e.target.responseText) {
                                    _pixie.params.url = e.target.responseText;
                                    _pixie.rootScope.canvas.fabric.clear();
                                    _pixie.rootScope.canvas.zoom(1);
                                    _pixie.rootScope.canvas.loadMainImage(e.target.responseText);
                                    _pixie.rootScope.$apply(function() {
                                        _pixie.rootScope.started = true;
                                    });
                                }
                            };
                        }

                        //no laundering was required so we can just load the image now
                        else if (typeof resp === 'string') {
                            _pixie.rootScope.canvas.fabric.clear();
                            _pixie.rootScope.canvas.zoom(1);
                            _pixie.rootScope.canvas.loadMainImage(resp);
                            _pixie.rootScope.$apply(function() {
                                _pixie.rootScope.started = true;
                            });
                        }
                    } else {
                        _pixie.error('invalidImg', _pixie.params.url);
                    }
                });
            } else if (_pixie.params.blankCanvasSize) {
                var size = _pixie.params.blankCanvasSize;
                _pixie.rootScope.canvas.openNew(size.width, size.height, 'newCanvas');
                _pixie.rootScope.$apply(function() {
                    _pixie.rootScope.started = true;
                    _pixie.rootScope.canvas.zoom(1.1);
                });
            }

        },

        create: function(callback) {
            this.loading = true;

            var markup = '<section id="pixie-editor-container"><div id="pixie-frame-container"><div id="pixie-editor-header">Pixie Editor<div class="pixie-close">&times;</div></div></div></section>',
                link   = document.createElement('link'); link.rel = 'stylesheet'; link.href = this.getPath()+'assets/css/integrate.css';

            document.querySelector('head').appendChild(link);

            var wrapper = document.createElement('div');
            wrapper.innerHTML = markup;

            this.container = document.querySelector(_pixie.params.appendTo).appendChild(wrapper.firstChild);
            this.container.style.display = 'none';

            this.frame = document.createElement('iframe');

            this.container.querySelector('#pixie-frame-container').appendChild(this.frame);

            this.frame.onload = function() {
                _pixie.frameWindow = _pixie.frame.contentWindow;

                _pixie.rootScope   = _pixie.frameWindow.angular.element('body').scope();

                _pixie.loaded = true;
                _pixie.loading = false;

                _pixie.params.onLoad(_pixie.container, _pixie.rootScope, _pixie.frameWindow);
                callback && callback();
            };

            this.frame.src = this.getPath()+'index.html';

            if ( ! _pixie.params.noManualClose) {
                document.addEventListener('click', function(e) {
                    if (e.target.id === 'pixie-editor-container' || e.target.className === 'pixie-close') {
                        _pixie.close();
                    }
                });
            } else {
                document.querySelector('.pixie-close').style.display = 'none';
            }
        },

        imageExists: function(url, callback) {
            var img = new Image();
            img.onload = function() { callback(true); };
            img.onerror = function() { callback(false); };
            img.src = url;
            img = null;
        },

        urlInSameDomain: function(url) {
            return url.indexOf(document.domain) > -1 || url.indexOf('//') === -1 || url.indexOf('data:image') > -1;
        },

        error: function(name, args) {
            _pixie.params.onError({
                message: _pixie.errors[name],
                args: args
            });
        },

        getPath: function() {
            return this.params.path ? this.params.path+'/' : '';
        },

        absoluteUrl: function(url) {
            if (url.indexOf('//') > -1) return url;

            var a = document.createElement('a');
            a.href = url;
            return a.href;
        },

        extend: function(out) {
            out = out || {};

            for (var i = 1; i < arguments.length; i++) {
                var obj = arguments[i];

                if (!obj)
                    continue;

                for (var key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        out[key] = obj[key];
                    }
                }
            }

            return out;
        },

        ajax: function(url, data) {
            var request = new XMLHttpRequest();
            request.open('POST', url, true);
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            request.send(data);

            return request;
        },

        animate: function(options) {
            var start = new Date;
            var id = setInterval(function() {
                var timePassed = new Date - start;
                var progress = timePassed / options.duration;
                if (progress > 1) {
                    progress = 1;
                }
                options.progress = progress;
                var delta = options.delta(progress);
                options.step(delta);
                if (progress == 1) {
                    clearInterval(id);
                    options.complete && options.complete();
                }
            }, options.delay || 10);
        },

        fadeOut: function(element, options) {
            var to = 1;
            _pixie.animate({
                duration: options.duration,
                delta: function(progress) {
                    return 0.5 - Math.cos(progress * Math.PI) / 2;
                },
                complete: options.complete,
                step: function(delta) {
                    element.style.opacity = to - delta;
                }
            });
        },

        fadeIn: function(element, options) {
            var to = 0;
            _pixie.animate({
                duration: options.duration,
                delta: function(progress) {
                    return 0.5 - Math.cos(progress * Math.PI) / 2;
                },
                complete: options.complete,
                step: function(delta) {
                    element.style.opacity = to + delta;
                }
            });
        }
    };

    window.Pixie = new Pixie();

}(this));

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('PendingCalc.Controller', PendingCalcController);

  /** @ngInject */
  function PendingCalcController($scope, $rootScope, $log, $timeout, $routeParams, $document, OrganizationService, UserService, MsgService, OrgUserService) {
    var vm = this;
    vm.name = 'Pending Calculate';
    vm.tempID = $routeParams.tempID;
    vm.orgID = $routeParams.orgID;

    vm.loadData = function() {


      UserService.load(function() {
        OrgUserService.dbLoadMyUser(['orgadmin', 'workflowaccess'], function(error) {
          if ( error ) {
            $timeout(function() {
              $rootScope.$emit('page.ready');
            }, 100);
            return;
          }
          MsgService.loadQueued( function() {
            $timeout(function() {
              $rootScope.$emit('page.ready');
            }, 100);
          });
        });
      });
    }

    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.onDone = function() {
      //StateService.go("announcement");
    }

    vm.onSend = function() {
      //StateService.go("announcement");
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Pending.Controller', PendingController);

  /** @ngInject */
  function PendingController($scope, $routeParams, $rootScope, $timeout, MsgService, OrganizationService, StateService, UserService, OrgUserService) {
    var vm = this;
    vm.name = 'Pending Page';
    vm.orgID = $routeParams.orgID;

    vm.msg = {'announcement':[],
      'ad':[],
      'appointment':[]};

    vm.loadData = function() {
      UserService.load(function() {
        OrgUserService.dbLoadMyUser(['orgadmin', 'workflowaccess'], function(error) {
          if ( error ) {
            $timeout(function() {
              $rootScope.$emit('page.ready');
            }, 100);
            return;
          }
          MsgService.loadQueued( function() {
            vm.Update();
            $timeout(function() {
              $rootScope.$emit('page.ready');
            }, 100);
          });
        });
      });
    };

    vm.onDelete = function(data) {
      MsgService.deleteListQueued(data.list, function() {
        vm.Update();
      });
    };

    vm.onEdit = function(data) {
      StateService.go('pendingcalc', data.sendgroupid);
    };

    vm.Update = function() {
      var list = [];

      list = MsgService.getQueued('announcement');
      if ( list && list.length > 0 ) {
        vm.msg.announcement = list;
      }

      list = MsgService.getQueued('advertisement');
      if ( list && list.length > 0 ) {
        vm.msg.ad = list;
      }

      list = MsgService.getQueued('appointment');
      if ( list && list.length > 0 ) {
        vm.msg.appointment = list;
      }
    };

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }


    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Payment.Controller', PaymentController);

  /** @ngInject */
  function PaymentController($scope, $routeParams, OrgBillingService, IndTypeService, OrgCatService, OrganizationService, StateService, MessageBoxService) {
    var vm = this;
    vm.orgID = $routeParams.orgID;

    vm.loadData = function() {
      OrgBillingService.load(function() {
        vm.billing = OrgBillingService.get();
        IndTypeService.load(null, function() {
          IndTypeService.getPlan(vm.orgID, function() {
            IndTypeService.setCurrentByID(OrganizationService.get().industrytypeid);
            vm.industry = IndTypeService.getCurrent();
            vm.costs = IndTypeService.getCosts();
          });
        });
      });
    }

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.Continue = function() {
      IndTypeService.finishPlan(vm.orgID, function(error) {
        if (!error) {
          OrganizationService.setOnboardFinish(function() {
            StateService.go('dashboard');
          });
        } else {
          MessageBoxService.open(
            'ERROR',
            'Unable to process payment. Please verify your payment information is correct.',
            'ok',
            function() { }
          );
        }
      });
    }

    vm.Back = function() {
      StateService.go('ratefee');
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('PasswordReset.Controller', PasswordResetController);

  /** @ngInject */
  function PasswordResetController($log, $scope, $routeParams, $window, UserService, MessageBoxService) {
    var vm = this;
    vm.token = $routeParams.token;

    vm.resetPassword = function(isValid) {
      if (isValid && vm.password == vm.confirm) {
        UserService.resetPassword({
          'password': vm.password,
          'confirm': vm.confirm
        }, vm.token, function(error) {
          if (error) {
            MessageBoxService.open(
              'Failed to change your password',
              error,
              'ok',
              function() { $log.debug('close'); }
            );
          } else {
            MessageBoxService.open(
              'Success',
              'Your Password has been updated!',
              'ok',
              function() {
                $log.debug('close');
                $window.location = '#';
              }
            );
          }
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('PasswordHelp.Controller', PasswordHelpController);

  /** @ngInject */
  function PasswordHelpController($window, $location, UserService, MessageBoxService, FormValidationService) {
    var vm = this;
    vm.ePattern = FormValidationService.GetEmailPattern();
    vm.email = '';

    vm.goHome = function() {
      //console.log("I am being told to go home");
      $location.path('home');
    };

    vm.onSubmit = function(isValid) {
      if (isValid) {
        UserService.exists( vm.email, function(error, doesExist) {
          if ( doesExist ) {

            UserService.sendResetPassword({
              'email': vm.email
            }, function(error) {
              if (error) {
                MessageBoxService.open(
                  'ERROR',
                  error,
                  'ok',
                  function() { }
                );
              } else {
                MessageBoxService.open(
                  'Reset Your Password',
                  'A reset email has been sent. It may take a minute or two. If you do not receive it within a few minutes, please contact us: customercare@yougetitfirst.com',
                  'Close',
                  function() {
                    $window.location = '#';
                  }
                );
              }
            });
          } else {
            MessageBoxService.open(
              'Oops',
              'No matching email found.',
              'ok',
              function() {
              }
            );
          }
        });
      } else {
        MessageBoxService.open(
          'Oops',
          'Please enter a valid email',
          'ok',
          function() {
          }
        );
      }
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Onboarding.Controller', OnboardingController)
  .directive('onboardingAccount', yaAccount)
  .directive('onboardingIndustry', yaIndustry)
  .directive('onboardingInfo', yaInfo)
  .directive('onboardingPlans', yaPlans )
  .directive('onboardingBilling', yaBilling)
  .directive('onboardingSummary', yaSummary);

  /** @ngInject */
  function OnboardingController($scope) {
    var vm = this; // vm in js and home in html
    vm.currentNavItem = false;
    vm.activeList = [true, false, false, false, false, false];
    // vm.availableList = [true,false,false,false,false,false];
    vm.availableList = [true, true, true, true, true, true];

    // if (UserService.isLoggedIn()) {
    //   vm.availableList = [false, true, true, true, true, true];
    // } else {
    //   vm.availableList = [true, false, false, false, false, false];
    // }

    vm.onSelect = function(tab) {
      vm.currentNavItem = tab;
    }

    vm.isActive = function(tab) {
      return vm.activeList[tab];
    };

    vm.isAvailable = function(tab) {
      return vm.availableList[tab];
    };

    vm.isOpen = function(tab) {
      return tab == vm.currentNavItem;
    };

    vm.loadData = function() {

    };

    vm.setActive = function(tab, isactive) {
      vm.activeList[tab] = isactive;
    };

    vm.setAvailable = function(tab, isavailable) {
      vm.availableList[tab] = isavailable;
    };

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });
  }

  function yaAccount() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/pages/onboarding/onboarding-createaccount.html',
      scope: { parent: '=parent' },
      controller: AccountCtrl,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;

  }

  /** @ngInject */
  function AccountCtrl(
    $scope,
    $rootScope,
    $timeout,
    $log,
    UserService,
    OrganizationService,
    FormValidationService,
    MessageBoxService,
    OrgBillingService,
    IndTypeService,
    BusCatService
  ) {
    var vm = this;
    vm.firstname = '';
    vm.lastname = '';
    vm.email = '';
    vm.password = '';
    vm.phoneNumber = '';
    vm.birthday = '';
    vm.ePattern = FormValidationService.GetEmailPattern();
    vm.phPattern = FormValidationService.GetPhonePattern();
    vm.bdPattern = FormValidationService.GetExDatePattern();
    vm.isUserExist = true;
    vm.isOrgDetected = false;

    vm.getCtrl = function(ctrl) {
      vm.stepperCtrl = ctrl;
      vm.loaded();
    }

    vm.loaded = function() {
      // setup

      // if already logged in
      if ( UserService.isLoggedIn() ) {
        UserService.load(function(/*error*/) {
          vm.email = UserService.getEmail();
          vm.password = '**********';
          // turn off input of password
          vm.stepperCtrl.elementList[0].setup(true, true, true);
          vm.stepperCtrl.elementList[1].setup(true, true, true);
          vm.stepperCtrl.setNumbers();

          // check for more organizations
          OrganizationService.loadList( false, function(error, list) {

            vm.list = list;
            if ( list && list.length > 0)
              vm.isOrgDetected = true;

            if ( vm.isOrgDetected ) {
              vm.orgsDetected();
              vm.stepperCtrl.setCurrent(2);
            }
          });
        });
      }
    }

    vm.resetPassword = function() {
      UserService.exists( vm.email, function(error, doesExist) {
        if ( doesExist ) {
          UserService.sendResetPassword({
            'email': vm.email
          }, function(error) {
            if (error) {
              MessageBoxService.open(
                'ERROR',
                error,
                'ok',
                function() { }
              );
            } else {
              MessageBoxService.open(
                'Success',
                'Check your email for password reset request.',
                'ok',
                function() {
                }
              );
            }
          });
        } else {
          MessageBoxService.open(
            'ERROR',
            'No matching email found.',
            'ok',
            function() {
            }
          );
        }
      });
    }

    vm.bdvalid = false;
    vm.phvalid = false;

    vm.updatePhoneNumber = function( ) {
      vm.phoneNumber = FormValidationService.UpdatePhoneNumber( vm.phoneNumber );
      vm.phvalid = vm.phPattern.test( vm.phoneNumber );
    }

    vm.updateBirthdate = function( ) {
      vm.birthday = FormValidationService.UpdateBirthDate( vm.birthday );
      vm.bdvalid = vm.bdPattern.test( vm.birthday );
      //verify that birthday is between now and 120 years ago
      vm.bdvalid = FormValidationService.isValidBirthday(vm.birthday)
    }

    vm.createValid = function() {
      return vm.bdvalid && vm.phvalid && vm.signupForm.$valid;
    }

    vm.canPassword = function() {
      return !UserService.isLoggedIn();
    }

    vm.isEmailDone = function() {
      return !vm.checkingEmail;
    }

    vm.isEmailExist = function( ) {
      return vm.isUserExist && !vm.checkingEmail && vm.email != '';
    }

    vm.isLoggedIn = function( ) {
      return UserService.isLoggedIn();
    }

    vm.logout = function( ) {
      UserService.logout();
      vm.email = '';
      vm.password = '';
      vm.reset();
      vm.stepperCtrl.setCurrent(0);
    }

    vm.finished = function() {
      // turn on next tab
      vm.parent.setActive(1, true);
      //vm.parent.onSelect(1);

      OrganizationService.clear();
      IndTypeService.clear();
      BusCatService.clear();
      OrgBillingService.clear();
    }

    vm.orgsDetected = function() {
      // turn on organizations
      vm.stepperCtrl.elementList[2].setup(true, true, false);
      vm.stepperCtrl.setNumbers();
    }

    vm.reset = function() {
      // trun off all tabs
      vm.parent.setActive(1, false);
      vm.parent.setActive(2, false);
      vm.parent.setActive(3, false);
      vm.parent.setActive(4, false);
      vm.parent.setActive(5, false);

      // turn off
      vm.stepperCtrl.elementList[1].setup(true, false, false);
      vm.stepperCtrl.elementList[2].setup(false, false, false);
      vm.stepperCtrl.elementList[3].setup(false, false, false);
      //vm.stepperCtrl.elementList[4].setup(false,false,false);

      vm.password = '';
    }

    vm.newUser = function( ) {
      $log.log('New User');

      // vm.parent.setActive(1,false);
      vm.parent.setActive(2, false);
      vm.parent.setActive(3, false);
      vm.parent.setActive(4, false);
      vm.parent.setActive(5, false);
      // ( isvisible, isactive, isdone )
      vm.stepperCtrl.elementList[1].setup(false, false, false);
      vm.stepperCtrl.elementList[2].setup(false, false, false);
      vm.stepperCtrl.elementList[3].setup(true, false, false);
      //vm.stepperCtrl.elementList[4].setup(true,false,false);
      vm.stepperCtrl.setNumbers();
    }

    vm.checkEmail = function(isValid) {

      if ( UserService.isLoggedIn() ) {
        UserService.logout();
        vm.password = '';
      }

      if (isValid) {
        vm.checkingEmail = true;
        UserService.exists( vm.email, function(error, doesExist) {
          vm.checkingEmail = false;
          vm.isUserExist = doesExist;
          if ( !vm.isUserExist ) {
            vm.newUser( );
          } else {
            vm.reset();
          }

        });
      } else {
        vm.reset();
      }
    }

    vm.onBack = function() {
      if ( vm.stepperCtrl.moveBack() ) {
        location.assign('/#/');
      }
    }

    vm.onSelectOrg = function( index ) {
      OrganizationService.load(index);
      var profile = OrganizationService.get();

      IndTypeService.load(null, function() {
        IndTypeService.setCurrentByID( OrganizationService.get().industrytypeid );
        BusCatService.load( function() {
          BusCatService.getOrgBusCat( function() {

            OrgBillingService.load( function( error ) {
              IndTypeService.getPlan( OrganizationService.getID(), function( ) {
                // industry & category
                vm.parent.setActive(1, true);
                if ( profile.industrytypeid != 0 ) {
                  // organization Info
                  vm.parent.setActive(2, true);
                  // rate plans // has a billing plan
                  vm.parent.setActive(3, true);
                  vm.parent.onSelect(3);
                }
                if ( IndTypeService.getCosts().ready ) {
                  // billing info
                  vm.parent.setActive(4, true);
                  vm.parent.onSelect(4);
                }
                if ( error == null ) { // has a billing profile
                  if ( OrgBillingService.get().method != '' ) {
                    // billing info
                    vm.parent.setActive(4, true);
                    // summary and payment
                    vm.parent.setActive(5, true);
                    vm.parent.onSelect(5);
                  }
                }
              });
            });
          });
        });
      });
    }

    vm.onNewOrg = function() {
      vm.finished();

      vm.parent.onSelect(1);
      vm.parent.setActive(1, true);
      vm.parent.setActive(2, false);
      vm.parent.setActive(3, false);
      vm.parent.setActive(4, false);
      vm.parent.setActive(5, false);
    }

    vm.onEmail = function(isValid) {
      if ( isValid && !vm.checkingEmail ) {
        vm.stepperCtrl.moveToNext();
      }
    }

    vm.onPassword = function(isValid) {
      if ( isValid ) {

        if ( UserService.isLoggedIn() && UserService.getEmail() == vm.email ) {
          vm.checkForOrg();
        } else {
          UserService.login({
            'email': vm.email,
            'password': vm.password
          }, function(error) {
            if (error == null) {
              vm.checkForOrg();
            }
          });
        }
      }
    }

    vm.checkForOrg = function() {
      // check for more organizations
      OrganizationService.loadList( false, function(error, list) {

        vm.list = list;
        if ( list && list.length > 0)
          vm.isOrgDetected = true;

        if ( vm.isOrgDetected ) {
          vm.orgsDetected();
          vm.stepperCtrl.setCurrent(2);
        } else {
          vm.stepperCtrl.elementList[2].setup(false, false, false);
          vm.stepperCtrl.setNumbers();
          // if not we are done
          vm.finished();
          vm.parent.onSelect(1);
        }
      });
    }

    vm.onSignup = function(isValid) {
      if (isValid && vm.createValid() ) {

        UserService.register({
          'firstname': vm.firstname,
          'lastname': vm.lastname,
          'password': vm.password,
          'email': vm.email,
          'phone': vm.phoneNumber,
          'birthday': vm.birthday
        }, function(error) {
          if (error == null) {
            //vm.stepperCtrl.moveToNext();
            vm.finished();
            vm.parent.onSelect(1);
          }
        });
      }
    }

    $scope.$on('$destroy', function UnLoaded() {

    });

  }

  function yaIndustry() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/pages/onboarding/onboarding-industrycategory.html',
      scope: { parent: '=parent' },
      controller: IndustryCtrl,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;

  }

  /** @ngInject */
  function IndustryCtrl($scope, $rootScope, IndTypeService, BusCatService, OrganizationService) {
    var vm = this;

    vm.currentType = '';
    vm.currentCat = '';

    vm.getCtrl = function(ctrl) {
      vm.stepperCtrl = ctrl;
      vm.loaded();
    }

    /*vm.loadOrg = $rootScope.$on('onboarding.load', function() {
        vm.loaded();
      });

    $scope.$on('$destroy', function() {
      vm.loadOrg();
    });*/

    vm.loaded = function() {

      // ( isvisible, isactive, isdone )
      vm.stepperCtrl.elementList[0].setup(true, true, false);
      vm.stepperCtrl.elementList[1].setup(true, false, false);

      IndTypeService.load(null, function() {
        vm.types = IndTypeService.getTypes();

        if ( OrganizationService.get().industrytypeid != -1) {
          IndTypeService.setCurrentByID( OrganizationService.get().industrytypeid );
        }
        vm.currentType = IndTypeService.getCurrent().name;

        vm.categories = [];
        BusCatService.load( function(error) {
          if ( error == null ) {

            if ( vm.currentType != '' ) {
              // ( isvisible, isactive, isdone )
              vm.stepperCtrl.elementList[0].setup(true, true, true);
              vm.categories = BusCatService.getCategories(IndTypeService.getID());

              BusCatService.getOrgBusCat( function() {
                vm.currentCat = BusCatService.getCurrent().name;
                if ( vm.currentCat != '' ) {
                  // ( isvisible, isactive, isdone )
                  vm.stepperCtrl.elementList[1].setup(true, true, true);
                }
              });
            }
          }
        });
      });
    }

    vm.getCurrentIndustryType = function() {
      if (vm.currentType === '') {
        return 'Industry Type';
      } else {
        return vm.currentType;
      }
    }

    vm.getCurrentCategories = function() {
      if (vm.currentCat === '') {
        return 'Category';
      }
      else {
        return vm.currentCat;
      }
    }

    vm.onBack = function() {
      if ( vm.stepperCtrl.moveBack() ) {
        vm.parent.onSelect(0);
      }
    }

    vm.onIndustryType = function(isValid) {
      if ( isValid ) {
        vm.stepperCtrl.moveToNext();
      }
    }

    vm.onIndustryCat = function(isValid) {
      if ( isValid ) {
        var indyID = OrganizationService.getIndustry();
        BusCatService.removeOrgBusCat( function() {
          BusCatService.setCurrent(vm.currentCat);
          BusCatService.setOrganization( function() {
            if ( OrganizationService.getID() ) {
              OrganizationService.register(function() {
              });
            }
            // if the industry type changed kill the billing plan ( rate plans tab )
            if ( indyID != IndTypeService.getID() ) {
              IndTypeService.removePlan(OrganizationService.getID(), function() {});
              vm.parent.setActive(3, false);
              vm.parent.setActive(4, false);
              vm.parent.setActive(5, false);
            }
            vm.stepperCtrl.moveToNext();
            vm.parent.setActive(2, true);
            vm.parent.onSelect(2);
          });
        });
      }
    }

    vm.Update = function( ) {
      //vm.ready = ( vm.currentCat != "" && vm.currentType != "" );
      IndTypeService.setCurrent(vm.currentType);
      vm.categories = BusCatService.getCategories(IndTypeService.getID());
      vm.currentCat = '';
      BusCatService.setCurrent(vm.currentCat);
      // ( isvisible, isactive, isdone )
      vm.stepperCtrl.elementList[1].setup(true, true, false);

    }

    vm.UpdateCat = function( ) {
      //vm.ready = ( vm.currentCat != "" && vm.currentType != "" );
      //
    }
  }

  function yaInfo() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/pages/onboarding/onboarding-organizationinfo.html',
      scope: { parent: '=parent' },
      controller: InfoCtrl,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;

  }

  /** @ngInject */
  function InfoCtrl($scope, $rootScope, $timeout, OrganizationService, FormValidationService, BusCatService, OrgSaleService, MessageBoxService) {
    var vm = this;
    vm.states = FormValidationService.GetStates();
    //regex patterns for validation
    vm.ePattern = FormValidationService.GetEmailPattern();
    vm.phPattern = FormValidationService.GetPhonePattern();
    vm.zPattern = FormValidationService.GetZipPattern();
    vm.doesNameExists = false;

    vm.getCtrl = function(ctrl) {
      vm.stepperCtrl = ctrl;
      vm.loaded();
    };


    /*vm.loadOrg = $rootScope.$on('onboarding.load', function() {
     vm.loaded();
     });

     $scope.$on('$destroy', function() {
     vm.loadOrg();
     });*/

    vm.loaded = function() {
      vm.profile = OrganizationService.get();

      // ( isvisible, isactive, isdone )
      vm.stepperCtrl.elementList[0].setup(true, true, false);
      vm.stepperCtrl.elementList[1].setup(true, false, false);
      vm.stepperCtrl.elementList[2].setup(true, false, false);

      $timeout(function() {
        if ( !vm.nameForm.$invalid ) {
          vm.stepperCtrl.elementList[0].setup(true, true, true);
          vm.stepperCtrl.elementList[1].setup(true, true, false);
        }
        if ( !vm.addressForm.$invalid ) {
          vm.stepperCtrl.elementList[1].setup(true, true, true);
          vm.stepperCtrl.elementList[2].setup(true, true, false);
        }
        if ( !vm.contactForm.$invalid ) {
          vm.stepperCtrl.elementList[2].setup(true, true, true);
        }
      }, 1);

    };

    vm.onOrgName = function(isValid) {
      if (isValid) {
        vm.stepperCtrl.moveToNext();
      }
    };

    vm.nameExists = function() {
      return vm.doesNameExists;
    };

    vm.checkName = function() {
      OrganizationService.checkName( vm.profile.name, vm.profile.city, vm.profile.state, function(doesExist) {
        vm.doesNameExists = doesExist;
      });

    };

    vm.onOrgAddress = function(isValid) {
      if ( isValid ) {
        OrganizationService.checkName( vm.profile.name, vm.profile.city, vm.profile.state, function(doesExist) {
          if (doesExist) {
            MessageBoxService.open('Organization Exists', 'This Organization already exists', 'Continue', function() { });
          } else {
            OrganizationService.checkCode(vm.code, function(doesExist) {
              if ( doesExist || !vm.code ) {
                OrganizationService.register(function(error, result) {
                  BusCatService.setOrganization( function() {
                    if ( vm.code !== '' && angular.isDefined(vm.code)) {
                      OrgSaleService.setCode(vm.code);
                      OrgSaleService.verify(function(error) {
                        if ( error === null ) {
                          if (result) {
                            OrgSaleService.setSalesPerson(result, function() {
                              vm.stepperCtrl.moveToNext();
                            });
                          } else {
                            OrgSaleService.setSalesPerson(OrganizationService.getID(), function() {
                              vm.stepperCtrl.moveToNext();
                            });
                          }
                        }
                      });
                    } else {
                      vm.stepperCtrl.moveToNext();
                    }
                  });
                });
              } else {
                MessageBoxService.open('Sales Person Error', 'No sales person found with that referral code', 'Continue', function() { });
              }
            });
          }
        })
      }
    };

    vm.onBack = function() {
      if ( vm.stepperCtrl.moveBack() ) {
        vm.parent.onSelect(1);
      }
    };

    vm.updatePhoneNumber = function( name ) {
      vm.profile[ name ] = FormValidationService.UpdatePhoneNumber( vm.profile[ name ] );
    };

    vm.onOrgContact = function(isValid) {
      if ( isValid ) {
        OrganizationService.register(function() {
          BusCatService.setOrganization( function() {
            vm.stepperCtrl.moveToNext();
            vm.parent.setActive(3, true);
            vm.parent.onSelect(3);
          });
        });
      }
    }
  }

  function yaPlans() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/pages/onboarding/onboarding-rateplans.html',
      scope: { parent: '=parent' },
      controller: PlansCtrl,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;

  }

  /** @ngInject */
  function PlansCtrl($scope, $rootScope, $timeout, IndTypeService, OrganizationService, MessageBoxService) {
    var vm = this;
    vm.ready = false;
    vm.alertCheck = false;
    vm.defaultAlert = true;
    vm.numberOfUsersLabel = '';

    vm.getCtrl = function(ctrl) {
      vm.stepperCtrl = ctrl;
      vm.loaded();
    }

    vm.loaded = function() {
      IndTypeService.load(null, function() {
        IndTypeService.setCurrentByID(OrganizationService.get().industrytypeid);

        IndTypeService.getPlan(OrganizationService.getID(), function() {
          IndTypeService.setCurrentByID(OrganizationService.get().industrytypeid);
          // reset
          vm.industry = IndTypeService.getCurrent( );
          if ( vm.industry.id == 1) {
            vm.alertCheck = false;
          } else {
            vm.alertCheck = true;
          }
          if (vm.industry.name == 'Business or Organization') {
            vm.numberOfUsersLabel = 'Total number of Employees';
          } else if (vm.industry.name == 'Education') {
            vm.numberOfUsersLabel = 'Total number of Students';
          } else if (vm.industry.name == 'Government') {
            vm.numberOfUsersLabel = 'Total number of Elected Officials and Employees';
          }

          vm.costs = IndTypeService.getCosts();
          vm.numberOfUsers = vm.costs.users;

          vm.PlanSelected();
        });


        // ( isvisible, isactive, isdone )
        vm.stepperCtrl.elementList[0].setup(true, true, false);
        vm.stepperCtrl.elementList[1].setup(true, false, false);

        $timeout(function() {
          if ( !vm.planForm.$invalid ) {
            vm.stepperCtrl.elementList[0].setup(true, true, true);
            vm.stepperCtrl.elementList[1].setup(true, true, false);
          }
          /*if( !vm.addressForm.$invalid ){
            vm.stepperCtrl.elementList[1].setup(true,true,true);
            vm.stepperCtrl.elementList[2].setup(true,true,true);
          }*/
        }, 1);

      });
    }

    // select only one plan
    vm.ClickPlan = function(info) {
      for ( var i = 0; i < vm.industry.plans.length; i++ ) {
        var plan = vm.industry.plans[i];
        if ( plan === info ) info.selected = !info.selected;
        else plan.selected = false;
      }
      vm.Update( );
    }

    // toggle options
    vm.ClickOption = function(info) {
      info.selected = !info.selected;
      vm.Update( );
    }

    vm.PlanSelected = function() {
      if ( !vm.industry || !vm.industry.plans )
        return false;
      if ( vm.industry.defualtPlanID != -1 )
        return true;

      for ( var i = 0; i < vm.industry.plans.length; i++ ) {
        var plan = vm.industry.plans[i];
        if ( plan.selected )
          return true;
      }
      return false;
    }

    vm.Update = function( ) {
      vm.numberOfUsers = Math.max(vm.numberOfUsers, 0);
      IndTypeService.setUserCount( vm.numberOfUsers );
      //only show the small school option for small schools (< 100 students)
      if (vm.industry.name == 'Education' && vm.numberOfUsers < 100) {
        angular.forEach(vm.industry.plans, function(plan) {
          if (plan.maxUser == -1) {
            plan.maxUser = 0;
          }
        })
      } else {
        angular.forEach(vm.industry.plans, function(plan) {
          if (plan.maxUser == 0) {
            plan.maxUser = -1;
          }
        })
      }
    }

    /*vm.isReady = function(){
      return vm.ready;
    }*/

    vm.onBack = function() {
      if ( vm.stepperCtrl.moveBack() ) {
        vm.parent.onSelect(2);
      }
    }

    vm.onPlan = function(isValid) {
      if (isValid) {
        if ( vm.alertCheck && vm.industry ) {
          for ( var i = 0; i < vm.industry.options.length; i++ ) {
            if ( vm.industry.options[i].title.toLowerCase().indexOf('alert') == 0 ) {
              vm.industry.options[i].selected = vm.defaultAlert;
              break;
            }
          }
        }
        vm.Update();

        if (vm.promocode) {
          //rate plans are tied to industry type, so we have to reload them
          //to get the new payment plan to come down
          IndTypeService.load(vm.promocode, function(err) {
            if (err) {
              MessageBoxService.open('Unable to Apply Promotional Code', err, 'Continue', function() {
                vm.promocode = null;
              });
            } else {
              IndTypeService.getPlan(OrganizationService.getID(), function() {
                IndTypeService.setCurrentByID(OrganizationService.get().industrytypeid);
                // reset
                vm.industry = IndTypeService.getCurrent( );
                if ( vm.industry.id == 1) {
                  vm.alertCheck = false;
                } else {
                  vm.alertCheck = true;
                }

                vm.costs = IndTypeService.getCosts();

                vm.PlanSelected();
                vm.stepperCtrl.moveToNext();

              });
            }
          });
        } else {
          IndTypeService.load(null, function(err) {
            if (err) {
              MessageBoxService.open('Unable to load Payment Plans', err, 'Continue', function() {
                vm.promocode = null;
              });
            } else {
              vm.stepperCtrl.moveToNext();
            }
          });
        }
      }
    }

    vm.Done = function() {
      IndTypeService.setPlan(OrganizationService.getID(), function() {
        vm.costs = IndTypeService.getCosts();
        vm.ready = vm.costs.ready;
        if ( vm.ready ) {
          vm.parent.setActive(4, true);
          vm.parent.onSelect(4);
        }
      });
    }
  }

  function yaBilling() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/pages/onboarding/onboarding-billinginfo.html',
      scope: { parent: '=parent' },
      controller: BillingCtrl,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
  }

  /** @ngInject */
  function BillingCtrl($scope, OrgBillingService, FormValidationService, MessageBoxService, OrganizationService) {
    var vm = this;

    vm.billingTypes = ['Bank Account', 'Credit Card'];
    vm.bankAccountTypes = ['CHECKING', 'SAVINGS', 'BUSINESS'];
    vm.billing = OrgBillingService.get();

    //regex patterns for validation
    vm.ePattern = FormValidationService.GetEmailPattern();
    vm.phPattern = FormValidationService.GetPhonePattern();
    vm.zPattern = FormValidationService.GetZipPattern();
    vm.rPattern = FormValidationService.GetRoutingPattern();
    vm.aPattern = FormValidationService.GetAccountNoPattern();
    vm.cPattern = FormValidationService.GetCardNoPattern();
    vm.cvcPattern = FormValidationService.GetCvcPattern();
    vm.dPattern = FormValidationService.GetDatePattern();

    vm.monthList = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    vm.yearList = [];
    var date = new Date();
    for ( var i = 0; i < 20; i++)
      vm.yearList.push( (date.getFullYear() + i).toString() );

    vm.getCtrl = function(ctrl) {
      vm.stepperCtrl = ctrl;
      vm.loaded();
    }

    vm.loaded = function() {

      OrgBillingService.load(function() {
        vm.billing = OrgBillingService.get();
        if ( vm.billing.loaded ) {
          vm.stepperCtrl.elementList[1].setup(false, false, false);
        }
      });
    }

    vm.Remove = function( ) {
      OrgBillingService.delete(function() {
        vm.billing = OrgBillingService.get();
        if ( vm.billing.loaded ) {
          vm.stepperCtrl.elementList[1].setup(false, false, false);
        }
        vm.parent.setActive(3, true);
        vm.parent.onSelect(3);
      });
    }

    vm.Update = function( ) {

    }

    vm.onImport = function() {
      if ( vm.import ) {
        var profile = OrganizationService.get();
        vm.billing.billtofirstname = profile.contactfirstname;
        vm.billing.billtolastname = profile.contactlastname;
        vm.billing.email = profile.email;
        vm.billing.address = profile.street + ' ' + profile.street2;
        vm.billing.city = profile.city;
        vm.billing.zip = profile.zip;
      } else {
        vm.billing.billtofirstname = '';
        vm.billing.billtolastname = '';
        vm.billing.email = '';
        vm.billing.address = '';
        vm.billing.city = '';
        vm.billing.zip = '';
      }
    }

    vm.onContinue = function() {
      vm.parent.setActive(5, true);
      vm.parent.onSelect(5);
    }

    vm.onBack = function() {
      if ( vm.stepperCtrl.moveBack() ) {
        vm.parent.onSelect(3);
      }
    }

    vm.SetUp = function(isValid) {
      if (isValid) {
        vm.stepperCtrl.moveToNext();
      }
    }

    vm.Address = function(isValid) {
      if (isValid) {
        vm.billing.expDate = vm.year + '-' + vm.month;
        OrgBillingService.register(function(error) {
          if ( error ) {
            MessageBoxService.open('Billing Error', error, 'Continue', function() { });
          } else {
            vm.parent.setActive(5, true);
            vm.parent.onSelect(5);
          }
        });
      }
    }
  }

  function yaSummary() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/pages/onboarding/onboarding-summary.html',
      scope: { parent: '=parent' },
      controller: SummaryCtrl,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
  }

  /** @ngInject */
  function SummaryCtrl(IndTypeService, OrganizationService, OrgBillingService, StateService, MessageBoxService) {
    var vm = this;
    vm.agreement = false;

    vm.getCtrl = function(ctrl) {
      vm.stepperCtrl = ctrl;
      vm.loaded();
    }

    vm.loaded = function() {
      vm.profile = OrganizationService.get();
      vm.address = vm.profile.city + ', ' + vm.profile.state + ' ' + vm.profile.zip;

      OrgBillingService.load(function() {
        vm.billing = OrgBillingService.get();
        IndTypeService.load(null, function() {
          IndTypeService.getPlan(OrganizationService.getID(), function() {
            IndTypeService.setCurrentByID(OrganizationService.get().industrytypeid);
            vm.industry = IndTypeService.getCurrent();
            vm.costs = IndTypeService.getCosts();
            if (vm.industry.name == 'Education') {
              //handle small schools a little differently
              if (vm.costs.users < 100) {
                vm.smallSchoolCost = parseFloat(vm.costs.plan.minimum);
              } else {
                vm.studentCost = parseFloat(vm.costs.plan.priceperperson) * parseFloat(vm.costs.users);
              }
            }

            if (vm.industry.name == 'Business or Organization') {
              vm.userLabel = 'Employees';
            } else if (vm.industry.name == 'Education') {
              vm.userLabel = 'Students';
            } else if (vm.industry.name == 'Government') {
              vm.userLabel = 'Elected Officials and Employees';
            }
            vm.ready = true;
          });
        });
      });
    }

    vm.onContinue = function(valid) {
      if ( valid ) {
        IndTypeService.finishPlan(OrganizationService.getID(), function(error) {
          if (!error) {
            OrganizationService.setOnboardFinish(function() {
              StateService.go('dashboard');
            });
          } else {
            MessageBoxService.open(
              'ERROR',
              'Unable to process payment. Please verify your payment information is correct.',
              'ok',
              function() { }
            );
          }
        });
      }
    }

    vm.onBack = function() {
      if ( vm.stepperCtrl.moveBack() ) {
        vm.parent.onSelect(4);
      }
    }

  }

})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('MobileLanding.Controller', MobileLandingController);

  /** @ngInject */
  function MobileLandingController() {

  }

});

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('MessageReportsDetailed.Controller', MessageReportsDetailedController);

  /** @ngInject */
  function MessageReportsDetailedController(
    $scope,
    $routeParams,
    OrgReportService,
    StateService,
    OrganizationService,
    $sce,
    TokenService,
    $window,
    loadingScreen
  ) {
    var vm = this;
    vm.name = 'Message Reports Detailed';
    vm.orgID = $routeParams.orgID;
    vm.reportID = $routeParams.reportID;

    vm.loadData = function() {
      // OrgReportService.getReportDetails(vm.reportID, function() {
      //   vm.report = OrgReportService.getMessageReportDetails();
      // })
    };

    vm.loadData();

    vm.downloadFile = function(type) {
      OrgReportService.getDownloadLink(vm.reportID, type, function(error, result) {
        $window.open(
          result,
          '_blank'
        );
      })
    };

    vm.getFrameSrc = function() {
      return $sce.trustAsResourceUrl($window.APPLICATION_SETTINGS.V2_URL + '/organizations/' + vm.orgID + '/reports/message/' + vm.reportID + '?iframe=true&token=' + TokenService.get());
    }

    $window.addEventListener('message', function(e) {
      if (e.data && e.data.type === 'url') {
        location.assign(e.data.url);
      }
      if (e.data && e.data.type === 'loading') {
        $scope.$apply(function() {
          loadingScreen.turnOn(e.data.loading);
        });
      }
    }, false);

    // check to see if data should reload
    if (vm.orgID != OrganizationService.getID()) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });


    vm.onBack = function() {
      StateService.go('messagereports')
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('MessageReports.Controller', MessageReportsController);

  /** @ngInject */
  function MessageReportsController(
    $scope,
    $routeParams,
    $uibModal,
    $timeout,
    $rootScope,
    OrganizationService,
    UserService,
    OrgUserService,
    OrgReportService,
    MessageBoxService,
    $sce,
    TokenService,
    $window,
    loadingScreen
  ) {
    var vm = this;
    vm.name = 'Reporting Page';
    vm.orgID = $routeParams.orgID;
    vm.report = {};
    vm.data = [];
    vm.totalPages = 0;
    vm.currentPage = 0;
    vm.lastWeek = new Date();
    vm.selectedTab = '';
    vm.lastWeek.setDate(vm.lastWeek.getDate() - 7);


    vm.getFrameSrc = function() {
      return $sce.trustAsResourceUrl($window.APPLICATION_SETTINGS.V2_URL + '/organizations/' + vm.orgID + '/reports/messages/alert?iframe=true&token=' + TokenService.get());
    }

    $window.addEventListener('message', function(e) {
      if (e.data && e.data.type === 'url') {
        location.assign(e.data.url);
      }
      if (e.data && e.data.type === 'loading') {
        $scope.$apply(function() {
          loadingScreen.turnOn(e.data.loading);
        });
      }
    }, false);



    vm.loadData = function() {

    };

    // vm.loadData = function(){
    //   UserService.load(function(){
    //     OrgUserService.dbLoadMyUser( ['reportaccess'],function(error){
    //       if(error){
    //         MessageBoxService.open("Permission Error", "You do not have permission to view this page.","Continue", function(){ });
    //       }

    //       $timeout(function() {
    //         $rootScope.$emit('page.ready');
    //       },100);

    //     });

    //     OrgReportService.reportMaxPage('alert', function(result) {
    //       vm.selectedTab = 'alert';
    //       vm.totalPages = result;

    //       OrgReportService.loadMessageReportList('alert', vm.currentPage, function() {
    //         vm.data = OrgReportService.getMessageReportList();
    //         vm.checkDates();
    //         console.log(vm.data);
    //       })
    //     });
    //   });
    // };

    vm.onTabSelected = function(type) {
      if ( OrgUserService.dbGetMyPermissions('reportaccess') ) {
        vm.selectedTab = type;

        OrgReportService.reportMaxPage(type, function(result) {

          vm.totalPages = result;

          OrgReportService.loadMessageReportList(type, vm.currentPage, function() {
            vm.data = OrgReportService.getMessageReportList();

            vm.checkDates();

          })
        });

      }
    };

    vm.viewReportDetails = function(data) {
      location.assign('/#/messagereports/' + vm.orgID + '/' + data.id );
    };

    vm.checkDates = function() {
      vm.data.forEach(function(message) {
        message.actualDateObject = new Date(message.sendtime);
        message.isInGracePeriod = message.actualDateObject >= vm.lastWeek;
      })
    };

    vm.confirmPurchase = function(report) {
      vm.popup = $uibModal.open({
        templateUrl: 'app/popups/purchasereport/purchasereport.html',
        controller: 'PurchaseReport.Controller as vm',
        windowClass: 'template-box',
        scope: $scope,
        resolve: {
          report: function() {
            return report;
          }
        }
      });
    };

    vm.onPage = function() {
      vm.onTabSelected(vm.selectedTab);
    };

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();


(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Logout.Controller', LogoutController);

  /** @ngInject */
  function LogoutController(
    $scope,
    $rootScope,
    $routeParams,
    $timeout,
    $sce,
    TokenService,
    $window,
    $document,
    loadingScreen,
    UserService
  ) {
    var vm = this;

    loadingScreen.turnOn(true);
    vm.initialToken = TokenService.get();

    vm.getFrameSrc = function() {
      return $sce.trustAsResourceUrl($window.APPLICATION_SETTINGS.V2_URL + '/logout?iframe=true&token=' + vm.initialToken);
    }

    $window.addEventListener('message', function(e) {
      if (e.data && e.data.type === 'logout') {
        UserService.logout();

        var ifr = document.getElementsByTagName('iframe')[0];
        var rslt = {
          uuid: e.data.uuid,
          success: true
        };

        ifr.contentWindow.postMessage(rslt, '*');
      }
      if (e.data && e.data.type === 'url') {
        loadingScreen.turnOn(false);
        location.assign(e.data.url);
      }
      if (e.data && e.data.type === 'loading') {
        $scope.$apply(function() {
          loadingScreen.turnOn(e.data.loading);
        });
      }
    }, false);

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('License.Controller', LicenseController);

  /** @ngInject */
  function LicenseController() {
    var vm = this;

    vm.loadData = function() {

    }

    vm.loadData();
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Join.Controller', JoinController);

  /** @ngInject */
  function JoinController($routeParams) {
    var vm = this;
    vm.link = $routeParams.redirect;
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Image.Controller', ImageController);

  /** @ngInject */
  function ImageController($scope, $document, $routeParams, OrganizationService, UploadFileService, StateService) {
    var vm = this;
    vm.name = 'Profile Image';
    vm.orgID = $routeParams.orgID;

    vm.loadData = function() {
      vm.profile = OrganizationService.get();
      vm.reader = new FileReader( );
      vm.profileimage = null;
      vm.profiletagline = null;

      if ( vm.profile.profileimage != null ) {
        $document[0].getElementById('image1').src = vm.profile.profileimage
      }
      if ( vm.profile.profiletagline != null ) {
        $document[0].getElementById('image2').src = vm.profile.profiletagline;
      }
    }

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.LoadImage = function(dest, file) {
      var image = $document[0].getElementById(dest);
      vm.reader.onload = function(event) {
        image.src = event.target.result;
        $scope.$apply();
      };
      vm.reader.readAsDataURL(file);
    }

    vm.Update = function(dest, element) {
      vm[element.id] = element.files[0];
      vm.LoadImage(dest, element.files[0]);
    }

    vm.Upload = function(id) {
      UploadFileService.upload( vm[id], function(path, error) {
        if ( error == null ) {
          vm[id] = null;
          vm.profile[id] = path;
        }
      })
    }

    vm.Continue = function() {
      if ( vm.profileimage == null && vm.profiletagline == null ) {
        OrganizationService.register(function() {
          OrganizationService.setState('image', function() {
            StateService.go('catsetup');
          });
        });
      }
    }

    vm.Back = function() {
      StateService.go('billing');
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      vm.reader = null; // some how causes GC to clear stupid memory for filereader
    });


  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('IframeAdmin.Controller', IframeAdminController);

  /** @ngInject */
  function IframeAdminController(
    $scope,
    $rootScope,
    $timeout,
    $log,
    $sce,
    $uibModal,
    TokenService,
    UserService,
    OrganizationService,
    OrgUserService,
    $window,
    $document,
    loadingScreen,
    $route,
    $location,
    ClasslinkService,
    $routeParams
  ) {
    var vm = this;
    vm.orgID = $routeParams.orgID;
    vm.loadData = function() {
      UserService.load(function() {
        OrgUserService.dbUserLoad( function() {
          OrgUserService.dbLoadMyUser( [], function() {
            vm.mypermission = OrgUserService.dbGetMyPermissions('orgadmin');

            UserService.load(function() {

              $timeout(function() {
                $rootScope.$emit('page.ready');
              }, 100);
            });

          });
        });
      });
    };

    if ( vm.orgID !== OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else if (vm.orgID) {
      vm.loadData();
    }

    vm.getFramePathFromPath = function(currentPath) {
      var paths = [
        {
          replace: '/login',
          pattern: '/',
          view: 'full'
        },
        {
          replace: '/logout',
          pattern: '/logout',
          view: 'full'
        },
        // {
        //   replace: '/completesales',
        //   pattern: '/completesales',
        //   view: 'full'
        // },
        // {
        //   replace: '/completesales/$1',
        //   pattern: '/completesales/(.*)',
        //   view: 'full'
        // },
        {
          replace: '/completesales/$1/$2',
          pattern: '/completesales/([0-9]{3}-[0-9]{3})/(.*)',
          view: 'full'
        },
        {
          replace: '/select',
          pattern: '/select',
          view: 'full'
        },
        {
          replace: '/select/$1',
          pattern: '/select/([0-9]{3}-[0-9]{3}-[0-9]{4})',
          view: 'full'
        },
        {
          replace: '/sales-order/$1',
          pattern: '/sales/([0-9]{3}-[0-9]{3})',
          view: 'full'
        },
        {
          replace: '/sales-order/$1',
          pattern: '/sales/([0-9]{3}-[0-9]{3}-[0-9]{4})',
          view: 'full'
        },
        {
          replace: '/sales-order/$1/$2',
          pattern: '/sales/([0-9]{3}-[0-9]{3}-[0-9]{4})/(.*)',
          view: 'full'
        },
        {
          replace: '/sales-order-bulk/$1',
          pattern: '/sales-bulk/([0-9]{3}-[0-9]{3})',
          view: 'full'
        },
        {
          replace: '/sales-order-bulk/$1',
          pattern: '/sales-bulk/([0-9]{3}-[0-9]{3}-[0-9]{4})',
          view: 'full'
        },
        {
          replace: '/sales-order-bulk/$1/$2',
          pattern: '/sales-bulk/([0-9]{3}-[0-9]{3}-[0-9]{4})/(.*)',
          view: 'full'
        },
        {
          replace: '/distributors',
          pattern: '/distributors',
          view: 'admin'
        },
        {
          replace: '/distributors/add',
          pattern: '/distributors/add',
          view: 'admin'
        },
        {
          replace: '/distributors/$1',
          pattern: '/distributors/([0-9]+)',
          view: 'admin'
        },
        {
          replace: '/distributors/$1/sales-orders/$2',
          pattern: '/distributors/([0-9]+)/sales-orders/([0-9]{3}-[0-9]{3}-[0-9]{4})',
          view: 'admin'
        },
        {
          replace: '/distributors/$1/resellers/add',
          pattern: '/distributors/([0-9]+)/resellers/add',
          view: 'admin'
        },
        {
          replace: '/distributors/$1/resellers/$2',
          pattern: '/distributors/([0-9]+)/resellers/([0-9]+)',
          view: 'admin'
        },
        {
          replace: '/distributors/$1/resellers/$2/sales-people',
          pattern: '/distributors/([0-9]+)/resellers/([0-9]+)/sales-people',
          view: 'admin'
        },
        {
          replace: '/distributors/$1/resellers/$2/sales-people/add',
          pattern: '/distributors/([0-9]+)/resellers/([0-9]+)/sales-people/add',
          view: 'admin'
        },
        {
          replace: '/distributors/$1/resellers/$2/sales-people/$3',
          pattern: '/distributors/([0-9]+)/resellers/([0-9]+)/sales-people/([0-9]+)',
          view: 'admin'
        },
        {
          replace: '/distributors/$1/resellers/$2/sales-order/$3',
          pattern: '/distributors/([0-9]+)/resellers/([0-9]+)/sales-order/([0-9]{3}-[0-9]{3}-[0-9]{4})',
          view: 'admin'
        },
        {
          replace: '/distributors/$1/payment-reports/$2',
          pattern: '/distributors/([0-9]+)/payment-reports/([0-9]{3}-[0-9]{3}-[0-9]{4})',
          view: 'admin'
        },
        {
          replace: '/distributor/$1',
          pattern: '/distributor/([0-9]+)',
          view: 'full'
        },
        {
          replace: '/distributor/$1/sales-orders/$2',
          pattern: '/distributor/([0-9]+)/sales-orders/([0-9]{3}-[0-9]{3}-[0-9]{4})',
          view: 'full'
        },
        {
          replace: '/distributor/$1/resellers/add',
          pattern: '/distributor/([0-9]+)/resellers/add',
          view: 'full'
        },
        {
          replace: '/distributor/$1/resellers/$2',
          pattern: '/distributor/([0-9]+)/resellers/([0-9]+)',
          view: 'full'
        },
        {
          replace: '/distributor/$1/resellers/$2/sales-people',
          pattern: '/distributor/([0-9]+)/resellers/([0-9]+)/sales-people',
          view: 'full'
        },
        {
          replace: '/distributor/$1/resellers/$2/sales-people/add',
          pattern: '/distributor/([0-9]+)/resellers/([0-9]+)/sales-people/add',
          view: 'full'
        },
        {
          replace: '/distributor/$1/resellers/$2/sales-people/$3',
          pattern: '/distributor/([0-9]+)/resellers/([0-9]+)/sales-people/([0-9]+)',
          view: 'full'
        },
        {
          replace: '/distributor/$1/resellers/$2/sales-order/$3',
          pattern: '/distributor/([0-9]+)/resellers/([0-9]+)/sales-order/([0-9]{3}-[0-9]{3}-[0-9]{4})',
          view: 'full'
        },
        {
          replace: '/distributor/$1/payment-reports/$2',
          pattern: '/distributor/([0-9]+)/payment-reports/([0-9]{3}-[0-9]{3}-[0-9]{4})',
          view: 'full'
        },
        {
          replace: '/resellers/$1',
          pattern: '/resellers/([0-9]{3}-[0-9]{3})',
          view: 'full'
        },
        {
          replace: '/resellers/$1/sales-people',
          pattern: '/resellers/([0-9]{3}-[0-9]{3})/sales-people',
          view: 'full'
        },
        {
          replace: '/resellers/$1/sales-people/add',
          pattern: '/resellers/([0-9]{3}-[0-9]{3})/sales-people/add',
          view: 'full'
        },
        {
          replace: '/resellers/$1/sales-people/$2',
          pattern: '/resellers/([0-9]{3}-[0-9]{3})/sales-people/([0-9]+)',
          view: 'full'
        },
        {
          replace: '/resellers/$1/sales-order/$2',
          pattern: '/resellers/([0-9]{3}-[0-9]{3})/sales-order/([0-9]{3}-[0-9]{3}-[0-9]{4})',
          view: 'full'
        },
        {
          replace: '/pricing-templates',
          pattern: '/pricing-templates',
          view: 'admin'
        },
        {
          replace: '/pricing-templates/add',
          pattern: '/pricing-templates/add',
          view: 'admin'
        },
        {
          replace: '/pricing-templates/$1',
          pattern: '/pricing-templates/([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})',
          view: 'admin'
        },
        {
          replace: '/organizations/$1/reports/covid',
          pattern: '/covidreports/([0-9]+)',
          view: 'normal'
        }
      ];

      var iframePath = null;
      var matchedPath = null;

      paths.some(function(path) {
        var re = new RegExp('^' + path.pattern + '$');

        if (re.test(currentPath)) {
          matchedPath = path;
          iframePath = currentPath.replace(re, path.replace);
          return true;
        } else {
          return false;
        }
      });

      if (!iframePath) {
        $log.log('No Match: ', currentPath);
        return null;
      }

      return Object.assign({}, matchedPath, {iframePath: iframePath});
    };

    vm.iframeLookup = vm.getFramePathFromPath($location.path());
    vm.iframeSource = vm.iframeLookup ? $sce.trustAsResourceUrl($window.APPLICATION_SETTINGS.V2_URL + vm.iframeLookup.iframePath + '?iframe=true&token=' + TokenService.get()) : null;

    vm.getFrameSrc = function() {
      return $sce.trustAsResourceUrl(vm.iframeSource);
    }

    vm.postMessage = function(message) {
      var ifr = document.getElementsByTagName('iframe')[0];
      if (ifr && ifr.contentWindow) {
        ifr.contentWindow.postMessage(message, '*');
      } else {
        $log.log('no ifr.contentWindow', ifr);
      }
    }

    var skipReload = function(iframeLookup) {
      var lastRoute = $route.current;
      var un = $rootScope.$on('$locationChangeSuccess', function() {
        if (iframeLookup) {
          $route.current = lastRoute;
          vm.postMessage({
            type: 'navigate',
            url: iframeLookup.iframePath + '?force=true'
          });
        }
        un();
      });
    };

    $window.addEventListener('message', function(e) {
      var ifr;
      var rslt;
      if (e.data && e.data.type === 'logout') {
        UserService.logout();

        ifr = document.getElementsByTagName('iframe')[0];
        rslt = {
          uuid: e.data.uuid,
          success: true
        };

        ifr.contentWindow.postMessage(rslt, '*');
      }
      if (e.data && e.data.type === 'sendwithschedule') {
        ifr = document.getElementsByTagName('iframe')[0];
        rslt = {
          uuid: e.data.uuid
        };
        UserService.sendReportMessage(e.data)
        .then(function() {
          rslt.success = true;
          ifr.contentWindow.postMessage(rslt, '*');
        })
        .catch(function() {
          rslt.success = false;
          ifr.contentWindow.postMessage(rslt, '*');
        });
      }
      if (e.data && e.data.type === 'login') {
        ifr = document.getElementsByTagName('iframe')[0];
        rslt = {
          uuid: e.data.uuid
        };

        UserService.loginPromise({
          email: e.data.email,
          password: e.data.password
        })
        .then(function() {
          rslt.success = true;
          rslt.access_token = TokenService.get();
          ifr.contentWindow.postMessage(rslt, '*');
        })
        .catch(function() {
          UserService.logout();
          rslt.success = false;
          ifr.contentWindow.postMessage(rslt, '*');
        });
      }

      if (e.data && e.data.type === 'url') {
        if (e.data.url === '/class-link') {
          vm.signInWithClasslink();
          return;
        }

        vm.iframeLookup = vm.getFramePathFromPath(e.data.url.replace('/#/', '/'));

        if (vm.iframeLookup) {
          skipReload(vm.iframeLookup);
        }

        $timeout(function() {
          location.assign(e.data.url);
        }, 0);
      }

      if (e.data && e.data.type === 'terms') {
        vm.popup = $uibModal.open({
          templateUrl: 'app/popups/terms/terms.html',
          controller: 'Terms.Controller as vm',
          windowClass: 'template-box',
          scope: $scope
        });
      }

      if (e.data && e.data.type === 'loading') {
        $scope.$apply(function() {
          loadingScreen.turnOn(e.data.loading);

          if (e.data.loading) {
            $timeout(function() {
              loadingScreen.reset();
            }, 2000);
          }
        });
      }
    }, false);


    vm.signInWithClasslink = function() {
      var here = $location.protocol() + '://' + $location.host() + ':' + $location.port();
      location.href = ClasslinkService.getProfileAccessUrl(here + '/#');
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      //vm.reader = null; // garbage collect
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Home.Controller', HomeController);

  /** @ngInject */
  function HomeController(
    $scope,
    $log,
    $uibModal,
    UserService,
    MessageBoxService,
    $window,
    $document,
    $location,
    ClasslinkService,
    TokenService,
    $sce,
    loadingScreen
  ) {
    var vm = this; // vm in js and home in html
    vm.name = 'Home Page';
    vm.popup = null;
    vm.username = '';
    vm.password = '';
    vm.params = $location.search();
    vm.initialToken = TokenService.get();

    if ( UserService.isLoggedIn() ) {
      UserService.load(function(error) {
        if ( error == null ) {
          vm.username = UserService.getEmail();
          vm.password = '**********';
        }
        else {
          UserService.logout();
        }
      });
    }

    if (vm.params.error || vm.params.code) {
      // we arrived here via the redirect uri from classlink
      // check if our access request passed or failed
      if (vm.params.code) {
        ClasslinkService.exchangeCodeForAccessToken(vm.params.code, function(error, response) {
          if (response && response.data && response.data.access_token) {
            UserService.loginWithClasslink(response.data.access_token, function(error) {
              if (error) {
                UserService.logout();
              } else {
                location.assign('/#/select');
              }
            });
          }
        });
      }
    }

    vm.getFrameSrc = function() {
      return $sce.trustAsResourceUrl($window.APPLICATION_SETTINGS.V2_URL + '/login?iframe=true&token=' + vm.initialToken);
    }

    $window.addEventListener('message', function(e) {
      if (e.data && e.data.type === 'url') {
        if (e.data.url === '/class-link') {
          vm.signInWithClasslink();
        } else {
          location.assign(e.data.url);
        }
      }
      if (e.data && e.data.type === 'loading') {
        $scope.$apply(function() {
          loadingScreen.turnOn(e.data.loading);
        });
      }
      if (e.data && e.data.type === 'login') {
        var ifr = document.getElementsByTagName('iframe')[0];
        var rslt = {
          uuid: e.data.uuid
        };

        UserService.loginPromise({
          email: e.data.email,
          password: e.data.password
        })
        .then(function() {
          rslt.success = true;
          rslt.access_token = TokenService.get();
          ifr.contentWindow.postMessage(rslt, '*');
        })
        .catch(function() {
          UserService.logout();
          rslt.success = false;
          ifr.contentWindow.postMessage(rslt, '*');
        });


      }
    }, false);

    // vm.AdminLogin = function(isValid){
    //   if( UserService.isLoggedIn() && UserService.getEmail() == vm.username ){
    //       location.assign("/#/select");
    //   }else if(isValid) {
    //     UserService.login({
    //       'email': vm.username,
    //       'password': vm.password
    //     },function(error){
    //       if(error) {
    //         //error
    //         UserService.logout();
    //         //MessageBoxService.open("Login Error",error,"Continue", function(){ $log.debug("close"); });
    //       } else {
    //         location.assign("/#/select");
    //       }
    //     });
    //   }
    // }

    // vm.openTerms = function(){
    //   vm.popup = $uibModal.open({
    //     templateUrl: 'app/popups/terms/terms.html',
    //     controller: 'Terms.Controller as vm',
    //     windowClass: 'template-box',
    //     scope: $scope
    //   });
    // }

    vm.signInWithClasslink = function() {
      var here = $location.protocol() + '://' + $location.host() + ':' + $location.port();
      location.href = ClasslinkService.getProfileAccessUrl(here + '/#');
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      vm.username = '';
      vm.password = '';
      vm.popup = null;
    });
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('GroupUser.Controller', GroupUserController);

  /** @ngInject */
  function GroupUserController($scope, $routeParams, $rootScope, $timeout, $document, $uibModal, FormValidationService, UploadFileService, MessageBoxService, OrganizationService, OrgCatService, OrgUserService, UserService, StateService) {
    var vm = this;
    vm.name = '';
    vm.groupUser = OrgUserService.getGroupUser();
    vm.orgID = $routeParams.orgID;
    vm.groupID = $routeParams.groupID;
    vm.exportLink = OrgUserService.getCsvExportLink(null, vm.groupID);
    vm.users = [];
    vm.group = {};
    vm.totalPages = 0;
    vm.currentPage = 0;
    vm.mypermission = false;
    vm.reader = new FileReader( );
    vm.helpTipList = [
      'Once recipients are uploaded into a group, they will receive a confirmation email. If you need to re-send the email, you may hover over a recipient and click \'Re-Send\'.'
    ];
    vm.filter = '';

    vm.loadData = function() {
      OrgUserService.dbLoadMyUser(['orgadmin'], function(error) {

        if ( error ) {
          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
          return;
        }

        vm.mypermission = true;
        UserService.load(function() {
          OrgCatService.load(function() {
            vm.GetGroupName();
            vm.Update();
          });
        });
      });
    };


    vm.Update = function() {
      OrgUserService.grpMaxPage(vm.groupID, function(result) {
        vm.totalPages = result;
        OrgUserService.grpUserLoad(vm.groupID, vm.currentPage, vm.filter, function(/*error*/) {
          var grpList = OrgCatService.get(false);
          for ( var i = 0; i < grpList.length; i++) {
            if ( grpList[i].id == vm.groupID) {
              vm.group = grpList[i];
              break;
            }
          }
          vm.users = OrgUserService.grpGet();
          vm.users.forEach(function(user) {
            user.phonenumber = FormValidationService.UpdatePhoneNumber( user.phonenumber );
            user.canInvite = vm.isUninvitedUser(user);
            user.canReinvite = vm.isInvitedUser(user);
          });

          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);

        });
      });
    };


    vm.canInvite = function(user) {
      if (!user.userid) {
        return vm.isUninvitedUser(user);
      } else if (user.loggedin && !(user.orgUserGroup || {}).optout) {
        return false;
      } else {
        return false;
      }
    };

    vm.canRemind = function(user) {
      if (!user.userid) {
        return false;
      } else if (user.loggedin && !(user.orgUserGroup || {}).optout) {
        return false;
      } else {
        return !(user.orgUserGroup || {}).optout;
      }
    };

    vm.canReinvite = function(user) {
      if (!user.userid) {
        return vm.isInvitedUser(user);
      } else if (user.loggedin && !(user.orgUserGroup || {}).optout) {
        return false;
      } else {
        return false;
      }
    };


    // check to see if data should reload
    if ( vm.orgID !== OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.AddNew = function() {
      if ( vm.mypermission ) {
        vm.popup = $uibModal.open({
          templateUrl: 'app/popups/newgroupuser/newgroupuser.html',
          controller: 'NewGroupUser.Controller as vm',
          windowClass: 'template-box',
          scope: $scope
        });
      }
    };

    vm.GetGroupName = function() {
      OrgCatService.getGroupName(vm.groupID, function(result) {
        vm.name = result;
      });
    };

    vm.deleted = $rootScope.$on('userDeleted', function() {
      vm.Update();
    });
    vm.ConfirmRemove = function(user) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      if ( vm.mypermission ) {
        vm.popup = $uibModal.open({
          templateUrl: 'app/popups/deleteuserconfirm/deleteuserconfirm.html',
          controller: 'DeleteUserConfirm.Controller as vm',
          windowClass: 'template-box',
          scope: $scope,
          resolve: {
            user: function() {
              vm.groupUser = user;
              return vm.groupUser;
            },
            groupID: function() {
              return vm.groupID;
            }
          }
        });
      }
    };

    vm.Remove = function(user) {
      OrgUserService.grpDeleteUser(user, vm.groupID, function() {
        vm.Update();
      });
    };

    vm.OpenEdit = function(user) {
      if ( vm.mypermission ) {

        user.edit = true;
      } else {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
      }
    };

    vm.updatePhoneNumber = function( user ) {
      user.phonenumber = FormValidationService.UpdatePhoneNumber( user.phonenumber );
    };

    vm.CloseEdit = function(user) {
      user.edit = false;

      OrgUserService.grpUpdateUser(user, vm.groupID, function(error) {
        if ( error === null ) {
          vm.Update();
        }
      });
    };

    vm.getPageUsers = function() {
      //var start = (vm.currentPage-1)*20
      //var end = Math.min(start + 20,vm.users.length);
      //return vm.users.slice(start, end);
      return vm.users;
    };

    vm.getStatus = function(user) {
      var invite = OrgUserService.getInvite(user, (user.orgUserGroup || {}).categoryid);


      if (user.userid) {
        if (user.orgUserGroup && user.orgUserGroup.optout) {
          return 'Opted Out';
        } else if (user.loggedin) {
          return 'Opted In';
        // } else if (invite) {
        //   var d = moment(Date.parse(invite.modifieddate));
        //   return 'Logged Out (' + d.format('MM/DD/YYYY') + ')';
        } else {
          return 'Logged Out';
        }
      } else if (invite) {
        var d = moment(Date.parse(invite.modifieddate));
        return 'Invited (' + d.format('MM/DD/YYYY') + ')';
      } else {
        return 'New';
      }
    };

    vm.onPage = function() {
      vm.Update();
    };

    vm.UploadUsers = function(index) {
      var element = $document[0].getElementById(index);
      element.value = '';
    };

    vm.CSVFile = function(element) {
      if ( vm.mypermission ) {
        vm.reader.onload = function(event) {
          OrgUserService.loadCsvData(event.target.result, vm.groupID, function() {
            vm.Update();
          });
        };
        vm.reader.readAsText(element.files[0]);
      } else {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
      }
    };

    vm.LoadImage = function(index, file) {
      vm.reader.onload = function(event) {
        vm.users[index].imageFile = event.target.result;
        $scope.$apply();
      };
      vm.reader.readAsDataURL(file);
    };

    vm.UpdateImage = function(index, element) {
      vm.users[index].imageFile = element.files[0];
      vm.LoadImage(index, element.files[0]);
    };

    vm.Upload = function(id) {
      UploadFileService.upload( vm.users[id].imageFile, function(path, error) {
        if ( error === null ) {
          vm.users[id].imageFile = null;
          vm.users[id].profileimage = path;
          $scope.$apply();
        }
      })
    };

    vm.isUninvitedUser = function(user) {
      if ((user.invites || []).length === 0) {
        return true;
      } else {
        return OrgUserService.isUninvitedUser(user, vm.groupID)
      }
    };

    vm.SendInvite = function(user) {
      OrgUserService.grpSendInvite(user, vm.groupID, function(error) {
        if ( error === null ) {
          MessageBoxService.open('Invite Sent ', 'Email sent to ' + user.email, 'OK', function() {
            //this user has been sent an invite, so switch the toggle to reinvite
            user.canInvite = false;
            user.canReinvite = true;
          });
        } else {
          MessageBoxService.open('Error', 'Could not send invite to ' + user.email + ' try again later', 'OK', function() {
          });
        }
      });
    };

    vm.isInvitedUser = function(user) {
      return OrgUserService.isInvitedUser(user, vm.groupID) && vm.mypermission;
    };

    vm.InviteAll = function() {
      OrgUserService.dbSendRemindAll({
        organizationid: Number(vm.orgID),
        groupid: Number(vm.groupID)
      }, function(err) {
        if (err === null) {
          MessageBoxService.open('Invites Sent', 'An email has been sent to all eligible users', 'OK', function() {
            vm.Update()
          });
        } else {
          MessageBoxService.open('Error', 'Could not send invites, try again later', 'OK', function() {
            vm.Update()
          });
        }
      });

    };

    // vm.InviteAll = function() {
    //   vm.allusers = [];

    //   OrgUserService.grpUserLoadAll(vm.groupID, function(result){
    //     vm.allusers = result;
    //     vm.ids = [];
    //     vm.allusers.forEach(function(user) {
    //       vm.ids.push(user.id);
    //       user.canReinvite = true;
    //   });

    //     if (vm.ids.length > 0) {
    //       OrgUserService.grpSendInvites(vm.ids, vm.groupID,function(error){
    //         if( error === null ){
    //           MessageBoxService.open("Invites Sent","An email has been sent to all eligible users","OK", function(){vm.Update()});
    //         } else {
    //           MessageBoxService.open("Error","Could not send invites, try again later","OK", function(){vm.Update()});
    //         }
    //       });
    //     } else {
    //       MessageBoxService.open("Good News!","All users have already accepted their invites","OK", function(){vm.Update()});
    //     }
    //   });
    // };

    vm.onBack = function() {
      StateService.go('group');
    };

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      vm.reader = null; // garbage collect
      vm.deleted = null;
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Group.Controller', GroupController);

  /** @ngInject */
  function GroupController($scope, $routeParams, $uibModal, $rootScope, $timeout, $document,loadingScreen,
     MessageBoxService, OrganizationService, OrgUserService, UserService, OrgCatService,RecipientGroupService, StateService,FormValidationService,UploadFileService,$q) {
    var vm = this;
    vm.name = 'Group Page';
    //vm.reader = new FileReader( );
    vm.orgID = $routeParams.orgID;
    vm.totalPages = 0;
    vm.currentPage = 0;
    vm.grpList = [];
    vm.cancelPreviousCall = null;
    vm.users = [];
    vm.helpTipList = ['These are suggested recipient groups. You may \'Edit\' them, or choose to \'Add New Recipient Group\'.',
      'Make sure to add recipients by hovering over the group to \'Add / Update Recipient Info\''
    ];
    vm.filter = '';

    vm.loadData = function() {
      UserService.load(function() {
        OrgUserService.dbUserLoad( function() {
          OrgUserService.dbLoadMyUser( [], function() {
            vm.mypermission = OrgUserService.dbGetMyPermissions('orgadmin');
            OrgCatService.load(function() {
              vm.Update();
              UserService.load(function() {

                $timeout(function() {
                  $rootScope.$emit('page.ready');
                }, 100);
              });
            });
          });
        });
      });
    };

    vm.onPage = function() {
      vm.Update();
    };

    vm.Disable = function(object) {
      if (!vm.mypermission) {
        object.enabled = !object.disable;
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }
      object.disable = !object.enabled;
      OrgCatService.update(object, function() {

      });
    };

    // check to see if data should reload
    if ( vm.orgID !== OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.Update = function() {
      OrgCatService.catMaxPage(vm.orgID, true, false, function(result) {
        vm.totalPages = result;
        OrgCatService.catLoadByPage(vm.orgID, vm.currentPage, true, false, function(result) {
          vm.grpList = result;
          vm.grpList.forEach( function(grp) {
            grp.enabled = !grp.disable;
          });
          vm.max = OrgCatService.getMax();
          vm.current = vm.grpList.length;
        })
      })
    };

    vm.RemoveCat = function(index) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      if ( vm.mypermission ) {

        var cat = null;
        cat = vm.grpList[index];

        $uibModal.open({
          templateUrl: 'app/popups/deletegroupconfirm/deletegroupconfirm.html',
          controller: 'DeleteGroupConfirm.Controller as vm',
          windowClass: 'template-box',
          scope: $scope,
          resolve: {
            confirmFun: function() {
              vm.confirmFun = function() {
                OrgCatService.remove(cat, function(error) {
                  if (error === null) {
                    vm.loadData();
                  }
                });
              };
              return vm.confirmFun;
            }
          }
        });
      }
    };

    vm.OpenEdit = function(index) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      vm.grpList[index].edit = true;
    };

    vm.CloseEdit = function(index) {
      var cat = {};
      cat = vm.grpList[index];
      OrgCatService.update(cat, function(error) {
        if (error === null) {
          vm.Update();
          cat.edit = false;
        }
      });
    };

    vm.AddUsers = function(data) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      StateService.go('groupuser', data.id)
    };

    vm.UploadUsers = function(index) {
      var id = 'input' + index;
      var element = $document[0].getElementById(id);
      element.value = '';
      element.click();
    };

    vm.CSVFile = function(/*element*/) {
      if ( vm.mypermission ) {

        /* var data = vm.grpList[parseInt(element.name)];

        vm.reader.onload = function(event) {
          var users = OrgUserService.getCSVFileUsers(event.target.result);
          var list = [];
          users.forEach(function(user){
            list.push(user.id);
          });
          OrgUserService.assignToGroup(data.id, list,function(){

          });
        };

        vm.reader.readAsText(element.files[0]);*/
      }
    };

    vm.AddCat = function(isGroup) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      OrgCatService.getMaxCategories(vm.orgID, function(result) {
        OrgCatService.add(isGroup, result, function(result) {
          if (result === false) {
            vm.popup = $uibModal.open({
              templateUrl: 'app/popups/addmaxcat/addmaxcat.html',
              controller: 'AddMaxCat.Controller as vm',
              windowClass: 'template-box',
              scope: $scope
            });
          }
        });
      });
      vm.loadData();
    };

    vm.AddCatFromModal = function() {
      OrgCatService.getMaxCategories(vm.orgID, function(result) {
        vm.max = result;
        OrgCatService.add(true, vm.max, function() {
          vm.Update();
        })
      });
    };

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      //vm.reader = null; // garbage collect
    });

    vm.GroupUpdate = function() {
      // Cancel the previous API call if it's still pending
      if (vm.cancelPreviousCall && vm.cancelPreviousCall.resolve) {
        vm.cancelPreviousCall.resolve(); // Resolve the previous promise to cancel the request
      }
      vm.cancelPreviousCall = $q.defer();
      // Turn on the loading screen
      loadingScreen.turnOn(true);
      // Create a new promise with a cancellation mechanism
      // var currentCall = DashboardGroupService.load(vm.filter || '',vm.cancelPreviousCall.promise);
      // vm.cancelPreviousCall = currentCall.cancel; // Store the cancel function
      return RecipientGroupService.recipentGroupLoad(vm.filter || '', vm.cancelPreviousCall.promise)
      .then(function(recipentGroupsList) {
        vm.users = recipentGroupsList;
        loadingScreen.turnOn(false);
      });
    };

    vm.GroupUserUpload = function(id) {
      UploadFileService.upload( vm.users[id].imageFile, function(path, error) {
        if ( error === null ) {
          vm.users[id].imageFile = null;
          vm.users[id].profileimage = path;
          $scope.$apply();
        }
      })
    };

    vm.GroupUserConfirmRemove = function(user) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      if ( vm.mypermission ) {
        vm.popup = $uibModal.open({
          templateUrl: 'app/popups/deleteuserconfirm/deleteuserconfirm.html',
          controller: 'DeleteUserConfirm.Controller as vm',
          windowClass: 'template-box',
          scope: $scope,
          resolve: {
            user: function() {
              vm.groupUser = user;
              return vm.groupUser;
            },
            groupID: function() {
              return vm.groupID;
            }
          }
        });
      }
    };


    vm.GroupUserOpenEdit = function(user) {
      if ( vm.mypermission ) {

        user.edit = true;
      } else {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
      }
    };

    vm.updatePhoneNumber = function( user ) {
      user.phonenumber = FormValidationService.UpdatePhoneNumber( user.phonenumber );
    };

    vm.GroupUserCloseEdit = function(user) {
      user.edit = false;
      loadingScreen.turnOn(true);
      return OrgUserService.update(user)
      .then(function() {
        loadingScreen.turnOn(false);
        return vm.GroupUpdate();
      })
      // OrgUserService.update(user, vm.groupID, function(error) {
      //   if ( error === null ) {
      //     vm.Update();
      //   }
      // });
    };

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Existing.Controller', ExistingController);

  /** @ngInject */
  function ExistingController($log, UserService, FormValidationService, MessageBoxService) {
    var vm = this; // vm in js and home in html
    vm.name = 'Are You An Existing Member?';
    vm.state = 'Question';

    vm.login = {};
    vm.login.email = '';
    vm.login.username = '';

    //error states
    vm.showErrorLgn = false;
    vm.showErrorReg = false;
    vm.showErrorSnd = false;

    vm.user = {};
    vm.user.email = '';
    vm.user.username = '';
    vm.user.password = '';
    vm.user.confirm = '';

    vm.ePattern = FormValidationService.GetEmailPattern();

    vm.Existing = function() {
      vm.state = 'Login';
      if ( UserService.isLoggedIn() ) {
        location.assign('/#/continue');
      }
    }

    vm.NewUser = function() {
      vm.state = 'Register';
    }

    vm.Cancel = function() {
      vm.state = 'Question';
    }

    vm.Login = function(isValid) {
      if (isValid) {
        UserService.login({
          'email': vm.login.username,
          'password': vm.login.password
        }, function(error) {
          if (error == null) {
            location.assign('/#/continue');
          }
        });
      }
    }

    vm.Register = function(isValid) {
      if (isValid && vm.user.password == vm.user.confirm) {
        UserService.register({
          'username': vm.user.username,
          'password': vm.user.password,
          'email': vm.user.email
        }, function(error) {
          if (error == null) {
            vm.state = 'Login';
          }
        });
      }
    }

    vm.Resend = function() {
      UserService.resendEmailVerification({
        'email': vm.user.email
      }, function(error) {
        if (error) {
          MessageBoxService.open(
            'Resend failed',
            MessageBoxService.invalidEmailMsg(
              vm.user.email,
              'could not resend email to ' + vm.user.email,
              'Please enter a valid email address'),
            'ok',
            function() { $log.debug('close'); }
          );
        } else {
          vm.state = 'Login';
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Error.Controller', ErrorController);

  /** @ngInject */
  function ErrorController($routeParams, loadingScreen) {
    var vm = this;
    vm.errorID = $routeParams.errorID;

    loadingScreen.turnOn(false);
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('EmailCampaignUsers.Controller', EmailCampaignUsersController);

  /** @ngInject */
  function EmailCampaignUsersController(
    $scope,
    $routeParams,
    $rootScope,
    $timeout,
    $document,
    $uibModal,
    FormValidationService,
    EmailTemplateService,
    MessageBoxService,
    OrganizationService,
    OrgCatService,
    OrgUserService,
    UserService,
    StateService
  ) {
    var vm = this;
    vm.name = '';
    vm.groupUser = OrgUserService.getGroupUser();
    vm.orgID = $routeParams.orgID;
    vm.groupID = $routeParams.groupID;
    vm.exportLink = OrgUserService.getCsvExportLink(null, vm.groupID);
    vm.users = [];
    vm.templateid = -1;
    vm.group = {};
    vm.emailTemplates = [];
    vm.totalPages = 0;
    vm.currentPage = 0;
    vm.mypermission = false;
    vm.reader = new FileReader( );
    vm.helpTipList = [
      'Tip: This is where you can place the “Lightbulb Notification”. We need to place a character limit on here - or - implement this container to support multi-line text strings…'
    ];

    vm.loadData = function() {
      EmailTemplateService.load(vm.groupID, function(result) {
        vm.emailTemplates = result;
        for (var i = result.length; i < 4; i++) {
          EmailTemplateService.add(vm.groupID, function(result) {
            vm.emailTemplates.push(result);
          })
        }

        vm.emailTemplates.forEach(function(template, index) {
          vm.emailTemplates[index].body = template.body.replace( /<br\s*[/]?>/gi, '\n');
        });

        OrgUserService.dbLoadMyUser([], function(error) {
          vm.mypermission = OrgUserService.dbGetMyPermissions('orgadmin') || OrgUserService.dbGetMyPermissions('emailmarketing');
          if ( error ) {
            $timeout(function() {
              $rootScope.$emit('page.ready');
            }, 100);
            return;
          }

          UserService.load(function() {
            OrgCatService.load(function() {
              vm.GetCampaignName();
              vm.Update();
            });
          });
        });
      });
    };

    vm.userHasBeenInvited = function(invites, groupID, templateid) {
      return (invites || []).some(function(invite) {
        return Number(invite.categoryid) === Number(groupID) && invite.emailtemplateid === templateid;
      });
    }

    vm.userCanInvite = function(user, template) {
      var templateid = vm.emailTemplates[template].id;
      var hasBeenInvited = vm.userHasBeenInvited(user.invites, vm.groupID, templateid);
      return !hasBeenInvited && vm.mypermission;
    };

    vm.userCanReinvite = function(user, template) {
      var templateid = vm.emailTemplates[template].id;
      var hasBeenInvited = vm.userHasBeenInvited(user.invites, vm.groupID, templateid);
      return hasBeenInvited && vm.mypermission;
    };

    vm.Update = function() {
      OrgUserService.grpMaxPage(vm.groupID, function(result) {
        vm.totalPages = result;
        OrgUserService.grpUserLoad(vm.groupID, vm.currentPage, undefined, function() {
          var grpList = OrgCatService.get(false);
          for ( var i = 0; i < grpList.length; i++) {
            if ( grpList[i].id === vm.groupID) {
              vm.group = grpList[i];
              break;
            }
          }
          vm.users = OrgUserService.grpGet();
          vm.users.forEach(function(user) {
            user.phonenumber = FormValidationService.UpdatePhoneNumber( user.phonenumber );
            // user.canInvite = vm.isUninvitedUser(user);
            // user.canReinvite = vm.isInvitedUser(user);
          });

          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);

        });
      });
    };

    // check to see if data should reload
    if ( vm.orgID !== OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.AddNew = function() {
      if ( vm.mypermission ) {
        vm.popup = $uibModal.open({
          templateUrl: 'app/popups/newemailuser/newemailuser.html',
          controller: 'NewEmailUser.Controller as vm',
          windowClass: 'template-box',
          scope: $scope
        });
      }
    };

    vm.GetCampaignName = function() {
      OrgCatService.getGroupName(vm.groupID, function(result) {
        vm.name = result;
      });
    };

    vm.deleted = $rootScope.$on('userDeleted', function() {
      vm.Update();
    });

    vm.ConfirmRemove = function(user) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      if ( vm.mypermission ) {
        vm.popup = $uibModal.open({
          templateUrl: 'app/popups/deleteuserconfirm/deleteuserconfirm.html',
          controller: 'DeleteUserConfirm.Controller as vm',
          windowClass: 'template-box',
          scope: $scope,
          resolve: {
            user: function() {
              vm.groupUser = user;
              return vm.groupUser;
            },
            groupID: function() {
              return vm.groupID;
            }
          }
        });
      }
    };

    vm.Remove = function(user) {
      OrgUserService.grpDeleteUser(user, vm.groupID, function() {
        vm.Update();
      });
    };

    vm.OpenEdit = function(user) {
      if ( vm.mypermission ) {
        user.edit = true;
      } else {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
      }
    };

    vm.updatePhoneNumber = function( user ) {
      user.phonenumber = FormValidationService.UpdatePhoneNumber(user.phonenumber);
    };

    vm.getStatus = function(user) {
      var invite = OrgUserService.getInvite(user);

      if (user.userid) {
        if (user.optout) {
          return 'Opted Out';
        } else if (user.loggedin) {
          return 'Opted In';
        // } else if (invite) {
        //   var d = moment(Date.parse(invite.modifieddate));
        //   return 'Invited (' + d.format('MM/DD/YYYY') + ')';
        } else {
          return 'Logged Out';
        }
      } else if (invite) {
        var d = moment(Date.parse(invite.modifieddate));
        return 'Invited (' + d.format('MM/DD/YYYY') + ')';
      } else {
        return 'New';
      }
    };

    vm.CloseEdit = function(user) {
      user.edit = false;

      OrgUserService.grpUpdateUser(user, vm.groupID, function(error) {
        if ( error === null ) {
          vm.Update();
        }
      });
    };

    vm.getPageUsers = function() {
      //var start = (vm.currentPage-1)*20
      //var end = Math.min(start + 20,vm.users.length);
      //return vm.users.slice(start, end);
      return vm.users;
    };

    vm.onPage = function() {
      vm.Update();
    };

    vm.UploadUsers = function(index) {
      var element = $document[0].getElementById(index);
      element.value = '';
    };

    vm.openEmailEditor = function(template) {
      vm.templateid = template;
      if ( vm.mypermission ) {
        vm.popup = $uibModal.open({
          templateUrl: 'app/popups/sendemailcampaign/sendemailcampaign.html',
          controller: 'SendEmailCampaign.Controller as vm',
          windowClass: 'template-box',
          scope: $scope
        });
      }
    };

    vm.CSVFile = function(element) {
      if ( vm.mypermission ) {
        vm.reader.onload = function(event) {
          OrgUserService.loadCsvData(
            event.target.result,
            vm.groupID,
            function() {
              vm.Update();
            }
          );
        };
        vm.reader.readAsText(element.files[0]);
      } else {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
      }
    };

    // vm.isUninvitedUser = function(user) {
    //   if (user.invites.length === 0) {
    //     return true;
    //   } else {
    //     return OrgUserService.isUninvitedUser(user, vm.groupID)
    //   }
    // };

    vm.SendInvite = function(user, template) {
      OrgUserService.emailSendInvite(user, vm.groupID, vm.emailTemplates[template].id, function(error) {
        if ( error === null ) {
          MessageBoxService.open('Invite Sent ', 'Email sent to ' + user.email, 'OK', function() {
            //this user has been sent an invite, so switch the toggle to reinvite
          });
        } else {
          MessageBoxService.open('Error', 'Could not send invite to ' + user.email + ' try again later', 'OK', function() {
          });
        }
      });
    };

    // vm.isInvitedUser = function(user) {
    //   return OrgUserService.isInvitedUser(user, vm.groupID) && vm.mypermission;
    // };

    vm.InviteAll = function(template) {
      OrgUserService.emailSendInvites(null, vm.groupID, vm.emailTemplates[template].id, function(error) {
        if ( error === null ) {
          MessageBoxService.open('Invites Sent', 'An email has been sent to all eligible users', 'OK', function() {vm.Update()});
        } else {
          MessageBoxService.open('Error', 'Could not send invites, try again later', 'OK', function() {vm.Update()});
        }
      });
    };

    vm.onBack = function() {
      StateService.go('emailcampaign');
    };

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      vm.reader = null; // garbage collect
      vm.deleted = null;
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('EmailCampaign.Controller', EmailCampaignController);

  /** @ngInject */
  function EmailCampaignController($scope, $routeParams, $uibModal, $rootScope, $timeout, $document, MessageBoxService, OrganizationService, OrgUserService, UserService, OrgCatService, StateService) {
    var vm = this;
    vm.name = 'Group Page';
    //vm.reader = new FileReader( );
    vm.orgID = $routeParams.orgID;
    vm.totalPages = 0;
    vm.currentPage = 0;
    vm.grpList = [];
    vm.helpTipList = ['These are suggested recipient groups. You may \'Edit\' them, or choose to \'Add New Recipient Group\'.',
      'Make sure to add recipients by hovering over the group to \'Add / Update Recipient Info\''
    ];

    vm.loadData = function() {
      UserService.load(function() {
        OrgUserService.dbUserLoad( function() {
          OrgUserService.dbLoadMyUser( [], function() {
            vm.mypermission = OrgUserService.dbGetMyPermissions('orgadmin') || OrgUserService.dbGetMyPermissions('emailmarketing');
            OrgCatService.load(function() {
              vm.Update();
              UserService.load(function() {

                $timeout(function() {
                  $rootScope.$emit('page.ready');
                }, 100);
              });
            });
          });
        });
      });
    };

    vm.Disable = function(object) {
      if (!vm.mypermission) {
        object.enabled = !object.disable;
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }
      object.disable = !object.enabled;
      OrgCatService.update(object, function() {

      });
    }

    // check to see if data should reload
    if ( vm.orgID !== OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.Update = function() {
      OrgCatService.catLoadAll(vm.orgID, true, true, function(result) {
        vm.grpList = result;
        vm.grpList.forEach( function(grp) {
          grp.enabled = !grp.disable;
        });

        vm.current = vm.grpList.length;
      });
    };

    vm.RemoveCat = function(index) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      if ( vm.mypermission ) {

        var cat = null;
        cat = vm.grpList[index];

        $uibModal.open({
          templateUrl: 'app/popups/deletegroupconfirm/deletegroupconfirm.html',
          controller: 'DeleteGroupConfirm.Controller as vm',
          windowClass: 'template-box',
          scope: $scope,
          resolve: {
            confirmFun: function() {
              vm.confirmFun = function() {
                OrgCatService.remove(cat, function(error) {
                  if (error === null) {
                    vm.Update();
                  }
                });
              };
              return vm.confirmFun;
            }
          }
        });
      }
    };

    vm.OpenEdit = function(index) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      vm.grpList[index].edit = true;
    };

    vm.CloseEdit = function(index) {
      var cat = {};
      cat = vm.grpList[index];
      OrgCatService.update(cat, function(error) {
        if (error === null) {
          vm.Update();
          cat.edit = false;
        }
      });
    };

    vm.AddUsers = function(data) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      StateService.go('emailcampaignusers', data.id)
    };

    vm.UploadUsers = function(index) {
      var id = 'input' + index;
      var element = $document[0].getElementById(id);
      element.value = '';
      element.click();
    };

    vm.CSVFile = function(/*element*/) {
      if ( vm.mypermission ) {

        /* var data = vm.grpList[parseInt(element.name)];

                 vm.reader.onload = function(event) {
                 var users = OrgUserService.getCSVFileUsers(event.target.result);
                 var list = [];
                 users.forEach(function(user){
                 list.push(user.id);
                 });
                 OrgUserService.assignToGroup(data.id, list,function(){

                 });
                 };

                 vm.reader.readAsText(element.files[0]);*/
      }
    };

    vm.AddCat = function() {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      OrgCatService.addEmailGroup(function() {
        vm.Update();
      });
    };

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      //vm.reader = null; // garbage collect
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('EditSalesOrg.Controller', EditSalesOrgController);

  /** @ngInject */
  function EditSalesOrgController($scope, $routeParams, $rootScope, $uibModal, MessageBoxService, SalesPersonService, SalesOrgService, FormValidationService) {
    var vm = this;
    vm.editingOrgID = $routeParams.editingOrgID;
    vm.currentPage = 0;
    vm.salesOrg = {};
    vm.salesOrgName = '';
    vm.formattedDates = [];
    vm.YTDSales = [];
    vm.reader = new FileReader( );
    vm.ePattern = FormValidationService.GetEmailPattern();
    vm.phPattern = FormValidationService.GetPhonePattern();
    vm.helpTipList = ['Tip: This is where you can place the “Lightbulb Notification”. We need to place a character limit on here - or - implement this container to support multi-line text strings…'];

    vm.Update = function() {
      SalesOrgService.getOrgById(vm.editingOrgID, function(result) {
        vm.salesOrg = result;
        vm.salesOrgName = vm.salesOrg.name;


        SalesPersonService.loadList(vm.editingOrgID, function(error, list) {
          vm.salesPeople = list;

          //ensure edits are closed
          vm.salesPeople.forEach(function(user) {
            user.edit = false;
          });

          SalesPersonService.getSalesPeopleTotals(vm.editingOrgID, function(error, list) {
            vm.YTDSales = list;
          });

          for (var i = 0; i < vm.salesPeople.length; i++) {
            vm.salesPeople[i].canInvite = vm.isUninvitedUser(vm.salesPeople[i]);
            vm.salesPeople[i].canReinvite = vm.isInvitedUser(vm.salesPeople[i]);
          }

        });
      });
    };

    vm.loadData = function() {
      vm.Update();
    };

    vm.updatePhoneNumber = function( user ) {
      user.phone = FormValidationService.UpdatePhoneNumber( user.phone );
    };

    vm.loadData();

    vm.AddNew = function() {
      vm.popup = $uibModal.open({
        templateUrl: 'app/popups/newsalesperson/newsalesperson.html',
        controller: 'NewSalesPerson.Controller as vm',
        windowClass: 'template-box',
        scope: $scope
      });
    };

    var userDeletedUnregister = $rootScope.$on('userDeleted', function() {
      vm.Update();
    });

    vm.ConfirmRemove = function(user) {
      vm.popup = $uibModal.open({
        templateUrl: 'app/popups/deletesalesperson/deletesalesperson.html',
        controller: 'DeleteSalesPerson.Controller as vm',
        windowClass: 'template-box',
        scope: $scope,
        resolve: {
          user: function() {
            return user;
          }
        }
      });
    };

    vm.OpenEdit = function(user) {
      user.edit = true;
    };

    vm.CloseEdit = function(user) {
      user.edit = false;

      SalesPersonService.update(user, function(error) {
        if ( error === null ) {
          vm.Update();
        } else {
          MessageBoxService.open('Error', error, 'OK', function() {});
        }
      });
    };

    vm.isInvitedUser = function(user) {
      return SalesPersonService.isInvitedUser(user, vm.salesOrg.recipientgroupid);
    };

    vm.isUninvitedUser = function(user) {
      return SalesPersonService.isUninvitedUser(user, vm.salesOrg.recipientgroupid);
    };

    vm.SendInvite = function(user) {
      vm.ids = [user.id];
      SalesPersonService.inviteSalesPerson(vm.ids, function(error) {
        if ( error === null ) {
          MessageBoxService.open('Invite Sent ', 'Email sent to ' + user.email, 'OK', function() {
            //this user has been sent an invite, so switch the toggle to reinvite
            user.canInvite = false;
            user.canReinvite = true;
          });
        } else {
          MessageBoxService.open('Error', 'Could not send invite to ' + user.email + ' try again later', 'OK', function() {
          });
        }
      });
    };

    vm.InviteAll = function() {
      vm.ids = [];
      SalesPersonService.loadList(vm.editingOrgID, function(error, list) {
        vm.salesPeople = list;
        angular.forEach(vm.salesPeople, function() {
          vm.ids.push(vm.salesPeople.id);
        });
        if (vm.ids.length > 0) {
          SalesPersonService.inviteSalesPerson(vm.ids, function(error) {
            if (error === null) {
              MessageBoxService.open('Invites Sent', 'An email has been sent to all eligible users', 'OK', function() {
                vm.Update()
              });
            } else {
              MessageBoxService.open('Error', 'Could not send invites, try again later', 'OK', function() {
                vm.Update()
              });
            }
          });
        } else {
          MessageBoxService.open('Good News!', 'All users have already accepted their invites', 'OK', function() {
            vm.Update()
          });
        }
      })
    };

    vm.LoadImage = function(index, file) {
      vm.reader.onload = function(event) {
        vm.salesPeople[index].imageFile = event.target.result;
        $scope.$apply();
      };
      vm.reader.readAsDataURL(file);
    };

    vm.UpdateImage = function(index, element) {
      vm.salesPeople[index].imageFile = element.files[0];
      vm.LoadImage(index, element.files[0]);
    };

    vm.onBack = function() {
      location.assign('#/salesorganizations');
    };

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      vm.reader = null; // garbage collect
      userDeletedUnregister();
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('ConfirmDeleteAccount.Controller', ConfirmDeleteAccountController);

  /** @ngInject */
  function ConfirmDeleteAccountController($routeParams, UserService, MessageBoxService, $scope) {
    var vm = this;
    $scope.loadHTMl = false;  // Bind loadHTMl to $scope
    $scope.errorMessage = '';  // Initialize error message as an empty string
    var token = $routeParams.token;  // Get token from the URL

    vm.confirmDeleteAccount = function() {
      if (token) {
        UserService.confirmDeleteAccount(token, function(error, response) {
          if (error) {
            $scope.loadHTMl = false; // Set loadHTMl to false if there's an error
            $scope.errorMessage = 'There was an error processing your account deletion request. Please try again later.';
          } else {
            if (response.status) {
              // MessageBoxService.open('Success', response, 'ok', function() {
              $scope.loadHTMl = true; // Set loadHTMl to true after successful deletion
              $scope.errorMessage = ''; // Clear any error message
              // });
            } else {
              $scope.errorMessage = 'Failed to delete your account. Please try again later.'; // Set error message if status is not true
            }
          }
        });
      } else {
        $scope.errorMessage = 'Invalid token. Please check the link and try again.'; // Show error if token is invalid
      }
    };

    // Call the confirmDeleteAccount method when the controller is initialized
    vm.confirmDeleteAccount();
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('DeleteAccount.Controller', DeleteAccountController);
  /** @ngInject */
  function DeleteAccountController($window, $location, UserService, MessageBoxService, FormValidationService) {
    var vm = this;

    vm.confirmEmail = '';
    vm.ePattern = FormValidationService.GetEmailPattern();

    vm.goHome = function() {
      $location.path('home');
    };

    vm.onDeleteAccount = function(isValid) {
      if (isValid) {
        UserService.exists(vm.confirmEmail,function(error, doesExist) {
          if (doesExist) {
            UserService.sendDeleteAccountLink({ email: vm.confirmEmail }, function(error) {
              if (error) {
                MessageBoxService.open('ERROR', error, 'ok', function() { });
              } else {
                MessageBoxService.open(
                  'Delete Account Request Sent',
                  'A link to confirm account deletion has been sent to your email. Please check your inbox to proceed.',
                  'Close',
                  function() {
                    // $window.location = '#';
                  }
                );
              }
            });
          } else {
            MessageBoxService.open(
              'Oops',
              'No matching email found.',
              'ok',
              function() {
              }
            );
          }
        });
      } else {
        MessageBoxService.open('Oops','Please enter a valid email address', 'ok', function() { })
      }
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('DashboardGroupUser.Controller', DashboardGroupUserController);

  /** @ngInject */
  function DashboardGroupUserController(
    $scope,
    $routeParams,
    $rootScope,
    $document,
    $uibModal,
    $timeout,
    OrganizationService,
    UploadFileService,
    MessageBoxService,
    UserService,
    StateService,
    FormValidationService,
    DashboardGroupService,
    RecipientGroupService,
    OrgUserService,
    $log,
    loadingScreen
  ) {
    var vm = this;
    vm.name = 'User Page';
    vm.user = OrgUserService.getNewUser();
    vm.orgID = $routeParams.orgID;
    vm.dashboardGroupId = Number($routeParams.groupID);
    vm.dashboardGroup = null;
    vm.dashboardGroups = null;
    vm.recipientGroups = null;

    vm.showInviteAll = true;
    vm.filter = '';
    vm.enablequickresponse = false;

    vm.workFlowAdmins = [];
    vm.workFlowAdminNames = [];
    vm.permissionList = OrgUserService.getPermissionList();

    vm.reader = new FileReader();

    vm.loadData = function() {
      return UserService.load()
      .then(function() {
        return OrgUserService.dbUserLoad();
      })
      .then(function() {
        return OrgUserService.dbLoadMyUser([]);
      })
      .then(function() {
        vm.mypermission = OrgUserService.dbGetMyPermissions('orgadmin');

        vm.workFlowAdmins = [];
        vm.workFlowAdminNames = [];
        vm.workFlowAdmins = OrgUserService.dbGetWorkFlowAdmins();

        vm.workFlowAdmins.forEach(function(admin) {
          var name = admin.firstname + ' ' + admin.lastname;
          if (vm.workFlowAdminNames.indexOf(name) === -1) {
            vm.workFlowAdminNames.push(name);
          }
        });

        return vm.Update();
      })
      .then(function() {
        $timeout(function() {
          $rootScope.$emit('page.ready');
        }, 100);
      });
    };

    vm.Update = function() {
      return Promise.all([
        DashboardGroupService.getById(vm.dashboardGroupId, vm.filter || ''),
        DashboardGroupService.load(),
        RecipientGroupService.load()
      ])
      .then(function(results) {

        vm.dashboardGroup = results[0];
        vm.dashboardGroups = results[1];
        vm.recipientGroups = results[2];

        vm.dashboardGroup.userorganizations.forEach(function(userorganization) {
          userorganization.originalxmitnumber = userorganization.xmitnumber;
          userorganization.originalFirstname = userorganization.firstname;
          userorganization.originalLastname = userorganization.lastname;
          userorganization.originalPhonenumber = userorganization.phonenumber;
          userorganization.originalAlertaccess = userorganization.alertaccess;
          userorganization.permissions = vm.permissionList.map(function(permission, indx) {
            switch (indx) {
            case 0:
              return userorganization.workflowaccess;
            case 1:
              return userorganization.templateaccess;
            case 2:
              return userorganization.reportaccess;
            case 3:
              return userorganization.alertaccess;
            case 4:
              return userorganization.advertisementaccess;
            case 5:
              return userorganization.announcementaccess;
            case 6:
              return userorganization.appointmentaccess;
            case 7:
              return userorganization.orgadmin;
            case 8:
              return userorganization.emailmarketing;
            default:
              return false;
            }
          });

          userorganization.dashboardGroups = (userorganization.dashboardGroupIds || []).reduce(function(dashboardGroups, groupId) {
            dashboardGroups[groupId] = true;

            return dashboardGroups;
          }, {});

          userorganization.recipientGroups = (userorganization.recipientGroupIds || []).reduce(function(recipientGroups, groupId) {
            recipientGroups[groupId] = true;

            return recipientGroups;
          }, {});
        });

        $timeout(function() {
          for (var i = 0; i < vm.dashboardGroup.userorganizations.length; i++) {
            if (vm.dashboardGroup.userorganizations[i].profileimage !== null && vm.dashboardGroup.userorganizations[i].profileimage !== '') {
              var image = $document[0].getElementById('display' + i);
              image.src = vm.dashboardGroup.userorganizations[i].profileimage;
            }
            vm.dashboardGroup.userorganizations[i].canInvite = vm.isUninvitedUser(vm.dashboardGroup.userorganizations[i]);
            vm.dashboardGroup.userorganizations[i].canReinvite = vm.isInvitedUser(vm.dashboardGroup.userorganizations[i]);
          }

        }, 100);
      });
    };

    // check to see if data should reload
    if (vm.orgID !== OrganizationService.getID()) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.onPage = function() {
      vm.Update();
    };

    vm.getStatus = function(user) {
      var invite = OrgUserService.getInvite(user);

      if (user.userid) {
        if (user.optout) {
          return 'Opted Out';
        } else if (user.loggedin) {
          return 'Opted In';
        // } else if (invite) {
        //   var d = moment(Date.parse(invite.modifieddate));
        //   return 'Invited (' + d.format('MM/DD/YYYY') + ')';
        } else {
          return 'Logged Out';
        }
      } else if (invite) {
        var d = moment(Date.parse(invite.modifieddate));
        return 'Invited (' + d.format('MM/DD/YYYY') + ')';
      } else {
        return 'New';
      }
    };

    vm.getStatusBool = function(user) {
      var quickResponse = OrganizationService.get();
      if (quickResponse && quickResponse.enablequickresponse === true) {
        vm.enablequickresponse = true;
        if (user.userid) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    };

    vm.onBack = function() {
      StateService.go('dashboardgroup');
    };

    vm.OpenEdit = function(user) {
      vm.showInviteAll = false;
      vm.workFlowAdminNames.forEach(function(admin, index) {
        if (admin === (user.firstname + ' ' + user.lastname)) {
          vm.workFlowAdminNames.splice(index, 1);
        }
      });

      if (vm.mypermission) {
        OrgUserService.dbGetAdmin(user, function(error, myAdmin) {
          if (error === null) {
            if (!myAdmin.firstname) user.workflowadminName = 'None';
            else user.workflowadminName = (myAdmin.firstname + ' ' + myAdmin.lastname);
            user.edit = true;
          }
        });
      } else {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {
        });
      }
    };

    vm.CloseEdit = function(user) {
      vm.showInviteAll = true;
      // user.edit = false;

      if (user.permissions.length > 0) {
        user.workflowaccess = user.permissions[0];
        user.templateaccess = user.permissions[1];
        user.reportaccess = user.permissions[2];
        user.alertaccess = user.permissions[3];
        user.advertisementaccess = user.permissions[4];
        user.announcementaccess = user.permissions[5];
        user.appointmentaccess = user.permissions[6];
        user.orgadmin = user.permissions[7];
        user.emailmarketing = user.permissions[8];
      }

      user.dashboardGroupIds = Object.keys(user.dashboardGroups).reduce(function(groupIds, groupId) {
        if (user.dashboardGroups[groupId]) {
          groupIds.push(Number(groupId));
        }

        return groupIds;
      }, []);

      user.recipientGroupIds = Object.keys(user.recipientGroups).reduce(function(groupIds, groupId) {
        if (user.recipientGroups[groupId]) {
          groupIds.push(Number(groupId));
        }

        return groupIds;
      }, []);

      loadingScreen.turnOn(true);
      return vm.checkXmitNumber(user)
      .then(function() {
        user.edit = false;
        return OrgUserService.update(user);
      })
      .then(function() {
        if (vm.enablequickresponse) {
          return OrgUserService.updateUserToQuickResponse(user);
        } else {
          // Return a resolved promise to keep the chain going
          return Promise.resolve();
        }
      })
      .then(function() {
        return vm.Update();
      })
      .then(function() {
        var name = user.workflowadminName;
        if (name && name.toLowerCase().trim() === 'none') {
          OrgUserService.dbRemoveWorkflowAdmin(user, function() {
            vm.Update();
          })
        }
        var admin = {};
        // assign workflowadmin id
        for (var i = 0; i < vm.workFlowAdmins.length; i++) {
          if (name === vm.workFlowAdmins[i].firstname + ' ' + vm.workFlowAdmins[i].lastname) {
            admin = vm.workFlowAdmins[i];
            user.workflowadminid = vm.workFlowAdmins[i].id;
            break;
          }
        }
        OrgUserService.dbSetAdmin(user, admin, function() {
          OrgUserService.dbUpdate(user, function(error) {
            if (error === null) {
              vm.Update();
            }
          });
        });
      })
      .then(function() {
        loadingScreen.turnOn(false);
      });
    };

    vm.onPage = function() {
      vm.Update();
    };

    vm.isUninvitedUser = function(user) {
      return OrgUserService.isUninvitedUser(user) && vm.mypermission;
    };

    vm.isInvitedUser = function(user) {
      return OrgUserService.isInvitedUser(user) && vm.mypermission;
    };

    vm.updatePhoneNumber = function(user) {
      user.phonenumber = FormValidationService.UpdatePhoneNumber(user.phonenumber);
    };

    vm.checkXmitNumber = function(user) {
      return new Promise(function(resolve, reject) {
        OrgUserService.checkXmitNumber(user, function(err) {
          if (err) {
            MessageBoxService.open('Error', err, 'Close', function() {});
            reject(err); // Reject promise on error
          } else {
            resolve(true); // Resolve promise on success
          }
        });
      });
    };
    vm.AddNew = function() {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {});
        return;
      }

      if (vm.mypermission) {
        vm.popup = $uibModal.open({
          templateUrl: 'app/popups/newdashboarduser/newdashboarduser.html',
          controller: 'NewDashboardUser.Controller as vm',
          windowClass: 'template-box',
          scope: $scope,
          resolve: {
            addUser: function() {
              return function(addedUser) {
                return Promise.resolve()
                .then(function() {
                  // user already exists, update the existing record
                  if (addedUser.id) {
                    return OrgUserService.getById(addedUser.id)
                    .then(function(existingUser) {
                      existingUser.dashboardGroupIds = existingUser.dashboardGroupIds || [];
                      existingUser.dashboardGroupIds.push(vm.dashboardGroup.id);
                      existingUser.firstname = addedUser.firstname || existingUser.firstname;
                      existingUser.lastname = addedUser.lastname || existingUser.lastname;
                      existingUser.email = (addedUser.email || existingUser.email).toLowerCase();
                      existingUser.title = addedUser.title || existingUser.title;
                      existingUser.phonenumber = addedUser.phonenumber || existingUser.phonenumber;
                      existingUser.isdashboarduser = true;

                      return OrgUserService.update(existingUser);
                    });
                  } else {
                    addedUser.dashboardGroupIds = [vm.dashboardGroup.id];
                    addedUser.isdashboarduser = true;
                    return OrgUserService.insert(addedUser);
                  }
                })
                .then(function() {
                  return vm.Update();
                });

              };
            }
          }
        });
      }
    };

    vm.ConfirmRemove = function(user) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {
        });
        return;
      }

      if (vm.mypermission) {
        vm.popup = $uibModal.open({
          templateUrl: 'app/popups/deletedashboarduserconfirm/deletedashboarduserconfirm.html',
          controller: 'DeleteDashboardUserConfirm.Controller as vm',
          windowClass: 'template-box',
          scope: $scope,
          resolve: {
            user: function() {
              vm.user = user;
              return vm.user;
            },
            groupID: function() {
              return null;
            },
            remove: function() {
              return function() {
                user.workflowaccess = false;
                user.templateaccess = false;
                user.reportaccess = false;
                user.alertaccess = false;
                user.advertisementaccess = false;
                user.announcementaccess = false;
                user.appointmentaccess = false;
                user.orgadmin = false;
                user.isdashboarduser = false;
                user.dashboardGroupIds = [];
                return OrgUserService.update(user)
                .then(function() {
                  return vm.Update();
                });
              };
            }
          }
        });
      }
    };

    vm.UploadUsers = function(index) {
      var element = $document[0].getElementById(index);
      element.value = '';
    };

    vm.CSVFile = function(element) {
      var reader = new FileReader();

      if (!vm.mypermission) {
        MessageBoxService.open(
          'Permissions',
          'You don\'t have permissions to edit this.',
          'Continue',
          function() {}
        );
        return;
      }

      if (vm.mypermission) {
        reader.onload = function() {
          loadingScreen.turnOn(true);
          OrgUserService.loadDashboardGroupFromCSV(reader.result, vm.dashboardGroup.id)
          .then(function() {
            return vm.Update();
          })
          .then(function() {
            loadingScreen.turnOn(false);
          });
        };
        reader.readAsText(element.files[0]);

      }
    };

    vm.ExportCSV = function() {
      var filename = ('DashboardGroup-' + vm.dashboardGroup.name).toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text

      OrgUserService.createCSVFile(vm.dashboardGroup.userorganizations, filename + '.csv');
    };

    vm.InviteAll = function() {
      OrgUserService.dbSendInviteAll({
        organizationid: Number(vm.orgID),
        dashboard: true,
        dashboardgroupid: vm.dashboardGroupId,
      }, function(err) {
        if (err === null) {
          MessageBoxService.open('Invites Sent', 'An email has been sent to all eligible users', 'OK', function() {
            vm.Update()
          });
        } else {
          MessageBoxService.open('Error', 'Could not send invites, try again later', 'OK', function() {
            vm.Update()
          });
        }
      });
    };

    $scope.$on('$destroy', function UnLoaded() {
      vm.reader = null; // garbage collect
      vm.deleted = null;
    });

    vm.LoadImage = function(index, file) {
      var reader = new FileReader();
      var image = $document[0].getElementById('display' + index);
      reader.onload = function() {
        image.src = reader.result;

        UploadFileService.upload(vm.dashboardGroup.userorganizations[index].imageFile)
        .then(function(path) {
          vm.dashboardGroup.userorganizations[index].profileimage = path;
        })
        .catch(function() {
          // TODO: handle error
        });

      };
      reader.readAsDataURL(file);
    };

    vm.UpdateImage = function(index, element) {
      vm.dashboardGroup.userorganizations[index].imageFile = element.files[0];
      vm.LoadImage(index, element.files[0]);
    };
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('DashboardGroup.Controller', DashboardGroupController);

  /** @ngInject */
  function DashboardGroupController(
    $scope,
    $routeParams,
    $uibModal,
    $rootScope,
    $timeout,
    $document,
    $log,
    MessageBoxService,
    FormValidationService,
    OrganizationService,
    OrgUserService,
    UserService,
    OrgCatService,
    StateService,
    DashboardGroupService,
    RecipientGroupService,
    loadingScreen,
    $q
  ) {
    var vm = this;
    vm.filter = '';
    vm.name = 'Dashboard Group Page';
    //vm.reader = new FileReader( );
    vm.orgID = $routeParams.orgID;
    vm.regions = [];
    vm.totalPages = 0;
    vm.currentPage = 0;
    vm.grpList = [];
    vm.uniqueUsers = {};
    vm.helpTipList = [
      'These are suggested dashboard groups. You may \'Edit\' them, or choose to \'Add New Dashboard Group\'.',
      'Make sure to add recipients by hovering over the group to \'Add / Update Recipient Info\''
    ];
    vm.workFlowAdmins = [];
    vm.workFlowAdminNames = [];
    vm.permissionList = OrgUserService.getPermissionList();
    vm.dashboardGroups = null;
    vm.cancelPreviousCall = null; // Initialize the cancellation object
    vm.loadData = function() {
      return UserService.load()
      .then(function() {
        return OrgUserService.dbUserLoad();
      })
      .then(function() {
        return OrgUserService.regionsLoadList();
      })
      .then(function() {
        return OrgUserService.dbLoadMyUser([]);
      })
      .then(function() {
        vm.regions = OrgUserService.getRegions();
        vm.mypermission = OrgUserService.dbGetMyPermissions('orgadmin');
        vm.workFlowAdmins = [];
        vm.workFlowAdminNames = [];
        vm.workFlowAdmins = OrgUserService.dbGetWorkFlowAdmins();
        vm.workFlowAdmins.forEach(function(admin) {
          var name = admin.firstname + ' ' + admin.lastname;
          if (vm.workFlowAdminNames.indexOf(name) === -1) {
            vm.workFlowAdminNames.push(name);
          }
        });
        return vm.Update();
      })
      .then(function() {
        return vm.getrecipientGroups();
      })
      .then(function() {
        $timeout(function() {
          $rootScope.$emit('page.ready');
        }, 100);
      });
    };
    vm.getRegionLabel = function(regionCode) {
      if (!regionCode || !vm.regions) return '';
      var region = vm.regions.find(function(r) {
        return r.region_code == regionCode;
      });
      return region ? region.description + '(' + region.region_code + ')' : regionCode;
    };
    vm.Update = function() {
      // Cancel the previous API call if it's still pending
      if (vm.cancelPreviousCall && vm.cancelPreviousCall.resolve) {
        vm.cancelPreviousCall.resolve(); // Resolve the previous promise to cancel the request
      }
      vm.cancelPreviousCall = $q.defer();
      // Turn on the loading screen
      loadingScreen.turnOn(true);
      // Create a new promise with a cancellation mechanism
      // var currentCall = DashboardGroupService.load(vm.filter || '',vm.cancelPreviousCall.promise);
      // vm.cancelPreviousCall = currentCall.cancel; // Store the cancel function
      return DashboardGroupService.load(vm.filter || '', vm.cancelPreviousCall.promise)
      .then(function(dashboardGroupsList) {
        vm.uniqueUsers = {};
        if (vm.filter) {
          // dashboardGroupsList = dashboardGroupsList.filter(function(group) {
          //   return group.userorganizations.length > 0;
          // });
          // Update permissions for each user organization in each dashboard group
          dashboardGroupsList.forEach(function(dashboardGroup) {
            dashboardGroup.userorganizations.forEach(function(userorganization) {
              // userorganization.permissions = vm.permissionList.map(function(permission, indx) {
              //   switch (indx) {
              //   case 0:
              //     return userorganization.workflowaccess;
              //   case 1:
              //     return userorganization.templateaccess;
              //   case 2:
              //     return userorganization.reportaccess;
              //   case 3:
              //     return userorganization.alertaccess;
              //   case 4:
              //     return userorganization.advertisementaccess;
              //   case 5:
              //     return userorganization.announcementaccess;
              //   case 6:
              //     return userorganization.appointmentaccess;
              //   case 7:
              //     return userorganization.orgadmin;
              //   case 8:
              //     return userorganization.emailmarketing;
              //   default:
              //     return false;
              //   }
              // });
              // userorganization.dashboardGroups = (userorganization.dashboardGroupIds || []).reduce(function(dashboardGroups, groupId) {
              //   dashboardGroups[groupId] = true;
              //   return dashboardGroups;
              // }, {});
              // userorganization.recipientGroups = (userorganization.recipientGroupIds || []).reduce(function(recipientGroups, groupId) {
              //   recipientGroups[groupId] = true;
              //   return recipientGroups;
              // }, {});
              if (!vm.uniqueUsers[userorganization.userid]) {
                // If not, add the userorganization to the uniqueUsers object
                vm.uniqueUsers[userorganization.userid] = userorganization;
              } else {
                // If it already exists, merge the existing userorganization with the new one
                // You might want to customize this merge logic based on your needs
                Object.assign(vm.uniqueUsers[userorganization.userid], userorganization);
              }
            });
          });
          const allUniqueUserOrganizations = Object.values(vm.uniqueUsers);
          // Optionally, you can perform additional processing on the unique users array
          allUniqueUserOrganizations.forEach(function(userorganization) {
            userorganization.permissions = vm.permissionList.map(function(permission, indx) {
              switch (indx) {
              case 0:
                return userorganization.workflowaccess;
              case 1:
                return userorganization.templateaccess;
              case 2:
                return userorganization.reportaccess;
              case 3:
                return userorganization.alertaccess;
              case 4:
                return userorganization.advertisementaccess;
              case 5:
                return userorganization.announcementaccess;
              case 6:
                return userorganization.appointmentaccess;
              case 7:
                return userorganization.orgadmin;
              case 8:
                return userorganization.emailmarketing;
              default:
                return false;
              }
            });
            userorganization.dashboardGroups = (userorganization.dashboardGroupIds || []).reduce(function(dashboardGroups, groupId) {
              dashboardGroups[groupId] = true;
              return dashboardGroups;
            }, {});
            userorganization.recipientGroups = (userorganization.recipientGroupIds || []).reduce(function(recipientGroups, groupId) {
              recipientGroups[groupId] = true;
              return recipientGroups;
            }, {});
          });
        }
        vm.dashboardGroups = dashboardGroupsList;
        vm.grpList = dashboardGroupsList;
        loadingScreen.turnOn(false);
      });
    };
    vm.updatePhoneNumber = function(user) {
      user.phonenumber = FormValidationService.UpdatePhoneNumber(user.phonenumber);
    };
    // vm.Update = function() {
    //   loadingScreen.turnOn(true);
    //   return DashboardGroupService.load(vm.filter || '')
    //   .then(function(dashboardGroupsList) {
    //     if (vm.filter) {
    //       dashboardGroupsList = dashboardGroupsList.filter(function(group) {
    //         return group.userorganizations.length > 0;
    //       });
    //       // Update permissions for each userorganization in each dashboardGroup
    //       dashboardGroupsList.forEach(function(dashboardGroup) {
    //         dashboardGroup.userorganizations.forEach(function(userorganization) {
    //           userorganization.permissions = vm.permissionList.map(function(permission, indx) {
    //             switch (indx) {
    //             case 0:
    //               return userorganization.workflowaccess;
    //             case 1:
    //               return userorganization.templateaccess;
    //             case 2:
    //               return userorganization.reportaccess;
    //             case 3:
    //               return userorganization.alertaccess;
    //             case 4:
    //               return userorganization.advertisementaccess;
    //             case 5:
    //               return userorganization.announcementaccess;
    //             case 6:
    //               return userorganization.appointmentaccess;
    //             case 7:
    //               return userorganization.orgadmin;
    //             case 8:
    //               return userorganization.emailmarketing;
    //             default:
    //               return false;
    //             }
    //           });
    //           userorganization.dashboardGroups = (userorganization.dashboardGroupIds || []).reduce(function(dashboardGroups, groupId) {
    //             dashboardGroups[groupId] = true;
    //             return dashboardGroups;
    //           }, {});
    //           userorganization.recipientGroups = (userorganization.recipientGroupIds || []).reduce(function(recipientGroups, groupId) {
    //             recipientGroups[groupId] = true;
    //             return recipientGroups;
    //           }, {});
    //         });
    //       });
    //     } else {
    //       vm.dashboardGroups = dashboardGroupsList;
    //     }
    //     vm.grpList = dashboardGroupsList;
    //     loadingScreen.turnOn(false);
    //   });
    // };
    vm.getrecipientGroups = (function() {
      return RecipientGroupService.load()
      .then(function(recipentGroupsList) {
        vm.recipientGroups = recipentGroupsList;
      });
    });
    vm.OpenEdit = function(index) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {});
        return;
      }
      vm.grpList[index].edit = true;
    };
    vm.CloseEdit = function(index) {
      loadingScreen.turnOn(true);
      var dashboardGroup = vm.grpList[index];
      return DashboardGroupService.update(dashboardGroup)
      .then(function() {
        return vm.Update();
      })
      .then(function() {
        dashboardGroup.edit = false;
        loadingScreen.turnOn(false);
      });
    };

    vm.onPage = function() {
      vm.Update();
    };

    vm.AddDashboardGroup = function() {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {});
        return;
      }

      return DashboardGroupService.insert()
      .then(vm.loadData());
    };

    vm.RemoveDashboardGroup = function(index) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {});
        return;
      }

      var dashboardGroup = vm.grpList[index];

      $uibModal.open({
        templateUrl: 'app/popups/deletedashboardgroupconfirm/deletedashboardgroupconfirm.html',
        controller: 'DeleteDashboardGroupConfirm.Controller as vm',
        windowClass: 'template-box',
        scope: $scope,
        resolve: {
          confirmFun: function() {
            return function() {
              return DashboardGroupService.delete(dashboardGroup.id)
              .then(function() {
                vm.loadData();
              });
            };
          }
        }
      });
    };


    vm.AddEditMembers = function(dashboardGroup) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {});
        return;
      }
      StateService.go('dashboardgroupuser', dashboardGroup.id)
    };

    // check to see if data should reload
    if (vm.orgID !== OrganizationService.getID()) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    // vm.InviteAll = function() {
    //   OrgUserService.dbSendInviteAll({
    //     organizationid: Number(vm.orgID),
    //     dashboard: true,
    //     dashboardgroupid: vm.dashboardGroupId,
    //   }, function(err) {
    //     if (err === null) {
    //       MessageBoxService.open('Invites Sent', 'An email has been sent to all eligible users', 'OK', function() {
    //         vm.Update()
    //       });
    //     } else {
    //       MessageBoxService.open('Error', 'Could not send invites, try again later', 'OK', function() {
    //         vm.Update()
    //       });
    //     }
    //   });
    // };


    vm.OpenEditIndividualUser = function(user) {
      vm.showInviteAll = false;
      vm.workFlowAdminNames.forEach(function(admin, index) {
        if (admin === (user.firstname + ' ' + user.lastname)) {
          vm.workFlowAdminNames.splice(index, 1);
        }
      });

      if (vm.mypermission) {
        OrgUserService.dbGetAdmin(user, function(error, myAdmin) {
          if (error === null) {
            if (!myAdmin.firstname) user.workflowadminName = 'None';
            else user.workflowadminName = (myAdmin.firstname + ' ' + myAdmin.lastname);
            user.edit = true;
          }
        });
      } else {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {
        });
      }
    };


    vm.CloseEditIndividualUser = function(user) {
      vm.showInviteAll = true;
      user.edit = false;
      if (user.permissions.length > 0) {
        user.workflowaccess = user.permissions[0];
        user.templateaccess = user.permissions[1];
        user.reportaccess = user.permissions[2];
        user.alertaccess = user.permissions[3];
        user.advertisementaccess = user.permissions[4];
        user.announcementaccess = user.permissions[5];
        user.appointmentaccess = user.permissions[6];
        user.orgadmin = user.permissions[7];
        user.emailmarketing = user.permissions[8];
      }

      user.dashboardGroupIds = Object.keys(user.dashboardGroups).reduce(function(groupIds, groupId) {
        if (user.dashboardGroups[groupId]) {
          groupIds.push(Number(groupId));
        }

        return groupIds;
      }, []);

      user.recipientGroupIds = Object.keys(user.recipientGroups).reduce(function(groupIds, groupId) {
        if (user.recipientGroups[groupId]) {
          groupIds.push(Number(groupId));
        }

        return groupIds;
      }, []);

      loadingScreen.turnOn(true);
      return OrgUserService.update(user)
      .then(function() {
        return vm.Update();
      })
      .then(function() {
        var name = user.workflowadminName;
        if (name && name.toLowerCase().trim() === 'none') {
          OrgUserService.dbRemoveWorkflowAdmin(user, function() {
            vm.Update();
          })
        }
        var admin = {};
        // assign workflowadmin id
        for (var i = 0; i < vm.workFlowAdmins.length; i++) {
          if (name === vm.workFlowAdmins[i].firstname + ' ' + vm.workFlowAdmins[i].lastname) {
            admin = vm.workFlowAdmins[i];
            user.workflowadminid = vm.workFlowAdmins[i].id;
            break;
          }
        }
        OrgUserService.dbSetAdmin(user, admin, function() {
          OrgUserService.dbUpdate(user, function(error) {
            if (error === null) {
              vm.Update();
            }
          });
        });
      })
      .then(function() {
        loadingScreen.turnOn(false);
      });
    };
    vm.ConfirmRemove = function(user) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() {
        });
        return;
      }

      if (vm.mypermission) {
        vm.popup = $uibModal.open({
          templateUrl: 'app/popups/deletedashboarduserconfirm/deletedashboarduserconfirm.html',
          controller: 'DeleteDashboardUserConfirm.Controller as vm',
          windowClass: 'template-box',
          scope: $scope,
          resolve: {
            user: function() {
              vm.user = user;
              return vm.user;
            },
            groupID: function() {
              return null;
            },
            remove: function() {
              return function() {
                user.workflowaccess = false;
                user.templateaccess = false;
                user.reportaccess = false;
                user.alertaccess = false;
                user.advertisementaccess = false;
                user.announcementaccess = false;
                user.appointmentaccess = false;
                user.orgadmin = false;
                user.isdashboarduser = false;
                user.dashboardGroupIds = [];
                return OrgUserService.update(user)
                .then(function() {
                  return vm.Update();
                });
              };
            }
          }
        });
      }
    };

    // ============================================================================================================================================

    // vm.UploadUsers = function(index) {
    //   var id = 'input' + index;
    //   var element = $document[0].getElementById(id);
    //   element.value = '';
    //   element.click();
    // };

    // vm.CSVFile = function(/*element*/) {
    //   if ( vm.mypermission ) {

    //     //  var data = vm.grpList[parseInt(element.name)];

    //     // vm.reader.onload = function(event) {
    //     //   var users = OrgUserService.getCSVFileUsers(event.target.result);
    //     //   var list = [];
    //     //   users.forEach(function(user){
    //     //     list.push(user.id);
    //     //   });
    //     //   OrgUserService.assignToGroup(data.id, list,function(){

    //     //   });
    //     // };

    //     // vm.reader.readAsText(element.files[0]);
    //   }
    // };

    // vm.AddCatFromModal = function () {
    //   OrgCatService.getMaxCategories(vm.orgID, function(result) {
    //     vm.max = result;
    //     OrgCatService.add(true, vm.max, function () {
    //       vm.Update();
    //     })
    //   });
    // };

    // $scope.$on('$viewContentLoaded', function ContentLoaded() {
    // });

    // $scope.$on('$destroy', function UnLoaded() {
    //   //vm.reader = null; // garbage collect
    // });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Dashboard.Controller', DashboardController);

  /** @ngInject */
  function DashboardController($scope, $log, $timeout, $rootScope, $routeParams, StateService, UserService, OrganizationService, MsgService, OrgUserService, $window, $document, MessageBoxService) {
    var vm = this;
    vm.name = 'Admin Dashboard Page';
    vm.helpPage = 'app/pages/dashboard/dashboard-help.html';
    vm.orgID = $routeParams.orgID;

    vm.curMsgCount = [
      {type: 'Announcements', newm: 0, total: 0, link: 'announcement'},
      {type: 'Alerts', newm: 0, total: 0, link: 'alert'},
      {type: 'Advertising', newm: 0, total: 0, link: 'ad'},
      {type: 'Appointments', newm: 0, total: 0, link: 'appointment'}
    ];

    vm.pendApproves = [
      {type: 'Announcements', qty: 0, link: 'approval'},
      //{type: "Alerts", qty: 12, link: "approval"},
      {type: 'Advertisements', qty: 0, link: 'approval'},
      //{type: "Appointments", qty: 0, link: "approval"},
      {type: 'Messages ready to Send / Schedule', qty: 0, link: 'pending'},
      {type: 'User needs to be set up', qty: 0, link: 'user'}
    ];

    vm.PendingApproval = function(data) {
      StateService.go(data.link);
    }

    vm.loadData = function() {

      var width = $window.innerWidth
        || $document.documentElement.clientWidth
        || $document.body.clientWidth;

      if (width >= 768 && width < 1024) {
        MessageBoxService.open(
          'Please Rotate Your Device',
          'The You Get It First dashboard is intended for a minimum pixel resolution of 1024',
          'Ok',
          function() {
          }
        );
      }

      if (width < 768) {
        StateService.go('mobilelanding');
      }

      var total = 0;
      var list = [];
      UserService.load(function() {
        OrgUserService.dbLoadMyUser([], function() {
          MsgService.load('', function() {

            list = MsgService.getAll('announcement');
            vm.curMsgCount[0].total = list.length;
            list = MsgService.getAll('alert');
            vm.curMsgCount[1].total = list.length;
            list = MsgService.getAll('advertisement');
            vm.curMsgCount[2].total = list.length;
            list = MsgService.getAll('appointment');
            vm.curMsgCount[3].total = list.length;

            vm.mypermission = /*OrgUserService.dbGetMyPermissions('orgadmin') || */OrgUserService.dbGetMyPermissions('workflowaccess');

            MsgService.loadQueued( function() {

              list = MsgService.getQueued('announcement');
              total += list.length;
              list = MsgService.getQueued('advertisement');
              total += list.length;
              vm.pendApproves[2].qty = total;

              MsgService.loadApproval( function() {

                list = MsgService.getApproval('announcement');
                vm.pendApproves[0].qty = (list.length || 0);
                list = MsgService.getApproval('advertisement');
                vm.pendApproves[1].qty = (list.length || 0);


                OrgUserService.dbUserLoad( function() {
                  list = OrgUserService.dbGet();
                  total = 0;
                  list.forEach(function(user) {
                    if ( !OrgUserService.isFullUser(user))
                      total++;
                  });
                  vm.pendApproves[3].qty = total;
                  $timeout(function() {
                    $rootScope.$emit('page.ready');
                  }, 100);
                });
              });
            });
          });
        });
      });
    }

    // check to see if data should reload
    if ( vm.orgID !== OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function( ) {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Continue.Controller', ContinueController);

  /** @ngInject */
  function ContinueController($log, OrganizationService, IndTypeService, StateService) {
    var vm = this; // vm in js and home in html
    vm.name = 'Continue On Boarding?';
    vm.list = [];

    OrganizationService.loadList( false, function(error, list) {
      if ( error == null) {
        vm.list = list;
        if ( !list || list.length == 0) {
          location.assign('/#/signuporg');
        }
      }
    });
    vm.New = function() {
      OrganizationService.clear();
      IndTypeService.clear();
      location.assign('/#/signuporg');
    }

    vm.Continue = function(index) {
      OrganizationService.load(index);
      var state = OrganizationService.getStateName();
      StateService.go(state);
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('CatSetup.Controller', CatSetupController);

  /** @ngInject */
  function CatSetupController($scope, $log, $routeParams, OrgCatService, OrganizationService, StateService) {
    var vm = this;
    vm.name = 'Catagories And Groups Setup';
    vm.orgID = $routeParams.orgID;

    vm.loadData = function() {
      OrgCatService.load(function() {
        vm.Update();
      });
    }

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.Back = function() {
      StateService.go('image');
    }

    vm.Continue = function() {
      OrganizationService.setState('catsetup', function() {
        StateService.go('usersetup');
      });
    }

    vm.Update = function() {
      vm.catList = OrgCatService.get(true);
      vm.grpList = OrgCatService.get(false);
      vm.max = OrgCatService.getMax();
      vm.current = vm.catList.length + vm.grpList.length;
    }

    vm.RemoveCat = function(index, isCat) {
      var cat = null;
      if ( isCat )
        cat = vm.catList[index];
      else
        cat = vm.grpList[index];

      OrgCatService.remove(cat, function(error) {
        if (error == null) {
          vm.Update();
        }
      });

    }

    vm.OpenEdit = function(index, isCat) {
      if ( isCat )
        vm.catList[index].edit = true;
      else
        vm.grpList[index].edit = true;
    }

    vm.CloseEdit = function(index, isCat) {
      var cat = {};
      if ( isCat )
        cat = vm.catList[index];
      else
        cat = vm.grpList[index];

      cat.edit = false;

      OrgCatService.update(cat, function(error) {
        if (error == null) {
          vm.Update();
        }
      });
    }

    vm.AddMax = function() {
      OrgCatService.buy(function(max) { vm.max = max;});
    }

    vm.AddCat = function(isCat) {
      OrgCatService.add(isCat);
      vm.Update();
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Contact.Controller', ContactController);

  /** @ngInject */
  function ContactController($scope, $routeParams) {
    var vm = this;
    vm.name = 'Contact Page';
    vm.orgID = $routeParams.orgID;

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Classlink.Controller', ClasslinkController);

  /** @ngInject */
  function ClasslinkController($location, ClasslinkService) {
    var vm = this;
    vm.name = 'Classlink';
    vm.params = $location.search();

    vm.getAccessUrl = function() {
      var here = $location.protocol() + '://' + $location.host() + ':' + $location.port();
      location.href = ClasslinkService.getProfileAccessUrl(here + '/#/classlink');
    };

    vm.initiate = function() {
      if (vm.params.error || vm.params.code) {
        // we arrived here via the redirect uri from classlink
        // check if our access request passed or failed
        if (vm.params.code) {
          vm.state = 'exchanging';

          ClasslinkService.exchangeCodeForAccessToken(vm.params.code, function(error, response) {
            if (!error) {
              if (response && response.data && response.data.access_token) {
                vm.accessToken = response.data.access_token;
                vm.link = 'you://loginwithclasslink/' + vm.accessToken;
                vm.state = 'success';
              } else {
                vm.state = 'error';
              }
            } else {
              delete vm.params.code;
              vm.getAccessUrl()
            }
          });
        } else {
          vm.state = 'error';
        }

      } else {
        // we arrived here directly
        // request access from classlink
        vm.state = 'redirecting';
        vm.getAccessUrl();
      }
    };

    vm.initiate();
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('CatGroup.Controller', CatGroupController);

  /** @ngInject */
  function CatGroupController($scope, $routeParams, $rootScope, $timeout, $document, OrganizationService, OrgUserService, UserService, OrgCatService, StateService) {
    var vm = this;
    vm.name = 'Catagories And Groups Page';
    vm.reader = new FileReader( );
    vm.orgID = $routeParams.orgID;

    vm.loadData = function() {
      UserService.load(function() {
        OrgUserService.dbUserLoad( function() {
          OrgUserService.dbLoadMyUser( [], function() {
            vm.mypermission = OrgUserService.dbGetMyPermissions('orgadmin');
            OrgCatService.load(function() {
              vm.Update();
              UserService.load(function() {

                $timeout(function() {
                  $rootScope.$emit('page.ready');
                }, 100);
              });
            });
          });
        });
      });
    }

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.Update = function() {
      vm.catList = OrgCatService.get(true);
      vm.grpList = OrgCatService.get(false);
      vm.max = OrgCatService.getMax();
      vm.current = vm.catList.length + vm.grpList.length;
    }

    vm.RemoveCat = function(index, isCat) {
      if (!vm.mypermission) return;

      var cat = null;
      if ( isCat )
        cat = vm.catList[index];
      else
        cat = vm.grpList[index];

      OrgCatService.remove(cat, function(error) {
        if (error == null) {
          vm.Update();
        }
      });

    }

    vm.Disable = function(object) {
      OrgCatService.update(object, function() {

      });
    }

    vm.OpenEdit = function(index, isCat) {
      if (!vm.mypermission) return;

      if ( isCat )
        vm.catList[index].edit = true;
      else
        vm.grpList[index].edit = true;
    }

    vm.CloseEdit = function(index, isCat) {
      var cat = {};
      if ( isCat )
        cat = vm.catList[index];
      else
        cat = vm.grpList[index];



      OrgCatService.update(cat, function(error) {
        if (error == null) {
          vm.Update();
          cat.edit = false;
        }
      });
    }

    vm.AddUsers = function(data) {
      if (!vm.mypermission) return;

      StateService.go('groupuser', data.id)
    }

    vm.UploadUsers = function(index) {
      var id = 'input' + index;
      var element = $document[0].getElementById(id);
      element.value = '';
      element.click();
    }

    vm.CSVFile = function(/*element*/) {
      if ( vm.mypermission ) {

        /* var data = vm.grpList[parseInt(element.name)];

        vm.reader.onload = function(event) {
          var users = OrgUserService.getCSVFileUsers(event.target.result);
          var list = [];
          users.forEach(function(user){
            list.push(user.id);
          });
          OrgUserService.assignToGroup(data.id, list,function(){

          });
        };

        vm.reader.readAsText(element.files[0]);*/
      }
    }

    vm.AddMax = function() {
      if (!vm.mypermission) return;

      OrgCatService.buy(function(max) { vm.max = max;});
    }

    vm.AddCat = function(isCat) {
      if (!vm.mypermission) return;

      OrgCatService.add(isCat);
      vm.Update();
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      vm.reader = null; // garbage collect
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Category.Controller', CategoryController);

  /** @ngInject */
  function CategoryController($scope, $routeParams, $rootScope, $timeout, $document, MessageBoxService, OrganizationService, OrgUserService, UserService, OrgCatService, StateService, $uibModal) {
    var vm = this;
    vm.name = 'Catagory Page';
    vm.orgID = $routeParams.orgID;
    vm.totalPages = 0;
    vm.currentPage = 0;
    vm.catList = [];
    vm.helpTipList = ['These are suggested categories. You may \'Edit\' them, or choose to \'Add New Category\'.'
    ];

    vm.loadData = function() {
      UserService.load(function() {
        OrgUserService.dbUserLoad( function() {
          OrgUserService.dbLoadMyUser( [], function() {
            vm.mypermission = OrgUserService.dbGetMyPermissions('orgadmin');
            OrgCatService.load(function() {
              vm.Update();
              UserService.load(function() {
                $timeout(function() {
                  $rootScope.$emit('page.ready');
                }, 100);
              });
            });
          });
        });
      });
    };

    vm.onPage = function() {
      vm.Update();
    };

    // check to see if data should reload
    if ( vm.orgID !== OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.Update = function() {
      OrgCatService.catMaxPage(vm.orgID, false, false, function(result) {
        vm.totalPages = result;
        OrgCatService.catLoadByPage(vm.orgID, vm.currentPage, false, false, function(result) {
          vm.catList = result;
          vm.catList.forEach( function(cat) {
            cat.enabled = !cat.disable;
          });
          vm.max = OrgCatService.getMax();
          vm.current = vm.catList.length;
        });
      })
    };

    vm.RemoveCat = function(index) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      var cat = vm.catList[index];


      OrgCatService.remove(cat, function(error) {
        if (error === null) {
          vm.loadData();
        }
      });

    };

    vm.Disable = function(object) {
      if (!vm.mypermission) {
        object.enabled = !object.disable;
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }
      object.disable = !object.enabled;
      OrgCatService.update(object, function() {

      });
    };

    vm.OpenEdit = function(index) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      vm.catList[index].edit = true;

    };

    vm.CloseEdit = function(index) {
      var cat = {};
      cat = vm.catList[index];
      OrgCatService.update(cat, function(error) {
        if (error === null) {
          vm.Update();
          cat.edit = false;
        }
      });
    };

    vm.AddUsers = function(data) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      StateService.go('groupuser', data.id)
    };

    vm.UploadUsers = function(index) {
      var id = 'input' + index;
      var element = $document[0].getElementById(id);
      element.value = '';
      element.click();
    };

    vm.CSVFile = function(/*element*/) {
      if ( vm.mypermission ) {

        /* var data = vm.grpList[parseInt(element.name)];

         vm.reader.onload = function(event) {
         var users = OrgUserService.getCSVFileUsers(event.target.result);
         var list = [];
         users.forEach(function(user){
         list.push(user.id);
         });
         OrgUserService.assignToGroup(data.id, list,function(){

         });
         };

         vm.reader.readAsText(element.files[0]);*/
      }
    };

    vm.AddCat = function(isGroup) {
      if (!vm.mypermission) {
        MessageBoxService.open('Permissions', 'You don\'t have permissions to edit this.', 'Continue', function() { });
        return;
      }

      OrgCatService.getMaxCategories(vm.orgID, function(result) {
        vm.max = result;
        OrgCatService.add(isGroup, vm.max, function(result) {
          if (result === false) {
            vm.popup = $uibModal.open({
              templateUrl: 'app/popups/addmaxcat/addmaxcat.html',
              controller: 'AddMaxCat.Controller as vm',
              windowClass: 'template-box',
              scope: $scope
            });
          }
        });
      });
      vm.loadData();
    };

    vm.AddCatFromModal = function() {
      OrgCatService.getMaxCategories(vm.orgID, function(result) {
        vm.max = result;
        OrgCatService.add(false, vm.max, function() {
          vm.Update();
        })
      });
    };

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      //vm.reader = null; // garbage collect
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('BulkSMS.Controller', BulkSMSController);

  /** @ngInject */
  function BulkSMSController(
    $document,
    $log,
    $scope,
    $routeParams,
    OrgBillingService,
    OrganizationService,
    FormValidationService,
    StateService,
    MessageBoxService,
    UserService
  ) {
    var vm = this;
    vm.name = 'Bulk SMS';
    vm.orgID = $routeParams.orgID;
    vm.data = {};

    UserService.load(function() {
      UserService.checkAdminPromise()
      .then(function() {
        $log.log('Ready');
      });
    });

    vm.UploadUsers = function(index) {
      var element = $document[0].getElementById(index);
      element.value = '';
    };

    vm.CSVFile = function(element) {
      var reader = new FileReader();
      reader.onload = function() {
        var numbers = (reader.result || '').split('\n')
        .map(function(num) {
          return num.trim().replace(/\D+/g, '').replace(/^1/, '');
        })
        .filter(function(num) {
          return num.length === 10;
        });

        vm.data.numbers = numbers;
      };
      reader.readAsText(element.files[0]);
    };

    vm.SubmitForm = function() {
      OrganizationService.bulksms(vm.data.message, vm.data.numbers)
      .then(function() {
        $log.log('Done');
      });
    };

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {

    });
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('BrightPattern.Controller', Controller);

  /** @ngInject */
  function Controller($scope, $timeout, $log, $location, UserService, $interval, $mdToast) {
    var vm = this;
    vm.error = null;
    vm.composeMode = false;
    vm.isSending = false;
    vm.isLoadingTemplate = false;
    vm.currentTemplateId = null;
    vm.currentComposeActionType = null;
    vm.editableTextBoxes = [];
    vm.goBack = goBack;
    vm.sendTemplate = sendTemplate;
    vm.callNotes = '';
    vm.dispatchXmit = '';
    vm.callTimerSeconds = 0;
    vm.authenticationError = false;
    vm.callStatus = 'idle'; // idle, dialing, connected, failed, ended
    vm.callStatusMessage = '';
    vm.callStartTime = null;
    vm.callEndTime = null;
    // Testing interface variables
    vm.callTimerDisplay = function() {
      var m = Math.floor((vm.callTimerSeconds || 0) / 60);
      var s = (vm.callTimerSeconds || 0) % 60;
      var mm = (m < 10 ? '0' : '') + m;
      var ss = (s < 10 ? '0' : '') + s;
      return mm + ':' + ss;
    };

    // Production environment configuration
    vm.isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
    vm.brightPatternConfig = {
      tenantUrl: 'https://telecomincdev.brightpattern.com',
      apiBaseUrl: 'https://telecomincdev.brightpattern.com/clientweb/api/v2',
      accessToken: null // Will be set from URL parameters
    };

    // Extract access token from URL parameters
    function extractAccessToken() {
      var urlParams = new URLSearchParams(window.location.search);
      var accessToken = urlParams.get('access_token');

      if (accessToken) {
        vm.brightPatternConfig.accessToken = accessToken;
        /* eslint-disable no-console */
        console.log('[BrightPattern] Access token extracted from URL');

        // Store token securely for API calls
        if (vm.isProduction) {
          sessionStorage.setItem('bp_access_token', accessToken);
        }

        // Validate token with BrightPattern
        validateAccessToken(accessToken);
      } else {
        /* eslint-disable no-console */
        console.warn('[BrightPattern] No access token found in URL parameters');
        showAuthenticationError();
      }
    }

    // Validate access token with BrightPattern
    function validateAccessToken(token) {
      /* eslint-disable no-console */
      console.log('[BrightPattern] Validating access token...');

      // Make API call to validate token
      var validationUrl = vm.brightPatternConfig.apiBaseUrl + '/chats?tenantUrl=' +
                         encodeURIComponent(vm.brightPatternConfig.tenantUrl) +
                         '&access_token=' + encodeURIComponent(token);

      fetch(validationUrl)
      .then(function(response) {
        if (response.ok) {
          /* eslint-disable no-console */
          console.log('[BrightPattern] Access token validated successfully');
          hideAuthenticationError();
        } else {
          /* eslint-disable no-console */
          console.error('[BrightPattern] Access token validation failed:', response.status);
          showAuthenticationError();
        }
      })
      .catch(function(error) {
        /* eslint-disable no-console */
        console.error('[BrightPattern] Token validation error:', error);
        showAuthenticationError();
      });
    }

    // Show authentication error
    function showAuthenticationError() {
      /* eslint-disable no-console */
      console.warn('[BrightPattern] Authentication error - showing error state');
      vm.authenticationError = true;
      vm.error = 'Authentication failed. Please check your access token.';
    }

    // Hide authentication error
    function hideAuthenticationError() {
      vm.authenticationError = false;
      vm.error = null;
    }

    var canvasEl = null;
    var fabricCanvas = null;
    // var baseWidth = 720;
    // var baseHeight = 1000;
    var baseWidth = 375;   // width for mobile portrait
    var baseHeight = 667;  // height for mobile portrait
    var originalItem = null;
    var callTimerPromise = null;
    // Track map containers globally
    var mapContainers = [];

    function rgbaStrToCss(rgbaStr) {
      var parts = (rgbaStr || '').split(',');
      if (parts.length === 4) {
        return 'rgba(' + parts[0] + ',' + parts[1] + ',' + parts[2] + ',' + parts[3] + ')';
      }
      return 'rgba(255,255,255,1)';
    }

    vm.copyNotes = function() {
      if (vm.callNotes) {
        navigator.clipboard.writeText(vm.callNotes).then(function() {
          // Show toast
          $mdToast.show(
            $mdToast.simple()
            .textContent('Notes copied to clipboard!')
            .position('top right')
            .hideDelay(2000)
          );
        }, function() {
          $mdToast.show(
            $mdToast.simple()
            .textContent('Failed to copy notes')
            .position('top right')
            .hideDelay(2000)
          );
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
          .textContent('No notes to copy!')
          .position('top right')
          .hideDelay(2000)
        );
      }
    };


    function ensureWebFonts(fontFamilies, cb) {
      cb = cb || function() { };
      fontFamilies = (fontFamilies || []).filter(Boolean).map(function(f) { return (f + '').trim(); });
      if (!fontFamilies.length) return cb();

      var uniqueFamilies = Array.from(new Set(fontFamilies));

      if (document.fonts && document.fonts.load) {
        var loads = [];
        uniqueFamilies.forEach(function(name) {
          loads.push(document.fonts.load('400 16px "' + name + '"'));
          loads.push(document.fonts.load('700 16px "' + name + '"'));
        });

        Promise.all(loads).then(function() {
          cb();
        }).catch(function() {
          cb();
        });
      } else {
        setTimeout(cb, 100);
      }
    }

    function relX(left) { return left * baseWidth; }
    function relY(top) { return top * baseHeight; }
    function relW(width) { return width * baseWidth; }
    function relH(height) { return height * baseHeight; }

    function adjustTextHeight(tb, targetHeightPx) {
      var guard = 0;
      var rect = tb.getBoundingRect(true);
      if (!rect || !rect.height) return;
      while (Math.abs(rect.height - targetHeightPx) > 1 && guard < 10) {
        var ratio = targetHeightPx / rect.height;
        var nextSize = Math.max(6, Math.round(tb.fontSize * ratio));
        if (nextSize === tb.fontSize) break;
        tb.set('fontSize', nextSize);
        rect = tb.getBoundingRect(true);
        guard++;
      }
    }

    function setCanvasSize(width, height) {
      baseWidth = Math.max(1, Math.round(width || baseWidth));
      baseHeight = Math.max(1, Math.round(height || baseHeight));

      if (fabricCanvas) {
        fabricCanvas.enableRetinaScaling = true;
        fabricCanvas.setWidth(baseWidth);
        fabricCanvas.setHeight(baseHeight);
        fabricCanvas.setZoom(1);
        fabricCanvas.renderAll();
      }
    }

    function reorderByZ() {
      try {
        fabricCanvas._objects.sort(function(a, b) {
          var za = (typeof a.zorder === 'number') ? a.zorder : 0;
          var zb = (typeof b.zorder === 'number') ? b.zorder : 0;
          return zb - za;
        });
        fabricCanvas.renderAll();
      } catch (e) { return; }
    }

    function clearCanvas() {
      try {
        if (!fabricCanvas) return;
        fabricCanvas.clear();
        fabricCanvas.setBackgroundColor('rgba(255,255,255,1)', fabricCanvas.renderAll.bind(fabricCanvas));
        vm.editableTextBoxes = [];
        // Remove all map containers
        mapContainers.forEach(function(container) {
          if (container && container.parentNode) {
            try {
              container.parentNode.removeChild(container);
            } catch (e) {
              // Container might already be removed
            }
          }
        });
        mapContainers = []; // Reset the array
      } catch (e) { return; }
    }

    function addImages(imageLayout) {
      (imageLayout || []).forEach(function(imgDef) {
        if (imgDef.useGoogleMap) {
          var mapContainer = document.createElement('div');
          mapContainer.style.position = 'absolute';
          mapContainer.style.left = relX(imgDef.left || 0) + 'px';
          mapContainer.style.top = relY(imgDef.top || 0) + 'px';
          mapContainer.style.width = relW(imgDef.width || 0.5) + 'px';
          mapContainer.style.height = relH(imgDef.height || 0.1) + 'px';
          mapContainer.id = 'map_' + Math.random().toString(36).substr(2, 9);
          var canvasElement = document.getElementById('brightCanvas');
          if (canvasElement && canvasElement.parentNode) {
            canvasElement.parentNode.appendChild(mapContainer);
          }

          // Track the map container
          mapContainers.push(mapContainer);

          var mapOptions = {
            zoom: 15,
            mapTypeId: google.maps.MapTypeId.SATELLITE,
            disableDefaultUI: true
          };

          var map = new google.maps.Map(mapContainer, mapOptions);

          var useUserGPS = imgDef.useUserGPS || false;
          var targetLat, targetLng;

          if (useUserGPS) {
            if (vm.latUser && vm.lngUser && vm.latUser !== '' && vm.lngUser !== '') {
              targetLat = parseFloat(vm.latUser);
              targetLng = parseFloat(vm.lngUser);
            } else {
              targetLat = vm.currentLat && vm.currentLat !== '' ? parseFloat(vm.currentLat) : 0;
              targetLng = vm.currentLng && vm.currentLng !== '' ? parseFloat(vm.currentLng) : 0;
            }
          } else {
            targetLat = vm.currentLat && vm.currentLat !== '' ? parseFloat(vm.currentLat) : 0;
            targetLng = vm.currentLng && vm.currentLng !== '' ? parseFloat(vm.currentLng) : 0;
          }

          if (targetLat && targetLng) {
            var location = new google.maps.LatLng(targetLat, targetLng);
            map.setCenter(location);
            map.setZoom(15); // Explicitly set zoom
            new google.maps.Marker({
              position: location,
              map: map,
              title: ''
            });
          }

          if (imgDef.angle && imgDef.angle !== 0) {
            fabricCanvas.add(new fabric.Rect({
              left: relX(imgDef.left || 0),
              top: relY(imgDef.top || 0),
              width: relW(imgDef.width || 0.5),
              height: relH(imgDef.height || 0.1),
              angle: imgDef.angle,
              fill: 'rgba(0,0,0,0)',
              selectable: false,
              evented: false,
              zorder: (typeof imgDef.zorder === 'number') ? imgDef.zorder : 0
            }));
          }

          google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
            if (typeof html2canvas === 'undefined') {
              if (mapContainer && mapContainer.parentNode) {
                mapContainer.parentNode.removeChild(mapContainer);
                mapContainers = mapContainers.filter(function(c) {
                  return c !== mapContainer;
                });
              }
              return;
            }

            setTimeout(function() {
              var scale = window.devicePixelRatio || 2;
              html2canvas(mapContainer, {
                useCORS: true,
                backgroundColor: null,
                scale: scale
              }).then(function(canvas) {
                var targetW = relW(imgDef.width || 0.5);
                var targetH = relH(imgDef.height || 0.1);

                var outCanvas = document.createElement('canvas');
                outCanvas.width = targetW;
                outCanvas.height = targetH;
                var ctx = outCanvas.getContext('2d');
                ctx.drawImage(canvas, 0, 0, targetW, targetH);
                try {
                  // var dataUrl = outCanvas.toDataURL('image/png');
                  // fabric.Image.fromURL(dataUrl, function(image) {
                  //   if (!image) return;
                  //   image.set({
                  //     left: relX(imgDef.left || 0),
                  //     top: relY(imgDef.top || 0),
                  //     angle: imgDef.angle || 0,
                  //     selectable: false,
                  //     evented: false
                  //   });
                  //   var sx = targetW / image.width;
                  //   var sy = targetH / image.height;
                  //   image.set({ scaleX: sx, scaleY: sy });
                  //   image.zorder = (typeof imgDef.zorder === 'number') ? imgDef.zorder : 0;
                  //   fabricCanvas.add(image);
                  //   reorderByZ();
                  //   if (mapContainer && mapContainer.parentNode) {
                  //     mapContainer.parentNode.removeChild(mapContainer);
                  //     mapContainers = mapContainers.filter(function(c) { return c !== mapContainer; });
                  //   }
                  // }, { crossOrigin: 'anonymous' });
                } catch (e) {
                  if (mapContainer && mapContainer.parentNode) {
                    mapContainer.parentNode.removeChild(mapContainer);
                    mapContainers = mapContainers.filter(function(c) { return c !== mapContainer; });
                  }
                }
              }).catch(function() {
                if (mapContainer && mapContainer.parentNode) {
                  mapContainer.parentNode.removeChild(mapContainer);
                  mapContainers = mapContainers.filter(function(c) {
                    return c !== mapContainer;
                  });
                }
              });
            }, 500); // Delay to ensure map rendering
          });
        } else {
          fabric.Image.fromURL(imgDef.url, function(image) {
            if (!image) return;
            image.set({
              left: relX(imgDef.left || 0),
              top: relY(imgDef.top || 0),
              angle: imgDef.angle || 0,
              selectable: false,
              evented: false
            });
            var width = relW(imgDef.width || 0);
            var height = relH(imgDef.height || 0);
            if (width && height) {
              var sx = width / image.width;
              var sy = height / image.height;
              image.set({ scaleX: sx, scaleY: sy });
            }
            image.zorder = (typeof imgDef.zorder === 'number') ? imgDef.zorder : 0;
            fabricCanvas.add(image);
            reorderByZ();
          }, { crossOrigin: 'anonymous' });
        }
      });
    }

    function addTexts(textLayout) {
      (textLayout || []).forEach(function(txtDef) {
        var targetH = relH(txtDef.height || 0.1);
        var computedFontSize = Math.min(targetH * 0.3, txtDef.fontsize || 26);

        var existingText = fabricCanvas.getObjects().find(function(obj) {
          return obj.type === 'textbox' &&
            obj.left === relX(txtDef.left || 0) &&
            obj.top === relY(txtDef.top || 0) &&
            obj.text === (txtDef.text || '');
        });

        if (!existingText) {
          var tb = new fabric.Textbox((txtDef.text || '').toString(), {
            left: relX(txtDef.left || 0),
            top: relY(txtDef.top || 0),
            width: relW(txtDef.width || 0.5),
            fontSize: computedFontSize,
            fill: rgbaStrToCss(txtDef.color || '0,0,0,1'),
            angle: txtDef.angle || 0,
            lineHeight: 1.2,
            selectable: false,
            evented: false,
            textAlign: 'center'
          });

          tb.zorder = (typeof txtDef.zorder === 'number') ? txtDef.zorder : 0;
          fabricCanvas.add(tb);
          reorderByZ();

          adjustTextHeight(tb, targetH);
        }
      });
    }

    function addButtons(buttonLayout) {
      (buttonLayout || []).forEach(function(btn) {
        var style = (btn.style || 'rect').toLowerCase();
        var left = relX(btn.left || 0);
        var top = relY(btn.top || 0);
        var width = relW(btn.width || 0.15);
        var height = relH(btn.height || 0.06);
        var fill = rgbaStrToCss(btn.color || '0,0,0,1');
        var textColor = rgbaStrToCss(btn.textColor || '255,255,255,1');

        var shapeOptions = {
          left: left,
          top: top,
          fill: fill,
          selectable: false,
          evented: true
        };

        var shape;
        if (style === 'circle') {
          var radius = Math.min(width, height) / 2;
          shape = new fabric.Circle(angular.extend({}, shapeOptions, { radius: radius }));
        } else if (style === 'ellipse') {
          shape = new fabric.Ellipse(angular.extend({}, shapeOptions, { rx: width / 2, ry: height / 2 }));
        } else {
          var corner = btn.corner || 0;
          shape = new fabric.Rect(angular.extend({}, shapeOptions, { width: width, height: height, rx: corner, ry: corner }));
        }

        shape.zorder = (typeof btn.zorder === 'number') ? btn.zorder : 0;
        shape.actionType = btn.actionType;
        shape.action = btn.action;
        fabricCanvas.add(shape);

        var computedFontSize = Math.min(height * 0.3, btn.fontsize);
        var label = new fabric.Text((btn.text || '').toString(), {
          left: left + width / 2,
          top: top + height / 2,
          originX: 'center',
          originY: 'center',
          fontFamily: btn.fontfamily || 'Open Sans',
          fontSize: computedFontSize,
          lineHeight: 1.0,
          fill: textColor,
          selectable: false,
          evented: false
        });

        label.zorder = shape.zorder - 0.0001;
        fabricCanvas.add(label);
        reorderByZ();
      });
    }

    function enterEditing(textbox) {
      fabricCanvas.setActiveObject(textbox);
      textbox.enterEditing();
      textbox.selectAll();
      if (textbox.hiddenTextarea) {
        textbox.hiddenTextarea.focus();
      }
      fabricCanvas.renderAll();
    }

    function addEditableLayouts(editableLayout, customText) {
      if (!fabricCanvas) {
        return;
      }

      if (!vm.editableTextBoxes) vm.editableTextBoxes = [];

      (editableLayout || []).forEach(function(edDef) {
        const rectLeft = relX(edDef.left || 0);
        const rectTop = relY(edDef.top || 0);
        const rectWidth = relW(edDef.width || 0.5);
        const rectHeight = relH(edDef.height || 0.1);

        if (rectWidth <= 0 || rectHeight <= 0) return;

        const isEditable = !!vm.composeMode;

        const rect = new fabric.Rect({
          left: rectLeft,
          top: rectTop,
          width: rectWidth,
          height: rectHeight,
          fill: 'rgba(255, 255, 255, 1)',
          stroke: isEditable ? 'black' : 'rgba(0,0,0,0)',
          strokeWidth: 1,
          selectable: false,
          evented: isEditable,
          zorder: typeof edDef.zorder === 'number' ? edDef.zorder : 0,
        });
        const text = new fabric.Textbox(customText || '', {
          left: rect.left,
          top: rect.top,
          width: rect.width,
          minWidth: rect.width,
          height: rect.height,
          maxHeight: rect.height,
          fontSize: 16,
          fill: 'black',
          textAlign: 'left',
          selectable: false,
          evented: isEditable,
          backgroundColor: 'rgba(255,255,255,0)',
          zorder: typeof edDef.zorder === 'number' ? edDef.zorder : 0,
        });
        text.set('text', customText || 'Your Text Here');

        function stretchTextboxToRect(textbox, rect) {
          textbox.set({
            left: rect.left,
            top: rect.top,
            width: rect.width,
            minWidth: rect.width,
            height: rect.height,
            maxHeight: rect.height,
            padding: 5
          });
          if (textbox._initDimensions) {
            textbox._initDimensions();
          } else {
            textbox.initDimensions();
          }
          textbox.setCoords();
          fabricCanvas.renderAll();
        }

        stretchTextboxToRect(text, rect);

        if (isEditable) {
          text.on('changed', function() {
            stretchTextboxToRect(text, rect);
          });

          text.on('mousedown', function() {
            enterEditing(text);
          });

          text.on('mousedblclick', function() {
            enterEditing(text);
          });

          rect.on('mousedown', function() {
            enterEditing(text);
          });

        }

        fabricCanvas.add(rect);
        fabricCanvas.add(text);
        vm.editableTextBoxes.push(text);
      });

      fabricCanvas.selection = true;
      fabricCanvas.renderAll();

      reorderByZ();
    }

    function renderLayouts(app, customtext) {
      // Clear canvas and map containers before rendering new layout
      clearCanvas();
      addImages(app.imageLayout || []);
      addButtons(app.buttonLayout || []);
      addTexts(app.textLayout);
      addEditableLayouts(app.editableLayout, customtext);
      fabricCanvas.renderAll();
    }

    /* eslint-disable no-console */
    function handleAction(actionType, action) {
      console.log('[BrightPattern] handleAction called with:', { actionType: actionType, action: action });
      switch ((actionType || '').toLowerCase()) {
      case 'senderphone':
        var number = action; //resolveCallNumber(action);
        console.log('[BrightPattern] Phone number from action:', number);
        if (number) {
          // Add country code "1" if not already present
          var phoneNumber = (number + '').trim();
          if (!phoneNumber.startsWith('1')) {
            phoneNumber = '1' + phoneNumber;
          }
          console.log('[BrightPattern] Phone number with country code:', phoneNumber);
          startOutboundCall(phoneNumber);
        } else {
          vm.error = 'No phone number available for CALL action.';
        }
        break;
      // case 'senderphone':
      //   if (action) window.location.href = 'tel:' + action;
      //   break;
      case 'directions':
        var lat = vm.currentLat;
        var lng = vm.currentLng;
        if (lat && lng) window.open('https://www.google.com/maps?q=' + lat + ',' + lng, '_blank');
        break;
      case 'safelink':
      case 'url':
        if (action) {
          window.open(action, '_blank');
        }
        break;
      case 'sendtemplateonreply':
      case 'sendtemplateon911':
        if (!action) return;
        if (vm.isLoadingTemplate) return;
        vm.isLoadingTemplate = true;
        startComposeFromTemplate(action, (actionType || '').toLowerCase());
        break;
      default:
        break;
      }
    }

    function startComposeFromTemplate(templateId, composeType) {
      vm.composeMode = true;
      vm.currentTemplateId = templateId;
      vm.currentComposeActionType = composeType || null;
      vm.error = null;
      vm.editableTextBoxes = [];

      var token = ($location.search() && $location.search().access_token) || '';
      UserService.getTemplateById(templateId, token)
      .then(function(tpl) {
        var app = (tpl && tpl.applayout) ? tpl.applayout : {};
        clearCanvas();

        var bg = rgbaStrToCss(app.backgroundColor || '255,255,255,1');
        fabricCanvas.setBackgroundColor(bg, fabricCanvas.renderAll.bind(fabricCanvas));

        var fontList = ['Russo One', 'Open Sans'];
        (app.textLayout || []).forEach(function(t) { if (t.fontfamily) fontList.push(t.fontfamily); });
        (app.buttonLayout || []).forEach(function(b) { if (b.fontfamily) fontList.push(b.fontfamily); });

        ensureWebFonts(fontList, function() {
          renderLayouts(app, '');
          fabricCanvas.renderAll();
        });
        vm.isLoadingTemplate = false;
      })
      .catch(function(err) {
        $log.error('Failed to load template', err);
        vm.error = 'Failed to load template.';
        vm.isLoadingTemplate = false;
      });
    }

    function renderLayout(item) {
      var mi = item.messageinstance || {};
      var app = mi.applayout || {};

      vm.currentLat = mi.lat || mi.latitude;
      vm.currentLng = mi.lng || mi.longitude;
      vm.latUser = mi.latUser || '';
      vm.lngUser = mi.lngUser || '';

      // Expose caller details
      vm.caller = {
        name: mi.name || mi.sendername || mi.fullname || mi.displayname || '',
        phone: mi.phone || mi.phonenumber || mi.senderphone || mi.fromPhone || '',
        address: [mi.address, mi.address1, mi.city, mi.state, mi.zip].filter(Boolean).join(', '),
        dob: mi.dob || mi.dateofbirth || '',
        age: mi.age || '',
        gender: mi.gender || mi.sex || ''
      };

      // Original message
      vm.originalMessage = (mi.customtext && mi.customtext[0]) || '';

      // Handle "Sent By" details
      vm.sentBy = '';
      vm.sentByEmail = '';
      vm.sentByPhone = '';
      vm.sentByDOB = '';
      vm.sentByAge = '';

      if (mi.sender) {
        if (typeof mi.sender === 'object') {
          // sender is an object
          vm.sentBy = mi.sender.fullName || (mi.sender.firstname + ' ' + mi.sender.lastname) || '';
          vm.sentByEmail = mi.sender.email || '';
          vm.sentByPhone = mi.sender.phone || '';
          vm.sentByDOB = mi.sender.birthday || '';
          vm.sentByAge = mi.sender.age || '';
        } else {
          vm.sentBy = mi.sender; // sender is string
        }
      } else if (mi.sendername) {
        vm.sentBy = mi.sendername;
      } else {
        vm.sentBy = vm.caller.name || '';
      }

      // Set canvas background
      var bg = rgbaStrToCss(app.backgroundColor || '255,255,255,1');
      fabricCanvas.setBackgroundColor(bg, fabricCanvas.renderAll.bind(fabricCanvas));

      // Collect fonts
      var fontList = ['Russo One', 'Open Sans'];
      (app.textLayout || []).forEach(function(t) { if (t.fontfamily) fontList.push(t.fontfamily); });
      (app.buttonLayout || []).forEach(function(b) { if (b.fontfamily) fontList.push(b.fontfamily); });

      // Render function
      var doRender = function() { renderLayouts(app, mi.customtext[0]); };

      ensureWebFonts(fontList, function() {
        doRender();
        fabricCanvas.renderAll();
      });
    }



    function fetchMessages() {
      var token = ($location.search() && $location.search().access_token) || '';
      UserService.listMyMessages({ access_token: token, favoritesonly: false, newonly: false }, function(result, error) {
        if (error) {
          $log.error('Failed to load messages', error);
          vm.error = 'Failed to load messages.';
          return;
        }
        var list = result || [];
        if (!list.length) {
          vm.error = 'No messages available.';
          return;
        }
        originalItem = list[0];
        clearCanvas();
        vm.composeMode = false;
        vm.callNotes = '';
        vm.dispatchXmit = '';
        renderLayout(originalItem);
      });
    }

    $scope.$on('$viewContentLoaded', function() {
      $timeout(function() {
        canvasEl = document.getElementById('brightCanvas');
        if (!canvasEl) return;
        fabricCanvas = new fabric.Canvas('brightCanvas', { selection: false });
        fabricCanvas.skipTargetFind = true;
        fabricCanvas.hoverCursor = 'default';
        if (fabricCanvas.upperCanvasEl) {
          fabricCanvas.upperCanvasEl.style.pointerEvents = 'auto';
        }
        setCanvasSize(baseWidth, baseHeight);
        fabricCanvas.skipTargetFind = false;
        fabricCanvas.on('mouse:down', function(opt) {
          var t = opt && opt.target;
          if (!t) return;
          var at = t.actionType || (t.group && t.group.actionType);
          var ac = t.action || (t.group && t.group.action);
          if (at) handleAction(at, ac);
        });
        fetchMessages();
      });
    });

    $scope.$on('$destroy', function() {
      if (fabricCanvas) {
        fabricCanvas.dispose();
        fabricCanvas = null;
      }
      if (callTimerPromise) { $interval.cancel(callTimerPromise); callTimerPromise = null; }
      // Clean up map containers
      mapContainers.forEach(function(container) {
        if (container && container.parentNode) {
          container.parentNode.removeChild(container);
        }
      });
      mapContainers = [];
    });

    function goBack() {
      vm.composeMode = false;
      vm.currentTemplateId = null;
      vm.currentComposeActionType = null;
      vm.editableTextBoxes = [];
      if (callTimerPromise) { $interval.cancel(callTimerPromise); callTimerPromise = null; }
      if (originalItem) {
        clearCanvas();
        renderLayout(originalItem);
      }
    }

    function sendTemplate() {
      if (!vm.currentTemplateId) return;
      try {
        vm.isSending = true;
        var textVal = '';
        if (vm.editableTextBoxes && vm.editableTextBoxes.length) {
          textVal = vm.editableTextBoxes[0].text || '';
        }

        if (vm.callNotes && vm.callNotes.trim().length) {
          textVal = (textVal || '') + '\n\nNotes:\n' + vm.callNotes.trim();
        }
        if (vm.dispatchXmit && vm.dispatchXmit.trim().length) {
          textVal = (textVal || '') + '\nXMIT: ' + vm.dispatchXmit.trim();
        }

        var mi = (originalItem && originalItem.messageinstance) ? originalItem.messageinstance : {};
        var info = {
          templateid: vm.currentTemplateId,
          sendingorganizationid: mi.sendingorganizationid || mi.organizationid || undefined,
          lat: vm.currentLat,
          lng: vm.currentLng,
          userlat: vm.latUser || vm.currentLat,
          userlng: vm.lngUser || vm.currentLng,
          is_message_reporting: true,
          customtext: textVal,
          userids: [],
          currentUserId: (mi && mi.currentUserId) || 0
        };

        var token = ($location.search() && $location.search().access_token) || '';
        UserService.sendReportMessage(info, token)
        .then(function() {
          vm.isSending = false;
          goBack();
        })
        .catch(function(err) {
          vm.isSending = false;
          $log.error('Failed to send', err);
          vm.error = 'Failed to send. Please try again.';
        });
      } catch (e) {
        vm.isSending = false;
      }
    }

    /* eslint-disable no-console */
    function startOutboundCall(phoneNumber) {
      console.log('[BrightPattern] ===== CALL INITIATION START =====');
      console.log('[BrightPattern] startOutboundCall received phoneNumber:', phoneNumber, 'type:', typeof phoneNumber);
      var num = (phoneNumber + '').trim();
      console.log('[BrightPattern] startOutboundCall input:', phoneNumber, 'normalized:', num);

      // Detect environment
      var isInAgentDesktop = window.parent !== window && window.parent.location.href.includes('agentdesktop');
      var isStandaloneApp = !isInAgentDesktop && window.location.hostname === 'localhost';
      var isProductionApp = vm.isProduction && !isInAgentDesktop;
      console.log('[BrightPattern] Environment Detection:');
      console.log('  - isInAgentDesktop:', isInAgentDesktop);
      console.log('  - isStandaloneApp:', isStandaloneApp);
      console.log('  - isProductionApp:', isProductionApp);

      // Check SDK availability immediately
      console.log('[BrightPattern] SDK Check:');
      console.log('  - window.bpspat exists:', !!window.bpspat);
      console.log('  - window.bpspat.api exists:', !!(window.bpspat && window.bpspat.api));
      console.log('  - dialNumber function exists:', !!(window.bpspat && window.bpspat.api && typeof window.bpspat.api.dialNumber === 'function'));
      console.log('  - getState function exists:', !!(window.bpspat && window.bpspat.api && typeof window.bpspat.api.getState === 'function'));

      if (!num) {
        console.warn('[BrightPattern] No phone number available. Aborting outdial.');
        vm.error = 'No phone number available for call.';
        vm.callStatus = 'failed';
        vm.callStatusMessage = 'No phone number available';
        return;
      }

      // Reset call status
      vm.callStatus = 'initiating';
      vm.callStatusMessage = 'Initiating call...';
      vm.callStartTime = null;
      vm.callEndTime = null;

      // Start call timer
      try {
        if (callTimerPromise) { $interval.cancel(callTimerPromise); callTimerPromise = null; }
        vm.callTimerSeconds = 0;
        callTimerPromise = $interval(function() { vm.callTimerSeconds++; }, 1000);
        console.log('[BrightPattern] Call timer started.');
      } catch (e) {
        console.error('[BrightPattern] Failed to start call timer:', e);
      }

      // Different call strategies based on environment
      if (isInAgentDesktop) {
        console.log('[BrightPattern] Running inside Agent Desktop - using parent window communication');
        callFromAgentDesktop(num);
      } else if (window.bpspat && window.bpspat.api && typeof window.bpspat.api.dialNumber === 'function') {
        console.log('[BrightPattern] Running standalone - using SDK directly');
        ensureAgentReady(function() {
          console.log('[BrightPattern] ensureAgentReady callback executed');
          callWithSDK(num);
        });
      } else {
        console.log('[BrightPattern] SDK not available - using fallback');
        callWithFallback(num);
      }
      console.log('[BrightPattern] ===== CALL INITIATION END =====');
    }

    // Call from within Agent Desktop environment
    function callFromAgentDesktop(phoneNumber) {
      console.log('[BrightPattern] Attempting call from Agent Desktop environment');
      vm.callStatusMessage = 'Initiating call from Agent Desktop...';
      try {
        // Try to communicate with parent Agent Desktop
        if (window.parent && window.parent !== window) {
          console.log('[BrightPattern] Sending call request to parent Agent Desktop');
          // Send message to parent Agent Desktop
          var message = {
            type: 'DIAL_NUMBER',
            number: phoneNumber,
            source: 'guardian-link'
          };
          window.parent.postMessage(JSON.stringify(message), '*');
          console.log('[BrightPattern] Call request sent to Agent Desktop:', message);
          vm.callStatus = 'dialing';
          vm.callStatusMessage = 'Call initiated in Agent Desktop';
          // Set timeout to check if call connects
          setTimeout(function() {
            if (vm.callStatus === 'initiating' || vm.callStatus === 'dialing') {
              console.warn('[BrightPattern] Call status unknown - checking...');
              vm.callStatusMessage = 'Call initiated but status unknown';
            }
          }, 10000);
        } else {
          console.warn('[BrightPattern] No parent window available for Agent Desktop communication');
          callWithFallback(phoneNumber);
        }
      } catch (e) {
        console.error('[BrightPattern] Error communicating with Agent Desktop:', e);
        callWithFallback(phoneNumber);
      }
    }

    // Call using BrightPattern SDK directly
    function callWithSDK(phoneNumber) {
      console.log('[BrightPattern] Attempting bpspat.api.dialNumber to', phoneNumber);
      try {
        window.bpspat.api.dialNumber(phoneNumber);
        console.log('[BrightPattern] Call initiated successfully via bpspat.api.dialNumber');

        // Set timeout to check if call connects
        setTimeout(function() {
          if (vm.callStatus === 'initiating' || vm.callStatus === 'dialing') {
            console.warn('[BrightPattern] Call may not have connected - checking status...');
            vm.callStatusMessage = 'Call initiated but connection status unknown';
          }
        }, 10000); // Check after 10 seconds

      } catch (e) {
        console.error('[BrightPattern] dialNumber error:', e);
        vm.callStatus = 'failed';
        vm.callStatusMessage = 'Call initiation failed: ' + e.message;
      }
    }

    // Fallback call method
    function callWithFallback(phoneNumber) {
      console.log('[BrightPattern] Using fallback tel: protocol for', phoneNumber);
      vm.callStatus = 'fallback';
      vm.callStatusMessage = 'Using device dialer (tel: protocol)';
      window.location.href = 'tel:' + phoneNumber;
    }

    // Ensure agent is ready before making calls
    function ensureAgentReady(callback) {
      console.log('[BrightPattern] ===== ENSURE AGENT READY START =====');
      if (!window.bpspat || !window.bpspat.api) {
        console.warn('[BrightPattern] SDK not available for agent state check');
        callback();
        return;
      }

      console.log('[BrightPattern] SDK available, checking agent state...');
      // Check current agent state
      window.bpspat.api.getState(function(stateData) {
        console.log('[BrightPattern] Current agent state:', stateData);
        if (stateData && stateData.status === 'ready') {
          console.log('[BrightPattern] Agent is ready, proceeding with call');
          callback();
        } else {
          console.log('[BrightPattern] Agent not ready, attempting to set ready state');
          vm.callStatusMessage = 'Setting agent to ready state...';
          // Try to set agent to ready state
          window.bpspat.api.setStatus('READY');
          // Wait a moment and check again
          setTimeout(function() {
            window.bpspat.api.getState(function(newStateData) {
              console.log('[BrightPattern] Agent state after setStatus:', newStateData);
              if (newStateData && newStateData.status === 'ready') {
                console.log('[BrightPattern] Agent is now ready, proceeding with call');
                vm.callStatusMessage = 'Agent ready, initiating call...';
                callback();
              } else {
                console.warn('[BrightPattern] Agent still not ready, proceeding anyway');
                vm.callStatusMessage = 'Agent not ready, attempting call anyway...';
                callback();
              }
            });
          }, 2000); // Wait 2 seconds for state change
        }
      });
      console.log('[BrightPattern] ===== ENSURE AGENT READY END =====');
    }
    // function initializeBrightPattern() {
    //   console.log('[BrightPattern] Initializing BrightPattern...');
    //   // Initialize BrightPattern SDK if available
    //   if (window.BPClient) {
    //     try {
    //       console.log('[BrightPattern] Initializing BP SDK...');
    //       // Initialize the helper
    //       if (window.BPClient.initHelper) {
    //         console.log('[BrightPattern] Initializing BP helper...');
    //         var helperInitialized = window.BPClient.initHelper();
    //         console.log('[BrightPattern] BP helper initialized:', helperInitialized);
    //         if (helperInitialized) {
    //           // Create BP instance
    //           if (window.BPClient.create) {
    //             console.log('[BrightPattern] Creating BP instance...');
    //             window.BPClient.create();
    //             console.log('[BrightPattern] BP instance creation requested.');
    //           }
    //         }
    //       }
    //       console.log('[BrightPattern] BP SDK initialization completed.');
    //     } catch (e) {
    //       console.error('[BrightPattern] Failed to initialize BP SDK:', e);
    //     }
    //   } else {
    //     console.log('[BrightPattern] BP SDK not available for initialization.');
    //   }
    //   // Set up iframe message listener
    //   window.addEventListener('message', function(event) {
    //     if (event.data && event.data.type === 'iframe-pos') {
    //       console.log('[BrightPattern] Received iframe position update:', event.data);
    //     }
    //   });
    // }
    // BrightPattern log function to display events
    function log(data) {
      /* eslint-disable no-console */
      console.log('[BrightPattern Event]', data);


      // Track call status based on events
      if (data && data.command) {
        var command = data.command.toUpperCase();

        switch (command) {
        case '_O_CALL_DIALING':
          vm.callStatus = 'dialing';
          vm.callStatusMessage = 'Call is being dialed...';
          /* eslint-disable no-console */
          console.log('[BrightPattern] Call Status: DIALING');
          break;

        case '_O_CALL_CONNECTED':
          vm.callStatus = 'connected';
          vm.callStatusMessage = 'Call connected successfully!';
          vm.callStartTime = new Date();
          /* eslint-disable no-console */
          console.log('[BrightPattern] Call Status: CONNECTED');
          break;

        case '_CALL_ENDED':
          vm.callStatus = 'ended';
          vm.callStatusMessage = 'Call ended';
          vm.callEndTime = new Date();
          /* eslint-disable no-console */
          console.log('[BrightPattern] Call Status: ENDED');

          // Calculate call duration
          if (vm.callStartTime) {
            var duration = Math.floor((vm.callEndTime - vm.callStartTime) / 1000);
            /* eslint-disable no-console */
            console.log('[BrightPattern] Call Duration:', duration + ' seconds');
          }
          break;

        case '_CALL_HELD':
          vm.callStatusMessage = 'Call is on hold';
          /* eslint-disable no-console */
          console.log('[BrightPattern] Call Status: HELD');
          break;

        case '_CALL_RESUMED':
          vm.callStatusMessage = 'Call resumed';
          /* eslint-disable no-console */
          console.log('[BrightPattern] Call Status: RESUMED');
          break;

        case 'STATE_CHANGED':
          /* eslint-disable no-console */
          console.log('[BrightPattern] Agent State Changed:', data.data);
          break;

        case 'LOGIN_CHANGED':
          /* eslint-disable no-console */
          console.log('[BrightPattern] Login Status Changed:', data.data);
          break;
        }
      }
    }


    // Handle session sharing issues
    function handleSessionSharing() {
      /* eslint-disable no-console */
      console.log('[BrightPattern] Checking for session sharing issues...');

      // Check if we're in production environment
      var isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

      if (isProduction) {
        /* eslint-disable no-console */
        console.log('[BrightPattern] Production environment detected - applying session fixes');

        // Clear any existing BrightPattern sessions
        try {
          // Clear localStorage items related to BrightPattern
          var keysToRemove = [];
          for (var i = 0; i < localStorage.length; i++) {
            var key = localStorage.key(i);
            if (key && (key.includes('bpattern') || key.includes('brightpattern') || key.includes('agent') || key.includes('session'))) {
              keysToRemove.push(key);
            }
          }

          keysToRemove.forEach(function(key) {
            localStorage.removeItem(key);
            /* eslint-disable no-console */
            console.log('[BrightPattern] Removed localStorage key:', key);
          });

          // Clear sessionStorage as well
          var sessionKeysToRemove = [];
          for (var j = 0; j < sessionStorage.length; j++) {
            var sessionKey = sessionStorage.key(j);
            if (sessionKey && (sessionKey.includes('bpattern') || sessionKey.includes('brightpattern') || sessionKey.includes('agent') || sessionKey.includes('session'))) {
              sessionKeysToRemove.push(sessionKey);
            }
          }

          sessionKeysToRemove.forEach(function(key) {
            sessionStorage.removeItem(key);
            /* eslint-disable no-console */
            console.log('[BrightPattern] Removed sessionStorage key:', key);
          });

          // Force logout from BrightPattern if possible
          if (window.bpspat && window.bpspat.api && typeof window.bpspat.api.logout === 'function') {
            /* eslint-disable no-console */
            console.log('[BrightPattern] Attempting to logout from existing session...');
            try {
              window.bpspat.api.logout();
            } catch (e) {
              /* eslint-disable no-console */
              console.log('[BrightPattern] Logout not available or failed:', e);
            }
          }

        } catch (e) {
          /* eslint-disable no-console */
          console.warn('[BrightPattern] Could not clear storage:', e);
        }
      }
    }

    // Handle session sharing popup
    function handleSessionSharingPopup() {
      /* eslint-disable no-console */
      console.log('[BrightPattern] Setting up session sharing popup handler...');

      // Immediate check for existing popup
      setTimeout(function() {
        checkForSessionSharingPopup();
      }, 500);

      // Listen for session sharing messages
      window.addEventListener('message', function(event) {
        if (event.data && event.data.type === 'session-sharing') {
          /* eslint-disable no-console */
          console.log('[BrightPattern] Session sharing detected:', event.data);
          autoResolveSessionSharing();
        }
      });

      // Set up DOM mutation observer to catch popup as soon as it appears
      if (window.MutationObserver) {
        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) { // Element node
                  var text = node.textContent || node.innerText || '';
                  if (text.toLowerCase().includes('session sharing') || text.toLowerCase().includes('shared session') || text.toLowerCase().includes('i\'m back')) {
                    /* eslint-disable no-console */
                    console.log('[BrightPattern] Session sharing popup detected via DOM mutation');
                    setTimeout(function() {
                      checkForSessionSharingPopup();
                    }, 100);
                  }
                }
              });
            }
          });
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });

        // Stop observing after 60 seconds
        setTimeout(function() {
          observer.disconnect();
        }, 60000);
      }

      // Also check for session sharing popup periodically
      var sessionCheckInterval = setInterval(function() {
        checkForSessionSharingPopup();
      }, 500); // Check every 500ms instead of 1 second

      // Clear interval after 60 seconds instead of 30
      setTimeout(function() {
        clearInterval(sessionCheckInterval);
      }, 60000);
    }

    // Check for session sharing popup and auto-resolve
    function checkForSessionSharingPopup() {
      /* eslint-disable no-console */
      console.log('[BrightPattern] Checking for session sharing popup...');
      // Look for session sharing popup elements using multiple methods
      var sessionPopup = document.querySelector('[title*="Session sharing"]') ||
                        document.querySelector('[title*="session sharing"]') ||
                        findElementByText('div', 'Session sharing') ||
                        findElementByText('div', 'session sharing') ||
                        findElementByText('div', 'Shared session has been detected') ||
                        findElementByText('div', 'shared session has been detected') ||
                        document.querySelector('.modal[style*="display"]') ||
                        document.querySelector('[role="dialog"]');

      // Also check for any modal/popup that might be the session sharing dialog
      var modals = document.querySelectorAll('.modal, [role="dialog"], .popup, .dialog, [class*="modal"], [class*="popup"], [class*="dialog"]');
      for (var i = 0; i < modals.length; i++) {
        var modal = modals[i];
        if (modal.style.display !== 'none' && modal.offsetParent !== null) {
          var modalText = modal.textContent || modal.innerText || '';
          if (modalText.toLowerCase().includes('session sharing') || modalText.toLowerCase().includes('shared session')) {
            sessionPopup = modal;
            /* eslint-disable no-console */
            console.log('[BrightPattern] Found session sharing modal by text content');
            break;
          }
        }
      }

      // Additional check for any visible popup with "I'm back" button
      if (!sessionPopup) {
        var allButtons = document.querySelectorAll('button, input[type="button"], input[type="submit"], a');
        for (var j = 0; j < allButtons.length; j++) {
          var button = allButtons[j];
          var buttonText = (button.textContent || button.value || '').toLowerCase();
          if (buttonText.includes('i\'m back') || buttonText.includes('back')) {
            // Check if this button is in a visible popup/modal
            var parent = button.closest('.modal, [role="dialog"], .popup, .dialog, [class*="modal"], [class*="popup"]');
            if (parent && parent.style.display !== 'none' && parent.offsetParent !== null) {
              sessionPopup = parent;
              /* eslint-disable no-console */
              console.log('[BrightPattern] Found session sharing popup by button location');
              break;
            }
          }
        }
      }

      if (sessionPopup) {
        /* eslint-disable no-console */
        console.log('[BrightPattern] Session sharing popup detected, auto-resolving...');
        console.log('[BrightPattern] Popup element:', sessionPopup);
        console.log('[BrightPattern] Popup text:', sessionPopup.textContent || sessionPopup.innerText);
        autoResolveSessionSharing();
      } else {
        /* eslint-disable no-console */
        console.log('[BrightPattern] No session sharing popup found');
      }
    }

    // Helper function to find elements by text content
    function findElementByText(tagName, text) {
      var elements = document.querySelectorAll(tagName);
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].textContent && elements[i].textContent.includes(text)) {
          return elements[i];
        }
      }
      return null;
    }

    // Auto-resolve session sharing
    function autoResolveSessionSharing() {
      /* eslint-disable no-console */
      console.log('[BrightPattern] Attempting to auto-resolve session sharing...');

      // Try multiple methods to find the "I'm back" button
      var backButton = null;

      // Method 1: Look for buttons with specific attributes and classes
      backButton = document.querySelector('[data-testid="session-back-button"]') ||
                  document.querySelector('button[class*="back"]') ||
                  document.querySelector('button[onclick*="back"]') ||
                  document.querySelector('input[value*="back"]') ||
                  document.querySelector('button[class*="primary"]') ||
                  document.querySelector('button[class*="confirm"]') ||
                  document.querySelector('button[class*="ok"]');

      // Method 2: Look for buttons by text content (case insensitive)
      if (!backButton) {
        backButton = findElementByText('button', 'I\'m back') ||
                    findElementByText('button', 'I am back') ||
                    findElementByText('button', 'Back') ||
                    findElementByText('input', 'I\'m back') ||
                    findElementByText('input', 'Back') ||
                    findElementByText('a', 'I\'m back') ||
                    findElementByText('a', 'Back');
      }

      // Method 3: Look for any clickable element with "back" text
      if (!backButton) {
        var allElements = document.querySelectorAll('*');
        for (var i = 0; i < allElements.length; i++) {
          var element = allElements[i];
          var text = (element.textContent || element.innerText || '').toLowerCase().trim();
          if ((text === 'i\'m back' || text === 'back' || text === 'i am back') && (element.tagName === 'BUTTON' || element.tagName === 'INPUT' || element.tagName === 'A' || element.onclick || element.style.cursor === 'pointer')) {
            backButton = element;
            break;
          }
        }
      }

      // Method 4: Look for buttons in modal dialogs
      if (!backButton) {
        var modals = document.querySelectorAll('.modal, [role="dialog"], .popup, .dialog');
        for (var j = 0; j < modals.length; j++) {
          var modalDialog = modals[j];
          if (modalDialog.style.display !== 'none' && modalDialog.offsetParent !== null) {
            var modalButtons = modalDialog.querySelectorAll('button, input[type="button"], input[type="submit"], a');
            for (var k = 0; k < modalButtons.length; k++) {
              var btn = modalButtons[k];
              var btnText = (btn.textContent || btn.value || btn.innerText || '').toLowerCase().trim();
              if (btnText.includes('back') || btnText.includes('i\'m') || btnText.includes('ok') || btnText.includes('continue')) {
                backButton = btn;
                break;
              }
            }
            if (backButton) break;
          }
        }
      }

      if (backButton) {
        /* eslint-disable no-console */
        console.log('[BrightPattern] Found back button:', backButton);
        console.log('[BrightPattern] Button text:', backButton.textContent || backButton.value);
      }

      if (backButton) {
        /* eslint-disable no-console */
        console.log('[BrightPattern] Auto-clicking session back button');
        try {
          // Try multiple click methods
          if (backButton.click) {
            backButton.click();
          } else if (backButton.onclick) {
            backButton.onclick();
          } else {
            // Create and dispatch a click event
            var clickEvent = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true
            });
            backButton.dispatchEvent(clickEvent);
          }
          /* eslint-disable no-console */
          console.log('[BrightPattern] Session sharing resolved successfully');
          // Also try to close any modal overlays
          setTimeout(function() {
            var overlays = document.querySelectorAll('.modal-backdrop, .overlay, [class*="backdrop"]');
            for (var l = 0; l < overlays.length; l++) {
              if (overlays[l].style.display !== 'none') {
                overlays[l].style.display = 'none';
              }
            }
          }, 500);
        } catch (e) {
          /* eslint-disable no-console */
          console.error('[BrightPattern] Error clicking back button:', e);
        }
      } else {
        /* eslint-disable no-console */
        console.warn('[BrightPattern] Could not find "I\'m back" button');
        // Try to close any visible modals as fallback
        var visibleModals = document.querySelectorAll('.modal, [role="dialog"], .popup');
        for (var m = 0; m < visibleModals.length; m++) {
          var modalElement = visibleModals[m];
          if (modalElement.style.display !== 'none' && modalElement.offsetParent !== null) {
            /* eslint-disable no-console */
            console.log('[BrightPattern] Attempting to close modal:', modalElement);
            modalElement.style.display = 'none';
          }
        }
      }
    }

    // Set up message listener for Agent Desktop communication
    function setupAgentDesktopMessageListener() {
      /* eslint-disable no-console */
      console.log('[BrightPattern] Setting up Agent Desktop message listener...');
      window.addEventListener('message', function(event) {
        try {
          var message = JSON.parse(event.data);
          console.log('[BrightPattern] Received message from Agent Desktop:', message);
          // Handle call status updates from Agent Desktop
          if (message.type === 'CALL_STATUS') {
            console.log('[BrightPattern] Call status update:', message.status);
            vm.callStatus = message.status;
            vm.callStatusMessage = message.message || 'Call status updated';
            if (message.status === 'connected') {
              vm.callStartTime = new Date();
            } else if (message.status === 'ended') {
              vm.callEndTime = new Date();
            }
          }
          // Handle call events from Agent Desktop
          if (message.type === 'CALL_EVENT') {
            console.log('[BrightPattern] Call event from Agent Desktop:', message.event);
            log(message);
          }
        } catch (e) {
          // Ignore non-JSON messages
        }
      });
    }

    // Initialize BrightPattern ServicePattern SDK
    function initializeBrightPatternSDK() {
      /* eslint-disable no-console */
      console.log('[BrightPattern] Initializing ServicePattern SDK...');
      // Detect if we're running inside Agent Desktop
      var isInAgentDesktop = window.parent !== window && window.parent.location.href.includes('agentdesktop');
      if (isInAgentDesktop) {
        /* eslint-disable no-console */
        console.log('[BrightPattern] Running inside Agent Desktop - using parent communication only');
        // Set up message listener for Agent Desktop communication
        setupAgentDesktopMessageListener();
        // Handle session sharing issues
        handleSessionSharing();
        return;
      }
      // Set up message listener for Agent Desktop communication
      setupAgentDesktopMessageListener();
      if (window.bpspat && window.bpspat.api) {
        /* eslint-disable no-console */
        console.log('[BrightPattern] bpspat.api found, initializing...');
        try {
          // Handle session sharing issues before initialization
          handleSessionSharing();

          window.bpspat.api.init('https://telecomincdev.brightpattern.com');
          /* eslint-disable no-console */
          console.log('[BrightPattern] ServicePattern SDK initialized successfully');
          // Add all event handlers
          window.bpspat.api.addAgentLoginHandler(log);
          window.bpspat.api.addStatusChangeHandler(log);
          window.bpspat.api.addInteractionRenderedHandler(log);
          window.bpspat.api.addInteractionCompletedHandler(log);
          window.bpspat.api.addInboundCallOfferedHandler(log);
          window.bpspat.api.addInboundCallAnsweredHandler(log);
          window.bpspat.api.addOutboundCallDialingHandler(log);
          window.bpspat.api.addOutboundCallConnectedHandler(log);
          window.bpspat.api.addCallEndedHandler(log);
          window.bpspat.api.addCallHoldedHandler(log);
          window.bpspat.api.addCallResumedHandler(log);
          window.bpspat.api.addBlindTransferHandler(log);
          window.bpspat.api.addConsultTransferHandler(log);
          window.bpspat.api.addCallRecordingStatusHandler(log);
          window.bpspat.api.addScreenRecordingStatusHandler(log);
          /* eslint-disable no-console */
          console.log('[BrightPattern] All event handlers registered successfully');
        } catch (e) {
          /* eslint-disable no-console */
          console.error('[BrightPattern] Failed to initialize ServicePattern SDK:', e);
        }
      } else {
        /* eslint-disable no-console */
        console.log('[BrightPattern] bpspat.api not found, retrying...');
        setTimeout(initializeBrightPatternSDK, 1000);
      }
    }
    // Initialize BrightPattern when view loads
    $scope.$on('$viewContentLoaded', function() {
      $timeout(function() {
        // Extract access token from URL
        extractAccessToken();

        // Set up session sharing popup handler
        handleSessionSharingPopup();

        // Initialize SDK
        initializeBrightPatternSDK();
      }, 1000); // Wait 1 second for scripts to load
    });
  }
})();
(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Billing.Controller', BillingController);

  /** @ngInject */
  function BillingController($log, $scope, $routeParams, OrgBillingService, OrganizationService, FormValidationService, StateService, MessageBoxService) {
    var vm = this;
    vm.name = 'Billing Info';
    vm.orgID = $routeParams.orgID;
    vm.billingTypes = ['Bank Account', 'Credit Card'];
    vm.bankAccountTypes = ['CHECKING', 'SAVINGS', 'BUSINESS'];
    vm.billing = {};

    //regex patterns for validation
    vm.ePattern = FormValidationService.GetEmailPattern();
    vm.phPattern = FormValidationService.GetPhonePattern();
    vm.zPattern = FormValidationService.GetZipPattern();
    vm.rPattern = FormValidationService.GetRoutingPattern();
    vm.aPattern = FormValidationService.GetAccountNoPattern();
    vm.cPattern = FormValidationService.GetCardNoPattern();
    vm.cvcPattern = FormValidationService.GetCvcPattern();

    vm.loadData = function() {
      OrgBillingService.load(function() {
        vm.billing = OrgBillingService.get();
        vm.billing.expDate = undefined;
      });
    }

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function( ) {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }


    vm.Update = function( ) {

    }

    vm.Remove = function( ) {
      OrgBillingService.delete(function() {
        $scope.$apply();
      });
    }

    vm.SetUp = function(isValid) {
      if (isValid) {
        OrgBillingService.register(function(error) {
          if ( error ) {
            MessageBoxService.open('Billing Error', error, 'Continue', function() { });
          } else {

            OrganizationService.setState('billing', function() {
              StateService.go('ratefee');
            });
          }
        });
      }
    }

    vm.Back = function() {
      StateService.go('setup');
    }

    vm.ClickContinue = function() {
      StateService.go('ratefee');
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {

    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('ApptSelect.Controller', ApptSelectController);

  /** @ngInject */
  function ApptSelectController($scope, $routeParams, $log, $uibModal, ApptService, OrganizationService, OrgUserService, StateService) {
    var vm = this;
    vm.name = 'Appointment Template Selection Page';
    vm.list = [];
    vm.orgID = $routeParams.orgID;

    vm.sorts = [
      'sort type A',
      'sort type B',
      'sort type C'];

    vm.currentSort = vm.sorts[0];

    vm.Nav = function(page) {
      StateService.go(page);
    }

    vm.loadData = function() {
      OrgUserService.dbLoadMyUser(['appointmentaccess'], function(error) {
        if ( error ) {

          return;
        }
        ApptService.load('appointment', function() {
          ApptService.clear();
          vm.list = ApptService.getTemplates('appointment');
        });
      });
    }

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.onCreate = function() {
      ApptService.newTemplate('new template', 'template', 'appointment', function(error, data) {
        StateService.go('apptedit', data.id);
      });
    }

    vm.onSelect = function(data) {
      vm.data = data;
      vm.popup = $uibModal.open({
        templateUrl: 'app/popups/templateconfirm/templateconfirm.html',
        controller: 'TemplateConfirm.Controller',
        windowClass: 'template-box',
        scope: $scope
      });
    }

    vm.onDone = function() {
      vm.popup.close();
      ApptService.clone(vm.data, 'book', 'appointment', function(error, data) {
        if (error == null && data) {
          StateService.go('apptedit', data.id);
        }
      });
    }

    vm.onCancel = function() {
      vm.popup.close();
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      if ( vm.popup ) vm.popup.close();
    });
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('ApptSchedule.Controller', ApptScheduleController);

  /** @ngInject */
  function ApptScheduleController($scope, $rootScope, $window, $interval, $log, $timeout, $routeParams, $document, OrganizationService, OrgUserService, OrgCatService, StateService, ApptService) {
    var vm = this;
    vm.name = 'Appointment Schedule ';
    vm.tempID = $routeParams.tempID;
    vm.orgID = $routeParams.orgID;

    var d = new Date();
    vm.date = d;
    vm.monthList = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];

    vm.days = [
      {name:'Sun', id:0, date:''},
      {name:'Mon', id:1, date:''},
      {name:'Tue', id:2, date:''},
      {name:'Wed', id:3, date:''},
      {name:'Thu', id:4, date:''},
      {name:'Fri', id:5, date:''},
      {name:'Sat', id:6, date:''}
    ];

    vm.yearList = [];

    var i = 0, number = 0;

    for ( i = 0; i < 20; i++)
      vm.yearList.push( (vm.date.getFullYear() + i).toString() );

    vm.cellHeight = 10;
    vm.cellWidth = 80;

    vm.month = vm.monthList[d.getMonth()];
    vm.year = d.getFullYear().toString();
    vm.times = [];

    for ( i = 0; i <= 11; i++) {
      number = i;
      if (number == 0) number = 12
      vm.times.push({name:number.toString() + 'AM',
        style:{},
        cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)'
        }, id:vm.times.length});
      vm.times.push({name:'',
        style:{},
        cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)',
          borderBottom:'1px solid rgb( 200, 200, 200)'
        }, id:vm.times.length});
      vm.times.push({name:'',
        style:{},
        cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)'
        }, id:vm.times.length});
      vm.times.push({name:'',
        style:{
          borderBottom:'1px solid rgb( 130, 130, 130)'
        }, cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)',
          borderBottom:'1px solid rgb( 130, 130, 130)'
        }, id:vm.times.length});
    }

    for ( i = 0; i <= 11; i++) {
      number = i;
      if (number == 0) number = 12
      vm.times.push({name:number.toString() + 'PM',
        style:{},
        cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)'
        }, id:vm.times.length});
      vm.times.push({name:'',
        style:{},
        cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)',
          borderBottom:'1px solid rgb( 200, 200, 200)'
        }, id:vm.times.length});
      vm.times.push({name:'',
        style:{},
        cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)'
        }, id:vm.times.length});
      vm.times.push({name:'',
        style:{
          borderBottom:'1px solid rgb( 130, 130, 130)'
        },
        cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)',
          borderBottom:'1px solid rgb( 130, 130, 130)'
        }, id:vm.times.length});
    }

    vm.waitingUserList = [];
    vm.attendeeUserList = [];
    vm.currentUser = null;
    vm.users = [];
    vm.selectedItem = '';
    vm.searchText = '';
    vm.curWeek = {};
    vm.floatObject = {};

    vm.switch = function() {
      StateService.go('apptavailable', vm.tempID);
    }

    $document.on('keydown', handleKeyDown);
    function handleKeyDown(e) {
      e = e || $window.event;
      if (e.keyCode === 46) vm.deleteUser();
    }

    vm.deleteUser = function() {
      vm.floatObject.style.display = 'none';
      vm.currentUser = null;
    }

    vm.getUser = function(list, data) {
      if ( vm.currentUser ) {
        // if a group add all users
        if ( vm.currentUser.group ) {
          vm.currentUser.group.forEach(function(user) {
            if ( list.indexOf(user) < 0)
              list.push(user);
          });
        }
        vm.currentUser = null;
      } else {

        if ( list == vm.waitingUserList ) {
          ApptService.deleteFromWaitingList([data.id], function(error) {
            if (error == null) {
              i = list.indexOf(data);
              list.splice(i, 1);
              vm.currentUser = {name:data.name, group:[data]};
            }
          });
        } else {
          i = list.indexOf(data);
          list.splice(i, 1);
          vm.currentUser = {name:data.name, group:[data]};
        }
      }
    }

    vm.adjustList = function() {
      if ( vm.currentUser ) {
        // if a group add all users
        if ( vm.currentUser.group ) {
          var list = [];
          vm.currentUser.group.forEach(function(user) {
            list.push(user.id);
          });
          ApptService.addToWaitingList(list, function(error) {
            if (error == null) {
              vm.currentUser.group.forEach(function(user) {
                if ( vm.waitingUserList.indexOf(user) < 0)
                  vm.waitingUserList.push(user);
              });
              vm.currentUser = null;
            }
          });

        }
      } else {
        // no user
      }
    }

    vm.adjustAttendeeList = function() {
      if ( vm.currentUser ) {
        // if a group add all users
        if ( vm.currentUser.group ) {
          vm.currentUser.group.forEach(function(user) {
            if ( vm.attendeeUserList.indexOf(user) < 0)
              vm.attendeeUserList.push(user);
          });
        }
        vm.currentUser = null;
      } else if ( vm.attendeeUserList.length > 0 ) {
        // grap the entirelist
        var newlist = vm.attendeeUserList;
        vm.attendeeUserList = [];
        vm.currentUser = { name: newlist.length + ' attendee(s)', group: newlist};
      }
    }

    vm.selectUser = function(user) {
      if ( user ) {
        vm.currentUser = { name: user.name, group:[user] };
      } else {
        vm.currentUser = null;
      }
    }

    vm.getMatches = function(text) {
      var list = [];
      vm.users.forEach(function(user) {
        if ( user.name && user.name.toLowerCase().indexOf(text) == 0 )
          list.push(user);
      });
      return list;
    }

    vm.setSlotsInRect = function(state, rtop, rleft, rheight, rwidth) {
      var posY = parseInt(rtop.replace('px', '')) / vm.cellHeight;
      var posX = (parseInt(rleft.replace('px', '')) - vm.cellWidth) / vm.cellWidth;
      var width = parseInt(rwidth.replace('px', '')) / vm.cellWidth;
      var height = parseInt(rheight.replace('px', '')) / vm.cellHeight;

      for (var x = 0; x < width; x++) {
        for (var y = 0; y < height; y++) {
          var obj = vm.__getSlot(posX + x, posY + y);
          obj.state = state;
        }
      }
    }

    vm.canPlaceTime = function(idx, idy) {
      var x = idx.id;
      for ( var y = idy.id; y < idy.id + vm.userTimeSize; y++) {
        if (vm.__getSlot(x, y).state != 0 )
          return false;
      }
      return true;
    }

    vm.resetSlots = function(week) {
      vm.slots = [];
      var style = false;
      for ( i = 0; i < vm.days.length * vm.times.length; i++ ) {
        vm.slots.push({state:0, id:i});
      }
      // mark unavailable
      for ( i = 0; i < week.unavailable.length; i++ ) {
        style = week.unavailable[i].style;
        vm.setSlotsInRect(1, style.top, style.left, style.height, style.width);
      }
      // mark user objects
      for ( i = 0; i < week.userObjects.length; i++ ) {
        style = week.userObjects[i].style;
        vm.setSlotsInRect(1, style.top, style.left, style.height, style.width);
      }
    }

    vm._convertTimeToObject = function(startDate, endDate ) {
      var day = startDate.getDay();
      var start = (startDate.getHours()) * 4 + (startDate.getMinutes() / 15);
      var end = (endDate.getHours()) * 4 + (endDate.getMinutes() / 15);

      var style = {
        display:'block',
        height:((end - start) * vm.cellHeight) + 'px',
        left:(vm.cellWidth + day * vm.cellWidth) + 'px',
        position:'absolute',
        top:(start * vm.cellHeight) + 'px',
        width:vm.cellWidth + 'px'
      }
      return style;
    }

    vm._convertObjectToTime = function( obj ) {

      var style = obj.style;
      var left = parseInt(style.left.replace('px', ''));
      var startTime = (parseInt(style.top.replace('px', '')) / vm.cellHeight * 15);
      var endTime = startTime + (parseInt(style.height.replace('px', '')) / vm.cellHeight * 15);
      var startDate = ((left) / vm.cellWidth) - 1;

      var start = ApptService.getSunday( new Date(vm.date) );
      start.setDate( start.getDate() + startDate );
      start.setHours(0, 0, 0, 0);
      start.setMinutes(startTime);

      var end = ApptService.getSunday( new Date(vm.date) );
      end.setDate( end.getDate() + startDate );
      end.setHours(0, 0, 0, 0);
      end.setMinutes(endTime);

      return {startdate:start, enddate:end, object:obj};
    }

    vm.loadData = function() {
      $log.debug('Load data');
      OrgUserService.dbLoadMyUser(['announcementaccess'], function(error) {
        if ( error ) {

          return;
        }
        OrgUserService.dbUserLoad(function() {
          OrgCatService.load(function() {
            ApptService.loadByID(vm.tempID, function() {

              $log.debug('Set Week');
              vm.groups = ApptService.getGroups();

              vm.waitingUserList = ApptService.getBook().waitingUserList;

              OrgUserService.getGroupListUsers(vm.groups, function() {

              });
              vm.userTimeSize = ApptService.getBook().appointmentlength / 15;

              vm.floatObject = {
                style: {'display':'none', 'position':'absolute', 'top':'0px', 'left':'0px', 'height':(vm.cellHeight * vm.userTimeSize) + 'px', 'width':vm.cellWidth + 'px'}
              };
              vm.data = ApptService.getBook();
              vm.setWeek();
              vm.users = OrgUserService.dbGet();
              $timeout(function() {
                $rootScope.$emit('page.ready');
              }, 100);

            });
          });
        });
      });
    }

    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.setWeek = function() {
      // save current week
      //   ApptService.registerWeek(function(error){
    //    if( error == null ){

      var sunday = ApptService.getSunday( new Date(vm.date) );
      ApptService.loadWeek(sunday, function() {
        ApptService.loadWeekExtras(function() {
          vm.curWeek = ApptService.getWeek();
          var i = 0;
          for ( i = 0; i < vm.curWeek.unavailable.length; i++ ) {
            vm.curWeek.unavailable[i].style = vm._convertTimeToObject(
              vm.curWeek.unavailable[i].startdate,
              vm.curWeek.unavailable[i].enddate
            );
          }

          for ( i = 0; i < vm.curWeek.userObjects.length; i++ ) {
            vm.curWeek.userObjects[i].style = vm._convertTimeToObject(
              vm.curWeek.userObjects[i].startdate,
              vm.curWeek.userObjects[i].enddate
            );
          }

          for ( i = 0; i < vm.curWeek.reschedule.length; i++ ) {
            vm.curWeek.reschedule[i].style = vm._convertTimeToObject(
              vm.curWeek.reschedule[i].startdate,
              vm.curWeek.reschedule[i].enddate
            );
          }

          // set dates of the week
          for ( i = 0; i < vm.days.length; i++ ) {
            vm.days[i].date = (sunday.getMonth() + 1) + '/' + (sunday.getDate());
            sunday.setDate(sunday.getDate() + 1);
          }

          vm.resetSlots(vm.curWeek);

        })
      });
      //      }
      //     });
    }
    /*
    vm.setWeek = function(){
      // save current week
      ApptService.registerWeek(function(error){
        if( error == null ){

          var sunday = ApptService.getSunday( new Date(vm.date) );
          ApptService.loadWeek(sunday, function(error){
            if( error == null ){
              vm.curWeek = ApptService.getWeek();
              // set dates of the week
              for( var i = 0; i < vm.days.length; i++ ){
                vm.days[i].date = (sunday.getMonth()+1)+"/"+(sunday.getDate());
                sunday.setDate(sunday.getDate()+1);
              }

              vm.resetSlots(vm.curWeek);
            }
          });
        }
      });
    }*/

    vm.SelectToday = function() {
      vm.date = d;
      vm.setWeek();
    }

    vm.checkDate = function() {
      if ( vm.date < d) {
        vm.date = d;
      }
      vm.setWeek();
    }

    vm.Change = function() {
      vm.date = new Date( vm.month + ' 1, ' + vm.year);
      vm.setWeek();
    }

    vm.getSlot = function(idx, idy) {
      return vm.slots[ idy.id * vm.days.length + idx.id ];
    }

    vm.__getSlot = function(x, y) {
      if ( x < vm.days.length && y < vm.times.length ) {
        return vm.slots[ y * vm.days.length + x ];
      }

      return {state:-1, id:-1};
    }

    vm.touch = function(idx, idy) {

      if ( !vm.curWeek.id ) return;

      if ( vm.currentUser ) {
        vm.floatObject.style.display = 'block';
        var top = idy.id * vm.cellHeight;
        var left = idx.id * vm.cellWidth + vm.cellWidth;
        vm.floatObject.style.top = top + 'px';
        vm.floatObject.style.left = left + 'px';
        if ( vm.canPlaceTime(idx, idy) ) {
          vm.floatObject.style.backgroundColor = 'rgba(100,100,255,1)';
        } else {
          vm.floatObject.style.backgroundColor = 'rgba(255,255,255,1)';
        }
      }
    }

    vm.click = function(idx, idy) {

      if ( !vm.curWeek.id ) return;

      if ( vm.currentUser != null && vm.floatObject.style.display != 'none' && vm.canPlaceTime(idx, idy) ) {
        var top = idy.id * vm.cellHeight;
        var left = idx.id * vm.cellWidth + vm.cellWidth;
        // create appointment
        var obj = {userobject: vm.currentUser, style: {position:'absolute', display:'block', top:top + 'px', left:left + 'px', height:(vm.userTimeSize * vm.cellHeight) + 'px', width:'80px'}};
        vm.curWeek.userObjects.push(obj);
        vm.setSlotsInRect(1, obj.style.top, obj.style.left, obj.style.height, obj.style.width);
        vm.floatObject.style.display = 'none';
        vm.currentUser = null;

        var data = vm._convertObjectToTime(obj);
        ApptService.addAppointment(data, function() {

        });
      }
    }

    vm.clickUserObject = function(obj) {
      if ( !vm.curWeek.id ) return;

      if ( vm.currentUser == null ) {

        ApptService.deleteAppointment(obj.id, function() {
          var i = vm.curWeek.userObjects.indexOf(obj);
          vm.curWeek.userObjects.splice(i, 1);
          vm.currentUser = obj.userobject;
          vm.setSlotsInRect(0, obj.style.top, obj.style.left, obj.style.height, obj.style.width);
        });
      }
    }

    vm.mouseLeave = function() {
      if ( !vm.curWeek.id ) return;
      vm.floatObject.style.display = 'none';
    }

    vm.onDone = function() {
      StateService.go('appointment');
    }

    vm.onAvailable = function() {
      StateService.go('apptavailable', vm.tempID)
    }

    vm.onSend = function() {
      if (vm.canContinue()) {
        StateService.go('appointment');
      }
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {

    });

    $scope.$on('$destroy', function UnLoaded() {
      if ( vm.popup ) vm.popup.close();
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('ApptEdit.Controller', ApptEditController);

  /** @ngInject */
  function ApptEditController($scope, $rootScope, $timeout, $routeParams, $document, ApptService, OrganizationService, OrgCatService, OrgUserService, StateService) {
    var vm = this;
    vm.name = 'Appointment Edit Page';
    vm.tempID = $routeParams.tempID;
    vm.orgID = $routeParams.orgID;

    vm.loadData = function() {
      OrgUserService.dbLoadMyUser(['appointmentaccess'], function(error) {
        if ( error ) {
          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
          return;
        }
        OrgUserService.dbUserLoad(function() {
          OrgCatService.load(function() {
            ApptService.loadByID(vm.tempID, function() {
              ApptService.loadExtras(function() {
                vm.data = ApptService.getBook();
                if ( vm.data ) {
                  $timeout(function() {
                    $rootScope.$emit('page.ready');
                    vm.isValid = true;
                  }, 100);
                }
              });
            });
          });
        });
      });
    }

    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.onUpdateData = function(data) {
      ApptService.set(data);
    }

    vm.onDone = function() {
      StateService.go('appointment');
    }

    vm.onSend = function() {
      StateService.go('appointment');
    }

    vm.onSchedule = function() {
      vm.data = ApptService.getBook();
      StateService.go('apptschedule', vm.data.id);
    }

    vm.onCalculate = function() {

    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {

    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Approval.Controller', ApprovalController);

  /** @ngInject */
  function ApprovalController($scope, $routeParams, $timeout, $rootScope, MsgService, OrganizationService, OrgUserService, StateService) {
    var vm = this;
    vm.name = 'Workflow Approval Page';
    vm.orgID = $routeParams.orgID;

    vm.tabs = [
      {name:'ALL', list: [], status: 'pending', id: '0'},
      {name:'Announcements', list: [], status: 'pending', id: '1', callback: function() { vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[1].list); }},
      {name:'Advertisements', list: [], status: 'pending', id: '2', callback: function() { vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[2].list); }},
      {name:'Appointments', list: [], status: 'pending', id: '3', callback: function() { vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[3].list); }}
    ];

    vm.loadData = function() {
      OrgUserService.dbLoadMyUser([], function() {
        MsgService.loadApproval( function() {
          vm.Update();
          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
        });
      });
    };

    vm.Update = function() {
      var total = [];

      vm.tabs.forEach(function(tab) {
        tab.list = [];
      });

      if ( OrgUserService.dbGetMyPermissions('workflowaccess') ) {

        var list = MsgService.getApproval('announcement');
        if ( list && list.length > 0 ) {
          vm.tabs[1].list = list;
          total = total.concat(list);
          vm.tabs[1].callback();
        }

        list = MsgService.getApproval('advertisement');
        if ( list && list.length > 0 ) {
          vm.tabs[2].list = list;
          total = total.concat(list);
          vm.tabs[2].callback();
        }

        list = MsgService.getApproval('appointment');
        if ( list && list.length > 0 ) {
          vm.tabs[3].list = list;
          total = total.concat(list);
          vm.tabs[3].callback();
        }

        vm.ready = true;
      }

      if ( total.length === 0) {
        StateService.go('dashboard');
      }

    };

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.onUpdateMessage = function(data) {
      MsgService.updateMessage(data, function() {

      });
    };

    vm.onApprove = function(data) {
      MsgService.setCurrent(data);
      MsgService.register(function(error) {
        if ( error === null ) {
          MsgService.send(null, function(error) {
            if ( error === null ) {
              vm.loadData();
            }
          });
        }
      });
    };

    vm.onAdminEdit = function(data) {
      var next = '';
      if ( data.type === 'alert' ) next = 'alertedit';
      else if ( data.type === 'announcement' ) next = 'announcedit';
      else if ( data.type === 'advertisement' ) next = 'adedit';

      data.status = 'pending';
      MsgService.setCurrent(data);
      MsgService.register(function(error) {
        if ( error === null ) {
          StateService.go(next, data.id);
        }
      });
    };

    vm.onReject = function(data) {
      MsgService.setCurrent(data);
      data.status = 'rejected';
      MsgService.register(function(error) {
        if ( error === null ) {
          vm.Update();
        }
      });
    };

    vm.Next = function() {
      StateService.go('dashboard');
    };

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('ApptAvailable.Controller', ApptAvailableController);

  /** @ngInject */
  function ApptAvailableController($scope, $rootScope, $interval, $log, $timeout, $routeParams, $document, OrganizationService, ScheduleService, OrgUserService, OrgCatService, StateService, ApptService) {
    var vm = this;
    vm.name = 'Available Schedule';
    vm.tempID = $routeParams.tempID;
    vm.orgID = $routeParams.orgID;

    var d = new Date();
    vm.date = d;
    vm.monthList = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];

    vm.days = [
      {name:'Sun', id:0, date:''},
      {name:'Mon', id:1, date:''},
      {name:'Tue', id:2, date:''},
      {name:'Wed', id:3, date:''},
      {name:'Thu', id:4, date:''},
      {name:'Fri', id:5, date:''},
      {name:'Sat', id:6, date:''}
    ];

    vm.yearList = [];
    var i = 0, number = 0;

    for ( i = 0; i < 20; i++)
      vm.yearList.push( (vm.date.getFullYear() + i).toString() );

    vm.month = vm.monthList[d.getMonth()];
    vm.year = d.getFullYear().toString();
    vm.times = [];

    for ( i = 0; i <= 11; i++) {
      number = i;
      if (number == 0) number = 12
      vm.times.push({name:number.toString() + 'AM',
        style:{},
        cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)'
        }, id:vm.times.length});
      vm.times.push({name:'',
        style:{},
        cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)',
          borderBottom:'1px solid rgb( 200, 200, 200)'
        }, id:vm.times.length});
      vm.times.push({name:'',
        style:{},
        cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)'
        }, id:vm.times.length});
      vm.times.push({name:'',
        style:{
          borderBottom:'1px solid rgb( 130, 130, 130)'
        }, cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)',
          borderBottom:'1px solid rgb( 130, 130, 130)'
        }, id:vm.times.length});
    }

    for ( i = 0; i <= 11; i++) {
      number = i;
      if (number == 0) number = 12
      vm.times.push({name:number.toString() + 'PM',
        style:{},
        cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)'
        }, id:vm.times.length});
      vm.times.push({name:'',
        style:{},
        cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)',
          borderBottom:'1px solid rgb( 200, 200, 200)'
        }, id:vm.times.length});
      vm.times.push({name:'',
        style:{},
        cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)'
        }, id:vm.times.length});
      vm.times.push({name:'',
        style:{
          borderBottom:'1px solid rgb( 130, 130, 130)'
        },
        cell:{
          borderLeft:'1px solid rgb( 200, 200, 200)',
          borderBottom:'1px solid rgb( 130, 130, 130)'
        }, id:vm.times.length});
    }

    vm.dragObject = { style: { display:'none', position:'absolute', top:'0', left:'0', height:'0px', width:'0px'}};
    vm.cellHeight = 10;
    vm.cellWidth = 80;
    vm.curWeek = {};

    vm.switch = function() {
      StateService.go('apptschedule', vm.tempID);
    }

    vm.removeUnavailable = function(u) {
      ApptService.deleteUnavailable(u.id, function(error) {
        if ( error == null ) {
          var i = vm.curWeek.unavailable.indexOf(u);
          vm.curWeek.unavailable.splice(i, 1);
        }
      });
    }

    vm.reSlotsCount = 0;
    vm.reSlots = [
      0, 1, 2, 3, 4
    ];
    vm.reSlotTimes = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, //am
      12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23//pm
    ];

    vm.getReSlotTime = function(time) {

      var simple = time;
      if ( time >= 13 ) simple = time - 12;
      if ( time == 0) simple = 12;
      var next = time + 1;
      if ( next >= 13 ) next = next - 12;
      return (simple.toString() + '-' + next.toString() + ((time >= 12) ? ' pm' : ' am') );
    }

    vm.ChangeReSlots = function() {
      if ( !vm.curWeek.id ) return;

      var list = [];
      var timeObjects = [];
      for (var i = 0; i < vm.reSlotsCount; i++) {
        list.push( vm.curWeek.reSlotObjects[i] );

        var start = ApptService.getSunday( new Date(vm.date) );
        start.setHours( vm.curWeek.reSlotObjects[i].time, 0, 0, 0 );
        var end = ApptService.getSunday( new Date(vm.date) );
        end.setHours( parseInt(vm.curWeek.reSlotObjects[i].time) + 1, 0, 0, 0 );

        timeObjects.push( { starttime:start, endtime:end } );

      }
      vm.curWeek.rescheduledata = angular.toJson(list);//JSON.stringify(list);

      ApptService.updateReschedule(timeObjects, function() {

        for ( var i = 0; i < vm.curWeek.reschedule.length; i++ ) {
          vm.curWeek.reschedule[i].style = vm._convertTimeToObject(
            vm.curWeek.reschedule[i].startdate,
            vm.curWeek.reschedule[i].enddate
          );
        }
      });

    }

    vm.setupReSlots = function() {
      var i = 0;

      //var timezone = new Date().getTimezoneOffset()/60;
      if ( vm.curWeek.rescheduledata ) {

        vm.curWeek.reSlotObjects = angular.fromJson(vm.curWeek.rescheduledata);//JSON.parse( vm.curWeek.rescheduledata );
        vm.reSlotsCount = vm.curWeek.reSlotObjects.length;
        for (i = vm.curWeek.reSlotObjects.length; i < 4; i++) {
          vm.curWeek.reSlotObjects.push( {name:'Rescheduling Slot ' + (i + 1), time:0} );
        }

      } else {

        vm.reSlotsCount = 0;
        vm.curWeek.reSlotObjects = [];
        for (i = 0; i < 4; i++) {
          vm.curWeek.reSlotObjects.push( {name:'Rescheduling Slot ' + (i + 1), time:0
          } );
        }
      }
    }

    vm.setReTime = function() {

      vm.ChangeReSlots();
    }

    vm.loadData = function() {
      OrgUserService.dbLoadMyUser(['announcementaccess'], function(error) {
        if ( error ) {
          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
          return;
        }
        OrgCatService.load(function() {
          ApptService.loadByID(vm.tempID, function() {

            vm.data = ApptService.getBook();
            vm.setWeek();
            $timeout(function() {
              $rootScope.$emit('page.ready');
            }, 100);

          });
        });
      });
    }

    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm._convertTimeToObject = function(startDate, endDate ) {
      var localStart = new Date(startDate);
      var localEnd = new Date(endDate);
      var day = localStart.getDay();
      var start = (localStart.getHours()) * 4 + (localStart.getMinutes() / 15);
      var length = Math.abs(localStart - localEnd);
      length = Math.floor(length / 1000 / 60 / 15);
      //var end = (localEnd.getHours())*4+(localEnd.getMinutes()/15);

      var style = {
        display:'block',
        height:((length) * vm.cellHeight) + 'px',
        left:(vm.cellWidth + day * vm.cellWidth) + 'px',
        position:'absolute',
        top:(start * vm.cellHeight) + 'px',
        width:vm.cellWidth + 'px'
      }
      return style;
    }

    vm.setWeek = function() {
      var sunday = ApptService.getSunday( new Date(vm.date) );
      ApptService.loadWeek(sunday, function() {
        ApptService.loadWeekExtras(function() {
          vm.curWeek = ApptService.getWeek();
          vm.setupReSlots();
          var i = 0;
          for ( i = 0; i < vm.curWeek.unavailable.length; i++ ) {
            vm.curWeek.unavailable[i].style = vm._convertTimeToObject(
              vm.curWeek.unavailable[i].startdate,
              vm.curWeek.unavailable[i].enddate
            );
          }

          for ( i = 0; i < vm.curWeek.reschedule.length; i++ ) {
            vm.curWeek.reschedule[i].style = vm._convertTimeToObject(
              vm.curWeek.reschedule[i].startdate,
              vm.curWeek.reschedule[i].enddate
            );
          }

          // set dates of the week
          for ( i = 0; i < vm.days.length; i++ ) {
            vm.days[i].date = (sunday.getMonth() + 1) + '/' + (sunday.getDate());
            sunday.setDate(sunday.getDate() + 1);
          }
        })
      });
    }

    vm.SelectToday = function() {
      vm.date = d;
      vm.setWeek();
    }

    vm.checkDate = function() {
      if ( vm.date < d) {
        vm.date = d;
      }
      vm.setWeek();
    }

    vm.Change = function() {
      vm.date = new Date( vm.month + ' 1, ' + vm.year);
      vm.setWeek();
    }

    vm.canContinue = function()
    {
      return ( ScheduleService.getList().length > 0 );
    }

    vm.currsorDown = false;
    vm.posY = 0;
    vm.posX = 0;
    vm.offsetX = 0;
    vm.offsetY = 0;

    vm.select = function(idx, idy, event) {
      if ( !vm.curWeek.id ) return;

      if ( !vm.currsorDown ) {
        vm.offsetX = event.offsetX;
        vm.offsetY = event.offsetY;
        var top = (idy.id * vm.cellHeight);
        var left = (idx.id * vm.cellWidth + vm.cellWidth);
        vm.dragObject.style.top = top + 'px';
        vm.dragObject.style.left = left + 'px';
        vm.dragObject.style.height = vm.cellHeight + 'px';
        vm.dragObject.style.width = vm.cellWidth + 'px';
        vm.dragObject.style.display = 'block';
      }
      vm.currsorDown = true;
    }

    vm.mouseSelect = function(event) {
      if ( !vm.curWeek.id ) return;

      var scroll = $document[0].getElementById('gridScroll');
      vm.posY = event.clientY + scroll.scrollTop;
      vm.posX = event.clientX;
    }

    vm._convertObjectToTime = function( obj ) {

      var style = obj.style;
      var left = parseInt(style.left.replace('px', ''));
      var startTime = (parseInt(style.top.replace('px', '')) / vm.cellHeight * 15);
      var endTime = startTime + (parseInt(style.height.replace('px', '')) / vm.cellHeight * 15);
      var startDate = ((left) / vm.cellWidth) - 1;

      var start = ApptService.getSunday( new Date(vm.date) );
      start.setDate( start.getDate() + startDate );
      start.setHours(0, 0, 0, 0);
      start.setMinutes(startTime);

      var end = ApptService.getSunday( new Date(vm.date) );
      end.setDate( end.getDate() + startDate );
      end.setHours(0, 0, 0, 0);
      end.setMinutes(endTime);

      return {startdate:start, enddate:end, object:obj};
    }

    vm.mouseRelease = function() {

      if ( !vm.curWeek.id ) return;

      vm.currsorDown = false;

      if ( vm.dragObject.style.display == 'none' )
        return;

      var days = parseInt(vm.dragObject.style.width.replace('px', '')) / vm.cellWidth;
      var left = parseInt(vm.dragObject.style.left.replace('px', ''));
      var list = [];

      //break up by day
      for ( var i = 0; i < days; i++ ) {

        var newObj = {};
        for (var attrname in vm.dragObject.style) {
          newObj[attrname] = vm.dragObject.style[attrname];
        }
        newObj.width = vm.cellWidth + 'px';
        newObj.left = (left + (vm.cellWidth * i)) + 'px';

        var obj = {style:newObj};
        vm.curWeek.unavailable.push(obj);
        list.push( vm._convertObjectToTime( obj ) );

      }
      vm.dragObject.style.display = 'none';
      ApptService.addUnavailable(list, function() {

      });
    }

    vm.mouseMove = function(event) {

      if ( !vm.curWeek.id ) return;

      if ( vm.currsorDown ) {
        var scroll = $document[0].getElementById('gridScroll');
        var height = event.clientY - vm.posY + vm.offsetY + scroll.scrollTop;
        var width = event.clientX - vm.posX + vm.offsetX;

        height = (Math.floor(height / vm.cellHeight) + 1) * vm.cellHeight;
        width = (Math.floor(width / vm.cellWidth) + 1) * vm.cellWidth;

        vm.dragObject.style.height = height + 'px';
        vm.dragObject.style.width = width + 'px';
      }
    }

    vm.mouseLeave = function() {
      if ( !vm.curWeek.id ) return;

      vm.currsorDown = false;
      vm.dragObject.style.display = 'none';
    }

    vm.onDone = function() {
      StateService.go('appointment');
    }

    vm.onSchedule = function() {
      StateService.go('apptschedule', vm.tempID);
    }

    vm.onSend = function() {
      if (vm.canContinue()) {
        StateService.go('appointment');
      }
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {

    });

    $scope.$on('$destroy', function UnLoaded() {
      if ( vm.popup ) vm.popup.close();
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Appointment.Controller', AppointmentController);

  /** @ngInject */
  function AppointmentController($scope, $routeParams, $timeout, $rootScope, $log, ApptService, OrganizationService, UserService, OrgUserService, OrgReportService, StateService, IndTypeService, MessageBoxService) {
    var vm = this;
    vm.name = 'Appointment Page';
    vm.orgID = $routeParams.orgID;
    vm.list = [];
    vm.sorts = [
      'sort type A',
      'sort type B',
      'sort type C'];

    vm.currentSort = vm.sorts[0];

    vm.loadData = function() {
      UserService.load(function() {
        IndTypeService.load(null, function() {
          OrgUserService.dbLoadMyUser(['appointmentaccess'], function(error) {
            ApptService.clear();
            MessageBoxService.open('Permission Error', 'You do not have permission to view this page.', 'Continue', function() {
              StateService.go('dashboard');
            });
            if ( error ) {
              $timeout(function() {
                $rootScope.$emit('page.ready');
              }, 100);
              return;
            }
            ApptService.load('appointment', function(error) {
              if (error == null) {
                vm.list = ApptService.getAll('appointment');
                vm.super = (UserService.isAdmin() && OrganizationService.get().superorg);
                OrgReportService.loadMsgReports( vm.list, function() {
                  vm.reports = OrgReportService.getMsgReports();
                  for (var i = 1; i < vm.list.length; i++) {
                    if ( vm.list[i].status != 'template')
                      vm.list[i].report = vm.reports[i];
                  }
                  $timeout(function() {
                    $rootScope.$emit('page.ready');
                  }, 100);
                });
              }
            });
          });
        });
      });
    }

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.onNewMSG = function(data) {
      ApptService.clone(data, 'book', 'appointment', function(error, data) {
        if (error == null ) {
          StateService.go('apptedit', data.id);
        }
      });
    }

    vm.onClone = function(data) {
      var status = (data.status == 'template') ? 'template' : 'book';
      ApptService.clone(data, status, 'appointment', function(error, data) {
        if (error == null ) {
          StateService.go('apptedit', data.id);
        }
      });
    }

    vm.onUpdateMessage = function(data) {
      ApptService.updateMessage(data, function() {

      });
    }

    vm.onDelete = function(data) {
      ApptService.delete(data, function() {
        vm.loadData();
      });
    }

    vm.onTemplatePicker = function() {
      StateService.go('apptselect');
    }

    vm.onUpload = function() {

    }

    vm.onEdit = function(data) {
      ApptService.setCurrent(data);
      var status = (data.status == 'template') ? 'template' : 'ready';
      data.status = status;
      StateService.go('apptedit', data.id);
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();
(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AnnouncSelect.Controller', AnnouncSelectController);

  /** @ngInject */
  function AnnouncSelectController($scope, $routeParams, $timeout, $rootScope, $log, $uibModal, MsgService, OrganizationService, UserService, OrgUserService, OrgReportService, StateService, MessageBoxService) {
    var vm = this;
    vm.name = 'Announcement Template Selection Page';
    vm.orgID = $routeParams.orgID;
    vm.ready = false;
    vm.tabs = [
      {name:'ALL TEMPLATES', list: [], status: 'template', id: '1', callback: function(result) {
        vm.tabs[1].list = result.data;
        MsgService.getAllTemplates('announcement', function(error, data) {
          vm.tabs[0].list = data;
          vm.ready = true;
          $rootScope.$emit('page.ready');
        });
      }},
      {name:'MY TEMPLATES', list: [], id: '0'}];

    vm.Nav = function(page) {
      StateService.go(page);
    }

    vm.loadData = function() {
      UserService.load(function() {
        OrgUserService.dbLoadMyUser(['announcementaccess'], function(error) {
          if ( error ) {
            MessageBoxService.open('Permission Error', 'You do not have permission to view this page.', 'Continue', function() {
              StateService.go('dashboard');
            });
            $timeout(function() {
              $rootScope.$emit('page.ready');
            }, 100);
            return;
          }

          vm.super = (UserService.isAdmin() && OrganizationService.get().superorg);
          MsgService.clear();
          MsgService.getAllTypes('announcement', vm.tabs, function() {});

        });
      });
    }

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.onCreate = function() {
      MsgService.newTemplate('new template', 'template', 'announcement', function(error, data) {
        if ( error == null ) {
          StateService.go('announcedit', data.id);
        }
      });
    }

    vm.onSelect = function(data) {
      vm.data = data;
      vm.popup = $uibModal.open({
        templateUrl: 'app/popups/templateconfirm/templateconfirm.html',
        controller: 'TemplateConfirm.Controller',
        windowClass: 'template-box',
        scope: $scope
      });
    }

    vm.onDone = function() {
      vm.popup.close();
      var status = 'ready';
      MsgService.clone(vm.data, status, 'announcement', function(error, data) {
        if (error == null && data) {
          StateService.go('announcedit', data.id);
        }
      });
    }

    vm.onCancel = function() {
      vm.popup.close();
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      if ( vm.popup ) vm.popup.close();
    });
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AnnouncSchedule.Controller', AnnouncScheduleController);

  /** @ngInject */
  function AnnouncScheduleController($scope, $rootScope, $timeout, $routeParams, $document, MsgService, OrganizationService, ScheduleService, OrgUserService, OrgCatService, StateService) {
    var vm = this;
    vm.name = 'Announcement Schedule ';
    vm.tempID = $routeParams.tempID;
    vm.orgID = $routeParams.orgID;

    vm.loadData = function() {
      OrgUserService.dbLoadMyUser(['announcementaccess'], function(error) {
        if ( error ) {
          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
          return;
        }
        OrgCatService.load(function() {
          MsgService.loadByID(vm.tempID, function() {
            ScheduleService.load( vm.tempID, function() {
              vm.data = MsgService.get();
              $timeout(function() {
                $rootScope.$emit('page.ready');
              }, 100);
            });
          });
        });
      });
    }

    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.canContinue = function()
    {
      return ( ScheduleService.getList().length > 0 );
    }

    vm.onDone = function() {
      StateService.go('announcement');
    }

    vm.onSend = function() {
      if (vm.canContinue()) {
        StateService.go('announcement');
      }
    }

    vm.onCalculate = function() {
      if (vm.canContinue()) {
        StateService.go('announccalc', vm.data.id);
      }
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      if ( vm.popup ) vm.popup.close();
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Announcement.Controller', AnnouncementController);

  /** @ngInject */
  function AnnouncementController($scope, $timeout, $rootScope, $routeParams, $log, MsgService, ScheduleService, IndTypeService, OrganizationService, OrgUserService, OrgReportService, UserService, StateService, MessageBoxService) {
    var vm = this;
    vm.name = 'Announcement Page';
    vm.orgID = $routeParams.orgID;
    vm.ready = false;

    vm.tabs = [
      {name:'ALL', list: [], id: '0'},
      {name:'MY SENT MESSAGES', list: [], status: 'sent', id: '1', callback: function(result) { vm.tabs[1].list = result.data; vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[1].list); }},
      {name:'READY TO SEND', list: [], status: 'ready', id: '2', callback: function(result) { vm.tabs[2].list = result.data; vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[2].list); }},
      {name:'MY SAVED TEMPLATES', list: [], status: 'template', id: '3', callback: function(result) { vm.tabs[3].list = result.data; vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[3].list); }},
      {name:'NEEDS ATTENTION', list: [], status: 'rejected', id: '4', callback: function(result) { vm.tabs[4].list = result.data; vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[4].list); }},
      {name:'MY PENDING', list: [], status: 'pending', id: '5', callback: function(result) { vm.tabs[5].list = result.data; vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[5].list); }}
    ];

    vm.loadData = function() {
      vm.ready = false;
      UserService.load(function() {
        IndTypeService.load(null, function() {
          OrgUserService.dbLoadMyUser(['announcementaccess'], function(error) {
            if ( error ) {
              MessageBoxService.open('Permission Error', 'You do not have permission to view this page.', 'Continue', function() {
                StateService.go('dashboard');
              });
              $timeout(function() {
                $rootScope.$emit('page.ready');
              }, 100);
              return;
            }

            vm.tabs[0].list = [];
            vm.super = (UserService.isAdmin() && OrganizationService.get().superorg);
            MsgService.clear();
            MsgService.getAllTypes('announcement', vm.tabs, function() {
              MsgService.getDefaultTemplates('announcement', function(data) {
                vm.tabs[0].list = vm.tabs[0].list.concat(data);
                vm.ready = true;
                $rootScope.$emit('page.ready');
              });
            });
          });

        });
      });
    }

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.onNewMSG = function(data) {
      MsgService.clone(data, 'template', 'announcement', function(error, data) {
        if (error == null ) {
          StateService.go('announcedit', data.id);
        }
      });
    }

    vm.onClone = function(data) {
      var status = (data.status == 'template') ? 'template' : 'ready';
      MsgService.clone(data, status, 'announcement', function(error, data) {
        if (error == null ) {
          StateService.go('announcedit', data.id);
        }
      });
    }

    vm.onUpdateMessage = function(data) {
      MsgService.updateMessage(data, function() {

      });
    }

    vm.onDelete = function(data) {
      MsgService.delete(data, function() {
        vm.loadData();
      });
    }

    vm.onSend = function(data) {
      MsgService.setCurrent(data);
      var notAschool = ( OrganizationService.getIndustry() != 1); // not a school
      if ( notAschool ) {
        ScheduleService.load( data.id, function() {
          if ( ScheduleService.getList().length > 0 ) { // must have a schedule
            StateService.go('announccalc', data.id);
          } else {
            StateService.go('announcschedule', data.id);
          }
        });

      } else {
        ScheduleService.load( data.id, function() {
          if ( ScheduleService.getList().length > 0 ) { // must have a schedule
            MsgService.send(null, function(result, message) {
              if ( message )
                MessageBoxService.open('Send Error', message, 'Continue', function() { });
            });
          } else {
            StateService.go('announcschedule', data.id);
          }
        });
      }
    }

    vm.onSchedule = function(data) {
      MsgService.setCurrent(data);
      var status = (data.status == 'template') ? 'template' : 'ready';
      data.status = status;
      StateService.go('announcschedule', data.id);
    }

    vm.onTemplatePicker = function() {
      StateService.go('announcselect');
    }

    vm.onUpload = function() {

    }

    vm.onEdit = function(data) {
      MsgService.setCurrent(data);
      var status = (data.status == 'template') ? 'template' : 'ready';
      data.status = status;
      StateService.go('announcedit', data.id);
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();


(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AnnouncEdit.Controller', AnnouncEditController);

  /** @ngInject */
  function AnnouncEditController($scope, $rootScope, $timeout, $routeParams, $document, MsgService, MessageBoxService, OrganizationService, OrgCatService, OrgUserService, StateService) {
    var vm = this;
    vm.name = 'Announcement Edit Page';
    vm.tempID = $routeParams.tempID;
    vm.orgID = $routeParams.orgID;
    vm.isValid = false;

    vm.loadData = function() {
      OrgUserService.dbLoadMyUser(['announcementaccess'], function(error) {
        if ( error ) {
          MessageBoxService.open('Permission Error', 'You do not have permission to view this page.', 'Continue', function() {
            StateService.go('dashboard');
          });
          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
          return;
        }
        OrgCatService.load(function() {
          MsgService.loadByID(vm.tempID, function() {
            vm.data = MsgService.get();
            if ( vm.data ) {
              $timeout(function() {
                $rootScope.$emit('page.ready');
                vm.isValid = true;
              }, 100);
            }
          });
        });
      });
    }

    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.isTemplate = function( ) {
      return (vm.data && vm.data.status == 'template');
    }

    vm.onUpdateData = function() {
      MsgService.set(vm.data);
    }

    vm.onUpdateDescription = function() {
      if ( !vm.useDescription ) {
        vm.data.description = '';
      }
    }

    vm.onDone = function() {
      vm.loadData();
    }

    vm.onSend = function() {
      StateService.go('announcement');
    }

    vm.onCalculate = function() {

    }

    vm.onSchedule = function() {
      vm.data = MsgService.get();
      StateService.go('announcschedule', vm.data.id);
    }


    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {

    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AnnouncCalc.Controller', AnnouncCalcController);

  /** @ngInject */
  function AnnouncCalcController($scope, $rootScope, $timeout, $routeParams, $document, MsgService, OrganizationService, ScheduleService, OrgCatService, OrgUserService, StateService) {
    var vm = this;
    vm.name = 'Calculate';
    vm.tempID = $routeParams.tempID;
    vm.orgID = $routeParams.orgID;

    vm.loadData = function() {
      OrgUserService.dbLoadMyUser(['announcementaccess'], function(error) {
        if ( error ) {
          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
          return;
        }
        OrgCatService.load(function() {
          MsgService.loadByID(vm.tempID, function() {
            ScheduleService.load(vm.tempID, function() {
              vm.data = MsgService.get();
              $timeout(function() {
                $rootScope.$emit('page.ready');
              }, 100);
            });
          });
        });
      });
    }

    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.onDone = function() {
      StateService.go('announcement');
    }

    vm.onSend = function() {
      StateService.go('announcement');
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AlertSelect.Controller', AlertSelectController);

  /** @ngInject */
  function AlertSelectController($scope, $routeParams, $timeout, $rootScope, $log, $uibModal, MsgService, OrganizationService, UserService, OrgUserService, OrgReportService, StateService, MessageBoxService) {
    var vm = this;
    vm.name = 'Alert Template Selection Page';
    vm.orgID = $routeParams.orgID;
    vm.ready = false;
    vm.tabs = [
      {name:'ALL TEMPLATES', list: [], status: 'template', id: '1', callback: function(result) {
        vm.tabs[1].list = result.data;
        MsgService.getAllTemplates('alert', function(error, data) {
          vm.tabs[0].list = data;
          vm.ready = true;
          $rootScope.$emit('page.ready');
        });
      }},
      {name:'MY TEMPLATES', list: [], id: '0'}];

    vm.Nav = function(page) {
      StateService.go(page);
    }

    vm.loadData = function() {
      UserService.load(function() {
        OrgUserService.dbLoadMyUser(['alertaccess'], function(error) {
          if ( error ) {
            MessageBoxService.open('Permission Error', 'You do not have permission to view this page.', 'Continue', function() {
              StateService.go('dashboard');
            });
            $timeout(function() {
              $rootScope.$emit('page.ready');
            }, 100);
            return;
          }

          vm.super = (UserService.isAdmin() && OrganizationService.get().superorg);
          MsgService.clear();
          MsgService.getAllTypes('alert', vm.tabs, function() {});

        });
      });
    }

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.onCreate = function() {
      MsgService.newTemplate('new template', 'template', 'alert', function(error, data) {
        if ( error == null ) {
          StateService.go('alertedit', data.id);
        }
      });
    }

    vm.onSelect = function(data) {
      vm.data = data;
      vm.popup = $uibModal.open({
        templateUrl: 'app/popups/templateconfirm/templateconfirm.html',
        controller: 'TemplateConfirm.Controller',
        windowClass: 'template-box',
        scope: $scope
      });
    }

    vm.onDone = function() {
      vm.popup.close();
      var status = 'ready';
      MsgService.clone(vm.data, status, 'alert', function(error, data) {
        if (error == null && data) {
          StateService.go('alertedit', data.id);
        }
      });
    }

    vm.onCancel = function() {
      vm.popup.close();
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      if ( vm.popup ) vm.popup.close();
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AlertEdit.Controller', AlertEditController);

  /** @ngInject */
  function AlertEditController($scope, $rootScope, $timeout, $routeParams, $document, MsgService, MessageBoxService, OrganizationService, OrgUserService, OrgCatService, StateService) {
    var vm = this;
    vm.name = 'Alert Edit Page';
    vm.tempID = $routeParams.tempID;
    vm.orgID = $routeParams.orgID;
    vm.isValid = false;

    vm.loadData = function() {
      OrgUserService.dbLoadMyUser(['alertaccess'], function(error) {
        if ( error ) {
          MessageBoxService.open('Permission Error', 'You do not have permission to view this page.', 'Continue', function() {
            StateService.go('dashboard');
          });
          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
          return;
        }
        OrgCatService.load(function() {
          MsgService.loadByID(vm.tempID, function() {
            vm.data = MsgService.get();

            if ( vm.data ) {
              if ( vm.data.description != '') {
                vm.useDescription = true;
              }
              $timeout(function() {
                $rootScope.$emit('page.ready');
                vm.isValid = true;
              }, 100);
            }
          });
        });
      });
    }

    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.isTemplate = function( ) {
      return (vm.data && vm.data.status == 'template');
    }

    vm.onUpdateData = function() {
      MsgService.set(vm.data);
    }

    vm.onUpdateDescription = function() {
      if ( !vm.useDescription ) {
        vm.data.description = '';
      }
    }

    vm.onDone = function() {
      vm.loadData();
    }

    vm.onSend = function() {
      StateService.go('alert');
    }

    vm.onCalculate = function() {

    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {

    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Alert.Controller', AlertController);

  /** @ngInject */
  function AlertController(
    $scope,
    $routeParams,
    $timeout,
    $rootScope,
    $log,
    $sce,
    MsgService,
    IndTypeService,
    OrganizationService,
    UserService,
    OrgUserService,
    OrgReportService,
    StateService,
    MessageBoxService,
    $window,
    DashboardGroupService
  ) {
    var vm = this;
    vm.name = 'Alert Page';
    vm.orgID = $routeParams.orgID;
    vm.ready = false;
    vm.coords = {};

    if ($window.navigator && $window.navigator.geolocation) {
      var handler = function(position) {
        vm.coords = position.coords;
      };
      $window.navigator.geolocation.getCurrentPosition(handler);
    }

    vm.tabs = [
      // {name:'ALL', list: [], id: '0'},
      // {name:'READY TO SEND', list: [], id: '2'},
      // {name:'MY SENT MESSAGES', list: [], status: 'sent', id: '1', callback: function(result) { vm.tabs[1].list = result.data; vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[1].list); }},
      // {name:'READY TO SEND', list: [], id: '2'},
      // {name:'MY SAVED TEMPLATES', list: [], status: 'template', id: '3', callback: function(result) { vm.tabs[3].list = result.data; vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[3].list); }},
      // {name:'NEEDS ATTENTION', list: [], status: 'rejected', id: '4', callback: function(result) { vm.tabs[4].list = result.data; vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[4].list); }},
      // {name:'MY PENDING', list: [], status: 'pending', id: '5', callback: function(result) { vm.tabs[5].list = result.data; vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[5].list); }},
      // {
      //   name:'REMOTE MONITORING',
      //   list: [],
      //   isdmpreceive: true,
      //   id: '6',
      //   callback: function(result) {
      //     $log.log('rslt', result.data);
      //     vm.tabs[6].list = result.data;
      //     // vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[6].list);
      //   }
      // }
    ];

    vm.tabsByName = {};

    vm.loadData = function() {

      vm.tabsByName = {
        all: {
          name: 'ALL',
          list: [],
          id: '0'
        },
        templates: {
          name: 'Templates',
          list: [],
          id: '1'
        }
      };

      vm.ready = false;
      UserService.load(function() {
        IndTypeService.load(null, function() {
          OrgUserService.dbLoadMyUser(['alertaccess'], function(error) {
            if ( error ) {
              MessageBoxService.open('Permission Error', 'You do not have permission to view this page.', 'Continue', function() {
                StateService.go('dashboard');
              });
              $timeout(function() {
                $rootScope.$emit('page.ready');
              }, 100);
              return;
            }


            vm.super = (UserService.isAdmin() && OrganizationService.get().superorg);
            MsgService.clear();
            Promise.all([
              MsgService.getAlertsByStatus('ready'),
              MsgService.getAlertsByStatus('template'),
              MsgService.getDefaultTemplates('alert'),
              DashboardGroupService.load(),
            ])
            .then(function(results) {
              var readyMessages = results[0].filter(function(msg) {
                return !msg.parenttemplateid;
              });
              var orgTemplateMessages = results[1];
              var templatesMessages = results[2];
              var dashboardGroups = results[3];

              vm.tabsByName.all.list = vm.tabsByName.all.list || [];
              readyMessages.forEach(function(m) {
                vm.tabsByName.all.list.push(m);
              });

              orgTemplateMessages.forEach(function(m) {
                if (m.status === 'template') {
                  vm.tabsByName.templates.list.push(m);
                }
              });

              templatesMessages.forEach(function(m) {
                if (m.status === 'template') {
                  vm.tabsByName.templates.list.push(m);
                }
              });

              if (!vm.tabsByName.templates.list || !vm.tabsByName.templates.list.length) {
                delete vm.tabsByName.templates;
              }

              vm.tabs = Object.values(vm.tabsByName);

              dashboardGroups.forEach(function(dashboardGroup) {
                vm.tabs.push({
                  name: 'READY TO SEND\n' + dashboardGroup.name,
                  list: readyMessages.filter(function(m) {
                    return (m.dashboardgroups || []).indexOf(dashboardGroup.id) > -1;
                  }),
                  id: '' + vm.tabs.length
                });
              });

              vm.tabs.push({
                name: 'READY TO SEND\n SENSORS',
                list: readyMessages.filter(function(m) {
                  return m.isdmp || m.isdmpreceive;
                }),
                id: '' + vm.tabs.length
              });

              $rootScope.$emit('page.ready');
              vm.ready = true;
            });
            // MsgService.getAllTypes('alert', vm.tabs, function() {
            //   //'ready' alerts use a different query
            //   MsgService.getReadyAlerts(function(result) {
            //     vm.tabs[2].list = result.data;
            //     vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[2].list);

            //     MsgService.getDefaultTemplates('alert', function(data) {
            //       vm.tabs[0].list = vm.tabs[0].list.concat(data);
            //       vm.ready = true;
            //       $rootScope.$emit('page.ready');
            //     });
            //   });
            // });
          });
        });
      });
    }

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.tabName = function(tab) {
      return $sce.trustAsHtml(tab.name.replace('\n', '<br />'));
    }

    vm.onNewMSG = function(data) {
      MsgService.clone(data, 'ready', 'alert', function(error, data) {
        if (error == null ) {
          StateService.go('alertedit', data.id);
        }
      });
    }

    vm.onClone = function(data) {
      var status = (data.status == 'template') ? 'template' : 'ready';
      MsgService.clone(data, status, 'alert', function(error, data) {
        if (error == null ) {
          StateService.go('alertedit', data.id);
        }
      });
    }

    vm.onUpdateMessage = function(data) {
      MsgService.updateMessage(data, function() {

      });
    }

    vm.onDelete = function(data) {
      MsgService.delete(data, function() {
        vm.loadData();
      });
    }

    vm.onSend = function(data) {
      var info = null;

      try {
        info = {};
        vm.coords = vm.coords || {};
        info.userlat = vm.coords.latitude;
        info.userlng = vm.coords.longitude;
        info.lat = vm.coords.latitude;
        info.lng = vm.coords.longitude;
      } catch (err) {
        // ignore
      }

      MsgService.setCurrent(data);
      MsgService.send(null, function(result, message) {
        if ( message )
          MessageBoxService.open('Send Error', message, 'Continue', function() { });
      });
    }

    vm.onTemplatePicker = function() {
      StateService.go('alertselect');
    }

    vm.onUpload = function() {

    }

    vm.onEdit = function(data) {
      MsgService.setCurrent(data);
      var status = (data.status == 'template') ? 'template' : 'ready';
      data.status = status;
      StateService.go('alertedit', data.id);
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AdSelect.Controller', AdSelectController);

  /** @ngInject */
  function AdSelectController($scope, $routeParams, $timeout, $rootScope, $log, $uibModal, MsgService, OrganizationService, UserService, OrgUserService, OrgReportService, StateService, MessageBoxService) {
    var vm = this;
    vm.name = 'Ad Template Selection Page';
    vm.orgID = $routeParams.orgID;
    vm.ready = false;
    vm.tabs = [
      {name:'ALL TEMPLATES', list: [], status: 'template', id: '1', callback: function(result) {
        vm.tabs[1].list = result.data;
        MsgService.getAllTemplates('advertisement', function(error, data) {
          vm.tabs[0].list = data;
          vm.ready = true;
          $rootScope.$emit('page.ready');
        });
      }},
      {name:'MY TEMPLATES', list: [], id: '0'}];

    vm.Nav = function(page) {
      StateService.go(page);
    }

    vm.loadData = function() {
      UserService.load(function() {
        OrgUserService.dbLoadMyUser(['advertisementaccess'], function(error) {
          if ( error ) {
            MessageBoxService.open('Permission Error', 'You do not have permission to view this page.', 'Continue', function() {
              StateService.go('dashboard');
            });
            $timeout(function() {
              $rootScope.$emit('page.ready');
            }, 100);
            return;
          }

          vm.super = (UserService.isAdmin() && OrganizationService.get().superorg);
          MsgService.clear();
          MsgService.getAllTypes('advertisement', vm.tabs, function() {});

        });
      });
    }

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      })
    } else {
      vm.loadData();
    }

    vm.onCreate = function() {
      MsgService.newTemplate('new template', 'template', 'advertisement', function(error, data) {
        if ( error == null ) {
          StateService.go('adedit', data.id);
        }
      });
    }

    vm.onSelect = function(data) {
      vm.data = data;
      vm.popup = $uibModal.open({
        templateUrl: 'app/popups/templateconfirm/templateconfirm.html',
        controller: 'TemplateConfirm.Controller',
        windowClass: 'template-box',
        scope: $scope
      });
    }

    vm.onDone = function() {
      vm.popup.close();
      var status = 'ready';
      MsgService.clone(vm.data, status, 'advertisement', function(error, data) {
        if (error == null && data) {
          StateService.go('adedit', data.id);
        }
      });
    }

    vm.onCancel = function() {
      vm.popup.close();
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
      if ( vm.popup ) vm.popup.close();
    });
  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AdSchedule.Controller', AdScheduleController);

  /** @ngInject */
  function AdScheduleController($scope, $rootScope, $timeout, $routeParams, $document, ScheduleService, MsgService, OrganizationService, OrgCatService, OrgUserService, StateService) {
    var vm = this;
    vm.name = 'Ad Schedule ';
    vm.tempID = $routeParams.tempID;
    vm.orgID = $routeParams.orgID;

    vm.loadData = function() {
      OrgUserService.dbLoadMyUser(['advertisementaccess'], function(error) {
        if ( error ) {
          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
          return;
        }
        OrgCatService.load(function() {
          MsgService.loadByID(vm.tempID, function() {
            ScheduleService.load(vm.tempID, function() {
              vm.data = MsgService.get();
              $timeout(function() {
                $rootScope.$emit('page.ready');
              }, 100);
            });
          });
        });
      });
    }

    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.onDone = function() {
      //StateService.go("ad");
    }

    vm.canContinue = function()
    {
      return ( ScheduleService.getList().length > 0 );
    }

    vm.onSend = function() {
      if ( vm.canContinue() ) {
        StateService.go('ad');
      }
    }

    vm.onCalculate = function() {
      if ( vm.canContinue() ) {
        vm.data = MsgService.get();
        StateService.go('adcalc', vm.data.id);
      }
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AdminUsers.Controller', AdminUsersController);

  /** @ngInject */
  function AdminUsersController($scope, $timeout, $rootScope, UserService, OrgUserService, OrganizationService, StateService) {
    var vm = this;
    vm.name = 'Admin Users Messages';

    vm.currentPage = 1;
    vm.totalPages = 0;
    vm.limit = 10;
    vm.searchQuery = '';

    vm.loadData = function(page, limit, search) {
      UserService.load(function() {
        OrgUserService.adminLoadListWithPagination(page, limit, search, function() {
          vm.list = OrgUserService.dbGet();
          vm.paginationData = OrgUserService.getPaginationData();
          vm.totalPages = vm.paginationData.totalPages;
          vm.currentPage = vm.paginationData.currentPage;
          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
        });
      });
    };

    // vm.loadData = function() {
    //   UserService.load(function() {
    //     OrgUserService.adminLoadList(function() {

    //       vm.list = OrgUserService.dbGet();

    //       $timeout(function() {
    //         $rootScope.$emit('page.ready');
    //       }, 100);

    //     });
    //   });
    // }

    vm.changePage = function(page) {
      vm.currentPage = page;
      vm.loadData(vm.currentPage, vm.limit, vm.searchQuery);
    };

    vm.searchOrganizations = function() {
      // vm.loadData(1, vm.limit, vm.searchQuery);
      OrgUserService.adminLoadListWithPagination(1, vm.limit, vm.searchQuery, function() {
        vm.list = OrgUserService.dbGet();
        vm.paginationData = OrgUserService.getPaginationData();
        vm.totalPages = vm.paginationData.totalPages;
        vm.currentPage = vm.paginationData.currentPage;
        // $timeout(function() {
        //   $rootScope.$emit('page.ready');
        // }, 100);
      });
    };

    vm.loadData(vm.currentPage, vm.limit, vm.searchQuery);

    vm.Select = function(user) {
      OrganizationService.loadByID(user.organizationid, function() {
        StateService.go('user', null, user.email);
      });
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AdminSales.Controller', AdminSalesController);

  /** @ngInject */
  function AdminSalesController($scope, $timeout, $rootScope, UserService) {
    var vm = this;
    vm.name = 'Admin Sales Messages';

    vm.loadData = function() {
      UserService.load(function() {

        $timeout(function() {
          $rootScope.$emit('page.ready');
        }, 100);

      });
    }

    vm.loadData();

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AdminOrganizations.Controller', AdminOrganizationsController);

  /** @ngInject */
  function AdminOrganizationsController($scope, $timeout, $uibModal, $rootScope, UserService, OrganizationService, StateService, MessageBoxService) {
    var vm = this;
    vm.name = 'Admin Organization Messages';
    vm.org = {};


    vm.currentPage = 1;
    vm.totalPages = 0;
    vm.limit = 10;
    vm.searchQuery = '';

    vm.loadData = function(page, limit, search) {
      UserService.load(function() {
        OrganizationService.adminLoadListWithPagination(page, limit, search, function() {
          vm.list = OrganizationService.getList();
          vm.paginationData = OrganizationService.getPaginationData();
          vm.totalPages = vm.paginationData.totalPages;
          vm.currentPage = vm.paginationData.currentPage;
          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
        });
      });
    };

    vm.changePage = function(page) {
      vm.currentPage = page;
      vm.loadData(vm.currentPage, vm.limit, vm.searchQuery);
    };

    vm.searchOrganizations = function() {
      vm.loadData(1, vm.limit, vm.searchQuery);
    };
    vm.Select = function(org) {
      OrganizationService.loadByID(org.id, function() {
        StateService.go('profile')
      });
    };

    vm.DeleteOrg = function() {
      OrganizationService.deleteOrgById(vm.org.id, function(error) {
        if (error === null) {
          MessageBoxService.open('Success', 'Organization has been successfully deleted', 'Continue', function() {
            vm.loadData(vm.currentPage, vm.limit, vm.searchQuery);
          })
        } else {
          MessageBoxService.open('Error', 'Problem Deleting Organization, please try again', 'Continue', function() {})
        }
      })
    };

    vm.ConfirmDelete = function(org) {
      vm.org = org;
      vm.popup = $uibModal.open({
        templateUrl: 'app/popups/deleteorgconfirm/deleteorgconfirm.html',
        controller: 'DeleteOrgConfirm.Controller as vm',
        windowClass: 'template-box',
        scope: $scope
      });
    };


    vm.loadData(vm.currentPage, vm.limit, vm.searchQuery);

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AdminMessages.Controller', AdminMessagesController);

  /** @ngInject */
  function AdminMessagesController($scope, $timeout, $rootScope, UserService) {
    var vm = this;
    vm.name = 'Admin Dashboard Messages';

    vm.loadData = function() {
      UserService.load(function() {

        $timeout(function() {
          $rootScope.$emit('page.ready');
        }, 100);

      });
    }

    vm.loadData();

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AdminLms.Controller', AdminLmsController);

/** @ngInject */
  function AdminLmsController($scope, $timeout, $rootScope, UserService, OrgUserService, OrganizationService, StateService, $q) {
    var vm = this;
    vm.name = 'Admin Users Messages';
    vm.currentPage = 1;
    vm.totalPages = 0;
    vm.limit = 10;
    vm.searchQuery = '';
    vm.selectedOrganization = null;
    vm.list = [];
    vm.orgData = [];
    vm.cancelPreviousCall = null;

    // Load organizations with pagination
    // vm.loadData = function(page, limit, search) {
      // OrganizationService.adminLoadListWithPagination(page, limit, search, function() {
      //   // vm.list = OrganizationService.dbGet();
      //   vm.paginationData = OrganizationService.getPaginationData();
      //   vm.totalPages = vm.paginationData.totalPages;
      //   vm.currentPage = vm.paginationData.currentPage;
      //   $timeout(function() {
      //     $rootScope.$emit('page.ready');
      //   }, 100);
      // });
    // };

    // Search for organizations
    vm.searchOrganizations = function(query) {
      if (!query || query.length < 2) {
        vm.list = []; // Clear results if query is empty or too short
        return;
      }
      // Cancel the previous API call if it's still pending
      if (vm.cancelPreviousCall && vm.cancelPreviousCall.resolve) {
        vm.cancelPreviousCall.resolve(); // Resolve the previous promise to cancel the request
      }
      vm.cancelPreviousCall = $q.defer();
      // Turn on the loading screen
      // Create a new promise with a cancellation mechanism
      // var currentCall = DashboardGroupService.load(vm.filter || '',vm.cancelPreviousCall.promise);
      // vm.cancelPreviousCall = currentCall.cancel; // Store the cancel function
      return OrganizationService.adminLoadListWithPaginationLms(vm.currentPage, vm.limit, vm.searchQuery, vm.cancelPreviousCall.promise)
      .then(function(dashboardGroupsList) {
        vm.list = dashboardGroupsList;
      })
    };

    // Select an organization and display only the selected one
    vm.selectOrganization = function(org) {
      vm.selectedOrganization = org;
      vm.searchQuery = org.name; // Show only selected org name
      // Once an organization is selected, load its YAOrganizationData
      OrganizationService.getOrganizationDataByOrgId(org.id, function() {
        vm.instructions = [];
        vm.certifications = [];
        // vm.orgData = OrganizationService.getOrganizationDataList();
        angular.forEach(OrganizationService.getOrganizationDataList(), function(item) {
          if (item.type === 'instruction') {
            vm.instructions.push({ name: item.name, url: item.url });
          } else if (item.type === 'certification') {
            vm.certifications.push({ name: item.name, url: item.url });
          }
        });
      })
    };

     // Instructions and Certifications Arrays
    vm.instructions = [];
    vm.certifications = [];
    // Add & Remove Instructions
    vm.addInstruction = function() {
      vm.instructions.push({ name: '', url: '' });
    };

    vm.removeInstruction = function(index) {
      vm.instructions.splice(index, 1);
    };

     // Add & Remove Certifications
    vm.addCertification = function() {
      vm.certifications.push({ name: '', url: '' });
    };

    vm.removeCertification = function(index) {
      vm.certifications.splice(index, 1);
    };

     // Save Data
    vm.saveData = function() {
      var payload = {
        organizationid: vm.selectedOrganization ? vm.selectedOrganization.id : null,
        instructions: vm.instructions,
        certifications: vm.certifications
      };
      OrganizationService.saveOrganizationData(payload, function() {
        alert('Data saved successfully!');
      });
    };

    // vm.loadData(vm.currentPage, vm.limit, vm.searchQuery);

    vm.Select = function(user) {
      OrganizationService.loadByID(user.organizationid, function() {
        StateService.go('user', null, user.email);
      });
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();
(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AdminIndustry.Controller', AdminIndustryController);

  /** @ngInject */
  function AdminIndustryController($scope, $timeout, $rootScope, UserService) {
    var vm = this;
    vm.name = 'Admin Industry Types Messages';

    vm.loadData = function() {
      UserService.load(function() {

        $timeout(function() {
          $rootScope.$emit('page.ready');
        }, 100);

      });
    }

    vm.loadData();

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AdminEmployees.Controller', AdminEmployeesController);

  /** @ngInject */
  function AdminEmployeesController($scope, $timeout, $rootScope, UserService) {
    var vm = this;
    vm.name = 'Admin Employees Messages';

    vm.loadData = function() {
      UserService.load(function() {

        $timeout(function() {
          $rootScope.$emit('page.ready');
        }, 100);

      });
    }

    vm.loadData();

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AdminCategory.Controller', AdminCategoryController);

  /** @ngInject */
  function AdminCategoryController($scope, $timeout, $rootScope, UserService) {
    var vm = this;
    vm.name = 'Admin Category Group Messages';

    vm.loadData = function() {
      UserService.load(function() {

        $timeout(function() {
          $rootScope.$emit('page.ready');
        }, 100);

      });
    }

    vm.loadData();

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AdminInviteTemplates.Controller', AdminInviteTemplatesController);

  /** @ngInject */
  function AdminInviteTemplatesController($scope, $timeout, $rootScope, UserService, OrgUserService, OrganizationService, StateService, $q) {
    var vm = this;
    vm.name = 'Admin Invite Templates';
    vm.currentPage = 1;
    vm.totalPages = 0;
    vm.limit = 10;
    vm.searchQuery = '';
    vm.selectedOrganization = null;
    vm.list = [];
    vm.orgData = [];
    vm.cancelPreviousCall = null;
    vm.templateType = 'dashboard_invite';// 'recipient_invite' or 'dashboard_invite'
    vm.emailTemplates = [];// Stores multiple email templates
    vm.quillInstance = null;

    // Initialize Quill.js Editor
    function initializeQuillEditor() {
      $timeout(function() {
        var editorElement = document.querySelector('#emailEditor');
        if (!editorElement) {
          return;
        }
        if (!vm.quillInstance) {
          vm.quillInstance = new Quill('#emailEditor', {
            theme: 'snow',
            placeholder: 'Write your email template here...',
            modules: {
              toolbar: [
                [{ header: [1, 2, false] }],
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link', 'image']
              ]
            }
          });
          vm.quillInstance.root.innerHTML = vm.emailContent;
          // Sync Quill content with Angular model
          vm.quillInstance.on('text-change', function() {
            $scope.$apply(function() {
              vm.emailContent = vm.quillInstance.root.innerHTML;
            });
          });
        }
      }, 500);  // Delay ensures DOM is ready
    }
    // Search Organizations
    vm.searchOrganizations = function(query) {
      if (!query || query.length < 2) {
        vm.list = [];
        return;
      }
      if (vm.cancelPreviousCall && vm.cancelPreviousCall.resolve) {
        vm.cancelPreviousCall.resolve();
      }
      vm.cancelPreviousCall = $q.defer();

      return OrganizationService.adminLoadListWithPaginationLms(vm.currentPage, vm.limit, vm.searchQuery, vm.cancelPreviousCall.promise)
      .then(function(dashboardGroupsList) {
        vm.list = dashboardGroupsList;
      });
    };

    // Select an Organization
    vm.selectOrganization = function(org) {
      vm.selectedOrganization = org;
      vm.searchQuery = org.name;
      vm.loadTemplates(org.id);
    };

    // Load Templates based on Organization ID
    vm.loadTemplates = function(orgId) {
      OrganizationService.getEmailTemplatesByOrgId(orgId,vm.templateType, function() {
        vm.emailContent = OrganizationService.getEmailTemplate(); // Assuming API returns email templates array
        $timeout(initializeQuillEditor, 100); // Reinitialize Quill with new content
      });
    };

    // Select Template Type and Load Content
    vm.selectTemplateType = function() {
      OrganizationService.getEmailTemplatesByOrgId(vm.selectedOrganization.id,vm.templateType, function() {
        vm.emailContent = OrganizationService.getEmailTemplate(); // Assuming API returns email templates array
        $timeout(initializeQuillEditor, 100); // Reinitialize Quill with new content
      });
    };

    // Save Email Template
    vm.saveTemplate = function() {
      // if (!vm.selectedOrganization) {
      //   alert("Please select an organization first.");
      //   return;
      // }
      // var payload = {
      //   organization_id: vm.selectedOrganization.id,
      //   type: vm.templateType,
      //   content: vm.emailContent
      // };
      // OrganizationService.saveEmailTemplate(payload)
      //   .then(function() {
      //     // alert("Email Template saved successfully!");
      //     vm.loadTemplates(vm.selectedOrganization.id); // Reload templates
      //   });
    };

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AdEdit.Controller', AdEditController);

  /** @ngInject */
  function AdEditController($scope, $rootScope, $timeout, $routeParams, $document, MsgService, MessageBoxService, OrganizationService, OrgCatService, OrgUserService, StateService) {
    var vm = this;
    vm.name = 'Ad Edit Page';
    vm.tempID = $routeParams.tempID;
    vm.orgID = $routeParams.orgID;
    vm.isValid = false;

    vm.loadData = function() {
      OrgUserService.dbLoadMyUser(['advertisementaccess'], function(error) {
        if ( error ) {
          MessageBoxService.open('Permission Error', 'You do not have permission to view this page.', 'Continue', function() {
            StateService.go('dashboard');
          });
          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
          return;
        }
        OrgCatService.load(function() {
          MsgService.loadByID(vm.tempID, function() {
            vm.data = MsgService.get();
            if ( vm.data ) {
              $timeout(function() {
                $rootScope.$emit('page.ready');
                vm.isValid = true;
              }, 100);
            }
          });
        });
      });
    }

    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.onUpdateData = function() {
      MsgService.set(vm.data);
    }

    vm.isTemplate = function( ) {
      return (vm.data && vm.data.status == 'template');
    }

    vm.onUpdateDescription = function() {
      if ( !vm.useDescription ) {
        vm.data.description = '';
      }
    }

    vm.onDone = function() {
      vm.loadData();
    }

    vm.onSend = function() {
      StateService.go('ad');
    }

    vm.onCalculate = function() {

    }

    vm.onSchedule = function() {
      vm.data = MsgService.get();
      StateService.go('adschedule', vm.data.id);
    }


    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {

    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('AdCalc.Controller', AdCalcController);

  /** @ngInject */
  function AdCalcController($scope, $rootScope, $timeout, $routeParams, $document, MsgService, OrganizationService, ScheduleService, OrgCatService, OrgUserService, StateService) {
    var vm = this;
    vm.name = 'Ad';
    vm.tempID = $routeParams.tempID;
    vm.orgID = $routeParams.orgID;
    vm.data = {id:-1};

    vm.loadData = function() {
      OrgUserService.dbLoadMyUser(['advertisementaccess'], function(error) {
        if ( error ) {
          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
          return;
        }
        OrgCatService.load(function() {
          MsgService.loadByID(vm.tempID, function() {
            ScheduleService.load( vm.tempID, function() {
              vm.data = MsgService.get();
              $timeout(function() {
                $rootScope.$emit('page.ready');
              }, 100);
            });
          });
        });
      });
    }

    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.onDone = function() {
      StateService.go('ad');
    }

    vm.onSend = function() {
      StateService.go('ad');
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .controller('Ad.Controller', AdController);

  /** @ngInject */
  function AdController($scope, $routeParams, $timeout, $rootScope, MsgService, ScheduleService, OrganizationService, IndTypeService, UserService, OrgUserService, OrgReportService, StateService, MessageBoxService) {
    var vm = this;
    vm.name = 'Ad Page';
    vm.orgID = $routeParams.orgID;
    vm.ready = false;
    vm.tabs = [
      {name:'ALL', list: [], id: '0'},
      {name:'MY SENT MESSAGES', list: [], status: 'sent', id: '1', callback: function(result) { vm.tabs[1].list = result.data; vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[1].list); }},
      {name:'READY TO SEND', list: [], status: 'ready', id: '2', callback: function(result) { vm.tabs[2].list = result.data; vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[2].list); }},
      {name:'MY SAVED TEMPLATES', list: [], status: 'template', id: '3', callback: function(result) { vm.tabs[3].list = result.data; vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[3].list); }},
      {name:'NEEDS ATTENTION', list: [], status: 'rejected', id: '4', callback: function(result) { vm.tabs[4].list = result.data; vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[4].list); }},
      {name:'MY PENDING', list: [], status: 'pending', id: '5', callback: function(result) { vm.tabs[5].list = result.data; vm.tabs[0].list = vm.tabs[0].list.concat(vm.tabs[5].list); }}
    ];

    vm.loadData = function() {
      vm.ready = false;
      UserService.load(function() {
        IndTypeService.load(null, function() {
          OrgUserService.dbLoadMyUser(['advertisementaccess'], function(error) {
            if ( error ) {
              MessageBoxService.open('Permission Error', 'You do not have permission to view this page.', 'Continue', function() {
                StateService.go('dashboard');
              });
              $timeout(function() {
                $rootScope.$emit('page.ready');
              }, 100);
              return;
            }

            vm.tabs[0].list = [];
            vm.super = (UserService.isAdmin() && OrganizationService.get().superorg);
            MsgService.clear();
            MsgService.getAllTypes('advertisement', vm.tabs, function() {

              MsgService.getDefaultTemplates('advertisement', function(data) {
                vm.tabs[0].list = vm.tabs[0].list.concat(data);
                vm.ready = true;
                $rootScope.$emit('page.ready');
              });
            });

          });

        });
      });
    }

    // check to see if data should reload
    if ( vm.orgID != OrganizationService.getID() ) {
      OrganizationService.loadByID(vm.orgID, function() {
        vm.loadData();
      });
    } else {
      vm.loadData();
    }

    vm.onNewMSG = function(data) {
      MsgService.clone(data, 'template', 'advertisement', function(error, data) {
        if (error == null ) {
          StateService.go('adedit', data.id);
        }
      });
    }

    vm.onClone = function(data) {
      var status = (data.status == 'template') ? 'template' : 'ready';
      MsgService.clone(data, status, 'advertisement', function(error, data) {
        if (error == null ) {
          StateService.go('adedit', data.id);
        }
      });
    }

    vm.onDelete = function(data) {
      MsgService.delete(data, function() {
        vm.loadData();
      });
    }

    vm.onUpdateMessage = function(data) {
      MsgService.updateMessage(data, function() {

      });
    }

    vm.onSend = function(data) {
      MsgService.setCurrent(data);
      var notAschool = ( OrganizationService.getIndustry() != 1); // not a school
      if ( notAschool ) {
        ScheduleService.load( data.id, function() {
          if ( ScheduleService.getList().length > 0 ) {
            StateService.go('adcalc', data.id);
          } else {
            StateService.go('adschedule', data.id);
          }
        });

      } else {
        ScheduleService.load( data.id, function() {
          if ( ScheduleService.getList().length > 0 ) { // must have a schedule
            MsgService.send(null, function(result, message) {
              if ( message )
                MessageBoxService.open('Send Error', message, 'Continue', function() { });
            });
          } else {
            StateService.go('adschedule', data.id);
          }
        });
      }
    }

    vm.onTemplatePicker = function() {
      StateService.go('adselect');
    }

    vm.onUpload = function() {

    }

    vm.onSchedule = function(data) {
      MsgService.setCurrent(data);
      var status = (data.status == 'template') ? 'template' : 'ready';
      data.status = status;
      StateService.go('adschedule', data.id);
    }

    vm.onEdit = function(data) {
      MsgService.setCurrent(data);
      var status = (data.status == 'template') ? 'template' : 'ready';
      data.status = status;
      StateService.go('adedit', data.id);
    }

    $scope.$on('$viewContentLoaded', function ContentLoaded() {
    });

    $scope.$on('$destroy', function UnLoaded() {
    });

  }
})();

(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaUserSearch', yaUserSearch);

  function yaUserSearch() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/usersearch/ya-user-search.html',
      scope: { },
      controller: UserSearchController,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function UserSearchController($scope, $rootScope, $document, OrgUserService, UploadFileService) {
      var vm = this;
      vm.users = [];
      vm.permissionList = [];
      vm.searchText = 'enter';
      vm.profile = undefined;
      vm.reader = new FileReader( );
      vm.profileimage = null;

      vm.pageready = $rootScope.$on('page.ready', function() {
        vm.users = OrgUserService.dbGet();
      });

      vm.Change = function() {

        if ( vm.profile && vm.profile.profileimage && vm.profile.profileimage != '' ) {
          $document[0].getElementById('image1').src = vm.profile.profileimage
        } else {
          $document[0].getElementById('image1').src = '';
        }
      }

      // load image
      vm.LoadImage = function(dest, file) {
        var image = $document[0].getElementById(dest);
        vm.reader.onload = function(event) {
          image.src = event.target.result;
          $scope.$apply();
        };
        vm.reader.readAsDataURL(file);
      }

      // set the image to be loaded/uploaded
      vm.UpdateImage = function(dest, element) {
        vm[element.id] = element.files[0];
        vm.LoadImage(dest, element.files[0]);
      }

      // upload the image
      vm.Upload = function(id) {
        UploadFileService.upload( vm[id], function(path, error) {
          if ( error == null ) {
            vm[id] = null;
            vm.profile[id] = path;
          }
        });
      }

      $scope.$on('$destroy', function UnLoaded() {
        vm.reader = null; // some how causes GC to clear stupid memory for filereader
      });

      vm.getMatches = function(text) {
        var list = [];
        vm.users.forEach(function(user) {
          if ( user.name && user.name.toLowerCase().indexOf(text) == 0 )
            list.push(user);
        });
        return list;
      }

      vm.CloseEdit = function() {
        // assign workflowadmin id
        var index = vm.users.indexOf(vm.profile);
        if ( index < 0 ) return;
        OrgUserService.dbUpdate(index, function() {
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaTutorialBox', yaTutorialBox);

  function yaTutorialBox() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/tutorial-box/ya-tutorial-box.html',
      scope: {},
      controller: TutorialController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;


    //controls state of tutorial box which is based on app/routing state
    /** @ngInject */
    function TutorialController() {
      var vm = this;
      vm.text = 'Lorem ipsum dolor sit amet, periculis accommodare ea nec, in ius modo invidunt adipiscing. No sit epicuri petentium. In eum nulla hendrerit, quidam dolores nec at, ut putent fierent verterem duo. Per te purto nonumy, cum ei homero detraxit, sit eu quem illum consul. Te pro sint contentiones, ei aperiam diceret comprehensam ius.';
      vm.image = 'http://placehold.it/400x400'
    }
  }
})();
(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaStepper', yaStepper)
  .directive('yaStepperItem', yaStepperItem);

  function yaStepper($timeout) {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/stepper/ya-stepper.html',
      transclude: true,
      scope: { callback: '=?callback' },
      controller: StepperController,
      controllerAs: 'main',
      bindToController: true,
      link: function(scope, element) {
        var list = element[0].getElementsByTagName('ya-stepper-item');
        scope.main.totalElements = list.length;

        if ( scope.main.totalElements == scope.main.elementList.length ) {
          if ( scope.main.callback ) {
            $timeout( scope.main.callback( scope.main ), 0);
          }
        }
      }
    };
    return directive;
    /** @ngInject */
    function StepperController() {
      var vm = this;
      vm.testName = 'this';
      vm.elementList = [];
      vm.currentIndex = 0;

      vm._addItem = function( ctrl ) {
        ctrl.number = vm.elementList.length;
        ctrl.index = ctrl.number;
        vm.elementList.push( ctrl );

        if ( ctrl.number == 0) {
          ctrl._open = true;
        }

        if ( vm.totalElements == vm.elementList.length ) {
          if ( vm.callback ) {
            $timeout( vm.callback( vm ), 0);
          }
        }
      }

      vm.moveToNext = function() {
        vm.elementList[vm.currentIndex]._done = true;
        vm.elementList[vm.currentIndex]._open = false;

        for ( var i = vm.currentIndex + 1; i < vm.elementList.length; i++ ) {
          if ( vm.elementList[i].isVisible() ) {

            vm.elementList[i].onOpen();
            break;
          }
        }
      }

      vm.moveBack = function( ) {
        var start = vm.currentIndex;
        vm.elementList[vm.currentIndex]._open = false;

        for ( var i = vm.currentIndex - 1; i >= 0; i-- ) {
          if ( vm.elementList[i].isVisible() ) {

            vm.elementList[i].onOpen();
            break;
          }
        }

        return vm.currentIndex == start;
      }

      vm.setCurrent = function( index ) {
        vm.elementList[vm.currentIndex]._done = true;
        vm.elementList[vm.currentIndex]._open = false;
        vm.elementList[index].onOpen();
      }

      vm.setNumbers = function() {
        var count = 0;
        vm.elementList.forEach(function( item ) {
          if ( item.isVisible() ) {
            item.number = count++;
          }
        });
      }

      vm.closeAll = function( openIndex ) {
        for ( var i = 0; i < vm.elementList.length; i++ ) {
          vm.elementList[i]._open = (openIndex != undefined && openIndex == i);
        }
        if ( openIndex != undefined ) vm.currentIndex = openIndex;
      }
    }
  }

  function yaStepperItem() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/stepper/ya-stepper-item.html',
      transclude: true,
      require: '^yaStepper',
      scope: { title:'@title', open: '=?open', active: '=?active', done: '=?done', visible: '=?visible' },
      controller: StepperItemController,
      controllerAs: 'vm',
      bindToController: true,
      link: function(scope, element, attrs, ctrl) {
        scope.vm.parent = ctrl;
        ctrl._addItem( scope.vm );
      }
    };
    return directive;

    function StepperItemController() {
      var vm = this;
      vm.number = 0;
      vm.index = 0;

      if ( vm.open == undefined ) vm._open = false;
      else vm._open = vm.open;
      if ( vm.active == undefined ) vm._active = true;
      else vm._active = vm.active;
      if ( vm.done == undefined ) vm._done = false;
      else vm._done = vm.done;
      if ( vm.visible == undefined ) vm._visible = true;
      else vm._visible = vm.visible;

      vm.onOpen = function() {
        if ( !vm.isOpen() && vm.isVisible() ) {
          vm._active = true;
          vm.parent.closeAll( vm.index );
        }
      }

      vm.onTouched = function() {
        if ( vm.isActive() && !vm.isOpen()) {
          vm.parent.closeAll( vm.index );
        }
      }

      vm.isOpen = function() {
        return vm._open;
      }

      vm.isDone = function() {
        return vm._done;
      }

      vm.isActive = function() {
        return vm._active;
      }

      vm.isVisible = function() {
        return vm._visible;
      }

      vm.setup = function( isvisible, isactive, isdone ) {
        vm._visible = isvisible;
        vm._done = isdone;
        vm._active = isactive;
      }
    }
  }

})();
(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaSelectCard', yaSelectCard);

  function yaSelectCard() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/select-card/ya-select-card.html',
      scope: { data: '=data', parent: '=parent', page: '=page' },
      controller: SelectCardController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;
    /** @ngInject */
    function SelectCardController( ) {
      var vm = this;

      vm.onCreate = function() {
        if ( vm.parent && vm.parent.onCreate )
          vm.parent.onCreate();
      }

      vm.onSelect = function() {
        if ( vm.parent && vm.parent.onSelect )
          vm.parent.onSelect(vm.data);
      }
    }
  }
})();
(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaMsgScheduleRebudget', yaMsgScheduleRebudget);

  function yaMsgScheduleRebudget($rootScope) {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/msg-schedule-rebudget/ya-msg-schedule-rebudget.html',
      scope: { tempid: '=tempid' },
      controller: MsgScheduleRebudgetController,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function MsgScheduleRebudgetController($scope, MsgService) {
      var vm = this;
      vm.maxBudget = 0;
      vm.totalBudget = 0;
      vm.currentBudget = 0;

      var MonthNames = [
        'Jan', 'Feb', 'Mar',
        'Apr', 'May', 'Jun', 'Jul',
        'Aug', 'Sep', 'Oct',
        'Novr', 'Dec'];
      /*
			var DayNames = [
				"Sun", "Mon", "Tue", "Wed",
				"Thu", "Fri", "Sat"
			]*/


      vm.LoadData = function() {
        var id = vm.tempid;
        var data = MsgService.getQueuedByID( id );
        vm.scheduledList = data.list;
        vm.scheduledList.forEach(function(date) {
          date.start = MonthNames[date.localSendTime.getMonth()] + ' ' + date.localSendTime.getDate().toString() + ' ' + date.localSendTime.getFullYear();
          date.end = MonthNames[date.localEndTime.getMonth()] + ' ' + date.localEndTime.getDate().toString() + ' ' + date.localEndTime.getFullYear();
        });

        vm.totalBudget = 0;
        vm.scheduledList.forEach(function(d) {
          vm.totalBudget += d.maxbudget;
        });
      }

      vm.SetBudget = function(data) {
        MsgService.setMaxBudgetInstance(data, function() {
          vm.LoadData();
        });
      }

      vm.Delete = function(data) {
        MsgService.deleteQueued(data, function() {
          vm.LoadData();
          $rootScope.$emit('item.delete');
        });
        /*ScheduleService.delete(data,function(){
					vm.LoadData();
					$rootScope.$emit('item.delete');
				});*/
      }

      vm.pageready = $rootScope.$on('page.ready', function() {
        vm.LoadData();
      });

      $scope.$on('$destroy', function UnLoaded() {
        vm.pageready();
      });
    }
  }
})();
(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaMsgScheduleList', yaMsgScheduleList);

  function yaMsgScheduleList() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/msg-schedule-list/ya-msg-schedule-list.html',
      scope: { },
      controller: MsgScheduleListController,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function MsgScheduleListController($rootScope, $scope, ScheduleService) {
      var vm = this;

      var MonthNames = [
        'Jan', 'Feb', 'Mar',
        'Apr', 'May', 'Jun', 'Jul',
        'Aug', 'Sep', 'Oct',
        'Novr', 'Dec'];
      /*
			var DayNames = [
				"Sun", "Mon", "Tue", "Wed",
				"Thu", "Fri", "Sat"
			]*/


      vm.LoadData = function() {
        vm.scheduledList = ScheduleService.getList();
        vm.scheduledList.forEach(function(date) {
          date.start = MonthNames[date.senddate.getMonth()] + ' ' + date.senddate.getDate().toString() + ' ' + date.senddate.getFullYear();
          date.end = MonthNames[date.expirationdate.getMonth()] + ' ' + date.expirationdate.getDate().toString() + ' ' + date.expirationdate.getFullYear();
        })
      }

      vm.Delete = function(data) {
        ScheduleService.delete(data, function() {

        });
      }

      vm.pageready = $rootScope.$on('page.ready', function() {
        vm.LoadData();
      });

      $scope.$on('$destroy', function UnLoaded() {
        vm.pageready();
      });
    }
  }
})();
(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaMsgScheduleBudget', yaMsgScheduleBudget);

  function yaMsgScheduleBudget($rootScope) {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/msg-schedule-budget/ya-msg-schedule-budget.html',
      scope: { },
      controller: MsgScheduleBudgetController,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function MsgScheduleBudgetController($scope, ScheduleService, MsgService) {
      var vm = this;
      vm.maxBudget = 0;
      vm.totalBudget = 0;
      vm.currentBudget = 0;

      var MonthNames = [
        'Jan', 'Feb', 'Mar',
        'Apr', 'May', 'Jun', 'Jul',
        'Aug', 'Sep', 'Oct',
        'Novr', 'Dec'];
      /*
			var DayNames = [
				"Sun", "Mon", "Tue", "Wed",
				"Thu", "Fri", "Sat"
			]*/


      vm.LoadData = function() {
        vm.scheduledList = ScheduleService.getList();
        var msg = MsgService.get();
        if (msg) {
          vm.currentBudget = vm.maxBudget = msg.maxbudget;
          vm.totalBudget = vm.maxBudget * vm.scheduledList.length;
        }
        vm.scheduledList.forEach(function(date) {
          date.start = MonthNames[date.senddate.getMonth()] + ' ' + date.senddate.getDate().toString() + ' ' + date.senddate.getFullYear();
          date.end = MonthNames[date.expirationdate.getMonth()] + ' ' + date.expirationdate.getDate().toString() + ' ' + date.expirationdate.getFullYear();
        });
      }

      vm.SetBudget = function() {
        vm.currentBudget = vm.maxBudget;
        var msg = MsgService.get();
        if (msg) msg.maxbudget = vm.maxBudget;
        MsgService.register(function() {
          vm.totalBudget = vm.maxBudget * vm.scheduledList.length;
        });
      }

      vm.Delete = function(data) {
        ScheduleService.delete(data, function() {
          vm.LoadData();
          $rootScope.$emit('item.delete');
        });
      }

      vm.pageready = $rootScope.$on('page.ready', function() {
        vm.LoadData();
      });

      $scope.$on('$destroy', function UnLoaded() {
        vm.pageready();
      });
    }
  }
})();
(function() {
  'use strict';


  angular.module('youApp')
  .directive('yaMsgSchedule', yaMsgSchedule);

  function yaMsgSchedule() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/msg-schedule/ya-msg-schedule.html',
      scope: { },
      controller: MsgScheduleController,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function MsgScheduleController($rootScope, $timeout, $scope, ScheduleService) {
      var vm = this;
      var d = new Date();
      vm.date = d;
      vm.monthList = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'];
      vm.yearList = [];
      vm.sendByList = [
        'Send Now',
        'Before 10:30am',
        'Before 4:30pm',
        'Before 7:30pm'
      ];
      vm.expirationList = [
        '1', '7', '14', '30'
      ];

      for ( var i = 0; i < 20; i++)
        vm.yearList.push( (vm.date.getFullYear() + i).toString() );

      vm.sendBy = vm.sendByList[0];
      vm.expiration = vm.expirationList[0];
      vm.month = vm.monthList[d.getMonth()];
      vm.year = d.getFullYear().toString();

      vm.SelectToday = function() {
        vm.date = d;
      }

      vm.ScheduleItem = function() {
        var start = new Date(vm.date);
        start.setSeconds(0);
        switch ( vm.sendBy ) {
        case 'First Out':
          start.setMinutes(1);
          start.setHours(0);
          break;
        case 'Before 10:30am':
          start.setMinutes(30);
          start.setHours(10);
          break;
        case 'Before 4:30pm':
          start.setMinutes(30);
          start.setHours(16);
          break;
        case 'Before 7:30pm':
          start.setMinutes(30);
          start.setHours(19);
          break;
        }
        var end = new Date( vm.date );
        end.setDate( end.getDate() + parseInt(vm.expiration) );
        end.setSeconds(0);
        end.setMinutes(59);
        end.setHours(23); // end at 11:59pm
        ScheduleService.add(start, end, vm.sendBy, function() {
          $timeout(function() {
            $rootScope.$emit('page.ready');
          }, 100);
        });
      }

      vm.checkDate = function() {
        if ( vm.date < d) {
          vm.date = d;
        }
      }

      vm.Change = function() {
        vm.date = new Date( vm.month + ' 1, ' + vm.year);
      }

      vm.LoadData = function() {

      }

      vm.pageready = $rootScope.$on('page.ready', function() {
        vm.LoadData();
      });

      $scope.$on('$destroy', function() {
        vm.pageready();
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('youApp').directive('yaMsgRecipients',yaMsgRecipients);

  function yaMsgRecipients() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/msg-recipients/ya-msg-recipients.html',
      scope: {
        parent: '=parent',
        type: '=type'
      },
      controller: yaMsgRecipientController,
      controllerAs: 'vmp',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function yaMsgRecipientController(
      $log,
      $scope,
      $rootScope,
      $routeParams,
      $uibModal,
      $document,
      $timeout,
      MsgService,
      OrgCatService,
      ScheduleService,
      OrganizationService,
      StateService,
      MessageBoxService,
      CalculateApproval,
      OrgBillingService,
      $window,
      IdenticardService,
      DmpService,
      DashboardGroupService,
      RrmsService
    ) {
      var vm = this;
      vm.tempID = $routeParams.tempID;
      vm.orgID = $routeParams.orgID;
      vm.organization = null;
      var isEditor = vm.type.indexOf('edit') > -1;
      var isCalculate = vm.type.indexOf('calc') > -1;
      vm.isEmergencyCenterAvailable = false;
      vm.isAccessControlEnabled = false;
      vm.isRemoteMonitoringEnabled = false;
      vm.isRRMSEnabled = false;
      vm.enablequickresponse = false;
      vm.enablebrightpattern = false;
      vm.isExcelReportingEnabled = false;
      vm.IdenticardBuildings = null;
      vm.isEmergency = false;
      vm.coords = {};

      vm.responseTemplates = [];

      var handler;

      vm.IdenticardStatusCodes = IdenticardService.StatusCodes();

      if ($window.navigator && $window.navigator.geolocation) {
        handler = function(position) {
          vm.coords = position.coords;
        };
        $window.navigator.geolocation.getCurrentPosition(handler);
      }

      if ($window.navigator && $window.navigator.geolocation) {
        handler = function(position) {
          vm.coords = position.coords;
        };
        $window.navigator.geolocation.getCurrentPosition(handler);
      } else {
        //no geolocation support, no lat / lng
        vm.coords = {
          latitude: null,
          longitude: null
        };
      }

      vm.LoadData = function() {
        vm.data = MsgService.get();
        vm.isEmergency = vm.data.isemergency;
        vm.catList = OrgCatService.get(true);
        vm.groupList = OrgCatService.get(false);
        vm.selectAllCats = false;
        vm.selectAllGroups = false;
        vm.selectedCats = [];
        vm.selectedGroups = [];
        vm.sendfrommessagereport = vm.data.sendfrommessagereport;
        vm.textalert = vm.data.textalert;
        vm.emailalert = vm.data.emailalert;
        vm.shriactivation = vm.data.shriactivation;
        vm.nexttemplateSender = vm.data.nexttemplateSender;
        vm.alertTemplateList = [];
        vm.nexttemplateid = null;
        vm.selectAllAssist = false;
        vm.selectedAssist = [];
        vm.dashboardGroups = [];
        vm.selectedDashboardGroups = {};
        vm.isSchool = (OrganizationService.getIndustry() === 1); // school
        vm.followers = vm.data.followers;
        vm.responsetemplateid = null;

        if (vm.type == 'alertedit') {

          MsgService.getAllParentTemplates('alert', vm.tempID, function(error, data) {
            vm.alertTemplateList = data;
          });


          OrganizationService.isEmergencyCenterActive(vm.orgID, function(err, isActive) {
            vm.isEmergencyCenterAvailable = isActive;
            if (!vm.isEmergencyCenterAvailable) {
              vm.isEmergency = false;
            }
          });

          DashboardGroupService.load().then(function(dashboardGroups) {
            vm.dashboardGroups = dashboardGroups;
          });

          OrganizationService.loadByID(vm.orgID, function() {
            vm.organization = OrganizationService.get();

            MsgService.getAlertsByStatus('ready').then(function(messages) { vm.responseTemplates = messages; });

            if (vm.organization.enableaccesscontrol) {
              vm.isAccessControlEnabled = true;

              IdenticardService.GetBuildings(vm.orgID).then(function(identicardBuildings) {
                vm.IdenticardBuildings = identicardBuildings;
              });
            }
            if (vm.organization.enableremotemonitoring) {
              vm.isRemoteMonitoringEnabled = true;

              DmpService.GetZoneList(vm.orgID).then(function(dmpZones) {
                vm.dmpzones = dmpZones;
              });

              DmpService.GetActiveAlerts().then(function(dmpAlerts) {
                vm.dmpalerts = dmpAlerts;
              });

              DmpService.GetAlertTypes().then(function(dmpAlertTypes) {
                vm.dmpalerttypes = dmpAlertTypes;
              });
            }
            vm.isExcelReportingEnabled = !!vm.organization.excelreporting;

            if (vm.organization.enablerrms) {
              vm.isRRMSEnabled = true;
              window.RrmsService = RrmsService;
              RrmsService.GetAlerts().then(function(rrmsAlertTypes) {
                vm.rrmsalerttypes = rrmsAlertTypes;
              });
            }
            vm.enablequickresponse = vm.organization.enablequickresponse;
            vm.enablebrightpattern = vm.organization.enablebrightpattern;
          });
        }

        $timeout(function() {
          if (vm.data) {
            var image = $document[0].getElementById('preview');
            if (image)
              image.src = vm.data.previewurl;
          }
          $scope.$apply();
          $log.debug(vm.catList);
        }, 1000);

        var i = 0;
        var a = 0;
        for (i = 0; i < vm.catList.length; i++) {
          vm.selectedCats[i] = false;
        }
        for (i = 0; i < vm.groupList.length; i++) {
          vm.selectedGroups[i] = false;
          // For Assist
          vm.selectedAssist[i] = false;
        }

        var catIds = (vm.data) ? vm.data.catlist : [];
        var groupCount = 0;
        var catCount = 0;
        for (i = 0; i < catIds.length; i++) {
          for (a = 0; a < vm.catList.length; a++) {
            if (vm.catList[a].id === catIds[i]) {
              vm.selectedCats[a] = true;
              catCount++;
              break;
            }
          }
          for (a = 0; a < vm.groupList.length; a++) {
            if (vm.groupList[a].id === catIds[i]) {
              vm.selectedGroups[a] = true;
              groupCount++;
              break;
            }
          }
        }

        var asisitIds = (vm.data && vm.data.assistlist) ? vm.data.assistlist : [];
        var assistCount = 0;
        for (i = 0; i < asisitIds.length; i++) {
          for (a = 0; a < vm.groupList.length; a++) {
            if (vm.groupList[a].id === asisitIds[i]) {
              vm.selectedAssist[a] = true;
              assistCount++;
              break;
            }
          }
        }


        if (vm.data && vm.data.dashboardgroups) {
          vm.data.dashboardgroups.forEach(function(d) {
            vm.selectedDashboardGroups[d] = true;
          });
        }

        vm.selectAllCats = catCount === vm.catList.length;
        vm.selectAllGroups = groupCount === vm.groupList.length;
        vm.selectAllAssist = assistCount === vm.groupList.length;


        vm.delay = (vm.data) ? vm.data.delay : '0';
        vm.nexttemplateid = (vm.data) ? vm.data.nexttemplateid : null;

        vm.templateid = vm.data ? vm.data.id : null;

        vm.isidenticard = vm.data ? vm.data.isidenticard : false;
        vm.isdmp = vm.data ? vm.data.isdmp : false;
        vm.dmpzonecode = vm.data ? vm.data.dmpzonecode : '';
        vm.dmpalertcode = vm.data ? vm.data.dmpalertcode : '';
        vm.dmpalerttype = vm.data ? vm.data.dmpalerttype : 'Za';
        vm.isdmpreceive = vm.data ? vm.data.isdmpreceive : false;
        vm.isrrms = vm.data ? vm.data.isrrms : false;
        vm.isenablequickresponse = vm.data ? vm.data.isenablequickresponse : false;
        vm.isenablebrightpattern = vm.data ? vm.data.isenablebrightpattern : false;
        vm.rrmsalerttype = vm.data ? vm.data.rrmsalerttype : '';
        vm.responsetemplateid = vm.data ? vm.data.responsetemplateid : null;

        vm.identicardbuildings = {};
        vm.dmpzones = [];
        vm.dmpalerts = [];
        vm.dmpalerttypes = [];

        try {
          var identicardbuildings = angular.fromJson(vm.data.identicardbuildings);
          identicardbuildings = _.fromPairs(_.map(identicardbuildings, function(buildingid) {
            return ['building_' + buildingid, true];
          }));
          vm.identicardbuildings = identicardbuildings;
        } catch (err) {
          vm.identicardbuildings = {};
        }
        vm.identicardbuildingstatus = vm.data ? vm.data.identicardbuildingstatus : '';
      };

      vm.toggleCats = function() {
        for (var c = 0; c < vm.selectedCats.length; c++)
          vm.selectedCats[c] = !vm.selectAllCats;
      };

      // vm.UpdateChildTemplate = function() {
      //   vm.nexttemplateid = null
      //   alert(111)
      // }

      vm.toggleGroups = function() {
        for (var c = 0; c < vm.selectedGroups.length; c++)
          vm.selectedGroups[c] = !vm.selectAllGroups;
      };

      vm.toggleAssist = function() {
        for (var c = 0; c < vm.selectedAssist.length; c++)
          vm.selectedAssist[c] = !vm.selectAllAssist;
      };

      vm.toggleReminder = function() {
        for (var c = 0; c < vm.reminderList.length; c++)
          vm.reminderList[c].active = !vm.selectAllReminders;
      };

      vm.setUp = function() {
        var cat = [];
        var assist = [];
        var i = 0;
        for (i = 0; i < vm.selectedCats.length; i++) {
          if (vm.selectedCats[i]) cat.push(vm.catList[i].id);
        }
        for (i = 0; i < vm.selectedGroups.length; i++) {
          if (vm.selectedGroups[i]) cat.push(vm.groupList[i].id);
        }
        for (i = 0; i < vm.selectedAssist.length; i++) {
          if (vm.selectedAssist[i]) assist.push(vm.groupList[i].id);
        }
        var identicardbuildings = [];
        _.each(vm.identicardbuildings, function(enabled, buildkey) {
          if (enabled) {
            identicardbuildings.push(buildkey.replace('building_', ''));
          }
        });

        var dashboardgroups = vm.dashboardGroups.reduce(function(dashboardgroups, dashboardgroup) {
          if (vm.selectedDashboardGroups[dashboardgroup.id]) {
            dashboardgroups.push(dashboardgroup.id);
          }
          return dashboardgroups;
        }, []);

        MsgService.set({
          catlist: cat,
          assistlist: assist,
          sendfrommessagereport: vm.sendfrommessagereport,
          textalert:vm.textalert,
          emailalert:vm.emailalert,
          shriactivation:vm.shriactivation,
          nexttemplateSender:vm.nexttemplateSender,
          nexttemplateid:vm.nexttemplateid,
          delay: vm.delay,
          isidenticard: vm.isidenticard,
          identicardbuildingstatus: vm.identicardbuildingstatus,
          identicardbuildings: identicardbuildings,
          isdmp: vm.isdmp,
          dmpzonecode: vm.dmpzonecode,
          dmpalertcode: vm.dmpalertcode,
          dmpalerttype: vm.dmpalerttype,
          isdmpreceive: vm.isdmpreceive,
          dashboardgroups: dashboardgroups,
          followers: vm.followers,
          responsetemplateid: vm.responsetemplateid,
          isrrms: vm.isrrms,
          isenablequickresponse: vm.isenablequickresponse,
          isenablebrightpattern: vm.isenablebrightpattern,
          rrmsalerttype: vm.rrmsalerttype,
        });
      };

      vm.Done = function() {
        if (vm.type === 'alertedit') {
          var dashboardgroups = (vm.dashboardGroups || []).reduce(function(dashboardgroups, dashboardgroup) {
            if (vm.selectedDashboardGroups[dashboardgroup.id]) {
              dashboardgroups.push(dashboardgroup.id);
            }
            return dashboardgroups;
          }, []);

          if (!dashboardgroups.length) {
            MessageBoxService.open(
              'No Dashboard Group',
              'There were no Dashboard Group selected. Please select a Dashboard Group',
              'Continue',
              function() { }
            );
            return;
          }
        }

        vm.setUp();
        if (isEditor) {
          $rootScope.$emit('editor.save', {
            cb: vm.DoneCallback,
          });
        } else {
          vm.DoneCallback();
        }
      };

      vm.DoneCallback = function() {
        if (!vm.isEmergencyCenterAvailable) {
          vm.isEmergency = false;
        }
        MsgService.set({ isemergency: vm.isEmergency });
        MsgService.save(function(response) {
          if (response === 'approval') {
            StateService.go('approval');
          } else {
            vm.parent.onDone();
          }
        });
      };

      vm.canContinue = function() // only used for caluculate and schedule pages
      {
        var length = ScheduleService.getList().length;
        return (length > 0) && (isCalculate && CalculateApproval.getApproval() || !isCalculate);
      };

      vm.Schedule = function() {
        vm.setUp();
        if (isEditor)
          $rootScope.$emit('editor.save', { cb: vm.ScheduleCallback });
        else
          vm.ScheduleCallback();
      };

      vm.ScheduleCallback = function() {
        MsgService.register(function(error) {
          if (error === null) {
            if (vm.parent && vm.parent.onSchedule)
              vm.parent.onSchedule();
          }
        });
      };

      vm.Send = function() {
        if (vm.canContinue()) {
          vm.setUp();
          if (isEditor)
            $rootScope.$emit('editor.save', { cb: vm.SendCallback });
          else
            vm.SendCallback();
        } else {
          MessageBoxService.open(
            'Accept Terms',
            'Please check the box to agree to the order',
            'Continue',
            function() { }
          );
        }
      };

      vm.AlertSend = function() {
        vm.setUp();
        if (isEditor)
          $rootScope.$emit('editor.save', {
            cb: vm.SendCallback
          });
        else
          vm.SendCallback();
      };

      vm.SendCallback = function() {
        vm.noerror = true;
        vm.selectedGroups.forEach(function(group, index) {
          if (group === true) {
            if (vm.groupList[index].membercount === 0) {
              vm.noerror = false;
              MessageBoxService.open(
                'No Recipients in Group',
                'There were no recipient group users in ' + vm.groupList[index].name + '. Please select a different recipient group',
                'Continue',
                function() { }
              );
            }
          }
        });
        if (vm.noerror === true && vm.type === 'alertedit') {
          vm.popup = $uibModal.open({
            templateUrl: 'app/popups/confirmsend/confirmsend.html',
            controller: 'ConfirmSend.Controller as vm',
            windowClass: 'template-box',
            scope: $scope
          });
        } else {
          vm.finish();
        }
      };

      vm.finish = function() {
        OrgBillingService.checkIfExists(vm.orgID, function(result) {
          if (result === false) {
            // No Billing Info, need to do something
          }
          // if (result === false) {
          //   MessageBoxService.open(
          //     'No Billing Info', 'Please update your billing information in your profile',
          //     'Okay',
          //     function() {}
          //   );
          // } else {
          if (!vm.isEmergencyCenterAvailable) {
            vm.isEmergency = false;
          }
          MsgService.set({ isemergency: vm.isEmergency });
          MsgService.save(function() {
            var info = null;
            if (isCalculate) {
              info = CalculateApproval.getSendData();
              info.userlat = vm.coords.latitude;
              info.userlng = vm.coords.longitude;
            }
            if (vm.type == 'alertedit') {
              info = info || {};
              info.isEmergency = vm.isEmergency;
              info.userlat = vm.coords.latitude;
              info.userlng = vm.coords.longitude;
            }
            MsgService.send(info, function(response, message) {
              if (message) {
                MessageBoxService.open(
                  'Send Error',
                  message,
                  'Continue',
                  function() { }
                );
              } else if (response === 'approval') {
                StateService.go('approval');
              } else if (vm.parent && vm.parent.onSend) {
                vm.parent.onSend();
              }
            });
          });
          // }
        });
      };

      vm.Calculate = function() {
        vm.setUp();
        if (isEditor)
          $rootScope.$emit('editor.save', { cb: vm.CalculateCallback });
        else
          vm.CalculateCallback();
      };

      vm.CalculateCallback = function() {
        MsgService.register(function(error) {
          if (error === null) {
            if (vm.parent && vm.parent.onCalculate)
              vm.parent.onCalculate();
          }
        });
      };

      vm.IdenticardStatus = function(statusCode) {
        return IdenticardService.Status(statusCode);
      };

      // vm.IdenticardSetBuilding = function(buildingid, status) {
      //   loadingScreen.turnOn(true);
      //   return IdenticardService.SetBuilding(vm.orgID, buildingid, status)
      //   .then(function(rslt) {
      //     loadingScreen.turnOn(false);
      //     if (rslt.buildings) {
      //       vm.IdenticardBuildings = rslt.buildings;
      //     }
      //   });
      // };

      vm.savetemplate = $rootScope.$on('save.template', function(event, data) {
        var image = $document[0].getElementById('preview');
        image.src = data;
      });

      vm.pageready = $rootScope.$on('page.ready', function() {
        vm.LoadData();
      });

      $scope.$on('$destroy', function UnLoaded() {
        vm.pageready();
        vm.savetemplate();
      });


    }
  }

})();

(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaMsgPreview', yaMsgPreview);

  function yaMsgPreview() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/msg-preview/ya-msg-preview.html',
      scope: { parent: '=parent', type: '=type'},
      controller: yaMsgPreviewController,
      controllerAs: 'vmp',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function yaMsgPreviewController($log, $scope, $rootScope, $routeParams, $uibModal, $document, $timeout, MsgService, OrgCatService, ScheduleService, OrganizationService, StateService, MessageBoxService, CalculateApproval, OrgBillingService, $window) {
      var vm = this;
      vm.tempID = $routeParams.tempID;
      vm.orgID = $routeParams.orgID;
      var isEditor = vm.type.indexOf('edit') > -1;
      var isCalculate = vm.type.indexOf('calc') > -1;
      vm.isEmergencyCenterAvailable = false;
      vm.isEmergency = false;
      vm.coords = {};

      if ($window.navigator && $window.navigator.geolocation) {
        var handler = function(position) {
          vm.coords = position.coords;
        };
        $window.navigator.geolocation.getCurrentPosition(handler);
      } else {
        //no geolocation support, no lat / lng
        vm.coords = {
          latitude: null,
          longitude: null
        };
      }

      vm.LoadData = function() {
        vm.data = MsgService.get();
        vm.isEmergency = vm.data.isemergency;
        vm.catList = OrgCatService.get(true);
        vm.groupList = OrgCatService.get(false);
        vm.selectAllCats = false;
        vm.selectAllGroups = false;
        vm.selectedCats = [];
        vm.selectedGroups = [];
        vm.isSchool = ( OrganizationService.getIndustry() === 1); // school
        if (vm.type == 'alertedit') {
          OrganizationService.isEmergencyCenterActive(vm.orgID, function(err, isActive) {
            vm.isEmergencyCenterAvailable = isActive;
            if (!vm.isEmergencyCenterAvailable) {
              vm.isEmergency = false;
            }
          });
        }


        $timeout(function() {
          if ( vm.data ) {
            var image = $document[0].getElementById('preview');
            if ( image )
              image.src = vm.data.previewurl;
          }
          $scope.$apply();
          $log.debug(vm.catList);
        }, 1000);

        var i = 0;
        var a = 0;
        for ( i = 0; i < vm.catList.length; i++ ) {
          vm.selectedCats[i] = false;
        }
        for ( i = 0; i < vm.groupList.length; i++ ) {
          vm.selectedGroups[i] = false;
        }

        var catIds = (vm.data) ? vm.data.catlist : [];
        var groupCount = 0;
        var catCount = 0;
        for (i = 0; i < catIds.length; i++) {
          for ( a = 0; a < vm.catList.length; a++ ) {
            if ( vm.catList[a].id === catIds[i]) {
              vm.selectedCats[a] = true;
              catCount++;
              break;
            }
          }
          for ( a = 0; a < vm.groupList.length; a++ ) {
            if ( vm.groupList[a].id === catIds[i]) {
              vm.selectedGroups[a] = true;
              groupCount++;
              break;
            }
          }
        }

        vm.selectAllCats = catCount === vm.catList.length;
        vm.selectAllGroups = groupCount === vm.groupList.length;

        vm.delay = (vm.data) ? vm.data.delay : '0';
      };

      vm.toggleCats = function() {
        for ( var c = 0; c < vm.selectedCats.length; c++)
          vm.selectedCats[c] = !vm.selectAllCats;
      };

      vm.toggleGroups = function() {
        for ( var c = 0; c < vm.selectedGroups.length; c++)
          vm.selectedGroups[c] = !vm.selectAllGroups;
        vm.isEmergency = !vm.isEmergency;
      };

      vm.toggleReminder = function() {
        for ( var c = 0; c < vm.reminderList.length; c++)
          vm.reminderList[c].active = !vm.selectAllReminders;
      };

      vm.setUp = function() {
        var cat = [];
        var i = 0;
        for ( i = 0; i < vm.selectedCats.length; i++) {
          if ( vm.selectedCats[i] ) cat.push(vm.catList[i].id);
        }
        for ( i = 0; i < vm.selectedGroups.length; i++) {
          if ( vm.selectedGroups[i] ) cat.push(vm.groupList[i].id);
        }
        MsgService.set({catlist: cat, delay: vm.delay});

      };

      vm.Done = function() {
        vm.setUp();
        if ( isEditor )
          $rootScope.$emit('editor.save', {cb: vm.DoneCallback });
        else
          vm.DoneCallback();
      };

      vm.DoneCallback = function() {
        if (!vm.isEmergencyCenterAvailable) {
          vm.isEmergency = false;
        }
        MsgService.set({isemergency: vm.isEmergency});
        MsgService.save(function(response) {
          if ( response === 'approval' ) {
            StateService.go('approval');
          } else {
            vm.parent.onDone();
          }
        });
      };

      vm.canContinue = function() // only used for caluculate and schedule pages
      {
        var length = ScheduleService.getList().length;
        return ( length > 0 ) && (isCalculate && CalculateApproval.getApproval() || !isCalculate);
      };

      vm.Schedule = function() {
        vm.setUp();
        if ( isEditor )
          $rootScope.$emit('editor.save', {cb: vm.ScheduleCallback });
        else
          vm.ScheduleCallback();
      };

      vm.ScheduleCallback = function() {
        MsgService.register(function(error) {
          if ( error === null ) {
            if ( vm.parent && vm.parent.onSchedule )
              vm.parent.onSchedule();
          }
        });
      };

      vm.Update = function() {
        if ( isEditor )
          $rootScope.$emit('editor.update', {});
      };

      vm.Send = function() {
        if (vm.canContinue()) {
          vm.setUp();
          if ( isEditor )
            $rootScope.$emit('editor.save', {cb: vm.SendCallback });
          else
            vm.SendCallback();
        } else {
          MessageBoxService.open('Accept Terms', 'Please check the box to agree to the order', 'Continue', function() { });
        }
      };

      vm.AlertSend = function() {

        vm.setUp();
        if ( isEditor )
          $rootScope.$emit('editor.save', {cb: vm.SendCallback });
        else
          vm.SendCallback();
      };

      vm.SendCallback = function() {
        vm.noerror = true;
        vm.selectedGroups.forEach(function(group, index) {
          if (group === true) {
            if (vm.groupList[index].membercount === 0) {
              vm.noerror = false;
              MessageBoxService.open('No Recipients in Group', 'There were no recipient group users in ' + vm.groupList[index].name + '. Please select a different recipient group', 'Continue', function() {});
            }
          }
        });
        if (vm.noerror === true && vm.type === 'alertedit') {
          vm.popup = $uibModal.open({
            templateUrl: 'app/popups/confirmsend/confirmsend.html',
            controller: 'ConfirmSend.Controller as vm',
            windowClass: 'template-box',
            scope: $scope
          });
        } else {
          vm.finish();
        }
      };

      vm.finish = function() {
        OrgBillingService.checkIfExists(vm.orgID, function() {
        // OrgBillingService.checkIfExists(vm.orgID, function(result) {
          // if (result === false) {
          //   MessageBoxService.open('No Billing Info', 'Please update your billing information in your profile', 'Okay', function() {});
          // } else {
          if (!vm.isEmergencyCenterAvailable) {
            vm.isEmergency = false;
          }
          MsgService.set({isemergency: vm.isEmergency});
          MsgService.save(function() {
            var info = null;
            if ( isCalculate ) {
              info = CalculateApproval.getSendData();
            }
            if (vm.type == 'alertedit') {
              info = info || {};
              info.isEmergency = vm.isEmergency;
            }
            vm.coords = vm.coords || {};
            info.userlat = vm.coords.latitude;
            info.userlng = vm.coords.longitude;
            MsgService.send(info, function(response, message) {
              if ( message ) {
                MessageBoxService.open('Send Error', message, 'Continue', function() { });
              } else if ( response === 'approval') {
                StateService.go('approval');
              } else if ( vm.parent && vm.parent.onSend ) {
                vm.parent.onSend();
              }
            });
          });
          // }
        });
      };

      vm.Calculate = function() {
        vm.setUp();
        if ( isEditor )
          $rootScope.$emit('editor.save', {cb: vm.CalculateCallback });
        else
          vm.CalculateCallback();
      };

      vm.CalculateCallback = function() {
        MsgService.register(function(error) {
          if ( error === null ) {
            if ( vm.parent && vm.parent.onCalculate )
              vm.parent.onCalculate();
          }
        });
      };

      vm.savetemplate = $rootScope.$on('save.template', function(event, data) {
        var image = $document[0].getElementById('preview');
        image.src = data;
      });

      vm.pageready = $rootScope.$on('page.ready', function() {
        vm.LoadData();
      });

      $scope.$on('$destroy', function UnLoaded() {
        vm.pageready();
        vm.savetemplate();
      });
    }
  }

})();

(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaMsgCreateNew', yaMsgCreateNew);

  function yaMsgCreateNew() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/msg-create-new/ya-msg-create-new.html',
      scope: { parent: '=parent', type: '@type'},
      controller: yaMsgCreateController,
      controllerAs: 'vmp',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function yaMsgCreateController($log, $scope, $rootScope, $routeParams) {
      var vm = this;
      vm.tempID = $routeParams.tempID;
      vm.orgID = $routeParams.orgID;

      vm.onNew = function() {
        if ( vm.parent && vm.parent.onNewMSG )
          vm.parent.onNewMSG( );
      }

      vm.onTemplate = function() {
        if ( vm.parent && vm.parent.onTemplatePicker )
          vm.parent.onTemplatePicker( );
      }

      $scope.$on('$destroy', function UnLoaded() {

      });
    }
  }

})();
(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaMsgCreateTemplate', yaMsgCreateTemplate);

  function yaMsgCreateTemplate() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/msg-create-template/ya-msg-create-template.html',
      scope: { parent: '=parent'},
      controller: yaMsgCreateTempController,
      controllerAs: 'vmp',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function yaMsgCreateTempController($log, $scope, $rootScope, $routeParams) {
      var vm = this;
      vm.tempID = $routeParams.tempID;
      vm.orgID = $routeParams.orgID;

      vm.onCreate = function() {
        if ( vm.parent && vm.parent.onCreate )
          vm.parent.onCreate( );
      }

      $scope.$on('$destroy', function UnLoaded() {

      });
    }
  }

})();
/*eslint angular/no-private-call: [2,{"allow":["$$childHead"]}]*/

(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaMsgCarousel', yaMsgCarousel);

  function yaMsgCarousel() {

    var directive = {
      restrict: 'EA',
      templateUrl: 'app/components/msg-carousel/ya-msg-carousel.html',
      scope: { data: '=data', parent: '=parent', name: '@name', select: '='},
      controller: MsgCarouselController,
      //require: 'carousel',
      controllerAs: 'vmp',
      bindToController: true
      //link: function (scope, element, attributes, controller) {
      /*scope.vmp.carouselScope = scope.control || {};

	          scope.vmp.carouselScope.next = function() {
	            scope.next();
	          };

	          scope.vmp.carouselScope.prev = function() {
	            scope.prev();
	          };
	        }*/
    };
    return directive;
    /** @ngInject */

    function MsgCarouselController($timeout) {
      var vm = this;
      vm.active = 0;
      vm.last = 0;
      vm.showLeft = false;
      vm.showRight = true;

      var length = vm.data.length / 8;

      vm.chunkList = [];
      for ( var i = 0; i < length; i++) {
        vm.chunkList[i] = {start:i * 8, index:i};
      }
      if ( vm.chunkList.length <= 1 ) {
        vm.showLeft = false;
        vm.showRight = false;
      }

      $timeout( function() {
        var name = '#TestCarousel_' + vm.name;
        vm.carouselCtrl = angular.element(name);
        vm.carouselCtrl = vm.carouselCtrl.scope();
        vm.carouselCtrl = vm.carouselCtrl.$$childHead;// should fix this

      }, 1);

      vm.Test = function( index ) {
        return vm.active == index || vm.last == index;
      }

      vm.setArrows = function( active ) {

        if ( active == 0 )
          vm.showLeft = false;
        else vm.showLeft = true;

        if ( active + 1 == vm.chunkList.length )
          vm.showRight = false;
        else vm.showRight = true;

      }

      vm.prev = function( ) {
        vm.carouselCtrl.prev();
        vm.last = vm.active;
        vm.active = vm.carouselCtrl.carousel.getCurrentIndex ();
        vm.setArrows( vm.active );
      }

      vm.next = function( ) {
        vm.carouselCtrl.next();
        vm.last = vm.active;
        vm.active = vm.carouselCtrl.carousel.getCurrentIndex ();
        vm.setArrows( vm.active );

      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaMsgCalculate', yaMsgCalculate);

  function yaMsgCalculate($rootScope) {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/msg-calculate/ya-msg-calculate.html',
      scope: { },
      controller: MsgCalculateController,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function MsgCalculateController(
      $scope,
      $document,
      ScheduleService,
      MsgService,
      FormValidationService,
      OrganizationService,
      CalculateApproval,
      $log,
      $timeout,
      loadingScreen,
      uiGmapIsReady
    ) {
      var vm = this;
      vm.mapSettings = {
        center: {
          latitude: 44.513332,
          longitude: -88.015831,
        },
        zoom: 8,
      }
      vm.radius = 50;
      vm.approval = false;
      vm.mapInstance = null;
      vm.filterOnGeography = false;

      $scope.$watch(function() {
        return vm.filterOnGeography;
      }, function() {
        vm.setFilterOnGeography();
      });

      vm.toggleGeographyFilter = function() {
        vm.filterOnGeography = !vm.filterOnGeography;
        CalculateApproval.setFilterOnGeography(vm.filterOnGeography);
        vm.updateRadius();
      };

      vm.setFilterOnGeography = function() {
        CalculateApproval.setFilterOnGeography(vm.filterOnGeography);
        vm.updateRadius();
      };

      vm.LoadData = function() {

        vm.profile = OrganizationService.get();
        loadingScreen.turnOn(true);
        vm.getPosition(vm.profile)
        .then(function(pos) {
          vm.mapSettings.center = pos;
          vm.mapSettings.zoom = 8;
          loadingScreen.turnOn(false);
        })
        .then(function() {
          return uiGmapIsReady.promise(1)
          .then(function(mapInstances) {
            if (mapInstances.length) {
              vm.map = mapInstances[0].map;
            } else {
              $log.log('Unable to find the mapInstances');
            }
          })
        })
        .then(function() {
          // force ui to update before proceeding
          $timeout(function() {
            vm.autoText = '';
            vm.totalCost = 0;
            vm.users = 0;

            var scheduledList = ScheduleService.getList();
            vm.scheduledTotal = scheduledList.length;
            vm.initAutocomplete();

            CalculateApproval.setApproval(vm.approval);
            CalculateApproval.setLocation(vm.marker.position);
            CalculateApproval.setRadius(vm.radius);
            vm.updateRadius();
          }, 0)

        });
      }

      vm.ClearLocation = function() {
        vm.LoadData();
      }

      vm.updateRadius = function() {
        vm.radius = Math.max(vm.radius, 1);
        vm.circle.setRadius(vm.radius * 1609.34);
        CalculateApproval.setRadius(vm.radius);

        var dataToSend = CalculateApproval.getSendData();

        MsgService.calculateSend(dataToSend, function(error, data) {
          if (data) {
            vm.totalCost = Math.round(100 * data.total) / 100;
            vm.users = data.totalusers;
          }
        });
      }

      vm.updateAproval = function() {
        CalculateApproval.setApproval(vm.approval);
      }

      vm.getPosition = function(profile) {
        return new Promise(function(resolve) {
          if (profile.location) {
            resolve({
              latitude: profile.location.lat,
              longitude: profile.location.lng,
            });
          } else {
            try {
              navigator.geolocation.getCurrentPosition(function(position) {
                resolve({
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude,
                });
              })
            } catch (err) {
              // Green Bay, WI
              resolve({
                latitude: 44.513332,
                longitude: -88.015831,
              });
            }
          }
        });
      }

      vm.initAutocomplete = function() {
        // Create the autocomplete object, restricting the search to geographical
        // location types.
        vm.autocomplete = new google.maps.places.Autocomplete(
          /** @type {!HTMLInputElement} */($document[0].getElementById('autocomplete')),
          {types: ['geocode']}
        );

        var centerPoint = {
          lat: 44.513332,
          lng: -88.015831,
        };
        if (vm.mapSettings.center.latitude && vm.mapSettings.center.longitude) {
          centerPoint = {
            lat: vm.mapSettings.center.latitude,
            lng: vm.mapSettings.center.longitude,
          };
        }

        if (!vm.marker) {
          vm.marker = new google.maps.Marker({
            map: vm.map,
            position: centerPoint,
          });
        }

        if (!vm.circle) {
          vm.circle = new google.maps.Circle({
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FF0000',
            fillOpacity: 0.35,
            map: vm.map,
            center: centerPoint,
            radius: (vm.radius || 2) * 1609.34
          });
        }

        vm.circle.setVisible(true);
        vm.marker.setVisible(true);


        vm.autocomplete.bindTo('bounds', vm.map);
        // When the user selects an address from the dropdown, populate the address
        // fields in the form.
        vm.autocomplete.addListener('place_changed', vm.fillInAddress);
      }

      vm.fillInAddress = function() {
        // Get the place details from the autocomplete object.
        var place = vm.autocomplete.getPlace();
        if (!place.geometry) {
          // error;
          return;
        }

        CalculateApproval.setLocation(place.geometry.location );

        // If the place has a geometry, then present it on a map.
        vm.map.setCenter(place.geometry.location);
        vm.map.setZoom(8);
        vm.marker.setPosition(place.geometry.location);
        vm.marker.setVisible(true);
        vm.circle.setCenter(place.geometry.location);
        vm.circle.setVisible(true);

        vm.updateRadius();
      }

      vm.itemdelete = $rootScope.$on('item.delete', function() {
        vm.LoadData();
      });

      vm.pageready = $rootScope.$on('page.ready', function() {
        vm.LoadData();
      });

      $scope.$on('$destroy', function UnLoaded() {
        vm.pageready();
        vm.itemdelete();
      });
    }
  }
})();


angular
.module('youApp')
.factory('CalculateApproval', function() {
  var me = this;
  me.approval = false;
  me.filterOnGeography = false;
  return {
    getApproval: function() {
      return me.approval;
    },
    setApproval: function( value ) {
      me.approval = value;
    },
    getRadius: function() {
      return me.radius;
    },
    setRadius: function( value ) {
      me.radius = value;
    },
    setLocation: function( loc ) {
      me.location = loc;
    },
    getLocation: function() {
      return me.location;
    },
    getSendData: function() {
      var data = {};
      if (!me.filterOnGeography) {
        data.lat = 0;
        data.lng = 0;
        data.radius = 0;
      } else if (me.location && me.location.latitude && me.location.longitude) {
        data.lat = me.location.latitude;
        data.lng = me.location.longitude;
        data.radius = Math.max(me.radius, 1);
      } else if ( me.location ) {
        data.lat = me.location.lat();
        data.lng = me.location.lng();
        data.radius = Math.max(me.radius, 1);
      } else {
        data.lat = 0;
        data.lng = 0;
        data.radius = 0;
      }

      return data;
    },
    setFilterOnGeography: function(filterOnGeography) {
      me.filterOnGeography = filterOnGeography;
    },
    getFilterOnGeography: function() {
      return me.filterOnGeography;
    },
  }
});

(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaMessagePendingCard', yaMessagePendingCard);

  function yaMessagePendingCard($document) {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/message-pending-card/ya-message-pending-card.html',
      scope: { data: '=data', parent: '=parent' },
      controller: MessageCardController,
      controllerAs: 'vm',
      bindToController: true,
      link: function(scope, element, attr, ctrl) {
        $document.bind('click', function(event) {
          var isClickedElementMe = element
            .find(event.target)
            .length > 0;

          if (isClickedElementMe )
            return;

          ctrl.state = 'close';
          scope.$apply();
        });
      }
    };
    return directive;
    /** @ngInject */
    function MessageCardController() {
      var vm = this;
      vm.state = 'close';

      vm.onSelect = function() {
        vm.state = 'open';
      }

      vm.getDate = function(date) {
        return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes() + ' ' + ((date.getHours() >= 12 ) ? 'pm' : 'am');
      }

      vm.onDelete = function() {
        if ( vm.parent && vm.parent.onDelete )
          vm.parent.onDelete(vm.data);
      }

      vm.onEdit = function() {
        if ( vm.parent && vm.parent.onEdit )
          vm.parent.onEdit(vm.data);
      }
    }
  }
})();
(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaMessageCard', yaMessageCard);

  function yaMessageCard() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/message-card/ya-message-card.html',
      scope: { data: '=data', parent: '=parent', page: '=page' },
      controller: MessageCardController,
      controllerAs: 'vm',
      bindToController: true,
      link: function(scope, element, attr, ctrl) {
        ctrl.element = element;

      }
    };
    return directive;
    /** @ngInject */
    function MessageCardController($rootScope, $document, $scope, $location, MsgService, IndTypeService, OrganizationService) {
      var vm = this;
      vm.creatingMessage = false;
      vm.state = 'close';
      vm.expireDate = 'expiration date';
      vm.loc = $location.path();
      vm.atApproval = vm.loc.includes('approval');

      if ( vm.data.status == 'create' ) {
        vm.state = 'open';
      }

      vm.publish = vm.data.availableglobal;
      vm.types = IndTypeService.getTypes();
      IndTypeService.setCurrentByID( vm.data.industrytypeid );
      vm.industrytype = IndTypeService.getCurrent().name;

      vm.PublicOnly = function( ) {
        return vm.data.organizationid != OrganizationService.getID() && vm.data.availableglobal;
      };

      vm.isSuper = function() {
        return vm.parent && vm.parent.super
      };

      vm.Publish = function() {
        vm.data.availableglobal = vm.publish;

        IndTypeService.setCurrent(vm.industrytype);
        vm.data.industrytypeid = IndTypeService.getID();

        MsgService.setCurrent(vm.data);
        MsgService.register(function() {
        });
      };

      vm.onNewMSG = function() {
        if ( vm.parent && vm.parent.onNewMSG )
          vm.parent.onNewMSG(vm.data);
      };

      vm.onClone = function() {
        if ( vm.parent && vm.parent.onClone )
          vm.parent.onClone(vm.data);
      };

      vm.onTemplatePicker = function() {
        if ( vm.parent && vm.parent.onTemplatePicker )
          vm.parent.onTemplatePicker();
      };

      vm.onUpload = function() {
        if ( vm.parent && vm.parent.onUpload )
          vm.parent.onUpload();
      };

      vm.onSelect = function() {
        if ( vm.state != 'msg' )
        {
          $document.bind('click', vm.closeCard );
          vm.state = 'open';
        }
      };

      vm.onEdit = function() {
        if ( vm.parent && vm.parent.onEdit )
          vm.parent.onEdit(vm.data);
      };

      vm.onUpdateMessage = function() {
        vm.creatingMessage ^= true;
        //if(event)event.stopPropagation();
        if (vm.state != 'msg')
          vm.state = 'msg';
        else if ( vm.parent && vm.parent.onUpdateMessage && vm.creatingMessage === false) {
          vm.parent.onUpdateMessage(vm.data);
          vm.state = 'close';
        } else {
          vm.state = 'close';
        }
      };

      vm.closeCard = function( event ) {
        var isClickedElementMe = vm.element
          .find(event.target)
          .length > 0;

        if (isClickedElementMe ||
                    vm.data.status == 'create') {
          event.stopPropagation();

          return;
        }

        if (vm.state == 'msg')
          vm.onUpdateMessage();

        vm.state = 'close';

        $scope.$apply();

        $document.unbind(event);
      };

      vm.onSend = function() {
        vm.state = 'close';
        if ( vm.parent && vm.parent.onSend )
          vm.parent.onSend(vm.data);
      };

      vm.onDelete = function() {
        $document.unbind('click');

        if (vm.parent && vm.parent.onDelete) {
          vm.parent.onDelete(vm.data);
        }
      };

      vm.onApprove = function() {
        vm.state = 'close';
        if ( vm.parent && vm.parent.onApprove )
          vm.parent.onApprove(vm.data);
      };

      vm.onAdminEdit = function() {
        if ( vm.parent && vm.parent.onAdminEdit )
          vm.parent.onAdminEdit(vm.data);
      };

      vm.onReject = function() {
        vm.state = 'close';
        if ( vm.parent && vm.parent.onReject )
          vm.parent.onReject(vm.data);
      };

      vm.onUnSelect = function() {
        vm.state = 'close';
      };

      vm.onSchedule = function() {
        vm.state = 'close';
        if ( vm.parent && vm.parent.onSchedule )
          vm.parent.onSchedule(vm.data);
      };


      vm.pageready = $rootScope.$on('page.ready', function() {
        vm.publish = vm.data.availableglobal;
        vm.types = IndTypeService.getTypes();
        IndTypeService.setCurrentByID( vm.data.industrytypeid );
        vm.industrytype = IndTypeService.getCurrent().name;
      });

      $scope.$on('$destroy', function UnLoaded() {
        vm.pageready();
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaMainSidenav', yaMainSidenav);

  function yaMainSidenav() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/main-sidenav/ya-main-sidenav.html',
      scope: {},
      controller: SidenavController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;


    /** @ngInject */
    function SidenavController($rootScope, $log, $scope, $location, StateService, OrganizationService, UserService) {
      var vm = this;
      vm.ready = false;
      vm.currentID = -1;

      vm.currentOrgPic = 'assets/images/60x60.png';
      //vm.currentPage = page;

      //check if on a particular page
      vm.isOnPage = function(page) {
        if ($location.path() == page) {
          return true;
        }
        return false;
      }

      vm.Nav = function(page) {
        StateService.go(page);
      }

      vm.Logout = function() {
        UserService.logout();
        location.assign('/#/');
      }

      // vm.changeOrg = function() {
      //   $log.debug(vm.currentOrg);
      //   if ( vm.currentOrg.id == vm.currentID ) return;

      //   vm.ready = false;
      //   if ( vm.currentOrg.id == 0) {
      //     location.assign('/#/adminmessages');
      //   } else {
      //     OrganizationService.loadByID(vm.currentOrg.id, function() {
      //       StateService.go('dashboard');
      //     });
      //   }
      // }


 // Update this method to handle changes from the autocomplete
      vm.changeOrg = function() {
        $log.debug(vm.currentOrg);
        if (vm.currentOrg && vm.currentOrg.id === vm.currentID) return;

        vm.ready = false;
        if (vm.currentOrg && vm.currentOrg.id === 0) {
          location.assign('/#/adminmessages');
        } else if (vm.currentOrg) {
          OrganizationService.loadByID(vm.currentOrg.id, function() {
            StateService.go('dashboard');
          });
        }
      }

      // Define querySearch to filter the organizations based on the search text
      vm.querySearch = function(searchText) {
        searchText = searchText || '';
        return vm.orgs.filter(function(org) {
          return org.name.toLowerCase().includes(searchText.toLowerCase());
        });
      };
      vm.orgupdated = $rootScope.$on('organizationUpdated', function() {
        var profile = OrganizationService.get();
        if (profile && profile.profileimage) {
          vm.currentOrgPic = profile.profileimage;
        }
      });

      vm.pageready = $rootScope.$on('page.ready', function() {
        var profile = OrganizationService.get();
        vm.currentID = profile.id;
        if (profile) {
          vm.currentOrg = profile;
          if ( profile.profileimage) {
            vm.currentOrgPic = profile.profileimage;
          }
        }
        vm.orgs = [];

        OrganizationService.loadListSideBar(true, function(error, list) {
          if (error == null) {
            vm.orgs = [];

            vm.orgs = vm.orgs.concat(list);

            if (UserService.isAdmin()) {
              vm.orgs.push({
                name:'You App Corporate',
                id:0
              });
            }
          }

          vm.ready = true;
        });
        vm.currentUser = UserService.getEmail();
      });

      $scope.$on('$destroy', function UnLoaded() {
        vm.pageready();
        vm.orgupdated = null;
      });
    }
  }
})();

(function() {
  'use strict'

  angular.module('youApp')
  .directive('yaMainHeader', yaMainHeader);

  function yaMainHeader() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/main-header/ya-main-header.html',
      scope: { page: '@'},
      controller: HeaderController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function HeaderController(
      $location,
      $mdSidenav,
      StateService
    ) {
      var vm = this;

      vm.isOnPage = function(page) {
        if ($location.path() == page) {
          return true;
        }
        return false;
      }

      vm.Nav = function(page) {
        StateService.go(page);
      }

      vm.Logout = function() {
        location.assign('/#/logout');
      }

      vm.isHelpMenuOpen = function() {
        return $mdSidenav('help-menu').isOpen();
      };

      vm.toggleHelp = function() {
        $mdSidenav('help-menu').toggle();
      }
    }
  }
})();

(function() {
  'use strict'

  angular.module('youApp')
  .directive('yaMainFooter', yaMainFooter);

  function yaMainFooter() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/main-footer/ya-main-footer.html',
      scope: { page: '@'},
      controller: FooterController,
      controllerAs: 'vm',
      bindToController: true
    };


    return directive;

    /** @ngInject */
    function FooterController($location, StateService) {
      var vm = this;

      vm.isOnPage = function(page) {
        if ($location.path() == page) {
          return true;
        }
        return false;
      }

      vm.Nav = function(page) {
        StateService.go(page);
      }

    }

  }
})();
(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaLoading', yaLoading);

  function yaLoading() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/loading/ya-loading.html',
      scope: { },
      controller: LoadingController,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function LoadingController($scope, $timeout, loadingScreen) {
      var vm = this;
      vm.on = false;
      vm.count = 0;
      vm.closing = false;

      vm.turnOn = function(on) {
        if ( !on ) {
          vm.count--;
          if ( vm.count < 0)vm.count = 0;
          if ( vm.closing ) {
            $timeout.cancel(vm.closing);
            vm.closing = false;
          }
          vm.closing = $timeout(function() {
            if ( vm.count == 0 ) vm.on = false;
          }, 1000);
        } else {
          vm.on = on;
          vm.count++;
        }

        //$log.debug(vm.count);
      }

      loadingScreen.set(vm);

    }
  }
})();

angular
.module('youApp')
.factory('loadingScreen', function() {
  var me = this;
  return {
    turnOn: function(on) {
      try {
        me.vm.turnOn(on);
      } catch (err) {
        // ignore
      }
    },
    set: function(vm) {
      me.vm = vm;
    },
    reset: function() {
      me.vm.turnOn(false);
      me.vm.count = 0;
    }
  }
});

(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaHelpTips', yaHelpTips);

  function yaHelpTips() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/help-tips/help-tips.html',
      scope: { data: '=data', name: '@name' },
      controller: HelpTipsController,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function HelpTipsController($window) {
      var vm = this;
      vm.active = true;
      vm.anim = '';
      vm.index = 0;//$window.localStorage[ vm.name ] || 0;
      if ( !vm.data || vm.data.length == 0 ) {
        vm.active = false;
        return;
      }
      if ( vm.index == -1 ) vm.active = false;
      vm.text = vm.data[ vm.index ];
      // load what one we are on

      vm.onClose = function() {
        if ( ++vm.index >= vm.data.length ) {
          vm.index = -1;
          vm.text = '';
          vm.active = false;
          vm.anim = 'done';
        }
        else {
          vm.anim = 'enter';
          vm.text = vm.data[ vm.index ];
        }
        $window.localStorage[ vm.name ] = vm.index;
        // close this one, load next
        // save what one we are on
      }
    }
  }
})();
(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaHelpMenu', yaHelpMenuDirective);

  function yaHelpMenuDirective() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/help-menu/ya-help-menu.html',
      scope: { helpPage: '=?'},
      controller: yaHelpMenuController,
      controllerAs: 'vm',
      bindToController: true
    };
  }

  /** @ngInject */
  function yaHelpMenuController($mdSidenav) {
    var vm = this;

    // default help page
    if (!vm.helpPage) {
      vm.helpPage = 'app/components/help-menu/ya-help-content.html';
    }

    vm.close = function() {
      $mdSidenav('help-menu').close();
    };
  }
})();

/* global $ */
(function(){
  'use strict';

  angular.module('youApp')
  .directive('yaEditorWindow', yaEditorWindow);

  function yaEditorWindow(){

    var directive = {
      restrict: 'E',
      templateUrl: 'app/pages/pixie/pixie.html',
      controller: MainController,
      controllerAs: 'vme',
      bindToController: true,
      scope: { data: '=data', parent: '=parent'}
    };
    return directive;

    /** @ngInject */
    function MainController(MsgService, $scope, $timeout, $rootScope, $$rAF, $mdBottomSheet, canvas, history, simpleShapes, filters, IES, text) {
      var vm = this;
      vm.name = "this is a test";
      vm.scope = $scope;
        //true after user uploads an image or create a new canvas
        vm.started = false;
        vm.delayEditorStart = true;

        //check if we're on a demo site
        vm.isDemo = document.URL.indexOf('pixie.vebto.com') > -1;

        vm.isIntegrationMode = false;

        //check if we're running in integration mode
        try {
          if (window.self !== window.top) {
            $('script', window.top.document).each(function(i, node) {
              if (node.src.indexOf('pixie-integrate') > -1) {
                vm.isIntegrationMode = true;
                return false;
              }
            });
          }
        } catch (e) {
          vm.isIntegrationMode = false;
        }

        //get a reference to top window if we're inside iframe
        if (vm.isIntegrationMode) {
          vm.pixie = window.top.Pixie;
        }

        vm.getParam = function(name) {
          if (vm.pixie) {
            return vm.pixie.getParams()[name];
          } else if (window.PixieParams) {
            return window.PixieParams[name];
          }
        };

        //make actions panels draggable
        /*$('.actions-menu').draggable({
            handle: '.menu-header',
            containment: 'body'
        });*/

        vm.countButtons = function(){
          var count = 0;
          vm.canvas.fabric.forEachObject(function(obj) {
            if(
              obj.niceName &&
              (
                obj.niceName.indexOf('button rect') == 0 ||
                obj.niceName.indexOf('button circle') == 0 ||
                obj.niceName.indexOf('button ellipse') == 0
              )
            ) {
              count++;
            }
          });

          //$log.debug("BUtton Count " + count);

          vm.buttonCount = count;
        };


      vm.history = history;
        vm.shapes = simpleShapes;
        vm.buttonCount = 0;
        vm.buttonMax = 5;
        vm.loading = false;
        vm.defaultWidth = 720;
        vm.defaultHeight = 1000;
        vm.animationEndEvent = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        vm.transitionEndEvent = 'webkitTransitionEnd mozTransitionEnd MSTransitionEnd oatransitionend atransitionend transitionend';

        vm.maxPanelHeight = $(window).height() - 120;

        vm.openPanel = function(name, e) {
          if (vm.activePanel === name) return;
          vm.activePanel = name;

          var panel = $('[data-name="'+name+'"]');
          if( !e ) {
            e = {};
            e.target = panel[0];
          }

          var clickRect = e.target.getBoundingClientRect();
          var panelRect = panel[0].getBoundingClientRect();

          var scaleX = Math.min(0.5, clickRect.width / panelRect.width);
          var scaleY = Math.min(0.5, clickRect.height / panelRect.height);

          panel.removeClass('transition-in').css('transform', 'translate3d(' +
            (-panelRect.left + clickRect.left + clickRect.width/2 - panelRect.width/2) + 'px,' +
            (-panelRect.top + clickRect.top + clickRect.height/2 - panelRect.height/2) + 'px,' +
            '0) scale(' + scaleX + ',' + scaleY + ')'
          );

          $$rAF(function() {
              $(panel).addClass('transition-in').css('transform', '');
          });
        };

      vm.isLoading = function() {
        $timeout(function() {
          vm.loading = true;
        });
      };

      vm.isNotLoading = function() {
        $timeout(function() {
          vm.loading = false;
        });
      };

      vm.activePanel = false;
        vm.activeTab   = false;

      vm.keys = {
        google_fonts: 'AIzaSyDhc_8NKxXjtv69htFcUPe6A7oGSQ4om2o',
      };

      $scope.$watch('activePanel', function() {
        setTimeout(function () {
          $(window).resize();
        }, 100);
      });

        vm.resetUI = function() {
          $timeout(function() {
            vm.activePanel = null;
            vm.activeTab   = 'basics';
            vm.shapes.selected  = null;
            filters.appliedFilters = [];
          });
        };

        vm.spacify = function(text) {
          if (text) {
            var temp = text.replace( /([A-Z])/g, " $1" );
            return temp.charAt(0).toUpperCase() + temp.slice(1);
          }
        };

        vm.updateData = function(data){
          if( vm.parent && vm.parent.onUpdateData )
            vm.parent.onUpdateData();
            MsgService.set(data);
        };

        vm.openBottomSheet = function(name) {
          $mdBottomSheet.show({
            template: $('#'+name+'-sheet-template').html(),
            controller: 'BottomSheetController'
          });
        };

        vm.setGeneratedTextName = function(name){
          if( vm.generatedText ) {
            vm.generatedText.setText(name+'\n 00/00/0000 \n 00:00 PM ');
          } else{
            vm.generatedText = text.generateText(name);
          }
          canvas.fabric.renderAll();
        };

        vm.canvas = canvas;
        IES.setRoot(vm);

        canvas.start();

        //open corresponding tab in left panel when user selects an object
        canvas.fabric.on('object:selected', function(e) {
          var i, shape, target;
          if (e.target.name == 'text' && !e.target.niceName.indexOf("button") == 0 ) {
            $rootScope.$emit('panel.getobject', e.target);
                vm.activeTab = 'text';
            } else if ( e.target.niceName && e.target.niceName == 'shape') {
              vm.activeTab = 'new-shapes';
              for (i = 0; i < simpleShapes.available.length; i++) {
                    shape = simpleShapes.available[i];
                    if (shape.name === e.target.name ) {
                        simpleShapes.selected = shape;
                    }
                }
                $rootScope.$emit('panel.getobject', e.target, 'shape');
            } else if (e.target.name == 'sticker') {
                vm.activeTab = 'stickers';
                $rootScope.$emit('panel.getobject', e.target, 'sticker');
            } else if( e.target.name == 'icon' ){
              target = e.target;
              if( target.textObj) canvas.fabric.setActiveObject(target.textObj);
            }else if (e.target.name == 'text' && e.target.niceName.indexOf("button") == 0 ) {
              if( vm.activeTab != 'simple-shapes' ) vm.activeTab = 'simple-shapes';

              var search = e.target;
              var button = undefined;
              // var text = undefined;
              // var icon = undefined;
              while(search){
                // if(search.name == 'text') {
                  // text = search;
                // } else if (search.name == 'icon') {
                  // icon = search;
                // } else{
                  button = search;
                // }
                search = search.textObj;
                if( search == e.target ) search = null;
              }

              // open the shapes menu
              if(button) {
                for (i = 0; i < simpleShapes.available.length; i++) {
                      shape = simpleShapes.available[i];
                      if (shape.name === button.name ) {
                          simpleShapes.selected = shape;
                      }
                  }
              }

              $rootScope.$emit('panel.getobject', e.target, 'button');
            } else if (e.target.name) {
              target = e.target;
              if( target.textObj) canvas.fabric.setActiveObject(target.textObj);
            }

            $rootScope.$emit('panel.show');

            $timeout(angular.noop);
        });

        //Close object panel when object is de-selected
        canvas.fabric.on('selection:cleared', function() {
            $timeout(angular.noop);
        });

        //deselect all objects when clicking outside canvas
        $('#viewport').on('click', function(e) {
            if (e.target.id === 'viewport') {
                $timeout(function() {
                    canvas.fabric.deactivateAll().renderAll();
                });
            }
        });

        //cleanup. remove color picker containers on scope destroy.
        $scope.$on('$destroy', function() {
            $('.sp-container').remove();
            vm.generateText();
            vm.pageReady();
        });

        // load data from server
      /*  var data = MsgService.get();
      if( !data ){

      } else {
        canvas.setDesignPayload(data);
      }*/

        $scope.$on('$viewContentLoaded', function ContentLoaded() {

        });

        vm.generateText = $rootScope.$on('page.setGeneratedText', function(event,name){
          vm.setGeneratedTextName(name);
        });

        vm.pageReady = $rootScope.$on('page.ready', function(event, data) {
          data = vm.data;//MsgService.get();
          if(data) {
            vm.type = vm.data.type;
            canvas.setDesignPayload(data,function(){

            });
          }
        });
    }
  }
})();

angular
  .module('youApp')
  .factory('IES', function () {
  var me = this;
  return {
    get: function(){
      return me.vm;
    },
    setRoot: function(vm){
      me.vm = vm;
    }

  }
});

(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaDashboardCard', yaDashboardCard);

  function yaDashboardCard() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/dashboard-card/ya-dashboard-card.html',
      scope: { data: '=data'},
      controller: DashboardCardController,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function DashboardCardController($scope, $rootScope, StateService) {
      var vm = this;

      vm.pageready = $rootScope.$on('page.ready', function() {
        if ( !vm.data ) return;

      });

      $scope.$on('$destroy', function UnLoaded() {
        vm.pageready();
      });

      vm.onClick = function() {
        StateService.go(vm.data.link);
      }
    }
  }
})();
(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaCardStats', yaCardStats);

  function yaCardStats() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/card-stats/ya-card-stats.html',
      scope: { data: '=data', parent: '=parent', page: '=page' },
      controller: CardStatsController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;
    /** @ngInject */
    function CardStatsController($rootScope, $scope, OrgReportService) {
      var vm = this;

      if ( vm.data.status == 'template') return;

      var list = [];
      list.push( vm.data );
      OrgReportService.loadMsgReports( list, function(error, data) {
        if ( !error && data.length > 0 ) {
          vm.data.report = data[0];
          vm.stats = {
            touched   : {name: 'Touched', val: vm.data.report.viewedcount},
            delivered    : {name: 'Delivered', val: vm.data.report.youappcount},
            saved     : {name: 'Saved', val: vm.data.report.savedcount},
            del   : {name: 'Deleted', val: vm.data.report.deletedcount},
            delText    : {name: 'Delivered via Text', val: vm.data.report.textcount},
            undelivered: {name: 'Undelivered', val: vm.data.report.deletedcount}
          }
        }
      });
    }
  }
})();
(function() {
  'use strict';

  angular.module('youApp')
  .directive('ngYaPasswordMatch', ngYaPasswordMatch);

  function ngYaPasswordMatch($document) {
    var directive = {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, elem, attrs, ngModel) {
        var otherPassword = $document[0].getElementById(attrs.ngYaPasswordMatch);
        ngModel.$validators.ngYaPasswordMatch = function(modelValue) {

          return modelValue === otherPassword.value;
        };
      }
    };

    return directive;
  }

})();
//clear another form field when this one is changed
//used for resetting password validation

(function() {
  'use strict';

  angular.module('youApp')
  .directive('ngYaPasswordClear', ngYaPasswordClear);

  function ngYaPasswordClear($document) {
    var directive = {
      restrict: 'A',
      link: function(scope, elem, attrs) {
        var fieldToClear = $document[0].getElementById(attrs.ngYaPasswordClear);
        elem.on('blur keyup change', function() {
          fieldToClear.value = '';
        });
      }
    };

    return directive;
  }

})();
(function(/*fillHeightModule*/) {
  'use strict';

  angular.module('youApp')
  .directive('fillHeight', yaFillHeight );

  function yaFillHeight($window, $document, $timeout) {
    return {
      restrict: 'A',
      scope: {
        footerElementId: '@',
        additionalPadding: '@',
        debounceWait: '@'
      },
      link: function(scope, element/*, attrs*/, windowResize) {
        if (scope.debounceWait === 0) {
          angular.element($window).on('resize', windowResize);
        } else {
          // allow debounce wait time to be passed in.
          // if not passed in, default to a reasonable 250ms
          angular.element($window).on('resize', debounce(onWindowResize, scope.debounceWait || 250));
        }

        onWindowResize();

        // returns a fn that will trigger 'time' amount after it stops getting called.
        function debounce(fn, time) {
          var timeout;
          // every time this returned fn is called, it clears and re-sets the timeout
          return function() {
            var context = this;
            // set args so we can access it inside of inner function
            var args = arguments;
            var later = function() {
              timeout = null;
              fn.apply(context, args);
            };
            $timeout.cancel(timeout);
            timeout = $timeout(later, time);
          };
        }

        function onWindowResize() {
          var footerElement = angular.element($document[0].getElementById(scope.footerElementId));
          var footerElementHeight;

          if (footerElement.length === 1) {
            footerElementHeight = footerElement[0].offsetHeight
                              + getTopMarginAndBorderHeight(footerElement)
                              + getBottomMarginAndBorderHeight(footerElement);
          } else {
            footerElementHeight = 0;
          }

          var elementOffsetTop = element[0].offsetTop;
          var elementBottomMarginAndBorderHeight = getBottomMarginAndBorderHeight(element);

          var additionalPadding = scope.additionalPadding || 0;

          var elementHeight = $window.innerHeight
                                        - elementOffsetTop
                                        - elementBottomMarginAndBorderHeight
                                        - footerElementHeight
                                        - additionalPadding;
          element.css('height', elementHeight + 'px');
        }

        function getTopMarginAndBorderHeight(element) {
          var footerTopMarginHeight = getCssNumeric(element, 'margin-top');
          var footerTopBorderHeight = getCssNumeric(element, 'border-top-width');
          return footerTopMarginHeight + footerTopBorderHeight;
        }

        function getBottomMarginAndBorderHeight(element) {
          var footerBottomMarginHeight = getCssNumeric(element, 'margin-bottom');
          var footerBottomBorderHeight = getCssNumeric(element, 'border-bottom-width');
          return footerBottomMarginHeight + footerBottomBorderHeight;
        }

        function getCssNumeric(element, propertyName) {
          return parseInt(element.css(propertyName), 10) || 0;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaAptPreview', yaAptPreview);

  function yaAptPreview() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/apt-preview/ya-apt-preview.html',
      scope: { parent: '=parent', type: '=type'},
      controller: yaAptPreviewController,
      controllerAs: 'vmp',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function yaAptPreviewController($log, $scope, $rootScope, $routeParams, $document, $timeout, ApptService) {
      var vm = this;
      vm.tempID = $routeParams.tempID;
      vm.orgID = $routeParams.orgID;
      vm.reminderList = [];
      var isEditor = vm.type.toLowerCase().includes('edit');

      vm.LoadData = function() {
        vm.data = ApptService.getBook();
        if ( vm.data ) {
          vm.selectAllReminders = false;
          vm.buttonList = ApptService.getButtonList();
          vm.reminderList = ApptService.getReminderFrequencyList();
          for ( var c = 0; c < vm.reminderList.length; c++)
            vm.reminderList[c].active = vm.data[vm.reminderList[c].dataName];

          $timeout(function() {
            if ( vm.data ) {
              var image = $document[0].getElementById('preview');
              if ( image )
                image.src = vm.data.previewurl;
            }
            $scope.$apply();
            $log.debug(vm.catList);
          }, 1000);
        }
      }

      vm.ChangeReminder = function() {
        for ( var c = 0; c < vm.reminderList.length; c++)
          vm.data[vm.reminderList[c].dataName] = vm.reminderList[c].active;
      }

      vm.toggleReminder = function() {
        for ( var c = 0; c < vm.reminderList.length; c++)
          vm.reminderList[c].active = !vm.selectAllReminders;

        vm.ChangeReminder();
      }

      vm.Available = function() {
        if (isEditor)
          $rootScope.$emit('editor.save', {cb: vm.AvailableCallback });
        else
          vm.AvailableCallback();
      }

      vm.AvailableCallback = function() {
        ApptService.save(function() {
          if ( vm.parent && vm.parent.onAvailable )
            vm.parent.onAvailable();
        });
      }

      vm.Done = function() {
        if (isEditor)
          $rootScope.$emit('editor.save', {cb: vm.DoneCallback });
        else
          vm.DoneCallback();
      }

      vm.DoneCallback = function() {

        ApptService.save(function() {
          vm.parent.onDone();
        });
      }

      vm.Schedule = function() {
        if (isEditor)
          $rootScope.$emit('editor.save', {cb: vm.ScheduleCallback });
        else
          vm.ScheduleCallback();


      }

      vm.ScheduleCallback = function() {
        ApptService.register(function(error) {
          if ( error == null ) {
            if ( vm.parent && vm.parent.onSchedule )
              vm.parent.onSchedule();
          }
        });
      }

      vm.savetemplate = $rootScope.$on('save.template', function(event, data) {
        var image = $document[0].getElementById('preview');
        image.src = data;
      });

      vm.pageready = $rootScope.$on('page.ready', function() {
        vm.LoadData();
      });

      $scope.$on('$destroy', function UnLoaded() {
        vm.pageready();
        vm.savetemplate();
      });
    }
  }

})();
(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaApptBook', yaApptBook);

  function yaApptBook() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/apptbook/ya-appt-book.html',
      scope: { },
      controller: GetApptBookController,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
    /** @ngInject */
    function GetApptBookController($scope, $rootScope, $document, OrgUserService, OrgCatService, ApptService, UploadFileService) {
      var vm = this;
      vm.users = [];
      vm.permissionList = [];
      vm.searchText = '';
      vm.profile = undefined;
      vm.reader = new FileReader( );
      vm.profileimage = null;
      vm.curGroup = '';
      vm.groupSearchText = '';
      vm.selectedGroupList = [];

      vm.pageready = $rootScope.$on('page.ready', function() {

        vm.appt = ApptService.getBook();
        vm.profile = ApptService.getApptBookUser();
        vm.apptLengthList = ApptService.getDefaultApptLenths();
        vm.selectedGroupList = ApptService.getGroups();

        vm.users = OrgUserService.dbGet();
        vm.groups = OrgCatService.get(false);

      });

      vm.Change = function() {
        if ( vm.profile ) {
          ApptService.setApptBookUser( vm.profile );

          $rootScope.$emit('page.setGeneratedText', vm.profile.name );
        }
      }

      vm.ChangeActive = function() {
        ApptService.register(function() {

        });
      }

      // load image
      vm.LoadImage = function(dest, file) {
        var image = $document[0].getElementById(dest);
        vm.reader.onload = function(event) {
          image.src = event.target.result;
          $scope.$apply();
        };
        vm.reader.readAsDataURL(file);
      }

      // set the image to be loaded/uploaded
      vm.UpdateImage = function(dest, element) {
        vm[element.id] = element.files[0];
        vm.LoadImage(dest, element.files[0]);
      }

      vm.UpdateApptLength = function() {
        ApptService.register(function() {

        });
      }

      // upload the image
      vm.Upload = function(id) {
        UploadFileService.upload( vm[id], function(path, error) {
          if ( error == null ) {
            vm[id] = null;
            vm.profile[id] = path;
          }
        });
      }

      $scope.$on('$destroy', function UnLoaded() {
        vm.reader = null; // some how causes GC to clear stupid memory for filereader
        vm.pageready();
      });

      vm.getMatches = function(text) {
        var list = [];
        vm.users.forEach(function(user) {
          if ( user.name && user.name.toLowerCase().indexOf(text) == 0 )
            list.push(user);
        });
        return list;
      }

      vm.getGroupMatches = function(text) {
        var list = [];
        vm.groups.forEach(function(group) {
          if ( group.name && group.name.toLowerCase().indexOf (text) == 0 )
            list.push(group);
        });
        return list;
      }

      vm.CloseEdit = function() {

        var index = vm.users.indexOf(vm.profile);
        if ( index < 0 ) return;
        OrgUserService.dbUpdate(index, function() {
          $rootScope.$emit('page.setGeneratedText', vm.profile.name );
        });
      }

      vm.Add = function() {
        if ( vm.selectedGroupList.indexOf(vm.curGroup) == -1 && vm.groups.indexOf(vm.curGroup) >= 0 ) {
          vm.selectedGroupList.push(vm.curGroup);
          ApptService.setGroups(vm.selectedGroupList);
          ApptService.register(function() {

          });
        }
      }

      vm.Delete = function(x) {
        var i = vm.selectedGroupList.indexOf(x);
        vm.selectedGroupList.splice(i, 1);
        ApptService.setGroups(vm.selectedGroupList);
        ApptService.register(function() {

        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('youApp')
  .directive('yaAdminSidenav', yaAdminSidenav);

  function yaAdminSidenav() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/admin-sidenav/ya-admin-sidenav.html',
      scope: {},
      controller: AdminSidenavController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;


    /** @ngInject */
    function AdminSidenavController(
      $rootScope,
      $scope,
      StateService,
      UserService,
      $route,
      $window
    ) {
      var vm = this;

      vm.currentOrgPic = ''; //http://placehold.it/50x50

      var iframePages = [
        'pricing-templates',
        'distributors'
      ];

      vm.Nav = function(page) {
        if (iframePages.indexOf(page) === -1 || $route.current.controller !== 'IframeAdmin.Controller') {
          location.assign('/#/' + page);
        } else {
          try {
            $window.postMessage({
              type: 'url',
              url: '/#/' + page,
              force: true
            }, '*');
          } catch (err) {
            location.assign('/#/' + page);
          }
        }
      };

      vm.pageready = $rootScope.$on('page.ready', function() {
        vm.currentUser = UserService.getEmail();
      });

      $scope.$on('$destroy', function() {
        vm.pageready();
      });
    }
  }
})();

angular
.module('youApp')
.factory('UserService', function(
    $window,
    $log,
    $http,
    apiUrl,
    TokenService,
    loadingScreen
  ) {

  var me = this;
  me.user = angular.fromJson($window.localStorage['userD']) || null;
  me.email = '';
  me.name = '';
  me.admin = angular.fromJson($window.localStorage['admin']) || false;
  $log.debug(me.user);
  me.dir = {
    isLoggedIn: function() {
      return me.user != null;
    },
    getID: function() {
      return ( me.user == null ) ? -1 : me.user.userId;
    },
    setAdmin: function( value ) {
      $window.localStorage['admin'] = angular.toJson( value );
      me.admin = value;
    },
    isAdmin: function() {
      return me.admin;
    },
    load: function(cb) {
      cb = cb || function(err, rslt) {
        return new Promise(function(resolve, reject) {
          if (err) {
            reject(err);
          } else {
            resolve(rslt);
          }
        });
      };

      if ( me.user == null ) {
        return cb('no user');
      }
      loadingScreen.turnOn(true);
      return $http
      .get(apiUrl + '/YAusers/' + me.user.userId + '?access_token=' + TokenService.get(), {})
      .then(function(result) {
        me.email = result.data.email;
        me.name = result.data.firstname;
        loadingScreen.turnOn(false);
        return cb(null);
      })
      .catch(function(error) {
        loadingScreen.turnOn(false);
        return cb(error.message);
      });
    },
    login: function(options, cb, loadingScreenDisabled) {
      if (!loadingScreenDisabled) {
        loadingScreen.turnOn(true);
      }
      $http.post(apiUrl + '/YAusers/login', options).then(function(result) {
        $log.debug('Login result', result);
        me.user = result.data;
        me.admin = false;
        $window.localStorage['userD'] = angular.toJson( me.user );
        $window.localStorage['admin'] = false;
        TokenService.set(result.data.id);
        me.dir.checkAdmin(cb, loadingScreenDisabled);
        if (!loadingScreenDisabled) {
          loadingScreen.turnOn(false);
        }
      }).catch(function(error) {
        $log.debug('Login error', error);
        cb(error.message);
        if (!loadingScreenDisabled) {
          loadingScreen.turnOn(false);
        }
      });
    },
    loginPromise: function(options) {
      return $http.post(apiUrl + '/YAusers/login', options)
      .then(function(result) {
        $log.debug('Login result', result);
        me.user = result.data;
        me.admin = false;
        $window.localStorage['userD'] = angular.toJson( me.user );
        $window.localStorage['admin'] = false;
        TokenService.set(result.data.id);
        return me.dir.checkAdminPromise();
      })
      .then(function() {
        return me.user;
      })
      .catch(function(err) {
        $log.debug('Login error', err);
        return Promise.reject(err);
      });
    },
    logout: function() {
      me.user = null;
      $window.localStorage['userD'] = null;
      $window.localStorage['admin'] = false;
      TokenService.clear();
    },
    register: function(options, cb) {
      loadingScreen.turnOn(true);
      options.profileimage = 'https://s3-us-west-2.amazonaws.com/yougetitfirstfiles/YA_default_profile_img.png';
      $http.post(apiUrl + '/YAusers', options ).then(function(result) {
        me.user = result.data;
        me.user.userId = result.data.id;
        TokenService.set(result.data.token);
        cb(null, me.user);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    getEmail: function() {
      return (me.email || '');
    },
    getName: function() {
      return (me.name || '');
    },
    resendEmailVerification: function(options, cb) {
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAusers/reset', options ).then(function(result) {
        if ( result ) {
          cb(null);
        }
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    sendResetPassword: function(options, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAusers/passwordresetemail?email=' + encodeURIComponent(options.email) ).then(function(result) {
        $log.debug(result);
        if ( result ) {
          cb(null);
        }
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    sendDeleteAccountLink: function(options, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAusers/deleteAccountEmail?email=' + encodeURIComponent(options.email) ).then(function(result) {
        $log.debug(result);
        if ( result ) {
          cb(null);
        }
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    confirmDeleteAccount: function(token, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAusers/confirmDeleteAccount?token=' + token ).then(function(result) {
        $log.debug(result);
        cb(null,result.data);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    resetPassword: function(options, token, cb) {
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAusers/passwordreset?access_token=' + token, options ).then(function(result) {
        $log.debug(result);
        if ( result ) {
          cb(null);
        }
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    checkAdmin: function(cb, loadingScreenDisabled) {
      if (!loadingScreenDisabled) {
        loadingScreen.turnOn(true);
      }
      $http.get(apiUrl + '/YAusers/hassuperadminprivs?access_token=' + TokenService.get(), {} ).then(function(result) {
        if ( result && result.data ) {
          me.dir.setAdmin(result.data.superadmin);
          cb(null);
        }
        if (!loadingScreenDisabled) {
          loadingScreen.turnOn(false);
        }
      }).catch(function(error) {
        cb(error.message);
        if (!loadingScreenDisabled) {
          loadingScreen.turnOn(false);
        }
      });
    },
    checkAdminPromise: function() {
      return $http.get(apiUrl + '/YAusers/hassuperadminprivs?access_token=' + TokenService.get(), {})
      .then(function(result) {
        if (result && result.data) {
          me.dir.setAdmin(result.data.superadmin);
        }
      })
      .catch(function(error) {
        $log.log(error);
        return Promise.reject(error);
      });
    },
    unsubscribe: function(code, cb) {
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAusers/unsubscribe', { code: code } ).then(function(result) {
        if ( result ) {
            //result.data is a boolean indicating success
          cb(null, result.data );
        }
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    exists: function(email, cb) {
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAusers/doesuserexist', { email: email } ).then(function(result) {
        if ( result && result.data ) {
          cb(null, result.data.exists );
        }
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    exchangeClasslinkCodeForClasslinkToken: function(classlinkCode, cb) {
      $http.post(apiUrl + '/YAusers/exchangeClasslinkCodeForClasslinkToken', {classlinkCode: classlinkCode}).then(function(result) {
        $log.debug('exchangeClasslinkCodeForClasslinkToken result', result);
        cb(null, result);
      }).catch(function(error) {
        $log.debug('exchangeClasslinkCodeForClasslinkToken error', error);
        cb(error.yaerrorcode);
      });
    },
    loginWithClasslink: function(classlinkToken, cb) {
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAusers/loginwithclasslink', { 'accesstoken': classlinkToken })
      .then(function(result) {
        $log.debug('loginWithClasslink result', result);
        me.user = result.data;
        me.admin = false;
        $window.localStorage['userD'] = angular.toJson(me.user);
        $window.localStorage['admin'] = false;
        TokenService.set(result.data.id);
        me.dir.checkAdmin(cb);
        loadingScreen.turnOn(false);
        cb(null, me.user);
      }).catch(function(error) {
        $log.debug('loginWithClasslink error', error);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    listMyMessages: function(options, cb) {
      options = options || {};
      cb = cb || function(result, error) {
        if (error) {
          return Promise.reject(error);
        } else {
          return Promise.resolve(result);
        }
      };
      loadingScreen.turnOn(true);
      return $http.get(apiUrl + '/YAusers/listmymessages', {
        params: {
          access_token: options.access_token || TokenService.get(),
          favoritesonly: options.favoritesonly === true,
          newonly: options.newonly === true
        }
      }).then(function(result) {
        loadingScreen.turnOn(false);
        return cb(result.data);
      }).catch(function(error) {
        loadingScreen.turnOn(false);
        return cb(null, error);
      });
    },
    getTemplateById: function(templateId, access_token) {
      access_token = access_token || '';
      loadingScreen.turnOn(true);
      return $http.get(apiUrl + '/YATemplates/' + templateId, {
        params: { access_token : access_token || TokenService.get() }
      })
      .then(function(result) {
        loadingScreen.turnOn(false);
        return result.data;
      })
      .catch(function(error) {
        loadingScreen.turnOn(false);
        $log.debug('getTemplateById error', error);
        return Promise.reject(error);
      });
    },
    dbAcceptInvite: function(invitecode, cb) {
      loadingScreen.turnOn(true);
      var body = {
        invitecode: invitecode
      };
      $http.post(apiUrl + '/YAUsers/acceptinvite?access_token=' + TokenService.get(), body ).then(function(result) {
        var res = result.data;
          //res.description will either be an error message or the userorg object
        if (res && res.status === true) {
          cb(null, res.description)
        } else {
          cb(res.description);
        }
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    sendReportMessage: function(info, access_token) {
      access_token = access_token || '';
      return new Promise(function(resolve, reject) {
        try {
          loadingScreen.turnOn(true);
          const params = {
            templateid: info.templateid,
            sendingorganizationid: info.sendingorganizationid,
            access_token: access_token || TokenService.get(),
            lat: info.lat || info.userlat || undefined,
            lng: info.lng || info.userlng || undefined,
            userlat: info.userlat || info.lat || undefined,
            userlng: info.userlng || info.lng || undefined,
            is_message_reporting: info.is_message_reporting || true,
            customtext: info.customtext || undefined,
            userids: info.userids || [],
            currentUserId: info.currentUserId || 0
          };
          $http({
            method: 'POST',
            url: apiUrl + '/YATemplates/sendwithschedule',
            data: params
          })
          .then(function(result) {
            $log.debug(result);
            loadingScreen.turnOn(false);
            resolve(true); // Resolve the promise with the result
          })
          .catch(function(error) {
            $log.debug(error.message);
            loadingScreen.turnOn(false);
            reject(error); // Reject the promise with the error
          });
        } catch (error) {
          reject(error); // Reject the promise with the error
        }
      });
    }
  };
  return me.dir;
});

angular
.module('youApp')
.factory('UploadFileService', function($log, $http, apiUrl, TokenService, loadingScreen, OrganizationService) {
  var me = this;
  me._List = [];
  return {
    getList: function() {
      return me._List;
    },
    load: function(cb) {
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      if ( !orgID ) {
        me._List = [];
        cb([], 'organization not loaded yet');
        loadingScreen.turnOn(false);
        return;
      }
      $http.get(apiUrl + '/YAFiles/listbyorganization?organizationid=' + orgID + '&public=true&access_token=' + TokenService.get(), {}).then(function(result) {
        $log.debug(result);
        result.data.forEach( function(image) {
          image.niceName = image.name;
          image.name = apiUrl + image.url.replace('/api/v1', '');
        });
        me._List = result.data;
        loadingScreen.turnOn(false);
        cb(result.data, null);
      }).catch(function(error) {
        $log.debug(error.message);
        loadingScreen.turnOn(false);
        cb(null, error.message);
      });
    },
    dataURItoBlob: function(dataURI) {
        // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
      else
          byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], {type:mimeString});
    },

    blobToFile: function(fileName, contentType, theBlob) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName + '.' + contentType;
      return theBlob;
    },

    upload: function(file, cb) {
      cb = cb || function(path, err) {
        if (path) {
          return Promise.resolve(path);
        } else {
          return Promise.reject(err);
        }
      };
      if (!file) {
        return cb(null);
      } else {
        loadingScreen.turnOn(true);
        var orgID = OrganizationService.getID();
        var fd = new FormData();
        var public = false;
        if ( typeof file == 'string' ) {
          var blob = this.dataURItoBlob(file);
          fd.append('file', blob);
          public = false;
        } else {
          fd.append('file', file);
          public = true;
        }
        return $http.post(apiUrl + '/YAFiles/upload', fd, {
          transformRequest: angular.identity,
          headers: {'Content-Type': undefined},
          params: {
            organizationid: orgID,
            public: public,
            name: file.name || (new Date().getTime()),
            access_token: TokenService.get()
          }
        })
        .then(function(result) {
          return result.data;
        })
        .then(function(result) {
          $log.debug(result);
          if (result.result) {
            result = result.result;
          }
          var path = '';
          path = apiUrl + result.url.replace('/api/v1', '');
          loadingScreen.turnOn(false);
          return cb(path, null);
        })
        .catch(function(error) {
          loadingScreen.turnOn(false);
          return cb(null, error.message);
        });
      }
    }
  }
});

angular
.module('youApp')
.factory('TokenService', function($window, $log) {
  var me = this;
  me._apiToken = $window.localStorage['token'] || '';
  return {
    set: function(token) {
      $window.localStorage['token'] = token;
      me._apiToken = token;
      $log.debug(me._apiToken);
    },
    clear: function() {
      $window.localStorage['token'] = null;
      me._apiToken = null;
    },
    get: function() {
      return me._apiToken;
    }
  }
});
angular
.module('youApp')
.factory('StateService', function(OrganizationService) {
  return {
    go: function(url, template, email) {
      var id = OrganizationService.getID();
      if (id < 1) {
        location.assign('/#/');
      } else {
        var loc = '/#/' + url + '/' + id;
        if (angular.isDefined(template) && template != null) {
          loc += '/' + template;
        }
        if (angular.isDefined(email) && email != null) {   // Append email only if provided
          loc += '?email=' + email;
        }
        location.assign(loc);
      }
    }
  }
});

angular
.module('youApp')
.factory('ScheduleService', function($http, apiUrl, TokenService, MsgService, loadingScreen) {

  function ScheduledTime(start, end, sendBy) {
    this.senddate = start;
    this.expirationdate = end;
    this.sendby = sendBy;
    this.templateid = -1;
  }

  var me = this;
  me._List = [];

  return {
    load: function(templateid, cb) {
      if ( !templateid || templateid < 1 ) return;
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YATemplates/getschedules?templateid=' + templateid + '&access_token=' + TokenService.get(), {})
      .then(function(result) {
        me._List = result.data;
        me._List.forEach(function(data) {
          data.senddate = new Date( data.senddate );
          data.expirationdate = new Date( data.expirationdate );
        });
        loadingScreen.turnOn(false);
        cb(null);
      }).catch(function(error) {
        loadingScreen.turnOn(false);
        cb(error.message);
      });
    },
    add: function(start, end, sendBy, cb) {
      var data = new ScheduledTime(start, end, sendBy);
      var template = MsgService.get();
      if ( !template ) return;
      data.templateid = template.id;
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YATemplates/addschedule?access_token=' + TokenService.get(), data)
      .then(function(result) {
        result.data.senddate = new Date( result.data.senddate );
        result.data.expirationdate = new Date( result.data.expirationdate );
        me._List.push(result.data);
        loadingScreen.turnOn(false);
        cb(null);
      }).catch(function(error) {
        loadingScreen.turnOn(false);
        cb(error.message);
      });
    },
    delete: function(data, cb) {
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YATemplates/removeschedule?scheduleid=' + data.id + '&access_token=' + TokenService.get(), {})
      .then(function() {
        var index = me._List.indexOf(data);
        me._List.splice(index, 1);
        loadingScreen.turnOn(false);
        cb(null);
      }).catch(function(error) {
        loadingScreen.turnOn(false);
        cb(error.message);
      });

    },
    getList: function() {
      return me._List;
    }

  }
});
angular
.module('youApp')
.factory('SalesPersonService', function($log, $http, apiUrl, TokenService, IndTypeService, loadingScreen) {

  function SalesPerson() {
      // in database
    this.firstname = '';
    this.lastname = '';
    this.phone = '';
    this.title = '';
    this.email = '';
    this.startdate = new Date();
    this.salespersongroupid = -1;
    this.referralcode = '';
  }

  var me = this;
  me._Profile = new SalesPerson();
  me._List = [];
  me._ID = -1;

  return {

    register: function(cb) {
      loadingScreen.turnOn(true);
      me._Profile.industrytypeid = IndTypeService.getID();
      me._Profile.location = undefined;
      var data = me._Profile;
      if (me._ID !== -1) {// already registered just update
        $http.post(apiUrl + '/YASalesPeople/update?access_token=' + TokenService.get(), data)
        .then(function(result) {
          $log.debug(result);
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
        return;
      }

        // check to see if already exists
      $http.get(apiUrl + '/YASalesPeople?filter={"where":{"name":"' + data.name + '"}}&access_token=' + TokenService.get(), {})
      .then(function(result) {
        if (result.data.length === 0) {
              // create new org
          data.profileimage = me._DefaultIcons[data.industrytypeid];
          return $http.post(apiUrl + '/YASalesPeople/update?access_token=' + TokenService.get(), data);
        }
        else {
          $log.debug('already exists');
          loadingScreen.turnOn(false);
          cb('already exists');
        }
      }).then(function(result) {
        $log.debug(result);
        me._ID = result.data.id;
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    isUninvitedUser: function(user, groupid) {
        //look through this users invites to find the one for this groupid
        //(or with no groupid if one isn't passed in)
      if (user.userorganization) {
        var invite = _.find(user.userorganization.invites, function(invite) {
          if (groupid) {
            return invite.categoryid == groupid;
          } else {
            return invite.categoryid === null;
          }
        });
      }
        //return true if there isn't an invite, false if there is
        //(if they have an invite they've been invited to this group)
      return !invite;
    },

      // a user that was invited to join an organization but hasn't accepted yet
    isInvitedUser: function(user, groupid) {
        //look through this users invites to find the one for this groupid
        //(or with no groupid if one isn't passed in)
      if (user.userorganization) {
        var invite = _.find(user.userorganization.invites, function(invite) {
          if (groupid) {
            return invite.categoryid == groupid;
          } else {
            return invite.categoryid === null;
          }
        });
      }

      if (!invite) {
        return false;
      }

        //sent status means the invite has yet to be accepted
      return invite.status == 'sent';
    },

    update: function(salesPerson, cb) {
      loadingScreen.turnOn(true);
      if (salesPerson.id > 0) {
        $http.put(apiUrl + '/YASalesPeople?access_token=' + TokenService.get(), salesPerson)
        .then(function(result) {
          $log.debug(result);
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
      } else {
        $http.post(apiUrl + '/YASalesPeople?access_token=' + TokenService.get(), salesPerson)
        .then(function(result) {
          $log.debug(result);
          salesPerson.id = result.data.id;
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          loadingScreen.turnOn(false);
          cb(error.message);
        });
      }
    },

    loadList: function(groupID, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YASalesPeople?filter={"include":{"userorganization": "invites"}, "where": {"salespersongroupid":' + groupID + '}}&access_token=' + TokenService.get(), {})
      .then(function(result) {
        $log.debug(result);
        me._List = result.data;

        cb(null, me._List);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message, []);
        loadingScreen.turnOn(false);
      });
    },

    get: function() {
      var list = [];
      for (var i = 0; i < me._List.length; i++) {
        list.push(me._List[i]);
      }
      return list;
    },

    getTempSalesPerson: function() {
      return new SalesPerson();
    },

    deleteSalesPerson: function(id, cb) {
      loadingScreen.turnOn(true);
      $http.delete(apiUrl + '/YASalesPeople/' + id + '?access_token=' + TokenService.get(), {})
      .then(function(result) {
        $log.debug(result);
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    getSalesPeopleTotals: function(orgid, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YASalesPersonGroups/getsalestotals?salespersongroupid=' + orgid + '&access_token=' + TokenService.get(), {})
      .then(function(result) {
        $log.debug(result);
        me._List = result.data[0];
        cb(null, me._List);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      })
    },

    inviteSalesPerson: function(ids, cb) {
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YASalesPeople/invite?access_token=' + TokenService.get(), {
        salespersonids: ids
      })
      .then(function(result) {
        $log.debug(result);
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      })
    }
  }
});



angular
.module('youApp')
.factory('SalesOrgService', function($log, $http, apiUrl, TokenService, IndTypeService, loadingScreen) {

  function SalesOrg() {
      // in database
    this.name = '';
    this.firstname = '';
    this.lastname = '';
    this.phone = '';
    this.phone2 = '';
    this.title = '';
    this.email = '';
    this.enabled = true;
    this.referralcode = '';
    this.industrytypeid = -1;
    this.recipientgroupid = -1;
  }

  var me = this;
  me._Profile = new SalesOrg();
  me._List = [];
  me._ID = -1;
  me._Count = -1;
  me._Total = -1;

  return {

    register: function(cb) {
      loadingScreen.turnOn(true);
      me._Profile.industrytypeid = IndTypeService.getID();
      me._Profile.location = undefined;
      var data = me._Profile;
      if (me._ID !== -1 ) {// already registered just update
        $http.post(apiUrl + '/YASalesPersonGroups/update?access_token=' + TokenService.get(), data )
        .then(function(result) {
          $log.debug(result);
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
        return;
      }

        // check to see if already exists
      $http.get(apiUrl + '/YASalesPersonGroups?filter={"where":{"name":"' + data.name + '"}}&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        $log.debug(result);
        me._ID = result.data.id;
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    loadList: function(isOnboard, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YASalesPersonGroups?access_token=' + TokenService.get(), {} )
      .then(function(result) {
        $log.debug(result);
        me._List = result.data;
        cb(null, me._List);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message, []);
        loadingScreen.turnOn(false);
      });
    },

    getTotalSales: function(cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YASalesPersonGroups/getsalestotals?access_token=' + TokenService.get(), {} )
      .then(function(result) {
        $log.debug(result);
        loadingScreen.turnOn(false);
        cb(null, result.data)
      }).catch(function(error) {
        $log.debug(error.message);
        loadingScreen.turnOn(false);
      });
    },

    getTotalPeople: function(id, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YASalesPersonGroups/' + id + '/salespeople/count?access_token=' + TokenService.get(), {} )
      .then(function(result) {
        $log.debug(result);
        loadingScreen.turnOn(false);
        cb(null, result.data);
      }).catch(function(error) {
        $log.debug(error.message);
        loadingScreen.turnOn(false);
      });
    },

    update: function(salesOrg, cb) {
      loadingScreen.turnOn(true);
      if ( salesOrg.id > 0 ) {
        $http.put(apiUrl + '/YASalesPersonGroups?access_token=' + TokenService.get(), salesOrg)
        .then(function(result) {
          $log.debug(result);
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
      } else {
        $http.post(apiUrl + '/YASalesPersonGroups?access_token=' + TokenService.get(), salesOrg)
        .then(function(result) {
          $log.debug(result);
          salesOrg.id = result.data.id;
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
      }
    },

    get: function() {
      var list = [];
      for ( var i = 0; i < me._List.length; i++ ) {
        list.push( me._List[i]);
      }
      return list;
    },

    delete: function(id, cb) {
      loadingScreen.turnOn(true);
      $http.delete(apiUrl + '/YASalesPersonGroups/' + id + '?access_token=' + TokenService.get(), {} )
      .then(function(result) {
        $log.debug(result);
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    getTempSalesOrg: function() {
      return new SalesOrg();
    },

    getOrgById: function(salesOrgId, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YaSalesPersonGroups/' + salesOrgId + '?access_token=' + TokenService.get(), {})
      .then(function(result) {
        $log.debug(result);
        loadingScreen.turnOn(false);
        cb(result.data);
      }).catch(function(error) {
        $log.debug(error.message);
        loadingScreen.turnOn(false);
        cb(false);
      })
    },

    getOrgReferralCodeById: function(salesOrgId, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YaSalesPersonGroups/' + salesOrgId + '?access_token=' + TokenService.get(), {})
      .then(function(result) {
        $log.debug(result);
        loadingScreen.turnOn(false);
        cb(null, result.data.referralcode)
      }).catch(function(error) {
        $log.debug(error.message);
        loadingScreen.turnOn(false);
      })
    }
  }
});



angular
.module('youApp')
.factory('RrmsService', function(
    $http,
    $log,
    $q,
    apiUrl,
    TokenService
  ) {

  var alerts = [
    {
      signalCode: 'abd',
      description: 'Abduction-On Premise',
      eventCode: 'ABD',
    },
    // {
    //   signalCode: 'abdoff',
    //   description: 'Abduction-Off Premise',
    //   eventCode: 'ABD',
    // },
    {
      signalCode: 'asa',
      description: 'Active Shooter-On Premise',
      eventCode: 'ASA',
    },
    // {
    //   signalCode: 'asaoff',
    //   description: 'Active Shooter-Off Premise',
    //   eventCode: 'ASA',
    // },
    {
      signalCode: 'bom',
      description: 'Bomb Threat-On Premise',
      eventCode: 'bom',
    },
    // {
    //   signalCode: 'bomoff',
    //   description: 'Bomb Threat-Off Premise',
    //   eventCode: 'bom',
    // },
    {
      signalCode: 'fire',
      description: 'Fire/Smoke/Sprinkler-On Premise',
      eventCode: 'FIRE',
    },
    // {
    //   signalCode: 'fireoff',
    //   description: 'Fire/Smoke/Sprinkler-Off Premise',
    //   eventCode: 'FIRE',
    // },
    {
      signalCode: 'intr',
      description: 'Intruder-On Premise',
      eventCode: 'INTR',
    },
    // {
    //   signalCode: 'introff',
    //   description: 'Intruder-Off Premise',
    //   eventCode: 'INTR',
    // },
    {
      signalCode: 'sfwk',
      description: 'Safe Walk-On Premise',
      eventCode: 'sfwk',
    },
    // {
    //   signalCode: 'sfwkoff',
    //   description: 'Safe Walk-Off Premise',
    //   eventCode: 'sfwk',
    // },
  ];

  return {
    GetZoneList: function(organizationId) {
      return $http.get(
          apiUrl + '/YAOrganizations/' + organizationId + '/alert-zones',
        {
          params: {
            access_token: TokenService.get()
          }
        }
        )
      .then(function(results) {
        return results.data;
      });
    },

    GetAlerts: function() {
      return Promise.resolve(alerts);
    },

    GetAlertTypes: function() {
      return Promise.resolve([
        {
          code: 'Za',
          label: 'Zone Alarm'
        },
        {
          code: 'Zr',
          label: 'Zone Restore'
        }
      ]);
    }
  };
});

angular
.module('youApp')
.factory('RecipientGroupService', function(
    $log,
    $http,
    apiUrl,
    OrganizationService,
    TokenService
  ) {

  return {
    load: function() {
      var orgId = OrganizationService.getID();
      return $http({
        method: 'GET',
        url: apiUrl + '/YACategories',
        params: {
          access_token: TokenService.get(),
          filter: angular.toJson({
            where: {
              organizationid: orgId,
              isemailgroup: false,
              private: true
            }
          })
        },
      })
      .then(function(result) {
        return result.data;
      })
      .catch(function(err) {
        $log.log(err);
        return [];
      });
    },
    recipentGroupLoad: function(userorgFilter, cancelPromise) {
      userorgFilter = userorgFilter || ''; // Fallback to an empty string if userorgFilter is undefined
      const orgId = OrganizationService.getID();
      const url = apiUrl + '/YACategories/getCategoryGroupByOrgId?access_token=' + TokenService.get() + '&organizationid=' + orgId + '&search=' + userorgFilter ;
      const abortController = cancelPromise ? new window.AbortController() : null;
      if (cancelPromise && abortController) {
        cancelPromise.then(function() {
          abortController.abort();
        });
      }
      return fetch(url, {
        method: 'GET',
        signal: abortController ? abortController.signal : null
      })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(function(data) {
        // Check if data is an array and has more than one item
        // if (userorgFilter !== '' && Array.isArray(data) && data.length > 1) {
        //   return [data[0]]; // Return only the first item in an array
        // }
        return data.data; // Return the original data if length is 1 or less
      })
      .catch(function(err) {
        if (err.name === 'AbortError') {
        //   // The request was canceled, customize the error message here
        //   return $q.reject({ message: 'Request was canceled by the user', error: err });
        }
        return [];
      });
    },
    // update: function(dashboardGroup) {
    //   return $http({
    //     method: 'PUT',
    //     url: apiUrl + '/YADashboardGroups/' + dashboardGroup.id,
    //     data: dashboardGroup,
    //     params: {
    //       access_token: TokenService.get()
    //     }
    //   })
    //   .then(function(result) {
    //     return result.data;
    //   });
    // },
    // insert: function(dashboardGroup) {
    //   dashboardGroup = dashboardGroup || {};
    //   dashboardGroup.name = dashboardGroup.name || 'New Dashboard Group ' + new Date().toISOString().substr(0, 10);
    //   dashboardGroup.organizationid = OrganizationService.getID();

    //   return $http({
    //     method: 'POST',
    //     url: apiUrl + '/YADashboardGroups',
    //     data: dashboardGroup,
    //     params: {
    //       access_token: TokenService.get()
    //     }
    //   })
    //   .then(function(result) {
    //     return result.data;
    //   });
    // },
    // delete: function(dashboardGroupId) {
    //   return $http({
    //     method: 'DELETE',
    //     url: apiUrl + '/YADashboardGroups/' + dashboardGroupId,
    //     params: {
    //       access_token: TokenService.get()
    //     }
    //   })
    //   .then(function(result) {
    //     return result.data;
    //   });
    // },
    // getById: function(id) {
    //   var orgId = OrganizationService.getID();
    //   return $http({
    //     method: 'GET',
    //     url: apiUrl + '/YADashboardGroups',
    //     params: {
    //       access_token: TokenService.get(),
    //       filter: angular.toJson(getFilter({
    //         id: id,
    //         organizationid: orgId
    //       }))
    //     },
    //   })
    //   .then(function(result) {
    //     return (result.data || [])[0];
    //   })
    //   .catch(function(err) {
    //     $log.log(err);
    //     return [];
    //   });
    // }
  }
});

angular
.module('youApp')
.factory('OrganizationService', function($log, $http, apiUrl, UserService, IndTypeService, TokenService, loadingScreen) {

  function Organization( ) {
      // in database
    this.name = '';
    this.email = '';
    this.phone = '';
    this.phone2 = '';
    this.street = '';
    this.street2 = '';
    this.city = '';
    this.state = '';
    this.zip = '';
    this.contactname = '';
    this.contactfirstname = '';
    this.contactlastname = '';
    this.profileimage = null;
    this.profiletagline = null;
    this.currentstate = '';
    this.isonboarded = false;
    this.industrytypeid = -1;
    this.industryname = '';
    this.paymentprofile = '';
    this.currentstate = '';
    this.paymentprofileid = 0;
    this.lookupcode = '';
    this.superorg = false;
    this.maxcategories = 8;

      // not in database
    this.salesRep = '';
    this.indType = '';
    this.busCat = '';
    this.location = undefined;
    this.authorizedProv = undefined;
    this.how = undefined;

  }

  var me = this;
  me._Profile = new Organization();
  me._List = [];
  me._OrganizationDataList = [];
  me.emailTemplate = {};
  me.paginationData = {};
  me._ID = -1;
  me._StateNames = ['signuporg', 'setup', 'billing', 'ratefee', 'payment'];

  return {
    bulksms: function(message, numbers) {
      loadingScreen.turnOn(true);
      return $http({
        method: 'POST',
        url: apiUrl + '/YAOrganizations/bulksms',
        params: {
          access_token: TokenService.get(),
        },
        data: {
          message: message,
          numbers: numbers,
        },
      })
      .then(function() {
        loadingScreen.turnOn(false);
      })
      .catch(function() {
        loadingScreen.turnOn(false);
      });
    },

    register: function(cb) {
      loadingScreen.turnOn(true);
      me._Profile.industrytypeid = IndTypeService.getID();
      me._Profile.location = undefined;
      var data = me._Profile;
      if (me._ID !== -1 ) {// already registered just update
        // $http.post(apiUrl + '/YAOrganizations/update?where={"id":' + me._ID + '}&access_token=' + TokenService.get(), data )
        $http.post(apiUrl + '/YAOrganizations/updateOrgDetails?where={"id":' + me._ID + '}&access_token=' + TokenService.get(), data )
        .then(function(result) {
          $log.debug(result);
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
        return;
      }

        // check to see if already exists
      var where = {
        where: {
          and: [
              {name: data.name},
              {city: data.city},
              {state: data.state}
          ]
        }
      };
      $http.get(apiUrl + '/YAOrganizations?filter=' + angular.toJson(where) + '&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        if (result.data.length === 0) {
              // create new org
          data.profileimage = 'https://s3-us-west-2.amazonaws.com/yougetitfirstfiles/YA_default_profile_img.png';
          return $http.post(apiUrl + '/YAOrganizations?access_token=' + TokenService.get(), data );
        }
        else {
          $log.debug('already exists');
          loadingScreen.turnOn(false);
          cb('already exists');
        }
      }).then(function(result) {
        $log.debug(result);
        me._ID = result.data.id;
        cb(null, me._ID);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

      // check to see if an organization name already exists
      // name: org name
      // cb: cb( doesExist(true:false) )
    checkName: function( name, city, state, cb ) {
        // check to see if already exists
      var where = {
        where: {
          and: [
              {name: name},
              {city: city},
              {state: state}
          ]
        }
      };
      $http.get(apiUrl + '/YAOrganizations?filter=' + angular.toJson(where) + '&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        if (result.data.length === 0) {
          if ( cb )cb(false);
        }
        else {
          if ( cb )cb(true);
        }
      })
    },

    checkCode: function(code, cb) {
      loadingScreen.turnOn(true);
      var where = {
        where: {
          and: [
              {referralcode: code}
          ]
        }
      };
      $http.get(apiUrl + '/YASalesPeople?filter=' + angular.toJson(where) + '&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        if (result.data.length === 0) {
          if ( cb )cb(false);
        }
        else {
          if ( cb )cb(true);
        }
        loadingScreen.turnOn(false);
      })
      .catch(function() {
        if ( cb )cb(false);
        loadingScreen.turnOn(false);
      })
    },

    getList: function() {
      return me._List;
    },

    getOrganizationDataList: function() {
      return me._OrganizationDataList;
    },

    getEmailTemplate: function() {
      return me.emailTemplate;
    },

    getPaginationData: function() {
      return me.paginationData;
    },

    addMaxCategory: function(orgID, cb) {
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAOrganizations/addcategoryslot?access_token=' + TokenService.get(), {
        organizationid:  orgID
      }) .then(function(result) {
        $log.debug(result);
        cb(result.data);
        loadingScreen.turnOn(false);
      }) .catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    updateBusCategory: function(busCat, cb) {
      loadingScreen.turnOn(true);
      me._Profile.industrytypeid = IndTypeService.getID();
      if (me._ID !== -1) {
        $http.post(apiUrl + '/YAOrganizations/updateprimarycategory?access_token=' + TokenService.get(), {
          organizationid:  me._ID,
          primarycategoryid: busCat
        })
        .then(function(result) {
          $log.debug(result);
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
      }
    },

    deleteOrgById: function(orgID, cb) {
      loadingScreen.turnOn(true);
      $http.delete(apiUrl + '/YAOrganizations/' + orgID + '?&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        $log.debug(result);
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },


      //TODO: call update category from backend

    getIndustry: function() {
      return (me._Profile.industrytypeid || -1);
    },

    adminLoadList: function(cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAOrganizations?filter={"where":{"active":true}}&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        me._List = result.data;
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    adminLoadListWithPagination: function(page, limit, search, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAOrganizations/listWithPagination?access_token=' + TokenService.get() + '&page=' + page + '&limit=' + limit + '&search=' + search)
      .then(function(result) {
        me._List = result.data.data;
        me.paginationData = result.data.paginationdata;
        loadingScreen.turnOn(false);
        cb(null);
      }).catch(function(error) {
        loadingScreen.turnOn(false);
        cb(error.message);
      });
    },

    adminLoadListWithPaginationLms: function(page, limit, search, cancelPromise) {
      const url = apiUrl + '/YAOrganizations/listWithPagination?access_token=' + TokenService.get() + '&page=' + page + '&limit=' + limit + '&search=' + search;
      // Create a cancellation promise
      // let abortController;
      // if (cancelPromise) {
      //   abortController = new window.AbortController();
      //   cancelPromise.then(function() {
      //     abortController.abort(); // Cancel the request
      //   });
      // }
      const abortController = cancelPromise ? new window.AbortController() : null;
      if (cancelPromise && abortController) {
        cancelPromise.then(function() {
          abortController.abort();
        });
      }
      return fetch(url, {
        method: 'GET',
        signal: abortController ? abortController.signal : null
      })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(function(data) {
        // Check if data is an array and has more than one item
        // if (userorgFilter !== '' && Array.isArray(data) && data.length > 1) {
        //   return [data[0]]; // Return only the first item in an array
        // }
        return data.data; // Return the original data if length is 1 or less
      })
      .catch(function(err) {
        if (err.name === 'AbortError') {
        //   // The request was canceled, customize the error message here
        //   return $q.reject({ message: 'Request was canceled by the user', error: err });
        }
        return [];
      });
    },

    getOrganizationDataByOrgId: function(organizationid, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAOrganizations/getOrganizationDataByOrgId?access_token=' + TokenService.get() + '&organizationid=' + organizationid)
      .then(function(result) {
        me._OrganizationDataList = result.data.data;
        loadingScreen.turnOn(false);
        cb(null);
      }).catch(function(error) {
        loadingScreen.turnOn(false);
        cb(error.message);
      });
    },

    saveOrganizationData: function(payload, cb) {
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAOrganizations/saveYaOrganizationData?access_token=' + TokenService.get(), payload) .then(function(result) {
        $log.debug(result);
        cb(result.data);
        loadingScreen.turnOn(false);
      }) .catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    loadList: function(isOnboard, cb) {
      loadingScreen.turnOn(true);
      var id = UserService.getID();
      $http.get(apiUrl + '/YAUserOrganizations?filter={"where":{"and": [{"userid":' + id + '}, {"isdashboarduser": true}]}}&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        $log.debug(result);
        if ( result.data.length === 0 ) {
              // no organizations
          throw new Error('no organizations');
        } else {
          var search = '{"where":{"and":[{"isonboarded":' + isOnboard + '},{"active": true}, {"or":[';
          var idList = [];
          result.data.forEach(function(userOrg) {
            if ( userOrg.organizationid ) {
              if ( idList.indexOf(userOrg.organizationid) < 0 ) {
                idList.push(userOrg.organizationid);
                search += '{"id":"' + userOrg.organizationid + '"},';
              }
            }
          });
          search = search.slice(0, -1);
          search += ']}]}}';
          return $http.get(apiUrl + '/YAOrganizations?filter=' + search + '&access_token=' + TokenService.get(), {} );
        }
      }).then(function(result) {
        $log.debug(result);
        me._List = result.data;
        cb(null, me._List);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message, []);
        loadingScreen.turnOn(false);
      });
    },
    loadListSideBar: function(isOnboard, cb) {
      loadingScreen.turnOn(true);
      var id = UserService.getID();
      $http.get(apiUrl + '/YAOrganizations/getOrganizationListForAdmin?&userid=' + id + '&isonboarded=' + isOnboard + '&access_token=' + TokenService.get(), {} )
      // }
      .then(function(result) {
        $log.debug(result);
        me._List = result.data.data;
        cb(null, me._List);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message, []);
        loadingScreen.turnOn(false);
      });
    },
    loadByID: function(id, cb) {
      loadingScreen.turnOn(true);
      $http({
        method: 'GET',
        url: apiUrl + '/YAOrganizations/' + id,
        headers: {
          Authorization: TokenService.get(),
        }
      })
      .then(function(result) {
        $log.debug(result);
        if (result.data && result.data.id) {
          me._Profile = result.data;
          me._ID = me._Profile.id;
        } else {
          location.replace('/#/error/' + 404);
          throw {'status':404, 'message':'organization not found'};
        }
        cb(null);
        loadingScreen.turnOn(false);
      })
      .catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });

      // $http.get(apiUrl + '/YAOrganizations?filter={"where": {"and": [{"id":' + id + '}, {"active":true}]}}&access_token=' + TokenService.get(), {} )
      // .then(function(result) {
      //   $log.debug(result);
      //   if ( result.data && result.data.length > 0 ) {
      //     me._Profile = result.data[0];
      //     me._ID = me._Profile.id;
      //   }
      //   else {
      //     location.replace('/#/error/' + 404);
      //     throw {'status':404, 'message':'organization not found'};
      //   }
      //   cb(null);
      //   loadingScreen.turnOn(false);
      // }).catch(function(error) {
      //   $log.debug(error.message);
      //   cb(error.message);
      //   loadingScreen.turnOn(false);
      // });
    },

    isEmergencyCenterActive: function(id, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAOrganizations/isemergencycenteractive/?organizationid=' + id + '&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        $log.debug(result);
        if (result && result.data) {
          cb(null, result.data);
        } else {
          cb(null, false);
        }

        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    load: function(index) {
      me._Profile = me._List[index];
      me._ID = me._Profile.id;
      return me._Profile;
    },

    clear: function() {
      me._Profile = new Organization();
      me._ID = -1;
    },

    get: function() {
      return me._Profile;
    },

    getID: function() {
      if ( me._ID < 0 )
        return undefined;

      return me._ID;
    },

    setID: function(id) {
      me._ID = id;
    },

    setOnboardFinish: function(cb) {
      if ( me._ID > -1 ) {
        loadingScreen.turnOn(true);
        $http.post(apiUrl +
            '/YAOrganizations/update?where={"id":' + me._ID + '}&access_token=' + TokenService.get(), {'isonboarded': true} )
        .then(function(result) {
          $log.debug(result);
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
      }
    },

    setState: function(name, cb) {
      var curID = me._StateNames.indexOf(me._Profile.currentstate);
      var newID = me._StateNames.indexOf(name);
        // return first index if state isn't set or not correct
      if ( newID < 0 ) {
        newID = 0;
      }
      if ( newID > curID ) {
        curID = newID;
      }
      name = me._StateNames[curID];
      me._Profile.currentstate = name;

      if ( me._ID > -1 ) {
        loadingScreen.turnOn(true);
        $http.post(apiUrl +
            '/YAOrganizations/update?where={"id":' + me._ID + '}&access_token=' + TokenService.get(), {'currentstate':me._Profile.currentstate} )
        .then(function(result) {
          $log.debug(result);
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
      }
    },

    getStateName: function() {
      var id = me._StateNames.indexOf(me._Profile.currentstate);
        // return first index if state isn't set or not correct
      if ( id < 0 ) {
        id = 0;
      }
      return me._StateNames[id];
    },

    getEmailTemplatesByOrgId: function(organizationid,templateType, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAOrganizations/getEmailTemplatesByOrgId?access_token=' + TokenService.get() + '&organizationid=' + organizationid + '&templateType=' + templateType)
      .then(function(result) {
        me.emailTemplate = result.data.data;
        loadingScreen.turnOn(false);
        cb(null);
      }).catch(function(error) {
        loadingScreen.turnOn(false);
        cb(error.message);
      });
    }
  }
});

/*global Papa*/

angular
.module('youApp')
.factory('OrgUserService', function(
    $http,
    $httpParamSerializer,
    $timeout,
    $log,
    $q,
    apiUrl,
    TokenService,
    OrganizationService,
    UserService,
    loadingScreen,
    MessageBoxService,
    DashboardGroupService
  ) {

  function OrganizationUser() {
    this.name = 'New User';
    this.firstname = 'New';
    this.lastname = 'User';
    this.title = '';
    this.phonenumber = '';
    this.email = '';
    this.birthday = '';
    this.permissions = [false, false, false, false, false, false, false, false];
    this.edit = false;
    this.imageFile = '';
    this.profileImage = '';
    this.isdashboarduser = true;
  }

  function GroupUser() {
    this.name = 'New User';
    this.firstname = 'New';
    this.lastname = 'User';
    this.title = '';
    this.phonenumber = '';
    this.email = '';
    this.birthday = '';
    this.edit = false;
    this.imageFile = '';
    this.profileImage = '';
    this.isdashboarduser = false;
  }

  var me = this;
  me._Users = [];
  me._MyUser = {};
  me._MyAdmin = null;
  me.paginationData = {};
  me._regions = [];
  me._PageLimit = 20;

  me._Permissions = [
    'workflow admin',
    'add/edit templates',
    'view reports',
    'send alerts',
    'send advertisements',
    'send announcements',
    'send appointments',
    'organization admin',
    'email marketing'
  ];

  me._ServerPermissions = [
    'workflowaccess',
    'templateaccess',
    'reportaccess',
    'alertaccess',
    'advertisementaccess',
    'announcementaccess',
    'appointmentaccess',
    'orgadmin',
    'emailmarketing'
  ];

  me._Header = [
    'name',
    'firstname',
    'lastname',
    'title',
    'phonenumber',
    'email',
    'birthday'];

  me._CSVIgnore = [
    'organization admin'
  ];

  return {
      // ==
      // Generic Functions
      // ==

      // an accepted user that is on the server
    isFullUser: function(user) {
      return user.userid >= 0 && user.id >= 0 && (!user.pending || user.pending === false);
    },
      // a user that is not created on the server
    isNewUser: function(user) {
      return (!user.userid || user.userid < 0) && (!user.id || user.id < 0) && (!user.pending || user.pending === false);
    },

    getNewUser: function() {
      return new OrganizationUser();
    },

    getGroupUser: function() {
      return new GroupUser();
    },

    getInvite: function(user, groupid) {
      return _.find(user.invites, {
        categoryid: groupid || null
      });
    },

      // a user that has been created, but not yet invited
    isUninvitedUser: function(user, groupid) {
        //look through this users invites to find the one for this groupid
        //(or with no groupid if one isn't passed in)
      var invite = _.find(user.invites, function(invite) {
        if (groupid) {
          return invite.categoryid == groupid;
        } else {
          return invite.categoryid === null;
        }
      });
        //return true if there isn't an invite, false if there is
        //(if they have an invite they've been invited to this group)
      return !invite;
    },
      // a user that was invited to join an organization but hasn't accepted yet
    isInvitedUser: function(user, groupid) {
        //look through this users invites to find the one for this groupid
        //(or with no groupid if one isn't passed in)
      var invite = _.find(user.invites, function(invite) {
        if (groupid) {
          return invite.categoryid == groupid;
        } else {
          return invite.categoryid === null;
        }
      });
      if (!invite) {
        return false;
      }
        //sent status means the invite has yet to be accepted
      return invite.status === 'sent';
    },
      // a user that is requesting to join ( shouldn't be used anymore )
    isRequestingUser: function(user) {
      return user.userid && user.userid >= 0 && user.pending === true && user.id >= 0
    },
      // gets the current list of permissions
    getPermissionList: function() {
      return me._Permissions;
    },
      // returns a list of users
    __loadCSVFile: function(input, isDashboardUser) {
      var rslt = Papa.parse(input, {
        delimiter: ','
      });

      var cols = rslt.data.shift();
      var boolColMapping = {
        'workflow admin': 'workflowaccess',
        'add/edit templates': 'templateaccess',
        'view reports': 'reportaccess',
        'send alerts': 'alertaccess',
        'send advertisements': 'advertisementaccess',
        'send announcements': 'announcementaccess',
        'send appointments': 'appointmentaccess'
      };
      cols = _.map(cols, function(col) {
        return boolColMapping[col] || col;
      });
      var rows = _.map(rslt.data, function(row) {
        var hasContent = row.some(function(elmt) {
          return elmt;
        });

        if (!hasContent) {
          return null;
        }

        row = _.zipObject(cols, row);
        _.each(boolColMapping, function(col) {
          if ((row[col] || '').toLowerCase() === 'y' || (row[col] || '').toLowerCase() === 'true' || row[col] === true) {
            row[col] = true;
          } else {
            row[col] = false;
          }
        });

        _.each(cols, function(col) {
          if (col === 'email') {
            row[col] = ('' + row[col].toLowerCase());
          }
          if (_.isString(row[col])) {
            row[col] = row[col].trim();
          }
        });

        if (isDashboardUser) {
          row['isdashboarduser'] = true;
        }
        return row;
      });
      return rows.filter(function(row) {
        return row;
      });
    },

    __createCSVContent: function(rows) {

      var boolColMapping = {
        'workflow admin': 'workflowaccess',
        'add/edit templates': 'templateaccess',
        'view reports': 'reportaccess',
        'send alerts': 'alertaccess',
        'send advertisements': 'advertisementaccess',
        'send announcements': 'announcementaccess',
        'send appointments': 'appointmentaccess'
      };

      var cols = [
        'firstname',
        'lastname',
        'title',
        'phonenumber',
        'email',
        'workflow admin',
        'add/edit templates',
        'view reports',
        'send alerts',
        'send advertisements',
        'send announcements',
        'send appointments'
      ];

      return Papa.unparse({
        fields: cols,
        data: rows.map(function(row) {
          return cols.reduce(function(record, col) {
            if (boolColMapping[col]) {
              record.push(row[boolColMapping[col]] ? 'y' : 'n');
            } else {
              record.push(row[col]);
            }

            return record;
          }, []);
        }),
      });
    },

      //get a link to export a csv of dashboard or group users
    getCsvExportLink: function(organizationid, groupid) {
      if (organizationid) {
        return apiUrl + '/YAUserOrganizations/export?organizationid=' + organizationid + '&access_token=' + TokenService.get();
      } else {
        return apiUrl + '/YAUserOrganizations/export?groupid=' + groupid + '&access_token=' + TokenService.get();
      }
    },

      // ==
      // Dashboard User Functions
      // ==
      // load all dashboard users
      // must load Organization first
    dbUserLoad: function(cb) {
      cb = cb || function(err, rslt) {
        return new Promise(function(resolve, reject) {
          if (err) {
            reject(err);
          } else {
            resolve(rslt);
          }
        });
      };
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      return $http.get(apiUrl + '/YAOrganizations/listorgmembers?organizationid=' + orgID + '&access_token=' + TokenService.get(), {})
      .then(function(result) {
        $log.debug(result);
        var i = 0;
        me._Users = result.data;
        me._Users.forEach(function(user) {
          user.permissions = [];
          for (i = 0; i < me._Permissions.length; i++) {
            user.permissions[i] = user[me._ServerPermissions[i]];
          }
        });
        loadingScreen.turnOn(false);
        return cb(null);
      })
      .catch(function(error) {
        $log.debug(error.message);
        loadingScreen.turnOn(false);
        return cb(error.message);
      });
    },

      // Admin panel ONLY, load all dashboard users
    adminLoadList: function(cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAUserOrganizations?filter={"where":{"isdashboarduser":"true"}}&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        me._Users = result.data;
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    adminLoadListWithPagination: function(page, limit, search, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAUserOrganizations/listWithPagination?access_token=' + TokenService.get() + '&page=' + page + '&limit=' + limit + '&search=' + search)
      .then(function(result) {
        me._Users = result.data.data;
        me.paginationData = result.data.paginationdata;
        loadingScreen.turnOn(false);
        cb(null);
      }).catch(function(error) {
        loadingScreen.turnOn(false);
        cb(error.message);
      });
    },
      // must load users with dbUserLoad() first
      // add a temp dashboard user to the current user list
    dbAdd: function() {
      me._Users.splice( 0, 0, new OrganizationUser());
    },

      // remove a user from dashboard users
      // must load users with dbUserLoad() first
    dbRemove: function(user, cb) {
      if ( user.id > 0 && user.isdashboarduser ) {
        loadingScreen.turnOn(true);
        user.isdashboarduser = false;
        $http.put(apiUrl + '/YAUserOrganizations/?access_token=' + TokenService.get(), user ).then(function(result) {
          $log.debug(result);
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
      } else {
        var index = me._Users.indexOf(user);
        if ( index > -1 ) me._Users.splice(index, 1);
        cb(null);
      }
    },

      // must load users with dbUserLoad() first
      // get all loaded dashboard users that are not requesting to join
    dbGet: function() {
      var list = [];
      for ( var i = 0; i < me._Users.length; i++ ) {
        if ( me._Users[i].isdashboarduser ) {
          list.push(me._Users[i]);
        }
      }
      return list;
    },

      // must load users with dbUserLoad() first
      // get all loaded dashboard users that are requesting to join
      // ( should not use this anymore )
      /*dbGetRequesting: function(){
       var list = [];
       for( var i = 0; i < me._Users.length; i++ ){
       if( this.isRequestingUser(me._Users[i]) ){
       list.push(me._Users[i]);
       }
       }
       return list;
       },*/

      // must load users with dbUserLoad() first
      // gets the dashboard users that are workflow admins
    dbGetWorkFlowAdmins: function() {
      var list = [];
      list.push({
        'name':'None',
        'firstname': 'None',
        'lastname': '',
        'id':-1});
      for (var i = 0; i < me._Users.length; i++) {
        if ( me._Users[i].isdashboarduser && me._Users[i].workflowaccess ) {
          list.push(me._Users[i]);
        }
      }

      return list;
    },

      // must load an Organization first
      // send a dashboard user an invite
    dbSendInvite: function(user, cb) {
      if ( user.isdashboarduser ) {
        loadingScreen.turnOn(true);
        var orgID = parseInt( OrganizationService.getID() );
        var id = parseInt( user.id );
        $http.post(apiUrl + '/YAOrganizations/sendinvites?access_token=' + TokenService.get(), {organizationid: orgID, userorganizationid: id, isgroupinvite: false } ).then(function() {
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          cb(error.message);
          loadingScreen.turnOn(false);
        });
      } else {
        cb('not a dashboard user');
      }
    },

    dbSendRemindAll: function(options, cb) {
      options.organizationid = options.organizationid || parseInt(OrganizationService.getID());
      options.isgroupinvite = options.isgroupinvite || false;
      options.groupid = options.groupid || undefined;

      if (!options.organizationid) {
        return cb('Organization ID Required');
      }

      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAOrganizations/sendreminders?access_token=' + TokenService.get(), options)
      .then(function() {
        loadingScreen.turnOn(false);
        cb(null);
      })
      .catch(function(error) {
        loadingScreen.turnOn(false);
        cb(error.message);
      });
    },

    dbSendInviteAll: function(options, cb) {
      options = options || {};
      options.organizationid = options.organizationid || parseInt(OrganizationService.getID());
      options.isgroupinvite = false;
      options.dashboardgroupid = options.dashboardgroupid || undefined;

      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAOrganizations/sendinvites?access_token=' + TokenService.get(), options).then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

      //( should NOT be used anymore )
      // loads users from a csv file and matches them to the current dashboard user list and returns those dashboard users found
      /*getCSVFileUsers: function(text){
       var header = [];
       var userList = [];
       text = text.replace('\r','\n');
       var data = text.split('\n');
       var entries = [];
       var count = data.length;
       var i = 0, c = 0;
       for( i = 0; i < count; i++){
       entries.push( data[i].replace(';',',').replace('\t',',').split(',') );
       }
       // grab header
       header = entries[0];
       for( i = 0; i < header.length; i++){
       header[i] = header[i].toLowerCase();
       }

       // grab user info
       for( c = 1; c < count; c++){
       var user = {};
       var raw = entries[c];
       if( raw.length == header.length){
       // user info
       for( i = 0; i < header.length; i++ ){
       var index = me._Header.indexOf(header[i]);
       if( index >= 0 ){
       user[header[i]] = raw[i];
       }
       }

       // try to find user object
       for( var u = 0; u < me._Users.length; u++ ){
       if( user.name === me._Users[u].name && user.email === me._Users[u].email ){
       userList.push(me._Users[u]);
       break;
       }
       }
       }
       }
       return userList;
       },*/

      // loads dashboard users from a csv file
      // and uploads them to the current organization
      // must load an Organization first
    dbLoadCSVFile: function(text, isDashboardUser, cb) {
      var list = this.__loadCSVFile(text, isDashboardUser);
      this.__register(list, true, cb);
    },

      // update/create a dashboard user
      // must load Organization first
    dbUpdate: function(user, cb) {
      if (!user.isdashboarduser ) {
        cb('not a dashboard user');
        return;
      }
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      user.organizationid = orgID;
      for (var i = 0;i < me._Permissions.length;i++) {
        if ( user.permissions[i] ) {
          user[me._ServerPermissions[i]] = user.permissions[i];
        }
      }

      $log.log('user', user);
        // update
      if ( user.id > 0 ) {
        $http.put(apiUrl + '/YAUserOrganizations?access_token=' + TokenService.get(), user ).then(function(result) {
          $log.debug(result);
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
          // create new
      } else {
        $http.post(apiUrl + '/YAOrganizations/addpendingusers?access_token=' + TokenService.get(), {'organizationid':orgID, 'userstoadd':[user]} ).then(function(result) {
          $log.debug(result);
            //user.id = result.data.id;
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
      }
    },

      // must load Organization first
      // adds all current users as new pending dashboard users
      // optional groupID ( for addeding group users ONLY )
    __register: function(userArray, replace, cb) {
      $log.log('Replace:', !!replace);
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      var data = {organizationid: orgID, userstoadd: userArray, replace: !!replace};

        //var jsonList = angular.toJson( data );
        //$log.debug( jsonList.length );
      if (data.userstoadd.length !== 0) {
        $http.post(apiUrl + '/YAOrganizations/addpendingusers?access_token=' + TokenService.get(), data )
        .then(function(result) {
          $log.debug(result);
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
      } else {
        MessageBoxService.open('Incorrect Format', 'Formatting of the CSV is incorrect. Please use the included format in the download link above', 'Ok', function() {} );
        loadingScreen.turnOn(false);
      }
    },

    // load my organization dashboard user
    // must load Organization first
    // must login to a user first
    // also checks permissions
    // also loads myAdmin (workflow admin)
    dbLoadMyUser: function(permissionList, cb) {
      cb = cb || function(err, rslt) {
        return new Promise(function(resolve, reject) {
          if (err) {
            reject(err);
          } else {
            resolve(rslt);
          }
        });
      };

      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      var userID = UserService.getID();
      return $http.get(apiUrl + '/YAUserOrganizations?filter={"where":{"and":[{"userid":' + userID + '},{"organizationid":' + orgID + '},{"isdashboarduser":true}]}}&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        if (result.data && result.data.length > 0) {

          me._MyUser = result.data[0];
          var i = 0;
          if ( !UserService.isAdmin()) {
            for ( i = 0; i < permissionList.length; i++) {
              if ( me._MyUser[permissionList[i]] === false ) {
                //location.replace('/#/error/permission');
                throw {
                  status: -1,
                  message: 'no permission'
                };
              }
            }
          }

          var count = 0;
          for ( i = 0; i < me._ServerPermissions.length; i++ ) {
            if ( me._MyUser[me._ServerPermissions[i]] ) {
              count++;
            }
          }
          if ( count === 0 ) {
            throw {
              status: -1,
              message: 'no permission'
            };
          }

          return $http.get(apiUrl + '/YAUserOrganizations/getworkflowadmin?orguserid=' + me._MyUser.id + '&access_token=' + TokenService.get(), {})
          .then(function(result) {
            if (result && result.data && result.data.id && result.data.userid !== userID) {
              me._MyAdmin = result.data;
            } else {
              me._MyAdmin = null;
            }
            loadingScreen.turnOn(false);
            return cb(null);
          })
          .catch(function(error) {
            loadingScreen.turnOn(false);
            return cb(error.message);
          });
        } else {
          loadingScreen.turnOn(false);
          if (!UserService.isAdmin()) {
            location.replace('/#/error/' + 404);
            throw {
              status: 404,
              message: 'user not found'
            };
          } else {
            return cb(null);
          }
        }
      })
      .catch(function(error) {
        loadingScreen.turnOn(false);
        return cb(error.message);
      });
    },

    // load dashboard user by invitation token
    dbGetByToken: function(token, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAUserOrganizations?filter={"where":{"invitetoken":"' + token + '"}}&access_token=' + TokenService.get(), {} ).then(function(result) {
        if (result.data && result.data.length > 0) {
          me._MyUser = result.data[0];
          cb(null, me._MyUser.organizationid);
          loadingScreen.turnOn(false);
        } else {
          loadingScreen.turnOn(false);
          if ( !UserService.isAdmin()) {
            location.replace('/#/error/' + 404);
            throw {'status':404, 'message':'user not found'};
          } else {
            cb();
          }
        }
      }).catch(function(error) {
        cb(error.message, -1);
        loadingScreen.turnOn(false);
      });
    },

    // must call dbLoadMyUser() or dbGetByToken() first
    // test to see if the current user has the permission
    dbGetMyPermissions: function(permission) {
      return (me._MyUser[permission] === true);
    },

      // must call dbLoadMyUser() or dbGetByToken() first
    dbGetMyID: function() {
      return (me._MyUser.id || -1);
    },

      // must call dbLoadMyUser() first
      // get my workflow admin
    dbGetMyAdmin: function() {
      return me._MyAdmin;
    },

      // gets a dashboard users workflow admin
    dbGetAdmin: function(user, cb) {
      if ( user && user.id && user.id >= 1 && user.isdashboarduser ) {
        loadingScreen.turnOn(true);
        $http.get(apiUrl + '/YAUserOrganizations/getworkflowadmin?orguserid=' + user.id + '&access_token=' + TokenService.get(), {}
          ).then(function(result) {
            cb(null, result.data);
            loadingScreen.turnOn(false);
          }).catch(function(error) {
            cb(error.message, {name:'None'});
            loadingScreen.turnOn(false);
          });
      } else {
        cb(null, {name:'None'});
      }
    },

    dbSetAdmin: function(user, admin, cb) {
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAUserOrganizations/assignworkflowadmin?access_token=' + TokenService.get(), {
        orguserid: user.id,
        workflowadminid: admin.id
      }).then(function(result) {
        $log.debug(result);
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    dbRemoveWorkflowAdmin: function(user, cb) {
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAUserOrganizations/removeworkflowadmin?access_token=' + TokenService.get(), {
        orguserid: user.id
      }).then(function(result) {
        $log.debug(result);
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

      // ( not used anymore)
      // create a dashboard user request to joining an organization ( by organization code )
      /*requestJoin: function(code,cb) {
       loadingScreen.turnOn(true);
       $http.get(apiUrl + '/YAOrganizations/getbylookupcode?lookupcode='+code+'&access_token='+TokenService.get(), {} ).then(function(result){
       if( !result.data ) {
       cb("Code Not Found");
       loadingScreen.turnOn(false);
       return;
       }
       var id = result.data.id;
       $http.post(apiUrl + '/YAOrganizations/requestaccess?access_token='+TokenService.get(), {"organizationid":id} ).then(function(result){
       $log.debug(result);
       cb(null);
       loadingScreen.turnOn(false);
       }).catch(function(){
       cb("Server Error Try Again");
       loadingScreen.turnOn(false);
       });
       }).catch(function(){
       cb("Server Error Try Again");
       loadingScreen.turnOn(false);
       });
       },*/

      // ( not used anymore)
      // approve a requesting dashboard user into joining your organization
      /*approveUser: function(user,cb){
       loadingScreen.turnOn(true);
       $http.post(apiUrl + '/YAOrganizations/approverequest?access_token='+TokenService.get(), {"userorganizationid":user.id} ).then(function(){
       cb(null);
       loadingScreen.turnOn(false);
       }).catch(function(error){
       cb(error.message);
       loadingScreen.turnOn(false);
       });
       },*/

      // ( not used anymore)
      // deny a requesting dashboard user from joining your organization
      /*denyUser: function(user,cb){
       loadingScreen.turnOn(true);
       $http.post(apiUrl + '/YAOrganizations/denyrequest?access_token='+TokenService.get(), {"userorganizationid":user.id} ).then(function(){
       cb(null);
       loadingScreen.turnOn(false);
       }).catch(function(error){
       cb(error.message);
       loadingScreen.turnOn(false);
       });
       },*/

      // accept invite into organization
      // must dbGetByToken() to load myUser
    dbAcceptInvite: function(invitecode, cb) {
      loadingScreen.turnOn(true);
      me._MyUser.userid = UserService.getID();
      me._MyUser.pending = false;
      var body = {
        invitecode: invitecode
      };
      $http.post(apiUrl + '/YAUsers/acceptinvite?access_token=' + TokenService.get(), body ).then(function(result) {
        var res = result.data;
          //res.description will either be an error message or the userorg object
        if (res && res.status === true) {
          cb(null, res.description)
        } else {
          cb(res.description);
        }
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

      // ==
      // Group User Functions
      // ==

      // load all group users
      // must load Organization first
    grpUserLoad: function(groupID, page, filter, cb) {
      loadingScreen.turnOn(true);
      var limit = me._PageLimit;
      var skip = Math.max( (page - 1) * limit, 0);
      $http({
        method: 'GET',
        url: apiUrl + '/YAUserOrganizations/getbygroup',
        params: {
          groupid: groupID,
          limit: limit,
          skip: skip,
          filter: filter,
          access_token: TokenService.get(),
        },
      })
      .then(function(result) {
        if ( result.data && result.data.length > 0 ) {
          me._Users = result.data;
          cb(null);
        } else {
          me._Users = [];
          cb(null);
        }
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });

    },

    grpUserLoadAll: function(groupID, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAUserOrganizations/getbygroup' +
          '?groupid=' + groupID +
          '&limit=0' + //limit must be explicitly set to zero to get all results
          '&access_token=' + TokenService.get(), {})
      .then(function(result) {
        if (result.data && result.data.length > 0) {
          me._Users = result.data;
          cb(result.data, null);
        } else {
          me._Users = [];
          cb(me._Users, null);
        }
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(null, error.message);
        loadingScreen.turnOn(false);
      });

    },

    userLoadByPage: function(orgID, page, filter, cb) {
      loadingScreen.turnOn(true);
      var limit = me._PageLimit;
      var skip = Math.max( (page - 1) * limit, 0);
      $http.get(apiUrl + '/YAOrganizations/listorgmembers?organizationid=' + orgID + '&limit=' + limit + '&skip=' + skip + '&filter=' + filter + '&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        if ( result.data && result.data.length > 0 ) {
          me._Users = result.data;
          var i = 0;
          me._Users.forEach( function(user) {
            user.permissions = [];
            for (i = 0;i < me._Permissions.length;i++) {
              user.permissions[i] = user[me._ServerPermissions[i]];
            }
          });
          cb(null);
        } else {
          me._Users = [];
          cb(null);
        }
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    userMaxPage: function(orgID, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAOrganizations/listorgmemberscount?organizationid=' + orgID + '&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        var max = Math.ceil(result.data / me._PageLimit);
        cb( max );
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });

    },

    grpMaxPage: function(groupID, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAUserOrganizations/getbygroupcount?groupid=' + groupID + '&access_token=' + TokenService.get(), {} ).then(function(result) {
        var max = Math.ceil(result.data / me._PageLimit);
        cb( max );
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });

    },

      // must load users with grpUserLoad() or grpLoadCSVFile() first
      // get all loaded group users
    grpGet: function() {
      return me._Users;
    },
    getPaginationData: function() {
      return me.paginationData;
    },
    loadCsvData: function(text, groupid, cb) {
      var list = this.__loadCSVFile(text, false);
      this.grpLoadCSVFile(list, groupid, true, cb);
    },

    grpLoadCSVFile: function(userArray, groupID, replace, cb) {
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      var data = {organizationid: orgID, groupid: groupID, userstoadd: userArray};

      data.userstoadd.forEach(function(user) {
        user.isdashboarduser = false;
      });

      data.replace = !!replace

        //var jsonList = angular.toJson( data );
        //$log.debug( jsonList.length );
      if (data.userstoadd.length !== 0) {
        $http.post(apiUrl + '/YAOrganizations/addpendingusers?access_token=' + TokenService.get(), data )
        .then(function(result) {
          $log.debug(result);
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
      } else {
        MessageBoxService.open('Incorrect Format', 'Formatting of the CSV is incorrect. Please use the included format in the download link above', 'Ok', function() {} );
        loadingScreen.turnOn(false);
      }
    },

      // deleteUser
    grpDeleteUser: function(user, groupID, cb) {
      if ( user.id <= 0 ) return;
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAUserOrganizations/removefromgroup?groupid=' + groupID + '&access_token=' + TokenService.get(), {'orgusers':[user.id]} ).then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

      // return a new group user to fill out
    grpGetTempUser: function() {
      return new GroupUser();
    },

      // addUser
    grpUpdateUser: function(user, groupID, cb) {
      if ( user.isdashboarduser ) {
        cb('not a group user');
        return;
      }
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      user.organizationid = orgID;

      $http.post(apiUrl + '/YAOrganizations/addpendingusers?access_token=' + TokenService.get(), {'organizationid':orgID, 'groupid': parseInt(groupID), 'userstoadd':[user]} ).then(function(result) {
        $log.debug(result);
          //user.id = result.data.id;
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });

    },

    grpSendInvite: function(user, groupid, cb) {
      loadingScreen.turnOn(true);
      var orgID = parseInt( OrganizationService.getID() );
      var id = parseInt( user.id );
      $http.post(apiUrl + '/YAOrganizations/sendinvites?access_token=' + TokenService.get(), {
        organizationid: orgID,
        userorganizationid: id,
        groupid: groupid
      } ).then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    grpSendInvites: function(ids, groupid, cb) {
      loadingScreen.turnOn(true);
      var orgID = parseInt( OrganizationService.getID() );
      $http.post(apiUrl + '/YAOrganizations/sendinvites?access_token=' + TokenService.get(), {
        organizationid: orgID,
        userorganizationids: ids,
        groupid: groupid
      }).then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    emailSendInvite: function(user, groupid, templateid, cb) {
      loadingScreen.turnOn(true);
      var orgID = parseInt( OrganizationService.getID() );
      var id = parseInt( user.id );
      $http.post(apiUrl + '/YAOrganizations/sendinvites?access_token=' + TokenService.get(), {
        organizationid: orgID,
        userorganizationid: id,
        groupid: groupid,
        emailtemplateid: templateid
      } ).then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    emailSendInvites: function(ids, groupid, templateid, cb) {
      loadingScreen.turnOn(true);
      var orgID = parseInt(OrganizationService.getID());
      var params = {
        organizationid: orgID,
        groupid: groupid,
        emailtemplateid: templateid
      }

      if (ids && ids.length) {
        params.userorganizationids = ids;
      }

      $http.post(apiUrl + '/YAOrganizations/sendinvites?access_token=' + TokenService.get(), params)
      .then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    update: function(userOrganization) {
      if (!userOrganization.id) {
        return Promise.resolve(null);
      }

      return $http({
        method: 'PUT',
        url: apiUrl + '/YAUserOrganizations/' + userOrganization.id,
        data: userOrganization,
        params: {
          access_token: TokenService.get()
        }
      })
      .then(function(result) {
        return result.data;
      });
    },

    insert: function(userOrganization) {
      if (!userOrganization.isdashboarduser ) {
        return Promise.resolve(null);
      }

      userOrganization.organizationid = parseInt(OrganizationService.getID());

      return $http({
        method: 'POST',
        url: apiUrl + '/YAUserOrganizations',
        data: userOrganization,
        params: {
          access_token: TokenService.get()
        }
      })
      .then(function(result) {
        return result.data;
      });
    },

    lookupByEmail: function(email) {
      var orgId = parseInt(OrganizationService.getID());

      return $http({
        method: 'GET',
        url: apiUrl + '/YAUserOrganizations',
        params: {
          access_token: TokenService.get(),
          filter: angular.toJson({
            where: {
              email: (email || '').toLowerCase(),
              organizationid: orgId
            }
          })
        }
      })
      .then(function(result) {
        return result.data;
      });
    },

    getById: function(id) {
      var orgId = parseInt(OrganizationService.getID());

      return $http({
        method: 'GET',
        url: apiUrl + '/YAUserOrganizations',
        params: {
          access_token: TokenService.get(),
          filter: angular.toJson({
            where: {
              id: id,
              organizationid: orgId
            }
          })
        }
      })
      .then(function(result) {
        return (result.data || [])[0];
      });
    },

    loadDashboardGroupFromCSV: function(contents, dashboardGroupId) {
      var self = this;
      var list = self.__loadCSVFile(contents, true)
      .filter(function(user) {
        return user.email;
      });

      return DashboardGroupService.getDashboardGroupUserOrganizations(dashboardGroupId)
      .then(function(dashboardGroupUserOrganizations) {
        return Promise.all(list.map(function(user) {
          return self.lookupByEmail(user.email.toLowerCase())
          .then(function(existingUsers) {
            var existingUser = (existingUsers || [])[0];

            if (existingUser) {
              var dashboardGroupUserOrganizationIndex = (dashboardGroupUserOrganizations || [])
              .findIndex(function(dashboardGroupUserOrganization) {
                return dashboardGroupUserOrganization && dashboardGroupUserOrganization.yauserorganizationid === existingUser.id;
              });

              if (dashboardGroupUserOrganizationIndex > -1) {
                dashboardGroupUserOrganizations[dashboardGroupUserOrganizationIndex] = null;
              }

              Object.assign(existingUser, user);
              existingUser.dashboardGroupIds = existingUser.dashboardGroupIds || [];
              existingUser.dashboardGroupIds.push(dashboardGroupId);
              return self.update(existingUser);
            } else {
              user.dashboardGroupIds = user.dashboardGroupIds || [];
              user.dashboardGroupIds.push(dashboardGroupId);
              return self.insert(user);
            }
          })
          .then(function() {
            return Promise.all(
              dashboardGroupUserOrganizations
              .filter(function(r) {
                return r;
              })
              .map(function(dashboardGroupUserOrganization) {
                return DashboardGroupService.deleteById(dashboardGroupUserOrganization.id);
              })
            );
          });
        }));
      });
    },

    createCSVFile: function(users, filename) {
      var csvContent = this.__createCSVContent(users);

      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
      hiddenElement.target = '_blank';
      hiddenElement.download = filename || 'users.csv';
      hiddenElement.click();

      hiddenElement = null;
    },

    loadFormRespondents: function(input, orgId, groupId) {
      var rslt = Papa.parse(input, {
        delimiter: ','
      });
      var colOriginals = rslt.data.shift();
      var colMappings = colOriginals.reduce(function(collector, col, indx) {
        var colSnake = _.snakeCase(col + '_' + indx);
        collector[colSnake] = col.replace(/email/g, '').trim();
        return collector;
      }, {});
      var cols = Object.keys(colMappings);

      // console.log({colMappings, cols});

      var rows = _.map(rslt.data, function(row) {
        var hasContent = Object
        .values(row)
        .filter(function(v) {
          return v;
        })
        .length;

        if (!hasContent) {
          return null;
        }

        return _.zipObject(cols, row);
      }).filter(function(r) {return r; });

      var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      var data = rows.reduce(function(collector, row) {
        var record = {
          firstname: '',
          lastname: '',
          title: '',
          phone: '',
          email: '',
          reporters: [],
          receivers: [],
        };

        var busCompanyInformation = {
          type: 'bus',
          name: '',
          email: '',
        };

        Object.entries(row).forEach(function(kv) {
          // console.log({kv})
          var k = kv[0];
          var v = kv[1];

          if (k.startsWith('first')) {
            record.firstname = v;
            return;
          }
          if (k.startsWith('last')) {
            record.lastname = v;
            return;
          }
          if (k.includes('title')) {
            record.title = v;
            return;
          }
          if (k.includes('phone')) {
            record.phone = v.replace(/[^0-9]+/g, '');
            return;
          }
          if (k.includes('bus') && !k.includes('email')) {
            busCompanyInformation.name = v;
            return;
          }
          if (!emailRegex.test(v)) {
            // value is not an email
            return;
          }
          if (k.startsWith('email')) {
            record.email = v;
            return;
          }
          if (k.includes('bus') && k.includes('email')) {
            busCompanyInformation.email = v;
            return;
          }
          if (k.includes('parent') || k.includes('guardian')) {
            record.reporters.push({
              type: colMappings[k],
              email: v,
            });
            return;
          }

          record.receivers.push({
            type: colMappings[k],
            email: v,
          });
        });

        if (busCompanyInformation.email) {
          record.receivers.push(busCompanyInformation);
        }

        collector.push(record);
        return collector;
      }, []);

      return $http({
        method: 'POST',
        url: apiUrl + '/YAOrganizations/formrespondents',
        params: {
          access_token: TokenService.get(),
          organizationid: orgId,
          groupid: groupId,
        },
        data: data,
      })
      .then(function(result) {
        return (result.data);
      });
    },

    getFormRespondents: function(orgId, groupId, csv) {
      if (csv) {
        const qs = $httpParamSerializer({
          access_token: TokenService.get(),
          organizationid: orgId,
          groupid: groupId,
          format: 'csv',
        });
        const csvUrl = apiUrl + '/YAOrganizations/formrespondents?' + qs;
        return csvUrl;
      }

      return $http({
        method: 'GET',
        url: apiUrl + '/YAOrganizations/formrespondents',
        params: {
          access_token: TokenService.get(),
          organizationid: orgId,
          groupid: groupId,
        },
      })
      .then(function(result) {
        const rows = result.data
        .filter(function(record) {
          return record.sourcekey;
        })
        .reduce(function(collector, record) {
          collector[record.sourcekey] = collector[record.sourcekey] || {
            sourcekey: record.sourcekey,
            subjectdescription: record.subjectdescription,
            firstname: record.firstname,
            lastname: record.lastname,
            title: record.title,
            phone: record.phone,
            email: record.email,
            reporters: [],
            reportees: [],
          };

          const related = {
            firstname: record.ufirstname,
            lastname: record.ulastname,
            userphone: record.userphone,
            useremail: record.useremail,
            reporter: record.reporter,
          };

          if (record.reporter && record.useremail) {
            collector[record.sourcekey].reporters.push(related);
          } else if (record.useremail) {
            collector[record.sourcekey].reportees.push(related);
          }

          return collector;
        }, {});

        return Object.values(rows);
      });
    },

    deleteRespondent: function(sourcekey) {
      return $http({
        method: 'DELETE',
        url: apiUrl + '/YAOrganizations/formrespondents/' + sourcekey,
        params: {
          access_token: TokenService.get(),
        },
      });
    },

    getFormRespondentGroups: function(orgId) {
      return $http({
        method: 'GET',
        url: apiUrl + '/YAFormResponseGroups',
        params: {
          access_token: TokenService.get(),
          filter: angular.toJson({
            where: {
              organizationid: orgId
            }
          })
        },
      })
      .then(function(result) {
        return result.data;
      });
    },

    addFormRespondentGroups: function(orgId) {
      return $http({
        method: 'POST',
        url: apiUrl + '/YAFormResponseGroups',
        params: {
          access_token: TokenService.get(),
        },
        data: {
          organizationid: orgId,
          name: 'New Response Group'
        },
      });
    },

    deleteFormRespondentGroup: function(groupId) {
      return $http({
        method: 'DELETE',
        url: apiUrl + '/YAFormResponseGroups/' + groupId,
        params: {
          access_token: TokenService.get(),
        },
      });
    },

    updateResponseGroup: function(responseGroup) {
      return $http({
        method: 'PUT',
        url: apiUrl + '/YAFormResponseGroups/' + responseGroup.id,
        params: {
          access_token: TokenService.get(),
        },
        data: {
          name: responseGroup.name
        },
      });
    },

    checkXmitNumber: function(user, cb) {
      if (!user.xmitnumber || user.xmitnumber.trim() === '') {
        cb(null);
        return true;
      }
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      $http.post(apiUrl + '/YAUserOrganizations/siteSearchNumber?access_token=' + TokenService.get(), {
        xmitnumber: user.xmitnumber,orgID:orgID,id:user.id
      }).then(function(response) {
        loadingScreen.turnOn(false);
        if (response.data && response.data.status === true) {
          cb(null);
          return true; // Return true on success
        } else {
          loadingScreen.turnOn(false);
          var errorMsg = response.data && response.data.description ? response.data.description : 'Unknown error occurred';
          cb(errorMsg);
          return false; // Return false on failure
        }
      }).catch(function(error) {
        loadingScreen.turnOn(false);
        cb(error.message);
        return false; // Return false on API error
      });
    },

    // updateUserToQuickResponse: function(user) {
    //   if (!user.xmitnumber || user.xmitnumber.trim() === '') {
    //     // cb(null);
    //     return true;
    //   }
    //   loadingScreen.turnOn(true);
    //   var orgID = OrganizationService.getID();
    //   $http.post(apiUrl + '/YAUserOrganizations/updateUserToQuickResponse?access_token=' + TokenService.get(), {
    //     xmitnumber: user.xmitnumber,orgID:orgID,id:user.id
    //   }).then(function(response) {
    //     loadingScreen.turnOn(false);
    //     if (response.data && response.data.status === true) {
    //       $http.post(apiUrl + '/YAUserOrganizations/updateUserToQuickResponse?access_token=' + TokenService.get(), {
    //         xmitnumber: user.xmitnumber,orgID:orgID,id:user.id
    //       }).then(function(response) {
    //         loadingScreen.turnOn(false);
    //         if (response.data && response.data.status === true) {
    //           // cb(null);
    //           return true; // Return true on success
    //         } else {
    //           loadingScreen.turnOn(false);
    //           return false; // Return false on failure
    //         }
    //       }).catch(function() {
    //         loadingScreen.turnOn(false);
    //         // cb(error.message);
    //         return false; // Return false on API error
    //       });
    //     } else {
    //       loadingScreen.turnOn(false);
    //       return false; // Return false on failure
    //     }
    //   }).catch(function() {
    //     loadingScreen.turnOn(false);
    //     // cb(error.message);
    //     return false; // Return false on API error
    //   });
    // },
    updateUserToQuickResponse: function(user) {
      // Skip if xmitnumber is missing or empty
      const orgID = OrganizationService.getID();
      if (!user.xmitnumber || user.xmitnumber.trim() === '') {
        if (user.originalxmitnumber) {
          $http
          .post(apiUrl + '/YAUserOrganizations/device-alert-access?access_token=' + TokenService.get(), {
            orgID: orgID,
            id: user.id,
            originalxmitnumber:user.originalxmitnumber
          })
          .then(function(updateResponse) {
            if (updateResponse.data && updateResponse.data.status === true) {
              // loadingScreen.turnOn(false);
              return true; // Both APIs succeeded
            } else {
              // loadingScreen.turnOn(false);
              return true; // siteUpdate failed
            }
          })
          .catch(function() {
            // loadingScreen.turnOn(false);
            return true; // siteUpdate API error
          });
        } else {
          return Promise.resolve(true); // Return resolved promise with true
        }
      } else {
        loadingScreen.turnOn(true);
        // const apiUrl = apiUrl; // Assumes apiUrl is defined in scope
        // const accessToken = TokenService.get();
        // Step 1: Call siteSearch API
        $http
        .post(apiUrl + '/YAUserOrganizations/site-search?access_token=' + TokenService.get(), {
          xmitnumber: user.xmitnumber,
          orgID: orgID,
          id: user.id
        })
        .then(function(response) {
          // Check siteSearch response
          if (response.data && response.data.status === true) {
            // Step 2: Call siteUpdate API
            $http
            .post(apiUrl + '/YAUserOrganizations/site-update?access_token=' + TokenService.get(), {
              xmitnumber: user.xmitnumber,
              orgID: orgID,
              id: user.id
            })
            .then(function(updateResponse) {
              loadingScreen.turnOn(false);
              if (updateResponse.data && updateResponse.data.status === true) {
                $http
                .post(apiUrl + '/YAUserOrganizations/phone-update?access_token=' + TokenService.get(), {
                  orgID: orgID,
                  id: user.id
                })
                .then(function(updateResponse) {
                  if (updateResponse.data && updateResponse.data.status === true) {
                    $http
                    .post(apiUrl + '/YAUserOrganizations/device-phone-update?access_token=' + TokenService.get(), {
                      orgID: orgID,
                      id: user.id
                    })
                    .then(function(updateResponse) {
                      if (updateResponse.data && updateResponse.data.status === true) {
                        $http
                        .post(apiUrl + '/YAUserOrganizations/device-alert-access?access_token=' + TokenService.get(), {
                          orgID: orgID,
                          id: user.id,
                          originalxmitnumber: user.xmitnumber,
                        })
                        .then(function(updateResponse) {
                          if (updateResponse.data && updateResponse.data.status === true) {
                            // loadingScreen.turnOn(false);
                            return true; // Both APIs succeeded
                          } else {
                            // loadingScreen.turnOn(false);
                            return false; // siteUpdate failed
                          }
                        })
                        .catch(function() {
                          // loadingScreen.turnOn(false);
                          return false; // siteUpdate API error
                        });
                      } else {
                        return false; // siteUpdate failed
                      }
                    })
                    .catch(function() {
                      // loadingScreen.turnOn(false);
                      return false; // siteUpdate API error
                    });
                  } else {
                    return false; // siteUpdate failed
                  }
                })
                .catch(function() {
                  // loadingScreen.turnOn(false);
                  return false; // siteUpdate API error
                });
              } else {
                return false; // siteUpdate failed
              }
            })
            .catch(function() {
              loadingScreen.turnOn(false);
              return false; // siteUpdate API error
            });
          } else {
            loadingScreen.turnOn(false);
            return false; // siteSearch failed
          }
        })
        .catch(function() {
          loadingScreen.turnOn(false);
          return false; // siteSearch API error
        });
      }
    },

    updateSiteDetails: function(user) {
      if (!user.xmitnumber || user.xmitnumber.trim() === '') {
        // cb(null);
        return true;
      }
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      return $http.post(apiUrl + '/YAUserOrganizations/updateSiteDetails?access_token=' + TokenService.get(), {orgID:orgID,id:user.id
      }).then(function(response) {
        loadingScreen.turnOn(false);
        if (response.data && response.data.status === true) {
          // cb(null);
          return true; // Return true on success
        } else {
          loadingScreen.turnOn(false);
          // var errorMsg = response.data && response.data.description ? response.data.description : 'Unknown error occurred';
          // cb(errorMsg);
          return false; // Return false on failure
        }
      }).catch(function() {
        loadingScreen.turnOn(false);
        // cb(error.message);
        return false; // Return false on API error
      });
    },

    updatePhoneDetails: function(user) {
      if (!user.xmitnumber || user.xmitnumber.trim() === '') {
        // cb(null);
        return true;
      }
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      return $http.post(apiUrl + '/YAUserOrganizations/updatePhoneDetails?access_token=' + TokenService.get(), {orgID:orgID,id:user.id
      }).then(function(response) {
        loadingScreen.turnOn(false);
        if (response.data && response.data.status === true) {
          // cb(null);
          return true; // Return true on success
        } else {
          loadingScreen.turnOn(false);
          // var errorMsg = response.data && response.data.description ? response.data.description : 'Unknown error occurred';
          // cb(errorMsg);
          return false; // Return false on failure
        }
      }).catch(function() {
        loadingScreen.turnOn(false);
        // cb(error.message);
        return false; // Return false on API error
      });
    },

    updateAlertAccess: function(user) {
      if (!user.xmitnumber || user.xmitnumber.trim() === '') {
        // cb(null);
        return true;
      }
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      return $http.post(apiUrl + '/YAUserOrganizations/updateAlertAccess?access_token=' + TokenService.get(), {orgID:orgID,id:user.id
      }).then(function(response) {
        loadingScreen.turnOn(false);
        if (response.data && response.data.status === true) {
          // cb(null);
          return true; // Return true on success
        } else {
          loadingScreen.turnOn(false);
          // var errorMsg = response.data && response.data.description ? response.data.description : 'Unknown error occurred';
          // cb(errorMsg);
          return false; // Return false on failure
        }
      }).catch(function() {
        loadingScreen.turnOn(false);
        // cb(error.message);
        return false; // Return false on API error
      });
    },

    regionsLoadList: function() {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAOrganizations/getAllRegions?access_token=' + TokenService.get(), {} )
      .then(function(result) {
        me._regions = result.data.data;
        // cb(null);
        loadingScreen.turnOn(false);
      })
    },

    getRegions: function() {
      return me._regions;
    },

      ////// OLD
      /*
       getGroupUser: function(groupID,cb){
       loadingScreen.turnOn(true);
       $http.get(apiUrl + '/YAUserOrganizations/getbygroup?groupid='+groupID+'&access_token='+TokenService.get(), {} ).then(function(result) {
       if( result.data && result.data.length>0 ){
       cb(null,result.data);
       }else{
       cb(null,[]);
       }
       loadingScreen.turnOn(false);
       }).catch(function(error){
       cb(error.message,[]);
       loadingScreen.turnOn(false);
       });
       },
       getGroupListUsers: function(groups,cb){

       loadingScreen.turnOn(true);
       var chain = [];
       var userList = [];
       for( var i = 0; i < groups.length; i++ ){
       chain.push( $http.get(apiUrl + '/YAUserOrganizations/getbygroup?groupid='+groups[i].id+'&access_token='+TokenService.get(), {} )
       .then(function(result){
       userList = userList.concat(result.data);
       }));
       }

       $q.all( chain ).then(function(){
       cb(null,userList);
       loadingScreen.turnOn(false);
       }).catch(function(error){
       cb(error.message,[]);
       loadingScreen.turnOn(false);
       });

       },
       assignToGroup: function(groupID,users,cb){
       loadingScreen.turnOn(true);
       $http.post(apiUrl + '/YAUserOrganizations/assigntogroup?groupid='+groupID+'&access_token='+TokenService.get(), {"orgusers":users} ).then(function() {
       cb(null);
       loadingScreen.turnOn(false);
       }).catch(function(error){
       cb(error.message);
       loadingScreen.turnOn(false);
       });
       },
       removeFromGroup: function(groupID,users,cb){
       loadingScreen.turnOn(true);
       $http.post(apiUrl + '/YAUserOrganizations/removefromgroup?groupid='+groupID+'&access_token='+TokenService.get(), {"orgusers":users} ).then(function() {
       cb(null);
       loadingScreen.turnOn(false);
       }).catch(function(error){
       cb(error.message);
       loadingScreen.turnOn(false);
       });
       }
       */

  }
});

angular
.module('youApp')
.factory('OrgSaleService', function($http, $log, apiUrl, TokenService, OrganizationService, loadingScreen) {
  function SalesPerson() {
    this.firstname = '';
    this.lastname = '';
    this.referralcode = '';
    this.id = -1;
  }
  var me = this;
  me._SalesMember = new SalesPerson();
  me._Code = '';
  return {
    setCode: function(code) {
      me._Code = code;
    },
    loadSalesPerson: function(cb) {
      if ( me._Code !== '') {
        loadingScreen.turnOn(true);
        $http.get(apiUrl + '/YASalesPeople?filter={"where":{"referralcode":"' + me._Code + '"}}&access_token=' + TokenService.get(), {} )
        .then(function(result) {
          me._SalesMember = result.data[0];
          $log.debug(result);
          cb(me._SalesMember, null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(undefined, error.message);
          loadingScreen.turnOn(false);
        });
      }
      else {
        cb(undefined, 'no code');
      }
    },
    setSalesPerson: function(orgID, cb) {
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YASalesPeople/addtoorganization?access_token=' + TokenService.get(), {
        organizationid: orgID,
        referralcode: me._Code}
        ).then(function(result) {
          $log.debug(result);
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
    },
    clearSalesPerson: function(cb) {
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      $http.post(apiUrl + '/YASalesPeople/removefromorganization?access_token=' + TokenService.get(), {'organizationid':orgID, 'salespersonid':me._SalesMember.id} )
      .then(function(result) {
        $log.debug(result);
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    getSalesPerson: function() {
      return me._SalesMember;
    },
    verify: function(cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YASalesPeople/verifybyreferral?referral=' + me._Code + '&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        $log.debug(result);
        cb((result.data.status) ? null : result.data.description);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    }
  }
});

angular
.module('youApp')
.factory('OrgReportService', function($http, apiUrl, TokenService, OrganizationService, loadingScreen, $httpParamSerializer) {

  function MessageTypeReport() {
    this.sentlast1day = 0;
    this.sentlast7days = 0;
    this.sentlast30days = 0;
  }

  function OrganizationReport() {
    this.followers = 0;
    this.followerslast1day = 0;
    this.followerslast7days = 3;
    this.followerslast30days = 3;
    this.expenselast1day = 60;
    this.expenselast7days = 150;
    this.expenselast30days = 150;
    this.unfollowedlast1day = 0;
    this.unfollowedlast7days = 0;
    this.unfollowedlast30days = 0;
  }


  var me = this;
  me._MsgReports = [];
  me._MsgTypeReport = undefined;
  me._OrgReport = undefined;
  me._MessageReport = undefined;
  me._ReportDetails = undefined;
  me._PageLimit = 10;

  return {
    loadMsgReports: function(messages, cb) {
      var idList = [];
      messages.forEach(function(message) {
        idList.push(message.id || -1 );
      });

        //loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAReports/messagereport?templateids=[' + idList.toString() + ']&access_token=' + TokenService.get(), {})
      .then(function(result) {
        if (cb)cb(null, result.data);
            //loadingScreen.turnOn(false);
      }).catch(function(error) {
        if (cb)cb(error.message);
            //loadingScreen.turnOn(false);
      });
    },
    getMsgReports: function() {
      return (me._MsgReports || []);
    },

    loadMsgTypeReport: function(type, cb) {
      var id = OrganizationService.getID();
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAReports/messagesummary?messagetype=' + type + '&organizationid=' + id + '&access_token=' + TokenService.get(), {})
      .then(function(result) {
        me._MsgTypeReport = result.data;
        if (cb)cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    getMsgTypeReport: function() {
      return (me._MsgTypeReport || new MessageTypeReport() );
    },

    loadFollowersReport: function(cb) {
      var id = OrganizationService.getID();
      loadingScreen.turnOn(true);
      $http({
        method: 'GET',
        url: apiUrl + '/YAOrganizations/listfollowers',
        params: {
          organizationid: id,
          access_token: TokenService.get(),
          limit: 0,
        },
      })
      .then(function(result) {
        if (cb)cb(null, result.data);
        loadingScreen.turnOn(false);
      })
      .catch(function(error) {
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    loadOrgReport: function(cb) {
      var id = OrganizationService.getID();
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAReports/organizationsummary?access_token=' + TokenService.get(), {organizationid:id})
      .then(function(result) {
        me._OrgReport = result.data;
        if (cb)cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    getOrgReport: function() {
      return (me._OrgReport || new OrganizationReport() );
    },

    getMessageReportList: function() {
      return (me._MessageReport || null );
    },

    loadMessageReportList: function(type, page, cb) {
      var id = OrganizationService.getID();
      loadingScreen.turnOn(true);
      var limit = me._PageLimit;
      var skip = Math.max( (page - 1) * limit, 0);
      var timezone = 'America/Chicago';
      try {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch (e) {
        // this function might not be supported everywhere
      }

      $http.get(
          apiUrl + '/yamessages',
        {
          params: {
            type: type,
            organizationid: id,
            skip: skip,
            limit: limit,
            access_token: TokenService.get(),
            timezone: timezone
          }
        }
        )
      .then(function(result) {
        me._MessageReport = result.data;
        if (cb)cb(null);
        loadingScreen.turnOn(false)
      })
      .catch(function(error) {
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    purchaseReport: function(reportid, cb) {
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/yamessages/' + reportid + '/purchase?access_token=' + TokenService.get(), {}) .then(function() {
        if (cb)cb(null);
        loadingScreen.turnOn(false)
      }) .catch(function(error) {
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    getMessageReportDetails: function() {
      return (me._ReportDetails || null );
    },

    getReportDetails: function(reportid, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/yamessages/' + reportid + '/report?access_token=' + TokenService.get(), {}
        ).then(function(result) {
          me._ReportDetails = result.data;
          if (cb)cb(null);
          loadingScreen.turnOn(false)
        }) .catch(function(error) {
          if (cb)cb(error.message);
          loadingScreen.turnOn(false);
        });
    },

    reportMaxPage: function(type, cb) {
      var id = OrganizationService.getID();
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/yamessages/count?organizationid=' + id + '&type=' + type + '&access_token=' + TokenService.get(), {} ).then(function(result) {
        var max = Math.ceil(result.data / me._PageLimit);
        cb( max );
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    getDownloadLink: function(reportid, type, cb) {

      var timezone = 'America/Chicago';
      try {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch (e) {
        // this function might not be supported everywhere
      }

      var params = {
        access_token: TokenService.get(),
        timezone: timezone
      };

      cb(null, apiUrl + '/yamessages/' + reportid + '/report/' + type + '?' + $httpParamSerializer(params));
    }

  }
});

angular
.module('youApp')
.factory('OrgCatService', function($log, $http, apiUrl, OrganizationService, TokenService, loadingScreen) {

  function Category(name, isCat) {
    this.name = name;
    this.disable = ''; // active
    this.type = '';
    this.private = isCat; // private
    this.isemailgroup = false;
    this.edit = false;
    this.issalesgroup = false;
    this.salespersongroupid = null;
    this.membercount = 0;
  }

  var me = this;
  me._Categories = [];
  me._Max = OrganizationService.get().maxcategories;
  me._PageLimit = 10;

  return {
    load: function(cb) {
      loadingScreen.turnOn(true);
      var id = OrganizationService.getID();
      $http.get(apiUrl + '/YAOrganizations/listcategories?organizationid=' + id + '&access_token=' + TokenService.get(), {})
      .then(function(result) {
        $log.debug(result);
        me._Categories = [];
        if ( result.data.length === 0 ) {
          if (cb)cb(null);
          loadingScreen.turnOn(false);
          return;
        }
        result.data.forEach(function(cat) {
          var c = {};
          c.name = cat.name;
          c.public = (cat.private) ? 'Private' : 'Public';
          c.disable = !cat.active;
          c.isCat = !cat.isgroup;
          c.id = cat.id;
          c.isemailgroup = cat.isemailgroup;
          c.issalesgroup = cat.issalesgroup;
          c.membercount = cat.membercount;
          c.salespersongroupid = cat.salespersongroupid;
          me._Categories.push(c);
        });
        if (cb)cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    register: function(cb) {
      loadingScreen.turnOn(true);
      var id = OrganizationService.getID();
      var catList = [];
      me._Categories.forEach( function(cat) {
        var c = {};
        c.name = cat.name;
        c.description = '';
        c.private = cat.public === 'Private';
        c.active = !cat.disable;
        c.isgroup = !cat.isCat;
        c.organizationid = id;
        catList.push(c);
      });
      $http.post(apiUrl + '/YAOrganizations/' + id + '/Categories?access_token=' + TokenService.get(), catList)
      .then(function(result) {
        $log.debug(result);
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    update: function(cat, cb) {
      loadingScreen.turnOn(true);
      var id = OrganizationService.getID();
      cat.organizationid = id;
      var c = {};
      c.name = cat.name;
      c.private = cat.private;
      c.active = !cat.disable;
      c.isgroup = cat.private;
      c.isemailgroup = cat.isemailgroup;
      c.id = cat.id;
      c.organizationid = id;
      if ( cat.id > 0 ) {
        $http.put(apiUrl + '/YACategories?access_token=' + TokenService.get(), c ).then(function(result) {
          $log.debug(result);
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
      } else {
        $http.post(apiUrl + '/YACategories?access_token=' + TokenService.get(), c ).then(function(result) {
          $log.debug(result);
          cat.id = result.data.id;
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
      }
    },
    get: function(isCat) {
      var list = [];
      for ( var i = 0; i < me._Categories.length; i++ ) {
        if ( isCat === me._Categories[i].isCat ) {
          list.push( me._Categories[i]);
        }
      }
      return list;
    },
    add: function(isGroup, max, cb) {
      if ( max > me._Categories.length ) {
        var cat = {};
        if (isGroup === true) {
          cat = new Category('New Recipient Group', isGroup);
        } else {
          cat = new Category('New Category', isGroup);
        }
        me._Categories.push( cat );
          //save the category right away
        this.update(cat, function() {
          cb(true);
        });
      } else {
        cb(false);
      }
    },

    addEmailGroup: function(cb) {
      var cat = new Category();
      cat.isemailgroup = true;
      cat.name = 'New Email Group';
      cat.isCat = true;
      cat.private = true;
      this.update(cat, function() {
        cb(true);
      });
    },

    getMaxCategories: function(orgID, cb) {
      cb(100);
        // loadingScreen.turnOn(true);
        // $http.get(apiUrl + '/YAOrganizations/' + orgID + '?access_token=' + TokenService.get() , {})
        //   .then(function (result) {
        //     $log.debug(result);
        //     cb(result.data.maxcategories);
        //     loadingScreen.turnOn(false);
        //   }) .catch(function (error) {
        //   $log.debug(error.message);
        //   cb(error.message);
        //   loadingScreen.turnOn(false);
        // });
    },

    catMaxPage: function(orgID, isGrp, isEmailGroup, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAOrganizations/listcategoriescount?organizationid=' + orgID + '&isPrivate=' + isGrp + '&isEmailGroup=' + isEmailGroup + '&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        var max = Math.ceil(result.data / me._PageLimit);
        cb( max );
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
      loadingScreen.turnOn(false)
    },

    catLoadByPage: function(orgID, page, isGrp, isEmailGroup, cb) {
      loadingScreen.turnOn(true);
      var limit = me._PageLimit;
      var skip = Math.max( (page - 1) * limit, 0);
      $http.get(apiUrl + '/YAOrganizations/listcategories?organizationid=' + orgID + '&limit=' + limit + '&skip=' + skip + '&isPrivate=' + isGrp + '&isEmailGroup=' + isEmailGroup + '&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        $log.debug(result);
        cb(result.data);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    catLoadAll: function(orgID, isGrp, isEmailGroup, cb) {
      loadingScreen.turnOn(true);
      $http({
        method: 'GET',
        url: apiUrl + '/YAOrganizations/listcategories',
        params: {
          organizationid: orgID,
          isPrivate: isGrp,
          isEmailGroup: isEmailGroup,
          access_token: TokenService.get(),
        }
      })
      .then(function(result) {
        $log.debug(result);
        cb(result.data);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    getGroupName: function(groupID, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YACategories/' + groupID + '?access_token=' + TokenService.get(), {})
      .then(function(result) {
        $log.debug(result);
        cb(result.data.name);
        loadingScreen.turnOn(false);
      }) .catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    remove: function(cat, cb) {
      if ( cat.id > 0 ) {
        loadingScreen.turnOn(true);
        $http.delete(apiUrl + '/YACategories/' + cat.id + '?access_token=' + TokenService.get(), {} ).then(function(result) {
          $log.debug(result);
          for ( var i = 0; i < me._Categories.length; i++ ) {
            if ( cat === me._Categories[i] ) {
              me._Categories.splice(i, 1);
              break;
            }
          }
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
      } else {
        for ( var i = 0; i < me._Categories.length; i++ ) {
          if ( cat === me._Categories[i] ) {
            me._Categories.splice(i, 1);
            break;
          }
        }
        loadingScreen.turnOn(false);
        cb(null);
      }
    },
    getMax: function() {
      return me._Max;
    },
    getExtraCount: function() {
      return me._Max - 8;
    },
    buy: function(callback) {
      me._Max += 3;
      callback(me._Max);
    }
  }
});

angular
.module('youApp')
.factory('OrgBillingService', function($log, $http, apiUrl, OrganizationService, TokenService, loadingScreen) {

  function OrganizationBilling() {
    this.method = ''; // ['Bank Account', 'Credit Card', 'PayPal']
    this.email = '';
    this.billtofirstname = '';
    this.billtolastname = '';
    this.address = '';
    this.city = '';
    this.zip = '';
    this.paymenttype = '';// creditCard, bankAccount

    this.bankName = '';
    this.routingNumber = '';
    this.accountNumber = '';
    this.accountType = ''; //checking, savings, businessChecking

    this.cardNumber = '';
    this.cardCode = '';
    this.expDate = ''; //2020-12

    this.paypalAccount = '';

    this.loaded = false;
  }

  var me = this;
  me._Billing = new OrganizationBilling();
    //me._BillingTypes = ['Bank Account', 'Credit Card', 'PayPal'];
    //me._BankAccountTypes = ['CHECKING', "SAVINGS", "BUSINESS"];

  return {

    get: function() {
      return me._Billing;
    },
    delete: function(cb) {
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      $http.post(apiUrl +
      '/YAOrganizations/deletepaymentprofile?access_token=' + TokenService.get() + '&organizationid=' + orgID,
        {} ).then(function(result) {
          $log.debug(result);
          me._Billing = new OrganizationBilling();
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
    },
    clear: function() {
      me._Billing = new OrganizationBilling();
    },
    load: function(cb) {
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      $http.get(apiUrl +
      '/YAOrganizations/getpaymentprofile?access_token=' + TokenService.get() + '&organizationid=' + orgID,
        {} ).then(function(result) {
          $log.debug(result);
          me._Billing.loaded = false;
          if ( result.data && result.data.data && result.data.data.profile ) {
            me._Billing.email = result.data.data.profile.email;
            if ( result.data.data.profile.paymentProfiles && result.data.data.profile.paymentProfiles.length > 0 ) {
              var data = result.data.data.profile.paymentProfiles[0];
              me._Billing.billtofirstname = data.billTo.firstName;
              me._Billing.billtolastname = data.billTo.lastName;
              me._Billing.address = data.billTo.address;
              me._Billing.city = data.billTo.city;
              me._Billing.zip = data.billTo.zip;
              if (data.payment.bankAccount) {
                me._Billing.method = 'Bank Account';
                me._Billing.accountType = data.payment.bankAccount.accountType.toUpperCase();
                if ( me._Billing.accountType === 'BUSINESSCHECKING') {
                  me._Billing.accountType = 'BUSINESS';
                }
                me._Billing.routingNumber = data.payment.bankAccount.routingNumber;
                me._Billing.accountNumber = data.payment.bankAccount.accountNumber;
                me._Billing.bankName = '';
              } else if (data.payment.creditCard) {
                me._Billing.method = 'Credit Card';
                me._Billing.cardNumber = data.payment.creditCard.cardNumber;
                me._Billing.cardCode = data.payment.creditCard.cardCode;
                me._Billing.expDate = data.payment.creditCard.expDate;
              }
            }
            me._Billing.loaded = true;
          } else {
            me._Billing = new OrganizationBilling();
          }
          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          cb(error.message);
          loadingScreen.turnOn(false);
        });
    },
    register: function(cb) {
      if ( me._Billing.loaded ) {
        cb(null);
        return;
      }
      var orgID = OrganizationService.getID();
      var method = me._Billing.method.replace(' ', '').toLowerCase();
      var options = {};
      options.organizationid = orgID;
      options.email = me._Billing.email;
      options.billtofirstname = me._Billing.billtofirstname;
      options.billtolastname = me._Billing.billtolastname;
      options.address = me._Billing.address;
      options.city = me._Billing.city;
      options.zip = me._Billing.zip;
      switch (method) {
      case 'creditcard':
        options.paymenttype = 'creditCard';
        options.cardnumber = me._Billing.cardNumber;
        options.cardcode = me._Billing.cardCode;
          //var dateObj = new Date( me._Billing.expDate );
          //var month = dateObj.getUTCMonth() + 1;
          //var year = dateObj.getUTCFullYear();
        options.expirationdate = me._Billing.expDate;//year + "-" + ((month < 10 )? "0":"") + month;
        break;
      case 'bankaccount':
        options.paymenttype = 'bankAccount';
        options.bankname = me._Billing.bankName;
        options.routingnumber = me._Billing.routingNumber;
        options.accountnumber = me._Billing.accountNumber;
        var type = me._Billing.accountType.replace(' ', '').toLowerCase();
        switch (type) {
        case 'checking':
          options.accounttype = 'checking';
          break;
        case 'savings':
          options.accounttype = 'savings';
          break;
        case 'business':
          options.accounttype = 'businessChecking';
          break;
        }
        break;
      case 'paypal':
        options.paymenttype = 'payPal';
        break;
      }
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAOrganizations/createpaymentprofile?access_token=' + TokenService.get(), options).then(function(result) {
        if ( result.data && result.data.status === true ) {
          cb(null);
        } else {
          cb(result.data.description);
        }
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    checkIfExists: function(id, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl +
        '/YAOrganizations/getpaymentprofile?access_token=' + TokenService.get() + '&organizationid=' + id, {})
      .then(function(result) {

        if (result && result.data && result.data.data &&
            result.data.data.messages &&
            result.data.data.messages.resultCode != 'Error') {
          cb(true)
        } else {
          cb(false)
        }
        loadingScreen.turnOn(false);
      })
    }
  }
});

angular
.module('youApp')
.factory('MsgService', function($http, $log, $q, apiUrl, $injector, TokenService, OrganizationService, OrgUserService, UserService, loadingScreen, $rootScope) {

  function Message(name, status, type) {
    this.name = name;
    this.layout = '{}';
    this.actions = '{}';
    this.buttonlayout = '[]';
    this.edittextdata = '[]';
    this.generatedlayout = '[]';
    this.dimensions = '{"width":0, "height":0}';
    this.catlist = []; // server list
    this.delay = '0';
    this.previewurl = '';
    this.imageurl = '';
    this.industrytypeid = -1;
    this.availableglobal = false;
    this.isemergency = false;
    this.description = ''

    this.organizationid = -1;
    this.ownerid = -1;
    this.id = undefined;
    this.status = status; // creat,template, sent, ready, rejected, pending, editing
    this.type = type;
    this.message = '';
  }

  var _temp = new Message('Create', 'create', '');
  var _Current = undefined;
  var _Messages = [];

  var me = {
      // create a new template based of the currently loaded template
    register: function(cb) {
      if ( !_Current ) return;
      loadingScreen.turnOn(true);
      var data = _Current;
      var orgID = OrganizationService.getID();
      data.organizationid = orgID;
      $http.put(apiUrl + '/YATemplates?access_token=' + TokenService.get(), data)
      .then(function(result) {
        $log.debug(result);
        _Current.id = result.data.id;
        if (cb)cb(null, result.data);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        if (cb)cb(error.message, null);
        loadingScreen.turnOn(false);
      });
    },
      // delete a template
    delete: function(data, cb) {
      loadingScreen.turnOn(true);
      $http.delete(apiUrl + '/YATemplates/' + data.id + '?access_token=' + TokenService.get(), {})
      .then(function() {
        if (cb)cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    datafix: function(data) {
      for (var attrname in _temp) {
        if ( !data[attrname] ) {
          data[attrname] = _temp[attrname];
        }
      }
    },
      // load a current template based of its id
    loadByID: function(id, cb) {
      loadingScreen.turnOn(true);
      if ( id == -1 ) {
        if (cb)cb(null);
        loadingScreen.turnOn(false);
      }
        // need to check if we own this template
        // can only edit
      $http.get(apiUrl + '/YATemplates?filter={"where":{"id":"' + id + '"}}&access_token=' + TokenService.get(), {})
      .then(function(result) {
        $log.debug(result);
        if ( result.data && result.data.length > 0 ) {
          _Current = result.data[0];
          $rootScope.$emit('templateLoaded', _Current);
        }
        if (cb)cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
      // load a list of templates based of type
      // type: alert, announcement, advertisement
      // globals: include global templates
    load: function(type, cb, globals) {
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();

      $http.get(apiUrl + '/YATemplates?filter={"where":{"organizationid":"' + orgID + '"}}&access_token=' + TokenService.get(), {})
      .then(function(result) {
        $log.debug(result);
        _Messages = result.data;

        for (var i = 0; i < _Messages.length; i++) {
          me.datafix(_Messages[i]);
        }

            // global templates
        if ( globals ) {
          $http.get(apiUrl + '/YATemplates/listglobaltemplates?type=' + type + '&industrytypeid=' + OrganizationService.getIndustry() + '&access_token=' + TokenService.get(), { }).then(function(result) {

            if ( result.data && result.data.length > 0 )
              _Messages = _Messages.concat( result.data );

            if (cb)cb(null);
            loadingScreen.turnOn(false);

          }).catch(function(error) {
            $log.debug(error.message);
            if (cb)cb(error.message);
            loadingScreen.turnOn(false);
          });
        } else {
          if (cb)cb(null);
          loadingScreen.turnOn(false);
        }
      }).catch(function(error) {
        $log.debug(error.message);
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
      // get the current template
    get: function() {
      return _Current;
    },
      // set the current template
    set: function(data) {
      if ( _Current ) {
        for (var attrname in data) { _Current[attrname] = data[attrname]; }
      }
    },
      // create and save a new template
    newTemplate: function(name, status, type, cb) {
      _Current = new Message(name, status, type);
      _Messages.push(_Current);
      _Current.organizationid = OrganizationService.getID();
      me.register(cb);
    },
    clone: function(data, status, type, cb) {
      if ( !data ) {
        _Current = new Message('new', status, type);
        _Messages.push(_Current);
      } else {
          // copy
        _Current = {};
        for (var attrname in data) {
          _Current[attrname] = data[attrname];
        }
          //_Current = jQuery.extend({}, data);
        _Current.id = undefined;
        _Current.status = status;
        _Current.createddate = undefined;
        _Current.senttime = undefined;
        _Current.type = type;
        _Current.ownerid = OrgUserService.dbGetMyID();
        _Messages.push(_Current);
      }

        //if(cb)cb(null,_Current);
      me.register(function(err, template) {
          //if there are any schedules set up for this message we need
          //to copy those as well, or this won't get sent out
        if (err) return cb(err);

        loadingScreen.turnOn(true);
        if (data) {
          $http.get(apiUrl + '/YATemplates/getschedules?templateid=' + data.id + '&access_token=' + TokenService.get(), {})
          .then(function(result) {
                //for each found schedule we need
                // to create a copy and add using the ScheduleService
            if (!result || !result.data || result.data.length < 1) {
              loadingScreen.turnOn(false);
              return cb(null, template);
            }

            var promises = [];
            var ScheduleService = $injector.get('ScheduleService');
                //make the schedule adding promise based so
                //we can manage them asynchronously
            var addSchedule = function(schedule) {
              var d = $q.defer();
              ScheduleService.add(schedule.senddate, schedule.expirationdate, schedule.sendby, function(err) {
                if (err) {
                  $log.log('unable to copy schedules, logging error');
                  $log.log(err);
                }
                return d.resolve(result);
              });
              return d.promise;
            };

            angular.forEach(result.data, function(schedule) {
                  //no real need to do anything in the callback since state is handled by the service
              promises.push(addSchedule(schedule));
            });

            $q.all(promises).then(function() {
              loadingScreen.turnOn(false);
              cb(null, template);
            });

          }).catch(function(err) {
            loadingScreen.turnOn(false);
            cb(err);
          });
        } else {
          loadingScreen.turnOn(false);
          return cb(null, template);
        }
      });
    },
    clear: function() {
      _Current = undefined;
    },
    setCurrent: function(data) {
      _Current = data;
    },
      // type: alert, announcement, ad, appointment
    getAll: function(type) { // get my messages/templates
      var list = [];
      var myID = OrgUserService.dbGetMyID();
      for (var i = 0; i < _Messages.length; i++) {
        if ( _Messages[i].type == type && _Messages[i].ownerid == myID) {
          list.push(_Messages[i]);
        }
      }

        // add create card
        /*if( type != '' ){
         list.splice(0,0,new Message("","create",type));
         }*/

      return list;
    },
      // type: alert, announcement, ad, appointment
      /* dataArray = [{
       status= 'pending',
       callback= function{}
       },{}]*/
    getAllTypes: function(type, dataArray, cb) {
      cb = cb || function(err, result) {
        if (err) {
          return Promise.reject(err);
        } else {
          return Promise.resolve(result);
        }
      }

      var chain = [];
      var orgID = OrganizationService.getID();
      var myID = OrgUserService.dbGetMyID();
      var filter;

      for ( var i = 0; i < dataArray.length; i++ ) {
        var status = dataArray[i].status;
        var isdmpreceive = dataArray[i].isdmpreceive || false;

        if (!status && !isdmpreceive) {
          continue;
        }

        if (isdmpreceive) {
          filter = angular.toJson({
            where: {
              and: [
                {
                  organizationid: orgID
                },
                {
                  type: type
                },
                {
                  isdmpreceive: isdmpreceive
                },
                {
                  status: 'ready'
                }
              ]
            }
          });
        } else if (myID === -1 || myID === 2) {
          filter = angular.toJson({
            where: {
              and: [
                {
                  organizationid: orgID
                },
                {
                  type: type
                },
                {
                  status: status
                },
                {
                  isdmpreceive: isdmpreceive
                }
              ]
            }
          });
        } else {
          filter = angular.toJson({
            where: {
              and: [
                {
                  organizationid: orgID
                },
                {
                  type: type
                },
                {
                  ownerid: myID
                },
                {
                  status: status
                },
                {
                  isdmpreceive: isdmpreceive
                }
              ]
            }
          });
        }

        chain.push( $http.get(apiUrl + '/YATemplates', {
          params: {
            filter: filter,
            access_token: TokenService.get()
          }
        }).then( dataArray[i].callback ) );
      }
      return Promise.all(chain)
      .then(function(results) {
        loadingScreen.turnOn(false);
        return cb(null, results);
      })
      .catch(function(error) {
        loadingScreen.turnOn(false);
        return cb(error.message);
      });
    },

    getDefaultTemplates: function(type, cb) {
      cb = cb || function(results, error) {
        if (error) {
          return Promise.reject(error);
        } else {
          return Promise.resolve(results);
        }
      };

      var orgType = OrganizationService.getIndustry();
      loadingScreen.turnOn(true);
      return $http.get(
        apiUrl + '/YATemplates/listglobaltemplates',
        {
          params: {
            type: type,
            industrytypeid: orgType,
            access_token: TokenService.get()
          }
        }
      )
      .then(function(results) {
        loadingScreen.turnOn(false);
        return cb(results.data);
      })
      .catch(function(error) {
        $log.debug(error.message);
        loadingScreen.turnOn(false);
        return cb(null, error.message);
      });
    },

    getAlertsByStatus: function(status, cb) {
      status = status || 'ready';
      cb = cb || function(results, error) {
        if (error) {
          return Promise.reject(error);
        } else {
          return Promise.resolve(results);
        }
      };

      var orgID = OrganizationService.getID();
      var ownerid = OrgUserService.dbGetMyID();
      var filter = {};

      if (ownerid == -1) {
        filter = {
          where: {
            or: [
              {
                and: [
                  {
                    organizationid: orgID
                  },
                  {
                    type: 'alert'
                  },
                  {
                    status: status
                  }
                ]
              },
              {
                and: [
                  {
                    ispublictoorganization: true
                  },
                  {
                    organizationid: orgID
                  },
                  {
                    status: status
                  },
                  {
                    type: 'alert'
                  }
                ]
              }
            ]
          }
        };
      } else {
        filter = {
          where: {
            or: [
              {
                and: [
                  {
                    organizationid: orgID
                  },
                  {
                    type: 'alert'
                  },
                  {
                    ownerid: ownerid
                  },
                  {
                    status: status
                  }
                ]
              },
              {
                and: [
                  {
                    ispublictoorganization: true
                  },
                  {
                    organizationid: orgID
                  },
                  {
                    status: status
                  },
                  {
                    type: 'alert'
                  }
                ]
              }
            ]
          }
        };
      }
      // Call the 'resetsent' API first, then proceed to the 'GET' request to fetch the templates
      return $http.get(
        apiUrl + '/YATemplates/resetsent',
        {
          params: {
            access_token: TokenService.get()  // Pass the access token
          }
        }
      )
      .then(function() {
        return $http.get(
          apiUrl + '/YATemplates',
          {
            params: {
              filter: angular.toJson(filter),
              access_token: TokenService.get()
            }
          }
        )
        .then(function(results) {
          return cb(results.data.map(function(m) {
            m.dashboardgroups = m.dashboardgroups || [];
            return m;
          }));
        })
        .catch(function(error) {
          return cb(null, error.message);
        });
      });
    },

    getReadyAlerts: function(cb) {
      cb = cb || function(results, error) {
        if (error) {
          return Promise.reject(error);
        } else {
          return Promise.resolve(results);
        }
      };

      var orgID = OrganizationService.getID();
      var ownerid = OrgUserService.dbGetMyID();
      var filter = {};

      if (ownerid == -1) {
        filter = {
          where: {
            or: [
              {
                and: [
                  {
                    organizationid: orgID
                  },
                  {
                    type: 'alert'
                  },
                  {
                    status: 'ready'
                  }
                ]
              },
              {
                and: [
                  {
                    ispublictoorganization: true
                  },
                  {
                    organizationid: orgID
                  },
                  {
                    status: 'ready'
                  },
                  {
                    type: 'alert'
                  }
                ]
              }
            ]
          }
        };
      } else {
        filter = {
          where: {
            or: [
              {
                and: [
                  {
                    organizationid: orgID
                  },
                  {
                    type: 'alert'
                  },
                  {
                    ownerid: ownerid
                  },
                  {
                    status: 'ready'
                  }
                ]
              },
              {
                and: [
                  {
                    ispublictoorganization: true
                  },
                  {
                    organizationid: orgID
                  },
                  {
                    status: 'ready'
                  },
                  {
                    type: 'alert'
                  }
                ]
              }
            ]
          }
        };
      }

      return $http.get(
        apiUrl + '/YATemplates',
        {
          params: {
            filter: angular.toJson(filter),
            access_token: TokenService.get()
          }
        }
      )
      .then(function(results) {
        return cb(results.data.map(function(m) {
          m.dashboardgroups = m.dashboardgroups || [];
          return m;
        }));
      })
      .catch(function(error) {
        return cb(null, error.message);
      });

    },
      /*getAllType: function(type,status,cb)
       {
       loadingScreen.turnOn(true);
       var orgID = OrganizationService.getID();
       var myID = OrgUserService.dbGetMyID();
       var filter = '{"where":{"and":[{"organizationid":"'+orgID+'"},{"type":"'+type+'"},{"ownerid":"'+myID+'"},{"status":"'+status+'"}] }}';
       $http.get(apiUrl + '/YATemplates?filter='+filter+'&access_token='+TokenService.get(),{})
       .then(function(result){
       $log.debug(result);
       if(cb)cb(null, result.data);
       loadingScreen.turnOn(false);

       }).catch(function(error){
       $log.debug(error.message);
       if(cb)cb(error.message);
       loadingScreen.turnOn(false);
       });

       },*/
      // type: alert, announcement, ad, appointment
    getAllTemplates: function(type, cb) {
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      var data = [];
      var filter = '{"where":{"and":[{"organizationid":"' + orgID + '"},{"type":"' + type + '"},{"status":"template"}] }}';
      $http.get(apiUrl + '/YATemplates?filter=' + filter + '&access_token=' + TokenService.get(), {})
      .then(function(result) {
            // global templates
        data = result.data;

        $http.get(apiUrl + '/YATemplates/listglobaltemplates?type=' + type + '&industrytypeid=' + OrganizationService.getIndustry() + '&access_token=' + TokenService.get(), { }).then(function(result) {

          if ( result.data && result.data.length > 0 )
            data = data.concat( result.data );

          $log.debug(result);
          if (cb)cb(null, data);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          $log.debug(error.message);
          if (cb)cb(error.message);
          loadingScreen.turnOn(false);
        });

      }).catch(function(error) {
        $log.debug(error.message);
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });

    },
    getAllParentTemplates: function(type, tempID, cb) {
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      var data = [];
      var filter = '{"where":{"and":[{"organizationid":"' + orgID + '"},{"type":"' + type + '"},{"status":"ready"},{"parenttemplateid":null},{"id":{"neq":"' + tempID + '"}}] }}';
      $http.get(apiUrl + '/YATemplates?filter=' + filter + '&access_token=' + TokenService.get(), {})
      .then(function(result) {
            // global templates
        data = result.data;
        if (cb)cb(null, data);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        // alert(error.message)
        $log.debug(error.message);
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });

    },
      /*
       // type: alert, announcement, ad, appointment
       getTemplates: function(type,globals){ // get everyone templates
       var list = [];
       for(var i = 0; i < _Messages.length; i++){
       if( _Messages[i].type==type && _Messages[i].status == 'template' ){
       if( ( !globals && !_Messages[i].availableglobal) || globals)
       list.push(_Messages[i]);
       }
       }

       return list;
       },*/
    loadApproval: function(cb) {
      loadingScreen.turnOn(true);
      var id = OrgUserService.dbGetMyID();
      var isAdmin = OrgUserService.dbGetMyPermissions('workflowaccess');
      if (!isAdmin) {
        _Messages = [];
        loadingScreen.turnOn(false);
        cb(null);
        return;
      }
      $http.get(apiUrl + '/yamessages/listpendingmessages?workflowadminid=' + id + '&access_token=' + TokenService.get(), {})
      .then(function(result) {
        _Messages = result.data;
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    loadQueued: function(cb) {
      loadingScreen.turnOn(true);
      var id = OrgUserService.dbGetMyID();
      $http.get(apiUrl + '/yamessages/listqueuedmessages?organizationid=' + id + '&access_token=' + TokenService.get(), {})
      .then(function(result) {
        _Messages = result.data;
        _Messages.forEach(function(data) {
          var localtime = new Date( data.sendtime );
          localtime.setSeconds(0);
          data.localSendTime = localtime;
          localtime = new Date( data.expirationdate );
          localtime.setSeconds(0);
          data.localEndTime = localtime;
        });
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    __findTemplate: function(list, templateID) {
      var result = null;
      list.every(function(element) {
        if ( element.sendgroupid == templateID) {
          result = element
          return false;
        }
        return true;
      })
      return result;
    },
    getQueued: function(type) {
      var list = [];
      for (var i = 0; i < _Messages.length; i++) {
        if ( _Messages[i].type == type && _Messages[i].status == 'queued' && _Messages[i].enabled) {
          var template = me.__findTemplate(list, _Messages[i].sendgroupid)
          if ( template )
            template.list.push(_Messages[i]);
          else
              list.push({status:'queued', name:_Messages[i].name, imageurl:_Messages[i].imageurl, sendgroupid:_Messages[i].sendgroupid, list:[_Messages[i]]});
        }
      }
      return list;
    }, /*
       loadQueuedTemplate: function(queued){
       var orgID = OrganizationService.getID();
       loadingScreen.turnOn(true);
       $http.get(apiUrl + '/YATemplates?filter={"where":{"and":[{"organizationid":"'+orgID+'"},{"templateid":"'+queued.templateid+'"}]}}&access_token='+TokenService.get(),{})
       .then(function(result){
       _Current = result.data;

       if(cb)cb(null);
       loadingScreen.turnOn(false);
       }).catch(function(error){
       if(cb)cb(error.message);
       loadingScreen.turnOn(false);
       });
       },    */
      /*getQueuedTemplateInstances: function(template){
       var orgID = OrganizationService.getID();
       loadingScreen.turnOn(true);
       $http.get(apiUrl + '/yamessages/listqueuedmessages?templateid'+template.id+'&organizationid='+orgID+'&access_token='+TokenService.get(),{})
       .then(function(result){
       _Messages = result.data;
       if(cb)cb(null);
       loadingScreen.turnOn(false);
       }).catch(function(error){
       if(cb)cb(error.message);
       loadingScreen.turnOn(false);
       });
       },*/
    getQueuedByID: function(id) {
      var list = [];
      var t = me.getQueued('announcement');
      if ( t && t.length > 0 ) list = list.concat(t);
      t = me.getQueued('advertisement');
      if ( t && t.length > 0 ) list = list.concat(t);

      for ( var i = 0; i < list.length; i++ )
        {
        if ( list[i].sendgroupid == id)
          return list[i];
      }
      return null;
    },
    deleteQueued: function(data, cb) {
      var i = _Messages.indexOf(data);
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/yamessages/cancelmessageinstance?messageinstanceid=' + data.id + '&access_token=' + TokenService.get(), {})
      .then(function() {
        _Messages.splice(i, 1);
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    deleteListQueued: function(list, cb) {
      loadingScreen.turnOn(true);
      var chain = [];
      for ( var i = 0; i < list.length; i++ ) {
        chain.push( $http.get(apiUrl + '/yamessages/cancelmessageinstance?messageinstanceid=' + list[i].id + '&access_token=' + TokenService.get(), {})
          );
      }
      $q.all( chain ).then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    setMaxBudgetInstance: function(data, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/yamessages/setmaxbudget?messageinstanceid=' + data.id + '&newmaxbudget=' + data.maxbudget + '&access_token=' + TokenService.get(), {})
      .then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    getApproval: function(type) { // get my pending
      var list = [];
      for (var i = 0; i < _Messages.length; i++) {
        if ( _Messages[i].type == type && (_Messages[i].status == 'pending' || _Messages[i].status == 'pendingedit')) {
          list.push(_Messages[i]);
        }
      }
      return list;
    },

    save: function(cb) {
      if ( !_Current ) return;
      var data = _Current
      var isPending = (data.status == 'pendingedit' );
      if ( isPending ) {
        data.status = 'pending';
      } else if ( data.status == 'template' ) {
        data.status = 'template';
      } else {
        data.status = 'ready';
      }


      me.register(function(error) {
        if ( error == null ) {
          if ( isPending ) {
            cb('approval');
          } else
              cb('saved');
        }
      });
    },
    send: function(info, cb) {
      if ( !_Current ) return;
      var data = _Current;
      me.canSend( function(yes, message) {
        if ( yes ) {

          var isPending = ( data.status == 'pending' );
          var hasWorkflowAdmin = ( OrgUserService.dbGetMyAdmin() != null );

            // alerts are sent right away, pending edit can send, you don't have an admin
          if ( data.type == 'alert' || isPending || !hasWorkflowAdmin ) {
            data.status = 'sent';
          } else {
              // everything else goes to pending
            data.status = 'pending';
          }


          me.register(function(error) {
            if ( error == null ) {

                // pending edit can send
              if ( isPending ) {
                me.__send( info );
                cb('approval'); // go back to approval page
              }
              else {
                  // alerts are sent right away, also if you have no workflow admin
                if ( data.type == 'alert' || !hasWorkflowAdmin) me.__send( info );
                cb('sent');
              }
            }
          });

        } // end yes
        else {
          cb('', message)
        }

      });// can send
    },
    __send: function( info ) {
      info = info || {};
      loadingScreen.turnOn(true);
      var params = {
        templateid: _Current.id,
        sendingorganizationid: OrganizationService.getID(),
        access_token: TokenService.get(),
        lat: info.lat || info.userlat || undefined,
        lng: info.lng || info.userlng || undefined,
        userlat: info.userlat || info.lat || undefined,
        userlng: info.userlng || info.lng || undefined
      }

      if ( _Current.type != 'alert') {
        params.radius = info.radius || undefined;
      } else {
        if (info && info.isEmergency) {
          params.isemergency = true;
        }
      }

      if ( _Current.description != '' ) {
        params.customtext = _Current.description;
      }

      $http({
        method: 'POST',
        url: apiUrl + '/YATemplates/sendwithschedule',
        params: params,
        data: {}
      })
      .then(function(result) {
        $log.debug(result);
        loadingScreen.turnOn(false);
      })
      .catch(function(error) {
        $log.debug(error.message);
        loadingScreen.turnOn(false);
      });
    },
    canSend: function(cb) {
      if ( !_Current ) return;
      var data = _Current;

      var verify = ( data.name != '' &&
          data.layout != '{}' &&
          data.previewurl != '' &&
          data.imageurl != '' &&
          data.organizationid > 0 &&
          data.ownerid > 0 &&
          data.id > 0 );

        // is it a valid message
      if ( !verify ) {
        var message = 'message not ready';
        if (data.name == '' ) message = 'Needs Name';
        else if ( data.layout == '{}' ) message = 'Needs Layout';
        else if ( data.catlist.length <= 0 && !data.isemergency ) message = 'Needs at least 1 Recipient Group';
        else if ( data.previewurl == '' ) message = 'Needs Update';
        else if ( data.imageurl == '' ) message = 'Needs Update';
        else if ( data.organizationid <= 0 ) message = 'Missing Organization';
        else if ( data.ownerid <= 0 ) message = 'Needs Owner';
        else if ( data.id <= 0 ) message = 'Not Saved';

        cb(false, message);
        return;
      }

        // alerts don't need schedules
      if ( data.type == 'alert') {
        cb(true);
        return;
      }

      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YATemplates/getschedules?templateid=' + data.id + '&access_token=' + TokenService.get(), {})
      .then(function(result) {
        loadingScreen.turnOn(false);
        if (result && result.data && result.data.length) {
          return cb(true);
        } else {
          return cb(false, 'No schedules found for this template. Please contact support. Your template id is ' + data.id);
        }
      }).catch(function() {
        cb(false);
        loadingScreen.turnOn(false);
      });
    },
    updateMessage: function(msg, cb) {
      loadingScreen.turnOn(true);
      $http.put(apiUrl + '/YATemplates?access_token=' + TokenService.get(), {'id':msg.id, 'message':msg.message})
      .then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.result);
        loadingScreen.turnOn(false);
      });
    },
    calculateSend: function(data, cb) {
      loadingScreen.turnOn(true);
      var id = -1;
      if ( _Current && _Current.id ) id = _Current.id;
      var info = '';
      if ( data ) {
        info = '&lat=' + data.lat + '&lng=' + data.lng + '&radius=' + data.radius;
      }
      $http.get(apiUrl + '/YATemplates/calculatesend?templateid=' + id + info + '&access_token=' + TokenService.get(), {})
      .then(function(result) {
        cb(null, result.data);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.result, null);
        loadingScreen.turnOn(false);
      });
    }
  };

  return me;

});

angular
.module('youApp')
.factory('MessageBoxService', function($uibModal, FormValidationService) {

  var data = this;
  if ( data.messageData == undefined ) {
    data.messageData = {};
    data.popup = null;
  }

  var me = {
    close: function() {
      data.messageData = {};
      data.messageData.open = false;
      data.popup.close();
    },
    open: function(title, message, buttonName, cb) {
      if ( data.messageData.open ) return;
      data.messageData = {};
      data.messageData.title = title;
      data.messageData.open = true;
      data.messageData.cb = cb;
      data.messageData.message = message;
      data.messageData.buttonName = buttonName;
      data.messageData.close = me.close;

      data.popup = $uibModal.open({
        templateUrl: 'app/popups/message/message.html',
        controller: 'Message.Controller'
      });

      data.popup.result.then(function() {
      }, function() {
        if ( data.messageData.cb ) data.messageData.cb();
      });
    },
    getData: function() {
      if ( data.messageData == undefined ) {
        data.messageData = {
          message: 'an error',
          buttonName: 'close',
          close: me.close
        };
      }
      return data.messageData;
    },

    invalidEmailMsg: function(email, msg1, msg2) {
      return FormValidationService.GetEmailPattern().test(email)
          ? msg1 //email is valid
          : msg2; //email is not valid
    }
  };

  return me;
});
angular
.module('youApp')
.factory('IndTypeService', function($log, $http, apiUrl, TokenService, loadingScreen) {
  var _Current = {name: '', user: '', defualtPlanID: -1, setupFee: 0, plans: [], options: [], info: [], hidden: [] };
  var _Types = [];
  var _NumberOfUsers = 0;
  var _Cost = {ready:false, cost:0};
  var me = {
    // load the industry types and their data ( billing plan info )
    load: function(promocode, cb) {
      loadingScreen.turnOn(true);
      var couponcode = promocode || '';
      var filter = {
        'include': {
          'relation': 'paymentplans', 'scope': {
            'where': {
              'couponcode': couponcode ? couponcode : null
            },
            'include': {
              'relation': 'paymentoptions'
            }
          }
        }
      };
      $http.get(apiUrl +
        '/YAIndustryTypes?filter=' + angular.toJson(filter) + '&access_token=' + TokenService.get(), {})
      .then(function(result) {
        _Types = [];
        var numberOfPlans = 0;
        result.data.forEach( function(data) {
          var type = {};
          type.name = data.name;
          type.id = data.id;
          type.user = 'people';
          type.setupFee = 0;
          type.plans = [];
          type.options = [];
          type.hidden = [];
          type.info = [];

          numberOfPlans += data.paymentplans.length;

          data.paymentplans.forEach( function( plans ) {
            type.setupFee = parseFloat(plans.setupfee);
            var newPlan = {};
            newPlan.title = plans.name;
            newPlan.setupFee = parseFloat(plans.setupfee);
            newPlan.perUserCost = parseFloat(plans.priceperperson);
            newPlan.maxUser = parseInt(plans.maxpeople);
            newPlan.minPrice = -1;
            newPlan.selected = false;
            newPlan.text = plans.description;
            newPlan.id = plans.id;
            newPlan.options = [];
            newPlan.hidden = [];
            newPlan.info = [];

                // if only one plan we don't want to select it
            if ( data.paymentplans.length > 1) {
              type.defualtPlanID = -1;
              type.plans.push(newPlan);
            } else {
              type.defualtPlanID = newPlan.id;
                  // add plan as info if its the only one
              type.info.push(newPlan);
            }

            plans.paymentoptions.forEach( function( options ) {
              var newOption = {};
              newOption.title = options.name;
              newOption.perUserCost = parseFloat(options.priceperperson);
              newOption.maxUser = -1;
              newOption.minPrice = parseFloat(options.minimum);
              newOption.selected = true;
              newOption.text = options.description;
              newOption.id = options.id;

                  // only display optons with description
              if ( options.description != null ) {
                if (options.optional) {

                  newOption.selected = false;

                  if ( data.paymentplans.length > 1) {
                    newPlan.options.push(newOption);
                  } else {
                    type.options.push(newOption);
                  }

                } else {

                  newOption.selected = true;
                  if ( data.paymentplans.length > 1) {
                    newPlan.info.push(newOption);
                  } else {
                    type.info.push(newOption);
                  }

                }
              } else {

                newOption.selected = true;
                if ( data.paymentplans.length > 1) {
                  newPlan.hidden.push(newOption);
                } else {
                  type.hidden.push(newOption);
                }

              }

            });
          });

          _Types.push(type);
        });

        if (numberOfPlans == 0) {
          loadingScreen.turnOn(false);
          return cb('No Payment Plans found');
        }

        cb(null);
        loadingScreen.turnOn(false);

      }).catch(function(error) {
        $log.debug('error result', error);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    getUserCount: function() {
      return _NumberOfUsers;
    },
    setUserCount: function(count) {
      _NumberOfUsers = count;
    },
      // get a list of the industry type names
    getTypes: function() {
      var names = [];
      for ( var i = 0; i < _Types.length; i++ ) {
        names.push( _Types[i].name);
      }
      return names;
    },
      // clear the current industry type
    clear: function() {
      _NumberOfUsers = 0;
      _Current = {name: '', user: '', setupFee: 0, plans: [], optons: [], info: [] };
    },
      // set current industry type by name
    setCurrent: function(name) {
      for ( var i = 0; i < _Types.length; i++ ) {
        if ( _Types[i].name === name ) {
          _Current = _Types[i];
          break;
        }
      }
    },
      // set current industry type by id
    setCurrentByID: function(id) {
      for ( var i = 0; i < _Types.length; i++ ) {
        if ( _Types[i].id == id ) {
          _Current = _Types[i];
          break;
        }
      }
      if ( !_Current.id || _Current.id != id ) {
        _Current = {name: '', user: '', setupFee: 0, plans: [], options: [], info: [] };
      }
    },
      // get currently selected industry type
    getCurrent: function() {
      return _Current;
    },
      // get current industry type id
    getID: function() {
      if ( _Current.id )
        return _Current.id;
      return -1;
    },
      // load the billing plan currently assigned to the organization
      // also get the estimated cost
    getPlan: function(orgID, cb) {
      if ( orgID == -1 || !orgID ) {
        cb(null);
        return;
      }
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAOrganizations/getbillingplan?organizationid=' + orgID + '&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        if ( result.data ) {
          _Cost.cost = result.data.paymentplan.setupfee;
          _Cost.ready = true;
          _Cost.users = result.data.numberofuserslots;
          _Cost.annual = result.data.annualfee;
          _Cost.alertsenabled = result.data.alertsenabled;
          _Cost.alertcost = result.data.alertcost;
          _Cost.announcementsenabled = result.data.announcementsenabled;
          _Cost.announcementcost = result.data.announcementcost;
          _Cost.appointmentbookenabled = result.data.appointmentbookenabled;
          _Cost.appointmentcost = result.data.appointmentcost;
          _Cost.advertisingenabled = result.data.advertisingenabled;
          _Cost.advertisingcost = result.data.advertisingcost;
          _Cost.enabledoptions = result.data.enabledoptions;
          _Cost.plan = result.data.paymentplan;
        } else {
          _Cost.cost = 0;
          _Cost.ready = false;
          _Cost.users = _Cost.users || 0;
          _Cost.annual = 0;
        }
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
      // delete the current billing plan assigned to the organization
    removePlan: function(orgID, cb) {
      if ( orgID == -1 || !orgID ) {
        cb(null);
        return;
      }
      loadingScreen.turnOn(true);
      $http.delete(apiUrl + '/YAOrganizations/' + orgID + '/billingplan?organizationid=' + orgID + '&access_token=' + TokenService.get(), {} )
      .then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
      // finalize and bill the organization accourding to the current billing plan
    finishPlan: function(orgID, cb) {
      if ( orgID == -1 || !orgID) {
        cb(null);
        return;
      }
      loadingScreen.turnOn(true);
      $http.post(apiUrl + '/YAOrganizations/payannualfee?organizationid=' + orgID + '&access_token=' + TokenService.get(), {} )
      .then(function(response) {
        if (response.data && response.data.status) {
          cb(null);
        } else {
          cb('Unable to process payment');
        }
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
      // assign the current billing plan from the currently loaded industry type to the organization
      // also get the estimated cost
    setPlan: function(orgID, cb) {
      loadingScreen.turnOn(true);

      var planID = _Current.defualtPlanID;
      var options = [];
      var plan = {};
      if ( planID == -1 ) {
        //search for selected plan
        for (var i = 0; i < _Current.plans.length; i++) {
          if ( _Current.plans[i].selected ) {
            plan = _Current.plans[i];
            planID = _Current.plans[i].id;
            break;
          }
        }

        if ( planID == -1 || orgID <= 0 ) {
          loadingScreen.turnOn(false);
          _Cost.cost = 0;
          _Cost.ready = false;
          _Cost.users = 0;
          _Cost.annual = 0;
          cb('Invalid Data');
          return;
        }

        plan.hidden.forEach(function(o) {
          if (o.id && o.selected) options.push(o.id);
        });
        plan.info.forEach(function(o) {
          if (o.id && o.selected) options.push(o.id);
        });
        plan.options.forEach(function(o) {
          if (o.id && o.selected) options.push(o.id);
        });

      } else {

        _Current.hidden.forEach(function(o) {
          if (o.id && o.selected) options.push(o.id);
        });
        _Current.info.forEach(function(o) {
          if (o.id && o.selected) options.push(o.id);
        });
        _Current.options.forEach(function(o) {
          if (o.id && o.selected) options.push(o.id);
        });

      }

      if ( planID == -1 || orgID <= 0 ) {
        loadingScreen.turnOn(false);
        _Cost.cost = 0;
        _Cost.ready = false;
        _Cost.users = 0;
        _Cost.annual = 0;
        cb('Invalid Data');
        return;
      }
      var data = {
        enabledoptions: options,
        numberofusers: _NumberOfUsers,
        organizationid: orgID,
        paymentplanid: planID
      }
      $http.post(apiUrl + '/YAOrganizations/selectbillingplan?access_token=' + TokenService.get(), data )
      .then(function(result) {
        if ( result.data ) {
          _Cost.cost = result.data.data.setup;
          _Cost.annual = result.data.data.total;
          var plan = result.data.data.plan;
          _Cost.alertsenabled = result.data.data.plan.alertsenabled;
          _Cost.alertcost = plan.alertcost;
          _Cost.announcementsenabled = plan.announcementsenabled;
          _Cost.announcementcost = plan.announcementcost;
          _Cost.appointmentbookenabled = plan.appointmentbookenabled;
          _Cost.appointmentcost = plan.appointmentcost;
          _Cost.advertisingenabled = plan.advertisingenabled;
          _Cost.advertisingcost = plan.advertisingcost;
          _Cost.ready = true;
          _Cost.plan = plan;
        }
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
      // get the currently loaded cost
    getCosts: function() {
      return _Cost;
    }
  };

  return me;
});
angular
.module('youApp')
.factory('IdenticardService', function(
    $http,
    $log,
    $q,
    apiUrl,
    TokenService
  ) {
  var statusCodes = {
    '1': 'Clear',
    '2': 'Lockout',
    '3': 'Lockdown'
  };

  return {
    GetBuildings: function(organizationId) {
      return $http({
        method: 'GET',
        url: apiUrl + '/YAOrganizations/identicard',
        params: {
          access_token: TokenService.get(),
          organizationid: organizationId
        }
      })
      .then(function(rslt) {
        return rslt.data;
      })
      .catch(function() {
        return false;
      });
    },
    SetBuilding: function(organizationId, buildingid, operation) {
      return $http({
        method: 'POST',
        url: apiUrl + '/YAOrganizations/identicard',
        params: {
          access_token: TokenService.get(),
          organizationid: organizationId
        },
        data: {
          buildingid: buildingid,
          operation: operation
        }
      })
      .then(function(rslt) {
        return rslt.data;
      })
      .catch(function() {
        return false;
      });
    },
    Status: function(statusCode) {
      return statusCodes['' + statusCode] || (statusCode + ' (Unknown)');
    },
    StatusCodes: function() {
      return statusCodes;
    }
  }
});

//contains regex patterns and functions for form validation

angular
.module('youApp')
.factory('FormValidationService', function() {

  return {
    GetEmailPattern: function() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/ ; //x@x.xx
    },

      //recommend use type=number
    GetPhonePattern: function() {
      return /^(?:\(\d{3}\)|\d{3})[- ]?\d{3}[- ]?\d{4}$/;// /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/; //us phone, any delimeter
    },

      //recommend use type=number
    GetZipPattern: function() {
      return /^((\d{5})(\d{4})?)((-|\s)?\d{4})?$/;//us zip, xxxxx or xxxxx-xxxx
    },

    GetRoutingPattern: function() {
      return /^\d{9}$/;
    },

      //recommend use type=number
    GetAccountNoPattern: function() {
      return /^\d{9,12}$/;
    },

      //recommend use type=number
    GetCardNoPattern: function() {
      return /^\d{12,19}$/;
    },

    GetDatePattern: function() {
      //return /^\d{12}$/;
      return /^(\d{2})-(\d{2})-(\d{4})$/; // mm-dd-yyyy
      //return /^(?:(?:31(\/)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec)))\1|(?:(?:29|30)(\/)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/)(?:0?2|(?:Feb))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep))|(?:1[0-2]|(?:Oct|Nov|Dec)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
    },

    GetExDatePattern: function() {
      // mm/yyyy
      return /^((0[1-9])|(1[0-2]))\/(\d{4})$/
    },

    isValidBirthday: function(birthday) {
      //our format is mm-dd-yyyy
      if (birthday.length < 10) {
        return false;
      }
      var uLimit = moment();
      var lLimit = moment().subtract(120, 'years');
      var dt = moment(birthday, 'MM-Do-YYYY');
      if (!dt.isValid() || dt.isAfter(uLimit) || dt.isBefore(lLimit)) {
        return false;
      }
      return true;
    },

    GetPasswordPattern: function() {
      return /^\S+$/;
    },

      //recommend use type=number
    GetCvcPattern: function() {
      return /^[0-9]{3,4}$/;
    },

    UpdatePhoneNumber: function( phonenumber ) {
      if ( !phonenumber ) return phonenumber;
      var str = phonenumber;
      str = str.replace(/\D/g, '');
      if ( str.length > 10 ) str = str.substring( 0, 10 );
      if ( str.length > 6 ) {
        str = str.replace(/(\d{3})(\d{3})(\d{1,4})/, '$1-$2-$3');

      } else if ( str.length > 3 ) {

        str = str.replace(/(\d{3})(\d{1,3})/, '$1-$2');

      } else {

        str = str.replace(/(\d{1,3})/, '$1');

      }

      return str;
    },

    UpdateReferralCode: function(code) {
      if (!code) return code;
      var str = code;
      if ( str.length > 3 ) str = str.substring ( 0, 3 );
      return str;
    },

    UpdateBirthDate: function( date ) {
      if ( !date ) return date;
      var str = date;
      str = str.replace(/\D/g, '');
      if ( str.length > 8 ) str = str.substring( 0, 8 );
      if ( str.length > 4 ) {
        str = str.replace(/(\d{2})(\d{2})(\d{1,4})/, '$1-$2-$3');

      } else if ( str.length > 2 ) {

        str = str.replace(/(\d{2})(\d{1,2})/, '$1-$2');

      } else {

        str = str.replace(/(\d{1,2})/, '$1');

      }

      return str;
    },

      //if true, returns array of US states as abbreviations
    GetStates: function() {
      return [
        'AL',
        'AK',
        'AZ',
        'AR',
        'CA',
        'CO',
        'CT',
        'DE',
        'FL',
        'GA',
        'HI',
        'ID',
        'IL',
        'IN',
        'IA',
        'KS',
        'KY',
        'LA',
        'ME',
        'MD',
        'MA',
        'MI',
        'MN',
        'MS',
        'MO',
        'MT',
        'NE',
        'NV',
        'NH',
        'NJ',
        'NM',
        'NY',
        'NC',
        'ND',
        'OH',
        'OK',
        'OR',
        'PA',
        'RI',
        'SC',
        'SD',
        'TN',
        'TX',
        'UT',
        'VT',
        'VA',
        'WA',
        'WV',
        'WI',
        'WY'
      ];
    }
  }
});

angular
.module('youApp')
.factory('EmailTemplateService', function($http, $log, $q, apiUrl, $injector, TokenService, OrganizationService, OrgUserService, UserService, loadingScreen) {

  function EmailTemplate() {
    this.categoryid = -1;
    this.title = 'Example Title';
    this.body = 'Example Body';
    this.imageurl = null;
    this.type = 'dashboard';
    this.imageposition = 'top';
  }

  return {
    load: function(groupid, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAEmailTemplates?filter={"where":{"categoryid":"' + groupid + '"}}&access_token=' + TokenService.get(), {})
      .then(function(result) {
        $log.debug(result);
        cb(result.data);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    update: function(template, cb) {
      loadingScreen.turnOn(true);
      var id = template.id;
      template.body = template.body.replace(/(?:\r\n|\r|\n)/g, '<br/>');
      $http.put(apiUrl + '/YAEmailTemplates/' + id + '?access_token=' + TokenService.get(), template)
      .then(function(result) {
        $log.debug(result);
        loadingScreen.turnOn(false);
        cb(true);
      }).catch(function(error) {
        $log.debug(error.message);
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    add: function(groupid, cb) {
      loadingScreen.turnOn(true);
      var template = new EmailTemplate();
      template.categoryid = groupid;
      $http.put(apiUrl + '/YAEmailTemplates?access_token=' + TokenService.get(), template)
      .then(function(result) {
        $log.debug(result);
        loadingScreen.turnOn(false);
        cb(template);
      }).catch(function(error) {
        $log.debug(error.message);
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    }
  }

});

angular
.module('youApp')
.factory('DmpService', function(
    $http,
    $log,
    $q,
    apiUrl,
    TokenService
  ) {

  var alerts = [
    {
      code: 'BL',
      label: 'Blank',
      active: true
    },
    {
      code: 'FI',
      label: 'Fire',
      active: true
    },
    {
      code: 'BU',
      label: 'Burglary',
      active: true
    },
    {
      code: 'SV',
      label: 'Supervisory',
      active: true
    },
    {
      code: 'PN',
      label: 'Panic',
      active: true
    },
    {
      code: 'EM',
      label: 'Emergency',
      active: true
    },
    {
      code: 'A1',
      label: 'Auxiliary 1',
      active: true
    },
    {
      code: 'A2',
      label: 'Auxiliary 2',
      active: true
    }
    // {
    //   code: 100,
    //   label: 'Medical',
    //   active: true
    // },
    // {
    //   code: 101,
    //   label: 'Personal Emergency',
    //   active: true
    // },
    // {
    //   code: 102,
    //   label: 'Fail to report in',
    //   active: true
    // },
    // {
    //   code: 110,
    //   label: 'Fire',
    //   active: true
    // },
    // {
    //   code: 111,
    //   label: 'Smoke',
    //   active: true
    // },
    // {
    //   code: 112,
    //   label: 'Combustion',
    //   active: true
    // },
    // {
    //   code: 113,
    //   label: 'Water flow',
    //   active: false
    // },
    // {
    //   code: 114,
    //   label: 'Heat',
    //   active: false
    // },
    // {
    //   code: 115,
    //   label: 'Pull Station',
    //   active: false
    // },
    // {
    //   code: 116,
    //   label: 'Duct',
    //   active: false
    // },
    // {
    //   code: 117,
    //   label: 'Flame',
    //   active: false
    // },
    // {
    //   code: 118,
    //   label: 'Near Alarm',
    //   active: false
    // },
    // {
    //   code: 126,
    //   label: 'Hold-up suspicion print',
    //   active: false
    // },
    // {
    //   code: 120,
    //   label: 'Panic',
    //   active: true
    // },
    // {
    //   code: 121,
    //   label: 'Duress',
    //   active: true
    // },
    // {
    //   code: 122,
    //   label: 'Silent',
    //   active: true
    // },
    // {
    //   code: 123,
    //   label: 'Audible',
    //   active: true
    // },
    // {
    //   code: 124,
    //   label: 'Duress – Access granted',
    //   active: false
    // },
    // {
    //   code: 125,
    //   label: 'Duress – Egress granted',
    //   active: false
    // },
    // {
    //   code: 126,
    //   label: 'Hold-up suspicion print',
    //   active: false
    // },
    // {
    //   code: 130,
    //   label: 'Burglary',
    //   active: true
    // },
    // {
    //   code: 131,
    //   label: 'Perimeter',
    //   active: true
    // },
    // {
    //   code: 132,
    //   label: 'Interior',
    //   active: true
    // },
    // {
    //   code: 133,
    //   label: '24 Hour (Safe)',
    //   active: false
    // },
    // {
    //   code: 134,
    //   label: 'Entry/Exit',
    //   active: false
    // },
    // {
    //   code: 135,
    //   label: 'Day/night',
    //   active: false
    // },
    // {
    //   code: 136,
    //   label: 'Outdoor',
    //   active: false
    // },
    // {
    //   code: 137,
    //   label: 'Tamper',
    //   active: false
    // },
    // {
    //   code: 138,
    //   label: 'Near alarm',
    //   active: false
    // },
    // {
    //   code: 139,
    //   label: 'Intrusion Verifier',
    //   active: false
    // },
    // {
    //   code: 140,
    //   label: 'General Alarm',
    //   active: true
    // },
    // {
    //   code: 141,
    //   label: 'Polling loop open',
    //   active: false
    // },
    // {
    //   code: 142,
    //   label: 'Polling loop short',
    //   active: false
    // },
    // {
    //   code: 143,
    //   label: 'Expansion module failure',
    //   active: false
    // },
    // {
    //   code: 144,
    //   label: 'Sensor tamper',
    //   active: false
    // },
    // {
    //   code: 145,
    //   label: 'Expansion module tamper',
    //   active: false
    // },
    // {
    //   code: 146,
    //   label: 'Silent Burglary',
    //   active: true
    // },
    // {
    //   code: 147,
    //   label: 'Sensor Supervision Failure',
    //   active: false
    // },
    // {
    //   code: 150,
    //   label: '24 Hour Non-Burglary',
    //   active: false
    // },
    // {
    //   code: 151,
    //   label: 'Gas detected',
    //   active: true
    // },
    // {
    //   code: 152,
    //   label: 'Refrigeration',
    //   active: true
    // },
    // {
    //   code: 153,
    //   label: 'Loss of heat',
    //   active: true
    // },
    // {
    //   code: 154,
    //   label: 'Water Leakage',
    //   active: true
    // },
    // {
    //   code: 155,
    //   label: 'Foil Break',
    //   active: false
    // },
    // {
    //   code: 156,
    //   label: 'Day Trouble',
    //   active: false
    // },
    // {
    //   code: 157,
    //   label: 'Low bottled gas level Zone ',
    //   active: false
    // },
    // {
    //   code: 158,
    //   label: 'High temp',
    //   active: true
    // },
    // {
    //   code: 159,
    //   label: 'Low temp',
    //   active: true
    // },
    // {
    //   code: 161,
    //   label: 'Loss of air flow',
    //   active: false
    // },
    // {
    //   code: 162,
    //   label: 'Carbon Monoxide detected',
    //   active: true
    // },
    // {
    //   code: 163,
    //   label: 'Tank level',
    //   active: false
    // },
    // {
    //   code: 200,
    //   label: 'Fire Supervisory',
    //   active: false
    // },
    // {
    //   code: 201,
    //   label: 'Low water pressure',
    //   active: false
    // },
    // {
    //   code: 202,
    //   label: 'Low CO2',
    //   active: false
    // },
    // {
    //   code: 203,
    //   label: 'Gate valve sensor',
    //   active: false
    // },
    // {
    //   code: 204,
    //   label: 'Low water level',
    //   active: false
    // },
    // {
    //   code: 205,
    //   label: 'Pump activated',
    //   active: false
    // },
    // {
    //   code: 206,
    //   label: 'Pump failure',
    //   active: false
    // },
    // {
    //   code: 300,
    //   label: 'System Trouble',
    //   active: false
    // },
    // {
    //   code: 301,
    //   label: 'AC Loss',
    //   active: false
    // },
    // {
    //   code: 302,
    //   label: 'Low system battery',
    //   active: false
    // },
    // {
    //   code: 303,
    //   label: 'RAM Checksum bad',
    //   active: false
    // },
    // {
    //   code: 304,
    //   label: 'ROM checksum bad',
    //   active: false
    // },
    // {
    //   code: 305,
    //   label: 'System reset',
    //   active: false
    // },
    // {
    //   code: 306,
    //   label: 'Panel programming changed',
    //   active: false
    // },
    // {
    //   code: 307,
    //   label: 'Self-test failure',
    //   active: false
    // },
    // {
    //   code: 308,
    //   label: 'System shutdown',
    //   active: false
    // },
    // {
    //   code: 309,
    //   label: 'Battery test failure',
    //   active: false
    // },
    // {
    //   code: 310,
    //   label: 'Ground fault',
    //   active: false
    // },
    // {
    //   code: 311,
    //   label: 'Battery Missing/Dead',
    //   active: false
    // },
    // {
    //   code: 312,
    //   label: 'Power Supply Over current',
    //   active: false
    // },
    // {
    //   code: 313,
    //   label: 'Engineer Reset',
    //   active: false
    // },
    // {
    //   code: 314,
    //   label: 'Primary Power Supply Failure',
    //   active: false
    // },
    // {
    //   code: 320,
    //   label: 'Sounder/Relay',
    //   active: false
    // },
    // {
    //   code: 321,
    //   label: 'Bell 1',
    //   active: false
    // },
    // {
    //   code: 322,
    //   label: 'Bell 2',
    //   active: false
    // },
    // {
    //   code: 323,
    //   label: 'Alarm relay',
    //   active: false
    // },
    // {
    //   code: 324,
    //   label: 'Trouble relay',
    //   active: false
    // },
    // {
    //   code: 325,
    //   label: 'Reversing relay',
    //   active: false
    // },
    // {
    //   code: 326,
    //   label: 'Notification Appliance Ckt. # 3',
    //   active: false
    // },
    // {
    //   code: 327,
    //   label: 'Notification Appliance Ckt. #4',
    //   active: false
    // },
    // {
    //   code: 330,
    //   label: 'System Peripheral trouble',
    //   active: false
    // },
    // {
    //   code: 331,
    //   label: 'Polling loop open',
    //   active: false
    // },
    // {
    //   code: 332,
    //   label: 'Polling loop short',
    //   active: false
    // },
    // {
    //   code: 333,
    //   label: 'Expansion module failure',
    //   active: false
    // },
    // {
    //   code: 334,
    //   label: 'Repeater failure',
    //   active: false
    // },
    // {
    //   code: 335,
    //   label: 'Local printer out of paper',
    //   active: false
    // },
    // {
    //   code: 336,
    //   label: 'Local printer failure',
    //   active: false
    // },
    // {
    //   code: 337,
    //   label: 'Exp. Module DC Loss',
    //   active: false
    // },
    // {
    //   code: 338,
    //   label: 'Exp. Module Low Batt.',
    //   active: false
    // },
    // {
    //   code: 339,
    //   label: 'Exp. Module Reset',
    //   active: false
    // },
    // {
    //   code: 341,
    //   label: 'Exp. Module Tamper',
    //   active: false
    // },
    // {
    //   code: 342,
    //   label: 'Exp. Module AC Loss',
    //   active: false
    // },
    // {
    //   code: 343,
    //   label: 'Exp. Module self-test fail',
    //   active: false
    // },
    // {
    //   code: 344,
    //   label: 'RF Receiver Jam Detect',
    //   active: false
    // },
    // {
    //   code: 350,
    //   label: 'Communication trouble',
    //   active: true
    // },
    // {
    //   code: 351,
    //   label: 'Telco 1 fault',
    //   active: false
    // },
    // {
    //   code: 352,
    //   label: 'Telco 2 fault',
    //   active: false
    // },
    // {
    //   code: 353,
    //   label: 'Long Range Radio xmitter fault',
    //   active: false
    // },
    // {
    //   code: 354,
    //   label: 'Failure to communicate event',
    //   active: false
    // },
    // {
    //   code: 355,
    //   label: 'Loss of Radio supervision',
    //   active: false
    // },
    // {
    //   code: 356,
    //   label: 'Loss of central polling',
    //   active: false
    // },
    // {
    //   code: 357,
    //   label: 'Long Range Radio VSWR problem',
    //   active: false
    // },
    // {
    //   code: 370,
    //   label: 'Protection loop',
    //   active: false
    // },
    // {
    //   code: 371,
    //   label: 'Protection loop open',
    //   active: false
    // },
    // {
    //   code: 372,
    //   label: 'Protection loop short',
    //   active: false
    // },
    // {
    //   code: 373,
    //   label: 'Fire trouble',
    //   active: false
    // },
    // {
    //   code: 374,
    //   label: 'Exit error alarm (zone)',
    //   active: false
    // },
    // {
    //   code: 375,
    //   label: 'Panic zone trouble',
    //   active: false
    // },
    // {
    //   code: 376,
    //   label: 'Hold-up zone trouble',
    //   active: false
    // },
    // {
    //   code: 377,
    //   label: 'Swinger Trouble',
    //   active: true
    // },
    // {
    //   code: 378,
    //   label: 'Cross-zone Trouble',
    //   active: false
    // },
    // {
    //   code: 380,
    //   label: 'Sensor trouble',
    //   active: false
    // },
    // {
    //   code: 381,
    //   label: 'Loss of supervision - RF',
    //   active: false
    // },
    // {
    //   code: 382,
    //   label: 'Loss of supervision - RPM',
    //   active: false
    // },
    // {
    //   code: 383,
    //   label: 'Sensor tamper',
    //   active: false
    // },
    // {
    //   code: 384,
    //   label: 'RF low battery',
    //   active: false
    // },
    // {
    //   code: 385,
    //   label: 'Smoke detector Hi sensitivity',
    //   active: false
    // },
    // {
    //   code: 386,
    //   label: 'Smoke detector Low sensitivity',
    //   active: false
    // },
    // {
    //   code: 387,
    //   label: 'Intrusion detector Hi sensitivity',
    //   active: false
    // },
    // {
    //   code: 388,
    //   label: 'Intrusion detector Low sensitivity',
    //   active: false
    // },
    // {
    //   code: 389,
    //   label: 'Sensor self-test failure',
    //   active: false
    // },
    // {
    //   code: 391,
    //   label: 'Sensor Watch trouble',
    //   active: false
    // },
    // {
    //   code: 392,
    //   label: 'Drift Compensation Error',
    //   active: false
    // },
    // {
    //   code: 393,
    //   label: 'Maintenance Alert',
    //   active: false
    // },
    // {
    //   code: 400,
    //   label: 'Open/Close',
    //   active: false
    // },
    // {
    //   code: 401,
    //   label: 'O/C by user',
    //   active: false
    // },
    // {
    //   code: 402,
    //   label: 'Group O/C',
    //   active: false
    // },
    // {
    //   code: 403,
    //   label: 'Automatic O/C',
    //   active: false
    // },
    // {
    //   code: 404,
    //   label: 'Late to O/C (Note: use 453, 454 instead)',
    //   active: false
    // },
    // {
    //   code: 405,
    //   label: 'Deferred O/C (Obsolete- do not use)',
    //   active: false
    // },
    // {
    //   code: 406,
    //   label: 'Cancel',
    //   active: false
    // },
    // {
    //   code: 407,
    //   label: 'Remote arm/disarm',
    //   active: false
    // },
    // {
    //   code: 408,
    //   label: 'Quick arm',
    //   active: false
    // },
    // {
    //   code: 409,
    //   label: 'Keyswitch O/C',
    //   active: true
    // },
    // {
    //   code: 441,
    //   label: 'Armed STAY',
    //   active: false
    // },
    // {
    //   code: 442,
    //   label: 'Keyswitch Armed STAY',
    //   active: false
    // },
    // {
    //   code: 450,
    //   label: 'Exception O/C',
    //   active: false
    // },
    // {
    //   code: 451,
    //   label: 'Early O/C',
    //   active: false
    // },
    // {
    //   code: 452,
    //   label: 'Late O/C',
    //   active: false
    // },
    // {
    //   code: 453,
    //   label: 'Failed to Open',
    //   active: false
    // },
    // {
    //   code: 454,
    //   label: 'Failed to Close',
    //   active: false
    // },
    // {
    //   code: 455,
    //   label: 'Auto-arm Failed',
    //   active: false
    // },
    // {
    //   code: 456,
    //   label: 'Partial Arm',
    //   active: false
    // },
    // {
    //   code: 457,
    //   label: 'Exit Error (user)',
    //   active: false
    // },
    // {
    //   code: 458,
    //   label: 'User on Premises',
    //   active: false
    // },
    // {
    //   code: 459,
    //   label: 'Recent Close',
    //   active: false
    // },
    // {
    //   code: 461,
    //   label: 'Wrong Code Entry Zone ',
    //   active: true
    // },
    // {
    //   code: 462,
    //   label: 'Legal Code Entry',
    //   active: false
    // },
    // {
    //   code: 463,
    //   label: 'Re-arm after Alarm',
    //   active: false
    // },
    // {
    //   code: 464,
    //   label: 'Auto-arm Time Extended',
    //   active: false
    // },
    // {
    //   code: 465,
    //   label: 'Panic Alarm Reset',
    //   active: false
    // },
    // {
    //   code: 466,
    //   label: 'Service On/Off Premises',
    //   active: false
    // },
    // {
    //   code: 411,
    //   label: 'Callback request made',
    //   active: false
    // },
    // {
    //   code: 412,
    //   label: 'Successful download/access',
    //   active: false
    // },
    // {
    //   code: 413,
    //   label: 'Unsuccessful access',
    //   active: false
    // },
    // {
    //   code: 414,
    //   label: 'System shutdown command received',
    //   active: false
    // },
    // {
    //   code: 415,
    //   label: 'Dialer shutdown command received',
    //   active: false
    // },
    // {
    //   code: 416,
    //   label: 'Successful Upload',
    //   active: false
    // },
    // {
    //   code: 421,
    //   label: 'Access denied',
    //   active: false
    // },
    // {
    //   code: 422,
    //   label: 'Access report by user',
    //   active: false
    // },
    // {
    //   code: 423,
    //   label: 'Forced Access',
    //   active: false
    // },
    // {
    //   code: 424,
    //   label: 'Egress Denied',
    //   active: false
    // },
    // {
    //   code: 425,
    //   label: 'Egress Granted',
    //   active: false
    // },
    // {
    //   code: 426,
    //   label: 'Access Door propped open',
    //   active: false
    // },
    // {
    //   code: 427,
    //   label: 'Access point Door Status Monitor trouble',
    //   active: false
    // },
    // {
    //   code: 428,
    //   label: 'Access point Request To Exit trouble',
    //   active: false
    // },
    // {
    //   code: 429,
    //   label: 'Access program mode entry',
    //   active: false
    // },
    // {
    //   code: 430,
    //   label: 'Access program mode exit',
    //   active: false
    // },
    // {
    //   code: 431,
    //   label: 'Access threat level change',
    //   active: false
    // },
    // {
    //   code: 432,
    //   label: 'Access relay/trigger fail',
    //   active: false
    // },
    // {
    //   code: 433,
    //   label: 'Access RTE shunt',
    //   active: false
    // },
    // {
    //   code: 434,
    //   label: 'Access DSM shunt',
    //   active: false
    // },
    // {
    //   code: 435,
    //   label: 'Second Person Access',
    //   active: false
    // },
    // {
    //   code: 436,
    //   label: 'Irregular Access',
    //   active: false
    // },
    // {
    //   code: 501,
    //   label: 'Access reader disable',
    //   active: false
    // },
    // {
    //   code: 520,
    //   label: 'Sounder/Relay Disable',
    //   active: false
    // },
    // {
    //   code: 521,
    //   label: 'Bell 1 disable',
    //   active: false
    // },
    // {
    //   code: 522,
    //   label: 'Bell 2 disable',
    //   active: false
    // },
    // {
    //   code: 523,
    //   label: 'Alarm relay disable',
    //   active: false
    // },
    // {
    //   code: 524,
    //   label: 'Trouble relay disable',
    //   active: false
    // },
    // {
    //   code: 525,
    //   label: 'Reversing relay disable',
    //   active: false
    // },
    // {
    //   code: 526,
    //   label: 'Notification Appliance Ckt. # 3 disable',
    //   active: false
    // },
    // {
    //   code: 527,
    //   label: 'Notification Appliance Ckt. # 4 disable',
    //   active: false
    // },
    // {
    //   code: 531,
    //   label: 'Module Added',
    //   active: false
    // },
    // {
    //   code: 532,
    //   label: 'Module Removed',
    //   active: false
    // },
    // {
    //   code: 551,
    //   label: 'Dialer disabled',
    //   active: false
    // },
    // {
    //   code: 552,
    //   label: 'Radio transmitter disabled',
    //   active: false
    // },
    // {
    //   code: 553,
    //   label: 'Remote Upload/Download disabled',
    //   active: false
    // },
    // {
    //   code: 570,
    //   label: 'Zone/Sensor bypass',
    //   active: false
    // },
    // {
    //   code: 571,
    //   label: 'Fire bypass',
    //   active: false
    // },
    // {
    //   code: 572,
    //   label: '24 Hour zone bypass Zone ',
    //   active: false
    // },
    // {
    //   code: 573,
    //   label: 'Burg. Bypass',
    //   active: false
    // },
    // {
    //   code: 574,
    //   label: 'Group bypass',
    //   active: false
    // },
    // {
    //   code: 575,
    //   label: 'Swinger bypass',
    //   active: false
    // },
    // {
    //   code: 576,
    //   label: 'Access zone shunt',
    //   active: false
    // },
    // {
    //   code: 577,
    //   label: 'Access point bypass',
    //   active: false
    // },
    // {
    //   code: 578,
    //   label: 'Vault Bypass',
    //   active: false
    // },
    // {
    //   code: 579,
    //   label: 'Vent Zone Bypass',
    //   active: false
    // },
    // {
    //   code: 601,
    //   label: 'Manual trigger test report',
    //   active: false
    // },
    // {
    //   code: 602,
    //   label: 'Periodic test report',
    //   active: false
    // },
    // {
    //   code: 603,
    //   label: 'Periodic RF transmission',
    //   active: false
    // },
    // {
    //   code: 604,
    //   label: 'Fire test',
    //   active: false
    // },
    // {
    //   code: 605,
    //   label: 'Status report to follow',
    //   active: false
    // },
    // {
    //   code: 606,
    //   label: 'Listen-in to follow',
    //   active: false
    // },
    // {
    //   code: 607,
    //   label: 'Walk test mode',
    //   active: false
    // },
    // {
    //   code: 608,
    //   label: 'Periodic test - System Trouble Present',
    //   active: false
    // },
    // {
    //   code: 609,
    //   label: 'Video Xmitter active',
    //   active: false
    // },
    // {
    //   code: 611,
    //   label: 'Point tested OK',
    //   active: false
    // },
    // {
    //   code: 612,
    //   label: 'Point not tested',
    //   active: false
    // },
    // {
    //   code: 613,
    //   label: 'Intrusion Zone Walk Tested',
    //   active: false
    // },
    // {
    //   code: 614,
    //   label: 'Fire Zone Walk Tested',
    //   active: false
    // },
    // {
    //   code: 615,
    //   label: 'Panic Zone Walk Tested',
    //   active: false
    // },
    // {
    //   code: 616,
    //   label: 'Service Request',
    //   active: false
    // },
    // {
    //   code: 621,
    //   label: 'Event Log reset',
    //   active: false
    // },
    // {
    //   code: 622,
    //   label: 'Event Log 50% full',
    //   active: false
    // },
    // {
    //   code: 623,
    //   label: 'Event Log 90% full',
    //   active: false
    // },
    // {
    //   code: 624,
    //   label: 'Event Log overflow',
    //   active: false
    // },
    // {
    //   code: 625,
    //   label: 'Time/Date reset',
    //   active: false
    // },
    // {
    //   code: 626,
    //   label: 'Time/Date inaccurate',
    //   active: false
    // },
    // {
    //   code: 627,
    //   label: 'Program mode entry',
    //   active: false
    // },
    // {
    //   code: 628,
    //   label: 'Program mode exit',
    //   active: false
    // },
    // {
    //   code: 629,
    //   label: '32 Hour Event log marker',
    //   active: true
    // },
    // {
    //   code: 630,
    //   label: 'Schedule change',
    //   active: false
    // },
    // {
    //   code: 631,
    //   label: 'Exception schedule change',
    //   active: false
    // },
    // {
    //   code: 632,
    //   label: 'Access schedule change',
    //   active: false
    // },
    // {
    //   code: 641,
    //   label: 'Senior Watch Trouble',
    //   active: false
    // },
    // {
    //   code: 642,
    //   label: 'Latch-key Supervision',
    //   active: false
    // },
    // {
    //   code: 651,
    //   label: 'Reserved for ADEMCO Use',
    //   active: false
    // },
    // {
    //   code: 652,
    //   label: 'Reserved for ADEMCO Use',
    //   active: false
    // },
    // {
    //   code: 653,
    //   label: 'Reserved for ADEMCO Use',
    //   active: false
    // },
    // {
    //   code: 654,
    //   label: 'System Inactivity',
    //   active: false
    // },
    // {
    //   code: 703,
    //   label: 'Auxiliary #3',
    //   active: false
    // },
    // {
    //   code: 704,
    //   label: 'Installer Test',
    //   active: false
    // },
    // {
    //   code: 796,
    //   label: 'Unable to output signal (Derived Channel)',
    //   active: false
    // },
    // {
    //   code: 798,
    //   label: 'STU Controller down (Derived Channel)',
    //   active: false
    // },
    // {
    //   code: 900,
    //   label: 'Download Abort',
    //   active: false
    // },
    // {
    //   code: 901,
    //   label: 'Download Start/End',
    //   active: false
    // },
    // {
    //   code: 902,
    //   label: 'Download Interrupted',
    //   active: false
    // },
    // {
    //   code: 910,
    //   label: 'Auto-close with Bypass',
    //   active: false
    // },
    // {
    //   code: 911,
    //   label: 'Bypass Closing',
    //   active: false
    // },
    // {
    //   code: 912,
    //   label: 'Fire Alarm Silence',
    //   active: false
    // },
    // {
    //   code: 913,
    //   label: 'Supervisory Point test Start/End',
    //   active: false
    // },
    // {
    //   code: 914,
    //   label: 'Hold-up test Start/End',
    //   active: false
    // },
    // {
    //   code: 915,
    //   label: 'Burg. Test Print Start/End',
    //   active: false
    // },
    // {
    //   code: 916,
    //   label: 'Supervisory Test Print Start/End',
    //   active: false
    // },
    // {
    //   code: 917,
    //   label: 'Burg. Diagnostics Start/End',
    //   active: false
    // },
    // {
    //   code: 918,
    //   label: 'Fire Diagnostics Start/End',
    //   active: false
    // },
    // {
    //   code: 919,
    //   label: 'Untyped diagnostics',
    //   active: false
    // },
    // {
    //   code: 920,
    //   label: 'Trouble Closing (closed with burg. during exit)',
    //   active: false
    // },
    // {
    //   code: 921,
    //   label: 'Access Denied Code Unknown',
    //   active: false
    // },
    // {
    //   code: 922,
    //   label: 'Supervisory Point Alarm',
    //   active: false
    // },
    // {
    //   code: 923,
    //   label: 'Supervisory Point Bypass',
    //   active: false
    // },
    // {
    //   code: 924,
    //   label: 'Supervisory Point Trouble',
    //   active: false
    // },
    // {
    //   code: 925,
    //   label: 'Hold-up Point Bypass',
    //   active: false
    // },
    // {
    //   code: 926,
    //   label: 'AC Failure for 4 hours',
    //   active: false
    // },
    // {
    //   code: 927,
    //   label: 'Output Trouble',
    //   active: false
    // },
    // {
    //   code: 928,
    //   label: 'User code for event',
    //   active: false
    // },
    // {
    //   code: 929,
    //   label: 'Log-off User ',
    //   active: false
    // }
  ];

  return {
    GetZoneList: function(organizationId) {
      return $http.get(
          apiUrl + '/YAOrganizations/' + organizationId + '/alert-zones',
        {
          params: {
            access_token: TokenService.get()
          }
        }
        )
      .then(function(results) {
        return results.data;
      });
    },

    GetAllAlerts: function() {
      return Promise.resolve(alerts);
    },

    GetActiveAlerts: function() {
      return Promise.resolve(alerts.filter(function(alert) {
        return alert.active;
      }));
    },

    GetAlertTypes: function() {
      return Promise.resolve([
        {
          code: 'Za',
          label: 'Zone Alarm'
        },
        {
          code: 'Zr',
          label: 'Zone Restore'
        }
      ]);
    }
  };
});

angular
.module('youApp')
.factory('DashboardGroupService', function(
    $log,
    $http,
    apiUrl,
    OrganizationService,
    TokenService
  ) {
  var getFilter = function(where, userorgFilter) {
    where = where || {};
    return {
      where: where,
      include: {
        relation: 'userorganizations',
        scope: {
          include: 'invites',
          where: {
            and: [
              {
                active: true,
                isdashboarduser: true
              },
              {
                or: ['firstname', 'lastname', 'email', 'phonenumber'].map(function(field) {
                  var condition = {};
                  var filterParam = new RegExp('.*' + (userorgFilter || '').toLowerCase() + '.*', 'i');
                  condition[field] = {
                    regexp: filterParam.toString()
                  };
                  return condition;
                })
              }
            ]
          }
        }
      }
    };
  };

  return {
    load: function(userorgFilter, cancelPromise) {
      userorgFilter = userorgFilter || ''; // Fallback to an empty string if userorgFilter is undefined
      const orgId = OrganizationService.getID();
      // const params = new URLSearchParams({
      //   access_token: TokenService.get(),
      //   filter: JSON.stringify(getFilter({ organizationid: orgId }, userorgFilter))
      // });

      const url = apiUrl + '/YADashboardGroups/getDashboardGroupByOrgId?access_token=' + TokenService.get() + '&organizationid=' + orgId + '&search=' + userorgFilter ;
      // Create a cancellation promise
      // let abortController;
      // if (cancelPromise) {
      //   abortController = new window.AbortController();
      //   cancelPromise.then(function() {
      //     abortController.abort(); // Cancel the request
      //   });
      // }
      const abortController = cancelPromise ? new window.AbortController() : null;
      if (cancelPromise && abortController) {
        cancelPromise.then(function() {
          abortController.abort();
        });
      }
      return fetch(url, {
        method: 'GET',
        signal: abortController ? abortController.signal : null
      })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(function(data) {
        // Check if data is an array and has more than one item
        // if (userorgFilter !== '' && Array.isArray(data) && data.length > 1) {
        //   return [data[0]]; // Return only the first item in an array
        // }
        return data.data; // Return the original data if length is 1 or less
      })
      .catch(function(err) {
        if (err.name === 'AbortError') {
        //   // The request was canceled, customize the error message here
        //   return $q.reject({ message: 'Request was canceled by the user', error: err });
        }
        return [];
      });
    },
    update: function(dashboardGroup) {
      return $http({
        method: 'PUT',
        url: apiUrl + '/YADashboardGroups/' + dashboardGroup.id,
        data: dashboardGroup,
        params: {
          access_token: TokenService.get()
        }
      })
      .then(function(result) {
        return result.data;
      });
    },
    insert: function(dashboardGroup) {
      dashboardGroup = dashboardGroup || {};
      dashboardGroup.name = dashboardGroup.name || 'New Dashboard Group ' + new Date().toISOString().substr(0, 10);
      dashboardGroup.organizationid = OrganizationService.getID();

      return $http({
        method: 'POST',
        url: apiUrl + '/YADashboardGroups',
        data: dashboardGroup,
        params: {
          access_token: TokenService.get()
        }
      })
      .then(function(result) {
        return result.data;
      });
    },
    delete: function(dashboardGroupId) {
      return $http({
        method: 'DELETE',
        url: apiUrl + '/YADashboardGroups/deleteDashboardGroupById', // Update the URL to match the remote method
        params: {
          dashboardgropid: dashboardGroupId, // Pass the dashboard group ID as a parameter
          access_token: TokenService.get()    // Include access token if needed for authentication
        }
      })
      .then(function(result) {
        return result.data; // Return the API response
      })
      .catch(function(error) {
        throw error; // Propagate the error for further handling
      });
    },
    getById: function(id, userorgFilter) {
      var orgId = OrganizationService.getID();

      return $http({
        method: 'GET',
        url: apiUrl + '/YADashboardGroups',
        params: {
          access_token: TokenService.get(),
          filter: angular.toJson(getFilter({
            id: id,
            organizationid: orgId
          }, userorgFilter))
        },
      })
      .then(function(result) {
        return (result.data || [])[0];
      })
      .catch(function(err) {
        $log.log(err);
        return null;
      });
    },
    getDashboardGroupUserOrganizations: function(dashboardGroupId) {
      return this.getById(dashboardGroupId)
      .then(function(dashboardGroup) {
        if (!dashboardGroup) {
          return null;
        }
        return $http({
          method: 'GET',
          url: apiUrl + '/YADashboardGroupUserOrganizations',
          params: {
            access_token: TokenService.get(),
            filter: angular.toJson({
              where: {
                yadashboardgroupid: dashboardGroup.id,
              },
            })
          },
        })
      })
      .then(function(result) {
        return (result.data || []);
      })
      .catch(function(err) {
        $log.log(err);
        return [];
      });
    },
    deleteById: function(id) {
      return $http({
        method: 'DELETE',
        url: apiUrl + '/YADashboardGroupUserOrganizations/' + id,
        params: {
          access_token: TokenService.get(),
        },
      })
    },
  }
});

angular
.module('youApp')
.factory('ClasslinkService', function($http, $log, $httpParamSerializer, UserService) {

  var _clientId = 'c150583594723380f631814986bd9aa14b943168dff9ab';
  var _oauthAccessUrl = 'https://launchpad.classlink.com/oauth2/v2/auth';

  var me = {

    getAccessUrl: function(scope, redirectUrl) {
      return _oauthAccessUrl + '?' +
                    $httpParamSerializer({
                      scope: scope,
                      redirect_uri: redirectUrl,
                      client_id: _clientId,
                      response_type: 'code'
                    });
    },

    getProfileAccessUrl: function(redirectUrl) {
      return me.getAccessUrl('profile', redirectUrl);
    },

    exchangeCodeForAccessToken: function(code, cb) {
      cb(UserService.exchangeClasslinkCodeForClasslinkToken(code, cb));
    }
  };

  return me;
});

angular
.module('youApp')
.factory('BusCatService', function($http, $log, apiUrl, OrganizationService, TokenService, loadingScreen) {
  var _Current = {name:'', id:-1};
  var _Cats = [];
  var me = {
    // get a list of all the primary categories assigned to an Industry Type
    //sort these alphabetically
    getCategories: function(industryTypeID) {
      var list = [];
      for ( var i = 0; i < _Cats.length; i++ ) {
        if ( _Cats[i].industrytypeid === industryTypeID ) {
          list.push(_Cats[i]);
        }
      }
      return _.sortBy(list, 'name');
    },
      // set the currently selected primary category
    setCurrent: function(name) {
      for ( var i = 0; i < _Cats.length; i++ ) {
        if ( _Cats[i].name === name ) {
          _Current = _Cats[i];
          break;
        }
      }
    },
    clear: function() {
      _Current = {name:'', id:-1};
    },
    getCurrent: function() {
      return _Current;
    },
      // load all the primary categories
    load: function(cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl +
      '/YAPrimaryCategories?access_token=' + TokenService.get(), {})
      .then(function(result) {
        $log.debug('result', result);
        _Cats = result.data;
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug('error result', error);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
      // set the current 'primary category' to the current organization
    setOrganization: function(cb) {
      var orgID = OrganizationService.getID();
      if ( !orgID ) {
        cb(null);
        return;
      }
      loadingScreen.turnOn(true);
      $http.post(apiUrl +
      '/YAOrganizations/addprimarycategory?access_token=' + TokenService.get(), {'organizationid': orgID, 'primarycategoryid':_Current.id})
      .then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
      // remove the currently assigned 'primary category' from an organization
    removeOrgBusCat: function(cb) {
      var orgID = OrganizationService.getID();
      if ( !orgID || _Current.id == -1) {
        cb(null);
        return;
      }
      loadingScreen.turnOn(true);
      $http.post(apiUrl +
      '/YAOrganizations/removeprimarycategory?access_token=' + TokenService.get(), {'organizationid': orgID, 'primarycategoryid':_Current.id})
      .then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
      // get the 'primary category' assigned to an organization
      // also removes extras, at the moment we are supporting only 1
    getOrgBusCat: function(cb) {
      var id = OrganizationService.getID();
      if ( !id ) {
        cb(null);
        return;
      }
      loadingScreen.turnOn(true);
      $http.get(apiUrl +
      '/YAOrganizations/getprimarycategories?organizationid=' + id + '&access_token=' + TokenService.get(), {})
      .then(function(result) {
        $log.debug('result', result);
        if ( result.data && result.data.length > 0 ) {
          _Current = result.data[0];
          for ( var i = 1; i < result.data.length; i++) {
            $http.post(apiUrl + '/YAOrganizations/removeprimarycategory?access_token=' + TokenService.get(), {'organizationid': id, 'primarycategoryid':result.data[i].id})
          }
        } else {
          _Current = {name:''};
        }
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug('error result', error);
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    }
  };

  return me;
});

// (function() {
//   'use strict';

//   angular
//     .module('youApp')
//     .factory('BpLayoutRenderer', Factory);

//   /** @ngInject */
//   function Factory() {
//     function rgbaStrToCss(rgbaStr) {
//       try {
//         var parts = (rgbaStr || '').split(',');
//         if (parts.length === 4) {
//           return 'rgba(' + parts[0] + ',' + parts[1] + ',' + parts[2] + ',' + parts[3] + ')';
//         }
//       } catch (e) {}
//       return 'rgba(255,255,255,1)';
//     }

//     function reorderByZ(fabricCanvas) {
//       try {
//         fabricCanvas._objects.sort(function(a, b) {
//           var za = (typeof a.zorder === 'number') ? a.zorder : 0;
//           var zb = (typeof b.zorder === 'number') ? b.zorder : 0;
//           return zb - za; // lower z on top (Android behavior)
//         });
//         fabricCanvas.renderAll();
//       } catch (e) {}
//     }

//     function addImages(fabricCanvas, layout, baseWidth, baseHeight) {
//       (layout || []).forEach(function(imgDef) {
//         fabric.Image.fromURL(imgDef.url, function(image) {
//           if (!image) return;
//           image.set({
//             left: (imgDef.left || 0) * baseWidth,
//             top: (imgDef.top || 0) * baseHeight,
//             angle: imgDef.angle || 0,
//             selectable: false,
//             evented: false
//           });
//           var width = (imgDef.width || 0) * baseWidth;
//           var height = (imgDef.height || 0) * baseHeight;
//           if (width && height) {
//             var sx = width / image.width;
//             var sy = height / image.height;
//             image.set({ scaleX: sx, scaleY: sy });
//           }
//           image.zorder = (typeof imgDef.zorder === 'number') ? imgDef.zorder : 0;
//           fabricCanvas.add(image);
//           reorderByZ(fabricCanvas);
//         }, { crossOrigin: 'anonymous' });
//       });
//     }

//     function addTexts(fabricCanvas, layout, baseWidth, baseHeight) {
//       (layout || []).forEach(function(txtDef) {
//         var tb = new fabric.Textbox((txtDef.text || '').toString(), {
//           left: (txtDef.left || 0) * baseWidth,
//           top: (txtDef.top || 0) * baseHeight,
//           width: (txtDef.width || 0.5) * baseWidth,
//           fontFamily: txtDef.fontfamily || 'Open Sans',
//           fontSize: txtDef.fontsize || 16,
//           fill: rgbaStrToCss(txtDef.color || '0,0,0,1'),
//           angle: txtDef.angle || 0,
//           textAlign: 'left',
//           lineHeight: 1.0,
//           selectable: false,
//           evented: false
//         });
//         tb.zorder = (typeof txtDef.zorder === 'number') ? txtDef.zorder : 0;
//         fabricCanvas.add(tb);
//         reorderByZ(fabricCanvas);
//       });
//     }

//     function addButtons(fabricCanvas, layout, baseWidth, baseHeight, handle) {
//       (layout || []).forEach(function(btn) {
//         var style = (btn.style || 'rect').toLowerCase();
//         var left = (btn.left || 0) * baseWidth;
//         var top = (btn.top || 0) * baseHeight;
//         var width = (btn.width || 0.15) * baseWidth;
//         var height = (btn.height || 0.06) * baseHeight;
//         var fill = rgbaStrToCss(btn.color || '0,0,0,1');
//         var textColor = rgbaStrToCss(btn.textColor || '255,255,255,1');

//         var shapeOptions = {
//           left: left,
//           top: top,
//           fill: fill,
//           selectable: false,
//           evented: true
//         };

//         var shape;
//         if (style === 'circle') {
//           var radius = Math.min(width, height) / 2;
//           shape = new fabric.Circle(angular.extend({}, shapeOptions, { radius: radius }));
//         } else if (style === 'ellipse') {
//           shape = new fabric.Ellipse(angular.extend({}, shapeOptions, { rx: width/2, ry: height/2 }));
//         } else {
//           var corner = btn.corner || 0;
//           shape = new fabric.Rect(angular.extend({}, shapeOptions, { width: width, height: height, rx: corner, ry: corner }));
//         }

//         shape.zorder = (typeof btn.zorder === 'number') ? btn.zorder : 0;
//         shape.actionType = btn.actionType;
//         shape.action = btn.action;
//         if (handle) {
//           shape.on('mousedown', function() { handle(shape.actionType, shape.action); });
//         }
//         fabricCanvas.add(shape);

//         var label = new fabric.Text((btn.text || '').toString(), {
//           left: left + width / 2,
//           top: top + height / 2,
//           originX: 'center',
//           originY: 'center',
//           fontFamily: btn.fontfamily || 'Open Sans',
//           fontSize: btn.fontsize || 18,
//           lineHeight: 1.0,
//           fill: textColor,
//           selectable: false,
//           evented: false
//         });
//         label.zorder = shape.zorder - 0.0001;
//         fabricCanvas.add(label);
//         reorderByZ(fabricCanvas);
//       });
//     }

//     function render(fabricCanvas, applayout, baseWidth, baseHeight, handleAction) {
//       if (!fabricCanvas || !applayout) return;
//       // background color
//       var bg = rgbaStrToCss(applayout.backgroundColor || '255,255,255,1');
//       fabricCanvas.setBackgroundColor(bg, fabricCanvas.renderAll.bind(fabricCanvas));

//       addImages(fabricCanvas, applayout.imageLayout || [], baseWidth, baseHeight);
//       addTexts(fabricCanvas, applayout.textLayout || [], baseWidth, baseHeight);
//       addButtons(fabricCanvas, applayout.buttonLayout || [], baseWidth, baseHeight, handleAction);
//       fabricCanvas.renderAll();
//     }

//     return {
//       render: render
//     };
//   }
// })();
angular
.module('youApp')
.factory('ApptService', function($http, $log, $q, apiUrl, TokenService, OrganizationService, OrgUserService, loadingScreen) {

  function Book(name, status, type) {
    this.appointmentlength = 60;
    this.assignedto = -1;
    this.groups = [];
    this.notification10day = false;
    this.notification5day = false;
    this.notification1day = false;
    this.notification1hour = false;
    this.active = true;

    this.waitingUserList = [];

    this.rescheduledata = '';
    this.name = name;
    this.layout = '{}';
    this.actions = '{}';
    this.buttonlayout = '{}';
    this.dimensions = '{"width":0, "height":0}';
    this.catlist = []; // server list
    this.delay = '0';
    this.previewurl = '';
    this.imageurl = '';
    this.maxbudget = 10;
    this.organizationid = -1;
    this.ownerid = -1;
    this.id = undefined;
    this.status = status; // creat,template, sent, ready, rejected, pending, editing
    this.type = type;
    this.message = '';
  }

  var me = this;

  me._apptLength = [
    15,
    30,
    45,
    60
  ];

  me._reminderFrequencyList = [
      {name: '10 days', dataName:'notification10day', active:false}, // 10 days, in minutes
      {name: '1 day', dataName:'notification1day', active:false}, // 1 day, in minutes
      {name: '1 hour', dataName:'notification1hour', active:false} // 1 hour, in minutes
  ];
  me._buttonList = [
      {name: 'Accept', active:false},
      {name: 'Cancel', active:false}
  ];

  me._CurrentWeek = null;
  me._CurrentBook = undefined;
  me._BookList = [];
  me._ApptBookUser = null;
  me._GroupList = [];

  return {

    register: function(cb) {
      if ( !me._CurrentBook ) return;
      loadingScreen.turnOn(true);
      var data = me._CurrentBook;
      var orgID = OrganizationService.getID();
      data.organizationid = orgID;
      $http.put(apiUrl + '/YAAppointmentBooks?access_token=' + TokenService.get(), data)
      .then(function(result) {
        if (cb)cb(null, result.data);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        if (cb)cb(error.message, null);
        loadingScreen.turnOn(false);
      });
    },

    delete: function(data, cb) {
      loadingScreen.turnOn(true);
      $http.delete(apiUrl + '/YAAppointmentBooks/' + data.id + '?access_token=' + TokenService.get(), {})
      .then(function() {
        for (var i = 0; i < me._BookList.length; i++) {
          if ( me._BookList[i].id == data.id) {
            me._BookList.splice(i, 1);
            break;
          }
        }
        if (cb)cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    loadByID: function(id, cb) {
      loadingScreen.turnOn(true);
      $http.get(apiUrl + '/YAAppointmentBooks/' + id + '?access_token=' + TokenService.get(), {})
      .then(function(result) {

        if ( result.data ) {
          me._CurrentBook = result.data;

          $http.get(apiUrl + '/YAAppointmentBooks/listwaitinglist?aptbookid=' + me._CurrentBook.id + '&access_token=' + TokenService.get(), {})
          .then(function(result) {
            me._CurrentBook.waitingUserList = result.data;
            if (cb)cb(null);
            loadingScreen.turnOn(false);
          }).catch(function(error) {
            if (cb)cb(error.message);
            loadingScreen.turnOn(false);
          });

        }

      }).catch(function(error) {
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    save: function(cb) {
      this.register(cb);
    },

    load: function(type, cb) {
      loadingScreen.turnOn(true);
      var orgID = OrganizationService.getID();
      $http.get(apiUrl + '/YAAppointmentBooks?filter={"where":{"organizationid":"' + orgID + '"}}&access_token=' + TokenService.get(), {})
      .then(function(result) {
        $log.debug(result);
        result.data.forEach(function(book) {
          if ( book.status != 'book' && book.status != 'template') {
            book.status = 'book';
          }
        });

        me._BookList = result.data;

        if (cb)cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        $log.debug(error.message);
        if (cb)cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    getBook: function() {
      return me._CurrentBook;
    },

    loadExtras: function(cb) {
      loadingScreen.turnOn(true);
      var chain = [];
      me._ApptBookUser = null;
      me._GroupList = [];

        // load groups
      me._CurrentBook.groups.forEach(function(cat) {
        if ( cat > 0 ) {
          chain.push( $http.get(apiUrl + '/YACategories/' + cat + '?access_token=' + TokenService.get(), {} ).then(function(result) {
            me._GroupList.push(result.data);
          })
            );
        }
      });

        // load assigned user
      if ( me._CurrentBook.assignedto > 0 ) {
        chain.push( $http.get(apiUrl + '/YAUserOrganizations/' + me._CurrentBook.assignedto + '?access_token=' + TokenService.get(), {} ).then(function(result) {
          me._ApptBookUser = result.data;
        })
          );
      }

      $q.all( chain ).then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    set: function(data) {
      if ( me._CurrentBook ) {
        for (var attrname in data) { me._CurrentBook[attrname] = data[attrname]; }
      }
    },

    newTemplate: function(name, status, type, cb) {
      me._CurrentBook = new Book(name, status, type);
      me._BookList.push(me._CurrentBook);
      me._CurrentBook.organizationid = OrganizationService.getID();
      this.register(cb);
    },

    clone: function(data, status, type, cb) {
      if ( !data ) {
        me._CurrentBook = new Book('new', status, type);
        me._BookList.push(me._CurrentBook);
      } else {
        // copy
        me._CurrentBook = {};
        for (var attrname in data) {
          me._CurrentBook[attrname] = data[attrname];
        }
        me._CurrentBook.id = undefined;
        me._CurrentBook.status = status;
        me._CurrentBook.type = type;
        me._BookList.push(me._CurrentBook);
      }

      this.register(cb);
    },

    clear: function() {
      me._CurrentBook = undefined;
    },

    setCurrent: function(data) {
      me._CurrentBook = data;
    },

    getAll: function(type) { // get my messages/templates
      var list = [];
      var myID = OrgUserService.dbGetMyID();
      for (var i = 0; i < me._BookList.length; i++) {
        if ( me._BookList[i].type == type && me._BookList[i].ownerid == myID) {
          list.push(me._BookList[i]);
        }
      }

        // add create card
      if ( type != '' ) {
        list.splice(0, 0, new Book('', 'create', type));
      }

      return list;
    },

    getTemplates: function(type) { // get everyone templates
      var list = [];
      for (var i = 0; i < me._BookList.length; i++) {
        if ( me._BookList[i].type == type && me._BookList[i].status == 'template' ) {
          list.push(me._BookList[i]);
        }
      }

        // add create card
      if ( type != '' ) {
        list.splice(0, 0, new Book('', 'create', type));
      }

      return list;
    },

    getReminderFrequencyList: function() {
      return me._reminderFrequencyList;
    },

    getButtonList: function() {
      return me._buttonList;
    },

    setApptBookUser: function(user) {
      if ( user && user.id && user.id > 0 ) {
        me._ApptBookUser = user;
        me._CurrentBook.assignedto = user.id;
      }
    },

    getApptBookUser: function() {
      return me._ApptBookUser;
    },

    getDefaultApptLenths: function() {
      return me._apptLength;
    },

    setGroups: function(list) {
      me._GroupList = list;
      var ids = [];
      for (var i = 0; i < list.length; i++) {
        if ( list[i].id && list[i].id > 0 )
          ids.push(list[i].id);
      }
        // assign ids to book
      me._CurrentBook.groups = ids;
    },

    getGroups: function() {
      return me._GroupList;
    },

    getSunday: function(date) {
      var sunday = new Date(date);
      sunday.setDate(sunday.getDate() - date.getDay());
      sunday.setHours(0, 0, 0, 0);
      return sunday;
    },

    getTag: function(date) {
      return (date.getMonth() + 1).toString() + ' ' + date.getDate() + ' ' + date.getFullYear();
    },

    loadWeek: function(sunday, cb) {
      if ( !me._CurrentBook ) return;
      loadingScreen.turnOn(true);
      var tag = this.getTag(sunday);
        // search for tag
      var id = me._CurrentBook.id;
      var local = this;
      var filter = '{"where":{"startdate":"' + tag + '"}}';
      $http.get(apiUrl + '/YAAppointmentBooks/' + id + '/weeks?filter=' + filter + '&access_token=' + TokenService.get(), {} )
      .then(function(result) {
        if ( result && result.data && result.data.length > 0) {
          me._CurrentWeek = result.data[0];
          me._CurrentWeek.userObjects = [];
          me._CurrentWeek.unavailable = [];
          me._CurrentWeek.reschedule = [];
          cb(null)
          loadingScreen.turnOn(true);
        } else {
              // no week make a new one
              //var week = new Week(this.getTag(sunday));
          var end = new Date(sunday);
              //end.setHours(0,0,0,0);
          end.setDate(sunday.getDate() + 6);
          var endTag = local.getTag(end);
          var data = {
            aptbookid: id,
            startdate: tag,
            enddate: endTag,
            rescheduleflags: [true, true, true, true, true, true, true]
          }
          $http.post(apiUrl + '/YAAppointmentBooks/createappointmentweek?access_token=' + TokenService.get(), data )
          .then(function(result) {
            me._CurrentWeek = result.data;
            cb(null);
            loadingScreen.turnOn(true);
          }).catch(function(error) {
            cb(error.message);
            loadingScreen.turnOn(true);
          });

        }
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(true);
      });
    },

    loadWeekExtras: function(cb) {

      loadingScreen.turnOn(true);
      this.userObjects = [];
      this.unavailable = [];
      this.reschedule = [];

      var id = me._CurrentWeek.id;
      var chain = [];
      var userList = {};

      chain.push($http.get(apiUrl + '/YAAppointmentBookWeeks/listappointments?weekid=' + id + '&access_token=' + TokenService.get(), {} ).then(function(result) {
        $log.debug(result.data.length);
          // local time
        me._CurrentWeek.userObjects = [];
        for (var i = 0; i < result.data.length; i++ ) {

          result.data[i].startdate = new Date(result.data[i].starttime);
          result.data[i].enddate = new Date(result.data[i].endtime);

          result.data[i].orgusers.forEach(function(user) {
            if ( userList['id' + user] == undefined )
              userList['id' + user] = user;
          });

        }
        me._CurrentWeek.userObjects = result.data;
      }));

      chain.push($http.get(apiUrl + '/YAAppointmentBookWeeks/listunavailabletimes?weekid=' + id + '&access_token=' + TokenService.get(), {} ).then(function(result) {
        $log.debug(result.data.length);
          // local time
        for (var i = 0; i < result.data.length; i++ ) {
          result.data[i].startdate = new Date(result.data[i].starttime);
          result.data[i].enddate = new Date(result.data[i].endtime);
        }
        me._CurrentWeek.unavailable = result.data;
      }));

      chain.push($http.get(apiUrl + '/YAAppointmentBookWeeks/listrescheduletimes?weekid=' + id + '&access_token=' + TokenService.get(), {} ).then(function(result) {
        $log.debug(result.data.length);
          // local time
        for (var i = 0; i < result.data.length; i++ ) {
          result.data[i].startdate = new Date(result.data[i].starttime);
          result.data[i].enddate = new Date(result.data[i].endtime);
        }
        me._CurrentWeek.reschedule = result.data;
      }));

      $q.all( chain ).then(function() {

          // get users
        chain = [];
        for (var attrname in userList) {
          var id = userList[attrname];
          if ( id > 0 ) {
            chain.push($http.get(apiUrl + '/YAUserOrganizations/' + id + '?access_token=' + TokenService.get(), {} ).then(function(result) {
              userList['id' + result.data.id] = result.data;
            }));
          }
        }


        $q.all( chain ).then(function() {
          me._CurrentWeek.userObjects.forEach(function(obj) {
            var userObjList = [];
            for ( var i = 0; i < obj.orgusers.length; i++ ) {
              userObjList.push( userList[ 'id' + obj.orgusers[i] ] );
            }
            if ( userObjList.length == 0 ) {
                // remove
            }
            else if ( userObjList.length == 1 ) {
              obj.userobject = { name: userObjList[0].name, group: userObjList};
            } else {
              obj.userobject = { name: userObjList.length + ' attendee(s)', group: userObjList};
            }

          });

          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          cb(error.message);
          loadingScreen.turnOn(false);
        });

      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });

    },

    addAppointment: function(data, cb) {
      loadingScreen.turnOn(true);
      var userids = [];
      data.object.userobject.group.forEach(function(user) {
        userids.push(user.id);
      });
      var d = {
        weekid: me._CurrentWeek.id,
        orgusers: userids,
        startime: data.startdate,
        endtime: data.enddate,
        scheduler10day: false,
        scheduler5day: false,
        scheduler1day: false,
        scheduler1hour: false
      }
      $http.post(apiUrl + '/YAAppointmentBookWeeks/addappointment?access_token=' + TokenService.get(), d )
      .then(function(result) {
        data.object.id = result.data.id;
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });

    },
    deleteAppointment: function(id, cb) {
      loadingScreen.turnOn(true);
      var d = {
        weekid: me._CurrentWeek.id,
        appointmentid: id
      };
      $http.post(apiUrl + '/YAAppointmentBookWeeks/removeappointment?access_token=' + TokenService.get(), d )
      .then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    addToWaitingList: function(idList, cb) {
      loadingScreen.turnOn(true);
      var chain = [];
      for ( var i = 0; i < idList.length; i++ ) {
        var d = {
          aptbookid: me._CurrentBook.id,
          userorgid: idList[i]
        };
        chain.push($http.post(apiUrl + '/YAAppointmentBooks/addtowaitinglist?access_token=' + TokenService.get(), d ));
      }

      $q.all( chain ).then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    deleteFromWaitingList: function(idList, cb) {
      loadingScreen.turnOn(true);
      var chain = [];
      for ( var i = 0; i < idList.length; i++ ) {
        var d = {
          aptbookid: me._CurrentBook.id,
          userorgid: idList[i]
        };
        chain.push($http.post(apiUrl + '/YAAppointmentBooks/removefromwaitinglist?access_token=' + TokenService.get(), d ));
      }

      $q.all( chain ).then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },

    addUnavailable: function(dataList, cb) {
      loadingScreen.turnOn(true);
      var chain = [];
      var id = me._CurrentWeek.id;
      var newList = [];
      for ( var i = 0; i < dataList.length; i++ ) {
        var d = {
          'weekid': id,
          'startdate':dataList[i].startdate,
          'enddate':dataList[i].enddate
        };
        chain.push($http.post(apiUrl + '/YAAppointmentBookWeeks/addunavailabletime?access_token=' + TokenService.get(), d ).then(function(result) {
          result.data.startdate = new Date(result.data.starttime);
          result.data.enddate = new Date(result.data.endtime);
          newList.push(result.data);
        }));
      }

      $q.all( chain ).then(function() {
        // assign ids to objects
        for ( var i = 0; i < dataList.length; i++ ) {
          for ( var a = 0; a < newList.length; a++ ) {
            if ( newList[a].startdate.toString() == dataList[i].startdate.toString() ) {
              dataList[i].object.id = newList[a].id;
              break;
            }
          }
        }
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });

    },
    deleteUnavailable: function(id, cb) {
      loadingScreen.turnOn(true);
      var d = {
        weekid: me._CurrentWeek.id,
        timeid: id
      };
      $http.post(apiUrl + '/YAAppointmentBookWeeks/removeunavailabletime?access_token=' + TokenService.get(), d )
      .then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },
    updateMessage: function(msg, cb) {
      loadingScreen.turnOn(true);
      $http.put(apiUrl + '/YAAppointmentBooks?access_token=' + TokenService.get(), {'id':msg.id, 'message':msg.message})
      .then(function() {
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error) {
        cb(error.result);
        loadingScreen.turnOn(false);
      });
    },
    updateReschedule: function(objects, cb) {
      loadingScreen.turnOn(true);
      var d = {
        'weekid': me._CurrentWeek.id,
        'rescheduleflags': me._CurrentWeek.rescheduleflags,
        'slotdata':objects
      };

      var update = {
        'rescheduledata':me._CurrentWeek.rescheduledata
      }

      $http.post(apiUrl + '/YAAppointmentBookWeeks/update?where={"id":' + me._CurrentWeek.id + '}&access_token=' + TokenService.get(), update )
      .then(function() {

        $http.post(apiUrl + '/YAAppointmentBookWeeks/updaterescheduleslots?access_token=' + TokenService.get(), d )
        .then(function(result) {

          for (var i = 0; i < result.data.timeslots.length; i++ ) {
            result.data.timeslots[i].startdate = new Date(result.data.timeslots[i].starttime);
            result.data.timeslots[i].enddate = new Date(result.data.timeslots[i].endtime);
          }
          me._CurrentWeek.reschedule = result.data.timeslots;

          cb(null);
          loadingScreen.turnOn(false);
        }).catch(function(error) {
          cb(error.message);
          loadingScreen.turnOn(false);
        });

      }).catch(function(error) {
        cb(error.message);
        loadingScreen.turnOn(false);
      });


    },

      /* addReschedule: function(data,cb){
      loadingScreen.turnOn(true);
      var id = me._CurrentWeek.id;
      var d = {
          "weekid": id,
          "startdate":data.startdate,
          "enddate":data.enddate
        };
      $http.post(apiUrl + '/YAAppointmentBookWeeks/addrescheduletime?access_token='+TokenService.get(), d )
      .then(function(result){
        data.id = result.data.id;
        cb(null);
        loadingScreen.turnOn(false);
      }).catch(function(error){
        cb(error.message);
        loadingScreen.turnOn(false);
      });
    },*/

    registerWeek: function(cb) {
      loadingScreen.turnOn(true);

      if ( me._CurrentWeek ) {
        var tag = me._CurrentWeek.startdate;
        for (var i = 0; i < me._testData.length; i++ ) {
          if ( me._testData[i].startdate == tag ) {
            me._testData[i] = me._CurrentWeek;
            cb(null);
            loadingScreen.turnOn(false);
            return;
          }
        }

        me._testData.push(me._CurrentWeek);
      }

      cb(null);
      loadingScreen.turnOn(false);
      return;
    },

    getWeek: function() {
      return me._CurrentWeek;
    }

  }

});


(function() {
  'use strict';

  angular
  .module('youApp')
  .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
  .module('youApp')
  .config(routeConfig);

  function routeConfig($routeProvider) {
    $routeProvider
      // home page
      // .when('/', {
      //   templateUrl: 'app/pages/home/home.html',
      //   controller: 'Home.Controller',
      //   controllerAs: 'vm'
      // })
    .when('/', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/classlink', {
      templateUrl: 'app/pages/classlink/classlink.html',
      controller: 'Classlink.Controller',
      controllerAs: 'vm'
    })
    .when('/onboarding', {
      templateUrl: 'app/pages/onboarding/onboarding.html',
      controller: 'Onboarding.Controller',
      controllerAs: 'vm'
    })
    .when('/request', {
      templateUrl: 'app/pages/request/request.html',
      controller: 'Request.Controller',
      controllerAs: 'vm'
    })
      //
    .when('/existing', {
      templateUrl: 'app/pages/existing/existing.html',
      controller: 'Existing.Controller',
      controllerAs: 'vm'
    })
    .when('/continue', {
      templateUrl: 'app/pages/continue/continue.html',
      controller: 'Continue.Controller',
      controllerAs: 'vm'
    })
    .when('/userjoin/:token', {
      templateUrl: 'app/pages/userjoin/userjoin.html',
      controller: 'UserJoin.Controller',
      controllerAs: 'vm'
    })
    .when('/delete-account', {
      templateUrl: 'app/pages/deleteaccount/deleteaccount.html',
      controller: 'DeleteAccount.Controller',
      controllerAs: 'vm'
    })
    .when('/delete-account-confirmation/:token', {
      templateUrl: 'app/pages/deleteaccountconfirmation/deleteaccountconfirmation.html',
      controller: 'ConfirmDeleteAccount.Controller',
      controllerAs: 'vm'
    })
    .when('/passwordhelp', {
      templateUrl: 'app/pages/passwordhelp/passwordhelp.html',
      controller: 'PasswordHelp.Controller',
      controllerAs: 'vm'
    })
    .when('/passwordreset/:token', {
      templateUrl: 'app/pages/passwordreset/passwordreset.html',
      controller: 'PasswordReset.Controller',
      controllerAs: 'vm'
    })
    .when('/join', {
      templateUrl: 'app/pages/join/join.html',
      controller: 'Join.Controller',
      controllerAs: 'vm'
    })
      /*.when('/userrequest/:orgID', {
        templateUrl: 'app/pages/userrequest/userrequest.html',
        controller: 'UserRequest.Controller',
        controllerAs: 'vm'
      })*/
    .when('/error/:errorID', {
      templateUrl: 'app/pages/error/error.html',
      controller: 'Error.Controller',
      controllerAs: 'vm'
    })
      // new organization set-up
    .when('/signuporg', {
      templateUrl: 'app/pages/signuporg/signuporg.html',
      controller: 'SignUpOrg.Controller',
      controllerAs: 'vm'
    })
      //
    .when('/setup/:orgID?', {
      templateUrl: 'app/pages/setup/setup.html',
      controller: 'SetUp.Controller',
      controllerAs: 'vm'
    })
      //
    .when('/ratefee/:orgID', {
      templateUrl: 'app/pages/ratefee/ratefee.html',
      controller: 'RateFee.Controller',
      controllerAs: 'vm'
    })
      //
    .when('/billing/:orgID', {
      templateUrl: 'app/pages/billing/billing.html',
      controller: 'Billing.Controller',
      controllerAs: 'vm'
    })
      //
      /*.when('/image/:orgID', {
        templateUrl: 'app/pages/image/image.html',
        controller: 'Image.Controller',
        controllerAs: 'vm'
      })
      //
      .when('/catsetup/:orgID', {
        templateUrl: 'app/pages/catsetup/catsetup.html',
        controller: 'CatSetup.Controller',
        controllerAs: 'vm'
      })
      //
      .when('/usersetup/:orgID', {
        templateUrl: 'app/pages/usersetup/usersetup.html',
        controller: 'UserSetup.Controller',
        controllerAs: 'vm'
      })*/
      //
    .when('/payment/:orgID', {
      templateUrl: 'app/pages/payment/payment.html',
      controller: 'Payment.Controller',
      controllerAs: 'vm'
    })
    .when('/distributor/:distributorID', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/distributor/:distributorID/sales-orders/:code', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/distributor/:distributorID/resellers/:resellerID', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/distributor/:distributorID/resellers/:resellerID/sales-people', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/distributor/:distributorID/resellers/:resellerID/sales-people/:salesPersonId', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/distributor/:distributorID/resellers/:resellerID/sales-order/:salesOrderCode', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/distributor/:distributorID/payment-reports/:code', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/resellers/:code', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/resellers/:code/sales-people', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/resellers/:code/sales-people/add', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/resellers/:code/sales-people/:salesPersonId', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/resellers/:code/sales-order/:salesOrderCode', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
      // .when('/select', {
      //   templateUrl: 'app/pages/select/select.html',
      //   controller: 'Select.Controller',
      //   controllerAs: 'vm'
      // })
    .when('/select', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/select/:code', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    // .when('/completesales', {
    //   templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
    //   controller: 'IframeAdmin.Controller',
    //   controllerAs: 'vm'
    // })
    // .when('/completesales/:code', {
    //   templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
    //   controller: 'IframeAdmin.Controller',
    //   controllerAs: 'vm'
    // })
    .when('/completesales/:companyCode/:code', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
      // workflow approval required
    .when('/approval/:orgID', {
      templateUrl: 'app/pages/approval/approval.html',
      controller: 'Approval.Controller',
      controllerAs: 'vm'
    })
      // queued
    .when('/pending/:orgID', {
      templateUrl: 'app/pages/pending/pending.html',
      controller: 'Pending.Controller',
      controllerAs: 'vm'
    })
    .when('/pendingcalc/:orgID/:tempID', {
      templateUrl: 'app/pages/pendingcalc/pendingcalc.html',
      controller: 'PendingCalc.Controller',
      controllerAs: 'vm'
    })
      // admin dashboard
    .when('/dashboard/:orgID', {
      templateUrl: 'app/pages/dashboard/dashboard.html',
      controller: 'Dashboard.Controller',
      controllerAs: 'vm'
    })
      // super admin dashboard
    .when('/adminmessages', {
      templateUrl: 'app/pages/adminmessages/adminmessages.html',
      controller: 'AdminMessages.Controller',
      controllerAs: 'vm'
    })
    .when('/adminorganizations', {
      templateUrl: 'app/pages/adminorganizations/adminorganizations.html',
      controller: 'AdminOrganizations.Controller',
      controllerAs: 'vm'
    })
    .when('/adminusers', {
      templateUrl: 'app/pages/adminusers/adminusers.html',
      controller: 'AdminUsers.Controller',
      controllerAs: 'vm'
    })
    .when('/adminlms', {
      templateUrl: 'app/pages/adminlms/adminlms.html',
      controller: 'AdminLms.Controller',
      controllerAs: 'vm'
    })
    .when('/adminInviteTemplates', {
      templateUrl: 'app/pages/adminInviteTemplates/adminInviteTemplates.html',
      controller: 'AdminInviteTemplates.Controller',
      controllerAs: 'vm'
    })
    .when('/adminemployees', {
      templateUrl: 'app/pages/adminemployees/adminemployees.html',
      controller: 'AdminEmployees.Controller',
      controllerAs: 'vm'
    })
    .when('/adminindustry', {
      templateUrl: 'app/pages/adminindustry/adminindustry.html',
      controller: 'AdminIndustry.Controller',
      controllerAs: 'vm'
    })
    .when('/admincategory', {
      templateUrl: 'app/pages/admincategory/admincategory.html',
      controller: 'AdminCategory.Controller',
      controllerAs: 'vm'
    })
    .when('/adminsales', {
      templateUrl: 'app/pages/adminsales/adminsales.html',
      controller: 'AdminSales.Controller',
      controllerAs: 'vm'
    })
      // message pages
    .when('/appointment/:orgID', {
      templateUrl: 'app/pages/appointment/appointment.html',
      controller: 'Appointment.Controller',
      controllerAs: 'vm'
    })
    .when('/apptschedule/:orgID/:tempID', {
      templateUrl: 'app/pages/apptschedule/apptschedule.html',
      controller: 'ApptSchedule.Controller',
      controllerAs: 'vm'
    })
    .when('/apptselect/:orgID', {
      templateUrl: 'app/pages/apptselect/apptselect.html',
      controller: 'ApptSelect.Controller',
      controllerAs: 'vm'
    })
    .when('/apptavailable/:orgID/:tempID', {
      templateUrl: 'app/pages/apptavailable/apptavailable.html',
      controller: 'ApptAvailable.Controller',
      controllerAs: 'vm'
    })
    .when('/apptedit/:orgID/:tempID', {
      templateUrl: 'app/pages/apptedit/apptedit.html',
      controller: 'ApptEdit.Controller',
      controllerAs: 'vm'
    })
    .when('/announcement/:orgID', {
      templateUrl: 'app/pages/announcement/announcement.html',
      controller: 'Announcement.Controller',
      controllerAs: 'vm'
    })
    .when('/announcselect/:orgID', {
      templateUrl: 'app/pages/announcselect/announcselect.html',
      controller: 'AnnouncSelect.Controller',
      controllerAs: 'vm'
    })
    .when('/announcedit/:orgID/:tempID', {
      templateUrl: 'app/pages/announcedit/announcedit.html',
      controller: 'AnnouncEdit.Controller',
      controllerAs: 'vm'
    })
    .when('/announccalc/:orgID/:tempID', {
      templateUrl: 'app/pages/announccalc/announccalc.html',
      controller: 'AnnouncCalc.Controller',
      controllerAs: 'vm'
    })
    .when('/announcschedule/:orgID/:tempID', {
      templateUrl: 'app/pages/announcschedule/announcschedule.html',
      controller: 'AnnouncSchedule.Controller',
      controllerAs: 'vm'
    })
    .when('/ad/:orgID', {
      templateUrl: 'app/pages/ad/ad.html',
      controller: 'Ad.Controller',
      controllerAs: 'vm'
    })
    .when('/adselect/:orgID', {
      templateUrl: 'app/pages/adselect/adselect.html',
      controller: 'AdSelect.Controller',
      controllerAs: 'vm'
    })
    .when('/adedit/:orgID/:tempID', {
      templateUrl: 'app/pages/adedit/adedit.html',
      controller: 'AdEdit.Controller',
      controllerAs: 'vm'
    })
    .when('/adcalc/:orgID/:tempID', {
      templateUrl: 'app/pages/adcalc/adcalc.html',
      controller: 'AdCalc.Controller',
      controllerAs: 'vm'
    })
    .when('/adschedule/:orgID/:tempID', {
      templateUrl: 'app/pages/adschedule/adschedule.html',
      controller: 'AdSchedule.Controller',
      controllerAs: 'vm'
    })
    .when('/alert/:orgID', {
      templateUrl: 'app/pages/alert/alert.html',
      controller: 'Alert.Controller',
      controllerAs: 'vm'
    })
    .when('/alertselect/:orgID', {
      templateUrl: 'app/pages/alertselect/alertselect.html',
      controller: 'AlertSelect.Controller',
      controllerAs: 'vm'
    })
    .when('/alertedit/:orgID/:tempID', {
      templateUrl: 'app/pages/alertedit/alertedit.html',
      controller: 'AlertEdit.Controller',
      controllerAs: 'vm'
    })
    .when('/reporting/:orgID', {
      templateUrl: 'app/pages/reporting/reporting.html',
      controller: 'Reporting.Controller',
      controllerAs: 'vm'
    })
    .when('/catgroup/:orgID', {
      templateUrl: 'app/pages/catgroup/catgroup.html',
      controller: 'CatGroup.Controller',
      controllerAs: 'vm'
    })
    .when('/category/:orgID', {
      templateUrl: 'app/pages/category/category.html',
      controller: 'Category.Controller',
      controllerAs: 'vm'
    })
    .when('/dashboardgroup/:orgID', {
      templateUrl: 'app/pages/dashboardgroup/dashboardgroup.html',
      controller: 'DashboardGroup.Controller',
      controllerAs: 'vm'
    })
    .when('/dashboardgroupuser/:orgID/:groupID', {
      templateUrl: 'app/pages/dashboardgroupuser/dashboardgroupuser.html',
      controller: 'DashboardGroupUser.Controller',
      controllerAs: 'vm'
    })
    .when('/group/:orgID', {
      templateUrl: 'app/pages/group/group.html',
      controller: 'Group.Controller',
      controllerAs: 'vm'
    })
    .when('/groupuser/:orgID/:groupID', {
      templateUrl: 'app/pages/groupuser/groupuser.html',
      controller: 'GroupUser.Controller',
      controllerAs: 'vm'
    })
    .when('/user/:orgID', {
      templateUrl: 'app/pages/user/user.html',
      controller: 'User.Controller',
      controllerAs: 'vm'
    })
    .when('/profile/:orgID', {
      templateUrl: 'app/pages/profile/profile.html',
      controller: 'Profile.Controller',
      controllerAs: 'vm'
    })
    .when('/contact/:orgID', {
      templateUrl: 'app/pages/contact/contact.html',
      controller: 'Contact.Controller',
      controllerAs: 'vm'
    })
    .when('/support/:orgID', {
      templateUrl: 'app/pages/support/support.html',
      controller: 'Support.Controller',
      controllerAs: 'vm'
    })
      // .when('/logout', {
      //   templateUrl: 'app/pages/logout/logout.html',
      //   controller: 'Logout.Controller',
      //   controllerAs: 'vm'
      // })
    .when('/logout', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/license', {
      templateUrl: 'app/pages/license/license.html',
      controller: 'License.Controller',
      controllerAs: 'vm'
    })

    .when('/salesorganizations', {
      templateUrl: 'app/pages/salesorganizations/salesorganizations.html',
      controller: 'SalesOrganizations.Controller',
      controllerAs: 'vm'
    })
    .when('/sales/:salesOrderCode', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/sales/:salesOrderCode/:selectedTab', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/sales-bulk/:salesOrderCode', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/sales-bulk/:salesOrderCode/:selectedTab', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
      // .when('/sales/:salesOrderCode', {
      //   templateUrl: 'app/pages/sales/sales.html',
      //   controller: 'Sales.Controller',
      //   controllerAs: 'vm'
      // })
      // .when('/sales/:salesOrderCode/:selectedTab', {
      //   templateUrl: 'app/pages/sales/sales.html',
      //   controller: 'Sales.Controller',
      //   controllerAs: 'vm'
      // })
    .when('/editsalesorg/:editingOrgID', {
      templateUrl: 'app/pages/editsalesorg/editsalesorg.html',
      controller: 'EditSalesOrg.Controller',
      controllerAs: 'vm'
    })

    .when('/mobilelanding/:orgID', {
      templateUrl: 'app/pages/mobilelanding/mobilelanding.html',
      controller: 'MobileLanding.Controller',
      controllerAs: 'vm'
    })

    .when('/brightpattern', {
      templateUrl: 'app/pages/brightpattern/brightpattern.html',
      controller: 'BrightPattern.Controller',
      controllerAs: 'vm'
    })

    .when('/unsubscribe/', {
      templateUrl: 'app/pages/unsubscribe/unsubscribe.html',
      controller: 'Unsubscribe.Controller',
      controllerAs: 'vm'
    })

    .when('/emailcampaign/:orgID', {
      templateUrl: 'app/pages/emailcampaign/emailcampaign.html',
      controller: 'EmailCampaign.Controller',
      controllerAs: 'vm'
    })

    .when('/emailcampaignusers/:orgID/:groupID', {
      templateUrl: 'app/pages/emailcampaignusers/emailcampaignusers.html',
      controller: 'EmailCampaignUsers.Controller',
      controllerAs: 'vm'
    })
    .when('/messagereports/:orgID', {
      templateUrl: 'app/pages/messagereports/messagereports.html',
      controller: 'MessageReports.Controller',
      controllerAs: 'vm'
    })
    .when('/messagereports/:orgID/:reportID', {
      templateUrl: 'app/pages/messagereportsdetailed/messagereportsdetailed.html',
      controller: 'MessageReportsDetailed.Controller',
      controllerAs: 'vm'
    })
    .when('/distributors', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/distributors/:distributorID', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/distributors/:distributorID/sales-orders/:code', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/distributors/:distributorID/resellers/:resellerID', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/distributors/:distributorID/resellers/:resellerID/sales-people', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/distributors/:distributorID/resellers/:resellerID/sales-people/:salesPersonId', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/distributors/:distributorID/resellers/:resellerID/sales-order/:salesOrderCode', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/distributors/:distributorID/payment-reports/:code', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/pricing-templates', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/pricing-templates/:pricingTemplateID', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .when('/bulksms/:orgID', {
      templateUrl: 'app/pages/bulksms/bulksms.html',
      controller: 'BulkSMS.Controller',
      controllerAs: 'vm'
    })
    .when('/responsegroups/:orgID', {
      templateUrl: 'app/pages/responsegroup/responsegroup.html',
      controller: 'ResponseGroup.Controller',
      controllerAs: 'vm'
    })
    .when('/responseforms/:orgID/:groupID', {
      templateUrl: 'app/pages/responseforms/responseforms.html',
      controller: 'Responseforms.Controller',
      controllerAs: 'vm'
    })
    .when('/covidreports/:orgID', {
      templateUrl: 'app/pages/iframe-admin/iframeAdmin.html',
      controller: 'IframeAdmin.Controller',
      controllerAs: 'vm'
    })
    .otherwise({
      redirectTo: '/'
    });
  }

})();

(function() {
  'use strict';

  angular
  .module('youApp')
    // .constant('apiUrl', "/api/v1")
  .factory('apiUrl', function($location) {
    var port = ($location.port() !== 443 && $location.port() !== 80) ? ':' + $location.port() : ''
    var apiUrl = $location.protocol() + '://' + $location.host() + port + '/api/v1';
    return apiUrl;
  })
  .constant('fileBucket', 'yougetitfirstfiles')
    // .constant('youAppOrganizationId', 3)

  //Staging
  //.constant('apiUrl', "https://api.staging.yougetitfirst.com/api/v1")
  //.constant('fileBucket', 'yougetitfirststaging')

  //Production
  //.constant('apiUrl', "https://api.yougetitfirst.com/api/v1")
  //.constant('fileBucket', "yougetitfirstfiles")

})();

(function() {
  'use strict';

  //overwrite the default fabric _wrapLine function to include word breaking
  fabric.Textbox.prototype._wrapLine = function(ctx, text, lineIndex) {
    var lineWidth = 0,
      lines = [],
      line = '',
      words = text.split(' '),
      word = '',
      offset = 0,
      infix = ' ',
      wordWidth = 0,
      infixWidth = 0,
      letterWidth = 0,
      largestWordWidth = 0;

    for (var i = 0; i < words.length; i++) {
      word = words[i];
      wordWidth = this._measureText(ctx, word, lineIndex, offset);
      lineWidth += infixWidth;

      // Break Words if wordWidth is greater than textbox width
      if (this.breakWords && wordWidth > this.width) {
        line += infix;
        var wordLetters = word.split('');
        while (wordLetters.length) {
          letterWidth = this._getWidthOfChar(ctx, wordLetters[0], lineIndex, offset);
          if (lineWidth + letterWidth > this.width) {
            lines.push(line);
            line = '';
            lineWidth = 0;
          }
          line += wordLetters.shift();
          offset++;
          lineWidth += letterWidth;
        }
        word = '';
      } else {
        lineWidth += wordWidth;
      }

      if (lineWidth >= this.width && line !== '') {
        lines.push(line);
        line = '';
        lineWidth = wordWidth;
      }

      if (line !== '' || i === 1) {
        line += infix;
      }
      line += word;
      offset += word.length;
      infixWidth = this._measureText(ctx, infix, lineIndex, offset);
      offset++;

      // keep track of largest word
      if (wordWidth > largestWordWidth && !this.breakWords) {
        largestWordWidth = wordWidth;
      }
    }

    i && lines.push(line);

    if (largestWordWidth > this.dynamicMinWidth) {
      this.dynamicMinWidth = largestWordWidth;
    }

    return lines;
  };

  angular
  .module('youApp')
  .config(configHTTP)
  .config(configToastr)
  .config(logConfig)
  .config(whiteList);

  /** @ngInject */
  function configHTTP($httpProvider,MessageBoxServiceProvider) {

    $httpProvider.defaults.useXDomain = true;
    delete $httpProvider.defaults.headers.common['X-Requested-With'];
    // global error handle
    $httpProvider.interceptors.push( function($q) {
      return {
        'requestError': function(error) {
          return $q.reject(error);
        },

        'responseError': function(error) {
          var errorstatus = 0;
          // do something on error
          var message = '';

          var messageBox = MessageBoxServiceProvider.$get();

          if (error.status == -1 && errorstatus == 0) {
            setError(1);
            messageBox.open('Brief timeout, will resume', 'Please try again' ,'Continue', function() {});
          }

          if ( error.data != undefined && error.data.details != undefined ) {
            error = error.data.error;
            message += error.details.context + ': ';
            message += error.status + ' ' + error.name + ': ';
            for ( var m in error.details.messages )
              message += m + ' ';
          }
          else if ( error.data != undefined && error.data.error != undefined) {
            error = error.data.error;
            message = error.message;
          }
          else {
            message = error.status + ' ' + error.statusText;
          }

          function setError(number) {
            errorstatus = number;
          }

          if ( error.yaerrorcode && errorstatus == 0 ) {
            switch (error.yaerrorcode.toLowerCase()) {
            case 'ya_emailinuse':
              setError(1);
              messageBox.open('Email In Use Error', message,'Continue', function() { });
              break;

            case 'ya_orgadmin_delete_last':
              setError(1);
              messageBox.open('Error', message,'Continue', function() { });
              break;

            case 'ya_notverified':
              setError(1);
              messageBox.open('Email Not Verified Error', message,'Continue', function() { });
              break;

            case 'ya_invalidlogin':
              setError(1);
              // messageBox.open("Invalid Login Error", message,"Continue", function(){ });
              break;

            case 'ya_socialerror':
              setError(1);
              messageBox.open('Invalid Login Error', message,'Continue', function() { });
              break;
            case 'ya_passwordmatch':
              setError(1);
              messageBox.open('Invalid Login Error', message,'Continue', function() { });
              break;

            case 'ya_paymentfailed':
              setError(1);
              messageBox.open('Payment Error', message,'Continue', function() { });
              break;

            case 'ya_orgexists':
              setError(1);
              messageBox.open('Organization already exists', 'An organization with this name has already been found for this city / state.','Continue', function() { });
              break;

            case 'ya_referralcode':
              setError(1);
              messageBox.open('Duplicate Referral Code', 'Please use a different referral code', 'OK', function() {});
              break;

            case 'ya_workflowadmin':
            case 'ya_unauthoriezed':
            case 'ya_classlinkcode':
              setError(1);
              break;

            case 'ya_identicard':
              setError(1);
              // messageBox.open("Invalid Identicard Configuration", "Please configure" ,"Continue", function(){});
              break;

            case 'ya_unknown':
            default:
              if (errorstatus == 0) {
                setError(1);
                messageBox.open('Brief timeout, will resume', 'Please try again' ,'Continue', function() {});
              }
              break;
            }
          }
          else {
            if (errorstatus == 0) {
              setError(1);
              messageBox.open('Brief timeout, will resume', 'Please try again' ,'Continue', function() {});
            }
          }

          if ( error.status == 401 && errorstatus == 0) {
            setError(1);
            messageBox.open('Error', 'Something went wrong, please return to home page', 'Continue', function() {
              location.href = '/#/';
            });
          }

          return $q.reject(error);
        }
      };
    });
  }


  function whiteList( $compileProvider )
  {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|you):/);
    // Angular before v1.2 uses $compileProvider.urlSanitizationWhitelist(...)
  }

  function logConfig($logProvider) {
    $logProvider.debugEnabled(false);
  }

  function configToastr($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }
})();

angular.module("youApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/admin-sidenav/ya-admin-sidenav.html","<div id=\"adminSideNav\" layout=\"column\" layout-align=\"start stretch\" class=\"adminSideNav shorten-on-tablet\">\n\n  <!--Header layout-gt-sm=\"column\" stacks items on mobile-->\n  <div layout=\"row\" layout-md=\"column\" layout-align=\"start center\" class=\"column-top\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\">\n      <img class=\"md-avatar avatar-update\" ng-src=\"{{vm.currentOrgPic}}\">\n    </div>\n\n    <div flex class=\"padLeft\" style=\"overflow:hidden\">\n      <p class=\"sidenav-title\">You App Corporate</p>\n      <p class=\"lighter\" style=\"font-size: 12px\">{{vm.currentUser}}</p>\n    </div>\n  </div>\n\n  <!--Admin-->\n  <!-- <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" style=\"min-height: 80px\" ng-click=\"vm.Nav(\'select\')\">  -->\n  <!--enable this temporarily as a homepage. Delete this and uncomment the div above to reset back to original  -->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" style=\"min-height: 80px\" ng-click=\"vm.Nav(\'adminmessages\')\"> <!-- this -->\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"dashboardinfotext=true\" ng-mouseleave=\"dashboardinfotext=false\">\n      <img class=\"iconSize\" src=\"assets\\images\\icons\\nav-home.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"dashboardinfotext\">Corporate Dashboard</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div style=\"font-size: 20px\" class=\"hide-on-tablet buttonText\">Corporate Dashboard</div>\n    </div>\n  </div>\n\n  <!--Send Message-->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'adminmessages\')\" style=\"opacity: .25; cursor:not-allowed\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"sendmessageinfotext = true\" ng-mouseleave=\"sendmessageinfotext = false\">\n      <i class=\"material-icons md-24 md-light\">mail</i>\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"sendmessageinfotext\">Send Message</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Send Message</div>\n    </div>\n  </div>\n\n  <!--Organizations -->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'adminorganizations\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"organizationinfotext = true\" ng-mouseleave=\"organizationinfotext = false\">\n      <img class=\"iconSize\" style=\"margin-left: 0\" src=\"assets\\images\\icons\\nav-home.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"organizationinfotext\">Organizations</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Organizations</div>\n    </div>\n  </div>\n\n  <!--Org Users  -->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'adminusers\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"orguserinfotext = true\" ng-mouseleave=\"orguserinfotext = false\">\n      <md-icon class=\"s24\" md-svg-src=\"../../assets/images/icons/navicon-users.svg\"></md-icon>\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"orguserinfotext\">Orgnanization Users</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Orgnanization Users</div>\n    </div>\n  </div>\n\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'adminlms\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"lmsinfotext = true\" ng-mouseleave=\"lmsinfotext = false\">\n      <md-icon class=\"s24\" md-svg-src=\"../../assets/images/icons/navicon-users.svg\"></md-icon>\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"lmsinfotext\">LMS</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">LMS</div>\n    </div>\n  </div>\n\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'adminInviteTemplates\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"adminInviteTemplatesinfotext = true\" ng-mouseleave=\"adminInviteTemplatesinfotext = false\">\n      <md-icon class=\"s24\" md-svg-src=\"../../assets/images/icons/navicon-users.svg\"></md-icon>\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"adminInviteTemplatesinfotext\">LMS</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Invite Templates</div>\n    </div>\n  </div>\n  <!--Corp Employees  -->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'adminemployees\')\" style=\"opacity: .25; cursor:not-allowed\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"corpemployees = true\" ng-mouseleave=\"corpemployees = false\">\n      <i class=\"material-icons md-24 md-light\">work</i>\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"corpemployees\">Corporate Employees</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Corporate Employees</div>\n    </div>\n  </div>\n\n  <!--Industry Type  -->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'adminindustry\')\" style=\"opacity: .25; cursor:not-allowed\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"industrytypesinfotext = true\" ng-mouseleave=\"industrytypesinfotext = false\">\n      <i class=\"material-icons md-24 md-light\">business</i>\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"industrytypesinfotext\">Industry Type</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Industry Type</div>\n    </div>\n  </div>\n\n  <!--Cats & Groups  -->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'admincategory\')\" style=\"opacity: .25; cursor:not-allowed\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"categoriesandgroupsinfotext = true\" ng-mouseleave=\"categoriesandgroupsinfotext = false\">\n      <md-icon class=\"s24\" md-svg-src=\"../../assets/images/icons/navicon-catgroups.svg\"></md-icon>\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"categoriesandgroupsinfotext\">Categories & Groups</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Categories & Groups</div>\n    </div>\n  </div>\n\n  <!-- Sales Organizations -->\n  <!-- <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'salesorganizations\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"salesinfotext = true\" ng-mouseleave=\"salesinfotext = false\">\n      <img class=\"iconSize\" style=\"margin-left: 0\" src=\"assets\\images\\icons\\nav-home.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"salesinfotext\">Sales Organizations</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Sales Organizations</div>\n    </div>\n  </div> -->\n\n  <!--Reporting  -->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" style=\"opacity: .25; cursor:not-allowed\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"reportinginfotext = true\" ng-mouseleave=\"reportinginfotext = false\">\n      <img class=\"iconSize\" style=\"margin-left: 0\" src=\"assets\\images\\icons\\nav-home.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"reportinginfotext\">Reporting</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Reporting</div>\n    </div>\n  </div>\n\n  <!--Payment  -->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" style=\"opacity: .25; cursor:not-allowed\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"paymentinfotext = true\" ng-mouseleave=\"paymentinfotext = false\">\n      <img class=\"iconSize\" style=\"margin-left: 0\" src=\"assets\\images\\icons\\nav-home.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"paymentinfotext\">Payment</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Payment</div>\n    </div>\n  </div>\n\n  <!-- Distributors -->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'distributors\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"distributorinfotext = true\" ng-mouseleave=\"distributorinfotext = false\">\n      <img class=\"iconSize\" style=\"margin-left: 0\" src=\"assets\\images\\icons\\nav-home.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"distributorinfotext\">Distributors</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Distributors</div>\n    </div>\n  </div>\n\n  <!-- Pricing Templates -->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'pricing-templates\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"pricingtemplatestext = true\" ng-mouseleave=\"pricingtemplatestext = false\">\n      <img class=\"iconSize\" style=\"margin-left: 0\" src=\"assets\\images\\icons\\nav-home.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"pricingtemplatestext\">Pricing Templates</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Pricing Templates</div>\n    </div>\n  </div>\n\n</div>");
$templateCache.put("app/components/apptbook/ya-appt-book.html","<div id=\"apptbook\">\n	<div class=\"size\">\n		<div class=\"headerText\" layout=\"column\" layout-align=\"center center\">\n			Appointment Book For:\n		</div>\n		<md-autocomplete md-selected-item=\"vm.profile\" md-selected-item-change=\"vm.Change()\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getMatches(vm.searchText)\" md-item-text=\"item.name\">\n			<span md-highlight-text=\"searchText\">{{item.name}}</span>\n		</md-autocomplete>\n		<div class=\"whiteBox topBox\" layout=\"row\" layout-wrap layout-padding>		        \n	        <div layout=\"column\" layout-align=\"center start\">\n	            <md-input-container>\n	                <label>Name</label>\n	                <input aria-label=\"name\" type=\"text\" value=\"{{vm.profile.name}}\" ng-model=\"vm.profile.name\">\n	            </md-input-container>\n	            <md-input-container>\n	                <label>Title</label>\n	                <input aria-label=\"title\" type=\"text\" value=\"{{vm.profile.title}}\" ng-model=\"vm.profile.title\">\n	            </md-input-container>\n	            <md-input-container>\n	            	<label>Phone</label>\n	                <input aria-label=\"phone number\" type=\"text\" value=\"{{vm.profile.phonenumber}}\" ng-model=\"vm.profile.phonenumber\" ng-pattern=\"vm.phPattern\" onclick=\"if(value==\'(###)-###-####\'){value=\'\'}\">\n	                <div ng-messages=\"{\'pattern\': !x.phone}\">\n	                    <div ng-message=\"pattern\">invalid phone number</div>\n	                </div>\n	            </md-input-container>\n	            <md-input-container>\n	            	<label>Appointment Length</label>\n	            	<md-select aria-label=\"appointment length\" ng-change=\"vm.UpdateApptLength()\" ng-model=\"vm.appt.appointmentlength\">\n						<md-option ng-repeat=\"x in vm.apptLengthList\">{{x}}</md-option>\n					</md-select>\n	            </md-input-container>\n	            <md-checkbox class=\"blue italics\" type=\"checkbox\" ng-model=\"vm.appt.active\" ng-change=\"vm.ChangeActive()\">Active</md-checkbox>\n				<md-button aria-label=\"update\" ng-click=\"vm.CloseEdit()\" class=\"buttonOne\">Update User</md-button>\n	        </div>	        \n	    </div>\n	    <md-content id=\"element\" class=\"whiteBox bottomBox scrollable\">\n	    	<div layout=\"row\" layout-align=\"center center\">\n	    		<md-autocomplete class=\"autoComp\" md-selected-item=\"vm.curGroup\" md-search-text=\"vm.groupSearchText\" md-items=\"item in vm.getGroupMatches(vm.groupSearchText)\" md-item-text=\"item.name\">\n					<span md-highlight-text=\"searchText\">{{item.name}}</span>\n				</md-autocomplete>\n				<div flex></div>\n				<div ng-click=\"vm.Add()\">\n					<img src=\"/assets/images/icons/ic_done_black_24px.svg\">\n				</div>\n	    	</div>\n			<div class=\"userTab\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"x in vm.selectedGroupList\">\n				<div class=\"catLabel\">\n					{{x.name}}\n				</div>\n				<div class=\"close\" ng-click=\"vm.Delete(x)\"></div>\n			</div>\n	    </md-content>\n	</div>\n</div>");
$templateCache.put("app/components/apt-preview/ya-apt-preview.html","<div layout=\"column\" id=\"msg_preview\">\n	<div class=\"imagePlace\">\n		<img id=\"preview\" src=\"\" alt=\"Image Preview\" class=\"preview\">\n	</div>\n	<!-- <p>categories</p> -->\n	<div class=\"inputPosition\" layout=\"column\" layout-align=\"center center\">\n		\n		<md-content class=\"contentSize\">\n			<p>Reminder Frequency</p>\n			<md-checkbox class=\"blue italics\" type=\"checkbox\" ng-model=\"vmp.selectAllReminders\" ng-click=\"vmp.toggleReminder(vmp.selectAllReminders)\">Select ALL</md-checkbox>\n\n			<div ng-repeat=\"c in vmp.reminderList track by $index\">\n				<md-checkbox aria-label=\"select group\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.reminderList[$index].active\" ng-change=\"vmp.ChangeReminder()\">{{c.name}}</md-checkbox>\n			</div>\n			<!--p>Message Action Buttons</p>\n			<div ng-repeat=\"c in vmp.buttonList track by $index\">\n				<md-checkbox aria-label=\"select group\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.buttonList[$index].active\">{{c.name}}</md-checkbox>\n			</div-->\n\n		</md-content>\n\n		<div class=\"titleSpace\"></div>\n		<div ng-show=\"vmp.type==\'appointmentScheduler\'\">		\n			<md-button class=\"prevButton button\" ng-click=\"vmp.Done()\"><div class=\"buttonText\">Save</div></md-button>\n			 <md-button class=\"prevButton button\" ng-show=\"vmp.data.status!=\'template\'\" ng-click=\"vmp.Available()\"><div class=\"buttonText\">Available</div></md-button>\n		</div>\n		<div ng-show=\"vmp.type==\'appointmentEditor\'\">		\n      		<md-button class=\"prevButton button\" ng-click=\"vmp.Done()\"><div class=\"buttonText\">Save</div></md-button>\n      		 <md-button class=\"prevButton button\" ng-show=\"vmp.data.status!=\'template\'\" ng-click=\"vmp.Schedule()\"><div class=\"buttonText\">Schedule</div></md-button>\n		</div>\n		<div ng-show=\"vmp.type==\'appointmentAvailable\'\">		\n      		<md-button class=\"prevButton button\" ng-click=\"vmp.Done()\"><div class=\"buttonText\">Save</div></md-button>\n      		 <md-button class=\"prevButton button\" ng-show=\"vmp.data.status!=\'template\'\" ng-click=\"vmp.Schedule()\"><div class=\"buttonText\">Schedule</div></md-button>\n		</div>\n	</div>\n</div>");
$templateCache.put("app/components/card-stats/ya-card-stats.html","<div class=\"card-stats invis\" layout=\"column\" layout-align=\"space-around center\" layout-fill>\n	<div layout=\"row\" ng-repeat=\"(key, val) in vm.stats\">	\n		<div class=\"count\">{{(\"000\"+val.val).slice(-3)}}</div>\n		<div class=\"txt lighter\">{{val.name}}</div>\n	</div>\n</div>");
$templateCache.put("app/components/dashboard-card/ya-dashboard-card.html","<div id=\"dashboard-card\">\n		<!--div class=\"cardHead\" layout=\"row\" layout-align=\"center center\">\n			<div class=\"newCount\" align=\"center\">{{vm.data.newm}}</div>\n			<div class=\"cardTitle\">New</div>\n		</div-->\n		<div class=\"cardCont\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.onClick()\">\n			<div class=\"totalCont\" layout=\"column\" layout-align=\"center center\">\n				<div class=\"totalVal\">{{vm.data.total}}</div>\n				<div class=\"totalText\">total</div>\n			</div>\n		</div>\n		\n		<div class=\"cardFoot\" layout=\"column\" layout-align=\"center center\">\n			<div layout=\"row\">\n				<img ng-show=\"vm.data.type==\'Announcements\'\" class=\"imagePad\" src=\"assets\\images\\icons\\cardicon-announcements.png\">\n				<img ng-show=\"vm.data.type==\'Alerts\'\" class=\"imagePad\" src=\"assets\\images\\icons\\cardicon-alerts.png\">\n				<img ng-show=\"vm.data.type==\'Advertising\'\" class=\"imagePad\" src=\"assets\\images\\icons\\cardicon-advertising.png\">\n				<img ng-show=\"vm.data.type==\'Appointments\'\" class=\"imagePad\" src=\"assets\\images\\icons\\cardicon-appointments.png\">\n				<div class=\"footTitle\">{{vm.data.type}}</div>\n			</div>\n			<!--div class=\"lastStyle\" layout=\"row\">\n				<div>\n					Last Added:\n				</div>\n				<div class=\"dateGap\"></div>\n				<div>\n					{{vm.data.last}}\n				</div>\n			</div-->\n		</div>\n</div>");
$templateCache.put("app/components/help-menu/ya-help-content.html","<div class=\"help-drawer\">\n  <div class=\"top-help-content\">\n    <div class=\"help-image\">\n      <img src=\"/assets/images/help-drawer/quickstart_rocket.png\">\n    </div>\n    <div class=\"help-drawer-content\">\n      First time user?\n    </div>\n    <md-button class=\"quickstart-guide-button\" ng-href=\"https://s3-us-west-2.amazonaws.com/yougetitfirstfiles/QuickStartGuide_082119.pdf\">\n      Get the Quickstart Guide\n    </md-button>\n    <md-button class=\"three-step-checklist-button\" ng-href=\"https://s3-us-west-2.amazonaws.com/yougetitfirstfiles/YOU_3_Step_Checklist_082119.pdf\">\n      3-step Checklist\n    </md-button>\n  </div>\n  <div class=\"help-topics-section\">\n    <h4>\n      Help\n    </h4>\n    <h5>Top help topics</h5>\n    <ul>\n      <li ng-hide=\"category || users || group\" class=\"help-topic-title animate-show-hide\">\n        <a href ng-click=\"createMessage = !createMessage\" ng-hide=\"createMessage\">How do I create a message?</a>\n        <div ng-show=\"createMessage\" class=\"faq-content-title\" ng-click=\"createMessage = !createMessage\">\n          <div class=\"active-rectangle\"></div>\n          <a href>How do I create a message?</a>\n        </div>\n        <div class=\"support-text-content animate-show-hide\" ng-show=\"createMessage\">\n          From the left menu, select Alert, Advertising or Announcement. In the Create box, select NEW (Alert, Advertisement, Announcement). Your templates will appear. Select your template and click DONE. Your template will be in the Editor. Add in your edits and functions.\n        </div>\n      </li>\n      <li ng-hide=\"createMessage || users || group\" class=\"help-topic-title animate-show-hide\">\n        <a href ng-click=\"category = !category\" ng-hide=\"category\">What is a Category</a>\n        <div ng-show=\"category\" class=\"faq-content-title\" ng-click=\"category = !category\">\n          <div class=\"active-rectangle\"></div>\n          <a href>What is a Category</a>\n        </div>\n        <div class=\"support-text-content animate-show-hide\" ng-show=\"category\">\n          Categories (PUBLIC - Appear on YOU mobile phone app users)\n          Dashboard Users create Categories to be listed on all YOU mobile apps in the ecosystem. Each mobile app user can select an organization and their category to receive specific messages from the designated category. This allows narrowcasting and targeting. Example; Theatre, Sports, Food Service or any topic your reader is interested. Use items on your website navigation bar where you want your readers to be directed to.\n        </div>\n      </li>\n      <li ng-hide=\"createMessage || category || users\" class=\"help-topic-title animate-show-hide\">\n        <a href ng-click=\"group = !group\" ng-hide=\"group\">What is a Group?</a>\n        <div ng-show=\"group\" class=\"faq-content-title\" ng-click=\"group = !group\">\n          <div class=\"active-rectangle\"></div>\n          <a href>What is a Group?</a>\n        </div>\n        <div class=\"support-text-content animate-show-hide\" ng-show=\"group\">\n          Dashboard Users create Groups. These “private” Groups are your sending groups; usually within your organization. You can create as many Groups as your organization requires. And individual in a Group will receive an email inviting them to download the YOU phone App. Individuals can be added or deleted from a Group easily in the YOU dashboard.\n        </div>\n      </li>\n      <li ng-hide=\"createMessage || category || group\" class=\"help-topic-title animate-show-hide\">\n        <a href ng-click=\"users = !users\" ng-hide=\"users\">How do I upload individuals or lists to the Group?</a>\n        <div ng-show=\"users\" class=\"faq-content-title two-lines\" ng-click=\"users = !users\">\n          <div class=\"active-rectangle two-lines\"></div>\n          <a href>How do I upload individuals or lists to the Group?</a>\n        </div>\n        <div class=\"support-text-content animate-show-hide\" ng-show=\"users\">\n          On the far right of the Group you created, click upload. Select the CSV file you created to upload the group. Go to Reports to view your uploaded Group.\n          To create a Group for your dashboard users, click Users on the far right. On the right box, click the ‘X’ to view and select your dashboard users. Click the individual’s name to add them to your group.\n        </div>\n      </li>\n    </ul>\n    <p class=\"viewall-help\" ng-hide=\"createMessage || category || users || group\"><a href=\"#/support/4\">View all help topics >></a></p>\n  </div>\n  <div class=\"csv-help-content\">\n    <div class=\"help-image\">\n      <img src=\"/assets/images/help-drawer/group_recipients_img.png\">\n    </div>\n    <div class=\"csv-help-content-text\">\n      Need to Upload Multiple Recipients in a Group?\n    </div>\n    <md-button class=\"csv-buttons\" ng-href=\"https://s3-us-west-2.amazonaws.com/yougetitfirstfiles/LoadGroupData.csv\">\n        Download CSV Template\n    </md-button>\n  </div>\n  <div class=\"csv-help-content\">\n    <div class=\"help-image\">\n      <img src=\"/assets/images/help-drawer/dashboard_users_img.png\">\n    </div>\n    <div class=\"csv-help-content-text\">\n      Need to Upload Multiple You Get it First Dashboard Users?\n    </div>\n    <md-button class=\"csv-buttons\" ng-href=\"https://s3-us-west-2.amazonaws.com/yougetitfirstfiles/LoadUserData.csv\">\n        Download CSV Template\n    </md-button>\n  </div>\n  <div class=\"bottom-help-content\">\n    <div class=\"help-image\">\n      <img src=\"/assets/images/help-drawer/contact_us-img.png\">\n    </div>\n    <div class=\"help-drawer-content\">\n      <div class=\"contact-content\">\n        Need more help?\n      </div>\n      <md-button class=\"contact-us-button\" ng-href=\"#/contact/4\">\n        Contact Us\n      </md-button>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/help-menu/ya-help-menu.html","<md-sidenav md-component-id=\"help-menu\" class=\"md-sidenav-right md-whiteframe-4dp\">\n  <md-content>\n    <ng-include src=\"vm.helpPage\"></ng-include>\n    <md-button ng-click=\"vm.close()\" class=\"md-primary\">\n      Close Help\n    </md-button>\n  </md-content>\n</md-sidenav>\n");
$templateCache.put("app/components/help-tips/help-tips.html","<div id=\"help-tip\" ng-if=\"vm.active\" class=\"enter\" layout=\"column\">\n  <div layout=\"row\" layout-align=\"center center\" class=\"ie myStyle\">\n\n    <div flex=\"5\" class=\"icon\">\n      <md-icon md-svg-src=\"/assets/images/icons/ic_lightbulb_outline_black_24px.svg\"></md-icon>\n    </div>\n\n		<div flex class=\"text\">\n			{{vm.text}}\n    </div>\n\n    <div flex=\"5\" class=\"icon\" ng-click=\"vm.onClose()\" style=\"cursor:pointer\">\n       <md-icon md-svg-src=\"/assets/images/icons/ic_done_black_24px.svg\"></md-icon> \n    </div>\n\n  </div>\n</div>\n");
$templateCache.put("app/components/loading/ya-loading.html","<div id=\"ya-loading\">\n	<div ng-show=\"vm.on\" class=\"splash centered\">\n		<md-progress-circular md-diameter=\"180px\" class=\"spinner\"></md-progress-circular>\n	</div>\n</div>");
$templateCache.put("app/components/main-footer/ya-main-footer.html","<div class=\"ya-footer\">\n	<!--<md-toolbar>\n		<div class=\"md-toolbar-tools\">\n			\n			<div class=\"copywrite\" layout=\"column\" layout-align=\"center center\">\n				<div>© 2015 YOU Get It First</div>\n				<div>All rights reserved</div>\n			</div>\n			<div flex></div>\n			<a ng-click=\"vm.Nav(\'dashboard\')\" target=\"_blank\" class=\"siup buttUnder\">home</a>\n			<div flex=\"5\"></div>\n			<a href=\"http://www.yougetitfirst.com/how-it-works/\" target=\"_blank\" class=\"siup buttUnder\">features</a>\n			<div flex=\"5\"></div>\n			<a href=\"http://www.yougetitfirst.com/users/\" target=\"_blank\" class=\"siup buttUnder\">provider / user</a>\n			<div flex=\"5\"></div>\n			<a href=\"http://www.yougetitfirst.com/\" target=\"_blank\" class=\"siup buttUnder\">testimonials</a>\n			<div flex=\"5\"></div>\n			<a href=\"http://www.yougetitfirst.com/company/\" target=\"_blank\" class=\"siup buttUnder\">about</a>\n			<div flex></div>\n			<div>\n				<md-button aria-label=\"facebook\" class=\"md-icon-button\">\n					<md-icon md-svg-src=\"/assets/images/icons/facebook.svg\">\n					</md-icon>\n				</md-button>\n				<md-button aria-label=\"twitter\" class=\"md-icon-button\">\n					<md-icon md-svg-src=\"/assets/images/icons/twitter.svg\">\n					</md-icon>\n				</md-button>\n			</div>\n		</div>\n	</md-toolbar>-->\n</div>");
$templateCache.put("app/components/main-header/ya-main-header.html","<div id=\"mainHeader\" layout=\"column\" style=\"height: 65px; background-color: #0a4f78\">\n  <div style=\"height: 15%\"></div>\n\n  <div layout=\"row\" style=\"height: 70%\" layout-align=\"space-between center\">\n\n    <div ng-click=\"vm.Nav(\'dashboard\')\" layout=\"row\" layout-align=\"center center\" style=\"height: 100%; width: 13%; min-width: 250px\">\n      <img src=\"/assets/images/you-brand-medium.png\">\n    </div>\n\n    <div layout=\"row\" layout-align=\"center center\">\n      <!--menu-->\n      <div layout=\"row\" layout-align=\"center center\" class=\"icon-div\" style=\"margin-right: 25px\">\n        <div class=\"gearMenu\" layout=\"column\" layout-align=\"start end\">\n          <img class=\"\" src=\"/assets/images/icons/header-gear.png\">\n          <div class=\"menu\" layout=\"column\">\n            <div layout=\"row\" layout-align=\"start center\" class=\"buttonStyle hoverColor\" ng-click=\"vm.Nav(\'profile\')\">\n              <div style=\"width: 30px\"></div>\n              <img src=\"/assets/images/icons/gear-profile.png\">\n              <div style=\"width: 25px\"></div>\n              Profile\n            </div>\n            <div layout=\"row\" layout-align=\"start center\" class=\"buttonStyle hoverColor\" ng-click=\"vm.Nav(\'contact\')\">\n              <div style=\"width: 30px\"></div>\n              <img src=\"/assets/images/icons/gear-contact.png\">\n              <div style=\"width: 25px\"></div>\n              Contact Us\n            </div>\n            <div layout=\"row\" layout-align=\"start center\" class=\"buttonStyle hoverColor\" ng-click=\"vm.Nav(\'support\')\">\n              <div style=\"width: 30px\"></div>\n              <img src=\"/assets/images/icons/gear-support.png\">\n              <div style=\"width: 25px\"></div>\n              Support\n            </div>\n            <div class=\"buttonStyle\"></div>\n            <div layout=\"row\" layout-align=\"start center\" class=\"buttonStyle hoverColor\" ng-click=\"vm.Logout()\">\n              <div style=\"width: 30px\"></div>\n              <img src=\"/assets/images/icons/gear-logout.png\">\n              <div style=\"width: 25px\"></div>\n              Log Out\n            </div>\n          </div>\n        </div>\n        <!--end menu-->\n      </div>\n\n      <div layout=\"row\" layout-align=\"center center\" class=\"icon-div\">\n        <div class=\"infoButton\">\n          <md-button class=\"md-icon-button md-primary\" aria-label=\"Help\" ng-click=\"vm.toggleHelp()\">\n            <md-icon style=\"fill: white\" md-svg-icon=\"assets/images/icons/navicon-help.svg\" ng-hide=\"isHelpMenuOpen()\"></md-icon>\n          </md-button>\n        </div>\n      </div>\n\n      <div layout=\"row\" layout-align=\"center center\" class=\"icon-div\">\n        <!-- empty div for spacing-->\n      </div>\n    </div>\n\n  </div>\n</div>\n");
$templateCache.put("app/components/main-sidenav/ya-main-sidenav.html","<div id=\"sideNav\" layout=\"column\" layout-align=\"start stretch\" class=\"shorten-on-tablet\">\n  <!--Header layout-gt-sm=\"column\" stacks items on mobile-->\n  <div layout=\"row\" layout-md=\"column\" layout-align=\"start center\" class=\"column-top\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\">\n      <img class=\"md-avatar avatar-update\" ng-src=\"{{vm.currentOrgPic}}\">\n    </div>\n\n    <!-- <div flex class=\"padLeft\" style=\"overflow:hidden;\">\n      <md-select ng-if=\"vm.ready\" aria-label=\"select organization\" placeholder=\"{{vm.currentOrg.name}}\" ng-model=\"vm.currentOrg\" ng-change=\"vm.changeOrg()\" class=\"bold\">\n        <md-option ng-repeat=\"org in vm.orgs\" ng-value=\"org\">{{org.name}}</md-option>\n      </md-select>\n      <p style=\"font-size: 12px\" class=\"lighter\">{{vm.currentUser}}</p>\n    </div> -->\n\n    <div style=\"overflow:hidden\">\n      <md-autocomplete md-no-cache=\"true\" md-escape-options=\"none\" md-selected-item=\"vm.currentOrg\" md-search-text=\"vm.searchText\" md-items=\"org in vm.querySearch(vm.searchText)\" md-item-text=\"org.name\" placeholder=\"{{vm.currentOrg.name || \'Select organization\'}}\" md-min-length=\"0\" md-selected-item-change=\"vm.changeOrg()\" class=\"bold custom-autocomplete\">\n      <md-item-template>\n        <span>{{org.name}}</span>\n      </md-item-template>\n      <md-not-found>\n        No organizations found.\n      </md-not-found>\n    </md-autocomplete>\n    \n    <p style=\"font-size: 12px\" class=\"lighter\">{{vm.currentUser}}</p>\n    \n  </div>\n  </div> \n\n  <!--Admin-->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" style=\"min-height: 80px\" ng-click=\"vm.Nav(\'dashboard\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"dashboardinfotext=true\" ng-mouseleave=\"dashboardinfotext=false\">\n      <img class=\"iconSize\" src=\"assets\\images\\icons\\nav-home.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"dashboardinfotext\">Admin Dashboard</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div style=\"font-size: 20px\" class=\"hide-on-tablet buttonText\">Admin Dashboard</div>\n    </div>\n  </div>\n\n  <!--Alert-->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'alert\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"alertinfotext=true\" ng-mouseleave=\"alertinfotext=false\">\n      <img class=\"iconSize\" src=\"/assets/images/icons/nav-alert.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"alertinfotext\">Alerts</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Alerts</div>\n    </div>\n  </div>\n\n  <!--Advertisements-->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'ad\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"Advertisementsinfotext=true\" ng-mouseleave=\"Advertisementsinfotext=false\">\n      <img class=\"iconSize\" src=\"/assets/images/icons/nav-ad.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"Advertisementsinfotext\">Advertisements</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Advertisements</div>\n    </div>\n  </div>\n\n  <!--Announcements-->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'announcement\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"Announceinfotext=true\" ng-mouseleave=\"Announceinfotext=false\">\n      <img class=\"iconSize\" src=\"assets\\images\\icons\\nav-announce.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"Announceinfotext\">Announcements</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Announcements</div>\n    </div>\n  </div>\n\n<!--Appoints-->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" style=\"opacity: .25; cursor:not-allowed\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"Appointmentsinfotext=true\" ng-mouseleave=\"Appointmentsinfotext=false\">\n      <img class=\"iconSize\" src=\"assets\\images\\icons\\nav-appointments.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"Appointmentsinfotext\">Appointments</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Appointments</div>\n    </div>\n  </div>\n\n  <!--spacer-->\n  <div class=\"buttonBorder hide-on-tablet\"></div>\n\n  <!--Dash Users-->\n  <!-- <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'user\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"Usersinfotext=true\" ng-mouseleave=\"Usersinfotext=false\">\n      <img class=\"iconSize\" src=\"assets\\images\\icons\\nav-users.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"Usersinfotext\">Dashboard Users</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Dashboard Users</div>\n    </div>\n  </div>\n  -->\n  <!--Dash Groups-->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'dashboardgroup\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"Usersinfotext=true\" ng-mouseleave=\"Usersinfotext=false\">\n      <img class=\"iconSize\" src=\"assets\\images\\icons\\nav-users.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"Usersinfotext\">Dashboard Groups</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Dashboard Groups</div>\n    </div>\n  </div>\n\n  <!--Categories-->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'category\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"Categoriesinfotext=true\" ng-mouseleave=\"Categoriesinfotext=false\">\n      <img class=\"iconSize\" src=\"assets\\images\\icons\\nav-cat.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"Categoriesinfotext\">Categories</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Categories</div>\n    </div>\n  </div>\n\n  <!--Recipients Groups-->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'group\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"Groupsinfotext=true\" ng-mouseleave=\"Groupsinfotext=false\">\n      <img class=\"iconSize\" src=\"assets\\images\\icons\\nav-group.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"Groupsinfotext\">Recipient Groups</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Recipient Groups</div>\n    </div>\n  </div>\n\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'responsegroups\')\" ng-show=\"vm.currentOrg.responseforms\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"Responseformtext=true\" ng-mouseleave=\"Responseformtext=false\">\n      <img class=\"iconSize\" src=\"assets\\images\\icons\\sign.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"Responseformtext\">Covid Respondents</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Covid Respondents</div>\n    </div>\n  </div>\n\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'emailcampaign\')\" ng-show=\"vm.currentOrg.id == 3\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"Emailinfotext=true\" ng-mouseleave=\"Emailinfotext=false\">\n      <img class=\"iconSize\" src=\"assets\\images\\icons\\sign.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"Emailinfotext\">Email Marketing Campaigns</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Email Marketing Campaigns</div>\n    </div>\n  </div>\n\n  <!--spacer-->\n  <div class=\"buttonBorder hide-on-tablet\"></div>\n\n  <!--Reports-->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'reporting\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"Reportinginfotext=true\" ng-mouseleave=\"Reportinginfotext=false\">\n      <img class=\"iconSize\" src=\"assets\\images\\icons\\nav-reporting.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"Reportinginfotext\">Reporting</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Reporting</div>\n    </div>\n  </div>\n\n  <!--Message Reports-->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'messagereports\')\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"messageReportsInfoText=true\" ng-mouseleave=\"messageReportsInfoText=false\">\n      <img class=\"iconSize\" src=\"assets\\images\\icons\\nav-reporting.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"messageReportsInfoText\">Message Reports</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Message Reports</div>\n    </div>\n  </div>\n\n  <!--Covid Reports-->\n  <div class=\"buttonBorder butthover\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.Nav(\'covidreports\')\" ng-show=\"vm.currentOrg.responseforms\">\n    <div class=\"iconContainer\" layout=\"column\" layout-align=\"center center\" ng-mouseenter=\"covidReportsInfoText=true\" ng-mouseleave=\"covidReportsInfoText=false\">\n      <img class=\"iconSize\" src=\"assets\\images\\icons\\nav-reporting.png\">\n      <div hide-gt-md class=\"onhover-popup\" ng-show=\"messageReportsInfoText\">Covid Reports</div>\n    </div>\n\n    <div class=\"padLeft\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"hide-on-tablet buttonText\">Covid Reports</div>\n    </div>\n  </div>\n\n</div>\n");
$templateCache.put("app/components/message-card/ya-message-card.html","<div id=\"message-card\">\n  <md-card class=\"message_card\" ng-click=\"vm.onSelect()\" ng-mouseenter=\"hover = \'md-whiteframe-z5\'\" ng-mouseleave=\"hover = \'\'\" ng-class=\"hover\" ng-style=\"{\'background-image\': \'url(\' + vm.data.previewurl + \')\'}\">\n\n    <md-card-title ng-class=\"{\'create-title\' : vm.data.status==\'create\', \'transparent-title\' : vm.data.status==\'template\' || vm.data.status==\'ready\' || vm.data.status==\'pending\' || vm.data.status==\'pendingedit\' || vm.data.status==\'sent\' || vm.data.status==\'book\', \'reject-title\' : vm.data.status == \'rejected\'}\">\n      <md-card-title-text layout=\"row\">\n        <div flex=\"25\"></div>\n        <span flex=\"50\" class=\"md-title\">{{vm.data.status}}</span>\n        <div class=\"messageButtCont\">\n          <div class=\"messageButton\" ng-show=\"vm.data.status!=\'create\'&& vm.creatingMessage == false\" style=\"z-index: 99\" ng-click=\"vm.onUpdateMessage($event)\" layout=\"row\" layout-align=\"center center\">\n            MSG\n          </div>\n          <div class=\"messageButton\" ng-show=\"vm.data.status!=\'create\' && vm.creatingMessage == true\" style=\"z-index: 99\" ng-click=\"vm.onUpdateMessage($event)\" layout=\"row\" layout-align=\"center center\">\n            X\n          </div>\n        </div>\n      </md-card-title-text>\n    </md-card-title>\n\n    <div class=\"stats-area\" ng-show=\"vm.state==\'close\' && vm.data.status!=\'create\'\">\n      <ya-card-stats data=\"vm.data\"></ya-card-stats>\n    </div>\n\n    <div ng-show=\"vm.state==\'msg\'\" style=\"height:100%; padding-top: 50px\" layout=\"row\" layout-align=\"center end\">\n      <textarea type=\"text\" style=\"height:100%; width:100%\" ng-model=\"vm.data.message\"></textarea>\n    </div>\n\n    <!--create, template, sent, ready, rejected, pending-->\n    <div ng-show=\"vm.state==\'open\'\" layout-fill>\n\n      <div class=\"card-states\">\n\n        <div class=\"state-create\" ng-show=\"vm.data.status==\'create\'&&!vm.PublicOnly()\" layout=\"column\" layout-align=\"center center\" ng-click=\"vm.onTemplatePicker()\">\n          <div class=\"card-content-area\" layout=\"column\" layout-align=\"center center\">\n            <div class=\"circle-text\">{{vm.data.name}} </div>\n          </div>\n        </div>\n\n        <div class=\"state-template\" ng-show=\"vm.PublicOnly()\">\n          <div class=\"darken-bg\"></div>\n          <div class=\"card-content-area\" layout=\"column\" layout-align=\"space-around center\">\n            <md-button aria-label=\"duplicate\" ng-click=\"vm.onClone()\">CREATE</md-button>\n          </div>\n        </div>\n\n        <div class=\"state-template\" ng-show=\"vm.data.status==\'template\'&&!vm.PublicOnly()\">\n          <div class=\"darken-bg\"></div>\n          <div class=\"card-content-area\" layout=\"column\" layout-align=\"space-around center\">\n            <md-button aria-label=\"duplicate\" ng-click=\"vm.onClone()\">DUPLICATE</md-button>\n            <md-button aria-label=\"edit template\" ng-click=\"vm.onEdit()\">EDIT TEMPLATE</md-button>\n            <md-button aria-label=\"delete\" class=\"delete-btn\" ng-click=\"vm.onDelete()\">DELETE</md-button>\n          </div>\n        </div>\n\n        <div class=\"state-sent\" ng-show=\"vm.data.status==\'sent\'&&!vm.PublicOnly()\">\n          <div class=\"darken-bg\"></div>\n          <div class=\"card-content-area\" layout=\"column\" layout-align=\"space-around center\">\n            <md-button aria-label=\"duplicate\" ng-click=\"vm.onClone()\">DUPLICATE</md-button>\n            <md-button aria-label=\"edit\" ng-click=\"vm.onEdit()\">EDIT</md-button>\n            <md-button aria-label=\"schedule\" ng-click=\"vm.onSchedule()\" ng-show=\"vm.loc.indexOf(\'announcement\') > -1\">\n              SCHEDULE\n            </md-button>\n            <md-button class=\"delete-btn\" ng-click=\"vm.onDelete()\">DELETE</md-button>\n          </div>\n        </div>\n \n        <div class=\"state-ready\" ng-show=\"vm.data.status==\'ready\'&&!vm.PublicOnly()\">\n          <div class=\"darken-bg\"></div>\n          <div class=\"card-content-area\" layout=\"column\" layout-align=\"space-around center\">\n            <md-button aria-label=\"send\" ng-click=\"vm.onSend()\">SEND</md-button>\n            <md-button aria-label=\"copy message\" ng-click=\"vm.onClone()\">COPY MESSAGE</md-button>\n            <md-button aria-label=\"edit message\" ng-click=\"vm.onEdit()\">EDIT MESSAGE</md-button>\n            <md-button aria-label=\"delete\" class=\"delete-btn\" ng-click=\"vm.onDelete()\">DELETE</md-button>\n          </div>\n        </div>\n\n        <div class=\"state-ready\" ng-show=\"vm.data.status==\'book\'&&!vm.PublicOnly()\">\n          <div class=\"darken-bg\"></div>\n          <div class=\"card-content-area\" layout=\"column\" layout-align=\"space-around center\">\n            <md-button aria-label=\"copy message\" ng-click=\"vm.onClone()\">COPY BOOK</md-button>\n            <md-button aria-label=\"edit message\" ng-click=\"vm.onEdit()\">EDIT BOOK</md-button>\n            <md-button aria-label=\"delete\" class=\"delete-btn\" ng-click=\"vm.onDelete()\">DELETE</md-button>\n          </div>\n        </div>\n\n        <div class=\"state-rejected\" ng-show=\"vm.data.status==\'rejected\'&&!vm.PublicOnly()\">\n          <div class=\"darken-bg\"></div>\n          <div class=\"card-content-area\" layout=\"column\" layout-align=\"space-around center\">\n            <md-button aria-label=\"copy message\" ng-click=\"vm.onClone()\">COPY MESSAGE</md-button>\n            <md-button aria-label=\"edit message\" ng-click=\"vm.onEdit()\">EDIT MESSAGE</md-button>\n            <md-button aria-label=\"delete\" class=\"delete-btn\" ng-click=\"vm.onDelete()\">DELETE</md-button>\n          </div>\n        </div>\n\n        <div class=\"state-pending\" ng-show=\"(vm.data.status==\'pending\'||vm.data.status==\'pendingedit\') && !vm.PublicOnly()\">\n          <div class=\"darken-bg\"></div>\n          <div class=\"card-content-area\" layout=\"column\" layout-align=\"space-around center\" style=\"height: 100%\" ng-show=\"vm.atApproval\">\n            <md-button aria-label=\"send/approve\" ng-click=\"vm.onApprove()\">SEND/APPROVE</md-button>\n            <md-button aria-label=\"edit\" ng-click=\"vm.onAdminEdit()\">EDIT</md-button>\n            <md-button aria-label=\"reject\" ng-click=\"vm.onReject()\">REJECT</md-button>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </md-card>\n\n  <div class=\"under-card\" ng-hide=\"vm.data.status==\'create\'\" layout=\"column\" layout-align=\"start center\">\n    <div class=\"under-title\">\n      {{vm.data.name}}<br>\n    </div>\n    <div class=\"under-type\" ng-show=\"(vm.data.status==\'pending\'||vm.data.status==\'pendingedit\')&&!vm.PublicOnly()\">\n      {{vm.data.type}}\n    </div>\n\n    <div ng-show=\"vm.isSuper()\" layout=\"row\">\n      <md-checkbox style=\"padding-top:16px;margin-top: 9px\" aria-label=\"publish\" class=\"\" type=\"checkbox\" ng-model=\"vm.publish\" ng-change=\"vm.Publish()\">Publish</md-checkbox>\n      <md-input-container flex>\n        <label>Industry Type</label>\n        <md-select style=\"margin-left:5px\" aria-label=\"industry type\" ng-model=\"vm.industrytype\" ng-change=\"vm.Publish()\">\n          <md-option ng-repeat=\"type in vm.types track by $index\" ng-value=\"type\">{{type}}</md-option>\n        </md-select>\n      </md-input-container>\n    </div>\n  </div>\n\n</div>\n");
$templateCache.put("app/components/message-pending-card/ya-message-pending-card.html","<div id=\"pending-card\">\n	<md-card class=\"message_card\" ng-click=\"vm.onSelect()\" ng-mouseenter=\"hover = \'md-whiteframe-z5\'\" ng-mouseleave=\"hover = \'\'\" ng-class=\"hover\" ng-style=\"{\'background-image\': \'url(\' + vm.data.imageurl + \')\'}\">\n\n		<md-card-title class=\"transparent-title\">\n			<md-card-title-text>\n				<span class=\"md-title\">{{vm.data.status}}</span>	\n			</md-card-title-text>\n		</md-card-title>\n		<div class=\"stats-area\" ng-show=\"vm.state==\'close\'\">			\n		</div>\n		<div ng-show=\"vm.state==\'open\'\" layout-fill>\n			<div class=\"card-states\">				\n				<div class=\"state-sent\">\n					<div class=\"darken-bg\"></div>\n					<div class=\"card-content-area\" layout=\"column\" layout-align=\"space-around center\">\n						<md-button class=\"btn\" ng-click=\"vm.onEdit()\">Edit</md-button>\n						<md-button class=\"delete-btn\" ng-click=\"vm.onDelete()\">Delete</md-button>\n					</div>\n				</div>\n			</div>\n		</div>\n	</md-card>\n\n	<div class=\"under-card\">\n		<h3>{{vm.data.name}}</h3>		\n	</div>\n</div>");
$templateCache.put("app/components/msg-calculate/ya-msg-calculate.html","<!-- <script src=\'//maps.googleapis.com/maps/api/js?sensor=false&libraries=places&callback=initAutocomplete\'></script> -->\n<div id=\"msg_calculate\" layout=\"column\">\n  <div style=\"height: 20px; font-size: 16px; color: grey\">\n    Optional: Filter Location for ALL Scheduled Messages\n  </div>\n  <div class=\"title-subtext\">Location filter will calculate all mobile users active within the past 10 days, in the radius surrounding the defined address.</div>\n  <md-checkbox type=\"checkbox\" ng-model=\"vm.filterOnGeography\">Filter Recipients by Location</md-checkbox>\n\n  <div layout=\"column\" style=\"width: 100%; background-color: white\">\n    <div id=\"geography-filter-container\">\n      <div id=\"hide-filter\" ng-show=\"!vm.filterOnGeography\"></div>\n      <div id=\"mapid\" style=\"border: 1px solid lightgrey\" layout=\"row\">\n        <md-input-container layout=\"row\" layout-align=\"center center\" flex style=\"border: 0px; background-color: white; height: 100%; width: 100%\">\n          <input id=\"autocomplete\" type=\"text\" ng-model=\"vm.autoText\">\n        </md-input-container>\n        <div style=\"font-size: 22px; font-weight: 300; background-color: white;padding-right: 10px; color: grey\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.ClearLocation()\">\n            X\n        </div>\n      </div>\n      <ui-gmap-google-map center=\"vm.mapSettings.center\" zoom=\"vm.mapSettings.zoom\" id=\"map\" flex></ui-gmap-google-map>\n      <md-slider-container style=\"width: 100%; padding: 15px\">\n        <label>filter radius</label>\n        <md-slider flex min=\"1\" max=\"200\" ng-model=\"vm.radius\" aria-label=\"radius\" ng-change=\"vm.updateRadius()\" ng-model-options=\"{ debounce: 300 }\"></md-slider>\n        <div>Mi</div>\n        <md-input-container>\n          <input flex type=\"number\" min=\"1\" max=\"100\" ng-model=\"vm.radius\" aria-label=\"radius\" ng-change=\"vm.updateRadius()\" ng-model-options=\"{ debounce: 300 }\">\n        </md-input-container>\n      </md-slider-container>\n      <div style=\"width: 100%; height: 30px\"></div>\n    </div>\n\n    <div layout=\"row\">\n      <div layout=\"column\" layout-align=\"center left\" style=\"width: 80%\" class=\"info-text\">\n        <div class=\"info-header\">\n          Number Of Recipients\n        </div>\n        <div class=\"info-body\">\n          Total \"Number of Recipients\" is equal to the total number of individuals selected in your private group PLUS the total number of individuals selected in your public group.\n        </div>\n      </div>\n      <div layout=\"column\" layout-align=\"center right\" flex>\n        <div class=\"total-users\">\n          {{vm.users}}\n        </div>\n      </div>\n    </div>\n  </div>\n  <div style=\"width: 100%; height: 5%\"></div>\n	<div style=\"color: #005f97; font-size: 22px; font-weight: 500\" layout=\"row\">\n		<div style=\"min-width: 120px\">Total Cost</div>\n		<div style=\"width: 60%\"></div>\n		<div>${{vm.totalCost}}</div>\n	</div>\n  <div style=\"width: 100%; height: 5%\"></div>\n	<md-checkbox aria-label=\"agree to this order\" class=\"yellow\" ng-model=\"vm.approval\" ng-change=\"vm.updateAproval()\">\n    I agree to this order & please use my credit card listed in PROFILE\n  </md-checkbox>\n\n</div>\n");
$templateCache.put("app/components/msg-carousel/ya-msg-carousel.html","<md-content id=\"msg_carousel\" layout=\"row\" layout-align=\"space-between stretch\">\n\n    <div layout=\"column\" layout-align=\"center center\">\n      <button flex=\"auto\" class=\"buttons\" ng-show=\"vmp.showLeft\" ng-click=\"vmp.prev()\">\n        <img class=\"arrow\" src=\"assets\\images\\icons\\message-prev.png\">\n      </button>\n    </div>\n\n    <div class=\"carousel-flexdiv\" flex=\"100\">\n      <uib-carousel id=\"TestCarousel_{{vmp.name}}\" class=\"carousel-container\" interval=\"0\" active=\"0\" style=\"height:100%; width:100%\">\n        <uib-slide ng-repeat=\"chunk in vmp.chunkList track by $index\" style=\"height:100%; width:100%\">\n          <div ng-if=\"vmp.Test($index)\">\n\n            <div layout=\"row\">\n              <div ng-repeat=\"data in vmp.data | limitTo:4:chunk.start\">\n                <ya-message-card ng-if=\"!vmp.select\" data=\"data\" parent=\"vmp.parent\"></ya-message-card>\n                <ya-select-card ng-if=\"vmp.select\" data=\"data\" parent=\"vmp.parent\"></ya-select-card>\n              </div>\n            </div>\n            <div layout=\"row\">\n              <div ng-repeat=\"data in vmp.data | limitTo:4:chunk.start + 4\">\n                <ya-message-card ng-if=\"!vmp.select\" data=\"data\" parent=\"vmp.parent\"></ya-message-card>\n                <ya-select-card ng-if=\"vmp.select\" data=\"data\" parent=\"vmp.parent\"></ya-select-card>\n              </div>\n            </div>\n\n          </div>\n        </uib-slide>\n      </uib-carousel>\n    </div>\n\n    <div layout=\"column\" layout-align=\"center center\">\n      <button flex=\"auto\" class=\"buttons\" ng-show=\"vmp.showRight\" ng-click=\"vmp.next()\">\n        <img class=\"arrow\" src=\"assets\\images\\icons\\message-next.png\">\n      </button>\n    </div>\n\n</md-content>\n");
$templateCache.put("app/components/msg-create-new/ya-msg-create-new.html","<div id=\"msg_create_new\" layout=\"column\" class=\"msg-container\" layout-align=\"start center\">\n\n  <div layout=\"row\" class=\"toptext card_width\" layout-align=\"start center\">\n    + Create New\n  </div>\n  \n  <!--Select Template-->\n  <button flex=\"nogrow\" layout=\"column\" class=\"cardSafari card_width card_height lowerCard\" ng-click=\"vmp.onTemplate()\">\n    <div layout=\"row\" layout-align=\"start center\">\n      <img class=\"msg-image\" src=\"assets\\images\\icons\\message-templates.png\">\n      <div class=\"msg-top-image-spacing\"></div>\n      <img class=\"msg-image\" src=\"assets\\images\\icons\\message-photo.png\">\n    </div>\n    \n    <div class=\"msg-image-spacing\"></div>\n    <div style=\"text-align:left; color: white; font-size: 15px; font-weight: 300\">\n      I WANT TO\n    </div>\n    <div class=\"msg-left-cards-text\">\n      SELECT A TEMPLATE\n    </div>\n    <div class=\"msg-image-spacing\"></div>\n    <div class=\"smallText\">\n      I want to create a new composition from an existing template. Take me to the templates.\n    </div>\n	</button>\n\n  <div class=\"buffer\"></div>\n\n  <!--Create new Alert-->\n  <button flex=\"nogrow\" layout=\"column\" class=\"cardSafari card_width card_height upperCard\" ng-click=\"vmp.onNew()\">\n    <div layout=\"row\" layout-align=\"start center\">\n      <img class=\"msg-image\" src=\"assets\\images\\icons\\message-brush.png\">\n      <div class=\"msg-top-image-spacing\"></div>\n      <img class=\"msg-image\" src=\"assets\\images\\icons\\message-photo.png\">    \n    </div>\n    <div class=\"msg-image-spacing\"></div>\n    <div style=\"text-align:left; color: white; font-size: 15px; font-weight: 300\">\n      I WANT TO\n    </div>\n    <div class=\"msg-left-cards-text\">\n      CREATE A NEW {{vmp.type}}\n    </div>\n    <div class=\"msg-image-spacing\"></div>\n    <div class=\"smallText\">\n      I want to create a brand new composition from scratch. Take me to the {{vmp.type}} editor.\n    </div>\n	</button>\n\n</div>\n");
$templateCache.put("app/components/msg-create-template/ya-msg-create-template.html","<div id=\"msg_create_template\" layout=\"column\" class=\"msg-container\" layout-align=\"start center\">\n\n  <div layout=\"row\" class=\"toptext card_width\" layout-align=\"start center\">\n    + Create New\n  </div>\n\n  <!--Create new Alert-->\n  <button flex=\"nogrow\" layout=\"column\" class=\"cardSafari card_width card_height upperCard\" ng-click=\"vmp.onCreate()\">\n    <div layout=\"row\" layout-align=\"start center\">\n      <img class=\"msg-image\" src=\"assets\\images\\icons\\message-brush.png\">\n      <div class=\"msg-top-image-spacing\"></div>\n      <img class=\"msg-image\" src=\"assets\\images\\icons\\message-photo.png\">    \n    </div>\n    <div class=\"msg-image-spacing\"></div>\n    <div style=\"text-align:left; color: white; font-size: 15px; font-weight: 300\">\n      I WANT TO\n    </div>\n    <div class=\"msg-left-cards-text\">\n      CREATE A NEW {{vmp.type}}\n    </div>\n    <div class=\"msg-image-spacing\"></div>\n    <div class=\"smallText\">\n      I want to create a brand new composition from scratch. Take me to the {{vmp.type}} editor.\n    </div>\n	</button>\n\n</div>\n");
$templateCache.put("app/components/msg-preview/ya-msg-preview.html","<div layout=\"column\" id=\"msg_preview\">\n  <div class=\"previewBackground\" layout=\"column\">\n    <div style=\"height: 125px; width: 100%\"></div>\n    <div layout=\"row\">\n      <div style=\"height: 100%; width: 82px\"></div>\n      <img id=\"preview\" src=\"\" alt=\"Image Preview\" class=\"preview\">\n    </div>\n  </div>\n  <div layout=\"row\" layout-align=\"center center\" style=\"width: 350px\">\n    <md-button style=\"min-width: 211px; background-color: #456dbc; font-size: 11px\" class=\"buttonbase\" ng-click=\"vmp.Update()\">\n      Update Thumbnail\n    </md-button>\n  </div>\n  <div ng-show=\"vmp.type!=\'none\' && vmp.type!=\'alertedit\' && vmp.type!=\'announcedit\'\" flex>\n    <div layout=\"column\" layout-align=\"center center\">\n      <div class=\"tile\">\n        Who is going to see this?\n      </div>\n      <div class=\"redText\">\n        *Please select at least one...*\n      </div>\n      <div class=\"titleSpace\"></div>\n\n      <div id=\"checkboxes\" class=\"contentSize\" flex>\n        <div>\n          <div>\n            <p>Recipient Groups</p>\n            <div>\n              <md-checkbox class=\"blue italics\" type=\"checkbox\" ng-model=\"vmp.selectAllGroups\" ng-click=\"vmp.toggleGroups(vmp.selectAllGroups)\">\n                Select ALL\n              </md-checkbox>\n            </div>\n            <!-- <div ng-show=\"vmp.isEmergencyCenterAvailable\">\n              <md-checkbox class=\"blue danger italics\" type=\"checkbox\" ng-model=\"vmp.isEmergency\">\n                Emergency 911 Dispatch \n              </md-checkbox>\n            </div> -->\n            <div ng-repeat=\"c in vmp.groupList track by $index\">\n              <md-checkbox aria-label=\"select category\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.selectedGroups[$index]\">\n                {{c.name}}\n              </md-checkbox>\n            </div>\n\n            <p>Public</p>\n            <div layout=\"row\" style=\"width: 100%\" ng-show=\"vmp.type==\'alertedit\'\">\n              <div style=\"padding-right: 30px\">\n                <md-checkbox class=\"blue italics\" type=\"checkbox\" ng-model=\"vmp.followers\">\n                  Followers\n                </md-checkbox>\n              </div>\n              <md-input-container flex>\n                <md-select style=\"max-width: 150px; height: 30px; padding-left: 10%; background-color: white; font-weight: 300; font-size: 11px\" aria-label=\"select delay\" ng-model=\"vmp.delay\">\n                  <md-option value=\"0\">Delay 0 min</md-option>\n                    <md-option value=\"5\">Delay 5 min</md-option>\n                    <md-option value=\"10\">Delay 10 min</md-option>\n                    <md-option value=\"30\">Delay 30 min</md-option>\n                    <md-option value=\"60\">Delay 60 min</md-option>\n                </md-select>\n              </md-input-container>\n              <div style=\"width: 25px\"></div>\n            </div>\n            <div style=\"width: 100%\" ng-show=\"vmp.type!=\'alertedit\'\">\n              <div>\n                <md-checkbox class=\"blue italics\" type=\"checkbox\" ng-model=\"vmp.selectAllCats\" ng-click=\"vmp.toggleCats(vmp.selectAllCats)\">\n                  Select ALL\n                </md-checkbox>\n              </div>\n              <div ng-repeat=\"c in vmp.catList track by $index\">\n                <md-checkbox aria-label=\"select group\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.selectedCats[$index]\">\n                  {{c.name}}\n                </md-checkbox>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"titleSpace\"></div>\n    <div layout=\"column\" ng-show=\"vmp.type==\'alertedit\' && false\">\n      <div layout=\"row\">\n        <div flex></div>\n        <md-button style=\"min-width: 130px; background-color: #4a4a4a; font-size: 11px\" class=\"buttonbase\" ng-click=\"vmp.Done()\">\n          Save Changes\n        </md-button>\n        <div flex></div>\n        <md-button style=\"min-width: 130px; background-color: #0a4f77; font-size: 11px\" class=\"buttonbase\" ng-click=\"vmp.AlertSend()\">\n          Send\n        </md-button>\n        <div flex></div>\n      </div>\n    </div>\n    <div layout=\"row\" ng-show=\"vmp.type==\'announcedit\'\">\n      <div flex></div>\n      <md-button style=\"min-width: 130px; background-color: #4a4a4a; font-size: 11px\" class=\"buttonbase\" ng-click=\"vmp.Done()\">\n        Save Changes\n      </md-button>\n      <div flex></div>\n      <md-button style=\"min-width: 130px; background-color: #0a4f77; font-size: 11px\" class=\"buttonbase\" ng-click=\"vmp.Schedule()\">\n        Schedule\n      </md-button>\n      <div flex></div>\n    </div>\n    <div layout=\"row\" ng-show=\"vmp.type==\'announcschedule\'\">\n      <div flex></div>\n      <md-button style=\"min-width: 130px; background-color: #4a4a4a; font-size: 11px\" class=\"buttonbase\" ng-click=\"vmp.Done()\">\n        Save Changes\n      </md-button>\n      <div flex></div>\n      <md-button style=\"min-width: 130px; background-color: #0a4f77; font-size: 11px\" class=\"buttonbase\" ng-if=\"!vm.isSchool\" ng-click=\"vmp.Calculate()\">\n        Calculate\n      </md-button>\n      <div flex></div>\n        <md-button style=\"min-width: 130px; background-color: #0a4f77; font-size: 11px\" class=\"buttonbase\" ng-if=\"vm.isSchool\" ng-click=\"vmp.Send()\">Send</md-button>\n      <div flex></div>\n    </div>\n    <div layout=\"row\" ng-show=\"vmp.type==\'announccalc\'\">\n      <div flex></div>\n      <md-button style=\"min-width: 130px; background-color: #0a4f77; font-size: 11px\" class=\"buttonbase\" ng-click=\"vmp.Send()\">Send</md-button>\n      <div flex></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/msg-recipients/ya-msg-recipients.html","<div id=\"msg_recipients\">\n  <div ng-show=\"vmp.type!=\'none\'\" flex>\n    <div layout=\"row\" layout-align=\"start\">\n      <div style=\"width: 40px\"></div>\n      <div layout=\"column\" class=\"layout-margin\" flex=\"25\">\n        <div class=\"tile\">\n          Who is going to see this?\n        </div>\n        <div class=\"redText\">\n          *Please select at least one...*\n        </div>\n        <div flex>\n          <p>Recipient Groups</p>\n          <div>\n            <md-checkbox class=\"blue italics\" type=\"checkbox\" ng-model=\"vmp.selectAllGroups\" ng-click=\"vmp.toggleGroups(vmp.selectAllGroups)\">\n              Select ALL\n            </md-checkbox>\n          </div>\n          <div ng-repeat=\"c in vmp.groupList track by $index\">\n            <md-checkbox aria-label=\"select category\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.selectedGroups[$index]\">\n              {{c.name}}\n            </md-checkbox>\n          </div>\n\n          <p>Public</p>\n          <div layout=\"column\" ng-show=\"vmp.type==\'alertedit\'\">\n            <div style=\"padding-right: 30px\">\n              <md-checkbox class=\"blue italics\" type=\"checkbox\" ng-model=\"vmp.selectAllCats\" ng-click=\"vmp.toggleCats(vmp.selectAllCats)\">\n                Followers\n              </md-checkbox>\n            </div>\n            <md-input-container flex>\n              <md-select style=\"max-width: 150px; height: 30px; margin-left: 30px; background-color: white; font-weight: 300; font-size: 11px\" aria-label=\"select delay\" ng-model=\"vmp.delay\">\n                <md-option value=\"0\">Delay 0 min</md-option>\n                <md-option value=\"5\">Delay 5 min</md-option>\n                <md-option value=\"10\">Delay 10 min</md-option>\n                <md-option value=\"30\">Delay 30 min</md-option>\n                <md-option value=\"60\">Delay 60 min</md-option>\n              </md-select>\n            </md-input-container>\n            <div style=\"width: 25px\"></div>\n          </div>\n          <div style=\"width: 100%\" ng-show=\"vmp.type!=\'alertedit\'\">\n            <div>\n              <md-checkbox class=\"blue italics\" type=\"checkbox\" ng-model=\"vmp.selectAllCats\" ng-click=\"vmp.toggleCats(vmp.selectAllCats)\">\n                Select ALL\n              </md-checkbox>\n            </div>\n            <div ng-repeat=\"c in vmp.catList track by $index\">\n              <md-checkbox aria-label=\"select group\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.selectedCats[$index]\">\n                {{c.name}}\n              </md-checkbox>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div layout=\"column\" class=\"layout-margin\" flex=\"25\" ng-show=\"vmp.type==\'alertedit\'\">\n        <div class=\"tile\">\n          Who is going to send this?\n        </div>\n        <div class=\"redText\">\n          *Please select at least one...*\n        </div>\n        <div flex>\n          <p>Dashboard Groups</p>\n          <!-- <div>\n            <md-checkbox class=\"blue italics\" type=\"checkbox\" ng-model=\"vmp.selectAllGroups\" ng-click=\"vmp.toggleGroups(vmp.selectAllGroups)\">\n              Select ALL\n            </md-checkbox>\n          </div> -->\n          <div ng-repeat=\"c in vmp.dashboardGroups track by $index\">\n            <md-checkbox aria-label=\"select dashboard group\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.selectedDashboardGroups[c.id]\">\n              {{c.name}}\n            </md-checkbox>\n          </div>\n        </div>\n      </div>\n      <!-- <div layout=\"column\" class=\"layout-margin\" flex=\"25\" ng-show=\"vmp.type==\'alertedit\'\">\n        <div class=\"tile\">\n          Who will receive Assist?\n        </div>\n        <div class=\"redText\">\n          *Please select at least one...*\n        </div>\n        <div flex>\n          <p>Recipient Groups</p>\n          <div>\n            <md-checkbox class=\"blue italics\" type=\"checkbox\" ng-model=\"vmp.selectAllAssist\"\n              ng-click=\"vmp.toggleAssist(vmp.selectAllAssist)\">\n              Select ALL\n            </md-checkbox>\n          </div>\n          <div ng-repeat=\"c in vmp.groupList track by $index\">\n            <md-checkbox aria-label=\"select category\" class=\"blue blueFont\" type=\"checkbox\"\n              ng-model=\"vmp.selectedAssist[$index]\">\n              {{c.name}}\n            </md-checkbox>\n          </div>\n        </div>\n\n\n      </div> -->\n      <div layout=\"column\" class=\"layout-margin\" flex=\"25\" ng-show=\"vmp.type==\'alertedit\'\">\n        <div class=\"tile\">\n          Choose Next Template\n        </div>\n\n        <div>\n          <md-select aria-label=\"Choose child alert template\" ng-model=\"vmp.nexttemplateid\">\n            <md-option value=\"\" selected=\"selected\">Select a template</md-option>\n            <md-option ng-repeat=\"x in vmp.alertTemplateList\" ng-value=\"x.id\">\n              {{x.name}}\n            </md-option>\n          </md-select>\n        </div>\n        <div>\n          <md-checkbox aria-label=\"Next template goes to sender\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.nexttemplateSender\">\n            Next template goes to sender\n          </md-checkbox>\n        </div>\n        <div>\n          <md-checkbox aria-label=\"Send from Message Report\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.sendfrommessagereport\">\n            Send from Message Report\n          </md-checkbox>\n        </div>\n        <div>\n          <md-checkbox aria-label=\"Text Alert\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.textalert\">\n            Text Alert\n          </md-checkbox>\n        </div>\n        <div>\n          <md-checkbox aria-label=\"Email Alert\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.emailalert\">\n            Email Alert\n          </md-checkbox>\n        </div>\n        <div>\n          <md-checkbox aria-label=\"Text Alert\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.shriactivation\">\n            Siri/Google Activation\n          </md-checkbox>\n        </div>\n      </div>\n      <div layout=\"column\" class=\"layout-margin\" flex=\"25\" ng-show=\"vmp.type==\'alertedit\' && vmp.isAccessControlEnabled && vmp.IdenticardBuildings && vmp.IdenticardBuildings.length\">\n        <div class=\"tile\">\n          Access Control\n        </div>\n        <div flex>\n          <div layout=\"column\" ng-show=\"vmp.type==\'alertedit\'\">\n            <div>\n              <md-checkbox aria-label=\"Enable Identicard\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.isidenticard\">\n                Enable Identicard\n              </md-checkbox>\n            </div>\n            <div ng-if=\"vmp.isidenticard\">\n              <p>Building</p>\n              <div ng-repeat=\"identicardBuilding in vmp.IdenticardBuildings track by $index\">\n                <md-checkbox aria-label=\"Identicard Building\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.identicardbuildings[\'building_\' + identicardBuilding.BuildingId]\">\n                  {{identicardBuilding.Name}} ({{vmp.IdenticardStatus(identicardBuilding.CurrentMode)}})\n                </md-checkbox>\n              </div>\n\n              <md-input-container flex>\n                <md-select style=\"max-width: 150px; height: 30px; margin-left: 30px; background-color: white; font-weight: 300; font-size: 11px\" aria-label=\"select buiding status\" ng-model=\"vmp.identicardbuildingstatus\">\n                  <md-option value=\"\">Set Status</md-option>\n                  <md-option ng-repeat=\"statusCode in vmp.IdenticardStatusCodes track by $index\" value=\"{{statusCode}}\">{{statusCode}}</md-option>\n                </md-select>\n              </md-input-container>\n            </div>\n            <div style=\"width: 25px\"></div>\n          </div>\n        </div>\n      </div>\n      <div layout=\"column\" class=\"layout-margin\" flex=\"25\">\n        <div ng-show=\"vmp.type==\'alertedit\' && vmp.isExcelReportingEnabled\">\n          <div class=\"tile\">\n            Report Responses\n          </div>\n          <div flex>\n            <p>Response Template</p>\n            <md-select aria-label=\"Alert Type\" ng-model=\"vmp.responsetemplateid\">\n              <md-option ng-value=\"template.id\" ng-repeat=\"template in vmp.responseTemplates\">\n                {{template.name}}\n              </md-option>\n            </md-select>\n          </div>\n        </div>\n        <div ng-show=\"vmp.type==\'alertedit\' && vmp.isRemoteMonitoringEnabled\">\n          <div class=\"tile\">\n            Remote Monitoring\n          </div>\n          <div flex>\n            <div layout=\"column\" ng-show=\"vmp.type==\'alertedit\'\">\n              <div>\n                <md-checkbox aria-label=\"Enable Remote Monitoring Sending\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.isdmp\">\n                  Enable Remote Monitoring Sending\n                </md-checkbox>\n              </div>\n              <div>\n                <md-checkbox aria-label=\"Enable Remote Monitoring Receiving\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.isdmpreceive\">\n                  Enable Remote Monitoring Receiving\n                </md-checkbox>\n              </div>\n              <div ng-if=\"vmp.isdmp || vmp.isdmpreceive\">\n                <p>Alert Type</p>\n                <md-select aria-label=\"Alert Type\" ng-model=\"vmp.dmpalerttype\">\n                  <md-option ng-value=\"dmpalerttype.code\" ng-repeat=\"dmpalerttype in vmp.dmpalerttypes\">\n                    {{dmpalerttype.code}} - {{dmpalerttype.label}}\n                  </md-option>\n                </md-select>\n                <p>Zone</p>\n                <md-select aria-label=\"Zone\" ng-model=\"vmp.dmpzonecode\">\n                  <!-- <md-option  ng-if=\"!dmpzone.templateid || dmpzone.templateid === vmp.templateid\"  ng-value=\"dmpzone.code\" ng-repeat=\"dmpzone in vmp.dmpzones\">{{dmpzone.code}}</md-option> -->\n                  <!-- <md-option  ng-if=\"dmpzone.templateid\" ng-value=\"dmpzone.code\" ng-repeat=\"dmpzone in vmp.dmpzones\">\n                    {{dmpzone.code}} - {{dmpzone.templatename}} ({{dmpzone.alerttype || \'Za\'}})\n                  </md-option>\n                  <md-option  ng-if=\"!dmpzone.templateid\"  ng-value=\"dmpzone.code\" ng-repeat=\"dmpzone in vmp.dmpzones\">\n                    {{dmpzone.code}}\n                  </md-option> -->\n\n                  <md-option ng-value=\"dmpzone.code\" ng-repeat=\"dmpzone in vmp.dmpzones\">\n                    <ng-template ng-if=\"dmpzone.templateid\">\n                      {{dmpzone.code}} - {{dmpzone.templatename}} ({{dmpzone.alerttype || \'Za\'}})\n                    </ng-template>\n                    <ng-template ng-if=\"!dmpzone.templateid\">\n                      {{dmpzone.code}}\n                    </ng-template>\n                  </md-option>\n                </md-select>\n                <p>Alert Code</p>\n                <md-select aria-label=\"Alert Code\" ng-model=\"vmp.dmpalertcode\">\n                  <md-option ng-value=\"dmpalert.code\" ng-repeat=\"dmpalert in vmp.dmpalerts\">{{dmpalert.code}} -\n                    {{dmpalert.label}}</md-option>\n                </md-select>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div ng-show=\"vmp.type==\'alertedit\' && vmp.isRRMSEnabled\">\n          <div class=\"tile\">\n            RRMS Messaging\n          </div>\n          <div flex>\n            <div layout=\"column\" ng-show=\"vmp.type==\'alertedit\'\">\n              <div>\n                <md-checkbox aria-label=\"Enable Remote Monitoring Sending\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.isrrms\">\n                  Enable RRMS\n                </md-checkbox>\n              </div>\n              <div ng-if=\"vmp.isrrms\">\n                <p>Alert Type</p>\n                <md-select aria-label=\"Alert Type\" ng-model=\"vmp.rrmsalerttype\">\n                  <md-option ng-value=\"rrmsalerttype.signalCode\" ng-repeat=\"rrmsalerttype in vmp.rrmsalerttypes\">\n                    {{rrmsalerttype.description}}\n                  </md-option>\n                </md-select>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div ng-show=\"vmp.type==\'alertedit\' && vmp.enablequickresponse\">\n          <div class=\"tile\">\n            Quick Response\n          </div>\n          <div flex>\n            <div layout=\"column\" ng-show=\"vmp.type==\'alertedit\'\">\n              <div>\n                <md-checkbox aria-label=\"Enable Quick Response\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.isenablequickresponse\">\n                  Enable Quick Response\n                </md-checkbox>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div ng-show=\"vmp.type==\'alertedit\' && vmp.enablebrightpattern\">\n          <div class=\"tile\">\n            Bright Pattern\n          </div>\n          <div flex>\n            <div layout=\"column\" ng-show=\"vmp.type==\'alertedit\'\">\n              <div>\n                <md-checkbox aria-label=\"Enable Bright Patter\" class=\"blue blueFont\" type=\"checkbox\" ng-model=\"vmp.isenablebrightpattern\">\n                  Enable Bright Pattern\n                </md-checkbox>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div layout=\"column\" class=\"layout-margin\" flex=\"25\" ng-show=\"vmp.isEmergencyCenterAvailable\">\n        <div class=\"tile\">\n          Emergency 911 Dispatch\n        </div>\n        <div flex>\n          <md-checkbox class=\"blue danger uppercase\" type=\"checkbox\" ng-model=\"vmp.isEmergency\">\n            Send Alert to Emergency 911 Dispatch\n          </md-checkbox>\n        </div>\n      </div>\n      <div flex></div>\n      <div style=\"width: 40px\"></div>\n      <div class=\"buttons layout-margin\">\n        <div layout=\"column\" ng-show=\"vmp.type==\'alertedit\'\" layout-align=\"space-between center\">\n          <md-button class=\"buttonbase alternate-action\" ng-click=\"vmp.Done()\">\n            Save Changes\n          </md-button>\n          <md-button class=\"buttonbase primary-action\" ng-click=\"vmp.AlertSend()\">\n            Send\n          </md-button>\n        </div>\n        <div layout=\"column\" ng-show=\"vmp.type==\'announcedit\'\" layout-align=\"space-between center\">\n          <md-button class=\"buttonbase alternate-action\" ng-click=\"vmp.Done()\">\n            Save Changes\n          </md-button>\n          <md-button class=\"buttonbase primary-action\" ng-click=\"vmp.Schedule()\">\n            Schedule\n          </md-button>\n        </div>\n        <div layout=\"column\" ng-show=\"vmp.type==\'announcschedule\'\" layout-align=\"space-between center\">\n          <md-button class=\"buttonbase alternate-action\" ng-click=\"vmp.Done()\">\n            Save Changes\n          </md-button>\n          <md-button class=\"buttonbase primary-action\" ng-if=\"!vm.isSchool\" ng-click=\"vmp.Calculate()\">\n            Calculate\n          </md-button>\n          <md-button class=\"buttonbase primary-action\" ng-if=\"vm.isSchool\" ng-click=\"vmp.Send()\">\n            Send\n          </md-button>\n        </div>\n        <div layout=\"column\" ng-show=\"vmp.type==\'announccalc\'\" layout-align=\"space-between center\">\n          <md-button class=\"buttonbase primary-action\" ng-click=\"vmp.Send()\">\n            Send\n          </md-button>\n        </div>\n\n      </div>\n    </div>\n\n  </div>\n</div>");
$templateCache.put("app/components/msg-schedule/ya-msg-schedule.html","<!--<div id=\"msg_schedule\">\n	\n	<div layout=\"column\">\n		<div class=\"selectADate\">Select a Date:</div>\n		<div layout=\"row\" layout-align=\"center start\">\n			<div layout=\"column\" layout-align=\"center start\">\n				<md-calendar ng-model=\"vm.date\" ng-change=\"vm.checkDate()\"></md-calendar>\n\n				<div class=\"calandarSpace\"></div>\n\n				<div layout=\"row\">\n					<div layout=\"column\">\n						<div class=\"sendBy\"></div>\n						<div>Select Send By:</div>\n						<div class=\"message\"></div>\n						<div>Message Expiration:</div>\n					</div>\n					<div class=\"twentyPX\"></div>\n					<div layout=\"column\">\n						<div>\n							<md-select class=\"mdSelect\" ng-model=\"vm.sendBy\">\n								<md-option ng-repeat=\"data in vm.sendByList track by $index\" ng-value=\"data\">\n									{{data}}\n								</md-option>\n							</md-select>\n						</div>\n\n						<div>\n							<md-select class=\"mdSelect\" ng-model=\"vm.expiration\">\n								<md-option class=\"leftSelect\" ng-repeat=\"data in vm.expirationList track by $index\" ng-value=\"data\">\n									{{data}}\n								</md-option>\n							</md-select>\n						</div>\n					</div>\n				</div>\n\n			</div>\n			<div class=\"calandarSpace\"></div>\n			<div layout=\"column\" layout-align=\"start center\">\n\n				<md-button class=\"schedButtons todayButton\" ng-click=\"vm.SelectToday()\"><div class=\"buttonText\">Today</div></md-button>\n\n				<md-select class=\"mdSelect\" ng-model=\"vm.month\" ng-change=\"vm.Change()\">\n					<md-option ng-repeat=\"data in vm.monthList track by $index\" ng-value=\"data\">{{data}}</md-option>\n				</md-select>\n\n				<md-select class=\"mdSelect\" ng-model=\"vm.year\" ng-change=\"vm.Change()\">\n					<md-option ng-repeat=\"data in vm.yearList track by $index\" ng-value=\"data\">{{data}}</md-option>\n				</md-select>\n				<div class=\"schedButt\"></div>\n				<md-button class=\"schedButtons scheduleButton\" ng-click=\"vm.ScheduleItem()\"><div class=\"buttonText\">Schedule Item</div></md-button>\n\n			</div>\n	</div>\n</div>-->\n\n<div layout=\"row\" style=\"width: 100%; height: 100%\">\n	<div style=\"background-color: white; width: 5%\"></div>\n	<div layout=\"column\" style=\"background-color: white; width: 60%\">\n		<div style=\"height: 5%\"></div>\n		<div style=\"font-size: 22px\">Select A Date:</div>\n		<div style=\"height: 5%\"></div>\n		<md-calendar style=\"overflow: hidden; width: 100%\" ng-model=\"vm.date\" ng-change=\"vm.checkDate()\"></md-calendar>\n		<div style=\"height: 5%\"></div>\n		<div layout=\"row\" layout-align=\"start center\">\n			<div style=\"width: 130px\">Select Send By:</div>\n			<div style=\"width: 10%\"></div>\n			<md-select style=\"min-width: 150px\" ng-model=\"vm.sendBy\">\n				<md-option ng-repeat=\"data in vm.sendByList track by $index\" ng-value=\"data\">\n					{{data}}\n				</md-option>\n			</md-select>\n		</div>\n		<div style=\"height: 5%\"></div>\n		<div layout=\"row\" layout-align=\"start center\">\n			<div style=\"width: 130px\">Message Expiration:</div>\n			<div style=\"width: 10%\"></div>\n			<md-select style=\"min-width: 150px\" ng-model=\"vm.expiration\">\n				<md-option ng-repeat=\"data in vm.expirationList track by $index\" ng-value=\"data\">\n					{{data}}\n				</md-option>\n			</md-select>\n		</div>\n	</div>\n	<div layout=\"column\" layout-align=\"start center\" style=\"height: 100%; background-color: white; width: 30%\">\n\n		<div style=\"height: 13%\"></div>\n\n		<md-button style=\"background-color: #e0e0e0; width: 100%\" ng-click=\"vm.SelectToday()\"><div class=\"buttonText\">Today</div></md-button>\n\n		<md-select style=\"width: 85%\" ng-model=\"vm.month\" ng-change=\"vm.Change()\">\n			<md-option ng-repeat=\"data in vm.monthList track by $index\" ng-value=\"data\">{{data}}</md-option>\n		</md-select>\n\n		<md-select style=\"width: 85%\" ng-model=\"vm.year\" ng-change=\"vm.Change()\">\n			<md-option ng-repeat=\"data in vm.yearList track by $index\" ng-value=\"data\">{{data}}</md-option>\n		</md-select>\n\n		<div flex></div>\n\n		<md-button style=\"background-color: #e0e0e0; width: 100%\" ng-click=\"vm.ScheduleItem()\"><div class=\"buttonText\">Schedule Item</div></md-button>\n		\n	</div>\n	<div style=\"background-color: white; width: 5%\"></div>\n</div>");
$templateCache.put("app/components/msg-schedule-budget/ya-msg-schedule-budget.html","<div layout=\"column\" id=\"msg_schedulelist_budget\">\n\n	<div style=\"font-size: 16px; color: grey\">Scheduled Messages</div>\n	<div style=\"width: 100%; min-height: 20px\"></div>\n	<div style=\"background-color: white\">\n		<div style=\"font-size: 15px; font-weight: 500\" class=\"option labelText\" layout=\"row\">\n			<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">Start Date</div>\n			<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">End Date</div>\n			<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">Send By</div>\n			<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">Budget</div>\n\n		</div>\n\n		<md-content class=\"scrollable\">\n\n			<div style=\"font-size: 15px; font-weight: 500\" ng-repeat=\"data in vm.scheduledList track by $index\" class=\"option catText\" layout=\"row\">\n				<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">{{data.start}}</div>\n				<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">{{data.end}}</div>\n				<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">{{data.sendby}}</div>\n				<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">{{vm.currentBudget}}</div>\n				<button ng-click=\"vm.Delete(data)\">X</button>\n			</div>\n		</md-content>\n	</div>\n\n	<div style=\"width: 100%; height: 5%\"></div>\n\n	<div layout=\"row\" style=\"width: 100%; height: 60px; min-height: 60px; background-color: white\">\n		<div layout=\"column\">\n			<div style=\"width: 20px; height: 24px\"></div>\n			<div style=\"padding-left: 10px; font-size: 18px; font-weight: 300\">\n				$\n			</div>\n		</div>\n		<md-input-container style=\"width: 100%\" class=\"md-block inputCont\">\n			<label>Set Budget (per scheduled message)</label>\n			<input style=\"width: 100%\" type=\"text\" aria-label=\"budget\" required ng-model=\"vm.maxBudget\">\n		</md-input-container>\n		<div style=\"height: 100%; width: 5%\"></div>\n		<md-button style=\"min-width: 129px; height: 40px; background-color: #005f97; color: white; text-transform: none\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.SetBudget()\">\n			Set Budget\n		</md-button>\n	</div>\n\n	<div style=\"width: 100%; height: 20%\"></div>\n\n	<div>\n	    <div style=\"color: #005f97; font-size: 12px; font-weight: 600\" layout=\"row\">\n			<div style=\"min-width: 90px\">\n				Total Budget\n			</div>\n			<div style=\"width: 100%; height: 10px\"></div>\n			<div>\n				${{vm.totalBudget}}\n			</div>\n		</div>\n		<div style=\"width: 100%; height: 20px\"></div>\n	    <div style=\"color: grey; font-size: 11px; font-weight: 600; max-width: 500px\">\n			Total budget is \'Budget (per Scheduled Message)\' multiplied by the number of \'Scheduled Messages\'\n		</div>\n	</div>\n\n</div>\n");
$templateCache.put("app/components/msg-schedule-list/ya-msg-schedule-list.html","<div id=\"msg_schedulelist\">\n\n	<div layout=\"row\" layout-align=\"start center\" class=\"instructions\">\n		<div class=\"fontSize\">Please assign regions to ALL scheduled items</div>\n	</div>\n	\n	<div class=\"option labelText\" layout=\"row\">\n		<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">Start Date</div>\n		<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">End Date</div>\n		<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">Send By</div>\n	</div>\n\n	<md-content class=\"scrollable\">\n\n		<div ng-repeat=\"data in vm.scheduledList track by $index\" class=\"option catText\" layout=\"row\">\n			<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">{{data.start}}</div>\n			<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">{{data.end}}</div>\n			<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">{{data.sendby}}</div>\n			<button ng-click=\"vm.Delete(data)\">X</button>\n		</div>\n\n	</md-content>\n</div>");
$templateCache.put("app/components/msg-schedule-rebudget/ya-msg-schedule-rebudget.html","<div id=\"msg_schedulelist_rebudget\">\n\n	<div layout=\"row\" layout-align=\"start center\" class=\"instructions\">\n		<div class=\"fontSize\">Please assign regions to ALL scheduled items</div>\n	</div>\n	\n	<div class=\"option labelText\" layout=\"row\">\n		<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">Start Date</div>\n		<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">End Date</div>\n		<div class=\"catagory\" layout=\"row\" layout-align=\"center center\"></div>\n		<!--div class=\"catagory\" layout=\"row\" layout-align=\"center center\">Send By</div-->\n		<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">Budget</div>\n		\n	</div>\n\n	<md-content class=\"scrollable\">\n\n		<div ng-repeat=\"data in vm.scheduledList track by $index\" class=\"option catText\" layout=\"row\">\n			<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">{{data.start}}</div>\n			<div class=\"catagory\" layout=\"row\" layout-align=\"center center\">{{data.end}}</div>\n			<!--div class=\"catagory\" layout=\"row\" layout-align=\"center center\">{{data.sendby}}</div-->\n			<input class=\"inputBudget\" layout=\"row\" layout-align=\"center center\" type=\"number\" ng-model=\"data.maxbudget\">\n			<button class=\"catagory\" ng-click=\"vm.SetBudget(data)\">SetBudget</button>\n			<button ng-click=\"vm.Delete(data)\">X</button>\n		</div>\n\n	</md-content>\n\n	<div>\n	    <span>Total Budget {{vm.totalBudget}}</span>\n	    <p>Total budget is \'Budget (per Scheduled Message)\' multiplied by the number of \'Scheduled Messages\'</p>	    \n	</div>\n\n</div>");
$templateCache.put("app/components/select-card/ya-select-card.html","\n	<md-card class=\"select-card\" ng-mouseenter=\"hover = \'md-whiteframe-z5\'\" ng-mouseleave=\"hover = \'\'\" ng-class=\"hover\" ng-style=\"{\'background-image\': \'url(\' + vm.data.previewurl + \')\'}\">\n\n		<md-card-title-text>\n			<span class=\"md-title\">{{vm.data.status}}</span>	\n		</md-card-title-text>\n\n		<div layout-fill>\n\n			<div class=\"card-states\">\n				\n				<div class=\"state-create\" ng-show=\"vm.data.status==\'create\'\" layout=\"column\" layout-align=\"center center\" ng-click=\"vm.onCreate()\">\n					<div class=\"card-content-area\" layout=\"column\" layout-align=\"center center\">\n						<div class=\"circle-text\">{{vm.data.name}} </div>\n					</div>\n				</div>\n			\n				<div class=\"state-template\" ng-show=\"vm.data.status!=\'create\'\" ng-click=\"vm.onSelect()\">\n					<div class=\"card-content-area\" layout=\"column\" layout-align=\"space-around center\">\n					</div>\n				</div>\n				\n			</div>\n		</div>\n	</md-card>\n\n	<div class=\"under-card buffer-bottom\" ng-hide=\"vm.data.status==\'create\'\">\n    <div style=\"font-size: 14px\">\n      {{vm.data.name}}\n    </div>\n	</div>");
$templateCache.put("app/components/stepper/ya-stepper-item.html","<md-card class=\"stepperItem\" ng-show=\"vm.isVisible()\">\n	<md-card-header ng-click=\"vm.onTouched()\">\n		<md-card-avatar>\n			 <md-icon aria-label=\"icon\" ng-if=\"vm.isDone()\" ng-class=\"{\'active\':vm.isActive(),\'disabled\':!vm.isActive()}\" class=\"md-icon\">done</md-icon>\n			 <h3 ng-if=\"!vm.isDone()\" ng-class=\"{\'active\':vm.isActive(),\'disabled\':!vm.isActive()}\" class=\"icon-number\">{{vm.number+1}}</h3>\n        </md-card-avatar>\n        <md-card-header-text>\n			<p ng-class=\"{ \'stepperInactive\': !vm.isOpen() }\">{{vm.title}}</p>\n		</md-card-header-text>\n	</md-card-header>\n	<md-card-content ng-show=\"vm.isOpen()\">\n		<ng-transclude></ng-transclude>	\n	</md-card-content>\n</md-card>");
$templateCache.put("app/components/stepper/ya-stepper.html","<div>\n	<ng-transclude></ng-transclude>\n</div>");
$templateCache.put("app/components/tutorial-box/ya-tutorial-box.html","<div flex layout=\"column\" layout-align=\"center center\" layout-padding layout-fill>\n	\n	<img ng-src=\"{{vm.image}}\">\n	<p>{{vm.text}}</p>\n\n</div>");
$templateCache.put("app/components/usersearch/ya-user-search.html","<div id=\"usersearch\">\n	<div class=\"size\">\n			<md-autocomplete layout=\"column\" layout-align=\"center\" class=\"autocomp\" md-selected-item=\"vm.profile\" md-selected-item-change=\"vm.Change()\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getMatches(vm.searchText)\" md-item-text=\"item.name\">\n				<span md-highlight-text=\"searchText\">{{item.name}}</span>\n			</md-autocomplete>\n	\n		<div layout=\"row\" layout-wrap layout-padding>\n	                                    \n	        <div flex=\"100\" layout=\"row\" layout-align=\"space-between center\">\n				<div>\n		            <image class=\"imagesize\" id=\"image1\">\n		        </div>  \n		        <div layout=\"column\" layout-align=\"center center\" class=\"padding\">\n		            <p>{{vm.profileImage.name}}</p>\n		            <div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.profileimage==null\" class=\"fileUpload uploadButton\">     \n		                <input aria-label=\"browse\" type=\"file\" class=\"upload\" id=\"profileimage\" onchange=\"angular.element(this).scope().vm.UpdateImage(\'image1\',this)\" accept=\".jpg\">\n		                    BROWSE\n		                                            \n		            </div>\n		            <div layout=\"row\" layout-align=\"center center\" class=\"fileUpload uploadButton\">\n		            	<div aria-label=\"update\" ng-click=\"vm.CloseEdit()\">\n		            	UPDATE\n		            	</div>\n		            </div>\n\n		            \n		        </div>\n	        </div>\n	        \n	        <div layout=\"column\" flex>\n	            <md-input-container class=\"formCont\">\n	                <label>Name</label>\n	                <input aria-label=\"name\" type=\"text\" value=\"{{vm.profile.name}}\" ng-model=\"vm.profile.name\">\n	            </md-input-container>\n	            <md-input-container class=\"formCont\">\n	                <label>Title</label>\n	                <input aria-label=\"title\" type=\"text\" value=\"{{vm.profile.title}}\" ng-model=\"vm.profile.title\">\n	            </md-input-container>\n	            <md-input-container class=\"formCont\">\n	            	<label>Phone</label>\n	                <input aria-label=\"phone number\" type=\"text\" value=\"{{vm.profile.phonenumber}}\" ng-model=\"vm.profile.phonenumber\" ng-pattern=\"vm.phPattern\" onclick=\"if(value==\'(###)-###-####\'){value=\'\'}\">\n	                <div ng-messages=\"{\'pattern\': !x.phone}\">\n	                    <div ng-message=\"pattern\">invalid phone number</div>\n	                </div>\n	            </md-input-container>\n	            <md-input-container class=\"formCont\">\n	                <label>Email</label>\n	                <input aria-label=\"email\" type=\"text\" onclick=\"if(value==\'abc@abc.com\'){value=\'\'}\" value=\"{{vm.profile.email}}\" ng-model=\"vm.profile.email\" ng-pattern=\"vm.ePattern\">\n	                <div ng-messages=\"{\'pattern\': !x.email}\">\n	                    <div ng-message=\"pattern\">invalid email</div>\n	                </div>\n	            </md-input-container>\n	        </div>\n	    </div>\n	</div>\n</div>");
$templateCache.put("app/pages/ad/ad.html","<div id=\"ad\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"row\" layout-align=\"start\" flex>\n    <div style=\"height: 100%\" layout=\"column\" flex>\n      <ya-main-header></ya-main-header>\n\n      <div layout=\"row\" style=\"height:100%\">\n        <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n          <ya-main-sidenav></ya-main-sidenav>\n        </div>\n\n        <div flex=\"noshrink\" style=\"height: 100%; background: #04293e\">\n          <ya-msg-create-new parent=\"vm\" type=\"advertisement\"></ya-msg-create-new>\n        </div>\n\n        <div layout=\"column\" layout-fill>\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n\n          <div layout=\"row\" layout-fill>\n            <md-content class=\"tabShadows\" layout-fill ng-if=\"vm.ready\">\n\n              <div layout-fill layout=\"column\">\n                <md-tabs style=\"height: 100%\" md-selected=\"vm.currentNavItem\">\n                  <md-tab style=\"height: 100%\" ng-repeat=\"tab in vm.tabs track by $index\" label=\"{{tab.name}}\">\n                      <ya-msg-carousel data=\"vm.tabs[$index].list\" parent=\"vm\" select=\"false\" name=\"{{vm.tabs[$index].id}}\"></ya-msg-carousel>\n                  </md-tab>\n                </md-tabs>\n              </div>\n\n            </md-content>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/adcalc/adcalc.html","<div id=\"announcSched\" style=\"height: 100%\" layout=\"column\">\n	<div layout=\"column\" flex>\n		<ya-main-header page=\"Calculate\"></ya-main-header>\n    	<div layout=\"row\" flex>\n			<div style=\"background-color: #f89921\">             \n            	<ya-main-sidenav></ya-main-sidenav>\n			</div>\n            <div id=\"style-3\" layout=\"row\" style=\"min-height:100%; width: 100%; overflow-y: scroll\">\n				<div style=\"width: 3%\"></div>\n				<div class=\"contentBox\" layout=\"row\" layout-align=\"center center\">\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n					<div layout=\"row\" flex>\n						<div layout=\"column\" flex>\n							<div style=\"font-size: 18px; font-weight: 500\">Calculate Total Cost of All Messages sent to Respective Regions</div>\n							<div style=\"font-size: 13px; font-weight: 400; color: grey\">Create a name that will be used to identify this creation.</div>\n							<div style=\"width: 100%; height: 5%\"></div>\n							<div layout=\"row\" flex>\n								<div style=\"width: 100%\" class=\"whiteBlock\">\n									<ya-msg-schedule-budget></ya-msg-schedule-budget>\n								</div>\n								<div style=\"width: 5%\"></div>\n								<div style=\"width: 100%\" class=\"whiteBlock\">\n									<ya-msg-calculate></ya-msg-calculate>\n								</div>\n							</div>\n						</div>\n					</div>\n				</div>\n				<div style=\"width: 3%\"></div>\n            </div>\n			<ya-msg-preview parent=\"vm\" type=\"\'announccalc\'\"></ya-msg-preview>\n        </div>\n    </div> \n</div>\n");
$templateCache.put("app/pages/adedit/adedit.html","<div id=\"alertedit\" layout=\"column\" style=\"min-height: 100%\">\n  <div layout=\"column\" flex>\n    <ya-main-header page=\"Advertisement Editor\"></ya-main-header>\n    <div layout=\"row\" flex>\n      <div class=\"sideNav\" style=\"background-color: #f89921\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n      <div flex layout=\"column\">\n        <div layout=\"row\" flex>\n          <div layout=\"row\" style=\"width: 100%\" ng-show=\"vm.isValid\" flex>\n            <div style=\"width: 40px; height: 100%\"></div>\n            <div flex>\n              <div layout=\"column\" style=\"height:100%\">\n                <ya-help-menu help-page=\"\"></ya-help-menu>\n                <div style=\"padding-left: 10px; max-width: 1242px\" layout=\"row\">\n                  <div flex>\n                    <div style=\"height: 10px; width: 100%\"></div>\n                    <div class=\"titleText\">Name this Advertisement <span ng-if=\"vm.isTemplate()\">Template</span></div>\n                    <div class=\"descriptionText\">Create a name that will be used to identify this creation.</div>\n                    <div layout=\"row\">\n                      <div layout=\"column\">\n                        <div style=\"min-width: 40px; min-height: 30px\"></div>\n                        <img style=\"width: 26px; height: 26px\" src=\"assets\\images\\icons\\user-title.png\">\n                      </div>\n                      <md-input-container style=\"width: 495px\">\n                        <label>Name of Advertisement</label>\n                        <input aria-label=\"name\" ng-model=\"vm.data.name\" md-maxlength=\"60\">\n                      </md-input-container>\n                    </div>\n                  </div>\n                  <div id=\"checkBox\" flex>\n                    <md-input-container>\n                      <md-checkbox aria-label=\"use description\" ng-model=\"vm.useDescription\" ng-change=\"vm.onUpdateDescription()\">\n                        <div layout=\"column\">\n                          <div class=\"titleText\">\n                            Include A Description for Emails and Text Messages\n                          </div>\n                          <div class=\"descriptionText\">\n                            This description will show up in the body of an email and/or text (optional)\n                          </div>\n                        </div>\n                      </md-checkbox>\n                    </md-input-container>\n                    <div layout=\"row\">\n                      <div style=\"width: 70px; height: 15px\"></div>\n                      <div layout=\"column\">\n                        <div style=\"min-width: 40px; min-height: 1px\"></div>\n                        <img style=\"width: 26px; height: 26px; margin-top: 5px\" src=\"assets\\images\\icons\\alert-message.png\">\n                      </div>\n                      <md-input-container style=\"margin-bottom: 15px; width: 555px\">\n                        <input aria-label=\"description\" ng-model=\"vm.data.description\" ng-disabled=\"!vm.useDescription\" md-maxlength=\"160\">\n                      </md-input-container>\n                    </div>\n                  </div>\n                </div>\n                <div layout=\"column\">\n                  <div class=\"titleText\" style=\"padding-left: 10px\">Image Editor</div>\n                  <div class=\"whiteBlock\" style=\"height:740px\">\n                    <ya-editor-window data=\"vm.data\" parent=\"vm\"></ya-editor-window>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div style=\"width: 40px; height: 100%\"></div>\n          </div>\n          <ya-msg-preview parent=\"vm\" type=\"\'announcedit\'\"></ya-msg-preview>\n        </div>\n        <ya-msg-recipients parent=\"vm\" type=\"\'announcedit\'\"></ya-msg-recipients>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/adminInviteTemplates/adminInviteTemplates.html","<div class=\"adminorg\" style=\"height: 100%; width: 100%\">\n    <ya-main-header></ya-main-header>\n\n    <div style=\"height: 100%\" class=\"main-area\" layout=\"row\">\n        <div style=\"height: 100%; background-color: #f89921\">\n            <ya-admin-sidenav></ya-admin-sidenav>\n        </div>\n\n        <md-content style=\"height: 100%; width: 100%\" layout=\"column\">\n            <div style=\"width: 100%; height: 50px\"></div>\n            <div layout=\"row\">\n                <div style=\"width: 50px; height: 100%\"></div>\n                <ya-help-menu help-page=\"\"></ya-help-menu>\n                <md-content style=\"width: 100%\">\n                    \n                  <!-- Organization Search -->\n<div layout=\"row\" layout-align=\"center center\">\n    <md-autocomplete md-selected-item=\"vm.selectedOrganization\" md-search-text=\"vm.searchQuery\" md-items=\"org in vm.list\" md-item-text=\"org.name\" md-no-cache=\"true\" md-min-length=\"2\" placeholder=\"Search Organization\" md-selected-item-change=\"vm.selectOrganization(org)\" md-search-text-change=\"vm.searchOrganizations(vm.searchQuery)\">\n        <md-item-template>\n            <span>{{ org.name }}</span>\n        </md-item-template>\n    </md-autocomplete>\n</div>\n\n<!-- Template Type Dropdown -->\n<div layout=\"row\" layout-align=\"center center\">\n    <md-input-container style=\"width: 50%\">\n        <label>Select Template Type</label>\n        <md-select ng-model=\"vm.templateType\" ng-change=\"vm.selectTemplateType()\">\n           \n            <md-option value=\"dashboard_invite\">Dashboard Invite</md-option>\n            <md-option value=\"recipient_invite\">Recipient Invite</md-option>\n        </md-select>\n    </md-input-container>\n</div>\n\n<div layout=\"column\" class=\"form-section\">\n    <h3>Email Template Content</h3>\n    <div id=\"emailEditor\" style=\"height: 200px\"></div>\n</div>\n\n<!-- Save Template Button -->\n<div layout=\"row\" layout-align=\"center center\">\n    <md-button class=\"md-raised md-primary\" ng-click=\"vm.saveTemplate()\">Save Template</md-button>\n</div>\n\n\n\n\n                </md-content>\n            </div>\n        </md-content>\n    </div>\n</div>\n");
$templateCache.put("app/pages/admincategory/admincategory.html","<div class=\"adminorg\" style=\"height: 100%; width: 100%\">\n	<ya-main-header></ya-main-header>\n\n	<div style=\"height: 100%\" class=\"main-area\" layout=\"row\">\n\n		<div style=\"height: 100%; background-color: #f89921\">\n			<ya-admin-sidenav></ya-admin-sidenav>\n		</div>\n\n		<md-content style=\"height: 100%; width: 100%\" layout=\"column\">\n			<ya-help-menu help-page=\"\"></ya-help-menu>\n			\n			</md-content></div>\n		\n	</div>\n\n");
$templateCache.put("app/pages/adminemployees/adminemployees.html","<div class=\"adminorg\" style=\"height: 100%; width: 100%\">\n	<ya-main-header></ya-main-header>\n\n	<div style=\"height: 100%\" class=\"main-area\" layout=\"row\">\n\n		<div style=\"height: 100%; background-color: #f89921\">\n			<ya-admin-sidenav></ya-admin-sidenav>\n		</div>\n\n		<md-content style=\"height: 100%; width: 100%\" layout=\"column\">\n			<ya-help-menu help-page=\"\"></ya-help-menu>\n			\n			</md-content></div>\n		\n	</div>\n\n");
$templateCache.put("app/pages/adminindustry/adminindustry.html","<div class=\"adminorg\" style=\"height: 100%; width: 100%\">\n	<ya-main-header></ya-main-header>\n\n	<div style=\"height: 100%\" class=\"main-area\" layout=\"row\">\n\n		<div style=\"height: 100%; background-color: #f89921\">\n			<ya-admin-sidenav></ya-admin-sidenav>\n		</div>\n\n		<md-content style=\"height: 100%; width: 100%\" layout=\"column\">\n			<ya-help-menu help-page=\"\"></ya-help-menu>\n			\n			</md-content></div>\n		\n	</div>\n\n");
$templateCache.put("app/pages/adminlms/adminlms.html","<div class=\"adminorg\" style=\"height: 100%; width: 100%\">\n    <ya-main-header></ya-main-header>\n\n    <div style=\"height: 100%\" class=\"main-area\" layout=\"row\">\n        <div style=\"height: 100%; background-color: #f89921\">\n            <ya-admin-sidenav></ya-admin-sidenav>\n        </div>\n\n        <md-content style=\"height: 100%; width: 100%\" layout=\"column\">\n            <div style=\"width: 100%; height: 50px\"></div>\n            <div layout=\"row\">\n                <div style=\"width: 50px; height: 100%\"></div>\n                <ya-help-menu help-page=\"\"></ya-help-menu>\n                <md-content style=\"width: 100%\">\n                    \n                    <!-- Search Bar -->\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <md-autocomplete md-selected-item=\"vm.selectedOrganization\" md-search-text=\"vm.searchQuery\" md-items=\"org in vm.list\" md-item-text=\"org.name\" md-no-cache=\"true\" md-min-length=\"2\" placeholder=\"Search Organization\" md-selected-item-change=\"vm.selectOrganization(org)\" md-search-text-change=\"vm.searchOrganizations(vm.searchQuery)\">\n                        \n                        <md-item-template>\n                            <span>{{ org.name }}</span>\n                        </md-item-template>\n                    </md-autocomplete>\n                    \n                    </div>\n\n                    <!-- Instructions Section -->\n                    <div layout=\"column\" class=\"form-section\">\n                        <h3>Instructions</h3>\n                        <div ng-repeat=\"instruction in vm.instructions track by $index\" layout=\"row\">\n                            <md-input-container style=\"width: 30%\">\n                                <label>Instruction</label>\n                                <input type=\"text\" ng-model=\"instruction.name\">\n                            </md-input-container>\n                            <md-input-container style=\"width: 50%\">\n                                <label>Instruction Link</label>\n                                <input type=\"text\" ng-model=\"instruction.url\">\n                            </md-input-container>\n                            <md-button class=\"md-secondary\" ng-click=\"vm.removeInstruction($index)\" style=\"width: 20%;\n                            background: red;\n                            height: 0px\">Remove\n                            </md-button>\n                        </div>\n                        <!-- <div layout=\"row\" layout-align=\"end center\"> -->\n                        <md-button class=\"md-raised md-primary\" ng-click=\"vm.addInstruction()\">Add More</md-button>\n                        <!-- </div> -->\n                    </div>\n\n                    <!-- Certifications Section -->\n                    <div layout=\"column\" class=\"form-section\">\n                        <h3>Certifications</h3>\n                        <div ng-repeat=\"certification in vm.certifications track by $index\" layout=\"row\">\n                            <md-input-container style=\"width: 30%\">\n                                <label>Certification</label>\n                                <input type=\"text\" ng-model=\"certification.name\">\n                            </md-input-container>\n                            <md-input-container style=\"width: 50%\">\n                                <label>Certification Link</label>\n                                <input type=\"text\" ng-model=\"certification.url\">\n                            </md-input-container>\n                            <md-button class=\"md-secondary\" ng-click=\"vm.removeCertification($index)\" style=\"width: 20%;\n                            background: red;\n                            height: 0px\">\n                                Remove\n                            </md-button>\n                        </div>\n                        <md-button class=\"md-raised md-primary\" ng-click=\"vm.addCertification()\">Add More</md-button>\n                    </div>\n\n                    <!-- Save Button -->\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <md-button class=\"buttonbase alternate-action\" ng-click=\"vm.saveData()\">Save</md-button>\n                    </div>\n\n                </md-content>\n            </div>\n        </md-content>\n    </div>\n</div>\n");
$templateCache.put("app/pages/adminmessages/adminmessages.html","<div id=\"adminMessages\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-admin-sidenav><ya-admin-sidenav>\n        <!-- <ya-main-sidenav></ya-main-sidenav>  -->\n      </ya-admin-sidenav></ya-admin-sidenav></div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div class=\"title\">\n            This is the Admin Messages Page\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div class=\"sub-title\">\n            There is nothing to see here.\n          </div>\n\n          <div style=\"height: 10px; width: 100%\"></div>\n\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/adminorganizations/adminorganizations.html","<div class=\"adminorg\" style=\"height: 100%; width: 100%\">\n	<ya-main-header></ya-main-header>\n  \n	<div style=\"height: 100%\" class=\"main-area\" layout=\"row\">\n  \n	  <div style=\"height: 100%; background-color: #f89921\">\n		<ya-admin-sidenav></ya-admin-sidenav>\n	  </div>\n   \n	  <md-content style=\"height: 100%; width: 100%\" layout=\"column\">\n		<div style=\"width: 100%; height: 50px\"></div>\n		<div layout=\"row\">\n		  <div style=\"width: 50px; height: 100%\"></div>\n		  <ya-help-menu help-page=\"\"></ya-help-menu>\n		  <md-content style=\"width: 100%\">\n			<!-- Search Bar -->\n			<div layout=\"row\" layout-align=\"center center\">\n			  <md-input-container>\n				<label>Search By Organization name</label>\n				<input ng-model=\"vm.searchQuery\" ng-model-options=\"{ debounce: 300 }\" ng-change=\"vm.searchOrganizations()\">\n			  </md-input-container>\n			  <md-button class=\"md-icon-button\" aria-label=\"Search\" ng-click=\"vm.searchOrganizations()\">\n				<!-- <md-icon md-svg-src=\"assets/images/icons/search.svg\"></md-icon> -->\n			  </md-button>\n			</div>\n\n			<md-list>\n			  <md-list-item class=\"orgs\" ng-repeat=\"x in vm.list\">\n				<p ng-click=\"vm.Select(x)\">{{x.name}}</p>\n				<div style=\"width: 40px; height: 20px; float: right\" aria-label=\"remove\" ng-click=\"vm.ConfirmDelete(x)\" class=\"listbutton md-icon-btn dont-repeat\">\n				  <img src=\"assets/images/icons/user-trash.png\">\n				</div>\n			  </md-list-item>\n			</md-list>\n  \n			<!-- Pagination Controls -->\n			<div layout=\"row\" layout-align=\"center center\">\n			  <md-button ng-disabled=\"vm.currentPage == 1\" ng-click=\"vm.changePage(vm.currentPage - 1)\">\n				Previous\n			  </md-button>\n			  <span>Page {{vm.currentPage}} of {{vm.totalPages}}</span>\n			  <md-button ng-disabled=\"vm.currentPage == vm.totalPages\" ng-click=\"vm.changePage(vm.currentPage + 1)\">\n				Next\n			  </md-button>\n			</div>\n		  </md-content>\n		</div>\n	  </md-content>\n	</div>\n</div>\n");
$templateCache.put("app/pages/adminsales/adminsales.html","<div class=\"adminorg\" style=\"height: 100%; width: 100%\">\n	<ya-main-header></ya-main-header>\n\n	<div style=\"height: 100%\" class=\"main-area\" layout=\"row\">\n\n		<div style=\"height: 100%; background-color: #f89921\">\n			<ya-admin-sidenav></ya-admin-sidenav>\n		</div>\n\n		<md-content style=\"height: 100%; width: 100%\" layout=\"column\">\n			<ya-help-menu help-page=\"\"></ya-help-menu>\n			\n			</md-content></div>\n		\n	</div>\n\n");
$templateCache.put("app/pages/adminusers/adminusers.html","<div class=\"adminorg\" style=\"height: 100%; width: 100%\">\n	<ya-main-header></ya-main-header>\n  \n	<div style=\"height: 100%\" class=\"main-area\" layout=\"row\">\n  \n	  <div style=\"height: 100%; background-color: #f89921\">\n		<ya-admin-sidenav></ya-admin-sidenav>\n	  </div>\n   \n	  <md-content style=\"height: 100%; width: 100%\" layout=\"column\">\n		<div style=\"width: 100%; height: 50px\"></div>\n		<div layout=\"row\">\n		  <div style=\"width: 50px; height: 100%\"></div>\n		  <ya-help-menu help-page=\"\"></ya-help-menu>\n		  <md-content style=\"width: 100%\">\n			<!-- Search Bar -->\n			<div layout=\"row\" layout-align=\"center center\">\n			  <md-input-container>\n				<label>Search By Name</label>\n				<input ng-model=\"vm.searchQuery\" ng-model-options=\"{ debounce: 300 }\" ng-change=\"vm.searchOrganizations()\">\n			  </md-input-container>\n			  <md-button class=\"md-icon-button\" aria-label=\"Search\" ng-click=\"vm.searchOrganizations()\">\n				<!-- <md-icon md-svg-src=\"assets/images/icons/search.svg\"></md-icon> -->\n			  </md-button>\n			</div> \n \n			<md-list>\n				<md-list-item class=\"orgs\" ng-repeat=\"x in vm.list\">\n				  <p ng-click=\"vm.Select(x)\">\n					<span>\n					  Name: \n					  <span ng-if=\"x.firstname\">{{x.firstname}} {{x.lastname}} ({{x.email}})</span>\n					  <span ng-if=\"!x.firstname && x.email != \'undefined\'\">{{x.email}}</span>\n					</span>\n					&nbsp;|&nbsp;\n					<span>\n					  Organization: \n					  <span ng-if=\"x.organizationname\">{{x.organizationname}}</span>\n					  <span ng-if=\"!x.organizationname\">No organization</span>\n					</span>\n					&nbsp;|&nbsp;\n					<span>\n						Is Dashboard User: \n						<span ng-if=\"x.is_dashboard_user > 0\">Yes</span>\n						<span ng-if=\"x.is_dashboard_user < 1\">No</span>\n					  </span>\n					  &nbsp;|&nbsp;\n					  <span>\n						Is Recipient User: \n						<span ng-if=\"x.is_recipent_user > 0\">Yes</span>\n						<span ng-if=\"x.is_recipent_user < 1\">No</span>\n					  </span>\n				  </p>\n				</md-list-item>\n			  </md-list>\n			  \n			  \n  \n			<!-- Pagination Controls -->\n			<div layout=\"row\" layout-align=\"center center\">\n			  <md-button ng-disabled=\"vm.currentPage == 1\" ng-click=\"vm.changePage(vm.currentPage - 1)\">\n				Previous\n			  </md-button>\n			  <span>Page {{vm.currentPage}} of {{vm.totalPages}}</span>\n			  <md-button ng-disabled=\"vm.currentPage == vm.totalPages\" ng-click=\"vm.changePage(vm.currentPage + 1)\">\n				Next\n			  </md-button>\n			</div>\n		  </md-content>\n		</div>\n	  </md-content>\n	</div>\n</div>\n");
$templateCache.put("app/pages/adschedule/adschedule.html","<div id=\"announcSched\" style=\"height: 100%\" layout=\"column\">\n  <div layout=\"column\" flex>\n    <ya-main-header page=\"Schedule\"></ya-main-header>\n    <div layout=\"row\" flex>\n      <div style=\"background-color: #f89921\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n      <div id=\"style-3\" layout=\"row\" style=\"min-height:100%; width: 100%; overflow-y: scroll\">\n        <div style=\"width: 3%\"></div>\n        <div class=\"contentBox\" layout=\"row\" layout-align=\"center center\">\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n          <div layout=\"row\" flex>\n            <div layout=\"column\" flex>\n              <div style=\"font-size: 18px; font-weight: 500\">Schedule Items to Calculate Cost</div>\n              <div style=\"width: 100%; height: 5%\"></div>\n              <div layout=\"row\" flex>\n                <div style=\"width: 100%; background-color: white\" class=\"whiteBlock\">\n                  <ya-msg-schedule></ya-msg-schedule>\n                </div>\n                <div style=\"width: 5%\"></div>\n                <div style=\"width: 100%; background-color: white\" class=\"whiteBlock\">\n                  <ya-msg-schedule-list></ya-msg-schedule-list>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div style=\"width: 3%\"></div>\n      </div>\n      <ya-msg-preview parent=\"vm\" type=\"\'announcschedule\'\"></ya-msg-preview>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/adselect/adselect.html","<div id=\"ad-select\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"row\" layout-align=\"start\" flex>\n    <div style=\"height: 100%\" layout=\"column\" flex>\n      <ya-main-header></ya-main-header>\n\n      <div layout=\"row\" style=\"height:100%\">\n        <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n          <ya-main-sidenav></ya-main-sidenav>\n        </div>\n\n        <div flex=\"noshrink\" style=\"height: 100%; background: #04293e\">\n          <ya-msg-create-template parent=\"vm\" type=\"advertisement\"></ya-msg-create-template>\n        </div>\n\n        <div layout=\"column\" layout-fill>\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n\n          <div layout=\"row\" layout-fill>\n            <md-content class=\"tabShadows\" layout-fill ng-if=\"vm.ready\">\n\n              <div layout-fill layout=\"column\">\n                <!-- youngest page wrapper -->\n                <md-tabs style=\"height: 100%\" md-selected=\"vm.currentNavItem\"> \n\n                  <!-- tabs bar -->\n                  <md-tab style=\"height: 100%\" ng-repeat=\"tab in vm.tabs track by $index\" label=\"{{tab.name}}\">\n\n                  <ya-msg-carousel data=\"vm.tabs[$index].list\" parent=\"vm\" select=\"true\" name=\"{{vm.tabs[$index].id}}\"></ya-msg-carousel>\n\n                  </md-tab>\n                </md-tabs>\n              </div>\n\n            </md-content>\n            </div>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </div>\n\n");
$templateCache.put("app/pages/alert/alert.html","<div id=\"alert\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"row\" layout-align=\"start\" layout-fill>\n    <div style=\"height: 100%\" layout=\"column\" layout-fill>\n      <ya-main-header></ya-main-header>\n\n      <div layout=\"row\" style=\"height:100%\">\n        <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n          <ya-main-sidenav></ya-main-sidenav>\n        </div>\n\n        <div flex=\"noshrink\" style=\"height: 100%; background: #04293e\">\n          <ya-msg-create-new parent=\"vm\" type=\"alert\"></ya-msg-create-new>\n        </div>\n\n        <div layout=\"column\" layout-fill>\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n\n          <div layout=\"row\" layout-fill>\n            <md-content class=\"tabShadows\" layout-fill ng-if=\"vm.ready\">\n\n              <div layout-fill layout=\"column\">\n                <!-- youngest page wrapper -->\n\n                <md-tabs style=\"height: 100%\" md-selected=\"vm.currentNavItem\">\n                  <!-- tabs bar -->\n                  <md-tab style=\"height: 100%\" ng-repeat=\"tab in vm.tabs track by $index\" md-tab-class=\"tightTab\">\n                    <md-tab-label><span ng-bind-html=\"vm.tabName(tab)\"></span></md-tab-label>\n                    <md-tab-body>\n                      <!-- <pre>{{vm.tabs[$index].list | json}}</pre> -->\n                      <ya-msg-carousel data=\"vm.tabs[$index].list\" parent=\"vm\" select=\"false\" name=\"{{vm.tabs[$index].id}}\"></ya-msg-carousel>\n                    </md-tab-body>\n                  </md-tab>\n                </md-tabs>\n              </div>\n\n            </md-content>\n          </div>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/alertedit/alertedit.html","<div id=\"alertedit\" layout=\"column\" style=\"min-height: 100%\">\n  <div layout=\"column\" flex>\n    <ya-main-header page=\"Alert Edit Page\"></ya-main-header>\n    <div layout=\"row\" flex>\n      <div class=\"sideNav\" style=\"background-color: #f89921\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n      <div flex layout=\"column\">\n        <div layout=\"row\" flex>\n          <div layout=\"row\" style=\"width: 100%\" ng-show=\"vm.isValid\" flex>\n            <div style=\"width: 40px; height: 100%\"></div>\n            <div flex>\n              <div layout=\"column\">\n                <ya-help-menu help-page=\"\"></ya-help-menu>\n                <div style=\"padding-left: 10px; max-width: 1242px\" layout=\"row\">\n                  <div flex>\n                    <div style=\"height: 10px; width: 100%\"></div>\n                    <div class=\"titleText\">Name this Alert <span ng-if=\"vm.isTemplate()\">Template</span></div>\n                    <div class=\"descriptionText\">Create a name that will be used to identify this creation.</div>\n                    <div layout=\"row\">\n                      <div layout=\"column\">\n                        <div style=\"min-width: 40px; min-height: 30px\"></div>\n                        <img style=\"width: 26px; height: 26px\" src=\"assets\\images\\icons\\user-title.png\">\n                      </div>\n                      <md-input-container style=\"width: 495px\">\n                        <label>Name of Alert</label>\n                        <input aria-label=\"name\" ng-model=\"vm.data.name\" md-maxlength=\"60\">\n                      </md-input-container>\n                    </div>\n                  </div>\n                  <div id=\"checkBox\" flex>\n                    <md-input-container>\n                      <md-checkbox aria-label=\"use description\" ng-model=\"vm.useDescription\" ng-change=\"vm.onUpdateDescription()\">\n                        <div layout=\"column\">\n                          <div class=\"titleText\">\n                            Include A Description for Emails and Text Messages\n                          </div>\n                          <div class=\"descriptionText\">\n                            This description will show up in the body of an email and/or text (optional)\n                          </div>\n                        </div>\n                      </md-checkbox>\n                    </md-input-container>\n                    <div layout=\"row\">\n                      <div style=\"width: 70px; height: 15px\"></div>\n                      <div layout=\"column\">\n                        <div style=\"min-width: 40px; min-height: 1px\"></div>\n                        <img style=\"width: 26px; height: 26px; margin-top: 5px\" src=\"assets\\images\\icons\\alert-message.png\">\n                      </div>\n                      <md-input-container style=\"margin-bottom: 15px; width: 555px\">\n                        <input aria-label=\"description\" ng-model=\"vm.data.description\" ng-disabled=\"!vm.useDescription\" md-maxlength=\"160\">\n                      </md-input-container>\n                    </div>\n                  </div>\n                </div>\n                <div layout=\"column\">\n                  <div class=\"titleText\" style=\"padding-left: 10px\">Image Editor</div>\n                  <div class=\"whiteBlock\" style=\"height:740px\">\n                    <ya-editor-window data=\"vm.data\" parent=\"vm\"></ya-editor-window>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div style=\"width: 40px; height: 100%\"></div>\n          </div>\n          <ya-msg-preview parent=\"vm\" type=\"\'alertedit\'\"></ya-msg-preview>\n        </div>\n        <ya-msg-recipients parent=\"vm\" type=\"\'alertedit\'\"></ya-msg-recipients>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/alertselect/alertselect.html","<div id=\"alert-select\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"row\" layout-align=\"start\" flex>\n    <div style=\"height: 100%\" layout=\"column\" flex>\n      <ya-main-header></ya-main-header>\n\n      <div layout=\"row\" style=\"height:100%\">\n        <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n          <ya-main-sidenav></ya-main-sidenav>\n        </div>\n\n        <div flex=\"noshrink\" style=\"height: 100%; background: #04293e\">\n          <ya-msg-create-template parent=\"vm\" type=\"alert\"></ya-msg-create-template>\n        </div>\n\n        <div layout=\"column\" layout-fill>\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n\n          <div layout=\"row\" layout-fill>\n            <md-content class=\"tabShadows\" layout-fill ng-if=\"vm.ready\">\n\n              <div layout-fill layout=\"column\">\n                <!-- youngest page wrapper -->\n                <md-tabs style=\"height: 100%\" md-selected=\"vm.currentNavItem\"> \n\n                  <!-- tabs bar -->\n                  <md-tab style=\"height: 100%\" ng-repeat=\"tab in vm.tabs track by $index\" label=\"{{tab.name}}\">\n\n                  <ya-msg-carousel data=\"vm.tabs[$index].list\" parent=\"vm\" select=\"true\" name=\"{{vm.tabs[$index].id}}\"></ya-msg-carousel>\n\n                  </md-tab>\n                </md-tabs>\n              </div>\n\n            </md-content>\n            </div>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </div>\n");
$templateCache.put("app/pages/announccalc/announccalc.html","<div id=\"announcSched\" style=\"height: 100%\" layout=\"column\">\n	<div layout=\"column\" flex>\n		<ya-main-header page=\"Calculate\"></ya-main-header>\n    	<div layout=\"row\" flex>\n			<div style=\"background-color: #f89921\">\n            	<ya-main-sidenav></ya-main-sidenav>\n			</div>\n            <div id=\"style-3\" layout=\"row\" style=\"min-height:100%; width: 100%; overflow-y: scroll\">\n				<div style=\"width: 3%\"></div>\n				<div class=\"contentBox\" layout=\"row\" layout-align=\"center center\">\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n					<div layout=\"row\" flex>\n						<div layout=\"column\" flex style=\"margin-top: 25px\">\n							<div style=\"font-size: 18px; font-weight: 500\">Calculate Total Cost of All Messages sent to Respective Regions</div>\n							<div style=\"font-size: 13px; font-weight: 400; color: grey\">Create a name that will be used to identify this creation.</div>\n							<div style=\"width: 100%; height: 5%\"></div>\n							<div layout=\"row\" flex>\n								<div style=\"width: 100%\" class=\"whiteBlock\">\n									<ya-msg-schedule-budget></ya-msg-schedule-budget>\n								</div>\n								<div style=\"width: 5%\"></div>\n								<div style=\"width: 100%\" class=\"whiteBlock\">\n									<ya-msg-calculate></ya-msg-calculate>\n								</div>\n							</div>\n						</div>\n					</div>\n				</div>\n				<div style=\"width: 3%\"></div>\n            </div>\n			<ya-msg-preview parent=\"vm\" type=\"\'announccalc\'\"></ya-msg-preview>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/pages/announcedit/announcedit.html","<div id=\"alertedit\" layout=\"column\" style=\"min-height: 100%\">\n  <div layout=\"column\" flex>\n    <ya-main-header page=\"Announcement Editor\"></ya-main-header>\n    <div layout=\"row\" flex>\n      <div class=\"sideNav\" style=\"background-color: #f89921\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n      <div flex layout=\"column\">\n        <div layout=\"row\" flex>\n          <div layout=\"row\" style=\"width: 100%\" ng-show=\"vm.isValid\" flex>\n            <div style=\"width: 40px; height: 100%\"></div>\n            <div flex>\n              <div layout=\"column\">\n                <ya-help-menu help-page=\"\"></ya-help-menu>\n                <div style=\"padding-left: 10px; max-width: 1242px\" layout=\"row\">\n                  <div flex>\n                    <div style=\"height: 10px; width: 100%\"></div>\n                    <div class=\"titleText\">Name this Announcement <span ng-if=\"vm.isTemplate()\">Template</span></div>\n                    <div class=\"descriptionText\">Create a name that will be used to identify this creation.</div>\n                    <div layout=\"row\">\n                      <div layout=\"column\">\n                        <div style=\"min-width: 40px; min-height: 30px\"></div>\n                        <img style=\"width: 26px; height: 26px\" src=\"assets\\images\\icons\\user-title.png\">\n                      </div>\n                      <md-input-container style=\"width: 495px\">\n                        <label>Name of Announcement</label>\n                        <input aria-label=\"name\" ng-model=\"vm.data.name\" md-maxlength=\"60\">\n                      </md-input-container>\n                    </div>\n                  </div>\n                  <div id=\"checkBox\" flex>\n                    <md-input-container>\n                      <md-checkbox aria-label=\"use description\" ng-model=\"vm.useDescription\" ng-change=\"vm.onUpdateDescription()\">\n                        <div layout=\"column\">\n                          <div class=\"titleText\">\n                            Include A Description for Emails and Text Messages\n                          </div>\n                          <div class=\"descriptionText\">\n                            This description will show up in the body of an email and/or text (optional)\n                          </div>\n                        </div>\n                      </md-checkbox>\n                    </md-input-container>\n                    <div layout=\"row\">\n                      <div style=\"width: 70px; height: 15px\"></div>\n                      <div layout=\"column\">\n                        <div style=\"min-width: 40px; min-height: 1px\"></div>\n                        <img style=\"width: 26px; height: 26px; margin-top: 5px\" src=\"assets\\images\\icons\\alert-message.png\">\n                      </div>\n                      <md-input-container style=\"margin-bottom: 15px; width: 555px\">\n                        <input aria-label=\"description\" ng-model=\"vm.data.description\" ng-disabled=\"!vm.useDescription\" md-maxlength=\"160\">\n                      </md-input-container>\n                    </div>\n                  </div>\n                </div>\n                <div layout=\"column\">\n                  <div class=\"titleText\" style=\"padding-left: 10px\">Image Editor</div>\n                  <div class=\"whiteBlock\" style=\"height:740px\">\n                    <ya-editor-window data=\"vm.data\" parent=\"vm\"></ya-editor-window>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div style=\"width: 40px; height: 100%\"></div>\n          </div>\n          <ya-msg-preview parent=\"vm\" type=\"\'announcedit\'\"></ya-msg-preview>\n        </div>\n        <ya-msg-recipients parent=\"vm\" type=\"\'announcedit\'\"></ya-msg-recipients>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/announcement/announcement.html","<div id=\"announcement\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"row\" layout-align=\"start\" flex>\n    <div style=\"height: 100%\" layout=\"column\" flex>\n      <ya-main-header></ya-main-header>\n\n      <div layout=\"row\" style=\"height:100%\">\n        <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n          <ya-main-sidenav></ya-main-sidenav>\n        </div>\n\n        <div flex=\"noshrink\" style=\"height: 100%; background: #04293e\">\n          <ya-msg-create-new parent=\"vm\" type=\"announcement\"></ya-msg-create-new>\n        </div>\n\n        <div layout=\"column\" layout-fill>\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n\n          <div layout=\"row\" layout-fill>\n            <md-content class=\"tabShadows\" layout-fill ng-if=\"vm.ready\">\n\n              <div layout-fill layout=\"column\">\n                <md-tabs style=\"height: 100%\" md-selected=\"vm.currentNavItem\">\n                  <md-tab style=\"height: 100%\" ng-repeat=\"tab in vm.tabs track by $index\" label=\"{{tab.name}}\">\n                      <ya-msg-carousel data=\"vm.tabs[$index].list\" parent=\"vm\" select=\"false\" name=\"{{vm.tabs[$index].id}}\"></ya-msg-carousel>\n                  </md-tab>\n                </md-tabs>\n              </div>\n\n            </md-content>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/announcschedule/announcschedule.html","<div id=\"announcSched\" style=\"height: 100%\" layout=\"column\">\n	<div layout=\"column\" flex>\n		<ya-main-header page=\"Calculate\"></ya-main-header>\n    	<div layout=\"row\" flex>\n			<div style=\"background-color: #f89921\">             \n            	<ya-main-sidenav></ya-main-sidenav>\n			</div>\n            <div id=\"style-3\" layout=\"row\" style=\"min-height:100%; width: 100%; overflow-y: scroll\">\n				<div style=\"width: 3%\"></div>\n				<div class=\"contentBox\" layout=\"row\" layout-align=\"center center\">\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n					<div layout=\"row\" flex>\n						<div layout=\"column\" flex>\n							<div style=\"font-size: 18px; font-weight: 500\">Schedule Items to Calculate Cost</div>\n							<div style=\"width: 100%; height: 5%\"></div>\n							<div layout=\"row\" flex>\n								<div style=\"width: 100%; background-color: white\" class=\"whiteBlock\">\n									<ya-msg-schedule></ya-msg-schedule>\n								</div>\n								<div style=\"width: 5%\"></div>\n								<div style=\"width: 100%; background-color: white\" class=\"whiteBlock\">\n									<ya-msg-schedule-list></ya-msg-schedule-list>\n								</div>\n							</div>\n						</div>\n					</div>\n				</div>\n				<div style=\"width: 3%\"></div>\n            </div>\n			<ya-msg-preview parent=\"vm\" type=\"\'announcschedule\'\"></ya-msg-preview>\n        </div>\n    </div> \n</div>\n");
$templateCache.put("app/pages/announcselect/announcselect.html","<div id=\"announce-select\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"row\" layout-align=\"start\" flex>\n    <div style=\"height: 100%\" layout=\"column\" flex>\n      <ya-main-header></ya-main-header>\n\n      <div layout=\"row\" style=\"height:100%\">\n        <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n          <ya-main-sidenav></ya-main-sidenav>\n        </div>\n\n        <div flex=\"noshrink\" style=\"height: 100%; background: #04293e\">\n          <ya-msg-create-template parent=\"vm\" type=\"announcement\"></ya-msg-create-template>\n        </div>\n\n        <div layout=\"column\" layout-fill>\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n\n          <div layout=\"row\" layout-fill>\n            <md-content class=\"tabShadows\" layout-fill ng-if=\"vm.ready\">\n\n              <div layout-fill layout=\"column\">\n                <!-- youngest page wrapper -->\n                <md-tabs style=\"height: 100%\" md-selected=\"vm.currentNavItem\"> \n\n                  <!-- tabs bar -->\n                  <md-tab style=\"height: 100%\" ng-repeat=\"tab in vm.tabs track by $index\" label=\"{{tab.name}}\">\n\n                  <ya-msg-carousel data=\"vm.tabs[$index].list\" parent=\"vm\" select=\"true\" name=\"{{vm.tabs[$index].id}}\"></ya-msg-carousel>\n\n                  </md-tab>\n                </md-tabs>\n              </div>\n\n            </md-content>\n            </div>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </div>\n\n");
$templateCache.put("app/pages/appointment/appointment.html","<div id=\"appointment\" layout=\"row\">\n    <div class=\"page\" layout=\"row\" layout-align=\"start\" flex>\n        <div id=\"wrapper\" layout=\"column\" flex>\n            <ya-main-header page=\"Appointment\"></ya-main-header>\n            <div layout=\"row\">\n\n                <div class=\"sideNavi\" layout=\"column\" flex=\"none\">\n                    <ya-main-sidenav></ya-main-sidenav>\n                </div>\n                <div class=\"\" layout=\"column\" flex=\"none\">\n                    <!--ya-msg-create-new parent=\"vm\" type=\"appointment\"></ya-msg-create-new-->\n                </div>\n                <div>\n\n                	<md-content id=\"element\" class=\"scrollable\">\n                    <ya-help-menu help-page=\"\"></ya-help-menu>\n	                	<md-tabs md-dynamic-height md-border-bottom md-selected=\"vm.currentNavItem\">\n					    	<md-tab ng-repeat=\"tab in vm.tabs track by $index\" label=\"{{tab.name}}\" md-on-select=\"vm.onSelectTab($index)\"></md-tab>\n					    </md-tabs>\n						<div layout=\"row\" layout-fill layout-wrap layout-margin>\n							<div class=\"grid-cards\" flex=\"none\" layout=\"column\" layout-align=\"start center\" ng-repeat=\"data in vm.currentList track by $index\">\n								<ya-message-card data=\"data\" parent=\"vm\"></ya-message-card>\n							</div>\n						</div>\n					</md-content>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/pages/approval/approval.html","<div id=\"approval\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header page=\"Workflow Approval Required\"></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div flex>\n            <div class=\"title\">\n              Items Waiting for Approval\n            </div>\n            <div style=\"height: 10px; width: 100%\"></div>\n            <div class=\"sub-title\">\n              Please take action on these items you may proceed…\n            </div>\n            <div style=\"height: 10px; width: 100%\"></div>\n          </div>\n\n          <div class=\"bucket\">\n            <md-content class=\"tabShadows\" layout-fill style=\"\">\n\n              <md-tabs md-selected=\"vm.currentNavItem\">\n                <md-tab ng-repeat=\"tab in vm.tabs track by $index\">\n                  <md-tab-label style=\"position:relative\">\n                    <span class=\"tab-pos\">{{tab.name}}</span>\n                    <span ng-if=\"vm.tabs[$index].list.length > 0\" ng-init=\"vm.tabs[$index].list.length\" class=\"pending-circle\">\n                      {{vm.tabs[$index].list.length}}\n                    </span>\n                  </md-tab-label>\n                  <md-tab-body>\n                    <ya-msg-carousel ng-if=\"vm.ready\" data=\"vm.tabs[$index].list\" parent=\"vm\" select=\"false\" name=\"{{vm.tabs[$index].name}}\"></ya-msg-carousel>\n                  </md-tab-body>\n                </md-tab>\n              </md-tabs>\n\n            </md-content>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/apptavailable/apptavailable.html","<div id=\"apptAvailable\" layout=\"row\">\n    <div layout=\"row\" layout-align=\"start\" flex>\n        <div layout=\"column\" flex>\n	        <ya-main-header page=\"Appointment Book Editor\"></ya-main-header>\n            <div layout=\"row\">\n				<md-sidenav class=\"md-sidenav-left sidenavi\" md-component-id=\"left\" md-is-locked-open=\"$mdMedia(\'min-width: 1250px\')\" md-disable-backdrop md-whiteframe=\"4\" layout=\"column\" layout=\"column\" layout-align=\"center center\">\n					<div class=\"instructions\">Select the region(s) you would like to send your message(s).</div>\n					<div layout=\"column\" layout-align=\"end end\" flex=\"70\"></div>\n					<md-button ng-click=\"\" type=\"submit\" class=\"adminButton buttonColor1\" layout=\"row\" layout-align=\"center center\" ng-click=\"\">\n						<div class=\"buttonText\">\n							Back\n						</div>\n					</md-button>\n				</md-sidenav>\n				<div class=\"contentPadding\" layout=\"row\">\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n					<div class=\"thePad\">\n						<div layout=\"column\">\n							<div layout=\"column\" layout-align=\"start start\">\n								<md-calendar class=\"whiteBack shadow calSize\" ng-model=\"vm.date\" ng-change=\"vm.checkDate()\"></md-calendar>\n								<div layout=\"column\" layout-align=\"start start\">\n									<div layout=\"row\" layout-align=\"center center\">\n										<md-select class=\"mdSelect selectWidth\" ng-model=\"vm.month\" ng-change=\"vm.Change()\">\n											<md-option ng-repeat=\"data in vm.monthList track by $index\">{{data}}</md-option>\n										</md-select>\n\n										<md-button class=\"schedButtons todayButton buttonColor2 adminButton\" ng-click=\"vm.SelectToday()\"><div class=\"buttonText\">Today</div></md-button>\n									</div>\n									<md-select class=\"mdSelect selectWidth\" ng-model=\"vm.year\" ng-change=\"vm.Change()\">\n										<md-option ng-repeat=\"data in vm.yearList track by $index\">{{data}}</md-option>\n									</md-select>\n								</div>\n							</div>\n\n							<div layout=\"column\">\n								<label>Rescheduling Slots</label>\n								<md-select class=\"mdSelect\" ng-model=\"vm.reSlotsCount\" ng-change=\"vm.ChangeReSlots()\">\n									<md-option ng-repeat=\"n in vm.reSlots\">{{n}}</md-option>\n								</md-select>\n								<div ng-show=\"vm.reSlotsCount>$index\" ng-repeat=\"x in vm.curWeek.reSlotObjects\">\n									<p>{{x.name}}</p>\n									<md-select class=\"mdSelect\" ng-model=\"x.time\" ng-change=\"vm.setReTime(x.time,x)\">\n										<md-option ng-repeat=\"t in vm.reSlotTimes\" value=\"{{t}}\">{{vm.getReSlotTime(t)}}</md-option>\n									</md-select>\n								</div>\n							</div>\n						</div>\n					</div>\n\n					<div id=\"grid\" class=\"unselectable gridbody thePad\">\n\n\n						<div layout=\"row\" class=\"unselectable bottomBorder\" layout-align=\"\">\n							<div class=\"selectSpace\"></div>\n							<div layout=\"row\" layout-align=\"center start\" class=\"dateCont unselectable\">\n								Reserve\n							</div>\n							<div class=\"checkboxSpace\"></div>\n							<div layout=\"row\" layout-align=\"center start\" class=\"dateCont unselectable\" ng-repeat=\"x in vm.days\">\n								<md-checkbox class=\"blue\" type=\"checkbox\" ng-model=\"vm.curWeek.rescheduleflags[x.id]\" ng-change=\"vm.ChangeReSlots()\" ng-false-value=\"false\" ng-true-value=\"true\">\n							</div>\n						</div>\n						<div layout=\"row\" class=\"unselectable\" layout-align=\"\">\n							<div class=\"selectSpace\"></div>\n							<div layout=\"row\" layout-align=\"center start\" class=\"dateCont unselectable\">\n								All-Day\n							</div>\n							<div class=\"checkboxSpace\"></div>\n							<div layout=\"row\" layout-align=\"center start\" class=\"dateCont unselectable\" ng-repeat=\"x in vm.days\">\n								<md-checkbox class=\"blue\" type=\"checkbox\" ng-model=\"vm.curWeek.rescheduleflags[x.id]\" ng-change=\"vm.ChangeReSlots()\" ng-false-value=\"true\" ng-true-value=\"false\">\n							</div>\n						</div>\n						<div class=\"whiteBack pickerSize shadow scroll-bar-wrap\" layout=\"column\" layout-align=\"center center\">\n							<div layout=\"row\" class=\"unselectable\">\n								<div class=\"datePush unselectable\"></div>\n								<div layout=\"row\" layout-align=\"center center\" class=\"dateCont unselectable\" ng-repeat=\"x in vm.days\">\n									<p class=\"\">{{x.name}} {{x.date}}</p>\n								</div>\n							</div>\n							<div id=\"gridScroll\" class=\"content unselectable scroll-box\" ng-mouseup=\"vm.mouseRelease($event)\" ng-mousemove=\"vm.mouseMove($event)\" ng-mousedown=\"vm.mouseSelect($event)\" ng-mouseleave=\"vm.mouseLeave()\">\n								<div layout=\"row\" layout-align=\"\" class=\"unselectable\" ng-repeat=\"y in vm.times\">\n									<div class=\"timebox unselectable\" ng-style=\"y.style\">\n										<p class=\"timeCenter\">{{y.name}}</p>\n									</div>\n									<div class=\"cellbox unselectable\" ng-style=\"y.cell\" ng-repeat=\"x in vm.days\" ng-mousedown=\"vm.select(x,y,$event)\">\n									</div>\n								</div>\n								<div class=\"reSlotOject\" ng-style=\"o.style\" ng-repeat=\"o in vm.curWeek.reschedule\">\n								</div>\n								<div class=\"unavailable\" ng-style=\"u.style\" ng-repeat=\"u in vm.curWeek.unavailable\" ng-click=\"vm.removeUnavailable(u)\">\n								</div>\n								<div class=\"select\" ng-style=\"vm.dragObject.style\">\n								</div>\n							</div>\n						</div>\n					</div>\n				</div>\n				<div class=\"prevPose\">\n					<ya-apt-preview parent=\"vm\" type=\"\'appointmentAvailable\'\"></ya-apt-preview>\n				</div>\n            </div>\n        	<ya-main-footer></ya-main-footer>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/pages/apptedit/apptedit.html","<div id=\"apptedit\" layout=\"row\">\n    <div class=\"shrink\" layout=\"row\" layout-align=\"start\" flex>\n        <div layout=\"column\" flex>\n	        <ya-main-header page=\"Announcement Editor\"></ya-main-header>\n            <div layout=\"row\">\n\n				<md-sidenav class=\"md-sidenav-left sidenavi tentwentyfive left\" md-component-id=\"left\" md-is-locked-open=\"$mdMedia(\'min-width: 1000px\')\" md-disable-backdrop md-whiteframe=\"4\" layout=\"column\" layout-align=\"start center\">\n					<ya-appt-book></ya-appt-book>\n				</md-sidenav>\n\n				<div class=\"contentBox\" layout=\"row\" ng-show=\"vm.isValid\">\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n					<div class=\"editorCont tentwentyfive editPose\" layout=\"column\" layout-align=\"center center\">\n						<md-input-container class=\"nameSpace inputPadding\">\n                        	<input aria-label=\"name\" class=\"fontSize\" ng-model=\"vm.data.name\">\n                        </md-input-container>\n						<div class=\"whiteBlock\" layout=\"row\" layout-align=\"center center\">\n							<div class=\"editorBox\"><ya-editor-window data=\"vm.data\" parent=\"vm\"></ya-editor-window></div>\n						</div>\n					</div>\n\n					<div class=\"preview tentwentyfive\">\n						<ya-apt-preview parent=\"vm\" type=\"\'appointmentEditor\'\"></ya-apt-preview>\n					</div>\n				</div>\n            </div>\n            <div class=\"previewBox\">\n            	<ya-main-footer></ya-main-footer>\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/pages/apptschedule/apptschedule.html","<div id=\"apptSched\" layout=\"row\">\n    <div layout=\"row\" layout-align=\"start\" flex>\n        <div layout=\"column\" flex>\n	        <ya-main-header page=\"Scheduler\"></ya-main-header>\n            <div layout=\"row\">\n\n\n				<div class=\"sideNavi\" layout=\"column\" flex=\"none\">\n		            <ya-main-sidenav></ya-main-sidenav>\n		        </div>\n				<div layout=\"row\" class=\"contentBump\">\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n					<div class=\"listCont\" layout=\"column\" layout-align=\"start center\">\n\n						<md-autocomplete class=\"autosize\" md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" md-items=\"item in vm.getMatches(vm.searchText)\" md-item-text=\"item.name\" md-selected-item-change=\"vm.selectUser(vm.selectedItem)\" md-icon=\"/assets/images/icons/navicon-reporting.svg\" placeholder=\"search by name or phone#\">\n	                        <md-item-template><image ng-show=\"item.profileimage\" ng-src=\"{{item.profileimage}}\" class=\"apptSchedIcon\"></image><span md-highlight-text=\"searchText\">{{item.name}}</span></md-item-template>\n	                    </md-autocomplete>\n\n						<label>Current</label>\n						<div class=\"currentUser\">\n							{{vm.currentUser.name}}\n						</div>\n\n						<div class=\"listBox shadow\" ng-click=\"vm.adjustList()\">\n							<label>Waiting List</label>\n							<div class=\"userCard\" ng-repeat=\"user in vm.waitingUserList\" ng-click=\"vm.getUser(vm.waitingUserList,user); $event.stopPropagation();\">\n								{{user.name}}\n							</div>\n						</div>\n\n						<div class=\"listBox shadow\" ng-click=\"vm.adjustAttendeeList()\">\n							<label>Attendee List</label>\n							<div class=\"userCard\" ng-repeat=\"user in vm.attendeeUserList\" ng-click=\"vm.getUser(vm.attendeeUserList,user); $event.stopPropagation();\">\n								{{user.name}}\n							</div>\n						</div>\n					</div>\n					<div>\n						<div class=\"upperCont\" layout=\"row\" layout-align=\"start center\">\n							<div layout=\"row\">\n								<div class=\"calsize shadow\">\n									<md-calendar ng-model=\"vm.date\" ng-change=\"vm.checkDate()\"></md-calendar>\n								</div>\n								<div class=\"tenpx\"></div>\n								<div>\n									<div>\n										<md-select class=\"mdSelect\" ng-model=\"vm.month\" ng-change=\"vm.Change()\">\n											<md-option ng-repeat=\"data in vm.monthList track by $index\">{{data}}</md-option>\n										</md-select>\n										<md-select class=\"mdSelect\" ng-model=\"vm.year\" ng-change=\"vm.Change()\">\n											<md-option ng-repeat=\"data in vm.yearList track by $index\">{{data}}</md-option>\n										</md-select>\n										<md-button class=\"schedButtons todayButton adminButton buttonColor2\" ng-click=\"vm.SelectToday()\"><div class=\"buttonText\">Today</div></md-button>\n									</div>\n								</div>\n							</div>\n						</div>\n						<div class=\"lowerCont\" layout=\"row\" layout-align=\"start center\">\n							<div class=\"calBox shadow\">\n								<div class=\"calandar\">\n									<div id=\"grid\" class=\"unselectable gridbody scroll-bar-wrap\">\n										<div layout=\"row\" class=\"unselectable dateNudge\" layout-align=\"\">\n											<div class=\"datebox unselectable\"></div>\n											<div class=\"datebox unselectable\" ng-repeat=\"x in vm.days\">\n												<p class=\"datePadding\">{{x.name}} {{x.date}}</p>\n											</div>\n										</div>\n										<div id=\"gridScroll\" class=\"content unselectable scroll-box\" ng-mouseleave=\"vm.mouseLeave()\">\n											<div layout=\"row\" layout-align=\"\" class=\"unselectable\" ng-repeat=\"y in vm.times\">\n												<div class=\"timebox unselectable\" ng-style=\"y.style\">\n													<p class=\"timeCenter\">{{y.name}}</p>\n												</div>\n												<div class=\"cellbox unselectable\" ng-style=\"y.cell\" ng-repeat=\"x in vm.days\" ng-mouseover=\"vm.touch(x,y)\" ng-click=\"vm.click(x,y)\">\n												</div>\n											</div>\n											<div class=\"reSlotOject\" ng-style=\"o.style\" ng-repeat=\"o in vm.curWeek.reschedule\">\n											</div>\n											<div class=\"unavailable\" ng-style=\"u.style\" ng-repeat=\"u in vm.curWeek.unavailable\">\n											</div>\n											<div class=\"userobject\" style=\"overflow:hidden\" ng-repeat=\"o in vm.curWeek.userObjects\" ng-style=\"o.style\" ng-click=\"vm.clickUserObject(o)\">\n												<span>{{o.userobject.name}}</span>\n											</div>\n											<div class=\"floatobject\" style=\"overflow:hidden\" ng-style=\"vm.floatObject.style\">\n												<span>{{vm.currentUser.name}}</span>\n											</div>\n										</div>\n										<div class=\"cover-bar\"></div>\n									</div>\n								</div>\n								<div class=\"calCap\"></div>\n							</div>\n						</div>\n					</div>\n				</div>\n				<div class=\"prevPose\">\n					<ya-apt-preview parent=\"vm\" type=\"\'appointmentScheduler\'\"></ya-apt-preview>\n				</div>\n            </div>\n            <ya-main-footer></ya-main-footer>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/pages/apptselect/apptselect.html","<div id=\"wrap\" class=\"announce-select\" layout-fill>\n	<ya-main-header page=\"Select Template\"></ya-main-header>\n\n	<div class=\"main-area\" layout=\"row\">\n\n		<!-- <ya-main-sidenav></ya-main-sidenav> -->\n		<div flex=\"non\" class=\"sidebar\" layout=\"column\" layout-align=\"center center\">\n			<md-button class=\"md-raised cancel-btn\" aria-label=\"cancel\" ng-click=\"vm.Nav(\'alert\')\">\n				Cancel\n			</md-button>\n		</div>\n\n		<md-content layout-fill layout-padding>\n      <ya-help-menu help-page=\"\"></ya-help-menu>\n\n			<md-input-container>\n				<md-select aria-label=\"sort by\" ng-model=\"vm.currentSort\">\n					<md-option ng-repeat=\"sorts in vm.sorts\">\n					{{sorts}}\n					</md-option>\n				</md-select>\n			</md-input-container>\n\n\n\n			<div layout=\"row\" layout-fill layout-wrap layout-margin>\n\n				<div class=\"grid-cards\" flex=\"none\" layout=\"column\" layout-align=\"start center\" ng-repeat=\"data in vm.list track by $index\">\n\n					<ya-select-card data=\"data\" parent=\"vm\"></ya-select-card>\n				</div>\n			</div>\n\n		</md-content>\n	</div>\n	<ya-main-footer></ya-main-footer>\n</div>\n\n\n\n<!-- <div class=\"container\">\n\n	<div class=\"jumbotron text-center\">\n		<h1>{{vm.name}}</h1>\n	</div>\n\n	<div>\n		<button ng-click=\'vm.onCreate()\' style=\"width:100%\">\n			<p>New Template</p>\n		</button>\n	</div>\n\n	<div ng-repeat=\"data in vm.list track by $index\">\n		<div>\n			<button ng-click=\'vm.onSelect(data)\' style=\"width:100%\">\n				<p>{{data.status}}</p>\n				<p>{{data.name}}</p>\n			</button>\n		</div>\n	</div>\n\n</div> -->\n");
$templateCache.put("app/pages/billing/billing.html","<div id=\"billing\">\n\n	<div class=\"page\" layout=\"row\">\n\n        <div class=\"leftContent\">\n\n            <img class=\"tenpx\" src=\"assets\\images\\onboarding-logo.png\">\n\n            <div layout=\"column\" layout-align=\"center center\" flex=\"100\">\n\n                <div class=\"title\" layout=\"column\" layout-align=\"center center\">BILLING INFO</div>\n\n                <form name=\"setupForm\" ng-submit=\"vm.SetUp(setupForm.$valid)\" class=\"bicontent\" ng-show=\"vm.billing.loaded==false\" layout=\"column\" layout-align=\"center\" flex>\n\n                    <md-content class=\"formSize\">\n                      <ya-help-menu help-page=\"\"></ya-help-menu>\n\n                        <div layout=\"column\" layout-align=\"center center\">\n\n                            <md-input-container class=\"md-block inputCont\">\n                                <label>Payment Method</label>\n                                <md-select aria-label=\"payment method\" name=\"payMethod\" required ng-model=\"vm.billing.method\" ng-change=\"vm.Update()\">\n                                    <md-option ng-repeat=\"t in vm.billingTypes\">{{t}}</md-option>\n                                </md-select>\n                                <div ng-messages=\"setupForm.payMethod.$error\" ng-show=\"setupForm.payMethod.$touched\">\n                                    <div ng-message=\"required\">Select payment method</div>\n                                </div>\n                            </md-input-container>\n\n                            <div layout=\"column\">\n                                <md-input-container class=\"md-block inputCont\">\n                                    <label>First Name</label>\n                                    <input type=\"text\" aria-label=\"first name\" name=\"fName\" required ng-model=\"vm.billing.billtofirstname\">\n                                    <div ng-messages=\"setupForm.fName.$error\" ng-show=\"setupForm.fName.$dirty\">\n                                        <div ng-message=\"required\">First name required</div>\n                                    </div>\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputCont\">\n                                    <label>Last Name</label>\n                                    <input type=\"text\" aria-label=\"last name\" name=\"lName\" required ng-model=\"vm.billing.billtolastname\">\n                                    <div ng-messages=\"setupForm.lName.$error\" ng-show=\"setupForm.lName.$dirty\">\n                                        <div ng-message=\"required\">Last name required</div>\n                                    </div>\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputCont\">\n                                    <label>Email</label>\n                                    <input type=\"email\" aria-label=\"email\" name=\"email\" required ng-pattern=\"vm.ePattern\" ng-model=\"vm.billing.email\">\n                                    <div ng-messages=\"setupForm.email.$error\" ng-show=\"setupForm.email.$dirty\">\n                                        <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid email required</div>\n                                    </div>\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputCont\">\n                                    <label>Address</label>\n                                    <input type=\"text\" aria-label=\"address\" name=\"address\" required ng-model=\"vm.billing.address\">\n                                    <div ng-messages=\"setupForm.address.$error\" ng-show=\"setupForm.address.$dirty\">\n                                        <div ng-message=\"required\">Address required</div>\n                                    </div>\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputCont\">\n                                    <label>City</label>\n                                    <input type=\"text\" aria-label=\"city\" name=\"city\" required ng-model=\"vm.billing.city\">\n                                    <div ng-messages=\"setupForm.city.$error\" ng-show=\"setupForm.city.$dirty\">\n                                        <div ng-message=\"required\">City required</div>\n                                    </div>\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputCont\">\n                                    <label>Zip</label>\n                                    <input type=\"text\" class=\"no-spinbox\" aria-label=\"zip code\" name=\"zip\" required ng-pattern=\"vm.zPattern\" ng-model=\"vm.billing.zip\">\n                                    <div ng-messages=\"setupForm.zip.$error\" ng-show=\"setupForm.zip.$dirty\">\n                                        <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid zip code required</div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n\n                        </div>\n\n                        <div ng-show=\"vm.billing.method==\'Bank Account\'\" layout=\"column\" layout-align=\"start center\">\n                            <md-input-container class=\"md-block inputCont\">\n                                <label>Bank Name</label>\n                                <input aria-label=\"bank name\" name=\"bank\" type=\"text\" ng-required=\"vm.billing.method==\'Bank Account\'\" ng-model=\"vm.billing.bankName\">\n                                <div ng-messages=\"setupForm.bank.$error\" ng-show=\"setupForm.bank.$dirty\">\n                                    <div ng-message=\"required\">Bank name required</div>\n                                </div>\n                            </md-input-container>\n                            <md-input-container class=\"md-block inputCont\">\n                                <label>Routing #</label>\n                                <input aria-label=\"routing number\" name=\"routing\" type=\"text\" class=\"no-spinbox\" ng-required=\"vm.billing.method==\'Bank Account\'\" ng-pattern=\"vm.rPattern\" ng-model=\"vm.billing.routingNumber\">\n                                <div ng-messages=\"setupForm.routing.$error\" ng-show=\"setupForm.routing.$dirty\">\n                                    <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid routing number required</div>\n                                </div>\n                            </md-input-container>\n                            <md-input-container class=\"md-block inputCont\">\n                                <label>Account #</label>\n                                <input aria-label=\"account number\" name=\"account\" type=\"text\" class=\"no-spinbox\" ng-required=\"vm.billing.method==\'Bank Account\'\" ng-pattern=\"vm.aPattern\" ng-model=\"vm.billing.accountNumber\">\n                                <div ng-messages=\"setupForm.account.$error\" ng-show=\"setupForm.account.$dirty\">\n                                    <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid account number required</div>\n                                </div>\n                            </md-input-container>\n                            <md-input-container class=\"md-block inputCont\">\n                                <label>Account Type</label>\n                                <md-select aria-label=\"account type\" name=\"accountType\" ng-required=\"vm.billing.method==\'Bank Account\'\" ng-model=\"vm.billing.accountType\">\n                                    <md-option ng-repeat=\"t in vm.bankAccountTypes\">{{t}}</md-option>\n                                </md-select>\n                                <div ng-messages=\"setupForm.accountType.$error\" ng-show=\"setupForm.accountType.$dirty\">\n                                    <div ng-message=\"required\">Select account type</div>\n                                </div>\n                            </md-input-container>\n                        </div>\n\n                        <div ng-show=\"vm.billing.method==\'Credit Card\'\" layout=\"column\" layout-align=\"center center\">\n                            <md-input-container class=\"md-block inputCont\" flex>\n                                <label>Card Number</label>\n                                <input aria-label=\"card number\" name=\"card\" type=\"text\" class=\"no-spinbox\" ng-required=\"vm.billing.method==\'Credit Card\'\" ng-pattern=\"vm.cPattern\" ng-model=\"vm.billing.cardNumber\">\n                                <div ng-messages=\"setupForm.card.$error\" ng-show=\"setupForm.card.$dirty\">\n                                    <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid card number required</div>\n                                </div>\n                            </md-input-container>\n                            <h4>Expiration Date</h4>\n                            <md-content class=\"cardDate\">\n                                <label>Month</label>\n                                <md-datepicker name=\"date\" ng-model=\"vm.billing.expDate\" ng-required=\"vm.billing.method==\'Credit Card\'\" md-placeholder=\"Enter date\"></md-datepicker>\n                                <div ng-messages=\"setupForm.date.$error\">\n                                  <div ng-message=\"required\">You must select a date.</div>\n                                </div>\n                            </md-content>\n                            <md-content class=\"cardDate\">\n                                <label>Year</label>\n                                <md-datepicker name=\"date\" ng-model=\"vm.billing.expDate\" ng-required=\"vm.billing.method==\'Credit Card\'\" md-placeholder=\"Enter date\"></md-datepicker>\n                                <div ng-messages=\"setupForm.date.$error\">\n                                  <div ng-message=\"required\">You must select a date.</div>\n                                </div>\n                            </md-content>\n                            <md-input-container class=\"md-block inputCont\" flex>\n                                <label>CVC</label>\n                                <input aria-label=\"cvc\" name=\"cvc\" type=\"text\" class=\"no-spinbox\" ng-required=\"vm.billing.method==\'Credit Card\'\" ng-pattern=\"vm.cvcPattern\" ng-model=\"vm.billing.cardCode\">\n                                <div ng-messages=\"setupForm.cvc.$error\" ng-show=\"setupForm.cvc.$dirty\">\n                                    <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid security code required</div>\n                                </div>\n                            </md-input-container>\n                        </div>\n\n\n\n                        <div ng-show=\"vm.billing.method==\'PayPal\'\" layout=\"column\" layout-align=\"start center\">\n                            <md-input-container class=\"md-block inputCont\" flex>\n                                <label>Account Number?</label>\n                                <input aria-label=\"paypal account\" ng-model=\"vm.billing.paypalAccount\">\n                            </md-input-container>\n                        </div>\n\n\n                    </md-content>\n\n                    <div flex=\"100\"></div>\n\n                    <div class=\"buttondiv\" layout=\"row\" layout-align=\"center end\">\n\n                        <md-button aria-label=\"go back\" class=\"md-raised backButton\" ng-click=\"vm.Back()\" class=\"btn btn-primary\" flex>Back</md-button>\n\n                        <md-button aria-label=\"continue\" class=\"md-raised contButton\" type=\"submit\" class=\"btn btn-primary\" flex>Continue</md-button>\n\n                    </div>\n\n                </form>\n\n\n                <div ng-show=\"vm.billing.loaded==true\">\n                    <div class=\"bicontent\" layout=\"column\" layout-align=\"center\" flex>\n                        <div class=\"billingCont\" layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"5\"></div>\n                            <div>First Name</div>\n                            <div flex></div>\n                            <div>{{vm.billing.billtofirstname}}</div>\n                            <div flex=\"5\"></div>\n                        </div>\n                        <div class=\"billingCont\" layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"5\"></div>\n                            <div>Last Name</div>\n                            <div flex></div>\n                            <div>{{vm.billing.billtolastname}}</div>\n                            <div flex=\"5\"></div>\n                        </div>\n                        <div class=\"billingCont\" layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"5\"></div>\n                            <div>Email</div>\n                            <div flex></div>\n                            <div>{{vm.billing.email}}</div>\n                            <div flex=\"5\"></div>\n                        </div>\n                        <div class=\"billingCont\" layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"5\"></div>\n                            <div>Address</div>\n                            <div flex></div>\n                            <div>{{vm.billing.address}}</div>\n                            <div flex=\"5\"></div>\n                        </div>\n                        <div class=\"billingCont\" layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"5\"></div>\n                            <div>City</div>\n                            <div flex></div>\n                            <div>{{vm.billing.city}}</div>\n                            <div flex=\"5\"></div>\n                        </div>\n                        <div class=\"billingCont\" layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"5\"></div>\n                            <div>Zip</div>\n                            <div flex></div>\n                            <div>{{vm.billing.zip}}</div>\n                            <div flex=\"5\"></div>\n                        </div>\n                        <div class=\"Spaceing\"></div>\n                        <div ng-show=\"vm.billing.method==\'Bank Account\'\">\n                            <div class=\"billingCont\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Account Type</div>\n                                <div flex></div>\n                                <div>{{vm.billing.accountType}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                             <div class=\"billingCont\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Routing Number</div>\n                                <div flex></div>\n                                <div>{{vm.billing.routingNumber}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"billingCont\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Account Number</div>\n                                <div flex></div>\n                                <div>{{vm.billing.accountNumber}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                        </div>\n\n                        <div ng-show=\"vm.billing.method==\'Credit Card\'\">\n                            <div class=\"billingCont\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Card Number</div>\n                                <div flex></div>\n                                <div>{{vm.billing.cardNumber}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                        </div>\n                        <div class=\"\" layout=\"row\" layout-align=\"center center\">\n                            <md-button aria-label=\"delete\" class=\"md-raised\" ng-click=\"vm.Remove()\" class=\"btn btn-primary\" flex>Delete</md-button>\n                        </div>\n\n                    </div>\n                    <div class=\"buttondiv\" layout=\"row\" layout-align=\"center center\" layout-padding>\n\n                        <md-button aria-label=\"go back\" class=\"md-raised backButton\" ng-click=\"vm.Back()\" class=\"btn btn-primary\" flex>Back</md-button>\n\n                        <md-button aria-label=\"continue\" class=\"md-raised contButton\" ng-click=\"vm.ClickContinue()\" class=\"btn btn-primary\" flex>Continue</md-button>\n\n                    </div>\n                </div>\n        </div>\n\n\n        </div>\n\n        <div class=\"tutorial\">\n        </div>\n    </div>\n\n\n\n</div>\n");
$templateCache.put("app/pages/brightpattern/brightpattern.html","<div class=\"brightpattern\" layout=\"row\" layout-align=\"start start\" style=\"margin-top:30px; width:100%\">\n\n  <!-- Sidebar for Operator Instructions -->\n  <div class=\"brightpattern-sidebar\" layout=\"column\" style=\"height: 100vh; overflow-y: auto\">\n\n    <md-card>\n      <md-card-content>\n        <div style=\"font-weight:600; font-size:16px; margin-bottom:6px\">\n          Guardian Link – Urgent Assist Operator Instructions\n        </div>\n        <div style=\"font-size:13px; line-height:1.5; white-space:pre-line; overflow:auto\">\n          Guardian Link – Urgent Assist Operator Instructions\n          For Telecom Inc Contact Center Agents\n\n          1. Initial Actions upon pop-up\n          • Step 1: Click REPLY → Add a short, supportive text message → Click SEND.\n          • Step 2: Click CALL (outbound call to vulnerable person).\n\n          2. Call Introduction\n          Agent: \"Hi, this is Amy, Urgent Response Coordinator 106 from Guardian Link. I received your Urgent Assist.\n          Are you Dick?\"\n\n          • If Yes → Proceed to Calm & Assess the Situation.\n          • If No answer →\n          o ACTION: Immediately dispatch law enforcement. Click 911 button on pop-up → Click SEND on template.\n          o Agent Voicemail: \"This is Amy, Urgent Response Coordinator Serial Number 106. I received your urgent assist\n          and immediately dispatched the police.\"\n\n          3. Calm and Assess the Situation\n          • Agent: \"Dick, are you OK?\"\n\n          If No:\n          • ACTION: Immediately dispatch law enforcement (911 button + SEND template).\n          • Agent: \"Dick, I\'ve dispatched the police. I\'m on the phone with you. Are you able to speak freely? Tell me\n          what is happening.\"\n          • Type notes in the Notes Box.\n          • Stay on the call until the Police arrive.\n          • Go to Verify Location and Situation\n\n          If Yes:\n          • Agent: \"Can you talk freely?\"\n          • If Yes → Go to Verify Location and Situation\n          • If person reports they are ok → Walk them to safety and \"Thank you for using Guardian Link.\"\n          • No 911 dispatch required → close call.\n\n          4. Verify Location and Situation\n          • Agent: \"I can see your location. Can you confirm if you\'re near [park, street intersection]?\"\n          • Agent: \"Can you tell me if the person following you is still visible and describe what they look like?\"\n          (If caller too distressed → reassure that help is on the way.)\n\n          5. Provide Reassurance\n          • Agent: \"Stay as calm as you can. You\'ve done the right thing by reaching out. I have alerted law\n          enforcement. Help is minutes away.\"\n          • Keep the person talking. Suggest moving to well-lit, populated areas if possible.\n          • Remind them to avoid being trapped and keep the phone close.\n          • Stay on the line until help arrives.\n\n          6. Ensure Continuous Support\n          • Agent: \"Help is on the way, Dick. Can you hear sirens or see anyone nearby yet?\"\n          • If police delayed, reassess situation and encourage safe movement.\n\n          7. Resolution\n          • Once law enforcement arrives:\n          o Agent: \"Dick, the police are with you now, and you\'re in safe hands. If you need follow-up support, please\n          let them know. I\'ll also file a report to ensure everything is recorded.\"\n\n          8. Post-Call Notes & Protocol\n          • Confirm with Quick Response Monitoring that law enforcement was successfully dispatched.\n          o Record the XMIT number for verification.\n          • Complete system documentation and escalate if necessary.\n\n          ⚡ Golden Rule:\n          If caller says No / unsafe OR does not answer → IMMEDIATE 911 DISPATCH.\n          If caller says Yes / safe → Stay on line, reassure, and document.\n        </div>\n      </md-card-content>\n    </md-card>\n  </div>\n\n  <!-- Empty sidebar column -->\n  <div class=\"brightpattern-sidebar\" layout=\"column\" style=\"\">\n\n    <!-- Caller Details -->\n    <md-card>\n      <md-card-content>\n        <div style=\"font-weight:600; font-size:15px; margin-bottom:4px\">Caller Details</div>\n        <div style=\"font-size:13px; line-height:1.6\">\n          <div style=\"margin-top:6px\">\n            <strong>Sent By:</strong> {{ vm.sentBy || \'—\' }}\n          </div>\n          <div><strong>Email:</strong> {{ vm.sentByEmail || \'—\' }}</div>\n          <div><strong>Phone:</strong> {{ vm.sentByPhone || \'—\' }}</div>\n          <div><strong>DOB:</strong> {{ vm.sentByDOB | date:\'dd-MMM-yyyy\' || \'—\' }}\n            <strong>Age:</strong> {{ vm.sentByAge || \'—\' }}\n          </div>\n\n        </div>\n      </md-card-content>\n      <md-card-content>\n        <div style=\"display: flex; align-items: center; justify-content: space-between; margin-bottom:4px\">\n          <div style=\"font-weight:600; font-size:15px\">Call Notes</div>\n          <button ng-click=\"vm.copyNotes($event)\" style=\"border:none; background:none; cursor:pointer; font-size:16px\" title=\"Copy Notes\">\n            📋\n          </button>\n        </div>\n\n        <textarea ng-model=\"vm.callNotes\" placeholder=\"Type notes here...\" style=\"width:100%; min-height:120px; padding:8px; border:1px solid #ddd; border-radius:4px\"></textarea>\n\n        <div style=\"margin-top:8px\">\n          <label style=\"font-size:13px\">Dispatch XMIT #</label>\n          <input type=\"text\" ng-model=\"vm.dispatchXmit\" placeholder=\"e.g., XMIT-12345\" style=\"width:100%; padding:6px; border:1px solid #ddd; border-radius:4px\">\n        </div>\n      </md-card-content>\n\n\n\n    </md-card> \n\n  </div>\n\n  <div class=\"brightpattern-main\" layout=\"column\">\n    <canvas id=\"brightCanvas\" style=\"width:50%; height:auto; display:block; margin:0 auto\"></canvas>\n   \n    <!-- BrightPattern Universal Repeater Iframe -->\n\n    <div class=\"brightpattern-controls\" layout=\"row\" layout-align=\"space-between center\" style=\"width:100%; margin-top:12px\">\n\n      <!-- Back Button -->\n      <button class=\"md-default\" ng-click=\"vm.goBack()\" ng-if=\"vm.composeMode\" style=\"min-width:100px; padding:5px 41px; font-size:14px; border-radius:4px; background:black; color:white\">\n        Back\n      </button>\n\n      <span flex></span>\n\n      <!-- Send Button -->\n      <button class=\"md-primary\" ng-click=\"vm.sendTemplate()\" ng-disabled=\"vm.isSending || !vm.composeMode\" ng-if=\"vm.composeMode\" style=\"min-width:100px; padding:5px 41px; font-size:14px; border-radius:4px; background:orange\">\n        {{ vm.isSending ? \'Sending…\' : \'Send\' }}\n      </button>\n    </div>\n\n    <!-- Authentication Error Message -->\n    <div class=\"brightpattern-auth-error\" ng-if=\"vm.authenticationError\" style=\"background-color:#ffebee; border:1px solid #f44336; color:#d32f2f; padding:12px; margin:10px; border-radius:4px; text-align:center\">\n      <strong>Authentication Error:</strong> {{ vm.error }}\n      <br>\n      <small>Please refresh the page or contact your administrator.</small>\n    </div>\n\n    <!-- Call Status Display -->\n    <div class=\"brightpattern-call-status\" ng-if=\"vm.callStatus !== \'idle\'\" style=\"background-color:#e3f2fd; border:1px solid #2196f3; color:#1976d2; padding:8px; margin:10px; border-radius:4px; text-align:center\">\n      <strong>Call Status:</strong> {{ vm.callStatusMessage }}\n      <br ng-if=\"vm.callStatus === \'connected\'\">\n      <small ng-if=\"vm.callStatus === \'connected\'\">Call Duration: {{ vm.callTimerDisplay() }}</small>\n    </div>\n\n\n    <!-- Error Message -->\n    <div class=\"brightpattern-status\" ng-if=\"vm.error && !vm.authenticationError\" style=\"color:red; font-size:13px; margin-top:6px; text-align:center\">\n      {{ vm.error }}\n    </div>\n  </div>\n</div>");
$templateCache.put("app/pages/bulksms/bulksms.html","<div id=\"bulksms\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout=\"row\" layout-fill class=\"main-area\">\n          <div style=\"padding-left: 10px; max-width: 1242px\" layout=\"row\">\n            <div>\n              <div layout=\"row\">\n                <h1>Bulk SMS</h1>\n              </div>\n              <div layout=\"row\">\n                <div layout=\"column\">\n                  <md-input-container>\n                    <label>SMS Message</label>\n                    <textarea name=\"message\" ng-model=\"vm.data.message\" md-maxlength=\"160\" cols=\"100\" rows=\"10\"></textarea>\n                  </md-input-container>\n                </div>\n              </div>\n              <div>\n                <div layout=\"row\">\n                  <div layout=\"column\">\n                    <input type=\"file\" id=\"file-upload1\" ng-show=\"false\" name=\"{{$index}}\" accept=\".csv\" onchange=\"angular.element(this).scope().vm.CSVFile(this)\">\n                    <label layout=\"row\" layout-align=\"start center\" for=\"file-upload1\" ng-click=\"vm.UploadUsers(\'file-upload1\')\" class=\"userButton buttonColor1\">\n                      <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n                      Import CSV\n                    </label>\n                  </div>\n                </div>\n              </div>\n              <div>\n                <div layout=\"row\">\n                  <div layout=\"column\">\n                    <label layout=\"row\" layout-align=\"start center\" ng-click=\"vm.SubmitForm()\" class=\"userButton buttonColor1\">\n                      Submit\n                    </label>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/category/category.html","<div id=\"category\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div class=\"title\">\n            Choose Your Organization\'s Categories\n          </div>\n\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div class=\"sub-title\">\n            Categories allow mobile users to \'follow\' specific aspects of an oganization.\n          </div>\n\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <!--buttons in a row  -->\n          <div class=\"buttonRow\" layout=\"row\">\n            <div flex=\"initial\">\n              <label class=\"userButton buttonColor1\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.AddCat(false)\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n                Add New Catagory\n              </label>\n            </div>\n          </div>\n\n          <ya-help-tips name=\"user\" data=\"vm.helpTipList\"></ya-help-tips>\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <!-- Category Content starts here -->\n          <div flex style=\"width:100%\">\n            <md-list class=\"setWidth\">\n              <!--table header starts here  -->\n              <md-list-item class=\"listItem listHover\" style=\"font-weight: 600; color: #585858; margin-bottom: 5px\">\n                <div style=\"height: 100%; width: 3.25%\"></div>\n                <div layout=\"row\" layout-align=\"center center\" style=\"font-size: 13px; font-weight: 600\">ENABLE</div>\n                <div style=\"height: 100%; width: 6.75%; min-width: 40px\"></div>\n                <div style=\"min-width: 120px; font-size: 13px; font-weight: 600\">CATEGORY NAME</div>\n                <div style=\"height: 100%; width: 90%\"></div>\n              </md-list-item>\n              <!--table header ends here  -->\n\n              <!--table rows start here  -->\n              <md-list-item class=\"listHover\" style=\"font-weight: 500; color: #585858; height:60px\" ng-repeat=\"x in vm.catList\">\n                <div style=\"height: 100%; width: 100%\" ng-show=\"!x.edit && x.enabled\" layout=\"row\" layout-align=\"start center\">\n                  <div style=\"height: 100%; width: 10%; min-width: 30px\"></div>\n                  <md-checkbox style=\"margin-bottom: -0px\" aria-label=\"enabled\" ng-change=\"vm.Disable(x)\" ng-model=\"x.enabled\"></md-checkbox>\n                  <div style=\"height: 100%; width: 15%; min-width: 60px\"></div>\n                  <div style=\"width: 250px; min-width: 250px\">{{x.name}}</div>\n                  <div style=\"height: 100%; width: 100%\"></div>\n                  <div layout=\"row\" style=\"height: 100%; width: 50%; min-width: 200px\">\n\n                    <div style=\"height: 100%; width: 20%\"></div>\n                    <div class=\"listbutton\" ng-click=\"vm.OpenEdit($index,true)\" style=\"color: #9b9b9b; cursor: pointer\">\n                      <img style=\"padding-right: 10px; padding-bottom: 3px\" src=\"assets\\images\\icons\\edit_icon-gray.png\">                      Edit\n                    </div>\n                    <div style=\"height: 100%; width: 20%\"></div>\n                    <div class=\"listbutton\" ng-click=\"vm.RemoveCat($index,true)\" style=\"cursor: pointer\">\n                      <img src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div>\n                </div>\n\n                <!-- Disabled Alpha\'d Version -->\n                <div style=\"height: 100%; width: 100%; opacity: 0.2\" ng-show=\"!x.edit && !x.enabled\" layout=\"row\" layout-align=\"start center\">\n                  <div style=\"height: 100%; width: 10%; min-width: 30px\"></div>\n                  <md-checkbox style=\"margin-bottom: -0px\" aria-label=\"enabled\" ng-change=\"vm.Disable(x)\" ng-model=\"x.enabled\"></md-checkbox>\n                  <div style=\"height: 100%; width: 15%; min-width: 60px\"></div>\n                  <div style=\"width: 250px; min-width: 250px\">{{x.name}}</div>\n                  <div style=\"height: 100%; width: 100%\"></div>\n                  <div layout=\"row\" style=\"height: 100%; width: 50%; min-width: 200px\">\n\n                    <div style=\"height: 100%; width: 20%\"></div>\n                    <div class=\"listbutton\" ng-click=\"vm.OpenEdit($index,true)\" style=\"color: #9b9b9b; cursor: pointer\">\n                      <img style=\"padding-right: 10px; padding-bottom: 3px\" src=\"assets\\images\\icons\\edit_icon-gray.png\">                      Edit\n                    </div>\n                    <div style=\"height: 100%; width: 20%\"></div>\n                    <div class=\"listbutton\" ng-click=\"vm.RemoveCat($index,true)\" style=\"cursor: pointer\">\n                      <img src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div>\n                  <!--<div style=\"height: 100%; width: 5%\"></div>-->\n                </div>\n\n                <div style=\"max-height: 75px; width: 100%\" ng-show=\"x.edit\" layout=\"row\" layout-align=\"start center\">\n                  <!--<div>{{$index+1}}</div>-->\n                  <div style=\"height: 100%; width: 10%\"></div>\n                  <md-checkbox style=\"margin-bottom: -0px\" aria-label=\"enabled\" ng-change=\"vm.Disable(x)\" ng-model=\"x.enabled\"></md-checkbox>\n                  <div style=\"height: 100%; width: 15%\"></div>\n                  <div layout=\"column\">\n                    <div style=\"width: 100%; height: 25px\"></div>\n                    <md-input-container style=\"min-width: 300px; font-size: 15px\">\n                      <label>Category Name</label>\n                      <input aria-label=\"category name\" type=\"text\" value=\"{{x.name}}\" ng-model=\"x.name\">\n                    </md-input-container>\n                  </div>\n                  <div style=\"height: 100%; width: 100%\"></div>\n                  <div class=\"listbutton\" layout=\"row\" layout-align=\"center center\" style=\"cursor: pointer; height: 100%; width: 50%; min-width: 200px\" ng-click=\"vm.CloseEdit($index,true)\">\n                    <img style=\"padding-right: 10px; padding-bottom: 3px\" src=\"/assets/images/icons/user-check.png\"> Done\n                    Editing\n                  </div>\n                </div>\n              </md-list-item>\n              <!--table rows end here  -->\n\n            </md-list>\n          </div>\n\n          <div layout=\"row\" style=\"width: 100%; padding-bottom:10px\">\n            <div flex></div>\n            <div paging page=\"vm.currentPage\" total=\"vm.totalPages\" page-size=\"1\" paging-action=\"vm.onPage()\" show-prev-next=\"true\" showfirst-last=\"true\"></div>\n            <div flex></div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/catgroup/catgroup.html","<div id=\"catgroup\" layout=\"row\">\n    <div id=\"wrapper\" layout=\"column\" flex>\n        <!-- <div class=\"header\" layout=\"row\" layout-align=\"start center\">\n            <img class=\"logo\" src=\"assets\\images\\you-brand-medium.png\">\n            <div class=\"profileLabel\">\n                Categories/Groups\n            </div>\n        </div> -->\n        <ya-main-header page=\"Categories/Groups\"></ya-main-header>\n        <div layout=\"row\">\n            <div class=\"sidenavi\" layout=\"column\" flex=\"none\">\n                <ya-main-sidenav></ya-main-sidenav>\n            </div>\n            <!-- <md-sidenav class=\"md-sidenav-left sidenavi\" md-component-id=\"left\" md-is-locked-open=\"$mdMedia(\'min-width: 700px\')\" md-disable-backdrop md-whiteframe=\"4\">\n                <div class=\"sideNavSize\">\n                    <ya-main-sidenav>\n                    </ya-main-sidenav>\n                </div>\n            </md-sidenav> -->\n            <div class=\"grey\" layout=\"column\" flex=\"100\">\n              <ya-help-menu help-page=\"\"></ya-help-menu>\n                <div class=\"contentBox\">\n                    <div class=\"titleSize\">\n                        Catagories\n                    </div>\n                    <md-content id=\"element\" class=\"scrollable\">\n                        <div class=\"group\" layout=\"column\" ng-repeat=\"x in vm.catList\" flex>\n                            <div ng-show=\"!x.edit\" layout=\"row\" layout-align=\"start center\">\n                                <div class=\"catSpace\"></div>\n                                <div class=\"pencil\" ng-click=\"vm.OpenEdit($index,true)\">\n                                    <!-- <md-icon md-svg-src = \'/assets/images/icons/ic_mode_edit_black_24px.svg\'> -->\n                                </div>\n                                <div class=\"penSpace\"></div>\n                                <div class=\"numSize\">{{$index+1}}</div>\n                                <div class=\"numberSpace\"></div>\n                                <div class=\"nameSpace\">{{x.name}}</div>\n                                <div class=\"checkBoxPadding\">\n                                    <md-checkbox aria-label=\"disable\" ng-change=\"vm.Disable(x)\" ng-model=\"x.disable\">Disable</md-checkbox>\n                                </div>\n                                <div class=\"checkboxSpace\"></div>\n                                <div>{{x.public}}</div>\n                                <div class=\"catReport\"></div>\n                                <div class=\"reporting\" ng-click=\"\">REPORTS</div>\n                                <div class=\"catReport\"></div>\n                                <div class=\"trash\" ng-click=\"vm.RemoveCat($index,true)\">\n                                    <!-- <md-icon md-svg-src = \'/assets/images/icons/ic_delete_black_24px.svg\'></md-icon> -->\n                                </div>\n                            </div>\n\n                            <div ng-show=\"x.edit\" layout=\"row\" layout-align=\"start center\">\n                                <div class=\"catSpace\"></div>\n                                <div>{{$index+1}}</div>\n                                <div class=\"penSpace\"></div>\n                                <md-input-container class=\"nameSpace inputPadding\">\n                                    <label>Institution Name</label>\n                                    <input aria-label=\"category name\" type=\"text\" value=\"{{x.name}}\" ng-model=\"x.name\">\n                                </md-input-container>\n                                <div class=\"penSpace\"></div>\n                                <!-- <select aria-label=\"space\"  class=\"input nameSpace\" ng-model=\"x.public\" value=\"{{x.public}}\">\n                                    <option>Public</option>\n                                    <option>Private</option>\n                                </select> -->\n\n                                <div class=\"penSpace\"></div>\n                                <div ng-click=\"vm.CloseEdit($index,true)\">\n                                    <md-icon md-svg-src=\"/assets/images/icons/ic_done_black_24px.svg\">\n                                </md-icon></div>\n                            </div>\n                             <md-divider></md-divider>\n                        </div>\n\n                        <div class=\"add-btn\" ng-show=\"vm.max==vm.current\" ng-click=\"vm.AddMax()\">+ &nbsp Purchase Additional Categories</div>\n\n                        <div class=\"add-btn\" ng-show=\"vm.max!=vm.current\" ng-click=\"vm.AddCat(true)\">+ &nbsp Add Categories</div>\n                    </md-content>\n                </div>\n                <div class=\"contentBox\">\n                    <div class=\"titleSize\">\n                        Groups\n                    </div>\n                    <md-content class=\"scrollable\">\n                        <div class=\"group\" ng-repeat=\"x in vm.grpList\" flex>\n\n                            <div ng-show=\"!x.edit\" layout=\"row\" layout-align=\"start center\">\n                                <div class=\"catSpace\"></div>\n                                <div class=\"pencil\" ng-click=\"vm.OpenEdit($index,false)\" class=\"md-icon-button\">\n                                    <!-- <md-icon md-svg-src = \'/assets/images/icons/ic_mode_edit_black_24px.svg\'> -->\n                                </div>\n                                <div class=\"penSpace\"></div>\n                                <div class=\"numSize\">{{$index+1}}</div>\n                                <div class=\"numberSpace\"></div>\n                                <div class=\"nameSpace\">{{x.name}}</div>\n                                <div class=\"checkBoxPadding\">\n                                    <md-checkbox aria-label=\"disable\" ng-change=\"vm.Disable(x)\" ng-model=\"x.disable\">Disable</md-checkbox>\n                                </div>\n                                <div class=\"checkboxSpace\"></div>\n                                <div>{{x.public}}</div>\n                                <div class=\"publicSpace\"></div>\n                                <div class=\"reportingSpace\"></div>\n                                <div class=\"reporting\" ng-click=\"vm.AddUsers(x)\">USERS</div>\n                                <div class=\"leftMargin\"></div>\n                                <div class=\"reporting\" ng-click=\"vm.UploadUsers($index)\">UPLOAD</div>\n                                <div class=\"leftMargin\"></div>\n                                <input type=\"file\" id=\"input{{$index}}\" ng-show=\"false\" name=\"{{$index}}\" accept=\".csv\" onchange=\"angular.element(this).scope().vm.CSVFile(this)\">\n                                <div class=\"trash\" ng-click=\"vm.RemoveCat($index,false)\" class=\"md-icon-button\">\n                                    <!-- <md-icon md-svg-src = \'/assets/images/icons/ic_delete_black_24px.svg\'></md-icon> -->\n                                </div>\n                            </div>\n\n                            <div ng-show=\"x.edit\" layout=\"row\" layout-align=\"start center\">\n                                <div class=\"catSpace\"></div>\n                                <div>{{$index+1}}</div>\n                                <div class=\"penSpace\"></div>\n                                <md-input-container class=\"nameSpace inputPadding\">\n                                    <input aria-label=\"group name\" type=\"text\" value=\"{{x.name}}\" ng-model=\"x.name\">\n                                </md-input-container>\n                                <div class=\"penSpace\"></div>\n                                <div ng-click=\"vm.CloseEdit($index,false)\" class=\"md-icon-button\">\n                                    <md-icon md-svg-src=\"/assets/images/icons/ic_done_black_24px.svg\">\n                                </md-icon></div>\n                            </div>\n\n                            <md-divider></md-divider>\n                        </div>\n                        <div>\n\n                            <div flex class=\"add-btn\" ng-show=\"vm.max==vm.current\" ng-click=\"vm.AddMax()\">+ &nbsp Purchase Additional Groups</div>\n\n                            <div flex class=\"add-btn\" ng-show=\"vm.max!=vm.current\" ng-click=\"vm.AddCat(false)\">+ &nbsp Add Group</div>\n                        </div>\n                    </md-content>\n                </div>\n            </div>\n        </div>\n        <ya-main-footer></ya-main-footer>\n    </div>\n</div>\n");
$templateCache.put("app/pages/catsetup/catsetup.html","<div id=\"catsetup\">\n\n	<div class=\"page\" layout=\"row\">\n\n		<div class=\"leftContent\">\n\n			<img class=\"tenpx\" src=\"assets\\images\\onboarding-logo.png\">\n\n			<div layout=\"column\" layout-align=\"center center\">\n				<div class=\"catgroupwidth\" layout=\"column\" layout-align=\"center center\">\n\n					<div class=\"title\" layout=\"column\" layout-align=\"center center\">\n					CATAGORIES SETUP\n					</div>\n\n					<md-content class=\"scrollable catgroupwidth\">\n            <ya-help-menu help-page=\"\"></ya-help-menu>\n						<div ng-repeat=\"x in vm.catList\" flex>\n\n							<div ng-show=\"!x.edit\" layout=\"row\">\n								<md-button aria-label=\"edit\" ng-click=\"vm.OpenEdit($index,true)\" class=\"md-icon-button\" flex=\"10\"><md-icon md-svg-src=\"/assets/images/icons/ic_mode_edit_black_24px.svg\"></md-icon></md-button>\n\n								<p flex=\"5\">{{$index+1}}</p>\n								<p flex=\"30\">{{x.name}}</p>\n\n								<md-checkbox aria-label=\"disable\" flex=\"25\">Disable</md-checkbox>\n								<p flex=\"10\">{{x.public}}</p>\n\n								<md-button aria-label=\"remove category\" ng-click=\"vm.RemoveCat($index,true)\" class=\"md-icon-button\" flex=\"10\"><md-icon md-svg-src=\"/assets/images/icons/ic_clear_black_24px.svg\"></md-icon></md-button>\n							</div>\n\n							<div ng-show=\"x.edit\" layout=\"row\">\n								<p flex=\"5\">{{$index+1}}</p>\n								<md-input-container flex>\n									<input aria-label=\"category name\" type=\"text\" value=\"{{x.name}}\" ng-model=\"x.name\">\n								</md-input-container>\n								<span flex=\"5\"></span>\n								<select aria-label=\"space\" flex=\"25\" class=\"input\" ng-model=\"x.public\" value=\"{{x.public}}\">\n									<option>Public</option>\n									<option>Private</option>\n								</select>\n								<span flex=\"5\"></span>\n								<md-button aria-label=\"close edit\" flex=\"10\" ng-click=\"vm.CloseEdit($index,true)\" class=\"md-icon-button\"><md-icon md-svg-src=\"/assets/images/icons/ic_done_black_24px.svg\"></md-icon></md-button>\n							</div>\n							<md-divider></md-divider>\n						</div>\n\n						<div class=\"add-btn\" ng-show=\"vm.max==vm.current\" ng-click=\"vm.AddMax()\">+ &nbsp Purchase Additional Categories</div>\n\n						<div class=\"add-btn\" ng-show=\"vm.max!=vm.current\" ng-click=\"vm.AddCat(true)\">+ &nbsp Add Categories</div>\n					</md-content>\n\n\n					<div class=\"title\" layout=\"column\" layout-align=\"center center\">\n					GROUP SETUP</div>\n\n					<md-content class=\"scrollable catgroupwidth\">\n						<div ng-repeat=\"x in vm.grpList\" flex>\n\n							<div ng-show=\"!x.edit\" layout=\"row\">\n								<md-button aria-label=\"edit\" flex=\"10\" ng-click=\"vm.OpenEdit($index,false)\" class=\"md-icon-button\"><md-icon md-svg-src=\"/assets/images/icons/ic_mode_edit_black_24px.svg\"></md-icon></md-button>\n\n								<p flex=\"5\">{{$index+1}}</p>\n								<p flex=\"30\">{{x.name}}</p>\n\n								<md-checkbox aria-label=\"disable\" flex=\"25\">Disable</md-checkbox>\n								<p flex=\"10\">{{x.public}}</p>\n\n								<md-button aria-label=\"remove category\" flex=\"10\" ng-click=\"vm.RemoveCat($index,false)\" class=\"md-icon-button\"><md-icon md-svg-src=\"/assets/images/icons/ic_clear_black_24px.svg\"></md-icon></md-button>\n							</div>\n\n							<div ng-show=\"x.edit\" layout=\"row\">\n								<p flex=\"5\">{{$index+1}}</p>\n								<md-input-container flex>\n									<input aria-label=\"group name\" aria-label=\"group name\" type=\"text\" value=\"{{x.name}}\" ng-model=\"x.name\">\n								</md-input-container>\n								<md-button aria-label=\"close edit\" flex=\"10\" ng-click=\"vm.CloseEdit($index,false)\" class=\"md-icon-button\"><md-icon md-svg-src=\"/assets/images/icons/ic_done_black_24px.svg\"></md-icon></md-button>\n							</div>\n\n							<md-divider></md-divider>\n						</div>\n						<div>\n\n							<div flex class=\"add-btn\" ng-show=\"vm.max==vm.current\" ng-click=\"vm.AddMax()\">+ &nbsp Purchase Additional Groups</div>\n\n							<div flex class=\"add-btn\" ng-show=\"vm.max!=vm.current\" ng-click=\"vm.AddCat(false)\">+ &nbsp Add Group</div>\n						</div>\n					</md-content>\n\n				</div>\n			</div>\n\n\n			<div class=\"nav-buttons\" layout=\"row\" layout-align=\"center\">\n				<md-button aria-label=\"back\" ng-click=\"vm.Back()\" class=\"md-raised contButton\">Back</md-button>\n				<md-button aria-label=\"continue\" ng-click=\"vm.Continue()\" class=\"md-raised backButton\">Continue</md-button>\n			</div>\n\n		</div>\n		<div class=\"tutorial\"></div>\n	</div>\n</div>\n");
$templateCache.put("app/pages/classlink/classlink.html","<div id=\"classlink\" layout=\"column\" class=\"background\" layout-fill>\n\n  <!-- family image -->\n  <div style=\"z-index: 25\" class=\"leftImage imageHide\">\n    <img src=\"assets\\images\\home-family.png\">\n  </div>\n\n  <!-- central container -->\n  <div style=\"z-index: 50\" layout=\"column\" layout-align=\"space-between center\" class=\"centralContainer\">\n\n    <!-- YouApp logo-->\n    <div style=\"padding-top: 80px; margin-bottom: 50px\">\n      <img src=\"assets\\images\\you-brand-lg.png\">\n    </div>\n\n    <div class=\"authorizing-text\">\n      <div ng-show=\"vm.state == \'redirecting\'\">Redirecting to classlink...</div>\n      <div ng-show=\"vm.state == \'exchanging\'\">Exchanging code for token, please wait...</div>\n      <div ng-show=\"vm.state == \'success\'\">Your link is ready!</div>\n    </div>\n\n    <div class=\"link-square\">\n      <div class=\"link-text\">\n        <div ng-show=\"vm.state == \'error\'\">Oops! Well that didn\'t work.</div>\n        <div ng-show=\"vm.state == \'redirecting\'\">Redirecting to classlink...</div>\n        <div ng-show=\"vm.state == \'exchanging\'\">Exchanging code for token, please wait...</div>\n        <div ng-show=\"vm.state == \'success\'\"><a href=\"{{vm.link}}\">Your link is ready! Click me!</a></div>\n      </div>\n    </div>\n\n    <div class=\"info-text-heading\">\n      In order to log into the You Get It First App with Classlink, please make sure you have the mobile application installed.\n    </div>\n\n    <div class=\"info-text-subtext\">\n      If you need to download it, please check your app store by clicking on the appropriate store badge:\n    </div>\n\n    <div class=\"mobile-icons\">\n      <a href=\"\"><img class=\"google\" src=\"assets\\images\\google-playstore-button.png\"></a>\n      <a href=\"\"><img class=\"apple\" src=\"assets\\images\\apple-appstore-button.png\"></a>\n    </div>\n\n  </div>\n\n  <!-- computer image -->\n  <div style=\"z-index: 20\" class=\"rightImage imageHide\">\n    <img src=\"assets\\images\\home-computers.png\">\n  </div>\n</div>\n");
$templateCache.put("app/pages/contact/contact.html","<div id=\"contact\" layout=\"row\">\n  <div class=\"page\" layout=\"row\" layout-align=\"start\" flex>\n    <div id=\"wrapper\" layout=\"column\" flex>\n      <ya-main-header page=\"Contact\"></ya-main-header>\n      <div layout=\"row\">\n        <div class=\"sideNavi\" layout=\"column\" flex=\"none\">\n          <ya-main-sidenav></ya-main-sidenav>\n        </div>\n        <div class=\"contentPosition\" layout=\"column\" layout-align=\"center center\" flex>\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n          <div style=\"height: 5%; width: 100%\"></div>\n          <div class=\"titleBox\" layout=\"row\">\n            <div class=\"title\">\n              Contact Us\n            </div>\n          </div>\n          <div style=\"height: 2.5%; width: 100%\"></div>\n          <div class=\"titleBox\" layout=\"row\">\n            <div class=\"sub-title\">\n              We\'re here to help!\n            </div>\n          </div>\n          <div style=\"height: 5%; width: 100%\"></div>\n          <div class=\"whiteBlock\">\n            <div class=\"img-block\" layout-align=\"center center\">\n              <img src=\"assets\\images\\contact-us\\contact_youapp_logo.png\">\n            </div>\n            <div class=\"contact-block\">\n              <div class=\"contact-content\">\n                <div class=\"address-container\">\n                  <img src=\"assets\\images\\contact-us\\contact_address_icon.png\">\n                  <div class=\"content-container\">\n                    <div>321 St. Geroge Street</div>\n                    <div>Green Bay, WI 54302</div>\n                  </div>\n                </div>\n                <div class=\"email-container\">\n                  <img src=\"assets\\images\\contact-us\\contact_email_icon.png\">\n                  <div class=\"content-container\">\n                    <div>support@yougetitfirst.com</div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <ya-main-footer></ya-main-footer>\n  </div>\n</div>\n");
$templateCache.put("app/pages/continue/continue.html","<div id=\"continue\">\n\n	<div class=\"page\" layout=\"row\">\n    <ya-help-menu help-page=\"\"></ya-help-menu>\n	        <div class=\"leftContent\">\n\n	            <img class=\"tenpx\" src=\"assets\\images\\onboarding-logo.png\">\n\n	            <div layout=\"column\" layout-align=\"center center\" flex=\"100\">\n\n	                <div class=\"title\" layout=\"column\" layout-align=\"center center\">Continue On Boarding?</div>\n\n					<div class=\"buttonCont\" ng-repeat=\"x in vm.list\">\n						<md-button aria-label=\"name\" ng-click=\"vm.Continue($index)\" class=\"btn btn-primary\">{{x.name}}</md-button>\n						<br>\n					</div>\n\n	                <div layout=\"row\" layout-align=\"center center\">\n\n						<md-button aria-label=\"back\" onclick=\"location.href=\'#existing\'\" class=\"md-raised backButton\">Back</md-button>\n\n						<md-button aria-label=\"start new\" ng-click=\"vm.New()\" class=\"md-raised contButton\">Start New</md-button>\n\n					</div>\n\n	        </div>\n\n	        </div>\n\n	        <div class=\"tutorial\">\n	        </div>\n	    </div>\n\n</div>\n");
$templateCache.put("app/pages/dashboard/dashboard-help.html","<div class=\"top-help-content\">\n  <img src=\"/assets/images/help-drawer/quickstart_rocket.png\">\n  <div class=\"help-content\">\n    First time user?\n  </div>\n</div>\n<div class=\"help-topics-section\">\n  <h4>\n    Dashboard Help\n  </h4>\n  <p>Top help topics</p>\n  <ul>\n    <li><a href=\"\">How do I create a message?</a></li>\n    <li><a href=\"\">What is a Category</a></li>\n    <li><a href=\"\">What is a Group?</a></li>\n    <li><a href=\"\">How do I upload users?</a></li>\n  </ul>\n</div>\n<div class=\"help-csv-section\">\n  <div class=\"help-image\">\n    <img src=\"/assets/images/help-drawer/quickstart_rocket.png\">\n  </div>\n  <div class=\"csv-content\">\n\n  </div>\n</div>\n<div class=\"help-csv-section\">\n  <div class=\"help-image\">\n    <img src=\"/assets/images/help-drawer/quickstart_rocket.png\">\n  </div>\n  <div class=\"csv-content\">\n\n  </div>\n</div>\n<div class=\"bottom-help-content\">\n  <div class=\"help-image\">\n    <img src=\"/assets/images/help-drawer/quickstart_rocket.png\">\n  </div>\n  <div class=\"help-content\">\n\n  </div>\n</div>\n");
$templateCache.put("app/pages/dashboard/dashboard.html","<div id=\"dashboard\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout=\"row\" layout-fill class=\"main-area\">\n          <!--Message Count-->\n          <div flex=\"50\">\n            <div layout=\"column\" layout-fill>\n              <div class=\"title\">\n                Current Message Counts:-\n              </div>\n              <div style=\"height: 10px; width: 100%\"></div>\n              <div class=\"sub-title\">\n                These are your message totals.\n              </div>\n\n\n              <div flex layout-fill>\n                <div class=\"card-div\" layout=\"row\" layout-align=\"start center\" layout-padding layout-wrap>\n                  <div flex=\"none\" layout=\"column\" ng-repeat=\"data in vm.curMsgCount track by $index\">\n                    <ya-dashboard-card data=\"data\"></ya-dashboard-card>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <!--Pending Approval-->\n          <div flex=\"50\" ng-show=\"vm.mypermission\">\n            <div layout=\"column\" layout-fill>\n              <div class=\"pendingTitle\">\n                Pending Approval:\n              </div>\n              <div style=\"height: 10px; width: 100%\"></div>\n              <div class=\"pendingSub\">\n                Please take action on these items.\n              </div>\n\n              <div layout=\"row\" layout-align=\"start center\" class=\"pendingBox\" ng-repeat=\"data in vm.pendApproves\">\n                <div flex=\"noshrink\" class=\"button-space\" layout=\"column\" layout-align=\"center center\">\n                  <md-button aria-label=\"announcment\" ng-click=\"vm.PendingApproval(data)\" type=\"submit\">\n                    <div class=\"\">GO</div>\n                  </md-button>\n                </div>\n                <div flex=\"noshrink\" layout=\"column\" layout-align=\"center center\" class=\"approvalVal\">\n                  <span ng-class=\"(data.qty > 0) ? \'pending-circle\' : \'unpending\'\">\n                    {{data.qty}}</span>\n                </div>\n\n                <div layout-fill layout=\"row\" layout-align=\"start center\">\n                  <div layout=\"column\" layout-align=\"center center\" class=\"approvalLabel\">\n                    {{data.type}}</div>\n                </div>\n              </div>\n            </div>\n\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/pages/dashboardgroup/dashboardgroup.html","<div id=\"catgroup\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div class=\"title\">\n            Choose Your Organization\'s Dashboard Groups\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div layout=\"row\">\n            <div class=\"sub-title\" flex=\"60\">\n              Dashboard Groups are groups of mobile users that can send messages.\n            </div>\n            <div flex=\"40\" style=\"position:relative\">\n              <div layout=\"row\" class=\"search-input\">\n                <input style=\"width: 100%; margin-bottom: 15px; box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12); border: solid 1px #9b9b9b\" type=\"text\" id=\"\" placeholder=\"Who are you looking for?\" class=\"search-box\" ng-model=\"vm.filter\" ng-change=\"vm.Update()\" ng-model-options=\"{ debounce: 800 }\">\n                <button class=\"clearButton\" ng-click=\"vm.filter = \'\'; vm.Update()\" style=\"position: absolute; right: 15px; padding-top: 7px\">\n                  <img src=\"/assets/images/search-icon.png\" style=\"width: 14px; position: absolute; right: 120%; padding-top: 2px\">\n                  <div class=\"search-line\"></div>\n                  <div class=\"X\">X</div>\n                </button>\n              </div>\n            </div>\n          </div>\n          \n \n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <!--buttons in a row  -->\n          <div class=\"buttonRow\" layout=\"row\">\n\n            <div flex=\"nogrow\">\n              <label class=\"userButton buttonColor1 buttonsize4\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.AddDashboardGroup(true)\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n              Add New Dashboard Group\n              </label>\n            </div>\n          </div>\n\n          <ya-help-tips name=\"user\" data=\"vm.helpTipList\"></ya-help-tips>\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <div flex style=\"width:100%\" ng-show=\"vm.filter==\'\'\">\n            <md-list>\n\n              <!-- Table Heading start here -->\n              <md-list-item class=\"listItem listHover\" style=\"font-weight: 600; color: #585858; margin-bottom: 5px\">\n                <div style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"groupName\">DASHBOARD GROUP NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"groupName\">Region</div>\n\n                  <!--push to end  -->\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n                    <!-- intentionally left empty -->\n                  </div>\n\n                </div>\n              </md-list-item>\n\n              <!--Table Rows start here  -->\n              <md-list-item class=\"listHover\" style=\"min-height:75px;  font-weight: 500; color: #585858\" ng-repeat=\"x in vm.grpList\">\n                <div ng-show=\"!x.edit\" style=\"width: 100%\" ng-style=\"{opacity: (x.active ? 1 : 0.4)}\" layout=\"row\" layout-align=\"start center\">\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"groupName\">\n                    {{x.name}} [{{((x.userorganizations || []).length || 0) | number:0}}]\n                  </div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"groupName\">\n                    {{ vm.getRegionLabel(x.region_code) }}\n                  </div>\n\n                  <!--push to end  -->\n                  <div layout-fill layout=\"row\" layout-align=\"end center\">\n\n                    <div flex=\"nogrow\" layout-align=\"start center\" class=\"listbutton\" ng-click=\"vm.AddEditMembers(x)\" style=\"color: #9b9b9b; padding-right:20px; cursor:pointer\">\n                      <img style=\"padding-right: 10px; padding-bottom: 3px\" src=\"assets\\images\\icons\\add-update-recipient.png\">\n                      Add / Update Dashboard Group Info\n                    </div>\n\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b; cursor: pointer\" aria-label=\"edit\" ng-click=\"vm.OpenEdit($index,false)\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"padding-right: 10px\" src=\"assets\\images\\icons\\edit_icon-gray.png\">Edit\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" ng-if=\"!x.orgadmin\" aria-label=\"remove\" ng-click=\"vm.RemoveDashboardGroup($index)\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor: pointer\">\n                      <img src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div><!--end end-->\n                </div>\n \n                <!-- EDIT  -->\n                <div style=\"max-height: 75px; width: 100%\" ng-show=\"x.edit\" layout=\"row\" layout-align=\"start center\">\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div layout=\"row\" layout-align=\"start center\" class=\"groupName\">\n                    <md-input-container style=\"margin-right: 16px; height:30px; min-width: 300px; font-size: 15px\">\n                      <label>Dashboard Group Name</label>\n                      <input aria-label=\"dashboard group name\" type=\"text\" ng-model=\"x.name\">\n                    </md-input-container>\n                  \n                    <md-input-container style=\"font-size: 15px; min-width: 300px\">\n                      <label>Select Region</label>\n                      <md-select ng-model=\"x.region_code\" aria-label=\"Region\">\n                        <md-option ng-repeat=\"region in vm.regions\" value=\"{{region.region_code}}\">\n                          {{region.description}} ({{region.region_code}})\n                        </md-option>\n                      </md-select>\n                    </md-input-container>\n                  </div>\n                  \n                  <!-- <div layout=\"column\" class=\"groupName\">\n                    <div style=\"width: 100%; height: 25px\"></div>\n                    <md-input-container style=\" min-width: 300px; font-size: 15px\">\n                      <label>Dashboard Group Name</label>\n                      <input aria-label=\"dashboard group name\" type=\"text\" value=\"{{x.name}}\" ng-model=\"x.name\">\n                    \n                    </md-input-container>\n                  <md-input-container style=\"min-width: 300px; font-size: 15px\">\n                    <label>Select Region</label>\n                    <md-select ng-model=\"x.region_code\" aria-label=\"Region\">\n                      <md-option ng-repeat=\"region in vm.regions\" value=\"{{region.region_code}}\">\n                        {{region.description}} ({{region.region_code}})\n                      </md-option>\n                    </md-select>\n                  </md-input-container>\n                  </div> -->\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n\n                    <div flex=\"nogrow\" class=\"listbutton\" layout=\"row\" layout-align=\"center center\" style=\"cursor: pointer; padding-right: 60px\" ng-click=\"vm.CloseEdit($index)\">\n                      <img style=\"padding-right: 10px; padding-bottom: 3px\" src=\"/assets/images/icons/user-check.png\">\n                      Done Editing\n                    </div>\n                  </div>\n                </div>\n              </md-list-item>\n\n              <!--Table Rows end here  -->\n\n            </md-list>\n          </div>\n\n          <div flex style=\"width:100%\" ng-show=\"vm.filter!=\'\'\">\n            <md-list class=\"setWidth\" id=\"style-3\">\n\n              <!-- Table Heading start here -->\n              <md-list-item class=\"listItem listHover\" style=\"font-weight: 600; color: #585858; margin-bottom: 5px\">\n                <div style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\"></div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">FIRST NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">LAST NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">TITLE</div>\n                  <!-- permission  SAVE- may need to use later - -->\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"permiss\">\n                    <span class=\"ellipsis\">PERMISSIONS</span>\n                  </div> -->\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">EMAIL</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"phone\">PHONE NUMBER</div>\n\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\">\n                    <div ng-click=\"vm.InviteAll() \" layout=\"row\" layout-align=\"start center\" role=\"button\">\n                      <img style=\"margin-top: -3px; padding-right:10px;\" src=\"assets\\images\\icons\\user-invite.png\"> Remind All\n                    </div>\n                  </div> -->\n\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" aria-label=\"edit\" class=\"listbutton md-icon-btn editTrash\" style=\"display:hidden\">\n                      <img style=\"padding-right: 10px; display:none\" src=\"assets\\images\\icons\\edit_icon-gray.png\">\n                      <span style=\"display:none\">Edit</span>\n                    </div>\n\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"display:none\" src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div>\n                </div>\n              </md-list-item>\n              <!-- Table Heading end here -->\n\n              <!--Table Rows start here  -->\n              <md-list-item class=\"listHover\" style=\"font-weight: 500; color: #585858\" ng-repeat=\"x in vm.uniqueUsers track by $index\">\n                <div ng-show=\"!x.edit\" style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\">\n                    <img ng-show=\"x.profileimage\" ng-src=\"{{x.profileimage}}\" id=\"display{{$index}}\" class=\"md-avatar\">\n                    <img ng-show=\"!x.profileimage\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n                  </div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.firstname}}</span></div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.lastname}}</span></div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.title}}</span></div>\n\n                  <!--permission  SAVE- may need to use later -->\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"permiss\">\n                    <md-menu ng-click=\"$mdMenu.open()\">\n                      <div class=\"permissions-menu\" style=\"font-size: 14px; font-weight: 600; color: #0f6ad4\" class=\"md-icon-button\" aria-label=\"View Permissions\">\n                        View Permissions\n                        <img style=\"margin-left: 5px; width: 11px; height: 9px\" src=\"assets\\images\\icons\\carrot-down.png\">\n                      </div>\n                      <md-menu-content ng-mouseleave=\"$mdMenu.close()\">\n                        <md-menu-item layout=\"column\" style=\"height: 300px\">\n                          <div layout=\"column\" style=\"border: 5px solid white; width: 256px\" ng-repeat=\"p in vm.permissionList\">\n                            <div layout=\"row\" ng-show=\"x.permissions[$index]\">\n                              <img style=\"padding-right: 20px; padding-left: 20px\" src=\"assets\\images\\icons\\dashuser-check.png\">{{p}}\n                            </div>\n                          </div>\n                        </md-menu-item>\n                      </md-menu-content>\n                    </md-menu>\n                  </div> -->\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">\n                    <span class=\"ellipsis\">{{x.email}}</span>\n                  </div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"phone\" style=\"padding-left: 5px\">{{x.phonenumber}}</div>\n\n\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\">{{vm.getStatus(x)}}</div> -->\n\n\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n                    <!--Invite  -->\n                    <!-- <div flex=\"none\" layout-align=\"start center\" class=\"listbutton invite\" ng-show=\"vm.showInviteAll\">\n                      <div flex style=\"color:#9b9b9b; cursor:pointer;\" ng-click=\"vm.SendInvite(x)\">\n                        <div ng-show=\"vm.canInvite(x)\">\n                          <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Invite\n                        </div>\n                        <div ng-show=\"vm.canReinvite(x)\" class=\"reinvite\">\n                          <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Re-Invite\n                        </div>\n                        <div ng-show=\"vm.canRemind(x)\" class=\"remind\">\n                          <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Remind\n                        </div>\n                      </div>\n                    </div> -->\n\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b; cursor: pointer\" aria-label=\"edit\" ng-click=\"vm.OpenEditIndividualUser(x)\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"padding-right: 10px\" src=\"assets\\images\\icons\\edit_icon-gray.png\"> Edit\n                    </div>\n\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" ng-if=\"!x.orgadmin\" aria-label=\"remove\" ng-click=\"vm.ConfirmRemove(x)\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                      <img src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" ng-if=\"x.orgadmin\" aria-label=\"remove\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                      <img style=\"opacity: .20\" src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div>\n                </div>\n\n                <!--EDIT popup  -->\n                <div class=\"shadowDashGroup\" ng-show=\"x.edit\" layout=\"row\">\n                  <div layout=\"column\" style=\"width: 12%; background-color: lightgrey\">\n\n\n                    <div layout=\"column\" layout-align=\"start center\" style=\"width: 100%; padding-top: 50px; text-align:center\">\n                        <input class=\"ng-hide\" aria-label=\"profile image\" type=\"file\" ng-model=\"vm.users[$index].imageFile\" id=\"profileImage{{$index}}\" onchange=\"angular.element(this).scope().vm.UpdateImage(angular.element(this).scope().$index,this)\" accept=\".jpg\">\n                        <label style=\"color: #0064d8; font-size: 15px; cursor: pointer\" for=\"profileImage{{$index}}\">Select New Photo</label>\n                    </div>\n\n                    <div layout=\"column\" layout-align=\"start center\" style=\"width: 100%; height: 20px\">\n                      <div style=\"color: #0064d8; font-size: 15px; cursor: pointer\" ng-show=\"x.imageFile!=null\" ng-click=\"vm.Upload($index)\">\n                        UPLOAD\n                      </div>\n                    </div>\n                    <div style=\"width: 100%; height: 150px\" layout=\"column\" layout-align=\"start center\">\n                      <img ng-show=\"x.profileimage\" ng-src=\"{{x.profileimage}}\" id=\"display2{{$index}}\" class=\"md-avatar\">\n                      <img ng-show=\"!x.profileimage\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n                    </div>\n                  </div>\n\n\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" style=\"width: 30%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>First Name</label>\n                        <input class=\"inputStyle\" aria-label=\"firstname\" type=\"text\" value=\"{{x.firstname}}\" ng-model=\"x.firstname\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Last Name</label>\n                        <input class=\"inputStyle\" aria-label=\"lastname\" type=\"text\" value=\"{{x.lastname}}\" ng-model=\"x.lastname\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Workflow Admin</label>\n                        <md-select ng-model=\"x.workflowadminName\">\n                          <md-option ng-repeat=\"adminName in vm.workFlowAdminNames track by $index\" ng-attr-value=\"{{adminName}}\">{{adminName}}</md-option>\n                        </md-select>\n                      </md-input-container>\n                    </div>\n\n                  </div>\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" style=\"width: 30%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Title</label>\n                        <input class=\"inputStyle\" aria-label=\"title\" type=\"text\" value=\"{{x.title}}\" ng-model=\"x.title\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactEmail.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Email</label>\n                        <input class=\"inputStyle\" aria-label=\"email\" type=\"text\" readonly=\"readonly\" onclick=\"if(value==\'abc@abc.com\'){value=\'\'}\" value=\"{{x.email}}\" ng-model=\"x.email\" ng-pattern=\"vm.ePattern\">\n                        <div ng-messages=\"{\'pattern\': !x.email}\">\n                          <div ng-message=\"pattern\">invalid email</div>\n                        </div>\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Mobile Phone Number</label>\n                        <input class=\"inputStyle\" type=\"text\" aria-label=\"phonenumber\" name=\"phonenumber\" value=\"{{x.phonenumber}}\" ng-model=\"x.phonenumber\" ng-change=\"vm.updatePhoneNumber(x)\">\n                      </md-input-container>\n\n                    </div>\n\n                  </div>\n                  <div style=\"width: 6%\"></div>\n                  <div layout=\"column\" style=\"width: 19%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"column\" layout-wrap>\n                      <div style=\"font-size: 15px; font-weight: 600; padding-bottom: 20px\">PERMISSIONS</div>\n                      <!--permission  -->\n                      <div ng-repeat=\"p in vm.permissionList\">\n                        <md-checkbox aria-label=\"permission\" ng-model=\"x.permissions[$index]\" ng-click=\"\" ng-show=\"p !== \'email marketing\' || vm.orgID == 3\">\n                          <div>\n                            {{p}}\n                          </div>\n                        </md-checkbox>\n                      </div>\n                    </div>\n                  </div>\n                  <div style=\"width: 6%\"></div>\n                  <div layout=\"column\" style=\"width: 19%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"column\" layout-wrap>\n                      <div style=\"font-size: 15px; font-weight: 600; padding-bottom: 20px\">DASHBOARD GROUPS</div>\n                      <!--permission  -->\n                      <div ng-repeat=\"dg in vm.dashboardGroups\">\n                        <md-checkbox aria-label=\"permission\" ng-model=\"x.dashboardGroups[dg.id]\" ng-click=\"\">\n                          <div>\n                            {{dg.name}}\n                          </div>\n                        </md-checkbox> \n                      </div>\n                    </div>\n                  </div>\n                  <div style=\"width: 6%\"></div>\n                  <div layout=\"column\" style=\"width: 19%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"column\" layout-wrap>\n                      <div style=\"font-size: 15px; font-weight: 600; padding-bottom: 20px\">RECIPIENT GROUPS</div>\n                      <!--permission  -->\n                      <div ng-repeat=\"rg in vm.recipientGroups\">\n                        <md-checkbox aria-label=\"permission\" ng-model=\"x.recipientGroups[rg.id]\" ng-click=\"\">\n                          <div>\n                            {{rg.name}} - {{rg.id}}\n                          </div>\n                        </md-checkbox>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" layout-align=\"start center\" style=\"width: 19%\">\n                    <div>&nbsp;</div>\n                    <div style=\"color: #0f6ad4; height:50px; font-size: 16px; font-weight: 600\" aria-label=\"done\" ng-click=\"vm.CloseEditIndividualUser(x)\">\n                      <img style=\"margin-right: 18px; margin-top: -5px\" src=\"assets\\images\\icons\\user-check.png\"> Done Editing\n                    </div>\n                  </div>\n                </div>\n                <!--end EDIT popup  -->\n\n              </md-list-item>\n              <!--Table Rows end here  -->\n\n            </md-list>\n          </div>\n\n          <div layout=\"row\" style=\"width: 100%; padding-bottom:10px\">\n            <div flex></div>\n            <div paging page=\"vm.currentPage\" total=\"vm.totalPages\" page-size=\"1\" paging-action=\"vm.onPage()\" show-prev-next=\"true\" showfirst-last=\"true\"></div>\n            <div flex></div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/dashboardgroupuser/dashboardgroupuser.html","<div id=\"dashboardGroupUser\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div class=\"title\">\n            Add / Update Dashboard User(s) In: {{vm.dashboardGroup.name}}\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div layout=\"row\">\n            <div class=\"sub-title\" flex=\"60\">\n              Add new dashboard users or dashboard user\'s information\n            </div>\n            <div flex=\"40\">\n              <div layout=\"row\" class=\"search-input\">\n                <input style=\"width: 100%; margin-bottom: 15px; box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12); border: solid 1px #9b9b9b\" type=\"text\" id=\"\" placeholder=\"Who are you looking for?\" class=\"search-box\" ng-model=\"vm.filter\" ng-change=\"vm.Update()\" ng-model-options=\"{ debounce: 500 }\">\n                <button class=\"clearButton\" ng-click=\"vm.filter = \'\'; vm.Update()\" style=\"position: absolute; right: 15px; padding-top: 7px\">\n                  <img src=\"/assets/images/search-icon.png\" style=\"width: 14px; position: absolute; right: 120%; padding-top: 2px\">\n                  <div class=\"search-line\"></div>\n                  <div class=\"X\">X</div>\n                </button>\n              </div>\n            </div>\n          </div>\n\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <!--buttons in a row  -->\n          <div class=\"buttonRow\" layout=\"row\">\n            <div flex=\"noshrink\">\n              <label class=\"userButton buttonColor0\" layout=\"row\" style=\"padding-left:15px\" layout-align=\"center center\" ng-click=\"vm.onBack()\">\n                BACK\n              </label>\n            </div>\n\n            <div flex=\"noshrink\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <label class=\"userButton buttonColor1\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.AddNew()\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n                ADD NEW DASHBOARD USER MANUALLY\n              </label>\n            </div>\n\n            <div flex=\"noshrink\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <input type=\"file\" id=\"file-upload1\" ng-show=\"false\" name=\"{{$index}}\" accept=\".csv\" onchange=\"angular.element(this).scope().vm.CSVFile(this)\">\n              <label layout=\"row\" layout-align=\"start center\" for=\"file-upload1\" ng-click=\"vm.UploadUsers(\'file-upload1\')\" class=\"userButton buttonColor1\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n                IMPORT CSV OF DASHBOARD USERS\n              </label>\n            </div>\n\n            <div flex=\"noshrink\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <a style=\"text-decoration: none\" ng-click=\"vm.ExportCSV()\">\n                <label class=\"userButton buttonColor1\" layout=\"row\" layout-align=\"start center\">\n                  <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-download.png\">\n                  EXPORT CSV OF DASHBOARD USERS\n                </label>\n              </a>\n            </div>\n\n            <div flex=\"noshrink\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <a style=\"text-decoration: none\" href=\"https://s3-us-west-2.amazonaws.com/yougetitfirstfiles/LoadUserData.csv\">\n                <label class=\"userButton buttonColor2\" layout=\"row\" layout-align=\"start center\">\n                  <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-download.png\">\n                  DOWNLOAD CSV TEMPLATE: DASHBOARD USERS\n                </label>\n              </a>\n            </div>\n          </div>\n\n          <ya-help-tips name=\"user\" data=\"vm.helpTipList\"></ya-help-tips>\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <div flex style=\"width:100%\">\n            <md-list class=\"setWidth\" id=\"style-3\">\n\n              <!-- Table Heading start here -->\n              <md-list-item class=\"listItem listHover\" style=\"font-weight: 600; color: #585858; margin-bottom: 5px\">\n                <div style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\"></div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">FIRST NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">LAST NAME</div>\n                  <div ng-if=\"vm.enablequickresponse\" flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">Xmit Number</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">TITLE</div>\n                  <!-- permission  SAVE- may need to use later - -->\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"permiss\">\n                    <span class=\"ellipsis\">PERMISSIONS</span>\n                  </div> -->\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">EMAIL</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"phone\">PHONE NUMBER</div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\">\n                    <div ng-click=\"vm.InviteAll() \" layout=\"row\" layout-align=\"start center\" role=\"button\">\n                      <img style=\"margin-top: -3px; padding-right:10px\" src=\"assets\\images\\icons\\user-invite.png\">\n                      Remind All\n                    </div>\n                  </div>\n\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n\n                    <!-- <div flex=\"none\" class=\"listbutton invite\" ng-show=\"vm.showInviteAll\">\n                      <div ng-click=\"vm.InviteAll() \" layout=\"row\" layout-align=\"start center\" role=\"button\">\n                        <img style=\"margin-top: -3px; padding-right:10px;\" src=\"assets\\images\\icons\\user-invite.png\"> Invite\n                        All\n                      </div>\n                    </div> -->\n\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" aria-label=\"edit\" class=\"listbutton md-icon-btn editTrash\" style=\"display:hidden\">\n                      <img style=\"padding-right: 10px; display:none\" src=\"assets\\images\\icons\\edit_icon-gray.png\">\n                      <span style=\"display:none\">Edit</span>\n                    </div>\n\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"display:none\" src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div>\n                </div>\n              </md-list-item>\n              <!-- Table Heading end here -->\n\n              <!--Table Rows start here  -->\n              <md-list-item class=\"listHover\" style=\"font-weight: 500; color: #585858\" ng-repeat=\"x in vm.dashboardGroup.userorganizations track by $index\">\n                <div ng-show=\"!x.edit\" style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\">\n                    <img ng-show=\"x.profileimage\" ng-src=\"{{x.profileimage}}\" id=\"display{{$index}}\" class=\"md-avatar\">\n                    <img ng-show=\"!x.profileimage\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n                  </div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.firstname}}</span>\n                  </div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.lastname}}</span>\n                  </div>\n                  <div ng-if=\"vm.enablequickresponse\" flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{ x.xmitnumber !== null && x.xmitnumber !== undefined ? x.xmitnumber : \'\'\n                      }}</span>\n                  </div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.title}}</span>\n                  </div>\n\n                  <!--permission  SAVE- may need to use later -->\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"permiss\">\n                    <md-menu ng-click=\"$mdMenu.open()\">\n                      <div class=\"permissions-menu\" style=\"font-size: 14px; font-weight: 600; color: #0f6ad4\" class=\"md-icon-button\" aria-label=\"View Permissions\">\n                        View Permissions\n                        <img style=\"margin-left: 5px; width: 11px; height: 9px\" src=\"assets\\images\\icons\\carrot-down.png\">\n                      </div>\n                      <md-menu-content ng-mouseleave=\"$mdMenu.close()\">\n                        <md-menu-item layout=\"column\" style=\"height: 300px\">\n                          <div layout=\"column\" style=\"border: 5px solid white; width: 256px\" ng-repeat=\"p in vm.permissionList\">\n                            <div layout=\"row\" ng-show=\"x.permissions[$index]\">\n                              <img style=\"padding-right: 20px; padding-left: 20px\" src=\"assets\\images\\icons\\dashuser-check.png\">{{p}}\n                            </div>\n                          </div>\n                        </md-menu-item>\n                      </md-menu-content>\n                    </md-menu>\n                  </div> -->\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">\n                    <span class=\"ellipsis\">{{x.email}}</span>\n                  </div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"phone\" style=\"padding-left: 5px\">\n                    {{x.phonenumber}}</div>\n\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\">{{vm.getStatus(x)}}</div>\n\n\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n                    <!--Invite  -->\n                    <!-- <div flex=\"none\" layout-align=\"start center\" class=\"listbutton invite\" ng-show=\"vm.showInviteAll\">\n                      <div flex style=\"color:#9b9b9b; cursor:pointer;\" ng-click=\"vm.SendInvite(x)\">\n                        <div ng-show=\"vm.canInvite(x)\">\n                          <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Invite\n                        </div>\n                        <div ng-show=\"vm.canReinvite(x)\" class=\"reinvite\">\n                          <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Re-Invite\n                        </div>\n                        <div ng-show=\"vm.canRemind(x)\" class=\"remind\">\n                          <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Remind\n                        </div>\n                      </div>\n                    </div> -->\n\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b; cursor: pointer\" aria-label=\"edit\" ng-click=\"vm.OpenEdit(x)\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"padding-right: 10px\" src=\"assets\\images\\icons\\edit_icon-gray.png\"> Edit\n                    </div>\n\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" ng-if=\"!x.orgadmin\" aria-label=\"remove\" ng-click=\"vm.ConfirmRemove(x)\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                      <img src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" ng-if=\"x.orgadmin\" aria-label=\"remove\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                      <img style=\"opacity: .20\" src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div>\n                </div>\n\n                <!--EDIT popup  -->\n                <div class=\"shadow\" ng-show=\"x.edit\" layout=\"row\">\n                  <div layout=\"column\" style=\"width: 12%; background-color: lightgrey\">\n\n\n                    <div layout=\"column\" layout-align=\"start center\" style=\"width: 100%; padding-top: 50px; text-align:center\">\n                      <input class=\"ng-hide\" aria-label=\"profile image\" type=\"file\" ng-model=\"vm.users[$index].imageFile\" id=\"profileImage{{$index}}\" onchange=\"angular.element(this).scope().vm.UpdateImage(angular.element(this).scope().$index,this)\" accept=\".jpg\">\n                      <label style=\"color: #0064d8; font-size: 15px; cursor: pointer\" for=\"profileImage{{$index}}\">Select New Photo</label>\n                    </div>\n\n                    <div layout=\"column\" layout-align=\"start center\" style=\"width: 100%; height: 20px\">\n                      <div style=\"color: #0064d8; font-size: 15px; cursor: pointer\" ng-show=\"x.imageFile!=null\" ng-click=\"vm.Upload($index)\">\n                        UPLOAD\n                      </div>\n                    </div>\n                    <div style=\"width: 100%; height: 150px\" layout=\"column\" layout-align=\"start center\" ng-if=\"vm.getStatusBool(x)\">\n                      <img ng-show=\"x.profileimage\" ng-src=\"{{x.profileimage}}\" id=\"display2{{$index}}\" class=\"md-avatar\">\n                      <img ng-show=\"!x.profileimage\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n                    </div>\n                  </div>\n\n\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" style=\"width: 30%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>First Name</label>\n                        <input class=\"inputStyle\" aria-label=\"firstname\" type=\"text\" value=\"{{x.firstname}}\" ng-model=\"x.firstname\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Last Name</label>\n                        <input class=\"inputStyle\" aria-label=\"lastname\" type=\"text\" value=\"{{x.lastname}}\" ng-model=\"x.lastname\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Workflow Admin</label>\n                        <md-select ng-model=\"x.workflowadminName\">\n                          <md-option ng-repeat=\"adminName in vm.workFlowAdminNames track by $index\" ng-attr-value=\"{{adminName}}\">{{adminName}}</md-option>\n                        </md-select>\n                      </md-input-container>\n                    </div>\n\n                  </div>\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" style=\"width: 30%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Title</label>\n                        <input class=\"inputStyle\" aria-label=\"title\" type=\"text\" value=\"{{x.title}}\" ng-model=\"x.title\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactEmail.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Email</label>\n                        <input class=\"inputStyle\" aria-label=\"email\" type=\"text\" readonly=\"readonly\" onclick=\"if(value==\'abc@abc.com\'){value=\'\'}\" value=\"{{x.email}}\" ng-model=\"x.email\" ng-pattern=\"vm.ePattern\">\n                        <div ng-messages=\"{\'pattern\': !x.email}\">\n                          <div ng-message=\"pattern\">invalid email</div>\n                        </div>\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Mobile Phone Number</label>\n                        <input class=\"inputStyle\" type=\"text\" aria-label=\"phonenumber\" name=\"phonenumber\" value=\"{{x.phonenumber}}\" ng-model=\"x.phonenumber\" ng-change=\"vm.updatePhoneNumber(x)\">\n                      </md-input-container>\n\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\" ng-if=\"vm.getStatusBool(x)\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Xmit Number</label>\n                        <input class=\"inputStyle\" type=\"text\" aria-label=\"xmitnumber\" name=\"xmitnumber\" value=\"{{x.xmitnumber}}\" ng-model=\"x.xmitnumber\">\n                      </md-input-container>\n\n                    </div>\n\n                  </div>\n                  <div style=\"width: 6%\"></div>\n                  <div layout=\"column\" style=\"width: 19%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"column\" layout-wrap>\n                      <div style=\"font-size: 15px; font-weight: 600; padding-bottom: 20px\">PERMISSIONS</div>\n                      <!--permission  -->\n                      <div ng-repeat=\"p in vm.permissionList\">\n                        <md-checkbox aria-label=\"permission\" ng-model=\"x.permissions[$index]\" ng-click=\"\" ng-show=\"p !== \'email marketing\' || vm.orgID == 3\">\n                          <div>\n                            {{p}}\n                          </div>\n                        </md-checkbox>\n                      </div>\n                    </div>\n                  </div>\n                  <div style=\"width: 6%\"></div>\n                  <div layout=\"column\" style=\"width: 19%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"column\" layout-wrap>\n                      <div style=\"font-size: 15px; font-weight: 600; padding-bottom: 20px\">DASHBOARD GROUPS</div>\n                      <!--permission  -->\n                      <div ng-repeat=\"dg in vm.dashboardGroups\">\n                        <md-checkbox aria-label=\"permission\" ng-model=\"x.dashboardGroups[dg.id]\" ng-click=\"\">\n                          <div>\n                            {{dg.name}}\n                          </div>\n                        </md-checkbox>\n                      </div>\n                    </div>\n                  </div>\n                  <div style=\"width: 6%\"></div>\n                  <div layout=\"column\" style=\"width: 19%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"column\" layout-wrap>\n                      <div style=\"font-size: 15px; font-weight: 600; padding-bottom: 20px\">RECIPIENT GROUPS</div>\n                      <!--permission  -->\n                      <div ng-repeat=\"rg in vm.recipientGroups\">\n                        <md-checkbox aria-label=\"permission\" ng-model=\"x.recipientGroups[rg.id]\" ng-click=\"\">\n                          <div>\n                            {{rg.name}} - {{rg.id}}\n                          </div>\n                        </md-checkbox>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" layout-align=\"start center\" style=\"width: 19%\">\n                    <div>&nbsp;</div>\n                    <div style=\"color: #0f6ad4; height:50px; font-size: 16px; font-weight: 600\" aria-label=\"done\" ng-click=\"vm.CloseEdit(x)\">\n                      <img style=\"margin-right: 18px; margin-top: -5px\" src=\"assets\\images\\icons\\user-check.png\"> Done\n                      Editing\n                    </div>\n                  </div>\n                </div>\n                <!--end EDIT popup  -->\n\n              </md-list-item>\n              <!--Table Rows end here  -->\n\n            </md-list>\n          </div>\n\n          <div layout=\"row\" style=\"width: 100%; padding-bottom:10px\">\n            <div flex></div>\n            <div paging page=\"vm.currentPage\" total=\"vm.totalPages\" page-size=\"1\" paging-action=\"vm.onPage()\" show-prev-next=\"true\" showfirst-last=\"true\"></div>\n            <div flex></div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/pages/deleteaccount/deleteaccount.html","<div id=\"passwordhelp\" style=\"background-color: #c8c8c8\" layout=\"column\" layout-fill layout-padding>\n  <div style=\"width: 100%; height: 100%\" layout=\"column\">\n    <!-- Header Section -->\n    <div style=\"width: 100%; height: 25%\" layout=\"row\" layout-align=\"center start\">\n      <img src=\"assets/images/pw_forgot_logo.png\" alt=\"Forgot Password Logo\">\n    </div>\n\n    <!-- Delete Account Section -->\n    <div style=\"width: 100%; height: 40%\" layout=\"row\">\n      <div style=\"width: 40%; height: 100%\"></div>\n\n      <form flex=\"auto\" style=\"background-color: white; box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25); width: 40%; min-width: 550px; border-radius: 10px; border: 1px solid rgba(120, 120, 120, 0.12)\" name=\"deleteAccountForm\" ng-submit=\"vm.onDeleteAccount(deleteAccountForm.$valid)\" novalidate layout-padding layout=\"column\" layout-align=\"center left\">\n        <div class=\"delete-account-content\">\n          <div style=\"color: #b20000; font-size: 28px; font-weight: 400\">Delete Your Account</div>\n          <div style=\"font-weight: 300; font-size: 18px; padding-bottom: 20px\">\n            Deleting your account is permanent and will remove all your data.\n          </div>\n          <md-input-container class=\"md-block\" layout=\"row\">\n            <label>Confirm Email</label>\n            <input style=\"font-size: 25px\" class=\"inputStyle\" aria-label=\"confirm-email\" name=\"confirmEmail\" id=\"confirmEmail\" ng-model=\"vm.confirmEmail\" required>\n            <div ng-messages=\"deleteAccountForm.confirmEmail.$error\">\n              <div ng-message=\"required\">Email confirmation required</div>\n            </div>\n          </md-input-container>\n          <div class=\"delete-button\">\n            <md-button style=\"background-color: #b20000; color: white\" class=\"adminStyle adminButton button\" aria-label=\"delete account\" type=\"submit\">\n              Delete Account\n            </md-button>\n          </div>\n        </div>\n      </form>\n\n      <div style=\"width: 40%; height: 100%\"></div>\n    </div>\n    <div style=\"width: 100%; height: 35%\"></div>\n  </div>\n</div>");
$templateCache.put("app/pages/deleteaccountconfirmation/deleteaccountconfirmation.html","<div id=\"passwordhelp\" style=\"background-color: #c8c8c8\" layout=\"column\" layout-fill layout-padding>\n    <div style=\"width: 100%; height: 100%\" layout=\"column\">\n        <!-- Header Section -->\n        <div style=\"width: 100%; height: 25%\" layout=\"row\" layout-align=\"center start\">\n            <img src=\"assets/images/pw_forgot_logo.png\" alt=\"Forgot Password Logo\">\n        </div>\n\n        <!-- Error Message Section -->\n        <div style=\"width: 100%; height: 40%\" layout=\"row\" ng-if=\"errorMessage\">\n            <div style=\"width: 40%; height: 100%\"></div>\n            <div style=\"text-align: center; padding: 20px; background-color: #f8d7da; border-radius: 10px\">\n                <h2 style=\"color: #721c24; font-size: 20px; font-weight: 600\">Error</h2>\n                <p style=\"font-size: 18px; color: #721c24\">\n                    {{errorMessage}} <!-- Display error message here -->\n                </p>\n            </div>\n            <div style=\"width: 40%; height: 100%\"></div>\n        </div>\n\n        <!-- Delete Account Section -->\n        <div style=\"width: 100%; height: 40%\" layout=\"row\" ng-if=\"loadHTMl\">\n            <div style=\"width: 40%; height: 100%\"></div>\n            <div style=\"text-align: center; padding: 50px; background-color: #f8f8f8; border-radius: 10px\">\n                <h1 style=\"color: #5cb85c; font-size: 36px; font-weight: 600\">Account Deleted</h1>\n                <p style=\"font-size: 18px; color: #333; margin-top: 20px\">\n                    Your account has been successfully deleted. Thank you for using our service.\n                </p>\n            </div>\n            <div style=\"width: 40%; height: 100%\"></div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/pages/editsalesorg/editsalesorg.html","<div id=\"editSalesOrg\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div class=\"title\">\n            Add / Update Sales Org : {{vm.salesOrgName}}\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div class=\"sub-title\">\n            Add new recipients or update recipient information.\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div class=\"sub-title\">\n            Dashboard Users are individuals with access to the web application dashboard panel.\n          </div>\n\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <!--buttons in a row  -->\n          <div layout=\"row\" layout-align=\"start center\" class=\"buttonRow\">\n\n            <div flex=\"nogrow\">\n              <label class=\"userButton buttonColor0\" layout=\"row\" style=\"padding-left:15px\" layout-align=\"center center\" ng-click=\"vm.onBack()\">\n                BACK\n              </label>\n            </div>\n\n            <div style=\"height: 100%; width:10px\"></div>\n\n            <div flex=\"nogrow\">\n              <label class=\"userButton buttonColor1\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.AddNew()\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n                ADD NEW SALESPERSON MANUALLY\n              </label>\n            </div>\n\n          </div>\n\n          <ya-help-tips name=\"user\" data=\"vm.helpTipList\"></ya-help-tips>\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <div flex style=\"width:100%\">\n            <md-list class=\"setWidth\" id=\"style-3\">\n\n              <!-- Table Heading start here -->\n              <md-list-item class=\"listItem listHover\" style=\"font-weight: 600; color: #585858; margin-bottom: 5px\">\n                <div style=\"width: 100%\" layout=\"row\" layout-align=\"start end\">\n\n                  <div flex=\"nogrow\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\"></div>\n                  <div flex=\"nogrow\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">FIRST NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">LAST NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">EMAIL</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"phone\">PHONE NUMBER</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"center center\" class=\"name-section\">REFERRAL CODE</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"center center\" class=\"invite\">START DATE</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"center center\" class=\"invite\">YTD Sales</div>\n\n                  <!--push to end  -->\n                   <div flex=\"grow\" layout=\"row\" layout-align=\"end center\"> \n                    <div flex=\"nogrow\" class=\"listbutton invite\">\n                      <div ng-click=\"vm.InviteAll()\" layout=\"row\" layout-align=\"start center\" role=\"button\">\n                        <img style=\"margin-top: -3px; padding-right:10px\" src=\"assets\\images\\icons\\user-invite.png\"> Invite\n                        All\n                      </div>\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b\" aria-label=\"edit\" class=\"listbutton md-icon-btn editTrash\" style=\"display:hidden\">\n                      <img style=\"padding-right: 10px; display:none\" src=\"assets\\images\\icons\\edit_icon-gray.png\">\n                      <span style=\"display:none\">Edit</span>\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"display:none\" src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div>\n\n                </div>\n              </md-list-item>\n              <!-- Table Heading end here -->\n\n              <!--Table Rows start here  -->\n              <md-list-item class=\"listHover\" style=\"font-weight: 500; color: #585858\" ng-repeat=\"x in vm.salesPeople\">\n                <div ng-show=\"!x.edit\" style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n                  <div flex=\"nogrow\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\">\n                    <img ng-show=\"x.profileimage\" ng-src=\"{{x.profileimage}}\" id=\"display{{$index}}\" class=\"md-avatar\">\n                    <img ng-show=\"!x.profileimage\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n                  </div>\n                  <div flex=\"nogrow\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.firstname}}</span>\n                  </div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.lastname}}</span>\n                  </div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">\n                    <span class=\"ellipsis\">{{x.email}}</span>\n                  </div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"phone\">\n                    <span class=\"ellipsis\">{{x.phone}}</span>\n                  </div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"center center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.referralcode}}</span>\n                  </div>\n                  <div layout=\"grow\" layout=\"row\" layout-align=\"center center\" class=\"invite\">\n                    <span class=\"ellipsis\">{{x.startdate | date}}</span>\n                  </div>                  \n                  <div layout=\"grow\" layout=\"row\" layout-align=\"center center\" class=\"invite\">\n                    <span class=\"ellipsis\">{{vm.YTDSales.salespeople[$index].total | currency}}</span>\n                  </div>\n\n                  <!--push to end  -->\n                   <div flex=\"grow\" layout=\"row\" layout-align=\"end center\"> \n\n                    <div flex=\"nogrow\" class=\"listbutton invite\" style=\"padding-right:5px\">\n                      <div style=\"color:#9b9b9b\" ng-click=\"vm.SendInvite(x)\" role=\"button\">\n                        <div ng-show=\"x.canInvite\">\n                          <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Invite\n                        </div>\n                        <div ng-show=\"x.canReinvite\" class=\"reinvite\">\n                          <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Re-Invite\n                        </div>\n                      </div>\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b; cursor:pointer\" aria-label=\"edit\" ng-click=\"vm.OpenEdit(x)\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"padding-right: 10px\" src=\"assets\\images\\icons\\edit_icon-gray.png\"> Edit\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" ng-if=\"!x.orgadmin\" aria-label=\"remove\" ng-click=\"vm.ConfirmRemove(x)\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                      <img src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" ng-if=\"x.orgadmin\" aria-label=\"remove\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                      <img style=\"opacity: .20\" src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                   </div> \n                </div>\n\n\n                <!--MODAL  -->\n                <div class=\"shadow\" ng-show=\"x.edit\" layout=\"row\" style=\"width: 100%; height: 367px; background-color: white\">\n                  <div layout=\"column\" style=\"width: 12%; background-color: lightgrey\">\n                    <div style=\"height: 6%\"></div>\n\n                    <div layout=\"column\" layout-align=\"center center\" style=\"width: 100%; height: 15%\">\n                      <input class=\"ng-hide\" aria-label=\"profile image\" type=\"file\" ng-model=\"x.imageFile\" id=\"profileImage{{$index}}\" onchange=\"angular.element(this).scope().vm.UpdateImage(angular.element(this).scope().$index,this)\" accept=\".jpg\">\n                      <label style=\"color: #0064d8; font-size: 15px; cursor: pointer\" for=\"profileImage{{$index}}\">\n                      Select New Photo\n                    </label>\n                    </div>\n                    <div layout=\"column\" layout-align=\"center center\" style=\"width: 100%; height: 2%\">\n                      <div style=\"color: #0064d8; font-size: 15px; cursor: pointer\" ng-show=\"x.imageFile!=null\" ng-click=\"vm.Upload($index)\">\n                        UPLOAD\n                      </div>\n                    </div>\n                    <div style=\"width: 100%; height: 100%\" layout=\"column\" layout-align=\"start center\">\n\n                      <img ng-show=\"x.profileimage\" ng-src=\"{{x.profileimage}}\" id=\"display2{{$index}}\" class=\"md-avatar\">\n                      <img ng-show=\"!x.profileimage && !x.imageFile\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n\n                    </div>\n                  </div>\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" style=\"width: 30%\">\n\n                    <div style=\"height: 6%\"></div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>First Name</label>\n                        <input class=\"inputStyle\" aria-label=\"firstname\" type=\"text\" value=\"{{x.firstname}}\" ng-model=\"x.firstname\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Last Name</label>\n                        <input class=\"inputStyle\" aria-label=\"lastname\" type=\"text\" value=\"{{x.lastname}}\" ng-model=\"x.lastname\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Mobile Phone Number</label>\n                        <input class=\"inputStyle\" type=\"text\" aria-label=\"phone\" name=\"phone\" ng-pattern=\"vm.phPattern\" value=\"{{x.phone}}\" ng-model=\"x.phone\" ng-change=\"vm.updatePhoneNumber(x)\">\n                      </md-input-container>\n                    </div>\n\n\n                  </div>\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" style=\"width: 30%\">\n\n                    <div style=\"height: 6%\"></div>\n\n\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Referral Code</label>\n                        <input class=\"inputStyle\" readonly=\"readonly\" aria-label=\"referralcode\" type=\"text\" value=\"{{x.referralcode}}\" ng-model=\"x.referralcode\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactEmail.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Email</label>\n                        <input class=\"inputStyle\" aria-label=\"email\" type=\"text\" ng-pattern=\"vm.ePattern\" value=\"{{x.email}}\" ng-model=\"x.email\" ng-pattern=\"vm.ePattern\" readonly=\"readonly\">\n                        <div ng-messages=\"{\'pattern\': !x.email}\">\n                          <div ng-message=\"pattern\">invalid email</div>\n                        </div>\n                      </md-input-container>\n                    </div>\n\n                  </div>\n                  <div style=\"width: 6%\"></div>\n\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" layout-align=\"start center\" style=\"width: 19%\">\n                    <div style=\"width: 100%; height: 6%\"></div>\n                    <div style=\"color: #0f6ad4; font-size: 16px; font-weight: 600\" aria-label=\"done\" ng-click=\"vm.CloseEdit(x)\" role=\"button\">\n                      <img style=\"margin-right: 18px; margin-top: -5px\" src=\"assets\\images\\icons\\user-check.png\"> Done Editing\n                    </div>\n                  </div>\n                </div>\n\n              </md-list-item>\n              <!--Table Rows end here  -->\n\n            </md-list>\n          </div>\n\n          <div layout=\"row\" style=\"width: 100%; padding-bottom:10px\">\n            <div flex></div>\n            <div paging page=\"vm.currentPage\" total=\"vm.totalPages\" page-size=\"1\" paging-action=\"vm.onPage()\" show-prev-next=\"true\" showfirst-last=\"true\"></div>\n            <div flex></div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/emailcampaign/emailcampaign.html","<div style=\"height: 100%; background-color: #eaeaea\" id=\"emailCamp\" layout=\"row\">\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div class=\"title\">\n            View Your Email Marketing Campaigns\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div class=\"sub-title\">\n            Email Marketing Campaigns will contain individuals you may deliver materials to.\n          </div>\n\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <!--buttons in a row  -->\n          <div class=\"buttonRow\" layout=\"row\">\n\n            <div flex=\"nogrow\">\n              <label class=\"userButton buttonColor1 buttonsize4\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.AddCat()\">\n              <img style=\"margin-top: -3px; padding-right: 25px; padding-left: 20px\" src=\"assets\\images\\icons\\user-add.png\">\n              Add New Marketing Campaign\n            </label>\n            </div>\n          </div>\n\n          <ya-help-tips name=\"user\" data=\"vm.helpTipList\"></ya-help-tips>\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <div flex style=\"width:100%\">\n            <md-list class=\"setWidth\" id=\"style-3\">\n\n              <!-- Table Heading start here -->\n              <md-list-item class=\"listItem listHover\" style=\"font-weight: 600; color: #585858; margin-bottom: 5px\">\n                <div style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"groupName\">CAMPAIGN</div>\n                  <div flex=\"grow\"></div>\n                </div>\n              </md-list-item>\n              <!-- Table Heading end here -->\n\n              <!--Table Rows start here  -->\n              <md-list-item ng-repeat=\"x in vm.grpList\" class=\"listHover\" style=\"min-height: 75px; font-size: 13px; color: #585858\">\n                <div ng-show=\"!x.edit\" style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"groupName\">{{x.name}} [{{x.membercount | number:0}}]</div>\n\n                  <!--push to end  -->\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n\n                    <div flex=\"nogrow\" layout-align=\"start center\" class=\"listbutton\" ng-click=\"vm.AddUsers(x)\" style=\"color: #9b9b9b; padding-right:20px; cursor:pointer\">\n                      <img style=\"padding-right: 10px; padding-bottom: 3px\" src=\"assets\\images\\icons\\add-update-recipient.png\">Add\n                      / Update Recipient Info\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b; cursor:pointer\" aria-label=\"edit\" ng-click=\"vm.OpenEdit($index,false)\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"padding-right: 10px\" src=\"assets\\images\\icons\\edit_icon-gray.png\">Edit\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" ng-if=\"!x.orgadmin\" aria-label=\"remove\" ng-click=\"vm.RemoveCat($index,false)\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                      <img src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div><!--end end-->\n                </div>\n                \n                <!--EDIT  -->\n                <div style=\"max-height: 75px; width: 100%\" ng-show=\"x.edit\" layout=\"row\" layout-align=\"start center\">\n                  <div style=\"height: 100%; width: 10%\"></div>\n                  <div layout=\"column\">\n                    <div style=\"width: 100%; height: 25px\"></div>\n                    <md-input-container style=\"min-width: 300px; font-size: 15px\">\n                      <label>Email Group Name</label>\n                      <input aria-label=\"category name\" type=\"text\" value=\"{{x.name}}\" ng-model=\"x.name\">\n                    </md-input-container>\n                  </div>\n                  <div style=\"height: 100%; width: 100%\"></div>\n                  <div class=\"listbutton\" layout=\"row\" layout-align=\"center center\" style=\"cursor: pointer; height: 100%; width: 50%; min-width: 200px\" ng-click=\"vm.CloseEdit($index,false)\">\n                    <img style=\"padding-right: 10px; padding-bottom: 3px\" src=\"/assets/images/icons/user-check.png\"> Done\n                    Editing\n                  </div>\n                </div><!-- EDIT end -->\n\n              </md-list-item>\n              <!--Table Rows end here  -->\n              \n            </md-list>\n          </div>\n\n          <div layout=\"row\" style=\"width: 100%; padding-bottom:10px\">\n            <div flex></div>\n            <div paging page=\"vm.currentPage\" total=\"vm.totalPages\" page-size=\"1\" paging-action=\"vm.onPage()\" show-prev-next=\"true\" showfirst-last=\"true\"></div>\n            <div flex></div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/emailcampaignusers/emailcampaignusers.html","<div id=\"emailcampaignusers\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header page=\"Catagories / Groups\"></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div class=\"head-title\">\n            Email Marketing Campaign: {{vm.name}}\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div class=\"sub-title\">\n            You may manually send out campaign items to individuals or send to all individuals using the ‘Send All’ button.\n          </div>\n\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <!--buttons in a row  -->\n          <div class=\"buttonRow\" layout=\"row\">\n\n            <div flex=\"noshrink\">\n              <label class=\"userButton buttonColor0\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.onBack()\">\n                BACK\n              </label>\n            </div>\n\n            <div flex=\"noshrink\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <label class=\"userButton buttonColor1\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.AddNew()\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n                ADD NEW RECIPIENT MANUALLY\n              </label>\n            </div>\n\n            <div flex=\"noshrink\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <input type=\"file\" id=\"file-upload1\" ng-show=\"false\" name=\"{{$index}}\" accept=\".csv\" onchange=\"angular.element(this).scope().vm.CSVFile(this)\">\n              <label layout=\"row\" layout-align=\"start center\" for=\"file-upload1\" ng-click=\"vm.UploadUsers(\'file-upload1\')\" class=\"userButton buttonColor1\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n                IMPORT CSV OF MARKETING GROUP USERS\n              </label>\n            </div>\n\n            <div flex=\"noshrink\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <a style=\"text-decoration: none\" ng-href=\"{{vm.exportLink}}\">\n                <label class=\"userButton buttonColor1\" layout=\"row\" layout-align=\"start center\">\n                  <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-download.png\">\n                  EXPORT CSV OF MARKETING GROUP USERS\n                </label>\n              </a>\n            </div>\n\n            <!-- <div  style=\"height: 100%; min-width:10px\"></div> -->\n            <div flex=\"noshrink\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <a ng-if=\"!vm.group.issalesgroup\" style=\"text-decoration: none\" href=\"https://s3-us-west-2.amazonaws.com/yougetitfirstfiles/LoadEmailUser.csv\">\n                <label class=\"userButton buttonColor2\" layout=\"row\" layout-align=\"start center\">\n                  <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-download.png\">\n                  DOWNLOAD CSV TEMPLATE: CAMPAIGN RECIPIENTS\n                </label>\n              </a>\n            </div>\n\n          </div>\n\n          <!-- <ya-help-tips name=\"groupuser\" data=\"vm.helpTipList\"></ya-help-tips> -->\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <div flex style=\"width:100%\">\n            <md-list class=\"\" id=\"\">\n\n              <!-- Table Heading start here -->\n              <md-list-item class=\"listItem listHover\" style=\"height:200px;  font-weight: 600; color: #585858; margin-bottom: 5px\">\n                <div style=\"width: 100%\" layout=\"row\" layout-align=\"start end\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">FIRST NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">LAST NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">EMAIL</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" style=\"width: 120px; min-width: 120px\">PHONE NUMBER</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" style=\"width: 100px; min-width: 100px\">STATUS</div>\n\n                  <!--1  -->\n                  <div flex=\"nogrow\" layout=\"column\" layout-align=\"start start\" class=\"cards listbutton\" style=\"cursor: pointer\">\n                    <div class=\"edit-email-block\" ng-click=\"vm.openEmailEditor(0)\">\n                      <div class=\"edit-text\">\n                        EDIT\n                      </div>\n                      <div class=\"body-text\">\n                        <div class=\"title\">\n                          {{vm.emailTemplates[0].title}}\n                        </div>\n                        <div class=\"body\">\n                          {{vm.emailTemplates[0].body}}\n                        </div>\n                      </div>\n                    </div>\n                    <div ng-click=\"vm.InviteAll(0)\" style=\"\" layout=\"row\" layout-align=\"center center\" class=\"invite-all-button\">\n                      <img style=\"padding-right:10px\" src=\"assets\\images\\icons\\user-invite.png\"> Invite All\n                    </div>\n                  </div>\n\n                  <!--2  -->\n                  <div flex=\"nogrow\" layout=\"column\" layout-align=\"start start\" class=\"cards listbutton\" style=\"cursor: pointer\">\n                    <div class=\"edit-email-block\" ng-click=\"vm.openEmailEditor(1)\">\n                      <div class=\"edit-text\">\n                        EDIT\n                      </div>\n                      <div class=\"body-text\">\n                        <div class=\"title\">\n                          {{vm.emailTemplates[1].title}}\n                        </div>\n                        <div class=\"body\">\n                          {{vm.emailTemplates[1].body}}\n                        </div>\n                      </div>\n                    </div>\n                    <div ng-click=\"vm.InviteAll(1)\" layout=\"row\" layout-align=\"center center\" class=\"invite-all-button\">\n                      <img style=\"padding-right:10px\" src=\"assets\\images\\icons\\user-invite.png\"> Invite All\n                    </div>\n                  </div>\n\n                  <!--3  -->\n                  <div flex=\"nogrow\" layout=\"column\" layout-align=\"start start\" class=\"cards listbutton\" style=\"cursor: pointer\">\n                    <div class=\"edit-email-block\" ng-click=\"vm.openEmailEditor(2)\">\n                      <div class=\"edit-text\">\n                        EDIT\n                      </div>\n                      <div class=\"body-text\">\n                        <div class=\"title\">\n                          {{vm.emailTemplates[2].title}}\n                        </div>\n                        <div class=\"body\">\n                          {{vm.emailTemplates[2].body}}\n                        </div>\n                      </div>\n                    </div>\n                    <div ng-click=\"vm.InviteAll(2)\" layout=\"row\" layout-align=\"center center\" class=\"invite-all-button\">\n                      <img style=\"padding-right:10px\" src=\"assets\\images\\icons\\user-invite.png\"> Invite All\n                    </div>\n                  </div>\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b\" aria-label=\"edit\" class=\"listbutton md-icon-btn editTrash\" style=\"display:hidden\">\n                    <img style=\"padding-right: 10px; display:none\" src=\"assets\\images\\icons\\edit_icon-gray.png\">\n                    <span style=\"display:none\">Edit</span>\n                  </div>\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" class=\"listbutton md-icon-btn editTrash\">\n                    <img style=\"display:none\" src=\"assets\\images\\icons\\user-trash.png\">\n                  </div>\n\n                 </div>\n\n              </md-list-item><!-- Table Heading end here -->\n\n              <!--Table Rows start here  -->\n              <md-list-item class=\"listHover\" style=\"font-weight: 500; color: #585858\" ng-repeat=\"x in vm.getPageUsers() track by $index\">\n                <div ng-show=\"!x.edit\" style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.firstname}}</span>\n                  </div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.lastname}}</span>\n                  </div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">\n                    <span class=\"ellipsis\">{{x.email}}</span>\n                  </div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" style=\"width: 120px; min-width: 120px\">\n                    {{x.phonenumber}}\n                  </div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" style=\"width: 100px; min-width: 100px\">\n                    {{vm.getStatus(x)}}\n                  </div>\n\n                  <!--1  -->\n                  <div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\" class=\"cards listbutton\" style=\"cursor: pointer\">\n                    <div style=\"color:#9b9b9b\" ng-click=\"vm.SendInvite(x, 0)\">\n                      <div ng-show=\"vm.userCanInvite(x, 0)\">\n                        <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Invite\n                      </div>\n                      <div ng-show=\"vm.userCanReinvite(x, 0)\" class=\"reinvite\">\n                        <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Re-Invite\n                      </div>\n                    </div>\n                  </div>\n\n                    <!--2  -->\n                  <div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\" class=\"cards listbutton\" style=\"cursor: pointer\">\n                    <div style=\"color:#9b9b9b\" ng-click=\"vm.SendInvite(x, 1)\">\n                      <div ng-show=\"vm.userCanInvite(x, 1)\">\n                        <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Invite\n                      </div>\n                      <div ng-show=\"vm.userCanReinvite(x, 1)\" class=\"reinvite\">\n                        <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Re-Invite\n                      </div>\n                    </div>\n                  </div>\n\n                  <!--3  -->\n                  <div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\" class=\"cards listbutton\" style=\"cursor: pointer\">\n                    <div style=\"color:#9b9b9b\" ng-click=\"vm.SendInvite(x, 2)\">\n                      <div ng-show=\"vm.userCanInvite(x, 2)\">\n                        <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Invite\n                      </div>\n                      <div ng-show=\"vm.userCanReinvite(x, 2)\" class=\"reinvite\">\n                        <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Re-Invite\n                      </div>\n                    </div>\n                  </div>\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b; cursor:pointer\" aria-label=\"edit\" ng-click=\"vm.OpenEdit(x)\" class=\"listbutton md-icon-btn editTrash\">\n                    <img style=\"padding-right: 10px\" src=\"assets\\images\\icons\\edit_icon-gray.png\"> Edit\n                  </div>\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" aria-label=\"remove\" ng-click=\"vm.ConfirmRemove(x)\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                    <img src=\"assets\\images\\icons\\user-trash.png\">\n                  </div>\n\n                </div>\n\n                <!--EDIT-->\n                <div class=\"shadow\" ng-show=\"x.edit\" layout=\"row\" style=\"width: 100%; height: 300px; background-color: white\">\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" style=\"width: 30%\">\n\n                    <div style=\"height: 6%\"></div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>First Name</label>\n                        <input class=\"inputStyle\" aria-label=\"firstname\" type=\"text\" value=\"{{x.firstname}}\" ng-model=\"x.firstname\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Last Name</label>\n                        <input class=\"inputStyle\" aria-label=\"lastname\" type=\"text\" value=\"{{x.lastname}}\" ng-model=\"x.lastname\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Mobile Phone Number</label>\n                        <input class=\"inputStyle\" type=\"text\" aria-label=\"phonenumber\" name=\"phonenumber\" value=\"{{x.phonenumber}}\" ng-model=\"x.phonenumber\" ng-change=\"vm.updatePhoneNumber(x)\">\n                      </md-input-container>\n                    </div>\n\n\n                  </div>\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" style=\"width: 30%\">\n\n                    <div style=\"height: 6%\"></div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactEmail.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Email</label>\n                        <input class=\"inputStyle\" aria-label=\"email\" type=\"text\" onclick=\"if(value==\'abc@abc.com\'){value=\'\'}\" value=\"{{x.email}}\" ng-model=\"x.email\" ng-pattern=\"vm.ePattern\" readonly=\"readonly\">\n                        <div ng-messages=\"{\'pattern\': !x.email}\">\n                          <div ng-message=\"pattern\">invalid email</div>\n                        </div>\n                      </md-input-container>\n                    </div>\n\n                  </div>\n                  <div style=\"width: 6%\"></div>\n\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" layout-align=\"start center\" style=\"width: 19%\">\n                    <div style=\"width: 100%; height: 6%\"></div>\n                    <div style=\"color: #0f6ad4; font-size: 16px; font-weight: 600\" aria-label=\"done\" ng-click=\"vm.CloseEdit(x)\">\n                      <img style=\"margin-right: 18px; margin-top: -5px\" src=\"assets\\images\\icons\\user-check.png\"> Done Editing\n                    </div>\n                  </div>\n                </div>\n                <!--END edit  -->\n\n              </md-list-item><!--Table Rows end here  -->\n\n            </md-list>\n          </div>\n\n          <div layout=\"row\" style=\"width: 100%; padding-bottom:10px\">\n            <div flex></div>\n            <div paging page=\"vm.currentPage\" total=\"vm.totalPages\" page-size=\"1\" paging-action=\"vm.onPage()\" show-prev-next=\"true\" showfirst-last=\"true\"></div>\n            <div flex></div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/error/error.html","<div id=\"error\" class=\"page-bump\">\n	<div class=\"bgcolor\">\n		<div class=\"headerbox headcenter\">\n			<div class=\"centered error-style textcolor\">\n				ERROR!\n			</div>\n		</div>\n	</div>\n	<div class=\"centered\">\n		<div class=\"labelone textmove\">\n			Something went wrong!<br>\n      Error: {{vm.errorID}}\n		</div>\n		<div class=\"centerTop\">\n      Information has been collected when receiving this error and we will work towards fixing it.\n		</div>\n		<md-button class=\"backButton centered buttonPadding\" onclick=\"goBack()\">BACK</md-button>\n	</div>\n	<script>\n		function goBack() {\n		    window.history.back();\n		}\n	</script>\n</div>\n");
$templateCache.put("app/pages/existing/existing.html","<div id=\"existing\" layout=\"row\">\n	<div class=\"leftContent\">\n		<img class=\"tenpx\" src=\"assets\\images\\onboarding-logo.png\">\n		<div ng-show=\"vm.state==\'Question\'\" layout=\"column\" layout-align=\"center center\" flex=\"100\">\n			<div class=\"title\">\n				ARE YOU AN EXISTING MEMBER?\n			</div>\n			<div class=\"buttonPadding\"></div>\n			<div ng-click=\"vm.Existing()\" type=\"submit\" class=\"yesButton button\" layout=\"row\" layout-align=\"center center\" ng-click=\"\">\n				<div class=\"buttonText\">\n					YES, I am an Existing Member\n				</div>\n			</div>\n\n			<div class=\"buttonPadding\"></div>\n			<div ng-click=\"vm.NewUser()\" class=\"noButton button\" layout=\"row\" layout-align=\"center center\" ng-click=\"\">\n				<div class=\"buttonText\">\n					NO, I am a New User\n				</div>\n			</div>\n			<div class=\"oopsSpace\"></div>\n			<div onclick=\"location.href=\'#home\'\" class=\"playVid buttOver button\" layout=\"row\" layout-align=\"center center\">\n				<div class=\"buttonText\">\n					Oops, Take me Back!\n				</div>\n			</div>\n		</div>\n		<div ng-show=\"vm.state==\'Login\'\" layout=\"column\" layout-align=\"center center\" flex=\"100\">\n			<div class=\"title\">\n				ARE YOU AN EXISTING MEMBER?\n			</div>\n			<div class=\"oopsSpace\"></div>\n			<form name=\"loginForm\" layout=\"column\" ng-submit=\"vm.Login(loginForm.$valid)\" class=\"forms\" flex=\"noshrink\" layout-align=\"center center\">\n				\n				<div class=\"login\" layout=\"column\" flex layout-align=\"center center\">				\n					<md-input-container class=\"md-block login\">\n						<label class=\"formtext\">Email</label>\n						<input aria-label=\"email\" name=\"username\" ng-model=\"vm.login.username\" required>\n						<div ng-messages=\"loginForm.username.$error\" ng-show=\"loginForm.username.$dirty\" md-auto-hide=\"false\">\n							<div ng-message=\"required\">Username Required</div>\n						</div>\n					</md-input-container>\n\n					<div class=\"fiftypx\"></div>\n					\n					<md-input-container class=\"md-block login\">\n						<label class=\"formtext\">Password</label>\n						<input aria-label=\"password\" name=\"password\" type=\"password\" required ng-model=\"vm.login.password\">\n						<div ng-messages=\"loginForm.password.$error\" ng-show=\"loginForm.password.$dirty\" md-auto-hide=\"false\">\n							<div ng-message=\"required\">Password Required</div>\n						</div>\n					</md-input-container>				\n				</div>\n				<div class=\"oopsSpace\"></div>\n				<div layout=\"column\" layout-align=\"center center\">\n					<!-- <md-button aria-label=\"validation email\" ng-click=\"vm.Resend()\" class=\"md-raised contButton\">Resend Validation Email</md-button> -->\n					<md-button aria-label=\"cancel\" ng-click=\"vm.Cancel()\" class=\"md-raised cancButton\">Cancel</md-button>\n					<md-button aria-label=\"continue\" type=\"submit\" ng-disabled=\"!loginForm.$valid\" class=\"md-raised contButton\">Continue</md-button>		\n				</div>\n				<div class=\"tenpx\"></div>\n			</form>\n		</div>\n\n		<div ng-show=\"vm.state==\'Register\'\" flex=\"noshrink\" layout=\"column\" layout-align=\"center center\">\n			<div class=\"title\">\n				ARE YOU AN EXISTING MEMBER?\n			</div>\n			<div class=\"fiftypx\"></div>\n			<form name=\"userForm\" ng-submit=\"vm.Register(userForm.$valid)\" class=\"forms\" flex=\"noshrink\" layout-align=\"space-between center\">\n				<div layout=\"row\">\n					<div class=\"login\" layout=\"column\" flex=\"100\" layout=\"column\" layout-align=\"center center\">\n						<md-input-container class=\"login\">\n							<label>Email</label>\n							<input aria-label=\"email\" name=\"email\" ng-model=\"vm.user.email\" required ng-pattern=\"vm.ePattern\" type=\"text\">\n							<div ng-messages=\"userForm.email.$error\" ng-show=\"userForm.email.$dirty\">\n								<div ng-message-exp=\"[\'required\',\'pattern\']\">Valid email required</div>\n							</div>\n						</md-input-container>\n\n						<div class=\"tenpx\"></div>\n\n						<md-input-container class=\"login\">\n							<label>User Name</label>\n							<input aria-label=\"username\" name=\"username\" ng-model=\"vm.user.username\" required ng-pattern=\"/\\S/\" minlength=\"5\" md-maxlength=\"32\">\n							<div ng-messages=\"userForm.username.$error\" ng-show=\"userForm.username.$dirty\" md-auto-hide=\"false\">\n								<div ng-message=\"required\">Username Required</div>\n								<div ng-message=\"pattern\">Spaces not allowed</div>\n								<div ng-message=\"minlength\">Username too short</div>\n								<div ng-message=\"md-maxlength\">Username too long</div>\n							</div>\n						</md-input-container>\n\n						<div class=\"tenpx\"></div>\n\n						<md-input-container class=\"login\">\n							<label>Password</label>\n							<input id=\"pass1\" aria-label=\"password\" ng-ya-password-clear=\"pass2\" name=\"password\" type=\"password\" ng-model=\"vm.user.password\" required ng-pattern=\"/\\S/\" minlength=\"6\" md-maxlength=\"64\">\n							<div ng-messages=\"userForm.password.$error\" ng-show=\"userForm.password.$dirty\" md-auto-hide=\"false\">\n								<div ng-message=\"required\">Password Required</div>\n								<div ng-message=\"pattern\">Spaces not allowed</div>\n								<div ng-message=\"minlength\">Password too short</div>\n								<div ng-message=\"md-maxlength\">Password too long</div>\n							</div>\n						</md-input-container>\n\n						<md-input-container class=\"login\">\n							<label>Confirm Password</label>\n							<input id=\"pass2\" aria-label=\"password confirm\" ng-ya-password-match=\"pass1\" name=\"password2\" type=\"password\" ng-model=\"vm.user.confirm\" required>\n							<div ng-messages=\"userForm.password2.$error\" ng-show=\"userForm.password2.$dirty\" md-auto-hide=\"false\">\n								<div ng-message=\"ngYaPasswordMatch\">Passwords do not match</div>\n								<div ng-message=\"required\">Password confirmation required</div> \n							</div>\n						</md-input-container>\n					</div>\n					<div class=\"login\" flex=\"100\">\n						<!-- <div class=\"fivepx\"></div> -->\n						 <mdp-date-picker aria-label=\"birthday\" mdp-placeholder=\"Birthday\" name=\"bday\" required ng-model=\"myDate\" flex=\"100\"></mdp-date-picker>\n						<!--md-datepicker aria-label=\"birthday\" ng-model=\"myDate\" name=\"bday\" md-placeholder=\"bday\" required flex=\"100\"></md-datepicker-->\n						<div ng-messages=\"userForm.bday.$error\" ng-show=\"userForm.bday.$touched\">\n							<div ng-message=\"required\">Date of birth required</div>\n						</div>\n					</div>\n				</div>\n				<div class=\"fiftypx\"></div>\n				<div layout=\"row\">               \n					<md-button ng-click=\"vm.Cancel()\" class=\"md-raised cancButton\">Cancel</md-button>\n					<md-button type=\"submit\" ng-disabled=\"!userForm.$valid\" class=\"md-raised contButton\">Continue</md-button>					\n				</div>\n				<div class=\"tenpx\"></div>\n			</form>\n		</div>\n	</div>\n	<div class=\"tutorial\" layout=\"column\" layout-align=\"center center\">\n		<div flex=\"65\"></div>\n		<div>\n			<div class=\"hideText\">\n				If you are an existing member, please sign in.\n			</div>\n			<div class=\"tenpx\"></div>\n			<div class=\"hideText\">\n				If you are a new member, please sign up for an account to proceed. \n			</div>\n		</div>\n	</div>\n</div>");
$templateCache.put("app/pages/group/group.html","<div id=\"catgroup\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div class=\"title\">\n            Choose Your Organization\'s Recipient Groups\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div layout=\"row\">\n            <div class=\"sub-title\" flex=\"60\">\n              Recipientss groups are groups of mobile users that messages can be delivered to.\n            </div>\n            <div flex=\"40\">\n              <div layout=\"row\" class=\"search-input\">\n                <input style=\"width: 100%; margin-bottom: 15px; box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12); border: solid 1px #9b9b9b\" type=\"text\" id=\"\" placeholder=\"Who are you looking for?\" class=\"search-box\" ng-model=\"vm.filter\" ng-change=\"vm.GroupUpdate()\" ng-model-options=\"{ debounce: 500 }\">\n                <button class=\"clearButton\" ng-click=\"vm.filter = \'\'; vm.GroupUpdate()\" style=\"position: absolute; right: 15px; padding-top: 7px\">\n                  <img src=\"/assets/images/search-icon.png\" style=\"width: 14px; position: absolute; right: 120%; padding-top: 2px\">\n                  <div class=\"search-line\"></div>\n                  <div class=\"X\">X</div>\n                </button>\n              </div>\n            </div>\n          </div>\n          <!-- <div class=\"sub-title\">\n            Recipients groups are groups of mobile users that messages can be delivered to.\n          </div> -->\n\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <!--buttons in a row  -->\n          <div class=\"buttonRow\" layout=\"row\">\n\n            <div flex=\"nogrow\">\n              <label class=\"userButton buttonColor1 buttonsize4\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.AddCat(true)\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n              Add New Recipient Group\n              </label>\n            </div>\n          </div>\n\n          <ya-help-tips name=\"user\" data=\"vm.helpTipList\"></ya-help-tips>\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <div flex style=\"width:100%\" ng-show=\"vm.filter==\'\'\">\n            <md-list>\n\n              <!-- Table Heading start here -->\n              <md-list-item class=\"listItem listHover\" style=\"font-weight: 600; color: #585858; margin-bottom: 5px\">\n                <div style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"noshrink\" class=\"avatar\" layout=\"row\" layout-align=\"center center\">ENABLE</div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"groupName\">RECIPIENT GROUP NAME</div>\n\n                  <!--push to end  -->\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n                    <!-- intentionally left empty -->\n                  </div>\n\n                </div>\n              </md-list-item>\n\n              <!--Table Rows start here  -->\n              <md-list-item class=\"listHover\" style=\"min-height:75px;  font-weight: 500; color: #585858\" ng-repeat=\"x in vm.grpList\">\n                <!-- Normal Version  -->\n                <div ng-show=\"!x.edit && x.enabled\" style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"noshrink\" class=\"avatar\" layout=\"row\" layout-align=\"center center\" style=\"padding-left:10px\">\n                    <md-checkbox aria-label=\"enabled\" ng-change=\"vm.Disable(x)\" ng-model=\"x.enabled\"></md-checkbox>\n                  </div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"groupName\">{{x.name}} [{{x.membercount | number:0}}]</div>\n\n                  <!--push to end  -->\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n\n                    <div flex=\"nogrow\" layout-align=\"start center\" class=\"listbutton\" ng-click=\"vm.AddUsers(x)\" style=\"color: #9b9b9b; padding-right:20px; cursor:pointer\">\n                      <img style=\"padding-right: 10px; padding-bottom: 3px\" src=\"assets\\images\\icons\\add-update-recipient.png\">Add\n                      / Update Recipient Info\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b; cursor:pointer\" aria-label=\"edit\" ng-click=\"vm.OpenEdit($index,false)\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"padding-right: 10px\" src=\"assets\\images\\icons\\edit_icon-gray.png\">Edit\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" ng-if=\"!x.orgadmin\" aria-label=\"remove\" ng-click=\"vm.RemoveCat($index,false)\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                      <img src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div><!--end end-->\n                </div>\n\n                <!-- Disabled Alpha\'d Version -->\n                <div ng-show=\"!x.edit && !x.enabled\" style=\"width: 100%; opacity: 0.4\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"noshrink\" class=\"avatar\" layout=\"row\" layout-align=\"center center\" style=\"padding-left:10px\">\n                    <md-checkbox aria-label=\"enabled\" ng-change=\"vm.Disable(x)\" ng-model=\"x.enabled\"></md-checkbox>\n                  </div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"groupName\">{{x.name}} [{{x.membercount | number:0}}]</div>\n\n                  <!--push to end  -->\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n\n                    <div flex=\"nogrow\" layout-align=\"start center\" class=\"listbutton\" ng-click=\"vm.AddUsers(x)\" style=\"color: #9b9b9b; padding-right:20px; cursor:pointer\">\n                      <img style=\"padding-right: 10px; padding-bottom: 3px\" src=\"assets\\images\\icons\\add-update-recipient.png\">Add\n                      / Update Recipient Info\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b; cursor:pointer\" aria-label=\"edit\" ng-click=\"vm.OpenEdit($index,false)\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"padding-right: 10px\" src=\"assets\\images\\icons\\edit_icon-gray.png\">Edit\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" ng-if=\"!x.orgadmin\" aria-label=\"remove\" ng-click=\"vm.RemoveCat($index,false)\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                      <img src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div><!--end end-->\n                </div><!-- END Disabled Alpha\'d Version -->\n \n                <!-- EDIT  -->\n                <div style=\"max-height: 75px; width: 100%\" ng-show=\"x.edit\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"noshrink\" class=\"avatar\" layout=\"row\" layout-align=\"center center\" style=\"padding-left:10px\">\n                    <md-checkbox aria-label=\"enabled\" ng-change=\"vm.Disable(x)\" ng-model=\"x.enabled\"></md-checkbox>\n                  </div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n\n                  <div layout=\"column\" class=\"groupName\">\n                    <div style=\"width: 100%; height: 25px\"></div>\n                    <md-input-container style=\"min-width: 300px; font-size: 15px\">\n                      <label>Recipient Group Name</label>\n                      <input aria-label=\"category name\" type=\"text\" value=\"{{x.name}}\" ng-model=\"x.name\">\n                    </md-input-container>\n                  </div>\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n\n                    <div flex=\"nogrow\" class=\"listbutton\" layout=\"row\" layout-align=\"center center\" style=\"cursor:pointer; padding-right:60px\" ng-click=\"vm.CloseEdit($index,false)\">\n                      <img style=\"padding-right: 10px; padding-bottom: 3px\" src=\"/assets/images/icons/user-check.png\"> Done\n                      Editing\n                    </div>\n                  </div>\n                </div>\n\n              </md-list-item>\n              <!--Table Rows end here  -->\n\n            </md-list>\n          </div>\n\n          <div flex style=\"width:100%\" ng-show=\"vm.filter!=\'\'\">\n            <md-list>\n\n              <!-- Table Heading start here -->\n              <md-list-item class=\"listItem listHover\" style=\"font-weight: 600; color: #585858; margin-bottom: 5px\">\n                <div style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\"></div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">FIRST NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">LAST NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">TITLE</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">EMAIL</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" style=\"width: 120px; min-width: 120px\">PHONE NUMBER</div>\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\">STATUS</div> -->\n\n                  <!--spacer  -->\n                  <!-- <div flex=\"grow\" style=\"max-width:300px; width:200px;\"></div> -->\n\n                  <!-- <div flex=\"grow\" id=\"inviteAllToggle\" class=\"listbutton name-section\">\n                    <div ng-click=\"vm.InviteAll() \" layout=\"row\" layout-align=\"start center\" role=\"button\">\n                      <img style=\"margin-top: -3px; padding-right:10px;\" src=\"assets\\images\\icons\\user-invite.png\">\n                      Remind All\n                    </div>\n                  </div> -->\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b\" aria-label=\"edit\" class=\"listbutton md-icon-btn editTrash\" style=\"display:hidden\">\n                    <img style=\"padding-right: 10px; display:none\" src=\"assets\\images\\icons\\edit_icon-gray.png\">\n                    <span style=\"display:none\">Edit</span>\n                  </div>\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" class=\"listbutton md-icon-btn editTrash\">\n                    <img style=\"display:none\" src=\"assets\\images\\icons\\user-trash.png\">\n                  </div>\n\n                </div>\n              </md-list-item>\n              <!-- Table Heading end here -->\n\n              <!--Table Rows start here  -->\n              <md-list-item class=\"listHover\" style=\"font-weight: 500; color: #585858\" ng-repeat=\"x in vm.users track by $index\">\n                <div ng-show=\"!x.edit\" style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n                  <!--spacer  -->\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\">\n                    <img ng-show=\"x.profileimage\" ng-src=\"{{x.profileimage}}\" id=\"display{{$index}}\" class=\"md-avatar\">\n                    <img ng-show=\"!x.profileimage\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n                  </div>\n\n                  <!--spacer  -->\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.firstname}}</span></div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.lastname}}</span></div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.title}}</span></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">\n                    <span class=\"ellipsis\">{{x.email}}</span>\n                  </div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" style=\"height: 40px; min-height: 40px; width: 120px; min-width: 120px\">{{x.phonenumber}}</div>\n\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{vm.getStatus(x)}}</span>\n                  </div> -->\n\n                  <!--spacer  -->\n                  <!-- <div flex=\"grow\" style=\"max-width:300px; width:200px;\"></div> -->\n\n                  <!-- <div flex=\"none\" layout-align=\"start center\" class=\"listbutton name-section\">\n                    <div style=\"color:#9b9b9b; cursor:pointer;\" ng-click=\"vm.SendInvite(x)\">\n                      <div ng-show=\"vm.canInvite(x)\">\n                        <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Invite\n                      </div>\n                      <div ng-show=\"vm.canReinvite(x)\" class=\"reinvite\">\n                        <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Re-Invite\n                      </div>\n                      <div ng-show=\"vm.canRemind(x)\" class=\"remind\">\n                        <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Remind\n                      </div>\n                    </div>\n                  </div> -->\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b; cursor:pointer\" aria-label=\"edit\" ng-click=\"vm.GroupUserOpenEdit(x)\" class=\"listbutton md-icon-btn editTrash\">\n                    <img style=\"padding-right: 10px\" src=\"assets\\images\\icons\\edit_icon-gray.png\"> Edit\n                  </div>\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" ng-if=\"!x.orgadmin\" aria-label=\"remove\" ng-click=\"vm.GroupUserConfirmRemove(x)\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                    <img src=\"assets\\images\\icons\\user-trash.png\">\n                  </div>\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" ng-if=\"x.orgadmin\" aria-label=\"remove\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                    <img style=\"opacity: .20\" src=\"assets\\images\\icons\\user-trash.png\">\n                  </div>\n\n                </div>\n\n                <!--EDIT popup  -->\n                <div class=\"shadow\" ng-show=\"x.edit\" layout=\"row\">\n                  <div flex=\"nogrow\" layout=\"column\" layout-align=\"start center\" style=\"min-width: 150px; height:100%; padding-top:30px; padding-bottom:30px; background-color: lightgrey\">\n                    <!--1st column  -->\n                    <div flex=\"nogrow\" style=\"padding-bottom:30px\">\n                      <input class=\"ng-hide\" aria-label=\"profile image\" type=\"file\" ng-model=\"vm.users[$index].imageFile\" id=\"profileImage{{$index}}\" onchange=\"angular.element(this).scope().vm.UpdateImage(angular.element(this).scope().$index,this)\" accept=\".jpg\">\n                      <label style=\"color: #0064d8; font-size: 15px; cursor: pointer\" for=\"profileImage{{$index}}\">\n                        Select New Photo\n                      </label>\n                        <div style=\"color: #0064d8; font-size: 15px; cursor: pointer\" ng-show=\"x.imageFile!=null\" ng-click=\"vm.GroupUserUpload($index)\">\n                        UPLOAD\n                      </div>\n                    </div>\n\n                    <div flex=\"nogrow\">\n                      <img ng-show=\"x.profileimage\" ng-src=\"{{x.profileimage}}\" id=\"display2{{$index}}\" class=\"md-avatar\">\n                      <img ng-show=\"!x.profileimage\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n                    </div>\n                  </div>\n\n\n                  <div style=\"width: 2%\"></div>\n                  <!--2nd column  -->\n                  <div layout=\"column\" style=\"width: 30%\">\n\n                    <div style=\"height: 6%\"></div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>First Name</label>\n                        <input class=\"inputStyle\" aria-label=\"firstname\" type=\"text\" value=\"{{x.firstname}}\" ng-model=\"x.firstname\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Last Name</label>\n                        <input class=\"inputStyle\" aria-label=\"lastname\" type=\"text\" value=\"{{x.lastname}}\" ng-model=\"x.lastname\">\n                      </md-input-container>\n                    </div>\n\n                  </div>\n\n                  <div style=\"width: 2%\"></div>\n                  <!--3rd column  -->\n                  <div layout=\"column\" style=\"width: 30%\">\n\n                    <div style=\"height: 6%\"></div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Title</label>\n                        <input class=\"inputStyle\" aria-label=\"title\" type=\"text\" value=\"{{x.title}}\" ng-model=\"x.title\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactEmail.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Email</label>\n                        <input class=\"inputStyle\" aria-label=\"email\" type=\"text\" readonly=\"readonly\" onclick=\"if(value==\'abc@abc.com\'){value=\'\'}\" value=\"{{x.email}}\" ng-model=\"x.email\" ng-pattern=\"vm.ePattern\">\n                        <div ng-messages=\"{\'pattern\': !x.email}\">\n                          <div ng-message=\"pattern\">invalid email</div>\n                        </div>\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Mobile Phone Number</label>\n                        <input class=\"inputStyle\" type=\"text\" aria-label=\"phonenumber\" name=\"phonenumber\" value=\"{{x.phonenumber}}\" ng-model=\"x.phonenumber\" ng-change=\"vm.updatePhoneNumber(x)\">\n                      </md-input-container>\n                    </div>\n\n                  </div>\n                  <!--4th column  -->\n                  <div style=\"width: 6%\"></div>\n                  <div layout=\"column\" style=\"width: 19%\">\n                    <div style=\"height: 6%\"></div>\n                  </div>\n\n                  <div style=\"width: 2%\"></div>\n                  <!--last column  -->\n                  <div layout=\"column\" layout-align=\"start center\" style=\"padding-top:30px; min-width:160px\">\n                    <div style=\"width: 100%; height: 6%\"></div>\n                    <div style=\"color: #0f6ad4; font-size: 16px; font-weight: 600; cursor:pointer\" aria-label=\"done\" ng-click=\"vm.GroupUserCloseEdit(x)\">\n                      <img style=\"margin-right: 18px; margin-top: -5px\" src=\"assets\\images\\icons\\user-check.png\"> Done Editing\n                    </div>\n                  </div>\n                </div>\n                <!--end EDIT popup  -->\n\n              </md-list-item>\n              <!--Table Rows end here  -->\n\n            </md-list>\n          </div>\n\n          <div layout=\"row\" style=\"width: 100%; padding-bottom:10px\">\n            <div flex></div>\n            <div paging page=\"vm.currentPage\" total=\"vm.totalPages\" page-size=\"1\" paging-action=\"vm.onPage()\" show-prev-next=\"true\" showfirst-last=\"true\"></div>\n            <div flex></div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/groupuser/groupuser.html","<div id=\"groupUser\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  --> \n          <div class=\"title\">\n            Add / Update Recipient(s) in: {{vm.name}}\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div layout=\"row\">\n            <div class=\"sub-title\" flex=\"60\">\n              Add new recipients or update recipient information.\n            </div>\n            <div flex=\"40\">\n              <div layout=\"row\" class=\"search-input\">\n                <input style=\"width: 100%; margin-bottom: 15px; box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12); border: solid 1px #9b9b9b\" type=\"text\" id=\"\" placeholder=\"Who are you looking for?\" class=\"search-box\" ng-model=\"vm.filter\" ng-change=\"vm.Update()\" ng-model-options=\"{ debounce: 500 }\">\n                <button class=\"clearButton\" ng-click=\"vm.filter = \'\'; vm.Update()\" style=\"position: absolute; right: 15px; padding-top: 7px\">\n                  <img src=\"/assets/images/search-icon.png\" style=\"width: 14px; position: absolute; right: 120%; padding-top: 2px\">\n                  <div class=\"search-line\"></div>\n                  <div class=\"X\">X</div>\n                </button>\n              </div>\n            </div>\n          </div>\n\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <!--buttons in a row  -->\n          <div class=\"buttonRow\" layout=\"row\">\n\n            <div flex=\"noshrink\">\n              <label class=\"userButton buttonColor0\" layout=\"row\" style=\"padding-left:15px\" layout-align=\"center center\" ng-click=\"vm.onBack()\">\n                BACK\n              </label>\n            </div>\n\n            <div flex=\"noshrink\" style=\"height: 100%; width:10px\"></div>\n\n            <div flex=\"noshrink\">\n              <label ng-if=\"!vm.group.issalesgroup\" class=\"userButton buttonColor1\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.AddNew()\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n                ADD NEW RECIPIENT MANUALLY\n              </label>\n            </div>\n\n            <div flex=\"noshrink\" style=\"height: 100%; width:10px\"></div>\n\n            <div flex=\"noshrink\">\n              <input ng-if=\"!vm.group.issalesgroup\" type=\"file\" id=\"file-upload1\" ng-show=\"false\" name=\"{{$index}}\" accept=\".csv\" onchange=\"angular.element(this).scope().vm.CSVFile(this)\">\n              <label layout=\"row\" ng-if=\"!vm.group.issalesgroup\" layout-align=\"center center\" for=\"file-upload1\" ng-click=\"vm.UploadUsers(\'file-upload1\')\" class=\"userButton buttonColor1\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n                IMPORT CSV OF RECIPIENTS\n              </label>\n            </div>\n\n            <div flex=\"noshrink\" style=\"height: 100%; width:10px\"></div>\n\n            <div flex=\"noshrink\">\n              <a style=\"text-decoration: none\" ng-href=\"{{vm.exportLink}}\">\n                <label class=\"userButton buttonColor1\" layout=\"row\" layout-align=\"start center\" style=\"max-width: 410px\">\n                  <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-download.png\">\n                  EXPORT CSV OF RECIPIENTS\n                </label>\n              </a> \n            </div>\n\n            <div flex=\"grow\" style=\"height: 100%; min-width:10px\"></div>\n\n            <div flex=\"noshrink\">\n              <a ng-if=\"!vm.group.issalesgroup\" style=\"text-decoration: none\" href=\"https://s3-us-west-2.amazonaws.com/yougetitfirstfiles/LoadGroupData.csv\">\n                <label class=\"userButton buttonColor2\" layout=\"row\" layout-align=\"start center\" style=\"max-width: 410px\">\n                  <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-download.png\">\n                  DOWNLOAD CSV TEMPLATE: GROUP RECIPIENTS\n                </label>\n              </a>\n            </div>\n          </div>\n\n          <ya-help-tips name=\"groupuser\" data=\"vm.helpTipList\"></ya-help-tips>\n          <div ng-if=\"vm.group.issalesgroup\" id=\"help-tip\" ng-if=\"vm.active\" class=\"enter\" layout=\"column\">\n            <div layout=\"row\" layout-align=\"center center\" class=\"ie myStyle\">\n\n              <div flex=\"5\" class=\"icon\">\n                <md-icon md-svg-src=\"/assets/images/icons/ic_lightbulb_outline_black_24px.svg\"></md-icon>\n              </div>\n\n              <div flex class=\"text\">\n                This is a sales group. Manage your sales users from the sales organization page, accessible from You App Corporate <a ng-href=\"/#/editsalesorg/{{vm.group.salespersongroupid}}\">here.</a>.\n              </div>\n            </div>\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <div flex style=\"width:100%\">\n            <md-list class=\"\" id=\"\">\n\n              <!-- Table Heading start here -->\n              <md-list-item class=\"listItem listHover\" style=\"font-weight: 600; color: #585858; margin-bottom: 5px\">\n                <div style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\"></div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">FIRST NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">LAST NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">TITLE</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">EMAIL</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" style=\"width: 120px; min-width: 120px\">PHONE NUMBER</div>\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\">STATUS</div> -->\n\n                  <!--spacer  -->\n                  <!-- <div flex=\"grow\" style=\"max-width:300px; width:200px;\"></div> -->\n\n                  <div flex=\"grow\" id=\"inviteAllToggle\" class=\"listbutton name-section\">\n                    <div ng-click=\"vm.InviteAll() \" layout=\"row\" layout-align=\"start center\" role=\"button\">\n                      <img style=\"margin-top: -3px; padding-right:10px\" src=\"assets\\images\\icons\\user-invite.png\">\n                      Remind All\n                    </div>\n                  </div>\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b\" aria-label=\"edit\" class=\"listbutton md-icon-btn editTrash\" style=\"display:hidden\">\n                    <img style=\"padding-right: 10px; display:none\" src=\"assets\\images\\icons\\edit_icon-gray.png\">\n                    <span style=\"display:none\">Edit</span>\n                  </div>\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" class=\"listbutton md-icon-btn editTrash\">\n                    <img style=\"display:none\" src=\"assets\\images\\icons\\user-trash.png\">\n                  </div>\n\n                </div>\n              </md-list-item>\n              <!-- Table Heading end here -->\n\n              <!--Table Rows start here  -->\n              <md-list-item class=\"listHover\" style=\"font-weight: 500; color: #585858\" ng-repeat=\"x in vm.users track by $index\">\n                <div ng-show=\"!x.edit\" style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n                  <!--spacer  -->\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\">\n                    <img ng-show=\"x.profileimage\" ng-src=\"{{x.profileimage}}\" id=\"display{{$index}}\" class=\"md-avatar\">\n                    <img ng-show=\"!x.profileimage\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n                  </div>\n\n                  <!--spacer  -->\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.firstname}}</span></div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.lastname}}</span></div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.title}}</span></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">\n                    <span class=\"ellipsis\">{{x.email}}</span>\n                  </div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" style=\"height: 40px; min-height: 40px; width: 120px; min-width: 120px\">{{x.phonenumber}}</div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{vm.getStatus(x)}}</span>\n                  </div>\n\n                  <!--spacer  -->\n                  <!-- <div flex=\"grow\" style=\"max-width:300px; width:200px;\"></div> -->\n\n                  <!-- <div flex=\"none\" layout-align=\"start center\" class=\"listbutton name-section\">\n                    <div style=\"color:#9b9b9b; cursor:pointer;\" ng-click=\"vm.SendInvite(x)\">\n                      <div ng-show=\"vm.canInvite(x)\">\n                        <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Invite\n                      </div>\n                      <div ng-show=\"vm.canReinvite(x)\" class=\"reinvite\">\n                        <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Re-Invite\n                      </div>\n                      <div ng-show=\"vm.canRemind(x)\" class=\"remind\">\n                        <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Remind\n                      </div>\n                    </div>\n                  </div> -->\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b; cursor:pointer\" aria-label=\"edit\" ng-click=\"vm.OpenEdit(x)\" class=\"listbutton md-icon-btn editTrash\">\n                    <img style=\"padding-right: 10px\" src=\"assets\\images\\icons\\edit_icon-gray.png\"> Edit\n                  </div>\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" ng-if=\"!x.orgadmin\" aria-label=\"remove\" ng-click=\"vm.ConfirmRemove(x)\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                    <img src=\"assets\\images\\icons\\user-trash.png\">\n                  </div>\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" ng-if=\"x.orgadmin\" aria-label=\"remove\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                    <img style=\"opacity: .20\" src=\"assets\\images\\icons\\user-trash.png\">\n                  </div>\n\n                </div>\n\n                <!--EDIT popup  -->\n                <div class=\"shadow\" ng-show=\"x.edit\" layout=\"row\">\n                  <div flex=\"nogrow\" layout=\"column\" layout-align=\"start center\" style=\"min-width: 150px; height:100%; padding-top:30px; padding-bottom:30px; background-color: lightgrey\">\n                    <!--1st column  -->\n                    <div flex=\"nogrow\" style=\"padding-bottom:30px\">\n                      <input class=\"ng-hide\" aria-label=\"profile image\" type=\"file\" ng-model=\"vm.users[$index].imageFile\" id=\"profileImage{{$index}}\" onchange=\"angular.element(this).scope().vm.UpdateImage(angular.element(this).scope().$index,this)\" accept=\".jpg\">\n                      <label style=\"color: #0064d8; font-size: 15px; cursor: pointer\" for=\"profileImage{{$index}}\">\n                        Select New Photo\n                      </label>\n                        <div style=\"color: #0064d8; font-size: 15px; cursor: pointer\" ng-show=\"x.imageFile!=null\" ng-click=\"vm.Upload($index)\">\n                        UPLOAD\n                      </div>\n                    </div>\n\n                    <div flex=\"nogrow\">\n                      <img ng-show=\"x.profileimage\" ng-src=\"{{x.profileimage}}\" id=\"display2{{$index}}\" class=\"md-avatar\">\n                      <img ng-show=\"!x.profileimage\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n                    </div>\n                  </div>\n\n\n                  <div style=\"width: 2%\"></div>\n                  <!--2nd column  -->\n                  <div layout=\"column\" style=\"width: 30%\">\n\n                    <div style=\"height: 6%\"></div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>First Name</label>\n                        <input class=\"inputStyle\" aria-label=\"firstname\" type=\"text\" value=\"{{x.firstname}}\" ng-model=\"x.firstname\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Last Name</label>\n                        <input class=\"inputStyle\" aria-label=\"lastname\" type=\"text\" value=\"{{x.lastname}}\" ng-model=\"x.lastname\">\n                      </md-input-container>\n                    </div>\n\n                  </div>\n\n                  <div style=\"width: 2%\"></div>\n                  <!--3rd column  -->\n                  <div layout=\"column\" style=\"width: 30%\">\n\n                    <div style=\"height: 6%\"></div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Title</label>\n                        <input class=\"inputStyle\" aria-label=\"title\" type=\"text\" value=\"{{x.title}}\" ng-model=\"x.title\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactEmail.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Email</label>\n                        <input class=\"inputStyle\" aria-label=\"email\" type=\"text\" readonly=\"readonly\" onclick=\"if(value==\'abc@abc.com\'){value=\'\'}\" value=\"{{x.email}}\" ng-model=\"x.email\" ng-pattern=\"vm.ePattern\">\n                        <div ng-messages=\"{\'pattern\': !x.email}\">\n                          <div ng-message=\"pattern\">invalid email</div>\n                        </div>\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Mobile Phone Number</label>\n                        <input class=\"inputStyle\" type=\"text\" aria-label=\"phonenumber\" name=\"phonenumber\" value=\"{{x.phonenumber}}\" ng-model=\"x.phonenumber\" ng-change=\"vm.updatePhoneNumber(x)\">\n                      </md-input-container>\n                    </div>\n\n                  </div>\n                  <!--4th column  -->\n                  <div style=\"width: 6%\"></div>\n                  <div layout=\"column\" style=\"width: 19%\">\n                    <div style=\"height: 6%\"></div>\n                  </div>\n\n                  <div style=\"width: 2%\"></div>\n                  <!--last column  -->\n                  <div layout=\"column\" layout-align=\"start center\" style=\"padding-top:30px; min-width:160px\">\n                    <div style=\"width: 100%; height: 6%\"></div>\n                    <div style=\"color: #0f6ad4; font-size: 16px; font-weight: 600; cursor:pointer\" aria-label=\"done\" ng-click=\"vm.CloseEdit(x)\">\n                      <img style=\"margin-right: 18px; margin-top: -5px\" src=\"assets\\images\\icons\\user-check.png\"> Done Editing\n                    </div>\n                  </div>\n                </div>\n                <!--end EDIT popup  -->\n\n              </md-list-item>\n              <!--Table Rows end here  -->\n\n            </md-list>\n          </div>\n\n          <div layout=\"row\" style=\"width: 100%; padding-bottom:10px\">\n            <div flex></div>\n            <div paging page=\"vm.currentPage\" total=\"vm.totalPages\" page-size=\"1\" paging-action=\"vm.onPage()\" show-prev-next=\"true\" showfirst-last=\"true\"></div>\n            <div flex></div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/home/home.html","<div id=\"home\">\n  <div layout-fill class=\"resp-container\">\n    <iframe class=\"resp-iframe\" ng-src=\"{{vm.getFrameSrc()}}\"></iframe>\n  </div>\n</div>\n");
$templateCache.put("app/pages/iframe-admin/iframeAdmin.html","<!-- <div style=\"position:  absolute; left: 0; top: 0; z-index: 1000; background-color: white;\">\n<pre>\n{{vm.iframeSource | json}}\n{{vm.iframeLookup | json}}\n</pre>\n</div>\n -->\n<div ng-if=\"vm.iframeLookup\" style=\"min-height: 100vh; overflow-y: scroll\">\n  <div id=\"iframe\" ng-class=\"vm.iframeLookup.view\" layout=\"row\">\n    <div style=\"flex-grow: 1\">\n      <div ng-if=\"vm.iframeLookup.view === \'admin\' || vm.iframeLookup.view === \'normal\'\">\n        <ya-main-header></ya-main-header>\n      </div>\n\n\n      <div layout=\"row\" style=\"height:100%\">\n        <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\" ng-if=\"vm.iframeLookup.view === \'admin\'\">\n          <ya-admin-sidenav>\n          </ya-admin-sidenav>\n        </div>\n        <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\" ng-if=\"vm.iframeLookup.view === \'normal\'\">\n          <ya-main-sidenav></ya-main-sidenav>\n        </div>\n        <div layout=\"column\" style=\"width: 100%\">\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n          <div class=\"resp-container\">\n            <iframe class=\"resp-iframe\" ng-src=\"{{vm.iframeSource}}\"></iframe>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/image/image.html","<div id=\"image\">\n\n	<div class=\"page\" layout=\"row\">\n    <ya-help-menu help-page=\"\"></ya-help-menu>\n        <div class=\"leftContent\">\n\n            <img class=\"tenpx\" src=\"assets\\images\\onboarding-logo.png\">\n\n            <div layout=\"column\" layout-align=\"center center\" flex=\"100\">\n\n                <div class=\"title\" layout=\"column\" layout-align=\"center center\">PROFILE IMAGE</div>\n\n                <div class=\"formSize\">\n\n                    <div class=\"padding\" layout=\"column\" layout-align=\"center center\">\n                        <div class=\"padding\" layout=\"row\" layout-align=\"center center\">\n                            <div class=\"padding\">\n                                <image id=\"image1\">\n                            </div>\n                            <div class=\"buttpadding\"></div> <!--my chair could use more butt padding -->\n                            <div layout=\"column\" layout-align=\"center center\" class=\"padding\">\n                                <p>{{vm.profileImage.name}}</p>\n                                <div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.profileimage==null\" class=\"fileUpload uploadButton\">\n                                    <input aria-label=\"browse\" type=\"file\" class=\"upload\" id=\"profileimage\" onchange=\"angular.element(this).scope().vm.Update(\'image1\',this)\" accept=\".jpg\">\n                                        BROWSE\n                                    \n                                </div>\n\n                                <div id=\"\" ng-show=\"vm.profileimage!=null\" class=\"fileUpload\">\n                                    <button aria-label=\"uplaod\" class=\"upload uploadButton\" ng-click=\"vm.Upload(\'profileimage\')\">\n                                        UPLOAD\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"padding\"></div>\n\n                        <div class=\"padding\" layout=\"row\" layout-align=\"center center\">\n                            <div class=\"padding\">\n                                <image id=\"image2\">\n                            </div>\n                            <div class=\"buttpadding\"></div>\n                            <div layout=\"column\" layout-align=\"center center\" class=\"padding\">\n                                <p>{{vm.profiletagline.name}}</p>\n                                <div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.profiletagline==null\" id=\"\" class=\"fileUpload uploadButton\">\n                                    <input aria-label=\"browse\" type=\"file\" class=\"upload\" id=\"profiletagline\" onchange=\"angular.element(this).scope().vm.Update(\'image2\',this)\" accept=\".jpg\">\n                                        BROWSE\n                                    \n                                </div>\n                                <div ng-show=\"vm.profiletagline!=null\" id=\"\" class=\"fileUpload\">\n                                    <button aria-label=\"upload\" class=\"upload uploadButton\" ng-click=\"vm.Upload(\'profiletagline\')\">\n                                        UPLOAD\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n\n                    </div>\n\n                </div>\n\n                <div class=\"padding\">\n                    <div class=\"buttondiv\" layout=\"row\" layout-align=\"center center\">\n\n                        <md-button aria-label=\"back\" class=\"md-raised backButton\" ng-click=\"vm.Back()\" class=\"btn btn-primary\">Back</md-button>\n\n                        <md-button aria-label=\"continue\" class=\"md-raised contButton\" ng-click=\"vm.Continue()\" class=\"btn btn-primary\">Continue</md-button>\n\n                    </div>\n                </div>\n\n            </div>\n\n        </div>\n\n        <div class=\"tutorial\">\n        </div>\n        <!--<input type=\"file\" class=\"fileUpload btn btn-default\" file-model=\"vm.file\" accept=\"image/*\">\n        <button ng-click=\"vm.uploadFile()\">upload me</button>-->\n    </div>\n\n\n</div>\n");
$templateCache.put("app/pages/join/join.html","<div id=\"join\" style=\"background-color: #00618b;  border-radius: 8px; width: 360px; margin: 0px auto\">\n  <div style=\"width: 100%; height: 25%; display: flex; justify-content: center; align-items: flex-start; background-color:#00618B\">\n    <img class=\"logoTop\" src=\"assets/images/you-brand-medium.png\" style=\"max-width: 100%; height: 80px;\n    margin: auto\">\n  </div>\n  <div style=\"width: 100%; margin-top: 0px; display: flex; justify-content: center; align-items: flex-start; border-top-left-radius: 10px; background: #fff; border-top-right-radius: 10px\">\n    <div style=\"font-size: 16px; color: #333; text-align: center\">\n      <p style=\"padding-top:50px\">If you have the YOU app installed, click below.</p>\n	  <a href=\"{{vm.link}}\" style=\"background: #00618b; text-decoration: none; color: #fff; padding: 15px 20px; display: block; border-radius: 2px;     width: 80%;\n    margin: 0px auto\">Open YOU App </a>\n	\n	  <p style=\"padding-top:50px; padding-left:70px; padding-right:70px;line-height: 25px; margin-bottom: 30px\">You can download the app for free from the \n	    <a href=\"https://apps.apple.com/us/app/you-get-it-first/id1164507217\" style=\"text-decoration: none; color: #007bff\">Apple App Store</a> or\n		<a href=\"https://play.google.com/store/apps/details?id=com.forward_move.YOU\" style=\"text-decoration: none; color: #007bff\">Google Play Store</a>.\n	  </p>\n     \n      <!--<p>If you have the application installed, please <a href=\"{{vm.link}}\" style=\"text-decoration: none; color: #007bff;\">open the application</a>.</p>-->\n	  \n	  \n    </div>\n  </div>\n  <div style=\"width: 100%; display: flex; justify-content: center; align-items: flex-start;  margin-top: 0px; background: #fff\">\n    <div class=\"app-buttons\" style=\"display: flex; justify-content: center; align-items: center; gap: 0px; flex-wrap: wrap\">\n      <a href=\"https://apps.apple.com/us/app/you-get-it-first/id1164507217\" style=\"text-decoration: none;  margin-bottom: 30px\">\n        <img src=\"https://s3-us-west-2.amazonaws.com/yougetitfirstfiles/Apple+store.png\">\n      </a>\n      <a href=\"https://play.google.com/store/apps/details?id=com.forward_move.YOU\" style=\"text-decoration: none; margin-bottom: 30px\">\n        <img src=\"https://s3-us-west-2.amazonaws.com/yougetitfirstfiles/Google+Play.png\">\n      </a>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/pages/license/license.html","<div id=\"license\" layout=\"row\" layout-fill>\n    \n	<div class=\"page\" layout=\"row\">        \n        \n		<div class=\"leftContent\">\n            <img class=\"tenpx\" src=\"assets\\images\\onboarding-logo.png\">\n			<div layout=\"column\" layout-align=\"center center\" flex=\"100\">\n                <div class=\"title\" layout=\"column\" layout-align=\"center center\">License Agreement</div>\n				<div flex=\"5\"></div>\n                <div flex=\"40\" layout=\"column\" layout-align=\" left\">\n                    \n                </div>\n            </div>\n		</div>        \n    </div>\n</div>");
$templateCache.put("app/pages/logout/logout.html","<div id=\"logout\">\n  <div layout-fill class=\"resp-container\">\n    <iframe class=\"resp-iframe\" ng-src=\"{{vm.getFrameSrc()}}\"></iframe>\n  </div>\n</div>\n");
$templateCache.put("app/pages/messagereports/messagereports.html","<div id=\"messagereports\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header page=\"MessageReports\"></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n        <div layout-fill class=\"resp-container\">\n          <iframe class=\"resp-iframe\" ng-src=\"{{vm.getFrameSrc()}}\"></iframe>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/messagereportsdetailed/messagereportsdetailed.html","<div id=\"messagedetails\" layout=\"row\">\n  <div class=\"page\" layout=\"row\" layout-align=\"start\" flex>\n    <div id=\"wrapper\" layout=\"column\" flex>\n      <ya-main-header page=\"Message Details\"></ya-main-header>\n      <div layout=\"row\">\n        <div class=\"sideNavi\" layout=\"column\" flex=\"none\">\n          <ya-main-sidenav></ya-main-sidenav>\n        </div>\n        <div layout=\"column\" layout-fill class=\"resp-container-outer\">\n          <div layout-fill class=\"resp-container\">\n            <iframe class=\"resp-iframe\" ng-src=\"{{vm.getFrameSrc()}}\"></iframe>\n          </div>\n        </div>\n      </div>\n    </div>\n    <ya-main-footer></ya-main-footer>\n  </div>\n</div>\n");
$templateCache.put("app/pages/mobilelanding/mobilelanding.html","<div class=\"mobile-landing\">\n  <div class=\"mobile-landing-image-area\">\n    <img class=\"mobile-landing-image\" src=\"assets\\images\\computer-icon.png\">\n  </div>\n  <div class=\"mobile-landing-text\">To use the dashboard, please log in to your You Get It First account on your personal computer.</div>\n</div>\n");
$templateCache.put("app/pages/onboarding/onboarding-billinginfo.html","<div id=\"billingInfo\">\n  <ya-stepper callback=\"vm.getCtrl\">\n    <ya-stepper-item title=\"Billing Info\" active=\"true\" done=\"false\">\n\n\n      <!--New Billing Info-->\n      <div ng-if=\"vm.billing.loaded==false\">\n\n          \n\n          <div style=\"width: 671px; margin-left: 45px; border-left: 1px solid rgba( 0, 0, 0, .15)\" layout=\"column\" layout-align=\"end end\">\n            \n            <div style=\"width: 600px; height: 30px\" layout=\"row\" layout-align=\"start start\">\n                <div style=\"font-size: 24px; margin-bottom: 30px; font-weight: 300\">How will you be paying?</div>\n            </div>\n\n            <div layout=\"row\" layout-align=\"center center\">\n                <div flex></div>\n                <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-payment.png\">\n                <div flex></div>\n                <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                    <md-input-container class=\"md-block\">\n                    <label>Payment Method</label>\n                        <md-select class=\"inputStyle\" aria-label=\"payment inputScale\" ng-model=\"vm.billing.method\" ng-change=\"vm.Update()\">\n                            <md-optgroup>\n                                <label>Payment Method</label>\n                                    <md-option ng-repeat=\"t in vm.billingTypes\" ng-value=\"t\">{{t}}</md-option>\n                            </md-optgroup>            \n                        </md-select>\n                    </md-input-container>\n                </div>\n            </div>\n\n            <div ng-if=\"vm.billing.method==\'\'\" layout=\"column\" layout-align=\"start start\">\n              <div style=\"width: 610px\" layout=\"row\" layout-align=\"end end\">\n                <div flex></div>\n                <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n                <div style=\"width: 100%; height: 100%\"></div>\n                <md-button type=\"submit\" ng-disabled=\"!creditForm.$valid\" class=\"md-raised contButton\">Next</md-button>                \n              </div>\n            </div>\n            \n            <div ng-if=\"vm.billing.method==\'Bank Account\'\" layout=\"column\" layout-align=\"start start\">\n                <form name=\"bankForm\" ng-submit=\"vm.SetUp(bankForm.$valid)\">\n                    \n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex></div>\n                        <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-bankname.png\">\n                        <div flex></div>\n                        <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                            <md-input-container class=\"md-block inputCont\">\n                                <label>Bank Name</label>\n                                <input class=\"inputStyle\" aria-label=\"bank name\" name=\"bank\" type=\"text\" required ng-model=\"vm.billing.bankName\">\n                                <div ng-messages=\"bankForm.bank.$error\" ng-show=\"bankForm.bank.$dirty\">\n                                    <div ng-message=\"required\">Bank name required</div>\n                                </div>\n                            </md-input-container>\n                        </div>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex></div>\n                        <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-number.png\">\n                        <div flex></div>\n                        <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                            <md-input-container class=\"md-block inputCont\">\n                                <label>Routing #</label>\n                                <input class=\"inputStyle\" aria-label=\"routing number\" name=\"routing\" type=\"text\" class=\"no-spinbox\" required ng-pattern=\"vm.rPattern\" ng-model=\"vm.billing.routingNumber\">\n                                <div ng-messages=\"bankForm.routing.$error\" ng-show=\"bankForm.routing.$dirty\">\n                                    <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid routing number required</div>\n                                </div>\n                            </md-input-container>\n                        </div>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex></div>\n                        <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-number.png\">\n                        <div flex></div>\n                        <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                            <md-input-container class=\"md-block inputCont\">\n                                <label>Account #</label>\n                                <input class=\"inputStyle\" aria-label=\"account number\" name=\"account\" type=\"text\" class=\"no-spinbox\" required ng-pattern=\"vm.aPattern\" ng-model=\"vm.billing.accountNumber\">\n                                <div ng-messages=\"bankForm.account.$error\" ng-show=\"bankForm.account.$dirty\">\n                                    <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid account number required</div>\n                                </div>\n                            </md-input-container>\n                         </div>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex></div>\n                        <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-accountType.png\">\n                        <div flex></div>\n                        <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                            <md-input-container class=\"md-block inputCont\">\n                                <label>Account Type</label>\n                                <md-select class=\"inputStyle\" aria-label=\"account type\" name=\"accountType\" required ng-model=\"vm.billing.accountType\">\n                                    <md-optgroup>\n                                        <label>Account Type</label>\n                                            <md-option ng-repeat=\"t in vm.bankAccountTypes\" ng-value=\"t\">{{t}}</md-option>\n                                    </md-optgroup>\n                                </md-select>\n                                <div ng-messages=\"bankForm.accountType.$error\" ng-show=\"bankForm.accountType.$dirty\">\n                                    <div ng-message=\"required\">Select account type</div>\n                                </div>\n                            </md-input-container>            \n                         </div>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"end end\">\n                    <div flex></div>\n                    <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n                    <div flex></div>\n                    <md-button type=\"submit\" ng-disabled=\"!bankForm.$valid\" class=\"md-raised contButton\">Next</md-button>                  \n                    </div>\n                </form>\n            </div>\n\n            <div ng-if=\"vm.billing.method==\'Credit Card\'\" layout=\"column\" layout-align=\"start start\">\n              <form name=\"creditForm\" ng-submit=\"vm.SetUp(creditForm.$valid)\">  \n\n                 <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-number.png\">\n                    <div flex></div>\n                    <div class=\"input\" layout=\"row\" layout-align=\"center center\">   \n                        <md-input-container class=\"md-block inputCont\" flex>\n                            <label>Card Number</label>\n                            <input class=\"inputStyle\" aria-label=\"card number\" name=\"card\" type=\"text\" class=\"no-spinbox\" required ng-pattern=\"vm.cPattern\" ng-model=\"vm.billing.cardNumber\">\n                            <div ng-messages=\"creditForm.card.$error\" ng-show=\"creditForm.card.$dirty\">\n                                <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid card number required</div>\n                            </div>\n                        </md-input-container>\n                    </div>\n                 </div>\n                 <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-password.png\">\n                    <div flex></div>\n                    <div class=\"input\" layout=\"row\" layout-align=\"center center\">   \n                        <md-input-container class=\"md-block inputCont\" flex>\n                            <label>CVC</label>\n                            <input class=\"inputStyle\" aria-label=\"cvc\" name=\"cvc\" type=\"text\" class=\"no-spinbox\" required ng-pattern=\"vm.cvcPattern\" ng-model=\"vm.billing.cardCode\">\n                            <div ng-messages=\"creditForm.cvc.$error\" ng-show=\"creditForm.cvc.$dirty\">\n                                <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid security code required</div>\n                            </div>\n                        </md-input-container>\n                    </div>\n                 </div>\n                 <!--<div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-callendar.png\">\n                    <div flex></div>\n                    <div class=\"input\" layout=\"row\" layout-align=\"center center\">   \n                        <md-content class=\"cardDate\">\n                            <md-input-container class=\"md-block login\">\n                            <label>Expiration Date </label>\n                            <input class=\"inputStyle\" aria-label=\"expiration date\" name=\"expdate\" ng-pattern=\"vm.dPattern\" ng-model=\"vm.billing.expDate\" required/>\n                            <div ng-messages=\"creditForm.date.$error\">\n                                <div ng-message=\"required\">You must select a date.</div>\n                            </div>\n                            <p>mm/dd/yyyy</p>\n                            </md-input-container>\n                        </md-content>\n                    </div>\n                 </div>-->\n\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-callendar.png\">\n                    <div flex></div>\n                    <div layout=\"column\">\n                        <div style=\"font-size: 18px; font-weight: 400; margin-bottom: 20px\">Expiration Date</div>\n                        <div style=\"width: 600px\" class=\"input\" layout=\"row\" layout-align=\"center center\">                        \n                            <div layout=\"row\" flex>\n                            <md-input-container class=\"md-block\" flex>\n                                <label>Month</label>\n                                <md-select class=\"inputStyleFlex\" aria-label=\"expiration month\" required ng-model=\"vm.month\">\n                                    <md-option ng-repeat=\"t in vm.monthList\" ng-value=\"t\">{{t}}</md-option>\n                                </md-select>\n                            </md-input-container>\n                            <md-input-container class=\"md-block\" flex>\n                                <label>Year</label>\n                                <md-select class=\"inputStyleFlex\" aria-label=\"expiration year\" required ng-model=\"vm.year\">\n                                    <md-option ng-repeat=\"t in vm.yearList\" ng-value=\"t\">{{t}}</md-option>\n                                </md-select>\n                            </md-input-container>\n                            </div>\n                        </div>\n                    </div>\n                 </div>\n\n                <div layout=\"row\" layout-align=\"end end\">\n                  <div flex></div>\n                  <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n                  <div flex></div>\n                  <md-button type=\"submit\" ng-disabled=\"!creditForm.$valid\" class=\"md-raised contButton\">Next</md-button>                  \n                </div>\n              </form>\n            </div>\n        </div>\n      </div>\n\n      <!--Existing Billing Info-->\n      <div ng-if=\"vm.billing.loaded==true\">\n        <div class=\"billingStyle\" layout=\"column\" layout-align=\"center\" flex>          \n          <div layout=\"column\" style=\"height: 300px\">\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      First Name:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      {{vm.billing.billtofirstname}}\n                  </div>\n              </div>\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Last Name:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      {{vm.billing.billtolastname}}\n                  </div>\n              </div>\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Email:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      {{vm.billing.email}}\n                  </div>\n              </div>\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Address:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      {{vm.billing.address}}\n                  </div>\n              </div>\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      City:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      {{vm.billing.city}}\n                  </div>\n              </div>\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Zip:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      {{vm.billing.zip}}\n                  </div>\n              </div>\n\n              <div flex></div>\n\n          </div>\n\n          <div ng-show=\"vm.billing.method==\'Bank Account\'\" layout=\"column\" style=\"padding-bottom: 60px\">\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Account Type:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      {{vm.billing.accountType}}\n                  </div>\n              </div>\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Routing #:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      **********\n                  </div>\n              </div>\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Account #:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      **********\n                  </div>\n              </div>\n          </div>\n\n          <div ng-show=\"vm.billing.method==\'Credit Card\'\" layout=\"column\" style=\"padding-bottom: 60px\">\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Card Number:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      xxxx-xxxx-xxxx-xxxx\n                  </div>\n              </div>\n\n          </div>\n          \n            <div class=\"billingHeight\"></div>                \n          \n        </div>\n        <div style=\"width: 700px; height: 200px\" layout=\"column\" layout-align=\"start start\">\n            <div style=\"height: 5%; width: 100%\"></div>\n            <div layout=\"row\" style=\"width: 100%\">\n              <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n              <div style=\"height: 100%; width: 100%\"></div>\n              <md-button class=\"md-raised contButton\" ng-click=\"vm.onContinue()\">Next</md-button>                  \n            </div>\n            <div style=\"height: 5%; width: 100%\"></div>\n            <div layout=\"row\" style=\"width: 100%\">\n              <md-button class=\"md-raised contButton\" ng-click=\"vm.Remove()\" flex>Clear</md-button>                \n            </div>\n        </div>\n      </div>\n    </ya-stepper-item>\n\n    <ya-stepper-item title=\"Associated Billing Information\" active=\"false\" done=\"false\">\n      <div id=\"sumPage\" style=\"width: 671px; margin-left: 45px; border-left: 1px solid rgba( 0, 0, 0, .15)\" layout=\"column\" layout-align=\"end end\">\n        <div style=\"width: 600px; height: 30px\" layout=\"row\" layout-align=\"start start\">\n            <div style=\"font-size: 24px; margin-bottom: 30px; font-weight: 300\">Enter in the billing information associated with the payment method.</div>           \n        </div>\n        <div style=\"width: 600px; height: 20px\"></div>\n\n        <form name=\"addressForm\" ng-submit=\"vm.Address(addressForm.$valid)\">\n\n            <div style=\"padding: 40px; padding-left: 60px; width: 600px; height: 30px\" layout=\"row\" layout-align=\"start start\">\n                <md-checkbox style=\"\" aria-label=\"import info\" ng-model=\"vm.import\" ng-change=\"vm.onImport()\">\n                    <div style=\"margin-top: -20px\">Use organization contact information for billing information</div>\n                </md-checkbox>\n            </div>\n\n            <div layout=\"row\" layout-align=\"center center\">\n                <div flex></div>\n                <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                <div flex></div>\n                <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                    <md-input-container class=\"md-block inputCont\">\n                        <label>First Name</label>\n                        <input class=\"inputStyle\" type=\"text\" aria-label=\"first name\" name=\"fName\" required ng-model=\"vm.billing.billtofirstname\">\n                        <div ng-messages=\"addressForm.fName.$error\" ng-show=\"addressForm.fName.$dirty\">\n                            <div ng-message=\"required\">First name required</div>\n                        </div>\n                    </md-input-container>\n                </div>\n            </div>\n\n            <div layout=\"row\" layout-align=\"center center\">\n                <div flex></div>\n                <img style=\"width: 32px; height: 32px; margin-right: 20px\">\n                <div flex></div>\n                <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                    <md-input-container class=\"md-block inputCont\">\n                        <label>Last Name</label>\n                        <input class=\"inputStyle\" type=\"text\" aria-label=\"last name\" name=\"lName\" required ng-model=\"vm.billing.billtolastname\">\n                        <div ng-messages=\"addressForm.lName.$error\" ng-show=\"addressForm.lName.$dirty\">\n                            <div ng-message=\"required\">Last name required</div>\n                        </div>\n                    </md-input-container>\n                </div>\n            </div>\n\n            <div layout=\"row\" layout-align=\"center center\">\n                <div flex></div>\n                <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-email.png\">\n                <div flex></div>\n                <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                    <md-input-container class=\"md-block inputCont\">\n                        <label>Email</label>\n                        <input class=\"inputStyle\" type=\"email\" aria-label=\"email\" name=\"email\" required ng-pattern=\"vm.ePattern\" ng-model=\"vm.billing.email\">\n                        <div ng-messages=\"addressForm.email.$error\" ng-show=\"addressForm.email.$dirty\">\n                            <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid email required</div>\n                        </div>\n                    </md-input-container>\n                </div>\n            </div>\n\n            <div layout=\"row\" layout-align=\"center center\">\n                <div flex></div>\n                <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-orgName.png\">\n                <div flex></div>\n                <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                    <md-input-container class=\"md-block inputCont\">\n                        <label>Address</label>\n                        <input class=\"inputStyle\" type=\"text\" aria-label=\"address\" name=\"address\" required ng-model=\"vm.billing.address\">\n                        <div ng-messages=\"addressForm.address.$error\" ng-show=\"addressForm.address.$dirty\">\n                            <div ng-message=\"required\">Address required</div>\n                        </div>\n                    </md-input-container>\n                </div>\n            </div>\n\n            <div layout=\"row\" layout-align=\"center center\">\n                <div flex></div>\n                <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-city.png\">\n                <div flex></div>\n                <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                    <md-input-container class=\"md-block inputCont\">\n                        <label>City</label>\n                        <input class=\"inputStyle\" type=\"text\" aria-label=\"city\" name=\"city\" required ng-model=\"vm.billing.city\">\n                        <div ng-messages=\"addressForm.city.$error\" ng-show=\"addressForm.city.$dirty\">\n                            <div ng-message=\"required\">City required</div>\n                        </div>\n                    </md-input-container>\n                </div>\n            </div>\n            <div layout=\"row\" layout-align=\"center center\">\n                <div flex></div>\n                <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-zipCode.png\">\n                <div flex></div>\n                <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                    <md-input-container class=\"md-block inputCont\">\n                        <label>Zip</label>\n                        <input class=\"inputStyle\" type=\"text\" class=\"no-spinbox\" aria-label=\"zip code\" name=\"zip\" required ng-pattern=\"vm.zPattern\" ng-model=\"vm.billing.zip\">\n                        <div ng-messages=\"addressForm.zip.$error\" ng-show=\"addressForm.zip.$dirty\">\n                            <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid zip code required</div>\n                        </div>\n                    </md-input-container>\n                </div>\n            </div>\n          <div layout=\"row\" layout-align=\"end end\">\n            <div flex></div>\n            <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n            <div flex></div>\n            <md-button type=\"submit\" ng-disabled=\"!addressForm.$valid\" class=\"md-raised contButton\">Next</md-button>                  \n          </div>\n        </form>\n      </div>\n    </ya-stepper-item>\n\n    <div style=\"width: 750px\" layout=\"row\" layout-align=\"end end\">\n        <img style=\"margin-left: 125px; padding-bottom: 40px\" src=\"assets\\images\\creditcards.png\">\n    </div>\n\n  </ya-stepper>\n\n</div>");
$templateCache.put("app/pages/onboarding/onboarding-createaccount.html","\n  <h2>{{vm.name}}</h2>\n  <ya-stepper callback=\"vm.getCtrl\">\n\n    <ya-stepper-item title=\"Enter your email\">\n      <div style=\"width: 671px; margin-left: 45px; border-left: 1px solid rgba( 0, 0, 0, .15)\" layout=\"column\" layout-align=\"end end\">\n        <div style=\"width: 600px; height: 30px\" layout=\"row\" layout-align=\"start start\">\n            <div style=\"font-size: 24px; margin-bottom: 30px; font-weight: 300\">Verify your account:</div>\n        </div>\n        <div style=\"width: 600px; height: 20px\"></div>\n        <form name=\"emailForm\" ng-submit=\"vm.onEmail(emailForm.$valid)\">\n          <div layout=\"row\" layout-align=\"center center\">\n            <div flex></div>\n            <img style=\"width: 32px; height: 32px; margin-bottom: 25px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-email.png\">\n            <div flex></div>\n            <md-input-container class=\"md-block login\" layout=\"row\">\n              <label>Email</label>\n              <input class=\"inputStyle\" ng-class=\"{\'inputStyleNoExist\': (emailForm.$valid && !vm.isEmailExist()), \'inputStyleExists\': (emailForm.$valid && vm.isEmailExist()) }\" aria-label=\"email\" ng-pattern=\"vm.ePattern\" name=\"email\" ng-model=\"vm.email\" ng-change=\"vm.checkEmail(emailForm.$valid)\" required>\n\n              <div ng-messages=\"!emailForm.email.$error\">\n                <div ng-message=\"required\">Valid email required</div>\n                <div ng-message=\"pattern\">Valid email required</div>\n                <div ng-show=\"emailForm.$valid && vm.isEmailExist()\" style=\"margin-top: 10px; margin-bottom: 20px; color: #417505\">Email Identified</div>\n                <div ng-show=\"emailForm.$valid && !vm.isEmailExist()\" style=\"margin-top: 10px; margin-bottom: 20px; color: rgba(0,0,0,1)\">Proceed to sign up for an account.</div>\n                <div ng-show=\"emailForm.$valid && vm.isEmailExist()\">^ You have an existing YOU account</div>\n              </div>\n            </md-input-container>\n          </div>\n          <div layout=\"row\" layout-align=\"end end\">\n            <div flex></div>\n            <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n            <div flex></div>\n            <md-button type=\"submit\" ng-disabled=\"!vm.isEmailDone() || !emailForm.$valid\" class=\"md-raised contButton\">Next</md-button>\n          </div>\n        </form>\n      </div>\n    </ya-stepper-item>\n    <div class=\"line\"></div>\n    <ya-stepper-item title=\"Enter Password\" active=\"false\">\n      <div style=\"width: 671px; margin-left: 45px; border-left: 1px solid rgba( 0, 0, 0, .15)\" layout=\"column\" layout-align=\"end end\">\n        <div style=\"width: 600px; height: 30px\" layout=\"row\" layout-align=\"start start\">\n            <div style=\"font-size: 24px; margin-bottom: 30px; font-weight: 300\">We\'ll log you into your account:</div>\n        </div>\n        <div style=\"width: 600px; height: 20px\"></div>\n        <form name=\"passwordForm\" ng-submit=\"vm.onPassword(passwordForm.$valid)\">\n          <div layout=\"row\" layout-align=\"center center\">\n            <div flex></div>\n            <img style=\"width: 32px; height: 32px; margin-bottom: 80px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-password.png\">\n            <div flex></div>\n            <div layout=\"column\" layout-align=\"start start\">\n              <md-input-container class=\"md-block login\">\n                <label>Password</label>\n                <input class=\"inputStyle\" aria-label=\"password\" name=\"password\" type=\"password\" ng-model=\"vm.password\" ng-disabled=\"!vm.canPassword()\" required>\n              </md-input-container>\n              <div style=\"margin-top: 10px;margin-bottom:10px\">\n                <p>Forgot Your Password?</p>\n                <p><a style=\"cursor:pointer\" ng-click=\"vm.resetPassword()\">Click Here</a>, a recovery email will be sent.</p>\n              </div>\n            </div>\n          </div>\n\n          <div layout=\"row\" layout-align=\"end end\">\n            <div flex></div>\n            <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n            <div flex></div>\n            <md-button type=\"submit\" ng-disabled=\"!passwordForm.$valid\" class=\"md-raised contButton\">Next</md-button>\n          </div>\n          <div style=\"height: 35px; width: 100%\"></div>\n          <div layout=\"row\" layout-align=\"end end\">\n            <md-button ng-disabled=\"!vm.isLoggedIn()\" ng-click=\"vm.logout()\" class=\"md-raised contButton\">Logout</md-button>\n          </div>\n        </form>\n      </div>\n    </ya-stepper-item>\n    <div class=\"line\"></div>\n    <ya-stepper-item title=\"Organization(s) Detected\" visible=\"false\" active=\"false\">\n      <div style=\"width: 671px; margin-left: 45px\" layout=\"column\" layout-align=\"end end\">\n        <div style=\"font-size: 20px; max-width: 607px\">Select an organization to complete sign up or sign up a new organization.</div>\n        <div style=\"width: 100%; height: 20px\"></div>\n        <md-list id=\"createPage\">\n          <md-list-item class=\"listItem\" ng-repeat=\"item in vm.list\">\n            <md-card style=\"width:100%;overflow: hidden\" ng-click=\"vm.onSelectOrg($index)\">\n              <md-card-header class=\"OrgList\">\n                <md-card-avatar><image class=\"avStyle\" ng-src=\"{{item.profileimage}}\"></image></md-card-avatar>\n                <md-card-header-text layout=\"row\" layout-align=\"start center\">{{item.name}}</md-card-header-text>\n              </md-card-header>\n            </md-card>\n          </md-list-item>\n        </md-list>\n        <div layout=\"row\" layout-align=\"center center\" ng-click=\"vm.onNewOrg()\">\n          <img style=\"width: 32px; height: 32px; margin-right: -19px\" src=\"assets\\images\\icons\\onboarding-addNewOrg.png\">\n          <div class=\"newOrgButton\" layout=\"row\" layout-align=\"center center\">\n            Sign Up\n            <div style=\"height: 100%; width: 20%\"></div>\n          </div>\n        </div>\n        <div style=\"padding-top: 30px\" layout=\"row\" layout-align=\"end end\">\n          <div flex></div>\n          <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n        </div>\n      </div>\n    </ya-stepper-item>\n    <div class=\"line\"></div>\n    <ya-stepper-item title=\"Sign Up\" visible=\"false\" active=\"false\">\n      <div style=\"width: 671px; margin-left: 45px; border-left: 1px solid rgba( 0, 0, 0, .15)\" layout=\"column\" layout-align=\"end end\">\n        <div style=\"width: 600px; height: 30px\" layout=\"row\" layout-align=\"start start\">\n            <div style=\"font-size: 24px; margin-bottom: 30px; font-weight: 300\">We just need some information:</div>\n        </div>\n        <div style=\"width: 600px; height: 20px\"></div>\n        <form name=\"vm.signupForm\" ng-submit=\"vm.onSignup(vm.signupForm.$valid)\">\n\n\n          <div layout=\"row\" layout-align=\"center center\">\n            <div flex></div>\n            <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets/images/profile/contact-icon.png\">\n            <div flex></div>\n            <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n              <md-input-container class=\"md-block login\">\n                <label>First Name</label>\n                <input class=\"inputStyle\" aria-label=\"firstname\" name=\"firstname\" ng-model=\"vm.firstname\" required>\n                <div ng-messages ng-show=\"vm.signupForm.firstname.$dirty\">\n                  <div ng-message=\"required\">First Name Required</div>\n                </div>\n              </md-input-container>\n            </div>\n          </div>\n\n          <div layout=\"row\" layout-align=\"center center\">\n            <div flex></div>\n            <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets/images/profile/contact-icon.png\">\n            <div flex></div>\n            <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n              <md-input-container class=\"md-block login\">\n                <label>Last Name</label>\n                <input class=\"inputStyle\" aria-label=\"lastname\" name=\"lastname\" ng-model=\"vm.lastname\" required>\n                <div ng-messages ng-show=\"vm.signupForm.lastname.$dirty\">\n                  <div ng-message=\"required\">Last Name Required</div>\n                </div>\n              </md-input-container>\n            </div>\n          </div>\n\n          <div layout=\"row\" layout-align=\"center center\">\n            <div flex></div>\n            <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-password.png\">\n            <div flex></div>\n            <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n              <md-input-container class=\"login\">\n                <label>Password</label>\n                <input class=\"inputStyle\" aria-label=\"password\" name=\"password\" type=\"password\" ng-model=\"vm.password\" required ng-pattern=\"/^\\S+$/\" minlength=\"6\" md-maxlength=\"64\">\n                <div ng-messages=\"vm.signupForm.password.$error\" ng-show=\"vm.signupForm.password.$dirty\" md-auto-hide=\"false\">\n                  <div ng-message=\"required\">Password Required</div>\n                  <div ng-message=\"pattern\">Spaces not allowed</div>\n                  <div ng-message=\"minlength\">Password too short</div>\n                  <div ng-message=\"md-maxlength\">Password too long</div>\n                </div>\n              </md-input-container>\n            </div>\n          </div>\n\n          <div layout=\"row\" layout-align=\"center center\">\n            <div flex></div>\n            <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-contactMobil.png\">\n            <div flex></div>\n            <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n              <md-input-container class=\"md-block login\">\n                <label>Mobile Phone Number</label>\n                <input class=\"inputStyle\" aria-label=\"phoneNumber\" name=\"phoneNumber\" ng-model=\"vm.phoneNumber\" ng-change=\"vm.updatePhoneNumber()\" required>\n                <div ng-messages ng-show=\"vm.signupForm.phoneNumber.$dirty\">\n                  <div ng-show=\"!vm.phvalid\">Phone Number Required</div>\n                </div>\n              </md-input-container>\n            </div>\n          </div>\n\n          <div layout=\"row\" layout-align=\"center center\">\n            <div flex></div>\n            <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-birthday.png\">\n            <div flex></div>\n            <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n              <md-input-container class=\"md-block login\">\n                <label>Birthday mm-dd-yyyy</label>\n                <input class=\"inputStyle\" aria-label=\"birthday\" name=\"birthday\" ng-model=\"vm.birthday\" ng-change=\"vm.updateBirthdate()\" required>\n                <div ng-messages ng-show=\"vm.signupForm.birthday.$dirty\">\n                  <div ng-show=\"!vm.bdvalid\">Valid Birthday Required</div>\n                </div>\n              </md-input-container>\n            </div>\n          </div>\n\n          <div layout=\"row\" layout-align=\"end end\">\n            <div flex></div>\n            <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n            <div flex></div>\n            <md-button type=\"submit\" ng-disabled=\"(!vm.createValid())\" class=\"md-raised contButton\">Next</md-button>\n          </div>\n\n        </form>\n      </div>\n    </ya-stepper-item>\n\n  </ya-stepper>\n\n");
$templateCache.put("app/pages/onboarding/onboarding-industrycategory.html","\n  <h2>Industry</h2>\n  <ya-stepper callback=\"vm.getCtrl\">\n\n    <ya-stepper-item title=\"Select Industry Type\" active=\"true\" done=\"false\" visible=\"true\">\n        <div style=\"width: 671px; margin-left: 45px; border-left: 1px solid rgba( 0, 0, 0, .15)\" layout=\"column\" layout-align=\"end end\">\n            <div style=\"width: 600px; height: 30px\" layout=\"row\" layout-align=\"start start\">\n                <div style=\"font-size: 24px; margin-bottom: 30px; font-weight: 300\">Select the industry type that fits your organization.</div>\n            </div>\n            <form name=\"typeForm\" ng-submit=\"vm.onIndustryType(typeForm.$valid)\">\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-industry.png\">\n                    <div flex></div>\n                    <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                        <md-input-container>\n                            <label>Industry Type</label>\n                            <md-select class=\"inputStyle\" aria-label=\"\" ng-model=\"vm.currentType\" md-selected-text=\"vm.getCurrentIndustryType()\" ng-change=\"vm.Update()\" required>\n                                <md-optgroup>\n                                    <label>Industry Type</label>\n                                    <md-option ng-repeat=\"t in vm.types\" ng-value=\"t\">{{t}}</md-option>\n                                </md-optgroup>\n                            </md-select>\n                        </md-input-container>\n                    </div>\n                </div>\n                <div layout=\"row\" layout-align=\"end end\">\n                    <div flex></div>\n                    <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n                    <div flex></div>\n                    <md-button ng-disabled=\"!typeForm.$valid\" class=\"md-raised contButton\" style=\"max-width:none\" type=\"submit\">Next</md-button>\n                </div>\n            </form>\n        </div>\n    </ya-stepper-item>\n    <div class=\"line\"></div>\n    <ya-stepper-item title=\"Select Mobile App Listing Category\" active=\"false\" done=\"false\" visible=\"true\">\n        <div style=\"width: 671px; margin-left: 45px; border-left: 1px solid rgba( 0, 0, 0, .15)\" layout=\"column\" layout-align=\"end end\">\n            <div style=\"width: 600px; height: 30px\" layout=\"row\" layout-align=\"start start\">\n                <div style=\"font-size: 24px; margin-bottom: 30px; font-weight: 300\">Choose what listing your followers will find you in.</div>\n            </div>\n            <div style=\"width: 600px; height: 20px\"></div>\n            <form name=\"catForm\" ng-submit=\"vm.onIndustryCat(catForm.$valid)\">\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-busCat.png\">\n                    <div flex></div>\n                    <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                        <md-input-container>\n                            <label>Category</label>\n                            <md-select class=\"inputStyle\" aria-label=\"category\" ng-model=\"vm.currentCat\" md-selected-text=\"vm.getCurrentCategories()\" ng-change=\"vm.UpdateCat()\" required>\n                                <md-optgroup>\n                                    <label>Category</label>\n                                    <md-option ng-repeat=\"c in vm.categories\" ng-value=\"c.name\">{{c.name}}</md-option>\n                                </md-optgroup>\n                            </md-select>\n                        </md-input-container>\n                    </div>\n                </div>\n                <div layout=\"row\" layout-align=\"end end\">\n                    <div flex></div>\n                    <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n                    <div flex></div>\n                    <md-button ng-disabled=\"!catForm.$valid\" class=\"md-raised contButton\" style=\"max-width:none\" type=\"submit\">Next</md-button>\n                </div>\n            </form>\n        </div>\n    </ya-stepper-item>\n\n  </ya-stepper>\n\n");
$templateCache.put("app/pages/onboarding/onboarding-organizationinfo.html","\n<h2>Organization</h2>\n<ya-stepper callback=\"vm.getCtrl\">\n\n    <ya-stepper-item title=\"About Your Organization\">\n        <div style=\"width: 671px; margin-left: 45px; border-left: 1px solid rgba( 0, 0, 0, .15)\" layout=\"column\" layout-align=\"end end\">\n            <div style=\"width: 600px; height: 30px\" layout=\"row\" layout-align=\"start start\">\n                <div style=\"font-size: 24px; margin-bottom: 30px; font-weight: 300\">This information will help mobile app users choose your organization.</div>\n            </div>\n            <div style=\"width: 600px; height: 50px\"></div>\n            <form name=\"vm.nameForm\" ng-submit=\"vm.onOrgName(vm.nameForm.$valid)\">\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-bottom: 25px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-orgName.png\">\n                    <div flex></div>\n                    <md-input-container class=\"md-block inputScale\">\n                        <label>Name of your Organization</label>\n                        <input class=\"inputStyle\" aria-label=\"organization name\" name=\"name\" type=\"text\" required ng-model=\"vm.profile.name\">\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-bottom: 25px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-refCode.png\">\n                    <div flex></div>\n                    <md-input-container class=\"md-block\">\n                        <label>Referral Code (optional; provided by your You rep)</label>\n                        <input class=\"inputStyle\" aria-label=\"enter referral code\" ng-model=\"vm.code\" ng-change=\"vm.Update()\">\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"end end\">\n                    <div flex></div>\n                    <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n                    <div flex></div>\n                    <md-button type=\"submit\" ng-disabled=\"!vm.nameForm.$valid || vm.nameExists()\" class=\"md-raised contButton\">Next</md-button>\n                </div>\n            </form>\n        </div>\n    </ya-stepper-item>\n    <div class=\"line\"></div>\n    <ya-stepper-item title=\"Physical Address\" active=\"false\">\n        <div style=\"width: 671px; margin-left: 45px; border-left: 1px solid rgba( 0, 0, 0, .15)\" layout=\"column\" layout-align=\"end end\">\n            <div style=\"width: 600px; height: 30px\" layout=\"row\" layout-align=\"start start\">\n                <div style=\"font-size: 24px; margin-bottom: 30px; font-weight: 300\">Where is your organization located?</div>\n            </div>\n            <div style=\"width: 600px; height: 20px\"></div>\n            <form name=\"vm.addressForm\" ng-submit=\"vm.onOrgAddress(vm.addressForm.$valid)\">\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-bottom: 25px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-orgName.png\">\n                    <div flex></div>\n                    <md-input-container class=\"md-block inputScale\">\n                        <label>Address (line 1)</label>\n                        <input class=\"inputStyle\" aria-label=\"Address line 1\" name=\"address1\" type=\"text\" required ng-model=\"vm.profile.street\">\n                        <div ng-messages=\"vm.addressForm.address1.$error\" ng-show=\"vm.addressForm.address1.$dirty\">\n                            <div ng-message=\"required\">Address required</div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-bottom: 25px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-orgName.png\">\n                    <div flex></div>\n                    <md-input-container class=\"md-block inputScale\">\n                        <label>Address (line 2)</label>\n                        <input class=\"inputStyle\" aria-label=\"Address line 2\" name=\"address2\" type=\"text\" ng-model=\"vm.profile.street2\">\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-bottom: 25px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-city.png\">\n                    <div flex></div>\n                    <md-input-container class=\"md-block city\">\n                        <label>City</label>\n                        <input class=\"inputStyle\" aria-label=\"City\" name=\"city\" type=\"text\" required ng-model=\"vm.profile.city\">\n                        <div ng-messages=\"vm.addressForm.city.$error\" ng-show=\"vm.addressForm.city.$dirty\">\n                            <div ng-message=\"required\">City required</div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-bottom: 25px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-state.png\">\n                    <div flex></div>\n                    <md-input-container class=\"md-block bottomborder\">\n                        <label>State</label>\n                        <md-select class=\"inputStyle\" aria-label=\"state\" name=\"state\" ng-model=\"vm.profile.state\" required>\n                            <md-optgroup>\n                                <label>State</label>\n                                <md-option ng-repeat=\"c in vm.states\" ng-value=\"c\">{{c}}</md-option>\n                            </md-optgroup>\n                        </md-select>\n                        <div ng-messages=\"vm.addressForm.state.$error\">\n                            <div ng-message=\"required\">State required</div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-bottom: 25px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-zipCode.png\">\n                    <div flex></div>\n                    <md-input-container class=\"md-block inputScale\">\n                        <label>Zip Code</label>\n                        <input class=\"inputStyle\" class=\"no-spinbox\" aria-label=\"zip code\" ng-pattern=\"vm.zPattern\" name=\"zip\" type=\"text\" required ng-model=\"vm.profile.zip\">\n                        <div ng-messages=\"vm.addressForm.zip.$error\" ng-show=\"vm.addressForm.zip.$dirty\">\n                            <div ng-message-exp=\"[\'required\', \'pattern\']\">valid zip code required</div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"end end\">\n                    <div flex></div>\n                    <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n                    <div flex></div>\n                    <md-button type=\"submit\" ng-disabled=\"!vm.addressForm.$valid\" class=\"md-raised contButton\">Next</md-button>\n                </div>\n            </form>\n        </div>\n    </ya-stepper-item>\n    <div class=\"line\"></div>\n    <ya-stepper-item title=\"Contact Info\" active=\"false\">\n        <div style=\"width: 671px; margin-left: 45px; border-left: 1px solid rgba( 0, 0, 0, .15)\" layout=\"column\" layout-align=\"end end\">\n            <div style=\"width: 600px; height: 30px\" layout=\"row\" layout-align=\"start start\">\n                <div style=\"font-size: 24px; margin-bottom: 30px; font-weight: 300\">Who should people contact with inquiries regarding your organization?</div>\n            </div>\n            <div style=\"width: 600px; height: 40px\"></div>\n            <form name=\"vm.contactForm\" ng-submit=\"vm.onOrgContact(vm.contactForm.$valid)\">\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-bottom: 25px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                    <div flex></div>\n                    <md-input-container class=\"md-block inputScale\">\n                        <label>First Name</label>\n                        <input class=\"inputStyle\" aria-label=\"Contact First Name\" name=\"contactfirstName\" type=\"text\" required ng-model=\"vm.profile.contactfirstname\">\n                        <div ng-messages=\"vm.contactForm.contactfirstName.$error\" ng-show=\"vm.contactForm.contactfirstName.$dirty\">\n                            <div ng-message=\"required\">Contact first name required</div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <md-input-container class=\"md-block inputScale\">\n                        <label>Last Name</label>\n                        <input class=\"inputStyle\" aria-label=\"Contact Last Name\" name=\"contactlastName\" type=\"text\" required ng-model=\"vm.profile.contactlastname\">\n                        <div ng-messages=\"vm.contactForm.contactlastName.$error\" ng-show=\"vm.contactForm.contactlastName.$dirty\">\n                            <div ng-message=\"required\">Contact last name required</div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-bottom: 25px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-contactEmail.png\">\n                    <div flex></div>\n                    <md-input-container class=\"md-block inputScale\">\n                        <label>Email Address</label>\n                        <input class=\"inputStyle\" aria-label=\"email\" name=\"email\" type=\"email\" required ng-pattern=\"vm.ePattern\" ng-model=\"vm.profile.email\">\n                        <div ng-messages=\"vm.contactForm.email.$error\" ng-show=\"vm.contactForm.email.$dirty\">\n                            <div ng-message-exp=\"[\'required\', \'pattern\']\">Valid email required</div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-bottom: 25px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-contactHome.png\">\n                    <div flex></div>\n                    <md-input-container class=\"md-block inputScale\">\n                        <label>Primary Phone</label>\n                        <input class=\"inputStyle\" class=\"no-spinbox\" aria-label=\"Home phone number\" name=\"phoneHome\" type=\"phone\" ng-model=\"vm.profile.phone\" ng-change=\"vm.updatePhoneNumber(\'phone\')\">\n                        <div ng-messages=\"vm.contactForm.phoneHome.$error\" ng-show=\"vm.contactForm.phoneHome.$dirty\">\n                            <div ng-message=\"pattern\">Invalid number format</div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div flex></div>\n                    <img style=\"width: 32px; height: 32px; margin-bottom: 25px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-contactMobil.png\">\n                    <div flex></div>\n                    <md-input-container class=\"md-block inputScale\">\n                        <label>Mobile Phone</label>\n                        <input class=\"inputStyle\" class=\"no-spinbox\" aria-label=\"Mobile phone number\" name=\"phoneMobile\" type=\"phone\" ng-model=\"vm.profile.phone2\" ng-change=\"vm.updatePhoneNumber(\'phone2\')\">\n                        <div ng-messages=\"vm.contactForm.phoneMobile.$error\" ng-show=\"vm.contactForm.phoneMobile.$dirty\">\n                            <div ng-message=\"pattern\">Invalid number format</div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"end end\" style=\"padding-bottom:40px\">\n                    <div flex></div>\n                    <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n                    <div flex></div>\n                    <md-button type=\"submit\" ng-disabled=\"!vm.contactForm.$valid\" class=\"md-raised contButton\">Next</md-button>\n                </div>\n            </form>\n        </div>\n    </ya-stepper-item>\n\n</ya-stepper>\n");
$templateCache.put("app/pages/onboarding/onboarding-rateplans.html","<div>\n  <ya-stepper callback=\"vm.getCtrl\">\n    <ya-stepper-item title=\"Rate Plan: {{ vm.industry.name }}\" active=\"true\" done=\"false\">\n      <div id=\"sumPage\" style=\"width: 671px; margin-left: 45px; border-left: 1px solid rgba( 0, 0, 0, .15)\" layout=\"column\" layout-align=\"end end\">\n          <form name=\"vm.planForm\" ng-submit=\"vm.onPlan(vm.planForm.$valid)\">\n            <div>\n              <div style=\"border-bottom: 5px solid #838383\" class=\"inputStyle\">${{vm.industry.setupFee}}</div>\n              <div style=\"width: 100%; height: 10px\"></div>\n              <md-checkbox aria-label=\"alerts\" ng-if=\"vm.alertCheck\" style=\"margin-top: 20px;margin-bottom: 40px\" ng-model=\"vm.defaultAlert\" name=\"alerts\">\n                  Activate Alert Messaging\n              </md-checkbox>\n              <div ng-if=\"vm.alertCheck\" style=\"width: 100%; height: 10px\"></div>\n              <md-input-container class=\"md-block inputScale\">\n                  <label>{{vm.numberOfUsersLabel}}</label>\n                  <input class=\"inputStyle\" name=\"users\" aria-label=\"number of users\" type=\"number\" ng-model=\"vm.numberOfUsers\" required min=\"1\" ng-change=\"vm.Update()\">\n              </md-input-container>\n              <div style=\"width: 100%; height: 10px\"></div>\n              <md-input-container class=\"md-block inputScale\">\n                  <label>Optional Promotional Code (Case Sensitive)</label>\n                  <input class=\"inputStyle\" name=\"users\" aria-label=\"Promotional Code\" type=\"text\" ng-model=\"vm.promocode\">\n              </md-input-container>\n              <div style=\"width: 100%; height: 10px\"></div>\n            </div>\n\n            <div style=\"width: 600px\" layout=\"row\" layout-align=\"end end\">\n              <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n              <div flex></div>\n              <md-button type=\"submit\" ng-disabled=\"!vm.planForm.$valid\" class=\"md-raised contButton\">Next</md-button>\n            </div>\n\n          </form>\n      </div>\n    </ya-stepper-item>\n    <div class=\"line\"></div>\n    <ya-stepper-item title=\"Review Package(s)\" active=\"true\" done=\"false\">\n      <div layout=\"row\" class=\"inputBorder\">\n          <div ng-show=\"!vm.PlanSelected()\" style=\"color: rgb(221,44,0)\">\n          </div>\n          <div class=\"ratePage\" layout=\"column\" layout-align=\"\">\n              <div class=\"checkBox whiteBlock\" ng-repeat=\"x in vm.industry.plans\" ng-if=\"vm.numberOfUsers < x.maxUser || x.maxUser == -1\">\n                  <h3>\n                      <md-checkbox aria-label=\"select this plan\" class=\"\" ng-checked=\"x.selected\" ng-click=\"vm.ClickPlan(x)\">{{x.title}}</md-checkbox>\n                  </h3>\n                  <div style=\"margin-left: 50px; font-size: 18px; color: gray; z-index: 500\" ng-repeat=\"y in x.text\">\n                      • {{y}}\n                  </div>\n              </div>\n          </div>\n          <!--  -->\n          <div class=\"\" layout=\"column\" layout-align=\"\">\n            <div class=\"checkBox whiteBlock\" ng-repeat=\"x in vm.industry.options\">\n              <h3>\n                  <md-checkbox aria-label=\"select this industry\" class=\"\" ng-checked=\"x.selected\" ng-click=\"vm.ClickOption(x)\">{{x.title}}</md-checkbox>\n              </h3>\n              <div style=\"font-size: 18px; color: gray\" ng-repeat=\"y in x.text\">\n                  <p>{{y}}</p>\n              </div>\n            </div>\n\n            <div class=\"checkBox whiteBlock\" ng-if=\"x.text && x.text.length\" ng-repeat=\"x in vm.industry.info\" flex=\"100\">\n              <h3>\n                  {{x.title}}\n              </h3>\n              <div style=\"font-size: 18px; color: gray\" ng-repeat=\"y in x.text\">\n                  <p>{{y}}</p>\n              </div>\n            </div>\n          </div>\n      </div>\n      <div style=\"height: 30px; width: 30px\"></div>\n      <div style=\"height: 100%; margin-right: -28px; padding-bottom:40px\" layout=\"row\" layout-align=\"\">\n          <div style=\"width: 94px; height: 100%\"></div>\n          <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n          <div style=\"width: 52px; height: 100%\"></div>\n          <md-button class=\"md-raised contButton\" ng-disabled=\"!vm.PlanSelected()\" ng-click=\"vm.Done()\">Next</md-button>\n      </div>\n    </ya-stepper-item>\n  </ya-stepper>\n</div>");
$templateCache.put("app/pages/onboarding/onboarding-summary.html","\n  <ya-stepper callback=\"vm.getCtrl\">\n    <ya-stepper-item id=\"sumPage\" title=\"\" active=\"true\" done=\"false\">\n\n      <div layout=\"column\">\n        <div class=\"billingStyle\">\n          <div style=\"font-size: 35px; padding-left: 30px\">Summary & Payment</div>\n          <div style=\"width: 90%; padding-left: 30px; font-size: 20px\">You are almost done! Please review your information and click \'Accept\' to complete sign up.</div>\n          <div style=\"width: 100%; height: 60px\"></div>\n          <div style=\"font-size: 35px; color: #0a5179; padding-left: 30px\">Billing Information</div>\n\n          <div layout=\"column\" style=\"height: 300px\">\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Company Name:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      {{vm.profile.name}}\n                  </div>\n              </div>\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Address:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      {{vm.profile.street}}\n                  </div>\n              </div>\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      City,State and Zip:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      {{vm.address}}\n                  </div>\n              </div>\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Mobile Phone:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      {{vm.profile.phone2}}\n                  </div>\n              </div>\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Work Phone:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      {{vm.profile.phone}}\n                  </div>\n              </div>\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 48%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Payment Type:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 48%\" layout=\"column\" layout-align=\"end start\">\n                      {{vm.billing.method}}\n                  </div>\n              </div>\n\n              <div flex></div>\n\n          </div>\n\n          <div style=\"font-size: 35px; color: #0a5179; padding-left: 30px\">\n              Summary\n          </div>\n          <div style=\"width: 100%; height: 10px\"></div>\n\n          <div ng-if=\"vm.ready\">\n\n              <div flex></div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 53%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Annual Listing Fee:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 18%\" layout=\"column\" layout-align=\"end end\">\n                      {{vm.costs.cost | currency}}\n                  </div>\n                  <div style=\"width: 25%\"></div>\n              </div>\n\n              <div layout=\"row\">\n                  <div style=\"width: 53%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Number of {{vm.userLabel}}:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 18%\" layout=\"column\" layout-align=\"end end\">\n                      {{vm.costs.users}}\n                  </div>\n              </div>\n\n\n              <div layout=\"row\" ng-if=\"vm.costs.alertsenabled && vm.costs.alertcost\">\n                  <div style=\"width: 53%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                     Alerts Fee:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 18%\" layout=\"column\" layout-align=\"end end\">\n                      {{vm.costs.alertcost | currency}}\n                  </div>\n              </div>\n\n              <div layout=\"row\" ng-if=\"vm.costs.advertisingenabled && vm.costs.advertisingcost\">\n                  <div style=\"width: 53%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                     Advertising Fee:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 18%\" layout=\"column\" layout-align=\"end end\">\n                      {{vm.costs.advertisingcost | currency}}\n                  </div>\n              </div>\n\n              <div layout=\"row\" ng-if=\"vm.costs.announcementsenabled && vm.costs.announcementcost\">\n                  <div style=\"width: 53%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                     Announcement Fee:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 18%\" layout=\"column\" layout-align=\"end end\">\n                      {{vm.costs.announcementcost | currency}}\n                  </div>\n              </div>\n\n              <div layout=\"row\" ng-if=\"vm.studentCost\">\n                  <div style=\"width: 53%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Package: {{vm.costs.plan.name.split(\'-\')[0]}}\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 18%\" layout=\"column\" layout-align=\"end end\">\n                      {{vm.costs.plan.name.split(\'-\')[1]}}\n                  </div>\n                  <div style=\"width: 25%\"></div>\n              </div>\n\n              <div layout=\"row\" ng-if=\"vm.studentCost\">\n                  <div style=\"width: 53%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Total Cost for {{vm.userLabel}}\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 18%\" layout=\"column\" layout-align=\"end end\">\n                      {{vm.studentCost | currency}}\n                  </div>\n                  <div style=\"width: 25%\"></div>\n              </div>\n\n              <div layout=\"row\" ng-if=\"vm.smallSchoolCost\">\n                  <div style=\"width: 53%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      Small School\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 18%\" layout=\"column\" layout-align=\"end end\">\n                      {{vm.smallSchoolCost | currency}}\n                  </div>\n                  <div style=\"width: 25%\"></div>\n              </div>\n\n\n              <div style=\"width: 100%; height: 20px\"></div>\n              <div layout=\"row\">\n                  <div style=\"width: 53%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                     Total Amount Due:\n                  </div>\n                  <div style=\"width: 4%\"></div>\n                  <div style=\"width: 18%; font-weight: bold\" layout=\"column\" layout-align=\"end end\">\n                      {{vm.costs.annual | currency}}\n                  </div>\n                  <div style=\"width: 25%\"></div>\n              </div>\n              <div style=\"width: 100%; height: 60px\"></div>\n          </div>\n        </div>\n\n\n        <form id=\"sumPage\" name=\"summary\" ng-submit=\"vm.onContinue(summary.$valid)\">\n          <md-checkbox style=\"padding: 30px\" aria-label=\"agreement\" name=\"agreement\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\" ng-required=\"true\" ng-model=\"vm.agreement\">\n            Please review the information carefully: by accepting you agree to charge the account for the fees listed. Upon accepting a reciept will be emailed to the address provided and access to your YOU portal will be complete.\n          </md-checkbox>\n          <div layout=\"row\" layout-align=\"center center\" style=\"padding-bottom:40px\">\n            <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n            <div flex></div>\n            <md-button class=\"md-raised contButton\" ng-disabled=\"!summary.$valid\" type=\"submit\">Accept</md-button>        \n          </div>\n        </form>\n        \n      </div>\n      \n    </ya-stepper-item>\n  </ya-stepper>  \n\n");
$templateCache.put("app/pages/onboarding/onboarding.html","\n<div id=\"onboarding\" layout=\"column\">\n  <div style=\"height:100px\">\n    <div layout=\"row\" style=\"padding-left: 40px; padding-top: 20px\">\n      <img onclick=\"location.href=\'#home\'\" style=\"width: 112px; height: 65px; cursor: pointer\" src=\"assets\\images\\you-brand-lg.png\">\n      <div flex></div>\n      <div style=\"color: white; font-size: 40px; font-weight: 100; margin-right: 200px; margin-bottom: 50px\">Sign Up</div>\n      <div flex></div>\n    </div>\n  </div>\n\n  <div layout=\"row\" style=\"height:100px\">\n\n    <div flex></div>\n    <md-tabs style=\"width: 1014px\" md-dynamic-height md-border-bottom md-selected=\"vm.currentNavItem\">\n      <div class=\"md-line\"></div>\n      <md-tab style=\"text-transform: none\" label=\"\" md-on-select=\"vm.onSelect(0)\" ng-disabled=\"!vm.isActive(0)\" ng-if=\"vm.isAvailable(0)\">Create Account</md-tab>\n      <md-tab label=\"Industry & Category\" md-on-select=\"vm.onSelect(1)\" ng-disabled=\"!vm.isActive(1)\" ng-if=\"vm.isAvailable(1)\"></md-tab>\n      <md-tab label=\"Organization Info\" md-on-select=\"vm.onSelect(2)\" ng-disabled=\"!vm.isActive(2)\" ng-if=\"vm.isAvailable(2)\"></md-tab>\n      <md-tab label=\"Rate Plans\" md-on-select=\"vm.onSelect(3)\" ng-disabled=\"!vm.isActive(3)\" ng-if=\"vm.isAvailable(3)\"></md-tab>\n      <md-tab label=\"Billing Info\" md-on-select=\"vm.onSelect(4)\" ng-disabled=\"!vm.isActive(4)\" ng-if=\"vm.isAvailable(4)\"></md-tab>\n      <md-tab label=\"Summary & Payment\" md-on-select=\"vm.onSelect(5)\" ng-disabled=\"!vm.isActive(5)\" ng-if=\"vm.isAvailable(5)\"></md-tab>\n\n    </md-tabs>\n    <div flex></div>\n  </div>\n\n  <md-content flex>\n    <div layout=\"row\">\n      <div style=\"width: 30%\"></div>\n      <div style=\"width: 697px\" class=\"contPos\">\n        <onboarding-account ng-if=\"vm.isOpen(0)\" class=\"tab-content\" parent=\"vm\"></onboarding-account>\n        <onboarding-industry ng-if=\"vm.isOpen(1)\" class=\"tab-content\" parent=\"vm\"></onboarding-industry>\n        <onboarding-info ng-if=\"vm.isOpen(2)\" class=\"tab-content\" parent=\"vm\"></onboarding-info>\n        <onboarding-plans ng-if=\"vm.isOpen(3)\" class=\"tab-content\" parent=\"vm\"></onboarding-plans>\n        <onboarding-billing ng-if=\"vm.isOpen(4)\" class=\"tab-content\" parent=\"vm\"></onboarding-billing>\n        <onboarding-summary ng-if=\"vm.isOpen(5)\" class=\"tab-content\" parent=\"vm\"></onboarding-summary>\n      </div>\n      <div style=\"width: 30%\"></div>\n    </div>\n  </md-content>\n</div>\n");
$templateCache.put("app/pages/passwordhelp/passwordhelp.html","<div id=\"passwordhelp\" style=\"background-color: #c8c8c8\" layout=\"column\" layout-fill layout-padding>\n  <div style=\"width: 100%; height: 100%\" layout=\"column\">\n    <div style=\"width: 100%; height: 25%\" layout=\"row\" layout-align=\"center start\">\n      <img src=\"assets\\images\\pw_forgot_logo.png\">\n    </div>\n    <div style=\"width: 100%; height: 40%\" layout=\"row\">\n      <div style=\"width: 40%; height: 100%\"></div>\n      <form flex=\"auto\" style=\"background-color: white; box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.258824); width: 40%; min-width: 550px; height: 100%; min-height: 400px; border-radius: 10px; border: 1px solid rgba( 120, 120, 120, 0.12)\" name=\"passwordForm\" ng-submit=\"vm.onSubmit(passwordForm.$valid)\" novalidate layout-padding layout=\"column\" layout-align=\"center left\">\n        <div class=\"password-content\">\n          <div style=\"color: #245fa3; font-size: 28px; font-weight: 400\">Enter your email</div>\n          <div style=\"font-weight: 300; font-size: 18px; padding-bottom: 40px\">A password reset link will be sent to this email:</div>\n          <md-input-container class=\"md-block login\" layout=\"row\">\n            <label>Email</label>\n            <input style=\"font-size: 25px\" class=\"inputStyle\" aria-label=\"email\" ng-pattern=\"vm.ePattern\" name=\"email\" id=\"email\" ng-model=\"vm.email\" required>\n            <div ng-messages=\"passwordForm.email.$error\">\n              <div ng-message=\"required\">Valid email required</div>\n              <div ng-show=\"passwordForm.email.$valid && vm.isEmailExist()\">Email Verified</div>\n            </div>\n            <div style=\"padding-bottom: 15px\"></div>\n          </md-input-container>\n          <div class=\"password-button\">\n            <md-button style=\"background-color: #f2f0f0\" class=\"adminStyle adminButton button password-button-text\" aria-label=\"reset password\" ng-click=\"vm.goHome()\">\n              Cancel\n            </md-button>\n\n            <md-button style=\"background-color: #f5a623\" class=\"adminStyle adminButton button password-button-text\" aria-label=\"reset password\" type=\"submit\" ng-click=\"\">\n              Send\n            </md-button>\n          </div>\n        </div>\n      </form>\n      <div style=\"width: 40%; height: 100%\"></div>\n    </div>\n    <div style=\"width: 100%; height: 35%\"></div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/passwordreset/passwordreset.html","<div id=\"passwordreset\" style=\"background-color: #c8c8c8\" layout=\"column\" layout-fill layout-padding>\n  <div style=\"width: 100%; height: 100%\" layout=\"column\">\n    <div style=\"width: 100%; height: 25%\" layout=\"row\" layout-align=\"center start\">\n      <img src=\"assets\\images\\pw_forgot_logo.png\">\n    </div>\n    <div style=\"width: 100%; height: 40%\" layout=\"row\">\n      <div style=\"width: 40%; height: 100%\"></div>\n      <form class=\"passwordFormCustomCss\" name=\"passwordForm\" ng-submit=\"vm.resetPassword(passwordForm.$valid)\" novalidate layout-padding layout=\"column\" layout-align=\"center center\">\n        <div class=\"password-reset-content\">\n          <div style=\"color: #245fa3; font-size: 28px; font-weight: 400; padding-bottom: 30px\">Reset Your Password:\n          </div>\n          <md-input-container class=\"md-block login\" layout=\"row\">\n            <label>Password</label>\n            <input id=\"pass1\" style=\"font-size: 25px\" class=\"inputStyle\" aria-label=\"password\" ng-ya-password-clear=\"pass2\" name=\"password\" type=\"password\" ng-model=\"vm.password\" required ng-pattern=\"/\\S/\" minlength=\"6\" md-maxlength=\"64\">\n            <div ng-messages=\"passwordForm.password.$error\" ng-show=\"passwordForm.password.$dirty\" md-auto-hide=\"false\">\n              <div ng-message=\"required\">Password Required</div>\n              <div ng-message=\"pattern\">Spaces not allowed</div>\n              <div ng-message=\"minlength\">Password too short</div>\n              <div ng-message=\"md-maxlength\">Password too long</div>\n            </div>\n          </md-input-container>\n\n          <md-input-container class=\"md-block login\" layout=\"row\">\n            <label>Confirm Password</label>\n            <input id=\"pass2\" style=\"font-size: 25px\" class=\"inputStyle\" aria-label=\"password confirm\" ng-ya-password-match=\"pass1\" name=\"password2\" type=\"password\" ng-model=\"vm.confirm\" required ng-pattern=\"/\\S/\" minlength=\"6\" md-maxlength=\"64\">\n            <div ng-messages=\"passwordForm.password2.$error\" ng-show=\"passwordForm.password2.$dirty\" md-auto-hide=\"false\">\n              <div ng-message=\"ngYaPasswordMatch\">Passwords do not match</div>\n              <div ng-message=\"required\">Password confirmation required</div>\n              <div ng-message=\"pattern\">Spaces not allowed</div>\n              <div ng-message=\"minlength\">Password too short</div>\n              <div ng-message=\"md-maxlength\">Password too long</div>\n            </div>\n          </md-input-container>\n\n          <md-button style=\"background-color: #f5a623\" class=\"adminStyle\" layout=\"row\" layout-align=\"center center\" aria-label=\"reset password\" type=\"submit\" class=\"adminButton button\" ng-disabled=\"!passwordForm.$valid\" layout=\"row\" ng-click=\"\">\n            <div class=\"buttonText\">Reset</div>\n          </md-button>\n        </div>\n      </form>\n      <div style=\"width: 40%; height: 100%\"></div>\n    </div>\n    <div style=\"width: 100%; height: 35%\"></div>\n  </div>\n</div>");
$templateCache.put("app/pages/payment/payment.html","<div id=\"payment\">\n    \n    <div class=\"page\" layout=\"row\">\n        \n        <div class=\"leftContent\">\n\n            <img class=\"tenpx\" src=\"assets\\images\\onboarding-logo.png\">\n            \n            <div layout=\"column\">\n        \n                <div class=\"title\" layout=\"column\" layout-align=\"center center\">SUMMARY AND PAYMENT</div>\n\n                <div layout=\"column\" layout-align=\"center center\">\n\n                    <div>\n                        \n                        <div class=\"scrollable catDiv\">\n                        \n                            <div class=\"catTitle\">\n                                Billing Information\n                            </div>\n\n                            <p>{{vm.billing.method}}</p>\n                            <div layout=\"column\" layout-align=\"start\" ng-show=\"vm.billing.method==\'Bank Account\'\">\n                                <p>Routing # {{vm.billing.routingNumber}}</p>\n                                <p>Account # {{vm.billing.accountNumber}}</p>\n                                <p>Account Type {{vm.billing.accountType}}</p>\n                            </div>\n                            <div ng-show=\"vm.billing.method==\'Credit Card\'\">\n                                <p>Card Number {{vm.billing.cardNumber}}</p>\n                            </div>\n                            <div ng-show=\"vm.billing.method==\'PayPal\'\">\n                                <p>Account Number? {{vm.billing.paypalAccount}}</p>\n                            </div>\n                            <div class=\"padding\">\n                            </div>\n\n                        </div>\n                        \n                        <div class=\"scrollable catDiv\">\n                            \n                            <div class=\"catTitle\">\n                                Rate Plan & Fee\n                            </div>\n                            \n                            <div class=\"infoStyle\">\n                                <p>Initial Setup Fee: ${{vm.industry.setupFee}}</p>\n                                <p># of users: {{vm.costs.users}}</p>\n                                \n                                <div class=\"font20px padding15px\">\n                                    Total Amount Due: ${{vm.costs.annual}}\n                                </div>\n                                <!--\n                                <p>Total Amount Due: {{vm.total}}</p>\n                                -->\n                            </div>\n\n                        </div>\n\n                    </div>\n\n                </div>\n\n                <div class=\"buttPad\"></div>\n\n                <div class=\"buttondiv\" layout=\"row\" layout-align=\"center center\">\n\n                <md-button aria-label=\"back\" class=\"md-raised backButton\" ng-click=\"vm.Back()\" class=\"btn btn-primary\">Back</md-button>\n\n                    <md-button aria-label=\"accept\" class=\"md-raised contButton\" ng-click=\"vm.Continue()\" class=\"btn btn-primary\">Accept</md-button>\n                    \n                </div>\n            </div>\n\n        </div>\n\n        <div class=\"tutorial\"></div>\n\n    </div>\n\n\n</div>");
$templateCache.put("app/pages/pending/pending.html","<div id=\"workflow-pending\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header page=\"Workflow Approval Required\"></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div flex>\n            <div class=\"title\">\n              This is Pending Page\n            </div>\n            <div style=\"height: 10px; width: 100%\"></div>\n            <div class=\"sub-title\">\n              There is nothing to see here…\n            </div>\n            <div style=\"height: 10px; width: 100%\"></div>\n          </div>\n          <div class=\"bucket\">\n            <!--md-input-container>\n							<md-select aria-label=\"sort by\" ng-model=\"vm.currentSort\">\n								<md-option ng-repeat=\"sorts in vm.sorts\">\n								{{sorts}}\n								</md-option>\n							</md-select>\n						</md-input-container -->\n\n            <!--Announcements-->\n            <div layout=\"row\" layout-fill layout-wrap layout-margin>\n              <div class=\"grid-cards\" flex=\"none\" layout=\"column\" layout-align=\"start center\" ng-repeat=\"data in vm.msg.announcement track by $index\">\n\n                <ya-message-pending-card data=\"data\" parent=\"vm\" page=\"\'approval\'\"></ya-message-pending-card>\n              </div>\n            </div>\n\n            <!--Ads-->\n            <div layout=\"row\" layout-fill layout-wrap layout-margin>\n              <div class=\"grid-cards\" flex=\"none\" layout=\"column\" layout-align=\"start center\" ng-repeat=\"data in vm.msg.ad track by $index\">\n\n                <ya-message-pending-card data=\"data\" parent=\"vm\" page=\"\'approval\'\"></ya-message-pending-card>\n              </div>\n            </div>\n\n            <!--Appointments-->\n            <div layout=\"row\" layout-fill layout-wrap layout-margin>\n              <div class=\"grid-cards\" flex=\"none\" layout=\"column\" layout-align=\"start center\" ng-repeat=\"data in vm.msg.appointment track by $index\">\n\n                <ya-message-pending-card data=\"data\" parent=\"vm\" page=\"\'approval\'\"></ya-message-pending-card>\n              </div>\n            </div>\n\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/pages/pendingcalc/pendingcalc.html","<div id=\"pendingcalc\" layout=\"row\">\n    <div layout=\"row\" layout-align=\"start\" flex>\n        <div layout=\"column\" flex>\n	        <ya-main-header page=\"Calculate\"></ya-main-header>\n            <div layout=\"row\">\n				<md-sidenav class=\"md-sidenav-left sidenavi\" md-component-id=\"left\" md-is-locked-open=\"$mdMedia(\'min-width: 1250px\')\" md-disable-backdrop md-whiteframe=\"4\" layout=\"column\" layout=\"column\" layout-align=\"center center\">\n					<div class=\"instructions\">Select the region(s) you would like to send your message(s).</div>\n					<div layout=\"column\" layout-align=\"end end\" flex=\"80\"></div>\n					<md-button ng-click=\"\" type=\"submit\" class=\"adminButton buttonColor1\" layout=\"row\" layout-align=\"center center\" ng-click=\"\">\n						<div class=\"buttonText\">\n							Back\n						</div>\n					</md-button>\n				</md-sidenav>\n				<div class=\"contentBox\" layout=\"row\" layout-align=\"center center\">\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n					<div layout=\"row\" flex>\n						<div layout=\"column\" flex>\n							<div class=\"tile\">Calculate Total Cost of All Messages sent to Respective Regions</div>\n							<div layout=\"row\" flex>\n								<div class=\"tenpx\" flex></div>\n								<div class=\"whiteBlock\">\n									<ya-msg-schedule-rebudget tempid=\"vm.tempID\"></ya-msg-schedule-rebudget>\n								</div>\n								<div class=\"tenpx\" flex></div>\n								<div class=\"whiteBlock\">\n									<ya-msg-calculate></ya-msg-calculate>\n								</div>\n								<div class=\"tenpx\" flex></div>\n							</div>\n						</div>\n					</div>\n					<ya-msg-preview parent=\"vm\" type=\"\'none\'\"></ya-msg-preview>\n				</div>\n            </div>\n            <div class=\"previewBox\">\n            	<ya-main-footer></ya-main-footer>\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/pages/pixie/pixie.html","<div style=\"height:100%\" id=\"editor\">\n    <meta charset=\"utf-8\">\n    <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\n    <meta name=\"viewport\" content=\"width=device-width,initial-scale=1,maximum-scale=1\">\n    <link href=\"app/pages/pixie/assets/css/main.css?v20\" rel=\"stylesheet\" type=\"text/css\">\n    <link href=\"https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900\" rel=\"stylesheet\" type=\"text/css\">\n    <link href=\"https://fonts.googleapis.com/css?family=Open+Sans|Lato|Oswald|Arvo\" rel=\"stylesheet\">\n    <link href=\"https://fonts.googleapis.com/css?family=Vollkorn|Droid+Sans|Droid+Serif|Permanent+Marker|Vibur|Abril+Fatface\" rel=\"stylesheet\">\n    <link href=\"https://fonts.googleapis.com/css?family=Amiri|Rubik+One|Bevan|Bungee+Shade|Russo+One|Space+Mono|Indie+Flower\" rel=\"stylesheet\">\n    <link href=\"https://fonts.googleapis.com/css?family=Molle:400i\" rel=\"stylesheet\">\n\n    <div ng-strict-di style=\"height:100%\">\n\n        <div id=\"splash\">\n            <div id=\"splash-spinner\"></div>\n        </div>\n\n        <div ng-cloak style=\"height:100%;width:100%;position:relative;display:block\">\n            <section id=\"right-panels\">\n                <section id=\"objects\" class=\"md-whiteframe-z1\" ng-controller=\"ObjectsPanelController\">\n                    <h3 ed-toggle-panel-visibility=\"objects\"><span>Layers</span><i class=\"mdi mdi-expand-less\"></i></h3>\n                    <div class=\"scrollbar-wrapper\" ed-pretty-scrollbar ed-scroll-axis=\"y\">\n                        <ul class=\"objects-panel list-unstyled\" ui-sortable=\"sortableOptions\" ng-model=\"objects\">\n                            <li class=\"object panel-item\" ng-repeat=\"object in objects\" ng-click=\"setAsActive(object)\" ng-if=\"!object.ignore\">\n                                <i class=\"mdi mdi-remove-red-eye toggle-visibility\" ng-class=\"{ \'not-visible\': !object.visible }\" ng-click=\"toggleVisibility(object); $event.stopPropagation();\"></i>\n                                <i class=\"mdi mdi-delete delete-object\" ng-click=\"deleteObject(object); $event.stopPropagation();\"></i>\n                                <i class=\"mdi mdi-lock-outline lock-object\" ng-class=\"{ \'not-locked\': !object.locked }\" ng-click=\"toggleLock(object); $event.stopPropagation();\"></i>\n                                {{ vme.spacify(object.niceName) || vme.spacify(object.name) || vme.spacify(object.type)\n                                }}\n                            </li>\n                            <li ng-if=\"!vme.canvas.fabric._objects.length\" class=\"text-center\">\n                                <h4>No layers yet.</h4>\n                            </li>\n                        </ul>\n                    </div>\n                </section>\n\n                <!--section id=\"history\" class=\"md-whiteframe-z1 panel-hidden\">\n                    <h3 ed-toggle-panel-visibility=\"history\"><span>History</span><i class=\"mdi mdi-expand-less\"></i></h3>\n                    <ul class=\"history-panel list-unstyled\" ed-pretty-scrollbar ed-scroll-axis=\"y\">\n                        <li class=\"history-item panel-item\" ng-click=\"vme.history.load(item)\" ng-repeat=\"item in vme.history.all\">\n                            <i class=\"mdi mdi-{{ item.icon }} main-icon\"></i>\n                            {{ vme.spacify(item.name) }}\n                        </li>\n                        <li ng-if=\"vme.history.all.length === 0\" class=\"text-center\"><h4>No history items yet.</h4></li>\n                    </ul>\n                </section-->\n            </section>\n\n            <section ng-hide=\"!vme.loading\" id=\"spinner\">\n                <md-progress-circular class=\"md-spinner\" md-diameter=\"100\" md-mode=\"indeterminate\"></md-progress-circular>\n            </section>\n\n            <section id=\"left-sidebar\" ed-tabs=\"basics\" class=\"md-whiteframe-z1\">\n                <div id=\"sidebar-toggler\" ed-toggle-sidebar>\n                    <md-button aria-label=\"toggle sidebar\" class=\"md-fab md-primary\" aria-label=\"Toggle Sidebar\">\n                        <i class=\"mdi mdi-edit show-icon\"></i>\n                        <i class=\"mdi mdi-close close-icon\"></i>\n                    </md-button>\n                </div>\n                <div id=\"hide-bar\">\n                    <div id=\"navigation-bar\">\n                        <div data-activates=\"basics\" class=\"nav-item\">\n                            <i class=\"mdi mdi-image\"></i>\n                            <div class=\"title\">BASICS</div>\n                        </div>\n                        <div data-activates=\"text\" class=\"nav-item\">\n                            <i class=\"mdi mdi-format-bold\"></i>\n                            <div class=\"title pull-up\">TEXT</div>\n                        </div>\n                        <!--div data-activates=\"drawing\" class=\"nav-item\">\n                            <i class=\"mdi mdi-brush\"></i>\n                            <div class=\"title\">DRAWING</div>\n                        </div-->\n                        <!--div data-activates=\"filters\" class=\"nav-item\">\n                            <i class=\"mdi mdi-brightness-6\"></i>\n                            <div class=\"title\">FILTERS</div>\n                        </div-->\n                        <div data-activates=\"new-shapes\" class=\"nav-item\">\n                            <i class=\"mdi mdi-panorama-vertical\"></i>\n                            <div class=\"title\">SHAPES</div>\n                        </div>\n                        <div data-activates=\"simple-shapes\" class=\"nav-item\">\n                            <i class=\"mdi mdi-panorama-vertical\"></i>\n                            <div class=\"title\">BUTTONS</div>\n                        </div>\n                        <div data-activates=\"stickers\" class=\"nav-item\">\n                            <i class=\"mdi mdi-favorite\"></i>\n                            <div class=\"title pull-up\">STICKERS</div>\n                        </div>\n                        <div data-activates=\"googleMap\" class=\"nav-item\">\n                            <i class=\"mdi mdi-image\"></i>\n                            <div class=\"title\">Google Map</div>\n                        </div>\n                    </div>\n                    <div id=\"tabs\">\n                        <section id=\"basics\" data-index=\"1\" class=\"tab\">\n                            <h2 class=\"tab-title\">Basics</h2>\n                            <div ng-controller=\"CanvasBackgroundController\" class=\"basics-item\">\n                                <div class=\"actions-menu\" ng-class=\"vme.activePanel == \'canvasColor\' ? \'closed\' : \'open\'\">\n                                    <div ng-click=\"vme.openPanel(\'canvasColor\', $event)\">\n                                        <i class=\"mdi mdi-format-color-fill basics-icon\"></i>\n                                        <div class=\"icon-title\">Color</div>\n                                    </div>\n                                </div>\n\n                                <div data-name=\"canvasColor\" class=\"actions-menu md-whiteframe-z1 fluid\" ng-class=\"vme.activePanel == \'canvasColor\' ? \'open\' : \'closed\'\">\n                                    <div class=\"menu-header\">\n                                        <h3>Canvas Background Color</h3>\n                                    </div>\n\n                                    <input aria-label=\"background color\" ed-flat ed-color-picker=\"setBackground(color)\" type=\"text\">\n\n\n                                    <div class=\"buttons\">\n                                        <!--md-button aria-label=\"cancel\" ng-click=\"cancel()\">Cancel</md-button-->\n                                        <md-button aria-label=\"apply\" ng-click=\"apply()\" class=\"md-primary md-raised\">Close</md-button>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <!--div class=\"basics-item\" ng-class=\"{ disabled: canvas.fabric._objects.length <= 1 }\">\n                                <div ng-click=\"canvas.mergeObjects()\">\n                                    <i class=\"mdi mdi-merge-type basics-icon\"></i>\n                                    <div class=\"icon-title\">Merge</div>\n                                </div>\n                            </div-->\n                        </section>\n\n                        <section id=\"text\" data-index=\"2\" class=\"tab\" ng-controller=\"TextController\" ng-init=\"init(\'text\')\">\n                            <h2 class=\"tab-title\">Fonts</h2>\n\n                            <!--div class=\"filter-inputs\">\n                                <div class=\"filter-input\">\n                                    <md-select aria-label=\"fonts\"  ng-model=\"filters.category\" ng-change=\"fonts.paginator.filter(filters)\" placeholder=\"Select a Type\">\n                                        <md-option value=\"serif\">Serif</md-option>\n                                        <md-option value=\"sans-serif\">Sans Serif</md-option>\n                                        <md-option value=\"display\">Display</md-option>\n                                        <md-option value=\"handwriting\">Handwriting</md-option>\n                                        <md-option value=\"monospace\">Monospace</md-option>\n                                    </md-select>\n                                </div>\n\n                                <md-input-container class=\"filter-input\">\n                                    <label>Search</label>\n                                    <input aria-label=\"search\" type=\"text\" ng-model=\"filters.family\" ng-change=\"fonts.paginator.filter(filters)\">\n                                </md-input-container>\n                            </div-->\n\n                            <!--div ng-hide=\"vme.activeTab !== \'text\'\" class=\"pagination md-whiteframe-z1\" ed-fonts-pagination></div-->\n                            <div class=\"font-list\" ng-class=\"isPanelEnabled() ? \'closed\' : \'open\'\">\n\n                                <section class=\"fonts-preview\" ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\">\n                                    <div class=\"font\" ng-style=\"{ \'font-family\':  font }\" ng-repeat=\"font in fonts.paginator.currentItems\" ng-click=\"changeFont(font, $event)\">{{ font }}</div>\n                                </section>\n\n                            </div>\n\n                            <div data-name=\"text\" class=\"actions-menu md-whiteframe-z1\" ng-class=\"isPanelEnabled() ? \'open\' : \'closed\'\">\n                                <div class=\"menu-header\">\n                                    <h3>{{getTextTitle()}}</h3>\n                                </div>\n\n                                <section class=\"actions-menu-inner\" ng-style=\"{ \'max-height\': maxPanelHeight }\" ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\">\n                                    <!--div class=\"md-slider\">\n                                        <div class=\"slider-label\">Opacity</div>\n                                        <md-slider aria-label=\"text opacity\" step=\"0.1\" ng-model=\"opacity\" ng-change=\"text.setProperty(\'opacity\', opacity)\" min=\"0\" max=\"1\"></md-slider>\n                                    </div-->\n                                    <!--iv class=\"slider-input\">\n                                        <input aria-label=\"opacity\" min=\"0.1\" max=\"1\" step=\"0.1\" type=\"number\" ng-change=\"text.setProperty(\'opacity\', opacity)\" ng-model=\"opacity\"/>\n                                    </div-->\n\n                                    <div class=\"md-slider\">\n                                        <div class=\"slider-label\">Font Size</div>\n                                        <md-slider aria-label=\"text size\" step=\"1\" ng-change=\"text.setProperty(\'fontSize\', fontSize)\" ng-model=\"fontSize\" min=\"1\" max=\"100\"></md-slider>\n                                    </div>\n                                    <div class=\"slider-input\">\n                                        <input aria-label=\"font size\" type=\"number\" ng-change=\"text.setProperty(\'fontSize\', fontSize)\" ng-model=\"fontSize\">\n                                    </div>\n\n                                    <div class=\"text-styles\">\n                                        <div class=\"text-style-toolbar\" ed-text-align-buttons>\n                                            <i data-align=\"left\" class=\"mdi mdi-format-align-left\"></i>\n                                            <i data-align=\"center\" class=\"mdi mdi-format-align-center active\"></i>\n                                            <i data-align=\"right\" class=\"mdi mdi-format-align-right\"></i>\n                                        </div>\n                                        <!--div class=\"text-style-toolbar text-decoration-buttons\" ed-text-decoration-buttons>\n                                            <div data-decoration=\"underline\" class=\"underline toolbar-btn\">U</div>\n                                            <div data-decoration=\"line-through\" class=\"line-through toolbar-btn\">S</div>\n                                            <div data-decoration=\"overline\" class=\"overline toolbar-btn\">O</div>\n                                            <div data-decoration=\"italic\" class=\"italic toolbar-btn\">I</div>\n                                        </div-->\n                                    </div>\n\n                                    <div class=\"colorpicker\">\n                                        <div class=\"colorpicker-label\"><span>Color</span></div>\n                                        <input aria-label=\"color picker\" ed-type=\"text\" ed-color-picker=\"text.setProperty(\'fill\', color)\" type=\"text\">\n                                    </div>\n\n                                    <!--  <div ng-hide=\"isGenerated()\">\n                                        <md-checkbox class=\"md-checkbox\" ng-model=\"toggleEdit\" ng-change=\"toggleEditable()\" aria-label=\"editable\">Editable Text</md-checkbox>\n                                    </div> -->\n\n\n                                    <section class=\"fonts-box\" ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\">\n                                        <div class=\"\" ng-style=\"{ \'font-family\':  font }\" ng-repeat=\"font in fonts.paginator.currentItems\" ng-click=\"changeFont(font, $event)\">{{ font }}</div>\n                                    </section>\n\n                                    <div>\n                                        <md-checkbox class=\"md-checkbox\" ng-model=\"senderNameChecked\" ng-change=\"changeSenderNameChecked(senderNameChecked)\" aria-label=\"senderNameChecked\">\n                                            Use Sender Name Instead Text\n                                        </md-checkbox>\n                                    </div>\n\n                                    <!--div class=\"colorpicker\">\n                                        <md-checkbox class=\"md-checkbox\" ng-model=\"enableBackground\" ng-change=\"text.toggleProperty(\'backgroundColor\', enableBackground)\" aria-label=\"Background\">Background</md-checkbox>\n                                        <input aria-label=\"color picker\" ed-color-picker=\"text.setProperty(\'backgroundColor\', color)\" ed-color-picker-disabled=\"{{ !enableBackground }}\" type=\"text\"/>\n                                    </div-->\n\n\n                                    <!--div class=\"colorpicker\">\n                                        <md-checkbox class=\"md-checkbox\" ng-model=\"enableOutline\" ng-change=\"text.toggleProperty(\'stroke\', enableOutline)\" aria-label=\"Outline\">Outline</md-checkbox>\n                                        <input ed-color-picker-disabled=\"{{ !enableOutline }}\" ed-color-picker=\"text.setProperty(\'stroke\', color)\" type=\"text\"/>\n                                    </div-->\n\n                                    <!--div class=\"md-inputs\">\n                                        <md-input-container>\n                                            <label>Line Height</label>\n                                            <input aria-label=\"line height\" type=\"number\" min=\"1\" max=\"100\" ng-model=\"lineHeight\" ng-change=\"text.setProperty(\'lineHeight\', lineHeight)\">\n                                        </md-input-container>\n                                        <md-input-container>\n                                            <label>Outline Width</label>\n                                            <input aria-label=\"outline width\" ng-disabled=\"!enableOutline\" type=\"number\" min=\"1\" max=\"100\" ng-model=\"strokeWidth\" ng-change=\"text.setProperty(\'strokeWidth\', strokeWidth)\">\n                                        </md-input-container>\n                                    </div-->\n\n                                    <!--div class=\"buttons\">\n                                        <md-button aria-label=\"done\" ng-click=\"finishAddingTextToCanvas()\" class=\"md-primary md-raised\">Done</md-button>\n                                        <md-button aria-label=\"save\" ng-click=\"cancelAddingTextToCanvas()\" class=\"md-raised\">Cancel</md-button>\n                                    </div-->\n                                </section>\n                            </div>\n                        </section>\n                        <!--section id=\"drawing\" class=\"tab\" data-index=\"3\" ng-controller=\"DrawingController\">\n                            <h2 class=\"tab-title\">Pick a Brush</h2>\n                            <div id=\"brushes\">\n                                <div ng-repeat=\"brush in drawing.availableBrushes\" ng-class=\"{ active: drawing.activeBrushName == brush }\" class=\"brush\" ng-click=\"changeBrush(brush, $event)\">\n                                    <img title=\"{{ brush }}\" class=\"img-responsive\" ng-src=\"assets/images/brushes/{{brush}}.png\"/>\n                                </div>\n                            </div>\n\n                            <div data-name=\"drawing\" class=\"actions-menu wider md-whiteframe-z1\" ng-class=\"vme.activePanel == \'drawing\' ? \'open\' : \'closed\'\">\n                                <div class=\"menu-header\"><h3>Brush</h3></div>\n\n                                <section class=\"actions-menu-inner\" ng-style=\"{ \'max-height\': maxPanelHeight }\" ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\">\n                                    <div class=\"md-slider\">\n                                        <div class=\"slider-label\">Brush Thickness</div>\n                                        <md-slider aria-label=\"brush thickness\" step=\"1\" ng-model=\"drawing.params.brushWidth\" ng-change=\"drawing.setProperty(\'width\', drawing.params.brushWidth)\" min=\"1\" max=\"100\"></md-slider>\n                                    </div>\n                                    <div class=\"slider-input\">\n                                        <input type=\"number\" ng-change=\"drawing.setProperty(\'width\', drawing.params.brushWidth)\" ng-model=\"drawing.params.brushWidth\"/>\n                                    </div>\n\n\n                                    <div class=\"colorpicker\">\n                                        <div class=\"colorpicker-label\"><span>Color</span></div>\n                                        <input ng-model=\"drawing.params.brushColor\" ed-color-picker=\"drawing.setProperty(\'color\', color)\" type=\"text\"/>\n                                    </div>\n\n                                    <div class=\"heading-with-switcher\">\n                                        <h3>Shadow</h3>\n                                        <md-switch class=\"md-switch\" ng-model=\"drawing.params.enableShadow\" ng-change=\"drawing.toggleShadow(drawing.params.enableShadow)\" aria-label=\"Enable Shadow\"></md-switch>\n                                    </div>\n\n                                    <div class=\"md-slider\">\n                                        <div class=\"slider-label\"><span>Blur</span></div>\n                                        <md-slider aria-label=\"shadow blur\" ng-disabled=\"!drawing.params.enableShadow\" step=\"1\" ng-model=\"drawing.params.shadowBlur\" ng-change=\"drawing.setShadowProperty(\'blur\', drawing.params.shadowBlur)\" min=\"1\" max=\"100\"></md-slider>\n                                    </div>\n                                    <div class=\"slider-input\">\n                                        <input type=\"number\" ng-change=\"drawing.setShadowProperty(\'blur\', drawing.params.shadowBlur)\" ng-disabled=\"!drawing.params.enableShadow\" ng-model=\"drawing.params.shadowBlur\"/>\n                                    </div>\n\n                                    <div class=\"md-slider\">\n                                        <div class=\"slider-label\"><span>Offset X</span></div>\n                                        <md-slider ng-disabled=\"!drawing.params.enableShadow\" aria-label=\"shadow blur\" step=\"1\" ng-model=\"drawing.params.shadowOffsetX\" ng-change=\"drawing.setShadowProperty(\'offsetX\', drawing.params.shadowOffsetX)\" min=\"1\" max=\"100\"></md-slider>\n                                    </div>\n                                    <div class=\"slider-input\">\n                                        <input type=\"number\" ng-change=\"drawing.setShadowProperty(\'offsetX\', drawing.params.shadowOffsetX)\" ng-disabled=\"!drawing.params.enableShadow\" min=\"1\" ng-model=\"drawing.params.shadowOffsetX\"/>\n                                    </div>\n\n                                    <div class=\"md-slider\">\n                                        <div class=\"slider-label\"><span>Offset Y</span></div>\n                                        <md-slider ng-disabled=\"!drawing.params.enableShadow\" aria-label=\"shadow blur\" step=\"1\" ng-model=\"drawing.params.shadowOffsetY\" ng-change=\"drawing.setShadowProperty(\'offsetY\', drawing.params.shadowOffsetY)\" min=\"1\" max=\"100\"></md-slider>\n                                    </div>\n                                    <div class=\"slider-input\">\n                                        <input type=\"number\" ng-change=\"drawing.setShadowProperty(\'offsetY\', drawing.params.shadowOffsetY)\" ng-disabled=\"!drawing.params.enableShadow\" min=\"1\" ng-model=\"drawing.params.shadowOffsetY\"/>\n                                    </div>\n\n                                    <div class=\"colorpicker\">\n                                        <div class=\"colorpicker-label\"><span>Color</span></div>\n                                        <input ng-disabled=\"!drawing.params.enableShadow\" ng-model=\"drawing.params.shadowColor\" start-color=\"{{ drawing.params.shadowColor }}\" ed-color-picker=\"drawing.setShadowProperty(\'color\', color)\" type=\"text\"/>\n                                    </div>\n\n                                    <div class=\"buttons\">\n                                        <md-button ng-click=\"finishAddingDrawingsToCanvas()\" class=\"md-primary md-raised\">Save</md-button>\n                                        <md-button ng-click=\"cancelAddingDrawingsToCanvas()\" class=\"md-raised\">Cancel</md-button>\n                                    </div>\n                                </section>\n                            </div>\n                        </section>\n                        <section id=\"filters\" class=\"tab\" data-index=\"4\" ng-controller=\"FiltersController\">\n                            <h2 class=\"tab-title\">Pick a Filter</h2>\n                            <div class=\"filters-list row\" ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\">\n                                <figure ng-class=\"{ applied: filters.filterAlreadyApplied(filter.name) }\" ng-repeat=\"filter in filters.all\" ng-click=\"filters.applyFilter(filter)\" class=\"filter col-sm-6\">\n                                    <div class=\"filter-image\">\n                                        <img ng-src=\"assets/images/filters/{{ filter.name.toLowerCase() }}.png\" class=\"img-responsive md-whiteframe-z1\"/>\n                                        <div ng-class=\"{ \'remove-only\': !filter.options }\" class=\"remove-filter-overlay\">\n                                            <i class=\"mdi mdi-cancel\"></i>\n                                            <i ng-if=\"filter.options\" ng-click=\"filters.lastAppliedFilter = filter; $event.stopPropagation();\" class=\"mdi mdi-settings\"></i>\n                                        </div>\n                                    </div>\n                                    <figcaption>{{ filter.displayName || filter.name }}</figcaption>\n                                </figure>\n                            </div>\n\n                            <div class=\"actions-menu md-whiteframe-z1\" ng-class=\"filters.lastAppliedFilter.options ? \'open\' : \'closed\'\">\n                                <div class=\"menu-header\"><h3>{{ filters.lastAppliedFilter.name }}</h3></div>\n\n                                <section class=\"actions-menu-inner\" ng-style=\"{ \'max-height\': maxPanelHeight }\" ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\">\n                                    <div ng-repeat=\"(key,value) in filters.lastAppliedFilter.options\">\n\n                                        <section ng-if=\"!value.colorpicker && !value.select\">\n                                            <div class=\"md-slider\">\n                                                <div class=\"slider-label\">{{ key == filters.lastAppliedFilter.name ? \'amount\' : key }}</div>\n                                                <md-slider\n                                                        md-discrete\n                                                        aria-label=\"{{ key }}\"\n                                                        step=\"{{ value.step ? value.step : 1 }}\"\n                                                        ng-model=\"filters.lastAppliedFilter.options[key].current\"\n                                                        ng-change=\"filters.applyValue(filters.lastAppliedFilter.name, key, filters.lastAppliedFilter.options[key].current)\"\n                                                        min=\"{{ value.min ? value.min : 1 }}\"\n                                                        max=\"{{ value.max ? value.max : 250 }}\"\n                                                        ></md-slider>\n                                            </div>\n                                            <div class=\"slider-input\">\n                                                <input ng-if=\"!value.colorpicker\" type=\"number\" ng-change=\"filters.applyValue(filters.lastAppliedFilter.name, key, filters.lastAppliedFilter.options[key].current)\" ng-model=\"filters.lastAppliedFilter.options[key].current\"/>\n                                            </div>\n                                        </section>\n\n                                        <section ng-if=\"value.colorpicker\" class=\"colorpicker\">\n                                            <div class=\"colorpicker-label\"><span>{{ key }}</span></div>\n                                            <input ed-discrete ng-model=\"filters.lastAppliedFilter.options[key].current\" start-color=\"{{ filters.lastAppliedFilter.options[key].current }}\" ed-color-picker=\"filters.applyValue(filters.lastAppliedFilter.name, key, color)\" type=\"text\"/>\n                                        </section>\n\n                                        <section ng-if=\"value.select\">\n                                            <div class=\"col-sm-8 pull-down\">{{ key }}</div>\n                                            <div class=\"col-sm-4 no-padding\">\n                                                <select class=\"form-control\" ng-model=\"filters.lastAppliedFilter.options[key].current\" ng-change=\"filters.applyValue(filters.lastAppliedFilter.name, key, filters.lastAppliedFilter.options[key].current)\">\n                                                    <option ng-repeat=\"mode in filters.lastAppliedFilter.options[key].available\" value=\"{{ mode }}\">{{ mode }}</option>\n                                                </select>\n                                            </div>\n                                        </section>\n                                    </div>\n                                </section>\n                            </div>\n                        </section-->\n\n                        <section id=\"new-shapes\" class=\"tab\" data-index=\"5\" ng-controller=\"SimpleShapesController\" ng-init=\"init(\'shape\')\">\n                            <h2 class=\"tab-title\">Shapes</h2>\n\n                            <div class=\"shapes-list\" ng-class=\"isShapePanelEnabled() ? \'closed\' : \'open\'\">\n                                <div class=\"shape\" ng-if=\"!shape.hidden\" data-name=\"{{ shape.name }}\" ng-repeat=\"shape in shapes.available\" ng-click=\"shapes.addShapeToCanvas(shape)\">\n                                    <div class=\"shape-image\" id=\"{{ shape.name }}\">\n                                        <div class=\"css-shape\"></div>\n                                    </div>\n                                    <div class=\"shape-name\">{{ shape.displayName || shape.name }}</div>\n                                </div>\n                            </div>\n\n                            <div class=\"actions-menu md-whiteframe-z1\" ng-class=\"isShapePanelEnabled() ? \'open\' : \'closed\'\">\n                                <div class=\"menu-header\">\n                                    <h3>{{ shapes.selected.displayName || shapes.selected.name }}</h3>\n                                </div>\n\n                                <section class=\"actions-menu-inner\" ng-style=\"{ \'max-height\': maxPanelHeight }\" ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\">\n                                    <section id=\"object-fills\">\n                                        <!--div class=\"fill-activator\">\n                                            <div class=\"fill-activator-label\">Image</div>\n                                            <button class=\"fill-activator-button image-activator\" ng-click=\"openBottomSheet(\'image\')\"></button>\n                                        </div>\n\n                                        <div class=\"fill-activator\">\n                                            <div class=\"fill-activator-label\">Gradient</div>\n                                            <button class=\"fill-activator-button gradient-activator\" ng-click=\"openBottomSheet(\'gradient\')\"></button>\n                                        </div-->\n\n                                        <div class=\"colorpicker\" ng-if=\"shapes.selected.options.main\">\n                                            <div class=\"colorpicker-label\"><span>Color</span></div>\n                                            <input id=\"colorSendShape\" ed-type=\"shapes\" aria-label=\"fill\" ng-model=\"shapes.selected.options.main.fill.current\" ed-color-picker=\"shapes.applyValue(\'main\', shapes.selected.name, \'fill\', color)\" type=\"text\">\n                                        </div>\n\n                                        <!--div class=\"fill-activator\">\n                                            <div class=\"fill-activator-label\">Color</div>\n                                            <input ed-discrete start-color=\"{{ shapes.selected.options.main.fill.current }}\" ed-type=\"shapes\" ng-model=\"shapes.selected.options.main.fill.current\" ed-color-picker=\"shapes.applyValue(\'main\', shapes.selected.name, \'fill\', color)\"  type=\"text\"/>\n                                        </div-->\n\n                                    </section>\n\n                                    <div ng-repeat=\"group in shapes.selected.options | orderOptions\" class=\"clearfix\">\n\n                                        <div ng-if=\"group.name !== \'main\'\" class=\"heading-with-switcher\">\n                                            <h3>{{ group.name }}</h3>\n                                            <md-switch class=\"md-switch\" ng-model=\"shapes.selected.options[group.name].enabled\" ng-change=\"shapes[group.onToggle](shapes.selected.name, shapes.selected.options[group.name].enabled)\" aria-label=\"Toggle {{ group.name }}\"></md-switch>\n                                        </div>\n\n                                        <div ng-repeat=\"(optionName, option) in group\">\n\n                                            <section ng-if=\"option.type === \'slider\'\">\n                                                <div class=\"md-slider\">\n                                                    <div class=\"slider-label\">{{ option.displayName || optionName }}\n                                                    </div>\n\n                                                    <md-slider md-discrete aria-label=\"{{ optionName }}\" step=\"{{ option.step ? option.step : 1 }}\" ng-model=\"shapes.selected.options[group.name][optionName].current\" ng-change=\"shapes.applyValue(group.name, shapes.selected.name, optionName, shapes.selected.options[group.name][optionName].current)\" min=\"{{ option.min ? option.min : 1 }}\" max=\"{{ option.max ? option.max : 250 }}\" ng-disabled=\"!group.enabled\"></md-slider>\n                                                </div>\n                                                <div class=\"slider-input\">\n                                                    <input type=\"number\" ng-change=\"shapes.applyValue(group.name, shapes.selected.name, optionName, shapes.selected.options[group.name][optionName].current)\" ng-disabled=\"!group.enabled\" ng-model=\"shapes.selected.options[group.name][optionName].current\">\n                                                </div>\n                                            </section>\n\n                                            <section ng-if=\"option.type === \'colorpicker\' && !option.hidden\" class=\"colorpicker\">\n                                                <div class=\"colorpicker-label\"><span>{{ option.displayName || optionName\n                                                        }}</span></div>\n                                                <input start-color=\"{{ option.current }}\" ed-discrete ng-disabled=\"!group.enabled\" ng-model=\"shapes.selected.options[group.name][optionName].current\" ed-color-picker=\"shapes.applyValue(group.name, shapes.selected.name, optionName, color)\" type=\"text\">\n                                            </section>\n                                        </div>\n                                    </div>\n                                </section>\n                            </div>\n                        </section>\n\n                        <section id=\"simple-shapes\" class=\"tab\" data-index=\"6\" ng-controller=\"SimpleShapesController\" ng-init=\"init(\'button\')\">\n                            <h2 class=\"tab-title\">Buttons</h2>\n\n                            <div class=\"shapes-list\" ng-class=\"isPanelEnabled() ? \'closed\' : \'open\'\">\n                                <div ng-show=\"shape.button\" class=\"shape\" data-name=\"{{ shape.name }}\" ng-repeat=\"shape in shapes.available\" ng-click=\"shapes.addToCanvas(shape)\">\n                                    <div class=\"shape-image\" id=\"{{ shape.name }}\">\n                                        <div class=\"css-shape\"></div>\n                                    </div>\n                                    <div class=\"shape-name\">{{ shape.displayName || shape.name }}</div>\n                                </div>\n                                <div ng-hide=\"canAddButton()\">\n                                    <p style=\"text-align: center; margin-top: 20px; color:#FF0000\">Button Limit Reached!\n                                    </p>\n                                </div>\n                            </div>\n\n                            <div ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\" style=\"height:90%\">\n                                <div class=\"actions-menu md-whiteframe-z1\" ng-class=\"isPanelEnabled() ? \'open\' : \'closed\'\">\n\n\n                                    <div class=\"menu-header\">\n                                        <h3>Button</h3>\n                                    </div>\n                                    <section class=\"actions-menu-inner\" ng-style=\"{ \'height\': maxPanelHeight }\" ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\" style=\"height:100%\">\n\n                                        <md-select id=\"actionselect\" aria-label=\"select action\" ng-model=\"shapes.actionType\" ng-change=\"shapes.applyAction()\" placeholder=\"Select Action\">\n                                            <md-option value=\"phone\">Phone Number</md-option>\n                                            <md-option value=\"link\">Website Link</md-option>\n                                            <md-option value=\"senderphone\">CallToSenderNumber</md-option>\n                                            <md-option value=\"sendtemplateonreply\">SendTemplateOnReply</md-option>\n                                            <md-option value=\"sendtemplateon911\">SendTemplateOn911</md-option>\n                                            <md-option value=\"directions\">Directions</md-option>\n                                            <md-option value=\"cancel\" ng-show=\"isAppt()\">Cancel</md-option>\n                                            <md-option value=\"confirm\" ng-show=\"isAppt()\">Confirm</md-option>\n                                            <md-option value=\"reschedule\" ng-show=\"isAppt()\">Re-Schedule</md-option>\n                                        </md-select>\n                                        <div ng-show=\"showTemplateForReply()\" style=\"padding-bottom: 30px\">\n                                            <label>{{shapes.action}}</label>\n                                            <md-select aria-label=\"Choose Reply Template\" ng-model=\"shapes.action\" ng-change=\"shapes.applyAction()\">\n                                                <md-option ng-repeat=\"x in alertTemplateList\" ng-value=\"x.id\">\n                                                    {{x.name}}\n                                                </md-option>\n                                            </md-select>\n                                        </div>\n                                        <div ng-show=\"showAction()\" style=\"padding-bottom: 30px\">\n                                            <label>{{shapes.actionType}}</label>\n                                            <input aria-label=\"shapes\" type=\"text\" ng-model=\"shapes.action\" ng-change=\"shapes.applyAction()\">\n                                        </div>\n\n                                        <div ng-show=\"shapes.currentObj.name==\'rect\'\">\n                                            <div class=\"md-slider\">\n                                                <div class=\"slider-label\">Corners</div>\n                                                <md-slider md-discrete aria-label=\"corners\" step=\"1\" ng-model=\"shapes.selected.options.main.corners.current\" ng-change=\"shapes.applyValue(group.name,\'rect\',\'corners\', shapes.selected.options.main.corners.current)\" min=\"0\" max=\"25\"></md-slider>\n                                            </div>\n                                            <div class=\"slider-input\">\n                                                <input type=\"number\" ng-change=\"shapes.applyValue(\'\',\'rect\',\'corners\', shapes.selected.options.main.corners.current)\" ng-model=\"shapes.selected.options.main.corners.current\">\n                                            </div>\n                                            <div class=\"md-slider\">\n                                                <div class=\"slider-label\">Vertical Padding</div>\n                                                <md-slider md-discrete aria-label=\"vertical\" step=\"1\" ng-model=\"shapes.vertical\" ng-change=\"shapes.applyValue(group.name,\'rect\',\'vertical\', shapes.vertical)\" min=\"0\" max=\"100\"></md-slider>\n                                            </div>\n                                            <div class=\"slider-input\">\n                                                <input type=\"number\" ng-change=\"shapes.applyValue(\'\',\'rect\',\'vertical\', shapes.vertical)\" ng-model=\"shapes.vertical\">\n                                            </div>\n                                            <div class=\"md-slider\">\n                                                <div class=\"slider-label\">Horizontal Padding</div>\n                                                <md-slider md-discrete aria-label=\"horizontal\" step=\"1\" ng-model=\"shapes.horizontal\" ng-change=\"shapes.applyValue(group.name,\'rect\',\'horizontal\', shapes.horizontal)\" min=\"0\" max=\"100\"></md-slider>\n                                            </div>\n                                            <div class=\"slider-input\">\n                                                <input type=\"number\" ng-change=\"shapes.applyValue(\'\',\'rect\',\'horizontal\', shapes.horizontal)\" ng-model=\"shapes.horizontal\">\n                                            </div>\n                                        </div>\n\n                                        <div>\n                                            <div class=\"colorpicker\">\n                                                <div class=\"colorpicker-label\"><span>Color</span></div>\n                                                <input id=\"colorSendShape\" ed-type=\"shapes\" aria-label=\"fill\" ed-color-picker=\"shapes.applyValue(\'main\', shapes.selected.name, \'fill\', color)\" type=\"text\">\n                                            </div>\n                                        </div>\n\n                                    </section>\n                                    <div class=\"button-header\" ng-click=\"clickHeader(\'icon\')\">Icon</div>\n                                    <section id=\"stickerbox\" ng-show=\"activeHeader==\'icon\'\" class=\"open\" ng-controller=\"StickersController\" ng-init=\"init(\'button\')\">\n                                        <div class=\"actions-menu-inner\" ng-style=\"{ \'max-height\': maxPanelHeight }\" ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\">\n                                            <div ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\" ed-stickers-categories style=\"height: 150px;padding-bottom: 20px\">\n                                                <section ng-repeat=\"category in iconCategories\" class=\"sticker-category-container\">\n                                                    <h3 class=\"sticker\" ng-click=\"addButtonIcon(0)\">NONE</h3>\n                                                    <div ng-repeat=\"doodle in category.items track by $index\" ng-click=\"addButtonIcon($index+1)\" class=\"sticker\">\n                                                        <img ng-src=\"assets/images/stickers/icons/{{$index+1}}.svg\">\n                                                    </div>\n                                                </section>\n                                            </div>\n\n                                            <div>\n                                                <div class=\"colorpicker\">\n                                                    <div class=\"colorpicker-label\"><span>Color</span></div>\n                                                    <input id=\"colorIcon\" ed-type=\"icon\" aria-label=\"fill\" ed-color-picker=\"shapes.applyValue(\'main\', shapes.selected.name, \'iconfill\', color)\" type=\"text\">\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </section>\n                                    <div class=\"sticker-category-container\">\n                                        <div class=\"button-header\" ng-click=\"clickHeader(\'text\')\">Text</div>\n                                    </div>\n                                    <section class=\"open\" ng-show=\"activeHeader==\'text\'\" ng-controller=\"TextController\" ng-init=\"init(\'button\')\">\n\n                                        <div class=\"actions-menu-inner\" ng-style=\"{ \'max-height\': maxPanelHeight }\" ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\">\n\n                                            <div class=\"md-slider\">\n                                                <div class=\"slider-label\">Font Size</div>\n                                                <md-slider aria-label=\"text size\" step=\"1\" ng-change=\"text.setProperty(\'fontSize\', fontSize)\" ng-model=\"fontSize\" min=\"1\" max=\"100\"></md-slider>\n                                            </div>\n                                            <div class=\"slider-input\">\n                                                <input aria-label=\"font size\" type=\"number\" ng-change=\"text.setProperty(\'fontSize\', fontSize)\" ng-model=\"fontSize\">\n                                            </div>\n\n                                            <div class=\"text-styles\">\n                                                <div class=\"text-style-toolbar\" ed-text-align-buttons>\n                                                    <i data-align=\"left\" class=\"mdi mdi-format-align-left\"></i>\n                                                    <i data-align=\"center\" class=\"mdi mdi-format-align-center active\"></i>\n                                                    <i data-align=\"right\" class=\"mdi mdi-format-align-right\"></i>\n                                                </div>\n                                            </div>\n\n                                            <div class=\"colorpicker\">\n                                                <div class=\"colorpicker-label\"><span>Color</span></div>\n                                                <input aria-label=\"color picker\" ed-type=\"text\" ed-color-picker=\"text.setProperty(\'fill\', color)\" type=\"text\">\n                                            </div>\n\n                                            <section class=\"fonts-box\" ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\">\n                                                <div class=\"font\" ng-style=\"{ \'font-family\':  font }\" ng-repeat=\"font in fonts.paginator.currentItems\" ng-click=\"changeFont(font, $event)\">{{ font }}</div>\n                                            </section>\n\n\n\n                                            <!--div class=\"buttons\">\n                                            <md-button aria-label=\"done\" ng-click=\"finishAddingTextToCanvas()\" class=\"md-primary md-raised\">Done</md-button>\n                                        </div-->\n                                        </div>\n                                    </section>\n                                </div>\n                            </div>\n                        </section>\n\n                        <section id=\"stickers\" class=\"tab\" data-index=\"7\" ng-controller=\"StickersController\" ng-init=\"init(\'sticker\')\">\n                            <h2 class=\"tab-title\">Stickers</h2>\n                            <div class=\"sticker-list\" ng-class=\"isPanelEnabled() ? \'closed\' : \'open\'\" ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\" ed-stickers-categories>\n                                <section ng-repeat=\"category in categories\" class=\"sticker-category-container\">\n                                    <div class=\"category-header\" data-name=\"{{ category.name }}\">{{ category.name }}\n                                    </div>\n                                    <div class=\"category-stickers\" ng-class=\"{ \'open animated slideInDown\': activeCategory === category.name, \'dark-bg\': category.darkbg }\">\n                                        <div ng-repeat=\"doodle in category.items track by $index\" ng-click=\"addToCanvas(category, $index+1, $event)\" class=\"sticker\">\n                                            <img class=\"img-responsive\" data-src=\"assets/images/stickers/{{category.name}}/{{$index+1}}.{{ category.type }}\">\n                                        </div>\n                                    </div>\n                                </section>\n                            </div>\n\n                            <div data-name=\"stickers\" class=\"actions-menu md-whiteframe-z1\" ng-class=\"isPanelEnabled() ? \'open\' : \'closed\'\">\n                                <div class=\"menu-header\">\n                                    <h3>Sticker</h3>\n                                </div>\n                                <section class=\"actions-menu-inner\" ng-style=\"{ \'max-height\': maxPanelHeight }\" ed-pretty-scrollbar ed-scroll-axis=\"y\" ed-scroll-theme=\"light\">\n                                    <div class=\"md-slider\">\n                                        <div class=\"slider-label\">Opacity</div>\n                                        <md-slider aria-label=\"shape opacity\" step=\"0.1\" ng-model=\"opacity\" ng-change=\"setOpacity(opacity)\" min=\"0\" max=\"1\"></md-slider>\n                                    </div>\n                                    <div class=\"slider-input\">\n                                        <input type=\"number\" ng-change=\"setOpacity(opacity)\" step=\"0.1\" min=\"0.1\" max=\"1\" ng-model=\"opacity\">\n                                    </div>\n                                    <section class=\"colorpicker\" ng-show=\"activeStickerIsSvg()\">\n                                        <div class=\"colorpicker-label\"><span>Color</span></div>\n                                        <input ng-model=\"color\" ed-type=\"sticker\" ed-color-picker=\"setColor(color)\" type=\"text\">\n                                    </section>\n                                </section>\n                            </div>\n\n                        </section>\n\n                        <section id=\"googleMap\" data-index=\"1\" class=\"tab\" ng-controller=\"TextController\">\n                            <h2 class=\"tab-title\">Select Google Map Options</h2>\n                            <div class=\"googleMap-item\">\n                        \n                                <!-- Use Google Map Instead of Image -->\n                                <div>\n                                    <md-checkbox class=\"md-checkbox\" ng-checked=\"setGoogleMap()\" ng-click=\"changeUseGoogleMap()\" aria-label=\"useGoogleMap\">\n                                    Use Google Map Instead Image\n                                </md-checkbox>\n                                </div>\n                                 <!-- Show Organization Banner Location or User GPS -->\n                                <div ng-if=\"useGoogleMap\" style=\"padding-top: 15px\">\n                                    <md-checkbox class=\"md-checkbox\" ng-checked=\"useUserGPS\" ng-click=\"changeUseUserGPS()\" aria-label=\"useUserGPS\">\n                                                Show Current User GPS Instead of Organization Banner Location\n                                    </md-checkbox>\n                                </div>\n                            </div>\n                                <!-- Map Type Selection -->\n                                <!-- <div ng-if=\"useGoogleMap\"  style=\"width: 80%; margin: auto;  padding-top: 15px;\">\n                                    <label for=\"mapType\">Select Map Type:</label>\n                                    <md-select id=\"mapType\" aria-label=\"mapType\" ng-model=\"selectedMapType\" \n                                    ng-change=\"changeSelectedMapType(selectedMapType)\" placeholder=\"Select a Map Type\">  \n                                       <md-option value=\"\">Select Map Type</md-option>  \n                                        <md-option value=\"transit\">Transit</md-option>\n                                        <md-option value=\"traffic\">Traffic</md-option>\n                                        <md-option value=\"biking\">Biking</md-option>\n                                        <md-option value=\"terrain\">Terrain</md-option>\n                                        <md-option value=\"street_view\">Street View</md-option>\n                                        <md-option value=\"wildfires\">Wildfires</md-option>\n                                        <md-option value=\"air_quality\">Air Quality</md-option>\n                                    </md-select>\n                                </div> -->\n                        \n                            \n                        </section>\n                        \n                    </div>\n                </div>\n\n            </section>\n\n            <section id=\"viewport\">\n\n                <section id=\"top-panel\" class=\"md-whiteframe-z1\" ng-controller=\"TopPanelController\">\n                    <md-button aria-label=\"open\" ng-click=\"openUploadDialog($event)\" ng-if=\"!getParam(\'hideOpenButton\')\">Load Image</md-button>\n                    <!--md-button ng-class=\"{ inactive: !historyPanelOpen }\" ng-click=\"toggleRightPanel(\'history\', $event)\">History</md-button-->\n                    <md-button aria-label=\"layers\" ng-class=\"{ inactive: !objectsPanelOpen }\" ng-click=\"toggleRightPanel(\'objects\', $event)\">Layers</md-button>\n                    <!--md-button aria-label=\"update\" ng-click=\"updatePreview()\" class=\"md-primary md-raised\">Update</md-button-->\n                </section>\n\n                <canvas ng-show=\"vme.started\" id=\"canvas\" class=\"md-whiteframe-z2\"></canvas>\n            </section>\n\n            <div id=\"bottom-bar\" ng-controller=\"ZoomController\">\n                <section class=\"zoom-container md-whiteframe-z1\">\n                    <div class=\"current-zoom\">{{ getCurrentZoom() }}%</div>\n                    <div class=\"zoom-slider\">\n                        <md-slider aria-label=\"zoom\" step=\"1\" ng-model=\"zoom\" ng-change=\"doZoom()\" min=\"{{ minScale }}\" max=\"{{ maxScale }}\"></md-slider>\n                    </div>\n                    <div class=\"action-icons\">\n                        <i ng-click=\"canvas.fitToScreen()\" class=\"mdi mdi-filter-center-focus fit-to-screen\"><md-tooltip md-delay=\"200\">Fit to screen</md-tooltip></i>\n                        <i ng-click=\"canvas.zoom(1)\" class=\"mdi mdi-fullscreen original-size\"><md-tooltip md-delay=\"200\">Original size</md-tooltip></i>\n                    </div>\n                    <div ed-ie-slider-fix></div>\n                </section>\n            </div>\n\n            <script type=\"application/ng-template\" id=\"gradient-sheet-template\">\n                <div id=\"editor\">\n                <md-bottom-sheet class=\"bottom-sheet gradients-sheet\">\n                    <div class=\"items-list\" ed-pretty-scrollbar>\n                        <div ng-repeat=\"g in shapes.gradients\" ng-style=\"{background: \'url(assets/images/gradients/\'+($index+1)+\'.png)\'}\" ng-click=\"shapes.fillWithGradient($index+1)\" class=\"item md-whiteframe-z1\"></div>\n                    </div>\n                </md-bottom-sheet>\n                <div>\n            </script>\n\n            <script type=\"application/ng-template\" id=\"image-sheet-template\">\n                <div id=\"editor\">\n                <md-bottom-sheet class=\"bottom-sheet images-sheet\">\n                    <div class=\"upload-new\" ng-click=\"showDialog($event)\">\n                        <i class=\"mdi mdi-cloud-upload\"></i>\n                        <span class=\"icon-label\">Upload</span>\n                    </div>\n                    <div class=\"items-list\" ed-pretty-scrollbar>\n                        <div ng-repeat=\"t in shapes.textures track by $index\" ng-style=\"{background: \'url(assets/images/textures/\'+$index+\'.png)\'}\" ng-click=\"shapes.fillWithImage(\'assets/images/textures/\'+$index+\'.png\')\" class=\"item md-whiteframe-z1\"></div>\n                    </div>\n                </md-bottom-sheet>\n                </div>\n            </script>\n\n            <script type=\"application/ng-template\" id=\"texture-upload-dialog-template\">\n                <div id=\"editor\">\n                <md-dialog class=\"upload-file-dialog\">\n                    <md-input-container>\n                        <label>Image URL</label>\n                        <input aria-label=\"image url\" aria-label=\"image url\" type=\"text\" ng-model=\"imageBgUrl\" ng-change=\"shapes.fillWithImage(imageBgUrl)\" ng-model-options=\"{ debounce: 500 }\">\n                    </md-input-container>\n\n                    <h2><span>OR</span></h2>\n\n                    <label class=\"pretty-upload\">\n                        <input aria-label=\"upload from computer\" type=\"file\" ed-file-uploader=\"shapes.fillWithImage\" ed-close-after/>\n                        <i class=\"mdi mdi-cloud-upload\"></i>\n                        <span class=\"upload-button-label\">Upload From Computer</span>\n                    </label>\n                </md-dialog>\n                </div>\n            </script>\n\n            <script type=\"application/ng-template\" id=\"save-image-dialog\">\n                <div id=\"editor\">\n                <md-dialog class=\"upload-file-dialog save-dialog\">\n                    <md-input-container>\n                        <label>File Name</label>\n                        <input aria-label=\"filename\" type=\"text\" ng-model=\"imageName\">\n                    </md-input-container>\n\n                    <md-radio-group ng-model=\"imageType\">\n                        <md-radio-button aria-label=\"jpeg\" value=\"jpeg\">JPEG</md-radio-button>\n                        <md-radio-button aria-label=\"png\" value=\"png\">PNG </md-radio-button>\n                    </md-radio-group>\n\n                    <div ng-if=\"imageType === \'jpeg\'\">\n                        <div class=\"slider-label\">Quality {{ imageQuality }}</div>\n                        <md-slider aria-label=\"Angle\" md-discrete ng-model=\"imageQuality\" step=\"1\" min=\"1\" max=\"10\" ></md-slider>\n                    </div>\n\n                    <md-button aria-label=\"save\" ng-click=\"saveImage($event)\" class=\"md-raised md-primary\">Save</md-button>\n\n                    <div class=\"demo-alert\" ng-if=\"isDemo\">Image saving is disabled on demo site.</div>\n                </md-dialog>\n                </div>\n            </script>\n\n            <script type=\"application/ng-template\" id=\"main-image-upload-dialog-template\">\n                <div id=\"editor\">\n                <md-dialog class=\"upload-file-dialog\">\n                    <div ng-show=\"openImageMode === \'open\'\">\n                        <md-input-container>\n                            <label>Image URL</label>\n                            <md-input-container flex>\n                                <md-select aria-label=\"image url\" ng-model=\"openImageUrl\" md-selected-text=\"openImageUrl\" ng-change=\"showImagePreview(openImageUrl.name)\">\n                                    <md-optgroup label=\"Images\">\n                                        <md-option ng-value=\"c\" ng-repeat=\"c in imageList\">{{c.niceName}}</md-option>\n                                    </md-optgroup>\n                                </md-select>\n                            </md-input-container>\n                        </md-input-container>\n\n                        <h2><span>OR</span></h2>\n\n                        <label class=\"pretty-upload\">\n                            <input aria-label=\"upload from computer\" type=\"file\" ed-file-uploader=\"showImagePreview\"/>\n                            <i class=\"mdi mdi-cloud-upload\"></i>\n                            <span class=\"upload-button-label\">Upload From Computers</span>\n                        </label>\n\n                        <div ng-show=\"canOpenImage\">\n                            <div class=\"img-preview\"></div>\n\n                            <div class=\"buttons\">\n                                <md-button aria-label=\"upload\" ng-click=\"openImage()\" class=\"md-primary md-raised\">Upload</md-button>\n                                <md-button aria-label=\"close\" ng-click=\"closeUploadDialog()\" class=\"md-raised\">Close</md-button>\n                            </div>\n                        </div>\n                    </div>\n                </md-dialog>\n                </div>\n            </script>\n\n            <script type=\"text/ng-template\" id=\"modals/polygon.html\">\n                <div id=\"editor\">\n                <md-dialog class=\"md-modal\">\n                    <div class=\"md-modal-header\">\n                        <h1>Polygon Instructions</h1>\n                        <div ng-click=\"closeModal()\" class=\"md-close-modal\"><i class=\"mdi mdi-close\"></i></div>\n                    </div>\n\n                    <ol>\n                        <li>Click on the canvas where you want to start the polygon edge.</li>\n                        <li>Drag your mouse.</li>\n                        <li>Click again where you want to end the edge.</li>\n                        <li>Repeat to add more edges.</li>\n                        <li>Hit escape or click anywhere outside of canvas to finish.</li>\n                    </ol>\n\n                    <div class=\"buttons\">\n                        <md-button aria-label=\"got it\" class=\"md-primary md-raised\" ng-click=\"closeModal()\">got it</md-button>\n                    </div>\n                </md-dialog>\n                </div>\n        </script>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/pages/pricingtemplate/pricingtemplate.html","<div id=\"pricingtemplate\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-admin-sidenav>\n          <ya-admin-sidenav>\n      </ya-admin-sidenav></ya-admin-sidenav></div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n        <div layout-fill class=\"resp-container\">\n          <iframe class=\"resp-iframe\" ng-src=\"{{vm.getFrameSrc()}}\"></iframe>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/pricingtemplates/pricingtemplates.html","<div id=\"pricingtemplates\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-admin-sidenav>\n          <ya-admin-sidenav>\n      </ya-admin-sidenav></ya-admin-sidenav></div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n        <div layout-fill class=\"resp-container\">\n          <iframe class=\"resp-iframe\" ng-src=\"{{vm.getFrameSrc()}}\"></iframe>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/profile/profile.html","<div id=\"profile\" name=\"header\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"row\" layout-align=\"start\" layout-fill>\n    <div style=\"height: 100%\" layout=\"column\" layout-fill>\n      <ya-main-header></ya-main-header>\n\n\n      <div layout=\"row\" style=\"height:100%\">\n        <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n          <ya-main-sidenav></ya-main-sidenav>\n        </div>\n\n        <div layout=\"column\" layout-fill>\n          <ya-help-menu help-page=\"\"></ya-help-menu>\n\n          <!--content  -->\n          <div layout=\"row\" layout-fill>\n            <div flex class=\"container tabcont\" style=\"padding-left: 35px; padding-top: 10px\">\n              <div class=\"titleBox\" layout=\"row\">\n                <div class=\"title\">\n                  <span ng-if=\"vm.profile && vm.profile.name\">{{vm.profile.name}}</span>\n                  <span ng-if=\"!vm.profile || !vm.profile.name\">Organization’s Profile</span>\n                </div>\n              </div>\n              <div style=\"height: 10px; width: 100%\"></div>\n              <div class=\"titleBox\" layout=\"row\">\n                <div class=\"sub-title\">\n                  Here you may view and update your organizations information, billing information, or profile image.\n                </div>\n              </div>\n              <md-tabs md-dynamic-height>\n\n                <!-- Organization TAB -->\n                <md-tab label=\"Organization Info\">\n\n                  <div layout=\"column\" layout-align=\"left left\">\n                    <div layout=\"row\" layout-align=\"left left\" class=\"whiteBlock\">\n\n                      <div id=\"proforg\" class=\"profFormSize\">\n\n                        <form name=\"setupForm\" ng-submit=\"vm.Update(setupForm)\" layout=\"column\" layout-align=\"center center\">\n\n                          <div class=\"formCont\" layout=\"row\" layout-align=\"center\" style=\"padding-left: 70px\">\n                            <div layout=\"column\">\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/org-building-icon.png\">\n                                <label>Organization Name</label>\n                                <input aria-label=\"Instituation name\" readonly=\"readonly\" name=\"instName\" type=\"text\" required ng-model=\"vm.profile.name\">\n                                <div ng-messages=\"setupForm.instName.$error\" ng-show=\"setupForm.instName.$dirty\">\n                                  <div ng-message=\"required\">Institution name required</div>\n                                </div>\n                              </md-input-container>\n\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/org-building-icon.png\">\n                                <label>Address (line 1)</label>\n                                <input aria-label=\"Address line 1\" name=\"address1\" type=\"text\" required ng-model=\"vm.profile.street\">\n                                <div ng-messages=\"setupForm.address1.$error\" ng-show=\"setupForm.address1.$dirty\">\n                                  <div ng-message=\"required\">Address required</div>\n                                </div>\n                              </md-input-container>\n\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/org-building-icon.png\">\n                                <label>Address (line 2)</label>\n                                <input aria-label=\"Address line 2\" name=\"address2\" type=\"text\" ng-model=\"vm.profile.street2\">\n                              </md-input-container>\n\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/city-icon.png\">\n                                <label>City</label>\n                                <input aria-label=\"City\" name=\"city\" type=\"text\" required ng-model=\"vm.profile.city\">\n                                <div ng-messages=\"setupForm.city.$error\" ng-show=\"setupForm.city.$dirty\">\n                                  <div ng-message=\"required\">City required</div>\n                                </div>\n                              </md-input-container>\n\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/state-icon.png\">\n                                <label>State</label>\n                                <md-select aria-label=\"state\" name=\"state\" ng-model=\"vm.profile.state\" required>\n                                  <md-optgroup label=\"State\">\n                                    <md-option ng-repeat=\"c in vm.states\" ng-value=\"c\">{{c}}</md-option>\n                                  </md-optgroup>\n                                </md-select>\n                                <div ng-messages=\"setupForm.state.$error\">\n                                  <div ng-message=\"required\">State required</div>\n                                </div>\n                              </md-input-container>\n\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/zip-icon.png\">\n                                <label>Zip Code</label>\n                                <input class=\"no-spinbox\" aria-label=\"zip code\" ng-pattern=\"vm.zPattern\" name=\"zip\" type=\"text\" required ng-model=\"vm.profile.zip\">\n                                <div ng-messages=\"setupForm.zip.$error\" ng-show=\"setupForm.zip.$dirty\">\n                                  <div ng-message-exp=\"[\'required\', \'pattern\']\">valid zip code required</div>\n                                </div>\n                              </md-input-container>\n                            </div>\n\n                            <div class=\"formSpace\"></div>\n                            <div layout=\"column\">\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/contact-icon.png\">\n                                <label>Contact First Name</label>\n                                <input aria-label=\"Contact name\" name=\"contactfirstname\" type=\"text\" required ng-model=\"vm.profile.contactfirstname\">\n                                <div ng-messages=\"setupForm.contactfirstname.$error\" ng-show=\"setupForm.contactfirstname.$dirty\">\n                                  <div ng-message=\"required\">Contact first name required</div>\n                                </div>\n                              </md-input-container>\n\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/contact-icon.png\">\n                                <label>Contact Last Name</label>\n                                <input aria-label=\"Contact name\" name=\"contactlastname\" type=\"text\" required ng-model=\"vm.profile.contactlastname\">\n                                <div ng-messages=\"setupForm.contactlastname.$error\" ng-show=\"setupForm.contactlastname.$dirty\">\n                                  <div ng-message=\"required\">Contact last name required</div>\n                                </div>\n                              </md-input-container>\n\n                              <md-input-container class=\"md-block inputScale\">\n                                <img class=\"email\" src=\"assets/images/profile/email-icon.png\">\n                                <label>Email Address</label>\n                                <input aria-label=\"email\" name=\"email\" type=\"email\" required ng-pattern=\"vm.ePattern\" ng-model=\"vm.profile.email\">\n                                <div ng-messages=\"setupForm.email.$error\" ng-show=\"setupForm.email.$dirty\">\n                                  <div ng-message-exp=\"[\'required\', \'pattern\']\">Valid email required</div>\n                                </div>\n                              </md-input-container>\n\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/phone-icon.png\">\n                                <label>Primary Phone</label>\n                                <input class=\"no-spinbox\" aria-label=\"Home phone number\" name=\"phoneHome\" type=\"phone\" ng-pattern=\"vm.phPattern\" ng-model=\"vm.profile.phone\">\n                                <div ng-messages=\"setupForm.phoneHome.$error\" ng-show=\"setupForm.phoneHome.$dirty\">\n                                  <div ng-message=\"pattern\">Invalid number format</div>\n                                </div>\n                              </md-input-container>\n\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/phone-icon.png\">\n                                <label>Mobile Phone</label>\n                                <input class=\"no-spinbox\" aria-label=\"Mobile phone number\" name=\"phoneMobile\" type=\"phone\" ng-pattern=\"vm.phPattern\" ng-model=\"vm.profile.phone2\">\n                                <div ng-messages=\"setupForm.phoneMobile.$error\" ng-show=\"setupForm.phoneMobile.$dirty\">\n                                  <div ng-message=\"pattern\">Invalid number format</div>\n                                </div>\n                              </md-input-container>\n\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/contact-icon.png\">\n                                <label>YOU Sales Rep</label>\n                                <input aria-label=\"YOU sales rep\" readonly=\"readonly\" ng-model=\"vm.profile.salesRep\">\n                              </md-input-container>\n                            </div>\n\n                            <div class=\"formSpace\"></div>\n                            <div layout=\"column\">\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/state-icon.png\">\n                                <label>Industry Type</label>\n                                <input aria-label=\"industry type\" readonly=\"readonly\" ng-model=\"vm.profile.indType\">\n                              </md-input-container>\n\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/org-building-icon.png\">\n                                <label>Category</label>\n                                <md-select aria-label=\"category\" name=\"category\" ng-model=\"vm.profile.busCat\" required>\n                                  <md-optgroup label=\"category\">\n                                    <md-option ng-repeat=\"c in vm.categories\" ng-value=\"c.id\">{{c.name}}</md-option>\n                                  </md-optgroup>\n                                </md-select>\n                              </md-input-container>\n\n                              <!--md-input-container class=\"md-block inputScale\">\n                                  <label>#Locations</label>\n                                  <input aria-label=\"locations\" ng-model=\"vm.profile.location\"></input>\n                              </md-input-container>\n\n                              <md-input-container class=\"md-block inputScale\">\n                                  <label>#Authorized Providers</label>\n                                  <input aria-label=\"authorized providers\" ng-model=\"vm.profile.authorizedProv\"></input>\n                              </md-input-container>\n\n                              <md-input-container class=\"md-block inputScale\">\n                                  <label>How Did You Hear About YOU?</label>\n                                  <input aria-label=\"how did you hear aout You?\" ng-model=\"vm.profile.how\"></input>\n                              </md-input-container>\n\n                              <md-input-container class=\"md-block inputScale\">\n                                  <label>Code</label>\n                                  <input aria-label=\"code\" readonly ng-model=\"vm.profile.lookupcode\"></input>\n                              </md-input-container-->\n\n                            </div>\n                            <div class=\"formSpace\"></div>\n                          </div>\n                          <div class=\"buttondiv\">\n                            <md-button class=\"upload uploadButton\" type=\"submit\">SAVE CHANGES</md-button>\n                          </div>\n                          <!-- <md-button class=\"btn btn-primary\" type=\"submit\">UPDATE</md-button> -->\n                        </form>\n                      </div>\n                    </div>\n\n                  </div>\n\n                </md-tab>\n\n                <!-- Billing TAB -->\n                <md-tab label=\"Billing Info\">\n\n                  <div layout=\"column\" layout-align=\"left left\">\n                    <div layout=\"row\" layout-align=\"left start\" class=\"whiteBlock\">\n\n                      <form name=\"setupBillingForm\" ng-submit=\"vm.SetUpBilling(setupBillingForm)\" class=\"bicontent\" ng-show=\"vm.billing.loaded==false\" layout=\"column\">\n\n                        <div id=\"proforg\" class=\"profFormSize\" layout=\"row\">\n\n                          <div style=\"padding-left: 70px\" layout=\"column\">\n                            <md-input-container class=\"md-block inputScale\">\n                              <img src=\"assets/images/profile/paymentmethod-icon.png\">\n                              <label>Payment Method</label>\n                              <md-select aria-label=\"payment method\" name=\"payMethod\" required ng-model=\"vm.billing.method\" ng-change=\"vm.Update()\">\n                                <md-option ng-repeat=\"t in vm.billingTypes\" ng-value=\"t\">{{t}}</md-option>\n                              </md-select>\n                              <div ng-messages=\"setupBillingForm.payMethod.$error\" ng-show=\"setupBillingForm.payMethod.$touched\">\n                                <div ng-message=\"required\">Select payment method</div>\n                              </div>\n                            </md-input-container>\n\n                            <md-input-container class=\"md-block inputScale\">\n                              <img src=\"assets/images/profile/contact-icon.png\">\n                              <label>First Name</label>\n                              <input type=\"text\" aria-label=\"first name\" name=\"fName\" required ng-model=\"vm.billing.billtofirstname\">\n                              <div ng-messages=\"setupBillingForm.fName.$error\" ng-show=\"setupBillingForm.fName.$dirty\">\n                                <div ng-message=\"required\">First name required</div>\n                              </div>\n                            </md-input-container>\n\n                            <md-input-container class=\"md-block inputScale\">\n                              <img src=\"assets/images/profile/contact-icon.png\">\n                              <label>Last Name</label>\n                              <input type=\"text\" aria-label=\"last name\" name=\"lName\" required ng-model=\"vm.billing.billtolastname\">\n                              <div ng-messages=\"setupBillingForm.lName.$error\" ng-show=\"setupBillingForm.lName.$dirty\">\n                                <div ng-message=\"required\">Last name required</div>\n                              </div>\n                            </md-input-container>\n\n                            <md-input-container class=\"md-block inputScale\">\n                              <img src=\"assets/images/profile/email-icon.png\">\n                              <label>Email</label>\n                              <input type=\"email\" aria-label=\"email\" name=\"email\" required ng-pattern=\"vm.ePattern\" ng-model=\"vm.billing.email\">\n                              <div ng-messages=\"setupBillingForm.email.$error\" ng-show=\"setupBillingForm.email.$dirty\">\n                                <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid email required</div>\n                              </div>\n                            </md-input-container>\n\n                            <md-input-container class=\"md-block inputScale\">\n                              <img src=\"assets/images/profile/zip-icon.png\">\n                              <label>Address</label>\n                              <input type=\"text\" aria-label=\"address\" name=\"address\" required ng-model=\"vm.billing.address\">\n                              <div ng-messages=\"setupBillingForm.address.$error\" ng-show=\"setupBillingForm.address.$dirty\">\n                                <div ng-message=\"required\">Address required</div>\n                              </div>\n                            </md-input-container>\n\n                            <md-input-container class=\"md-block inputScale\">\n                              <img src=\"assets/images/profile/city-icon.png\">\n                              <label>City</label>\n                              <input type=\"text\" aria-label=\"city\" name=\"city\" required ng-model=\"vm.billing.city\">\n                              <div ng-messages=\"setupBillingForm.city.$error\" ng-show=\"setupBillingForm.city.$dirty\">\n                                <div ng-message=\"required\">City required</div>\n                              </div>\n                            </md-input-container>\n\n                            <md-input-container class=\"md-block inputScale\">\n                              <img src=\"assets/images/profile/zip-icon.png\">\n                              <label>Zip</label>\n                              <input type=\"text\" class=\"no-spinbox\" aria-label=\"zip code\" required name=\"zip\" ng-pattern=\"vm.zPattern\" ng-model=\"vm.billing.zip\">\n                              <div ng-messages=\"setupBillingForm.zip.$error\" ng-show=\"setupBillingForm.zip.$dirty\">\n                                <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid zip code required</div>\n                              </div>\n                            </md-input-container>\n                          </div>\n\n                          <div layout=\"column\">\n                            <div ng-show=\"vm.billing.method==\'Bank Account\'\" layout=\"column\" style=\"padding-left: 70px\">\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/org-building-icon.png\">\n                                <label>Bank Name</label>\n                                <input aria-label=\"bank name\" name=\"bank\" type=\"text\" ng-required=\"vm.billing.method==\'Bank Account\'\" ng-model=\"vm.billing.bankName\">\n                                <div ng-messages=\"setupBillingForm.bank.$error\" ng-show=\"setupBillingForm.bank.$dirty\">\n                                  <div ng-message=\"required\">Bank name required</div>\n                                </div>\n                              </md-input-container>\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/cc-num-icon.png\">\n                                <label>Routing #</label>\n                                <input aria-label=\"routing number\" name=\"routing\" type=\"text\" class=\"no-spinbox\" ng-required=\"vm.billing.method==\'Bank Account\'\" ng-pattern=\"vm.rPattern\" ng-model=\"vm.billing.routingNumber\">\n                                <div ng-messages=\"setupBillingForm.routing.$error\" ng-show=\"setupBillingForm.routing.$dirty\">\n                                  <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid routing number required</div>\n                                </div>\n                              </md-input-container>\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/cc-num-icon.png\">\n                                <label>Account #</label>\n                                <input aria-label=\"account number\" ng-model=\"vm.billing.accountNumber\" name=\"account\" type=\"text\" class=\"no-spinbox\" ng-required=\"vm.billing.method==\'Bank Account\'\" ng-pattern=\"vm.aPattern\" ng-model=\"vm.billing.accountNumber\">\n                                <div ng-messages=\"setupBillingForm.account.$error\" ng-show=\"setupBillingForm.account.$dirty\">\n                                  <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid account number required</div>\n                                </div>\n                              </md-input-container>\n                              <md-input-container class=\"md-block inputScale\">\n                                <img src=\"assets/images/profile/paymentmethod-icon.png\">\n                                <label>Account Type</label>\n                                <md-select aria-label=\"account type\" name=\"accountType\" ng-required=\"vm.billing.method==\'Bank Account\'\" ng-model=\"vm.billing.accountType\">\n                                  <md-option ng-repeat=\"t in vm.bankAccountTypes\" ng-value=\"t\">{{t}}</md-option>\n                                </md-select>\n                                <div ng-messages=\"setupBillingForm.accountType.$error\" ng-show=\"setupBillingForm.accountType.$dirty\">\n                                  <div ng-message=\"required\">Select account type</div>\n                                </div>\n                              </md-input-container>\n                              <div class=\"profButtonSpace\"></div>\n                            </div>\n\n                            <div ng-show=\"vm.billing.method==\'Credit Card\'\" layout=\"column\" style=\"padding-left: 70px\">\n                              <md-input-container class=\"md-block inputScale\" flex>\n                                <img src=\"assets/images/profile/cc-num-icon.png\">\n                                <label>Card Number</label>\n                                <input aria-label=\"card number\" name=\"card\" type=\"text\" class=\"no-spinbox\" ng-required=\"vm.billing.method==\'Credit Card\'\" ng-pattern=\"vm.cPattern\" ng-model=\"vm.billing.cardNumber\">\n                                <div ng-messages=\"setupBillingForm.card.$error\" ng-show=\"setupBillingForm.card.$dirty\">\n                                  <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid card number required</div>\n                                </div>\n                              </md-input-container>\n                              <md-input-container class=\"md-block inputScale\" flex>\n                                <img src=\"assets/images/profile/cvv-icon.png\">\n                                <label>CVC</label>\n                                <input aria-label=\"cvc\" name=\"cvc\" type=\"text\" class=\"no-spinbox\" ng-required=\"vm.billing.method==\'Credit Card\'\" ng-pattern=\"vm.cvcPattern\" ng-model=\"vm.billing.cardCode\">\n                                <div ng-messages=\"setupBillingForm.cvc.$error\" ng-show=\"setupBillingForm.cvc.$dirty\">\n                                  <div ng-message-exp=\"[\'required\',\'pattern\']\">Valid security code required</div>\n                                </div>\n                              </md-input-container>\n                              <md-content>\n                                <h4>Expiration Date</h4>\n                                <md-input-container class=\"md-block\" flex>\n                                  <label>Month</label>\n                                  <md-select class=\"inputStyleFlex\" aria-label=\"expiration month\" required ng-model=\"vm.month\">\n                                    <md-option ng-repeat=\"t in vm.monthList\" ng-value=\"t\">{{t}}</md-option>\n                                  </md-select>\n                                </md-input-container>\n                                <md-input-container class=\"md-block\" flex>\n                                  <label>Year</label>\n                                  <md-select class=\"inputStyleFlex\" aria-label=\"expiration year\" required ng-model=\"vm.year\">\n                                    <md-option ng-repeat=\"t in vm.yearList\" ng-value=\"t\">{{t}}</md-option>\n                                  </md-select>\n                                </md-input-container>\n                                <div ng-messages=\"setupBillingForm.date.$error\">\n                                  <div ng-message=\"required\">You must select a date.</div>\n                                </div>\n                              </md-content>\n                              <div class=\"profButtonSpace\"></div>\n                            </div>\n\n                            <div ng-show=\"vm.billing.method==\'PayPal\'\" layout=\"column\" layout-align=\"start center\" style=\"padding-left: 70px\">\n                              <md-input-container class=\"md-block inputScale\" flex>\n                                <label>Account Number?</label>\n                                <input aria-label=\"paypal account\" ng-model=\"vm.billing.paypalAccount\">\n                              </md-input-container>\n                            </div>\n                            <div class=\"profileSpace\"></div>\n                          </div>\n\n                          <div layout=\"column\" ng-show=\"vm.billing.method==\'Bank Account\'\" style=\"padding-left: 70px\">\n                            <md-button aria-label=\"continue\" class=\"upload uploadButton\" type=\"submit\" flex>SAVE\n                              CHANGES</md-button>\n                          </div>\n\n                          <div layout=\"column\" ng-show=\"vm.billing.method==\'Credit Card\'\" style=\"padding-left: 70px\">\n                            <md-button aria-label=\"continue\" class=\"upload uploadButton\" type=\"submit\" flex>SAVE\n                              CHANGES</md-button>\n                          </div>\n\n                          <!-- <div class=\"buttondiv\" layout=\"column\">\n                              <md-button aria-label=\"continue\" class=\"md-raised contButton\" type=\"submit\" class=\"btn btn-primary\" flex>Update</md-button>\n                          </div> -->\n\n                        </div>\n\n                      </form>\n\n                      <div id=\"proforg\" class=\"profFormSize\" layout=\"row\">\n                        <div layout=\"column\" style=\"padding-left: 70px\">\n                          <div ng-show=\"vm.billing.loaded==true\">\n                            <div class=\"bicontent\" layout=\"column\" layout-align=\"center\" flex>\n                              <div layout=\"column\">\n                                <md-input-container class=\"md-block inputScale\">\n                                  <img src=\"assets/images/profile/contact-icon.png\">\n                                  <label>First Name</label>\n                                  <input aria-label=\"First NAme\" readonly=\"readonly\" name=\"billtofirstname\" type=\"text\" required ng-model=\"vm.billing.billtofirstname\">\n                                  <div ng-messages=\"billing.billtofirstname.$error\" ng-show=\"billing.billtofirstname.$dirty\">\n                                    <div ng-message=\"required\">First name required</div>\n                                  </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block inputScale\">\n                                  <img src=\"assets/images/profile/contact-icon.png\">\n                                  <label>Last Name</label>\n                                  <input aria-label=\"billtolastname\" readonly=\"readonly\" name=\"billtolastname\" type=\"text\" required ng-model=\"vm.billing.billtolastname\">\n                                  <div ng-messages=\"billing.billtolastname.$error\" ng-show=\"billing.billtolastname.$dirty\">\n                                    <div ng-message=\"required\">Last name required</div>\n                                  </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block inputScale\">\n                                  <img src=\"assets/images/profile/email-icon.png\">\n                                  <label>Email</label>\n                                  <input aria-label=\"email\" readonly=\"readonly\" name=\"email\" type=\"text\" required ng-model=\"vm.billing.email\">\n                                  <div ng-messages=\"billing.email.$error\" ng-show=\"billing.email.$dirty\">\n                                    <div ng-message=\"required\">Email required</div>\n                                  </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block inputScale\">\n                                  <img src=\"assets/images/profile/org-building-icon.png\">\n                                  <label>Address</label>\n                                  <input aria-label=\"address\" readonly=\"readonly\" name=\"address\" type=\"text\" required ng-model=\"vm.billing.address\">\n                                  <div ng-messages=\"billing.address.$error\" ng-show=\"billing.address.$dirty\">\n                                    <div ng-message=\"required\">Address required</div>\n                                  </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block inputScale\">\n                                  <img src=\"assets/images/profile/city-icon.png\">\n                                  <label>City</label>\n                                  <input aria-label=\"city\" readonly=\"readonly\" name=\"city\" type=\"text\" required ng-model=\"vm.billing.city\">\n                                  <div ng-messages=\"billing.city.$error\" ng-show=\"billing.city.$dirty\">\n                                    <div ng-message=\"required\">City required</div>\n                                  </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block inputScale\">\n                                  <img src=\"assets/images/profile/zip-icon.png\">\n                                  <label>Zip</label>\n                                  <input aria-label=\"zip\" readonly=\"readonly\" name=\"zip\" type=\"text\" required ng-model=\"vm.billing.zip\">\n                                  <div ng-messages=\"billing.zip.$error\" ng-show=\"billing.zip.$dirty\">\n                                    <div ng-message=\"required\">Zip required</div>\n                                  </div>\n                                </md-input-container>\n                              </div>\n\n                              <div ng-show=\"vm.billing.method==\'Bank Account\'\">\n                                <md-input-container class=\"md-block inputScale\">\n                                  <label>Account Type</label>\n                                  <input aria-label=\"accountType\" readonly=\"readonly\" name=\"accountType\" type=\"text\" required ng-model=\"vm.billing.accountType\">\n                                  <div ng-messages=\"billing.accountType.$error\" ng-show=\"billing.accountType.$dirty\">\n                                    <div ng-message=\"required\">Account type required</div>\n                                  </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block inputScale\">\n                                  <img src=\"assets/images/profile/cc-num-icon.png\">\n                                  <label>Account #</label>\n                                  <input aria-label=\"**********\" readonly=\"readonly\" name=\"**********\" type=\"text\" required ng-model=\"vm.billing.accountNumber\">\n                                </md-input-container>\n                              </div>\n\n                              <div ng-show=\"vm.billing.method==\'Credit Card\'\">\n                                <md-input-container class=\"md-block inputScale\">\n                                  <img src=\"assets/images/profile/cc-num-icon.png\">\n                                  <label>Card #</label>\n                                  <input aria-label=\"card#\" ng-model=\"vm.billing.cardNumber\" readonly=\"readonly\" name=\"card#\" type=\"text\" placeholder=\"xxxx-xxxx-xxxx-xxxx\">\n                                </md-input-container>\n                              </div>\n                              <div layout=\"column\">\n                                <div layout=\"row\">\n                                  <div flex></div>\n                                  <md-button aria-label=\"delete\" class=\"upload uploadButton\" style=\"max-width: 184px\" ng-click=\"vm.ConfirmRemove()\">CLEAR BILLING INFO</md-button>\n                                  <div flex></div>\n                                </div>\n                              </div>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </md-tab>\n\n                <!--Profile Image Tab  -->\n                <md-tab label=\"Profile Image\">\n                  <div layout=\"column\" layout-align=\"left left\" id=\"image\">\n                    <div layout=\"row\" layout-align=\"start start\" class=\"whiteBlock\">\n                      <div class=\"padding\" layout=\"row\" layout-align=\"left left\">\n                        <div layout=\"column\">\n                          <div class=\"\">\n                            <!-- <p class=\"profile-image-text\">Update your:</p> -->\n                            <image id=\"imageone\" height=\"256\" width=\"256\">\n                            <div style=\"width: 100%; height: 25px\"></div>\n                            <div class=\"Image-must-be-512x51\" style=\"font-size: large\">Image must be 512x512 pixels.\n                            </div>\n                            <!-- <div class=\"Image-must-be-512x51\">Image will be cropped in a circular format for mobile users.</div> -->\n                            <div layout=\"row\" layout-align=\"center center\" class=\"fileUpload uploadButton\">\n                              <input aria-label=\"browse\" type=\"file\" class=\"upload\" id=\"profileimage\" onchange=\"angular.element(this).scope().vm.UpdateImage(\'imageone\',this)\" accept=\"image/*\"> Profile Image\n                              \n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                      <div class=\"padding\" layout=\"row\" layout-align=\"left left\">\n                        <div layout=\"column\">\n                          <div class=\"\">\n                            <!-- <p class=\"profile-image-text\">Update your:</p> -->\n                            <image id=\"image1\" height=\"256\" width=\"256\">\n                            <div style=\"width: 100%; height: 25px\"></div>\n                            <div class=\"Image-must-be-512x51\" style=\"font-size: large\">Image must be 243x140 pixels.\n                            </div>\n                            <div layout=\"row\" layout-align=\"center center\" class=\"fileUpload uploadButton\">\n                              <input aria-label=\"browse\" type=\"file\" class=\"upload\" id=\"profileimage1\" onchange=\"angular.element(this).scope().vm.UpdateImage(\'image1\',this)\" accept=\"image/*\">\n                              Upload Logo\n                              \n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                      <div class=\"padding\" layout=\"row\" layout-align=\"left left\">\n                        <div layout=\"column\">\n                          <div class=\"\">\n                            <!-- <p class=\"profile-image-text\">Update your profile image 2:</p> -->\n                            <image id=\"image2\" height=\"256\" width=\"256\">\n                            <div style=\"width: 100%; height: 25px\"></div>\n                            <div class=\"Image-must-be-512x51\" style=\"font-size: large\">Image must be 320x198 pixels.\n                            </div>\n                            <div layout=\"row\" layout-align=\"center center\" class=\"fileUpload uploadButton\">\n                              <input aria-label=\"browse\" type=\"file\" class=\"upload\" id=\"profileimage2\" onchange=\"angular.element(this).scope().vm.UpdateImage(\'image2\',this)\" accept=\"image/*\">\n                              Upload Logo 2 \n                            </div>\n                          </div>\n                        </div>\n                      </div>\n\n                      <div class=\"padding\" layout=\"row\" layout-align=\"left left\">\n                        <div layout=\"column\">\n                          <div class=\"\">\n                            <!-- <p class=\"profile-image-text\">Update Logo 3:</p> -->\n                            <image id=\"image3\" height=\"256\" width=\"256\">\n                            <div style=\"width: 100%; height: 25px\"></div>\n                            <div class=\"Image-must-be-512x51\" style=\"font-size: large\">Image must be 362x163 pixels.\n                            </div>\n                            <div layout=\"row\" layout-align=\"center center\" class=\"fileUpload uploadButton\">\n                              <input aria-label=\"browse\" type=\"file\" class=\"upload\" id=\"profileimage3\" onchange=\"angular.element(this).scope().vm.UpdateImage(\'image3\',this)\" accept=\"image/*\">\n                              Upload Logo 3 \n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                      <div class=\"padding\" layout=\"row\" layout-align=\"left left\">\n                        <div layout=\"column\">\n                          <div class=\"\">\n                            <!-- <p class=\"profile-image-text\">Update Logo 4:</p> -->\n                            <image id=\"image4\" height=\"256\" width=\"256\">\n                            <div style=\"width: 100%; height: 25px\"></div>\n                            <div class=\"Image-must-be-512x51\" style=\"font-size: large\">Image must be 362x228 pixels.\n                            </div>\n                            <!-- <div class=\"Image-must-be-512x51\">Image will be cropped in a circular format for mobile users.</div> -->\n                            <div layout=\"row\" layout-align=\"center center\" class=\"fileUpload uploadButton\">\n                              <input aria-label=\"browse\" type=\"file\" class=\"upload\" id=\"profileimage4\" onchange=\"angular.element(this).scope().vm.UpdateImage(\'image4\',this)\" accept=\"image/*\">\n                              Upload Logo 4 \n                            </div>\n                          </div>\n                        </div>\n                      </div>\n\n                    </div>\n                  </div>\n                </md-tab>\n\n                <md-tab label=\"Permissons\">\n                  <div layout=\"column\" layout-align=\"left left\" id=\"permissions\">\n                    <div layout=\"row\" layout-align=\"left left\" class=\"whiteBlock\">\n\n                      <div id=\"proforg\" class=\"profFormSize\">\n\n                        <form name=\"setupFormAccessControl\" ng-submit=\"vm.Update(setupForm)\" layout=\"column\" layout-align=\"center center\">\n\n                          <div class=\"formCont\" layout=\"row\" layout-align=\"center\" style=\"padding-left: 70px\">\n                            <div layout=\"column\" style=\"padding-left: 10px\">\n                              <div>\n                                <md-checkbox aria-label=\"Enable Access Control Integration\" ng-model=\"vm.profile.enableaccesscontrol\" ng-click=\"\">\n                                  <div>\n                                    Enable Access Control Integration\n                                  </div>\n                                </md-checkbox>\n                              </div>\n                              <div ng-if=\"vm.profile.enableaccesscontrol\">\n                                <md-input-container class=\"md-block inputScale\">\n                                  <!-- <img src=\"assets/images/profile/org-building-icon.png\"> -->\n                                  <label>Access Control Type</label>\n                                  <md-select aria-label=\"Access Control Type\" name=\"accessControlType\" required ng-model=\"vm.profile.accesscontroltype\" ng-change=\"vm.Update()\">\n                                    <md-option ng-repeat=\"t in vm.accessControlTypes\" ng-value=\"t\">{{t}}</md-option>\n                                  </md-select>\n                                </md-input-container>\n                                <div ng-if=\"vm.profile.accesscontroltype === \'Identicard\'\">\n                                  <md-input-container class=\"md-block inputScale\">\n                                    <!-- <img src=\"assets/images/profile/contact-icon.png\"> -->\n                                    <label>Identicard Server URL</label>\n                                    <input type=\"text\" aria-label=\"Identicard Server URL\" name=\"identicardServerUrl\" required ng-model=\"vm.profile.identicardserverurl\">\n                                    <div ng-messages=\"setupFormAccessControl.identicardServerUrl.$error\" ng-show=\"setupFormAccessControl.identicardServerUrl.$dirty\">\n                                      <div ng-message=\"required\">Identicard Server URL Required</div>\n                                    </div>\n                                  </md-input-container>\n                                  <md-input-container class=\"md-block inputScale\">\n                                    <!-- <img src=\"assets/images/profile/contact-icon.png\"> -->\n                                    <label>Identicard Server Secret</label>\n                                    <input type=\"text\" aria-label=\"Identicard Server Secret\" name=\"identicardServerSecret\" required ng-model=\"vm.profile.identicardserversecret\">\n                                    <div ng-messages=\"setupFormAccessControl.identicardServerSecret.$error\" ng-show=\"setupFormAccessControl.identicardServerSecret.$dirty\">\n                                      <div ng-message=\"required\">Identicard Server Secret Required</div>\n                                    </div>\n                                  </md-input-container>\n                                  <div>\n                                    Identicard Buildings\n                                    <div ng-if=\"vm.IdenticardBuildings === false\">\n                                      Invalid Identicard Configuration\n                                    </div>\n                                    <ul ng-if=\"vm.IdenticardBuildings\">\n                                      <li ng-repeat=\"building in vm.IdenticardBuildings\">\n                                        <div>\n                                          {{building.Name}} ({{vm.IdenticardStatus(building.CurrentMode)}})\n                                        </div>\n                                        <div>\n                                          <md-button class=\"identicardButton\" type=\"button\" ng-class=\"{\'active\': building.CurrentMode === 1}\" ng-click=\"vm.IdenticardSetBuilding(building.BuildingId, \'clear\')\">\n                                            Clear\n                                          </md-button>\n                                          <md-button class=\"identicardButton\" type=\"button\" ng-class=\"{\'active\': building.CurrentMode === 2}\" ng-click=\"vm.IdenticardSetBuilding(building.BuildingId, \'lockout\')\">\n                                            Lockout\n                                          </md-button>\n                                          <md-button class=\"identicardButton\" type=\"button\" ng-class=\"{\'active\': building.CurrentMode === 3}\" ng-click=\"vm.IdenticardSetBuilding(building.BuildingId, \'lockdown\')\">\n                                            Lockdown\n                                          </md-button>\n                                        </div>\n                                      </li>\n                                    </ul>\n                                  </div>\n                                </div>\n                              </div>\n                            </div>\n                            <div layout=\"column\" style=\"padding-left: 10px\">\n                              <div>\n                                <md-checkbox aria-label=\"Enable Access Control Integration\" ng-model=\"vm.profile.enableremotemonitoring\" ng-click=\"\">\n                                  <div>\n                                    Enable Remote Monitoring\n                                  </div>\n                                </md-checkbox>\n                              </div>\n                              <div ng-if=\"vm.profile.enableremotemonitoring\">\n                                <md-input-container class=\"md-block inputScale\">\n                                  <!-- <img src=\"assets/images/profile/org-building-icon.png\"> -->\n                                  <label>Remote Monitoring Company</label>\n                                  <input type=\"text\" aria-label=\"Remote Monotoring Type\" name=\"accessControlType\" required ng-model=\"vm.profile.remotemonitoringtype\">\n                                  <!-- <md-select aria-label=\"Remote Monotoring Type\" name=\"accessControlType\" required ng-model=\"vm.profile.remotemonitoringtype\" ng-change=\"vm.Update()\">\n                                    <md-option ng-repeat=\"t in vm.remoteMonitoringTypes\" ng-value=\"t\">{{t}}</md-option>\n                                  </md-select> -->\n                                </md-input-container>\n                                <div ng-if=\"vm.profile.enableremotemonitoring\">\n                                  <md-input-container class=\"md-block inputScale\">\n                                    <!-- <img src=\"assets/images/profile/contact-icon.png\"> -->\n                                    <label>Receiver URL/IP Address</label>\n                                    <input type=\"text\" aria-label=\"Receiver URL/IP Address\" name=\"dmpServerIP\" required ng-model=\"vm.profile.dmpserverip\">\n                                    <div ng-messages=\"setupFormAccessControl.dmpServerIP.$error\" ng-show=\"setupFormAccessControl.dmpServerIP.$dirty\">\n                                      <div ng-message=\"required\">Receiver URL/IP Address</div>\n                                    </div>\n                                  </md-input-container>\n                                  <md-input-container class=\"md-block inputScale\">\n                                    <!-- <img src=\"assets/images/profile/contact-icon.png\"> -->\n                                    <label>Receiver Port</label>\n                                    <input type=\"text\" aria-label=\"Receiver Port\" name=\"dmpServerPort\" required ng-model=\"vm.profile.dmpserverport\">\n                                    <div ng-messages=\"setupFormAccessControl.dmpServerPort.$error\" ng-show=\"setupFormAccessControl.dmpServerPort.$dirty\">\n                                      <div ng-message=\"required\">Receiver Port</div>\n                                    </div>\n                                  </md-input-container>\n                                  <md-input-container class=\"md-block inputScale\">\n                                    <!-- <img src=\"assets/images/profile/contact-icon.png\"> -->\n                                    <label>Monitoring Station Account Number</label>\n                                    <input type=\"text\" aria-label=\"Monitoring Station Account Number\" name=\"dmpAccountNumber\" required ng-model=\"vm.profile.dmpaccountnumber\">\n                                    <div ng-messages=\"setupFormAccessControl.dmpAccountNumber.$error\" ng-show=\"setupFormAccessControl.dmpAccountNumber.$dirty\">\n                                      <div ng-message=\"required\">Monitoring Station Account Number Required</div>\n                                    </div>\n                                  </md-input-container>\n                                </div>\n                              </div>\n                            </div>\n                            <div layout=\"column\" style=\"padding-left: 10px\">\n                              <div>\n                                <md-checkbox aria-label=\"Enable RRMS Integration\" ng-model=\"vm.profile.enablerrms\" ng-click=\"\">\n                                  <div>\n                                    Enable RRMS Integration\n                                  </div>\n                                </md-checkbox>\n                              </div>\n                              <div ng-if=\"vm.profile.enablerrms && vm.profile.rrmssitenum\">\n                                <md-input-container class=\"md-block inputScale\">\n                                  <label>Site Number</label>\n                                  <input type=\"text\" aria-label=\"Address\" name=\"rrmssitenum\" readonly=\"readonly\" ng-model=\"vm.profile.rrmssitenum\">\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputScale\">\n                                  <label>Device Number</label>\n                                  <input type=\"text\" aria-label=\"Address\" name=\"rrmsdevnum\" readonly=\"readonly\" ng-model=\"vm.profile.rrmsdevnum\">\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputScale\">\n                                  <label>Transmitter Code</label>\n                                  <input type=\"text\" aria-label=\"Address\" name=\"rrmstransmittercode\" readonly=\"readonly\" ng-model=\"vm.profile.rrmstransmittercode\">\n                                </md-input-container>\n                              </div>\n                              <div ng-if=\"vm.profile.enablerrms && !vm.profile.rrmssitenum\">\n                                <md-input-container class=\"md-block inputScale\">\n                                  <label>Address</label>\n                                  <input type=\"text\" aria-label=\"Address\" name=\"rrmsaddress\" required ng-model=\"vm.profile.rrmsaddress\">\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputScale\">\n                                  <label>Address 2</label>\n                                  <input type=\"text\" aria-label=\"Address 2\" name=\"rrmsaddress2\" ng-model=\"vm.profile.rrmsaddress2\">\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputScale\">\n                                  <label>City</label>\n                                  <input type=\"text\" aria-label=\"City\" name=\"rrmscity\" required ng-model=\"vm.profile.rrmscity\">\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputScale\">\n                                  <label>State</label>\n                                  <md-select aria-label=\"State\" name=\"rrmsstate\" ng-model=\"vm.profile.rrmsstate\" required>\n                                    <md-optgroup label=\"State\">\n                                      <md-option ng-repeat=\"c in vm.states\" ng-value=\"c\">{{c}}</md-option>\n                                    </md-optgroup>\n                                  </md-select>\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputScale\">\n                                  <label>Zip Code</label>\n                                  <input type=\"text\" aria-label=\"Zip Code\" name=\"rrmszipcode\" required ng-model=\"vm.profile.rrmszipcode\">\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputScale\">\n                                  <label>Premise Phone</label>\n                                  <input type=\"text\" aria-label=\"Premise Phone\" name=\"rrmspremisesphone\" required ng-model=\"vm.profile.rrmspremisesphone\">\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputScale\">\n                                  <label>Contact First Name</label>\n                                  <input type=\"text\" aria-label=\"Contact First Name\" name=\"rrmscontact1firstname\" required ng-model=\"vm.profile.rrmscontact1firstname\">\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputScale\">\n                                  <label>Contact Last Name</label>\n                                  <input type=\"text\" aria-label=\"Contact Last Name\" name=\"rrmscontact1lastname\" required ng-model=\"vm.profile.rrmscontact1lastname\">\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputScale\">\n                                  <label>Contact Phone</label>\n                                  <input type=\"text\" aria-label=\"Contact Phone\" name=\"rrmscontact1phone\" required ng-model=\"vm.profile.rrmscontact1phone\">\n                                </md-input-container>\n                                <md-input-container class=\"md-block inputScale\">\n                                  <label>Code Word</label>\n                                  <input type=\"text\" aria-label=\"Code Word\" name=\"rrmscodeword\" required ng-model=\"vm.profile.rrmscodeword\">\n                                </md-input-container>\n                              </div>\n                            </div>\n                            <div layout=\"column\" style=\"padding-left: 10px\">\n                              <div>\n                                <md-checkbox aria-label=\"Enable Quick Response\" ng-model=\"vm.profile.enablequickresponse\" ng-click=\"\">\n                                  <div>\n                                    Enable Quick Response\n                                  </div>\n                                </md-checkbox>\n                              </div>\n                            </div>\n                            <div layout=\"column\" style=\"padding-left: 10px\">\n                              <div>\n                                <md-checkbox aria-label=\"Enable Bright Pattern\" ng-model=\"vm.profile.enablebrightpattern\" ng-click=\"\">\n                                  <div>\n                                    Enable Bright Pattern\n                                  </div>\n                                </md-checkbox>\n                              </div>\n                            </div>\n                          </div>\n                          <div class=\"buttondiv\">\n                            <md-button class=\"upload uploadButton\" type=\"submit\" style=\"width: 112px; margin-right: 10px\">SAVE</md-button>\n                          </div>\n                        </form>\n                      </div>\n\n                    </div>\n                  </div>\n                </md-tab>\n\n              </md-tabs>\n            </div>\n\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </div></div>");
$templateCache.put("app/pages/ratefee/ratefee.html","<div id=\"ratefee\" layout=\"row\" layout-fill>\n    \n	<div class=\"page\" layout=\"row\">        \n        \n		<div class=\"leftContent\">\n            <img class=\"tenpx\" src=\"assets\\images\\onboarding-logo.png\">\n			<form name=\"rateFee\" ng-submit=\"vm.Continue(rateFee.$valid)\" layout=\"column\" layout-align=\"center center\" flex=\"100\">\n                <div class=\"title\" layout=\"column\" layout-align=\"center center\">RATE PLAN & FEES</div>\n				<div flex=\"5\"></div>\n                <div flex=\"40\" layout=\"column\" layout-align=\" left\">\n                    <div layout=\"row\" class=\"num-users-input\">\n                        <div class=\"intSetup\" layout=\"column\">\n                            <p class=\"bold\">${{vm.industry.setupFee}}</p>\n                            <hr class=\"custom-hr\">\n                            <div class=\"border\"></div>\n                            <p>Initial Setup Fee</p>\n                        </div>\n                        <div class=\"numOf\">\n                            <md-input-container>\n                                <label>Number of {{vm.industry.user}}</label>\n                                <input name=\"users\" aria-label=\"number of users\" type=\"number\" ng-model=\"vm.numberOfUsers\" required min=\"1\" ng-change=\"vm.Update()\"> \n                            </md-input-container>\n                        </div>\n                    </div>\n                </div>\n                <md-content class=\"scrollable\" layout=\"row\">                    \n                    <div class=\"cont\">\n                        <div ng-show=\"vm.PlanSelected()\" style=\"color: rgb(221,44,0)\">\n                            Select One Plan\n                        </div>\n                        <div ng-repeat=\"x in vm.industry.plans\">\n                            <h3>\n                                <md-checkbox aria-label=\"select this plan\" class=\"checkBox\" ng-checked=\"x.selected\" ng-click=\"vm.ClickPlan(x)\">{{x.title}}</md-checkbox>\n                                <div class=\"indent smalltext\" ng-repeat=\"y in x.text\">\n                                    {{y}}\n                                </div>\n                            </h3>\n                        </div>                      \n                    </div>\n                    <div class=\"cont\" layout=\"column\" layout-align=\"end start\">\n\n                        <div class=\"border\"></div>\n                        <div ng-repeat=\"x in vm.industry.options\">\n                            <h3>\n                                <md-checkbox aria-label=\"select this industry\" ng-checked=\"x.selected\" ng-click=\"vm.ClickOption(x)\">{{x.title}}</md-checkbox>\n                            </h3>\n                            <div class=\"indent\" ng-repeat=\"y in x.text\">\n                                <p>{{y}}</p>\n                            </div>\n                        </div>\n                        <div ng-repeat=\"x in vm.industry.info\" flex=\"100\">\n                            <h3>{{x.title}}</h3>\n                            <div class=\"indent\" ng-repeat=\"y in x.text\">\n                                <p>{{y}}</p>\n                            </div>\n                        </div>\n                    </div>\n                </md-content>\n                <div>\n                    <p class=\"price-sum\">\n                        </p><h4 class=\"bold\">Initial Base Price ${{vm.totalCost}}</h4>\n                        <span class=\"italic\">(sum of data above)</span>\n                    <p></p>\n                    <md-input-container>\n                        <md-checkbox aria-label=\"agree to terms\" ng-model=\"vm.termsAgree\" name=\"license\" required ng-change=\"vm.Update()\">I agree to the terms & conditions of YOU Get it First. Please read <a href=\"#/license\">license agreement</a>. Thank you.</md-checkbox>\n                        <div ng-hide=\"vm.termsAgree\">\n                          <div style=\"color: rgb(221,44,0)\">\n                            Agreement Required\n                          </div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"space-around center\" layout-margin>\n                    <md-button aria-label=\"back\" ng-click=\"vm.Back()\" class=\"md-raised backButton\">BACK</md-button>\n                    <md-button aria-label=\"continue\" id=\"test\" type=\"submit\" class=\"md-raised contButton\">CONTINUE</md-button>                    \n                </div>\n            </form>\n		</div>\n        <div class=\"tutorial\" layout=\"column\" layout-align=\"center center\">\n        <div flex=\"75\"></div>\n        <div>\n            <div class=\"tutText\">\n                Please select your industry type. This helps us provide you with appropriate options.\n            </div>\n            <div class=\"tenpx\"></div>\n            <div class=\"tutText\">\n                Please select your Primary App Listing Category. This will help us identify what category your organization is indexed in. \n            </div>\n        </div>\n    </div>\n	</div>\n</div>");
$templateCache.put("app/pages/reporting/reporting.html","<div id=\"reporting\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header page=\"Reporting\"></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div class=\"title\">\n            View Your Reports\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div class=\"sub-title\">\n            Your reports are organized by various types. Click on a tab to view the corresponding report.\n          </div>\n\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <ya-help-tips name=\"user\" data=\"vm.helpTipList\"></ya-help-tips>\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <div flex style=\"width:100%; padding-bottom:40px\">\n            <md-tabs md-dynamic-height md-border-bottom md-selected=\"vm.currentNavItem\">\n                <md-tab md-on-select=\"vm.onTabSelected(\'organization\')\" label=\"Organization Report\">\n                    <div layout=\"column\" layout-align=\"center center\">\n                        <div layout=\"column\" layout-align=\"start start\" class=\"whiteBlock\">\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Total followers</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.followers}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Followers in the last day</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.followerslast1day}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Followers in the last 7 days</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.followerslast7days}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Followers in the last 30 days</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.followerslast30days}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Expense in the last day</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.expenselast1day}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Expense in the last 7 days</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.expenselast7days}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Expense in the last 30 days</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.expenselast30days}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Un-Followers in the last day</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.unfollowedlast1day}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Un-Followers in the last 7 days</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.unfollowedlast7days}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Un-Followers in the last 30 days</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.unfollowedlast30days}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                        </div>\n                    </div>\n                </md-tab>\n                <md-tab md-on-select=\"vm.onTabSelected(\'alert\')\" label=\"Alert Report\">\n                    <div layout=\"column\" layout-align=\"center center\">\n                        <div layout=\"column\" layout-align=\"start start\" class=\"whiteBlock\">\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Alerts sent in the last day</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.sentlast1day}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Alerts sent in the last 7 days</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.sentlast7days}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Alerts sent in the last 30 days</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.sentlast30days}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                        </div>\n                    </div>\n                </md-tab>\n                <md-tab md-on-select=\"vm.onTabSelected(\'announcement\')\" label=\"Announcement Report\">\n                    <div layout=\"column\" layout-align=\"center center\">\n                        <div layout=\"column\" layout-align=\"start start\" class=\"whiteBlock\">\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Announcements sent in the last day</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.sentlast1day}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Announcements sent in the last 7 days</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.sentlast7days}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Announcements sent in the last 30 days</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.sentlast30days}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                        </div>\n                    </div>\n                </md-tab>\n                <md-tab md-on-select=\"vm.onTabSelected(\'advertisement\')\" label=\"Advertisement Report\">\n                    <div layout=\"column\" layout-align=\"center center\">\n                        <div layout=\"column\" layout-align=\"start start\" class=\"whiteBlock\">\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Advertisements sent in the last day</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.sentlast1day}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Advertisements sent in the last 7 days</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.sentlast7days}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Advertisements sent in the last 30 days</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.sentlast30days}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                        </div>\n                    </div>\n                </md-tab>\n                <md-tab md-on-select=\"vm.onTabSelected(\'appointment\')\" label=\"Appointment Report\">\n                    <div layout=\"column\" layout-align=\"center center\">\n                        <div layout=\"column\" layout-align=\"start start\" class=\"whiteBlock\">\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Appointments sent in the last day</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.sentlast1day}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Appointments sent in the last 7 days</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.sentlast7days}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div>Appointments sent in the last 30 days</div>\n                                <div flex></div>\n                                <div class=\"numberSize\">{{vm.report.sentlast30days}}</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                        </div>\n                    </div>\n                </md-tab>\n                <md-tab md-on-select=\"vm.onTabSelected(\'followers\')\" label=\"Followers\">\n                    <div layout=\"column\" layout-align=\"center center\">\n                        <div layout=\"column\" layout-align=\"start start\" class=\"whiteBlock\">\n                            <div class=\"followers-header\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"5\"></div>\n                                <div style=\"font-weight: 600\" class=\"followers-firstname\">First Name</div>\n                                <div flex></div>\n                                <div style=\"font-weight: 600\" class=\"followers-lastname\">Last Name</div>\n                                <div flex></div>\n                                <div style=\"font-weight: 600\" class=\"followers-email\">Email</div>\n                                <div flex></div>\n                                <div style=\"color:black; font-weight: 600\" class=\"followers-category-menu\">Followed Categories</div>\n                                <div flex=\"5\"></div>\n                            </div>\n                            <div class=\"catStyle\" layout=\"row\" layout-align=\"center center\" ng-repeat=\"x in vm.report\">\n                                <div flex=\"5\"></div>\n                                <div class=\"followers-firstname\">{{x.firstname}}</div>\n                                <div flex></div>\n                                <div class=\"followers-lastname\">{{x.lastname}}</div>\n                                <div flex></div>\n                                <div class=\"followers-email\">{{x.email}}</div>\n                                <div flex></div>\n                                <div class=\"followers-category-menu\">\n                                    <md-menu ng-click=\"$mdMenu.open()\">\n                                        <div class=\"md-icon-button\" aria-label=\"Open some menu\">\n                                            Show Following Categories\n                                            <img style=\"margin-left: 5px; width: 11px; height: 9px\" src=\"assets\\images\\icons\\carrot-down.png\">\n                                        </div>\n                                        <md-menu-content ng-mouseleave=\"$mdMenu.close()\">\n                                            <!--popup style-->\n                                            <!--FIX THIS-->\n                                            <md-menu-item layout=\"column\" style=\"border: 5px solid white;margin:0; padding:0;height: 100%; min-height:150px;min-width: 256px\">\n                                                <div layout=\"column\" layout-align=\"center\" style=\"\" ng-repeat=\"y in x.categories\">\n                                                    <div layout=\"row\" layout-align=\"center\" style=\"min-height:30px;height:100px\" ng-show=\"x.categories[$index]\">\n                                                        <md-checkbox ng-model=\"y.following\" ng-disabled=\"true\" aria-label=\"catrgory\"></md-checkbox>\n                                                        {{y.name}}\n                                                    </div>\n                                                </div>\n\n                                            </md-menu-item>\n                                        </md-menu-content>\n                                    </md-menu>\n                                </div>\n                                <div flex=\"5\"></div>\n                            </div>\n                        </div>\n                    </div>\n                </md-tab>\n            </md-tabs>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/request/request.html","<div id=\"existingBlur\">\n	<div id=\"existing\" layout=\"row\">\n		<div class=\"leftContent\">\n			<img class=\"tenpx\" src=\"assets\\images\\onboarding-logo.png\">\n			<div ng-show=\"vm.state==\'Question\'\" layout=\"column\" layout-align=\"center center\" flex=\"100\">\n				<div class=\"title\">\n					ARE YOU AN EXISTING MEMBER?\n				</div>\n				<div class=\"buttonPadding\"></div>\n				<div ng-click=\"vm.Existing()\" type=\"submit\" class=\"yesButton button\" layout=\"row\" layout-align=\"center center\" ng-click=\"\">\n					<div class=\"buttonText\">\n						YES, I am an Existing Member\n					</div>\n				</div>\n\n				<div class=\"buttonPadding\"></div>\n				<div ng-click=\"vm.NewUser()\" class=\"noButton button\" layout=\"row\" layout-align=\"center center\" ng-click=\"\">\n					<div class=\"buttonText\">\n						NO, I am a New User\n					</div>\n				</div>\n				<div class=\"oopsSpace\"></div>\n				<div onclick=\"location.href=\'#home\'\" class=\"playVid buttOver button\" layout=\"row\" layout-align=\"center center\">\n					<div class=\"buttonText\">\n						Oops, Take me Back!\n					</div>\n				</div>\n			</div>\n			<div ng-show=\"vm.state==\'Login\'\" layout=\"column\" layout-align=\"center center\" flex=\"100\">\n				<div class=\"title\">\n					ARE YOU AN EXISTING MEMBER?\n				</div>\n				<div class=\"oopsSpace\"></div>\n				<form name=\"loginForm\" layout=\"column\" ng-submit=\"vm.Login(loginForm.$valid)\" class=\"forms\" flex=\"noshrink\" layout-align=\"center center\">\n					\n					<div class=\"login\" layout=\"column\" flex layout-align=\"center center\">				\n						<md-input-container class=\"md-block login\">\n							<label class=\"formtext\">Email</label>\n							<input aria-label=\"email\" name=\"username\" ng-model=\"vm.login.username\" required>\n							<div ng-messages=\"loginForm.username.$error\" ng-show=\"loginForm.username.$dirty\" md-auto-hide=\"false\">\n								<div ng-message=\"required\">Username Required</div>\n							</div>\n						</md-input-container>\n\n						<div class=\"fiftypx\"></div>\n						\n						<md-input-container class=\"md-block login\">\n							<label class=\"formtext\">Password</label>\n							<input aria-label=\"password\" name=\"password\" type=\"password\" required ng-model=\"vm.login.password\">\n							<div ng-messages=\"loginForm.password.$error\" ng-show=\"loginForm.password.$dirty\" md-auto-hide=\"false\">\n								<div ng-message=\"required\">Password Required</div>\n							</div>\n						</md-input-container>				\n					</div>\n					<div class=\"oopsSpace\"></div>\n					<div layout=\"column\" layout-align=\"center center\">\n						<md-button aria-label=\"validation email\" ng-click=\"vm.Resend()\" class=\"md-raised contButton\">Resend Validation Email</md-button>\n						<md-button aria-label=\"cancel\" ng-click=\"vm.Cancel()\" class=\"md-raised cancButton\">Cancel</md-button>\n						<md-button aria-label=\"continue\" type=\"submit\" ng-disabled=\"!loginForm.$valid\" class=\"md-raised contButton\">Continue</md-button>		\n					</div>\n					<div class=\"tenpx\"></div>\n				</form>\n			</div>\n\n\n			<div ng-show=\"vm.state==\'Register\'\" flex=\"noshrink\" layout=\"column\" layout-align=\"center center\">\n				<div class=\"title\">\n					ARE YOU AN EXISTING MEMBER?\n				</div>\n				<div class=\"fiftypx\"></div>\n				<form name=\"userForm\" ng-submit=\"vm.Register(userForm.$valid)\" class=\"forms\" flex=\"noshrink\" layout-align=\"space-between center\">\n					<div layout=\"row\">\n						<div class=\"login\" layout=\"column\" flex=\"100\" layout=\"column\" layout-align=\"center center\">\n							<md-input-container class=\"login\">\n								<label>Email</label>\n								<input aria-label=\"email\" name=\"email\" ng-model=\"vm.user.email\" required ng-pattern=\"vm.ePattern\" type=\"text\">\n								<div ng-messages=\"userForm.email.$error\" ng-show=\"userForm.email.$dirty\">\n									<div ng-message-exp=\"[\'required\',\'pattern\']\">Valid email required</div>\n								</div>\n							</md-input-container>\n\n							<div class=\"tenpx\"></div>\n\n							<md-input-container class=\"login\">\n								<label>User Name</label>\n								<input aria-label=\"username\" name=\"username\" ng-model=\"vm.user.username\" required ng-pattern=\"/\\S/\" minlength=\"5\" md-maxlength=\"32\">\n								<div ng-messages=\"userForm.username.$error\" ng-show=\"userForm.username.$dirty\" md-auto-hide=\"false\">\n									<div ng-message=\"required\">Username Required</div>\n									<div ng-message=\"pattern\">Spaces not allowed</div>\n									<div ng-message=\"minlength\">Username too short</div>\n									<div ng-message=\"md-maxlength\">Username too long</div>\n								</div>\n							</md-input-container>\n\n							<div class=\"tenpx\"></div>\n\n							<md-input-container class=\"login\">\n								<label>Password</label>\n								<input id=\"pass1\" aria-label=\"password\" ng-ya-password-clear=\"pass2\" name=\"password\" type=\"password\" ng-model=\"vm.user.password\" required ng-pattern=\"/\\S/\" minlength=\"6\" md-maxlength=\"64\">\n								<div ng-messages=\"userForm.password.$error\" ng-show=\"userForm.password.$dirty\" md-auto-hide=\"false\">\n									<div ng-message=\"required\">Password Required</div>\n									<div ng-message=\"pattern\">Spaces not allowed</div>\n									<div ng-message=\"minlength\">Password too short</div>\n									<div ng-message=\"md-maxlength\">Password too long</div>\n								</div>\n							</md-input-container>\n\n							<md-input-container class=\"login\">\n								<label>Confirm Password</label>\n								<input id=\"pass2\" aria-label=\"password confirm\" ng-ya-password-match=\"pass1\" name=\"password2\" type=\"password\" ng-model=\"vm.user.confirm\" required>\n								<div ng-messages=\"userForm.password2.$error\" ng-show=\"userForm.password2.$dirty\" md-auto-hide=\"false\">\n									<div ng-message=\"ngYaPasswordMatch\">Passwords do not match</div>\n									<div ng-message=\"required\">Password confirmation required</div> \n								</div>\n							</md-input-container>\n						</div>\n						<div class=\"login\" flex=\"100\">\n							<!-- <div class=\"fivepx\"></div> -->\n							<mdp-date-picker aria-label=\"birthday\" mdp-placeholder=\"Birthday\" name=\"bday\" required ng-model=\"myDate\" flex=\"100\"></mdp-date-picker>\n							<!--md-datepicker aria-label=\"birthday\" ng-model=\"myDate\" name=\"bday\" md-placeholder=\"Birthday\" required flex=\"100\"></md-datepicker-->\n							<div ng-messages=\"userForm.bday.$error\" ng-show=\"userForm.bday.$touched\">\n								<div ng-message=\"required\">Date of birth required</div>\n							</div>\n						</div>\n					</div>\n					<div class=\"fiftypx\"></div>\n					<div layout=\"row\">               \n						<md-button ng-click=\"vm.Cancel()\" class=\"md-raised cancButton\">Cancel</md-button>\n						<md-button type=\"submit\" ng-disabled=\"!userForm.$valid\" class=\"md-raised contButton\">Continue</md-button>					\n					</div>\n					<div class=\"tenpx\"></div>\n				</form>\n			</div>\n\n			<div ng-show=\"vm.state==\'Request\'\" flex=\"noshrink\" layout=\"column\" layout-align=\"center center\">\n				<div class=\"title\" layout=\"column\" layout-align=\"center center\">REQUEST LOGIN FOR THE EXISTING ORGANIZATION</div>			\n				<div class=\"formCont\" layout=\"row\" layout-align=\"center\">					\n					<div layout=\"column\">						\n						<form name=\"requestForm\" ng-submit=\"vm.Send(requestForm.$valid)\" layout-align=\"center center\" flex=\"50\" layout-align=\"center center\">						\n							<md-input-container class=\"md-block inputScale\">\n								<label class=\"textColor\">Organization ID</label>\n								<input aria-label=\"organization ID\" name=\"id\" ng-model=\"vm.id\" type=\"text\" required>\n								<div ng-messages=\"requestForm.id.$error\" ng-show=\"requestForm.id.$dirty\" md-auto-hide=\"false\">\n									<div ng-message=\"required\">Organization ID required</div>\n								</div>\n							</md-input-container>		\n\n							<div class=\"buttFlex\" layout=\"row\" layout-align=\"center center\">\n								<md-button class=\"md-raised backButton\" ng-click=\"vm.Cancel()\">Cancel</md-button>		\n								<md-button class=\"md-raised contButton\" type=\"submit\" ng-disabled=\"!requestForm.$valid\" class=\"md-raised\">Send Now</md-button>	\n							</div>										\n						</form>\n					</div>\n				</div>\n			</div>		\n		</div>	\n		<div class=\"tutorial\" layout=\"column\" layout-align=\"center center\">\n			<div flex=\"65\"></div>\n			<div>\n				<div class=\"hideText\">\n					If you are an existing member, please sign in.\n				</div>\n				<div class=\"tenpx\"></div>\n				<div class=\"hideText\">\n					If you are a new member, please sign up for an account to proceed. \n				</div>\n			</div>\n		</div>\n	</div>\n</div>");
$templateCache.put("app/pages/responseforms/responseforms.html","<div id=\"respondents\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div class=\"title\">\n            Add Update Covid Respondents:\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div layout=\"row\">\n            <div class=\"sub-title\" flex=\"60\">\n              Add new respondents or update existing respondents.\n            </div>\n          </div>\n\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <div class=\"buttonRow\" layout=\"row\">\n            <div flex=\"noshrink\">\n              <label class=\"userButton buttonColor0\" layout=\"row\" style=\"padding-left:15px\" layout-align=\"center center\" ng-click=\"vm.onBack()\">\n                BACK\n              </label>\n            </div>\n\n            <div flex=\"noshrink\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <label class=\"userButton buttonColor1 disabled\" layout=\"row\" layout-align=\"start center\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n                ADD MANUALLY (FUTURE)\n              </label>\n            </div>\n\n            <div flex=\"noshrink\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <input type=\"file\" id=\"file-upload1\" ng-show=\"false\" name=\"{{$index}}\" accept=\".csv\" onchange=\"angular.element(this).scope().vm.CSVFile(this)\">\n              <label layout=\"row\" layout-align=\"start center\" for=\"file-upload1\" ng-click=\"vm.UploadUsers(\'file-upload1\')\" class=\"userButton buttonColor1\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n                IMPORT CSV\n              </label>\n            </div>\n\n            <div flex=\"noshrink\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <a style=\"text-decoration: none\" ng-click=\"vm.ExportCSV()\">\n                <label class=\"userButton buttonColor1\" layout=\"row\" layout-align=\"start center\">\n                  <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-download.png\">\n                  EXPORT CSV\n                </label>\n              </a>\n            </div>\n\n            <div flex=\"grow\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <a style=\"text-decoration: none\" href=\"https://yougetitfirstfiles.s3-us-west-2.amazonaws.com/LoadCovidDataTemplate.csv\">\n                <label class=\"userButton buttonColor2\" layout=\"row\" layout-align=\"start center\">\n                  <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-download.png\">\n                  DOWNLOAD CSV TEMPLATE\n                </label>\n              </a>\n            </div>\n          </div>\n\n          <ya-help-tips name=\"user\" data=\"vm.helpTipList\"></ya-help-tips>\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <div flex style=\"width:100%\">\n            <md-list class=\"setWidth\" id=\"style-3\">\n\n              <!-- Table Heading start here -->\n              <md-list-item class=\"listItem listHover\" style=\"font-weight: 600; color: #585858; margin-bottom: 5px\">\n                <div style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\"></div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">FIRST NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">LAST NAME</div>\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">TITLE</div> -->\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">PHONE NUMBER</div> -->\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">EMAIL</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">REPORTING</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">REPORTS</div>\n                  <div flex=\"noshrink\" style=\"width: 100px\"></div>\n                </div>\n              </md-list-item>\n              <!-- Table Heading end here -->\n\n              <!--Table Rows start here  -->\n              <md-list-item class=\"listHover\" style=\"font-weight: 500; color: #585858\" ng-repeat=\"x in vm.respondents track by $index\">\n                <div ng-show=\"!x.edit\" style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\">\n                    <img ng-show=\"x.profileimage\" ng-src=\"{{x.profileimage}}\" id=\"display{{$index}}\" class=\"md-avatar\">\n                    <img ng-show=\"!x.profileimage\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n                  </div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.firstname}}</span></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.lastname}}</span></div>\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.title}}</span></div> -->\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x}}</span></div> -->\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.email}}</span></div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <ul class=\"people\">\n                      <li ng-repeat=\"y in x.reporters track by $index\">\n                        <span class=\"ellipsis\">\n                          <span ng-if=\"y.firstname || y.lastname\">{{y.firstname}} {{y.lastname}} ({{y.useremail}})</span>\n                          <span ng-if=\"!(y.firstname || y.lastname)\">{{y.useremail}}</span>\n                        </span>\n                      </li>\n                    </ul>\n                  </div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">\n                    <ul class=\"people\">\n                      <li ng-repeat=\"y in x.reportees track by $index\">\n                        <span class=\"ellipsis\">\n                          <span ng-if=\"y.firstname || y.lastname\">{{y.firstname}} {{y.lastname}} ({{y.useremail}})</span>\n                          <span ng-if=\"!(y.firstname || y.lastname)\">{{y.useremail}}</span>\n                        </span>\n                      </li>\n                    </ul>\n                  </div>\n\n                  <div flex=\"noshrink\" layout=\"row\" layout-align=\"end center\" style=\"width: 100px\">\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" aria-label=\"remove\" ng-click=\"vm.RemoveRespondent(x)\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor: pointer\">\n                      <img src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div>\n                </div>\n\n                <!--EDIT popup  -->\n                <div class=\"shadow\" ng-show=\"x.edit\" layout=\"row\">\n                  <div layout=\"column\" style=\"width: 12%; background-color: lightgrey\">\n\n\n                    <div layout=\"column\" layout-align=\"start center\" style=\"width: 100%; padding-top: 50px; text-align:center\">\n                        <input class=\"ng-hide\" aria-label=\"profile image\" type=\"file\" ng-model=\"vm.users[$index].imageFile\" id=\"profileImage{{$index}}\" onchange=\"angular.element(this).scope().vm.UpdateImage(angular.element(this).scope().$index,this)\" accept=\".jpg\">\n                        <label style=\"color: #0064d8; font-size: 15px; cursor: pointer\" for=\"profileImage{{$index}}\">Select New Photo</label>\n                    </div>\n\n                    <div layout=\"column\" layout-align=\"start center\" style=\"width: 100%; height: 20px\">\n                      <div style=\"color: #0064d8; font-size: 15px; cursor: pointer\" ng-show=\"x.imageFile!=null\" ng-click=\"vm.Upload($index)\">\n                        UPLOAD\n                      </div>\n                    </div>\n                    <div style=\"width: 100%; height: 150px\" layout=\"column\" layout-align=\"start center\">\n                      <img ng-show=\"x.profileimage\" ng-src=\"{{x.profileimage}}\" id=\"display2{{$index}}\" class=\"md-avatar\">\n                      <img ng-show=\"!x.profileimage\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n                    </div>\n                  </div>\n\n\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" style=\"width: 30%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>First Name</label>\n                        <input class=\"inputStyle\" aria-label=\"firstname\" type=\"text\" value=\"{{x.firstname}}\" ng-model=\"x.firstname\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Last Name</label>\n                        <input class=\"inputStyle\" aria-label=\"lastname\" type=\"text\" value=\"{{x.lastname}}\" ng-model=\"x.lastname\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Workflow Admin</label>\n                        <md-select ng-model=\"x.workflowadminName\">\n                          <md-option ng-repeat=\"adminName in vm.workFlowAdminNames track by $index\" ng-attr-value=\"{{adminName}}\">{{adminName}}</md-option>\n                        </md-select>\n                      </md-input-container>\n                    </div>\n\n                  </div>\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" style=\"width: 30%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Title</label>\n                        <input class=\"inputStyle\" aria-label=\"title\" type=\"text\" value=\"{{x.title}}\" ng-model=\"x.title\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactEmail.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Email</label>\n                        <input class=\"inputStyle\" aria-label=\"email\" type=\"text\" readonly=\"readonly\" onclick=\"if(value==\'abc@abc.com\'){value=\'\'}\" value=\"{{x.email}}\" ng-model=\"x.email\" ng-pattern=\"vm.ePattern\">\n                        <div ng-messages=\"{\'pattern\': !x.email}\">\n                          <div ng-message=\"pattern\">invalid email</div>\n                        </div>\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Mobile Phone Number</label>\n                        <input class=\"inputStyle\" type=\"text\" aria-label=\"phonenumber\" name=\"phonenumber\" value=\"{{x.phonenumber}}\" ng-model=\"x.phonenumber\" ng-change=\"vm.updatePhoneNumber(x)\">\n                      </md-input-container>\n\n                    </div>\n\n                  </div>\n                  <div style=\"width: 6%\"></div>\n                  <div layout=\"column\" style=\"width: 19%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"column\" layout-wrap>\n                      <div style=\"font-size: 15px; font-weight: 600; padding-bottom: 20px\">PERMISSIONS</div>\n                      <!--permission  -->\n                      <div ng-repeat=\"p in vm.permissionList\">\n                        <md-checkbox aria-label=\"permission\" ng-model=\"x.permissions[$index]\" ng-click=\"\" ng-show=\"p !== \'email marketing\' || vm.orgID == 3\">\n                          <div>\n                            {{p}}\n                          </div>\n                        </md-checkbox>\n                      </div>\n                    </div>\n                  </div>\n                  <div style=\"width: 6%\"></div>\n                  <div layout=\"column\" style=\"width: 19%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"column\" layout-wrap>\n                      <div style=\"font-size: 15px; font-weight: 600; padding-bottom: 20px\">DASHBOARD GROUPS</div>\n                      <!--permission  -->\n                      <div ng-repeat=\"dg in vm.dashboardGroups\">\n                        <md-checkbox aria-label=\"permission\" ng-model=\"x.dashboardGroups[dg.id]\" ng-click=\"\">\n                          <div>\n                            {{dg.name}}\n                          </div>\n                        </md-checkbox>\n                      </div>\n                    </div>\n                  </div>\n                  <div style=\"width: 6%\"></div>\n                  <div layout=\"column\" style=\"width: 19%\">\n                    <div>&nbsp;</div>\n\n                    <div layout=\"column\" layout-wrap>\n                      <div style=\"font-size: 15px; font-weight: 600; padding-bottom: 20px\">RECIPIENT GROUPS</div>\n                      <!--permission  -->\n                      <div ng-repeat=\"rg in vm.recipientGroups\">\n                        <md-checkbox aria-label=\"permission\" ng-model=\"x.recipientGroups[rg.id]\" ng-click=\"\">\n                          <div>\n                            {{rg.name}} - {{rg.id}}\n                          </div>\n                        </md-checkbox>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" layout-align=\"start center\" style=\"width: 19%\">\n                    <div>&nbsp;</div>\n                    <div style=\"color: #0f6ad4; height:50px; font-size: 16px; font-weight: 600\" aria-label=\"done\" ng-click=\"vm.CloseEdit(x)\">\n                      <img style=\"margin-right: 18px; margin-top: -5px\" src=\"assets\\images\\icons\\user-check.png\"> Done Editing\n                    </div>\n                  </div>\n                </div>\n                <!--end EDIT popup  -->\n\n              </md-list-item>\n              <!--Table Rows end here  -->\n\n            </md-list>\n          </div>\n\n          <div layout=\"row\" style=\"width: 100%; padding-bottom:10px\">\n            <div flex></div>\n            <div paging page=\"vm.currentPage\" total=\"vm.totalPages\" page-size=\"1\" paging-action=\"vm.onPage()\" show-prev-next=\"true\" showfirst-last=\"true\"></div>\n            <div flex></div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/responsegroup/responsegroup.html","<div id=\"catgroup\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div class=\"title\">\n            Choose Your Organization\'s Response Groups\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div class=\"sub-title\">\n            Response Groups are groups of mobile users that can send messages.\n          </div>\n\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <!--buttons in a row  -->\n          <div class=\"buttonRow\" layout=\"row\">\n\n            <div flex=\"nogrow\">\n              <label class=\"userButton buttonColor1 buttonsize4\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.AddResponseGroup(true)\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n              Add New Response Group\n              </label>\n            </div>\n          </div>\n\n          <ya-help-tips name=\"user\" data=\"vm.helpTipList\"></ya-help-tips>\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <div flex style=\"width:100%\">\n            <md-list>\n\n              <!-- Table Heading start here -->\n              <md-list-item class=\"listItem listHover\" style=\"font-weight: 600; color: #585858; margin-bottom: 5px\">\n                <div style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"groupName\">RESPONSE GROUP NAME</div>\n\n                  <!--push to end  -->\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n                    <!-- intentionally left empty -->\n                  </div>\n\n                </div>\n              </md-list-item>\n\n              <!--Table Rows start here  -->\n              <md-list-item class=\"listHover\" style=\"min-height:75px;  font-weight: 500; color: #585858\" ng-repeat=\"x in vm.grpList\">\n                <div ng-show=\"!x.edit\" style=\"width: 100%\" ng-style=\"{opacity: (x.active ? 1 : 0.4)}\" layout=\"row\" layout-align=\"start center\">\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"groupName\">\n                    {{x.name}}  [{{((x.respondents || []).length || 0) | number:0}}]\n                  </div>\n\n                  <!--push to end  -->\n                  <div layout-fill layout=\"row\" layout-align=\"end center\">\n                    <div flex=\"nogrow\" layout-align=\"start center\" class=\"listbutton\" ng-click=\"vm.AddEditMembers(x)\" style=\"color: #9b9b9b; padding-right:20px; cursor:pointer\">\n                      <img style=\"padding-right: 10px; padding-bottom: 3px\" src=\"assets\\images\\icons\\add-update-recipient.png\">\n                      Add / Update Response Group Info\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b; cursor: pointer\" aria-label=\"edit\" ng-click=\"vm.OpenEdit($index,false)\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"padding-right: 10px\" src=\"assets\\images\\icons\\edit_icon-gray.png\">Edit\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" ng-if=\"!x.orgadmin\" aria-label=\"remove\" ng-click=\"vm.RemoveResponseGroup($index)\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor: pointer\">\n                      <img src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div><!--end end-->\n                </div>\n\n                <!-- EDIT  -->\n                <div style=\"max-height: 75px; width: 100%\" ng-show=\"x.edit\" layout=\"row\" layout-align=\"start center\">\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div layout=\"column\" class=\"groupName\">\n                    <div style=\"width: 100%; height: 25px\"></div>\n                    <md-input-container style=\"min-width: 300px; font-size: 15px\">\n                      <label>Response Group Name</label>\n                      <input aria-label=\"response group name\" type=\"text\" value=\"{{x.name}}\" ng-model=\"x.name\">\n                    </md-input-container>\n                  </div>\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n\n                    <div flex=\"nogrow\" class=\"listbutton\" layout=\"row\" layout-align=\"center center\" style=\"cursor: pointer; padding-right: 60px\" ng-click=\"vm.CloseEdit($index)\">\n                      <img style=\"padding-right: 10px; padding-bottom: 3px\" src=\"/assets/images/icons/user-check.png\">\n                      Done Editing\n                    </div>\n                  </div>\n                </div>\n\n              </md-list-item>\n              <!--Table Rows end here  -->\n\n            </md-list>\n          </div>\n\n          <div layout=\"row\" style=\"width: 100%; padding-bottom:10px\">\n            <div flex></div>\n            <div paging page=\"vm.currentPage\" total=\"vm.totalPages\" page-size=\"1\" paging-action=\"vm.onPage()\" show-prev-next=\"true\" showfirst-last=\"true\"></div>\n            <div flex></div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/sales/sales.html","<div id=\"sales\">\n  <div layout-fill class=\"resp-container\">\n    <iframe class=\"resp-iframe\" ng-src=\"{{vm.getFrameSrc()}}\"></iframe>\n  </div>\n</div>\n");
$templateCache.put("app/pages/salesorganizations/salesorganizations.html","<div id=\"salesOrgs\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-admin-sidenav>\n          <ya-admin-sidenav>\n      </ya-admin-sidenav></ya-admin-sidenav></div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div class=\"title\">\n            Sales Organizations\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div class=\"sub-title\">\n            Add and Update Sales Organizations\n          </div>\n\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <!--buttons in a row  -->\n          <div class=\"buttonRow\" layout=\"row\">\n\n            <div flex=\"nogrow\">\n              <label class=\"userButton buttonColor1 buttonsize4\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.AddSalesOrg()\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n              Add New Sales Org\n              </label>\n            </div>\n          </div>\n\n          <ya-help-tips name=\"group\" data=\"vm.helpTipList\"></ya-help-tips>\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <div flex style=\"width:100%\">\n            <md-list>\n\n              <!-- Table Heading start here -->\n              <md-list-item class=\"listItem listHover\" style=\"min-height:75px; font-weight: 600; color: #585858; margin-bottom: 5px\">\n                <div style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n                  <div flex=\"nogrow\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"center center\">ENABLE</div>\n                  <div flex=\"nogrow\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"groupName\">SALES ORG NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"industry\">INDUSTRY TYPE</div>\n                  <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" class=\"name-section\">SALES ORG REFERRAL #</div>\n                  <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" class=\"name-section\">TOTAL SALES PEOPLE</div>\n                  <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" class=\"name-section\">TOTAL YTD SALES FOR SALES ORG</div>\n\n                  <!--push to end  -->\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" style=\"visibility:hidden\">\n                    <div flex=\"nogrow\" layout-align=\"start center\" class=\"listbutton\" style=\"padding-right:10px\">\n                      <img style=\"padding-right: 10px; padding-bottom: 3px\" src=\"assets\\images\\icons\\add-update-recipient.png\">Update\n                      Sales Group Info\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b\" aria-label=\"edit\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"\" src=\"assets\\images\\icons\\edit_icon-gray.png\">\n                      <span>Edit</span>\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"\" src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div>\n\n                </div>\n              </md-list-item>\n\n              <!--Table Rows start here  -->\n              <md-list-item class=\"listHover\" style=\"min-height: 75px; font-weight: 500; color: #585858\" ng-repeat=\"x in vm.salesOrgs\">\n                <div ng-show=\"!x.edit\" style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"center center\">\n                    <md-checkbox style=\"margin-bottom: -0px\" aria-label=\"enabled\" ng-change=\"vm.Disable(x)\" ng-model=\"x.enabled\"></md-checkbox>\n                  </div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"groupName\">\n                    <span class=\"ellipsis\">{{x.name}}</span>\n                  </div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"industry\">\n                    <span class=\"ellipsis\">{{vm.industryTypes[$index]}}</span>\n                  </div>\n\n                  <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.referralcode}}</span>\n                  </div>\n\n                  <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{vm.totalSalesPeople[$index].count}}</span>\n                  </div>\n\n                  <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{vm.salesTotals[$index].total | currency}}</span>\n                  </div>\n\n                  <!--push to end  -->\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\" style=\"padding-right:10px\">\n                      <div layout-align=\"start center\" class=\"listbutton\" ng-click=\"vm.updateSalesOrg(x)\" style=\"color: #9b9b9b; cursor:pointer\">\n                        <img style=\"padding-right:10px; padding-bottom: 3px\" src=\"assets\\images\\icons\\add-update-recipient.png\">Update\n                        Sales Group Info\n                      </div>\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b; cursor:pointer\" aria-label=\"edit\" ng-click=\"vm.OpenEdit($index,false)\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"padding-right: 10px\" src=\"assets\\images\\icons\\edit_icon-gray.png\">Edit\n                    </div>\n\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" ng-if=\"!x.orgadmin\" aria-label=\"remove\" ng-click=\"vm.deleteSalesOrg(x.id)\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                      <img src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n\n\n                  </div>\n\n                </div>\n                <!-- end x.edit div -->\n\n                <!--modal-->\n                <div style=\"max-height: 75px; width: 100%\" ng-show=\"x.edit\" layout=\"row\" layout-align=\"start center\">\n                  <div style=\"height: 100%; width: 10%\"></div>\n                  <!-- leave here for popup to attach to -->\n                  <div>\n                    <div style=\"height: 100%; width: 50px; min-width: 40px\"></div>\n                    <md-input-container style=\"min-width: 200px; font-size: 15px; margin-bottom:0px\">\n                      <label>Sales Organization Name</label>\n                      <input aria-label=\"name\" type=\"text\" value=\"{{x.name}}\" ng-model=\"x.name\">\n                    </md-input-container>\n                  </div>\n\n                  <div style=\"height: 100%; width: 50px; min-width: 40px\"></div>\n                  <div>\n                    <div style=\"height: 100%; width: 50px; min-width: 40px\"></div>\n                    <md-input-container style=\"min-width: 200px; font-size: 15px; margin-bottom:0px\">\n                      <label>Referral Code</label>\n                      <input aria-label=\"referralcode\" readonly=\"readonly\" type=\"text\" value=\"{{x.referralcode}}\" ng-model=\"x.referralcode\">\n                    </md-input-container>\n                  </div>\n                  <div style=\"height: 100%; width: 50px; min-width: 40px\"></div>\n\n                  <div>\n                    <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                    <md-input-container style=\"min-width: 200px\">\n                      <label>Industry Type</label>\n                      <md-select ng-model=\"vm.indName\" ng-click=\"vm.getTypes()\">\n                        <md-option ng-repeat=\"t in vm.types\" ng-value=\"t\">{{t}}</md-option>\n                      </md-select>\n                    </md-input-container>\n                  </div>\n                  <div style=\"height: 100%; width: 50px; min-width: 40px\"></div>\n                  <div class=\"listbutton\" ng-click=\"vm.CloseEdit($index,false)\">\n                    <img style=\"padding-right: 10px; padding-bottom: 3px\" src=\"/assets/images/icons/user-check.png\"> Done\n                    Editing\n                  </div>\n                </div>\n                <!-- end modal-->\n              </md-list-item>\n              <!--table rows end here  -->\n\n            </md-list>\n          </div>\n\n          <div layout=\"row\" style=\"width: 100%; padding-bottom:10px\">\n            <div flex></div>\n            <div paging page=\"vm.currentPage\" total=\"vm.totalPages\" page-size=\"1\" paging-action=\"vm.onPage()\" show-prev-next=\"true\" showfirst-last=\"true\"></div>\n            <div flex></div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/select/select.html","<div id=\"home\">\n  <div layout-fill class=\"resp-container\">\n    <iframe class=\"resp-iframe\" ng-src=\"{{vm.getFrameSrc()}}\"></iframe>\n  </div>\n</div>\n");
$templateCache.put("app/pages/setup/setup.html","<div id=\"setup\">\n    <div class=\"page\" layout=\"row\">\n                        \n        <div class=\"leftContent\">\n            \n            <img class=\"tenpx\" src=\"assets\\images\\onboarding-logo.png\">\n            \n            <div layout=\"column\" layout-align=\"center center\">\n                \n                <div class=\"title\" layout=\"column\" layout-align=\"center center\">ORGANIZATION PROFILE INFO</div>\n                \n                <form form name=\"setupForm\" ng-submit=\"vm.SetUp(setupForm.$valid)\" layout=\"column\" flex=\"50\" layout-align=\"center center\">\n                    \n                    <div class=\"formCont\" layout=\"row\" layout-align=\"center\">\n                        \n                        <div layout=\"column\">\n                            \n<!--\n                            <md-input-container class=\"md-block inputScale\">\n                                <label>Institution Name</label>\n                                <input required ng-model=\"vm.profile.name\"></input>\n                            </md-input-container>\n-->\n                            <md-input-container class=\"md-block inputScale\">\n                                <label>Institution Name</label>\n                                <input aria-label=\"Instituation name\" name=\"instName\" type=\"text\" required ng-model=\"vm.profile.name\">\n                                <div ng-messages=\"setupForm.instName.$error\" ng-show=\"setupForm.instName.$dirty\">\n                                    <div ng-message=\"required\">Institution name required</div>\n                                </div>\n                            </md-input-container>\n                        \n                            <md-input-container class=\"md-block inputScale\">\n                                <label>Address (line 1)</label>\n                                <input aria-label=\"Address line 1\" name=\"address1\" type=\"text\" required ng-model=\"vm.profile.street\">\n                                <div ng-messages=\"setupForm.address1.$error\" ng-show=\"setupForm.address1.$dirty\">\n                                    <div ng-message=\"required\">Address required</div>\n                                </div>\n                            </md-input-container>\n                    \n                            <md-input-container class=\"md-block inputScale\">\n                                <label>Address (line 2)</label>\n                            <input aria-label=\"Address line 2\" name=\"address2\" type=\"text\" ng-model=\"vm.profile.street2\">\n                        </md-input-container>\n                \n                            <md-container class=\"citystate\" layout=\"row\" layout-align=\"center\">\n                                <md-input-container class=\"md-block city\">\n                                    <label>City</label>\n                                    <input aria-label=\"City\" name=\"city\" type=\"text\" required ng-model=\"vm.profile.city\">\n                                    <div ng-messages=\"setupForm.city.$error\" ng-show=\"setupForm.city.$dirty\">\n                                        <div ng-message=\"required\">City required</div>\n                                    </div>\n                                </md-input-container>\n                                <md-input-container class=\"md-block bottomborder\">\n                                    <label>State</label>\n                                    <md-select aria-label=\"state\" name=\"state\" ng-model=\"vm.profile.state\" required>\n                                        <md-optgroup label=\"State\">\n                                            <md-option ng-repeat=\"c in vm.states\">{{c}}</md-option>\n                                        </md-optgroup>\n                                    </md-select>\n                                    <div ng-messages=\"setupForm.state.$error\">\n                                        <div ng-message=\"required\">State required</div>\n                                    </div>                            \n                                </md-input-container>\n                            </md-container> \n            \n                            <md-input-container class=\"md-block inputScale\">\n                                <label>Zip Code</label>\n                                <input class=\"no-spinbox\" aria-label=\"zip code\" ng-pattern=\"vm.zPattern\" name=\"zip\" type=\"text\" required ng-model=\"vm.profile.zip\">\n                                <div ng-messages=\"setupForm.zip.$error\" ng-show=\"setupForm.zip.$dirty\">\n                                    <div ng-message-exp=\"[\'required\', \'pattern\']\">valid zip code required</div>\n                                </div>\n                            </md-input-container>\n        \n                            <md-input-container class=\"md-block inputScale\">\n                                <label>Contact Name</label>\n                                <input aria-label=\"Contact name\" name=\"contactName\" type=\"text\" required ng-model=\"vm.profile.contactname\">\n                                <div ng-messages=\"setupForm.contactName.$error\" ng-show=\"setupForm.contactName.$dirty\">\n                                    <div ng-message=\"required\">Contact name required</div>\n                                </div>\n                            </md-input-container>\n    \n                            <md-input-container class=\"md-block inputScale\">\n                                <label>Email Address</label>\n                                <input aria-label=\"email\" name=\"email\" type=\"email\" required ng-pattern=\"vm.ePattern\" ng-model=\"vm.profile.email\">\n                                <div ng-messages=\"setupForm.email.$error\" ng-show=\"setupForm.email.$dirty\">\n                                    <div ng-message-exp=\"[\'required\', \'pattern\']\">Valid email required</div>\n                                </div>\n                            </md-input-container>\n\n                            <md-input-container class=\"md-block inputScale\">\n                                <label>Phone(Home)</label>\n                                <input class=\"no-spinbox\" aria-label=\"Home phone number\" name=\"phoneHome\" type=\"phone\" ng-pattern=\"vm.phPattern\" ng-model=\"vm.profile.phone\">\n                                <div ng-messages=\"setupForm.phoneHome.$error\" ng-show=\"setupForm.phoneHome.$dirty\">\n                                    <div ng-message=\"pattern\">Invalid number format</div>\n                                </div>\n                            </md-input-container>\n\n                            <md-input-container class=\"md-block inputScale\">\n                                <label>Phone(Mobile)</label>\n                                <input class=\"no-spinbox\" aria-label=\"Mobile phone number\" name=\"phoneMobile\" type=\"phone\" ng-pattern=\"vm.phPattern\" ng-model=\"vm.profile.phone2\">\n                                <div ng-messages=\"setupForm.phoneMobile.$error\" ng-show=\"setupForm.phoneMobile.$dirty\">\n                                    <div ng-message=\"pattern\">Invalid number format</div>  \n                                </div>\n                            </md-input-container>\n\n                        </div>\n                        <div class=\"tenpx\"></div>\n                        <div layout=\"column\">\n                            \n                            <md-input-container class=\"md-block inputScale\">\n                                <label>YOU Sales Rep</label>\n                                <input aria-label=\"YOU sales rep\" readonly=\"readonly\" ng-model=\"vm.profile.salesRep\">\n                            </md-input-container>\n\n                            <md-input-container class=\"md-block inputScale\">\n                                <label>Industry Type</label>\n                                <input aria-label=\"industry type\" readonly=\"readonly\" ng-model=\"vm.profile.indType\">\n                            </md-input-container>\n\n                            <md-input-container class=\"md-block inputScale\">\n                                <label>Business Category</label>\n                                <input aria-label=\"bussiness category\" readonly=\"readonly\" ng-model=\"vm.profile.busCat\">\n                            </md-input-container>\n\n                            <md-input-container class=\"md-block inputScale\">\n                                <label>#Locations</label>\n                                <input aria-label=\"locations\" ng-model=\"vm.profile.location\">\n                            </md-input-container>\n\n                            <md-input-container class=\"md-block inputScale\">\n                                <label>#Authorized Providers</label>\n                                <input aria-label=\"authorized providers\" ng-model=\"vm.profile.authorizedProv\">\n                            </md-input-container>\n\n                            <md-input-container class=\"md-block inputScale\">\n                                <label>How Did You Hear About YOU?</label>\n                                <input aria-label=\"how did you hear about YOU?\" ng-model=\"vm.profile.how\">\n                            </md-input-container>\n\n                        </div>\n                    </div>\n                    <div class=\"buttFlex\"></div>\n                    <div class=\"buttondiv\" layout=\"row\" layout-align=\"center center\">\n                        <md-button aria-label=\"back\" class=\"md-raised backButton\" onclick=\"location.href=\'#signuporg\'\" flex>Back</md-button>\n                        <md-button aria-label=\"continue\" class=\"md-raised contButton btn btn-primary\" type=\"submit\" flex>Continue</md-button>\n                    </div>\n                </form>\n                \n            </div>\n            \n        </div>\n        <div class=\"tutorial\"></div>\n    </div>\n</div>");
$templateCache.put("app/pages/signuporg/signuporg.html","<div id=\"signuporg\" layout=\"row\">\n\n    <div class=\"leftContent\">\n\n        <img class=\"tenpx\" src=\"assets\\images\\onboarding-logo.png\">\n\n        <div layout=\"column\" layout-align=\"center center\" flex=\"100\">\n            <div class=\"title\" layout=\"column\" layout-align=\"center center\">SIGN UP</div>\n            <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                <md-input-container flex>\n                    <md-select aria-label=\"industry type\" ng-model=\"vm.currentType\" md-selected-text=\"vm.getCurrentIndustryType()\" ng-change=\"vm.Update()\">\n                        <md-optgroup>\n                            <md-option ng-repeat=\"t in vm.types\">{{t}}</md-option>\n                        </md-optgroup>\n                    </md-select>\n                </md-input-container>\n            </div>\n            <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                <md-input-container flex>\n                    <md-select aria-label=\"category\" ng-model=\"vm.currentCat\" md-selected-text=\"vm.getCurrentCatagories()\" ng-change=\"vm.UpdateCat()\">\n                        <md-optgroup>\n                            <md-option ng-repeat=\"c in vm.categories\">{{c.name}}</md-option>\n                        </md-optgroup>\n                    </md-select>\n                </md-input-container>\n            </div>\n            <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n                <md-input-container class=\"md-block\" flex-gt-sm>\n                    <label>(OPTIONAL) Enter in Referral Code</label>\n                    <input aria-label=\"enter referral code\" ng-model=\"vm.code\" ng-change=\"vm.Update()\">\n                </md-input-container>\n            </div>\n            <div class=\"buttonSpacing\"></div>\n                <div class=\"buttondiv\" layout=\"row\" layout-align=\"center center\">\n                    <md-button aria-label=\"back\" class=\"md-raised backButton\" ng-click=\"vm.Back()\" flex>Back</md-button>\n                    <md-button aria-label=\"continue\" class=\"md-raised contButton\" ng-click=\"vm.Continue()\" ng-disabled=\"!vm.ready\" flex>Continue</md-button>\n                </div>\n            </div>\n    </div>\n\n\n    <div class=\"tutorial\" layout=\"column\" layout-align=\"center center\">\n        <div flex=\"75\"></div>\n        <div>\n            <div class=\"tutText\">\n                Please select your industry type. This helps us provide you with appropriate options.\n            </div>\n            <div class=\"tenpx\"></div>\n            <div class=\"tutText\">\n                Please select your Primary App Listing Category. This will help us identify what category your organization is indexed in.\n            </div>\n        </div>\n    </div>\n\n</div>\n");
$templateCache.put("app/pages/support/support.html","<ya-help-menu help-page=\"\"></ya-help-menu>\n<div style=\"height: 100%\" id=\"support\" layout=\"row\">\n\n  <div class=\"page\" layout=\"row\" layout-align=\"start\" flex>\n    <div id=\"wrapper\" layout=\"column\" flex>\n      <ya-main-header page=\"Support\"></ya-main-header>\n      <div style=\"height: 100%\" layout=\"row\">\n        <div style=\"height: 100%; background-color: #f89921\">\n          <ya-main-sidenav></ya-main-sidenav>\n        </div>\n\n        <div class=\"container\" style=\"padding-left: 43px; padding-right: 43px; background-color: #eaeaea\">\n          <div class=\"titleBox\" layout=\"row\">\n            <div class=\"title\">\n              Support\n            </div>\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div class=\"titleBox\" layout=\"row\">\n            <div class=\"sub-title\">\n              Click on a support category in the FAQ to view related topics\n            </div>\n          </div>\n          <ya-help-tips name=\"user\" data=\"vm.helpTipList\"></ya-help-tips>\n          <div class=\"accordion\">\n            <form>\n              <dl>\n                <ul id=\"list\">\n                  <div layout=\"row\" style=\"height: 50px; border-bottom: 1px solid lightgray\">\n                    <div flex></div>\n                    <div style=\"height: 10%\"></div>\n                    <input style=\"width: 100%; margin-bottom: 15px; box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12); border: solid 1px #9b9b9b\" type=\"text\" id=\"search-text\" placeholder=\"What do you need help with?\" class=\"search-box\">\n                    <button class=\"clearButton\" onclick=\"pageLoad()\" style=\"position: absolute; right: 0;padding-top: 7px\">\n                      <img src=\"/assets/images/search-icon.png\" style=\"width: 14px; position: absolute; right: 120%; padding-top: 2px\">\n                      <div class=\"search-line\"></div>\n                      <div class=\"X\">X</div>\n                    </button>\n                    <div style=\"height: 10%\"></div>\n                  </div>\n                  <li class=\"first-orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Tutorial Videos\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Add Profile Logo\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <div style=\"padding: 1em 2em 1em 2em\">\n                        <div>\n                          YOU Get it First - Add Profile Logo\n                        </div>\n                        <div><a style=\"color: #0a4f78\">https://www.youtube.com/watch?v=Bq5v9DG5uUs</a></div>\n                        <div><br><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/Bq5v9DG5uUs\" frameborder=\"0\"></iframe></div>\n                      </div>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Upload Dashboard Users\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <div style=\"padding: 1em 2em 1em 2em\">\n                        <div>\n                          YOU Get it First - Upload Dashboard Users\n                        </div>\n                        <div><a style=\"color: #0a4f78\">https://www.youtube.com/watch?v=UxvMrlpcpg0</a></div>\n                        <div><br><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/UxvMrlpcpg0\" frameborder=\"0\"></iframe></div>\n                      </div>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Upload Recipient Groups\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <div style=\"padding: 1em 2em 1em 2em\">\n                        <div>\n                          YOU Get it First - Upload Recipient Groups\n                        </div>\n                        <div><a style=\"color: #0a4f78\">https://www.youtube.com/watch?v=k7Dza3PK1E0</a></div>\n                        <div><br><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/k7Dza3PK1E0\" frameborder=\"0\"></iframe></div>\n                      </div>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Upload Logo Image or Graphic Background\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <div style=\"padding: 1em 2em 1em 2em\">\n                        <div>\n                          YOU Get it First - Upload Logo Image or Graphic Background\n                        </div>\n                        <div><a style=\"color: #0a4f78\">https://www.youtube.com/watch?v=Bib3Svyzei0</a></div>\n                        <div><br><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/Bib3Svyzei0\" frameborder=\"0\"></iframe></div>\n                      </div>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Add a Custom Button to a Graphic Background\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <div style=\"padding: 1em 2em 1em 2em\">\n                        <div>\n                          YOU Get it First - Editor: Add a Custom Button to a Graphic Background\n                        </div>\n                        <div><a style=\"color: #0a4f78\">https://www.youtube.com/watch?v=g0SGIkw8INw</a></div>\n                        <div><br><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/g0SGIkw8INw\" frameborder=\"0\"></iframe></div>\n                      </div>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Add a Call-Link Button\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <div style=\"padding: 1em 2em 1em 2em\">\n                        <div>\n                          YOU Get it First - Editor: Add a Call-Link Button\n                        </div>\n                        <div><a style=\"color: #0a4f78\">https://www.youtube.com/watch?v=7cOlmzc8BOM</a></div>\n                        <div><br><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/7cOlmzc8BOM\" frameborder=\"0\"></iframe></div>\n                      </div>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Add a Web-Linked Button\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <div style=\"padding: 1em 2em 1em 2em\">\n                        <div>\n                          YOU Get it First - Editor: Add a Web-Linked Button\n                        </div>\n                        <div><a style=\"color: #0a4f78\">https://www.youtube.com/watch?v=pIHI-k32F8M</a></div>\n                        <div><br><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/pIHI-k32F8M\" frameborder=\"0\"></iframe></div>\n                      </div>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How to Create an Alert\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <div style=\"padding: 1em 2em 1em 2em\">\n                        <div>\n                          YOU Get it First - How to Create an Alert Tutorial\n                        </div>\n                        <div><a style=\"color: #0a4f78\">https://www.youtube.com/watch?v=9WNz4-rbYKQ</a></div>\n                        <div><br><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/9WNz4-rbYKQ\" frameborder=\"0\"></iframe></div>\n                      </div>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How to Create an Announcement\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <div style=\"padding: 1em 2em 1em 2em\">\n                        <div>\n                          YOU Get it First - How to Create an Announcement Tutorial\n                        </div>\n                        <div><a style=\"color: #0a4f78\">https://www.youtube.com/watch?v=-ZHkASvNC8Q</a></div>\n                        <div><br><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/-ZHkASvNC8Q\" frameborder=\"0\"></iframe></div>\n                      </div>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How to Send a Message\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <div style=\"padding: 1em 2em 1em 2em\">\n                        <div>\n                          YOU Get it First - How to How to Send a Message\n                        </div>\n                        <div><a style=\"color: #0a4f78\">https://www.youtube.com/watch?v=B0oPAbRJv1o</a></div>\n                        <div><br><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/B0oPAbRJv1o\" frameborder=\"0\"></iframe></div>\n                      </div>\n                    </dd>\n                  </li>\n\n                  </dd>\n                  </li>\n                  <li class=\"first-orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Dashboard\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I create a message?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        From the left menu, select Alert, Advertising or Announcement.  In the Create box, select NEW (Alert, Advertisement, Announcement). Your templates will appear.  Select your template and click DONE. Your template will be in the Editor.  Add in your edits and functions.\n\n                      </p>\n                      <div style=\"padding: 1em 2em 1em 2em\">\n                        <a style=\"color: #0a4f78\">https://www.youtube.com/watch?v=B0oPAbRJv1o</a>\n                        <br><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/B0oPAbRJv1o\" frameborder=\"0\"></iframe>\n                      </div>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How can I tell a message was sent?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        On your dashboard, you will see “Sent” on your message.\n\n                      </p>\n                    </dd>\n                  </li>\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        What does “Ready” mean on an Alert template?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        “Ready” means the Alert is ready to send from the Dashboard and on the smart phone users that have the “Send Alerts” user preference.\n\n                      </p>\n                    </dd>\n                  </li>\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Can I move templates between Alerts, Announcement and Ads?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        No, you will need to create YOU messages in each area.\n\n                      </p>\n                    </dd>\n                  </li>\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        If I delete a template or one that is sent, can I retrieve it?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        No, the template will have to be re-created or uploaded.\n\n                      </p>\n                    </dd>\n                  </li>\n                  </dd>\n                  </li>\n\n\n                  <li class=\"first-blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Alerts\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        What happens if I Save an Alert message that I created?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        For Alerts, Click Save, the template will be tagged as “Ready”.  This message will be ready to send from your dashboard and the Alert message will be “Ready to Send from the smart phone when your User has that user preference.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I send an Alert?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        From the left menu, click Alerts.  From the “Ready” tagged message, click your message, click Send.  For a new Alert, click “New Alert” in the Create box. Select Template Alert, click done.  Edit your alert, Select “Who is going to get this,” click Save (for Save as Ready) or click Calculate to choose geographic radius, click SEND to send immediately.\n\n                      </p>\n                      <div style=\"padding: 1em 2em 1em 2em\">\n                        <a style=\"color: #0a4f78\">https://www.youtube.com/watch?v=9WNz4-rbYKQ</a>\n                        <br><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/9WNz4-rbYKQ\" frameborder=\"0\"></iframe>\n                      </div>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I send an Alert from a mobile device?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        Log into mobile device.  Click YOU Get it First icon.  Log into the YOU mobile app. From the main screen click Alert.  Select Threat Alert message; click select.  Type inform message in dialog box:  click SEND.\n                        <br>\n                        If you are already logged in, click the 3-bar menu.  Click Send Alert, Select Threat Alert message; click select.  Type inform message in dialog box:  click SEND.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  </dd>\n                  </li>\n\n                  <li class=\"first-orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Announcements\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        What happens if I Save an Ad or Announcement that I created?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        If you click Save for Ads and Announcements, the template will be saved as “Template,” in your dashboard.  From that Saved template, click on the message to Edit the template, choose “Who is going to get this”, Schedule, Calculate and Send.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I send an Announcement?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n\n                      <div>\n                        <p>\n                          From the left menu, click Announcement. Click New Advertisement in the Create box. Select Ad Template, click Done. Add Edits, select Who is going to get this, click schedule, choose schedule criteria, click calculate, choose geographic radius, click send.\n                        </p>\n                      </div>\n                      <div style=\"padding: 1em 2em 1em 2em\">\n                        <a style=\"color: #0a4f78\">www.youtube.com/watch?v=-ZHkASvNC8Q</a>\n                        <br><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/-ZHkASvNC8Q\" frameborder=\"0\"></iframe>\n                      </div>\n                    </dd>\n                  </li>\n\n\n                  </dd>\n                  </li>\n\n                  <li class=\"first-blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Ads\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I send an Ad?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        From the left menu, click Advertising. Click New Advertisement in the Create box. Select Ad Template, click Done. Add Edits, select Who is going to get this, click schedule, choose schedule criteria, click calculate, choose geographic radius, click send.\n\n                      </p>\n                    </dd>\n                  </li>\n                  </dd>\n                  </li>\n\n                  <li class=\"first-orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Appointments\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I create an Appointment Book?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        I don’t have the screens to do this. Leave 340 characters.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I send an Appointment?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        I don’t have the screens to do this. Leave 340 characters.\n\n                      </p>\n                    </dd>\n                  </li>\n\n\n                  </dd>\n                  </li>\n\n                  <li class=\"first-blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Categories/Groups\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        What is a Category?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n                        Categories (PUBLIC - Appear on YOU mobile phone app users)\n                        <br>\n                        Dashboard Users create Categories to be listed on all YOU mobile apps in the ecosystem.  Each mobile app user can select an organization and their category to receive specific messages from the designated category.  This allows narrowcasting and targeting. Example;  Theatre, Sports, Food Service or any topic your reader is interested.  Use items on your website navigation bar where you want your readers to be directed to.\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        What is a group?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n                        Dashboard Users create Groups. These “private” Groups are your sending groups; usually within your organization.  You can create as many Groups as your organization requires.  And individual in a Group will receive an email inviting them to download the YOU phone App.  Individuals can be added or deleted from a Group easily in the YOU dashboard.\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I create a Group?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n                        From the left hand menu, click Categories/Groups.  In the Group section (bottom), click the editor pencil on the first group.  Edit the title of the Group and click the check mark. Groups may include: Staff/Employees, VIP Customers, Local Law Enforcement, Students, Faculty, Administration.  Groups are who you chose to send to.  Note: Followers are created by the system.\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I upload individuals or lists to the Group?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n                        On the far right of the Group you created, click upload.  Select the CSV file you created to upload the group.  Go to Reports to view your uploaded Group.\n                        <br>\n                        To create a Group for your dashboard users, click Users on the far right. On the right box, click the ‘X’ to view and select your dashboard users. Click the individual’s name to add them to your group.\n                      </p>\n                    </dd>\n                  </li>\n\n                  </dd>\n                  </li>\n\n                  <li class=\"first-orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Dashboard Users\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I set up a person to approve a message before it is sent?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        From the left hand menu, click USERS. Click the pencil editor for a user. On the far right, “Work Flow Admin”, click the dialog box and select a dashboard user.  This will make the person selected under “Work Flow Admin” have their messages approved by the User you originally chose to edit.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I change the user preference for an Individual on my staff?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        From the left menu bar, click on Users. Locate your User, click the pencil editor to open permissions.  Click each preference you desire.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I invite someone to become a user in my organization?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        After you have entered or uploaded your users, and Invite button will appear. Click the Invite button.  An email will be sent to them to be joined.  Once the individual has accepted, the invite button will disappear.\n\n                      </p>\n                      <div style=\"padding: 1em 2em 1em 2em\">\n                        <a style=\"color: #0a4f78\">https://www.youtube.com/watch?v=UxvMrlpcpg0</a>\n                        <br><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/UxvMrlpcpg0\" frameborder=\"0\"></iframe>\n                      </div>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How can you tell an invited user has joined?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        The Invite button will disappear in the User menu.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Is my staff notified that they have been added as a user?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        Yes, after you have executed the Invite button in the User menu.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        If I delete a Dashboard User, do I have to re-enter that user?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        Yes and you will need to Invite them again.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  </dd>\n                  </li>\n\n                  <li class=\"first-blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Editor\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I edit a template?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n                        Name the template on the top bar.\n                        <br><br>\n                        After creating a template, from Basics choose a background color. Click Text to choose the font, on the template type new text. From Shapes select and add your shapes. Choose Sticker; use the opacity slider for faint or bold images and text.\n                        <br><br>\n                        To upload a template or an image click Open and select the template or image.\n                        <br><br>\n                        Click Update to view the mobile phone message image.\n                        <br><br>\n                        Click Save to save the template in the Dashboard.\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I add a phone number or website to a button on I created and uploaded?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n                        Click “Button” to create a Button that will appear on your message in the editor. Drag Button over your button to create function, cover your button, you can also cover your description.  Add your phone number or website.  Choose button color; make the button transparent. Update, Save and Send.\n                      </p>\n                    </dd>\n                  </li>\n\n                  </dd>\n                  </li>\n\n                  <li class=\"first-orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Scheduler\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        What happens if I Schedule a message that I created?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n                        Click Schedule, choose the date, time to be sent and the message expiration date, then click Schedule Item.  You can click Save or Calculate. Click Save to place your message in your dashboard tagged as Ready.  Click Calculate, you will be able to choose the geographic radius for your phone users. Click Send to send your message.\n                      </p>\n                    </dd>\n                  </li>\n\n\n                  </dd>\n                  </li>\n\n                  <li class=\"first-blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Profile\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Where do I find my billing info?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        From the left hand menu, click profile, and then click billing info on the top menu.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I upload my profile image?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        From the Profile menu, click Profile image.  Click Browse and select your profile image.  The image has to be 512x512 or smaller.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Where do I find my Organization info?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        The organization info is located under the Profile tab.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How do I change my Organization Name?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        Send an email  to info@yougetitfirst.com  and we will provide you the information to change the name.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  </dd>\n                  </li>\n\n                  <li class=\"first-orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Calculate\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n\n                  <li class=\"second orange\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Can I send to a geographic area?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>Yes, from the Calculate screen, you can choose any size radius from a specified location.</p>\n                    </dd>\n                  </li>\n\n                  </dd>\n                  </li>\n\n                  <li class=\"first-blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Reporting\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How can I view my followers?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>You will be able to view your followers and a total count in the Reports menu under Followers.</p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How is my Group notified that they are in it?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        Each individual in the Group will be notified to download the YOU phone app. You can keep track on the individuals in the Group in the Report Menu.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How quickly can I start to send YOU messages to followers?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        If you have an existing list of customers, you can upload them into the system and can begin sending messages the same day. The first message you send to existing customers will be an email inviting them to download the YOU App\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How much does it cost to send a YOU message?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        It starts at $.01 per message per user and reduces with higher volume. The minimum fee is $10.00 for up to 1,000 messages sent.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        What is the difference between Announcements and Advertising?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        Announcements and Advertising are very similar in the YOU system and treated the same. Advertising analytics will be available for a fee of $100 and provide in-depth reports and analytics to help you with your promotional management.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Can I build a following? Can I see my followers?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        Yes, you can build your following. You will receive strategies to build your following in your onboarding kit. You will be able to see your following grow from the YOU web portal.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        If I send a YOU message, what happens if they don’t get it?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        If you send a YOU message to a group and an individual doesn’t receive it for whatever reason, the system will automatically send an email to the intended person(s). If the email is not received, a text will be sent informing you.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        What kind of reports do I get when I send a message?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        There are many opportunities to track and verify your campaign’s performance. One report is called the “Touch Report.” As your follower views your message, their view will be tallied in the touch report letting you know they saw your message. Each message you send will also be summarized in a “Delivery Report”. Nearly every interaction with your database can be reported upon.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        Do I have to worry about spamming and privacy?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        Spamming is not a factor with the YOU platform. Your followers give permission to contact them by opting in to follow you. Once you have them, don’t loose them! Make sure that your messages are meaningful and provide value.\n                        <br><br>\n                        The YOU platform never shares any email addresses or cell phone numbers. Privacy is taken very seriously and no exposure occurs with YOU.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  <li class=\"second blue\">\n                    <dt>\n                      <div href=\"#accordion1\" aria-expanded=\"false\" aria-controls=\"accordion1\" class=\"accordion-title accordionTitle js-accordionTrigger\">\n                        <img style=\"padding: 10px; padding-right: 60px; padding-left: 30px\" src=\"assets\\images\\support.png\">\n                        How much does the Appointment Module cost?\n                        \n                      </div>\n                    </dt>\n                    <dd class=\"accordion-content accordionItem is-collapsed\" id=\"accordion1\" aria-hidden=\"true\">\n                      <p>\n\n                        The appointment module is based on how many appointment books your organization uses. An appointment book starts at $50/month and prorates down with additional books.\n\n                      </p>\n                    </dd>\n                  </li>\n\n                  </dd>\n                  </li>\n                </ul>\n              </dl>\n            </form>\n          </div>\n        </div>\n\n\n\n      </div>\n      <ya-main-footer></ya-main-footer>\n    </div>\n  </div>\n</div>\n<script>\n  $(document).ready(function() {\n\n    var jobCount = $(\'#list .in\').length;\n    $(\'.list-count\').text(jobCount + \' items\');\n\n\n    $(\"#search-text\").keyup(function () {\n      //$(this).addClass(\'hidden\');\n\n      var searchTerm = $(\"#search-text\").val();\n      var listItem = $(\'#list\').children(\'li\');\n\n\n      var searchSplit = searchTerm.replace(/ /g, \"\'):containsi(\'\")\n\n      //extends :contains to be case insensitive\n      $.extend($.expr[\':\'], {\n        \'containsi\': function(elem, i, match, array)\n        {\n          return (elem.textContent || elem.innerText || \'\').toLowerCase()\n            .indexOf((match[3] || \"\").toLowerCase()) >= 0;\n        }\n      });\n\n\n      $(\"#list li\").not(\":containsi(\'\" + searchSplit + \"\')\").each(function(e)   {\n        $(this).addClass(\'hiding out\').removeClass(\'in\');\n        setTimeout(function() {\n          $(\'.out\').addClass(\'hidden\');\n        }, 300);\n      });\n\n      $(\"#list li:containsi(\'\" + searchSplit + \"\')\").each(function(e) {\n        $(this).removeClass(\'hidden out\').addClass(\'in\');\n        setTimeout(function() {\n          $(\'.in\').removeClass(\'hiding\');\n        }, 1);\n      });\n\n\n      var jobCount = $(\'#list .in\').length;\n      $(\'.list-count\').text(jobCount + \' items\');\n\n      //shows empty state text when no jobs found\n      if(jobCount == \'0\') {\n        $(\'#list\').addClass(\'empty\');\n      }\n      else {\n        $(\'#list\').removeClass(\'empty\');\n      }\n\n    });\n\n\n  });\n</script>\n<script>\n  function pageLoad() {\n    location.reload();\n  }\n</script>\n");
$templateCache.put("app/pages/unsubscribe/unsubscribe.html","<div id=\"user_join\" layout=\"column\">\n  <div>\n    <div layout=\"row\" style=\"padding-left: 40px; padding-top: 20px\">\n      <img onclick=\"location.href=\'#home\'\" style=\"width: 112px; height: 65px; cursor: pointer\" class=\"youapp-logo-userjoin\" src=\"assets\\images\\you-brand-lg.png\">\n      <div flex></div>\n      <div layout=\"column\" class=\"title-text\">\n      </div>\n      <div flex></div>\n    </div>\n  </div>\n\n  <md-content flex layout-padding=\"10\">\n    <div layout=\"row\" class=\"unsubscribe-content\">\n      <p>\n        {{vm.status}}\n      </p>\n    </div>\n  </md-content>\n</div>\n\n");
$templateCache.put("app/pages/user/user.html","<div id=\"dashUser\" layout=\"row\" style=\"height:100%\" layout-fill>\n  <div style=\"height: 100%\" layout=\"column\" layout-fill>\n    <ya-main-header></ya-main-header>\n\n    <div layout=\"row\" style=\"height:100%\">\n      <div flex=\"noshrink\" style=\"height: 100%; background-color: #f89a22\">\n        <ya-main-sidenav></ya-main-sidenav>\n      </div>\n\n      <div layout=\"column\" layout-fill>\n        <ya-help-menu help-page=\"\"></ya-help-menu>\n\n        <div layout-fill class=\"container\">\n\n          <!--CONTENT - title section  -->\n          <div class=\"title\">\n            Choose Your Organization\'s Users\n          </div>\n          <div style=\"height: 10px; width: 100%\"></div>\n          <div layout=\"row\">\n            <div class=\"sub-title\" flex=\"60\">\n              Dashboard Users are individuals with access to the web application dashboard panel.\n            </div>\n            <div flex=\"40\">\n              <div layout=\"row\" class=\"search-input\">\n                <input style=\"width: 100%; margin-bottom: 15px; box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12); border: solid 1px #9b9b9b\" type=\"text\" id=\"\" placeholder=\"Who are you looking for?\" class=\"search-box\" ng-model=\"vm.filter\" ng-change=\"vm.Update()\" ng-model-options=\"{ debounce: 500 }\">\n                <button class=\"clearButton\" ng-click=\"vm.filter = \'\'; vm.Update()\" style=\"position: absolute; right: 15px; padding-top: 7px\">\n                  <img src=\"/assets/images/search-icon.png\" style=\"width: 14px; position: absolute; right: 120%; padding-top: 2px\">\n                  <div class=\"search-line\"></div>\n                  <div class=\"X\">X</div>\n                </button>\n              </div>\n            </div>\n          </div>\n\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <!--buttons in a row  -->\n          <div class=\"buttonRow\" layout=\"row\">\n\n            <div flex=\"25\">\n              <label class=\"userButton buttonColor1\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.AddNew()\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n                ADD NEW DASHBOARD USER MANUALLY\n              </label>\n            </div>\n\n            <div flex=\"noshrink\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <input type=\"file\" id=\"file-upload1\" ng-show=\"false\" name=\"{{$index}}\" accept=\".csv\" onchange=\"angular.element(this).scope().vm.CSVFile(this)\">\n              <label layout=\"row\" layout-align=\"start center\" for=\"file-upload1\" ng-click=\"vm.UploadUsers(\'file-upload1\')\" class=\"userButton buttonColor1\">\n                <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-add.png\">\n                IMPORT CSV OF DASHBOARD USERS\n              </label>\n            </div>\n\n            <div flex=\"noshrink\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <a style=\"text-decoration: none\" ng-href=\"{{vm.exportLink}}\">\n                <label class=\"userButton buttonColor1\" layout=\"row\" layout-align=\"start center\">\n                  <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-download.png\">\n                  EXPORT CSV OF DASHBOARD USERS\n                </label>\n              </a>\n            </div>\n\n            <div flex=\"noshrink\" style=\"width:10px\"></div>\n\n            <div flex=\"25\">\n              <a style=\"text-decoration: none\" href=\"https://s3-us-west-2.amazonaws.com/yougetitfirstfiles/LoadUserData.csv\">\n                <label class=\"userButton buttonColor2\" layout=\"row\" layout-align=\"start center\">\n                  <img class=\"imageStyling\" src=\"assets\\images\\icons\\user-download.png\">\n                  DOWNLOAD CSV TEMPLATE: DASHBOARD USERS\n                </label>\n              </a>\n            </div>\n          </div>\n\n          <ya-help-tips name=\"user\" data=\"vm.helpTipList\"></ya-help-tips>\n          <div style=\"height: 10px; width: 100%\"></div>\n\n          <div flex style=\"width:100%\">\n            <md-list class=\"setWidth\" id=\"style-3\">\n\n              <!-- Table Heading start here -->\n              <md-list-item class=\"listItem listHover\" style=\"font-weight: 600; color: #585858; margin-bottom: 5px\">\n                <div style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\"></div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">FIRST NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">LAST NAME</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">TITLE</div>\n                  <!-- permission  SAVE- may need to use later - -->\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"permiss\">\n                    <span class=\"ellipsis\">PERMISSIONS</span>\n                  </div> -->\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">EMAIL</div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"phone\">PHONE NUMBER</div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\">\n                    <div ng-click=\"vm.InviteAll() \" layout=\"row\" layout-align=\"start center\" role=\"button\">\n                      <img style=\"margin-top: -3px; padding-right:10px\" src=\"assets\\images\\icons\\user-invite.png\"> Remind All\n                    </div>\n                  </div>\n\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n\n                    <!-- <div flex=\"none\" class=\"listbutton invite\" ng-show=\"vm.showInviteAll\">\n                      <div ng-click=\"vm.InviteAll() \" layout=\"row\" layout-align=\"start center\" role=\"button\">\n                        <img style=\"margin-top: -3px; padding-right:10px;\" src=\"assets\\images\\icons\\user-invite.png\"> Invite\n                        All\n                      </div>\n                    </div> -->\n\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" aria-label=\"edit\" class=\"listbutton md-icon-btn editTrash\" style=\"display:hidden\">\n                      <img style=\"padding-right: 10px; display:none\" src=\"assets\\images\\icons\\edit_icon-gray.png\">\n                      <span style=\"display:none\">Edit</span>\n                    </div>\n\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"display:none\" src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div>\n                </div>\n              </md-list-item>\n              <!-- Table Heading end here -->\n\n              <!--Table Rows start here  -->\n              <md-list-item class=\"listHover\" style=\"font-weight: 500; color: #585858\" ng-repeat=\"x in vm.users track by $index\">\n                <div ng-show=\"!x.edit\" style=\"width: 100%\" layout=\"row\" layout-align=\"start center\">\n\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n                  <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\">\n                    <img ng-show=\"x.profileimage\" ng-src=\"{{x.profileimage}}\" id=\"display{{$index}}\" class=\"md-avatar\">\n                    <img ng-show=\"!x.profileimage\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n                  </div>\n                  <div flex=\"noshrink\" class=\"avatarSpacer\"></div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.firstname}}</span></div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.lastname}}</span></div>\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"name-section\">\n                    <span class=\"ellipsis\">{{x.title}}</span></div>\n\n                  <!--permission  SAVE- may need to use later -->\n                  <!-- <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"permiss\">\n                    <md-menu ng-click=\"$mdMenu.open()\">\n                      <div class=\"permissions-menu\" style=\"font-size: 14px; font-weight: 600; color: #0f6ad4\" class=\"md-icon-button\" aria-label=\"View Permissions\">\n                        View Permissions\n                        <img style=\"margin-left: 5px; width: 11px; height: 9px\" src=\"assets\\images\\icons\\carrot-down.png\">\n                      </div>\n                      <md-menu-content ng-mouseleave=\"$mdMenu.close()\">\n                        <md-menu-item layout=\"column\" style=\"height: 300px\">\n                          <div layout=\"column\" style=\"border: 5px solid white; width: 256px\" ng-repeat=\"p in vm.permissionList\">\n                            <div layout=\"row\" ng-show=\"x.permissions[$index]\">\n                              <img style=\"padding-right: 20px; padding-left: 20px\" src=\"assets\\images\\icons\\dashuser-check.png\">{{p}}\n                            </div>\n                          </div>\n                        </md-menu-item>\n                      </md-menu-content>\n                    </md-menu>\n                  </div> -->\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"email\">\n                    <span class=\"ellipsis\">{{x.email}}</span>\n                  </div>\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\" class=\"phone\" style=\"padding-left: 5px\">{{x.phonenumber}}</div>\n\n\n                  <div flex=\"grow\" layout=\"row\" layout-align=\"start center\">{{vm.getStatus(x)}}</div>\n\n\n                  <div layout-fill layout=\"row\" layout-align=\"end center\" class=\"\">\n                    <!--Invite  -->\n                    <!-- <div flex=\"none\" layout-align=\"start center\" class=\"listbutton invite\" ng-show=\"vm.showInviteAll\">\n                      <div flex style=\"color:#9b9b9b; cursor:pointer;\" ng-click=\"vm.SendInvite(x)\">\n                        <div ng-show=\"vm.canInvite(x)\">\n                          <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Invite\n                        </div>\n                        <div ng-show=\"vm.canReinvite(x)\" class=\"reinvite\">\n                          <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Re-Invite\n                        </div>\n                        <div ng-show=\"vm.canRemind(x)\" class=\"remind\">\n                          <img class=\"invite-image\" src=\"assets\\images\\icons\\gray-invite-icon.png\"> Remind\n                        </div>\n                      </div>\n                    </div> -->\n\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" style=\"color:#9b9b9b; cursor:pointer\" aria-label=\"edit\" ng-click=\"vm.OpenEdit(x)\" class=\"listbutton md-icon-btn editTrash\">\n                      <img style=\"padding-right: 10px\" src=\"assets\\images\\icons\\edit_icon-gray.png\"> Edit\n                    </div>\n\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" ng-if=\"!x.orgadmin\" aria-label=\"remove\" ng-click=\"vm.ConfirmRemove(x)\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                      <img src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n\n                    <div flex=\"noshrink\" layout=\"row\" layout-align=\"center center\" ng-if=\"x.orgadmin\" aria-label=\"remove\" class=\"listbutton md-icon-btn dont-repeat editTrash\" style=\"cursor:pointer\">\n                      <img style=\"opacity: .20\" src=\"assets\\images\\icons\\user-trash.png\">\n                    </div>\n                  </div>\n                </div>\n\n                <!--EDIT popup  -->\n                <div class=\"shadow\" ng-show=\"x.edit\" layout=\"row\">\n                  <div layout=\"column\" style=\"width: 12%; background-color: lightgrey\">\n\n\n                    <div layout=\"column\" layout-align=\"start center\" style=\"width: 100%; padding-top: 50px; text-align:center\">\n                        <input class=\"ng-hide\" aria-label=\"profile image\" type=\"file\" ng-model=\"vm.users[$index].imageFile\" id=\"profileImage{{$index}}\" onchange=\"angular.element(this).scope().vm.UpdateImage(angular.element(this).scope().$index,this)\" accept=\".jpg\">\n                        <label style=\"color: #0064d8; font-size: 15px; cursor: pointer\" for=\"profileImage{{$index}}\">Select New Photo</label>\n                    </div>\n\n                    <div layout=\"column\" layout-align=\"start center\" style=\"width: 100%; height: 20px\">\n                      <div style=\"color: #0064d8; font-size: 15px; cursor: pointer\" ng-show=\"x.imageFile!=null\" ng-click=\"vm.Upload($index)\">\n                        UPLOAD\n                      </div>\n                    </div>\n                    <div style=\"width: 100%; height: 150px\" layout=\"column\" layout-align=\"start center\">\n                      <img ng-show=\"x.profileimage\" ng-src=\"{{x.profileimage}}\" id=\"display2{{$index}}\" class=\"md-avatar\">\n                      <img ng-show=\"!x.profileimage\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n                    </div>\n                  </div>\n\n\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" style=\"width: 30%\">\n\n                    <div style=\"height: 6%\"></div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>First Name</label>\n                        <input class=\"inputStyle\" aria-label=\"firstname\" type=\"text\" value=\"{{x.firstname}}\" ng-model=\"x.firstname\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Last Name</label>\n                        <input class=\"inputStyle\" aria-label=\"lastname\" type=\"text\" value=\"{{x.lastname}}\" ng-model=\"x.lastname\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Workflow Admin</label>\n                        <md-select ng-model=\"x.workflowadminName\">\n                          <md-option ng-repeat=\"adminName in vm.workFlowAdminNames track by $index\" ng-attr-value=\"{{adminName}}\">{{adminName}}</md-option>\n                        </md-select>\n                      </md-input-container>\n                    </div>\n\n                  </div>\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" style=\"width: 30%\">\n\n                    <div style=\"height: 6%\"></div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Title</label>\n                        <input class=\"inputStyle\" aria-label=\"title\" type=\"text\" value=\"{{x.title}}\" ng-model=\"x.title\">\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactEmail.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Email</label>\n                        <input class=\"inputStyle\" aria-label=\"email\" type=\"text\" readonly=\"readonly\" onclick=\"if(value==\'abc@abc.com\'){value=\'\'}\" value=\"{{x.email}}\" ng-model=\"x.email\" ng-pattern=\"vm.ePattern\">\n                        <div ng-messages=\"{\'pattern\': !x.email}\">\n                          <div ng-message=\"pattern\">invalid email</div>\n                        </div>\n                      </md-input-container>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                      <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n                      <md-input-container style=\"width: 100%\">\n                        <label>Mobile Phone Number</label>\n                        <input class=\"inputStyle\" type=\"text\" aria-label=\"phonenumber\" name=\"phonenumber\" value=\"{{x.phonenumber}}\" ng-model=\"x.phonenumber\" ng-change=\"vm.updatePhoneNumber(x)\">\n                      </md-input-container>\n\n                    </div>\n\n                  </div>\n                  <div style=\"width: 6%\"></div>\n                  <div layout=\"column\" style=\"width: 19%\">\n                    <div style=\"height: 6%\"></div>\n\n                    <div layout=\"column\" layout-wrap>\n                      <div style=\"font-size: 15px; font-weight: 600; padding-bottom: 20px\">PERMISSIONS</div>\n                      <!--permission  -->\n                      <div ng-repeat=\"p in vm.permissionList\">\n                        <md-checkbox aria-label=\"permission\" ng-model=\"x.permissions[$index]\" ng-click=\"\">\n                          <div>\n                            {{p}}\n                          </div>\n                        </md-checkbox>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div style=\"width: 2%\"></div>\n                  <div layout=\"column\" layout-align=\"start center\" style=\"width: 19%\">\n\n                    <div style=\"color: #0f6ad4; height:50px; font-size: 16px; padding-top: 50px;font-weight: 600\" aria-label=\"done\" ng-click=\"vm.CloseEdit(x)\">\n                      <img style=\"margin-right: 18px; margin-top: -5px\" src=\"assets\\images\\icons\\user-check.png\"> Done Editing\n                    </div>\n                  </div>\n                </div>\n                <!--end EDIT popup  -->\n\n              </md-list-item>\n              <!--Table Rows end here  -->\n\n            </md-list>\n          </div>\n\n          <div layout=\"row\" style=\"width: 100%; padding-bottom:10px\">\n            <div flex></div>\n            <div paging page=\"vm.currentPage\" total=\"vm.totalPages\" page-size=\"1\" paging-action=\"vm.onPage()\" show-prev-next=\"true\" showfirst-last=\"true\"></div>\n            <div flex></div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/pages/userjoin/onjoining-createaccount.html","<div>\n  <ya-stepper callback=\"vm.getCtrl\">\n\n    <ya-stepper-item title=\"Enter your email\">\n      <div style=\"width: 671px; margin-left: 45px; border-left: 1px solid rgba( 0, 0, 0, .15)\" layout=\"column\" layout-align=\"start start\">\n        <div style=\"width: 600px; height: 30px\" layout=\"row\" layout-align=\"start start\">\n            <div class=\"verify-account\">Verify your account:</div>\n        </div>\n        <div style=\"width: 600px; height: 20px\"></div>\n        <form name=\"emailForm\" ng-submit=\"vm.onEmail(emailForm.$valid)\">\n          <div layout=\"row\" layout-align=\"center center\">\n            <div flex></div>\n            <img style=\"width: 32px; height: 32px; margin-bottom: 25px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-email.png\">\n            <div flex></div>\n            <md-input-container class=\"md-block login\" layout=\"row\">\n              <label>Email</label>\n              <input type=\"email\" class=\"inputStyle\" ng-class=\"{\'inputStyleNoExist\': (emailForm.$valid && !vm.isEmailExist()), \'inputStyleExists\': (emailForm.$valid && vm.isEmailExist()) }\" aria-label=\"email\" ng-pattern=\"vm.ePattern\" name=\"email\" ng-model=\"vm.email\" required readonly=\"readonly\">\n\n              <div ng-messages=\"!emailForm.email.$error\">\n                <div ng-message=\"required\">Valid email required</div>\n                <div ng-message=\"pattern\">Valid email required</div>\n                <div ng-show=\"emailForm.$valid && vm.isEmailExist()\" style=\"margin-top: 10px; margin-bottom: 20px; color: #417505\">Email Identified</div>\n                <div ng-show=\"emailForm.$valid && !vm.isEmailExist()\" style=\"margin-top: 10px; margin-bottom: 20px; color: rgba(0,0,0,1)\">Proceed to sign up for an account.</div>\n                <div ng-show=\"emailForm.$valid && vm.isEmailExist()\">^ You have an existing YOU account</div>\n              </div>\n            </md-input-container>\n          </div>\n          <div layout=\"row\" layout-align=\"end end\" class=\"userjoin-buttons\">\n            <div flex></div>\n            <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n            <div flex></div>\n            <md-button type=\"submit\" ng-disabled=\"!vm.isEmailDone() || !emailForm.$valid\" class=\"md-raised contButton\">Next</md-button>\n          </div>\n          <div layout=\"row\" layout-align=\"end end\">\n            <md-button style=\"background-color: #245fa3; color: white; min-width: 92% !important\" class=\"classlink-btn md-raised contButton\" ng-click=\"vm.signInWithClasslink()\">\n              Login with <img class=\"classlink-img\" src=\"assets/images/classlink.png\">\n            </md-button>\n          </div>\n        </form>\n      </div>\n    </ya-stepper-item>\n    <div class=\"line\"></div>\n    <ya-stepper-item title=\"Enter Password\" active=\"false\">\n      <div style=\"width: 671px; margin-left: 45px; border-left: 1px solid rgba( 0, 0, 0, .15)\" layout=\"column\" layout-align=\"start start\">\n        <div style=\"width: 600px; height: 30px\" layout=\"row\" layout-align=\"start start\">\n            <div style=\"font-size: 24px; margin-bottom: 30px; font-weight: 300\">We\'ll log you into your account:</div>\n        </div>\n        <div style=\"width: 600px; height: 20px\"></div>\n        <form name=\"passwordForm\" ng-submit=\"vm.onPassword(passwordForm.$valid)\">\n          <div layout=\"row\" layout-align=\"center center\">\n            <div flex></div>\n            <img style=\"width: 32px; height: 32px; margin-bottom: 80px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-password.png\">\n            <div flex></div>\n            <div layout=\"column\" layout-align=\"start start\">\n              <md-input-container class=\"md-block login\">\n                <label>Password</label>\n                <input class=\"inputStyle\" aria-label=\"password\" name=\"password\" type=\"password\" ng-model=\"vm.password\" required>\n              </md-input-container>\n              <div style=\"margin-top: 10px;margin-bottom:10px\">\n                <p>Forgot Your Password?</p>\n                <p><a style=\"cursor:pointer\" ng-click=\"vm.resetPassword()\">Click Here</a>, a recovery email will be sent.</p>\n              </div>\n            </div>\n          </div>\n\n          <div layout=\"row\" layout-align=\"end end\" class=\"userjoin-buttons\">\n            <div flex></div>\n            <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n            <div flex></div>\n            <md-button type=\"submit\" ng-disabled=\"!passwordForm.$valid\" class=\"md-raised contButton\">Next</md-button>\n          </div>\n        </form>\n      </div>\n    </ya-stepper-item>\n    <div class=\"line\"></div>\n    <ya-stepper-item title=\"Sign Up\" visible=\"false\" active=\"false\">\n      <div style=\"width: 671px; margin-left: 45px; border-left: 1px solid rgba( 0, 0, 0, .15)\" layout=\"column\" layout-align=\"start start\">\n        <div style=\"width: 600px; height: 30px\" layout=\"row\" layout-align=\"start start\">\n            <div class=\"verify-account\">We just need some information:</div>\n        </div>\n        <div style=\"width: 600px; height: 20px\"></div>\n        <form name=\"vm.signupForm\" ng-submit=\"vm.onSignup(vm.signupForm.$valid)\">\n\n          <div layout=\"row\" layout-align=\"center center\">\n            <div flex></div>\n            <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-password.png\">\n            <div flex></div>\n            <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n              <md-input-container class=\"login\">\n                <label>Password</label>\n                <input class=\"inputStyle\" aria-label=\"password\" name=\"password\" type=\"password\" ng-model=\"vm.password\" required ng-pattern=\"/^\\S+$/\" minlength=\"6\" md-maxlength=\"64\">\n                <div ng-messages=\"vm.signupForm.password.$error\" ng-show=\"vm.signupForm.password.$dirty\" md-auto-hide=\"false\">\n                  <div ng-message=\"required\">Password Required</div>\n                  <div ng-message=\"pattern\">Spaces not allowed</div>\n                  <div ng-message=\"minlength\">Password too short</div>\n                  <div ng-message=\"md-maxlength\">Password too long</div>\n                </div>\n              </md-input-container>\n            </div>\n          </div>\n\n          <div layout=\"row\" layout-align=\"center center\">\n            <div flex></div>\n            <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-contactMobil.png\">\n            <div flex></div>\n            <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n              <md-input-container class=\"md-block login\">\n                <label>Mobile Phone Number</label>\n                <input class=\"inputStyle\" aria-label=\"phoneNumber\" name=\"phoneNumber\" ng-model=\"vm.phoneNumber\" ng-change=\"vm.updatePhoneNumber()\" required>\n                <div ng-messages ng-show=\"vm.signupForm.phoneNumber.$dirty\">\n                  <div ng-show=\"!vm.phvalid\">Phone Number Required</div>\n                </div>\n              </md-input-container>\n            </div>\n          </div>\n\n          <div layout=\"row\" layout-align=\"center center\">\n            <div flex></div>\n            <img style=\"width: 32px; height: 32px; margin-right: 20px\" src=\"assets\\images\\icons\\onboarding-birthday.png\">\n            <div flex></div>\n            <div class=\"input\" layout=\"row\" layout-align=\"center center\">\n              <md-input-container class=\"md-block login\">\n                <label>Birthday mm-dd-yyyy</label>\n                <input class=\"inputStyle\" aria-label=\"birthday\" name=\"birthday\" ng-model=\"vm.birthday\" ng-change=\"vm.updateBirthdate()\" required>\n                <div ng-messages ng-show=\"vm.signupForm.birthday.$dirty\">\n                  <div ng-show=\"!vm.bdvalid\">Valid Birthday Required</div>\n                </div>\n              </md-input-container>\n            </div>\n          </div>\n\n          <div layout=\"row\" layout-align=\"end end\" class=\"userjoin-buttons\">\n            <div flex></div>\n            <md-button class=\"md-raised contButton\" ng-click=\"vm.onBack()\">Back</md-button>\n            <div flex></div>\n            <md-button type=\"submit\" ng-disabled=\"(!vm.createValid())\" class=\"md-raised contButton\">Next</md-button>\n          </div>\n\n        </form>\n      </div>\n    </ya-stepper-item>\n\n  </ya-stepper>\n</div>\n");
$templateCache.put("app/pages/userjoin/userjoin.html","<div id=\"user_join\" layout=\"column\">\n  <div>\n    <div layout=\"row\" style=\"padding-left: 40px; padding-top: 20px\">\n      <img onclick=\"location.href=\'#home\'\" style=\"width: 112px; height: 65px; cursor: pointer\" class=\"youapp-logo-userjoin\" src=\"assets\\images\\you-brand-lg.png\">\n      <div flex></div>\n      <div layout=\"column\" class=\"title-text\">\n          <div class=\"invited\">You have been invited to join</div>\n          <div class=\"org-name\" style=\"padding-bottom: 40px\">{{vm.orgName}}</div>\n    </div>\n      <div flex></div>\n    </div>\n  </div>\n\n  <md-content flex>\n    <div layout=\"row\">\n      <div style=\"width: 30%\"></div>\n      <div style=\"width: 697px\">\n        <ya-joining-account parent=\"vm\"></ya-joining-account>\n      </div>\n      <div style=\"width: 30%\"></div>\n    </div>\n  </md-content>\n</div>\n");
$templateCache.put("app/pages/userrequest/userrequest.html","<div id=\"userPage\" layout=\"row\">\n    <div class=\"page\" layout=\"row\" layout-align=\"start\" flex>\n        <div id=\"wrapper\" layout=\"column\" flex>\n\n            <ya-main-header page=\"Users\"></ya-main-header>\n            <div layout=\"row\">\n\n                <div class=\"sidenavi\" layout=\"column\" flex=\"none\">\n                    <ya-main-sidenav></ya-main-sidenav>\n                </div>\n                <div class=\"userInfo\" layout=\"column\" flex>\n\n                    <div class=\"titleSize\">\n                        Pending Users in My Organization:\n                    </div>\n\n                    <md-content class=\"scrollable listSize\">\n                      <ya-help-menu help-page=\"\"></ya-help-menu>\n                        <md-list>\n                            <md-list-item ng-repeat=\"x in vm.users\">\n\n                                <div ng-show=\"!x.edit\" layout-fill>\n                                    <div layout=\"row\" layout-align=\"space-between center\" layout-wrap layout-padding>\n\n                                        <div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\">\n                                            <md-button aria-label=\"edit\" ng-click=\"vm.OpenEdit($index)\" class=\"md-icon-btn\"><md-icon md-svg-src=\"/assets/images/icons/ic_mode_edit_black_24px.svg\"></md-icon></md-button>\n                                            <image ng-src=\"assets\\images\\60x60.png\" id=\"display{{$index}}\" class=\"md-avatar\">\n                                        </div>\n\n                                        <button ng-show=\"vm.CanInvite(x)\" ng-click=\"vm.SendInvite(x)\">Invite</button>\n                                        <button ng-show=\"vm.CanApprove(x)\" ng-click=\"vm.ApproveUser(x)\">Approve</button>\n                                        <button ng-show=\"vm.CanApprove(x)\" ng-click=\"vm.DenyUser(x)\">Deny</button>\n\n                                        <div flex class=\"user-info\" layout=\"row\" layout-align=\"space-between center\" layout-padding layout-wrap>\n                                            <p flex=\"noshrink\">{{x.name}}</p>\n                                            <p flex=\"noshrink\">{{x.title}}</p>\n\n                                            <p flex=\"noshrink\">{{x.phone}}</p>\n                                            <p flex=\"noshrink\">{{x.email}}</p>\n\n\n                                            <div flex-gt-md=\"25\" class=\"permissions\">\n                                                <div ng-repeat=\"p in vm.permissionList\">\n                                                    <div ng-show=\"x.permissions[$index]\">{{p}}</div>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                        <!--div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\" class=\"delete\">\n                                            <md-button aria-label=\"remove\" ng-click=\"vm.Remove($index)\" class=\"md-icon-btn\"><md-icon md-svg-src = \'/assets/images/icons/ic_delete_black_24px.svg\'></md-button>\n                                        </div-->\n                                    </div>\n\n                                </div>\n                                <div ng-show=\"x.edit\" layout=\"row\" layout-wrap layout-padding>\n\n                                    <div flex=\"100\" layout=\"row\" layout-align=\"space-between center\">\n                                        <md-input-container flex=\"80\">\n                                            <!-- <label for=\"profileImage{{$index}}\">Browse New Image</label> -->\n                                            <input aria-label=\"profile image\" type=\"file\" ng-model=\"vm.users[$index].imageFile\" class=\"\" id=\"profileImage{{$index}}\" onchange=\"angular.element(this).scope().vm.UpdateImage(angular.element(this).scope().$index,this)\" accept=\".jpg\">\n                                            <md-button ng-show=\"x.imageFile!=null\" ng-click=\"vm.Upload($index)\">UPLOAD</md-button>\n                                        </md-input-container>\n\n                                        <md-button aria-label=\"done\" ng-click=\"vm.CloseEdit($index)\" class=\"\" flex=\"20\">done</md-button>\n                                    </div>\n\n                                    <div flex=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"33\">\n                                        <md-input-container>\n                                            <label>Name</label>\n                                            <input aria-label=\"name\" type=\"text\" value=\"{{x.name}}\" ng-model=\"x.name\">\n                                        </md-input-container>\n\n\n                                        <md-input-container>\n                                            <label>Title</label>\n                                            <input aria-label=\"title\" type=\"text\" value=\"{{x.title}}\" ng-model=\"x.title\">\n                                        </md-input-container>\n                                    </div>\n\n                                    <div flex=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"33\">\n                                        <md-input-container>\n                                            <input aria-label=\"phone number\" type=\"text\" value=\"{{x.phone}}\" ng-model=\"x.phone\" ng-pattern=\"vm.phPattern\" onclick=\"if(value==\'(###)-###-####\'){value=\'\'}\">\n                                            <div ng-messages=\"{\'pattern\': !x.phone}\">\n                                                <div ng-message=\"pattern\">invalid phone number</div>\n                                            </div>\n                                        </md-input-container>\n\n                                        <md-input-container>\n                                            <label>Email</label>\n                                            <input aria-label=\"email\" type=\"text\" onclick=\"if(value==\'abc@abc.com\'){value=\'\'}\" value=\"{{x.email}}\" ng-model=\"x.email\" ng-pattern=\"vm.ePattern\">\n                                            <div ng-messages=\"{\'pattern\': !x.email}\">\n                                                <div ng-message=\"pattern\">invalid email</div>\n                                            </div>\n                                        </md-input-container>\n                                    </div>\n\n                                    <div flex=\"100\" flex-gt-md=\"33\" layout=\"row\" layout-wrap>\n                                        <p flex=\"100\">Permissions</p>\n\n                                        <div ng-repeat=\"p in vm.permissionList\" flex=\"50\" flex-gt-md=\"100\">\n                                            <md-checkbox aria-label=\"permission\" ng-model=\"x.permissions[$index]\" ng-click=\"\">{{p}}</md-checkbox>\n                                        </div>\n                                    </div>\n\n                                    <div>\n                                        <p>Work Flow Admin</p>\n                                        <select ng-model=\"x.workflowadminName\">\n                                            <option ng-repeat=\"a in vm.workFlowAdmins\" value=\"a\">{{a.name}}</option>\n                                        </select>\n                                    </div>\n                                </div>\n\n                            </md-list-item>\n                        </md-list>\n                    </md-content>\n\n                    <div class=\"buttPad\"></div>\n\n                    <button ng-click=\"vm.Done()\">Done</button>\n\n\n                </div>\n            </div>\n\n            <ya-main-footer></ya-main-footer>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/pages/usersetup/usersetup.html","<div id=\"usersetup\">  \n\n	<divdiv class=\"page\" layout=\"row\">\n\n		<div class=\"leftContent\">\n\n			<img class=\"tenpx\" src=\"assets\\images\\onboarding-logo.png\">\n			\n			<div layout=\"column\">\n				\n				<div class=\"title\" layout=\"column\" layout-align=\"center center\">NEW ORGANIZATION USER</div>\n\n					<md-content class=\"scrollable listSize\"> \n						<md-list>\n							<md-divider></md-divider>\n							<md-list-item ng-repeat=\"x in vm.users\">\n\n								<div ng-show=\"!x.edit\" layout-fill>\n									<div layout=\"row\" layout-align=\"space-between center\" layout-wrap layout-padding>\n\n										<div flex=\"nogrow\" class=\"avatar\" layout=\"row\" layout-align=\"start center\">\n											<md-button aria-label=\"edit\" ng-click=\"vm.OpenEdit($index)\" class=\"md-icon-btn\"><md-icon md-svg-src=\"/assets/images/icons/ic_mode_edit_black_24px.svg\"></md-icon></md-button>									\n											<image ng-src=\"assets\\images\\60x60.png\" id=\"display{{$index}}\" class=\"md-avatar\">	\n										</div>\n											\n										<div flex class=\"user-info\" layout=\"row\" layout-align=\"space-between center\" layout-padding layout-wrap>\n											<p flex=\"noshrink\"><!--{{$index+1}}--> {{x.name}}</p>\n											<p flex=\"noshrink\">{{x.title}}</p>						\n										\n											<p flex=\"noshrink\">{{x.phone}}</p>\n											<p flex=\"noshrink\">{{x.email}}</p>\n										\n\n											<div flex-gt-md=\"25\" class=\"permissions\">\n												<div ng-repeat=\"p in vm.permissions\">\n													<div ng-show=\"x.permissions[$index]\">{{p}}</div>\n												</div>\n											</div>\n										</div>\n										\n										<div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\" class=\"delete\">\n											<md-button aria-label=\"remove\" ng-click=\"vm.Remove($index)\" class=\"md-icon-btn\"><md-icon md-svg-src=\"/assets/images/icons/ic_delete_black_24px.svg\"></md-icon></md-button>\n										</div>\n									</div>\n								\n								</div>\n								<div ng-show=\"x.edit\" layout=\"row\" layout-wrap layout-padding>\n									\n									<div flex=\"100\" layout=\"row\" layout-align=\"space-between center\">\n										<md-input-container flex=\"80\">\n											<!-- <label for=\"profileImage{{$index}}\">Browse New Image</label> -->\n											<input aria-label=\"profile image\" type=\"file\" ng-model=\"vm.users[$index].imageFile\" class=\"\" id=\"profileImage{{$index}}\" onchange=\"angular.element(this).scope().vm.UpdateImage(angular.element(this).scope().$index,this)\" accept=\".jpg\">\n											<md-button ng-show=\"x.imageFile!=null\" ng-click=\"vm.Upload($index)\">UPLOAD</md-button>\n										</md-input-container>\n										\n										<md-button aria-label=\"done\" ng-click=\"vm.CloseEdit($index)\" class=\"\" flex=\"20\">done</md-button>\n									</div>\n									\n									<div flex=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"33\">\n										<md-input-container>\n											<label>Name</label>\n											<input aria-label=\"name\" type=\"text\" value=\"{{x.name}}\" ng-model=\"x.name\">\n										</md-input-container>\n\n\n										<md-input-container>\n											<label>Title</label>\n											<input aria-label=\"title\" type=\"text\" value=\"{{x.title}}\" ng-model=\"x.title\">\n										</md-input-container>\n									</div>\n\n									<div flex=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"33\">\n										<md-input-container>\n											<input aria-label=\"phone number\" type=\"text\" value=\"{{x.phone}}\" ng-model=\"x.phone\" ng-pattern=\"vm.phPattern\" onclick=\"if(value==\'(###)-###-####\'){value=\'\'}\">\n											<div ng-messages=\"{\'pattern\': !x.phone}\">\n												<div ng-message=\"pattern\">invalid phone number</div>\n											</div>\n										</md-input-container>\n\n										<md-input-container>\n											<label>Email</label>\n											<input aria-label=\"email\" type=\"text\" onclick=\"if(value==\'abc@abc.com\'){value=\'\'}\" value=\"{{x.email}}\" ng-model=\"x.email\" ng-pattern=\"vm.ePattern\">\n											<div ng-messages=\"{\'pattern\': !x.email}\">\n												<div ng-message=\"pattern\">invalid email</div>\n											</div>\n										</md-input-container>\n									</div>\n\n									<div flex=\"100\" flex-gt-md=\"33\" layout=\"row\" layout-wrap>\n										<p flex=\"100\">Permissions</p>\n\n										<div ng-repeat=\"p in vm.permissions\" flex=\"50\" flex-gt-md=\"100\">\n											<md-checkbox aria-label=\"permission\" ng-model=\"x.permissions[$index]\" ng-click=\"\">{{p}}</md-checkbox>\n										</div>\n									</div>\n								</div>\n\n								<md-divider></md-divider>\n\n							</md-list-item>\n						</md-list>\n					</md-content>\n\n					<div ng-click=\"vm.AddNew()\" class=\"add-btn\">Add New User</div>\n\n					<div layout=\"row\" layout-align=\"center center\">\n						Upload CSV for new users\n						<input aria-label=\"upload csv file of users\" type=\"file\" class=\"\" name=\"csvFile\" accept=\".csv\" onchange=\"angular.element(this).scope().vm.CSVFile(this)\">		\n					</div>\n\n					<div class=\"buttPad\"></div>\n\n					<div layout=\"row\" layout-align=\"center center\">\n\n						<md-button aria-label=\"back\" ng-click=\"vm.Back()\" class=\"md-raised backButton\">Back</md-button>\n\n						<md-button aria-label=\"continue\" ng-click=\"vm.Continue()\" class=\"md-raised contButton\">Continue</md-button>\n						\n					</div>\n\n			</div>\n\n		</div>\n\n	<div class=\"tutorial\"></div>\n	</divdiv></div>\n");
$templateCache.put("app/popups/addmaxcat/addmaxcat.html","<div id=\"addmaxcat\">\n  <form name=\"addmaxcat\" ng-submit=\"vm.AddMaxCat()\">\n    <div layout=\"column\" layout-align=\"center center\" class=\"bgcolor\">\n      <div class=\"message-content\">\n        <div style=\"color: #245fa3; font-size: 28px; font-weight: 400; padding-bottom: 20px\">Purchase additional categories/recipient groups?</div>\n        <div style=\"font-weight: 300; font-size: 18px; padding-bottom: 10px\">You have reached the maximum total combination of categories and recipient groups. Would you like to purchase an additional category/recipient group for $25?</div>\n        <md-checkbox aria-label=\"agree to this order\" class=\"yellow\" ng-model=\"vm.approval\" ng-change=\"vm.updateApproval()\">\n          I agree to this order & please use my credit card listed in PROFILE\n        </md-checkbox>\n        <md-button class=\"cancel-button\" ng-click=\"vm.onDone()\">\n          Cancel\n        </md-button>\n        <md-button class=\"delete-button\" type=\"submit\">\n          Purchase\n        </md-button>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/popups/confirmsend/confirmsend.html","<div id=\"confirmsend\">\n    <form name=\"confirmsend\" ng-submit=\"vm.Confirm()\">\n        <div layout=\"column\" layout-align=\"center center\" class=\"bgcolor\">\n            <div class=\"message-content\">\n                <div style=\"color: #245fa3; font-size: 28px; font-weight: 400\">Send Alert?</div>\n                <div style=\"font-weight: 300; font-size: 18px; padding-bottom: 40px\">Are you sure you would like to send this alert right now?</div>\n                <md-button class=\"cancel-button\" ng-click=\"vm.onDone()\">\n                    Cancel\n                </md-button>\n                <md-button class=\"delete-button\" type=\"submit\">\n                    Yes\n                </md-button>\n            </div>\n        </div>\n    </form>\n</div>\n");
$templateCache.put("app/popups/deletebillinginfo/deletebillinginfo.html","<div id=\"deletebillinginfo\">\n  <form name=\"DeleteBillingInfo\" ng-submit=\"vm.Remove()\">\n    <div layout=\"column\" layout-align=\"center center\" class=\"bgcolor\">\n      <div class=\"message-content\">\n        <div style=\"color: #245fa3; font-size: 28px; font-weight: 400\">Clear Billing Info?</div>\n        <div style=\"font-weight: 300; font-size: 18px; padding-bottom: 40px\">Are you sure you would like to delete the billing information? You will be required to re-complete the form</div>\n        <md-button class=\"cancel-button\" ng-click=\"vm.onDone()\">\n          Cancel\n        </md-button>\n        <md-button class=\"delete-button\" type=\"submit\">\n          Yes, Delete\n        </md-button>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/popups/deletedashboardgroupconfirm/deletedashboardgroupconfirm.html","<div id=\"DeleteDashboardGroupConfirm\">\n  <form name=\"DeleteDashboardGroupConfirm\" ng-submit=\"vm.Remove()\">\n    <div layout=\"column\" layout-align=\"center center\" class=\"bgcolor\">\n      <div class=\"message-content\">\n        <div style=\"color: #245fa3; font-size: 28px; font-weight: 400\">Are you sure?</div>\n        <div style=\"font-weight: 300; font-size: 18px; padding-bottom: 40px\">Are you sure you would like to delete this Dashboard Group?</div>\n        <md-button class=\"cancel-button\" ng-click=\"vm.onDone()\">\n          Cancel\n        </md-button>\n        <md-button class=\"delete-button\" type=\"submit\">\n          Yes, Delete\n        </md-button>\n       </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/popups/deletedashboarduserconfirm/deletedashboarduserconfirm.html","<div id=\"DeleteDashboardUserConfirm\">\n  <form name=\"DeleteUserConfirm\" ng-submit=\"vm.Remove()\">\n    <div layout=\"column\" layout-align=\"center center\" class=\"bgcolor\">\n      <div class=\"message-content\">\n        <div style=\"color: #245fa3; font-size: 28px; font-weight: 400\">Are you sure?</div>\n        <div style=\"font-weight: 300; font-size: 18px; padding-bottom: 40px\">Are you sure you would like to delete this user?</div>\n        <md-button class=\"cancel-button\" ng-click=\"vm.onDone()\">\n          Cancel\n        </md-button>\n        <md-button class=\"delete-button\" type=\"submit\">\n          Yes, Delete\n        </md-button>\n       </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/popups/deletegroupconfirm/deletegroupconfirm.html","<div id=\"DeleteUserConfirm\">\n  <form name=\"DeleteUserConfirm\" ng-submit=\"vm.Remove()\">\n    <div layout=\"column\" layout-align=\"center center\" class=\"bgcolor\">\n      <div class=\"message-content\">\n        <div style=\"color: #245fa3; font-size: 28px; font-weight: 400\">Are you sure?</div>\n        <div style=\"font-weight: 300; font-size: 18px; padding-bottom: 40px\">Are you sure you would like to delete this Recipient Group?</div>\n        <md-button class=\"cancel-button\" ng-click=\"vm.onDone()\">\n          Cancel\n        </md-button>\n        <md-button class=\"delete-button\" type=\"submit\">\n          Yes, Delete\n        </md-button>\n       </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/popups/deleteorgconfirm/deleteorgconfirm.html","<div id=\"deleteorgconfirm\">\n    <form name=\"deleteorgconfirm\" ng-submit=\"vm.Remove()\">\n        <div layout=\"column\" layout-align=\"center center\" class=\"bgcolor\">\n            <div class=\"message-content\">\n                <div style=\"color: #245fa3; font-size: 28px; font-weight: 400\">Are you sure?</div>\n                <div style=\"font-weight: 300; font-size: 18px; padding-bottom: 40px\">Are you sure you would like to delete the {{vm.org.name}} organization? <br><br> WARNING: THIS CANNOT BE UNDONE</div>\n                <md-button class=\"cancel-button\" ng-click=\"vm.onDone()\">\n                    Cancel\n                </md-button>\n                <md-button class=\"delete-button\" type=\"submit\">\n                    Yes, Delete\n                </md-button>\n            </div>\n        </div>\n    </form>\n</div>\n");
$templateCache.put("app/popups/deleterespondentconfirm/deleterespondentconfirm.html","<div id=\"DeleteRespondentConfirm\">\n  <form name=\"DeleteRespondentConfirm\" ng-submit=\"vm.Remove()\">\n    <div layout=\"column\" layout-align=\"center center\" class=\"bgcolor\">\n      <div class=\"message-content\">\n        <div style=\"color: #245fa3; font-size: 28px; font-weight: 400\">Are you sure?</div>\n        <div style=\"font-weight: 300; font-size: 18px; padding-bottom: 40px\">Are you sure you would like to delete this Person?</div>\n        <md-button class=\"cancel-button\" ng-click=\"vm.onDone()\">\n          Cancel\n        </md-button>\n        <md-button class=\"delete-button\" type=\"submit\">\n          Yes, Delete\n        </md-button>\n       </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/popups/deletesalesperson/deletesalesperson.html","<div id=\"DeleteUserConfirm\">\n  <form name=\"DeleteUserConfirm\" ng-submit=\"vm.Remove()\">\n    <div layout=\"column\" layout-align=\"center center\" class=\"bgcolor\">\n      <div class=\"message-content\">\n        <div style=\"color: #245fa3; font-size: 28px; font-weight: 400\">Are you sure?</div>\n        <div style=\"font-weight: 300; font-size: 18px; padding-bottom: 40px\">Are you sure you would like to delete this user?</div>\n        <md-button class=\"cancel-button\" ng-click=\"vm.onDone()\">\n          Cancel\n        </md-button>\n        <md-button class=\"delete-button\" type=\"submit\">\n          Yes, Delete\n        </md-button>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/popups/deleteuserconfirm/deleteuserconfirm.html","<div id=\"DeleteUserConfirm\">\n  <form name=\"DeleteUserConfirm\" ng-submit=\"vm.Remove()\">\n    <div layout=\"column\" layout-align=\"center center\" class=\"bgcolor\">\n      <div class=\"message-content\">\n        <div style=\"color: #245fa3; font-size: 28px; font-weight: 400\">Are you sure?</div>\n        <div style=\"font-weight: 300; font-size: 18px; padding-bottom: 40px\">Are you sure you would like to delete this user?</div>\n        <md-button class=\"cancel-button\" ng-click=\"vm.onDone()\">\n          Cancel\n        </md-button>\n        <md-button class=\"delete-button\" type=\"submit\">\n          Yes, Delete\n        </md-button>\n       </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/popups/message/message.html","<div id=\"message\" ng-controller=\"Message.Controller as vm\" ng-click=\"vm.Done()\">\n\n	<div layout=\"column\" layout-align=\"center center\" class=\"bgcolor\">\n    <div class=\"message-content\">\n      <div style=\"color: #245fa3; font-size: 28px; font-weight: 400; padding-bottom: 10px\">{{vm.data.title}}</div>\n      <div style=\"font-weight: 300; font-size: 18px; padding-bottom: 40px\">{{vm.data.message}}</div>\n      <div class=\"back-button-section\">\n        <md-button aria-label=\"done\" class=\"backButton\" ng-click=\"vm.Done()\">\n          {{vm.data.buttonName}}\n        </md-button>\n      </div>\n    </div>\n	</div>\n\n\n</div>\n");
$templateCache.put("app/popups/newdashboarduser/newdashboarduser.html","<div id=\"newdashboarduser\">\n  <form name=\"newDashboardUserForm\" ng-submit=\"vm.onAdd(newDashboardUserForm.$valid)\">\n    <div class=\"shadow\" layout=\"row\" style=\"width: 100%; background-color: white; min-height: 300px\">\n\n      <div layout=\"column\" style=\"width: 12%; background-color: lightgrey\">\n        <div style=\"height: 6%\"></div>\n        <div layout=\"column\" layout-align=\"center center\" style=\"width: 100%; height: 15%\">\n          <input class=\"ng-hide\" aria-label=\"profile image\" type=\"file\" id=\"uploader\" onchange=\"angular.element(this).scope().vm.UpdateImage(this)\" accept=\".jpg\">\n          <label style=\"color: #0064d8; font-size: 15px; cursor: pointer\" for=\"uploader\">\n            Select New Photo\n          </label>\n        </div>\n        <div style=\"width: 100%; height: 100%\" layout=\"column\" layout-align=\"start center\">\n          <image ng-show=\"vm.addedUser.profileimage\" ng-src=\"{{vm.addedUser.profileimage}}\" class=\"md-avatar\">\n          <image ng-show=\"!vm.addedUser.profileimage && !vm.addedUser.imageFile\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n          <div style=\"color: #0064d8; font-size: 15px; cursor: pointer\" ng-show=\"vm.addedUser.imageFile\" ng-click=\"vm.Upload()\">\n            UPLOAD\n          </div>\n        </div>\n      </div>\n      <div style=\"width: 2%\"></div>\n      <div layout=\"column\" style=\"width: 30%\">\n        <div style=\"height: 6%\"></div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactEmail.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Email</label>\n            <input class=\"inputStyle\" name=\"email\" aria-label=\"email\" type=\"text\" ng-model=\"vm.addedUser.email\" ng-pattern=\"vm.ePattern\" required ng-blur=\"vm.lookupUserByEmail()\">\n            <div ng-messages=\"newDashboardUserForm.email.$error\">\n              <div ng-message=\"required\">Valid email required</div>\n              <div ng-message=\"pattern\">Valid email required</div>\n            </div>\n          </md-input-container>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>First Name</label>\n            <input class=\"inputStyle\" name=\"firstname\" aria-label=\"firstname\" type=\"text\" value=\"{{vm.addedUser.firstname}}\" ng-model=\"vm.addedUser.firstname\" required>\n          </md-input-container>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Last Name</label>\n            <input class=\"inputStyle\" name=\"lastname\" aria-label=\"lastname\" type=\"text\" value=\"{{vm.addedUser.lastname}}\" ng-model=\"vm.addedUser.lastname\" required>\n          </md-input-container>\n        </div>\n      </div>\n      <div style=\"width: 2%\"></div>\n      <div layout=\"column\" style=\"width: 30%\">\n        <div style=\"height: 6%\"></div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Title</label>\n            <input class=\"inputStyle\" aria-label=\"title\" type=\"text\" value=\"{{vm.addedUser.title}}\" ng-model=\"vm.addedUser.title\">\n          </md-input-container>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactMobil.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Mobile Phone Number</label>\n            <input class=\"inputStyle\" aria-label=\"phonenumber\" type=\"text\" value=\"{{vm.addedUser.phonenumber}}\" ng-model=\"vm.addedUser.phonenumber\" ng-change=\"vm.updatePhoneNumber()\" required>\n          </md-input-container>\n        </div>\n      </div>\n      <div style=\"width: 6%\"></div>\n      <div style=\"width: 2%\"></div>\n      <div layout=\"column\" layout-align=\"start start\" style=\"width: 19%\">\n        <div style=\"width: 100%; height: 6%\"></div>\n        <md-button type=\"submit\">\n          <div style=\"color: #0f6ad4; font-size: 16px; font-weight: 600\" aria-label=\"done\">\n            <image type=\"image\" style=\"margin-right: 18px; margin-top: -5px\" src=\"assets\\images\\icons\\user-check.png\">\n            Add New\n          </div>\n        </md-button>\n        <md-button style=\"color: #0f6ad4; font-size: 16px; font-weight: 600\" ng-click=\"vm.onDone()\">\n          Cancel\n        </md-button>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/popups/newemailuser/newemailuser.html","<div id=\"newemailuser\">\n    <form name=\"newemailuserForm\" ng-submit=\"vm.onAdd(newemailuserForm.$valid)\">\n        <div class=\"shadow\" layout=\"row\" style=\"width: 100%; background-color: white\">\n            <div style=\"width: 2%\"></div>\n            <div layout=\"column\" style=\"width: 30%\">\n                <div style=\"height: 6%\"></div>\n                <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                    <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                    <md-input-container style=\"width: 100%\">\n                        <label>First Name</label>\n                        <input class=\"inputStyle\" name=\"firstname\" aria-label=\"firstname\" type=\"text\" value=\"{{vm.addedUser.firstname}}\" ng-model=\"vm.addedUser.firstname\" required>\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                    <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n                    <md-input-container style=\"width: 100%\">\n                        <label>Last Name</label>\n                        <input class=\"inputStyle\" name=\"lastname\" aria-label=\"lastname\" type=\"text\" value=\"{{vm.addedUser.lastname}}\" ng-model=\"vm.addedUser.lastname\" required>\n                    </md-input-container>\n                </div>\n                <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                    <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactMobil.png\">\n                    <md-input-container style=\"width: 100%\">\n                        <label>Mobile Phone Number</label>\n                        <input class=\"inputStyle\" aria-label=\"phonenumber\" type=\"text\" value=\"{{vm.addedUser.phonenumber}}\" ng-model=\"vm.addedUser.phonenumber\" ng-change=\"vm.updatePhoneNumber()\" required>\n                    </md-input-container>\n                </div>\n            </div>\n            <div style=\"width: 2%\"></div>\n            <div layout=\"column\" style=\"width: 30%\">\n                <div style=\"height: 6%\"></div>\n                <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n                    <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactEmail.png\">\n                    <md-input-container style=\"width: 100%\">\n                        <label>Email</label>\n                        <input class=\"inputStyle\" name=\"email\" aria-label=\"email\" type=\"text\" ng-model=\"vm.addedUser.email\" ng-pattern=\"vm.ePattern\" required>\n                        <div ng-messages=\"newGrpUserForm.email.$error\">\n                            <div ng-message=\"required\">Valid email required</div>\n                            <div ng-message=\"pattern\">Valid email required</div>\n                        </div>\n                    </md-input-container>\n                </div>\n            </div>\n            <div style=\"width: 6%\"></div>\n            <div style=\"width: 2%\"></div>\n            <div layout=\"column\" layout-align=\"start start\" style=\"width: 19%\">\n                <div style=\"width: 100%; height: 6%\"></div>\n                <md-button type=\"submit\">\n                    <div style=\"color: #0f6ad4; font-size: 16px; font-weight: 600\" aria-label=\"done\">\n                        <img type=\"image\" style=\"margin-right: 18px; margin-top: -5px\" src=\"assets\\images\\icons\\user-check.png\">\n                        Add New\n                    </div>\n                </md-button>\n                <md-button style=\"color: #0f6ad4; font-size: 16px; font-weight: 600\" ng-click=\"vm.onDone()\">\n                    Cancel\n                </md-button>\n            </div>\n        </div>\n    </form>\n</div>\n");
$templateCache.put("app/popups/newgroupuser/newgroupuser.html","<div id=\"newgroupuser\">\n  <form name=\"newGrpUserForm\" ng-submit=\"vm.onAdd(newGrpUserForm.$valid)\">\n    <div class=\"shadow\" layout=\"row\" style=\"width: 100%; background-color: white\">\n\n      <div layout=\"column\" style=\"width: 12%; background-color: lightgrey\">\n        <div style=\"height: 6%\"></div>\n        <div layout=\"column\" layout-align=\"center center\" style=\"width: 100%; height: 15%\">\n          <input class=\"ng-hide\" aria-label=\"profile image\" type=\"file\" id=\"uploader\" onchange=\"angular.element(this).scope().vm.UpdateImage(this)\" accept=\".jpg\">\n          <label style=\"color: #0064d8; font-size: 15px; cursor: pointer\" for=\"uploader\">\n            Select New Photo\n          </label>\n        </div>\n        <div style=\"width: 100%; height: 100%\" layout=\"column\" layout-align=\"start center\">\n          <image ng-show=\"vm.addedUser.profileimage\" ng-src=\"{{vm.addedUser.profileimage}}\" class=\"md-avatar\">\n          <image ng-show=\"!vm.addedUser.profileimage && !vm.addedUser.imageFile\" ng-src=\"assets\\images\\60x60.png\" class=\"md-avatar\">\n          <div style=\"color: #0064d8; font-size: 15px; cursor: pointer\" ng-show=\"vm.addedUser.imageFile\" ng-click=\"vm.Upload()\">\n            UPLOAD\n          </div>\n        </div>\n      </div>\n      <div style=\"width: 2%\"></div>\n      <div layout=\"column\" style=\"width: 30%\">\n        <div style=\"height: 6%\"></div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>First Name</label>\n            <input class=\"inputStyle\" name=\"firstname\" aria-label=\"firstname\" type=\"text\" value=\"{{vm.addedUser.firstname}}\" ng-model=\"vm.addedUser.firstname\" required>\n          </md-input-container>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Last Name</label>\n            <input class=\"inputStyle\" name=\"lastname\" aria-label=\"lastname\" type=\"text\" value=\"{{vm.addedUser.lastname}}\" ng-model=\"vm.addedUser.lastname\" required>\n          </md-input-container>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactMobil.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Mobile Phone Number</label>\n            <input class=\"inputStyle\" aria-label=\"phonenumber\" type=\"text\" value=\"{{vm.addedUser.phonenumber}}\" ng-model=\"vm.addedUser.phonenumber\" ng-change=\"vm.updatePhoneNumber()\" required>\n          </md-input-container>\n        </div>\n      </div>\n      <div style=\"width: 2%\"></div>\n      <div layout=\"column\" style=\"width: 30%\">\n        <div style=\"height: 6%\"></div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\user-title.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Title</label>\n            <input class=\"inputStyle\" aria-label=\"title\" type=\"text\" value=\"{{vm.addedUser.title}}\" ng-model=\"vm.addedUser.title\">\n          </md-input-container>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactEmail.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Email</label>\n            <input class=\"inputStyle\" name=\"email\" aria-label=\"email\" type=\"text\" ng-model=\"vm.addedUser.email\" ng-pattern=\"vm.ePattern\" required>\n            <div ng-messages=\"newGrpUserForm.email.$error\">\n              <div ng-message=\"required\">Valid email required</div>\n              <div ng-message=\"pattern\">Valid email required</div>\n            </div>\n          </md-input-container>\n        </div>\n      </div>\n      <div style=\"width: 6%\"></div>\n      <div style=\"width: 2%\"></div>\n      <div layout=\"column\" layout-align=\"start start\" style=\"width: 19%\">\n        <div style=\"width: 100%; height: 6%\"></div>\n        <md-button type=\"submit\">\n          <div style=\"color: #0f6ad4; font-size: 16px; font-weight: 600\" aria-label=\"done\">\n            <image type=\"image\" style=\"margin-right: 18px; margin-top: -5px\" src=\"assets\\images\\icons\\user-check.png\">\n            Add New\n          </div>\n        </md-button>\n        <md-button style=\"color: #0f6ad4; font-size: 16px; font-weight: 600\" ng-click=\"vm.onDone()\">\n          Cancel\n        </md-button>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/popups/newsalesorg/newsalesorg.html","<div id=\"newgroupuser\">\n  <form name=\"newSalesOrg\" ng-submit=\"vm.onAdd(newSalesOrg.$valid)\">\n    <div class=\"shadow\" layout=\"row\" style=\"width: 100%; background-color: white\">\n\n      <div style=\"width: 2%\"></div>\n      <div layout=\"column\" style=\"width: 100%\">\n        <div style=\"height: 6%\"></div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Sales Organization Name</label>\n            <input class=\"inputStyle\" name=\"name\" aria-label=\"name\" type=\"text\" ng-model=\"vm.addedSalesOrg.name\" required>\n            <div ng-messages=\"{\'pattern\': !vm.addedSalesOrg.name}\">\n              <div ng-message=\"pattern\">Name Required</div>\n            </div>\n          </md-input-container>\n        </div>\n        <div style=\"height: 6%\"></div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Referral Code</label>\n            <input class=\"inputStyle\" placeholder=\"Enter a 3 digit number\" name=\"referralcode\" aria-label=\"referralcode\" type=\"text\" ng-change=\"vm.updateReferralCode()\" ng-model=\"vm.addedSalesOrg.referralcode\" required>\n            <div ng-show=\"vm.refCodeValid === false && vm.showCode === true\">\n              <div style=\"color:red\">Invalid referral code. Please enter a 3 digit number</div>\n            </div>\n          </md-input-container>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Industry Type</label>\n            <md-select class=\"inputStyle\" ng-model=\"vm.industryType\" required>\n              <md-option ng-repeat=\"a in vm.types\" ng-value=\"a\">{{a}}</md-option>\n            </md-select>\n            <div ng-messages=\"{\'pattern\': !vm.industryType}\">\n              <div ng-message=\"pattern\">Industry Type Required</div>\n            </div>\n          </md-input-container>\n        </div>\n      </div>\n      <div style=\"width: 2%\"></div>\n      <div layout=\"column\" style=\"width: 30%\">\n        <div style=\"height: 6%\"></div>\n      </div>\n      <div style=\"width: 6%\"></div>\n      <div style=\"width: 2%\"></div>\n      <div layout=\"column\" layout-align=\"start start\" style=\"width: 19%\">\n        <div style=\"width: 100%; height: 6%\"></div>\n        <md-button type=\"submit\" ng-disabled=\"vm.refCodeValid === false\">\n          <div style=\"color: #0f6ad4; font-size: 16px; font-weight: 600\" aria-label=\"done\">\n            <img style=\"margin-right: 18px; margin-top: -5px\" src=\"assets\\images\\icons\\user-check.png\">\n            Add New\n          </div>\n        </md-button>\n        <md-button style=\"color: #0f6ad4; font-size: 16px; font-weight: 600\" ng-click=\"vm.onDone()\">\n          Cancel\n        </md-button>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/popups/newsalesperson/newsalesperson.html","<div id=\"newsalesperson\">\n  <form name=\"newSalesPerson\" ng-submit=\"vm.onAdd(newSalesPerson.$valid)\">\n    <div class=\"shadow\" layout=\"row\" style=\"width: 100%; background-color: white\">\n\n      <div style=\"width: 2%\"></div>\n      <div layout=\"column\" style=\"width: 100%\">\n        <div style=\"height: 6%\"></div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>First Name</label>\n            <input class=\"inputStyle\" name=\"firstname\" aria-label=\"firstname\" type=\"text\" ng-model=\"vm.addedSalesPerson.firstname\" required>\n            <div ng-messages=\"{\'pattern\': !vm.addedSalesPerson.firstname}\">\n              <div ng-message=\"pattern\">First name is required.</div>\n            </div>\n          </md-input-container>\n        </div>\n        <div style=\"height: 6%\"></div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Last Name</label>\n            <input class=\"inputStyle\" name=\"lastname\" aria-label=\"lastname\" type=\"text\" ng-model=\"vm.addedSalesPerson.lastname\" required>\n            <div ng-messages=\"{\'pattern\': !vm.addedSalesPerson.lastname}\">\n              <div ng-message=\"pattern\">Last name is required.</div>\n            </div>\n          </md-input-container>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Primary Phone</label>\n            <input class=\"inputStyle\" aria-label=\"phone\" name=\"phone\" ng-model=\"vm.addedSalesPerson.phone\" ng-change=\"vm.updatePhoneNumber()\" required>\n            <div ng-messages ng-show=\"newSalesPerson.phone.$dirty\">\n              <div ng-show=\"!vm.phvalid\">Valid Phone Number Required</div>\n            </div>\n          </md-input-container>\n        </div>\n      </div>\n      <div style=\"width: 2%\"></div>\n      <div layout=\"column\" style=\"width: 100%\">\n        <div style=\"height: 6%\"></div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Title</label>\n            <input class=\"inputStyle\" name=\"title\" aria-label=\"title\" type=\"text\" ng-model=\"vm.addedSalesPerson.title\">\n          </md-input-container>\n        </div>\n        <div style=\"height: 6%\"></div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Email</label>\n            <input class=\"inputStyle\" name=\"email\" aria-label=\"email\" type=\"text\" ng-pattern=\"vm.ePattern\" ng-model=\"vm.addedSalesPerson.email\" required>\n            <div ng-messages=\"{\'pattern\': !vm.addedSalesPerson.email}\">\n              <div ng-message=\"pattern\">Invalid email</div>\n            </div>\n          </md-input-container>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Referral Code</label>\n            <input class=\"inputStyle\" name=\"referralcode\" placeholder=\"Enter a 3 digit number\" ng-minlength=\"3\" ng-maxlength=\"3\" aria-label=\"referralcode\" ng-change=\"vm.updateReferralCode()\" type=\"text\" ng-model=\"vm.addedSalesPerson.referralcode\" required>\n            <div ng-show=\"vm.refCodeValid === false && vm.showCode === true\">\n              <div style=\"color:red\">Invalid referral code. Please enter a 3 digit number</div>\n            </div>\n          </md-input-container>\n        </div>\n      </div>\n      <div style=\"width: 2%\"></div>\n      <div layout=\"column\" style=\"width: 100%\">\n        <div style=\"height: 4%\"></div>\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n          <img style=\"min-width: 24px; height: 24px; margin-bottom: 20px; padding-right: 10px\" src=\"assets\\images\\icons\\onboarding-contactName.png\">\n          <md-input-container style=\"width: 100%\">\n            <label>Start Date</label>\n            <input class=\"inputStyle\" name=\"startdate\" aria-label=\"startdate\" type=\"text\" ng-model=\"vm.addedSalesPerson.startdate\" readonly=\"readonly\">\n          </md-input-container>\n        </div>\n      </div>\n      <div style=\"width: 2%\"></div>\n      <div layout=\"column\" layout-align=\"start start\" style=\"width: 19%\">\n        <div style=\"width: 100%; height: 6%\"></div>\n        <md-button type=\"submit\" ng-disabled=\"(!vm.createValid()) && vm.refCodeValid === false\">\n          <div class=\"button\" aria-label=\"done\">\n            <img type=\"image\" style=\"margin-right: 18px; margin-top: -5px\" src=\"assets\\images\\icons\\user-check.png\">\n            Add New\n          </div>\n        </md-button>\n        <md-button class=\"button\" ng-click=\"vm.onDone()\">\n          Cancel\n        </md-button>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/popups/purchasereport/purchasereport.html","<div id=\"addmaxcat\">\n  <form name=\"addmaxcat\" ng-submit=\"vm.PurchaseReport()\">\n    <div layout=\"column\" layout-align=\"center center\" class=\"bgcolor\">\n      <div class=\"message-content\">\n        <div style=\"color: #245fa3; font-size: 28px; font-weight: 400; padding-bottom: 20px\">Purchase the report?</div>\n        <div style=\"font-weight: 300; font-size: 18px; padding-bottom: 10px\">Reports over seven days old must be purchased in order to access them. You can buy the report for $10. Would you like to buy the report?</div>\n        <md-checkbox aria-label=\"agree to this order\" class=\"yellow\" ng-model=\"vm.approval\" ng-change=\"vm.updateApproval()\">\n          I agree to this order & please use my credit card listed in PROFILE\n        </md-checkbox>\n        <md-button class=\"cancel-button\" ng-click=\"vm.onDone()\">\n          Cancel\n        </md-button>\n        <md-button class=\"delete-button\" type=\"submit\">\n          Purchase\n        </md-button>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/popups/sendemailcampaign/sendemailcampaign.html","<div id=\"sendemailcampaign\">\n  <form name=\"sendemailcampaign\" ng-submit=\"vm.onAdd()\" style=\"height: 600px\">\n    <div class=\"shadow\" layout=\"row\" style=\"width: 100%; background-color: #eaeaea; border-radius: 8px\">\n      <div layout=\"column\" style=\"min-height: 600px; padding: 10px\">\n        <iframe ng-if=\"vm.iframeUrl\" ng-src=\"{{vm.iframeUrl}}\" width=\"700\" style=\"border: 1px #F4F4F4 solid; height: 100%\"></iframe>\n      </div>\n      <div layout=\"column\" style=\"overflow-y: scroll; width: 100%\">\n        <div style=\"height: 900px\">\n\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%; margin-top: 36px\">\n            <md-input-container style=\"width: 100%\">\n              <label>Subject</label>\n              <input class=\"inputStyle\" name=\"subject\" aria-label=\"subject\" type=\"text\" ng-model=\"vm.emailTemplate.subject\" required placeholder=\"Subject\">\n            </md-input-container>\n          </div>\n          <div style=\"height: 6%\"></div>\n\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\" style=\"font-size: 21px\">\n              <label>Logo</label>\n            </md-input-container>\n          </div>\n          <div layout=\"row\" style=\"margin-top: -10px; margin-bottom: 30px\">\n            <div layout=\"column\" class=\"fileUpload uploadButton image-buttons\" layout-align=\"left center\" style=\"padding: 11px; margin: 10px\">\n              <input aria-label=\"browse\" type=\"file\" class=\"upload\" id=\"imageurl\" onchange=\"angular.element(this).scope().vm.UpdateImage(this, \'imageurl\')\" accept=\"image/*\">\n              Upload Logo\n            </div>\n            <div layout=\"column\" class=\"fileUpload uploadButton image-buttons\" layout-align=\"left center\" style=\"padding: 11px; margin: 10px\" ng-click=\"vm.removeImage(\'imageurl\')\">\n              Remove Logo\n            </div>\n          </div>\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\" style=\"font-size: 21px\">\n              <label>Image</label>\n            </md-input-container>\n          </div>\n          <div layout=\"row\" style=\"margin-top: -10px; margin-bottom: 30px\">\n            <div layout=\"column\" class=\"fileUpload uploadButton image-buttons\" layout-align=\"left center\" style=\"padding: 11px; margin: 10px\">\n              <input aria-label=\"browse\" type=\"file\" class=\"upload\" id=\"topimage\" onchange=\"angular.element(this).scope().vm.UpdateImage(this, \'topimage\')\" accept=\"image/*\">\n              Upload Image\n            </div>\n            <div layout=\"column\" class=\"fileUpload uploadButton image-buttons\" layout-align=\"left center\" style=\"padding: 11px; margin: 10px\" ng-click=\"vm.removeImage(\'topimage\')\">\n              Remove Image\n            </div>\n          </div>\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\">\n              <label>Title</label>\n              <input class=\"inputStyle\" name=\"title\" aria-label=\"title\" type=\"text\" ng-model=\"vm.emailTemplate.title\" required placeholder=\"Title\">\n            </md-input-container>\n          </div>\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\">\n              <label>Allignment</label>\n              <md-select ng-model=\"vm.emailTemplate.titlealign\" placeholder=\"Alignment\">\n                <md-option value=\"left\">Left</md-option>\n                <md-option value=\"center\">Center</md-option>\n                <md-option value=\"right\">Right</md-option>\n              </md-select>\n            </md-input-container>\n          </div>\n          <div style=\"height: 6%\"></div>\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\">\n              <label>Subtitle</label>\n              <input class=\"inputStyle\" name=\"subtitle\" aria-label=\"subtitle\" type=\"text\" ng-model=\"vm.emailTemplate.subtitle\" required placeholder=\"Subtitle\">\n            </md-input-container>\n          </div>\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\">\n              <label>Allignment</label>\n              <md-select ng-model=\"vm.emailTemplate.subtitlealign\" placeholder=\"Alignment\">\n                <md-option value=\"left\">Left</md-option>\n                <md-option value=\"center\">Center</md-option>\n                <md-option value=\"right\">Right</md-option>\n              </md-select>\n            </md-input-container>\n          </div>\n          <div style=\"height: 6%\"></div>\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\">\n              <label>Top Background Color</label>\n            </md-input-container>\n          </div>\n          <div layout=\"row\" style=\"margin-top: -10px; margin-bottom: 30px\">\n            <color-picker ng-model=\"vm.emailTemplate.topbackgroundcolor\" options=\"vm.colorPickerOptions\"></color-picker>\n          </div>\n          <div style=\"height: 6%\"></div>\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\">\n              <label>Bottom Background Color</label>\n            </md-input-container>\n          </div>\n          <div layout=\"row\" style=\"margin-top: -10px; margin-bottom: 30px\">\n            <color-picker ng-model=\"vm.emailTemplate.bottombackgroundcolor\" options=\"vm.colorPickerOptions\"></color-picker>\n          </div>\n          <div style=\"height: 6%\"></div>\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\">\n              <label>Body</label>\n              <textarea class=\"inputStyle\" name=\"body\" aria-label=\"body\" type=\"text\" ng-model=\"vm.emailTemplate.body\" required placeholder=\"Body\"></textarea>\n            </md-input-container>\n          </div>\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\">\n              <label>Allignment</label>\n              <md-select ng-model=\"vm.emailTemplate.bodyalign\" placeholder=\"Alignment\">\n                <md-option value=\"left\">Left</md-option>\n                <md-option value=\"center\">Center</md-option>\n                <md-option value=\"right\">Right</md-option>\n              </md-select>\n            </md-input-container>\n          </div>\n\n          <div style=\"height: 6%\"></div>\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\">\n              <label>Buttons (Above App Store Buttons)</label>\n            </md-input-container>\n          </div>\n\n          <div layout=\"row\" layout-align=\"left top\" style=\"width: 100%\">\n            <ul>\n              <li ng-repeat=\"button in vm.emailTemplate.buttons track by $index\">\n                {{button.copy}} ({{button.link}}) -\n                <a ng-click=\"vm.deleteButtonAtIndex($index)\">Delete</a>\n              </li>\n            </ul>\n          </div>\n\n          <div style=\"height: 6%\"></div>\n          <div layout=\"row\" layout-align=\"left top\" style=\"width: 100%\" class=\"new-button\">\n            <div layout=\"column\" layout-align=\"center top\" style=\"width: 33%\">\n              <md-input-container style=\"width: 100%\">\n                <label>New Button Copy</label>\n                <input class=\"inputStyle\" name=\"button_copy\" aria-label=\"button_copy\" type=\"text\" ng-model=\"vm.newButton.copy\" placeholder=\"Copy\">\n              </md-input-container>\n            </div>\n            <div layout=\"column\" layout-align=\"center top\" style=\"width: 33%\">\n              <md-input-container style=\"width: 100%\">\n                <label>New Button Link</label>\n                <input class=\"inputStyle\" name=\"button_link\" aria-label=\"button_link\" type=\"text\" ng-model=\"vm.newButton.link\" placeholder=\"Link\">\n              </md-input-container>\n            </div>\n            <div layout=\"column\" layout-align=\"center top\" style=\"width: 33%; margin-top: -36px\">\n              <md-input-container style=\"width: 100%\">\n                <label>New Button Color</label>\n              </md-input-container>\n              <color-picker ng-model=\"vm.newButton.color\" options=\"vm.colorPickerOptions\"></color-picker>\n            </div>\n          </div>\n\n          <div layout=\"row\">\n            <div layout=\"column\">\n              <md-button class=\"fileUpload uploadButton\" ng-click=\"vm.addButton()\" style=\"margin: 10px\">\n                Add Button\n              </md-button>\n            </div>\n          </div>\n\n          <div style=\"height: 6%\"></div>\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\">\n              <label>App Store Buttons</label>\n              <md-checkbox ng-model=\"vm.emailTemplate.playstore\" aria-label=\"Google Play?\">\n                Google Play Store\n              </md-checkbox>\n              <md-checkbox ng-model=\"vm.emailTemplate.appstore\" aria-label=\"App Store?\">\n                Apple App Store\n              </md-checkbox>\n            </md-input-container>\n          </div>\n\n          <div style=\"height: 6%\"></div>\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\">\n              <label>Buttons (Below App Store Buttons)</label>\n            </md-input-container>\n          </div>\n\n          <div layout=\"row\" layout-align=\"left top\" style=\"width: 100%\">\n            <ul>\n              <li ng-repeat=\"button in vm.emailTemplate.buttonsalt track by $index\">\n                {{button.copy}} ({{button.link}}) -\n                <a ng-click=\"vm.deleteButtonAtIndex($index, true)\">Delete</a>\n              </li>\n            </ul>\n          </div>\n\n          <div style=\"height: 6%\"></div>\n          <div layout=\"row\" layout-align=\"left top\" style=\"width: 100%\" class=\"new-button\">\n            <div layout=\"column\" layout-align=\"center top\" style=\"width: 33%\">\n              <md-input-container style=\"width: 100%\">\n                <label>New Button Copy</label>\n                <input class=\"inputStyle\" name=\"button_copy\" aria-label=\"button_copy\" type=\"text\" ng-model=\"vm.newButtonAlt.copy\" placeholder=\"Copy\">\n              </md-input-container>\n            </div>\n            <div layout=\"column\" layout-align=\"center top\" style=\"width: 33%\">\n              <md-input-container style=\"width: 100%\">\n                <label>New Button Link</label>\n                <input class=\"inputStyle\" name=\"button_link\" aria-label=\"button_link\" type=\"text\" ng-model=\"vm.newButtonAlt.link\" placeholder=\"Link\">\n              </md-input-container>\n            </div>\n            <div layout=\"column\" layout-align=\"center top\" style=\"width: 33%; margin-top: -36px\">\n              <md-input-container style=\"width: 100%\">\n                <label>New Button Color</label>\n              </md-input-container>\n              <color-picker ng-model=\"vm.newButtonAlt.color\" options=\"vm.colorPickerOptions\"></color-picker>\n            </div>\n          </div>\n\n          <div layout=\"row\">\n            <div layout=\"column\">\n              <md-button class=\"fileUpload uploadButton\" ng-click=\"vm.addButton(true)\" style=\"margin: 10px\">\n                Add Button\n              </md-button>\n            </div>\n          </div>\n\n          <div style=\"height: 6%\"></div>\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\">\n              <label>Footer</label>\n              <textarea class=\"inputStyle\" name=\"footer\" aria-label=\"footer\" type=\"text\" ng-model=\"vm.emailTemplate.footer\" required placeholder=\"Footer\"></textarea>\n            </md-input-container>\n          </div>\n          <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-input-container style=\"width: 100%\">\n              <label>Allignment</label>\n              <md-select ng-model=\"vm.emailTemplate.footeralign\" placeholder=\"Alignment\">\n                <md-option value=\"left\">Left</md-option>\n                <md-option value=\"center\">Center</md-option>\n                <md-option value=\"right\">Right</md-option>\n              </md-select>\n            </md-input-container>\n          </div>\n\n          <div layout=\"row\">\n            <div layout=\"column\">\n              <md-button class=\"fileUpload uploadButton cancel-button\" ng-click=\"vm.onDone()\" style=\"margin: 10px\">\n                Cancel\n              </md-button>\n            </div>\n            <div layout=\"column\">\n              <md-button class=\"fileUpload uploadButton\" ng-click=\"vm.onSave()\" style=\"margin: 10px\">\n                Save & Preview\n              </md-button>\n            </div>\n            <div layout=\"column\">\n              <md-button class=\"fileUpload uploadButton\" ng-click=\"vm.onSave(true)\" style=\"margin: 10px\">\n                Save & Close\n              </md-button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/popups/templateconfirm/templateconfirm.html","<div id=\"templateConfirm\">\n\n	<!-- <div class=\"jumbotron text-center\">\n    	<h1>Template Confirm</h1>\n	</div> -->\n\n	<!-- <div>\n		<div style=\"width:100%\">\n			<p>{{vm.data.status}}</p>\n			<p>{{vm.data.name}}</p>\n		</div>\n	</div> -->\n\n	<div layout=\"row\" layout-align=\"center center\">\n\n		<md-button aria-label=\"done\" class=\"buttStyle colorTwo buttonSpace\" ng-click=\"vm.onDone()\">\n			<div class=\"buttText\">\n\n				SELECT\n\n			</div>\n		</md-button>\n\n		<!-- <ya-select-card data=\"data\" parent=\"vm\"></ya-select-card> -->\n		<md-card class=\"select-card cardSize\" ng-mouseleave=\"hover = \'\'\" ng-class=\"hover\" ng-style=\"{\'background-image\': \'url(\' + vm.data.previewurl + \')\'}\" style=\"background-image: url(&quot;http://youapp.zymodevelop.com/api/v1/containers/youappfiles/download/ba502381-fc16-e56f-7547-b2eba4562051:blob&quot;)\">\n\n			<div layout-fill=\"\" class=\"layout-fill\">\n\n				<div class=\"card-states\">\n\n					<div class=\"state-create layout-align-center-center layout-column ng-hide\" ng-show=\"vm.data.status==\'create\'\" layout=\"column\" layout-align=\"center center\" role=\"button\" tabindex=\"0\" aria-hidden=\"true\" style=\"\">\n\n\n						<div class=\"card-content-area layout-align-center-center layout-column\" layout=\"column\" layout-align=\"center center\">\n							<div class=\"circle-text ng-binding\">new template </div>\n						</div>\n\n\n					</div>\n\n\n\n					<div class=\"state-template\" ng-show=\"vm.data.status!=\'create\'\" role=\"button\" tabindex=\"0\" aria-hidden=\"false\">\n\n						<div class=\"card-content-area layout-align-space-around-center layout-column\" layout=\"column\" layout-align=\"space-around center\">\n\n						</div>\n\n					</div>\n\n				</div>\n			</div>\n		</md-card>\n\n		<md-button aria-label=\"cancel\" class=\"buttStyle colorOne buttonSpace\" ng-click=\"vm.onCancel()\">\n			<div class=\"buttText\" layout=\"row\" layout-align=\"center center\">\n				CANCEL\n			</div>\n		</md-button>\n\n	</div>\n</div>\n");
$templateCache.put("app/popups/terms/terms.html","<div id=\"terms-popup\" layout=\"column\">\n\n    <div layout=\"row\">\n      <div flex></div>\n      <div ng-click=\"vm.onDone()\" class=\"button\"><div class=\"text\">X</div></div>\n    </div>\n\n    <div layout=\"row\" flex style=\"height:100%\">\n\n    <md-tabs md-dynamic-height>\n      <div class=\"md-line\"></div>\n      <md-tab label=\"Privacy\">\n        <md-content>\n          <div class=\"content\" layout=\"column\">\n\n            <h1>PRIVACY POLICY OF FORWARD MOVE, LLC</h1>\n\n            <h2>Effective February 16, 2017</h2>\n            <h3>1.    Privacy Policy.</h3>\n            <p>\n              We value your privacy and are dedicated to protecting your information and providing you with notice about our information collection and use practices and how you have a choice to opt-in/out of any marketing or promotional contact from us. You may choose to register the installed copy of the “YOU Get it First App” with Forward Move, LLC (“Forward Move”) by means provided in the “YOU Get it First App”. By voluntarily sharing personally identifiable information by means of registering the “YOU Get it First App”, you agree to the following privacy policy.\n            </p>\n            <h3>2.    Personally Identifiable Information.</h3>\n            <p>\n              When you register for the “YOU Get it First App”, the registration form requires certain personal information to be provided (including, without limitation, your name and email address).\n            </p>\n            <h3>3.    Announcement Email Information. </h3>\n            <p>\n              From time to time, we provide information about our products to our customers in the form of email. When you register the “YOU Get it First App”, you will have the option to opt-in/out of announcement emails. After successfully registering the “YOU Get it First App”, you have the option to set your opt-in/out preference using the “YOU Get it First App’s” alert settings.  Announcement emails will be emailed directly to the address that you provide when you register.\n            </p>\n            <p>\n              We may place email links and or forms on our website to allow you to contact us directly. The personal information you provide in these links and forms are used to respond directly to your questions or comments. All information, other than the personal information that you send to Forward Move using these email links or forms, will not be considered or treated as confidential information. Do not send us any information, ideas, suggestions, proposals, or comments that you consider confidential or that you want to be treated as confidential.\n            </p>\n            <h3>4.    Use of Your Personally Identifiable Information. </h3>\n            <p>\n              We use personal information to respond to your inquiries, improve our marketing and promotional efforts, to analyze the “YOU Get it First App” and to customize our services. We may use personal information to deliver information to you and to contact you regarding administrative notices. We may also use personal information to resolve disputes and troubleshoot problems.\n            </p>\n            <p>\n              We may use additional information not considered personally identifiable to analyze and improve troubleshooting techniques and responses, and to improve the value of “YOU Get it First App”(s) and services provided by Forward Move or third parties.\n            </p>\n            <p>\n              If the email address you provide us is an email address that you access via a wireless device, you understand that your wireless carrier\'s standard rates apply to these messages, and that you may change your mind at any time and elect to not receive such messages. You also represent that you are the owner or authorized user of the wireless device on which the messages may be received, and that you understand and are authorized to approve the applicable charges.\n            </p>\n            <h3>5.    Reminder Alerts.</h3>\n            <p>\n              You may choose to allow the “YOU Get it First App” to provide reminder alerts. Should you allow the “YOU Get it First App” to provide reminder alerts, you understand and agree that this service may be provided using services operated outside of the “YOU Get it First App”. You understand and agree that pertinent data needed for such alerts will be transmitted and temporarily be stored on services operated by Forward Move, and that at the appropriate time, this alert data will be transmitted via corresponding services for delivery to your device or chosen delivery endpoints. At no time is the personal information you provide transmitted via a third-party delivery service unless as required by the nature of the delivery mechanism (electronic mail, for example, requires your name and email address for delivery). Should you disagree with the mechanism of this service, you agree to disable and not use reminder alerts as provided in the “YOU Get it First App”.\n            </p>\n            <h3>6.    Required Disclosures. </h3>\n            <p>\n              Forward Move may disclose personal information if required to do so by law or in the good-faith belief that such action is necessary to prevent injury or property damage. We will usually attempt to notify you when we are making such a disclosure, but we may not do so in an emergency or when we are prohibited by law or court order from giving such notice.\n            </p>\n            <h3>7.    Information Sharing and Third Party Service Partners. </h3>\n            <p>\n              Forward Move may rent, sell, or share personal information about you with other people or non-affiliated companies (with your consent) or if we have a good faith belief that access, use, preservation, or disclosure is reasonably necessary to (a) satisfy any law, regulation, legal process or enforceable governmental request, (b) enforce any applicable Terms of Service (including investigation of potential violations thereof), or (c) detect, prevent or otherwise address fraud, security, or technical issues.\n            </p>\n            <p>\n              Forward Move may provide services for the “YOU Get it First App” through contractual arrangements with affiliates, service providers, partners and other third parties (“Service Partners”). Forward Move and its Service Partners use your personal information to operate and deliver their products and services.\n            </p>\n            <p>\n              If Forward Move becomes involved in a merger, acquisition, or any form of sale of some or all of its assets, we will ensure the confidentiality of any personal information involved in such transactions and provide reasonable notice before personal information is transferred and becomes subject to a different privacy policy. Such notice may be given by a clear and concise statement on Forward Move’s website or in a subsequent update to the “YOU Get it First App” that there has been an update to this privacy policy.\n            </p>\n            <h3>8.    Opt-Out Policy. </h3>\n            <p>\n              Forward Move allows you to opt out of our use of your personal information for purposes other than the purpose for which it was provided. This includes, by way of example, marketing and promotional mailings relating to Forward Move products and services. You may exercise this option at the time your personal information is collected by toggling the appropriate setting in the “YOU Get it First App’s” settings. In some cases, we may ask you to affirmatively indicate your consent to receive marketing and promotional materials. In the case where you decline the consent to receive marketing and promotional materials, we will not send you any additional materials other than those required by our service agreement with you.\n            </p>\n            <h3>9.    Access and Integrity of Stored Personal Information. </h3>\n            <p>\n              The personal information provided to Forward Move during registration of the “YOU Get it First App” is shown directly in the “YOU Get it First App’s” settings.  Should you wish to actively delete the personal information that has been provided to us, subject to your understanding that certain deletions may affect our ability to provide the Forward Move services you have requested, please send us an email to info@yougetitfirst.com.\n            </p>\n            <h3>10.   Links. </h3>\n            <p>\n              The “YOU Get it First App” may include links to other applications or sites. This Privacy Policy applies to the “YOU Get it First App” only. Any information you submit to linked sites or other applications will be subject to the privacy policies of those sites or applications, if any. You should review those policies carefully before providing any information to these linked sites or applications.\n            </p>\n            <h3>11.   Security. </h3>\n            <p>\n              Forward Move undertakes practical and reasonable steps to protect personal information from unauthorized or accidental access, disclosure, misuse or processing, or from alteration, destruction, or loss. Personal information that we collect resides on servers operated by Forward Move and is accessible only to personnel who, by virtue of their duties, are required to have access and have been trained in, and tasked with, the observance of the principles embodied in this Privacy Policy.\n            </p>\n            <h3>12.   Enforcement. </h3>\n            <p>\n              If you have any questions or complaints regarding how your personal information is treated under this Privacy Policy or generally about the implementation of the principles of this policy, we encourage you to contact info@yougetitfirst.com.\n            </p>\n            <h3>13.   Changes to Privacy Policy. </h3>\n            <p>\n              Should we decide to change this Privacy Policy, we will update it with the release or update of the “YOU Get it First App” or on the following website: yougetitfirst.com, so that you will always know what personal information we gather, how we might use it, and whether we will disclose it to anyone. Unless you opt out of receiving announcement emails from us, as you may do so in the manner described herein, we may also notify you by email of changes to this Privacy Policy.\n            </p>\n          </div>\n        </md-content>\n      </md-tab>\n      <md-tab label=\"EULA\">\n        <md-content>\n          <div class=\"content\" layout=\"column\">\n            <h1>LICENSE AGREEMENT FOR SMARTPHONE/TABLET APP</h1>\n            <h2>Effective: February 28, 2020</h2>\n\n            <p>\n                This License Agreement, together with all updates, additional terms, and all of Forward Move, LLC’s rules and policies (“Agreement”) governs your (“you”, “You”, “your”, or “Your”) use of the “YOU Get it First App”, the Services and the Site (collectively, the “Technology”) provided by Forward Move, LLC its subsidiaries and contractors (“Forward Move,” “we,” “us” or “our”) designed to operate on your Smartphone and/or tablet (your “Computing Device”).\n            </p>\n            <p>\n              The Technology is licensed, not sold.\n            </p>\n            <p>\n              You acknowledge that the Agreement is entered into by and between Forward Move and you. Your use of the Technology constitutes your acceptance of the terms of this Agreement, which may be amended from time to time by Forward Move. Forward Move reserves the right to change or modify this Agreement or any other Forward Move policies related to use of the Technology at any time, and at its sole discretion, by posting revisions on an update to the Technology or on the Internet at yougetitfirst.com. Continued use of the Technology following the posting of these changes or modifications will constitute acceptance of such changes or modifications.\n            </p>\n            <h3>1.    Term and Termination.</h3>\n            <p>\n              This Agreement is entered into as of your first access or use of the Services or a Site (the “Effective Date”).  This Agreement will be effective upon the Effective Date.  If You have ordered a trial subscription for the Services or a subscription to any free Services (a “Trial/Free Subscription”), then the term of this Agreement will continue for the period of the Trial/Free Subscription indicated on the order form and will thereafter expire unless You place an order for a non-trial subscription to the Services prior to the completion thereof.  If You have ordered a non-trial subscription to the Services, then the term of this Agreement will continue for the initial period stated in the applicable order and will thereafter automatically renew for successive additional periods of equal duration.  If no initial period is stated in the applicable order, this Agreement will continue for an initial period of 1 month and will thereafter automatically renew for successive additional 1-month periods.  Unless terminated as set forth herein, the term of this Agreement will continue to renew until You notify Forward Move that You do not wish to renew the Agreement at least 10 days prior to the end of the then-current period.  In all other cases, the term of this Agreement will continue until terminated as set forth herein.  Notwithstanding the foregoing, Your rights under this license will terminate automatically without notice from Forward Move if you fail to comply with any term(s) of this Agreement.  In addition, Forward Move may also immediately and indefinitely suspend Your access to the Sites or Services, with or without notice to You, upon any actual, threatened or suspected breach of this Agreement or of applicable law or upon any other conduct deemed inappropriate or detrimental to the Services by Forward Move (including, but not limited to, rogue script, bad send and unauthorized takeover or other malicious activity on Your Account).  Upon termination or expiration of this Agreement for any reason: (a) all rights and subscriptions granted to You under this Agreement will terminate; (b) You will immediately cease all use of and access to the Sites and Services; (c) all Fees then owed by You will become immediately due and payable; (d) You will immediately either return to Forward Move or, at Forward Move’s discretion, destroy the Forward Move Content, Account IDs, and other information related to this Agreement in Your possession or control; and (e) Forward Move may delete any of Your Content held by Forward Move within 10 days after the date of termination.\n            </p>\n            <h3>2.    Payment.</h3>\n            <p>\n              You agree to pay Forward Move or a Forward Move Authorized reseller all fees set forth in each order and any fees otherwise specified on the Site or through the Services (“Fees”).  All Fees will be billed as indicated in each order.  If the applicable order does not specify any applicable billing terms, the initial payment of Fees specified under that order for each period in Your subscription will be due and payable by You in advance on or before the Effective Date and again on or before the completion of each subsequent period under this Agreement.  If You have specified credit card or direct withdrawal from a bank account as an applicable payment mechanism under this Agreement, You grant Forward Move the right to charge the credit card or debit the bank account provided to Forward Move for all Fees incurred under this Agreement.  All Fees will be non-refundable once paid to Forward Move (including upon any termination or suspension of this Agreement).  Until paid in full, all past due amounts will bear an additional charge of the lesser of 1½% per month or the maximum amount permitted under applicable law.  Forward Move may change any portion of the Fees by posting the changes to the Sites or otherwise notifying You through the Services of the change, such changes to take effect at the beginning of the next period of this Agreement.  If Forward Move requires use of collection agencies, attorneys, or courts of law for collection on Your account, You will be responsible for those expenses. You will be responsible for all use, sales, and other taxes imposed on the Services provided under this Agreement.\n            </p>\n            <h3>3.    License.</h3>\n            <p>\n              The license granted to you by Forward Move for the Technology is limited to a non-transferable license to use the Technology on any Computing Device that you own or control. This license does not allow you to use the Technology on any Computing Device that you do not own or control. You may not rent, lease, lend, sell, redistribute or sublicense the Technology. You may not copy, decompile, reverse engineer, disassemble, attempt to derive the source code of, modify, or create derivative works of the Technology, any updates, or any part thereof (except as and only to the extent any foregoing restriction is prohibited by applicable law or to the extent as may be permitted by the licensing terms governing use of any open sourced components included with the Technology). Any attempt to do so is a violation of the rights of Forward Move and its licensors. If you breach this restriction, you may be subject to prosecution and damages.  You agree to comply with applicable third party terms of agreement when using the Technology.  If You desire to integrate the Service into any of the services offered by You and/or provide the Service to Your customers and potential customers (“OEM Users”) as an integrated part of Your business (the “OEM Service”), You will also be subject to the OEM terms and conditions set forth in Section 25 below\n            </p>\n            <h3>4.     Account.</h3>\n            <p>\n              The rights granted to You under this Agreement entitle You to access the Services through accounts (each, an “Account”).  You will be provided with a user identification and password applicable to each Account You have purchased (each such user identification and password, an “Account ID”).  Each Account ID is personal in nature and may be used only by You or, if You are an organization, by designated employees within Your organization  or contractors who are contractually required to comply with the terms of this Agreement (such individual, as applicable, the “User” of the Account).  You are solely responsible for all use of the Services by each User and for compliance by each User with the applicable terms of this Agreement.  You will ensure the security and confidentiality of each Account ID and will notify Forward Move immediately if any Account ID is lost, stolen or otherwise compromised.  You acknowledge that You are fully responsible for all costs, fees, liabilities or damages incurred through use of each Account ID (whether lawful or unlawful) and that any Services ordered or transactions completed through any Account or under any Account ID will be deemed to have been lawfully completed by You.  In no event will Forward Move be liable for the foregoing obligations or the failure by You to fulfill such obligations.  You will be solely responsible, at Your own expense, for acquiring, installing and maintaining all hardware, software and other equipment as may be necessary for You and each User to connect to, access, and use the Services and the Sites.\n            </p>\n            <h3>5.     Services; Third-Party Materials</h3>\n            <p>\n              Forward Move provides certain services relating to the development, transmission, analysis, and management of email messages (“Services”) through the web site located at www.yougetitfirst.com and such other sites as may be designated by Forward Move (each, the “Site” or collectively, the “Sites”).  Use of the Services may require Internet access and you accept additional terms of service by making use of these Internet-accessible Services. All access to and use of the Services available through the Site is subject to the terms of this Agreement.  If You wish to access and use the publicly available portions of the Services and the Site, You may do so only in compliance with the terms of this Agreement.\n            </p>\n            <p>\n              You understand that by using any of the Services, you may encounter content that may be deemed offensive, indecent, or objectionable, which content may or may not be identified as having explicit language, and that the third parties’ results of any search or entering of a particular URL may automatically and unintentionally generate links or references to objectionable material. You agree to use the Services at your sole risk and that Forward Move shall not have any liability to you for content that may be found to be offensive, indecent, or objectionable. You acknowledge that the content you encounter does not necessarily reflect the opinions or policies of Forward Move.\n            </p>\n            <p>\n              Certain Services may display, include or make available content, data, information, applications or materials from third parties (“Third-Party Materials”) or provide links to certain third-party web sites. By using the Services, you acknowledge and agree that Forward Move is not responsible for examining or evaluating the content, accuracy, completeness, timeliness, validity, copyright compliance, legality, decency, quality or any other aspect of such Third-Party Materials or web sites. Forward Move does not warrant or endorse and does not assume and will not have any liability or responsibility to you or any other person for any third-party services, Third-Party Materials or web sites, or for any other materials, products, or services of third parties. Third-Party Materials and links to other web sites are provided solely as a convenience to you.\n            </p>\n            <p>\n              You further agree not to use the Services in any manner to harass, abuse, stalk, threaten, defame or otherwise infringe or violate the rights of any other party, and that Forward Move is not in any way responsible for any such use by you, nor for any harassing, threatening, defamatory, offensive or illegal messages or transmissions that you may receive as a result of using any of the Services.\n            </p>\n            <p>\n              Forward Move reserves the right to change, suspend, remove, terminate, or disable access to any Services for any or no reason at any time without notice. In no event will Forward Move be liable for the removal of, termination, or disabling of access to any such Services. Forward Move may also impose limits on the use of or access to certain Services, in any case, and without notice or liability\n            </p>\n            <h3>6.     Forward Move Content and Your Content.</h3>\n            <p>\n              Forward Move Content.  Forward Move provides You with access to certain data, information and other content through the Site and Services (“Forward Move Content”).  Unless otherwise noted on the Site, as between You and Forward Move, all Forward Move Content is owned by Forward Move.  Subject to this Agreement, each User and OEM User (as applicable) may: (a) access the Forward Move Content (without modification) solely for Your own personal or business purposes in connection with the use of the Services; and (b) distribute the Forward Move Content (without modification) as incorporated into emails generated and sent by You or any OEM User (as applicable) through the Services.  Except as expressly provided in this Agreement, You will not, and will not permit any User or OEM User (as applicable) to: (i) alter, modify, reproduce, or create derivative works of the Forward Move Content; (ii) distribute, sell, resell, lend, loan, lease, license, sublicense or transfer the Forward Move Content, including, without limitation, providing outsourcing, service bureau, commercial hosting, application service provider or on-line services to third parties; or (iii) alter, obscure or remove any copyright, trademark or any other notices that are provided on or in connection with the Forward Move Content.  Certain of the Forward Move Content includes or is based on data, information and content from independent third party providers (“Third Party Content”).  Forward Move uses commercially reasonable measures to ensure that the Third Party Content is reliable, but Forward Move has no independent basis to verify or contradict the accuracy or completeness of the Third Party Content and will not be responsible for any erroneous Third Party Content provided through the Services.\n            </p>\n            <p>\n              Your Content.  You will be solely responsible for all data, information and other content provided by, or collected or obtained from, You or any of Your Users or OEM Users (as applicable) through the Services, including, without limitation, all personally identifiable information relating to You or any of Your Users, customers, OEM Users, service providers, employees, contractors or agents (“Your Content”).  Forward Move does not claim ownership of any content you upload. However, Forward Move does need certain rights from you, with respect to your content, in order to operate certain features under this Agreement. Therefore, with respect to your photographs, video and literature, you grant Forward Move a worldwide, royalty-free, non-exclusive, fully sub-licensable license to use, distribute, reproduce, modify and publicly display said content (in whole or in part). You agree that Forward Move may place such advertisements and promotions on, about, or in conjunction with your content. The manner, mode and extent of such advertising and promotion are subject to change without specific notice to you.  You represent and warrant that none of Your Content violates this Agreement or the Privacy Policy.  You will maintain an adequate back-up of all Your Content and Forward Move will not be responsible or liable for any deletion, correction, destruction, damage, loss or failure to store or back-up any of Your Content.  Forward Move may take remedial action if any of Your Content violates this Agreement, provided that Forward Move is under no obligation to review any of Your Content for accuracy or potential liability.  You represent and warrant to Forward Move that You have all necessary right, title, interest and consent necessary to allow Forward Move to use Your Content for the purposes for which You or any OEM User (as applicable) provides Your Content to Forward Move, including, without limitation, the delivery of any and all emails and other communications.  You will defend, indemnify and hold harmless Forward Move from any and all losses, costs, damages, liabilities or expenses (including without limitation reasonable attorney’s fees) incurred or arising from any claim by a third party arising out of or relating to Your Content or the use thereof by Forward Move in providing the Services.  For the purpose of clarity, Sensitive Data (as defined below) will not be provided to Forward Move at any time.  For purposes of this Agreement, “Sensitive Data” means (a) social security number, passport number, driver’s license number, or similar identifier (or any portion thereof), (b) employment, financial or health information, (c) ethnic or religious affiliation or sexual orientation, (d) criminal history, (h) mother’s maiden name or (i) any other information or combinations of information that is deemed sensitive under the legal framework of any applicable jurisdiction.\n            </p>\n            <p>\n              You agree that Forward Move shall have the right to archive copies of any content you upload to the Technology, and to use a copy of that content to promote Services and Technology now and in the future.\n            </p>\n            <h3>7.     Copyrights And Trademarks.</h3>\n            <p>\n              You acknowledge that no title to the intellectual property in the Technology is transferred to you. You further acknowledge that title and full ownership rights to the Technology will remain the exclusive property of Forward Move and you will not acquire any rights to therein. Forward Move retains all right, title and interest, including, without limitation, all IPR (as defined below), in and to the Technology, Forward Move content and any additions, improvements, updates, and modifications thereto.  You acknowledge that You are not receiving any ownership interest in or to any of the foregoing, and no right or license is granted to You to use them apart from Your right to access the Services under this Agreement.  The Forward Move name, logo and the product and service names associated with the Technology are trademarks of Forward Move (or its third party providers), and no right or license is granted to You to use them.  For purposes of this Agreement, “IPR” means any and all intellectual property rights, proprietary rights, rights of publicity, rights of privacy, and any and all other legal rights protecting data, information or intangible property throughout the world, including, without limitation, any and all copyrights, trademarks, service marks, trade secrets, patent rights, moral rights, sui generis rights in databases, and contract rights.\n            </p>\n            <p>\n              This Technology is protected by copyright laws, international copyright treaties, other intellectual property laws and treaties.\n            </p>\n            <h3>8.     Updates Or Upgrades To The Technology.</h3>\n            <p>\n              Forward Move is not obligated to provide any updates or upgrades to the Technology.\n            </p>\n            <h3>9.     Disclaimer.</h3>\n            <p>\n              YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF THE TECHNOLOGY IS AT YOUR SOLE RISK AND THAT THE ENTIRE RISK AS TO SATISFACTORY QUALITY, PERFORMANCE, ACCURACY AND EFFORT IS WITH YOU. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE TECHNOLOGY IS PROVIDED “AS IS” AND “AS AVAILABLE”, WITH ALL FAULTS AND WITHOUT WARRANTY OF ANY KIND, AND FORWARD MOVE HEREBY DISCLAIMS ALL WARRANTIES AND CONDITIONS WITH RESPECT TO THE TECHNOLOGY, EITHER EXPRESS, IMPLIED OR STATUTORY, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES AND/OR CONDITIONS OF MERCHANTABILITY, OF SATISFACTORY QUALITY, OF FITNESS FOR A PARTICULAR PURPOSE, OF ACCURACY, OF QUIET ENJOYMENT, AND NON-INFRINGEMENT OF THIRD PARTY RIGHTS.\n            </p>\n            <p>\n              Forward Move does not warrant against interference with your enjoyment of the Technology, that the functions contained in, or Services performed or provided by, the Technology will meet your requirements, that the operation of the Technology will be uninterrupted or error-free, or that defects in the Technology will be corrected. Forward Move assumes no responsibility for any error, omission, interruption, deletion, defect, delay in operation or transmission, communications line failure, theft or destruction or unauthorized access to, or alteration of, any communication. Forward Move is not responsible for any problems or technical malfunction of any telephone network or lines, computer online systems, servers or providers, computer equipment, software, or failure of any email due to technical problems or traffic congestion on the internet or on any of the Technology or combination thereof, including any injury or damage to users or to any person’s smartphone and/or table related to or resulting from participation in connection with the Services.\n            </p>\n            <p>\n              No oral or written information or advice given by Forward Move or its authorized representative shall create a warranty.\n            </p>\n            <p>\n              Forward Move cannot guarantee and does not promise any specific results from use of the Forward Move Services.\n            </p>\n            <p>\n              Some jurisdictions do not allow the exclusion of implied warranties or limitations on applicable statutory rights of a consumer, so the above exclusion and limitations may not apply to you.\n            </p>\n            <h3>10.     Limitation Of Liability; Intellectual Property Rights.</h3>\n            <p>\n              TO THE EXTENT NOT PROHIBITED BY LAW, IN NO EVENT WILL FORWARD MOVE BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY OR CONSEQUENTIAL DAMAGES, HOWEVER CAUSED, UNDER ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE), ARISING IN ANY WAY IN CONNECTION WITH OR OUT OF THE USE OF THE TECHNOLOGY (OR ANY FORWARD MOVE CONTENT PROVIDED THROUGH THE TECHNOLOGY), EVEN IF FORWARD MOVE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, INCLUDING, WITHOUT LIMITATION, ANY LOSS OF DATA, OPPORTUNITY, REVENUES OR PROFITS, BUSINESS INTERRUPTION, OR PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES.  FORWARD MOVE’S TOTAL CUMULATIVE LIABILITY IN CONNECTION WITH THIS AGREEMENT AND ALL SERVICES PROVIDED UNDER THIS AGREEMENT, WHETHER IN CONTRACT OR TORT OR OTHERWISE, WILL NOT EXCEED THE FEES PAID TO FORWARD MOVE HEREUNDER IN THE 1 MONTH PRECEDING ANY SUCH INITIAL OCCURRENCE OF LIABILITY (OR, IF NO SUCH FEES HAVE BEEN PAID, $10.00).  YOU AGREE THAT THE FEES REFLECT THE ALLOCATION OF RISK SET FORTH IN THIS AGREEMENT AND ACKNOWLEDGE THAT FORWARD MOVE WOULD NOT ENTER INTO THIS AGREEMENT WITHOUT THESE LIMITATIONS ON ITS LIABILITY.  IN JURISDICTIONS WHERE LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES IS NOT PERMITTED, FORWARD MOVE’S LIABILITY IS LIMITED TO THE MAXIMUM EXTENT PERMITTED BY LAW.  FOR THE PURPOSE OF CLARITY, FORWARD MOVE WILL NOT BE LIABLE, AND WILL HAVE NO OBLIGATION TO INDEMNIFY YOU, FOR (A) SENSITIVE DATA SENT TO FORWARD MOVE; (B) VIOLATION OF ANY LAW BY FORWARD MOVE WHEN ACTING AT YOUR OR ANY OEM USER’S (AS APPLICABLE) DIRECTION; (C) THE SENDING BY FORWARD MOVE OF YOUR OR ANY OEM USER’S (AS APPLICABLE) EMAILS, INCLUDING ANY CLAIMS AGAINST FORWARD MOVE DUE TO YOUR OR ANY OEM USER’S (AS APPLICABLE) SENDING OR DATA COLLECTION PRACTICES OR YOUR CONTENT.\n            </p>\n            <p>\n              THE FOREGOING LIMITATIONS WILL APPLY EVEN IF THE ABOVE STATED REMEDY FAILS OF ITS ESSENTIAL PURPOSE.\n            </p>\n            <h3>11.     Forward Move’s Obligation to Defend.</h3>\n            <p>\n              We will at our expense and option, defend or settle any claim brought against you alleging that the Technology or your possession and use of the Technology breaches any third-party intellectual property rights. We will be solely responsible for the investigation, defense, settlement and discharge of this third-party intellectual property infringement claim.\n            </p>\n            <p>\n              We will have no obligation with respect to any claim under this section unless: (a) you promptly notify us about the claim; (b) you allow us to have sole control of the defense and settlement of such claim; and (c) you provide us with reasonable assistance in connection with our defense and settlement of such claim.\n            </p>\n            <p>\n              If the Technology infringes or misappropriates, or in our reasonable determination is likely to infringe or misappropriate any third party’s intellectual property rights, then we may, at our sole option and expense: (a) obtain from the third party the right to continue to use the Technology consistent with the rights granted hereunder; or (b) modify the Technology to avoid and eliminate such infringement or misappropriation.\n            </p>\n            <p>\n              We will not be liable for any infringement based on: (a) modification of the Technology by anyone other than us; or (b) the combination of the Technology with other software, items or processes not furnished by us if such infringement would have been avoided by the use of the Technology alone.\n            </p>\n            <h3>12.     Restrictions and Indemnification By You.</h3>\n            <p>\n              You acknowledge that the Technology and their structure, organization, and underlying data, information and source code constitute valuable trade secrets of Forward Move.  You will not, and will not permit any third party (including any OEM User, as applicable) to: (1) access or use the Services or the Sites, in whole or in part, except as expressly provided in this Agreement; (2) use the Technology to harvest or collect e-mail addresses or other contact information of third parties by any means for the purposes of sending unsolicited e-mails or other unsolicited communications; (3) use the Technology in any unlawful manner or in any other manner that could damage, disable, overburden or impair the Site or Services; (4) use automated scripts to collect information from or otherwise interact with the Technology; (5) use the Technology to intimidate or harass any other people or entities; alter, modify, reproduce, create derivative works of the Technology; (6) distribute, sell, resell, lend, loan, lease, license, sublicense or transfer any of Your rights to access or use the Technology, including, without limitation, providing outsourcing, service bureau, hosting, application service provider or on-line services to third parties, or otherwise make the Technology, or access thereto, available to any third party; (7) reverse engineer, disassemble, decompile, or otherwise attempt to derive the source code or method of operation of or any trade secrets embodied in the Technology; (8) attempt to circumvent or overcome any technological protection measures intended to restrict access to any portion of the Sites or Services; (9) interfere in any manner with the operation or hosting of the Technology, or attempt to gain unauthorized access to the Technology; or (10) use the Service for any high risk activities including, but not limited to, the operation of nuclear facilities, air traffic control, life support systems, emergency services or where the use or failure of the Service could lead to death, personal injury or environmental damage (collectively, “High Risk Activities”).  Forward Move does not intend uses of the Service to create obligations under The Health Insurance Portability and Accountability Act of 1996 (“HIPAA”), the Gramm-Leach-Bliley Act (“GLBA”) or similar laws and makes no representations that the Service satisfies the requirements of such laws. If You are (or become) a Covered Entity or Business Associate (as defined in HIPAA) or a Financial Institution (as defined in GLBA), You agree not to use the Service for any purpose or in any manner involving Protected Health Information (as defined in HIPAA) or Nonpublic Personal Information (as defined in GLBA). You will not allow any access to or use of the Services by anyone other than Your authorized Users or OEM Users (as applicable), and any such use will be consistent with the terms, conditions and restrictions set forth in this Agreement.\n            </p>\n            <p>\n              You agree to indemnify and hold Forward Move, its subsidiaries, and affiliates, and their respective officers, agents, partners and employees, harmless from any loss, liability, claim or demand, including reasonable attorney’s fees, made by any third party due to or arising out of your use of the Technology in violation of this Agreement, arising from a breach of this Agreement, any breach in your representations or warranties, or if any content you upload to the Services causes Forward Move to be liable to another.\n            </p>\n            <h3>13.     Export Control.</h3>\n            <p>\n              You may not use or otherwise export or re-export the Technology except as authorized by United States law and the laws of the jurisdiction in which the Technology was obtained.  In particular, but without limitation, you may not export or re-export the Technology:  (a) into any United States embargoed countries; or (b) to anyone on the United States Treasury Department\'s list of Specially Designated Nationals or the United States Department of Commerce Denied Person\'s List or Entity List.  By using the Technology, you represent and warrant that:  (i) you will not use these products for any purpose prohibited by United States law, including without limitation, the development, design, manufacture or production of nuclear missiles or chemical or biological weapons; (ii) you are not located in a country that is subject to a United States government embargo or has been designated by the United States government as a \"terrorist supporting\" country; and (iii) you are not listed on any United States government list of prohibited or restricted parties.\n            </p>\n            <h3>14.    Injunctive Relief.</h3>\n            <p>\n              Forward Move has the right to seek injunctive relief to enforce this Agreement or to stop or prevent an infringement of proprietary or other third-party rights.\n            </p>\n            <h3>15.     Choice Of Law, Jurisdiction And Venue.</h3>\n            <p>\n              You agree that any disputes between Forward Move and you shall be resolved under the substantive law of the state of Wisconsin (exclusive of its choice of law provisions). You and Forward Move agree to submit all disputes to the exclusive jurisdiction of the state and federal courts located in Green Bay, Wisconsin.  You irrevocably submit to the personal jurisdiction and venue of any such court in any such action or proceeding or in any action or proceeding brought in such courts by Forward Move.\n            </p>\n            <h3>16.     Section Titles.</h3>\n            <p>\n              The section titles in this Agreement are for convenience only and have no legal or contractual effect.\n            </p>\n            <h3>17.     Non-Waiver.</h3>\n            <p>\n              Forward Move’s failure to exercise or enforce any right or provision of this Agreement shall not operate as a waiver of such right or provision.\n            </p>\n            <h3>18.     Severability.</h3>\n            <p>\n              The parties agree that each provision of this Agreement is intended to be construed to be enforceable to the fullest extent possible. If any provision or part of a provision of this Agreement is held to be unlawful, void, or unenforceable, that provision or part of the provision shall be deemed severable from this Agreement and not affect the validity and enforceability of any remaining provisions.\n            </p>\n            <h3>19.     Assignment.</h3>\n            <p>\n              You may not assign your rights under this Agreement to any third party; Forward Move may assign your rights under this Agreement without condition.\n            </p>\n            <h4>20.     Product Questions, Comments, Claims And Contact Information.\n            <p>\n              We are responsible for addressing any questions, comments or claims relating to the Technology, including but not limited to:  (a) product liability claims; (b) any claim that the Technology fails to conform to any applicable legal or regulatory requirement; and (c) claims arising under consumer protection or similar legislation.  If you have any comments or questions, please contact Forward Move at:\n            </p>\n            <p>\n              Forward Move, LLC\n              321 St. George Street\n              Green Bay, WI  54302\n              Telephone:  920-461-4188\n              Email:  info@yougetitfirst.com\n            </p>\n            <h4>21.     Dispute Resolution.</h4>\n            <p>\n              The parties agree that any disputes or questions arising under this Agreement, including the construction or application of this Agreement, shall first be submitted to mediation.  Any mediation settlement by the parties shall be put in writing, signed by both parties, and added to this Agreement as an attachment, amendment, or modification hereof.  If mediation between the parties does not result in a mutual settlement within thirty (30) days after submission to mediation, then each party shall have the right to seek enforcement of the obligations of this Agreement through circuit court action or, if the parties mutually agree in writing, through binding arbitration pursuant to the provisions of Chapter 788 of the Wisconsin Statutes.  In the event the parties mutually agree in writing to submit to binding arbitration, the parties shall mutually select a single independent arbitrator within ten (10) days of their agreement to arbitrate.  If the parties cannot agree on an arbitrator, the arbitrator shall be chosen by a Circuit Court judge from Brown County, Wisconsin.  Unless the parties otherwise agree, the arbitration shall take place and the arbitrator’s decision shall be made not more than sixty (60) days after the date of either party’s demand for arbitration.  The cost and expense of the arbitrator and location costs shall be borne equally by the parties to the dispute.  All other costs and expenses, including reasonable attorney’s fees and expert’s fees, of all parties incurred in any dispute which is determined and/or settled by arbitration pursuant to this section shall be borne by the party incurring such cost and expense, except that the arbitrator in its discretion shall have the authority to award attorneys fees and costs to the prevailing party. The decision of the arbitrator shall be final and judgment upon the arbitration award may be entered in the circuit court having jurisdiction thereof upon the request of any party.  In the event the parties do not mutually agree in writing to submit to binding arbitration and, in the alternative, seek enforcement hereunder through circuit court action, all costs and expenses relating thereto, including reasonable attorney\'s fees and expert\'s fees, of either party incurred in litigating any dispute shall be borne by the party incurring such cost and expense.\n            </p>\n            <h3>22.     Promotional Consent.</h3>\n            <p>\n              Forward Move may reference You as a user of the Services and use Your name and logo, as applicable, in listings of users of the Services appearing on the Forward Move web site and for other marketing and promotional purposes relating to the Services.\n            </p>\n            <h3>23.     Requesting a Refund.</h3>\n            <p>\n              If you paid for the Technology, and if the Technology fails to conform to any applicable warranty (if any), please notify us and we will refund to you the price you paid for the Technology.  In addition, if you are not satisfied for any reason (in the first 45 days from the Effective Date) with the Technology provided to you by Forward Move, we will refund your administrative fee and any fees for messages you have sent. There is a catch, we will ask you WHY.  And that’s it.\n            </p>\n            <h3>24.     Privacy Policy.</h3>\n            <p>\n              Forward Move’s most current Privacy Policy, available at yougetitfirst.com applies to use of the Technology, and its terms are made a part of this Agreement by this reference.\n            </p>\n            <p>\n              In respect of Your or the OEM Users’ (as applicable) use of the Site and Services and in relation to any personally identifiable and other data and information You or any OEM User (as applicable) provides to Forward Move through the Site and Services, You expressly consent to the use and disclosure of that data and information as described in Forward Move’s then-current privacy policy displayed on the Site (“Privacy Policy”).  Notwithstanding anything in the Privacy Policy, Forward Move will have the right to collect, extract, compile, synthesize, and analyze non-personally identifiable data or information (data or information that does not identify an entity or natural person as the source thereof) resulting from Your or any OEM User’s (as applicable) access to the Site and Your or any OEM User’s (as applicable) use and operation of the Services (including, by way of example and not limitation, information relating to volumes, frequencies, recipients, bounce rates, or any other information regarding the email and other communications You and any OEM User (as applicable) generates and sends using the Services).  To the extent any such non-personally identifiable data or information is collected or generated by Forward Move, the data and information will be solely owned by Forward Move and may be used by Forward Move for any lawful business purpose without a duty of accounting to You or any OEM User, provided that the data and information is used only in an aggregated form, without directly identifying You, any User, OEM User or customer, or any other entity or natural person as the source thereof. You acknowledge that email is an insecure medium that is generally not encrypted in transit, and security of information transmitted through the Internet can never be guaranteed. Forward Move is not responsible for any interception or interruption of any communications through the Internet or for changes to or loss of Your Content.\n            </p>\n            <h3>25.     Additional Terms for OEM Services.</h3>\n            <p>\n              The terms set forth in this Section shall be in addition to, and not in lieu of, the terms set forth elsewhere in this Agreement.\n            </p>\n            <p>\n              Integration and Use of the Forward Move Interface. Forward Move will provide You with the right to integrate the Service into the OEM Service through one or more interfaces for the Service designated by Forward Move during the term of this Agreement (each, a “Forward Move Interface”) and to offer the Service to OEM Users as an integrated part of the OEM Service.  You will access the Service only through the Forward Move Interfaces designated by Forward Move, for purposes of integrating the Service into the OEM Service.\n            </p>\n            <p>\n              OEM Account.  You will be provided with an administrative account to manage access to and use of the Service (the “OEM Account”).  The OEM Account may be accessed and used only by You for purposes of (a) establishing and administering OEM User access to the Services and (b) utilizing the Service to send email messages to OEM Users in connection with Your business.  You will be solely responsible for all use of the OEM Account.  You will ensure the security and confidentiality of all usernames and passwords associated with the OEM Account and will notify Forward Move immediately if any such information is lost, stolen or otherwise compromised.  You will be fully responsible for all liabilities and damages incurred through use of the OEM Account (whether lawful or unlawful).  Any transactions completed through any OEM Account will be deemed to have been completed by You.  In no event will Forward Move be liable for the foregoing obligations or the failure by You to fulfill such obligations.\n            </p>\n            <p>\n              Use of the Service by OEM Users. Prior to allowing any OEM User to access or use any OEM Service, including any portion of the Service, You will require that the OEM User become legally bound by this Agreement.  You assume all responsibility and liability for the actions of all OEM Users, including all use of or access to the Service by each OEM User or by You on behalf of any OEM User and will be responsible for each OEM User’s compliance or failure to comply with this Agreement.  You will promptly notify Forward Move upon becoming aware of any breach of any OEM User.\n            </p>\n            <h3>26.     Acceptance.</h3>\n            <p>\n              This Agreement constitutes the entire agreement between you and Forward Move regarding the use of the Technology and supersedes any prior or contemporaneous understandings and agreements between you and Forward Move related to its subject matter.\n            </p>\n            <p>\n              You hereby represent, warrant, and covenant for the benefit of Forward Move that:\n            </p>\n            <div style=\"margin-left: 20px\">\n              <p>\n                (a) You have the legal right and authority to enter into this Agreement, and, if You are accepting this Agreement on behalf of a company or other entity, to bind the company or other entity to the terms of this Agreement;\n              </p>\n              <p>\n                (b) You have the legal right and authority to perform Your obligations under this Agreement and to grant the rights and licenses described in this Agreement and in any applicable additional agreement You enter into in connection with any of the Services;\n              </p>\n              <p>\n                (c) Your Content, and any other data, information or content You or any OEM User (as applicable) provides to Forward Move in connection with this Agreement and Your and each OEM User’s (as applicable) access to the Site and use of the Services, is correct and current.\n              </p>\n            </div>\n            <p>\n              YOU AGREE THAT YOU HAVE READ THE TERMS AND CONDITIONS SET FORTH HEREIN CAREFULLY.  FILLING IN THE SPACE NEXT TO “I ACCEPT THE TERMS IN THE LICENSE AGREEMENT” INDICATES YOUR ACCEPTANCE OF THESE TERMS AND CONDITIONS.  IF YOU DO NOT AGREE WITH SUCH TERMS AND CONDITIONS, CLICK “CANCEL”.\n            </p>\n          </h4></div>\n        </md-content>\n      </md-tab>\n      <md-tab label=\"Terms and Conditions\">\n        <md-content>\n          <div class=\"content\" layout=\"column\" layout-align=\"center center\">\n\n            <div>\n                <h1>Terms and Conditions</h1>\n            </div>\n            <p style=\"margin: 20px 10px\">\n                <span class=\"s1\">\n                    <strong>CONDITIONS OF USE.</strong>\n                    Your use of the website yougetitfirst.com (“Website”) of Forward Move, LLC (“Forward Move, LLC” or “We”) is governed by these Terms & Conditions. By using this Website, you agree to these Terms & Conditions. Please read them carefully. Forward Move, LLC may at any time revise these Terms & Conditions by updating this page, and any such revisions shall be effective when posted to the Website. We therefore encourage you to visit this page from time to time to review the current Terms & Conditions.\n                </span>\n            </p>\n            <p style=\"margin: 20px 10px\">\n                <span class=\"s1\">\n                    <strong>DISCLAIMER.</strong>\n                    The materials on this Website are provided “as is,” with no warranties, either expressed or implied, including, but not limited to, implied warranties of merchantability and fitness for a particular purpose. We reserve the right to modify the information contained on this Website at any time without notice. Despite the reasonable efforts of Forward Move, LLC, information on this Website may contain inaccuracies or typographical errors.\n                </span>\n            </p>\n            <p style=\"margin: 20px 10px\">\n                <span class=\"s1\">\n                    <strong>RESTRICTIONS ON USE.</strong>\n                    You may use the content of this Website for personal use only (either individually or in your capacity as the representative of a current or prospective customer of Forward Move, LLC).<br><br>Except as otherwise permitted by Forward Move, LLC, no materials from this Website may be copied, reproduced, or re-used in any other way.\n                </span>\n            </p>\n            <p style=\"margin: 20px 10px\">\n                <span class=\"s1\">\n                    <strong>TRADEMARKS/SERVICE MARKS AND COPYRIGHTS.</strong>\n                    Images displayed on this Website are the property of, or under license to, Forward Move, LLC. All Website content is protected by copyright. You may not use Website images or reproduce, adapt, or publish any Website content without the written consent of Forward Move, LLC. The Forward Move, LLC name and logos, as well as all other trademarks or service marks of Forward Move, LLC, are registered trademarks or service marks and may be used only with the written permission of Forward Move, LLC.\n                </span>\n            </p>\n            <p style=\"margin: 20px 10px\">\n                <span class=\"s1\">\n                    <strong>LIMITATION OF LIABILITY.</strong>\n                    Under no circumstances shall We be liable for any losses or damages of any kind, whether direct, indirect, incidental, consequential, or punitive, that are alleged to result in any way from the use of any portion or feature of this Website. If the foregoing limitation of liability is not enforceable in whole or in part, then in no event shall Forward Move, LLC’s total liability to a Website user for any loss or damage shown to have arisen from the use of this Website exceed the user’s internet access fees for the month in which the access leading to the proven loss or damage occurred.\n                </span>\n            </p>\n            <p style=\"margin: 20px 10px\">\n                <span class=\"s1\">\n                    <strong>Term and Conditions of Use; Revisions</strong>\n                    <br>If you choose to visit our site, your visit and any dispute over privacy is subject to this Privacy Statement and our site’s Terms and Conditions of Use, including limitations on damages. We reserve the right to modify this statement at any time without notice other than posting the change(s).\n                </span>\n            </p>\n          </div>\n        </md-content>\n      </md-tab>\n    </md-tabs>\n  </div>\n</div>\n");}]);